import {
    g as getElement,
    a as assignAttributes,
    b as getRotationAngle,
    s as snapToGrid,
    c as getBBox,
    d as shortFloat,
    e as getRefElem,
    f as findDefs,
    w as walkTree,
    t as toXml,
    p as preventClickDefault,
    h as getParentsUntil,
    i as getStrokedBBoxDefaultVisible,
    j as text2xml,
    k as setHref,
    l as getClosest,
    m as cleanupElement,
    n as findPos,
    o as getVisibleElements,
    q as convertToNum,
    r as getHref,
    u as getParents,
    v as mergeDeep,
    x as getFeGaussianBlur,
    y as walkTreePost,
    z as getUrlFromAttr,
    A as convertUnit,
    B as hashCode,
    C as createObjectURL,
    D as dataURLToObjectURL,
    E as getStrokedBBox,
    F as init$j,
    G as init$k,
    $ as $click,
    H as getBBoxOfElementAsPath,
    I as convertToPath,
    J as stringToHTML,
    K as insertChildAtIndex,
    L as getTypeMap,
    M as $id,
    N as $qq,
    O as $qa,
    P as encode64,
    Q as decode64,
    R as blankPageObjectURL,
    S as isValidUnit,
} from "./utilities-211329f7.js";
import {
    transformPoint,
    getMatrix,
    rectsIntersect,
    getTransformList,
    transformListToTransform,
    snapToAngle,
    hasMatrixTransform,
    matrixMultiply,
    transformBox,
    isIdentity,
} from "./math.js";
import { NS, getReverseNS } from "./namespaces.js";
import {
    C as ChangeElementCommand$2,
    B as BatchCommand$4,
    M as MoveElementCommand$1,
    I as InsertElementCommand$4,
    R as RemoveElementCommand$2,
    h as history,
} from "./history-8b669144.js";

function _mergeNamespaces(n, m) {
    m.forEach(function (e) {
        e &&
            typeof e !== "string" &&
            !Array.isArray(e) &&
            Object.keys(e).forEach(function (k) {
                if (k !== "default" && !(k in n)) {
                    var d = Object.getOwnPropertyDescriptor(e, k);
                    Object.defineProperty(
                        n,
                        k,
                        d.get
                            ? d
                            : {
                                  enumerable: true,
                                  get: function () {
                                      return e[k];
                                  },
                              },
                    );
                }
            });
    });
    return Object.freeze(n);
}

// SVGPathSeg API polyfill
// https://github.com/progers/pathseg
//
// This is a drop-in replacement for the SVGPathSeg and SVGPathSegList APIs that were removed from
// SVG2 (https://lists.w3.org/Archives/Public/www-svg/2015Jun/0044.html), including the latest spec
// changes which were implemented in Firefox 43 and Chrome 46.

(function () {
    // The polyfill only applies to browser environments with a `window` object
    // (i.e. not node.js, workers, etc.). If included in one of these
    // environments (such as when using 'react-dom/server'), simply return out
    if (typeof window === "undefined") return;
    if (!("SVGPathSeg" in window)) {
        // Spec: http://www.w3.org/TR/SVG11/single-page.html#paths-InterfaceSVGPathSeg
        window.SVGPathSeg = function (type, typeAsLetter, owningPathSegList) {
            this.pathSegType = type;
            this.pathSegTypeAsLetter = typeAsLetter;
            this._owningPathSegList = owningPathSegList;
        };
        window.SVGPathSeg.prototype.classname = "SVGPathSeg";
        window.SVGPathSeg.PATHSEG_UNKNOWN = 0;
        window.SVGPathSeg.PATHSEG_CLOSEPATH = 1;
        window.SVGPathSeg.PATHSEG_MOVETO_ABS = 2;
        window.SVGPathSeg.PATHSEG_MOVETO_REL = 3;
        window.SVGPathSeg.PATHSEG_LINETO_ABS = 4;
        window.SVGPathSeg.PATHSEG_LINETO_REL = 5;
        window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS = 6;
        window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_REL = 7;
        window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_ABS = 8;
        window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_REL = 9;
        window.SVGPathSeg.PATHSEG_ARC_ABS = 10;
        window.SVGPathSeg.PATHSEG_ARC_REL = 11;
        window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_ABS = 12;
        window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_REL = 13;
        window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_ABS = 14;
        window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_REL = 15;
        window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_ABS = 16;
        window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_REL = 17;
        window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_ABS = 18;
        window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_REL = 19;

        // Notify owning PathSegList on any changes so they can be synchronized back to the path element.
        window.SVGPathSeg.prototype._segmentChanged = function () {
            if (this._owningPathSegList)
                this._owningPathSegList.segmentChanged(this);
        };
        window.SVGPathSegClosePath = function (owningPathSegList) {
            window.SVGPathSeg.call(
                this,
                window.SVGPathSeg.PATHSEG_CLOSEPATH,
                "z",
                owningPathSegList,
            );
        };
        window.SVGPathSegClosePath.prototype = Object.create(
            window.SVGPathSeg.prototype,
        );
        window.SVGPathSegClosePath.prototype.toString = function () {
            return "[object SVGPathSegClosePath]";
        };
        window.SVGPathSegClosePath.prototype._asPathString = function () {
            return this.pathSegTypeAsLetter;
        };
        window.SVGPathSegClosePath.prototype.clone = function () {
            return new window.SVGPathSegClosePath(undefined);
        };
        window.SVGPathSegMovetoAbs = function (owningPathSegList, x, y) {
            window.SVGPathSeg.call(
                this,
                window.SVGPathSeg.PATHSEG_MOVETO_ABS,
                "M",
                owningPathSegList,
            );
            this._x = x;
            this._y = y;
        };
        window.SVGPathSegMovetoAbs.prototype = Object.create(
            window.SVGPathSeg.prototype,
        );
        window.SVGPathSegMovetoAbs.prototype.toString = function () {
            return "[object SVGPathSegMovetoAbs]";
        };
        window.SVGPathSegMovetoAbs.prototype._asPathString = function () {
            return this.pathSegTypeAsLetter + " " + this._x + " " + this._y;
        };
        window.SVGPathSegMovetoAbs.prototype.clone = function () {
            return new window.SVGPathSegMovetoAbs(undefined, this._x, this._y);
        };
        Object.defineProperty(window.SVGPathSegMovetoAbs.prototype, "x", {
            get: function () {
                return this._x;
            },
            set: function (x) {
                this._x = x;
                this._segmentChanged();
            },
            enumerable: true,
        });
        Object.defineProperty(window.SVGPathSegMovetoAbs.prototype, "y", {
            get: function () {
                return this._y;
            },
            set: function (y) {
                this._y = y;
                this._segmentChanged();
            },
            enumerable: true,
        });
        window.SVGPathSegMovetoRel = function (owningPathSegList, x, y) {
            window.SVGPathSeg.call(
                this,
                window.SVGPathSeg.PATHSEG_MOVETO_REL,
                "m",
                owningPathSegList,
            );
            this._x = x;
            this._y = y;
        };
        window.SVGPathSegMovetoRel.prototype = Object.create(
            window.SVGPathSeg.prototype,
        );
        window.SVGPathSegMovetoRel.prototype.toString = function () {
            return "[object SVGPathSegMovetoRel]";
        };
        window.SVGPathSegMovetoRel.prototype._asPathString = function () {
            return this.pathSegTypeAsLetter + " " + this._x + " " + this._y;
        };
        window.SVGPathSegMovetoRel.prototype.clone = function () {
            return new window.SVGPathSegMovetoRel(undefined, this._x, this._y);
        };
        Object.defineProperty(window.SVGPathSegMovetoRel.prototype, "x", {
            get: function () {
                return this._x;
            },
            set: function (x) {
                this._x = x;
                this._segmentChanged();
            },
            enumerable: true,
        });
        Object.defineProperty(window.SVGPathSegMovetoRel.prototype, "y", {
            get: function () {
                return this._y;
            },
            set: function (y) {
                this._y = y;
                this._segmentChanged();
            },
            enumerable: true,
        });
        window.SVGPathSegLinetoAbs = function (owningPathSegList, x, y) {
            window.SVGPathSeg.call(
                this,
                window.SVGPathSeg.PATHSEG_LINETO_ABS,
                "L",
                owningPathSegList,
            );
            this._x = x;
            this._y = y;
        };
        window.SVGPathSegLinetoAbs.prototype = Object.create(
            window.SVGPathSeg.prototype,
        );
        window.SVGPathSegLinetoAbs.prototype.toString = function () {
            return "[object SVGPathSegLinetoAbs]";
        };
        window.SVGPathSegLinetoAbs.prototype._asPathString = function () {
            return this.pathSegTypeAsLetter + " " + this._x + " " + this._y;
        };
        window.SVGPathSegLinetoAbs.prototype.clone = function () {
            return new window.SVGPathSegLinetoAbs(undefined, this._x, this._y);
        };
        Object.defineProperty(window.SVGPathSegLinetoAbs.prototype, "x", {
            get: function () {
                return this._x;
            },
            set: function (x) {
                this._x = x;
                this._segmentChanged();
            },
            enumerable: true,
        });
        Object.defineProperty(window.SVGPathSegLinetoAbs.prototype, "y", {
            get: function () {
                return this._y;
            },
            set: function (y) {
                this._y = y;
                this._segmentChanged();
            },
            enumerable: true,
        });
        window.SVGPathSegLinetoRel = function (owningPathSegList, x, y) {
            window.SVGPathSeg.call(
                this,
                window.SVGPathSeg.PATHSEG_LINETO_REL,
                "l",
                owningPathSegList,
            );
            this._x = x;
            this._y = y;
        };
        window.SVGPathSegLinetoRel.prototype = Object.create(
            window.SVGPathSeg.prototype,
        );
        window.SVGPathSegLinetoRel.prototype.toString = function () {
            return "[object SVGPathSegLinetoRel]";
        };
        window.SVGPathSegLinetoRel.prototype._asPathString = function () {
            return this.pathSegTypeAsLetter + " " + this._x + " " + this._y;
        };
        window.SVGPathSegLinetoRel.prototype.clone = function () {
            return new window.SVGPathSegLinetoRel(undefined, this._x, this._y);
        };
        Object.defineProperty(window.SVGPathSegLinetoRel.prototype, "x", {
            get: function () {
                return this._x;
            },
            set: function (x) {
                this._x = x;
                this._segmentChanged();
            },
            enumerable: true,
        });
        Object.defineProperty(window.SVGPathSegLinetoRel.prototype, "y", {
            get: function () {
                return this._y;
            },
            set: function (y) {
                this._y = y;
                this._segmentChanged();
            },
            enumerable: true,
        });
        window.SVGPathSegCurvetoCubicAbs = function (
            owningPathSegList,
            x,
            y,
            x1,
            y1,
            x2,
            y2,
        ) {
            window.SVGPathSeg.call(
                this,
                window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS,
                "C",
                owningPathSegList,
            );
            this._x = x;
            this._y = y;
            this._x1 = x1;
            this._y1 = y1;
            this._x2 = x2;
            this._y2 = y2;
        };
        window.SVGPathSegCurvetoCubicAbs.prototype = Object.create(
            window.SVGPathSeg.prototype,
        );
        window.SVGPathSegCurvetoCubicAbs.prototype.toString = function () {
            return "[object SVGPathSegCurvetoCubicAbs]";
        };
        window.SVGPathSegCurvetoCubicAbs.prototype._asPathString = function () {
            return (
                this.pathSegTypeAsLetter +
                " " +
                this._x1 +
                " " +
                this._y1 +
                " " +
                this._x2 +
                " " +
                this._y2 +
                " " +
                this._x +
                " " +
                this._y
            );
        };
        window.SVGPathSegCurvetoCubicAbs.prototype.clone = function () {
            return new window.SVGPathSegCurvetoCubicAbs(
                undefined,
                this._x,
                this._y,
                this._x1,
                this._y1,
                this._x2,
                this._y2,
            );
        };
        Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "x", {
            get: function () {
                return this._x;
            },
            set: function (x) {
                this._x = x;
                this._segmentChanged();
            },
            enumerable: true,
        });
        Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "y", {
            get: function () {
                return this._y;
            },
            set: function (y) {
                this._y = y;
                this._segmentChanged();
            },
            enumerable: true,
        });
        Object.defineProperty(
            window.SVGPathSegCurvetoCubicAbs.prototype,
            "x1",
            {
                get: function () {
                    return this._x1;
                },
                set: function (x1) {
                    this._x1 = x1;
                    this._segmentChanged();
                },
                enumerable: true,
            },
        );
        Object.defineProperty(
            window.SVGPathSegCurvetoCubicAbs.prototype,
            "y1",
            {
                get: function () {
                    return this._y1;
                },
                set: function (y1) {
                    this._y1 = y1;
                    this._segmentChanged();
                },
                enumerable: true,
            },
        );
        Object.defineProperty(
            window.SVGPathSegCurvetoCubicAbs.prototype,
            "x2",
            {
                get: function () {
                    return this._x2;
                },
                set: function (x2) {
                    this._x2 = x2;
                    this._segmentChanged();
                },
                enumerable: true,
            },
        );
        Object.defineProperty(
            window.SVGPathSegCurvetoCubicAbs.prototype,
            "y2",
            {
                get: function () {
                    return this._y2;
                },
                set: function (y2) {
                    this._y2 = y2;
                    this._segmentChanged();
                },
                enumerable: true,
            },
        );
        window.SVGPathSegCurvetoCubicRel = function (
            owningPathSegList,
            x,
            y,
            x1,
            y1,
            x2,
            y2,
        ) {
            window.SVGPathSeg.call(
                this,
                window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_REL,
                "c",
                owningPathSegList,
            );
            this._x = x;
            this._y = y;
            this._x1 = x1;
            this._y1 = y1;
            this._x2 = x2;
            this._y2 = y2;
        };
        window.SVGPathSegCurvetoCubicRel.prototype = Object.create(
            window.SVGPathSeg.prototype,
        );
        window.SVGPathSegCurvetoCubicRel.prototype.toString = function () {
            return "[object SVGPathSegCurvetoCubicRel]";
        };
        window.SVGPathSegCurvetoCubicRel.prototype._asPathString = function () {
            return (
                this.pathSegTypeAsLetter +
                " " +
                this._x1 +
                " " +
                this._y1 +
                " " +
                this._x2 +
                " " +
                this._y2 +
                " " +
                this._x +
                " " +
                this._y
            );
        };
        window.SVGPathSegCurvetoCubicRel.prototype.clone = function () {
            return new window.SVGPathSegCurvetoCubicRel(
                undefined,
                this._x,
                this._y,
                this._x1,
                this._y1,
                this._x2,
                this._y2,
            );
        };
        Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "x", {
            get: function () {
                return this._x;
            },
            set: function (x) {
                this._x = x;
                this._segmentChanged();
            },
            enumerable: true,
        });
        Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "y", {
            get: function () {
                return this._y;
            },
            set: function (y) {
                this._y = y;
                this._segmentChanged();
            },
            enumerable: true,
        });
        Object.defineProperty(
            window.SVGPathSegCurvetoCubicRel.prototype,
            "x1",
            {
                get: function () {
                    return this._x1;
                },
                set: function (x1) {
                    this._x1 = x1;
                    this._segmentChanged();
                },
                enumerable: true,
            },
        );
        Object.defineProperty(
            window.SVGPathSegCurvetoCubicRel.prototype,
            "y1",
            {
                get: function () {
                    return this._y1;
                },
                set: function (y1) {
                    this._y1 = y1;
                    this._segmentChanged();
                },
                enumerable: true,
            },
        );
        Object.defineProperty(
            window.SVGPathSegCurvetoCubicRel.prototype,
            "x2",
            {
                get: function () {
                    return this._x2;
                },
                set: function (x2) {
                    this._x2 = x2;
                    this._segmentChanged();
                },
                enumerable: true,
            },
        );
        Object.defineProperty(
            window.SVGPathSegCurvetoCubicRel.prototype,
            "y2",
            {
                get: function () {
                    return this._y2;
                },
                set: function (y2) {
                    this._y2 = y2;
                    this._segmentChanged();
                },
                enumerable: true,
            },
        );
        window.SVGPathSegCurvetoQuadraticAbs = function (
            owningPathSegList,
            x,
            y,
            x1,
            y1,
        ) {
            window.SVGPathSeg.call(
                this,
                window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_ABS,
                "Q",
                owningPathSegList,
            );
            this._x = x;
            this._y = y;
            this._x1 = x1;
            this._y1 = y1;
        };
        window.SVGPathSegCurvetoQuadraticAbs.prototype = Object.create(
            window.SVGPathSeg.prototype,
        );
        window.SVGPathSegCurvetoQuadraticAbs.prototype.toString = function () {
            return "[object SVGPathSegCurvetoQuadraticAbs]";
        };
        window.SVGPathSegCurvetoQuadraticAbs.prototype._asPathString =
            function () {
                return (
                    this.pathSegTypeAsLetter +
                    " " +
                    this._x1 +
                    " " +
                    this._y1 +
                    " " +
                    this._x +
                    " " +
                    this._y
                );
            };
        window.SVGPathSegCurvetoQuadraticAbs.prototype.clone = function () {
            return new window.SVGPathSegCurvetoQuadraticAbs(
                undefined,
                this._x,
                this._y,
                this._x1,
                this._y1,
            );
        };
        Object.defineProperty(
            window.SVGPathSegCurvetoQuadraticAbs.prototype,
            "x",
            {
                get: function () {
                    return this._x;
                },
                set: function (x) {
                    this._x = x;
                    this._segmentChanged();
                },
                enumerable: true,
            },
        );
        Object.defineProperty(
            window.SVGPathSegCurvetoQuadraticAbs.prototype,
            "y",
            {
                get: function () {
                    return this._y;
                },
                set: function (y) {
                    this._y = y;
                    this._segmentChanged();
                },
                enumerable: true,
            },
        );
        Object.defineProperty(
            window.SVGPathSegCurvetoQuadraticAbs.prototype,
            "x1",
            {
                get: function () {
                    return this._x1;
                },
                set: function (x1) {
                    this._x1 = x1;
                    this._segmentChanged();
                },
                enumerable: true,
            },
        );
        Object.defineProperty(
            window.SVGPathSegCurvetoQuadraticAbs.prototype,
            "y1",
            {
                get: function () {
                    return this._y1;
                },
                set: function (y1) {
                    this._y1 = y1;
                    this._segmentChanged();
                },
                enumerable: true,
            },
        );
        window.SVGPathSegCurvetoQuadraticRel = function (
            owningPathSegList,
            x,
            y,
            x1,
            y1,
        ) {
            window.SVGPathSeg.call(
                this,
                window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_REL,
                "q",
                owningPathSegList,
            );
            this._x = x;
            this._y = y;
            this._x1 = x1;
            this._y1 = y1;
        };
        window.SVGPathSegCurvetoQuadraticRel.prototype = Object.create(
            window.SVGPathSeg.prototype,
        );
        window.SVGPathSegCurvetoQuadraticRel.prototype.toString = function () {
            return "[object SVGPathSegCurvetoQuadraticRel]";
        };
        window.SVGPathSegCurvetoQuadraticRel.prototype._asPathString =
            function () {
                return (
                    this.pathSegTypeAsLetter +
                    " " +
                    this._x1 +
                    " " +
                    this._y1 +
                    " " +
                    this._x +
                    " " +
                    this._y
                );
            };
        window.SVGPathSegCurvetoQuadraticRel.prototype.clone = function () {
            return new window.SVGPathSegCurvetoQuadraticRel(
                undefined,
                this._x,
                this._y,
                this._x1,
                this._y1,
            );
        };
        Object.defineProperty(
            window.SVGPathSegCurvetoQuadraticRel.prototype,
            "x",
            {
                get: function () {
                    return this._x;
                },
                set: function (x) {
                    this._x = x;
                    this._segmentChanged();
                },
                enumerable: true,
            },
        );
        Object.defineProperty(
            window.SVGPathSegCurvetoQuadraticRel.prototype,
            "y",
            {
                get: function () {
                    return this._y;
                },
                set: function (y) {
                    this._y = y;
                    this._segmentChanged();
                },
                enumerable: true,
            },
        );
        Object.defineProperty(
            window.SVGPathSegCurvetoQuadraticRel.prototype,
            "x1",
            {
                get: function () {
                    return this._x1;
                },
                set: function (x1) {
                    this._x1 = x1;
                    this._segmentChanged();
                },
                enumerable: true,
            },
        );
        Object.defineProperty(
            window.SVGPathSegCurvetoQuadraticRel.prototype,
            "y1",
            {
                get: function () {
                    return this._y1;
                },
                set: function (y1) {
                    this._y1 = y1;
                    this._segmentChanged();
                },
                enumerable: true,
            },
        );
        window.SVGPathSegArcAbs = function (
            owningPathSegList,
            x,
            y,
            r1,
            r2,
            angle,
            largeArcFlag,
            sweepFlag,
        ) {
            window.SVGPathSeg.call(
                this,
                window.SVGPathSeg.PATHSEG_ARC_ABS,
                "A",
                owningPathSegList,
            );
            this._x = x;
            this._y = y;
            this._r1 = r1;
            this._r2 = r2;
            this._angle = angle;
            this._largeArcFlag = largeArcFlag;
            this._sweepFlag = sweepFlag;
        };
        window.SVGPathSegArcAbs.prototype = Object.create(
            window.SVGPathSeg.prototype,
        );
        window.SVGPathSegArcAbs.prototype.toString = function () {
            return "[object SVGPathSegArcAbs]";
        };
        window.SVGPathSegArcAbs.prototype._asPathString = function () {
            return (
                this.pathSegTypeAsLetter +
                " " +
                this._r1 +
                " " +
                this._r2 +
                " " +
                this._angle +
                " " +
                (this._largeArcFlag ? "1" : "0") +
                " " +
                (this._sweepFlag ? "1" : "0") +
                " " +
                this._x +
                " " +
                this._y
            );
        };
        window.SVGPathSegArcAbs.prototype.clone = function () {
            return new window.SVGPathSegArcAbs(
                undefined,
                this._x,
                this._y,
                this._r1,
                this._r2,
                this._angle,
                this._largeArcFlag,
                this._sweepFlag,
            );
        };
        Object.defineProperty(window.SVGPathSegArcAbs.prototype, "x", {
            get: function () {
                return this._x;
            },
            set: function (x) {
                this._x = x;
                this._segmentChanged();
            },
            enumerable: true,
        });
        Object.defineProperty(window.SVGPathSegArcAbs.prototype, "y", {
            get: function () {
                return this._y;
            },
            set: function (y) {
                this._y = y;
                this._segmentChanged();
            },
            enumerable: true,
        });
        Object.defineProperty(window.SVGPathSegArcAbs.prototype, "r1", {
            get: function () {
                return this._r1;
            },
            set: function (r1) {
                this._r1 = r1;
                this._segmentChanged();
            },
            enumerable: true,
        });
        Object.defineProperty(window.SVGPathSegArcAbs.prototype, "r2", {
            get: function () {
                return this._r2;
            },
            set: function (r2) {
                this._r2 = r2;
                this._segmentChanged();
            },
            enumerable: true,
        });
        Object.defineProperty(window.SVGPathSegArcAbs.prototype, "angle", {
            get: function () {
                return this._angle;
            },
            set: function (angle) {
                this._angle = angle;
                this._segmentChanged();
            },
            enumerable: true,
        });
        Object.defineProperty(
            window.SVGPathSegArcAbs.prototype,
            "largeArcFlag",
            {
                get: function () {
                    return this._largeArcFlag;
                },
                set: function (largeArcFlag) {
                    this._largeArcFlag = largeArcFlag;
                    this._segmentChanged();
                },
                enumerable: true,
            },
        );
        Object.defineProperty(window.SVGPathSegArcAbs.prototype, "sweepFlag", {
            get: function () {
                return this._sweepFlag;
            },
            set: function (sweepFlag) {
                this._sweepFlag = sweepFlag;
                this._segmentChanged();
            },
            enumerable: true,
        });
        window.SVGPathSegArcRel = function (
            owningPathSegList,
            x,
            y,
            r1,
            r2,
            angle,
            largeArcFlag,
            sweepFlag,
        ) {
            window.SVGPathSeg.call(
                this,
                window.SVGPathSeg.PATHSEG_ARC_REL,
                "a",
                owningPathSegList,
            );
            this._x = x;
            this._y = y;
            this._r1 = r1;
            this._r2 = r2;
            this._angle = angle;
            this._largeArcFlag = largeArcFlag;
            this._sweepFlag = sweepFlag;
        };
        window.SVGPathSegArcRel.prototype = Object.create(
            window.SVGPathSeg.prototype,
        );
        window.SVGPathSegArcRel.prototype.toString = function () {
            return "[object SVGPathSegArcRel]";
        };
        window.SVGPathSegArcRel.prototype._asPathString = function () {
            return (
                this.pathSegTypeAsLetter +
                " " +
                this._r1 +
                " " +
                this._r2 +
                " " +
                this._angle +
                " " +
                (this._largeArcFlag ? "1" : "0") +
                " " +
                (this._sweepFlag ? "1" : "0") +
                " " +
                this._x +
                " " +
                this._y
            );
        };
        window.SVGPathSegArcRel.prototype.clone = function () {
            return new window.SVGPathSegArcRel(
                undefined,
                this._x,
                this._y,
                this._r1,
                this._r2,
                this._angle,
                this._largeArcFlag,
                this._sweepFlag,
            );
        };
        Object.defineProperty(window.SVGPathSegArcRel.prototype, "x", {
            get: function () {
                return this._x;
            },
            set: function (x) {
                this._x = x;
                this._segmentChanged();
            },
            enumerable: true,
        });
        Object.defineProperty(window.SVGPathSegArcRel.prototype, "y", {
            get: function () {
                return this._y;
            },
            set: function (y) {
                this._y = y;
                this._segmentChanged();
            },
            enumerable: true,
        });
        Object.defineProperty(window.SVGPathSegArcRel.prototype, "r1", {
            get: function () {
                return this._r1;
            },
            set: function (r1) {
                this._r1 = r1;
                this._segmentChanged();
            },
            enumerable: true,
        });
        Object.defineProperty(window.SVGPathSegArcRel.prototype, "r2", {
            get: function () {
                return this._r2;
            },
            set: function (r2) {
                this._r2 = r2;
                this._segmentChanged();
            },
            enumerable: true,
        });
        Object.defineProperty(window.SVGPathSegArcRel.prototype, "angle", {
            get: function () {
                return this._angle;
            },
            set: function (angle) {
                this._angle = angle;
                this._segmentChanged();
            },
            enumerable: true,
        });
        Object.defineProperty(
            window.SVGPathSegArcRel.prototype,
            "largeArcFlag",
            {
                get: function () {
                    return this._largeArcFlag;
                },
                set: function (largeArcFlag) {
                    this._largeArcFlag = largeArcFlag;
                    this._segmentChanged();
                },
                enumerable: true,
            },
        );
        Object.defineProperty(window.SVGPathSegArcRel.prototype, "sweepFlag", {
            get: function () {
                return this._sweepFlag;
            },
            set: function (sweepFlag) {
                this._sweepFlag = sweepFlag;
                this._segmentChanged();
            },
            enumerable: true,
        });
        window.SVGPathSegLinetoHorizontalAbs = function (owningPathSegList, x) {
            window.SVGPathSeg.call(
                this,
                window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_ABS,
                "H",
                owningPathSegList,
            );
            this._x = x;
        };
        window.SVGPathSegLinetoHorizontalAbs.prototype = Object.create(
            window.SVGPathSeg.prototype,
        );
        window.SVGPathSegLinetoHorizontalAbs.prototype.toString = function () {
            return "[object SVGPathSegLinetoHorizontalAbs]";
        };
        window.SVGPathSegLinetoHorizontalAbs.prototype._asPathString =
            function () {
                return this.pathSegTypeAsLetter + " " + this._x;
            };
        window.SVGPathSegLinetoHorizontalAbs.prototype.clone = function () {
            return new window.SVGPathSegLinetoHorizontalAbs(undefined, this._x);
        };
        Object.defineProperty(
            window.SVGPathSegLinetoHorizontalAbs.prototype,
            "x",
            {
                get: function () {
                    return this._x;
                },
                set: function (x) {
                    this._x = x;
                    this._segmentChanged();
                },
                enumerable: true,
            },
        );
        window.SVGPathSegLinetoHorizontalRel = function (owningPathSegList, x) {
            window.SVGPathSeg.call(
                this,
                window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_REL,
                "h",
                owningPathSegList,
            );
            this._x = x;
        };
        window.SVGPathSegLinetoHorizontalRel.prototype = Object.create(
            window.SVGPathSeg.prototype,
        );
        window.SVGPathSegLinetoHorizontalRel.prototype.toString = function () {
            return "[object SVGPathSegLinetoHorizontalRel]";
        };
        window.SVGPathSegLinetoHorizontalRel.prototype._asPathString =
            function () {
                return this.pathSegTypeAsLetter + " " + this._x;
            };
        window.SVGPathSegLinetoHorizontalRel.prototype.clone = function () {
            return new window.SVGPathSegLinetoHorizontalRel(undefined, this._x);
        };
        Object.defineProperty(
            window.SVGPathSegLinetoHorizontalRel.prototype,
            "x",
            {
                get: function () {
                    return this._x;
                },
                set: function (x) {
                    this._x = x;
                    this._segmentChanged();
                },
                enumerable: true,
            },
        );
        window.SVGPathSegLinetoVerticalAbs = function (owningPathSegList, y) {
            window.SVGPathSeg.call(
                this,
                window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_ABS,
                "V",
                owningPathSegList,
            );
            this._y = y;
        };
        window.SVGPathSegLinetoVerticalAbs.prototype = Object.create(
            window.SVGPathSeg.prototype,
        );
        window.SVGPathSegLinetoVerticalAbs.prototype.toString = function () {
            return "[object SVGPathSegLinetoVerticalAbs]";
        };
        window.SVGPathSegLinetoVerticalAbs.prototype._asPathString =
            function () {
                return this.pathSegTypeAsLetter + " " + this._y;
            };
        window.SVGPathSegLinetoVerticalAbs.prototype.clone = function () {
            return new window.SVGPathSegLinetoVerticalAbs(undefined, this._y);
        };
        Object.defineProperty(
            window.SVGPathSegLinetoVerticalAbs.prototype,
            "y",
            {
                get: function () {
                    return this._y;
                },
                set: function (y) {
                    this._y = y;
                    this._segmentChanged();
                },
                enumerable: true,
            },
        );
        window.SVGPathSegLinetoVerticalRel = function (owningPathSegList, y) {
            window.SVGPathSeg.call(
                this,
                window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_REL,
                "v",
                owningPathSegList,
            );
            this._y = y;
        };
        window.SVGPathSegLinetoVerticalRel.prototype = Object.create(
            window.SVGPathSeg.prototype,
        );
        window.SVGPathSegLinetoVerticalRel.prototype.toString = function () {
            return "[object SVGPathSegLinetoVerticalRel]";
        };
        window.SVGPathSegLinetoVerticalRel.prototype._asPathString =
            function () {
                return this.pathSegTypeAsLetter + " " + this._y;
            };
        window.SVGPathSegLinetoVerticalRel.prototype.clone = function () {
            return new window.SVGPathSegLinetoVerticalRel(undefined, this._y);
        };
        Object.defineProperty(
            window.SVGPathSegLinetoVerticalRel.prototype,
            "y",
            {
                get: function () {
                    return this._y;
                },
                set: function (y) {
                    this._y = y;
                    this._segmentChanged();
                },
                enumerable: true,
            },
        );
        window.SVGPathSegCurvetoCubicSmoothAbs = function (
            owningPathSegList,
            x,
            y,
            x2,
            y2,
        ) {
            window.SVGPathSeg.call(
                this,
                window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_ABS,
                "S",
                owningPathSegList,
            );
            this._x = x;
            this._y = y;
            this._x2 = x2;
            this._y2 = y2;
        };
        window.SVGPathSegCurvetoCubicSmoothAbs.prototype = Object.create(
            window.SVGPathSeg.prototype,
        );
        window.SVGPathSegCurvetoCubicSmoothAbs.prototype.toString =
            function () {
                return "[object SVGPathSegCurvetoCubicSmoothAbs]";
            };
        window.SVGPathSegCurvetoCubicSmoothAbs.prototype._asPathString =
            function () {
                return (
                    this.pathSegTypeAsLetter +
                    " " +
                    this._x2 +
                    " " +
                    this._y2 +
                    " " +
                    this._x +
                    " " +
                    this._y
                );
            };
        window.SVGPathSegCurvetoCubicSmoothAbs.prototype.clone = function () {
            return new window.SVGPathSegCurvetoCubicSmoothAbs(
                undefined,
                this._x,
                this._y,
                this._x2,
                this._y2,
            );
        };
        Object.defineProperty(
            window.SVGPathSegCurvetoCubicSmoothAbs.prototype,
            "x",
            {
                get: function () {
                    return this._x;
                },
                set: function (x) {
                    this._x = x;
                    this._segmentChanged();
                },
                enumerable: true,
            },
        );
        Object.defineProperty(
            window.SVGPathSegCurvetoCubicSmoothAbs.prototype,
            "y",
            {
                get: function () {
                    return this._y;
                },
                set: function (y) {
                    this._y = y;
                    this._segmentChanged();
                },
                enumerable: true,
            },
        );
        Object.defineProperty(
            window.SVGPathSegCurvetoCubicSmoothAbs.prototype,
            "x2",
            {
                get: function () {
                    return this._x2;
                },
                set: function (x2) {
                    this._x2 = x2;
                    this._segmentChanged();
                },
                enumerable: true,
            },
        );
        Object.defineProperty(
            window.SVGPathSegCurvetoCubicSmoothAbs.prototype,
            "y2",
            {
                get: function () {
                    return this._y2;
                },
                set: function (y2) {
                    this._y2 = y2;
                    this._segmentChanged();
                },
                enumerable: true,
            },
        );
        window.SVGPathSegCurvetoCubicSmoothRel = function (
            owningPathSegList,
            x,
            y,
            x2,
            y2,
        ) {
            window.SVGPathSeg.call(
                this,
                window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_REL,
                "s",
                owningPathSegList,
            );
            this._x = x;
            this._y = y;
            this._x2 = x2;
            this._y2 = y2;
        };
        window.SVGPathSegCurvetoCubicSmoothRel.prototype = Object.create(
            window.SVGPathSeg.prototype,
        );
        window.SVGPathSegCurvetoCubicSmoothRel.prototype.toString =
            function () {
                return "[object SVGPathSegCurvetoCubicSmoothRel]";
            };
        window.SVGPathSegCurvetoCubicSmoothRel.prototype._asPathString =
            function () {
                return (
                    this.pathSegTypeAsLetter +
                    " " +
                    this._x2 +
                    " " +
                    this._y2 +
                    " " +
                    this._x +
                    " " +
                    this._y
                );
            };
        window.SVGPathSegCurvetoCubicSmoothRel.prototype.clone = function () {
            return new window.SVGPathSegCurvetoCubicSmoothRel(
                undefined,
                this._x,
                this._y,
                this._x2,
                this._y2,
            );
        };
        Object.defineProperty(
            window.SVGPathSegCurvetoCubicSmoothRel.prototype,
            "x",
            {
                get: function () {
                    return this._x;
                },
                set: function (x) {
                    this._x = x;
                    this._segmentChanged();
                },
                enumerable: true,
            },
        );
        Object.defineProperty(
            window.SVGPathSegCurvetoCubicSmoothRel.prototype,
            "y",
            {
                get: function () {
                    return this._y;
                },
                set: function (y) {
                    this._y = y;
                    this._segmentChanged();
                },
                enumerable: true,
            },
        );
        Object.defineProperty(
            window.SVGPathSegCurvetoCubicSmoothRel.prototype,
            "x2",
            {
                get: function () {
                    return this._x2;
                },
                set: function (x2) {
                    this._x2 = x2;
                    this._segmentChanged();
                },
                enumerable: true,
            },
        );
        Object.defineProperty(
            window.SVGPathSegCurvetoCubicSmoothRel.prototype,
            "y2",
            {
                get: function () {
                    return this._y2;
                },
                set: function (y2) {
                    this._y2 = y2;
                    this._segmentChanged();
                },
                enumerable: true,
            },
        );
        window.SVGPathSegCurvetoQuadraticSmoothAbs = function (
            owningPathSegList,
            x,
            y,
        ) {
            window.SVGPathSeg.call(
                this,
                window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_ABS,
                "T",
                owningPathSegList,
            );
            this._x = x;
            this._y = y;
        };
        window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype = Object.create(
            window.SVGPathSeg.prototype,
        );
        window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype.toString =
            function () {
                return "[object SVGPathSegCurvetoQuadraticSmoothAbs]";
            };
        window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype._asPathString =
            function () {
                return this.pathSegTypeAsLetter + " " + this._x + " " + this._y;
            };
        window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype.clone =
            function () {
                return new window.SVGPathSegCurvetoQuadraticSmoothAbs(
                    undefined,
                    this._x,
                    this._y,
                );
            };
        Object.defineProperty(
            window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype,
            "x",
            {
                get: function () {
                    return this._x;
                },
                set: function (x) {
                    this._x = x;
                    this._segmentChanged();
                },
                enumerable: true,
            },
        );
        Object.defineProperty(
            window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype,
            "y",
            {
                get: function () {
                    return this._y;
                },
                set: function (y) {
                    this._y = y;
                    this._segmentChanged();
                },
                enumerable: true,
            },
        );
        window.SVGPathSegCurvetoQuadraticSmoothRel = function (
            owningPathSegList,
            x,
            y,
        ) {
            window.SVGPathSeg.call(
                this,
                window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_REL,
                "t",
                owningPathSegList,
            );
            this._x = x;
            this._y = y;
        };
        window.SVGPathSegCurvetoQuadraticSmoothRel.prototype = Object.create(
            window.SVGPathSeg.prototype,
        );
        window.SVGPathSegCurvetoQuadraticSmoothRel.prototype.toString =
            function () {
                return "[object SVGPathSegCurvetoQuadraticSmoothRel]";
            };
        window.SVGPathSegCurvetoQuadraticSmoothRel.prototype._asPathString =
            function () {
                return this.pathSegTypeAsLetter + " " + this._x + " " + this._y;
            };
        window.SVGPathSegCurvetoQuadraticSmoothRel.prototype.clone =
            function () {
                return new window.SVGPathSegCurvetoQuadraticSmoothRel(
                    undefined,
                    this._x,
                    this._y,
                );
            };
        Object.defineProperty(
            window.SVGPathSegCurvetoQuadraticSmoothRel.prototype,
            "x",
            {
                get: function () {
                    return this._x;
                },
                set: function (x) {
                    this._x = x;
                    this._segmentChanged();
                },
                enumerable: true,
            },
        );
        Object.defineProperty(
            window.SVGPathSegCurvetoQuadraticSmoothRel.prototype,
            "y",
            {
                get: function () {
                    return this._y;
                },
                set: function (y) {
                    this._y = y;
                    this._segmentChanged();
                },
                enumerable: true,
            },
        );

        // Add createSVGPathSeg* functions to window.SVGPathElement.
        // Spec: http://www.w3.org/TR/SVG11/single-page.html#paths-Interfacewindow.SVGPathElement.
        window.SVGPathElement.prototype.createSVGPathSegClosePath =
            function () {
                return new window.SVGPathSegClosePath(undefined);
            };
        window.SVGPathElement.prototype.createSVGPathSegMovetoAbs = function (
            x,
            y,
        ) {
            return new window.SVGPathSegMovetoAbs(undefined, x, y);
        };
        window.SVGPathElement.prototype.createSVGPathSegMovetoRel = function (
            x,
            y,
        ) {
            return new window.SVGPathSegMovetoRel(undefined, x, y);
        };
        window.SVGPathElement.prototype.createSVGPathSegLinetoAbs = function (
            x,
            y,
        ) {
            return new window.SVGPathSegLinetoAbs(undefined, x, y);
        };
        window.SVGPathElement.prototype.createSVGPathSegLinetoRel = function (
            x,
            y,
        ) {
            return new window.SVGPathSegLinetoRel(undefined, x, y);
        };
        window.SVGPathElement.prototype.createSVGPathSegCurvetoCubicAbs =
            function (x, y, x1, y1, x2, y2) {
                return new window.SVGPathSegCurvetoCubicAbs(
                    undefined,
                    x,
                    y,
                    x1,
                    y1,
                    x2,
                    y2,
                );
            };
        window.SVGPathElement.prototype.createSVGPathSegCurvetoCubicRel =
            function (x, y, x1, y1, x2, y2) {
                return new window.SVGPathSegCurvetoCubicRel(
                    undefined,
                    x,
                    y,
                    x1,
                    y1,
                    x2,
                    y2,
                );
            };
        window.SVGPathElement.prototype.createSVGPathSegCurvetoQuadraticAbs =
            function (x, y, x1, y1) {
                return new window.SVGPathSegCurvetoQuadraticAbs(
                    undefined,
                    x,
                    y,
                    x1,
                    y1,
                );
            };
        window.SVGPathElement.prototype.createSVGPathSegCurvetoQuadraticRel =
            function (x, y, x1, y1) {
                return new window.SVGPathSegCurvetoQuadraticRel(
                    undefined,
                    x,
                    y,
                    x1,
                    y1,
                );
            };
        window.SVGPathElement.prototype.createSVGPathSegArcAbs = function (
            x,
            y,
            r1,
            r2,
            angle,
            largeArcFlag,
            sweepFlag,
        ) {
            return new window.SVGPathSegArcAbs(
                undefined,
                x,
                y,
                r1,
                r2,
                angle,
                largeArcFlag,
                sweepFlag,
            );
        };
        window.SVGPathElement.prototype.createSVGPathSegArcRel = function (
            x,
            y,
            r1,
            r2,
            angle,
            largeArcFlag,
            sweepFlag,
        ) {
            return new window.SVGPathSegArcRel(
                undefined,
                x,
                y,
                r1,
                r2,
                angle,
                largeArcFlag,
                sweepFlag,
            );
        };
        window.SVGPathElement.prototype.createSVGPathSegLinetoHorizontalAbs =
            function (x) {
                return new window.SVGPathSegLinetoHorizontalAbs(undefined, x);
            };
        window.SVGPathElement.prototype.createSVGPathSegLinetoHorizontalRel =
            function (x) {
                return new window.SVGPathSegLinetoHorizontalRel(undefined, x);
            };
        window.SVGPathElement.prototype.createSVGPathSegLinetoVerticalAbs =
            function (y) {
                return new window.SVGPathSegLinetoVerticalAbs(undefined, y);
            };
        window.SVGPathElement.prototype.createSVGPathSegLinetoVerticalRel =
            function (y) {
                return new window.SVGPathSegLinetoVerticalRel(undefined, y);
            };
        window.SVGPathElement.prototype.createSVGPathSegCurvetoCubicSmoothAbs =
            function (x, y, x2, y2) {
                return new window.SVGPathSegCurvetoCubicSmoothAbs(
                    undefined,
                    x,
                    y,
                    x2,
                    y2,
                );
            };
        window.SVGPathElement.prototype.createSVGPathSegCurvetoCubicSmoothRel =
            function (x, y, x2, y2) {
                return new window.SVGPathSegCurvetoCubicSmoothRel(
                    undefined,
                    x,
                    y,
                    x2,
                    y2,
                );
            };
        window.SVGPathElement.prototype.createSVGPathSegCurvetoQuadraticSmoothAbs =
            function (x, y) {
                return new window.SVGPathSegCurvetoQuadraticSmoothAbs(
                    undefined,
                    x,
                    y,
                );
            };
        window.SVGPathElement.prototype.createSVGPathSegCurvetoQuadraticSmoothRel =
            function (x, y) {
                return new window.SVGPathSegCurvetoQuadraticSmoothRel(
                    undefined,
                    x,
                    y,
                );
            };
        if (!("getPathSegAtLength" in window.SVGPathElement.prototype)) {
            // Add getPathSegAtLength to SVGPathElement.
            // Spec: https://www.w3.org/TR/SVG11/single-page.html#paths-__svg__SVGPathElement__getPathSegAtLength
            // This polyfill requires SVGPathElement.getTotalLength to implement the distance-along-a-path algorithm.
            window.SVGPathElement.prototype.getPathSegAtLength = function (
                distance,
            ) {
                if (distance === undefined || !isFinite(distance))
                    throw "Invalid arguments.";
                var measurementElement = document.createElementNS(
                    "http://www.w3.org/2000/svg",
                    "path",
                );
                measurementElement.setAttribute("d", this.getAttribute("d"));
                var lastPathSegment =
                    measurementElement.pathSegList.numberOfItems - 1;

                // If the path is empty, return 0.
                if (lastPathSegment <= 0) return 0;
                do {
                    measurementElement.pathSegList.removeItem(lastPathSegment);
                    if (distance > measurementElement.getTotalLength()) break;
                    lastPathSegment--;
                } while (lastPathSegment > 0);
                return lastPathSegment;
            };
        }
    }

    // Checking for SVGPathSegList in window checks for the case of an implementation without the
    // SVGPathSegList API.
    // The second check for appendItem is specific to Firefox 59+ which removed only parts of the
    // SVGPathSegList API (e.g., appendItem). In this case we need to re-implement the entire API
    // so the polyfill data (i.e., _list) is used throughout.
    if (
        !("SVGPathSegList" in window) ||
        !("appendItem" in window.SVGPathSegList.prototype)
    ) {
        // Spec: http://www.w3.org/TR/SVG11/single-page.html#paths-InterfaceSVGPathSegList
        window.SVGPathSegList = function (pathElement) {
            this._pathElement = pathElement;
            this._list = this._parsePath(this._pathElement.getAttribute("d"));

            // Use a MutationObserver to catch changes to the path's "d" attribute.
            this._mutationObserverConfig = {
                attributes: true,
                attributeFilter: ["d"],
            };
            this._pathElementMutationObserver = new MutationObserver(
                this._updateListFromPathMutations.bind(this),
            );
            this._pathElementMutationObserver.observe(
                this._pathElement,
                this._mutationObserverConfig,
            );
        };
        window.SVGPathSegList.prototype.classname = "SVGPathSegList";
        Object.defineProperty(
            window.SVGPathSegList.prototype,
            "numberOfItems",
            {
                get: function () {
                    this._checkPathSynchronizedToList();
                    return this._list.length;
                },
                enumerable: true,
            },
        );

        // The length property was not specified but was in Firefox 58.
        Object.defineProperty(window.SVGPathSegList.prototype, "length", {
            get: function () {
                this._checkPathSynchronizedToList();
                return this._list.length;
            },
            enumerable: true,
        });

        // Add the pathSegList accessors to window.SVGPathElement.
        // Spec: http://www.w3.org/TR/SVG11/single-page.html#paths-InterfaceSVGAnimatedPathData
        Object.defineProperty(window.SVGPathElement.prototype, "pathSegList", {
            get: function () {
                if (!this._pathSegList)
                    this._pathSegList = new window.SVGPathSegList(this);
                return this._pathSegList;
            },
            enumerable: true,
        });
        // FIXME: The following are not implemented and simply return window.SVGPathElement.pathSegList.
        Object.defineProperty(
            window.SVGPathElement.prototype,
            "normalizedPathSegList",
            {
                get: function () {
                    return this.pathSegList;
                },
                enumerable: true,
            },
        );
        Object.defineProperty(
            window.SVGPathElement.prototype,
            "animatedPathSegList",
            {
                get: function () {
                    return this.pathSegList;
                },
                enumerable: true,
            },
        );
        Object.defineProperty(
            window.SVGPathElement.prototype,
            "animatedNormalizedPathSegList",
            {
                get: function () {
                    return this.pathSegList;
                },
                enumerable: true,
            },
        );

        // Process any pending mutations to the path element and update the list as needed.
        // This should be the first call of all public functions and is needed because
        // MutationObservers are not synchronous so we can have pending asynchronous mutations.
        window.SVGPathSegList.prototype._checkPathSynchronizedToList =
            function () {
                this._updateListFromPathMutations(
                    this._pathElementMutationObserver.takeRecords(),
                );
            };
        window.SVGPathSegList.prototype._updateListFromPathMutations =
            function (mutationRecords) {
                if (!this._pathElement) return;
                var hasPathMutations = false;
                mutationRecords.forEach(function (record) {
                    if (record.attributeName == "d") hasPathMutations = true;
                });
                if (hasPathMutations)
                    this._list = this._parsePath(
                        this._pathElement.getAttribute("d"),
                    );
            };

        // Serialize the list and update the path's 'd' attribute.
        window.SVGPathSegList.prototype._writeListToPath = function () {
            this._pathElementMutationObserver.disconnect();
            this._pathElement.setAttribute(
                "d",
                window.SVGPathSegList._pathSegArrayAsString(this._list),
            );
            this._pathElementMutationObserver.observe(
                this._pathElement,
                this._mutationObserverConfig,
            );
        };

        // When a path segment changes the list needs to be synchronized back to the path element.
        window.SVGPathSegList.prototype.segmentChanged = function (pathSeg) {
            this._writeListToPath();
        };
        window.SVGPathSegList.prototype.clear = function () {
            this._checkPathSynchronizedToList();
            this._list.forEach(function (pathSeg) {
                pathSeg._owningPathSegList = null;
            });
            this._list = [];
            this._writeListToPath();
        };
        window.SVGPathSegList.prototype.initialize = function (newItem) {
            this._checkPathSynchronizedToList();
            this._list = [newItem];
            newItem._owningPathSegList = this;
            this._writeListToPath();
            return newItem;
        };
        window.SVGPathSegList.prototype._checkValidIndex = function (index) {
            if (isNaN(index) || index < 0 || index >= this.numberOfItems)
                throw "INDEX_SIZE_ERR";
        };
        window.SVGPathSegList.prototype.getItem = function (index) {
            this._checkPathSynchronizedToList();
            this._checkValidIndex(index);
            return this._list[index];
        };
        window.SVGPathSegList.prototype.insertItemBefore = function (
            newItem,
            index,
        ) {
            this._checkPathSynchronizedToList();

            // Spec: If the index is greater than or equal to numberOfItems, then the new item is appended to the end of the list.
            if (index > this.numberOfItems) index = this.numberOfItems;
            if (newItem._owningPathSegList) {
                // SVG2 spec says to make a copy.
                newItem = newItem.clone();
            }
            this._list.splice(index, 0, newItem);
            newItem._owningPathSegList = this;
            this._writeListToPath();
            return newItem;
        };
        window.SVGPathSegList.prototype.replaceItem = function (
            newItem,
            index,
        ) {
            this._checkPathSynchronizedToList();
            if (newItem._owningPathSegList) {
                // SVG2 spec says to make a copy.
                newItem = newItem.clone();
            }
            this._checkValidIndex(index);
            this._list[index] = newItem;
            newItem._owningPathSegList = this;
            this._writeListToPath();
            return newItem;
        };
        window.SVGPathSegList.prototype.removeItem = function (index) {
            this._checkPathSynchronizedToList();
            this._checkValidIndex(index);
            var item = this._list[index];
            this._list.splice(index, 1);
            this._writeListToPath();
            return item;
        };
        window.SVGPathSegList.prototype.appendItem = function (newItem) {
            this._checkPathSynchronizedToList();
            if (newItem._owningPathSegList) {
                // SVG2 spec says to make a copy.
                newItem = newItem.clone();
            }
            this._list.push(newItem);
            newItem._owningPathSegList = this;
            // TODO: Optimize this to just append to the existing attribute.
            this._writeListToPath();
            return newItem;
        };
        window.SVGPathSegList._pathSegArrayAsString = function (pathSegArray) {
            var string = "";
            var first = true;
            pathSegArray.forEach(function (pathSeg) {
                if (first) {
                    first = false;
                    string += pathSeg._asPathString();
                } else {
                    string += " " + pathSeg._asPathString();
                }
            });
            return string;
        };

        // This closely follows SVGPathParser::parsePath from Source/core/svg/SVGPathParser.cpp.
        window.SVGPathSegList.prototype._parsePath = function (string) {
            if (!string || string.length == 0) return [];
            var owningPathSegList = this;
            var Builder = function () {
                this.pathSegList = [];
            };
            Builder.prototype.appendSegment = function (pathSeg) {
                this.pathSegList.push(pathSeg);
            };
            var Source = function (string) {
                this._string = string;
                this._currentIndex = 0;
                this._endIndex = this._string.length;
                this._previousCommand = window.SVGPathSeg.PATHSEG_UNKNOWN;
                this._skipOptionalSpaces();
            };
            Source.prototype._isCurrentSpace = function () {
                var character = this._string[this._currentIndex];
                return (
                    character <= " " &&
                    (character == " " ||
                        character == "\n" ||
                        character == "\t" ||
                        character == "\r" ||
                        character == "\f")
                );
            };
            Source.prototype._skipOptionalSpaces = function () {
                while (
                    this._currentIndex < this._endIndex &&
                    this._isCurrentSpace()
                )
                    this._currentIndex++;
                return this._currentIndex < this._endIndex;
            };
            Source.prototype._skipOptionalSpacesOrDelimiter = function () {
                if (
                    this._currentIndex < this._endIndex &&
                    !this._isCurrentSpace() &&
                    this._string.charAt(this._currentIndex) != ","
                )
                    return false;
                if (this._skipOptionalSpaces()) {
                    if (
                        this._currentIndex < this._endIndex &&
                        this._string.charAt(this._currentIndex) == ","
                    ) {
                        this._currentIndex++;
                        this._skipOptionalSpaces();
                    }
                }
                return this._currentIndex < this._endIndex;
            };
            Source.prototype.hasMoreData = function () {
                return this._currentIndex < this._endIndex;
            };
            Source.prototype.peekSegmentType = function () {
                var lookahead = this._string[this._currentIndex];
                return this._pathSegTypeFromChar(lookahead);
            };
            Source.prototype._pathSegTypeFromChar = function (lookahead) {
                switch (lookahead) {
                    case "Z":
                    case "z":
                        return window.SVGPathSeg.PATHSEG_CLOSEPATH;
                    case "M":
                        return window.SVGPathSeg.PATHSEG_MOVETO_ABS;
                    case "m":
                        return window.SVGPathSeg.PATHSEG_MOVETO_REL;
                    case "L":
                        return window.SVGPathSeg.PATHSEG_LINETO_ABS;
                    case "l":
                        return window.SVGPathSeg.PATHSEG_LINETO_REL;
                    case "C":
                        return window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS;
                    case "c":
                        return window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_REL;
                    case "Q":
                        return window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_ABS;
                    case "q":
                        return window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_REL;
                    case "A":
                        return window.SVGPathSeg.PATHSEG_ARC_ABS;
                    case "a":
                        return window.SVGPathSeg.PATHSEG_ARC_REL;
                    case "H":
                        return window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_ABS;
                    case "h":
                        return window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_REL;
                    case "V":
                        return window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_ABS;
                    case "v":
                        return window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_REL;
                    case "S":
                        return window.SVGPathSeg
                            .PATHSEG_CURVETO_CUBIC_SMOOTH_ABS;
                    case "s":
                        return window.SVGPathSeg
                            .PATHSEG_CURVETO_CUBIC_SMOOTH_REL;
                    case "T":
                        return window.SVGPathSeg
                            .PATHSEG_CURVETO_QUADRATIC_SMOOTH_ABS;
                    case "t":
                        return window.SVGPathSeg
                            .PATHSEG_CURVETO_QUADRATIC_SMOOTH_REL;
                    default:
                        return window.SVGPathSeg.PATHSEG_UNKNOWN;
                }
            };
            Source.prototype._nextCommandHelper = function (
                lookahead,
                previousCommand,
            ) {
                // Check for remaining coordinates in the current command.
                if (
                    (lookahead == "+" ||
                        lookahead == "-" ||
                        lookahead == "." ||
                        (lookahead >= "0" && lookahead <= "9")) &&
                    previousCommand != window.SVGPathSeg.PATHSEG_CLOSEPATH
                ) {
                    if (previousCommand == window.SVGPathSeg.PATHSEG_MOVETO_ABS)
                        return window.SVGPathSeg.PATHSEG_LINETO_ABS;
                    if (previousCommand == window.SVGPathSeg.PATHSEG_MOVETO_REL)
                        return window.SVGPathSeg.PATHSEG_LINETO_REL;
                    return previousCommand;
                }
                return window.SVGPathSeg.PATHSEG_UNKNOWN;
            };
            Source.prototype.initialCommandIsMoveTo = function () {
                // If the path is empty it is still valid, so return true.
                if (!this.hasMoreData()) return true;
                var command = this.peekSegmentType();
                // Path must start with moveTo.
                return (
                    command == window.SVGPathSeg.PATHSEG_MOVETO_ABS ||
                    command == window.SVGPathSeg.PATHSEG_MOVETO_REL
                );
            };

            // Parse a number from an SVG path. This very closely follows genericParseNumber(...) from Source/core/svg/SVGParserUtilities.cpp.
            // Spec: http://www.w3.org/TR/SVG11/single-page.html#paths-PathDataBNF
            Source.prototype._parseNumber = function () {
                var exponent = 0;
                var integer = 0;
                var frac = 1;
                var decimal = 0;
                var sign = 1;
                var expsign = 1;
                var startIndex = this._currentIndex;
                this._skipOptionalSpaces();

                // Read the sign.
                if (
                    this._currentIndex < this._endIndex &&
                    this._string.charAt(this._currentIndex) == "+"
                )
                    this._currentIndex++;
                else if (
                    this._currentIndex < this._endIndex &&
                    this._string.charAt(this._currentIndex) == "-"
                ) {
                    this._currentIndex++;
                    sign = -1;
                }
                if (
                    this._currentIndex == this._endIndex ||
                    ((this._string.charAt(this._currentIndex) < "0" ||
                        this._string.charAt(this._currentIndex) > "9") &&
                        this._string.charAt(this._currentIndex) != ".")
                )
                    // The first character of a number must be one of [0-9+-.].
                    return undefined;

                // Read the integer part, build right-to-left.
                var startIntPartIndex = this._currentIndex;
                while (
                    this._currentIndex < this._endIndex &&
                    this._string.charAt(this._currentIndex) >= "0" &&
                    this._string.charAt(this._currentIndex) <= "9"
                )
                    this._currentIndex++; // Advance to first non-digit.

                if (this._currentIndex != startIntPartIndex) {
                    var scanIntPartIndex = this._currentIndex - 1;
                    var multiplier = 1;
                    while (scanIntPartIndex >= startIntPartIndex) {
                        integer +=
                            multiplier *
                            (this._string.charAt(scanIntPartIndex--) - "0");
                        multiplier *= 10;
                    }
                }

                // Read the decimals.
                if (
                    this._currentIndex < this._endIndex &&
                    this._string.charAt(this._currentIndex) == "."
                ) {
                    this._currentIndex++;

                    // There must be a least one digit following the .
                    if (
                        this._currentIndex >= this._endIndex ||
                        this._string.charAt(this._currentIndex) < "0" ||
                        this._string.charAt(this._currentIndex) > "9"
                    )
                        return undefined;
                    while (
                        this._currentIndex < this._endIndex &&
                        this._string.charAt(this._currentIndex) >= "0" &&
                        this._string.charAt(this._currentIndex) <= "9"
                    ) {
                        frac *= 10;
                        decimal +=
                            (this._string.charAt(this._currentIndex) - "0") /
                            frac;
                        this._currentIndex += 1;
                    }
                }

                // Read the exponent part.
                if (
                    this._currentIndex != startIndex &&
                    this._currentIndex + 1 < this._endIndex &&
                    (this._string.charAt(this._currentIndex) == "e" ||
                        this._string.charAt(this._currentIndex) == "E") &&
                    this._string.charAt(this._currentIndex + 1) != "x" &&
                    this._string.charAt(this._currentIndex + 1) != "m"
                ) {
                    this._currentIndex++;

                    // Read the sign of the exponent.
                    if (this._string.charAt(this._currentIndex) == "+") {
                        this._currentIndex++;
                    } else if (this._string.charAt(this._currentIndex) == "-") {
                        this._currentIndex++;
                        expsign = -1;
                    }

                    // There must be an exponent.
                    if (
                        this._currentIndex >= this._endIndex ||
                        this._string.charAt(this._currentIndex) < "0" ||
                        this._string.charAt(this._currentIndex) > "9"
                    )
                        return undefined;
                    while (
                        this._currentIndex < this._endIndex &&
                        this._string.charAt(this._currentIndex) >= "0" &&
                        this._string.charAt(this._currentIndex) <= "9"
                    ) {
                        exponent *= 10;
                        exponent +=
                            this._string.charAt(this._currentIndex) - "0";
                        this._currentIndex++;
                    }
                }
                var number = integer + decimal;
                number *= sign;
                if (exponent) number *= Math.pow(10, expsign * exponent);
                if (startIndex == this._currentIndex) return undefined;
                this._skipOptionalSpacesOrDelimiter();
                return number;
            };
            Source.prototype._parseArcFlag = function () {
                if (this._currentIndex >= this._endIndex) return undefined;
                var flag = false;
                var flagChar = this._string.charAt(this._currentIndex++);
                if (flagChar == "0") flag = false;
                else if (flagChar == "1") flag = true;
                else return undefined;
                this._skipOptionalSpacesOrDelimiter();
                return flag;
            };
            Source.prototype.parseSegment = function () {
                var lookahead = this._string[this._currentIndex];
                var command = this._pathSegTypeFromChar(lookahead);
                if (command == window.SVGPathSeg.PATHSEG_UNKNOWN) {
                    // Possibly an implicit command. Not allowed if this is the first command.
                    if (
                        this._previousCommand ==
                        window.SVGPathSeg.PATHSEG_UNKNOWN
                    )
                        return null;
                    command = this._nextCommandHelper(
                        lookahead,
                        this._previousCommand,
                    );
                    if (command == window.SVGPathSeg.PATHSEG_UNKNOWN)
                        return null;
                } else {
                    this._currentIndex++;
                }
                this._previousCommand = command;
                switch (command) {
                    case window.SVGPathSeg.PATHSEG_MOVETO_REL:
                        return new window.SVGPathSegMovetoRel(
                            owningPathSegList,
                            this._parseNumber(),
                            this._parseNumber(),
                        );
                    case window.SVGPathSeg.PATHSEG_MOVETO_ABS:
                        return new window.SVGPathSegMovetoAbs(
                            owningPathSegList,
                            this._parseNumber(),
                            this._parseNumber(),
                        );
                    case window.SVGPathSeg.PATHSEG_LINETO_REL:
                        return new window.SVGPathSegLinetoRel(
                            owningPathSegList,
                            this._parseNumber(),
                            this._parseNumber(),
                        );
                    case window.SVGPathSeg.PATHSEG_LINETO_ABS:
                        return new window.SVGPathSegLinetoAbs(
                            owningPathSegList,
                            this._parseNumber(),
                            this._parseNumber(),
                        );
                    case window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_REL:
                        return new window.SVGPathSegLinetoHorizontalRel(
                            owningPathSegList,
                            this._parseNumber(),
                        );
                    case window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_ABS:
                        return new window.SVGPathSegLinetoHorizontalAbs(
                            owningPathSegList,
                            this._parseNumber(),
                        );
                    case window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_REL:
                        return new window.SVGPathSegLinetoVerticalRel(
                            owningPathSegList,
                            this._parseNumber(),
                        );
                    case window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_ABS:
                        return new window.SVGPathSegLinetoVerticalAbs(
                            owningPathSegList,
                            this._parseNumber(),
                        );
                    case window.SVGPathSeg.PATHSEG_CLOSEPATH:
                        this._skipOptionalSpaces();
                        return new window.SVGPathSegClosePath(
                            owningPathSegList,
                        );
                    case window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_REL:
                        var points = {
                            x1: this._parseNumber(),
                            y1: this._parseNumber(),
                            x2: this._parseNumber(),
                            y2: this._parseNumber(),
                            x: this._parseNumber(),
                            y: this._parseNumber(),
                        };
                        return new window.SVGPathSegCurvetoCubicRel(
                            owningPathSegList,
                            points.x,
                            points.y,
                            points.x1,
                            points.y1,
                            points.x2,
                            points.y2,
                        );
                    case window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS:
                        var points = {
                            x1: this._parseNumber(),
                            y1: this._parseNumber(),
                            x2: this._parseNumber(),
                            y2: this._parseNumber(),
                            x: this._parseNumber(),
                            y: this._parseNumber(),
                        };
                        return new window.SVGPathSegCurvetoCubicAbs(
                            owningPathSegList,
                            points.x,
                            points.y,
                            points.x1,
                            points.y1,
                            points.x2,
                            points.y2,
                        );
                    case window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_REL:
                        var points = {
                            x2: this._parseNumber(),
                            y2: this._parseNumber(),
                            x: this._parseNumber(),
                            y: this._parseNumber(),
                        };
                        return new window.SVGPathSegCurvetoCubicSmoothRel(
                            owningPathSegList,
                            points.x,
                            points.y,
                            points.x2,
                            points.y2,
                        );
                    case window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_ABS:
                        var points = {
                            x2: this._parseNumber(),
                            y2: this._parseNumber(),
                            x: this._parseNumber(),
                            y: this._parseNumber(),
                        };
                        return new window.SVGPathSegCurvetoCubicSmoothAbs(
                            owningPathSegList,
                            points.x,
                            points.y,
                            points.x2,
                            points.y2,
                        );
                    case window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_REL:
                        var points = {
                            x1: this._parseNumber(),
                            y1: this._parseNumber(),
                            x: this._parseNumber(),
                            y: this._parseNumber(),
                        };
                        return new window.SVGPathSegCurvetoQuadraticRel(
                            owningPathSegList,
                            points.x,
                            points.y,
                            points.x1,
                            points.y1,
                        );
                    case window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_ABS:
                        var points = {
                            x1: this._parseNumber(),
                            y1: this._parseNumber(),
                            x: this._parseNumber(),
                            y: this._parseNumber(),
                        };
                        return new window.SVGPathSegCurvetoQuadraticAbs(
                            owningPathSegList,
                            points.x,
                            points.y,
                            points.x1,
                            points.y1,
                        );
                    case window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_REL:
                        return new window.SVGPathSegCurvetoQuadraticSmoothRel(
                            owningPathSegList,
                            this._parseNumber(),
                            this._parseNumber(),
                        );
                    case window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_ABS:
                        return new window.SVGPathSegCurvetoQuadraticSmoothAbs(
                            owningPathSegList,
                            this._parseNumber(),
                            this._parseNumber(),
                        );
                    case window.SVGPathSeg.PATHSEG_ARC_REL:
                        var points = {
                            x1: this._parseNumber(),
                            y1: this._parseNumber(),
                            arcAngle: this._parseNumber(),
                            arcLarge: this._parseArcFlag(),
                            arcSweep: this._parseArcFlag(),
                            x: this._parseNumber(),
                            y: this._parseNumber(),
                        };
                        return new window.SVGPathSegArcRel(
                            owningPathSegList,
                            points.x,
                            points.y,
                            points.x1,
                            points.y1,
                            points.arcAngle,
                            points.arcLarge,
                            points.arcSweep,
                        );
                    case window.SVGPathSeg.PATHSEG_ARC_ABS:
                        var points = {
                            x1: this._parseNumber(),
                            y1: this._parseNumber(),
                            arcAngle: this._parseNumber(),
                            arcLarge: this._parseArcFlag(),
                            arcSweep: this._parseArcFlag(),
                            x: this._parseNumber(),
                            y: this._parseNumber(),
                        };
                        return new window.SVGPathSegArcAbs(
                            owningPathSegList,
                            points.x,
                            points.y,
                            points.x1,
                            points.y1,
                            points.arcAngle,
                            points.arcLarge,
                            points.arcSweep,
                        );
                    default:
                        throw "Unknown path seg type.";
                }
            };
            var builder = new Builder();
            var source = new Source(string);
            if (!source.initialCommandIsMoveTo()) return [];
            while (source.hasMoreData()) {
                var pathSeg = source.parseSegment();
                if (!pathSeg) return [];
                builder.appendSegment(pathSeg);
            }
            return builder.pathSegList;
        };
    }
})();

/**
 *
 */
class Paint {
    /**
     * @param {module:jGraduate.jGraduatePaintOptions} [opt]
     */
    constructor(opt) {
        const options = opt || {};
        this.alpha = isNaN(options.alpha) ? 100 : options.alpha;
        // copy paint object
        if (options.copy) {
            /**
             * @name module:jGraduate~Paint#type
             * @type {"none"|"solidColor"|"linearGradient"|"radialGradient"}
             */
            this.type = options.copy.type;
            /**
             * Represents opacity (0-100).
             * @name module:jGraduate~Paint#alpha
             * @type {Float}
             */
            this.alpha = options.copy.alpha;
            /**
             * Represents #RRGGBB hex of color.
             * @name module:jGraduate~Paint#solidColor
             * @type {string}
             */
            this.solidColor = null;
            /**
             * @name module:jGraduate~Paint#linearGradient
             * @type {SVGLinearGradientElement}
             */
            this.linearGradient = null;
            /**
             * @name module:jGraduate~Paint#radialGradient
             * @type {SVGRadialGradientElement}
             */
            this.radialGradient = null;
            switch (this.type) {
                case "none":
                    break;
                case "solidColor":
                    this.solidColor = options.copy.solidColor;
                    break;
                case "linearGradient":
                    this.linearGradient =
                        options.copy.linearGradient.cloneNode(true);
                    break;
                case "radialGradient":
                    this.radialGradient =
                        options.copy.radialGradient.cloneNode(true);
                    break;
            }
            // create linear gradient paint
        } else if (options.linearGradient) {
            this.type = "linearGradient";
            this.solidColor = null;
            this.radialGradient = null;
            if (options.linearGradient.hasAttribute("xlink:href")) {
                const xhref = document.getElementById(
                    options.linearGradient.getAttribute("xlink:href").substr(1),
                );
                this.linearGradient = xhref.cloneNode(true);
            } else {
                this.linearGradient = options.linearGradient.cloneNode(true);
            }
            // create linear gradient paint
        } else if (options.radialGradient) {
            this.type = "radialGradient";
            this.solidColor = null;
            this.linearGradient = null;
            if (options.radialGradient.hasAttribute("xlink:href")) {
                const xhref = document.getElementById(
                    options.radialGradient.getAttribute("xlink:href").substr(1),
                );
                this.radialGradient = xhref.cloneNode(true);
            } else {
                this.radialGradient = options.radialGradient.cloneNode(true);
            }
            // create solid color paint
        } else if (options.solidColor) {
            this.type = "solidColor";
            this.solidColor = options.solidColor;
            // create empty paint
        } else {
            this.type = "none";
            this.solidColor = null;
            this.linearGradient = null;
            this.radialGradient = null;
        }
    }
}

/**
 * Path functionality.
 * @module path
 * @license MIT
 *
 * @copyright 2011 Alexis Deveria, 2011 Jeff Schiller
 */
let svgCanvas$h = null;

/**
 * @function module:path-actions.init
 * @param {module:path-actions.svgCanvas} pathMethodsContext
 * @returns {void}
 */
const init$i = (canvas) => {
    svgCanvas$h = canvas;
};

/* eslint-disable max-len */
/**
 * @function module:path.ptObjToArr
 * @todo See if this should just live in `replacePathSeg`
 * @param {string} type
 * @param {SVGPathSegMovetoAbs|SVGPathSegLinetoAbs|SVGPathSegCurvetoCubicAbs|SVGPathSegCurvetoQuadraticAbs|SVGPathSegArcAbs|SVGPathSegLinetoHorizontalAbs|SVGPathSegLinetoVerticalAbs|SVGPathSegCurvetoCubicSmoothAbs|SVGPathSegCurvetoQuadraticSmoothAbs} segItem
 * @returns {ArgumentsArray}
 */
/* eslint-enable max-len */
const ptObjToArrMethod = function (type, segItem) {
    const segData = svgCanvas$h.getSegData();
    const props = segData[type];
    return props.map((prop) => {
        return segItem[prop];
    });
};

/**
 * @function module:path.getGripPt
 * @param {Segment} seg
 * @param {module:math.XYObject} altPt
 * @returns {module:math.XYObject}
 */
const getGripPtMethod = function (seg, altPt) {
    const { path: pth } = seg;
    let out = {
        x: altPt ? altPt.x : seg.item.x,
        y: altPt ? altPt.y : seg.item.y,
    };
    if (pth.matrix) {
        const pt = transformPoint(out.x, out.y, pth.matrix);
        out = pt;
    }
    const zoom = svgCanvas$h.getZoom();
    out.x *= zoom;
    out.y *= zoom;
    return out;
};
/**
 * @function module:path.getPointFromGrip
 * @param {module:math.XYObject} pt
 * @param {module:path.Path} pth
 * @returns {module:math.XYObject}
 */
const getPointFromGripMethod = function (pt, pth) {
    const out = {
        x: pt.x,
        y: pt.y,
    };
    if (pth.matrix) {
        pt = transformPoint(out.x, out.y, pth.imatrix);
        out.x = pt.x;
        out.y = pt.y;
    }
    const zoom = svgCanvas$h.getZoom();
    out.x /= zoom;
    out.y /= zoom;
    return out;
};
/**
 * @function module:path.getGripContainer
 * @returns {Element}
 */
const getGripContainerMethod = function () {
    let c = getElement("pathpointgrip_container");
    if (!c) {
        const parentElement = getElement("selectorParentGroup");
        c = document.createElementNS(NS.SVG, "g");
        parentElement.append(c);
        c.id = "pathpointgrip_container";
    }
    return c;
};
/**
 * Requires prior call to `setUiStrings` if `xlink:title`
 *    to be set on the grip.
 * @function module:path.addPointGrip
 * @param {Integer} index
 * @param {Integer} x
 * @param {Integer} y
 * @returns {SVGCircleElement}
 */
const addPointGripMethod = function (index, x, y) {
    // create the container of all the point grips
    const pointGripContainer = getGripContainerMethod();
    let pointGrip = getElement("pathpointgrip_" + index);
    // create it
    if (!pointGrip) {
        pointGrip = document.createElementNS(NS.SVG, "circle");
        const atts = {
            id: "pathpointgrip_" + index,
            display: "none",
            r: 4,
            fill: "#0FF",
            stroke: "#00F",
            "stroke-width": 2,
            cursor: "move",
            style: "pointer-events:all",
        };
        const uiStrings = svgCanvas$h.getUIStrings();
        if ("pathNodeTooltip" in uiStrings) {
            // May be empty if running path.js without svg-editor
            atts["xlink:title"] = uiStrings.pathNodeTooltip;
        }
        assignAttributes(pointGrip, atts);
        pointGripContainer.append(pointGrip);
        const grip = document.getElementById("pathpointgrip_" + index);
        grip?.addEventListener("dblclick", () => {
            const path = svgCanvas$h.getPathObj();
            if (path) {
                path.setSegType();
            }
        });
    }
    if (x && y) {
        // set up the point grip element and display it
        assignAttributes(pointGrip, {
            cx: x,
            cy: y,
            display: "inline",
        });
    }
    return pointGrip;
};
/**
 * Requires prior call to `setUiStrings` if `xlink:title`
 *    to be set on the grip.
 * @function module:path.addCtrlGrip
 * @param {string} id
 * @returns {SVGCircleElement}
 */
const addCtrlGripMethod = function (id) {
    let pointGrip = getElement("ctrlpointgrip_" + id);
    if (pointGrip) {
        return pointGrip;
    }
    pointGrip = document.createElementNS(NS.SVG, "circle");
    const atts = {
        id: "ctrlpointgrip_" + id,
        display: "none",
        r: 4,
        fill: "#0FF",
        stroke: "#55F",
        "stroke-width": 1,
        cursor: "move",
        style: "pointer-events:all",
    };
    const uiStrings = svgCanvas$h.getUIStrings();
    if ("pathCtrlPtTooltip" in uiStrings) {
        // May be empty if running path.js without svg-editor
        atts["xlink:title"] = uiStrings.pathCtrlPtTooltip;
    }
    assignAttributes(pointGrip, atts);
    getGripContainerMethod().append(pointGrip);
    return pointGrip;
};
/**
 * @function module:path.getCtrlLine
 * @param {string} id
 * @returns {SVGLineElement}
 */
const getCtrlLineMethod = function (id) {
    let ctrlLine = getElement("ctrlLine_" + id);
    if (ctrlLine) {
        return ctrlLine;
    }
    ctrlLine = document.createElementNS(NS.SVG, "line");
    assignAttributes(ctrlLine, {
        id: "ctrlLine_" + id,
        stroke: "#555",
        "stroke-width": 1,
        style: "pointer-events:none",
    });
    getGripContainerMethod().append(ctrlLine);
    return ctrlLine;
};
/**
 * @function module:path.getPointGrip
 * @param {Segment} seg
 * @param {boolean} update
 * @returns {SVGCircleElement}
 */
const getPointGripMethod = function (seg, update) {
    const { index } = seg;
    const pointGrip = addPointGripMethod(index);
    if (update) {
        const pt = getGripPtMethod(seg);
        assignAttributes(pointGrip, {
            cx: pt.x,
            cy: pt.y,
            display: "inline",
        });
    }
    return pointGrip;
};

/**
 * @function module:path.getPointGrip
 * @param {Segment} seg
 * @param {boolean} update
 * @returns {SVGCircleElement}
 */
const getMiddlePointGripMethod = function (seg, update, nextSeg) {
    //This is what I want
    let { index } = seg;
    const pointGripContainer = getGripContainerMethod();
    let pointGrip = getElement("pathMiddlePoint_" + index);
    let pointx = (seg.item.x + nextSeg.item.x) / 2;
    let pointy = (seg.item.y + nextSeg.item.y) / 2;
    let direction;
    if (pointx === seg.item.x) {
        direction = "horizontal";
    } else {
        direction = "vertical";
    }
    if (!pointGrip && index <= seg.path.segs.length - 3) {
        pointGrip = document.createElementNS(NS.SVG, "circle");
        const atts = {
            id: "pathMiddlePoint_" + index,
            display: "none",
            r: 4,
            fill: "#0FF",
            stroke: "#00F",
            "stroke-width": 2,
            cursor: "move",
            cx: pointx,
            cy: pointy,
            style: "pointer-events:all",
            direction: direction,
        };
        const uiStrings = svgCanvas$h.getUIStrings();
        if ("pathNodeTooltip" in uiStrings) {
            // May be empty if running path.js without svg-editor
            atts["xlink:title"] = uiStrings.pathNodeTooltip;
        }
        assignAttributes(pointGrip, atts);
        pointGripContainer.append(pointGrip);
        const grip = document.getElementById("pathMiddlePoint_" + index);
        grip?.addEventListener("dblclick", () => {
            const path = svgCanvas$h.getPathObj();
            if (path) {
                path.setSegType();
            }
        });
    }
    if (update && index <= seg.path.segs.length - 3) {
        assignAttributes(pointGrip, {
            cx: pointx,
            cy: pointy,
            display: "inline",
        });
    }
    return pointGrip;
};

/**
 * @function module:path.getControlPoints
 * @param {Segment} seg
 * @returns {PlainObject<string, SVGLineElement|SVGCircleElement>}
 */
const getControlPointsMethod = function (seg) {
    const { item, index } = seg;
    if (!("x1" in item) || !("x2" in item)) {
        return null;
    }
    const cpt = {};
    /* const pointGripContainer = */
    getGripContainerMethod();

    // Note that this is intentionally not seg.prev.item
    const path = svgCanvas$h.getPathObj();
    const prev = path.segs[index - 1].item;
    const segItems = [prev, item];
    for (let i = 1; i < 3; i++) {
        const id = index + "c" + i;
        const ctrlLine = (cpt["c" + i + "_line"] = getCtrlLineMethod(id));
        const pt = getGripPtMethod(seg, {
            x: item["x" + i],
            y: item["y" + i],
        });
        const gpt = getGripPtMethod(seg, {
            x: segItems[i - 1].x,
            y: segItems[i - 1].y,
        });
        assignAttributes(ctrlLine, {
            x1: pt.x,
            y1: pt.y,
            x2: gpt.x,
            y2: gpt.y,
            display: "inline",
        });
        cpt["c" + i + "_line"] = ctrlLine;

        // create it
        const pointGrip = (cpt["c" + i] = addCtrlGripMethod(id));
        assignAttributes(pointGrip, {
            cx: pt.x,
            cy: pt.y,
            display: "inline",
        });
        cpt["c" + i] = pointGrip;
    }
    return cpt;
};
/**
 * This replaces the segment at the given index. Type is given as number.
 * @function module:path.replacePathSeg
 * @param {Integer} type Possible values set during {@link module:path.init}
 * @param {Integer} index
 * @param {ArgumentsArray} pts
 * @param {SVGPathElement} elem
 * @returns {void}
 */
const replacePathSegMethod = function (type, index, pts, elem) {
    const path = svgCanvas$h.getPathObj();
    const pth = elem || path.elem;
    const pathFuncs = svgCanvas$h.getPathFuncs();
    const func = "createSVGPathSeg" + pathFuncs[type];
    const seg = pth[func](...pts);
    pth.pathSegList.replaceItem(seg, index);
};
/**
 * @function module:path.getSegSelector
 * @param {Segment} seg
 * @param {boolean} update
 * @returns {SVGPathElement}
 */
const getSegSelectorMethod = function (seg, update, nextSeg) {
    const { index } = seg;
    let segLine = getElement("segline_" + index);
    if (!segLine) {
        const pointGripContainer = getGripContainerMethod();
        // create segline
        segLine = document.createElementNS(NS.SVG, "path");
        assignAttributes(segLine, {
            id: "segline_" + index,
            display: "none",
            fill: "none",
            stroke: "#0FF",
            "stroke-width": 2,
            style: "pointer-events:none",
            d: "M0,0 0,0",
        });
        pointGripContainer.append(segLine);
    }
    if (update) {
        const { prev } = seg;
        if (!prev) {
            segLine.setAttribute("display", "none");
            return segLine;
        }
        const pt = getGripPtMethod(prev);
        // Set start point
        replacePathSegMethod(2, 0, [pt.x, pt.y], segLine);
        const pts = ptObjToArrMethod(seg.type, seg.item); // , true);
        for (let i = 0; i < pts.length; i += 2) {
            const point = getGripPtMethod(seg, {
                x: pts[i],
                y: pts[i + 1],
            });
            pts[i] = point.x;
            pts[i + 1] = point.y;
        }
        replacePathSegMethod(seg.type, 1, pts, segLine);
    }
    return segLine;
};
/**
 *
 */
class Segment {
    /**
     * @param {Integer} index
     * @param {SVGPathSeg} item
     * @todo Is `item` be more constrained here?
     */
    constructor(index, item) {
        this.selected = false;
        this.index = index;
        this.item = item;
        this.type = item.pathSegType;
        this.ctrlpts = [];
        this.ptgrip = null;
        this.segsel = null;
    }

    /**
     * @param {boolean} y
     * @returns {void}
     */
    showCtrlPts(y) {
        for (const i in this.ctrlpts) {
            if ({}.hasOwnProperty.call(this.ctrlpts, i)) {
                this.ctrlpts[i].setAttribute("display", y ? "inline" : "none");
            }
        }
    }

    /**
     * @param {boolean} y
     * @returns {void}
     */
    selectCtrls(y) {
        if (document.getElementById("ctrlpointgrip_" + this.index + "c1")) {
            document
                .getElementById("ctrlpointgrip_" + this.index + "c1")
                .setAttribute("fill", y ? "#0FF" : "#EEE");
            document
                .getElementById("ctrlpointgrip_" + this.index + "c2")
                .setAttribute("fill", y ? "#0FF" : "#EEE");
        }
    }

    /**
     * @param {boolean} y
     * @returns {void}
     */
    show(y) {
        if (this.ptgrip) {
            this.ptgrip.setAttribute("display", y ? "inline" : "none");
            if (this.segsel) {
                this.segsel.setAttribute("display", y ? "inline" : "none");
            }
            // Show/hide all control points if available
            this.showCtrlPts(y);
        }
        if (this.middlePoint) {
            this.middlePoint.setAttribute("display", y ? "inline" : "none");
        }
    }

    /**
     * @param {boolean} y
     * @returns {void}
     */
    select(y) {
        if (this.ptgrip) {
            this.ptgrip.setAttribute("stroke", y ? "#0FF" : "#00F");
            if (this.segsel) {
                this.segsel.setAttribute("display", y ? "inline" : "none");
            }
            if (this.ctrlpts) {
                this.selectCtrls(y);
            }
            this.selected = y;
        }
    }

    /**
     * @returns {void}
     */
    addGrip() {
        this.ptgrip = getPointGripMethod(this, true);
        this.ctrlpts = getControlPointsMethod(this); // , true);
        this.segsel = getSegSelectorMethod(this, true);
    }

    addMiddleGrip(nextSeg) {
        this.middlePoint = getMiddlePointGripMethod(this, true, nextSeg);
    }

    /**
     * @param {boolean} full
     * @returns {void}
     */
    update(full) {
        if (this.ptgrip) {
            const pt = getGripPtMethod(this);
            assignAttributes(this.ptgrip, {
                cx: pt.x,
                cy: pt.y,
            });
            getSegSelectorMethod(this, true);
            if (this.ctrlpts) {
                if (full) {
                    const path = svgCanvas$h.getPathObj();
                    this.item = path.elem.pathSegList.getItem(this.index);
                    this.type = this.item.pathSegType;
                }
                getControlPointsMethod(this);
            }
            // this.segsel.setAttribute('display', y ? 'inline' : 'none');
        }
    }

    /**
     * @param {Integer} dx
     * @param {Integer} dy
     * @returns {void}
     */
    move(dx, dy) {
        const { item } = this;
        const curPts = this.ctrlpts
            ? [
                  (item.x += dx),
                  (item.y += dy),
                  item.x1,
                  item.y1,
                  (item.x2 += dx),
                  (item.y2 += dy),
              ]
            : [(item.x += dx), (item.y += dy)];
        replacePathSegMethod(
            this.type,
            this.index,
            // type 10 means ARC
            this.type === 10 ? ptObjToArrMethod(this.type, item) : curPts,
        );
        if (this.next?.ctrlpts) {
            const next = this.next.item;
            const nextPts = [
                next.x,
                next.y,
                (next.x1 += dx),
                (next.y1 += dy),
                next.x2,
                next.y2,
            ];
            replacePathSegMethod(this.next.type, this.next.index, nextPts);
        }
        if (this.mate) {
            // The last point of a closed subpath has a 'mate',
            // which is the 'M' segment of the subpath
            const { item: itm } = this.mate;
            const pts = [(itm.x += dx), (itm.y += dy)];
            replacePathSegMethod(this.mate.type, this.mate.index, pts);
            // Has no grip, so does not need 'updating'?
        }

        this.update(true);
        if (this.next) {
            this.next.update(true);
        }
    }

    /**
     * @param {Integer} num
     * @returns {void}
     */
    setLinked(num) {
        let seg;
        let anum;
        let pt;
        if (num === 2) {
            anum = 1;
            seg = this.next;
            if (!seg) {
                return;
            }
            pt = this.item;
        } else {
            anum = 2;
            seg = this.prev;
            if (!seg) {
                return;
            }
            pt = seg.item;
        }
        const { item } = seg;
        item["x" + anum] = pt.x + (pt.x - this.item["x" + num]);
        item["y" + anum] = pt.y + (pt.y - this.item["y" + num]);
        const pts = [item.x, item.y, item.x1, item.y1, item.x2, item.y2];
        replacePathSegMethod(seg.type, seg.index, pts);
        seg.update(true);
    }

    /**
     * @param {Integer} num
     * @param {Integer} dx
     * @param {Integer} dy
     * @returns {void}
     */
    moveCtrl(num, dx, dy) {
        const { item } = this;
        item["x" + num] += dx;
        item["y" + num] += dy;
        const pts = [item.x, item.y, item.x1, item.y1, item.x2, item.y2];
        replacePathSegMethod(this.type, this.index, pts);
        this.update(true);
    }

    /**
     * @param {Integer} newType Possible values set during {@link module:path.init}
     * @param {ArgumentsArray} pts
     * @returns {void}
     */
    setType(newType, pts) {
        replacePathSegMethod(newType, this.index, pts);
        this.type = newType;
        const path = svgCanvas$h.getPathObj();
        this.item = path.elem.pathSegList.getItem(this.index);
        this.showCtrlPts(newType === 6);
        this.ctrlpts = getControlPointsMethod(this);
        this.update(true);
    }
}

/**
 *
 */
let Path$1 = class Path {
    /**
     * @param {SVGPathElement} elem
     * @throws {Error} If constructed without a path element
     */
    constructor(elem) {
        if (!elem || elem.tagName !== "path") {
            throw new Error(
                "svgedit.path.Path constructed without a <path> element",
            );
        }
        this.elem = elem;
        this.segs = [];
        this.selected_pts = [];
        svgCanvas$h.setPathObj(this);
        // path = this;

        this.init();
    }
    setPathContext() {
        svgCanvas$h.setPathObj(this);
    }

    /**
     * Reset path data.
     * @returns {module:path.Path}
     */
    init() {
        // Hide all grips, etc

        // fixed, needed to work on all found elements, not just first
        const pointGripContainer = getGripContainerMethod();
        const elements = pointGripContainer.querySelectorAll("*");
        Array.prototype.forEach.call(elements, function (el) {
            el.setAttribute("display", "none");
        });
        const segList = this.elem.pathSegList;
        const len = segList.numberOfItems;
        this.segs = [];
        this.selected_pts = [];
        this.first_seg = null;

        // Set up segs array
        for (let i = 0; i < len; i++) {
            const item = segList.getItem(i);
            const segment = new Segment(i, item);
            segment.path = this;
            this.segs.push(segment);
        }
        const { segs } = this;
        const elementId = this.elem.id;
        if (elementId.startsWith("svg_")) {
            let startI = null;
            for (let i = 0; i < len; i++) {
                const seg = segs[i];
                const nextSeg = i + 1 >= len ? null : segs[i + 1];
                const prevSeg = i - 1 < 0 ? null : segs[i - 1];
                if (seg.type === 2) {
                    if (prevSeg && prevSeg.type !== 1) {
                        // New sub-path, last one is open,
                        // so add a grip to last sub-path's first point
                        const startSeg = segs[startI];
                        startSeg.next = segs[startI + 1];
                        startSeg.next.prev = startSeg;
                        startSeg.addGrip();
                    }
                    // Remember that this is a starter seg
                    startI = i;
                } else if (nextSeg?.type === 1) {
                    // This is the last real segment of a closed sub-path
                    // Next is first seg after "M"
                    seg.next = segs[startI + 1];

                    // First seg after "M"'s prev is this
                    seg.next.prev = seg;
                    seg.mate = segs[startI];
                    seg.addGrip();
                    if (!this.first_seg) {
                        this.first_seg = seg;
                    }
                } else if (!nextSeg) {
                    if (seg.type !== 1) {
                        // Last seg, doesn't close so add a grip
                        // to last sub-path's first point
                        const startSeg = segs[startI];
                        startSeg.next = segs[startI + 1];
                        startSeg.next.prev = startSeg;
                        startSeg.addGrip();
                        seg.addGrip();
                        if (!this.first_seg) {
                            // Open path, so set first as real first and add grip
                            this.first_seg = segs[startI];
                        }
                    }
                } else if (seg.type !== 1) {
                    // Regular segment, so add grip and its "next"
                    seg.addGrip();

                    // Don't set its "next" if it's an "M"
                    if (nextSeg && nextSeg.type !== 2) {
                        seg.next = nextSeg;
                        seg.next.prev = seg;
                    }
                }
            }
            return this;
        } else {
            let startI = null;
            for (let i = 0; i < len; i++) {
                const seg = segs[i];
                const nextSeg = i + 1 >= len ? null : segs[i + 1];
                const prevSeg = i - 1 < 0 ? null : segs[i - 1];
                if (seg.type === 2) {
                    if (prevSeg && prevSeg.type !== 1) {
                        // New sub-path, last one is open,
                        // so add a grip to last sub-path's first point
                        const startSeg = segs[startI];
                        startSeg.next = segs[startI + 1];
                        startSeg.next.prev = startSeg;
                    }
                    // Remember that this is a starter seg
                    startI = i;
                } else if (!nextSeg) {
                    if (seg.type !== 1) {
                        // Last seg, doesn't close so add a grip
                        // to last sub-path's first point
                        const startSeg = segs[startI];
                        startSeg.next = segs[startI + 1];
                        startSeg.next.prev = startSeg;
                        if (!this.first_seg) {
                            // Open path, so set first as real first and add grip
                            this.first_seg = segs[startI];
                        }
                    }
                } else if (seg.type !== 1) {
                    // Regular segment, so add grip and its "next"
                    seg.addMiddleGrip(nextSeg);
                    // Don't set its "next" if it's an "M"
                    if (nextSeg && nextSeg.type !== 2) {
                        seg.next = nextSeg;
                        seg.next.prev = seg;
                    }
                }
            }
            return this;
        }
    }

    /**
     * @callback module:path.PathEachSegCallback
     * @this module:path.Segment
     * @param {Integer} i The index of the seg being iterated
     * @returns {boolean|void} Will stop execution of `eachSeg` if returns `false`
     */
    /**
     * @param {module:path.PathEachSegCallback} fn
     * @returns {void}
     */
    eachSeg(fn) {
        const len = this.segs.length;
        for (let i = 0; i < len; i++) {
            const ret = fn.call(this.segs[i], i);
            if (ret === false) {
                break;
            }
        }
    }

    /**
     * @param {Integer} index
     * @returns {void}
     */
    addSeg(index) {
        // Adds a new segment
        const seg = this.segs[index];
        if (!seg.prev) {
            return;
        }
        const { prev } = seg;
        let newseg;
        let newX;
        let newY;
        switch (seg.item.pathSegType) {
            case 4: {
                newX = (seg.item.x + prev.item.x) / 2;
                newY = (seg.item.y + prev.item.y) / 2;
                newseg = this.elem.createSVGPathSegLinetoAbs(newX, newY);
                break;
            }
            case 6: {
                // make it a curved segment to preserve the shape (WRS)
                // https://en.wikipedia.org/wiki/De_Casteljau%27s_algorithm#Geometric_interpretation
                const p0x = (prev.item.x + seg.item.x1) / 2;
                const p1x = (seg.item.x1 + seg.item.x2) / 2;
                const p2x = (seg.item.x2 + seg.item.x) / 2;
                const p01x = (p0x + p1x) / 2;
                const p12x = (p1x + p2x) / 2;
                newX = (p01x + p12x) / 2;
                const p0y = (prev.item.y + seg.item.y1) / 2;
                const p1y = (seg.item.y1 + seg.item.y2) / 2;
                const p2y = (seg.item.y2 + seg.item.y) / 2;
                const p01y = (p0y + p1y) / 2;
                const p12y = (p1y + p2y) / 2;
                newY = (p01y + p12y) / 2;
                newseg = this.elem.createSVGPathSegCurvetoCubicAbs(
                    newX,
                    newY,
                    p0x,
                    p0y,
                    p01x,
                    p01y,
                );
                const pts = [seg.item.x, seg.item.y, p12x, p12y, p2x, p2y];
                replacePathSegMethod(seg.type, index, pts);
                break;
            }
        }
        const list = this.elem.pathSegList;
        list.insertItemBefore(newseg, index);
    }

    /**
     * @param {Integer} index
     * @returns {void}
     */
    deleteSeg(index) {
        const seg = this.segs[index];
        const list = this.elem.pathSegList;
        seg.show(false);
        const { next } = seg;
        if (seg.mate) {
            // Make the next point be the "M" point
            const pt = [next.item.x, next.item.y];
            replacePathSegMethod(2, next.index, pt);

            // Reposition last node
            replacePathSegMethod(4, seg.index, pt);
            list.removeItem(seg.mate.index);
        } else if (!seg.prev) {
            // First node of open path, make next point the M
            // const {item} = seg;
            const pt = [next.item.x, next.item.y];
            replacePathSegMethod(2, seg.next.index, pt);
            list.removeItem(index);
        } else {
            list.removeItem(index);
        }
    }

    /**
     * @param {Integer} index
     * @returns {void}
     */
    removePtFromSelection(index) {
        const pos = this.selected_pts.indexOf(index);
        if (pos === -1) {
            return;
        }
        this.segs[index].select(false);
        this.selected_pts.splice(pos, 1);
    }

    /**
     * @returns {void}
     */
    clearSelection() {
        this.eachSeg(function () {
            // 'this' is the segment here
            this.select(false);
        });
        this.selected_pts = [];
    }

    /**
     * @returns {void}
     */
    storeD() {
        this.last_d = this.elem.getAttribute("d");
    }

    /**
     * @param {Integer} y
     * @returns {Path}
     */
    show(y) {
        // Shows this path's segment grips
        this.eachSeg(function () {
            // 'this' is the segment here
            this.show(y);
        });
        if (y && this.first_seg) {
            this.selectPt(this.first_seg.index);
        }

        if (!y) {
            this.elem.removeAttribute("stroke-dasharray");
        }
        return this;
    }

    /**
     * Move selected points.
     * @param {Integer} dx
     * @param {Integer} dy
     * @returns {void}
     */
    movePts(dx, dy) {
        let i = this.selected_pts.length;
        while (i--) {
            const seg = this.segs[this.selected_pts[i]];
            seg.move(dx, dy);
        }
    }

    /**
     * @param {Integer} dx
     * @param {Integer} dy
     * @returns {void}
     */
    moveCtrl(dx, dy) {
        const seg = this.segs[this.selected_pts[0]];
        seg.moveCtrl(this.dragctrl, dx, dy);
        if (svgCanvas$h.getLinkControlPts()) {
            seg.setLinked(this.dragctrl);
        }
    }

    /**
     * @param {?Integer} newType See {@link https://www.w3.org/TR/SVG/single-page.html#paths-InterfaceSVGPathSeg}
     * @returns {void}
     */
    setSegType(newType) {
        this.storeD();
        let i = this.selected_pts.length;
        let text;
        while (i--) {
            const selPt = this.selected_pts[i];

            // Selected seg
            const cur = this.segs[selPt];
            const { prev } = cur;
            if (!prev) {
                continue;
            }
            if (!newType) {
                // double-click, so just toggle
                text = "Toggle Path Segment Type";

                // Toggle segment to curve/straight line
                const oldType = cur.type;
                newType = oldType === 6 ? 4 : 6;
            }
            newType = Number(newType);
            const curX = cur.item.x;
            const curY = cur.item.y;
            const prevX = prev.item.x;
            const prevY = prev.item.y;
            let points;
            switch (newType) {
                case 6: {
                    if (cur.olditem) {
                        const old = cur.olditem;
                        points = [curX, curY, old.x1, old.y1, old.x2, old.y2];
                    } else {
                        const diffX = curX - prevX;
                        const diffY = curY - prevY;
                        // get control points from straight line segment
                        /*
              const ct1x = (prevX + (diffY/2));
              const ct1y = (prevY - (diffX/2));
              const ct2x = (curX + (diffY/2));
              const ct2y = (curY - (diffX/2));
              */
                        // create control points on the line to preserve the shape (WRS)
                        const ct1x = prevX + diffX / 3;
                        const ct1y = prevY + diffY / 3;
                        const ct2x = curX - diffX / 3;
                        const ct2y = curY - diffY / 3;
                        points = [curX, curY, ct1x, ct1y, ct2x, ct2y];
                    }
                    break;
                }
                case 4: {
                    points = [curX, curY];

                    // Store original prevve segment nums
                    cur.olditem = cur.item;
                    break;
                }
            }
            cur.setType(newType, points);
        }
        const path = svgCanvas$h.getPathObj();
        path.endChanges(text);
    }

    /**
     * @param {Integer} pt
     * @param {Integer} ctrlNum
     * @returns {void}
     */
    selectPt(pt, ctrlNum) {
        this.clearSelection();
        if (!pt) {
            this.eachSeg(function (i) {
                // 'this' is the segment here.
                if (this.prev) {
                    pt = i;
                }
            });
        }
        this.addPtsToSelection(pt);
        if (ctrlNum) {
            this.dragctrl = ctrlNum;
            if (svgCanvas$h.getLinkControlPts()) {
                this.segs[pt].setLinked(ctrlNum);
            }
        }
    }

    /**
     * Update position of all points.
     * @returns {Path}
     */
    update() {
        const { elem } = this;
        if (getRotationAngle(elem)) {
            this.matrix = getMatrix(elem);
            this.imatrix = this.matrix.inverse();
        } else {
            this.matrix = null;
            this.imatrix = null;
        }
        this.eachSeg(function (i) {
            this.item = elem.pathSegList.getItem(i);
            this.update();
        });
        return this;
    }

    /**
     * @param {string} text
     * @returns {void}
     */
    endChanges(text) {
        const cmd = new ChangeElementCommand$2(
            this.elem,
            {
                d: this.last_d,
            },
            text,
        );
        svgCanvas$h.endChanges({
            cmd,
            elem: this.elem,
        });
    }

    /**
     * @param {Integer|Integer[]} indexes
     * @returns {void}
     */
    addPtsToSelection(indexes) {
        if (!Array.isArray(indexes)) {
            indexes = [indexes];
        }
        indexes.forEach((index) => {
            const seg = this.segs[index];
            if (
                seg.ptgrip &&
                !this.selected_pts.includes(index) &&
                index >= 0
            ) {
                this.selected_pts.push(index);
            }
        });
        this.selected_pts.sort();
        let i = this.selected_pts.length;
        const grips = [];
        grips.length = i;
        // Loop through points to be selected and highlight each
        while (i--) {
            const pt = this.selected_pts[i];
            const seg = this.segs[pt];
            seg.select(true);
            grips[i] = seg.ptgrip;
        }
        const closedSubpath = Path.subpathIsClosed(this.selected_pts[0]);
        svgCanvas$h.addPtsToSelection({
            grips,
            closedSubpath,
        });
    }

    // STATIC
    /**
     * @param {Integer} index
     * @returns {boolean}
     */
    static subpathIsClosed(index) {
        let clsd = false;
        // Check if subpath is already open
        const path = svgCanvas$h.getPathObj();
        path.eachSeg(function (i) {
            if (i <= index) {
                return true;
            }
            if (this.type === 2) {
                // Found M first, so open
                return false;
            }
            if (this.type === 1) {
                // Found Z first, so closed
                clsd = true;
                return false;
            }
            return true;
        });
        return clsd;
    }
};

/**
 * Path functionality.
 * @module path
 * @license MIT
 *
 * @copyright 2011 Alexis Deveria, 2011 Jeff Schiller
 */
let svgCanvas$g = null;
let path$1 = null;

/**
 * @function module:path-actions.init
 * @param {module:path-actions.svgCanvas} pathActionsContext
 * @returns {void}
 */
const init$h = (canvas) => {
    svgCanvas$g = canvas;
};

/**
 * Convert a path to one with only absolute or relative values.
 * @todo move to pathActions.js
 * @function module:path.convertPath
 * @param {SVGPathElement} pth - the path to convert
 * @param {boolean} toRel - true of convert to relative
 * @returns {string}
 */
const convertPath$1 = function (pth, toRel) {
    const { pathSegList } = pth;
    const len = pathSegList.numberOfItems;
    let curx = 0;
    let cury = 0;
    let d = "";
    let lastM = null;
    for (let i = 0; i < len; ++i) {
        const seg = pathSegList.getItem(i);
        // if these properties are not in the segment, set them to zero
        let x = seg.x || 0;
        let y = seg.y || 0;
        let x1 = seg.x1 || 0;
        let y1 = seg.y1 || 0;
        let x2 = seg.x2 || 0;
        let y2 = seg.y2 || 0;

        // const type = seg.pathSegType;
        // const pathMap = svgCanvas.getPathMap();
        // let letter = pathMap[type][toRel ? 'toLowerCase' : 'toUpperCase']();
        let letter = seg.pathSegTypeAsLetter;
        switch (letter) {
            case "z": // z,Z closepath (Z/z)
            case "Z":
                d += "z";
                if (lastM && !toRel) {
                    curx = lastM[0];
                    cury = lastM[1];
                }
                break;
            case "H":
                // absolute horizontal line (H)
                x -= curx;
            // Fallthrough
            case "h":
                // relative horizontal line (h)
                if (toRel) {
                    y = 0;
                    curx += x;
                    letter = "l";
                } else {
                    y = cury;
                    x += curx;
                    curx = x;
                    letter = "L";
                }
                // Convert to "line" for easier editing
                d += pathDSegment$1(letter, [[x, y]]);
                break;
            case "V":
                // absolute vertical line (V)
                y -= cury;
            // Fallthrough
            case "v":
                // relative vertical line (v)
                if (toRel) {
                    x = 0;
                    cury += y;
                    letter = "l";
                } else {
                    x = curx;
                    y += cury;
                    cury = y;
                    letter = "L";
                }
                // Convert to "line" for easier editing
                d += pathDSegment$1(letter, [[x, y]]);
                break;
            case "M": // absolute move (M)
            case "L": // absolute line (L)
            case "T":
                // absolute smooth quad (T)
                x -= curx;
                y -= cury;
            // Fallthrough
            case "l": // relative line (l)
            case "m": // relative move (m)
            case "t":
                // relative smooth quad (t)
                if (toRel) {
                    curx += x;
                    cury += y;
                    letter = letter.toLowerCase();
                } else {
                    x += curx;
                    y += cury;
                    curx = x;
                    cury = y;
                    letter = letter.toUpperCase();
                }
                if (letter === "m" || letter === "M") {
                    lastM = [curx, cury];
                }
                d += pathDSegment$1(letter, [[x, y]]);
                break;
            case "C":
                // absolute cubic (C)
                x -= curx;
                x1 -= curx;
                x2 -= curx;
                y -= cury;
                y1 -= cury;
                y2 -= cury;
            // Fallthrough
            case "c":
                // relative cubic (c)
                if (toRel) {
                    curx += x;
                    cury += y;
                    letter = "c";
                } else {
                    x += curx;
                    x1 += curx;
                    x2 += curx;
                    y += cury;
                    y1 += cury;
                    y2 += cury;
                    curx = x;
                    cury = y;
                    letter = "C";
                }
                d += pathDSegment$1(letter, [
                    [x1, y1],
                    [x2, y2],
                    [x, y],
                ]);
                break;
            case "Q":
                // absolute quad (Q)
                x -= curx;
                x1 -= curx;
                y -= cury;
                y1 -= cury;
            // Fallthrough
            case "q":
                // relative quad (q)
                if (toRel) {
                    curx += x;
                    cury += y;
                    letter = "q";
                } else {
                    x += curx;
                    x1 += curx;
                    y += cury;
                    y1 += cury;
                    curx = x;
                    cury = y;
                    letter = "Q";
                }
                d += pathDSegment$1(letter, [
                    [x1, y1],
                    [x, y],
                ]);
                break;
            case "A":
                x -= curx;
                y -= cury;
            // fallthrough
            case "a":
                // relative elliptical arc (a)
                if (toRel) {
                    curx += x;
                    cury += y;
                    letter = "a";
                } else {
                    x += curx;
                    y += cury;
                    curx = x;
                    cury = y;
                    letter = "A";
                }
                d += pathDSegment$1(
                    letter,
                    [[seg.r1, seg.r2]],
                    [
                        seg.angle,
                        seg.largeArcFlag ? 1 : 0,
                        seg.sweepFlag ? 1 : 0,
                    ],
                    [x, y],
                );
                break;
            case "S":
                // absolute smooth cubic (S)
                x -= curx;
                x2 -= curx;
                y -= cury;
                y2 -= cury;
            // Fallthrough
            case "s":
                // relative smooth cubic (s)
                if (toRel) {
                    curx += x;
                    cury += y;
                    letter = "s";
                } else {
                    x += curx;
                    x2 += curx;
                    y += cury;
                    y2 += cury;
                    curx = x;
                    cury = y;
                    letter = "S";
                }
                d += pathDSegment$1(letter, [
                    [x2, y2],
                    [x, y],
                ]);
                break;
        } // switch on path segment type
    } // for each segment
    return d;
};

/**
 * TODO: refactor callers in `convertPath` to use `getPathDFromSegments` instead of this function.
 * Legacy code refactored from `svgcanvas.pathActions.convertPath`.
 * @param {string} letter - path segment command (letter in potentially either case from {@link module:path.pathMap}; see [SVGPathSeg#pathSegTypeAsLetter]{@link https://www.w3.org/TR/SVG/single-page.html#paths-__svg__SVGPathSeg__pathSegTypeAsLetter})
 * @param {GenericArray<GenericArray<Integer>>} points - x,y points
 * @param {GenericArray<GenericArray<Integer>>} [morePoints] - x,y points
 * @param {Integer[]} [lastPoint] - x,y point
 * @returns {string}
 */
function pathDSegment$1(letter, points, morePoints, lastPoint) {
    points.forEach(function (pnt, i) {
        points[i] = shortFloat(pnt);
    });
    let segment = letter + points.join(" ");
    if (morePoints) {
        segment += " " + morePoints.join(" ");
    }
    if (lastPoint) {
        segment += " " + shortFloat(lastPoint);
    }
    return segment;
}

/**
 * Group: Path edit functions.
 * Functions relating to editing path elements.
 * @namespace {PlainObject} pathActions
 * @memberof module:path
 */
const pathActionsMethod = (function () {
    let subpath = false;
    let newPoint;
    let firstCtrl;
    let currentPath = null;
    let hasMoved = false;
    // No `svgCanvas` yet but should be ok as is `null` by default
    // svgCanvas.setDrawnPath(null);

    /**
     * This function converts a polyline (created by the fh_path tool) into
     * a path element and coverts every three line segments into a single bezier
     * curve in an attempt to smooth out the free-hand.
     * @function smoothPolylineIntoPath
     * @param {Element} element
     * @returns {Element}
     */
    const smoothPolylineIntoPath = function (element) {
        let i;
        const { points } = element;
        const N = points.numberOfItems;
        if (N >= 4) {
            // loop through every 3 points and convert to a cubic bezier curve segment
            //
            // NOTE: this is cheating, it means that every 3 points has the potential to
            // be a corner instead of treating each point in an equal manner. In general,
            // this technique does not look that good.
            //
            // I am open to better ideas!
            //
            // Reading:
            // - http://www.efg2.com/Lab/Graphics/Jean-YvesQueinecBezierCurves.htm
            // - https://www.codeproject.com/KB/graphics/BezierSpline.aspx?msg=2956963
            // - https://www.ian-ko.com/ET_GeoWizards/UserGuide/smooth.htm
            // - https://www.cs.mtu.edu/~shene/COURSES/cs3621/NOTES/spline/Bezier/bezier-der.html
            let curpos = points.getItem(0);
            let prevCtlPt = null;
            let d = [];
            d.push(["M", curpos.x, ",", curpos.y, " C"].join(""));
            for (i = 1; i <= N - 4; i += 3) {
                let ct1 = points.getItem(i);
                const ct2 = points.getItem(i + 1);
                const end = points.getItem(i + 2);

                // if the previous segment had a control point, we want to smooth out
                // the control points on both sides
                if (prevCtlPt) {
                    const newpts = svgCanvas$g.smoothControlPoints(
                        prevCtlPt,
                        ct1,
                        curpos,
                    );
                    if (newpts?.length === 2) {
                        const prevArr = d[d.length - 1].split(",");
                        prevArr[2] = newpts[0].x;
                        prevArr[3] = newpts[0].y;
                        d[d.length - 1] = prevArr.join(",");
                        ct1 = newpts[1];
                    }
                }
                d.push([ct1.x, ct1.y, ct2.x, ct2.y, end.x, end.y].join(","));
                curpos = end;
                prevCtlPt = ct2;
            }
            // handle remaining line segments
            d.push("L");
            while (i < N) {
                const pt = points.getItem(i);
                d.push([pt.x, pt.y].join(","));
                i++;
            }
            d = d.join(" ");
            element = svgCanvas$g.addSVGElementsFromJson({
                element: "path",
                curStyles: true,
                attr: {
                    id: svgCanvas$g.getId(),
                    d,
                    fill: "none",
                },
            });
            // No need to call "changed", as this is already done under mouseUp
        }

        return element;
    };
    return /** @lends module:path.pathActions */ {
        /**
         * @param {MouseEvent} evt
         * @param {Element} mouseTarget
         * @param {Float} startX
         * @param {Float} startY
         * @returns {boolean|void}
         */
        mouseDown(evt, mouseTarget, startX, startY) {
            let id;
            if (svgCanvas$g.getCurrentMode() === "path") {
                let mouseX = startX;
                let mouseY = startY;

                const zoom = svgCanvas$g.getZoom();
                let x = mouseX / zoom;
                let y = mouseY / zoom;
                let stretchy = getElement("path_stretch_line");
                newPoint = [x, y];
                if (svgCanvas$g.getGridSnapping()) {
                    x = snapToGrid(x);
                    y = snapToGrid(y);
                    mouseX = snapToGrid(mouseX);
                    mouseY = snapToGrid(mouseY);
                }
                if (!stretchy) {
                    stretchy = document.createElementNS(NS.SVG, "path");
                    assignAttributes(stretchy, {
                        id: "path_stretch_line",
                        stroke: "#22C",
                        "stroke-width": "0.5",
                        fill: "none",
                    });
                    getElement("selectorParentGroup").append(stretchy);
                }
                stretchy.setAttribute("display", "inline");
                let keep = null;
                let index;
                // if pts array is empty, create path element with M at current point
                const drawnPath = svgCanvas$g.getDrawnPath();
                if (!drawnPath) {
                    const dAttr = "M" + x + "," + y + " "; // Was this meant to work with the other `dAttr`? (was defined globally so adding `var` to at least avoid a global)
                    /* drawnPath = */
                    svgCanvas$g.setDrawnPath(
                        svgCanvas$g.addSVGElementsFromJson({
                            element: "path",
                            curStyles: true,
                            attr: {
                                d: dAttr,
                                id: svgCanvas$g.getNextId(),
                                opacity: svgCanvas$g.getOpacity() / 2,
                            },
                        }),
                    );
                    // set stretchy line to first point
                    stretchy.setAttribute(
                        "d",
                        ["M", mouseX, mouseY, mouseX, mouseY].join(" "),
                    );
                    index = subpath ? path$1.segs.length : 0;
                    svgCanvas$g.addPointGrip(index, mouseX, mouseY);
                } else {
                    // determine if we clicked on an existing point
                    const seglist = drawnPath.pathSegList;
                    let i = seglist.numberOfItems;
                    const FUZZ = 6 / zoom;
                    let clickOnPoint = false;
                    while (i) {
                        i--;
                        const item = seglist.getItem(i);
                        const px = item.x;
                        const py = item.y;
                        // found a matching point
                        if (
                            x >= px - FUZZ &&
                            x <= px + FUZZ &&
                            y >= py - FUZZ &&
                            y <= py + FUZZ
                        ) {
                            clickOnPoint = true;
                            break;
                        }
                    }

                    // get path element that we are in the process of creating
                    id = svgCanvas$g.getId();

                    // Remove previous path object if previously created
                    svgCanvas$g.removePath_(id);
                    const newpath = getElement(id);
                    let newseg;
                    let sSeg;
                    const len = seglist.numberOfItems;
                    // if we clicked on an existing point, then we are done this path, commit it
                    // (i, i+1) are the x,y that were clicked on
                    if (clickOnPoint) {
                        // if clicked on any other point but the first OR
                        // the first point was clicked on and there are less than 3 points
                        // then leave the path open
                        // otherwise, close the path
                        if (i <= 1 && len >= 2) {
                            // Create end segment
                            const absX = seglist.getItem(0).x;
                            const absY = seglist.getItem(0).y;
                            sSeg = stretchy.pathSegList.getItem(1);
                            newseg =
                                sSeg.pathSegType === 4
                                    ? drawnPath.createSVGPathSegLinetoAbs(
                                          absX,
                                          absY,
                                      )
                                    : drawnPath.createSVGPathSegCurvetoCubicAbs(
                                          absX,
                                          absY,
                                          sSeg.x1 / zoom,
                                          sSeg.y1 / zoom,
                                          absX,
                                          absY,
                                      );
                            const endseg =
                                drawnPath.createSVGPathSegClosePath();
                            seglist.appendItem(newseg);
                            seglist.appendItem(endseg);
                        } else if (len < 3) {
                            keep = false;
                            return keep;
                        }
                        stretchy.remove();

                        // This will signal to commit the path
                        // const element = newpath; // Other event handlers define own `element`, so this was probably not meant to interact with them or one which shares state (as there were none); I therefore adding a missing `var` to avoid a global
                        /* drawnPath = */
                        svgCanvas$g.setDrawnPath(null);
                        svgCanvas$g.setStarted(false);
                        if (subpath) {
                            if (path$1.matrix) {
                                svgCanvas$g.remapElement(
                                    newpath,
                                    {},
                                    path$1.matrix.inverse(),
                                );
                            }
                            const newD = newpath.getAttribute("d");
                            const origD = path$1.elem.getAttribute("d");
                            path$1.elem.setAttribute("d", origD + newD);
                            newpath.parentNode.removeChild(newpath);
                            if (path$1.matrix) {
                                svgCanvas$g.recalcRotatedPath();
                            }
                            pathActionsMethod.toEditMode(path$1.elem);
                            path$1.selectPt();
                            return false;
                        }
                        // else, create a new point, update path element
                    } else {
                        // Checks if current target or parents are #svgcontent
                        if (
                            !(
                                svgCanvas$g.getContainer() !==
                                    svgCanvas$g.getMouseTarget(evt) &&
                                svgCanvas$g
                                    .getContainer()
                                    .contains(svgCanvas$g.getMouseTarget(evt))
                            )
                        ) {
                            // Clicked outside canvas, so don't make point
                            return false;
                        }
                        const num = drawnPath.pathSegList.numberOfItems;
                        const last = drawnPath.pathSegList.getItem(num - 1);
                        const lastx = last.x;
                        const lasty = last.y;
                        if (evt.shiftKey) {
                            const xya = snapToAngle(lastx, lasty, x, y);
                            ({ x, y } = xya);
                        }

                        // Use the segment defined by stretchy
                        sSeg = stretchy.pathSegList.getItem(1);
                        newseg =
                            sSeg.pathSegType === 4
                                ? drawnPath.createSVGPathSegLinetoAbs(
                                      svgCanvas$g.round(x),
                                      svgCanvas$g.round(y),
                                  )
                                : drawnPath.createSVGPathSegCurvetoCubicAbs(
                                      svgCanvas$g.round(x),
                                      svgCanvas$g.round(y),
                                      sSeg.x1 / zoom,
                                      sSeg.y1 / zoom,
                                      sSeg.x2 / zoom,
                                      sSeg.y2 / zoom,
                                  );
                        drawnPath.pathSegList.appendItem(newseg);
                        x *= zoom;
                        y *= zoom;

                        // set stretchy line to latest point
                        stretchy.setAttribute("d", ["M", x, y, x, y].join(" "));
                        index = num;
                        if (subpath) {
                            index += path$1.segs.length;
                        }
                        svgCanvas$g.addPointGrip(index, x, y);
                        firstCtrl = null;
                    }
                    // keep = true;
                }

                return undefined;
            }

            // TODO: Make sure currentPath isn't null at this point
            if (!path$1) {
                return undefined;
            }
            path$1.storeD();
            ({ id } = evt.target);
            let curPt;
            if (id.substr(0, 14) === "pathpointgrip_") {
                // Select this point
                curPt = path$1.cur_pt = Number.parseInt(id.substr(14));
                path$1.dragging = [startX, startY];
                const seg = path$1.segs[curPt];

                // only clear selection if shift is not pressed (otherwise, add
                // node to selection)
                if (!evt.shiftKey) {
                    if (path$1.selected_pts.length <= 1 || !seg.selected) {
                        path$1.clearSelection();
                    }
                    path$1.addPtsToSelection(curPt);
                } else if (seg.selected) {
                    path$1.removePtFromSelection(curPt);
                } else {
                    path$1.addPtsToSelection(curPt);
                }
            } else if (id.startsWith("ctrlpointgrip_")) {
                path$1.dragging = [startX, startY];
                const parts = id.split("_")[1].split("c");
                curPt = Number(parts[0]);
                const ctrlNum = Number(parts[1]);
                path$1.selectPt(curPt, ctrlNum);
            }

            //This is what I want
            else if (id.startsWith("pathMiddlePoint_")) {
                let direction = evt.target.getAttribute("direction");
                curPt = Number.parseInt(id.substr(16));
                path$1.adjust = [
                    startX,
                    startY,
                    direction,
                    Number.parseInt(id.substr(16)),
                ];
            }

            // Start selection box
            if (!path$1.dragging) {
                let rubberBox = svgCanvas$g.getRubberBox();
                if (!rubberBox) {
                    rubberBox = svgCanvas$g.setRubberBox(
                        svgCanvas$g.selectorManager.getRubberBandBox(),
                    );
                }
                const zoom = svgCanvas$g.getZoom();
                assignAttributes(rubberBox, {
                    x: startX * zoom,
                    y: startY * zoom,
                    width: 0,
                    height: 0,
                    display: "inline",
                });
            }
            return undefined;
        },
        /**
         * @param {Float} mouseX
         * @param {Float} mouseY
         * @returns {void}
         */
        mouseMove(mouseX, mouseY) {
            const zoom = svgCanvas$g.getZoom();
            hasMoved = true;
            const drawnPath = svgCanvas$g.getDrawnPath();
            if (svgCanvas$g.getCurrentMode() === "path") {
                if (!drawnPath) {
                    return;
                }
                const seglist = drawnPath.pathSegList;
                const index = seglist.numberOfItems - 1;
                const threshold =
                    newPoint &&
                    (Math.abs(newPoint[0] - mouseX) > 5 ||
                        Math.abs(newPoint[1] - mouseY) > 5);
                if (newPoint && threshold) {
                    // First point
                    // if (!index) { return; }

                    // Set control points
                    const pointGrip1 = svgCanvas$g.addCtrlGrip("1c1");
                    const pointGrip2 = svgCanvas$g.addCtrlGrip("0c2");

                    // dragging pointGrip1
                    pointGrip1.setAttribute("cx", mouseX);
                    pointGrip1.setAttribute("cy", mouseY);
                    pointGrip1.setAttribute("display", "inline");
                    const ptX = newPoint[0];
                    const ptY = newPoint[1];

                    // set curve
                    // const seg = seglist.getItem(index);
                    const curX = mouseX / zoom;
                    const curY = mouseY / zoom;
                    const altX = ptX + (ptX - curX);
                    const altY = ptY + (ptY - curY);
                    pointGrip2.setAttribute("cx", altX * zoom);
                    pointGrip2.setAttribute("cy", altY * zoom);
                    pointGrip2.setAttribute("display", "inline");
                    const ctrlLine = svgCanvas$g.getCtrlLine(1);
                    assignAttributes(ctrlLine, {
                        x1: mouseX,
                        y1: mouseY,
                        x2: altX * zoom,
                        y2: altY * zoom,
                        display: "inline",
                    });
                    if (index === 0) {
                        firstCtrl = [mouseX, mouseY];
                    } else {
                        const last = seglist.getItem(index - 1);
                        let lastX = last.x;
                        let lastY = last.y;
                        if (last.pathSegType === 6) {
                            lastX += lastX - last.x2;
                            lastY += lastY - last.y2;
                        } else if (firstCtrl) {
                            lastX = firstCtrl[0] / zoom;
                            lastY = firstCtrl[1] / zoom;
                        }
                        svgCanvas$g.replacePathSeg(
                            6,
                            index,
                            [ptX, ptY, lastX, lastY, altX, altY],
                            drawnPath,
                        );
                    }
                } else {
                    const stretchy = getElement("path_stretch_line");
                    if (stretchy) {
                        const prev = seglist.getItem(index);
                        if (prev.pathSegType === 6) {
                            const cubicBezierRegex = /C/g;
                            const pathData =
                                drawnPath && drawnPath.getAttribute("d")
                                    ? drawnPath.getAttribute("d")
                                    : "";
                            const matches = pathData.match(cubicBezierRegex);
                            if (matches.length % 2 == 0) {
                                svgCanvas$g.replacePathSeg(
                                    4,
                                    1,
                                    [mouseX, mouseY],
                                    stretchy,
                                );
                                return;
                            }
                            const prevX = prev.x + (prev.x - prev.x2);
                            const prevY = prev.y + (prev.y - prev.y2);
                            svgCanvas$g.replacePathSeg(
                                6,
                                1,
                                [
                                    mouseX,
                                    mouseY,
                                    prevX * zoom,
                                    prevY * zoom,
                                    mouseX,
                                    mouseY,
                                ],
                                stretchy,
                            );
                        } else if (firstCtrl) {
                            svgCanvas$g.replacePathSeg(
                                6,
                                1,
                                [
                                    mouseX,
                                    mouseY,
                                    firstCtrl[0],
                                    firstCtrl[1],
                                    mouseX,
                                    mouseY,
                                ],
                                stretchy,
                            );
                        } else {
                            svgCanvas$g.replacePathSeg(
                                4,
                                1,
                                [mouseX, mouseY],
                                stretchy,
                            );
                        }
                    }
                }
                return;
            }
            // if we are dragging a point, let's move it
            if (path$1.dragging) {
                const pt = svgCanvas$g.getPointFromGrip(
                    {
                        x: path$1.dragging[0],
                        y: path$1.dragging[1],
                    },
                    path$1,
                );
                const mpt = svgCanvas$g.getPointFromGrip(
                    {
                        x: mouseX,
                        y: mouseY,
                    },
                    path$1,
                );
                const diffX = mpt.x - pt.x;
                const diffY = mpt.y - pt.y;
                path$1.dragging = [mouseX, mouseY];
                if (path$1.dragctrl) {
                    path$1.moveCtrl(diffX, diffY);
                } else {
                    path$1.movePts(diffX, diffY);
                }
            } else if (path$1.adjust) {
                let element = path$1.elem;
                let curPt = path$1.adjust[3];
                let d = element.getAttribute("d");
                let path = d.split(" ");
                if (path$1.adjust[2] === "horizontal") {
                    let firstPathToChange = path[curPt + 1].split(",");
                    let firstNewPath =
                        "L" + mouseX + "," + firstPathToChange[1] + " ";
                    let secondPathToChange = path[curPt].split(",");
                    let secondNewPath =
                        "L" + mouseX + "," + secondPathToChange[1] + " ";

                    let newPath = "";
                    path.forEach((subPath, i) => {
                        if (i == curPt + 1) {
                            newPath += firstNewPath;
                            return;
                        } else if (i == curPt) {
                            newPath += secondNewPath;
                            return;
                        } else if (i < path.length - 1) {
                            newPath += subPath + " ";
                            return;
                        }
                    });
                    element.setAttribute("d", newPath);
                    path$1.init();
                } else {
                    let originPoint;
                    let secondPathToChange;
                    let secondNewPath;
                    let firstNewPath;
                    if (curPt === 1) {
                        originPoint = path[curPt - 1].split(",");
                        firstNewPath =
                            "L" + originPoint[0].slice(1) + "," + mouseY + " ";
                        secondPathToChange = path[curPt + 1].split(",");
                        secondNewPath =
                            "L" +
                            secondPathToChange[0].slice(1) +
                            "," +
                            mouseY +
                            " ";
                    } else {
                        originPoint = path[curPt].split(",");
                        firstNewPath =
                            "L" + originPoint[0].slice(1) + "," + mouseY + " ";
                        secondPathToChange = path[curPt + 2].split(",");
                        secondNewPath =
                            "L" +
                            secondPathToChange[0].slice(1) +
                            "," +
                            mouseY +
                            " ";
                    }
                    let newPath = "";
                    path.forEach((subPath, i) => {
                        if (i == curPt) {
                            newPath += firstNewPath;
                            return;
                        } else if (i == curPt + 1) {
                            newPath += secondNewPath;
                            return;
                        } else if (i < path.length - 1) {
                            newPath += subPath + " ";
                            return;
                        }
                    });
                    element.setAttribute("d", newPath);
                    path$1.init();
                }
                path$1.adjust = [
                    mouseX,
                    mouseY,
                    path$1.adjust[2],
                    path$1.adjust[3],
                ];
            } else {
                path$1.selected_pts = [];
                path$1.eachSeg(function (_i) {
                    const seg = this;
                    if (!seg.next && !seg.prev) {
                        return;
                    }

                    // const {item} = seg;
                    const rubberBox = svgCanvas$g.getRubberBox();
                    const rbb = getBBox(rubberBox);
                    const pt = svgCanvas$g.getGripPt(seg);
                    const ptBb = {
                        x: pt.x,
                        y: pt.y,
                        width: 0,
                        height: 0,
                    };
                    const sel = rectsIntersect(rbb, ptBb);
                    this.select(sel);
                    // Note that addPtsToSelection is not being run
                    if (sel) {
                        path$1.selected_pts.push(seg.index);
                    }
                });
            }
        },
        /**
         * @typedef module:path.keepElement
         * @type {PlainObject}
         * @property {boolean} keep
         * @property {Element} element
         */
        /**
         * @param {Event} evt
         * @param {Element} element
         * @param {Float} _mouseX
         * @param {Float} _mouseY
         * @returns {module:path.keepElement|void}
         */
        mouseUp(evt, element, _mouseX, _mouseY) {
            const drawnPath = svgCanvas$g.getDrawnPath();
            // Create mode
            if (svgCanvas$g.getCurrentMode() === "path") {
                newPoint = null;
                if (!drawnPath) {
                    element = getElement(svgCanvas$g.getId());
                    svgCanvas$g.setStarted(false);
                    firstCtrl = null;
                }
                return {
                    keep: true,
                    element,
                };
            }

            // Edit mode
            const rubberBox = svgCanvas$g.getRubberBox();
            if (path$1.dragging) {
                const lastPt = path$1.cur_pt;
                path$1.dragging = false;
                path$1.dragctrl = false;
                path$1.update();
                if (hasMoved) {
                    path$1.endChanges("Move path point(s)");
                }
                if (!evt.shiftKey && !hasMoved) {
                    path$1.selectPt(lastPt);
                }
            } else if (rubberBox?.getAttribute("display") !== "none") {
                // Done with multi-node-select
                rubberBox.setAttribute("display", "none");
                if (
                    rubberBox.getAttribute("width") <= 2 &&
                    rubberBox.getAttribute("height") <= 2
                ) {
                    pathActionsMethod.toSelectMode(evt.target);
                }

                // else, move back to select mode
            } else {
                pathActionsMethod.toSelectMode(evt.target);
            }
            hasMoved = false;
            return undefined;
        },
        /**
         * @param {Element} element
         * @returns {void}
         */
        toEditMode(element) {
            if (element.getAttribute("type") == "rect") return;
            //This is what I want
            let elementId = element.id;
            if (!elementId.startsWith("svg")) {
                element.setAttribute("stroke-dasharray", "5,5");
            }
            path$1 = svgCanvas$g.getPath_(element);
            svgCanvas$g.setCurrentMode("pathedit");
            svgCanvas$g.clearSelection();
            path$1.setPathContext();
            path$1.show(true).update();
            path$1.oldbbox = getBBox(path$1.elem);
            subpath = false;
        },
        /**
         * @param {Element} elem
         * @fires module:svgcanvas.SvgCanvas#event:selected
         * @returns {void}
         */
        toSelectMode(elem) {
            const selPath = elem === path$1.elem;
            svgCanvas$g.setCurrentMode("select");
            path$1.setPathContext();
            path$1.show(false);
            currentPath = false;
            svgCanvas$g.clearSelection();
            if (path$1.matrix) {
                // Rotated, so may need to re-calculate the center
                svgCanvas$g.recalcRotatedPath();
            }
            if (selPath) {
                svgCanvas$g.call("selected", [elem]);
                svgCanvas$g.addToSelection([elem], true);
            }
        },
        /**
         * @param {boolean} on
         * @returns {void}
         */
        addSubPath(on) {
            if (on) {
                // Internally we go into "path" mode, but in the UI it will
                // still appear as if in "pathedit" mode.
                svgCanvas$g.setCurrentMode("path");
                subpath = true;
            } else {
                pathActionsMethod.clear(true);
                pathActionsMethod.toEditMode(path$1.elem);
            }
        },
        /**
         * @param {Element} target
         * @returns {void}
         */
        select(target) {
            if (target.getAttribute("type") == "rect") return;
            if (currentPath === target) {
                pathActionsMethod.toEditMode(target);
                svgCanvas$g.setCurrentMode("pathedit");
                // going into pathedit mode
            } else {
                currentPath = target;
            }
        },
        /**
         * @fires module:svgcanvas.SvgCanvas#event:changed
         * @returns {void}
         */
        reorient() {
            const elem = svgCanvas$g.getSelectedElements()[0];
            if (!elem) {
                return;
            }
            const angl = getRotationAngle(elem);
            if (angl === 0) {
                return;
            }
            const batchCmd = new BatchCommand$4("Reorient path");
            const changes = {
                d: elem.getAttribute("d"),
                transform: elem.getAttribute("transform"),
            };
            batchCmd.addSubCommand(new ChangeElementCommand$2(elem, changes));
            svgCanvas$g.clearSelection();
            this.resetOrientation(elem);
            svgCanvas$g.addCommandToHistory(batchCmd);

            // Set matrix to null
            svgCanvas$g.getPath_(elem).show(false).matrix = null;
            this.clear();
            svgCanvas$g.addToSelection([elem], true);
            svgCanvas$g.call("changed", svgCanvas$g.getSelectedElements());
        },
        /**
         * @param {boolean} remove Not in use
         * @returns {void}
         */
        clear() {
            const drawnPath = svgCanvas$g.getDrawnPath();
            currentPath = null;
            if (drawnPath) {
                const elem = getElement(svgCanvas$g.getId());
                const psl = getElement("path_stretch_line");
                psl.parentNode.removeChild(psl);
                elem.parentNode.removeChild(elem);
                const pathpointgripContainer = getElement(
                    "pathpointgrip_container",
                );
                const elements = pathpointgripContainer.querySelectorAll("*");
                Array.prototype.forEach.call(elements, function (el) {
                    el.setAttribute("display", "none");
                });
                firstCtrl = null;
                svgCanvas$g.setDrawnPath(null);
                svgCanvas$g.setStarted(false);
            } else if (svgCanvas$g.getCurrentMode() === "pathedit") {
                this.toSelectMode();
            }
            if (path$1) {
                path$1.init().show(false);
            }
        },
        /**
         * @param {?(Element|SVGPathElement)} pth
         * @returns {false|void}
         */
        resetOrientation(pth) {
            if (pth?.nodeName !== "path") {
                return false;
            }
            const tlist = getTransformList(pth);
            const m = transformListToTransform(tlist).matrix;
            tlist.clear();
            pth.removeAttribute("transform");
            const segList = pth.pathSegList;

            // Opera/win/non-EN throws an error here.
            // TODO: Find out why!
            // Presumed fixed in Opera 10.5, so commented out for now

            // try {
            const len = segList.numberOfItems;
            // } catch(err) {
            //   const fixed_d = pathActions.convertPath(pth);
            //   pth.setAttribute('d', fixed_d);
            //   segList = pth.pathSegList;
            //   const len = segList.numberOfItems;
            // }
            // let lastX, lastY;
            for (let i = 0; i < len; ++i) {
                const seg = segList.getItem(i);
                const type = seg.pathSegType;
                if (type === 1) {
                    continue;
                }
                const pts = [];
                ["", 1, 2].forEach(function (n) {
                    const x = seg["x" + n];
                    const y = seg["y" + n];
                    if (x !== undefined && y !== undefined) {
                        const pt = transformPoint(x, y, m);
                        pts.splice(pts.length, 0, pt.x, pt.y);
                    }
                });
                svgCanvas$g.replacePathSeg(type, i, pts, pth);
            }
            svgCanvas$g.reorientGrads(pth, m);
            return undefined;
        },
        /**
         * @returns {void}
         */
        zoomChange() {
            if (svgCanvas$g.getCurrentMode() === "pathedit") {
                path$1.update();
            }
        },
        /**
         * @typedef {PlainObject} module:path.NodePoint
         * @property {Float} x
         * @property {Float} y
         * @property {Integer} type
         */
        /**
         * @returns {module:path.NodePoint}
         */
        getNodePoint() {
            const selPt = path$1.selected_pts.length
                ? path$1.selected_pts[0]
                : 1;
            const seg = path$1.segs[selPt];
            return {
                x: seg.item.x,
                y: seg.item.y,
                type: seg.type,
            };
        },
        /**
         * @param {boolean} linkPoints
         * @returns {void}
         */
        linkControlPoints(linkPoints) {
            svgCanvas$g.setLinkControlPoints(linkPoints);
        },
        /**
         * @returns {void}
         */
        clonePathNode() {
            path$1.storeD();
            const selPts = path$1.selected_pts;
            // const {segs} = path;

            let i = selPts.length;
            const nums = [];
            while (i--) {
                const pt = selPts[i];
                path$1.addSeg(pt);
                nums.push(pt + i);
                nums.push(pt + i + 1);
            }
            path$1.init().addPtsToSelection(nums);
            path$1.endChanges("Clone path node(s)");
        },
        /**
         * @returns {void}
         */
        opencloseSubPath() {
            const selPts = path$1.selected_pts;
            // Only allow one selected node for now
            if (selPts.length !== 1) {
                return;
            }
            const { elem } = path$1;
            const list = elem.pathSegList;

            // const len = list.numberOfItems;

            const index = selPts[0];
            let openPt = null;
            let startItem = null;

            // Check if subpath is already open
            path$1.eachSeg(function (i) {
                if (this.type === 2 && i <= index) {
                    startItem = this.item;
                }
                if (i <= index) {
                    return true;
                }
                if (this.type === 2) {
                    // Found M first, so open
                    openPt = i;
                    return false;
                }
                if (this.type === 1) {
                    // Found Z first, so closed
                    openPt = false;
                    return false;
                }
                return true;
            });
            if (!openPt) {
                // Single path, so close last seg
                openPt = path$1.segs.length - 1;
            }
            if (openPt !== false) {
                // Close this path

                // Create a line going to the previous "M"
                const newseg = elem.createSVGPathSegLinetoAbs(
                    startItem.x,
                    startItem.y,
                );
                const closer = elem.createSVGPathSegClosePath();
                if (openPt === path$1.segs.length - 1) {
                    list.appendItem(newseg);
                    list.appendItem(closer);
                } else {
                    list.insertItemBefore(closer, openPt);
                    list.insertItemBefore(newseg, openPt);
                }
                path$1.init().selectPt(openPt + 1);
                return;
            }

            // M 1,1 L 2,2 L 3,3 L 1,1 z // open at 2,2
            // M 2,2 L 3,3 L 1,1

            // M 1,1 L 2,2 L 1,1 z M 4,4 L 5,5 L6,6 L 5,5 z
            // M 1,1 L 2,2 L 1,1 z [M 4,4] L 5,5 L(M)6,6 L 5,5 z

            const seg = path$1.segs[index];
            if (seg.mate) {
                list.removeItem(index); // Removes last "L"
                list.removeItem(index); // Removes the "Z"
                path$1.init().selectPt(index - 1);
                return;
            }
            let lastM;
            let zSeg;

            // Find this sub-path's closing point and remove
            for (let i = 0; i < list.numberOfItems; i++) {
                const item = list.getItem(i);
                if (item.pathSegType === 2) {
                    // Find the preceding M
                    lastM = i;
                } else if (i === index) {
                    // Remove it
                    list.removeItem(lastM);
                    // index--;
                } else if (item.pathSegType === 1 && index < i) {
                    // Remove the closing seg of this subpath
                    zSeg = i - 1;
                    list.removeItem(i);
                    break;
                }
            }
            let num = index - lastM - 1;
            while (num--) {
                list.insertItemBefore(list.getItem(lastM), zSeg);
            }
            const pt = list.getItem(lastM);

            // Make this point the new "M"
            svgCanvas$g.replacePathSeg(2, lastM, [pt.x, pt.y]);

            // i = index; // i is local here, so has no effect; what was the intent for this?

            path$1.init().selectPt(0);
        },
        /**
         * @returns {void}
         */
        deletePathNode() {
            if (!pathActionsMethod.canDeleteNodes) {
                return;
            }
            path$1.storeD();
            const selPts = path$1.selected_pts;
            let i = selPts.length;
            while (i--) {
                const pt = selPts[i];
                path$1.deleteSeg(pt);
            }

            // Cleanup
            const cleanup = function () {
                const segList = path$1.elem.pathSegList;
                let len = segList.numberOfItems;
                const remItems = function (pos, count) {
                    while (count--) {
                        segList.removeItem(pos);
                    }
                };
                if (len <= 1) {
                    return true;
                }
                while (len--) {
                    const item = segList.getItem(len);
                    if (item.pathSegType === 1) {
                        const prev = segList.getItem(len - 1);
                        const nprev = segList.getItem(len - 2);
                        if (prev.pathSegType === 2) {
                            remItems(len - 1, 2);
                            cleanup();
                            break;
                        } else if (nprev.pathSegType === 2) {
                            remItems(len - 2, 3);
                            cleanup();
                            break;
                        }
                    } else if (item.pathSegType === 2 && len > 0) {
                        const prevType = segList.getItem(len - 1).pathSegType;
                        // Path has M M
                        if (prevType === 2) {
                            remItems(len - 1, 1);
                            cleanup();
                            break;
                            // Entire path ends with Z M
                        } else if (
                            prevType === 1 &&
                            segList.numberOfItems - 1 === len
                        ) {
                            remItems(len, 1);
                            cleanup();
                            break;
                        }
                    }
                }
                return false;
            };
            cleanup();

            // Completely delete a path with 1 or 0 segments
            if (path$1.elem.pathSegList.numberOfItems <= 1) {
                pathActionsMethod.toSelectMode(path$1.elem);
                svgCanvas$g.canvas.deleteSelectedElements();
                return;
            }
            path$1.init();
            path$1.clearSelection();

            // TODO: Find right way to select point now
            // path.selectPt(selPt);
            if (window.opera) {
                // Opera repaints incorrectly
                path$1.elem.setAttribute("d", path$1.elem.getAttribute("d"));
            }
            path$1.endChanges("Delete path node(s)");
        },
        // Can't seem to use `@borrows` here, so using `@see`
        /**
         * Smooth polyline into path.
         * @function module:path.pathActions.smoothPolylineIntoPath
         * @see module:path~smoothPolylineIntoPath
         */
        smoothPolylineIntoPath,
        /* eslint-enable  */
        /**
         * @param {?Integer} v See {@link https://www.w3.org/TR/SVG/single-page.html#paths-InterfaceSVGPathSeg}
         * @returns {void}
         */
        setSegType(v) {
            path$1?.setSegType(v);
        },
        /**
         * @param {string} attr
         * @param {Float} newValue
         * @returns {void}
         */
        moveNode(attr, newValue) {
            const selPts = path$1.selected_pts;
            if (!selPts.length) {
                return;
            }
            path$1.storeD();

            // Get first selected point
            const seg = path$1.segs[selPts[0]];
            const diff = {
                x: 0,
                y: 0,
            };
            diff[attr] = newValue - seg.item[attr];
            seg.move(diff.x, diff.y);
            path$1.endChanges("Move path point");
        },
        /**
         * @param {Element} elem
         * @returns {void}
         */
        fixEnd(elem) {
            // Adds an extra segment if the last seg before a Z doesn't end
            // at its M point
            // M0,0 L0,100 L100,100 z
            const segList = elem.pathSegList;
            const len = segList.numberOfItems;
            let lastM;
            for (let i = 0; i < len; ++i) {
                const item = segList.getItem(i);
                if (item.pathSegType === 2) {
                    // 2 => M segment type (move to)
                    lastM = item;
                }
                if (item.pathSegType === 1) {
                    // 1 => Z segment type (close path)
                    const prev = segList.getItem(i - 1);
                    if (prev.x !== lastM.x || prev.y !== lastM.y) {
                        // Add an L segment here
                        const newseg = elem.createSVGPathSegLinetoAbs(
                            lastM.x,
                            lastM.y,
                        );
                        segList.insertItemBefore(newseg, i);
                        // Can this be done better?
                        pathActionsMethod.fixEnd(elem);
                        break;
                    }
                }
            }
        },
        // Can't seem to use `@borrows` here, so using `@see`
        /**
         * Convert a path to one with only absolute or relative values.
         * @function module:path.pathActions.convertPath
         * @see module:path.convertPath
         */
        convertPath: convertPath$1,
    };
})();
// end pathActions

/**
 * Path functionality.
 * @module path
 * @license MIT
 *
 * @copyright 2011 Alexis Deveria, 2011 Jeff Schiller
 */
const segData = {
    2: ["x", "y"],
    // PATHSEG_MOVETO_ABS
    4: ["x", "y"],
    // PATHSEG_LINETO_ABS
    6: ["x", "y", "x1", "y1", "x2", "y2"],
    // PATHSEG_CURVETO_CUBIC_ABS
    8: ["x", "y", "x1", "y1"],
    // PATHSEG_CURVETO_QUADRATIC_ABS
    10: ["x", "y", "r1", "r2", "angle", "largeArcFlag", "sweepFlag"],
    // PATHSEG_ARC_ABS
    12: ["x"],
    // PATHSEG_LINETO_HORIZONTAL_ABS
    14: ["y"],
    // PATHSEG_LINETO_VERTICAL_ABS
    16: ["x", "y", "x2", "y2"],
    // PATHSEG_CURVETO_CUBIC_SMOOTH_ABS
    18: ["x", "y"], // PATHSEG_CURVETO_QUADRATIC_SMOOTH_ABS
};

let svgCanvas$f;
/**
 * @tutorial LocaleDocs
 * @typedef {module:locale.LocaleStrings|PlainObject} module:path.uiStrings
 * @property {PlainObject<string, string>} ui
 */

const uiStrings = {};
/**
 * @function module:path.setUiStrings
 * @param {module:path.uiStrings} strs
 * @returns {void}
 */
const setUiStrings = (strs) => {
    Object.assign(uiStrings, strs.ui);
};
let pathFuncs = [];
let linkControlPts = true;

// Stores references to paths via IDs.
// TODO: Make this cross-document happy.
let pathData = {};

/**
 * @function module:path.setLinkControlPoints
 * @param {boolean} lcp
 * @returns {void}
 */
const setLinkControlPoints = (lcp) => {
    linkControlPts = lcp;
};

/**
 * @name module:path.path
 * @type {null|module:path.Path}
 * @memberof module:path
 */
let path = null;

/**
 * @external MouseEvent
 */

/**
 * Object with the following keys/values.
 * @typedef {PlainObject} module:path.SVGElementJSON
 * @property {string} element - Tag name of the SVG element to create
 * @property {PlainObject<string, string>} attr - Has key-value attributes to assign to the new element.
 *   An `id` should be set so that {@link module:utilities.EditorContext#addSVGElementsFromJson} can later re-identify the element for modification or replacement.
 * @property {boolean} [curStyles=false] - Indicates whether current style attributes should be applied first
 * @property {module:path.SVGElementJSON[]} [children] - Data objects to be added recursively as children
 * @property {string} [namespace="http://www.w3.org/2000/svg"] - Indicate a (non-SVG) namespace
 */
/**
 * @interface module:path.EditorContext
 * @property {module:select.SelectorManager} selectorManager
 * @property {module:svgcanvas.SvgCanvas} canvas
 */
/**
 * @function module:path.EditorContext#call
 * @param {"selected"|"changed"} ev - String with the event name
 * @param {module:svgcanvas.SvgCanvas#event:selected|module:svgcanvas.SvgCanvas#event:changed} arg - Argument to pass through to the callback function.
 *  If the event is "changed", an array of `Element`s is passed; if "selected", a single-item array of `Element` is passed.
 * @returns {void}
 */
/**
 * Note: This doesn't round to an integer necessarily.
 * @function module:path.EditorContext#round
 * @param {Float} val
 * @returns {Float} Rounded value to nearest value based on `zoom`
 */
/**
 * @function module:path.EditorContext#clearSelection
 * @param {boolean} [noCall] - When `true`, does not call the "selected" handler
 * @returns {void}
 */
/**
 * @function module:path.EditorContext#addToSelection
 * @param {Element[]} elemsToAdd - An array of DOM elements to add to the selection
 * @param {boolean} showGrips - Indicates whether the resize grips should be shown
 * @returns {void}
 */
/**
 * @function module:path.EditorContext#addCommandToHistory
 * @param {Command} cmd
 * @returns {void}
 */
/**
 * @function module:path.EditorContext#remapElement
 * @param {Element} selected - DOM element to be changed
 * @param {PlainObject<string, string>} changes - Object with changes to be remapped
 * @param {SVGMatrix} m - Matrix object to use for remapping coordinates
 * @returns {void}
 */
/**
 * @function module:path.EditorContext#addSVGElementsFromJson
 * @param {module:path.SVGElementJSON} data
 * @returns {Element} The new element
 */
/**
 * @function module:path.EditorContext#getGridSnapping
 * @returns {boolean}
 */
/**
 * @function module:path.EditorContext#getOpacity
 * @returns {Float}
 */
/**
 * @function module:path.EditorContext#getSelectedElements
 * @returns {Element[]} the array with selected DOM elements
 */
/**
 * @function module:path.EditorContext#getContainer
 * @returns {Element}
 */
/**
 * @function module:path.EditorContext#setStarted
 * @param {boolean} s
 * @returns {void}
 */
/**
 * @function module:path.EditorContext#getRubberBox
 * @returns {SVGRectElement}
 */
/**
 * @function module:path.EditorContext#setRubberBox
 * @param {SVGRectElement} rb
 * @returns {SVGRectElement} Same as parameter passed in
 */
/**
 * @function module:path.EditorContext#addPtsToSelection
 * @param {PlainObject} cfg
 * @param {boolean} cfg.closedSubpath
 * @param {SVGCircleElement[]} cfg.grips
 * @returns {void}
 */
/**
 * @function module:path.EditorContext#endChanges
 * @param {PlainObject} cfg
 * @param {string} cfg.cmd
 * @param {Element} cfg.elem
 * @returns {void}
 */
/**
 * @function module:path.EditorContext#getZoom
 * @returns {Float} The current zoom level
 */
/**
 * Returns the last created DOM element ID string.
 * @function module:path.EditorContext#getId
 * @returns {string}
 */
/**
 * Creates and returns a unique ID string for a DOM element.
 * @function module:path.EditorContext#getNextId
 * @returns {string}
 */
/**
 * Gets the desired element from a mouse event.
 * @function module:path.EditorContext#getMouseTarget
 * @param {external:MouseEvent} evt - Event object from the mouse event
 * @returns {Element} DOM element we want
 */
/**
 * @function module:path.EditorContext#getCurrentMode
 * @returns {string}
 */
/**
 * @function module:path.EditorContext#setCurrentMode
 * @param {string} cm The mode
 * @returns {string} The same mode as passed in
 */
/**
 * @function module:path.EditorContext#setDrawnPath
 * @param {SVGPathElement|null} dp
 * @returns {SVGPathElement|null} The same value as passed in
 */
/**
 * @function module:path.EditorContext#getSvgRoot
 * @returns {SVGSVGElement}
 */

/**
 * @function module:path.init
 * @param {module:path.EditorContext} editorContext
 * @returns {void}
 */
const init$g = (canvas) => {
    svgCanvas$f = canvas;
    svgCanvas$f.replacePathSeg = replacePathSegMethod;
    svgCanvas$f.addPointGrip = addPointGripMethod;
    svgCanvas$f.removePath_ = removePath_;
    svgCanvas$f.getPath_ = getPath_;
    svgCanvas$f.addCtrlGrip = addCtrlGripMethod;
    svgCanvas$f.getCtrlLine = getCtrlLineMethod;
    svgCanvas$f.getGripPt = getGripPt;
    svgCanvas$f.getPointFromGrip = getPointFromGripMethod;
    svgCanvas$f.setLinkControlPoints = setLinkControlPoints;
    svgCanvas$f.reorientGrads = reorientGrads;
    svgCanvas$f.getSegData = () => {
        return segData;
    };
    svgCanvas$f.getUIStrings = () => {
        return uiStrings;
    };
    svgCanvas$f.getPathObj = () => {
        return path;
    };
    svgCanvas$f.setPathObj = (obj) => {
        path = obj;
    };
    svgCanvas$f.getPathFuncs = () => {
        return pathFuncs;
    };
    svgCanvas$f.getLinkControlPts = () => {
        return linkControlPts;
    };
    pathFuncs = [0, "ClosePath"];
    const pathFuncsStrs = [
        "Moveto",
        "Lineto",
        "CurvetoCubic",
        "CurvetoQuadratic",
        "Arc",
        "LinetoHorizontal",
        "LinetoVertical",
        "CurvetoCubicSmooth",
        "CurvetoQuadraticSmooth",
    ];
    pathFuncsStrs.forEach((s) => {
        pathFuncs.push(s + "Abs");
        pathFuncs.push(s + "Rel");
    });
    init$h(svgCanvas$f);
    init$i(svgCanvas$f);
};

/* eslint-disable max-len */
/**
 * @function module:path.ptObjToArr
 * @todo See if this should just live in `replacePathSeg`
 * @param {string} type
 * @param {SVGPathSegMovetoAbs|SVGPathSegLinetoAbs|SVGPathSegCurvetoCubicAbs|SVGPathSegCurvetoQuadraticAbs|SVGPathSegArcAbs|SVGPathSegLinetoHorizontalAbs|SVGPathSegLinetoVerticalAbs|SVGPathSegCurvetoCubicSmoothAbs|SVGPathSegCurvetoQuadraticSmoothAbs} segItem
 * @returns {ArgumentsArray}
 */
/* eslint-enable max-len */
const ptObjToArr = ptObjToArrMethod;

/**
 * @function module:path.getGripPt
 * @param {Segment} seg
 * @param {module:math.XYObject} altPt
 * @returns {module:math.XYObject}
 */
const getGripPt = getGripPtMethod;

/**
 * @function module:path.getPointFromGrip
 * @param {module:math.XYObject} pt
 * @param {module:path.Path} pth
 * @returns {module:math.XYObject}
 */
const getPointFromGrip = getPointFromGripMethod;

/**
 * Requires prior call to `setUiStrings` if `xlink:title`
 *    to be set on the grip.
 * @function module:path.addPointGrip
 * @param {Integer} index
 * @param {Integer} x
 * @param {Integer} y
 * @returns {SVGCircleElement}
 */
const addPointGrip = addPointGripMethod;

/**
 * @function module:path.getGripContainer
 * @returns {Element}
 */
const getGripContainer = getGripContainerMethod;

/**
 * Requires prior call to `setUiStrings` if `xlink:title`
 *    to be set on the grip.
 * @function module:path.addCtrlGrip
 * @param {string} id
 * @returns {SVGCircleElement}
 */
const addCtrlGrip = addCtrlGripMethod;

/**
 * @function module:path.getCtrlLine
 * @param {string} id
 * @returns {SVGLineElement}
 */
const getCtrlLine = getCtrlLineMethod;

/**
 * @function module:path.getPointGrip
 * @param {Segment} seg
 * @param {boolean} update
 * @returns {SVGCircleElement}
 */
const getPointGrip = getPointGripMethod;

/**
 * @function module:path.getControlPoints
 * @param {Segment} seg
 * @returns {PlainObject<string, SVGLineElement|SVGCircleElement>}
 */
const getControlPoints = getControlPointsMethod;

/**
 * This replaces the segment at the given index. Type is given as number.
 * @function module:path.replacePathSeg
 * @param {Integer} type Possible values set during {@link module:path.init}
 * @param {Integer} index
 * @param {ArgumentsArray} pts
 * @param {SVGPathElement} elem
 * @returns {void}
 */
const replacePathSeg = replacePathSegMethod;

/**
 * @function module:path.getSegSelector
 * @param {Segment} seg
 * @param {boolean} update
 * @returns {SVGPathElement}
 */
const getSegSelector = getSegSelectorMethod;

/**
 * @typedef {PlainObject} Point
 * @property {Integer} x The x value
 * @property {Integer} y The y value
 */

/**
 * Takes three points and creates a smoother line based on them.
 * @function module:path.smoothControlPoints
 * @param {Point} ct1 - Object with x and y values (first control point)
 * @param {Point} ct2 - Object with x and y values (second control point)
 * @param {Point} pt - Object with x and y values (third point)
 * @returns {Point[]} Array of two "smoothed" point objects
 */
const smoothControlPoints = (ct1, ct2, pt) => {
    // each point must not be the origin
    const x1 = ct1.x - pt.x;
    const y1 = ct1.y - pt.y;
    const x2 = ct2.x - pt.x;
    const y2 = ct2.y - pt.y;
    if ((x1 !== 0 || y1 !== 0) && (x2 !== 0 || y2 !== 0)) {
        const r1 = Math.sqrt(x1 * x1 + y1 * y1);
        const r2 = Math.sqrt(x2 * x2 + y2 * y2);
        const nct1 = svgCanvas$f.getSvgRoot().createSVGPoint();
        const nct2 = svgCanvas$f.getSvgRoot().createSVGPoint();
        let anglea = Math.atan2(y1, x1);
        let angleb = Math.atan2(y2, x2);
        if (anglea < 0) {
            anglea += 2 * Math.PI;
        }
        if (angleb < 0) {
            angleb += 2 * Math.PI;
        }
        const angleBetween = Math.abs(anglea - angleb);
        const angleDiff = Math.abs(Math.PI - angleBetween) / 2;
        let newAnglea;
        let newAngleb;
        if (anglea - angleb > 0) {
            newAnglea =
                angleBetween < Math.PI
                    ? anglea + angleDiff
                    : anglea - angleDiff;
            newAngleb =
                angleBetween < Math.PI
                    ? angleb - angleDiff
                    : angleb + angleDiff;
        } else {
            newAnglea =
                angleBetween < Math.PI
                    ? anglea - angleDiff
                    : anglea + angleDiff;
            newAngleb =
                angleBetween < Math.PI
                    ? angleb + angleDiff
                    : angleb - angleDiff;
        }

        // rotate the points
        nct1.x = r1 * Math.cos(newAnglea) + pt.x;
        nct1.y = r1 * Math.sin(newAnglea) + pt.y;
        nct2.x = r2 * Math.cos(newAngleb) + pt.x;
        nct2.y = r2 * Math.sin(newAngleb) + pt.y;
        return [nct1, nct2];
    }
    return undefined;
};

/**
 * @function module:path.getPath_
 * @param {SVGPathElement} elem
 * @returns {module:path.Path}
 */
const getPath_ = (elem) => {
    let p = pathData[elem.id];
    if (!p) {
        p = pathData[elem.id] = new Path$1(elem);
    }
    return p;
};

/**
 * @function module:path.removePath_
 * @param {string} id
 * @returns {void}
 */
const removePath_ = (id) => {
    if (id in pathData) {
        delete pathData[id];
    }
};
let newcx;
let newcy;
let oldcx;
let oldcy;
let angle;
const getRotVals = (x, y) => {
    let dx = x - oldcx;
    let dy = y - oldcy;

    // rotate the point around the old center
    let r = Math.sqrt(dx * dx + dy * dy);
    let theta = Math.atan2(dy, dx) + angle;
    dx = r * Math.cos(theta) + oldcx;
    dy = r * Math.sin(theta) + oldcy;

    // dx,dy should now hold the actual coordinates of each
    // point after being rotated

    // now we want to rotate them around the new center in the reverse direction
    dx -= newcx;
    dy -= newcy;
    r = Math.sqrt(dx * dx + dy * dy);
    theta = Math.atan2(dy, dx) - angle;
    return {
        x: r * Math.cos(theta) + newcx,
        y: r * Math.sin(theta) + newcy,
    };
};

// If the path was rotated, we must now pay the piper:
// Every path point must be rotated into the rotated coordinate system of
// its old center, then determine the new center, then rotate it back
// This is because we want the path to remember its rotation

/**
 * @function module:path.recalcRotatedPath
 * @todo This is still using ye olde transform methods, can probably
 * be optimized or even taken care of by `recalculateDimensions`
 * @returns {void}
 */
const recalcRotatedPath = () => {
    const currentPath = path.elem;
    angle = getRotationAngle(currentPath, true);
    if (!angle) {
        return;
    }
    // selectedBBoxes[0] = path.oldbbox;
    const oldbox = path.oldbbox; // selectedBBoxes[0],
    oldcx = oldbox.x + oldbox.width / 2;
    oldcy = oldbox.y + oldbox.height / 2;
    const box = getBBox(currentPath);
    newcx = box.x + box.width / 2;
    newcy = box.y + box.height / 2;

    // un-rotate the new center to the proper position
    const dx = newcx - oldcx;
    const dy = newcy - oldcy;
    const r = Math.sqrt(dx * dx + dy * dy);
    const theta = Math.atan2(dy, dx) + angle;
    newcx = r * Math.cos(theta) + oldcx;
    newcy = r * Math.sin(theta) + oldcy;
    const list = currentPath.pathSegList;
    let i = list.numberOfItems;
    while (i) {
        i -= 1;
        const seg = list.getItem(i);
        const type = seg.pathSegType;
        if (type === 1) {
            continue;
        }
        const rvals = getRotVals(seg.x, seg.y);
        const points = [rvals.x, rvals.y];
        if (seg.x1 && seg.x2) {
            const cVals1 = getRotVals(seg.x1, seg.y1);
            const cVals2 = getRotVals(seg.x2, seg.y2);
            points.splice(
                points.length,
                0,
                cVals1.x,
                cVals1.y,
                cVals2.x,
                cVals2.y,
            );
        }
        replacePathSeg(type, i, points);
    } // loop for each point

    /* box = */
    getBBox(currentPath);
    // selectedBBoxes[0].x = box.x; selectedBBoxes[0].y = box.y;
    // selectedBBoxes[0].width = box.width; selectedBBoxes[0].height = box.height;

    // now we must set the new transform to be rotated around the new center
    const Rnc = svgCanvas$f.getSvgRoot().createSVGTransform();
    const tlist = getTransformList(currentPath);
    Rnc.setRotate((angle * 180.0) / Math.PI, newcx, newcy);
    tlist.replaceItem(Rnc, 0);
};

// ====================================
// Public API starts here

/**
 * @function module:path.clearData
 * @returns {void}
 */
const clearData = () => {
    pathData = {};
};

// Making public for mocking
/**
 * @function module:path.reorientGrads
 * @param {Element} elem
 * @param {SVGMatrix} m
 * @returns {void}
 */
const reorientGrads = (elem, m) => {
    const bb = getBBox(elem);
    for (let i = 0; i < 2; i++) {
        const type = i === 0 ? "fill" : "stroke";
        const attrVal = elem.getAttribute(type);
        if (attrVal && attrVal.startsWith("url(")) {
            const grad = getRefElem(attrVal);
            if (grad.tagName === "linearGradient") {
                let x1 = grad.getAttribute("x1") || 0;
                let y1 = grad.getAttribute("y1") || 0;
                let x2 = grad.getAttribute("x2") || 1;
                let y2 = grad.getAttribute("y2") || 0;

                // Convert to USOU points
                x1 = bb.width * x1 + bb.x;
                y1 = bb.height * y1 + bb.y;
                x2 = bb.width * x2 + bb.x;
                y2 = bb.height * y2 + bb.y;

                // Transform those points
                const pt1 = transformPoint(x1, y1, m);
                const pt2 = transformPoint(x2, y2, m);

                // Convert back to BB points
                const gCoords = {
                    x1: (pt1.x - bb.x) / bb.width,
                    y1: (pt1.y - bb.y) / bb.height,
                    x2: (pt2.x - bb.x) / bb.width,
                    y2: (pt2.y - bb.y) / bb.height,
                };
                const newgrad = grad.cloneNode(true);
                for (const [key, value] of Object.entries(gCoords)) {
                    newgrad.setAttribute(key, value);
                }
                newgrad.id = svgCanvas$f.getNextId();
                findDefs().append(newgrad);
                elem.setAttribute(type, "url(#" + newgrad.id + ")");
            }
        }
    }
};

/**
 * This is how we map paths to our preferred relative segment types.
 * @name module:path.pathMap
 * @type {GenericArray}
 */
const pathMap$1 = [
    0,
    "z",
    "M",
    "m",
    "L",
    "l",
    "C",
    "c",
    "Q",
    "q",
    "A",
    "a",
    "H",
    "h",
    "V",
    "v",
    "S",
    "s",
    "T",
    "t",
];

/**
 * Convert a path to one with only absolute or relative values.
 * @todo move to pathActions.js
 * @function module:path.convertPath
 * @param {SVGPathElement} pth - the path to convert
 * @param {boolean} toRel - true of convert to relative
 * @returns {string}
 */
const convertPath = (pth, toRel) => {
    const { pathSegList } = pth;
    const len = pathSegList.numberOfItems;
    let curx = 0;
    let cury = 0;
    let d = "";
    let lastM = null;
    for (let i = 0; i < len; ++i) {
        const seg = pathSegList.getItem(i);
        // if these properties are not in the segment, set them to zero
        let x = seg.x || 0;
        let y = seg.y || 0;
        let x1 = seg.x1 || 0;
        let y1 = seg.y1 || 0;
        let x2 = seg.x2 || 0;
        let y2 = seg.y2 || 0;
        const type = seg.pathSegType;
        let letter = pathMap$1[type][toRel ? "toLowerCase" : "toUpperCase"]();
        switch (type) {
            case 1:
                // z,Z closepath (Z/z)
                d += "z";
                if (lastM && !toRel) {
                    curx = lastM[0];
                    cury = lastM[1];
                }
                break;
            case 12:
                // absolute horizontal line (H)
                x -= curx;
            // Fallthrough
            case 13:
                // relative horizontal line (h)
                if (toRel) {
                    y = 0;
                    curx += x;
                    letter = "l";
                } else {
                    y = cury;
                    x += curx;
                    curx = x;
                    letter = "L";
                }
                // Convert to "line" for easier editing
                d += pathDSegment(letter, [[x, y]]);
                break;
            case 14:
                // absolute vertical line (V)
                y -= cury;
            // Fallthrough
            case 15:
                // relative vertical line (v)
                if (toRel) {
                    x = 0;
                    cury += y;
                    letter = "l";
                } else {
                    x = curx;
                    y += cury;
                    cury = y;
                    letter = "L";
                }
                // Convert to "line" for easier editing
                d += pathDSegment(letter, [[x, y]]);
                break;
            case 2: // absolute move (M)
            case 4: // absolute line (L)
            case 18: // absolute smooth quad (T)
            case 10:
                // absolute elliptical arc (A)
                x -= curx;
                y -= cury;
            // Fallthrough
            case 5: // relative line (l)
            case 3: // relative move (m)
            case 19:
                // relative smooth quad (t)
                if (toRel) {
                    curx += x;
                    cury += y;
                } else {
                    x += curx;
                    y += cury;
                    curx = x;
                    cury = y;
                }
                if (type === 2 || type === 3) {
                    lastM = [curx, cury];
                }
                d += pathDSegment(letter, [[x, y]]);
                break;
            case 6:
                // absolute cubic (C)
                x -= curx;
                x1 -= curx;
                x2 -= curx;
                y -= cury;
                y1 -= cury;
                y2 -= cury;
            // Fallthrough
            case 7:
                // relative cubic (c)
                if (toRel) {
                    curx += x;
                    cury += y;
                } else {
                    x += curx;
                    x1 += curx;
                    x2 += curx;
                    y += cury;
                    y1 += cury;
                    y2 += cury;
                    curx = x;
                    cury = y;
                }
                d += pathDSegment(letter, [
                    [x1, y1],
                    [x2, y2],
                    [x, y],
                ]);
                break;
            case 8:
                // absolute quad (Q)
                x -= curx;
                x1 -= curx;
                y -= cury;
                y1 -= cury;
            // Fallthrough
            case 9:
                // relative quad (q)
                if (toRel) {
                    curx += x;
                    cury += y;
                } else {
                    x += curx;
                    x1 += curx;
                    y += cury;
                    y1 += cury;
                    curx = x;
                    cury = y;
                }
                d += pathDSegment(letter, [
                    [x1, y1],
                    [x, y],
                ]);
                break;
            // Fallthrough
            case 11:
                // relative elliptical arc (a)
                if (toRel) {
                    curx += x;
                    cury += y;
                } else {
                    x += curx;
                    y += cury;
                    curx = x;
                    cury = y;
                }
                d += pathDSegment(
                    letter,
                    [[seg.r1, seg.r2]],
                    [
                        seg.angle,
                        seg.largeArcFlag ? 1 : 0,
                        seg.sweepFlag ? 1 : 0,
                    ],
                    [x, y],
                );
                break;
            case 16:
                // absolute smooth cubic (S)
                x -= curx;
                x2 -= curx;
                y -= cury;
                y2 -= cury;
            // Fallthrough
            case 17:
                // relative smooth cubic (s)
                if (toRel) {
                    curx += x;
                    cury += y;
                } else {
                    x += curx;
                    x2 += curx;
                    y += cury;
                    y2 += cury;
                    curx = x;
                    cury = y;
                }
                d += pathDSegment(letter, [
                    [x2, y2],
                    [x, y],
                ]);
                break;
        } // switch on path segment type
    } // for each segment
    return d;
};

/**
 * TODO: refactor callers in `convertPath` to use `getPathDFromSegments` instead of this function.
 * Legacy code refactored from `svgcanvas.pathActions.convertPath`.
 * @param {string} letter - path segment command (letter in potentially either case from {@link module:path.pathMap}; see [SVGPathSeg#pathSegTypeAsLetter]{@link https://www.w3.org/TR/SVG/single-page.html#paths-__svg__SVGPathSeg__pathSegTypeAsLetter})
 * @param {GenericArray<GenericArray<Integer>>} points - x,y points
 * @param {GenericArray<GenericArray<Integer>>} [morePoints] - x,y points
 * @param {Integer[]} [lastPoint] - x,y point
 * @returns {string}
 */
const pathDSegment = (letter, points, morePoints, lastPoint) => {
    points.forEach((pnt, i) => {
        points[i] = shortFloat(pnt);
    });
    let segment = letter + points.join(" ");
    if (morePoints) {
        segment += " " + morePoints.join(" ");
    }
    if (lastPoint) {
        segment += " " + shortFloat(lastPoint);
    }
    return segment;
};

/**
 * Group: Path edit functions.
 * Functions relating to editing path elements.
 */
const pathActions = pathActionsMethod;
// end pathActions

var pathModule = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    addCtrlGrip: addCtrlGrip,
    addPointGrip: addPointGrip,
    clearData: clearData,
    convertPath: convertPath,
    getControlPoints: getControlPoints,
    getCtrlLine: getCtrlLine,
    getGripContainer: getGripContainer,
    getGripPt: getGripPt,
    getPath_: getPath_,
    getPointFromGrip: getPointFromGrip,
    getPointGrip: getPointGrip,
    getSegSelector: getSegSelector,
    init: init$g,
    get path() {
        return path;
    },
    pathActions: pathActions,
    ptObjToArr: ptObjToArr,
    recalcRotatedPath: recalcRotatedPath,
    removePath_: removePath_,
    reorientGrads: reorientGrads,
    replacePathSeg: replacePathSeg,
    setLinkControlPoints: setLinkControlPoints,
    setUiStrings: setUiStrings,
    smoothControlPoints: smoothControlPoints,
});

/**
 * Provides tools for the layer concept.
 * @module layer
 * @license MIT
 *
 * @copyright 2011 Jeff Schiller, 2016 Flint O'Brien
 */

/**
 * This class encapsulates the concept of a layer in the drawing. It can be constructed with
 * an existing group element or, with three parameters, will create a new layer group element.
 *
 * @example
 * const l1 = new Layer('name', group); // Use the existing group for this layer.
 * const l2 = new Layer('name', group, svgElem); // Create a new group and add it to the DOM after group.
 * const l3 = new Layer('name', null, svgElem); // Create a new group and add it to the DOM as the last layer.
 * @memberof module:layer
 */
class Layer {
    /**
     * @param {string} name - Layer name
     * @param {SVGGElement|null} group - An existing SVG group element or null.
     *     If group and no svgElem, use group for this layer.
     *     If group and svgElem, create a new group element and insert it in the DOM after group.
     *     If no group and svgElem, create a new group element and insert it in the DOM as the last layer.
     * @param {SVGGElement} [svgElem] - The SVG DOM element. If defined, use this to add
     *     a new layer to the document.
     */
    constructor(name, group, svgElem) {
        this.name_ = name;
        this.group_ = svgElem ? null : group;
        if (svgElem) {
            // Create a group element with title and add it to the DOM.
            const svgdoc = svgElem.ownerDocument;
            this.group_ = svgdoc.createElementNS(NS.SVG, "g");
            const layerTitle = svgdoc.createElementNS(NS.SVG, "title");
            layerTitle.textContent = name;
            this.group_.append(layerTitle);
            if (group) {
                group.insertAdjacentElement("afterend", this.group_);
            } else {
                svgElem.append(this.group_);
            }
        }
        addLayerClass(this.group_);
        walkTree(this.group_, function (e) {});
        this.group_.setAttribute(
            "style",
            svgElem ? "pointer-events:all" : "pointer-events:none",
        );
    }

    /**
     * Get the layer's name.
     * @returns {string} The layer name
     */
    getName() {
        return this.name_;
    }

    /**
     * Get the group element for this layer.
     * @returns {SVGGElement} The layer SVG group
     */
    getGroup() {
        return this.group_;
    }

    /**
     * Active this layer so it takes pointer events.
     * @returns {void}
     */
    activate() {
        this.group_.setAttribute("style", "pointer-events:all");
    }

    /**
     * Deactive this layer so it does NOT take pointer events.
     * @returns {void}
     */
    deactivate() {
        this.group_.setAttribute("style", "pointer-events:none");
    }

    /**
     * Set this layer visible or hidden based on 'visible' parameter.
     * @param {boolean} visible - If true, make visible; otherwise, hide it.
     * @returns {void}
     */
    setVisible(visible) {
        const expected = visible === undefined || visible ? "inline" : "none";
        const oldDisplay = this.group_.getAttribute("display");
        if (oldDisplay !== expected) {
            this.group_.setAttribute("display", expected);
        }
    }

    /**
     * Is this layer visible?
     * @returns {boolean} True if visible.
     */
    isVisible() {
        return this.group_.getAttribute("display") !== "none";
    }

    /**
     * Get layer opacity.
     * @returns {Float} Opacity value.
     */
    getOpacity() {
        const opacity = this.group_.getAttribute("opacity");
        if (!opacity) {
            return 1;
        }
        return Number.parseFloat(opacity);
    }

    /**
     * Sets the opacity of this layer. If opacity is not a value between 0.0 and 1.0,
     * nothing happens.
     * @param {Float} opacity - A float value in the range 0.0-1.0
     * @returns {void}
     */
    setOpacity(opacity) {
        if (typeof opacity === "number" && opacity >= 0.0 && opacity <= 1.0) {
            this.group_.setAttribute("opacity", opacity);
        }
    }

    /**
     * Append children to this layer.
     * @param {SVGGElement} children - The children to append to this layer.
     * @returns {void}
     */
    appendChildren(children) {
        for (const child of children) {
            this.group_.append(child);
        }
    }

    /**
     * @returns {SVGTitleElement|null}
     */
    getTitleElement() {
        const len = this.group_.childNodes.length;
        for (let i = 0; i < len; ++i) {
            const child = this.group_.childNodes.item(i);
            if (child?.tagName === "title") {
                return child;
            }
        }
        return null;
    }

    /**
     * Set the name of this layer.
     * @param {string} name - The new name.
     * @param {module:history.HistoryRecordingService} hrService - History recording service
     * @returns {string|null} The new name if changed; otherwise, null.
     */
    setName(name, hrService) {
        const previousName = this.name_;
        name = toXml(name);
        // now change the underlying title element contents
        const title = this.getTitleElement();
        if (title) {
            while (title.firstChild) {
                title.removeChild(title.firstChild);
            }
            title.textContent = name;
            this.name_ = name;
            if (hrService) {
                hrService.changeElement(title, {
                    "#text": previousName,
                });
            }
            return this.name_;
        }
        return null;
    }

    /**
     * Remove this layer's group from the DOM. No more functions on group can be called after this.
     * @returns {SVGGElement} The layer SVG group that was just removed.
     */
    removeGroup() {
        const group = this.group_;
        this.group_.remove();
        this.group_ = undefined;
        return group;
    }

    /**
     * Test whether an element is a layer or not.
     * @param {SVGGElement} elem - The SVGGElement to test.
     * @returns {boolean} True if the element is a layer
     */
    static isLayer(elem) {
        return (
            elem &&
            elem.tagName === "g" &&
            Layer.CLASS_REGEX.test(elem.getAttribute("class"))
        );
    }
}
/**
 * @property {string} CLASS_NAME - class attribute assigned to all layer groups.
 */
Layer.CLASS_NAME = "layer";

/**
 * @property {RegExp} CLASS_REGEX - Used to test presence of class Layer.CLASS_NAME
 */
Layer.CLASS_REGEX = new RegExp("(\\s|^)" + Layer.CLASS_NAME + "(\\s|$)");

/**
 * Add class `Layer.CLASS_NAME` to the element (usually `class='layer'`).
 *
 * @param {SVGGElement} elem - The SVG element to update
 * @returns {void}
 */
function addLayerClass(elem) {
    const classes = elem.getAttribute("class");
    if (!classes || !classes.length) {
        elem.setAttribute("class", Layer.CLASS_NAME);
    } else if (!Layer.CLASS_REGEX.test(classes)) {
        elem.setAttribute("class", classes + " " + Layer.CLASS_NAME);
    }
}

/**
 * HistoryRecordingService component of history.
 * @module history
 * @license MIT
 * @copyright 2016 Flint O'Brien
 */

/**
 * History recording service.
 *
 * A self-contained service interface for recording history. Once injected, no other dependencies
 * or globals are required (example: UndoManager, command types, etc.). Easy to mock for unit tests.
 * Built on top of history classes in history.js.
 *
 * There is a simple start/end interface for batch commands.
 *
 * HistoryRecordingService.NO_HISTORY is a singleton that can be passed in to functions
 * that record history. This helps when the caller requires that no history be recorded.
 *
 * The following will record history: insert, batch, insert.
 * @example
 * hrService = new HistoryRecordingService(this.undoMgr);
 * hrService.insertElement(elem, text); // add simple command to history.
 * hrService.startBatchCommand('create two elements');
 * hrService.changeElement(elem, attrs, text); // add to batchCommand
 * hrService.changeElement(elem, attrs2, text); // add to batchCommand
 * hrService.endBatchCommand(); // add batch command with two change commands to history.
 * hrService.insertElement(elem, text); // add simple command to history.
 *
 * @example
 * // Note that all functions return this, so commands can be chained, like so:
 * hrService
 *   .startBatchCommand('create two elements')
 *   .insertElement(elem, text)
 *   .changeElement(elem, attrs, text)
 *   .endBatchCommand();
 *
 * @memberof module:history
 */
class HistoryRecordingService {
    /**
     * @param {history.UndoManager|null} undoManager - The undo manager.
     *     A value of `null` is valid for cases where no history recording is required.
     *     See singleton: {@link module:history.HistoryRecordingService.HistoryRecordingService.NO_HISTORY}
     */
    constructor(undoManager) {
        this.undoManager_ = undoManager;
        this.currentBatchCommand_ = null;
        this.batchCommandStack_ = [];
    }

    /**
     * Start a batch command so multiple commands can recorded as a single history command.
     * Requires a corresponding call to endBatchCommand. Start and end commands can be nested.
     *
     * @param {string} text - Optional string describing the batch command.
     * @returns {module:history.HistoryRecordingService}
     */
    startBatchCommand(text) {
        if (!this.undoManager_) {
            return this;
        }
        this.currentBatchCommand_ = new BatchCommand$4(text);
        this.batchCommandStack_.push(this.currentBatchCommand_);
        return this;
    }

    /**
     * End a batch command and add it to the history or a parent batch command.
     * @returns {module:history.HistoryRecordingService}
     */
    endBatchCommand() {
        if (!this.undoManager_) {
            return this;
        }
        if (this.currentBatchCommand_) {
            const batchCommand = this.currentBatchCommand_;
            this.batchCommandStack_.pop();
            const { length: len } = this.batchCommandStack_;
            this.currentBatchCommand_ = len
                ? this.batchCommandStack_[len - 1]
                : null;
            this.addCommand_(batchCommand);
        }
        return this;
    }

    /**
     * Add a `MoveElementCommand` to the history or current batch command.
     * @param {Element} elem - The DOM element that was moved
     * @param {Element} oldNextSibling - The element's next sibling before it was moved
     * @param {Element} oldParent - The element's parent before it was moved
     * @param {string} [text] - An optional string visible to user related to this change
     * @returns {module:history.HistoryRecordingService}
     */
    moveElement(elem, oldNextSibling, oldParent, text) {
        if (!this.undoManager_) {
            return this;
        }
        this.addCommand_(
            new MoveElementCommand$1(elem, oldNextSibling, oldParent, text),
        );
        return this;
    }

    /**
     * Add an `InsertElementCommand` to the history or current batch command.
     * @param {Element} elem - The DOM element that was added
     * @param {string} [text] - An optional string visible to user related to this change
     * @returns {module:history.HistoryRecordingService}
     */
    insertElement(elem, text) {
        if (!this.undoManager_) {
            return this;
        }
        this.addCommand_(new InsertElementCommand$4(elem, text));
        return this;
    }

    /**
     * Add a `RemoveElementCommand` to the history or current batch command.
     * @param {Element} elem - The DOM element that was removed
     * @param {Element} oldNextSibling - The element's next sibling before it was removed
     * @param {Element} oldParent - The element's parent before it was removed
     * @param {string} [text] - An optional string visible to user related to this change
     * @returns {module:history.HistoryRecordingService}
     */
    removeElement(elem, oldNextSibling, oldParent, text) {
        if (!this.undoManager_) {
            return this;
        }
        this.addCommand_(
            new RemoveElementCommand$2(elem, oldNextSibling, oldParent, text),
        );
        return this;
    }

    /**
     * Add a `ChangeElementCommand` to the history or current batch command.
     * @param {Element} elem - The DOM element that was changed
     * @param {module:history.CommandAttributes} attrs - An object with the attributes to be changed and the values they had *before* the change
     * @param {string} [text] - An optional string visible to user related to this change
     * @returns {module:history.HistoryRecordingService}
     */
    changeElement(elem, attrs, text) {
        if (!this.undoManager_) {
            return this;
        }
        this.addCommand_(new ChangeElementCommand$2(elem, attrs, text));
        return this;
    }

    /**
     * Private function to add a command to the history or current batch command.
     * @private
     * @param {Command} cmd
     * @returns {module:history.HistoryRecordingService|void}
     */
    addCommand_(cmd) {
        if (!this.undoManager_) {
            return this;
        }
        if (this.currentBatchCommand_) {
            this.currentBatchCommand_.addSubCommand(cmd);
        } else {
            this.undoManager_.addCommandToHistory(cmd);
        }
        return undefined;
    }
}
/**
 * @memberof module:history.HistoryRecordingService
 * @property {module:history.HistoryRecordingService} NO_HISTORY - Singleton that can be passed to functions that record history, but the caller requires that no history be recorded.
 */
HistoryRecordingService.NO_HISTORY = new HistoryRecordingService();

/**
 * Create a clone of an element, updating its ID and its children's IDs when needed.
 * @function module:utilities.copyElem
 * @param {Element} el - DOM element to clone
 * @param {module:utilities.GetNextID} getNextId - The getter of the next unique ID.
 * @returns {Element} The cloned element
 */
const copyElem = function (el, getNextId) {
    // manually create a copy of the element
    const newEl = document.createElementNS(el.namespaceURI, el.nodeName);
    Object.values(el.attributes).forEach((attr) => {
        newEl.setAttributeNS(attr.namespaceURI, attr.nodeName, attr.value);
    });
    // set the copied element's new id
    newEl.removeAttribute("id");
    newEl.id = getNextId();

    // now create copies of all children
    el.childNodes.forEach(function (child) {
        switch (child.nodeType) {
            case 1:
                // element node
                newEl.append(copyElem(child, getNextId));
                break;
            case 3:
                // text node
                newEl.textContent = child.nodeValue;
                break;
        }
    });
    if (el.dataset.gsvg) {
        newEl.dataset.gsvg = newEl.firstChild;
    } else if (el.dataset.symbol) {
        const ref = el.dataset.symbol;
        newEl.dataset.ref = ref;
        newEl.dataset.symbol = ref;
    } else if (newEl.tagName === "image") {
        preventClickDefault(newEl);
    }
    return newEl;
};

let nanoid = (size = 21) =>
    crypto.getRandomValues(new Uint8Array(size)).reduce((id, byte) => {
        byte &= 63;
        if (byte < 36) {
            id += byte.toString(36);
        } else if (byte < 62) {
            id += (byte - 26).toString(36).toUpperCase();
        } else if (byte > 62) {
            id += "-";
        } else {
            id += "_";
        }
        return id;
    }, "");

/**
 * Tools for drawing.
 * @module draw
 * @license MIT
 * @copyright 2011 Jeff Schiller
 */
const visElems$1 =
    "a,circle,ellipse,foreignObject,g,image,line,path,polygon,polyline,rect,svg,text,tspan,use".split(
        ",",
    );
const RandomizeModes = {
    LET_DOCUMENT_DECIDE: 0,
    ALWAYS_RANDOMIZE: 1,
    NEVER_RANDOMIZE: 2,
};
let randIds = RandomizeModes.LET_DOCUMENT_DECIDE;
// Array with current disabled elements (for in-group editing)
let disabledElems = [];

/**
 * Get a HistoryRecordingService.
 * @param {module:history.HistoryRecordingService} [hrService] - if exists, return it instead of creating a new service.
 * @returns {module:history.HistoryRecordingService}
 */
function historyRecordingService(hrService) {
    return hrService || new HistoryRecordingService(svgCanvas$e.undoMgr);
}

/**
 * Find the layer name in a group element.
 * @param {Element} group The group element to search in.
 * @returns {string} The layer name or empty string.
 */
function findLayerNameInGroup(group) {
    const sel = group.querySelector("title");
    return sel ? sel.textContent : "";
}

/**
 * Given a set of names, return a new unique name.
 * @param {string[]} existingLayerNames - Existing layer names.
 * @returns {string} - The new name.
 */
function getNewLayerName(existingLayerNames) {
    let i = 1;
    // TODO(codedread): What about internationalization of "Layer"?
    while (existingLayerNames.includes("Layer " + i)) {
        i++;
    }
    return "Layer " + i;
}

/**
 * This class encapsulates the concept of a SVG-edit drawing.
 */
class Drawing {
    /**
     * @param {SVGSVGElement} svgElem - The SVG DOM Element that this JS object
     *     encapsulates.  If the svgElem has a se:nonce attribute on it, then
     *     IDs will use the nonce as they are generated.
     * @param {string} [optIdPrefix=svg_] - The ID prefix to use.
     * @throws {Error} If not initialized with an SVG element
     */
    constructor(svgElem, optIdPrefix) {
        if (
            !svgElem ||
            !svgElem.tagName ||
            !svgElem.namespaceURI ||
            svgElem.tagName !== "svg" ||
            svgElem.namespaceURI !== NS.SVG
        ) {
            throw new Error(
                "Error: svgedit.draw.Drawing instance initialized without a <svg> element",
            );
        }

        /**
         * The SVG DOM Element that represents this drawing.
         * @type {SVGSVGElement}
         */
        this.svgElem_ = svgElem;

        /**
         * The latest object number used in this drawing.
         * @type {Integer}
         */
        this.obj_num = 0;

        /**
         * The prefix to prepend to each element id in the drawing.
         * @type {string}
         */
        this.idPrefix = optIdPrefix || "svg_";

        /**
         * An array of released element ids to immediately reuse.
         * @type {Integer[]}
         */
        this.releasedNums = [];

        /**
         * The z-ordered array of Layer objects. Each layer has a name
         * and group element.
         * The first layer is the one at the bottom of the rendering.
         * @type {Layer[]}
         */
        this.all_layers = [];

        /**
         * Map of all_layers by name.
         *
         * Note: Layers are ordered, but referenced externally by name; so, we need both container
         * types depending on which function is called (i.e. all_layers and layer_map).
         *
         * @type {PlainObject<string, Layer>}
         */
        this.layer_map = {};

        /**
         * The current layer being used.
         * @type {Layer}
         */
        this.current_layer = null;

        /**
         * The nonce to use to uniquely identify elements across drawings.
         * @type {!string}
         */
        this.nonce_ = "";
        const n = this.svgElem_.getAttributeNS(NS.SE, "nonce");
        // If already set in the DOM, use the nonce throughout the document
        // else, if randomizeIds(true) has been called, create and set the nonce.
        if (n && randIds !== RandomizeModes.NEVER_RANDOMIZE) {
            this.nonce_ = n;
        } else if (randIds === RandomizeModes.ALWAYS_RANDOMIZE) {
            this.setNonce(Math.floor(Math.random() * 100001));
        }
    }

    /**
     * @param {string} id Element ID to retrieve
     * @returns {Element} SVG element within the root SVGSVGElement
     */
    getElem_(id) {
        if (this.svgElem_.querySelector) {
            // querySelector lookup
            return this.svgElem_.querySelector("#" + id);
        }
        // jQuery lookup: twice as slow as xpath in FF
        return this.svgElem_.querySelector("[id=" + id + "]");
    }

    /**
     * @returns {SVGSVGElement}
     */
    getSvgElem() {
        return this.svgElem_;
    }

    /**
     * @returns {!(string|Integer)} The previously set nonce
     */
    getNonce() {
        return this.nonce_;
    }

    /**
     * @param {!(string|Integer)} n The nonce to set
     * @returns {void}
     */
    setNonce(n) {
        this.svgElem_.setAttributeNS(NS.XMLNS, "xmlns:se", NS.SE);
        this.svgElem_.setAttributeNS(NS.SE, "se:nonce", n);
        this.nonce_ = n;
    }

    /**
     * Clears any previously set nonce.
     * @returns {void}
     */
    clearNonce() {
        // We deliberately leave any se:nonce attributes alone,
        // we just don't use it to randomize ids.
        this.nonce_ = "";
    }

    /**
     * Returns the latest object id as a string.
     * @returns {string} The latest object Id.
     */
    getId() {
        return this.nonce_
            ? this.idPrefix + this.nonce_ + "_" + this.obj_num
            : this.idPrefix + this.obj_num;
    }

    /**
     * Returns the next object Id as a string.
     * @returns {string} The next object Id to use.
     */
    getNextId() {
        const oldObjNum = this.obj_num;
        let restoreOldObjNum = false;

        // If there are any released numbers in the release stack,
        // use the last one instead of the next obj_num.
        // We need to temporarily use obj_num as that is what getId() depends on.
        if (this.releasedNums.length > 0) {
            this.obj_num = this.releasedNums.pop();
            restoreOldObjNum = true;
        } else {
            // If we are not using a released id, then increment the obj_num.
            // this.obj_num++
            this.obj_num = nanoid();
        }

        // Ensure the ID does not exist.
        let id = this.getId();
        while (this.getElem_(id)) {
            if (restoreOldObjNum) {
                this.obj_num = oldObjNum;
                restoreOldObjNum = false;
            }
            // this.obj_num++
            this.obj_num = nanoid();
            id = this.getId();
        }
        // Restore the old object number if required.
        if (restoreOldObjNum) {
            this.obj_num = oldObjNum;
        }

        if (!id || id === "svg_NaN") {
            id = this.getNextId();
        }
        return id;
    }

    /**
     * Releases the object Id, letting it be used as the next id in getNextId().
     * This method DOES NOT remove any elements from the DOM, it is expected
     * that client code will do this.
     * @param {string} id - The id to release.
     * @returns {boolean} True if the id was valid to be released, false otherwise.
     */
    releaseId(id) {
        // confirm if this is a valid id for this Document, else return false
        const front = this.idPrefix + (this.nonce_ ? this.nonce_ + "_" : "");
        if (typeof id !== "string" || !id.startsWith(front)) {
            return false;
        }
        // extract the obj_num of this id
        const num = Number.parseInt(id.substr(front.length));

        // if we didn't get a positive number or we already released this number
        // then return false.
        if (
            typeof num !== "number" ||
            num <= 0 ||
            this.releasedNums.includes(num)
        ) {
            return false;
        }

        // push the released number into the released queue
        this.releasedNums.push(num);
        return true;
    }

    /**
     * Returns the number of layers in the current drawing.
     * @returns {Integer} The number of layers in the current drawing.
     */
    getNumLayers() {
        return this.all_layers.length;
    }

    /**
     * Check if layer with given name already exists.
     * @param {string} name - The layer name to check
     * @returns {boolean}
     */
    hasLayer(name) {
        return this.layer_map[name] !== undefined;
    }

    /**
     * Returns the name of the ith layer. If the index is out of range, an empty string is returned.
     * @param {Integer} i - The zero-based index of the layer you are querying.
     * @returns {string} The name of the ith layer (or the empty string if none found)
     */
    getLayerName(i) {
        return i >= 0 && i < this.getNumLayers()
            ? this.all_layers[i].getName()
            : "";
    }

    /**
     * @returns {SVGGElement|null} The SVGGElement representing the current layer.
     */
    getCurrentLayer() {
        return this.current_layer ? this.current_layer.getGroup() : null;
    }

    /**
     * Get a layer by name.
     * @param {string} name
     * @returns {SVGGElement} The SVGGElement representing the named layer or null.
     */
    getLayerByName(name) {
        const layer = this.layer_map[name];
        return layer ? layer.getGroup() : null;
    }

    /**
     * Returns the name of the currently selected layer. If an error occurs, an empty string
     * is returned.
     * @returns {string} The name of the currently active layer (or the empty string if none found).
     */
    getCurrentLayerName() {
        return this.current_layer ? this.current_layer.getName() : "";
    }

    /**
     * Set the current layer's name.
     * @param {string} name - The new name.
     * @param {module:history.HistoryRecordingService} hrService - History recording service
     * @returns {string|null} The new name if changed; otherwise, null.
     */
    setCurrentLayerName(name, hrService) {
        let finalName = null;
        if (this.current_layer) {
            const oldName = this.current_layer.getName();
            finalName = this.current_layer.setName(name, hrService);
            if (finalName) {
                delete this.layer_map[oldName];
                this.layer_map[finalName] = this.current_layer;
            }
        }
        return finalName;
    }

    /**
     * Set the current layer's position.
     * @param {Integer} newpos - The zero-based index of the new position of the layer. Range should be 0 to layers-1
     * @returns {{title: SVGGElement, previousName: string}|null} If the name was changed, returns {title:SVGGElement, previousName:string}; otherwise null.
     */
    setCurrentLayerPosition(newpos) {
        const layerCount = this.getNumLayers();
        if (!this.current_layer || newpos < 0 || newpos >= layerCount) {
            return null;
        }
        const oldpos = this.indexCurrentLayer();
        if (oldpos === -1 || oldpos === newpos) {
            return null;
        }

        // if our new position is below us, we need to insert before the node after newpos
        const currentGroup = this.current_layer.getGroup();
        const oldNextSibling = currentGroup.nextSibling;
        let refGroup = null;
        if (newpos > oldpos) {
            if (newpos < layerCount - 1) {
                refGroup = this.all_layers[newpos + 1].getGroup();
            }
            // if our new position is above us, we need to insert before the node at newpos
        } else {
            refGroup = this.all_layers[newpos].getGroup();
        }
        this.svgElem_.insertBefore(currentGroup, refGroup); // Ok to replace with `refGroup.before(currentGroup);`?

        this.identifyLayers();
        this.setCurrentLayer(this.getLayerName(newpos));
        return {
            currentGroup,
            oldNextSibling,
        };
    }

    /**
     * @param {module:history.HistoryRecordingService} hrService
     * @returns {void}
     */
    mergeLayer(hrService) {
        const currentGroup = this.current_layer.getGroup();
        const prevGroup = currentGroup.previousElementSibling;
        if (!prevGroup) {
            return;
        }
        hrService.startBatchCommand("Merge Layer");
        const layerNextSibling = currentGroup.nextSibling;
        hrService.removeElement(currentGroup, layerNextSibling, this.svgElem_);
        while (currentGroup.firstChild) {
            const child = currentGroup.firstChild;
            if (child.localName === "title") {
                hrService.removeElement(child, child.nextSibling, currentGroup);
                child.remove();
                continue;
            }
            const oldNextSibling = child.nextSibling;
            prevGroup.append(child);
            hrService.moveElement(child, oldNextSibling, currentGroup);
        }

        // Remove current layer's group
        this.current_layer.removeGroup();
        // Remove the current layer and set the previous layer as the new current layer
        const index = this.indexCurrentLayer();
        if (index > 0) {
            const name = this.current_layer.getName();
            this.current_layer = this.all_layers[index - 1];
            this.all_layers.splice(index, 1);
            delete this.layer_map[name];
        }
        hrService.endBatchCommand();
    }

    /**
     * @param {module:history.HistoryRecordingService} hrService
     * @returns {void}
     */
    mergeAllLayers(hrService) {
        // Set the current layer to the last layer.
        this.current_layer = this.all_layers[this.all_layers.length - 1];
        hrService.startBatchCommand("Merge all Layers");
        while (this.all_layers.length > 1) {
            this.mergeLayer(hrService);
        }
        hrService.endBatchCommand();
    }

    /**
     * Sets the current layer. If the name is not a valid layer name, then this
     * function returns `false`. Otherwise it returns `true`. This is not an
     * undo-able action.
     * @param {string} name - The name of the layer you want to switch to.
     * @returns {boolean} `true` if the current layer was switched, otherwise `false`
     */
    setCurrentLayer(name) {
        const layer = this.layer_map[name];
        if (layer) {
            if (this.current_layer) {
                this.current_layer.deactivate();
            }
            this.current_layer = layer;
            this.current_layer.activate();
            return true;
        }
        return false;
    }

    /**
     * Sets the current layer. If the name is not a valid layer name, then this
     * function returns `false`. Otherwise it returns `true`. This is not an
     * undo-able action.
     * @param {string} name - The name of the layer you want to switch to.
     * @returns {boolean} `true` if the current layer was switched, otherwise `false`
     */
    indexCurrentLayer() {
        return this.all_layers.indexOf(this.current_layer);
    }

    /**
     * Deletes the current layer from the drawing and then clears the selection.
     * This function then calls the 'changed' handler.  This is an undoable action.
     * @todo Does this actually call the 'changed' handler?
     * @returns {SVGGElement} The SVGGElement of the layer removed or null.
     */
    deleteCurrentLayer() {
        if (this.current_layer && this.getNumLayers() > 1) {
            const oldLayerGroup = this.current_layer.removeGroup();
            this.identifyLayers();
            return oldLayerGroup;
        }
        return null;
    }

    /**
     * Updates layer system and sets the current layer to the
     * top-most layer (last `<g>` child of this drawing).
     * @returns {void}
     */
    identifyLayers() {
        this.all_layers = [];
        this.layer_map = {};
        const numchildren = this.svgElem_.childNodes.length;
        // loop through all children of SVG element
        const orphans = [];
        const layernames = [];
        let layer = null;
        let childgroups = false;
        for (let i = 0; i < numchildren; ++i) {
            const child = this.svgElem_.childNodes.item(i);
            // for each g, find its layer name
            if (child?.nodeType === 1) {
                if (child.tagName === "g") {
                    childgroups = true;
                    const name = findLayerNameInGroup(child);
                    if (name) {
                        layernames.push(name);
                        layer = new Layer(name, child);
                        this.all_layers.push(layer);
                        this.layer_map[name] = layer;
                    } else {
                        // if group did not have a name, it is an orphan
                        orphans.push(child);
                    }
                } else if (visElems$1.includes(child.nodeName)) {
                    // Child is "visible" (i.e. not a <title> or <defs> element), so it is an orphan
                    orphans.push(child);
                }
            }
        }

        // If orphans or no layers found, create a new layer and add all the orphans to it
        if (orphans.length > 0 || !childgroups) {
            layer = new Layer(getNewLayerName(layernames), null, this.svgElem_);
            layer.appendChildren(orphans);
            this.all_layers.push(layer);
            this.layer_map[name] = layer;
        } else {
            layer.activate();
        }
        this.current_layer = layer;
    }

    /**
     * Creates a new top-level layer in the drawing with the given name and
     * makes it the current layer.
     * @param {string} name - The given name. If the layer name exists, a new name will be generated.
     * @param {module:history.HistoryRecordingService} hrService - History recording service
     * @returns {SVGGElement} The SVGGElement of the new layer, which is
     *     also the current layer of this drawing.
     */
    createLayer(name, hrService) {
        if (this.current_layer) {
            this.current_layer.deactivate();
        }
        // Check for duplicate name.
        if (
            name === undefined ||
            name === null ||
            name === "" ||
            this.layer_map[name]
        ) {
            name = getNewLayerName(Object.keys(this.layer_map));
        }

        // Crate new layer and add to DOM as last layer
        const layer = new Layer(name, null, this.svgElem_);
        // Like to assume hrService exists, but this is backwards compatible with old version of createLayer.
        if (hrService) {
            hrService.startBatchCommand("Create Layer");
            hrService.insertElement(layer.getGroup());
            hrService.endBatchCommand();
        }
        this.all_layers.push(layer);
        this.layer_map[name] = layer;
        this.current_layer = layer;
        return layer.getGroup();
    }

    /**
     * Creates a copy of the current layer with the given name and makes it the current layer.
     * @param {string} name - The given name. If the layer name exists, a new name will be generated.
     * @param {module:history.HistoryRecordingService} hrService - History recording service
     * @returns {SVGGElement} The SVGGElement of the new layer, which is
     *     also the current layer of this drawing.
     */
    cloneLayer(name, hrService) {
        if (!this.current_layer) {
            return null;
        }
        this.current_layer.deactivate();
        // Check for duplicate name.
        if (
            name === undefined ||
            name === null ||
            name === "" ||
            this.layer_map[name]
        ) {
            name = getNewLayerName(Object.keys(this.layer_map));
        }

        // Create new group and add to DOM just after current_layer
        const currentGroup = this.current_layer.getGroup();
        const layer = new Layer(name, currentGroup, this.svgElem_);
        const group = layer.getGroup();

        // Clone children
        const children = [...currentGroup.childNodes];
        children.forEach((child) => {
            if (child.localName === "title") {
                return;
            }
            group.append(this.copyElem(child));
        });
        if (hrService) {
            hrService.startBatchCommand("Duplicate Layer");
            hrService.insertElement(group);
            hrService.endBatchCommand();
        }

        // Update layer containers and current_layer.
        const index = this.indexCurrentLayer();
        if (index >= 0) {
            this.all_layers.splice(index + 1, 0, layer);
        } else {
            this.all_layers.push(layer);
        }
        this.layer_map[name] = layer;
        this.current_layer = layer;
        return group;
    }

    /**
     * Returns whether the layer is visible.  If the layer name is not valid,
     * then this function returns `false`.
     * @param {string} layerName - The name of the layer which you want to query.
     * @returns {boolean} The visibility state of the layer, or `false` if the layer name was invalid.
     */
    getLayerVisibility(layerName) {
        const layer = this.layer_map[layerName];
        return layer ? layer.isVisible() : false;
    }

    /**
     * Sets the visibility of the layer. If the layer name is not valid, this
     * function returns `null`, otherwise it returns the `SVGElement` representing
     * the layer. This is an undo-able action.
     * @param {string} layerName - The name of the layer to change the visibility
     * @param {boolean} bVisible - Whether the layer should be visible
     * @returns {?SVGGElement} The SVGGElement representing the layer if the
     *   `layerName` was valid, otherwise `null`.
     */
    setLayerVisibility(layerName, bVisible) {
        if (typeof bVisible !== "boolean") {
            return null;
        }
        const layer = this.layer_map[layerName];
        if (!layer) {
            return null;
        }
        layer.setVisible(bVisible);
        return layer.getGroup();
    }

    /**
     * Returns the opacity of the given layer.  If the input name is not a layer, `null` is returned.
     * @param {string} layerName - name of the layer on which to get the opacity
     * @returns {?Float} The opacity value of the given layer.  This will be a value between 0.0 and 1.0, or `null`
     * if `layerName` is not a valid layer
     */
    getLayerOpacity(layerName) {
        const layer = this.layer_map[layerName];
        if (!layer) {
            return null;
        }
        return layer.getOpacity();
    }

    /**
     * Sets the opacity of the given layer.  If the input name is not a layer,
     * nothing happens. If opacity is not a value between 0.0 and 1.0, then
     * nothing happens.
     * NOTE: this function exists solely to apply a highlighting/de-emphasis
     * effect to a layer. When it is possible for a user to affect the opacity
     * of a layer, we will need to allow this function to produce an undo-able
     * action.
     * @param {string} layerName - Name of the layer on which to set the opacity
     * @param {Float} opacity - A float value in the range 0.0-1.0
     * @returns {void}
     */
    setLayerOpacity(layerName, opacity) {
        if (typeof opacity !== "number" || opacity < 0.0 || opacity > 1.0) {
            return;
        }
        const layer = this.layer_map[layerName];
        if (layer) {
            layer.setOpacity(opacity);
        }
    }

    /**
     * Create a clone of an element, updating its ID and its children's IDs when needed.
     * @param {Element} el - DOM element to clone
     * @returns {Element}
     */
    copyElem(el) {
        const that = this;
        const getNextIdClosure = function () {
            return that.getNextId();
        };
        return copyElem(el, getNextIdClosure);
    }
}

/**
 * Called to ensure that drawings will or will not have randomized ids.
 * The currentDrawing will have its nonce set if it doesn't already.
 * @function module:draw.randomizeIds
 * @param {boolean} enableRandomization - flag indicating if documents should have randomized ids
 * @param {draw.Drawing} currentDrawing
 * @returns {void}
 */
const randomizeIds = function (enableRandomization, currentDrawing) {
    randIds =
        enableRandomization === false
            ? RandomizeModes.NEVER_RANDOMIZE
            : RandomizeModes.ALWAYS_RANDOMIZE;
    if (
        randIds === RandomizeModes.ALWAYS_RANDOMIZE &&
        !currentDrawing.getNonce()
    ) {
        currentDrawing.setNonce(Math.floor(Math.random() * 100001));
    } else if (
        randIds === RandomizeModes.NEVER_RANDOMIZE &&
        currentDrawing.getNonce()
    ) {
        currentDrawing.clearNonce();
    }
};

// Layer API Functions

/**
 * Group: Layers.
 */

/**
 * @see {@link https://api.jquery.com/jQuery.data/}
 * @name external:jQuery.data
 */

/**
 * @interface module:draw.DrawCanvasInit
 * @property {module:path.pathActions} pathActions
 * @property {module:history.UndoManager} undoMgr
 */
/**
 * @function module:draw.DrawCanvasInit#getCurrentGroup
 * @returns {Element}
 */
/**
 * @function module:draw.DrawCanvasInit#setCurrentGroup
 * @param {Element} cg
 * @returns {void}
 */
/**
 * @function module:draw.DrawCanvasInit#getSelectedElements
 * @returns {Element[]} the array with selected DOM elements
 */
/**
 * @function module:draw.DrawCanvasInit#getSvgContent
 * @returns {SVGSVGElement}
 */
/**
 * @function module:draw.DrawCanvasInit#getCurrentDrawing
 * @returns {module:draw.Drawing}
 */
/**
 * @function module:draw.DrawCanvasInit#clearSelection
 * @param {boolean} [noCall] - When `true`, does not call the "selected" handler
 * @returns {void}
 */
/**
 * Run the callback function associated with the given event.
 * @function module:draw.DrawCanvasInit#call
 * @param {"changed"|"contextset"} ev - String with the event name
 * @param {module:svgcanvas.SvgCanvas#event:changed|module:svgcanvas.SvgCanvas#event:contextset} arg - Argument to pass through to the callback
 * function. If the event is "changed", a (single-item) array of `Element`s is
 * passed. If the event is "contextset", the arg is `null` or `Element`.
 * @returns {void}
 */
/**
 * @function module:draw.DrawCanvasInit#addCommandToHistory
 * @param {Command} cmd
 * @returns {void}
 */
/**
 * @function module:draw.DrawCanvasInit#changeSvgContent
 * @returns {void}
 */

let svgCanvas$e;
/**
 * @function module:draw.init
 * @param {module:draw.DrawCanvasInit} canvas
 * @returns {void}
 */
const init$f = (canvas) => {
    svgCanvas$e = canvas;
};

/**
 * Updates layer system.
 * @function module:draw.identifyLayers
 * @returns {void}
 */
const identifyLayers = () => {
    leaveContext();
    svgCanvas$e.getCurrentDrawing().identifyLayers();
};

/**
 * get current index
 * @function module:draw.identifyLayers
 * @returns {void}
 */
const indexCurrentLayer = () => {
    return svgCanvas$e.getCurrentDrawing().indexCurrentLayer();
};

/**
 * Creates a new top-level layer in the drawing with the given name, sets the current layer
 * to it, and then clears the selection. This function then calls the 'changed' handler.
 * This is an undoable action.
 * @function module:draw.createLayer
 * @param {string} name - The given name
 * @param {module:history.HistoryRecordingService} hrService
 * @fires module:svgcanvas.SvgCanvas#event:changed
 * @returns {void}
 */
const createLayer = (name, hrService) => {
    const newLayer = svgCanvas$e
        .getCurrentDrawing()
        .createLayer(name, historyRecordingService(hrService));
    svgCanvas$e.clearSelection();
    svgCanvas$e.call("changed", [newLayer]);
};

/**
 * Creates a new top-level layer in the drawing with the given name, copies all the current layer's contents
 * to it, and then clears the selection. This function then calls the 'changed' handler.
 * This is an undoable action.
 * @function module:draw.cloneLayer
 * @param {string} name - The given name. If the layer name exists, a new name will be generated.
 * @param {module:history.HistoryRecordingService} hrService - History recording service
 * @fires module:svgcanvas.SvgCanvas#event:changed
 * @returns {void}
 */
const cloneLayer = (name, hrService) => {
    // Clone the current layer and make the cloned layer the new current layer
    const newLayer = svgCanvas$e
        .getCurrentDrawing()
        .cloneLayer(name, historyRecordingService(hrService));
    svgCanvas$e.clearSelection();
    leaveContext();
    svgCanvas$e.call("changed", [newLayer]);
};

/**
 * Deletes the current layer from the drawing and then clears the selection. This function
 * then calls the 'changed' handler. This is an undoable action.
 * @function module:draw.deleteCurrentLayer
 * @fires module:svgcanvas.SvgCanvas#event:changed
 * @returns {boolean} `true` if an old layer group was found to delete
 */
const deleteCurrentLayer = () => {
    const { BatchCommand, RemoveElementCommand } = svgCanvas$e.history;
    let currentLayer = svgCanvas$e.getCurrentDrawing().getCurrentLayer();
    const { nextSibling } = currentLayer;
    const parent = currentLayer.parentNode;
    currentLayer = svgCanvas$e.getCurrentDrawing().deleteCurrentLayer();
    if (currentLayer) {
        const batchCmd = new BatchCommand("Delete Layer");
        // store in our Undo History
        batchCmd.addSubCommand(
            new RemoveElementCommand(currentLayer, nextSibling, parent),
        );
        svgCanvas$e.addCommandToHistory(batchCmd);
        svgCanvas$e.clearSelection();
        svgCanvas$e.call("changed", [parent]);
        return true;
    }
    return false;
};

/**
 * Sets the current layer. If the name is not a valid layer name, then this function returns
 * false. Otherwise it returns true. This is not an undo-able action.
 * @function module:draw.setCurrentLayer
 * @param {string} name - The name of the layer you want to switch to.
 * @returns {boolean} true if the current layer was switched, otherwise false
 */
const setCurrentLayer = (name) => {
    const result = svgCanvas$e.getCurrentDrawing().setCurrentLayer(toXml(name));
    if (result) {
        svgCanvas$e.clearSelection();
    }
    return result;
};

/**
 * Renames the current layer. If the layer name is not valid (i.e. unique), then this function
 * does nothing and returns `false`, otherwise it returns `true`. This is an undo-able action.
 * @function module:draw.renameCurrentLayer
 * @param {string} newName - the new name you want to give the current layer. This name must
 * be unique among all layer names.
 * @fires module:svgcanvas.SvgCanvas#event:changed
 * @returns {boolean} Whether the rename succeeded
 */
const renameCurrentLayer = (newName) => {
    const drawing = svgCanvas$e.getCurrentDrawing();
    const layer = drawing.getCurrentLayer();
    if (layer) {
        const result = drawing.setCurrentLayerName(
            newName,
            historyRecordingService(),
        );
        if (result) {
            svgCanvas$e.call("changed", [layer]);
            return true;
        }
    }
    return false;
};

/**
 * Changes the position of the current layer to the new value. If the new index is not valid,
 * this function does nothing and returns false, otherwise it returns true. This is an
 * undo-able action.
 * @function module:draw.setCurrentLayerPosition
 * @param {Integer} newPos - The zero-based index of the new position of the layer. This should be between
 * 0 and (number of layers - 1)
 * @returns {boolean} `true` if the current layer position was changed, `false` otherwise.
 */
const setCurrentLayerPosition = (newPos) => {
    const { MoveElementCommand } = svgCanvas$e.history;
    const drawing = svgCanvas$e.getCurrentDrawing();
    const result = drawing.setCurrentLayerPosition(newPos);
    if (result) {
        svgCanvas$e.addCommandToHistory(
            new MoveElementCommand(
                result.currentGroup,
                result.oldNextSibling,
                svgCanvas$e.getSvgContent(),
            ),
        );
        return true;
    }
    return false;
};

/**
 * Sets the visibility of the layer. If the layer name is not valid, this function return
 * `false`, otherwise it returns `true`. This is an undo-able action.
 * @function module:draw.setLayerVisibility
 * @param {string} layerName - The name of the layer to change the visibility
 * @param {boolean} bVisible - Whether the layer should be visible
 * @returns {boolean} true if the layer's visibility was set, false otherwise
 */
const setLayerVisibility = (layerName, bVisible) => {
    const { ChangeElementCommand } = svgCanvas$e.history;
    const drawing = svgCanvas$e.getCurrentDrawing();
    const prevVisibility = drawing.getLayerVisibility(layerName);
    const layer = drawing.setLayerVisibility(layerName, bVisible);
    if (layer) {
        const oldDisplay = prevVisibility ? "inline" : "none";
        svgCanvas$e.addCommandToHistory(
            new ChangeElementCommand(
                layer,
                {
                    display: oldDisplay,
                },
                "Layer Visibility",
            ),
        );
    } else {
        return false;
    }
    if (layer === drawing.getCurrentLayer()) {
        svgCanvas$e.clearSelection();
        svgCanvas$e.pathActions.clear();
    }
    // call('changed', [selected]);
    return true;
};

/**
 * Moves the selected elements to layerName. If the name is not a valid layer name, then `false`
 * is returned. Otherwise it returns `true`. This is an undo-able action.
 * @function module:draw.moveSelectedToLayer
 * @param {string} layerName - The name of the layer you want to which you want to move the selected elements
 * @returns {boolean} Whether the selected elements were moved to the layer.
 */
const moveSelectedToLayer = (layerName) => {
    const { BatchCommand, MoveElementCommand } = svgCanvas$e.history;
    // find the layer
    const drawing = svgCanvas$e.getCurrentDrawing();
    const layer = drawing.getLayerByName(layerName);
    if (!layer) {
        return false;
    }
    const batchCmd = new BatchCommand("Move Elements to Layer");

    // loop for each selected element and move it
    const selElems = svgCanvas$e.getSelectedElements();
    let i = selElems.length;
    while (i--) {
        const elem = selElems[i];
        if (!elem) {
            continue;
        }
        const oldNextSibling = elem.nextSibling;
        // TODO: this is pretty brittle!
        const oldLayer = elem.parentNode;
        layer.append(elem);
        batchCmd.addSubCommand(
            new MoveElementCommand(elem, oldNextSibling, oldLayer),
        );
    }
    svgCanvas$e.addCommandToHistory(batchCmd);
    return true;
};

/**
 * @function module:draw.mergeLayer
 * @param {module:history.HistoryRecordingService} hrService
 * @returns {void}
 */
const mergeLayer = (hrService) => {
    svgCanvas$e
        .getCurrentDrawing()
        .mergeLayer(historyRecordingService(hrService));
    svgCanvas$e.clearSelection();
    leaveContext();
    svgCanvas$e.changeSvgContent();
};

/**
 * @function module:draw.mergeAllLayers
 * @param {module:history.HistoryRecordingService} hrService
 * @returns {void}
 */
const mergeAllLayers = (hrService) => {
    svgCanvas$e
        .getCurrentDrawing()
        .mergeAllLayers(historyRecordingService(hrService));
    svgCanvas$e.clearSelection();
    leaveContext();
    svgCanvas$e.changeSvgContent();
};

/**
 * Return from a group context to the regular kind, make any previously
 * disabled elements enabled again.
 * @function module:draw.leaveContext
 * @fires module:svgcanvas.SvgCanvas#event:contextset
 * @returns {void}
 */
const leaveContext = () => {
    const len = disabledElems.length;
    const dataStorage = svgCanvas$e.getDataStorage();
    if (len) {
        for (let i = 0; i < len; i++) {
            const elem = disabledElems[i];
            const orig = dataStorage.get(elem, "orig_opac");
            if (orig !== 1) {
                elem.setAttribute("opacity", orig);
            } else {
                elem.removeAttribute("opacity");
            }
            elem.setAttribute("style", "pointer-events: inherit");
        }
        disabledElems = [];
        svgCanvas$e.clearSelection(true);
        svgCanvas$e.call("contextset", null);
    }
    svgCanvas$e.setCurrentGroup(null);
};

/**
 * Set the current context (for in-group editing).
 * @function module:draw.setContext
 * @param {Element} elem
 * @fires module:svgcanvas.SvgCanvas#event:contextset
 * @returns {void}
 */
const setContext = (elem) => {
    const dataStorage = svgCanvas$e.getDataStorage();
    leaveContext();
    if (typeof elem === "string") {
        elem = getElement(elem);
    }

    // Edit inside this group
    svgCanvas$e.setCurrentGroup(elem);

    // Disable other elements
    const parentsUntil = getParentsUntil(elem, "#svgcontent");
    const siblings = [];
    parentsUntil.forEach(function (parent) {
        const elements = Array.prototype.filter.call(
            parent.parentNode.children,
            function (child) {
                return child !== parent;
            },
        );
        elements.forEach(function (element) {
            siblings.push(element);
        });
    });
    siblings.forEach(function (curthis) {
        const opac = curthis.getAttribute("opacity") || 1;
        // Store the original's opacity
        dataStorage.put(curthis, "orig_opac", opac);
        // curthis.setAttribute('opacity', opac * 0.33);
        // curthis.setAttribute('style', 'pointer-events: none');
        disabledElems.push(curthis);
    });
    svgCanvas$e.clearSelection();
    svgCanvas$e.call("contextset", svgCanvas$e.getCurrentGroup());
};

const {
    InsertElementCommand: InsertElementCommand$3,
    BatchCommand: BatchCommand$3,
} = history;
let svgCanvas$d = null;

/**
 * @function module:paste-elem.init
 * @param {module:paste-elem.pasteContext} pasteContext
 * @returns {void}
 */
const init$e = (canvas) => {
    svgCanvas$d = canvas;
};

/**
 * @function module:svgcanvas.SvgCanvas#pasteElements
 * @param {"in_place"|"point"|void} type
 * @param {Integer|void} x Expected if type is "point"
 * @param {Integer|void} y Expected if type is "point"
 * @fires module:svgcanvas.SvgCanvas#event:changed
 * @fires module:svgcanvas.SvgCanvas#event:ext_IDsUpdated
 * @returns {void}
 */
const pasteElementsMethod = function (type, x, y) {
    let clipb = JSON.parse(
        sessionStorage.getItem(svgCanvas$d.getClipboardID()),
    );
    if (!clipb) return;
    let len = clipb.length;
    if (!len) return;
    const pasted = [];
    const batchCmd = new BatchCommand$3("Paste elements");
    // const drawing = getCurrentDrawing();
    /**
     * @typedef {PlainObject<string, string>} module:svgcanvas.ChangedIDs
     */
    /**
     * @type {module:svgcanvas.ChangedIDs}
     */
    const changedIDs = {};

    // Recursively replace IDs and record the changes
    /**
     *
     * @param {module:svgcanvas.SVGAsJSON} elem
     * @returns {void}
     */
    function checkIDs(elem) {
        if (elem.attr?.id) {
            changedIDs[elem.attr.id] = svgCanvas$d.getNextId();
            elem.attr.id = changedIDs[elem.attr.id];
        }
        if (elem.children) elem.children.forEach((child) => checkIDs(child));
    }
    clipb.forEach((elem) => checkIDs(elem));

    // Give extensions like the connector extension a chance to reflect new IDs and remove invalid elements
    /**
     * Triggered when `pasteElements` is called from a paste action (context menu or key).
     * @event module:svgcanvas.SvgCanvas#event:ext_IDsUpdated
     * @type {PlainObject}
     * @property {module:svgcanvas.SVGAsJSON[]} elems
     * @property {module:svgcanvas.ChangedIDs} changes Maps past ID (on attribute) to current ID
     */
    svgCanvas$d
        .runExtensions(
            "IDsUpdated",
            /** @type {module:svgcanvas.SvgCanvas#event:ext_IDsUpdated} */
            {
                elems: clipb,
                changes: changedIDs,
            },
            true,
        )
        .forEach(function (extChanges) {
            if (!extChanges || !("remove" in extChanges)) return;
            extChanges.remove.forEach(function (removeID) {
                clipb = clipb.filter(function (clipBoardItem) {
                    return clipBoardItem.attr.id !== removeID;
                });
            });
        });

    // Move elements to lastClickPoint
    while (len--) {
        const elem = clipb[len];
        if (!elem) {
            continue;
        }
        const copy = svgCanvas$d.addSVGElementsFromJson(elem);
        pasted.push(copy);
        batchCmd.addSubCommand(new InsertElementCommand$3(copy));
        svgCanvas$d.restoreRefElements(copy);
    }
    svgCanvas$d.selectOnly(pasted);
    if (type !== "in_place") {
        let ctrX;
        let ctrY;
        if (!type) {
            ctrX = svgCanvas$d.getLastClickPoint("x");
            ctrY = svgCanvas$d.getLastClickPoint("y");
        } else if (type === "point") {
            ctrX = x;
            ctrY = y;
        }
        const bbox = getStrokedBBoxDefaultVisible(pasted);
        const cx = ctrX - (bbox.x + bbox.width / 2);
        const cy = ctrY - (bbox.y + bbox.height / 2);
        const dx = [];
        const dy = [];
        pasted.forEach(function (_item) {
            dx.push(cx);
            dy.push(cy);
        });
        const cmd = svgCanvas$d.moveSelectedElements(dx, dy, false);
        if (cmd) batchCmd.addSubCommand(cmd);
    }
    svgCanvas$d.addCommandToHistory(batchCmd);
    svgCanvas$d.call("changed", pasted);
};

// http://ross.posterous.com/2008/08/19/iphone-touch-events-in-javascript/
/**
 *
 * @param {Event} ev
 * @returns {void}
 */
const touchHandler = (ev) => {
    ev.preventDefault();
    const { changedTouches } = ev;
    const first = changedTouches[0];
    let type = "";
    switch (ev.type) {
        case "touchstart":
            type = "mousedown";
            break;
        case "touchmove":
            type = "mousemove";
            break;
        case "touchend":
            type = "mouseup";
            break;
        default:
            return;
    }
    const { screenX, screenY, clientX, clientY } = first;
    const simulatedEvent = new MouseEvent(type, {
        // Event interface
        bubbles: true,
        cancelable: true,
        // UIEvent interface
        view: window,
        detail: 1,
        // click count
        // MouseEvent interface (customized)
        screenX,
        screenY,
        clientX,
        clientY,
        // MouseEvent interface (defaults) - these could be removed
        ctrlKey: false,
        altKey: false,
        shiftKey: false,
        metaKey: false,
        button: 0,
        // main button (usually left)
        relatedTarget: null,
    });
    if (changedTouches.length < 2) {
        first.target.dispatchEvent(simulatedEvent);
    }
};
const init$d = (svgCanvas) => {
    svgCanvas.svgroot.addEventListener("touchstart", touchHandler);
    svgCanvas.svgroot.addEventListener("touchmove", touchHandler);
    svgCanvas.svgroot.addEventListener("touchend", touchHandler);
    svgCanvas.svgroot.addEventListener("touchcancel", touchHandler);
};

/**
 * Tools for SVG Root Element.
 * @module svgcanvas
 * @license MIT
 *
 * @copyright 2010 Alexis Deveria, 2010 Jeff Schiller
 */

/**
 * @function module:svgcanvas.svgRootElement svgRootElement the svg node and its children.
 * @param {Element} svgdoc - window.document
 * @param {ArgumentsArray} dimensions - dimensions of width and height
 * @returns {svgRootElement}
 */
const svgRootElement = function (svgdoc, dimensions) {
    return svgdoc.importNode(
        text2xml(`<svg id="svgroot" xmlns="${NS.SVG}" xlinkns="${NS.XLINK}" width="${dimensions[0]}" 
        height="${dimensions[1]}" x="${dimensions[0]}" y="${dimensions[1]}" overflow="visible">
        <defs>
          <filter id="canvashadow" filterUnits="objectBoundingBox">
            <feGaussianBlur in="SourceAlpha" stdDeviation="4" result="blur"/>
            <feOffset in="blur" dx="5" dy="5" result="offsetBlur"/>
            <feMerge>
              <feMergeNode in="offsetBlur"/>
              <feMergeNode in="SourceGraphic"/>
            </feMerge>
          </filter>
        </defs>
      </svg>`).documentElement,
        true,
    );
};

/**
 * Browser detection.
 * @module browser
 * @license MIT
 *
 * @copyright 2010 Jeff Schiller, 2010 Alexis Deveria
 */

const NSSVG = "http://www.w3.org/2000/svg";
const { userAgent } = navigator;

// Note: Browser sniffing should only be used if no other detection method is possible
const isWebkit_ = userAgent.includes("AppleWebKit");
const isGecko_ = userAgent.includes("Gecko/");
const isChrome_ = userAgent.includes("Chrome/");
userAgent.includes("Macintosh");

// text character positioning (for IE9 and now Chrome)
const supportsGoodTextCharPos_ = (function () {
    const svgroot = document.createElementNS(NSSVG, "svg");
    const svgContent = document.createElementNS(NSSVG, "svg");
    document.documentElement.append(svgroot);
    svgContent.setAttribute("x", 5);
    svgroot.append(svgContent);
    const text = document.createElementNS(NSSVG, "text");
    text.textContent = "a";
    svgContent.append(text);
    try {
        // Chrome now fails here
        const pos = text.getStartPositionOfChar(0).x;
        return pos === 0;
    } catch (err) {
        return false;
    } finally {
        svgroot.remove();
    }
})();

// Public API

/**
 * @function module:browser.isWebkit
 * @returns {boolean}
 */
const isWebkit = () => isWebkit_;
/**
 * @function module:browser.isGecko
 * @returns {boolean}
 */
const isGecko = () => isGecko_;
/**
 * @function module:browser.isChrome
 * @returns {boolean}
 */
const isChrome = () => isChrome_;

/**
 * @function module:browser.supportsGoodTextCharPos
 * @returns {boolean}
 */
const supportsGoodTextCharPos = () => supportsGoodTextCharPos_;

/**
 * Tools for undo.
 * @module undo
 * @license MIT
 * @copyright 2011 Jeff Schiller
 */
const { UndoManager, HistoryEventTypes } = history;
let svgCanvas$c = null;

/**
 * @function module:undo.init
 * @param {module:undo.undoContext} undoContext
 * @returns {void}
 */
const init$c = (canvas) => {
    svgCanvas$c = canvas;
    canvas.undoMgr = getUndoManager();
};
const getUndoManager = () => {
    return new UndoManager({
        /**
         * @param {string} eventType One of the HistoryEvent types
         * @param {module:history.HistoryCommand} cmd Fulfills the HistoryCommand interface
         * @fires module:undo.SvgCanvas#event:changed
         * @returns {void}
         */
        handleHistoryEvent(eventType, cmd) {
            const EventTypes = HistoryEventTypes;
            // TODO: handle setBlurOffsets.
            if (
                eventType === EventTypes.BEFORE_UNAPPLY ||
                eventType === EventTypes.BEFORE_APPLY
            ) {
                svgCanvas$c.clearSelection();
            } else if (
                eventType === EventTypes.AFTER_APPLY ||
                eventType === EventTypes.AFTER_UNAPPLY
            ) {
                const elems = cmd.elements();
                svgCanvas$c.pathActions.clear();
                svgCanvas$c.call("changed", elems);
                const cmdType = cmd.type();
                const isApply = eventType === EventTypes.AFTER_APPLY;
                if (cmdType === "MoveElementCommand") {
                    const parent = isApply ? cmd.newParent : cmd.oldParent;
                    if (parent === svgCanvas$c.getSvgContent()) {
                        identifyLayers();
                    }
                } else if (
                    cmdType === "InsertElementCommand" ||
                    cmdType === "RemoveElementCommand"
                ) {
                    if (cmd.parent === svgCanvas$c.getSvgContent()) {
                        identifyLayers();
                    }
                    if (cmdType === "InsertElementCommand") {
                        if (isApply) {
                            svgCanvas$c.restoreRefElements(cmd.elem);
                        }
                    } else if (!isApply) {
                        svgCanvas$c.restoreRefElements(cmd.elem);
                    }
                    if (cmd.elem?.tagName === "use") {
                        svgCanvas$c.setUseData(cmd.elem);
                    }
                } else if (cmdType === "ChangeElementCommand") {
                    // if we are changing layer names, re-identify all layers
                    if (
                        cmd.elem.tagName === "title" &&
                        cmd.elem.parentNode.parentNode ===
                            svgCanvas$c.getSvgContent()
                    ) {
                        identifyLayers();
                    }
                    const values = isApply ? cmd.newValues : cmd.oldValues;
                    // If stdDeviation was changed, update the blur.
                    if (values.stdDeviation) {
                        svgCanvas$c.setBlurOffsets(
                            cmd.elem.parentNode,
                            values.stdDeviation,
                        );
                    }
                    if (cmd.elem.tagName === "text") {
                        const [dx, dy] = [
                            cmd.newValues.x - cmd.oldValues.x,
                            cmd.newValues.y - cmd.oldValues.y,
                        ];
                        const tspans = cmd.elem.children;
                        for (let i = 0; i < tspans.length; i++) {
                            let x = Number(tspans[i].getAttribute("x"));
                            let y = Number(tspans[i].getAttribute("y"));
                            const unapply =
                                eventType === EventTypes.AFTER_UNAPPLY;
                            x = unapply ? x - dx : x + dx;
                            y = unapply ? y - dy : y + dy;
                            tspans[i].setAttribute("x", x);
                            tspans[i].setAttribute("y", y);
                        }
                    }
                }
            }
        },
    });
};

/**
 * Hack for Firefox bugs where text element features aren't updated or get
 * messed up. See issue 136 and issue 137.
 * This function clones the element and re-selects it.
 * @function module:svgcanvas~ffClone
 * @todo Test for this bug on load and add it to "support" object instead of
 * browser sniffing
 * @param {Element} elem - The (text) DOM element to clone
 * @returns {Element} Cloned element
 */
const ffClone = function (elem) {
    if (!isGecko()) {
        return elem;
    }
    const clone = elem.cloneNode(true);
    elem.before(clone);
    elem.remove();
    svgCanvas$c.selectorManager.releaseSelector(elem);
    svgCanvas$c.setSelectedElements(0, clone);
    svgCanvas$c.selectorManager.requestSelector(clone).showGrips(true);
    return clone;
};

/**
 * This function makes the changes to the elements. It does not add the change
 * to the history stack.
 * @param {string} attr - Attribute name
 * @param {string|Float} newValue - String or number with the new attribute value
 * @param {Element[]} elems - The DOM elements to apply the change to
 * @returns {void}
 */
const changeSelectedAttributeNoUndoMethod = (attr, newValue, elems) => {
    if (attr === "id") {
        // if the user is changing the id, then de-select the element first
        // change the ID, then re-select it with the new ID
        // as this change can impact other extensions, a 'renamedElement' event is thrown
        const elem = elems[0];
        const oldId = elem.id;
        if (oldId !== newValue) {
            svgCanvas$c.clearSelection();
            elem.id = newValue;
            svgCanvas$c.addToSelection([elem], true);
            svgCanvas$c.call("elementRenamed", {
                elem,
                oldId,
                newId: newValue,
            });
        }
        return;
    }
    const selectedElements = svgCanvas$c.getSelectedElements();
    const zoom = svgCanvas$c.getZoom();
    if (svgCanvas$c.getCurrentMode() === "pathedit") {
        // Editing node
        svgCanvas$c.pathActions.moveNode(attr, newValue);
    }
    elems = elems ?? selectedElements;
    let i = elems.length;
    const noXYElems = ["g", "polyline", "path"];
    while (i--) {
        let elem = elems[i];
        if (!elem) {
            continue;
        }

        // Set x,y vals on elements that don't have them
        if (
            (attr === "x" || attr === "y") &&
            noXYElems.includes(elem.tagName)
        ) {
            const bbox = getStrokedBBoxDefaultVisible([elem]);
            const diffX = attr === "x" ? newValue - bbox.x : 0;
            const diffY = attr === "y" ? newValue - bbox.y : 0;
            svgCanvas$c.moveSelectedElements(diffX * zoom, diffY * zoom, true);
            continue;
        }
        let oldval =
            attr === "#text" ? elem.textContent : elem.getAttribute(attr);
        if (!oldval) {
            oldval = "";
        }
        if (oldval !== String(newValue)) {
            if (attr === "#text") {
                // const oldW = utilsGetBBox(elem).width;
                elem.textContent = newValue;

                // FF bug occurs on on rotated elements
                if (/rotate/.test(elem.getAttribute("transform"))) {
                    elem = ffClone(elem);
                }
                // Hoped to solve the issue of moving text with text-anchor="start",
                // but this doesn't actually fix it. Hopefully on the right track, though. -Fyrd
            } else if (attr === "#href") {
                setHref(elem, newValue);
            } else if (newValue) {
                elem.setAttribute(attr, newValue);
            } else if (typeof newValue === "number") {
                elem.setAttribute(attr, newValue);
            } else {
                elem.removeAttribute(attr);
            }

            // Go into "select" mode for text changes
            // NOTE: Important that this happens AFTER elem.setAttribute() or else attributes like
            // font-size can get reset to their old value, ultimately by svgEditor.updateContextPanel(),
            // after calling textActions.toSelectMode() below
            if (
                svgCanvas$c.getCurrentMode() === "textedit" &&
                attr !== "#text" &&
                elem.textContent.length
            ) {
                svgCanvas$c.textActions.toSelectMode(elem);
            }

            // Use the Firefox ffClone hack for text elements with gradients or
            // where other text attributes are changed.
            if (
                isGecko() &&
                elem.nodeName === "text" &&
                /rotate/.test(elem.getAttribute("transform")) &&
                (String(newValue).startsWith("url") ||
                    (["font-size", "font-family", "x", "y"].includes(attr) &&
                        elem.textContent))
            ) {
                elem = ffClone(elem);
            }
            // Timeout needed for Opera & Firefox
            // codedread: it is now possible for this function to be called with elements
            // that are not in the selectedElements array, we need to only request a
            // selector if the element is in that array
            if (selectedElements.includes(elem)) {
                setTimeout(function () {
                    // Due to element replacement, this element may no longer
                    // be part of the DOM
                    if (!elem.parentNode) {
                        return;
                    }
                    svgCanvas$c.selectorManager.requestSelector(elem).resize();
                }, 0);
            }
            // if this element was rotated, and we changed the position of this element
            // we need to update the rotational transform attribute
            const angle = getRotationAngle(elem);
            if (angle !== 0 && attr !== "transform") {
                const tlist = getTransformList(elem);
                let n = tlist.numberOfItems;
                while (n--) {
                    const xform = tlist.getItem(n);
                    if (xform.type === 4) {
                        // remove old rotate
                        tlist.removeItem(n);
                        const box = getBBox(elem);
                        const center = transformPoint(
                            box.x + box.width / 2,
                            box.y + box.height / 2,
                            transformListToTransform(tlist).matrix,
                        );
                        const cx = center.x;
                        const cy = center.y;
                        const newrot = svgCanvas$c
                            .getSvgRoot()
                            .createSVGTransform();
                        newrot.setRotate(angle, cx, cy);
                        tlist.insertItemBefore(newrot, n);
                        break;
                    }
                }
            }
        } // if oldValue != newValue
    } // for each elem
};

/**
 * Change the given/selected element and add the original value to the history stack.
 * If you want to change all `selectedElements`, ignore the `elems` argument.
 * If you want to change only a subset of `selectedElements`, then send the
 * subset to this function in the `elems` argument.
 * @function module:svgcanvas.SvgCanvas#changeSelectedAttribute
 * @param {string} attr - String with the attribute name
 * @param {string|Float} val - String or number with the new attribute value
 * @param {Element[]} elems - The DOM elements to apply the change to
 * @returns {void}
 */
const changeSelectedAttributeMethod = function (attr, val, elems) {
    const selectedElements = svgCanvas$c.getSelectedElements();
    elems = elems || selectedElements;
    svgCanvas$c.undoMgr.beginUndoableChange(attr, elems);
    changeSelectedAttributeNoUndoMethod(attr, val, elems);
    const batchCmd = svgCanvas$c.undoMgr.finishUndoableChange();
    if (!batchCmd.isEmpty()) {
        // svgCanvas.addCommandToHistory(batchCmd);
        svgCanvas$c.undoMgr.addCommandToHistory(batchCmd);
    }
};

/**
 * Tools for selection.
 * @module selection
 * @license MIT
 * @copyright 2011 Jeff Schiller
 */
const { BatchCommand: BatchCommand$2 } = history;
let svgCanvas$b = null;

/**
 * @function module:selection.init
 * @param {module:selection.selectionContext} selectionContext
 * @returns {void}
 */
const init$b = (canvas) => {
    svgCanvas$b = canvas;
    svgCanvas$b.getMouseTarget = getMouseTargetMethod;
    svgCanvas$b.clearSelection = clearSelectionMethod;
    svgCanvas$b.addToSelection = addToSelectionMethod;
    svgCanvas$b.getIntersectionList = getIntersectionListMethod;
    svgCanvas$b.runExtensions = runExtensionsMethod;
    svgCanvas$b.groupSvgElem = groupSvgElem;
    svgCanvas$b.prepareSvg = prepareSvg;
    svgCanvas$b.recalculateAllSelectedDimensions =
        recalculateAllSelectedDimensions;
    svgCanvas$b.setRotationAngle = setRotationAngle;
};

/**
 * Clears the selection. The 'selected' handler is then optionally called.
 * This should really be an intersection applying to all types rather than a union.
 * @name module:selection.SvgCanvas#clearSelection
 * @type {module:draw.DrawCanvasInit#clearSelection|module:path.EditorContext#clearSelection}
 * @fires module:selection.SvgCanvas#event:selected
 */
const clearSelectionMethod = (noCall) => {
    const selectedElements = svgCanvas$b.getSelectedElements();
    selectedElements.forEach((elem) => {
        if (!elem) {
            return;
        }
        svgCanvas$b.selectorManager.releaseSelector(elem);
    });
    svgCanvas$b?.setEmptySelectedElements();
    if (!noCall) {
        svgCanvas$b.call("selected", svgCanvas$b.getSelectedElements());
    }
};

/**
 * Adds a list of elements to the selection. The 'selected' handler is then called.
 * @name module:selection.SvgCanvas#addToSelection
 * @type {module:path.EditorContext#addToSelection}
 * @fires module:selection.SvgCanvas#event:selected
 */
const addToSelectionMethod = (elemsToAdd, showGrips) => {
    const selectedElements = svgCanvas$b.getSelectedElements();
    if (!elemsToAdd.length) {
        return;
    }
    if (elemsToAdd.length === 1 && elemsToAdd[0].tagName === "text") {
        showGrips = false;
    }
    // find the first null in our selectedElements array

    let firstNull = 0;
    while (firstNull < selectedElements.length) {
        if (selectedElements[firstNull] === null) {
            break;
        }
        ++firstNull;
    }

    // now add each element consecutively
    let i = elemsToAdd.length;
    while (i--) {
        let elem = elemsToAdd[i];
        if (!elem || !elem.getBBox) {
            continue;
        }
        if (elem.tagName === "a" && elem.childNodes.length === 1) {
            // Make "a" element's child be the selected element
            elem = elem.firstChild;
        }

        // if it's not already there, add it
        if (!selectedElements.includes(elem)) {
            selectedElements[firstNull] = elem;

            // only the first selectedBBoxes element is ever used in the codebase these days
            // if (j === 0) selectedBBoxes[0] = utilsGetBBox(elem);
            firstNull++;
            const sel = svgCanvas$b.selectorManager.requestSelector(elem);
            if (selectedElements.length > 1) {
                sel.showGrips(false);
            }
        }
    }
    if (!selectedElements.length) {
        return;
    }
    svgCanvas$b.call("selected", selectedElements);
    if (selectedElements.length === 1) {
        svgCanvas$b.selectorManager
            .requestSelector(selectedElements[0])
            .showGrips(showGrips);
    }

    // make sure the elements are in the correct order
    // See: https://www.w3.org/TR/DOM-Level-3-Core/core.html#Node3-compareDocumentPosition

    selectedElements.sort((a, b) => {
        if (a && b && a.compareDocumentPosition) {
            return 3 - (b.compareDocumentPosition(a) & 6);
        }
        if (!a) {
            return 1;
        }
        return 0;
    });

    // Make sure first elements are not null
    while (!selectedElements[0]) {
        selectedElements.shift(0);
    }
};
/**
 * @name module:svgcanvas.SvgCanvas#getMouseTarget
 * @type {module:path.EditorContext#getMouseTarget}
 */
const getMouseTargetMethod = (evt) => {
    if (!evt) {
        return null;
    }
    let mouseTarget = evt.target;

    // if it was a <use>, Opera and WebKit return the SVGElementInstance
    if (mouseTarget.correspondingUseElement) {
        mouseTarget = mouseTarget.correspondingUseElement;
    }

    // for foreign content, go up until we find the foreignObject
    // WebKit browsers set the mouse target to the svgcanvas div
    if (
        [NS.MATH, NS.HTML].includes(mouseTarget.namespaceURI) &&
        mouseTarget.id !== "svgcanvas"
    ) {
        while (mouseTarget.nodeName !== "foreignObject") {
            mouseTarget = mouseTarget.parentNode;
            if (!mouseTarget) {
                return svgCanvas$b.getSvgRoot();
            }
        }
    }

    // Get the desired mouseTarget with jQuery selector-fu
    // If it's root-like, select the root
    const currentLayer = svgCanvas$b.getCurrentDrawing().getCurrentLayer();
    const svgRoot = svgCanvas$b.getSvgRoot();
    const container = svgCanvas$b.getDOMContainer();
    const content = svgCanvas$b.getSvgContent();
    if ([svgRoot, container, content, currentLayer].includes(mouseTarget)) {
        return svgCanvas$b.getSvgRoot();
    }

    // If it's a selection grip, return the grip parent
    if (getClosest(mouseTarget.parentNode, "#selectorParentGroup")) {
        // While we could instead have just returned mouseTarget,
        // this makes it easier to indentify as being a selector grip
        return svgCanvas$b.selectorManager.selectorParentGroup;
    }
    while (
        !mouseTarget?.parentNode?.isSameNode(
            svgCanvas$b.getCurrentGroup() || currentLayer,
        )
    ) {
        mouseTarget = mouseTarget.parentNode;
    }
    return mouseTarget;
};
/**
 * @typedef {module:svgcanvas.ExtensionMouseDownStatus|module:svgcanvas.ExtensionMouseUpStatus|module:svgcanvas.ExtensionIDsUpdatedStatus|module:locale.ExtensionLocaleData[]|void} module:svgcanvas.ExtensionStatus
 * @tutorial ExtensionDocs
 */
/**
 * @callback module:svgcanvas.ExtensionVarBuilder
 * @param {string} name The name of the extension
 * @returns {module:svgcanvas.SvgCanvas#event:ext_addLangData}
 */
/**
 * @callback module:svgcanvas.ExtensionNameFilter
 * @param {string} name
 * @returns {boolean}
 */
/* eslint-disable max-len */
/**
 * @todo Consider: Should this return an array by default, so extension results aren't overwritten?
 * @todo Would be easier to document if passing in object with key of action and vars as value; could then define an interface which tied both together
 * @function module:svgcanvas.SvgCanvas#runExtensions
 * @param {"mouseDown"|"mouseMove"|"mouseUp"|"zoomChanged"|"IDsUpdated"|"canvasUpdated"|"toolButtonStateUpdate"|"selectedChanged"|"elementTransition"|"elementChanged"|"langReady"|"langChanged"|"addLangData"|"workareaResized"} action
 * @param {module:svgcanvas.SvgCanvas#event:ext_mouseDown|module:svgcanvas.SvgCanvas#event:ext_mouseMove|module:svgcanvas.SvgCanvas#event:ext_mouseUp|module:svgcanvas.SvgCanvas#event:ext_zoomChanged|module:svgcanvas.SvgCanvas#event:ext_IDsUpdated|module:svgcanvas.SvgCanvas#event:ext_canvasUpdated|module:svgcanvas.SvgCanvas#event:ext_toolButtonStateUpdate|module:svgcanvas.SvgCanvas#event:ext_selectedChanged|module:svgcanvas.SvgCanvas#event:ext_elementTransition|module:svgcanvas.SvgCanvas#event:ext_elementChanged|module:svgcanvas.SvgCanvas#event:ext_langReady|module:svgcanvas.SvgCanvas#event:ext_langChanged|module:svgcanvas.SvgCanvas#event:ext_addLangData|module:svgcanvas.SvgCanvas#event:ext_workareaResized|module:svgcanvas.ExtensionVarBuilder} [vars]
 * @param {boolean} [returnArray]
 * @returns {GenericArray<module:svgcanvas.ExtensionStatus>|module:svgcanvas.ExtensionStatus|false} See {@tutorial ExtensionDocs} on the ExtensionStatus.
 */
/* eslint-enable max-len */
const runExtensionsMethod = (action, vars, returnArray) => {
    let result = returnArray ? [] : false;
    for (const [name, ext] of Object.entries(svgCanvas$b.getExtensions())) {
        if (typeof vars === "function") {
            vars = vars(name); // ext, action
        }

        if (ext.eventBased) {
            const event = new CustomEvent("svgedit", {
                detail: {
                    action,
                    vars,
                },
            });
            document.dispatchEvent(event);
        } else if (ext[action]) {
            if (returnArray) {
                result.push(ext[action](vars));
            } else {
                result = ext[action](vars);
            }
        }
    }
    return result;
};

/**
 * Get all elements that have a BBox (excludes `<defs>`, `<title>`, etc).
 * Note that 0-opacity, off-screen etc elements are still considered "visible"
 * for this function.
 * @function module:svgcanvas.SvgCanvas#getVisibleElementsAndBBoxes
 * @param {Element} parent - The parent DOM element to search within
 * @returns {ElementAndBBox[]} An array with objects that include:
 */
const getVisibleElementsAndBBoxes = (parent) => {
    if (!parent) {
        const svgContent = svgCanvas$b.getSvgContent();
        parent = svgContent.children; // Prevent layers from being included
    }

    const contentElems = [];
    const elements = parent.children;
    Array.from(elements).forEach((elem) => {
        if (elem.getBBox) {
            contentElems.push({
                elem,
                bbox: getStrokedBBoxDefaultVisible([elem]),
            });
        }
    });
    return contentElems.reverse();
};

/**
 * This method sends back an array or a NodeList full of elements that
 * intersect the multi-select rubber-band-box on the currentLayer only.
 *
 * We brute-force `getIntersectionList` for browsers that do not support it (Firefox).
 *
 * Reference:
 * Firefox does not implement `getIntersectionList()`, see {@link https://bugzilla.mozilla.org/show_bug.cgi?id=501421}.
 * @function module:svgcanvas.SvgCanvas#getIntersectionList
 * @param {SVGRect} rect
 * @returns {Element[]|NodeList} Bbox elements
 */
const getIntersectionListMethod = (rect) => {
    const zoom = svgCanvas$b.getZoom();
    if (!svgCanvas$b.getRubberBox()) {
        return null;
    }
    const parent =
        svgCanvas$b.getCurrentGroup() ||
        svgCanvas$b.getCurrentDrawing().getCurrentLayer();
    let rubberBBox;
    if (!rect) {
        rubberBBox = getBBox(svgCanvas$b.getRubberBox());
        const bb = svgCanvas$b.getSvgContent().createSVGRect();
        ["x", "y", "width", "height", "top", "right", "bottom", "left"].forEach(
            (o) => {
                bb[o] = rubberBBox[o] / zoom;
            },
        );
        rubberBBox = bb;
    } else {
        rubberBBox = svgCanvas$b.getSvgContent().createSVGRect();
        rubberBBox.x = rect.x;
        rubberBBox.y = rect.y;
        rubberBBox.width = rect.width;
        rubberBBox.height = rect.height;
    }
    const resultList = [];
    if (svgCanvas$b.getCurBBoxes().length === 0) {
        // Cache all bboxes
        svgCanvas$b.setCurBBoxes(getVisibleElementsAndBBoxes(parent));
    }
    let i = svgCanvas$b.getCurBBoxes().length;
    while (i--) {
        const curBBoxes = svgCanvas$b.getCurBBoxes();
        if (!rubberBBox.width) {
            continue;
        }
        if (
            curBBoxes[i].bbox &&
            rectsIntersect(rubberBBox, curBBoxes[i].bbox)
        ) {
            resultList.push(curBBoxes[i].elem);
        }
    }

    // addToSelection expects an array, but it's ok to pass a NodeList
    // because using square-bracket notation is allowed:
    // https://www.w3.org/TR/DOM-Level-2-Core/ecma-script-binding.html
    return resultList;
};

/**
 * @typedef {PlainObject} ElementAndBBox
 * @property {Element} elem - The element
 * @property {module:utilities.BBoxObject} bbox - The element's BBox as retrieved from `getStrokedBBoxDefaultVisible`
 */

/**
 * Wrap an SVG element into a group element, mark the group as 'gsvg'.
 * @function module:svgcanvas.SvgCanvas#groupSvgElem
 * @param {Element} elem - SVG element to wrap
 * @returns {void}
 */
const groupSvgElem = (elem) => {
    const dataStorage = svgCanvas$b.getDataStorage();
    const g = document.createElementNS(NS.SVG, "g");
    elem.replaceWith(g);
    g.appendChild(elem);
    dataStorage.put(g, "gsvg", elem);
    g.id = svgCanvas$b.getNextId();
};

/**
 * Runs the SVG Document through the sanitizer and then updates its paths.
 * @function module:svgcanvas.SvgCanvas#prepareSvg
 * @param {XMLDocument} newDoc - The SVG DOM document
 * @returns {void}
 */
const prepareSvg = (newDoc) => {
    svgCanvas$b.sanitizeSvg(newDoc.documentElement);

    // convert paths into absolute commands
    const paths = [...newDoc.getElementsByTagNameNS(NS.SVG, "path")];
    paths.forEach((path) => {
        const convertedPath = svgCanvas$b.pathActions.convertPath(path);
        path.setAttribute("d", convertedPath);
        svgCanvas$b.pathActions.fixEnd(path);
    });
};

/**
 * Removes any old rotations if present, prepends a new rotation at the
 * transformed center.
 * @function module:svgcanvas.SvgCanvas#setRotationAngle
 * @param {string|Float} val - The new rotation angle in degrees
 * @param {boolean} preventUndo - Indicates whether the action should be undoable or not
 * @fires module:svgcanvas.SvgCanvas#event:changed
 * @returns {void}
 */
const setRotationAngle = (val, preventUndo) => {
    const selectedElements = svgCanvas$b.getSelectedElements();
    // ensure val is the proper type
    val = Number.parseFloat(val);
    const elem = selectedElements[0];
    const oldTransform = elem.getAttribute("transform");
    const bbox = getBBox(elem);
    const cx = bbox.x + bbox.width / 2;
    const cy = bbox.y + bbox.height / 2;
    const tlist = getTransformList(elem);

    // only remove the real rotational transform if present (i.e. at index=0)
    if (tlist.numberOfItems > 0) {
        const xform = tlist.getItem(0);
        if (xform.type === 4) {
            tlist.removeItem(0);
        }
    }
    // find Rnc and insert it
    if (val !== 0) {
        const center = transformPoint(
            cx,
            cy,
            transformListToTransform(tlist).matrix,
        );
        const Rnc = svgCanvas$b.getSvgRoot().createSVGTransform();
        Rnc.setRotate(val, center.x, center.y);
        if (tlist.numberOfItems) {
            tlist.insertItemBefore(Rnc, 0);
        } else {
            tlist.appendItem(Rnc);
        }
    } else if (tlist.numberOfItems === 0) {
        elem.removeAttribute("transform");
    }
    if (!preventUndo) {
        // we need to undo it, then redo it so it can be undo-able! :)
        // TODO: figure out how to make changes to transform list undo-able cross-browser?
        let newTransform = elem.getAttribute("transform");
        // new transform is something like: 'rotate(5 1.39625e-8 -11)'
        // we round the x so it becomes 'rotate(5 0 -11)'
        if (newTransform) {
            const newTransformArray = newTransform.split(" ");
            const round = (num) => Math.round(Number(num) + Number.EPSILON);
            const x = round(newTransformArray[1]);
            newTransform = `${newTransformArray[0]} ${x} ${newTransformArray[2]}`;
        }
        if (oldTransform) {
            elem.setAttribute("transform", oldTransform);
        } else {
            elem.removeAttribute("transform");
        }
        svgCanvas$b.changeSelectedAttribute(
            "transform",
            newTransform,
            selectedElements,
        );
        svgCanvas$b.call("changed", selectedElements);
    }
    // const pointGripContainer = getElement('pathpointgrip_container');
    // if (elem.nodeName === 'path' && pointGripContainer) {
    //   pathActions.setPointContainerTransform(elem.getAttribute('transform'));
    // }
    const selector = svgCanvas$b.selectorManager.requestSelector(
        selectedElements[0],
    );
    selector.resize();
    svgCanvas$b.getSelector().updateGripCursors(val);
};

/**
 * Runs `recalculateDimensions` on the selected elements,
 * adding the changes to a single batch command.
 * @function module:svgcanvas.SvgCanvas#recalculateAllSelectedDimensions
 * @fires module:svgcanvas.SvgCanvas#event:changed
 * @returns {void}
 */
const recalculateAllSelectedDimensions = () => {
    const text =
        svgCanvas$b.getCurrentResizeMode() === "none" ? "position" : "size";
    const batchCmd = new BatchCommand$2(text);
    const selectedElements = svgCanvas$b.getSelectedElements();
    selectedElements.forEach((elem) => {
        const cmd = svgCanvas$b.recalculateDimensions(elem);
        if (cmd) {
            batchCmd.addSubCommand(cmd);
        }
    });
    if (!batchCmd.isEmpty()) {
        svgCanvas$b.addCommandToHistory(batchCmd);
        svgCanvas$b.call("changed", selectedElements);
    }
};

/**
 * @module text-actions Tools for Text edit functions
 * @license MIT
 *
 * @copyright 2010 Alexis Deveria, 2010 Jeff Schiller
 */
let svgCanvas$a = null;

/**
 * @function module:text-actions.init
 * @param {module:text-actions.svgCanvas} textActionsContext
 * @returns {void}
 */
const init$a = (canvas) => {
    svgCanvas$a = canvas;
};

/**
 * Group: Text edit functions
 * Functions relating to editing text elements.
 * @namespace {PlainObject} textActions
 * @memberof module:svgcanvas.SvgCanvas#
 */
const textActionsMethod = (function () {
    let curtext;
    let textinput;
    let cursor;
    let selblock;
    let blinker;
    let chardata = [];
    let textbb; // , transbb;
    let matrix;
    let lastX;
    let lastY;
    let allowDbl;

    /**
     *
     * @param {Integer} index
     * @returns {void}
     */
    function setCursor(index) {
        const empty = textinput.value === "";
        textinput.focus();
        if (!arguments.length) {
            if (empty) {
                index = 0;
            } else {
                if (textinput.selectionEnd !== textinput.selectionStart) {
                    return;
                }
                index = textinput.selectionEnd;
            }
        }
        const charbb = chardata[index];
        if (!empty) {
            textinput.setSelectionRange(index, index);
        }
        cursor = getElement("text_cursor");
        if (!cursor) {
            cursor = document.createElementNS(NS.SVG, "line");
            assignAttributes(cursor, {
                id: "text_cursor",
                stroke: "#333",
                "stroke-width": 1,
            });
            getElement("selectorParentGroup").append(cursor);
        }
        if (!blinker) {
            blinker = setInterval(function () {
                const show = cursor.getAttribute("display") === "none";
                cursor.setAttribute("display", show ? "inline" : "none");
            }, 600);
        }
        const startPt = ptToScreen(charbb.x, textbb.y);
        const endPt = ptToScreen(charbb.x, textbb.y + textbb.height);
        assignAttributes(cursor, {
            x1: startPt.x,
            y1: startPt.y,
            x2: endPt.x,
            y2: endPt.y,
            visibility: "visible",
            display: "inline",
        });
        if (selblock) {
            selblock.setAttribute("d", "");
        }
    }

    /**
     *
     * @param {Integer} start
     * @param {Integer} end
     * @param {boolean} skipInput
     * @returns {void}
     */
    function setSelection(start, end, skipInput) {
        if (start === end) {
            setCursor(end);
            return;
        }
        if (!skipInput) {
            textinput.setSelectionRange(start, end);
        }
        selblock = getElement("text_selectblock");
        if (!selblock) {
            selblock = document.createElementNS(NS.SVG, "path");
            assignAttributes(selblock, {
                id: "text_selectblock",
                fill: "green",
                opacity: 0.5,
                style: "pointer-events:none",
            });
            getElement("selectorParentGroup").append(selblock);
        }
        const startbb = chardata[start];
        const endbb = chardata[end];
        cursor.setAttribute("visibility", "hidden");
        const tl = ptToScreen(startbb.x, textbb.y);
        const tr = ptToScreen(startbb.x + (endbb.x - startbb.x), textbb.y);
        const bl = ptToScreen(startbb.x, textbb.y + textbb.height);
        const br = ptToScreen(
            startbb.x + (endbb.x - startbb.x),
            textbb.y + textbb.height,
        );
        const dstr =
            "M" +
            tl.x +
            "," +
            tl.y +
            " L" +
            tr.x +
            "," +
            tr.y +
            " " +
            br.x +
            "," +
            br.y +
            " " +
            bl.x +
            "," +
            bl.y +
            "z";
        assignAttributes(selblock, {
            d: dstr,
            display: "inline",
        });
    }

    /**
     *
     * @param {Float} mouseX
     * @param {Float} mouseY
     * @returns {Integer}
     */
    function getIndexFromPoint(mouseX, mouseY) {
        // Position cursor here
        const pt = svgCanvas$a.getSvgRoot().createSVGPoint();
        pt.x = mouseX;
        pt.y = mouseY;

        // No content, so return 0
        if (chardata.length === 1) {
            return 0;
        }
        // Determine if cursor should be on left or right of character
        let charpos = curtext.getCharNumAtPosition(pt);
        if (charpos < 0) {
            // Out of text range, look at mouse coords
            charpos = chardata.length - 2;
            if (mouseX <= chardata[0].x) {
                charpos = 0;
            }
        } else if (charpos >= chardata.length - 2) {
            charpos = chardata.length - 2;
        }
        const charbb = chardata[charpos];
        const mid = charbb.x + charbb.width / 2;
        if (mouseX > mid) {
            charpos++;
        }
        return charpos;
    }

    /**
     *
     * @param {Float} mouseX
     * @param {Float} mouseY
     * @returns {void}
     */
    function setCursorFromPoint(mouseX, mouseY) {
        setCursor(getIndexFromPoint(mouseX, mouseY));
    }

    /**
     *
     * @param {Float} x
     * @param {Float} y
     * @param {boolean} apply
     * @returns {void}
     */
    function setEndSelectionFromPoint(x, y, apply) {
        const i1 = textinput.selectionStart;
        const i2 = getIndexFromPoint(x, y);
        const start = Math.min(i1, i2);
        const end = Math.max(i1, i2);
        setSelection(start, end, !apply);
    }

    /**
     *
     * @param {Float} xIn
     * @param {Float} yIn
     * @returns {module:math.XYObject}
     */
    function screenToPt(xIn, yIn) {
        const out = {
            x: xIn,
            y: yIn,
        };
        const zoom = svgCanvas$a.getZoom();
        out.x /= zoom;
        out.y /= zoom;
        if (matrix) {
            const pt = transformPoint(out.x, out.y, matrix.inverse());
            out.x = pt.x;
            out.y = pt.y;
        }
        return out;
    }

    /**
     *
     * @param {Float} xIn
     * @param {Float} yIn
     * @returns {module:math.XYObject}
     */
    function ptToScreen(xIn, yIn) {
        const out = {
            x: xIn,
            y: yIn,
        };
        if (matrix) {
            const pt = transformPoint(out.x, out.y, matrix);
            out.x = pt.x;
            out.y = pt.y;
        }
        const zoom = svgCanvas$a.getZoom();
        out.x *= zoom;
        out.y *= zoom;
        return out;
    }

    /**
     *
     * @param {Event} evt
     * @returns {void}
     */
    function selectAll(evt) {
        setSelection(0, curtext.textContent.length);
        evt.target.removeEventListener("click", selectAll);
    }

    /**
     *
     * @param {Event} evt
     * @returns {void}
     */
    function selectWord(evt) {
        if (!allowDbl || !curtext) {
            return;
        }
        const zoom = svgCanvas$a.getZoom();
        const ept = transformPoint(
            evt.pageX,
            evt.pageY,
            svgCanvas$a.getrootSctm(),
        );
        const mouseX = ept.x * zoom;
        const mouseY = ept.y * zoom;
        const pt = screenToPt(mouseX, mouseY);
        const index = getIndexFromPoint(pt.x, pt.y);
        const str = curtext.textContent;
        const first = str.substr(0, index).replace(/[a-z\d]+$/i, "").length;
        const m = str.substr(index).match(/^[a-z\d]+/i);
        const last = (m ? m[0].length : 0) + index;
        setSelection(first, last);

        // Set tripleclick
        svgCanvas$a.$click(evt.target, selectAll);
        setTimeout(function () {
            evt.target.removeEventListener("click", selectAll);
        }, 300);
    }
    return /** @lends module:svgcanvas.SvgCanvas#textActions */ {
        /**
         * @param {Element} target
         * @param {Float} x
         * @param {Float} y
         * @returns {void}
         */
        select(target, x, y) {
            curtext = target;
            svgCanvas$a.textActions.toEditMode(x, y);
        },
        /**
         * @param {Element} elem
         * @returns {void}
         */
        start(elem) {
            curtext = elem;
            svgCanvas$a.textActions.toEditMode();
        },
        /**
         * @param {external:MouseEvent} evt
         * @param {Element} mouseTarget
         * @param {Float} startX
         * @param {Float} startY
         * @returns {void}
         */
        mouseDown(evt, mouseTarget, startX, startY) {
            const pt = screenToPt(startX, startY);
            textinput.focus();
            setCursorFromPoint(pt.x, pt.y);
            lastX = startX;
            lastY = startY;

            // TODO: Find way to block native selection
        },

        /**
         * @param {Float} mouseX
         * @param {Float} mouseY
         * @returns {void}
         */
        mouseMove(mouseX, mouseY) {
            const pt = screenToPt(mouseX, mouseY);
            setEndSelectionFromPoint(pt.x, pt.y);
        },
        /**
         * @param {external:MouseEvent} evt
         * @param {Float} mouseX
         * @param {Float} mouseY
         * @returns {void}
         */
        mouseUp(evt, mouseX, mouseY) {
            const pt = screenToPt(mouseX, mouseY);
            setEndSelectionFromPoint(pt.x, pt.y, true);

            // TODO: Find a way to make this work: Use transformed BBox instead of evt.target
            // if (lastX === mouseX && lastY === mouseY
            //   && !rectsIntersect(transbb, {x: pt.x, y: pt.y, width: 0, height: 0})) {
            //   svgCanvas.textActions.toSelectMode(true);
            // }

            if (
                evt.target !== curtext &&
                mouseX < lastX + 2 &&
                mouseX > lastX - 2 &&
                mouseY < lastY + 2 &&
                mouseY > lastY - 2
            ) {
                svgCanvas$a.textActions.toSelectMode(true);
            }
        },
        /**
         * @function
         * @param {Integer} index
         * @returns {void}
         */
        setCursor,
        /**
         * @param {Float} x
         * @param {Float} y
         * @returns {void}
         */
        toEditMode(x, y) {
            allowDbl = false;
            svgCanvas$a.setCurrentMode("textedit");
            svgCanvas$a.selectorManager
                .requestSelector(curtext)
                .showGrips(false);
            // Make selector group accept clicks
            /* const selector = */
            svgCanvas$a.selectorManager.requestSelector(curtext); // Do we need this? Has side effect of setting lock, so keeping for now, but next line wasn't being used
            // const sel = selector.selectorRect;

            svgCanvas$a.textActions.init();
            curtext.style.cursor = "text";

            // if (supportsEditableText()) {
            //   curtext.setAttribute('editable', 'simple');
            //   return;
            // }

            if (!arguments.length) {
                setCursor();
            } else {
                const pt = screenToPt(x, y);
                setCursorFromPoint(pt.x, pt.y);
            }
            setTimeout(function () {
                allowDbl = true;
            }, 300);
        },
        /**
         * @param {boolean|Element} selectElem
         * @fires module:svgcanvas.SvgCanvas#event:selected
         * @returns {void}
         */
        toSelectMode(selectElem) {
            svgCanvas$a.setCurrentMode("select");
            clearInterval(blinker);
            blinker = null;
            if (selblock) {
                selblock.setAttribute("display", "none");
            }
            if (cursor) {
                cursor.setAttribute("visibility", "hidden");
            }
            curtext.style.cursor = "move";
            if (selectElem) {
                svgCanvas$a.clearSelection();
                curtext.style.cursor = "move";
                svgCanvas$a.call("selected", [curtext]);
                svgCanvas$a.addToSelection([curtext], true);
            }
            if (!curtext?.textContent.length) {
                // No content, so delete
                svgCanvas$a.deleteSelectedElements();
            }
            textinput.blur();
            curtext = false;

            // if (supportsEditableText()) {
            //   curtext.removeAttribute('editable');
            // }
        },

        /**
         * @param {Element} elem
         * @returns {void}
         */
        setInputElem(elem) {
            textinput = elem;
        },
        /**
         * @returns {void}
         */
        clear() {
            if (svgCanvas$a.getCurrentMode() === "textedit") {
                svgCanvas$a.textActions.toSelectMode();
            }
        },
        /**
         * @param {Element} _inputElem Not in use
         * @returns {void}
         */
        init(_inputElem) {
            if (!curtext) {
                return;
            }
            let i;
            let end;
            // if (supportsEditableText()) {
            //   curtext.select();
            //   return;
            // }

            if (!curtext.parentNode) {
                // Result of the ffClone, need to get correct element
                const selectedElements = svgCanvas$a.getSelectedElements();
                curtext = selectedElements[0];
                svgCanvas$a.selectorManager
                    .requestSelector(curtext)
                    .showGrips(false);
            }
            const str = curtext.textContent;
            const len = str.length;
            const xform = curtext.getAttribute("transform");
            textbb = getBBox(curtext);
            matrix = xform ? getMatrix(curtext) : null;
            chardata = [];
            chardata.length = len;
            textinput.focus();
            curtext.removeEventListener("dblclick", selectWord);
            curtext.addEventListener("dblclick", selectWord);
            if (!len) {
                end = {
                    x: textbb.x + textbb.width / 2,
                    width: 0,
                };
            }
            for (i = 0; i < len; i++) {
                const start = curtext.getStartPositionOfChar(i);
                end = curtext.getEndPositionOfChar(i);
                if (!supportsGoodTextCharPos()) {
                    const zoom = svgCanvas$a.getZoom();
                    const offset = svgCanvas$a.contentW * zoom;
                    start.x -= offset;
                    end.x -= offset;
                    start.x /= zoom;
                    end.x /= zoom;
                }

                // Get a "bbox" equivalent for each character. Uses the
                // bbox data of the actual text for y, height purposes

                // TODO: Decide if y, width and height are actually necessary
                chardata[i] = {
                    x: start.x,
                    y: textbb.y,
                    // start.y?
                    width: end.x - start.x,
                    height: textbb.height,
                };
            }

            // Add a last bbox for cursor at end of text
            chardata.push({
                x: end.x,
                width: 0,
            });
            setSelection(
                textinput.selectionStart,
                textinput.selectionEnd,
                true,
            );
        },
    };
})();

/**
 * Tools for event.
 * @module event
 * @license MIT
 * @copyright 2011 Jeff Schiller
 */
const { InsertElementCommand: InsertElementCommand$2 } = history;
let svgCanvas$9 = null;
let moveSelectionThresholdReached = false;

/**
 * @function module:undo.init
 * @param {module:undo.eventContext} eventContext
 * @returns {void}
 */
const init$9 = (canvas) => {
    svgCanvas$9 = canvas;
    svgCanvas$9.mouseDownEvent = mouseDownEvent;
    svgCanvas$9.mouseMoveEvent = mouseMoveEvent;
    svgCanvas$9.dblClickEvent = dblClickEvent;
    svgCanvas$9.mouseUpEvent = mouseUpEvent;
    svgCanvas$9.mouseOutEvent = mouseOutEvent;
    svgCanvas$9.DOMMouseScrollEvent = DOMMouseScrollEvent;
};
const getBsplinePoint = (t) => {
    const spline = {
        x: 0,
        y: 0,
    };
    const p0 = {
        x: svgCanvas$9.getControllPoint2("x"),
        y: svgCanvas$9.getControllPoint2("y"),
    };
    const p1 = {
        x: svgCanvas$9.getControllPoint1("x"),
        y: svgCanvas$9.getControllPoint1("y"),
    };
    const p2 = {
        x: svgCanvas$9.getStart("x"),
        y: svgCanvas$9.getStart("y"),
    };
    const p3 = {
        x: svgCanvas$9.getEnd("x"),
        y: svgCanvas$9.getEnd("y"),
    };
    const S = 1.0 / 6.0;
    const t2 = t * t;
    const t3 = t2 * t;
    const m = [
        [-1, 3, -3, 1],
        [3, -6, 3, 0],
        [-3, 0, 3, 0],
        [1, 4, 1, 0],
    ];
    spline.x =
        S *
        ((p0.x * m[0][0] + p1.x * m[0][1] + p2.x * m[0][2] + p3.x * m[0][3]) *
            t3 +
            (p0.x * m[1][0] +
                p1.x * m[1][1] +
                p2.x * m[1][2] +
                p3.x * m[1][3]) *
                t2 +
            (p0.x * m[2][0] +
                p1.x * m[2][1] +
                p2.x * m[2][2] +
                p3.x * m[2][3]) *
                t +
            (p0.x * m[3][0] +
                p1.x * m[3][1] +
                p2.x * m[3][2] +
                p3.x * m[3][3]));
    spline.y =
        S *
        ((p0.y * m[0][0] + p1.y * m[0][1] + p2.y * m[0][2] + p3.y * m[0][3]) *
            t3 +
            (p0.y * m[1][0] +
                p1.y * m[1][1] +
                p2.y * m[1][2] +
                p3.y * m[1][3]) *
                t2 +
            (p0.y * m[2][0] +
                p1.y * m[2][1] +
                p2.y * m[2][2] +
                p3.y * m[2][3]) *
                t +
            (p0.y * m[3][0] +
                p1.y * m[3][1] +
                p2.y * m[3][2] +
                p3.y * m[3][3]));
    return {
        x: spline.x,
        y: spline.y,
    };
};

// update the dummy transform in our transform list
// to be a translate. We need to check if there was a transformation
// to avoid loosing it
const updateTransformList = (svgRoot, element, dx, dy) => {
    const xform = svgRoot.createSVGTransform();
    xform.setTranslate(dx, dy);
    const tlist = getTransformList(element);
    if (tlist.numberOfItems) {
        const firstItem = tlist.getItem(0);
        if (firstItem.type === 2) {
            // SVG_TRANSFORM_TRANSLATE = 2
            tlist.replaceItem(xform, 0);
        } else {
            tlist.insertItemBefore(xform, 0);
        }
    } else {
        tlist.appendItem(xform);
    }
    return xform;
};

/**
 *
 * @param {MouseEvent} evt
 * @fires module:svgcanvas.SvgCanvas#event:transition
 * @fires module:svgcanvas.SvgCanvas#event:ext_mouseMove
 * @returns {void}
 */

let posXMouseDown;
let posYMouseDown;
let movingX;
let movingY;

const mouseMoveEvent = (evt) => {
    if (svgCanvas$9.getCanvasIsLocked()) {
        svgCanvas$9.setStarted(false);
        return;
    }
    // if the mouse is move without dragging an element, just return.
    if (!svgCanvas$9.getStarted()) {
        return;
    }
    if (evt.button === 1 || svgCanvas$9.spaceKey) {
        return;
    }
    svgCanvas$9.textActions.init();
    evt.preventDefault();
    const selectedElements = svgCanvas$9.getSelectedElements();
    const zoom = svgCanvas$9.getZoom();
    const svgRoot = svgCanvas$9.getSvgRoot();
    const layer = svgRoot.getElementsByClassName("layer");
    const selected = selectedElements[0];
    let i;
    let xya;
    let cx;
    let cy;
    let dx;
    let dy;
    let len;
    let angle;
    let box;
    const pt = transformPoint(
        evt.clientX,
        evt.clientY,
        svgCanvas$9.getrootSctm(),
    );
    let mouseX = pt.x * zoom;
    let mouseY = pt.y * zoom;

    //Only move right/left or up/down if shift key is pressed
    if (evt.shiftKey) {
        document.getElementById("editorContainer").classList.add("cursor-move");
        const diff =
            Math.abs(posXMouseDown - mouseX) > Math.abs(posYMouseDown - mouseY);
        mouseY = posYMouseDown;
        mouseX = posXMouseDown;
        if (diff && !movingX) {
            mouseX = pt.x * zoom;
            if (!movingX && !movingY) {
                movingY = true;
            }
        } else if (!movingY) {
            mouseY = pt.y * zoom;
            if (!movingX && !movingY) {
                movingX = true;
            }
        }
    }
    const shape = getElement(svgCanvas$9.getId());
    let realX = mouseX / zoom;
    let x = realX;
    let realY = mouseY / zoom;
    let y = realY;
    if (svgCanvas$9.getCurConfig().gridSnapping) {
        x = snapToGrid(x);
        y = snapToGrid(y);
    }
    let tlist;
    switch (svgCanvas$9.getCurrentMode()) {
        case "select": {
            // we temporarily use a translate on the element(s) being dragged
            // this transform is removed upon mousing up and the element is
            // relocated to the new location
            if (selected) {
                dx = x - svgCanvas$9.getStartX();
                dy = y - svgCanvas$9.getStartY();
                if (svgCanvas$9.getCurConfig().gridSnapping) {
                    dx = snapToGrid(dx);
                    dy = snapToGrid(dy);
                }

                // Enable moving selection only if mouse has been moved at least 4 px in any direction
                // This prevents objects from being accidentally moved when (initially) selected
                const deltaThreshold = 1;
                const deltaThresholdReached =
                    Math.abs(dx) > deltaThreshold ||
                    Math.abs(dy) > deltaThreshold;
                moveSelectionThresholdReached =
                    moveSelectionThresholdReached || deltaThresholdReached;
                if (moveSelectionThresholdReached) {
                    selectedElements.forEach((el) => {
                        if (el) {
                            updateTransformList(svgRoot, el, dx, dy);
                            // update our internal bbox that we're tracking while dragging
                            svgCanvas$9.selectorManager
                                .requestSelector(el)
                                .resize();
                        }
                    });
                    svgCanvas$9.call("transition", selectedElements);
                }
            }
            break;
        }
        case "multiselect": {
            realX *= zoom;
            realY *= zoom;
            assignAttributes(svgCanvas$9.getRubberBox(), {
                x: Math.min(svgCanvas$9.getRStartX(), realX),
                y: Math.min(svgCanvas$9.getRStartY(), realY),
                width: Math.abs(realX - svgCanvas$9.getRStartX()),
                height: Math.abs(realY - svgCanvas$9.getRStartY()),
            });

            // for each selected:
            // - if newList contains selected, do nothing
            // - if newList doesn't contain selected, remove it from selected
            // - for any newList that was not in selectedElements, add it to selected
            const elemsToRemove = [];
            const elemsToAdd = [];
            const newList = svgCanvas$9.getIntersectionList();
            const currentSelectedSet = new Set();

            // For every element in the intersection, add if not present in selectedElements.
            len = newList.length;
            for (i = 0; i < len; ++i) {
                const intElem = newList[i];
                if (
                    intElem.getAttribute("lock") !== "true" &&
                    intElem.style.display !== "none" &&
                    !selectedElements.includes(intElem)
                ) {
                    elemsToAdd.push(intElem);
                }
                currentSelectedSet.add(intElem.getAttribute("id"));
            }

            for (i = 0; i < selectedElements.length; ++i) {
                const selectedElem = selectedElements[i];
                if (!currentSelectedSet.has(selectedElem.getAttribute("id"))) {
                    elemsToRemove.push(selectedElem);
                }
            }

            if (elemsToRemove.length > 0) {
                svgCanvas$9.removeFromSelection(elemsToRemove);
                svgCanvas$b.call("selected", newList);
            }

            if (elemsToAdd.length > 0) {
                svgCanvas$9.addToSelection(elemsToAdd);
            }
            break;
        }
        case "resize": {
            // we track the resize bounding box and translate/scale the selected element
            // while the mouse is down, when mouse goes up, we use this to recalculate
            // the shape's coordinates
            tlist = getTransformList(selected);
            const hasMatrix = hasMatrixTransform(tlist);
            box = hasMatrix ? svgCanvas$9.getInitBbox() : getBBox(selected);
            let left = box.x;
            let top = box.y;
            let { width, height } = box;
            dx = x - svgCanvas$9.getStartX();
            dy = y - svgCanvas$9.getStartY();
            if (svgCanvas$9.getCurConfig().gridSnapping) {
                dx = snapToGrid(dx);
                dy = snapToGrid(dy);
                height = snapToGrid(height);
                width = snapToGrid(width);
            }

            // if rotated, adjust the dx,dy values
            angle = getRotationAngle(selected);
            if (angle) {
                const r = Math.sqrt(dx * dx + dy * dy);
                const theta = Math.atan2(dy, dx) - (angle * Math.PI) / 180.0;
                dx = r * Math.cos(theta);
                dy = r * Math.sin(theta);
            }

            // if not stretching in y direction, set dy to 0
            // if not stretching in x direction, set dx to 0
            if (
                !svgCanvas$9.getCurrentResizeMode().includes("n") &&
                !svgCanvas$9.getCurrentResizeMode().includes("s")
            ) {
                dy = 0;
            }
            if (
                !svgCanvas$9.getCurrentResizeMode().includes("e") &&
                !svgCanvas$9.getCurrentResizeMode().includes("w")
            ) {
                dx = 0;
            }
            let // ts = null,
                tx = 0;
            let ty = 0;
            let sy = height ? (height + dy) / height : 1;
            let sx = width ? (width + dx) / width : 1;
            // if we are dragging on the north side, then adjust the scale factor and ty
            if (svgCanvas$9.getCurrentResizeMode().includes("n")) {
                sy = height ? (height - dy) / height : 1;
                ty = height;
            }

            // if we dragging on the east side, then adjust the scale factor and tx
            if (svgCanvas$9.getCurrentResizeMode().includes("w")) {
                sx = width ? (width - dx) / width : 1;
                tx = width;
            }

            // update the transform list with translate,scale,translate
            const translateOrigin = svgRoot.createSVGTransform();
            const scale = svgRoot.createSVGTransform();
            const translateBack = svgRoot.createSVGTransform();
            if (svgCanvas$9.getCurConfig().gridSnapping) {
                left = snapToGrid(left);
                tx = snapToGrid(tx);
                top = snapToGrid(top);
                ty = snapToGrid(ty);
            }
            translateOrigin.setTranslate(-(left + tx), -(top + ty));
            // For images, we maintain aspect ratio by default and relax when shift pressed
            const maintainAspectRatio =
                (selected.tagName !== "image" && evt.shiftKey) ||
                (selected.tagName === "image" && !evt.shiftKey);
            const type = selected.getAttribute("type");
            const constrain = Boolean(
                JSON.parse(selected.getAttribute("constrain-state")),
            );
            const isDefaultLibraryElement =
                selected.getAttribute("data-icreate-resizable") &&
                !type?.startsWith("connector-");
            const isConnectorElement =
                selected.getAttribute("data-icreate-resizable") &&
                !!type?.startsWith("connector-");
            if (
                maintainAspectRatio ||
                type === "fan" ||
                type === "generator" ||
                type === "valve" ||
                type === "filter" ||
                type === "tank" ||
                type === "mainEngine" ||
                type === "pump" ||
                constrain ||
                isDefaultLibraryElement ||
                isConnectorElement
            ) {
                if (sx === 1) {
                    sx = sy;
                } else {
                    sy = sx;
                }
            }
            scale.setScale(sx, sy);
            translateBack.setTranslate(left + tx, top + ty);
            if (hasMatrix) {
                const diff = angle ? 1 : 0;
                tlist.replaceItem(translateOrigin, 2 + diff);
                tlist.replaceItem(scale, 1 + diff);
                tlist.replaceItem(translateBack, Number(diff));
            } else {
                const N = tlist.numberOfItems;
                tlist.replaceItem(translateBack, N - 3);
                tlist.replaceItem(scale, N - 2);
                tlist.replaceItem(translateOrigin, N - 1);
            }
            svgCanvas$9.selectorManager.requestSelector(selected).resize();
            svgCanvas$9.call("transition", selectedElements);
            break;
        }
        case "zoom": {
            realX *= zoom;
            realY *= zoom;
            assignAttributes(svgCanvas$9.getRubberBox(), {
                x: Math.min(svgCanvas$9.getRStartX() * zoom, realX),
                y: Math.min(svgCanvas$9.getRStartY() * zoom, realY),
                width: Math.abs(realX - svgCanvas$9.getRStartX() * zoom),
                height: Math.abs(realY - svgCanvas$9.getRStartY() * zoom),
            });
            break;
        }
        case "text": {
            assignAttributes(shape, {
                x,
                y,
            });
            break;
        }
        case "line": {
            if (svgCanvas$9.getCurConfig().gridSnapping) {
                x = snapToGrid(x);
                y = snapToGrid(y);
            }
            let x2 = x;
            let y2 = y;
            if (evt.shiftKey) {
                xya = snapToAngle(
                    svgCanvas$9.getStartX(),
                    svgCanvas$9.getStartY(),
                    x2,
                    y2,
                );
                x2 = xya.x;
                y2 = xya.y;
            }
            shape.setAttribute("x2", x2);
            shape.setAttribute("y2", y2);
            break;
        }
        case "foreignObject": // fall through
        case "square":
        case "rect":
        case "image": {
            // For images, we maintain aspect ratio by default and relax when shift pressed
            const maintainAspectRatio =
                svgCanvas$9.getCurrentMode() === "square" ||
                (svgCanvas$9.getCurrentMode() === "image" && !evt.shiftKey) ||
                (svgCanvas$9.getCurrentMode() !== "image" && evt.shiftKey);
            let w = Math.abs(x - svgCanvas$9.getStartX());
            let h = Math.abs(y - svgCanvas$9.getStartY());
            let newX;
            let newY;
            if (maintainAspectRatio) {
                w = h = Math.max(w, h);
                newX =
                    svgCanvas$9.getStartX() < x
                        ? svgCanvas$9.getStartX()
                        : svgCanvas$9.getStartX() - w;
                newY =
                    svgCanvas$9.getStartY() < y
                        ? svgCanvas$9.getStartY()
                        : svgCanvas$9.getStartY() - h;
            } else {
                newX = Math.min(svgCanvas$9.getStartX(), x);
                newY = Math.min(svgCanvas$9.getStartY(), y);
            }
            if (svgCanvas$9.getCurConfig().gridSnapping) {
                w = snapToGrid(w);
                h = snapToGrid(h);
                newX = snapToGrid(newX);
                newY = snapToGrid(newY);
            }
            assignAttributes(shape, {
                width: w,
                height: h,
                x: newX,
                y: newY,
            });
            break;
        }
        case "circle": {
            cx = Number(shape.getAttribute("cx"));
            cy = Number(shape.getAttribute("cy"));
            let rad = Math.sqrt((x - cx) * (x - cx) + (y - cy) * (y - cy));
            if (svgCanvas$9.getCurConfig().gridSnapping) {
                rad = snapToGrid(rad);
            }
            shape.setAttribute("r", rad);
            break;
        }
        case "ellipse": {
            cx = Number(shape.getAttribute("cx"));
            cy = Number(shape.getAttribute("cy"));
            if (svgCanvas$9.getCurConfig().gridSnapping) {
                x = snapToGrid(x);
                cx = snapToGrid(cx);
                y = snapToGrid(y);
                cy = snapToGrid(cy);
            }
            shape.setAttribute("rx", Math.abs(x - cx));
            const ry = Math.abs(evt.shiftKey ? x - cx : y - cy);
            shape.setAttribute("ry", ry);
            break;
        }
        case "fhellipse":
        case "fhrect": {
            svgCanvas$9.setFreehand(
                "minx",
                Math.min(realX, svgCanvas$9.getFreehand("minx")),
            );
            svgCanvas$9.setFreehand(
                "maxx",
                Math.max(realX, svgCanvas$9.getFreehand("maxx")),
            );
            svgCanvas$9.setFreehand(
                "miny",
                Math.min(realY, svgCanvas$9.getFreehand("miny")),
            );
            svgCanvas$9.setFreehand(
                "maxy",
                Math.max(realY, svgCanvas$9.getFreehand("maxy")),
            );
        }
        // Fallthrough
        case "fhpath": {
            // dAttr += + realX + ',' + realY + ' ';
            // shape.setAttribute('points', dAttr);
            svgCanvas$9.setEnd("x", realX);
            svgCanvas$9.setEnd("y", realY);
            if (
                svgCanvas$9.getControllPoint2("x") &&
                svgCanvas$9.getControllPoint2("y")
            ) {
                for (i = 0; i < svgCanvas$9.getStepCount() - 1; i++) {
                    svgCanvas$9.setParameter(i / svgCanvas$9.getStepCount());
                    svgCanvas$9.setNextParameter(
                        (i + 1) / svgCanvas$9.getStepCount(),
                    );
                    svgCanvas$9.setbSpline(
                        getBsplinePoint(svgCanvas$9.getNextParameter()),
                    );
                    svgCanvas$9.setNextPos({
                        x: svgCanvas$9.getbSpline("x"),
                        y: svgCanvas$9.getbSpline("y"),
                    });
                    svgCanvas$9.setbSpline(
                        getBsplinePoint(svgCanvas$9.getParameter()),
                    );
                    svgCanvas$9.setSumDistance(
                        svgCanvas$9.getSumDistance() +
                            Math.sqrt(
                                (svgCanvas$9.getNextPos("x") -
                                    svgCanvas$9.getbSpline("x")) *
                                    (svgCanvas$9.getNextPos("x") -
                                        svgCanvas$9.getbSpline("x")) +
                                    (svgCanvas$9.getNextPos("y") -
                                        svgCanvas$9.getbSpline("y")) *
                                        (svgCanvas$9.getNextPos("y") -
                                            svgCanvas$9.getbSpline("y")),
                            ),
                    );
                    if (
                        svgCanvas$9.getSumDistance() >
                        svgCanvas$9.getThreSholdDist()
                    ) {
                        svgCanvas$9.setSumDistance(
                            svgCanvas$9.getSumDistance() -
                                svgCanvas$9.getThreSholdDist(),
                        );

                        // Faster than completely re-writing the points attribute.
                        const point = svgCanvas$9
                            .getSvgContent()
                            .createSVGPoint();
                        point.x = svgCanvas$9.getbSpline("x");
                        point.y = svgCanvas$9.getbSpline("y");
                        shape.points.appendItem(point);
                    }
                }
            }
            svgCanvas$9.setControllPoint2(
                "x",
                svgCanvas$9.getControllPoint1("x"),
            );
            svgCanvas$9.setControllPoint2(
                "y",
                svgCanvas$9.getControllPoint1("y"),
            );
            svgCanvas$9.setControllPoint1("x", svgCanvas$9.getStart("x"));
            svgCanvas$9.setControllPoint1("y", svgCanvas$9.getStart("y"));
            svgCanvas$9.setStart({
                x: svgCanvas$9.getEnd("x"),
                y: svgCanvas$9.getEnd("y"),
            });
            break;
            // update path stretch line coordinates
        }

        case "path": // fall through
        case "pathedit": {
            x *= zoom;
            y *= zoom;
            if (svgCanvas$9.getCurConfig().gridSnapping) {
                x = snapToGrid(x);
                y = snapToGrid(y);
                svgCanvas$9.setStartX(snapToGrid(svgCanvas$9.getStartX()));
                svgCanvas$9.setStartY(snapToGrid(svgCanvas$9.getStartY()));
            }
            if (evt.shiftKey) {
                const { path } = pathModule;
                let x1;
                let y1;
                if (path) {
                    x1 = path.dragging
                        ? path.dragging[0]
                        : svgCanvas$9.getStartX();
                    y1 = path.dragging
                        ? path.dragging[1]
                        : svgCanvas$9.getStartY();
                } else {
                    x1 = svgCanvas$9.getStartX();
                    y1 = svgCanvas$9.getStartY();
                }
                xya = snapToAngle(x1, y1, x, y);
                ({ x, y } = xya);
            }
            if (
                svgCanvas$9.getRubberBox()?.getAttribute("display") !== "none"
            ) {
                realX *= zoom;
                realY *= zoom;
                assignAttributes(svgCanvas$9.getRubberBox(), {
                    x: Math.min(svgCanvas$9.getRStartX() * zoom, realX),
                    y: Math.min(svgCanvas$9.getRStartY() * zoom, realY),
                    width: Math.abs(realX - svgCanvas$9.getRStartX() * zoom),
                    height: Math.abs(realY - svgCanvas$9.getRStartY() * zoom),
                });
            }
            svgCanvas$9.pathActions.mouseMove(x, y);
            break;
        }
        case "textedit": {
            x *= zoom;
            y *= zoom;
            svgCanvas$9.textActions.mouseMove(mouseX, mouseY);
            break;
        }
        case "rotate": {
            box = getBBox(selected);
            cx = box.x + box.width / 2;
            cy = box.y + box.height / 2;
            const m = getMatrix(selected);
            const center = transformPoint(cx, cy, m);
            cx = center.x;
            cy = center.y;
            angle = (Math.atan2(cy - y, cx - x) * (180 / Math.PI) - 90) % 360;
            if (svgCanvas$9.getCurConfig().gridSnapping) {
                angle = snapToGrid(angle);
            }
            if (evt.shiftKey) {
                // restrict rotations to nice angles (WRS)
                const snap = 45;
                angle = Math.round(angle / snap) * snap;
            }
            svgCanvas$9.setRotationAngle(
                angle < -180 ? 360 + angle : angle,
                true,
            );
            svgCanvas$9.call("transition", selectedElements);
            break;
        }
    }

    /**
     * The mouse has moved on the canvas area.
     * @event module:svgcanvas.SvgCanvas#event:ext_mouseMove
     * @type {PlainObject}
     * @property {MouseEvent} event The event object
     * @property {Float} mouse_x x coordinate on canvas
     * @property {Float} mouse_y y coordinate on canvas
     * @property {Element} selected Refers to the first selected element
     */
    svgCanvas$9.runExtensions(
        "mouseMove",
        /** @type {module:svgcanvas.SvgCanvas#event:ext_mouseMove} */ {
            event: evt,
            mouse_x: mouseX,
            mouse_y: mouseY,
            selected,
        },
    );
}; // mouseMove()

/**
 *
 * @returns {void}
 */
const mouseOutEvent = () => {
    if (svgCanvas$9.getCanvasIsLocked()) {
        svgCanvas$9.setStarted(false);
        return;
    }
    const { $id } = svgCanvas$9;
    if (svgCanvas$9.getCurrentMode() !== "select" && svgCanvas$9.getStarted()) {
        const event = new Event("mouseup");
        $id("svgcanvas").dispatchEvent(event);
    }
};

// - in create mode, the element's opacity is set properly, we create an InsertElementCommand
// and store it on the Undo stack
// - in move/resize mode, the element's attributes which were affected by the move/resize are
// identified, a ChangeElementCommand is created and stored on the stack for those attrs
// this is done in when we recalculate the selected dimensions()
/**
 *
 * @param {MouseEvent} evt
 * @fires module:svgcanvas.SvgCanvas#event:zoomed
 * @fires module:svgcanvas.SvgCanvas#event:changed
 * @fires module:svgcanvas.SvgCanvas#event:ext_mouseUp
 * @returns {void}
 */
const mouseUpEvent = (evt) => {
    if (svgCanvas$9.getCanvasIsLocked()) {
        svgCanvas$9.setStarted(false);
        return;
    }
    movingX = false;
    movingY = false;
    document.getElementById("editorContainer").classList.remove("cursor-move");
    moveSelectionThresholdReached = false;
    if (evt.button === 2) {
        return;
    }
    if (!svgCanvas$9.getStarted()) {
        return;
    }
    svgCanvas$9.textActions.init();
    const selectedElements = svgCanvas$9.getSelectedElements();
    const zoom = svgCanvas$9.getZoom();
    const tempJustSelected = svgCanvas$9.getJustSelected();
    svgCanvas$9.setJustSelected(null);
    const pt = transformPoint(
        evt.clientX,
        evt.clientY,
        svgCanvas$9.getrootSctm(),
    );
    const mouseX = pt.x * zoom;
    const mouseY = pt.y * zoom;
    const x = mouseX / zoom;
    const y = mouseY / zoom;
    let element = getElement(svgCanvas$9.getId());
    let keep = false;
    const realX = x;
    const realY = y;
    const mouseTarget = event.target;
    svgCanvas$9.setStarted(false);
    let t;
    switch (svgCanvas$9.getCurrentMode()) {
        // intentionally fall-through to select here
        case "resize":
        case "multiselect":
            if (svgCanvas$9.getRubberBox()) {
                svgCanvas$9.getRubberBox().setAttribute("display", "none");
                svgCanvas$9.setCurBBoxes([]);
            }
            svgCanvas$9.setCurrentMode("select");
        // Fallthrough
        case "select":
            if (selectedElements[0]) {
                // if we only have one selected element
                if (!selectedElements[1]) {
                    // set our current stroke/fill properties to the element's
                    const selected = selectedElements[0];
                    switch (selected.tagName) {
                        case "g":
                        case "use":
                        case "image":
                        case "foreignObject":
                            break;
                        case "text":
                            svgCanvas$9.setCurText(
                                "font_size",
                                selected.getAttribute("font-size"),
                            );
                            svgCanvas$9.setCurText(
                                "font_family",
                                "Inter-Regular",
                            );
                        // fallthrough
                        default:
                        /** 
              /* Set the selected element properties as default
              if (!selected.id.startsWith('connect')) {
                svgCanvas$9.setCurProperties('fill', selected.getAttribute('fill'));
                svgCanvas$9.setCurProperties('fill_opacity', selected.getAttribute('fill-opacity'));
                svgCanvas$9.setCurProperties('stroke', selected.getAttribute('stroke'));
                svgCanvas$9.setCurProperties('stroke_opacity', selected.getAttribute('stroke-opacity'));
                svgCanvas$9.setCurProperties('stroke_width', selected.getAttribute('stroke-width'));
                svgCanvas$9.setCurProperties('stroke_dasharray', selected.getAttribute('stroke-dasharray'));
                svgCanvas$9.setCurProperties('stroke_linejoin', selected.getAttribute('stroke-linejoin'));
                svgCanvas$9.setCurProperties('stroke_linecap', selected.getAttribute('stroke-linecap'));
              }
              */
                    }
                    if (selected?.id?.startsWith("ctrlLine")) {
                        let selectorGroup = getElement("selectorGroup0");
                        if (selectorGroup)
                            selectorGroup?.setAttribute("display", "none");
                        return;
                    }
                    svgCanvas$9.selectorManager
                        .requestSelector(selected)
                        .showGrips(selected.tagName !== "text");
                }
                // always recalculate dimensions to strip off stray identity transforms
                svgCanvas$9.recalculateAllSelectedDimensions();
                // if it was being dragged/resized
                if (
                    realX !== svgCanvas$9.getRStartX() ||
                    realY !== svgCanvas$9.getRStartY()
                ) {
                    const len = selectedElements.length;
                    for (let i = 0; i < len; ++i) {
                        if (!selectedElements[i]) {
                            break;
                        }
                        svgCanvas$9.selectorManager
                            .requestSelector(selectedElements[i])
                            .resize();
                    }
                    // no change in position/size, so maybe we should move to pathedit
                } else {
                    t = evt.target;
                    if (
                        selectedElements[0].nodeName === "path" &&
                        !selectedElements[1]
                    ) {
                        svgCanvas$9.pathActions.select(selectedElements[0]);
                        // if it was a path
                        // else, if it was selected and this is a shift-click, remove it from selection
                    } else if (evt.shiftKey && tempJustSelected !== t) {
                        svgCanvas$9.removeFromSelection([t]);
                    }
                } // no change in mouse position

                // Remove non-scaling stroke
                // const elem = selectedElements[0];
                // if (elem.tagName !== "foreignObject") {
                //     elem.removeAttribute("style");
                //     walkTree(elem, (el) => {
                //         el.removeAttribute("style");
                //     });
                // }
            }
            break;
        case "zoom": {
            svgCanvas$9.getRubberBox()?.setAttribute("display", "none");
            const factor = evt.shiftKey ? 0.5 : 2;
            svgCanvas$9.call("zoomed", {
                x: Math.min(svgCanvas$9.getRStartX(), realX),
                y: Math.min(svgCanvas$9.getRStartY(), realY),
                width: Math.abs(realX - svgCanvas$9.getRStartX()),
                height: Math.abs(realY - svgCanvas$9.getRStartY()),
                factor,
            });
            return;
        }
        case "fhpath": {
            // Check that the path contains at least 2 points; a degenerate one-point path
            // causes problems.
            // Webkit ignores how we set the points attribute with commas and uses space
            // to separate all coordinates, see https://bugs.webkit.org/show_bug.cgi?id=29870
            svgCanvas$9.setSumDistance(0);
            svgCanvas$9.setControllPoint2("x", 0);
            svgCanvas$9.setControllPoint2("y", 0);
            svgCanvas$9.setControllPoint1("x", 0);
            svgCanvas$9.setControllPoint1("y", 0);
            svgCanvas$9.setStart({
                x: 0,
                y: 0,
            });
            svgCanvas$9.setEnd("x", 0);
            svgCanvas$9.setEnd("y", 0);
            const coords = element.getAttribute("points");
            const commaIndex = coords.indexOf(",");
            keep =
                commaIndex >= 0
                    ? coords.includes(",", commaIndex + 1)
                    : coords.includes(" ", coords.indexOf(" ") + 1);
            if (keep) {
                element =
                    svgCanvas$9.pathActions.smoothPolylineIntoPath(element);
            }
            break;
        }
        case "line":
            {
                const x1 = element.getAttribute("x1");
                const y1 = element.getAttribute("y1");
                const x2 = element.getAttribute("x2");
                const y2 = element.getAttribute("y2");
                keep = x1 !== x2 || y1 !== y2;
            }
            break;
        case "foreignObject":
        case "square":
        case "rect":
        case "image":
            {
                const width = element.getAttribute("width");
                const height = element.getAttribute("height");
                // Image should be kept regardless of size (use inherit dimensions later)
                keep =
                    width || height || svgCanvas$9.getCurrentMode() === "image";
            }
            break;
        case "circle":
            keep = element.getAttribute("r") !== "0";
            break;
        case "ellipse":
            {
                const rx = Number(element.getAttribute("rx"));
                const ry = Number(element.getAttribute("ry"));
                keep = rx || ry;
            }
            break;
        case "fhellipse":
            if (
                svgCanvas$9.getFreehand("maxx") -
                    svgCanvas$9.getFreehand("minx") >
                    0 &&
                svgCanvas$9.getFreehand("maxy") -
                    svgCanvas$9.getFreehand("miny") >
                    0
            ) {
                element = svgCanvas$9.addSVGElementsFromJson({
                    element: "ellipse",
                    curStyles: true,
                    attr: {
                        cx:
                            (svgCanvas$9.getFreehand("minx") +
                                svgCanvas$9.getFreehand("maxx")) /
                            2,
                        cy:
                            (svgCanvas$9.getFreehand("miny") +
                                svgCanvas$9.getFreehand("maxy")) /
                            2,
                        rx:
                            (svgCanvas$9.getFreehand("maxx") -
                                svgCanvas$9.getFreehand("minx")) /
                            2,
                        ry:
                            (svgCanvas$9.getFreehand("maxy") -
                                svgCanvas$9.getFreehand("miny")) /
                            2,
                        id: svgCanvas$9.getId(),
                    },
                });
                svgCanvas$9.call("changed", [element]);
                keep = true;
            }
            break;
        case "fhrect":
            if (
                svgCanvas$9.getFreehand("maxx") -
                    svgCanvas$9.getFreehand("minx") >
                    0 &&
                svgCanvas$9.getFreehand("maxy") -
                    svgCanvas$9.getFreehand("miny") >
                    0
            ) {
                element = svgCanvas$9.addSVGElementsFromJson({
                    element: "rect",
                    curStyles: true,
                    attr: {
                        x: svgCanvas$9.getFreehand("minx"),
                        y: svgCanvas$9.getFreehand("miny"),
                        width:
                            svgCanvas$9.getFreehand("maxx") -
                            svgCanvas$9.getFreehand("minx"),
                        height:
                            svgCanvas$9.getFreehand("maxy") -
                            svgCanvas$9.getFreehand("miny"),
                        id: svgCanvas$9.getId(),
                    },
                });
                svgCanvas$9.call("changed", [element]);
                keep = true;
            }
            break;
        case "text":
            keep = true;
            svgCanvas$9.selectOnly([element]);
            svgCanvas$9.textActions.start(element);
            break;
        case "path": {
            // set element to null here so that it is not removed nor finalized
            element = null;
            // continue to be set to true so that mouseMove happens
            svgCanvas$9.setStarted(true);
            const res = svgCanvas$9.pathActions.mouseUp(
                evt,
                element,
                mouseX,
                mouseY,
            );
            ({ element } = res);
            ({ keep } = res);
            break;
        }
        case "pathedit":
            keep = true;
            element = null;
            svgCanvas$9.pathActions.mouseUp(evt);
            break;
        case "textedit":
            keep = false;
            element = null;
            svgCanvas$9.textActions.mouseUp(evt, mouseX, mouseY);
            break;
        case "rotate": {
            keep = true;
            element = null;
            svgCanvas$9.setCurrentMode("select");
            const batchCmd = svgCanvas$9.undoMgr.finishUndoableChange();
            if (!batchCmd.isEmpty()) {
                svgCanvas$9.addCommandToHistory(batchCmd);
            }
            // perform recalculation to weed out any stray identity transforms that might get stuck
            svgCanvas$9.recalculateAllSelectedDimensions();
            svgCanvas$9.call("changed", selectedElements);
            break;
        }
    }

    /**
     * The main (left) mouse button is released (anywhere).
     * @event module:svgcanvas.SvgCanvas#event:ext_mouseUp
     * @type {PlainObject}
     * @property {MouseEvent} event The event object
     * @property {Float} mouse_x x coordinate on canvas
     * @property {Float} mouse_y y coordinate on canvas
     */
    const extResult = svgCanvas$9.runExtensions(
        "mouseUp",
        {
            event: evt,
            mouse_x: mouseX,
            mouse_y: mouseY,
        },
        true,
    );
    extResult.forEach((r) => {
        if (r) {
            keep = r.keep || keep;
            ({ element } = r);
            svgCanvas$9.setStarted(r.started || svgCanvas$9.getStarted());
        }
    });
    if (!keep && element) {
        svgCanvas$9.getCurrentDrawing().releaseId(svgCanvas$9.getId());
        element = null;
        t = evt.target;
        return;
        // if this element is in a group, go up until we reach the top-level group
        element = null;
        t = evt.target;

        // if this element is in a group, go up until we reach the top-level group
        // just below the layer groups
        // TODO: once we implement links, we also would have to check for <a> elements
        while (t?.parentNode?.parentNode?.tagName === "g") {
            t = t.parentNode;
        }
        // if we are not in the middle of creating a path, and we've clicked on some shape,
        // then go to Select mode.
        // WebKit returns <div> when the canvas is clicked, Firefox/Opera return <svg>
        if (
            (svgCanvas$9.getCurrentMode() !== "path" ||
                !svgCanvas$9.getDrawnPath()) &&
            t &&
            t.parentNode?.id !== "selectorParentGroup" &&
            t.id !== "svgcanvas" &&
            t.id !== "svgroot"
        ) {
            // switch into "select" mode if we've clicked on an element;
        }
    } else if (element) {
        /**
      svgCanvas$9.selectOnly([t], true);
    }
    */
        /**
         * @name module:svgcanvas.SvgCanvas#addedNew
         * @type {boolean}
         */
        svgCanvas$9.addedNew = true;
        let aniDur = 0.2;
        let cAni;
        const curShape = svgCanvas$9.getStyle();
        const opacAni = svgCanvas$9.getOpacAni();
        if (
            opacAni.beginElement &&
            Number.parseFloat(element.getAttribute("opacity")) !==
                curShape.opacity
        ) {
            cAni = opacAni.cloneNode(true);
            cAni.setAttribute("to", curShape.opacity);
            cAni.setAttribute("dur", aniDur);
            element.appendChild(cAni);
            try {
                // Fails in FF4 on foreignObject
                cAni.beginElement();
            } catch (e) {
                /* empty fn */
            }
        } else {
            aniDur = 0;
        }

        // Ideally this would be done on the endEvent of the animation,
        // but that doesn't seem to be supported in Webkit
        setTimeout(() => {
            if (cAni) {
                cAni.remove();
            }

            if (svgCanvas$9.getCurrentMode() === "rect") {
                const width = element.getAttribute("width");
                const height = element.getAttribute("height");
                if (Number(width) == 0 && Number(height) == 0) {
                    element.remove();
                    return;
                }
            }
            element.setAttribute("opacity", curShape.opacity);
            element.setAttribute("style", "pointer-events:inherit");
            cleanupElement(element);
            if (svgCanvas$9.getCurrentMode() === "path") {
                if (element.getAttribute("type") == "rect") {
                    svgCanvas$9.setMode("select");
                    svgCanvas$9.call("set-select");
                    return;
                }
                svgCanvas$9.pathActions.toEditMode(element);
                svgCanvas$9.setMode("select");
                svgCanvas$9.call("set-select");
            } else if (svgCanvas$9.getCurConfig().selectNew) {
                const modes = [
                    "circle",
                    "ellipse",
                    "square",
                    "rect",
                    "fhpath",
                    "line",
                    "fhellipse",
                    "fhrect",
                    "star",
                    "polygon",
                ];
                if (modes.indexOf(svgCanvas$9.getCurrentMode()) !== -1) {
                    svgCanvas$9.setMode("select");
                    svgCanvas$9.call("set-select");
                }
                svgCanvas$9.selectOnly([element], true);
            }
            // we create the insert command that is stored on the stack
            // undo means to call cmd.unapply(), redo means to call cmd.apply()
            svgCanvas$9.addCommandToHistory(
                new InsertElementCommand$2(element),
            );
            svgCanvas$9.call("changed", [element]);
        }, aniDur * 1000);
    }
    svgCanvas$9.setStartTransform(null);
};
const dblClickEvent = (evt) => {
    if (svgCanvas$9.getCanvasIsLocked()) {
        svgCanvas$9.setStarted(false);
        return;
    }
    const selectedElements = svgCanvas$9.getSelectedElements();
    const evtTarget = evt.target;
    const parent = evtTarget.parentNode;
    let mouseTarget = svgCanvas$9.getMouseTarget(evt);
    if (mouseTarget.getAttribute("type")) return;
    const { tagName } = mouseTarget;
    if (tagName === "text" && svgCanvas$9.getCurrentMode() !== "textedit") {
        const pt = transformPoint(
            evt.clientX,
            evt.clientY,
            svgCanvas$9.getrootSctm(),
        );
        svgCanvas$9.textActions.select(mouseTarget, pt.x, pt.y);
    }

    // Do nothing if already in current group
    if (parent === svgCanvas$9.getCurrentGroup()) {
        return;
    }
    if ((tagName === "g" || tagName === "a") && getRotationAngle(mouseTarget)) {
        // TODO: Allow method of in-group editing without having to do
        // this (similar to editing rotated paths)

        // Ungroup and regroup
        svgCanvas$9.pushGroupProperties(mouseTarget);
        mouseTarget = selectedElements[0];
        svgCanvas$9.clearSelection(true);
    }
    // Reset context
    if (svgCanvas$9.getCurrentGroup()) {
        leaveContext();
    }
    if (
        (parent.tagName !== "g" && parent.tagName !== "a") ||
        parent === svgCanvas$9.getCurrentDrawing().getCurrentLayer() ||
        mouseTarget === svgCanvas$9.selectorManager.selectorParentGroup
    ) {
        // Escape from in-group edit
        return;
    }
    setContext(mouseTarget);
};

/**
 * Follows these conditions:
 * - When we are in a create mode, the element is added to the canvas but the
 *   action is not recorded until mousing up.
 * - When we are in select mode, select the element, remember the position
 *   and do nothing else.
 * @param {MouseEvent} evt
 * @fires module:svgcanvas.SvgCanvas#event:ext_mouseDown
 * @returns {void}
 */
const mouseDownEvent = (evt) => {
    if (svgCanvas$9.getCanvasIsLocked()) return;
    const dataStorage = svgCanvas$9.getDataStorage();
    const selectedElements = svgCanvas$9.getSelectedElements();
    const zoom = svgCanvas$9.getZoom();
    const curShape = svgCanvas$9.getStyle();
    const svgRoot = svgCanvas$9.getSvgRoot();
    const { $id } = svgCanvas$9;
    if (svgCanvas$9.spaceKey || evt.button === 1) {
        return;
    }
    const rightClick = evt.button === 2;
    if (evt.altKey) {
        // duplicate when dragging
        svgCanvas$9.cloneSelectedElements(0, 0);
    }
    svgCanvas$9.setRootSctm(
        $id("svgcontent").querySelector("g").getScreenCTM().inverse(),
    );
    const pt = transformPoint(
        evt.clientX,
        evt.clientY,
        svgCanvas$9.getrootSctm(),
    );
    const mouseX = pt.x * zoom;
    const mouseY = pt.y * zoom;
    posXMouseDown = mouseX;
    posYMouseDown = mouseY;
    movingX = false;
    movingY = false;
    evt.preventDefault();
    if (rightClick) {
        if (svgCanvas$9.getCurrentMode() === "path") {
            return;
        }
        svgCanvas$9.setCurrentMode("select");
        svgCanvas$9.setLastClickPoint(pt);
    }
    let x = mouseX / zoom;
    let y = mouseY / zoom;
    let mouseTarget = svgCanvas$9.getMouseTarget(evt);
    if (mouseTarget.tagName === "a" && mouseTarget.childNodes.length === 1) {
        mouseTarget = mouseTarget.firstChild;
    }

    // realX/y ignores grid-snap value
    const realX = x;
    svgCanvas$9.setStartX(x);
    svgCanvas$9.setRStartX(x);
    const realY = y;
    svgCanvas$9.setStartY(y);
    svgCanvas$9.setRStartY(y);
    if (svgCanvas$9.getCurConfig().gridSnapping) {
        x = snapToGrid(x);
        y = snapToGrid(y);
        svgCanvas$9.setStartX(snapToGrid(svgCanvas$9.getStartX()));
        svgCanvas$9.setStartY(snapToGrid(svgCanvas$9.getStartY()));
    }

    // if it is a selector grip, then it must be a single element selected,
    // set the mouseTarget to that and update the mode to rotate/resize

    if (
        mouseTarget === svgCanvas$9.selectorManager.selectorParentGroup &&
        selectedElements[0]
    ) {
        const grip = evt.target;
        const griptype = dataStorage.get(grip, "type");
        // rotating
        if (griptype === "rotate") {
            svgCanvas$9.setCurrentMode("rotate");
            // svgCanvas.setCurrentRotateMode(dataStorage.get(grip, 'dir'));
            // resizing
        } else if (griptype === "resize") {
            svgCanvas$9.setCurrentMode("resize");
            svgCanvas$9.setCurrentResizeMode(dataStorage.get(grip, "dir"));
        }
        mouseTarget = selectedElements[0];
    }
    svgCanvas$9.setStartTransform(mouseTarget.getAttribute("transform"));
    const tlist = getTransformList(mouseTarget);
    // consolidate transforms using standard SVG but keep the transformation used for the move/scale
    if (tlist.numberOfItems > 1) {
        const firstTransform = tlist.getItem(0);
        tlist.removeItem(0);
        tlist.consolidate();
        tlist.insertItemBefore(firstTransform, 0);
    }
    switch (svgCanvas$9.getCurrentMode()) {
        case "select":
            svgCanvas$9.setStarted(true);
            svgCanvas$9.setCurrentResizeMode("none");
            if (rightClick) {
                svgCanvas$9.setStarted(false);
            }
            if (mouseTarget !== svgRoot) {
                if (!selectedElements.includes(mouseTarget)) {
                    if (!evt.shiftKey) {
                        svgCanvas$9.clearSelection(true);
                    }
                    svgCanvas$9.addToSelection([mouseTarget]);
                    svgCanvas$9.setJustSelected(mouseTarget);
                    svgCanvas$9.pathActions.clear();
                }
                // else if it's a path, go into pathedit mode in mouseup

                // if (!rightClick) {
                //   // insert a dummy transform so if the element(s) are moved it will have
                //   // a transform to use for its translate
                //   for (const selectedElement of selectedElements) {
                //     if (!selectedElement) { continue }
                //     const slist = getTransformList(selectedElement)
                //     if (slist.numberOfItems) {
                //       slist.insertItemBefore(svgRoot.createSVGTransform(), 0)
                //     } else {
                //       slist.appendItem(svgRoot.createSVGTransform())
                //     }
                //   }
                // }

                //keep this here
            } else if (!rightClick) {
                svgCanvas$9.clearSelection();
                svgCanvas$9.setCurrentMode("multiselect");
                if (!svgCanvas$9.getRubberBox()) {
                    svgCanvas$9.setRubberBox(
                        svgCanvas$9.selectorManager.getRubberBandBox(),
                    );
                }
                svgCanvas$9.setRStartX(svgCanvas$9.getRStartX() * zoom);
                svgCanvas$9.setRStartY(svgCanvas$9.getRStartY() * zoom);
                assignAttributes(svgCanvas$9.getRubberBox(), {
                    x: svgCanvas$9.getRStartX(),
                    y: svgCanvas$9.getRStartY(),
                    width: 0,
                    height: 0,
                    display: "inline",
                });
            }
            break;
        case "zoom":
            svgCanvas$9.setStarted(true);
            if (!svgCanvas$9.getRubberBox()) {
                svgCanvas$9.setRubberBox(
                    svgCanvas$9.selectorManager.getRubberBandBox(),
                );
            }
            assignAttributes(svgCanvas$9.getRubberBox(), {
                x: realX * zoom,
                y: realX * zoom,
                width: 0,
                height: 0,
                display: "inline",
            });
            break;
        case "resize": {
            svgCanvas$9.setStarted(true);
            svgCanvas$9.setStartX(x);
            svgCanvas$9.setStartY(y);

            // Getting the BBox from the selection box, since we know we
            // want to orient around it
            svgCanvas$9.setInitBbox(getBBox($id("selectedBox0")));
            const bb = {};
            for (const [key, val] of Object.entries(
                svgCanvas$9.getInitBbox(),
            )) {
                bb[key] = val / zoom;
            }
            svgCanvas$9.setInitBbox(bb);

            // append three dummy transforms to the tlist so that
            // we can translate,scale,translate in mousemove
            const pos = getRotationAngle(mouseTarget) ? 1 : 0;
            if (hasMatrixTransform(tlist)) {
                tlist.insertItemBefore(svgRoot.createSVGTransform(), pos);
                tlist.insertItemBefore(svgRoot.createSVGTransform(), pos);
                tlist.insertItemBefore(svgRoot.createSVGTransform(), pos);
            } else {
                tlist.appendItem(svgRoot.createSVGTransform());
                tlist.appendItem(svgRoot.createSVGTransform());
                tlist.appendItem(svgRoot.createSVGTransform());
            }
            break;
        }
        case "fhellipse":
        case "fhrect":
        case "fhpath":
            svgCanvas$9.setStart({
                x: realX,
                y: realY,
            });
            svgCanvas$9.setControllPoint1("x", 0);
            svgCanvas$9.setControllPoint1("y", 0);
            svgCanvas$9.setControllPoint2("x", 0);
            svgCanvas$9.setControllPoint2("y", 0);
            svgCanvas$9.setStarted(true);
            svgCanvas$9.setDAttr(realX + "," + realY + " ");
            // Commented out as doing nothing now:
            // strokeW = parseFloat(curShape.stroke_width) === 0 ? 1 : curShape.stroke_width;
            svgCanvas$9.addSVGElementsFromJson({
                element: "polyline",
                curStyles: true,
                attr: {
                    points: svgCanvas$9.getDAttr(),
                    id: svgCanvas$9.getNextId(),
                    fill: "none",
                    opacity: curShape.opacity / 2,
                    "stroke-linecap": "round",
                    style: "pointer-events:none",
                },
            });
            svgCanvas$9.setFreehand("minx", realX);
            svgCanvas$9.setFreehand("maxx", realX);
            svgCanvas$9.setFreehand("miny", realY);
            svgCanvas$9.setFreehand("maxy", realY);
            break;
        case "image": {
            svgCanvas$9.setStarted(true);
            const newImage = svgCanvas$9.addSVGElementsFromJson({
                element: "image",
                attr: {
                    x,
                    y,
                    width: 0,
                    height: 0,
                    id: svgCanvas$9.getNextId(),
                    opacity: curShape.opacity / 2,
                    style: "pointer-events:inherit",
                },
            });
            setHref(newImage, svgCanvas$9.getLastGoodImgUrl());
            preventClickDefault(newImage);
            break;
        }
        case "square":
        // TODO: once we create the rect, we lose information that this was a square
        // (for resizing purposes this could be important)
        // Fallthrough
        case "rect":
            svgCanvas$9.setStarted(true);
            svgCanvas$9.setStartX(x);
            svgCanvas$9.setStartY(y);
            svgCanvas$9.addSVGElementsFromJson({
                element: "rect",
                curStyles: true,
                attr: {
                    x,
                    y,
                    width: 0,
                    height: 0,
                    id: svgCanvas$9.getNextId(),
                    opacity: curShape.opacity / 2,
                },
            });
            break;
        case "line": {
            svgCanvas$9.setStarted(true);
            const strokeW =
                Number(curShape.stroke_width) === 0 ? 1 : curShape.stroke_width;
            svgCanvas$9.addSVGElementsFromJson({
                element: "line",
                curStyles: true,
                attr: {
                    x1: x,
                    y1: y,
                    x2: x,
                    y2: y,
                    id: svgCanvas$9.getNextId(),
                    stroke: curShape.stroke,
                    "stroke-width": strokeW,
                    "stroke-dasharray": curShape.stroke_dasharray,
                    "stroke-linejoin": curShape.stroke_linejoin,
                    "stroke-linecap": curShape.stroke_linecap,
                    "stroke-opacity": curShape.stroke_opacity,
                    fill: "none",
                    opacity: curShape.opacity / 2,
                    style: "pointer-events:none",
                },
            });
            break;
        }
        case "circle":
            svgCanvas$9.setStarted(true);
            svgCanvas$9.addSVGElementsFromJson({
                element: "circle",
                curStyles: true,
                attr: {
                    cx: x,
                    cy: y,
                    r: 0,
                    id: svgCanvas$9.getNextId(),
                    opacity: curShape.opacity / 2,
                },
            });
            break;
        case "ellipse":
            svgCanvas$9.setStarted(true);
            svgCanvas$9.addSVGElementsFromJson({
                element: "ellipse",
                curStyles: true,
                attr: {
                    cx: x,
                    cy: y,
                    rx: 0,
                    ry: 0,
                    id: svgCanvas$9.getNextId(),
                    opacity: curShape.opacity / 2,
                },
            });
            break;
        case "text":
            svgCanvas$9.setStarted(true);
            /* const newText = */
            svgCanvas$9.addSVGElementsFromJson({
                element: "text",
                curStyles: true,
                attr: {
                    x,
                    y,
                    id: svgCanvas$9.getNextId(),
                    fill: svgCanvas$9.getCurText("fill"),
                    "stroke-width": svgCanvas$9.getCurText("stroke_width"),
                    "font-size": svgCanvas$9.getCurText("font_size"),
                    "font-family": "Inter-Regular",
                    "text-anchor": "middle",
                    "xml:space": "preserve",
                    opacity: curShape.opacity,
                },
            });
            // newText.textContent = 'text';
            break;
        case "path":
        // Fall through
        case "pathedit":
            svgCanvas$9.setStartX(svgCanvas$9.getStartX() * zoom);
            svgCanvas$9.setStartY(svgCanvas$9.getStartY() * zoom);
            svgCanvas$9.pathActions.mouseDown(
                evt,
                mouseTarget,
                svgCanvas$9.getStartX(),
                svgCanvas$9.getStartY(),
            );
            svgCanvas$9.setStarted(true);
            break;
        case "textedit":
            svgCanvas$9.setStartX(svgCanvas$9.getStartX() * zoom);
            svgCanvas$9.setStartY(svgCanvas$9.getStartY() * zoom);
            svgCanvas$9.textActions.mouseDown(
                evt,
                mouseTarget,
                svgCanvas$9.getStartX(),
                svgCanvas$9.getStartY(),
            );
            svgCanvas$9.setStarted(true);
            break;
        case "rotate":
            svgCanvas$9.setStarted(true);
            // we are starting an undoable change (a drag-rotation)
            svgCanvas$9.undoMgr.beginUndoableChange(
                "transform",
                selectedElements,
            );
            break;
    }

    /**
     * The main (left) mouse button is held down on the canvas area.
     * @event module:svgcanvas.SvgCanvas#event:ext_mouseDown
     * @type {PlainObject}
     * @property {MouseEvent} event The event object
     * @property {Float} start_x x coordinate on canvas
     * @property {Float} start_y y coordinate on canvas
     * @property {Element[]} selectedElements An array of the selected Elements
     */
    const extResult = svgCanvas$9.runExtensions(
        "mouseDown",
        {
            event: evt,
            start_x: svgCanvas$9.getStartX(),
            start_y: svgCanvas$9.getStartY(),
            selectedElements,
        },
        true,
    );
    extResult.forEach((r) => {
        if (r?.started) {
            svgCanvas$9.setStarted(true);
        }
    });
};
/**
 * @param {Event} e
 * @fires module:event.SvgCanvas#event:updateCanvas
 * @fires module:event.SvgCanvas#event:zoomDone
 * @returns {void}
 */
const DOMMouseScrollEvent = (e) => {
    const zoom = svgCanvas$9.getZoom();
    const { $id } = svgCanvas$9;
    if (!e.shiftKey) {
        return;
    }
    e.preventDefault();
    svgCanvas$9.setRootSctm(
        $id("svgcontent").querySelector("g").getScreenCTM().inverse(),
    );
    const workarea = document.getElementById("workarea");
    const scrbar = 15;
    const rulerwidth = svgCanvas$9.getCurConfig().showRulers ? 16 : 0;

    // mouse relative to content area in content pixels
    const pt = transformPoint(e.clientX, e.clientY, svgCanvas$9.getrootSctm());

    // full work area width in screen pixels
    const editorFullW = parseFloat(
        getComputedStyle(workarea, null).width.replace("px", ""),
    );
    const editorFullH = parseFloat(
        getComputedStyle(workarea, null).height.replace("px", ""),
    );

    // work area width minus scroll and ruler in screen pixels
    const editorW = editorFullW - scrbar - rulerwidth;
    const editorH = editorFullH - scrbar - rulerwidth;

    // work area width in content pixels
    const workareaViewW = editorW * svgCanvas$9.getrootSctm().a;
    const workareaViewH = editorH * svgCanvas$9.getrootSctm().d;

    // content offset from canvas in screen pixels
    const wOffset = findPos(workarea);
    const wOffsetLeft = wOffset.left + rulerwidth;
    const wOffsetTop = wOffset.top + rulerwidth;
    const delta = e.wheelDelta ? e.wheelDelta : e.detail ? -e.detail : 0;
    if (!delta) {
        return;
    }
    let factor = Math.max(3 / 4, Math.min(4 / 3, delta));
    let wZoom;
    let hZoom;
    if (factor > 1) {
        wZoom = Math.ceil((editorW / workareaViewW) * factor * 100) / 100;
        hZoom = Math.ceil((editorH / workareaViewH) * factor * 100) / 100;
    } else {
        wZoom = Math.floor((editorW / workareaViewW) * factor * 100) / 100;
        hZoom = Math.floor((editorH / workareaViewH) * factor * 100) / 100;
    }
    let zoomlevel = Math.min(wZoom, hZoom);
    zoomlevel = Math.min(10, Math.max(0.01, zoomlevel));
    if (zoomlevel === zoom) {
        return;
    }
    factor = zoomlevel / zoom;

    // top left of workarea in content pixels before zoom
    const topLeftOld = transformPoint(
        wOffsetLeft,
        wOffsetTop,
        svgCanvas$9.getrootSctm(),
    );

    // top left of workarea in content pixels after zoom
    const topLeftNew = {
        x: pt.x - (pt.x - topLeftOld.x) / factor,
        y: pt.y - (pt.y - topLeftOld.y) / factor,
    };

    // top left of workarea in canvas pixels relative to content after zoom
    const topLeftNewCanvas = {
        x: topLeftNew.x * zoomlevel,
        y: topLeftNew.y * zoomlevel,
    };

    // new center in canvas pixels
    const newCtr = {
        x: topLeftNewCanvas.x - rulerwidth + editorFullW / 2,
        y: topLeftNewCanvas.y - rulerwidth + editorFullH / 2,
    };
    svgCanvas$9.setZoom(zoomlevel);
    document.getElementById("zoom").value = (zoomlevel * 100).toFixed(1);
    svgCanvas$9.call("updateCanvas", {
        center: false,
        newCtr,
    });
    svgCanvas$9.call("zoomDone");
};

/**
 * Tools for SVG handle on JSON format.
 * @module svgcanvas
 * @license MIT
 *
 * @copyright 2010 Alexis Deveria, 2010 Jeff Schiller
 */
let svgCanvas$8 = null;
let svgdoc_ = null;

/**
 * @function module:json.jsonContext#getSelectedElements
 * @returns {Element[]} the array with selected DOM elements
 */
/**
 * @function module:json.jsonContext#getDOMDocument
 * @returns {HTMLDocument}
 */

/**
 * @function module:json.init
 * @param {module:json.jsonContext} jsonContext
 * @returns {void}
 */
const init$8 = (canvas) => {
    svgCanvas$8 = canvas;
    svgdoc_ = canvas.getDOMDocument();
};
/**
 * @function module:json.getJsonFromSvgElements Iterate element and return json format
 * @param {ArgumentsArray} data - element
 * @returns {svgRootElement}
 */
const getJsonFromSvgElements = (data) => {
    // Text node
    if (data.nodeType === 3) return data.nodeValue;
    const retval = {
        element: data.tagName,
        // namespace: nsMap[data.namespaceURI],
        attr: {},
        children: [],
    };

    if (!(data instanceof SVGElement)) {
        retval.element = retval.element.toLowerCase();
    }

    // Iterate attributes
    for (let i = 0, attr; (attr = data.attributes[i]); i++) {
        retval.attr[attr.name] = attr.value;
    }

    // Iterate children
    for (let i = 0, node; (node = data.childNodes[i]); i++) {
        retval.children[i] = getJsonFromSvgElements(node);
    }
    return retval;
};

/**
 * This should really be an intersection implementing all rather than a union.
 * @name module:json.addSVGElementsFromJson
 * @type {module:utilities.EditorContext#addSVGElementsFromJson|module:path.EditorContext#addSVGElementsFromJson}
 */

const addSVGElementsFromJson = (data) => {
    if (typeof data === "string") return svgdoc_.createTextNode(data);
    let shape = getElement(data.attr.id);
    // if shape is a path but we need to create a rect/ellipse, then remove the path
    const currentLayer = svgCanvas$8.getDrawing().getCurrentLayer();
    if (shape && data.element !== shape.tagName) {
        shape.remove();
        shape = null;
    }
    if (!shape) {
        const svgElements = [
            "rect",
            "ellipse",
            "line",
            "path",
            "image",
            "g",
            "svg",
            "clipPath",
            "foreignObject",
            "text",
            "a",
            "circle",
            "polygon",
            "polyline",
            "tspan",
            "use",
        ];
        if (svgElements.includes(data.element)) {
            const ns = data.namespace || NS.SVG;
            shape = svgdoc_.createElementNS(ns, data.element);
        } else {
            shape = svgdoc_.createElement(data.element.toLowerCase());
        }

        if (currentLayer) {
            (svgCanvas$8.getCurrentGroup() || currentLayer).append(shape);
        }
    }
    const curShape = svgCanvas$8.getCurShape();
    if (data.curStyles) {
        assignAttributes(shape, {
            fill: curShape.fill,
            stroke: curShape.stroke,
            "stroke-width": curShape.strokeWidth,
            "stroke-dasharray": curShape.stroke_dasharray,
            "stroke-linejoin": curShape.stroke_linejoin,
            "stroke-linecap": curShape.stroke_linecap,
            "stroke-opacity": curShape.stroke_opacity,
            "fill-opacity": curShape.fill_opacity,
            opacity: curShape.opacity / 2,
            style: "pointer-events:inherit",
        });
    }
    assignAttributes(shape, data.attr);
    cleanupElement(shape);

    if (data.text) {
        shape.textContent = data.text;
    }

    // Children
    if (data.children) {
        data.children.forEach((child) => {
            shape.append(addSVGElementsFromJson(child));
        });
    }
    return shape;
};

/**
 * @module elem-get-set get and set methods.
 * @license MIT
 * @copyright 2011 Jeff Schiller
 */
let svgCanvas$7 = null;

/**
 * @function module:elem-get-set.init
 * @param {module:elem-get-set.elemContext} elemContext
 * @returns {void}
 */
const init$7 = (canvas) => {
    svgCanvas$7 = canvas;
    svgCanvas$7.getBold = getBoldMethod; // Check whether selected element is bold or not.
    svgCanvas$7.setBold = setBoldMethod; // Make the selected element bold or normal.
    svgCanvas$7.getItalic = getItalicMethod; // Check whether selected element is in italics or not.
    svgCanvas$7.setItalic = setItalicMethod; // Make the selected element italic or normal.
    svgCanvas$7.hasTextDecoration = hasTextDecorationMethod; // Check whether the selected element has the given text decoration or not.
    svgCanvas$7.addTextDecoration = addTextDecorationMethod; // Adds the given value to the text decoration
    svgCanvas$7.removeTextDecoration = removeTextDecorationMethod; // Removes the given value from the text decoration
    svgCanvas$7.setTextAnchor = setTextAnchorMethod; // Set the new text anchor.
    svgCanvas$7.setLetterSpacing = setLetterSpacingMethod; // Set the new letter spacing.
    svgCanvas$7.setWordSpacing = setWordSpacingMethod; // Set the new word spacing.
    svgCanvas$7.setTextLength = setTextLengthMethod; // Set the new text length.
    svgCanvas$7.setLengthAdjust = setLengthAdjustMethod; // Set the new length adjust.
    svgCanvas$7.getFontFamily = getFontFamilyMethod; // The current font family
    svgCanvas$7.setFontFamily = setFontFamilyMethod; // Set the new font family.
    svgCanvas$7.setFontColor = setFontColorMethod; // Set the new font color.
    svgCanvas$7.getFontColor = getFontColorMethod; // The current font color
    svgCanvas$7.getFontSize = getFontSizeMethod; // The current font size
    svgCanvas$7.setFontSize = setFontSizeMethod; // Applies the given font size to the selected element.
    svgCanvas$7.getText = getTextMethod; // current text (`textContent`) of the selected element
    svgCanvas$7.setTextContent = setTextContentMethod; // Updates the text element with the given string.
    svgCanvas$7.setImageURL = setImageURLMethod; // Sets the new image URL for the selected image element
    svgCanvas$7.setLinkURL = setLinkURLMethod; // Sets the new link URL for the selected anchor element.
    svgCanvas$7.setRectRadius = setRectRadiusMethod; // Sets the `rx` and `ry` values to the selected `rect` element
    svgCanvas$7.makeHyperlink = makeHyperlinkMethod; // Wraps the selected element(s) in an anchor element or converts group to one.
    svgCanvas$7.removeHyperlink = removeHyperlinkMethod;
    svgCanvas$7.setSegType = setSegTypeMethod; // Sets the new segment type to the selected segment(s).
    svgCanvas$7.setStrokeWidth = setStrokeWidthMethod; // Sets the stroke width for the current selected elements.
    svgCanvas$7.getResolution = getResolutionMethod; // The current dimensions and zoom level in an object
    svgCanvas$7.getTitle = getTitleMethod; // the current group/SVG's title contents or `undefined` if no element
    svgCanvas$7.setGroupTitle = setGroupTitleMethod; // Sets the group/SVG's title content.
    svgCanvas$7.setStrokeAttr = setStrokeAttrMethod; // Set the given stroke-related attribute the given value for selected elements.
    svgCanvas$7.setBackground = setBackgroundMethod; // Set the background of the editor (NOT the actual document).
    svgCanvas$7.setDocumentTitle = setDocumentTitleMethod; // Adds/updates a title element for the document with the given name.
    svgCanvas$7.getEditorNS = getEditorNSMethod; // Returns the editor's namespace URL, optionally adding it to the root element.
    svgCanvas$7.setResolution = setResolutionMethod; // Changes the document's dimensions to the given size.
    svgCanvas$7.setBBoxZoom = setBBoxZoomMethod; // Sets the zoom level on the canvas-side based on the given value.
    svgCanvas$7.setCurrentZoom = setZoomMethod; // Sets the zoom to the given level.
    svgCanvas$7.setColor = setColorMethod; // Change the current stroke/fill color/gradien
    svgCanvas$7.setGradient = setGradientMethod; // Apply the current gradient to selected element's fill or stroke.
    svgCanvas$7.setPaint = setPaintMethod; // Set a color/gradient to a fill/stroke.
};

/**
 * @function module:elem-get-set.SvgCanvas#getResolution
 * @returns {DimensionsAndZoom} The current dimensions and zoom level in an object
 */
const getResolutionMethod = () => {
    const zoom = svgCanvas$7.getZoom();
    const w = svgCanvas$7.getSvgContent().getAttribute("width") / zoom;
    const h = svgCanvas$7.getSvgContent().getAttribute("height") / zoom;
    return {
        w,
        h,
        zoom,
    };
};

/**
 * @function module:elem-get-set.SvgCanvas#getTitle
 * @param {Element} [elem]
 * @returns {string|void} the current group/SVG's title contents or
 * `undefined` if no element is passed nd there are no selected elements.
 */
const getTitleMethod = (elem) => {
    const selectedElements = svgCanvas$7.getSelectedElements();
    const dataStorage = svgCanvas$7.getDataStorage();
    elem = elem || selectedElements[0];
    if (!elem) {
        return undefined;
    }
    if (dataStorage.has(elem, "gsvg")) {
        elem = dataStorage.get(elem, "gsvg");
    } else if (dataStorage.has(elem, "symbol")) {
        elem = dataStorage.get(elem, "symbol");
    }
    const childs = elem.childNodes;
    for (const child of childs) {
        if (child.nodeName === "title") {
            return child.textContent;
        }
    }
    return "";
};

/**
 * Sets the group/SVG's title content.
 * @function module:elem-get-set.SvgCanvas#setGroupTitle
 * @param {string} val
 * @todo Combine this with `setDocumentTitle`
 * @returns {void}
 */
const setGroupTitleMethod = (val) => {
    const {
        InsertElementCommand,
        RemoveElementCommand,
        ChangeElementCommand,
        BatchCommand,
    } = svgCanvas$7.history;
    const selectedElements = svgCanvas$7.getSelectedElements();
    const dataStorage = svgCanvas$7.getDataStorage();
    let elem = selectedElements[0];
    if (dataStorage.has(elem, "gsvg")) {
        elem = dataStorage.get(elem, "gsvg");
    }
    const ts = elem.querySelectorAll("title");
    const batchCmd = new BatchCommand("Set Label");
    let title;
    if (val.length === 0) {
        // Remove title element
        const tsNextSibling = ts.nextSibling;
        batchCmd.addSubCommand(
            new RemoveElementCommand(ts[0], tsNextSibling, elem),
        );
        ts.remove();
    } else if (ts.length) {
        // Change title contents
        title = ts[0];
        batchCmd.addSubCommand(
            new ChangeElementCommand(title, {
                "#text": title.textContent,
            }),
        );
        title.textContent = val;
    } else {
        // Add title element
        title = svgCanvas$7.getDOMDocument().createElementNS(NS.SVG, "title");
        title.textContent = val;
        elem.insertBefore(title, elem.firstChild);
        batchCmd.addSubCommand(new InsertElementCommand(title));
    }
    svgCanvas$7.addCommandToHistory(batchCmd);
};

/**
 * Adds/updates a title element for the document with the given name.
 * This is an undoable action.
 * @function module:elem-get-set.SvgCanvas#setDocumentTitle
 * @param {string} newTitle - String with the new title
 * @returns {void}
 */
const setDocumentTitleMethod = (newTitle) => {
    const { ChangeElementCommand, BatchCommand } = svgCanvas$7.history;
    const childs = svgCanvas$7.getSvgContent().childNodes;
    let docTitle = false;
    let oldTitle = "";
    const batchCmd = new BatchCommand("Change Image Title");
    for (const child of childs) {
        if (child.nodeName === "title") {
            docTitle = child;
            oldTitle = docTitle.textContent;
            break;
        }
    }
    if (!docTitle) {
        docTitle = svgCanvas$7
            .getDOMDocument()
            .createElementNS(NS.SVG, "title");
        svgCanvas$7
            .getSvgContent()
            .insertBefore(docTitle, svgCanvas$7.getSvgContent().firstChild);
        // svgContent.firstChild.before(docTitle); // Ok to replace above with this?
    }

    if (newTitle.length) {
        docTitle.textContent = newTitle;
    } else {
        // No title given, so element is not necessary
        docTitle.remove();
    }
    batchCmd.addSubCommand(
        new ChangeElementCommand(docTitle, {
            "#text": oldTitle,
        }),
    );
    svgCanvas$7.addCommandToHistory(batchCmd);
};

/**
 * Changes the document's dimensions to the given size.
 * @function module:elem-get-set.SvgCanvas#setResolution
 * @param {Float|"fit"} x - Number with the width of the new dimensions in user units.
 * Can also be the string "fit" to indicate "fit to content".
 * @param {Float} y - Number with the height of the new dimensions in user units.
 * @fires module:elem-get-set.SvgCanvas#event:changed
 * @returns {boolean} Indicates if resolution change was successful.
 * It will fail on "fit to content" option with no content to fit to.
 */
const setResolutionMethod = (x, y) => {
    const { ChangeElementCommand, BatchCommand } = svgCanvas$7.history;
    const zoom = svgCanvas$7.getZoom();
    const res = svgCanvas$7.getResolution();
    const { w, h } = res;
    let batchCmd;
    if (x === "fit") {
        // Get bounding box
        const bbox = getStrokedBBoxDefaultVisible();
        if (bbox) {
            batchCmd = new BatchCommand("Fit Canvas to Content");
            const visEls = getVisibleElements();
            svgCanvas$7.addToSelection(visEls);
            const dx = [];
            const dy = [];
            visEls.forEach((_item, _i) => {
                dx.push(bbox.x * -1);
                dy.push(bbox.y * -1);
            });
            const cmd = svgCanvas$7.moveSelectedElements(dx, dy, true);
            batchCmd.addSubCommand(cmd);
            svgCanvas$7.clearSelection();
            x = Math.round(bbox.width);
            y = Math.round(bbox.height);
        } else {
            return false;
        }
    }
    if (x !== w || y !== h) {
        if (!batchCmd) {
            batchCmd = new BatchCommand("Change Image Dimensions");
        }
        x = convertToNum("width", x);
        y = convertToNum("height", y);
        svgCanvas$7.getSvgContent().setAttribute("width", x);
        svgCanvas$7.getSvgContent().setAttribute("height", y);
        svgCanvas$7.contentW = x;
        svgCanvas$7.contentH = y;
        batchCmd.addSubCommand(
            new ChangeElementCommand(svgCanvas$7.getSvgContent(), {
                width: w,
                height: h,
            }),
        );
        svgCanvas$7
            .getSvgContent()
            .setAttribute("viewBox", [0, 0, x / zoom, y / zoom].join(" "));
        batchCmd.addSubCommand(
            new ChangeElementCommand(svgCanvas$7.getSvgContent(), {
                viewBox: ["0 0", w, h].join(" "),
            }),
        );
        svgCanvas$7.addCommandToHistory(batchCmd);
        svgCanvas$7.call("changed", [svgCanvas$7.getSvgContent()]);
    }
    return true;
};

/**
 * Returns the editor's namespace URL, optionally adding it to the root element.
 * @function module:elem-get-set.SvgCanvas#getEditorNS
 * @param {boolean} [add] - Indicates whether or not to add the namespace value
 * @returns {string} The editor's namespace URL
 */
const getEditorNSMethod = (add) => {
    if (add) {
        svgCanvas$7.getSvgContent().setAttribute("xmlns:se", NS.SE);
    }
    return NS.SE;
};

/**
 * @typedef {PlainObject} module:elem-get-set.ZoomAndBBox
 * @property {Float} zoom
 * @property {module:utilities.BBoxObject} bbox
 */
/**
 * Sets the zoom level on the canvas-side based on the given value.
 * @function module:elem-get-set.SvgCanvas#setBBoxZoom
 * @param {"selection"|"canvas"|"content"|"layer"|module:SVGEditor.BBoxObjectWithFactor} val - Bounding box object to zoom to or string indicating zoom option. Note: the object value type is defined in `svg-editor.js`
 * @param {Integer} editorW - The editor's workarea box's width
 * @param {Integer} editorH - The editor's workarea box's height
 * @returns {module:elem-get-set.ZoomAndBBox|void}
 */
const setBBoxZoomMethod = (val, editorW, editorH) => {
    const zoom = svgCanvas$7.getZoom();
    const selectedElements = svgCanvas$7.getSelectedElements();
    let spacer = 0.85;
    let bb;
    const calcZoom = (bb) => {
        if (!bb) {
            return false;
        }
        const wZoom = Math.round((editorW / bb.width) * 100 * spacer) / 100;
        const hZoom = Math.round((editorH / bb.height) * 100 * spacer) / 100;
        const zoom = Math.min(wZoom, hZoom);
        svgCanvas$7.setZoom(zoom);
        return {
            zoom,
            bbox: bb,
        };
    };
    if (typeof val === "object") {
        bb = val;
        if (bb.width === 0 || bb.height === 0) {
            const newzoom = bb.zoom ? bb.zoom : zoom * bb.factor;
            svgCanvas$7.setZoom(newzoom);
            return {
                zoom,
                bbox: bb,
            };
        }
        return calcZoom(bb);
    }
    switch (val) {
        case "selection": {
            if (!selectedElements[0]) {
                return undefined;
            }
            const selectedElems = selectedElements.map((n, _) => {
                if (n) {
                    return n;
                }
                return undefined;
            });
            bb = getStrokedBBoxDefaultVisible(selectedElems);
            break;
        }
        case "canvas": {
            const res = svgCanvas$7.getResolution();
            spacer = 0.95;
            bb = {
                width: res.w,
                height: res.h,
                x: 0,
                y: 0,
            };
            break;
        }
        case "content":
            bb = getStrokedBBoxDefaultVisible();
            break;
        case "layer":
            bb = getStrokedBBoxDefaultVisible(
                getVisibleElements(
                    svgCanvas$7.getCurrentDrawing().getCurrentLayer(),
                ),
            );
            break;
        default:
            return undefined;
    }
    return calcZoom(bb);
};

/**
 * Sets the zoom to the given level.
 * @function module:elem-get-set.SvgCanvas#setZoom
 * @param {Float} zoomLevel - Float indicating the zoom level to change to
 * @fires module:elem-get-set.SvgCanvas#event:ext_zoomChanged
 * @returns {void}
 */
const setZoomMethod = (zoomLevel) => {
    const selectedElements = svgCanvas$7.getSelectedElements();
    const res = svgCanvas$7.getResolution();
    svgCanvas$7
        .getSvgContent()
        .setAttribute(
            "viewBox",
            "0 0 " + res.w / zoomLevel + " " + res.h / zoomLevel,
        );
    svgCanvas$7.setZoom(zoomLevel);
    selectedElements.forEach((elem) => {
        if (!elem) {
            return;
        }
        svgCanvas$7.selectorManager.requestSelector(elem).resize();
    });
    svgCanvas$7.pathActions.zoomChange();
    svgCanvas$7.runExtensions("zoomChanged", zoomLevel);
};

/**
 * Change the current stroke/fill color/gradient value.
 * @function module:elem-get-set.SvgCanvas#setColor
 * @param {string} type - String indicating fill or stroke
 * @param {string} val - The value to set the stroke attribute to
 * @param {boolean} preventUndo - Boolean indicating whether or not svgCanvas should be an undoable option
 * @fires module:elem-get-set.SvgCanvas#event:changed
 * @returns {void}
 */
const setColorMethod = (type, val, preventUndo) => {
    const selectedElements = svgCanvas$7.getSelectedElements();
    /** 
  /* Set the selected element {{val}} {{type}} as default
  svgCanvas$7.setCurShape(type, val);
  svgCanvas$7.setCurProperties(type + '_paint', {
    type: 'solidColor'
  });
  */
    const elems = [];
    /**
     *
     * @param {Element} e
     * @returns {void}
     */
    const addNonG = (e) => {
        if (e.nodeName !== "g") {
            elems.push(e);
        }
    };
    let i = selectedElements.length;
    while (i--) {
        const elem = selectedElements[i];
        if (elem) {
            if (elem.tagName === "g") {
                walkTree(elem, addNonG);
            } else if (type === "fill") {
                if (elem.tagName !== "polyline" && elem.tagName !== "line") {
                    elems.push(elem);
                }
            } else {
                elems.push(elem);
            }
        }
    }
    if (elems.length > 0) {
        if (!preventUndo) {
            svgCanvas$7.changeSelectedAttribute(type, val, elems);
            svgCanvas$7.call("changed", elems);
        } else {
            svgCanvas$7.changeSelectedAttributeNoUndo(type, val, elems);
        }
    }
};

/**
 * Apply the current gradient to selected element's fill or stroke.
 * @function module:elem-get-set.SvgCanvas#setGradient
 * @param {"fill"|"stroke"} type - String indicating "fill" or "stroke" to apply to an element
 * @returns {void}
 */
const setGradientMethod = (type) => {
    if (
        !svgCanvas$7.getCurProperties(type + "_paint") ||
        svgCanvas$7.getCurProperties(type + "_paint").type === "solidColor"
    ) {
        return;
    }
    const canvas = svgCanvas$7;
    let grad = canvas[type + "Grad"];
    // find out if there is a duplicate gradient already in the defs
    const duplicateGrad = findDuplicateGradient(grad);
    const defs = findDefs();
    // no duplicate found, so import gradient into defs
    if (!duplicateGrad) {
        // const origGrad = grad;
        grad = svgCanvas$7.getDOMDocument().importNode(grad, true);
        defs.append(grad);
        // get next id and set it on the grad
        grad.id = svgCanvas$7.getNextId();
    } else {
        // use existing gradient
        grad = duplicateGrad;
    }
    svgCanvas$7.setColor(type, "url(#" + grad.id + ")");
};

/**
 * Check if exact gradient already exists.
 * @function module:svgcanvas~findDuplicateGradient
 * @param {SVGGradientElement} grad - The gradient DOM element to compare to others
 * @returns {SVGGradientElement} The existing gradient if found, `null` if not
 */
const findDuplicateGradient = (grad) => {
    const defs = findDefs();
    const existingGrads = defs.querySelectorAll(
        "linearGradient, radialGradient",
    );
    let i = existingGrads.length;
    const radAttrs = ["r", "cx", "cy", "fx", "fy"];
    while (i--) {
        const og = existingGrads[i];
        if (grad.tagName === "linearGradient") {
            if (
                grad.getAttribute("x1") !== og.getAttribute("x1") ||
                grad.getAttribute("y1") !== og.getAttribute("y1") ||
                grad.getAttribute("x2") !== og.getAttribute("x2") ||
                grad.getAttribute("y2") !== og.getAttribute("y2")
            ) {
                continue;
            }
        } else {
            const gradAttrs = {
                r: Number(grad.getAttribute("r")),
                cx: Number(grad.getAttribute("cx")),
                cy: Number(grad.getAttribute("cy")),
                fx: Number(grad.getAttribute("fx")),
                fy: Number(grad.getAttribute("fy")),
            };
            const ogAttrs = {
                r: Number(og.getAttribute("r")),
                cx: Number(og.getAttribute("cx")),
                cy: Number(og.getAttribute("cy")),
                fx: Number(og.getAttribute("fx")),
                fy: Number(og.getAttribute("fy")),
            };
            let diff = false;
            radAttrs.forEach((attr) => {
                if (gradAttrs[attr] !== ogAttrs[attr]) {
                    diff = true;
                }
            });
            if (diff) {
                continue;
            }
        }

        // else could be a duplicate, iterate through stops
        const stops = grad.getElementsByTagNameNS(NS.SVG, "stop");
        const ostops = og.getElementsByTagNameNS(NS.SVG, "stop");
        if (stops.length !== ostops.length) {
            continue;
        }
        let j = stops.length;
        while (j--) {
            const stop = stops[j];
            const ostop = ostops[j];
            if (
                stop.getAttribute("offset") !== ostop.getAttribute("offset") ||
                stop.getAttribute("stop-opacity") !==
                    ostop.getAttribute("stop-opacity") ||
                stop.getAttribute("stop-color") !==
                    ostop.getAttribute("stop-color")
            ) {
                break;
            }
        }
        if (j === -1) {
            return og;
        }
    } // for each gradient in defs

    return null;
};

/**
 * Set a color/gradient to a fill/stroke.
 * @function module:elem-get-set.SvgCanvas#setPaint
 * @param {"fill"|"stroke"} type - String with "fill" or "stroke"
 * @param {} paint - The paint object to apply
 * @returns {void}
 */
const setPaintMethod = (type, paint) => {
    // make a copy
    const p = new Paint(paint);
    svgCanvas$7.setPaintOpacity(type, p.alpha / 100, true);

    // svgCanvas$7.setCurProperties(type + '_paint', p);
    switch (p.type) {
        case "solidColor":
            svgCanvas$7.setColor(
                type,
                p.solidColor !== "none" ? "#" + p.solidColor : "none",
            );
            break;
        case "linearGradient":
        case "radialGradient":
            svgCanvas$7.setCanvas(type + "Grad", p[p.type]);
            svgCanvas$7.setGradient(type);
            break;
    }
};
/**
 * Sets the stroke width for the current selected elements.
 * When attempting to set a line's width to 0, this changes it to 1 instead.
 * @function module:elem-get-set.SvgCanvas#setStrokeWidth
 * @param {Float} val - A Float indicating the new stroke width value
 * @fires module:elem-get-set.SvgCanvas#event:changed
 * @returns {void}
 */
const setStrokeWidthMethod = (val) => {
    const selectedElements = svgCanvas$7.getSelectedElements();
    if (val === 0 && ["line", "path"].includes(svgCanvas$7.getMode())) {
        svgCanvas$7.setStrokeWidth(1);
        return;
    }
    // svgCanvas$7.setCurProperties('stroke_width', val);
    const elems = [];
    /**
     *
     * @param {Element} e
     * @returns {void}
     */
    const addNonG = (e) => {
        if (e.nodeName !== "g") {
            elems.push(e);
        }
    };
    let i = selectedElements.length;
    while (i--) {
        const elem = selectedElements[i];
        if (elem) {
            if (elem.tagName === "g") {
                walkTree(elem, addNonG);
            } else {
                elems.push(elem);
            }
        }
    }
    if (elems.length > 0) {
        svgCanvas$7.changeSelectedAttribute("stroke-width", val, elems);
        svgCanvas$7.call("changed", selectedElements);
    }
};

/**
 * Set the given stroke-related attribute the given value for selected elements.
 * @function module:elem-get-set.SvgCanvas#setStrokeAttr
 * @param {string} attr - String with the attribute name
 * @param {string|Float} val - String or number with the attribute value
 * @fires module:elem-get-set.SvgCanvas#event:changed
 * @returns {void}
 */
const setStrokeAttrMethod = (attr, val) => {
    const selectedElements = svgCanvas$7.getSelectedElements();
    // svgCanvas$7.setCurShape(attr.replace('-', '_'), val);
    const elems = [];
    let i = selectedElements.length;
    while (i--) {
        const elem = selectedElements[i];
        if (elem) {
            if (elem.tagName === "g") {
                walkTree(elem, (e) => {
                    if (e.nodeName !== "g") {
                        elems.push(e);
                    }
                });
            } else {
                elems.push(elem);
            }
        }
    }
    if (elems.length > 0) {
        svgCanvas$7.changeSelectedAttribute(attr, val, elems);
        svgCanvas$7.call("changed", selectedElements);
    }
};
/**
 * Check whether selected element is bold or not.
 * @function module:svgcanvas.SvgCanvas#getBold
 * @returns {boolean} Indicates whether or not element is bold
 */
const getBoldMethod = () => {
    const selectedElements = svgCanvas$7.getSelectedElements();
    // should only have one element selected
    const selected = selectedElements[0];
    if (selected?.tagName === "text" && !selectedElements[1]) {
        return selected.getAttribute("font-weight") === "bold";
    }
    return false;
};

/**
 * Make the selected element bold or normal.
 * @function module:svgcanvas.SvgCanvas#setBold
 * @param {boolean} b - Indicates bold (`true`) or normal (`false`)
 * @returns {void}
 */
const setBoldMethod = (b) => {
    const selectedElements = svgCanvas$7.getSelectedElements();
    const selected = selectedElements[0];
    if (selected?.tagName === "text" && !selectedElements[1]) {
        svgCanvas$7.changeSelectedAttribute(
            "font-weight",
            b ? "bold" : "normal",
        );
    }
    if (!selectedElements[0].textContent) {
        svgCanvas$7.textActions.setCursor();
    }
};

/**
 * Check whether selected element has the given text decoration value or not.
 * @returns {boolean} Indicates whether or not element has the text decoration value
 */
const hasTextDecorationMethod = (value) => {
    const selectedElements = svgCanvas$7.getSelectedElements();
    const selected = selectedElements[0];
    if (selected?.tagName === "text" && !selectedElements[1]) {
        const attribute = selected.getAttribute("text-decoration") || "";
        return attribute.includes(value);
    }
    return false;
};

/**
 * Adds the given text decoration value
 * @param value The text decoration value
 * @returns {void}
 */
const addTextDecorationMethod = (value) => {
    const selectedElements = svgCanvas$7.getSelectedElements();
    const selected = selectedElements[0];
    if (selected?.tagName === "text" && !selectedElements[1]) {
        const oldValue = selected.getAttribute("text-decoration") || "";
        svgCanvas$7.changeSelectedAttribute(
            "text-decoration",
            (oldValue + " " + value).trim(),
        );
    }
    if (selectedElements.length > 0 && !selectedElements[0].textContent) {
        svgCanvas$7.textActions.setCursor();
    }
};

/**
 * Removes the given text decoration value
 * @param value The text decoration value
 * @returns {void}
 */
const removeTextDecorationMethod = (value) => {
    const selectedElements = svgCanvas$7.getSelectedElements();
    const selected = selectedElements[0];
    if (selected?.tagName === "text" && !selectedElements[1]) {
        const actualValues = selected.getAttribute("text-decoration") || "";
        svgCanvas$7.changeSelectedAttribute(
            "text-decoration",
            actualValues.replace(value, "").trim(),
        );
    }
    if (selectedElements.length > 0 && !selectedElements[0].textContent) {
        svgCanvas$7.textActions.setCursor();
    }
};

/**
 * Check whether selected element is in italics or not.
 * @function module:svgcanvas.SvgCanvas#getItalic
 * @returns {boolean} Indicates whether or not element is italic
 */
const getItalicMethod = () => {
    const selectedElements = svgCanvas$7.getSelectedElements();
    const selected = selectedElements[0];
    if (selected?.tagName === "text" && !selectedElements[1]) {
        return selected.getAttribute("font-style") === "italic";
    }
    return false;
};

/**
 * Make the selected element italic or normal.
 * @function module:svgcanvas.SvgCanvas#setItalic
 * @param {boolean} i - Indicates italic (`true`) or normal (`false`)
 * @returns {void}
 */
const setItalicMethod = (i) => {
    const selectedElements = svgCanvas$7.getSelectedElements();
    const selected = selectedElements[0];
    if (selected?.tagName === "text" && !selectedElements[1]) {
        svgCanvas$7.changeSelectedAttribute(
            "font-style",
            i ? "italic" : "normal",
        );
    }
    if (!selectedElements[0].textContent) {
        svgCanvas$7.textActions.setCursor();
    }
};

/**
 * @function module:svgcanvas.SvgCanvas#setTextAnchorMethod Set the new text anchor
 * @param {string} value - The text anchor value (start, middle or end)
 * @returns {void}
 */
const setTextAnchorMethod = (value) => {
    const selectedElements = svgCanvas$7.getSelectedElements();
    const selected = selectedElements[0];
    if (selected?.tagName === "text" && !selectedElements[1]) {
        svgCanvas$7.changeSelectedAttribute("text-anchor", value);
    }
    if (selectedElements.length > 0 && !selectedElements[0].textContent) {
        svgCanvas$7.textActions.setCursor();
    }
};

/**
 * @function module:svgcanvas.SvgCanvas#setLetterSpacingMethod Set the new letter spacing
 * @param {string} value - The letter spacing value
 * @returns {void}
 */
const setLetterSpacingMethod = (value) => {
    const selectedElements = svgCanvas$7.getSelectedElements();
    const selected = selectedElements[0];
    if (selected?.tagName === "text" && !selectedElements[1]) {
        svgCanvas$7.changeSelectedAttribute("letter-spacing", value);
    }
    if (selectedElements.length > 0 && !selectedElements[0].textContent) {
        svgCanvas$7.textActions.setCursor();
    }
};

/**
 * @function module:svgcanvas.SvgCanvas#setWordSpacingMethod Set the new word spacing
 * @param {string} value - The word spacing value
 * @returns {void}
 */
const setWordSpacingMethod = (value) => {
    const selectedElements = svgCanvas$7.getSelectedElements();
    const selected = selectedElements[0];
    if (selected?.tagName === "text" && !selectedElements[1]) {
        svgCanvas$7.changeSelectedAttribute("word-spacing", value);
    }
    if (selectedElements.length > 0 && !selectedElements[0].textContent) {
        svgCanvas$7.textActions.setCursor();
    }
};

/**
 * @function module:svgcanvas.SvgCanvas#setTextLengthMethod Set the new text length
 * @param {string} value - The text length value
 * @returns {void}
 */
const setTextLengthMethod = (value) => {
    const selectedElements = svgCanvas$7.getSelectedElements();
    const selected = selectedElements[0];
    if (selected?.tagName === "text" && !selectedElements[1]) {
        svgCanvas$7.changeSelectedAttribute("textLength", value);
    }
    if (selectedElements.length > 0 && !selectedElements[0].textContent) {
        svgCanvas$7.textActions.setCursor();
    }
};

/**
 * @function module:svgcanvas.SvgCanvas#setLengthAdjustMethod Set the new length adjust
 * @param {string} value - The length adjust value
 * @returns {void}
 */
const setLengthAdjustMethod = (value) => {
    const selectedElements = svgCanvas$7.getSelectedElements();
    const selected = selectedElements[0];
    if (selected?.tagName === "text" && !selectedElements[1]) {
        svgCanvas$7.changeSelectedAttribute("lengthAdjust", value);
    }
    if (selectedElements.length > 0 && !selectedElements[0].textContent) {
        svgCanvas$7.textActions.setCursor();
    }
};

/**
 * @function module:svgcanvas.SvgCanvas#getFontFamily
 * @returns {string} The current font family
 */
const getFontFamilyMethod = () => {
    return svgCanvas$7.getCurText("font_family");
};

/**
 * Set the new font family.
 * @function module:svgcanvas.SvgCanvas#setFontFamily
 * @param {string} val - String with the new font family
 * @returns {void}
 */
const setFontFamilyMethod = (val) => {
    const selectedElements = svgCanvas$7.getSelectedElements();
    svgCanvas$7.setCurText("font_family", val);
    svgCanvas$7.changeSelectedAttribute("font-family", val);
    if (!selectedElements[0]?.textContent) {
        svgCanvas$7.textActions.setCursor();
    }
};

/**
 * Set the new font color.
 * @function module:svgcanvas.SvgCanvas#setFontColor
 * @param {string} val - String with the new font color
 * @returns {void}
 */
const setFontColorMethod = (val) => {
    svgCanvas$7.setCurText("fill", val);
    svgCanvas$7.changeSelectedAttribute("fill", val);
};

/**
 * @function module:svgcanvas.SvgCanvas#getFontColor
 * @returns {string} The current font color
 */
const getFontColorMethod = () => {
    return svgCanvas$7.getCurText("fill");
};

/**
 * @function module:svgcanvas.SvgCanvas#getFontSize
 * @returns {Float} The current font size
 */
const getFontSizeMethod = () => {
    return svgCanvas$7.getCurText("font_size");
};

/**
 * Applies the given font size to the selected element.
 * @function module:svgcanvas.SvgCanvas#setFontSize
 * @param {Float} val - Float with the new font size
 * @returns {void}
 */
const setFontSizeMethod = (val) => {
    const selectedElements = svgCanvas$7.getSelectedElements();
    svgCanvas$7.setCurText("font_size", val);
    svgCanvas$7.changeSelectedAttribute("font-size", val);
    if (!selectedElements[0]?.textContent) {
        svgCanvas$7.textActions.setCursor();
    }
};

/**
 * @function module:svgcanvas.SvgCanvas#getText
 * @returns {string} The current text (`textContent`) of the selected element
 */
const getTextMethod = () => {
    const selectedElements = svgCanvas$7.getSelectedElements();
    const selected = selectedElements[0];
    return selected ? selected.textContent : "";
};

/**
 * Updates the text element with the given string.
 * @function module:svgcanvas.SvgCanvas#setTextContent
 * @param {string} val - String with the new text
 * @returns {void}
 */
const setTextContentMethod = (val) => {
    svgCanvas$7.changeSelectedAttribute("#text", val);
    svgCanvas$7.textActions.init(val);
    svgCanvas$7.textActions.setCursor();
};

/**
 * Sets the new image URL for the selected image element. Updates its size if
 * a new URL is given.
 * @function module:svgcanvas.SvgCanvas#setImageURL
 * @param {string} val - String with the image URL/path
 * @fires module:svgcanvas.SvgCanvas#event:changed
 * @returns {void}
 */
const setImageURLMethod = (val) => {
    const { ChangeElementCommand, BatchCommand } = svgCanvas$7.history;
    const selectedElements = svgCanvas$7.getSelectedElements();
    const elem = selectedElements[0];
    if (!elem) {
        return;
    }
    const attrs = {
        width: elem.getAttribute("width"),
        height: elem.getAttribute("height"),
    };
    const setsize = !attrs.width || !attrs.height;
    const curHref = getHref(elem);

    // Do nothing if no URL change or size change
    if (curHref === val && !setsize) {
        return;
    }
    const batchCmd = new BatchCommand("Change Image URL");
    setHref(elem, val);
    batchCmd.addSubCommand(
        new ChangeElementCommand(elem, {
            "#href": curHref,
        }),
    );
    const img = new Image();
    img.onload = function () {
        const changes = {
            width: elem.getAttribute("width"),
            height: elem.getAttribute("height"),
        };
        elem.setAttribute("width", this.width);
        elem.setAttribute("height", this.height);
        svgCanvas$7.selectorManager.requestSelector(elem).resize();
        batchCmd.addSubCommand(new ChangeElementCommand(elem, changes));
        svgCanvas$7.addCommandToHistory(batchCmd);
        svgCanvas$7.call("changed", [elem]);
    };
    img.src = val;
};

/**
 * Sets the new link URL for the selected anchor element.
 * @function module:svgcanvas.SvgCanvas#setLinkURL
 * @param {string} val - String with the link URL/path
 * @returns {void}
 */
const setLinkURLMethod = (val) => {
    const { ChangeElementCommand, BatchCommand } = svgCanvas$7.history;
    const selectedElements = svgCanvas$7.getSelectedElements();
    let elem = selectedElements[0];
    if (!elem) {
        return;
    }
    if (elem.tagName !== "a") {
        // See if parent is an anchor
        const parentsA = getParents(elem.parentNode, "a");
        if (parentsA?.length) {
            elem = parentsA[0];
        } else {
            return;
        }
    }
    const curHref = getHref(elem);
    if (curHref === val) {
        return;
    }
    const batchCmd = new BatchCommand("Change Link URL");
    setHref(elem, val);
    batchCmd.addSubCommand(
        new ChangeElementCommand(elem, {
            "#href": curHref,
        }),
    );
    svgCanvas$7.addCommandToHistory(batchCmd);
};

/**
 * Sets the `rx` and `ry` values to the selected `rect` element
 * to change its corner radius.
 * @function module:svgcanvas.SvgCanvas#setRectRadius
 * @param {string|Float} val - The new radius
 * @fires module:svgcanvas.SvgCanvas#event:changed
 * @returns {void}
 */
const setRectRadiusMethod = (val) => {
    const { ChangeElementCommand } = svgCanvas$7.history;
    const selectedElements = svgCanvas$7.getSelectedElements();
    const selected = selectedElements[0];
    if (selected?.tagName === "rect") {
        const r = Number(selected.getAttribute("rx"));
        if (r !== val) {
            selected.setAttribute("rx", val);
            selected.setAttribute("ry", val);
            svgCanvas$7.addCommandToHistory(
                new ChangeElementCommand(
                    selected,
                    {
                        rx: r,
                        ry: r,
                    },
                    "Radius",
                ),
            );
            svgCanvas$7.call("changed", [selected]);
        }
    }
};

/**
 * Wraps the selected element(s) in an anchor element or converts group to one.
 * @function module:svgcanvas.SvgCanvas#makeHyperlink
 * @param {string} url
 * @returns {void}
 */
const makeHyperlinkMethod = (url) => {
    svgCanvas$7.groupSelectedElements("a", url);
};

/**
 * @function module:svgcanvas.SvgCanvas#removeHyperlink
 * @returns {void}
 */
const removeHyperlinkMethod = () => {
    svgCanvas$7.ungroupSelectedElement();
};

/**
 * Group: Element manipulation.
 */

/**
 * Sets the new segment type to the selected segment(s).
 * @function module:svgcanvas.SvgCanvas#setSegType
 * @param {Integer} newType - New segment type. See {@link https://www.w3.org/TR/SVG/paths.html#InterfaceSVGPathSeg} for list
 * @returns {void}
 */
const setSegTypeMethod = (newType) => {
    svgCanvas$7.pathActions.setSegType(newType);
};

/**
 * Set the background of the editor (NOT the actual document).
 * @function module:svgcanvas.SvgCanvas#setBackground
 * @param {string} color - String with fill color to apply
 * @param {string} url - URL or path to image to use
 * @returns {void}
 */
const setBackgroundMethod = (color, url) => {
    const bg = getElement("canvasBackground");
    const border = bg.querySelector("rect");
    let bgImg = getElement("background_image");
    let bgPattern = getElement("background_pattern");
    border.setAttribute("fill", color === "chessboard" ? "#fff" : color);
    if (color === "chessboard") {
        if (!bgPattern) {
            bgPattern = svgCanvas$7
                .getDOMDocument()
                .createElementNS(NS.SVG, "foreignObject");
            svgCanvas$7.assignAttributes(bgPattern, {
                id: "background_pattern",
                width: "100%",
                height: "100%",
                preserveAspectRatio: "xMinYMin",
                style: "pointer-events:none",
            });
            const div = document.createElement("div");
            svgCanvas$7.assignAttributes(div, {
                style:
                    "pointer-events:none;width:100%;height:100%;" +
                    "background-image:url(data:image/gif;base64," +
                    "R0lGODlhEAAQAIAAAP///9bW1iH5BAAAAAAALAAAAAAQABAAAAIfjG+" +
                    "gq4jM3IFLJgpswNly/XkcBpIiVaInlLJr9FZWAQA7);",
            });
            bgPattern.append(div);
            bg.append(bgPattern);
        }
    } else if (bgPattern) {
        bgPattern.remove();
    }
    if (url) {
        if (!bgImg) {
            bgImg = svgCanvas$7
                .getDOMDocument()
                .createElementNS(NS.SVG, "image");
            svgCanvas$7.assignAttributes(bgImg, {
                id: "background_image",
                width: "100%",
                height: "100%",
                preserveAspectRatio: "xMinYMin",
                style: "pointer-events:none",
            });
        }
        setHref(bgImg, url);
        bg.append(bgImg);
    } else if (bgImg) {
        bgImg.remove();
    }
};

/**
 * Manipulating coordinates.
 * @module coords
 * @license MIT
 */

// this is how we map paths to our preferred relative segment types
const pathMap = [
    0,
    "z",
    "M",
    "m",
    "L",
    "l",
    "C",
    "c",
    "Q",
    "q",
    "A",
    "a",
    "H",
    "h",
    "V",
    "v",
    "S",
    "s",
    "T",
    "t",
];

/**
 * @interface module:coords.EditorContext
 */
/**
 * @function module:coords.EditorContext#getGridSnapping
 * @returns {boolean}
 */
/**
 * @function module:coords.EditorContext#getSvgRoot
 * @returns {SVGSVGElement}
 */

let svgCanvas$6 = null;

/**
 * @function module:coords.init
 * @param {module:svgcanvas.SvgCanvas#event:pointsAdded} editorContext
 * @returns {void}
 */
const init$6 = (canvas) => {
    svgCanvas$6 = canvas;
};

/**
 * Applies coordinate changes to an element based on the given matrix.
 * @name module:coords.remapElement
 * @type {module:path.EditorContext#remapElement}
 */
const remapElement = (selected, changes, m) => {
    const remap = (x, y) => transformPoint(x, y, m);
    const scalew = (w) => m.a * w;
    const scaleh = (h) => m.d * h;
    const doSnapping =
        svgCanvas$6.getGridSnapping() &&
        selected.parentNode.parentNode.localName === "svg";
    const finishUp = () => {
        if (doSnapping) {
            Object.entries(changes).forEach(([o, value]) => {
                changes[o] = snapToGrid(value);
            });
        }
        assignAttributes(selected, changes, 1000, true);
    };
    const box = getBBox(selected);
    ["fill", "stroke"].forEach((type) => {
        const attrVal = selected.getAttribute(type);
        if (attrVal?.startsWith("url(") && (m.a < 0 || m.d < 0)) {
            const grad = getRefElem(attrVal);
            const newgrad = grad.cloneNode(true);
            if (m.a < 0) {
                // flip x
                const x1 = newgrad.getAttribute("x1");
                const x2 = newgrad.getAttribute("x2");
                newgrad.setAttribute("x1", -(x1 - 1));
                newgrad.setAttribute("x2", -(x2 - 1));
            }
            if (m.d < 0) {
                // flip y
                const y1 = newgrad.getAttribute("y1");
                const y2 = newgrad.getAttribute("y2");
                newgrad.setAttribute("y1", -(y1 - 1));
                newgrad.setAttribute("y2", -(y2 - 1));
            }
            newgrad.id = svgCanvas$6.getCurrentDrawing().getNextId();
            findDefs().append(newgrad);
            selected.setAttribute(type, "url(#" + newgrad.id + ")");
        }
    });
    const elName = selected.tagName;
    if (
        elName === "g" ||
        elName === "text" ||
        elName === "tspan" ||
        elName === "use"
    ) {
        // if it was a translate, then just update x,y
        if (
            m.a === 1 &&
            m.b === 0 &&
            m.c === 0 &&
            m.d === 1 &&
            (m.e !== 0 || m.f !== 0)
        ) {
            // [T][M] = [M][T']
            // therefore [T'] = [M_inv][T][M]
            const existing = transformListToTransform(selected).matrix;
            const tNew = matrixMultiply(existing.inverse(), m, existing);
            changes.x = Number.parseFloat(changes.x) + tNew.e;
            changes.y = Number.parseFloat(changes.y) + tNew.f;
        } else {
            // we just absorb all matrices into the element and don't do any remapping
            const chlist = getTransformList(selected);
            const mt = svgCanvas$6.getSvgRoot().createSVGTransform();
            mt.setMatrix(
                matrixMultiply(transformListToTransform(chlist).matrix, m),
            );
            chlist.clear();
            chlist.appendItem(mt);
        }
    }

    // now we have a set of changes and an applied reduced transform list
    // we apply the changes directly to the DOM
    switch (elName) {
        case "foreignObject":
        case "rect":
        case "image": {
            // Allow images to be inverted (give them matrix when flipped)
            if (elName === "image" && (m.a < 0 || m.d < 0)) {
                // Convert to matrix
                const chlist = getTransformList(selected);
                const mt = svgCanvas$6.getSvgRoot().createSVGTransform();
                mt.setMatrix(
                    matrixMultiply(transformListToTransform(chlist).matrix, m),
                );
                chlist.clear();
                chlist.appendItem(mt);
            } else {
                const pt1 = remap(changes.x, changes.y);
                changes.width = scalew(changes.width);
                changes.height = scaleh(changes.height);
                changes.x = pt1.x + Math.min(0, changes.width);
                changes.y = pt1.y + Math.min(0, changes.height);
                changes.width = Math.abs(changes.width);
                changes.height = Math.abs(changes.height);
            }
            finishUp();
            break;
        }
        case "ellipse": {
            const c = remap(changes.cx, changes.cy);
            changes.cx = c.x;
            changes.cy = c.y;
            changes.rx = scalew(changes.rx);
            changes.ry = scaleh(changes.ry);
            changes.rx = Math.abs(changes.rx);
            changes.ry = Math.abs(changes.ry);
            finishUp();
            break;
        }
        case "circle": {
            const c = remap(changes.cx, changes.cy);
            changes.cx = c.x;
            changes.cy = c.y;
            // take the minimum of the new selected box's dimensions for the new circle radius
            const tbox = transformBox(box.x, box.y, box.width, box.height, m);
            const w = tbox.tr.x - tbox.tl.x;
            const h = tbox.bl.y - tbox.tl.y;
            changes.r = Math.min(w / 2, h / 2);
            if (changes.r) {
                changes.r = Math.abs(changes.r);
            }
            finishUp();
            break;
        }
        case "line": {
            const pt1 = remap(changes.x1, changes.y1);
            const pt2 = remap(changes.x2, changes.y2);
            changes.x1 = pt1.x;
            changes.y1 = pt1.y;
            changes.x2 = pt2.x;
            changes.y2 = pt2.y;
        }
        // Fallthrough
        case "text":
        case "tspan":
        case "use": {
            finishUp();
            break;
        }
        case "g": {
            const dataStorage = svgCanvas$6.getDataStorage();
            const gsvg = dataStorage.get(selected, "gsvg");
            if (gsvg) {
                assignAttributes(gsvg, changes, 1000, true);
            }
            break;
        }
        case "polyline":
        case "polygon": {
            changes.points.forEach((pt) => {
                const { x, y } = remap(pt.x, pt.y);
                pt.x = x;
                pt.y = y;
            });

            // const len = changes.points.length;
            let pstr = "";
            changes.points.forEach((pt) => {
                pstr += pt.x + "," + pt.y + " ";
            });
            selected.setAttribute("points", pstr);
            break;
        }
        case "path": {
            const segList = selected.pathSegList;
            let len = segList.numberOfItems;
            changes.d = [];
            for (let i = 0; i < len; ++i) {
                const seg = segList.getItem(i);
                changes.d[i] = {
                    type: seg.pathSegType,
                    x: seg.x,
                    y: seg.y,
                    x1: seg.x1,
                    y1: seg.y1,
                    x2: seg.x2,
                    y2: seg.y2,
                    r1: seg.r1,
                    r2: seg.r2,
                    angle: seg.angle,
                    largeArcFlag: seg.largeArcFlag,
                    sweepFlag: seg.sweepFlag,
                };
            }
            len = changes.d.length;
            const firstseg = changes.d[0];
            let currentpt;
            if (len > 0) {
                currentpt = remap(firstseg.x, firstseg.y);
                changes.d[0].x = currentpt.x;
                changes.d[0].y = currentpt.y;
            }
            for (let i = 1; i < len; ++i) {
                const seg = changes.d[i];
                const { type } = seg;
                // if absolute or first segment, we want to remap x, y, x1, y1, x2, y2
                // if relative, we want to scalew, scaleh
                if (type % 2 === 0) {
                    // absolute
                    const thisx = seg.x !== undefined ? seg.x : currentpt.x; // for V commands
                    const thisy = seg.y !== undefined ? seg.y : currentpt.y; // for H commands
                    const pt = remap(thisx, thisy);
                    const pt1 = remap(seg.x1, seg.y1);
                    const pt2 = remap(seg.x2, seg.y2);
                    seg.x = pt.x;
                    seg.y = pt.y;
                    seg.x1 = pt1.x;
                    seg.y1 = pt1.y;
                    seg.x2 = pt2.x;
                    seg.y2 = pt2.y;
                    seg.r1 = scalew(seg.r1);
                    seg.r2 = scaleh(seg.r2);
                } else {
                    // relative
                    seg.x = scalew(seg.x);
                    seg.y = scaleh(seg.y);
                    seg.x1 = scalew(seg.x1);
                    seg.y1 = scaleh(seg.y1);
                    seg.x2 = scalew(seg.x2);
                    seg.y2 = scaleh(seg.y2);
                    seg.r1 = scalew(seg.r1);
                    seg.r2 = scaleh(seg.r2);
                }
            } // for each segment

            let dstr = "";
            changes.d.forEach((seg) => {
                const { type } = seg;
                dstr += pathMap[type];
                switch (type) {
                    case 13: // relative horizontal line (h)
                    case 12:
                        // absolute horizontal line (H)
                        dstr += seg.x + " ";
                        break;
                    case 15: // relative vertical line (v)
                    case 14:
                        // absolute vertical line (V)
                        dstr += seg.y + " ";
                        break;
                    case 3: // relative move (m)
                    case 5: // relative line (l)
                    case 19: // relative smooth quad (t)
                    case 2: // absolute move (M)
                    case 4: // absolute line (L)
                    case 18:
                        // absolute smooth quad (T)
                        dstr += seg.x + "," + seg.y + " ";
                        break;
                    case 7: // relative cubic (c)
                    case 6:
                        // absolute cubic (C)
                        dstr +=
                            seg.x1 +
                            "," +
                            seg.y1 +
                            " " +
                            seg.x2 +
                            "," +
                            seg.y2 +
                            " " +
                            seg.x +
                            "," +
                            seg.y +
                            " ";
                        break;
                    case 9: // relative quad (q)
                    case 8:
                        // absolute quad (Q)
                        dstr +=
                            seg.x1 +
                            "," +
                            seg.y1 +
                            " " +
                            seg.x +
                            "," +
                            seg.y +
                            " ";
                        break;
                    case 11: // relative elliptical arc (a)
                    case 10:
                        // absolute elliptical arc (A)
                        dstr +=
                            seg.r1 +
                            "," +
                            seg.r2 +
                            " " +
                            seg.angle +
                            " " +
                            Number(seg.largeArcFlag) +
                            " " +
                            Number(seg.sweepFlag) +
                            " " +
                            seg.x +
                            "," +
                            seg.y +
                            " ";
                        break;
                    case 17: // relative smooth cubic (s)
                    case 16:
                        // absolute smooth cubic (S)
                        dstr +=
                            seg.x2 +
                            "," +
                            seg.y2 +
                            " " +
                            seg.x +
                            "," +
                            seg.y +
                            " ";
                        break;
                }
            });
            selected.setAttribute("d", dstr);
            break;
        }
    }
};

/**
 * Recalculate.
 * @module recalculate
 * @license MIT
 */
let svgCanvas$5;

/**
 * @interface module:recalculate.EditorContext
 */
/**
 * @function module:recalculate.EditorContext#getSvgRoot
 * @returns {SVGSVGElement} The root DOM element
 */
/**
 * @function module:recalculate.EditorContext#getStartTransform
 * @returns {string}
 */
/**
 * @function module:recalculate.EditorContext#setStartTransform
 * @param {string} transform
 * @returns {void}
 */

/**
 * @function module:recalculate.init
 * @param {module:recalculate.EditorContext} editorContext
 * @returns {void}
 */
const init$5 = (canvas) => {
    svgCanvas$5 = canvas;
};

/**
 * Updates a `<clipPath>`s values based on the given translation of an element.
 * @function module:recalculate.updateClipPath
 * @param {string} attr - The clip-path attribute value with the clipPath's ID
 * @param {Float} tx - The translation's x value
 * @param {Float} ty - The translation's y value
 * @returns {void}
 */
const updateClipPath = (attr, tx, ty) => {
    const path = getRefElem(attr).firstChild;
    const cpXform = getTransformList(path);
    const newxlate = svgCanvas$5.getSvgRoot().createSVGTransform();
    newxlate.setTranslate(tx, ty);
    cpXform.appendItem(newxlate);

    // Update clipPath's dimensions
    recalculateDimensions(path);
};

/**
 * Decides the course of action based on the element's transform list.
 * @function module:recalculate.recalculateDimensions
 * @param {Element} selected - The DOM element to recalculate
 * @returns {Command} Undo command object with the resulting change
 */
const recalculateDimensions = (selected) => {
    if (!selected) return null;
    const svgroot = svgCanvas$5.getSvgRoot();
    const dataStorage = svgCanvas$5.getDataStorage();
    const tlist = getTransformList(selected);
    // remove any unnecessary transforms
    if (tlist?.numberOfItems > 0) {
        let k = tlist.numberOfItems;
        const noi = k;
        while (k--) {
            const xform = tlist.getItem(k);
            if (xform.type === 0) {
                tlist.removeItem(k);
                // remove identity matrices
            } else if (xform.type === 1) {
                if (isIdentity(xform.matrix)) {
                    if (noi === 1) {
                        // Overcome Chrome bug (though only when noi is 1) with
                        //    `removeItem` preventing `removeAttribute` from
                        //    subsequently working
                        // See https://bugs.chromium.org/p/chromium/issues/detail?id=843901
                        selected.removeAttribute("transform");
                        return null;
                    }
                    tlist.removeItem(k);
                }
                // remove zero-degree rotations
            } else if (xform.type === 4 && xform.angle === 0) {
                tlist.removeItem(k);
            }
        }
        // End here if all it has is a rotation
        if (tlist.numberOfItems === 1 && getRotationAngle(selected)) {
            return null;
        }
    }

    // if this element had no transforms, we are done
    if (!tlist || tlist.numberOfItems === 0) {
        // Chrome apparently had a bug that requires clearing the attribute first.
        selected.setAttribute("transform", "");
        // However, this still next line currently doesn't work at all in Chrome
        selected.removeAttribute("transform");
        return null;
    }

    // TODO: Make this work for more than 2
    if (tlist) {
        let mxs = [];
        let k = tlist.numberOfItems;
        while (k--) {
            const xform = tlist.getItem(k);
            if (xform.type === 1) {
                mxs.push([xform.matrix, k]);
            } else if (mxs.length) {
                mxs = [];
            }
        }
        if (mxs.length === 2) {
            const mNew = svgroot.createSVGTransformFromMatrix(
                matrixMultiply(mxs[1][0], mxs[0][0]),
            );
            tlist.removeItem(mxs[0][1]);
            tlist.removeItem(mxs[1][1]);
            tlist.insertItemBefore(mNew, mxs[1][1]);
        }

        // combine matrix + translate
        k = tlist.numberOfItems;
        if (
            k >= 2 &&
            tlist.getItem(k - 2).type === 1 &&
            tlist.getItem(k - 1).type === 2
        ) {
            const mt = svgroot.createSVGTransform();
            const m = matrixMultiply(
                tlist.getItem(k - 2).matrix,
                tlist.getItem(k - 1).matrix,
            );
            mt.setMatrix(m);
            tlist.removeItem(k - 2);
            tlist.removeItem(k - 2);
            tlist.appendItem(mt);
        }
    }

    // If it still has a single [M] or [R][M], return null too (prevents BatchCommand from being returned).
    switch (selected.tagName) {
        // Ignore these elements, as they can absorb the [M]
        case "line":
        case "polyline":
        case "polygon":
        case "path":
            break;
        default:
            if (
                (tlist.numberOfItems === 1 && tlist.getItem(0).type === 1) ||
                (tlist.numberOfItems === 2 &&
                    tlist.getItem(0).type === 1 &&
                    tlist.getItem(0).type === 4)
            ) {
                return null;
            }
    }
    // Grouped SVG element
    const gsvg = dataStorage.has(selected, "gsvg")
        ? dataStorage.get(selected, "gsvg")
        : undefined;
    // we know we have some transforms, so set up return variable
    const batchCmd = new BatchCommand$4("Transform");

    // store initial values that will be affected by reducing the transform list
    let changes = {};
    let initial = null;
    let attrs = [];
    switch (selected.tagName) {
        case "line":
            attrs = ["x1", "y1", "x2", "y2"];
            break;
        case "circle":
            attrs = ["cx", "cy", "r"];
            break;
        case "ellipse":
            attrs = ["cx", "cy", "rx", "ry"];
            break;
        case "foreignObject":
        case "rect":
        case "image":
            attrs = ["width", "height", "x", "y"];
            break;
        case "use":
        case "text":
        case "tspan":
            attrs = ["x", "y"];
            break;
        case "polygon":
        case "polyline": {
            initial = {};
            initial.points = selected.getAttribute("points");
            const list = selected.points;
            const len = list.numberOfItems;
            changes.points = new Array(len);
            for (let i = 0; i < len; ++i) {
                const pt = list.getItem(i);
                changes.points[i] = {
                    x: pt.x,
                    y: pt.y,
                };
            }
            break;
        }
        case "path":
            initial = {};
            initial.d = selected.getAttribute("d");
            changes.d = selected.getAttribute("d");
            break;
    } // switch on element type to get initial values

    if (attrs.length) {
        attrs.forEach((attr) => {
            changes[attr] = convertToNum(attr, selected.getAttribute(attr));
        });
    } else if (gsvg) {
        // GSVG exception
        changes = {
            x: Number(gsvg.getAttribute("x")) || 0,
            y: Number(gsvg.getAttribute("y")) || 0,
        };
    }

    // if we haven't created an initial array in polygon/polyline/path, then
    // make a copy of initial values and include the transform
    if (!initial) {
        initial = mergeDeep({}, changes);
        for (const [attr, val] of Object.entries(initial)) {
            initial[attr] = convertToNum(attr, val);
        }
    }
    // save the start transform value too
    initial.transform = svgCanvas$5.getStartTransform() || "";
    let oldcenter;
    let newcenter;

    // if it's a regular group, we have special processing to flatten transforms
    if ((selected.tagName === "g" && !gsvg) || selected.tagName === "a") {
        const box = getBBox(selected);
        oldcenter = {
            x: box.x + box.width / 2,
            y: box.y + box.height / 2,
        };
        newcenter = transformPoint(
            box.x + box.width / 2,
            box.y + box.height / 2,
            transformListToTransform(tlist).matrix,
        );
        // let m = svgroot.createSVGMatrix();

        // temporarily strip off the rotate and save the old center
        const gangle = getRotationAngle(selected);
        if (gangle) {
            const a = (gangle * Math.PI) / 180;
            const s =
                Math.abs(a) > 1.0e-10 ? Math.sin(a) / (1 - Math.cos(a)) : 2 / a;
            for (let i = 0; i < tlist.numberOfItems; ++i) {
                const xform = tlist.getItem(i);
                if (xform.type === 4) {
                    // extract old center through mystical arts
                    const rm = xform.matrix;
                    oldcenter.y = (s * rm.e + rm.f) / 2;
                    oldcenter.x = (rm.e - s * rm.f) / 2;
                    tlist.removeItem(i);
                    break;
                }
            }
        }
        const N = tlist.numberOfItems;
        let tx = 0;
        let ty = 0;
        let operation = 0;
        let firstM;
        if (N) {
            firstM = tlist.getItem(0).matrix;
        }
        let oldStartTransform;
        // first, if it was a scale then the second-last transform will be it
        if (
            N >= 3 &&
            tlist.getItem(N - 2).type === 3 &&
            tlist.getItem(N - 3).type === 2 &&
            tlist.getItem(N - 1).type === 2
        ) {
            operation = 3; // scale

            // if the children are unrotated, pass the scale down directly
            // otherwise pass the equivalent matrix() down directly
            const tm = tlist.getItem(N - 3).matrix;
            const sm = tlist.getItem(N - 2).matrix;
            const tmn = tlist.getItem(N - 1).matrix;
            const children = selected.childNodes;
            let c = children.length;
            while (c--) {
                const child = children.item(c);
                tx = 0;
                ty = 0;
                if (child.nodeType === 1) {
                    const childTlist = getTransformList(child);

                    // some children might not have a transform (<metadata>, <defs>, etc)
                    if (!childTlist) {
                        continue;
                    }
                    const m = transformListToTransform(childTlist).matrix;

                    // Convert a matrix to a scale if applicable
                    // if (hasMatrixTransform(childTlist) && childTlist.numberOfItems == 1) {
                    //   if (m.b==0 && m.c==0 && m.e==0 && m.f==0) {
                    //     childTlist.removeItem(0);
                    //     const translateOrigin = svgroot.createSVGTransform(),
                    //       scale = svgroot.createSVGTransform(),
                    //       translateBack = svgroot.createSVGTransform();
                    //     translateOrigin.setTranslate(0, 0);
                    //     scale.setScale(m.a, m.d);
                    //     translateBack.setTranslate(0, 0);
                    //     childTlist.appendItem(translateBack);
                    //     childTlist.appendItem(scale);
                    //     childTlist.appendItem(translateOrigin);
                    //   }
                    // }

                    const angle = getRotationAngle(child);
                    oldStartTransform = svgCanvas$5.getStartTransform();
                    // const childxforms = [];
                    svgCanvas$5.setStartTransform(
                        child.getAttribute("transform"),
                    );
                    if (angle || hasMatrixTransform(childTlist)) {
                        const e2t = svgroot.createSVGTransform();
                        e2t.setMatrix(matrixMultiply(tm, sm, tmn, m));
                        childTlist.clear();
                        childTlist.appendItem(e2t);
                        // childxforms.push(e2t);
                        // if not rotated or skewed, push the [T][S][-T] down to the child
                    } else {
                        // update the transform list with translate,scale,translate

                        // slide the [T][S][-T] from the front to the back
                        // [T][S][-T][M] = [M][T2][S2][-T2]

                        // (only bringing [-T] to the right of [M])
                        // [T][S][-T][M] = [T][S][M][-T2]
                        // [-T2] = [M_inv][-T][M]
                        const t2n = matrixMultiply(m.inverse(), tmn, m);
                        // [T2] is always negative translation of [-T2]
                        const t2 = svgroot.createSVGMatrix();
                        t2.e = -t2n.e;
                        t2.f = -t2n.f;

                        // [T][S][-T][M] = [M][T2][S2][-T2]
                        // [S2] = [T2_inv][M_inv][T][S][-T][M][-T2_inv]
                        const s2 = matrixMultiply(
                            t2.inverse(),
                            m.inverse(),
                            tm,
                            sm,
                            tmn,
                            m,
                            t2n.inverse(),
                        );
                        const translateOrigin = svgroot.createSVGTransform();
                        const scale = svgroot.createSVGTransform();
                        const translateBack = svgroot.createSVGTransform();
                        translateOrigin.setTranslate(t2n.e, t2n.f);
                        scale.setScale(s2.a, s2.d);
                        translateBack.setTranslate(t2.e, t2.f);
                        childTlist.appendItem(translateBack);
                        childTlist.appendItem(scale);
                        childTlist.appendItem(translateOrigin);
                    } // not rotated
                    const recalculatedDimensions = recalculateDimensions(child);
                    if (recalculatedDimensions) {
                        batchCmd.addSubCommand(recalculatedDimensions);
                    }
                    svgCanvas$5.setStartTransform(oldStartTransform);
                } // element
            } // for each child
            // Remove these transforms from group
            tlist.removeItem(N - 1);
            tlist.removeItem(N - 2);
            tlist.removeItem(N - 3);
        } else if (N >= 3 && tlist.getItem(N - 1).type === 1) {
            operation = 3; // scale
            const m = transformListToTransform(tlist).matrix;
            const e2t = svgroot.createSVGTransform();
            e2t.setMatrix(m);
            tlist.clear();
            tlist.appendItem(e2t);
            // next, check if the first transform was a translate
            // if we had [ T1 ] [ M ] we want to transform this into [ M ] [ T2 ]
            // therefore [ T2 ] = [ M_inv ] [ T1 ] [ M ]
        } else if (
            (N === 1 || (N > 1 && tlist.getItem(1).type !== 3)) &&
            tlist.getItem(0).type === 2
        ) {
            operation = 2; // translate
            const T_M = transformListToTransform(tlist).matrix;
            tlist.removeItem(0);
            const mInv = transformListToTransform(tlist).matrix.inverse();
            const M2 = matrixMultiply(mInv, T_M);
            tx = M2.e;
            ty = M2.f;
            if (tx !== 0 || ty !== 0) {
                // we pass the translates down to the individual children
                const children = selected.childNodes;
                let c = children.length;
                const clipPathsDone = [];
                while (c--) {
                    const child = children.item(c);
                    if (child.nodeType === 1) {
                        // Check if child has clip-path
                        if (child.getAttribute("clip-path")) {
                            // tx, ty
                            const attr = child.getAttribute("clip-path");
                            if (!clipPathsDone.includes(attr)) {
                                updateClipPath(attr, tx, ty);
                                clipPathsDone.push(attr);
                            }
                        }
                        oldStartTransform = svgCanvas$5.getStartTransform();
                        svgCanvas$5.setStartTransform(
                            child.getAttribute("transform"),
                        );
                        const childTlist = getTransformList(child);
                        // some children might not have a transform (<metadata>, <defs>, etc)
                        if (childTlist) {
                            const newxlate = svgroot.createSVGTransform();
                            newxlate.setTranslate(tx, ty);
                            if (childTlist.numberOfItems) {
                                childTlist.insertItemBefore(newxlate, 0);
                            } else {
                                childTlist.appendItem(newxlate);
                            }
                            const recalculatedDimensions =
                                recalculateDimensions(child);
                            if (recalculatedDimensions) {
                                batchCmd.addSubCommand(recalculatedDimensions);
                            }
                            // If any <use> have this group as a parent and are
                            // referencing this child, then impose a reverse translate on it
                            // so that when it won't get double-translated
                            const uses = selected.getElementsByTagNameNS(
                                NS.SVG,
                                "use",
                            );
                            const href = "#" + child.id;
                            let u = uses.length;
                            while (u--) {
                                const useElem = uses.item(u);
                                if (href === getHref(useElem)) {
                                    const usexlate =
                                        svgroot.createSVGTransform();
                                    usexlate.setTranslate(-tx, -ty);
                                    useElem.transform.baseVal.insertItemBefore(
                                        usexlate,
                                        0,
                                    );
                                    batchCmd.addSubCommand(
                                        recalculateDimensions(useElem),
                                    );
                                }
                            }
                            svgCanvas$5.setStartTransform(oldStartTransform);
                        }
                    }
                }
                svgCanvas$5.setStartTransform(oldStartTransform);
            }
            // else, a matrix imposition from a parent group
            // keep pushing it down to the children
        } else if (N === 1 && tlist.getItem(0).type === 1 && !gangle) {
            operation = 1;
            const m = tlist.getItem(0).matrix;
            const children = selected.childNodes;
            let c = children.length;
            while (c--) {
                const child = children.item(c);
                if (child.nodeType === 1) {
                    oldStartTransform = svgCanvas$5.getStartTransform();
                    svgCanvas$5.setStartTransform(
                        child.getAttribute("transform"),
                    );
                    const childTlist = getTransformList(child);
                    if (!childTlist) {
                        continue;
                    }
                    const em = matrixMultiply(
                        m,
                        transformListToTransform(childTlist).matrix,
                    );
                    const e2m = svgroot.createSVGTransform();
                    e2m.setMatrix(em);
                    childTlist.clear();
                    childTlist.appendItem(e2m, 0);
                    const recalculatedDimensions = recalculateDimensions(child);
                    if (recalculatedDimensions) {
                        batchCmd.addSubCommand(recalculatedDimensions);
                    }
                    svgCanvas$5.setStartTransform(oldStartTransform);

                    // Convert stroke
                    // TODO: Find out if this should actually happen somewhere else
                    const sw = child.getAttribute("stroke-width");
                    if (child.getAttribute("stroke") !== "none" && !isNaN(sw)) {
                        const avg = (Math.abs(em.a) + Math.abs(em.d)) / 2;
                        child.setAttribute("stroke-width", sw * avg);
                    }
                }
            }
            tlist.clear();
            // else it was just a rotate
        } else {
            if (gangle) {
                const newRot = svgroot.createSVGTransform();
                newRot.setRotate(gangle, newcenter.x, newcenter.y);
                if (tlist.numberOfItems) {
                    tlist.insertItemBefore(newRot, 0);
                } else {
                    tlist.appendItem(newRot);
                }
            }
            if (tlist.numberOfItems === 0) {
                selected.removeAttribute("transform");
            }
            return null;
        }

        // if it was a translate, put back the rotate at the new center
        if (operation === 2) {
            if (gangle) {
                newcenter = {
                    x: oldcenter.x + firstM.e,
                    y: oldcenter.y + firstM.f,
                };
                const newRot = svgroot.createSVGTransform();
                newRot.setRotate(gangle, newcenter.x, newcenter.y);
                if (tlist.numberOfItems) {
                    tlist.insertItemBefore(newRot, 0);
                } else {
                    tlist.appendItem(newRot);
                }
            }
            // if it was a resize
        } else if (operation === 3) {
            const m = transformListToTransform(tlist).matrix;
            const roldt = svgroot.createSVGTransform();
            roldt.setRotate(gangle, oldcenter.x, oldcenter.y);
            const rold = roldt.matrix;
            const rnew = svgroot.createSVGTransform();
            rnew.setRotate(gangle, newcenter.x, newcenter.y);
            const rnewInv = rnew.matrix.inverse();
            const mInv = m.inverse();
            const extrat = matrixMultiply(mInv, rnewInv, rold, m);
            tx = extrat.e;
            ty = extrat.f;
            if (tx !== 0 || ty !== 0) {
                // now push this transform down to the children
                // we pass the translates down to the individual children
                const children = selected.childNodes;
                let c = children.length;
                while (c--) {
                    const child = children.item(c);
                    if (child.nodeType === 1) {
                        oldStartTransform = svgCanvas$5.getStartTransform();
                        svgCanvas$5.setStartTransform(
                            child.getAttribute("transform"),
                        );
                        const childTlist = getTransformList(child);
                        const newxlate = svgroot.createSVGTransform();
                        newxlate.setTranslate(tx, ty);
                        if (childTlist.numberOfItems) {
                            childTlist.insertItemBefore(newxlate, 0);
                        } else {
                            childTlist.appendItem(newxlate);
                        }
                        const recalculatedDimensions =
                            recalculateDimensions(child);
                        if (recalculatedDimensions) {
                            batchCmd.addSubCommand(recalculatedDimensions);
                        }
                        svgCanvas$5.setStartTransform(oldStartTransform);
                    }
                }
            }
            if (gangle) {
                if (tlist.numberOfItems) {
                    tlist.insertItemBefore(rnew, 0);
                } else {
                    tlist.appendItem(rnew);
                }
            }
        }
        // else, it's a non-group
    } else {
        // TODO: box might be null for some elements (<metadata> etc), need to handle this
        const box = getBBox(selected);

        // Paths (and possbly other shapes) will have no BBox while still in <defs>,
        // but we still may need to recalculate them (see issue 595).
        // TODO: Figure out how to get BBox from these elements in case they
        // have a rotation transform

        if (!box && selected.tagName !== "path") return null;
        let m; // = svgroot.createSVGMatrix();
        // temporarily strip off the rotate and save the old center
        const angle = getRotationAngle(selected);
        if (angle) {
            oldcenter = {
                x: box.x + box.width / 2,
                y: box.y + box.height / 2,
            };
            newcenter = transformPoint(
                box.x + box.width / 2,
                box.y + box.height / 2,
                transformListToTransform(tlist).matrix,
            );
            const a = (angle * Math.PI) / 180;
            const s =
                Math.abs(a) > 1.0e-10
                    ? Math.sin(a) / (1 - Math.cos(a))
                    : // TODO: This blows up if the angle is exactly 0!
                      2 / a;
            for (let i = 0; i < tlist.numberOfItems; ++i) {
                const xform = tlist.getItem(i);
                if (xform.type === 4) {
                    // extract old center through mystical arts
                    const rm = xform.matrix;
                    oldcenter.y = (s * rm.e + rm.f) / 2;
                    oldcenter.x = (rm.e - s * rm.f) / 2;
                    tlist.removeItem(i);
                    break;
                }
            }
        }

        // 2 = translate, 3 = scale, 4 = rotate, 1 = matrix imposition
        let operation = 0;
        const N = tlist.numberOfItems;

        // Check if it has a gradient with userSpaceOnUse, in which case
        // adjust it by recalculating the matrix transform.

        const fill = selected.getAttribute("fill");
        if (fill?.startsWith("url(")) {
            const paint = getRefElem(fill);
            if (paint) {
                let type = "pattern";
                if (paint?.tagName !== type) type = "gradient";
                const attrVal = paint.getAttribute(type + "Units");
                if (attrVal === "userSpaceOnUse") {
                    // Update the userSpaceOnUse element
                    m = transformListToTransform(tlist).matrix;
                    const gtlist = getTransformList(paint);
                    const gmatrix = transformListToTransform(gtlist).matrix;
                    m = matrixMultiply(m, gmatrix);
                    const mStr =
                        "matrix(" +
                        [m.a, m.b, m.c, m.d, m.e, m.f].join(",") +
                        ")";
                    paint.setAttribute(type + "Transform", mStr);
                }
            }
        }

        // first, if it was a scale of a non-skewed element, then the second-last
        // transform will be the [S]
        // if we had [M][T][S][T] we want to extract the matrix equivalent of
        // [T][S][T] and push it down to the element
        if (
            N >= 3 &&
            tlist.getItem(N - 2).type === 3 &&
            tlist.getItem(N - 3).type === 2 &&
            tlist.getItem(N - 1).type === 2
        ) {
            // Removed this so a <use> with a given [T][S][T] would convert to a matrix.
            // Is that bad?
            //  && selected.nodeName != 'use'
            operation = 3; // scale
            m = transformListToTransform(tlist, N - 3, N - 1).matrix;
            tlist.removeItem(N - 1);
            tlist.removeItem(N - 2);
            tlist.removeItem(N - 3);
            // if we had [T][S][-T][M], then this was a skewed element being resized
            // Thus, we simply combine it all into one matrix
        } else if (N === 4 && tlist.getItem(N - 1).type === 1) {
            operation = 3; // scale
            m = transformListToTransform(tlist).matrix;
            const e2t = svgroot.createSVGTransform();
            e2t.setMatrix(m);
            tlist.clear();
            tlist.appendItem(e2t);
            // reset the matrix so that the element is not re-mapped
            m = svgroot.createSVGMatrix();
            // if we had [R][T][S][-T][M], then this was a rotated matrix-element
            // if we had [T1][M] we want to transform this into [M][T2]
            // therefore [ T2 ] = [ M_inv ] [ T1 ] [ M ] and we can push [T2]
            // down to the element
        } else if (
            (N === 1 || (N > 1 && tlist.getItem(1).type !== 3)) &&
            tlist.getItem(0).type === 2
        ) {
            operation = 2; // translate
            const oldxlate = tlist.getItem(0).matrix;
            const meq = transformListToTransform(tlist, 1).matrix;
            const meqInv = meq.inverse();
            m = matrixMultiply(meqInv, oldxlate, meq);
            tlist.removeItem(0);
            // else if this child now has a matrix imposition (from a parent group)
            // we might be able to simplify
        } else if (N === 1 && tlist.getItem(0).type === 1 && !angle) {
            // Remap all point-based elements
            m = transformListToTransform(tlist).matrix;
            switch (selected.tagName) {
                case "line":
                    changes = {
                        x1: selected.getAttribute("x1"),
                        y1: selected.getAttribute("y1"),
                        x2: selected.getAttribute("x2"),
                        y2: selected.getAttribute("y2"),
                    };
                // Fallthrough
                case "polyline":
                case "polygon":
                    changes.points = selected.getAttribute("points");
                    if (changes.points) {
                        const list = selected.points;
                        const len = list.numberOfItems;
                        changes.points = new Array(len);
                        for (let i = 0; i < len; ++i) {
                            const pt = list.getItem(i);
                            changes.points[i] = {
                                x: pt.x,
                                y: pt.y,
                            };
                        }
                    }
                // Fallthrough
                case "path":
                    changes.d = selected.getAttribute("d");
                    operation = 1;
                    tlist.clear();
                    break;
            }
            // if it was a rotation, put the rotate back and return without a command
            // (this function has zero work to do for a rotate())
        } else {
            // operation = 4; // rotation
            if (angle) {
                const newRot = svgroot.createSVGTransform();
                newRot.setRotate(angle, newcenter.x, newcenter.y);
                if (tlist.numberOfItems) {
                    tlist.insertItemBefore(newRot, 0);
                } else {
                    tlist.appendItem(newRot);
                }
            }
            if (tlist.numberOfItems === 0) {
                selected.removeAttribute("transform");
            }
            return null;
        }

        // if it was a translate or resize, we need to remap the element and absorb the xform
        if (operation === 1 || operation === 2 || operation === 3) {
            remapElement(selected, changes, m);
        } // if we are remapping

        // if it was a translate, put back the rotate at the new center
        if (operation === 2) {
            if (angle) {
                if (!hasMatrixTransform(tlist)) {
                    newcenter = {
                        x: oldcenter.x + m.e,
                        y: oldcenter.y + m.f,
                    };
                }
                const newRot = svgroot.createSVGTransform();
                newRot.setRotate(angle, newcenter.x, newcenter.y);
                if (tlist.numberOfItems) {
                    tlist.insertItemBefore(newRot, 0);
                } else {
                    tlist.appendItem(newRot);
                }
            }
            // We have special processing for tspans:  Tspans are not transformable
            // but they can have x,y coordinates (sigh).  Thus, if this was a translate,
            // on a text element, also translate any tspan children.
            if (selected.tagName === "text") {
                const children = selected.childNodes;
                let c = children.length;
                while (c--) {
                    const child = children.item(c);
                    if (child.tagName === "tspan") {
                        const tspanChanges = {
                            x: Number(child.getAttribute("x")) || 0,
                            y: Number(child.getAttribute("y")) || 0,
                        };
                        remapElement(child, tspanChanges, m);
                    }
                }
            }
            // [Rold][M][T][S][-T] became [Rold][M]
            // we want it to be [Rnew][M][Tr] where Tr is the
            // translation required to re-center it
            // Therefore, [Tr] = [M_inv][Rnew_inv][Rold][M]
        } else if (operation === 3 && angle) {
            const { matrix } = transformListToTransform(tlist);
            const roldt = svgroot.createSVGTransform();
            roldt.setRotate(angle, oldcenter.x, oldcenter.y);
            const rold = roldt.matrix;
            const rnew = svgroot.createSVGTransform();
            rnew.setRotate(angle, newcenter.x, newcenter.y);
            const rnewInv = rnew.matrix.inverse();
            const mInv = matrix.inverse();
            const extrat = matrixMultiply(mInv, rnewInv, rold, matrix);
            remapElement(selected, changes, extrat);
            if (angle) {
                if (tlist.numberOfItems) {
                    tlist.insertItemBefore(rnew, 0);
                } else {
                    tlist.appendItem(rnew);
                }
            }
        }
    } // a non-group

    // if the transform list has been emptied, remove it
    if (tlist.numberOfItems === 0) {
        selected.removeAttribute("transform");
    }
    batchCmd.addSubCommand(new ChangeElementCommand$2(selected, initial));
    return batchCmd;
};

/**
 * Tools for SVG selected element operation.
 * @module selected-elem
 * @license MIT
 *
 * @copyright 2010 Alexis Deveria, 2010 Jeff Schiller
 */
const {
    MoveElementCommand,
    BatchCommand: BatchCommand$1,
    InsertElementCommand: InsertElementCommand$1,
    RemoveElementCommand: RemoveElementCommand$1,
    ChangeElementCommand: ChangeElementCommand$1,
} = history;
let svgCanvas$4 = null;

/**
 * @function module:selected-elem.init
 * @param {module:selected-elem.elementContext} elementContext
 * @returns {void}
 */
const init$4 = (canvas) => {
    svgCanvas$4 = canvas;
    svgCanvas$4.copySelectedElements = copySelectedElements;
    svgCanvas$4.groupSelectedElements = groupSelectedElements; // Wraps all the selected elements in a group (`g`) element.
    svgCanvas$4.pushGroupProperties = pushGroupProperty; // Pushes all appropriate parent group properties down to its children
    svgCanvas$4.ungroupSelectedElement = ungroupSelectedElement; // Unwraps all the elements in a selected group (`g`) element
    svgCanvas$4.moveToTopSelectedElement = moveToTopSelectedElem; // Repositions the selected element to the bottom in the DOM to appear on top
    svgCanvas$4.moveToBottomSelectedElement = moveToBottomSelectedElem; // Repositions the selected element to the top in the DOM to appear under other elements
    svgCanvas$4.moveUpDownSelected = moveUpDownSelected; // Moves the select element up or down the stack, based on the visibly
    svgCanvas$4.moveSelectedElements = moveSelectedElements; // Moves selected elements on the X/Y axis.
    svgCanvas$4.cloneSelectedElements = cloneSelectedElements; // Create deep DOM copies (clones) of all selected elements and move them slightly
    svgCanvas$4.alignSelectedElements = alignSelectedElements; // Aligns selected elements.
    svgCanvas$4.updateCanvas = updateCanvas; // Updates the editor canvas width/height/position after a zoom has occurred.
    svgCanvas$4.cycleElement = cycleElement; // Select the next/previous element within the current layer.
    svgCanvas$4.deleteSelectedElements = deleteSelectedElements; // Removes all selected elements from the DOM and adds the change to the history
};

/**
 * Repositions the selected element to the bottom in the DOM to appear on top of
 * other elements.
 * @function module:selected-elem.SvgCanvas#moveToTopSelectedElem
 * @fires module:selected-elem.SvgCanvas#event:changed
 * @returns {void}
 */
const moveToTopSelectedElem = () => {
    const [selected] = svgCanvas$4.getSelectedElements();
    if (selected) {
        const t = selected;
        const oldParent = t.parentNode;
        const oldNextSibling = t.nextSibling;
        t.parentNode.append(t);
        // If the element actually moved position, add the command and fire the changed
        // event handler.
        if (oldNextSibling !== t.nextSibling) {
            svgCanvas$4.addCommandToHistory(
                new MoveElementCommand(t, oldNextSibling, oldParent, "top"),
            );
            svgCanvas$4.call("changed", [t]);
        }
    }
};

/**
 * Repositions the selected element to the top in the DOM to appear under
 * other elements.
 * @function module:selected-elem.SvgCanvas#moveToBottomSelectedElement
 * @fires module:selected-elem.SvgCanvas#event:changed
 * @returns {void}
 */
const moveToBottomSelectedElem = () => {
    const [selected] = svgCanvas$4.getSelectedElements();
    if (selected) {
        let t = selected;
        const oldParent = t.parentNode;
        const oldNextSibling = t.nextSibling;
        let { firstChild } = t.parentNode;
        if (firstChild.tagName === "title") {
            firstChild = firstChild.nextSibling;
        }
        // This can probably be removed, as the defs should not ever apppear
        // inside a layer group
        if (firstChild.tagName === "defs") {
            firstChild = firstChild.nextSibling;
        }
        t = t.parentNode.insertBefore(t, firstChild);
        // If the element actually moved position, add the command and fire the changed
        // event handler.
        if (oldNextSibling !== t.nextSibling && !t.id.startsWith("connect")) {
            svgCanvas$4.addCommandToHistory(
                new MoveElementCommand(t, oldNextSibling, oldParent, "bottom"),
            );
            svgCanvas$4.call("changed", [t]);
        }
    }
};

/**
 * Moves the select element up or down the stack, based on the visibly
 * intersecting elements.
 * @function module:selected-elem.SvgCanvas#moveUpDownSelected
 * @param {"Up"|"Down"} dir - String that's either 'Up' or 'Down'
 * @fires module:selected-elem.SvgCanvas#event:changed
 * @returns {void}
 */
const moveUpDownSelected = (dir) => {
    const selectedElements = svgCanvas$4.getSelectedElements();
    const selected = selectedElements[0];
    if (!selected) {
        return;
    }
    svgCanvas$4.setCurBBoxes([]);
    let closest;
    let foundCur;
    // jQuery sorts this list
    const list = svgCanvas$4.getIntersectionList(
        getStrokedBBoxDefaultVisible([selected]),
    );
    if (dir === "Down") {
        list.reverse();
    }
    Array.prototype.forEach.call(list, (el) => {
        if (!foundCur) {
            if (el === selected) {
                foundCur = true;
            }
            return true;
        }
        if (closest === undefined) {
            closest = el;
        }
        return false;
    });
    if (!closest) {
        return;
    }
    const t = selected;
    const oldParent = t.parentNode;
    const oldNextSibling = t.nextSibling;
    if (dir === "Down") {
        closest.insertAdjacentElement("beforebegin", t);
    } else {
        closest.insertAdjacentElement("afterend", t);
    }
    // If the element actually moved position, add the command and fire the changed
    // event handler.
    if (oldNextSibling !== t.nextSibling) {
        svgCanvas$4.addCommandToHistory(
            new MoveElementCommand(t, oldNextSibling, oldParent, "Move " + dir),
        );
        svgCanvas$4.call("changed", [t]);
    }
};

/**
 * Moves selected elements on the X/Y axis.
 * @function module:selected-elem.SvgCanvas#moveSelectedElements
 * @param {Float} dx - Float with the distance to move on the x-axis
 * @param {Float} dy - Float with the distance to move on the y-axis
 * @param {boolean} undoable - Boolean indicating whether or not the action should be undoable
 * @fires module:selected-elem.SvgCanvas#event:changed
 * @returns {BatchCommand|void} Batch command for the move
 */

const moveSelectedElements = (dx, dy, undoable = true) => {
    const selectedElements = svgCanvas$4.getSelectedElements();
    const zoom = svgCanvas$4.getZoom();
    // if undoable is not sent, default to true
    // if single values, scale them to the zoom
    if (!Array.isArray(dx)) {
        dx /= zoom;
        dy /= zoom;
    }
    const batchCmd = new BatchCommand$1("position");
    selectedElements.forEach((selected, i) => {
        if (selected) {
            const xform = svgCanvas$4.getSvgRoot().createSVGTransform();
            const tlist = getTransformList(selected);

            // dx and dy could be arrays
            if (Array.isArray(dx)) {
                xform.setTranslate(dx[i], dy[i]);
            } else {
                xform.setTranslate(dx, dy);
            }
            if (tlist.numberOfItems) {
                tlist.insertItemBefore(xform, 0);
            } else {
                tlist.appendItem(xform);
            }
            const cmd = recalculateDimensions(selected);
            if (cmd) {
                batchCmd.addSubCommand(cmd);
            }
            svgCanvas$4
                .gettingSelectorManager()
                .requestSelector(selected)
                .resize();
        }
    });
    if (!batchCmd.isEmpty()) {
        if (undoable) {
            svgCanvas$4.addCommandToHistory(batchCmd);
        }
        svgCanvas$4.call("changed", selectedElements);
        return batchCmd;
    }
    return undefined;
};

/**
 * Create deep DOM copies (clones) of all selected elements and move them slightly
 * from their originals.
 * @function module:selected-elem.SvgCanvas#cloneSelectedElements
 * @param {Float} x Float with the distance to move on the x-axis
 * @param {Float} y Float with the distance to move on the y-axis
 * @returns {void}
 */
const cloneSelectedElements = (x, y) => {
    const selectedElements = svgCanvas$4.getSelectedElements();
    const currentGroup = svgCanvas$4.getCurrentGroup();
    let i;
    let elem;
    const batchCmd = new BatchCommand$1("Clone Elements");
    // find all the elements selected (stop at first null)
    const len = selectedElements.length;
    const index = (el) => {
        if (!el) return -1;
        let i = 0;
        do {
            i++;
        } while (el === el.previousElementSibling);
        return i;
    };

    /**
     * Sorts an array numerically and ascending.
     * @param {Element} a
     * @param {Element} b
     * @returns {Integer}
     */
    const sortfunction = (a, b) => {
        return index(b) - index(a);
    };
    selectedElements.sort(sortfunction);
    for (i = 0; i < len; ++i) {
        elem = selectedElements[i];
        if (!elem) {
            break;
        }
    }
    // use slice to quickly get the subset of elements we need
    const copiedElements = selectedElements.slice(0, i);
    svgCanvas$4.clearSelection(true);
    // note that we loop in the reverse way because of the way elements are added
    // to the selectedElements array (top-first)
    const drawing = svgCanvas$4.getDrawing();
    i = copiedElements.length;
    while (i--) {
        // clone each element and replace it within copiedElements
        elem = copiedElements[i] = drawing.copyElem(copiedElements[i]);
        (currentGroup || drawing.getCurrentLayer()).append(elem);
        batchCmd.addSubCommand(new InsertElementCommand$1(elem));
    }
    if (!batchCmd.isEmpty()) {
        svgCanvas$4.addToSelection(copiedElements.reverse()); // Need to reverse for correct selection-adding
        moveSelectedElements(x, y, false);
        svgCanvas$4.addCommandToHistory(batchCmd);
    }
};
/**
 * Aligns selected elements.
 * @function module:selected-elem.SvgCanvas#alignSelectedElements
 * @param {string} type - String with single character indicating the alignment type
 * @param {"selected"|"largest"|"smallest"|"page"} relativeTo
 * @returns {void}
 */
const alignSelectedElements = (type, relativeTo) => {
    const selectedElements = svgCanvas$4.getSelectedElements();
    const bboxes = []; // angles = [];
    const _bboxes = []; // angles = [];
    const len = selectedElements.length;
    if (!len) {
        return;
    }
    let minx = Number.MAX_VALUE;
    let maxx = Number.MIN_VALUE;
    let miny = Number.MAX_VALUE;
    let maxy = Number.MIN_VALUE;
    const isHorizontalAlign = (type) =>
        ["l", "c", "r", "left", "center", "right"].includes(type);
    const isVerticalAlign = (type) =>
        ["t", "m", "b", "top", "middle", "bottom"].includes(type);
    for (let i = 0; i < len; ++i) {
        if (!selectedElements[i]) {
            break;
        }
        const elem = selectedElements[i];
        bboxes[i] = getStrokedBBoxDefaultVisible([elem]);
        bboxes[i].id = elem.id;
        _bboxes[i] = bboxes[i];
    }

    // distribute horizontal and vertical align is not support smallest and largest
    if (
        ["smallest", "largest"].includes(relativeTo) &&
        ["dh", "distrib_horiz", "dv", "distrib_verti"].includes(type)
    ) {
        relativeTo = "selected";
    }
    switch (relativeTo) {
        case "smallest":
            if (isHorizontalAlign(type) || isVerticalAlign(type)) {
                const sortedBboxes = bboxes
                    .slice()
                    .sort((a, b) => a.width - b.width);
                const minBbox = sortedBboxes[0];
                minx = minBbox.x;
                miny = minBbox.y;
                maxx = minBbox.x + minBbox.width;
                maxy = minBbox.y + minBbox.height;
            }
            break;
        case "largest":
            if (isHorizontalAlign(type) || isVerticalAlign(type)) {
                const sortedBboxes = bboxes
                    .slice()
                    .sort((a, b) => a.width - b.width);
                const maxBbox = sortedBboxes[bboxes.length - 1];
                minx = maxBbox.x;
                miny = maxBbox.y;
                maxx = maxBbox.x + maxBbox.width;
                maxy = maxBbox.y + maxBbox.height;
            }
            break;
        case "page":
            minx = 0;
            miny = 0;
            maxx = svgCanvas$4.getContentW();
            maxy = svgCanvas$4.getContentH();
            break;
        default:
            // 'selected'
            minx = Math.min(...bboxes.map((box) => box.x));
            miny = Math.min(...bboxes.map((box) => box.y));
            maxx = Math.max(...bboxes.map((box) => box.x + box.width));
            maxy = Math.max(...bboxes.map((box) => box.y + box.height));
            break;
    } // adjust min/max
    let dx = [];
    let dy = [];
    if (["dh", "distrib_horiz"].includes(type)) {
        // distribute horizontal align
        [dx, dy] = _getDistributeHorizontalDistances(
            relativeTo,
            selectedElements,
            bboxes,
            minx,
            maxx,
            miny,
            maxy,
        );
    } else if (["dv", "distrib_verti"].includes(type)) {
        // distribute vertical align
        [dx, dy] = _getDistributeVerticalDistances(
            relativeTo,
            selectedElements,
            bboxes,
            minx,
            maxx,
            miny,
            maxy,
        );
    } else if (["make-grid"].includes(type)) {
        // tidy up
        let newPositions = tidify(_bboxes);
        bboxes.forEach((box) => {
            newPositions.forEach((elem) => {
                if (box.id === elem.id) {
                    dx.push(elem.x - box.x);
                    dy.push(elem.y - box.y);
                }
            });
        });
    } else {
        // normal align (top, left, right, ...)
        [dx, dy] = _getNormalDistances(
            type,
            selectedElements,
            bboxes,
            minx,
            maxx,
            miny,
            maxy,
        );
    }
    moveSelectedElements(dx, dy);
};

function tidify(nodes) {
    var config = {
        columnCount: "Auto",
        columnWidth: "Auto",
        columnGap: "Auto",
        rowCount: "Auto",
        rowHeight: "Auto",
        rowGap: "Auto",
    };
    sortNodes(nodes);
    const result = arrangeNodes(config, nodes);
    return result;
}
function arrangeNodes(config2, nodes) {
    let n = nodes.length;
    let column_cnt = config2.columnCount;
    let row_cnt = config2.rowCount;
    let column_width = config2.columnWidth;
    let column_width_ary;
    let row_height = config2.rowHeight;
    let row_height_ary;
    let column_gap = config2.columnGap;
    let row_gap = config2.rowGap;
    let origin = nodes.reduce(
        (a, el) => [Math.min(a[0], el.x), Math.min(a[1], el.y)],
        [nodes[0].x, nodes[0].y],
    );
    if (row_cnt === "Auto" && column_cnt === "Auto") {
        column_cnt = Math.round(Math.sqrt(n));
        row_cnt = Math.ceil(n / column_cnt);
    }
    let grid = [];
    let altNodes = nodes;
    for (let i = 1; i <= row_cnt; i++) {
        grid.push(altNodes.splice(0, column_cnt));
    }

    if (column_width === "Auto") {
        column_width_ary = grid.reduce(
            (a, row) => {
                let columnWidths = row.map((e) => e.width);
                return a.map((a2, i) =>
                    Math.round(Math.max(a2, columnWidths[i] || 0)),
                );
            },
            createAry(column_cnt, 0),
        );
    } else {
        column_width_ary = createAry(column_cnt, +column_width);
    }
    if (row_height === "Auto") {
        row_height_ary = grid.reduce((a, row) => {
            let rowHeights = row.map((e) => e.height);
            a.push(Math.round(Math.max(...rowHeights)));
            return a;
        }, []);
    } else {
        row_height_ary = createAry(row_cnt, +row_height);
    }
    function getColumnGap() {
        let maxWidth = Math.max(...column_width_ary);
        return Math.round(maxWidth * 0.25);
    }
    function getRowGap() {
        let maxHeight = Math.max(...row_height_ary);
        return Math.round(maxHeight * 0.25);
    }
    if (column_gap === "Auto" && row_gap !== "Auto") {
        column_gap = getColumnGap();
    } else if (row_gap === "Auto" && column_gap !== "Auto") {
        row_gap = getRowGap();
    } else if (column_gap === "Auto" && row_gap === "Auto") {
        let gap = Math.max(getColumnGap(), getRowGap());
        column_gap = gap;
        row_gap = gap;
    }
    let result = [];
    grid.forEach((row, row_index) => {
        row.forEach((el, column_index) => {
            let cur_col_gap = column_index * +column_gap;
            let cur_row_gap = row_index * +row_gap;
            let left_offset = +column_width_ary
                .slice(0, column_index)
                .reduce((a, e) => a + e, 0);
            let top_offset = +row_height_ary
                .slice(0, row_index)
                .reduce((a, e) => a + e, 0);
            let x = origin[0] + left_offset + cur_col_gap;
            let y = origin[1] + top_offset + cur_row_gap;
            result.push({ id: el.id, x: x, y: y });
            // el.x = x;
            // el.y = y;
        });
    });
    function createAry(length, fillElements) {
        let ary = [];
        for (let i = 0; i < length; i++) {
            ary.push(fillElements);
        }
        return ary;
    }
    return result;
}
function sortNodes(nodes2) {
    nodes2.sort((a, b) => {
        if (a.y > b.y) return 1;
        if (a.y < b.y) return -1;
        if (a.x > b.x) return 1;
        if (a.x < b.x) return -1;
        return 0;
    });
}

/**
 * Aligns selected elements.
 * @function module:selected-elem.SvgCanvas#alignSelectedElements
 * @param {string} type - String with single character indicating the alignment type
 * @param {"selected"|"largest"|"smallest"|"page"} relativeTo
 * @returns {void}
 */

/**
 * get distribution horizontal distances.
 * (internal call only)
 *
 * @param {string} relativeTo
 * @param {Element[]} selectedElements - the array with selected DOM elements
 * @param {module:utilities.BBoxObject} bboxes - bounding box objects
 * @param {Float} minx - selected area min-x
 * @param {Float} maxx - selected area max-x
 * @param {Float} miny - selected area min-y
 * @param {Float} maxy - selected area max-y
 * @returns {Array.Float[]} x and y distances array
 * @private
 */
const _getDistributeHorizontalDistances = (
    relativeTo,
    selectedElements,
    bboxes,
    minx,
    maxx,
    miny,
    maxy,
) => {
    const dx = [];
    const dy = [];
    for (let i = 0; i < selectedElements.length; i++) {
        dy[i] = 0;
    }
    const bboxesSortedClone = bboxes.slice().sort((firstBox, secondBox) => {
        const firstMaxX = firstBox.x + firstBox.width;
        const secondMaxX = secondBox.x + secondBox.width;
        if (firstMaxX === secondMaxX) {
            return 0;
        } else if (firstMaxX > secondMaxX) {
            return 1;
        } else {
            return -1;
        }
    });
    if (relativeTo === "page") {
        bboxesSortedClone.unshift({
            x: 0,
            y: 0,
            width: 0,
            height: maxy,
        }); // virtual left box
        bboxesSortedClone.push({
            x: maxx,
            y: 0,
            width: 0,
            height: maxy,
        }); // virtual right box
    }

    const totalWidth = maxx - minx;
    const totalBoxWidth = bboxesSortedClone
        .map((b) => b.width)
        .reduce((w1, w2) => w1 + w2, 0);
    const space = (totalWidth - totalBoxWidth) / (bboxesSortedClone.length - 1);
    const _dx = [];
    for (let i = 0; i < bboxesSortedClone.length; ++i) {
        _dx[i] = 0;
        if (i === 0) {
            continue;
        }
        const orgX = bboxesSortedClone[i].x;
        bboxesSortedClone[i].x =
            bboxesSortedClone[i - 1].x + bboxesSortedClone[i - 1].width + space;
        _dx[i] = bboxesSortedClone[i].x - orgX;
    }
    bboxesSortedClone.forEach((boxClone, idx) => {
        const orgIdx = bboxes.findIndex((box) => box === boxClone);
        if (orgIdx !== -1) {
            dx[orgIdx] = _dx[idx];
        }
    });
    return [dx, dy];
};

/**
 * get distribution vertical distances.
 * (internal call only)
 *
 * @param {string} relativeTo
 * @param {Element[]} selectedElements - the array with selected DOM elements
 * @param {module:utilities.BBoxObject} bboxes - bounding box objects
 * @param {Float} minx - selected area min-x
 * @param {Float} maxx - selected area max-x
 * @param {Float} miny - selected area min-y
 * @param {Float} maxy - selected area max-y
 * @returns {Array.Float[]}} x and y distances array
 * @private
 */
const _getDistributeVerticalDistances = (
    relativeTo,
    selectedElements,
    bboxes,
    minx,
    maxx,
    miny,
    maxy,
) => {
    const dx = [];
    const dy = [];
    for (let i = 0; i < selectedElements.length; i++) {
        dx[i] = 0;
    }
    const bboxesSortedClone = bboxes.slice().sort((firstBox, secondBox) => {
        const firstMaxY = firstBox.y + firstBox.height;
        const secondMaxY = secondBox.y + secondBox.height;
        if (firstMaxY === secondMaxY) {
            return 0;
        } else if (firstMaxY > secondMaxY) {
            return 1;
        } else {
            return -1;
        }
    });
    if (relativeTo === "page") {
        bboxesSortedClone.unshift({
            x: 0,
            y: 0,
            width: maxx,
            height: 0,
        }); // virtual top box
        bboxesSortedClone.push({
            x: 0,
            y: maxy,
            width: maxx,
            height: 0,
        }); // virtual bottom box
    }

    const totalHeight = maxy - miny;
    const totalBoxHeight = bboxesSortedClone
        .map((b) => b.height)
        .reduce((h1, h2) => h1 + h2, 0);
    const space =
        (totalHeight - totalBoxHeight) / (bboxesSortedClone.length - 1);
    const _dy = [];
    for (let i = 0; i < bboxesSortedClone.length; ++i) {
        _dy[i] = 0;
        if (i === 0) {
            continue;
        }
        const orgY = bboxesSortedClone[i].y;
        bboxesSortedClone[i].y =
            bboxesSortedClone[i - 1].y +
            bboxesSortedClone[i - 1].height +
            space;
        _dy[i] = bboxesSortedClone[i].y - orgY;
    }
    bboxesSortedClone.forEach((boxClone, idx) => {
        const orgIdx = bboxes.findIndex((box) => box === boxClone);
        if (orgIdx !== -1) {
            dy[orgIdx] = _dy[idx];
        }
    });
    return [dx, dy];
};

/**
 * get normal align distances.
 * (internal call only)
 *
 * @param {string} type
 * @param {Element[]} selectedElements - the array with selected DOM elements
 * @param {module:utilities.BBoxObject} bboxes - bounding box objects
 * @param {Float} minx - selected area min-x
 * @param {Float} maxx - selected area max-x
 * @param {Float} miny - selected area min-y
 * @param {Float} maxy - selected area max-y
 * @returns {Array.Float[]} x and y distances array
 * @private
 */
const _getNormalDistances = (
    type,
    selectedElements,
    bboxes,
    minx,
    maxx,
    miny,
    maxy,
) => {
    const len = selectedElements.length;
    const dx = new Array(len);
    const dy = new Array(len);
    for (let i = 0; i < len; ++i) {
        if (!selectedElements[i]) {
            break;
        }
        // const elem = selectedElements[i];
        const bbox = bboxes[i];
        dx[i] = 0;
        dy[i] = 0;
        switch (type) {
            case "l": // left (horizontal)
            case "left":
                // left (horizontal)
                dx[i] = minx - bbox.x;
                break;
            case "c": // center (horizontal)
            case "center":
                // center (horizontal)
                dx[i] = (minx + maxx) / 2 - (bbox.x + bbox.width / 2);
                break;
            case "r": // right (horizontal)
            case "right":
                // right (horizontal)
                dx[i] = maxx - (bbox.x + bbox.width);
                break;
            case "t": // top (vertical)
            case "top":
                // top (vertical)
                dy[i] = miny - bbox.y;
                break;
            case "m": // middle (vertical)
            case "middle":
                // middle (vertical)
                dy[i] = (miny + maxy) / 2 - (bbox.y + bbox.height / 2);
                break;
            case "b": // bottom (vertical)
            case "bottom":
                // bottom (vertical)
                dy[i] = maxy - (bbox.y + bbox.height);
                break;
        }
    }
    return [dx, dy];
};

/**
 * Removes all selected elements from the DOM and adds the change to the
 * history stack.
 * @function module:selected-elem.SvgCanvas#deleteSelectedElements
 * @fires module:selected-elem.SvgCanvas#event:changed
 * @returns {void}
 */
const deleteSelectedElements = () => {
    const selectedElements = svgCanvas$4.getSelectedElements();
    const batchCmd = new BatchCommand$1("Delete Elements");
    const selectedCopy = []; // selectedElements is being deleted

    selectedElements.forEach((selected) => {
        if (selected) {
            let parent = selected.parentNode;
            let t = selected;
            // this will unselect the element and remove the selectedOutline
            svgCanvas$4.gettingSelectorManager().releaseSelector(t);
            // Remove the path if present.
            removePath_(t.id);
            // Get the parent if it's a single-child anchor
            if (parent.tagName === "a" && parent.childNodes.length === 1) {
                t = parent;
                parent = parent.parentNode;
            }
            const { nextSibling } = t;
            t.remove();
            const elem = t;
            selectedCopy.push(selected); // for the copy
            batchCmd.addSubCommand(
                new RemoveElementCommand$1(elem, nextSibling, parent),
            );
        }
    });
    svgCanvas$4.setEmptySelectedElements();
    if (!batchCmd.isEmpty()) {
        svgCanvas$4.addCommandToHistory(batchCmd);
    }
    svgCanvas$4.call("changed", selectedCopy);
    svgCanvas$4.clearSelection();
};

/**
 * Remembers the current selected elements on the clipboard.
 * @function module:selected-elem.SvgCanvas#copySelectedElements
 * @returns {void}
 */
const copySelectedElements = () => {
    const selectedElements = svgCanvas$4.getSelectedElements();
    const data = JSON.stringify(
        selectedElements.map((x) => svgCanvas$4.getJsonFromSvgElements(x)),
    );
    // Use sessionStorage for the clipboard data.
    sessionStorage.setItem(svgCanvas$4.getClipboardID(), data);
    svgCanvas$4.flashStorage();

    // Context menu might not exist (it is provided by editor.js).
    const canvMenu = document.getElementById("se-cmenu_canvas");
    canvMenu.setAttribute("enablemenuitems", "#paste,#paste_in_place");
};

/**
 * Wraps all the selected elements in a group (`g`) element.
 * @function module:selected-elem.SvgCanvas#groupSelectedElements
 * @param {"a"|"g"} [type="g"] - type of element to group into, defaults to `<g>`
 * @param {string} [urlArg]
 * @returns {void}
 */
const groupSelectedElements = (type, urlArg, id) => {
    const selectedElements = svgCanvas$4.getSelectedElements();
    if (!type) {
        type = "g";
    }
    let cmdStr = "";
    let url;
    switch (type) {
        case "a": {
            cmdStr = "Make hyperlink";
            url = urlArg || "";
            break;
        }
        default: {
            type = "g";
            cmdStr = "Group Elements";
            break;
        }
    }
    const batchCmd = new BatchCommand$1(cmdStr);

    let g;
    // create and insert the group element
    if (id) {
        g = svgCanvas$4.addSVGElementsFromJson({
            element: type,
            attr: {
                id: id,
            },
        });
    } else {
        g = svgCanvas$4.addSVGElementsFromJson({
            element: type,
            attr: {
                id: svgCanvas$4.getNextId(),
            },
        });
    }

    if (type === "a") {
        setHref(g, url);
    }
    batchCmd.addSubCommand(new InsertElementCommand$1(g));

    // now move all children into the group
    let i = selectedElements.length;
    while (i--) {
        let elem = selectedElements[i];
        if (!elem) {
            continue;
        }
        if (
            elem.parentNode.tagName === "a" &&
            elem.parentNode.childNodes.length === 1
        ) {
            elem = elem.parentNode;
        }
        // this.moveUpDownSelected()
        const oldNextSibling = elem.nextSibling;
        const oldParent = elem.parentNode;
        g.append(elem);
        batchCmd.addSubCommand(
            new MoveElementCommand(elem, oldNextSibling, oldParent),
        );
    }
    if (!batchCmd.isEmpty()) {
        svgCanvas$4.addCommandToHistory(batchCmd);
    }

    // update selection
    svgCanvas$4.selectOnly([g], true);
};

/**
 * Pushes all appropriate parent group properties down to its children, then
 * removes them from the group.
 * @function module:selected-elem.SvgCanvas#pushGroupProperty
 * @param {SVGAElement|SVGGElement} g
 * @param {boolean} undoable
 * @returns {BatchCommand|void}
 */
const pushGroupProperty = (g, undoable) => {
    const children = g.childNodes;
    const len = children.length;
    const xform = g.getAttribute("transform");
    const glist = getTransformList(g);
    const m = transformListToTransform(glist).matrix;
    const batchCmd = new BatchCommand$1("Push group properties");

    // TODO: get all fill/stroke properties from the group that we are about to destroy
    // "fill", "fill-opacity", "fill-rule", "stroke", "stroke-dasharray", "stroke-dashoffset",
    // "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity",
    // "stroke-width"
    // and then for each child, if they do not have the attribute (or the value is 'inherit')
    // then set the child's attribute

    const gangle = getRotationAngle(g);
    const gattrs = {
        filter: g.getAttribute("filter"),
        opacity: g.getAttribute("opacity"),
    };
    let gfilter;
    let gblur;
    let changes;
    const drawing = svgCanvas$4.getDrawing();
    for (let i = 0; i < len; i++) {
        const elem = children[i];
        if (elem.nodeType !== 1) {
            continue;
        }
        if (gattrs.opacity !== null && gattrs.opacity !== 1) {
            // const c_opac = elem.getAttribute('opacity') || 1;
            const newOpac =
                Math.round(
                    (elem.getAttribute("opacity") || 1) * gattrs.opacity * 100,
                ) / 100;
            svgCanvas$4.changeSelectedAttribute("opacity", newOpac, [elem]);
        }
        if (gattrs.filter) {
            let cblur = svgCanvas$4.getBlur(elem);
            const origCblur = cblur;
            if (!gblur) {
                gblur = svgCanvas$4.getBlur(g);
            }
            if (cblur) {
                // Is this formula correct?
                cblur = Number(gblur) + Number(cblur);
            } else if (cblur === 0) {
                cblur = gblur;
            }

            // If child has no current filter, get group's filter or clone it.
            if (!origCblur) {
                // Set group's filter to use first child's ID
                if (!gfilter) {
                    gfilter = getRefElem(gattrs.filter);
                } else {
                    // Clone the group's filter
                    gfilter = drawing.copyElem(gfilter);
                    findDefs().append(gfilter);

                    // const filterElem = getRefElem(gfilter);
                    const blurElem = getFeGaussianBlur(gfilter);
                    // Change this in future for different filters
                    const suffix =
                        blurElem?.tagName === "feGaussianBlur"
                            ? "blur"
                            : "filter";
                    gfilter.id = elem.id + "_" + suffix;
                    svgCanvas$4.changeSelectedAttribute(
                        "filter",
                        "url(#" + gfilter.id + ")",
                        [elem],
                    );
                }
            } else {
                gfilter = getRefElem(elem.getAttribute("filter"));
            }
            // const filterElem = getRefElem(gfilter);
            const blurElem = getFeGaussianBlur(gfilter);

            // Update blur value
            if (cblur) {
                svgCanvas$4.changeSelectedAttribute("stdDeviation", cblur, [
                    blurElem,
                ]);
                svgCanvas$4.setBlurOffsets(gfilter, cblur);
            }
        }
        let chtlist = getTransformList(elem);

        // Don't process gradient transforms
        if (elem.tagName.includes("Gradient")) {
            chtlist = null;
        }

        // Hopefully not a problem to add this. Necessary for elements like <desc/>
        if (!chtlist) {
            continue;
        }

        // Apparently <defs> can get get a transformlist, but we don't want it to have one!
        if (elem.tagName === "defs") {
            continue;
        }
        if (glist.numberOfItems) {
            // TODO: if the group's transform is just a rotate, we can always transfer the
            // rotate() down to the children (collapsing consecutive rotates and factoring
            // out any translates)
            if (gangle && glist.numberOfItems === 1) {
                // [Rg] [Rc] [Mc]
                // we want [Tr] [Rc2] [Mc] where:
                //  - [Rc2] is at the child's current center but has the
                // sum of the group and child's rotation angles
                //  - [Tr] is the equivalent translation that this child
                // undergoes if the group wasn't there

                // [Tr] = [Rg] [Rc] [Rc2_inv]

                // get group's rotation matrix (Rg)
                const rgm = glist.getItem(0).matrix;

                // get child's rotation matrix (Rc)
                let rcm = svgCanvas$4.getSvgRoot().createSVGMatrix();
                const cangle = getRotationAngle(elem);
                if (cangle) {
                    rcm = chtlist.getItem(0).matrix;
                }

                // get child's old center of rotation
                const cbox = getBBox(elem);
                const ceqm = transformListToTransform(chtlist).matrix;
                const coldc = transformPoint(
                    cbox.x + cbox.width / 2,
                    cbox.y + cbox.height / 2,
                    ceqm,
                );

                // sum group and child's angles
                const sangle = gangle + cangle;

                // get child's rotation at the old center (Rc2_inv)
                const r2 = svgCanvas$4.getSvgRoot().createSVGTransform();
                r2.setRotate(sangle, coldc.x, coldc.y);

                // calculate equivalent translate
                const trm = matrixMultiply(rgm, rcm, r2.matrix.inverse());

                // set up tlist
                if (cangle) {
                    chtlist.removeItem(0);
                }
                if (sangle) {
                    if (chtlist.numberOfItems) {
                        chtlist.insertItemBefore(r2, 0);
                    } else {
                        chtlist.appendItem(r2);
                    }
                }
                if (trm.e || trm.f) {
                    const tr = svgCanvas$4.getSvgRoot().createSVGTransform();
                    tr.setTranslate(trm.e, trm.f);
                    if (chtlist.numberOfItems) {
                        chtlist.insertItemBefore(tr, 0);
                    } else {
                        chtlist.appendItem(tr);
                    }
                }
            } else {
                // more complicated than just a rotate
                // transfer the group's transform down to each child and then
                // call recalculateDimensions()
                const oldxform = elem.getAttribute("transform");
                changes = {};
                changes.transform = oldxform || "";
                const newxform = svgCanvas$4.getSvgRoot().createSVGTransform();

                // [ gm ] [ chm ] = [ chm ] [ gm' ]
                // [ gm' ] = [ chmInv ] [ gm ] [ chm ]
                const chm = transformListToTransform(chtlist).matrix;
                const chmInv = chm.inverse();
                const gm = matrixMultiply(chmInv, m, chm);
                newxform.setMatrix(gm);
                chtlist.appendItem(newxform);
            }
            const cmd = recalculateDimensions(elem);
            if (cmd) {
                batchCmd.addSubCommand(cmd);
            }
        }
    }

    // remove transform and make it undo-able
    if (xform) {
        changes = {};
        changes.transform = xform;
        g.setAttribute("transform", "");
        g.removeAttribute("transform");
        batchCmd.addSubCommand(new ChangeElementCommand$1(g, changes));
    }
    if (undoable && !batchCmd.isEmpty()) {
        return batchCmd;
    }
    return undefined;
};

/**
 * Converts selected/given `<use>` or child SVG element to a group.
 * @function module:selected-elem.SvgCanvas#convertToGroup
 * @param {Element} elem
 * @fires module:selected-elem.SvgCanvas#event:selected
 * @returns {void}
 */
const convertToGroup = (elem) => {
    const selectedElements = svgCanvas$4.getSelectedElements();
    if (!elem) {
        elem = selectedElements[0];
    }
    const $elem = elem;
    const batchCmd = new BatchCommand$1();
    let ts;
    const dataStorage = svgCanvas$4.getDataStorage();
    if (dataStorage.has($elem, "gsvg")) {
        // Use the gsvg as the new group
        const svg = elem.firstChild;
        const pt = {
            x: Number(svg.getAttribute("x")),
            y: Number(svg.getAttribute("y")),
        };

        // $(elem.firstChild.firstChild).unwrap();
        const firstChild = elem.firstChild.firstChild;
        if (firstChild) {
            firstChild.outerHTML = firstChild.innerHTML;
        }
        dataStorage.remove(elem, "gsvg");
        const tlist = getTransformList(elem);
        const xform = svgCanvas$4.getSvgRoot().createSVGTransform();
        xform.setTranslate(pt.x, pt.y);
        tlist.appendItem(xform);
        recalculateDimensions(elem);
        svgCanvas$4.call("selected", [elem]);
    } else if (dataStorage.has($elem, "symbol")) {
        elem = dataStorage.get($elem, "symbol");
        ts = $elem.getAttribute("transform") || "";
        const pos = {
            x: Number($elem.getAttribute("x")),
            y: Number($elem.getAttribute("y")),
        };
        const vb = elem.getAttribute("viewBox");
        if (vb) {
            const nums = vb.split(" ");
            pos.x -= Number(nums[0]);
            pos.y -= Number(nums[1]);
        }

        // Not ideal, but works
        ts += " translate(" + (pos.x || 0) + "," + (pos.y || 0) + ")";
        const prev = $elem.previousElementSibling;

        // Remove <use> element
        batchCmd.addSubCommand(
            new RemoveElementCommand$1(
                $elem,
                $elem.nextElementSibling,
                $elem.parentNode,
            ),
        );
        $elem.remove();

        // See if other elements reference this symbol
        const svgContent = svgCanvas$4.getSvgContent();
        // const hasMore = svgContent.querySelectorAll('use:data(symbol)').length;
        // @todo review this logic
        const hasMore = svgContent.querySelectorAll("use").length;
        const g = svgCanvas$4.getDOMDocument().createElementNS(NS.SVG, "g");
        const childs = elem.childNodes;
        let i;
        for (i = 0; i < childs.length; i++) {
            g.append(childs[i].cloneNode(true));
        }

        // Duplicate the gradients for Gecko, since they weren't included in the <symbol>
        if (isGecko()) {
            const svgElement = findDefs();
            const gradients = svgElement.querySelectorAll(
                "linearGradient,radialGradient,pattern",
            );
            for (let i = 0, im = gradients.length; im > i; i++) {
                g.appendChild(gradients[i].cloneNode(true));
            }
        }
        if (ts) {
            g.setAttribute("transform", ts);
        }
        const parent = elem.parentNode;
        svgCanvas$4.uniquifyElems(g);

        // Put the dupe gradients back into <defs> (after uniquifying them)
        if (isGecko()) {
            const svgElement = findDefs();
            const elements = g.querySelectorAll(
                "linearGradient,radialGradient,pattern",
            );
            for (let i = 0, im = elements.length; im > i; i++) {
                svgElement.appendChild(elements[i]);
            }
        }

        // now give the g itself a new id
        g.id = svgCanvas$4.getNextId();
        prev.after(g);
        if (parent) {
            if (!hasMore) {
                // remove symbol/svg element
                const { nextSibling } = elem;
                elem.remove();
                batchCmd.addSubCommand(
                    new RemoveElementCommand$1(elem, nextSibling, parent),
                );
            }
            batchCmd.addSubCommand(new InsertElementCommand$1(g));
        }
        svgCanvas$4.setUseData(g);
        if (isGecko()) {
            svgCanvas$4.convertGradients(findDefs());
        } else {
            svgCanvas$4.convertGradients(g);
        }

        // recalculate dimensions on the top-level children so that unnecessary transforms
        // are removed
        walkTreePost(g, (n) => {
            try {
                recalculateDimensions(n);
            } catch (e) {
                console.error(e);
            }
        });

        // Give ID for any visible element missing one
        const visElems = g.querySelectorAll(svgCanvas$4.getVisElems());
        Array.prototype.forEach.call(visElems, (el) => {
            if (!el.id) {
                el.id = svgCanvas$4.getNextId();
            }
        });
        svgCanvas$4.selectOnly([g]);
        const cm = pushGroupProperty(g, true);
        if (cm) {
            batchCmd.addSubCommand(cm);
        }
        svgCanvas$4.addCommandToHistory(batchCmd);
    } else {
        console.warn("Unexpected element to ungroup:", elem);
    }
};

/**
 * Unwraps all the elements in a selected group (`g`) element. This requires
 * significant recalculations to apply group's transforms, etc. to its children.
 * @function module:selected-elem.SvgCanvas#ungroupSelectedElement
 * @returns {void}
 */
const ungroupSelectedElement = () => {
    const selectedElements = svgCanvas$4.getSelectedElements();
    const dataStorage = svgCanvas$4.getDataStorage();
    let g = selectedElements[0];
    if (!g) {
        return;
    }
    if (dataStorage.has(g, "gsvg") || dataStorage.has(g, "symbol")) {
        // Is svg, so actually convert to group
        convertToGroup(g);
        return;
    }
    if (g.tagName === "use") {
        // Somehow doesn't have data set, so retrieve
        const symbol = getElement(getHref(g).substr(1));
        dataStorage.put(g, "symbol", symbol);
        dataStorage.put(g, "ref", symbol);
        convertToGroup(g);
        return;
    }
    const parentsA = getParents(g.parentNode, "a");
    if (parentsA?.length) {
        g = parentsA[0];
    }

    // Look for parent "a"
    if (g.tagName === "g" || g.tagName === "a") {
        const batchCmd = new BatchCommand$1("Ungroup Elements");
        const cmd = pushGroupProperty(g, true);
        if (cmd) {
            batchCmd.addSubCommand(cmd);
        }
        const parent = g.parentNode;
        const anchor = g.nextSibling;
        const children = new Array(g.childNodes.length);
        let i = 0;
        while (g.firstChild) {
            const elem = g.firstChild;
            const oldNextSibling = elem.nextSibling;
            const oldParent = elem.parentNode;

            // Remove child title elements
            if (elem.tagName === "title") {
                const { nextSibling } = elem;
                batchCmd.addSubCommand(
                    new RemoveElementCommand$1(elem, nextSibling, oldParent),
                );
                elem.remove();
                continue;
            }
            children[i++] = parent.insertBefore(elem, anchor);
            batchCmd.addSubCommand(
                new MoveElementCommand(elem, oldNextSibling, oldParent),
            );
        }

        // remove the group from the selection
        svgCanvas$4.clearSelection();

        // delete the group element (but make undo-able)
        const gNextSibling = g.nextSibling;
        g.remove();
        batchCmd.addSubCommand(
            new RemoveElementCommand$1(g, gNextSibling, parent),
        );
        if (!batchCmd.isEmpty()) {
            svgCanvas$4.addCommandToHistory(batchCmd);
        }

        // update selection
        svgCanvas$4.addToSelection(children);
    }
};
/**
 * Updates the editor canvas width/height/position after a zoom has occurred.
 * @function module:svgcanvas.SvgCanvas#updateCanvas
 * @param {Float} w - Float with the new width
 * @param {Float} h - Float with the new height
 * @fires module:svgcanvas.SvgCanvas#event:ext_canvasUpdated
 * @returns {module:svgcanvas.CanvasInfo}
 */
const updateCanvas = (w, h) => {
    svgCanvas$4.getSvgRoot().setAttribute("width", w);
    svgCanvas$4.getSvgRoot().setAttribute("height", h);
    const zoom = svgCanvas$4.getZoom();
    const bg = document.getElementById("canvasBackground");
    const grid = document.getElementById("gridContainer");
    const oldX = Number(svgCanvas$4.getSvgContent().getAttribute("x"));
    const oldY = Number(svgCanvas$4.getSvgContent().getAttribute("y"));
    const x = (w - svgCanvas$4.contentW * zoom) / 2;
    const y = (h - svgCanvas$4.contentH * zoom) / 2;
    assignAttributes(svgCanvas$4.getSvgContent(), {
        width: svgCanvas$4.contentW * zoom,
        height: svgCanvas$4.contentH * zoom,
        x,
        y,
        viewBox: "0 0 " + svgCanvas$4.contentW + " " + svgCanvas$4.contentH,
    });
    assignAttributes(bg, {
        width: svgCanvas$4.getSvgContent().getAttribute("width"),
        height: svgCanvas$4.getSvgContent().getAttribute("height"),
        x,
        y,
    });
    assignAttributes(grid, {
        width: svgCanvas$4.getSvgContent().getAttribute("width"),
        height: svgCanvas$4.getSvgContent().getAttribute("height"),
        x,
        y,
    });
    const bgImg = getElement("background_image");
    if (bgImg) {
        assignAttributes(bgImg, {
            width: "100%",
            height: "100%",
        });
    }
    svgCanvas$4.selectorManager.selectorParentGroup.setAttribute(
        "transform",
        "translate(" + x + "," + y + ")",
    );

    /**
     * Invoked upon updates to the canvas.
     * @event module:svgcanvas.SvgCanvas#event:ext_canvasUpdated
     * @type {PlainObject}
     * @property {Integer} new_x
     * @property {Integer} new_y
     * @property {string} old_x (Of Integer)
     * @property {string} old_y (Of Integer)
     * @property {Integer} d_x
     * @property {Integer} d_y
     */
    svgCanvas$4.runExtensions(
        "canvasUpdated",
        /**
         * @type {module:svgcanvas.SvgCanvas#event:ext_canvasUpdated}
         */
        {
            new_x: x,
            new_y: y,
            old_x: oldX,
            old_y: oldY,
            d_x: x - oldX,
            d_y: y - oldY,
        },
    );
    return {
        x,
        y,
        old_x: oldX,
        old_y: oldY,
        d_x: x - oldX,
        d_y: y - oldY,
    };
};
/**
 * Select the next/previous element within the current layer.
 * @function module:svgcanvas.SvgCanvas#cycleElement
 * @param {boolean} next - true = next and false = previous element
 * @fires module:svgcanvas.SvgCanvas#event:selected
 * @returns {void}
 */
const cycleElement = (next) => {
    const selectedElements = svgCanvas$4.getSelectedElements();
    const currentGroup = svgCanvas$4.getCurrentGroup();
    let num;
    const curElem = selectedElements[0];
    let elem = false;
    const allElems = getVisibleElements(
        currentGroup || svgCanvas$4.getCurrentDrawing().getCurrentLayer(),
    );
    if (!allElems.length) {
        return;
    }
    if (!curElem) {
        num = next ? allElems.length - 1 : 0;
        elem = allElems[num];
    } else {
        let i = allElems.length;
        while (i--) {
            if (allElems[i] === curElem) {
                num = next ? i - 1 : i + 1;
                if (num >= allElems.length) {
                    num = 0;
                } else if (num < 0) {
                    num = allElems.length - 1;
                }
                elem = allElems[num];
                break;
            }
        }
    }
    svgCanvas$4.selectOnly([elem], true);
    svgCanvas$4.call("selected", selectedElements);
};

/**
 * Tools for blur event.
 * @module blur
 * @license MIT
 * @copyright 2011 Jeff Schiller
 */

let svgCanvas$3 = null;

/**
 * @function module:blur.init
 * @param {module:blur.blurContext} blurContext
 * @returns {void}
 */
const init$3 = (canvas) => {
    svgCanvas$3 = canvas;
};

/**
 * Sets the `stdDeviation` blur value on the selected element without being undoable.
 * @function module:svgcanvas.SvgCanvas#setBlurNoUndo
 * @param {Float} val - The new `stdDeviation` value
 * @returns {void}
 */
const setBlurNoUndo = function (val) {
    const selectedElements = svgCanvas$3.getSelectedElements();
    if (!svgCanvas$3.getFilter()) {
        svgCanvas$3.setBlur(val);
        return;
    }
    if (val === 0) {
        // Don't change the StdDev, as that will hide the element.
        // Instead, just remove the value for "filter"
        svgCanvas$3.changeSelectedAttributeNoUndo("filter", "");
        svgCanvas$3.setFilterHidden(true);
    } else {
        const elem = selectedElements[0];
        if (svgCanvas$3.getFilterHidden()) {
            svgCanvas$3.changeSelectedAttributeNoUndo(
                "filter",
                "url(#" + elem.id + "_blur)",
            );
        }
        const filter = svgCanvas$3.getFilter();
        svgCanvas$3.changeSelectedAttributeNoUndo("stdDeviation", val, [
            filter.firstChild,
        ]);
        svgCanvas$3.setBlurOffsets(filter, val);
    }
};

/**
 *
 * @returns {void}
 */
function finishChange() {
    const bCmd = svgCanvas$3.undoMgr.finishUndoableChange();
    svgCanvas$3.getCurCommand().addSubCommand(bCmd);
    svgCanvas$3.addCommandToHistory(svgCanvas$3.getCurCommand());
    svgCanvas$3.setCurCommand(null);
    svgCanvas$3.setFilter(null);
}

/**
 * Sets the `x`, `y`, `width`, `height` values of the filter element in order to
 * make the blur not be clipped. Removes them if not neeeded.
 * @function module:svgcanvas.SvgCanvas#setBlurOffsets
 * @param {Element} filterElem - The filter DOM element to update
 * @param {Float} stdDev - The standard deviation value on which to base the offset size
 * @returns {void}
 */
const setBlurOffsets = function (filterElem, stdDev) {
    if (stdDev > 3) {
        // TODO: Create algorithm here where size is based on expected blur
        svgCanvas$3.assignAttributes(
            filterElem,
            {
                x: "-50%",
                y: "-50%",
                width: "200%",
                height: "200%",
            },
            100,
        );
    } else {
        filterElem.removeAttribute("x");
        filterElem.removeAttribute("y");
        filterElem.removeAttribute("width");
        filterElem.removeAttribute("height");
    }
};

/**
 * Adds/updates the blur filter to the selected element.
 * @function module:svgcanvas.SvgCanvas#setBlur
 * @param {Float} val - Float with the new `stdDeviation` blur value
 * @param {boolean} complete - Whether or not the action should be completed (to add to the undo manager)
 * @returns {void}
 */
const setBlur = function (val, complete) {
    const { InsertElementCommand, ChangeElementCommand, BatchCommand } =
        svgCanvas$3.history;
    const selectedElements = svgCanvas$3.getSelectedElements();
    if (svgCanvas$3.getCurCommand()) {
        finishChange();
        return;
    }

    // Looks for associated blur, creates one if not found
    const elem = selectedElements[0];
    const elemId = elem.id;
    svgCanvas$3.setFilter(svgCanvas$3.getElement(elemId + "_blur"));
    val -= 0;
    const batchCmd = new BatchCommand();

    // Blur found!
    if (svgCanvas$3.getFilter()) {
        if (val === 0) {
            svgCanvas$3.setFilter(null);
        }
    } else {
        // Not found, so create
        const newblur = svgCanvas$3.addSVGElementsFromJson({
            element: "feGaussianBlur",
            attr: {
                in: "SourceGraphic",
                stdDeviation: val,
            },
        });
        svgCanvas$3.setFilter(
            svgCanvas$3.addSVGElementsFromJson({
                element: "filter",
                attr: {
                    id: elemId + "_blur",
                },
            }),
        );
        svgCanvas$3.getFilter().append(newblur);
        svgCanvas$3.findDefs().append(svgCanvas$3.getFilter());
        batchCmd.addSubCommand(
            new InsertElementCommand(svgCanvas$3.getFilter()),
        );
    }
    const changes = {
        filter: elem.getAttribute("filter"),
    };
    if (val === 0) {
        elem.removeAttribute("filter");
        batchCmd.addSubCommand(new ChangeElementCommand(elem, changes));
        return;
    }
    svgCanvas$3.changeSelectedAttribute("filter", "url(#" + elemId + "_blur)");
    batchCmd.addSubCommand(new ChangeElementCommand(elem, changes));
    svgCanvas$3.setBlurOffsets(svgCanvas$3.getFilter(), val);
    const filter = svgCanvas$3.getFilter();
    svgCanvas$3.setCurCommand(batchCmd);
    svgCanvas$3.undoMgr.beginUndoableChange("stdDeviation", [
        filter ? filter.firstChild : null,
    ]);
    if (complete) {
        svgCanvas$3.setBlurNoUndo(val);
        finishChange();
    }
};

/**
 * Tools for SVG sanitization.
 * @module sanitize
 * @license MIT
 *
 * @copyright 2010 Alexis Deveria, 2010 Jeff Schiller
 */
const REVERSE_NS = getReverseNS();

// Todo: Split out into core attributes, presentation attributes, etc. so consistent
/**
 * This defines which elements and attributes that we support (or at least
 * don't remove).
 * @type {PlainObject}
 */
/* eslint-disable max-len */
const svgGenericWhiteList = ["class", "id", "display", "transform", "style"];
const svgWhiteList_ = {
    // SVG Elements
    a: [
        "clip-path",
        "clip-rule",
        "fill",
        "fill-opacity",
        "fill-rule",
        "filter",
        "mask",
        "opacity",
        "stroke",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke-width",
        "systemLanguage",
        "xlink:href",
        "xlink:title",
    ],
    circle: [
        "clip-path",
        "clip-rule",
        "cx",
        "cy",
        "enable-background",
        "fill",
        "fill-opacity",
        "fill-rule",
        "filter",
        "mask",
        "opacity",
        "r",
        "requiredFeatures",
        "stroke",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke-width",
        "systemLanguage",
    ],
    clipPath: ["clipPathUnits"],
    defs: [],
    desc: [],
    ellipse: [
        "clip-path",
        "clip-rule",
        "cx",
        "cy",
        "fill",
        "fill-opacity",
        "fill-rule",
        "filter",
        "mask",
        "opacity",
        "requiredFeatures",
        "rx",
        "ry",
        "stroke",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke-width",
        "systemLanguage",
    ],
    feBlend: ["in", "in2"],
    feColorMatrix: ["in", "type", "value", "result", "values"],
    feComposite: ["in", "operator", "result", "in2"],
    feFlood: ["flood-color", "in", "result", "flood-opacity"],
    feGaussianBlur: [
        "color-interpolation-filters",
        "in",
        "requiredFeatures",
        "stdDeviation",
        "result",
    ],
    feMerge: [],
    feMergeNode: ["in"],
    feMorphology: ["in", "operator", "radius"],
    feOffset: ["dx", "in", "dy", "result"],
    filter: [
        "color-interpolation-filters",
        "filterRes",
        "filterUnits",
        "height",
        "primitiveUnits",
        "requiredFeatures",
        "width",
        "x",
        "xlink:href",
        "y",
    ],
    foreignObject: [
        "font-size",
        "height",
        "opacity",
        "requiredFeatures",
        "width",
        "x",
        "y",
    ],
    g: [
        "clip-path",
        "clip-rule",
        "fill",
        "fill-opacity",
        "fill-rule",
        "filter",
        "mask",
        "opacity",
        "requiredFeatures",
        "stroke",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke-width",
        "systemLanguage",
        "font-family",
        "font-size",
        "font-style",
        "font-weight",
        "text-anchor",
    ],
    image: [
        "clip-path",
        "clip-rule",
        "filter",
        "height",
        "mask",
        "opacity",
        "requiredFeatures",
        "systemLanguage",
        "width",
        "x",
        "xlink:href",
        "xlink:title",
        "y",
    ],
    line: [
        "clip-path",
        "clip-rule",
        "fill",
        "fill-opacity",
        "fill-rule",
        "filter",
        "marker-end",
        "marker-mid",
        "marker-start",
        "mask",
        "opacity",
        "requiredFeatures",
        "stroke",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke-width",
        "systemLanguage",
        "x1",
        "x2",
        "y1",
        "y2",
    ],
    linearGradient: [
        "gradientTransform",
        "gradientUnits",
        "requiredFeatures",
        "spreadMethod",
        "systemLanguage",
        "x1",
        "x2",
        "xlink:href",
        "y1",
        "y2",
    ],
    marker: [
        "markerHeight",
        "markerUnits",
        "markerWidth",
        "orient",
        "preserveAspectRatio",
        "refX",
        "refY",
        "se_type",
        "systemLanguage",
        "viewBox",
    ],
    mask: ["height", "maskContentUnits", "maskUnits", "width", "x", "y"],
    metadata: [],
    path: [
        "clip-path",
        "clip-rule",
        "d",
        "enable-background",
        "fill",
        "fill-opacity",
        "fill-rule",
        "filter",
        "marker-end",
        "marker-mid",
        "marker-start",
        "mask",
        "opacity",
        "requiredFeatures",
        "stroke",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke-width",
        "systemLanguage",
    ],
    pattern: [
        "height",
        "patternContentUnits",
        "patternTransform",
        "patternUnits",
        "requiredFeatures",
        "systemLanguage",
        "viewBox",
        "width",
        "x",
        "xlink:href",
        "y",
    ],
    polygon: [
        "clip-path",
        "clip-rule",
        "fill",
        "fill-opacity",
        "fill-rule",
        "filter",
        "marker-end",
        "marker-mid",
        "marker-start",
        "mask",
        "opacity",
        "points",
        "requiredFeatures",
        "stroke",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke-width",
        "systemLanguage",
        "sides",
        "shape",
        "edge",
        "point",
        "starRadiusMultiplier",
        "r",
        "radialshift",
        "r2",
        "orient",
        "cx",
        "cy",
    ],
    polyline: [
        "clip-path",
        "clip-rule",
        "fill",
        "fill-opacity",
        "fill-rule",
        "filter",
        "marker-end",
        "marker-mid",
        "marker-start",
        "mask",
        "opacity",
        "points",
        "requiredFeatures",
        "stroke",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke-width",
        "systemLanguage",
        "se:connector",
    ],
    radialGradient: [
        "cx",
        "cy",
        "fx",
        "fy",
        "gradientTransform",
        "gradientUnits",
        "r",
        "requiredFeatures",
        "spreadMethod",
        "systemLanguage",
        "xlink:href",
    ],
    rect: [
        "clip-path",
        "clip-rule",
        "fill",
        "fill-opacity",
        "fill-rule",
        "filter",
        "height",
        "mask",
        "opacity",
        "requiredFeatures",
        "rx",
        "ry",
        "stroke",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke-width",
        "systemLanguage",
        "width",
        "x",
        "y",
    ],
    stop: [
        "offset",
        "requiredFeatures",
        "stop-opacity",
        "systemLanguage",
        "stop-color",
        "gradientUnits",
        "gradientTransform",
    ],
    style: ["type"],
    svg: [
        "clip-path",
        "clip-rule",
        "enable-background",
        "filter",
        "height",
        "mask",
        "preserveAspectRatio",
        "requiredFeatures",
        "systemLanguage",
        "version",
        "viewBox",
        "width",
        "x",
        "xmlns",
        "xmlns:se",
        "xmlns:xlink",
        "xmlns:oi",
        "oi:animations",
        "y",
        "stroke-linejoin",
        "fill-rule",
        "aria-label",
        "stroke-width",
        "fill-rule",
        "xml:space",
    ],
    switch: ["requiredFeatures", "systemLanguage"],
    symbol: [
        "fill",
        "fill-opacity",
        "fill-rule",
        "filter",
        "font-family",
        "font-size",
        "font-style",
        "font-weight",
        "opacity",
        "overflow",
        "preserveAspectRatio",
        "requiredFeatures",
        "stroke",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke-width",
        "systemLanguage",
        "viewBox",
        "width",
        "height",
    ],
    text: [
        "clip-path",
        "clip-rule",
        "fill",
        "fill-opacity",
        "fill-rule",
        "filter",
        "font-family",
        "font-size",
        "font-style",
        "font-weight",
        "mask",
        "opacity",
        "requiredFeatures",
        "stroke",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke-width",
        "systemLanguage",
        "text-anchor",
        "letter-spacing",
        "word-spacing",
        "text-decoration",
        "textLength",
        "lengthAdjust",
        "x",
        "xml:space",
        "y",
    ],
    textPath: [
        "method",
        "requiredFeatures",
        "spacing",
        "startOffset",
        "systemLanguage",
        "xlink:href",
    ],
    title: [],
    tspan: [
        "clip-path",
        "clip-rule",
        "dx",
        "dy",
        "fill",
        "fill-opacity",
        "fill-rule",
        "filter",
        "font-family",
        "font-size",
        "font-style",
        "font-weight",
        "mask",
        "opacity",
        "requiredFeatures",
        "rotate",
        "stroke",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke-width",
        "systemLanguage",
        "text-anchor",
        "textLength",
        "x",
        "xml:space",
        "y",
    ],
    use: [
        "clip-path",
        "clip-rule",
        "fill",
        "fill-opacity",
        "fill-rule",
        "filter",
        "height",
        "mask",
        "stroke",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke-width",
        "width",
        "x",
        "xlink:href",
        "y",
        "overflow",
    ],
    // MathML Elements
    annotation: ["encoding"],
    "annotation-xml": ["encoding"],
    maction: ["actiontype", "other", "selection"],
    math: ["xmlns"],
    menclose: ["notation"],
    merror: [],
    mfrac: ["linethickness"],
    mi: ["mathvariant"],
    mmultiscripts: [],
    mn: [],
    mo: ["fence", "lspace", "maxsize", "minsize", "rspace", "stretchy"],
    mover: [],
    mpadded: ["lspace", "width", "height", "depth", "voffset"],
    mphantom: [],
    mprescripts: [],
    mroot: [],
    mrow: ["xlink:href", "xlink:type", "xmlns:xlink"],
    mspace: ["depth", "height", "width"],
    msqrt: [],
    mstyle: [
        "displaystyle",
        "mathbackground",
        "mathcolor",
        "mathvariant",
        "scriptlevel",
    ],
    msub: [],
    msubsup: [],
    msup: [],
    mtable: [
        "align",
        "columnalign",
        "columnlines",
        "columnspacing",
        "displaystyle",
        "equalcolumns",
        "equalrows",
        "frame",
        "rowalign",
        "rowlines",
        "rowspacing",
        "width",
    ],
    mtd: ["columnalign", "columnspan", "rowalign", "rowspan"],
    mtext: [],
    mtr: ["columnalign", "rowalign"],
    munder: [],
    munderover: [],
    none: [],
    semantics: [],
};
/* eslint-enable max-len */

// add generic attributes to all elements of the whitelist
Object.keys(svgWhiteList_).forEach((element) => {
    svgWhiteList_[element] = [
        ...svgWhiteList_[element],
        ...svgGenericWhiteList,
    ];
});

// Produce a Namespace-aware version of svgWhitelist
const svgWhiteListNS_ = {};
Object.entries(svgWhiteList_).forEach(([elt, atts]) => {
    const attNS = {};
    Object.entries(atts).forEach(([_i, att]) => {
        if (att.includes(":")) {
            const v = att.split(":");
            attNS[v[1]] = NS[v[0].toUpperCase()];
        } else {
            attNS[att] = att === "xmlns" ? NS.XMLNS : null;
        }
    });
    svgWhiteListNS_[elt] = attNS;
});

/**
 * Sanitizes the input node and its children.
 * It only keeps what is allowed from our whitelist defined above.
 * @function module:sanitize.sanitizeSvg
 * @param {Text|Element} node - The DOM element to be checked (we'll also check its children) or text node to be cleaned up
 * @returns {void}
 */
const sanitizeSvg = (node) => {
    // Cleanup text nodes
    if (node.nodeType === 3) {
        // 3 === TEXT_NODE
        // Trim whitespace
        node.nodeValue = node.nodeValue.trim();
        // Remove if empty
        if (!node.nodeValue.length) {
            node.remove();
        }
    }

    // We only care about element nodes.
    // Automatically return for all non-element nodes, such as comments, etc.
    if (node.nodeType !== 1) {
        // 1 == ELEMENT_NODE
        return;
    }
    const doc = node.ownerDocument;
    const parent = node.parentNode;
    // can parent ever be null here?  I think the root node's parent is the document...
    if (!doc || !parent) {
        return;
    }
    const allowedAttrs = svgWhiteList_[node.nodeName];
    const allowedAttrsNS = svgWhiteListNS_[node.nodeName];
    // if this element is supported, sanitize it
    if (typeof allowedAttrs !== "undefined") {
        const seAttrs = [];
        let i = node.attributes.length;
        while (i--) {
            // if the attribute is not in our whitelist, then remove it
            const attr = node.attributes.item(i);
            const attrName = attr.nodeName;
            const attrLocalName = attr.localName;
            const attrNsURI = attr.namespaceURI;
            // Check that an attribute with the correct localName in the correct namespace is on
            // our whitelist or is a namespace declaration for one of our allowed namespaces
            if (
                attrNsURI !== allowedAttrsNS[attrLocalName] &&
                attrNsURI !== NS.XMLNS &&
                !(attrNsURI === NS.XMLNS && REVERSE_NS[attr.value])
            ) {
                // Bypassing the whitelist to allow se: and oi: prefixes
                // We can add specific namepaces on demand for now.
                // Is there a more appropriate way to do this?
                if (
                    attrName.startsWith("se:") ||
                    attrName.startsWith("oi:") ||
                    attrName.startsWith("data-")
                ) {
                    // We should bypass the namespace aswell
                    const seAttrNS = attrName.startsWith("se:")
                        ? NS.SE
                        : attrName.startsWith("oi:")
                          ? NS.OI
                          : null;
                    seAttrs.push([attrName, attr.value, seAttrNS]);
                } else {
                    console.warn(
                        `sanitizeSvg: attribute ${attrName} in element ${node.nodeName} not in whitelist is removed`,
                    );
                    node.removeAttributeNS(attrNsURI, attrLocalName);
                }
            }

            // For the style attribute, rewrite it in terms of XML presentational attributes
            if (attrName === "style") {
                const props = attr.value.split(";");
                let p = props.length;
                while (p--) {
                    const [name, val] = props[p].split(":");
                    const styleAttrName = (name || "").trim();
                    const styleAttrVal = (val || "").trim();
                    // Now check that this attribute is supported
                    if (allowedAttrs.includes(styleAttrName)) {
                        node.setAttribute(styleAttrName, styleAttrVal);
                    }
                }
                node.removeAttribute("style");
            }
        }
        Object.values(seAttrs).forEach(([att, val, ns]) => {
            node.setAttributeNS(ns, att, val);
        });

        // for some elements that have a xlink:href, ensure the URI refers to a local element
        // (but not for links)
        const href = getHref(node);
        if (
            href &&
            [
                "filter",
                "linearGradient",
                "pattern",
                "radialGradient",
                "textPath",
                "use",
            ].includes(node.nodeName) &&
            href[0] !== "#"
        ) {
            // remove the attribute (but keep the element)
            setHref(node, "");
            console.warn(
                `sanitizeSvg: attribute href in element ${node.nodeName} pointing to a non-local reference (${href}) is removed`,
            );
            node.removeAttributeNS(NS.XLINK, "href");
        }

        // Safari crashes on a <use> without a xlink:href, so we just remove the node here
        if (node.nodeName === "use" && !getHref(node)) {
            console.warn(
                `sanitizeSvg: element ${node.nodeName} without a xlink:href is removed`,
            );
            node.remove();
            return;
        }
        // if the element has attributes pointing to a non-local reference,
        // need to remove the attribute
        Object.values(
            [
                "clip-path",
                "fill",
                "filter",
                "marker-end",
                "marker-mid",
                "marker-start",
                "mask",
                "stroke",
            ],
            (attr) => {
                let val = node.getAttribute(attr);
                if (val) {
                    val = getUrlFromAttr(val);
                    // simply check for first character being a '#'
                    if (val && val[0] !== "#") {
                        node.setAttribute(attr, "");
                        console.warn(
                            `sanitizeSvg: attribute ${attr} in element ${node.nodeName} pointing to a non-local reference (${val}) is removed`,
                        );
                        node.removeAttribute(attr);
                    }
                }
            },
        );

        // recurse to children
        i = node.childNodes.length;
        while (i--) {
            sanitizeSvg(node.childNodes.item(i));
        }
        // else (element not supported), remove it
    } else {
        // remove all children from this node and insert them before this node
        // TODO: in the case of animation elements this will hardly ever be correct
        console.warn(
            `sanitizeSvg: element ${node.nodeName} not supported is removed`,
        );
        const children = [];
        while (node.hasChildNodes()) {
            children.push(parent.insertBefore(node.firstChild, node));
        }

        // remove this node from the document altogether
        node.remove();

        // call sanitizeSvg on each of those children
        let i = children.length;
        while (i--) {
            sanitizeSvg(children[i]);
        }
    }
};

function _typeof(obj) {
    "@babel/helpers - typeof";

    return (
        (_typeof =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (obj) {
                      return typeof obj;
                  }
                : function (obj) {
                      return obj &&
                          "function" == typeof Symbol &&
                          obj.constructor === Symbol &&
                          obj !== Symbol.prototype
                          ? "symbol"
                          : typeof obj;
                  }),
        _typeof(obj)
    );
}

// DEFLATE is a complex format; to read this code, you should probably check the RFC first:

// aliases for shorter compressed code (most minifers don't do this)
var u8 = Uint8Array,
    u16 = Uint16Array,
    u32 = Uint32Array;
// fixed length extra bits
var fleb = new u8([
    0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5,
    5, 5, 5, 0, /* unused */ 0, 0, /* impossible */ 0,
]);
// fixed distance extra bits
// see fleb note
var fdeb = new u8([
    0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10,
    11, 11, 12, 12, 13, 13, /* unused */ 0, 0,
]);
// code length index map
var clim = new u8([
    16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15,
]);
// get base, reverse index map from extra bits
var freb = function (eb, start) {
    var b = new u16(31);
    for (var i = 0; i < 31; ++i) {
        b[i] = start += 1 << eb[i - 1];
    }
    // numbers here are at max 18 bits
    var r = new u32(b[30]);
    for (var i = 1; i < 30; ++i) {
        for (var j = b[i]; j < b[i + 1]; ++j) {
            r[j] = ((j - b[i]) << 5) | i;
        }
    }
    return [b, r];
};
var _a = freb(fleb, 2),
    fl = _a[0],
    revfl = _a[1];
// we can ignore the fact that the other numbers are wrong; they never happen anyway
(fl[28] = 258), (revfl[258] = 28);
var _b = freb(fdeb, 0),
    fd = _b[0],
    revfd = _b[1];
// map of value to reverse (assuming 16 bits)
var rev = new u16(32768);
for (var i$1 = 0; i$1 < 32768; ++i$1) {
    // reverse table algorithm from SO
    var x$1 = ((i$1 & 0xaaaa) >>> 1) | ((i$1 & 0x5555) << 1);
    x$1 = ((x$1 & 0xcccc) >>> 2) | ((x$1 & 0x3333) << 2);
    x$1 = ((x$1 & 0xf0f0) >>> 4) | ((x$1 & 0x0f0f) << 4);
    rev[i$1] = (((x$1 & 0xff00) >>> 8) | ((x$1 & 0x00ff) << 8)) >>> 1;
}
// create huffman tree from u8 "map": index -> code length for code index
// mb (max bits) must be at most 15
// TODO: optimize/split up?
var hMap = function (cd, mb, r) {
    var s = cd.length;
    // index
    var i = 0;
    // u16 "map": index -> # of codes with bit length = index
    var l = new u16(mb);
    // length of cd must be 288 (total # of codes)
    for (; i < s; ++i) ++l[cd[i] - 1];
    // u16 "map": index -> minimum code for bit length = index
    var le = new u16(mb);
    for (i = 0; i < mb; ++i) {
        le[i] = (le[i - 1] + l[i - 1]) << 1;
    }
    var co;
    if (r) {
        // u16 "map": index -> number of actual bits, symbol for code
        co = new u16(1 << mb);
        // bits to remove for reverser
        var rvb = 15 - mb;
        for (i = 0; i < s; ++i) {
            // ignore 0 lengths
            if (cd[i]) {
                // num encoding both symbol and bits read
                var sv = (i << 4) | cd[i];
                // free bits
                var r_1 = mb - cd[i];
                // start value
                var v = le[cd[i] - 1]++ << r_1;
                // m is end value
                for (var m = v | ((1 << r_1) - 1); v <= m; ++v) {
                    // every 16 bit value starting with the code yields the same result
                    co[rev[v] >>> rvb] = sv;
                }
            }
        }
    } else {
        co = new u16(s);
        for (i = 0; i < s; ++i) co[i] = rev[le[cd[i] - 1]++] >>> (15 - cd[i]);
    }
    return co;
};
// fixed length tree
var flt = new u8(288);
for (var i$1 = 0; i$1 < 144; ++i$1) flt[i$1] = 8;
for (var i$1 = 144; i$1 < 256; ++i$1) flt[i$1] = 9;
for (var i$1 = 256; i$1 < 280; ++i$1) flt[i$1] = 7;
for (var i$1 = 280; i$1 < 288; ++i$1) flt[i$1] = 8;
// fixed distance tree
var fdt = new u8(32);
for (var i$1 = 0; i$1 < 32; ++i$1) fdt[i$1] = 5;
// fixed length map
var flm = /*#__PURE__*/ hMap(flt, 9, 0),
    flrm = /*#__PURE__*/ hMap(flt, 9, 1);
// fixed distance map
var fdm = /*#__PURE__*/ hMap(fdt, 5, 0),
    fdrm = /*#__PURE__*/ hMap(fdt, 5, 1);
// find max of array
var max = function (a) {
    var m = a[0];
    for (var i = 1; i < a.length; ++i) {
        if (a[i] > m) m = a[i];
    }
    return m;
};
// read d, starting at bit p and mask with m
var bits = function (d, p, m) {
    var o = (p / 8) >> 0;
    return ((d[o] | (d[o + 1] << 8)) >>> (p & 7)) & m;
};
// read d, starting at bit p continuing for at least 16 bits
var bits16 = function (d, p) {
    var o = (p / 8) >> 0;
    return (d[o] | (d[o + 1] << 8) | (d[o + 2] << 16)) >>> (p & 7);
};
// get end of byte
var shft = function (p) {
    return ((p / 8) >> 0) + (p & 7 && 1);
};
// typed array slice - allows garbage collector to free original reference,
// while being more compatible than .slice
var slc = function (v, s, e) {
    if (s == null || s < 0) s = 0;
    if (e == null || e > v.length) e = v.length;
    // can't use .constructor in case user-supplied
    var n = new (v instanceof u16 ? u16 : v instanceof u32 ? u32 : u8)(e - s);
    n.set(v.subarray(s, e));
    return n;
};
// expands raw DEFLATE data
var inflt = function (dat, buf, st) {
    // source length
    var sl = dat.length;
    // have to estimate size
    var noBuf = !buf || st;
    // no state
    var noSt = !st || st.i;
    if (!st) st = {};
    // Assumes roughly 33% compression ratio average
    if (!buf) buf = new u8(sl * 3);
    // ensure buffer can fit at least l elements
    var cbuf = function (l) {
        var bl = buf.length;
        // need to increase size to fit
        if (l > bl) {
            // Double or set to necessary, whichever is greater
            var nbuf = new u8(Math.max(bl * 2, l));
            nbuf.set(buf);
            buf = nbuf;
        }
    };
    //  last chunk         bitpos           bytes
    var final = st.f || 0,
        pos = st.p || 0,
        bt = st.b || 0,
        lm = st.l,
        dm = st.d,
        lbt = st.m,
        dbt = st.n;
    // total bits
    var tbts = sl * 8;
    do {
        if (!lm) {
            // BFINAL - this is only 1 when last chunk is next
            st.f = final = bits(dat, pos, 1);
            // type: 0 = no compression, 1 = fixed huffman, 2 = dynamic huffman
            var type = bits(dat, pos + 1, 3);
            pos += 3;
            if (!type) {
                // go to end of byte boundary
                var s = shft(pos) + 4,
                    l = dat[s - 4] | (dat[s - 3] << 8),
                    t = s + l;
                if (t > sl) {
                    if (noSt) throw "unexpected EOF";
                    break;
                }
                // ensure size
                if (noBuf) cbuf(bt + l);
                // Copy over uncompressed data
                buf.set(dat.subarray(s, t), bt);
                // Get new bitpos, update byte count
                (st.b = bt += l), (st.p = pos = t * 8);
                continue;
            } else if (type == 1)
                (lm = flrm), (dm = fdrm), (lbt = 9), (dbt = 5);
            else if (type == 2) {
                //  literal                            lengths
                var hLit = bits(dat, pos, 31) + 257,
                    hcLen = bits(dat, pos + 10, 15) + 4;
                var tl = hLit + bits(dat, pos + 5, 31) + 1;
                pos += 14;
                // length+distance tree
                var ldt = new u8(tl);
                // code length tree
                var clt = new u8(19);
                for (var i = 0; i < hcLen; ++i) {
                    // use index map to get real code
                    clt[clim[i]] = bits(dat, pos + i * 3, 7);
                }
                pos += hcLen * 3;
                // code lengths bits
                var clb = max(clt),
                    clbmsk = (1 << clb) - 1;
                if (!noSt && pos + tl * (clb + 7) > tbts) break;
                // code lengths map
                var clm = hMap(clt, clb, 1);
                for (var i = 0; i < tl; ) {
                    var r = clm[bits(dat, pos, clbmsk)];
                    // bits read
                    pos += r & 15;
                    // symbol
                    var s = r >>> 4;
                    // code length to copy
                    if (s < 16) {
                        ldt[i++] = s;
                    } else {
                        //  copy   count
                        var c = 0,
                            n = 0;
                        if (s == 16)
                            (n = 3 + bits(dat, pos, 3)),
                                (pos += 2),
                                (c = ldt[i - 1]);
                        else if (s == 17)
                            (n = 3 + bits(dat, pos, 7)), (pos += 3);
                        else if (s == 18)
                            (n = 11 + bits(dat, pos, 127)), (pos += 7);
                        while (n--) ldt[i++] = c;
                    }
                }
                //    length tree                 distance tree
                var lt = ldt.subarray(0, hLit),
                    dt = ldt.subarray(hLit);
                // max length bits
                lbt = max(lt);
                // max dist bits
                dbt = max(dt);
                lm = hMap(lt, lbt, 1);
                dm = hMap(dt, dbt, 1);
            } else throw "invalid block type";
            if (pos > tbts) throw "unexpected EOF";
        }
        // Make sure the buffer can hold this + the largest possible addition
        // Maximum chunk size (practically, theoretically infinite) is 2^17;
        if (noBuf) cbuf(bt + 131072);
        var lms = (1 << lbt) - 1,
            dms = (1 << dbt) - 1;
        var mxa = lbt + dbt + 18;
        while (noSt || pos + mxa < tbts) {
            // bits read, code
            var c = lm[bits16(dat, pos) & lms],
                sym = c >>> 4;
            pos += c & 15;
            if (pos > tbts) throw "unexpected EOF";
            if (!c) throw "invalid length/literal";
            if (sym < 256) buf[bt++] = sym;
            else if (sym == 256) {
                lm = null;
                break;
            } else {
                var add = sym - 254;
                // no extra bits needed if less
                if (sym > 264) {
                    // index
                    var i = sym - 257,
                        b = fleb[i];
                    add = bits(dat, pos, (1 << b) - 1) + fl[i];
                    pos += b;
                }
                // dist
                var d = dm[bits16(dat, pos) & dms],
                    dsym = d >>> 4;
                if (!d) throw "invalid distance";
                pos += d & 15;
                var dt = fd[dsym];
                if (dsym > 3) {
                    var b = fdeb[dsym];
                    (dt += bits16(dat, pos) & ((1 << b) - 1)), (pos += b);
                }
                if (pos > tbts) throw "unexpected EOF";
                if (noBuf) cbuf(bt + 131072);
                var end = bt + add;
                for (; bt < end; bt += 4) {
                    buf[bt] = buf[bt - dt];
                    buf[bt + 1] = buf[bt + 1 - dt];
                    buf[bt + 2] = buf[bt + 2 - dt];
                    buf[bt + 3] = buf[bt + 3 - dt];
                }
                bt = end;
            }
        }
        (st.l = lm), (st.p = pos), (st.b = bt);
        if (lm) (final = 1), (st.m = lbt), (st.d = dm), (st.n = dbt);
    } while (!final);
    return bt == buf.length ? buf : slc(buf, 0, bt);
};
// starting at p, write the minimum number of bits that can hold v to d
var wbits = function (d, p, v) {
    v <<= p & 7;
    var o = (p / 8) >> 0;
    d[o] |= v;
    d[o + 1] |= v >>> 8;
};
// starting at p, write the minimum number of bits (>8) that can hold v to d
var wbits16 = function (d, p, v) {
    v <<= p & 7;
    var o = (p / 8) >> 0;
    d[o] |= v;
    d[o + 1] |= v >>> 8;
    d[o + 2] |= v >>> 16;
};
// creates code lengths from a frequency table
var hTree = function (d, mb) {
    // Need extra info to make a tree
    var t = [];
    for (var i = 0; i < d.length; ++i) {
        if (d[i])
            t.push({
                s: i,
                f: d[i],
            });
    }
    var s = t.length;
    var t2 = t.slice();
    if (!s) return [new u8(0), 0];
    if (s == 1) {
        var v = new u8(t[0].s + 1);
        v[t[0].s] = 1;
        return [v, 1];
    }
    t.sort(function (a, b) {
        return a.f - b.f;
    });
    // after i2 reaches last ind, will be stopped
    // freq must be greater than largest possible number of symbols
    t.push({
        s: -1,
        f: 25001,
    });
    var l = t[0],
        r = t[1],
        i0 = 0,
        i1 = 1,
        i2 = 2;
    t[0] = {
        s: -1,
        f: l.f + r.f,
        l: l,
        r: r,
    };
    // efficient algorithm from UZIP.js
    // i0 is lookbehind, i2 is lookahead - after processing two low-freq
    // symbols that combined have high freq, will start processing i2 (high-freq,
    // non-composite) symbols instead
    // see https://reddit.com/r/photopea/comments/ikekht/uzipjs_questions/
    while (i1 != s - 1) {
        l = t[t[i0].f < t[i2].f ? i0++ : i2++];
        r = t[i0 != i1 && t[i0].f < t[i2].f ? i0++ : i2++];
        t[i1++] = {
            s: -1,
            f: l.f + r.f,
            l: l,
            r: r,
        };
    }
    var maxSym = t2[0].s;
    for (var i = 1; i < s; ++i) {
        if (t2[i].s > maxSym) maxSym = t2[i].s;
    }
    // code lengths
    var tr = new u16(maxSym + 1);
    // max bits in tree
    var mbt = ln(t[i1 - 1], tr, 0);
    if (mbt > mb) {
        // more algorithms from UZIP.js
        // TODO: find out how this code works (debt)
        //  ind    debt
        var i = 0,
            dt = 0;
        //    left            cost
        var lft = mbt - mb,
            cst = 1 << lft;
        t2.sort(function (a, b) {
            return tr[b.s] - tr[a.s] || a.f - b.f;
        });
        for (; i < s; ++i) {
            var i2_1 = t2[i].s;
            if (tr[i2_1] > mb) {
                dt += cst - (1 << (mbt - tr[i2_1]));
                tr[i2_1] = mb;
            } else break;
        }
        dt >>>= lft;
        while (dt > 0) {
            var i2_2 = t2[i].s;
            if (tr[i2_2] < mb) dt -= 1 << (mb - tr[i2_2]++ - 1);
            else ++i;
        }
        for (; i >= 0 && dt; --i) {
            var i2_3 = t2[i].s;
            if (tr[i2_3] == mb) {
                --tr[i2_3];
                ++dt;
            }
        }
        mbt = mb;
    }
    return [new u8(tr), mbt];
};
// get the max length and assign length codes
var ln = function (n, l, d) {
    return n.s == -1
        ? Math.max(ln(n.l, l, d + 1), ln(n.r, l, d + 1))
        : (l[n.s] = d);
};
// length codes generation
var lc = function (c) {
    var s = c.length;
    // Note that the semicolon was intentional
    while (s && !c[--s]);
    var cl = new u16(++s);
    //  ind      num         streak
    var cli = 0,
        cln = c[0],
        cls = 1;
    var w = function (v) {
        cl[cli++] = v;
    };
    for (var i = 1; i <= s; ++i) {
        if (c[i] == cln && i != s) ++cls;
        else {
            if (!cln && cls > 2) {
                for (; cls > 138; cls -= 138) w(32754);
                if (cls > 2) {
                    w(
                        cls > 10
                            ? ((cls - 11) << 5) | 28690
                            : ((cls - 3) << 5) | 12305,
                    );
                    cls = 0;
                }
            } else if (cls > 3) {
                w(cln), --cls;
                for (; cls > 6; cls -= 6) w(8304);
                if (cls > 2) w(((cls - 3) << 5) | 8208), (cls = 0);
            }
            while (cls--) w(cln);
            cls = 1;
            cln = c[i];
        }
    }
    return [cl.subarray(0, cli), s];
};
// calculate the length of output from tree, code lengths
var clen = function (cf, cl) {
    var l = 0;
    for (var i = 0; i < cl.length; ++i) l += cf[i] * cl[i];
    return l;
};
// writes a fixed block
// returns the new bit pos
var wfblk = function (out, pos, dat) {
    // no need to write 00 as type: TypedArray defaults to 0
    var s = dat.length;
    var o = shft(pos + 2);
    out[o] = s & 255;
    out[o + 1] = s >>> 8;
    out[o + 2] = out[o] ^ 255;
    out[o + 3] = out[o + 1] ^ 255;
    for (var i = 0; i < s; ++i) out[o + i + 4] = dat[i];
    return (o + 4 + s) * 8;
};
// writes a block
var wblk = function (dat, out, final, syms, lf, df, eb, li, bs, bl, p) {
    wbits(out, p++, final);
    ++lf[256];
    var _a = hTree(lf, 15),
        dlt = _a[0],
        mlb = _a[1];
    var _b = hTree(df, 15),
        ddt = _b[0],
        mdb = _b[1];
    var _c = lc(dlt),
        lclt = _c[0],
        nlc = _c[1];
    var _d = lc(ddt),
        lcdt = _d[0],
        ndc = _d[1];
    var lcfreq = new u16(19);
    for (var i = 0; i < lclt.length; ++i) lcfreq[lclt[i] & 31]++;
    for (var i = 0; i < lcdt.length; ++i) lcfreq[lcdt[i] & 31]++;
    var _e = hTree(lcfreq, 7),
        lct = _e[0],
        mlcb = _e[1];
    var nlcc = 19;
    for (; nlcc > 4 && !lct[clim[nlcc - 1]]; --nlcc);
    var flen = (bl + 5) << 3;
    var ftlen = clen(lf, flt) + clen(df, fdt) + eb;
    var dtlen =
        clen(lf, dlt) +
        clen(df, ddt) +
        eb +
        14 +
        3 * nlcc +
        clen(lcfreq, lct) +
        (2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18]);
    if (flen <= ftlen && flen <= dtlen)
        return wfblk(out, p, dat.subarray(bs, bs + bl));
    var lm, ll, dm, dl;
    wbits(out, p, 1 + (dtlen < ftlen)), (p += 2);
    if (dtlen < ftlen) {
        (lm = hMap(dlt, mlb, 0)),
            (ll = dlt),
            (dm = hMap(ddt, mdb, 0)),
            (dl = ddt);
        var llm = hMap(lct, mlcb, 0);
        wbits(out, p, nlc - 257);
        wbits(out, p + 5, ndc - 1);
        wbits(out, p + 10, nlcc - 4);
        p += 14;
        for (var i = 0; i < nlcc; ++i) wbits(out, p + 3 * i, lct[clim[i]]);
        p += 3 * nlcc;
        var lcts = [lclt, lcdt];
        for (var it = 0; it < 2; ++it) {
            var clct = lcts[it];
            for (var i = 0; i < clct.length; ++i) {
                var len = clct[i] & 31;
                wbits(out, p, llm[len]), (p += lct[len]);
                if (len > 15)
                    wbits(out, p, (clct[i] >>> 5) & 127), (p += clct[i] >>> 12);
            }
        }
    } else {
        (lm = flm), (ll = flt), (dm = fdm), (dl = fdt);
    }
    for (var i = 0; i < li; ++i) {
        if (syms[i] > 255) {
            var len = (syms[i] >>> 18) & 31;
            wbits16(out, p, lm[len + 257]), (p += ll[len + 257]);
            if (len > 7) wbits(out, p, (syms[i] >>> 23) & 31), (p += fleb[len]);
            var dst = syms[i] & 31;
            wbits16(out, p, dm[dst]), (p += dl[dst]);
            if (dst > 3)
                wbits16(out, p, (syms[i] >>> 5) & 8191), (p += fdeb[dst]);
        } else {
            wbits16(out, p, lm[syms[i]]), (p += ll[syms[i]]);
        }
    }
    wbits16(out, p, lm[256]);
    return p + ll[256];
};
// deflate options (nice << 13) | chain
var deo = /*#__PURE__*/ new u32([
    65540, 131080, 131088, 131104, 262176, 1048704, 1048832, 2114560, 2117632,
]);
// empty
var et$1 = /*#__PURE__*/ new u8(0);
// compresses data into a raw DEFLATE buffer
var dflt = function (dat, lvl, plvl, pre, post, lst) {
    var s = dat.length;
    var o = new u8(pre + s + 5 * (1 + Math.floor(s / 7000)) + post);
    // writing to this writes to the output buffer
    var w = o.subarray(pre, o.length - post);
    var pos = 0;
    if (!lvl || s < 8) {
        for (var i = 0; i <= s; i += 65535) {
            // end
            var e = i + 65535;
            if (e < s) {
                // write full block
                pos = wfblk(w, pos, dat.subarray(i, e));
            } else {
                // write final block
                w[i] = lst;
                pos = wfblk(w, pos, dat.subarray(i, s));
            }
        }
    } else {
        var opt = deo[lvl - 1];
        var n = opt >>> 13,
            c = opt & 8191;
        var msk_1 = (1 << plvl) - 1;
        //    prev 2-byte val map    curr 2-byte val map
        var prev = new u16(32768),
            head = new u16(msk_1 + 1);
        var bs1_1 = Math.ceil(plvl / 3),
            bs2_1 = 2 * bs1_1;
        var hsh = function (i) {
            return (
                (dat[i] ^ (dat[i + 1] << bs1_1) ^ (dat[i + 2] << bs2_1)) & msk_1
            );
        };
        // 24576 is an arbitrary number of maximum symbols per block
        // 424 buffer for last block
        var syms = new u32(25000);
        // length/literal freq   distance freq
        var lf = new u16(288),
            df = new u16(32);
        //  l/lcnt  exbits  index  l/lind  waitdx  bitpos
        var lc_1 = 0,
            eb = 0,
            i = 0,
            li = 0,
            wi = 0,
            bs = 0;
        for (; i < s; ++i) {
            // hash value
            var hv = hsh(i);
            // index mod 32768
            var imod = i & 32767;
            // previous index with this value
            var pimod = head[hv];
            prev[imod] = pimod;
            head[hv] = imod;
            // We always should modify head and prev, but only add symbols if
            // this data is not yet processed ("wait" for wait index)
            if (wi <= i) {
                // bytes remaining
                var rem = s - i;
                if ((lc_1 > 7000 || li > 24576) && rem > 423) {
                    pos = wblk(
                        dat,
                        w,
                        0,
                        syms,
                        lf,
                        df,
                        eb,
                        li,
                        bs,
                        i - bs,
                        pos,
                    );
                    (li = lc_1 = eb = 0), (bs = i);
                    for (var j = 0; j < 286; ++j) lf[j] = 0;
                    for (var j = 0; j < 30; ++j) df[j] = 0;
                }
                //  len    dist   chain
                var l = 2,
                    d = 0,
                    ch_1 = c,
                    dif = (imod - pimod) & 32767;
                if (rem > 2 && hv == hsh(i - dif)) {
                    var maxn = Math.min(n, rem) - 1;
                    var maxd = Math.min(32767, i);
                    // max possible length
                    // not capped at dif because decompressors implement "rolling" index population
                    var ml = Math.min(258, rem);
                    while (dif <= maxd && --ch_1 && imod != pimod) {
                        if (dat[i + l] == dat[i + l - dif]) {
                            var nl = 0;
                            for (
                                ;
                                nl < ml && dat[i + nl] == dat[i + nl - dif];
                                ++nl
                            );
                            if (nl > l) {
                                (l = nl), (d = dif);
                                // break out early when we reach "nice" (we are satisfied enough)
                                if (nl > maxn) break;
                                // now, find the rarest 2-byte sequence within this
                                // length of literals and search for that instead.
                                // Much faster than just using the start
                                var mmd = Math.min(dif, nl - 2);
                                var md = 0;
                                for (var j = 0; j < mmd; ++j) {
                                    var ti = (i - dif + j + 32768) & 32767;
                                    var pti = prev[ti];
                                    var cd = (ti - pti + 32768) & 32767;
                                    if (cd > md) (md = cd), (pimod = ti);
                                }
                            }
                        }
                        // check the previous match
                        (imod = pimod), (pimod = prev[imod]);
                        dif += (imod - pimod + 32768) & 32767;
                    }
                }
                // d will be nonzero only when a match was found
                if (d) {
                    // store both dist and len data in one Uint32
                    // Make sure this is recognized as a len/dist with 28th bit (2^28)
                    syms[li++] = 268435456 | (revfl[l] << 18) | revfd[d];
                    var lin = revfl[l] & 31,
                        din = revfd[d] & 31;
                    eb += fleb[lin] + fdeb[din];
                    ++lf[257 + lin];
                    ++df[din];
                    wi = i + l;
                    ++lc_1;
                } else {
                    syms[li++] = dat[i];
                    ++lf[dat[i]];
                }
            }
        }
        pos = wblk(dat, w, lst, syms, lf, df, eb, li, bs, i - bs, pos);
        // this is the easiest way to avoid needing to maintain state
        if (!lst) pos = wfblk(w, pos, et$1);
    }
    return slc(o, 0, pre + shft(pos) + post);
};
// Alder32
var adler = function () {
    var a = 1,
        b = 0;
    return {
        p: function (d) {
            // closures have awful performance
            var n = a,
                m = b;
            var l = d.length;
            for (var i = 0; i != l; ) {
                var e = Math.min(i + 5552, l);
                for (; i < e; ++i) (n += d[i]), (m += n);
                (n %= 65521), (m %= 65521);
            }
            (a = n), (b = m);
        },
        d: function () {
            return (
                (((a >>> 8) << 16) | ((b & 255) << 8) | (b >>> 8)) +
                ((a & 255) << 23) * 2
            );
        },
    };
};
// deflate with opts
var dopt = function (dat, opt, pre, post, st) {
    return dflt(
        dat,
        opt.level == null ? 6 : opt.level,
        opt.mem == null
            ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5)
            : 12 + opt.mem,
        pre,
        post,
        !st,
    );
};
// write bytes
var wbytes = function (d, b, v) {
    for (; v; ++b) (d[b] = v), (v >>>= 8);
};
// zlib header
var zlh = function (c, o) {
    var lv = o.level,
        fl = lv == 0 ? 0 : lv < 6 ? 1 : lv == 9 ? 3 : 2;
    (c[0] = 120), (c[1] = (fl << 6) | (fl ? 32 - 2 * fl : 1));
};
// zlib valid
var zlv = function (d) {
    if ((d[0] & 15) != 8 || d[0] >>> 4 > 7 || ((d[0] << 8) | d[1]) % 31)
        throw "invalid zlib data";
    if (d[1] & 32) throw "invalid zlib data: preset dictionaries not supported";
};
/**
 * Compress data with Zlib
 * @param data The data to compress
 * @param opts The compression options
 * @returns The zlib-compressed version of the data
 */
function zlibSync(data, opts) {
    if (opts === void 0) {
        opts = {};
    }
    var a = adler();
    a.p(data);
    var d = dopt(data, opts, 2, 4);
    return zlh(d, opts), wbytes(d, d.length - 4, a.d()), d;
}
/**
 * Expands Zlib data
 * @param data The data to decompress
 * @param out Where to write the data. Saves memory if you know the decompressed size and provide an output buffer of that length.
 * @returns The decompressed version of the data
 */
function unzlibSync(data, out) {
    return inflt((zlv(data), data.subarray(2, -4)), out);
}

/** @license
 *
 * jsPDF - PDF Document creation from JavaScript
 * Version 2.5.1 Built on 2022-01-28T15:37:57.791Z
 *                      CommitID 00000000
 *
 * Copyright (c) 2010-2021 James Hall <james@parall.ax>, https://github.com/MrRio/jsPDF
 *               2015-2021 yWorks GmbH, http://www.yworks.com
 *               2015-2021 Lukas Holländer <lukas.hollaender@yworks.com>, https://github.com/HackbrettXXX
 *               2016-2018 Aras Abbasi <aras.abbasi@gmail.com>
 *               2010 Aaron Spike, https://github.com/acspike
 *               2012 Willow Systems Corporation, https://github.com/willowsystems
 *               2012 Pablo Hess, https://github.com/pablohess
 *               2012 Florian Jenett, https://github.com/fjenett
 *               2013 Warren Weckesser, https://github.com/warrenweckesser
 *               2013 Youssef Beddad, https://github.com/lifof
 *               2013 Lee Driscoll, https://github.com/lsdriscoll
 *               2013 Stefan Slonevskiy, https://github.com/stefslon
 *               2013 Jeremy Morel, https://github.com/jmorel
 *               2013 Christoph Hartmann, https://github.com/chris-rock
 *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
 *               2014 James Makes, https://github.com/dollaruw
 *               2014 Diego Casorran, https://github.com/diegocr
 *               2014 Steven Spungin, https://github.com/Flamenco
 *               2014 Kenneth Glassey, https://github.com/Gavvers
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 * Contributor(s):
 *    siefkenj, ahwolf, rickygu, Midnith, saintclair, eaparango,
 *    kim3er, mfo, alnorth, Flamenco
 */
var n = (function () {
    return "undefined" != typeof window
        ? window
        : "undefined" != typeof global
          ? global
          : "undefined" != typeof self
            ? self
            : this;
})();
function i() {
    n.console &&
        "function" == typeof n.console.log &&
        n.console.log.apply(n.console, arguments);
}
var a = {
    log: i,
    warn: function (t) {
        n.console &&
            ("function" == typeof n.console.warn
                ? n.console.warn.apply(n.console, arguments)
                : i.call(null, arguments));
    },
    error: function (t) {
        n.console &&
            ("function" == typeof n.console.error
                ? n.console.error.apply(n.console, arguments)
                : i(t));
    },
};
function o(t, e, r) {
    var n = new XMLHttpRequest();
    n.open("GET", t),
        (n.responseType = "blob"),
        (n.onload = function () {
            l(n.response, e, r);
        }),
        (n.onerror = function () {
            a.error("could not download file");
        }),
        n.send();
}
function s(t) {
    var e = new XMLHttpRequest();
    e.open("HEAD", t, !1);
    try {
        e.send();
    } catch (t) {}
    return e.status >= 200 && e.status <= 299;
}
function c(t) {
    try {
        t.dispatchEvent(new MouseEvent("click"));
    } catch (r) {
        var e = document.createEvent("MouseEvents");
        e.initMouseEvent(
            "click",
            !0,
            !0,
            window,
            0,
            0,
            0,
            80,
            20,
            !1,
            !1,
            !1,
            !1,
            0,
            null,
        ),
            t.dispatchEvent(e);
    }
}
var u,
    h,
    l =
        n.saveAs ||
        ("object" !==
            ("undefined" == typeof window ? "undefined" : _typeof(window)) ||
        window !== n
            ? function () {}
            : "undefined" != typeof HTMLAnchorElement &&
                "download" in HTMLAnchorElement.prototype
              ? function (t, e, r) {
                    var i = n.URL || n.webkitURL,
                        a = document.createElement("a");
                    (e = e || t.name || "download"),
                        (a.download = e),
                        (a.rel = "noopener"),
                        "string" == typeof t
                            ? ((a.href = t),
                              a.origin !== location.origin
                                  ? s(a.href)
                                      ? o(t, e, r)
                                      : c(a, (a.target = "_blank"))
                                  : c(a))
                            : ((a.href = i.createObjectURL(t)),
                              setTimeout(function () {
                                  i.revokeObjectURL(a.href);
                              }, 4e4),
                              setTimeout(function () {
                                  c(a);
                              }, 0));
                }
              : "msSaveOrOpenBlob" in navigator
                ? function (e, r, n) {
                      if (
                          ((r = r || e.name || "download"),
                          "string" == typeof e)
                      ) {
                          if (s(e)) o(e, r, n);
                          else {
                              var i = document.createElement("a");
                              (i.href = e),
                                  (i.target = "_blank"),
                                  setTimeout(function () {
                                      c(i);
                                  });
                          }
                      } else
                          navigator.msSaveOrOpenBlob(
                              (function (e, r) {
                                  return (
                                      void 0 === r
                                          ? (r = {
                                                autoBom: !1,
                                            })
                                          : "object" !== _typeof(r) &&
                                            (a.warn(
                                                "Deprecated: Expected third argument to be a object",
                                            ),
                                            (r = {
                                                autoBom: !r,
                                            })),
                                      r.autoBom &&
                                      /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(
                                          e.type,
                                      )
                                          ? new Blob(
                                                [String.fromCharCode(65279), e],
                                                {
                                                    type: e.type,
                                                },
                                            )
                                          : e
                                  );
                              })(e, n),
                              r,
                          );
                  }
                : function (e, r, i, a) {
                      if (
                          ((a = a || open("", "_blank")) &&
                              (a.document.title = a.document.body.innerText =
                                  "downloading..."),
                          "string" == typeof e)
                      )
                          return o(e, r, i);
                      var s = "application/octet-stream" === e.type,
                          c = /constructor/i.test(n.HTMLElement) || n.safari,
                          u = /CriOS\/[\d]+/.test(navigator.userAgent);
                      if (
                          (u || (s && c)) &&
                          "object" ===
                              ("undefined" == typeof FileReader
                                  ? "undefined"
                                  : _typeof(FileReader))
                      ) {
                          var h = new FileReader();
                          (h.onloadend = function () {
                              var t = h.result;
                              (t = u
                                  ? t
                                  : t.replace(
                                        /^data:[^;]*;/,
                                        "data:attachment/file;",
                                    )),
                                  a ? (a.location.href = t) : (location = t),
                                  (a = null);
                          }),
                              h.readAsDataURL(e);
                      } else {
                          var l = n.URL || n.webkitURL,
                              f = l.createObjectURL(e);
                          a ? (a.location = f) : (location.href = f),
                              (a = null),
                              setTimeout(function () {
                                  l.revokeObjectURL(f);
                              }, 4e4);
                      }
                  });
/**
 * A class to parse color values
 * @author Stoyan Stefanov <sstoo@gmail.com>
 * {@link   http://www.phpied.com/rgb-color-parser-in-javascript/}
 * @license Use it if you like it
 */
function f(t) {
    var e;
    (t = t || ""), (this.ok = !1), "#" == t.charAt(0) && (t = t.substr(1, 6));
    t =
        {
            aliceblue: "f0f8ff",
            antiquewhite: "faebd7",
            aqua: "00ffff",
            aquamarine: "7fffd4",
            azure: "f0ffff",
            beige: "f5f5dc",
            bisque: "ffe4c4",
            black: "000000",
            blanchedalmond: "ffebcd",
            blue: "0000ff",
            blueviolet: "8a2be2",
            brown: "a52a2a",
            burlywood: "deb887",
            cadetblue: "5f9ea0",
            chartreuse: "7fff00",
            chocolate: "d2691e",
            coral: "ff7f50",
            cornflowerblue: "6495ed",
            cornsilk: "fff8dc",
            crimson: "dc143c",
            cyan: "00ffff",
            darkblue: "00008b",
            darkcyan: "008b8b",
            darkgoldenrod: "b8860b",
            darkgray: "a9a9a9",
            darkgreen: "006400",
            darkkhaki: "bdb76b",
            darkmagenta: "8b008b",
            darkolivegreen: "556b2f",
            darkorange: "ff8c00",
            darkorchid: "9932cc",
            darkred: "8b0000",
            darksalmon: "e9967a",
            darkseagreen: "8fbc8f",
            darkslateblue: "483d8b",
            darkslategray: "2f4f4f",
            darkturquoise: "00ced1",
            darkviolet: "9400d3",
            deeppink: "ff1493",
            deepskyblue: "00bfff",
            dimgray: "696969",
            dodgerblue: "1e90ff",
            feldspar: "d19275",
            firebrick: "b22222",
            floralwhite: "fffaf0",
            forestgreen: "228b22",
            fuchsia: "ff00ff",
            gainsboro: "dcdcdc",
            ghostwhite: "f8f8ff",
            gold: "ffd700",
            goldenrod: "daa520",
            gray: "808080",
            green: "008000",
            greenyellow: "adff2f",
            honeydew: "f0fff0",
            hotpink: "ff69b4",
            indianred: "cd5c5c",
            indigo: "4b0082",
            ivory: "fffff0",
            khaki: "f0e68c",
            lavender: "e6e6fa",
            lavenderblush: "fff0f5",
            lawngreen: "7cfc00",
            lemonchiffon: "fffacd",
            lightblue: "add8e6",
            lightcoral: "f08080",
            lightcyan: "e0ffff",
            lightgoldenrodyellow: "fafad2",
            lightgrey: "d3d3d3",
            lightgreen: "90ee90",
            lightpink: "ffb6c1",
            lightsalmon: "ffa07a",
            lightseagreen: "20b2aa",
            lightskyblue: "87cefa",
            lightslateblue: "8470ff",
            lightslategray: "778899",
            lightsteelblue: "b0c4de",
            lightyellow: "ffffe0",
            lime: "00ff00",
            limegreen: "32cd32",
            linen: "faf0e6",
            magenta: "ff00ff",
            maroon: "800000",
            mediumaquamarine: "66cdaa",
            mediumblue: "0000cd",
            mediumorchid: "ba55d3",
            mediumpurple: "9370d8",
            mediumseagreen: "3cb371",
            mediumslateblue: "7b68ee",
            mediumspringgreen: "00fa9a",
            mediumturquoise: "48d1cc",
            mediumvioletred: "c71585",
            midnightblue: "191970",
            mintcream: "f5fffa",
            mistyrose: "ffe4e1",
            moccasin: "ffe4b5",
            navajowhite: "ffdead",
            navy: "000080",
            oldlace: "fdf5e6",
            olive: "808000",
            olivedrab: "6b8e23",
            orange: "ffa500",
            orangered: "ff4500",
            orchid: "da70d6",
            palegoldenrod: "eee8aa",
            palegreen: "98fb98",
            paleturquoise: "afeeee",
            palevioletred: "d87093",
            papayawhip: "ffefd5",
            peachpuff: "ffdab9",
            peru: "cd853f",
            pink: "ffc0cb",
            plum: "dda0dd",
            powderblue: "b0e0e6",
            purple: "800080",
            red: "ff0000",
            rosybrown: "bc8f8f",
            royalblue: "4169e1",
            saddlebrown: "8b4513",
            salmon: "fa8072",
            sandybrown: "f4a460",
            seagreen: "2e8b57",
            seashell: "fff5ee",
            sienna: "a0522d",
            silver: "c0c0c0",
            skyblue: "87ceeb",
            slateblue: "6a5acd",
            slategray: "708090",
            snow: "fffafa",
            springgreen: "00ff7f",
            steelblue: "4682b4",
            tan: "d2b48c",
            teal: "008080",
            thistle: "d8bfd8",
            tomato: "ff6347",
            turquoise: "40e0d0",
            violet: "ee82ee",
            violetred: "d02090",
            wheat: "f5deb3",
            white: "ffffff",
            whitesmoke: "f5f5f5",
            yellow: "ffff00",
            yellowgreen: "9acd32",
        }[(t = (t = t.replace(/ /g, "")).toLowerCase())] || t;
    for (
        var r = [
                {
                    re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
                    example: ["rgb(123, 234, 45)", "rgb(255,234,245)"],
                    process: function (t) {
                        return [parseInt(t[1]), parseInt(t[2]), parseInt(t[3])];
                    },
                },
                {
                    re: /^(\w{2})(\w{2})(\w{2})$/,
                    example: ["#00ff00", "336699"],
                    process: function (t) {
                        return [
                            parseInt(t[1], 16),
                            parseInt(t[2], 16),
                            parseInt(t[3], 16),
                        ];
                    },
                },
                {
                    re: /^(\w{1})(\w{1})(\w{1})$/,
                    example: ["#fb0", "f0f"],
                    process: function (t) {
                        return [
                            parseInt(t[1] + t[1], 16),
                            parseInt(t[2] + t[2], 16),
                            parseInt(t[3] + t[3], 16),
                        ];
                    },
                },
            ],
            n = 0;
        n < r.length;
        n++
    ) {
        var i = r[n].re,
            a = r[n].process,
            o = i.exec(t);
        o &&
            ((e = a(o)),
            (this.r = e[0]),
            (this.g = e[1]),
            (this.b = e[2]),
            (this.ok = !0));
    }
    (this.r = this.r < 0 || isNaN(this.r) ? 0 : this.r > 255 ? 255 : this.r),
        (this.g =
            this.g < 0 || isNaN(this.g) ? 0 : this.g > 255 ? 255 : this.g),
        (this.b =
            this.b < 0 || isNaN(this.b) ? 0 : this.b > 255 ? 255 : this.b),
        (this.toRGB = function () {
            return "rgb(" + this.r + ", " + this.g + ", " + this.b + ")";
        }),
        (this.toHex = function () {
            var t = this.r.toString(16),
                e = this.g.toString(16),
                r = this.b.toString(16);
            return (
                1 == t.length && (t = "0" + t),
                1 == e.length && (e = "0" + e),
                1 == r.length && (r = "0" + r),
                "#" + t + e + r
            );
        });
}
/**
 * @license
 * Joseph Myers does not specify a particular license for his work.
 *
 * Author: Joseph Myers
 * Accessed from: http://www.myersdaily.org/joseph/javascript/md5.js
 *
 * Modified by: Owen Leong
 */
function d(t, e) {
    var r = t[0],
        n = t[1],
        i = t[2],
        a = t[3];
    (r = g(r, n, i, a, e[0], 7, -680876936)),
        (a = g(a, r, n, i, e[1], 12, -389564586)),
        (i = g(i, a, r, n, e[2], 17, 606105819)),
        (n = g(n, i, a, r, e[3], 22, -1044525330)),
        (r = g(r, n, i, a, e[4], 7, -176418897)),
        (a = g(a, r, n, i, e[5], 12, 1200080426)),
        (i = g(i, a, r, n, e[6], 17, -1473231341)),
        (n = g(n, i, a, r, e[7], 22, -45705983)),
        (r = g(r, n, i, a, e[8], 7, 1770035416)),
        (a = g(a, r, n, i, e[9], 12, -1958414417)),
        (i = g(i, a, r, n, e[10], 17, -42063)),
        (n = g(n, i, a, r, e[11], 22, -1990404162)),
        (r = g(r, n, i, a, e[12], 7, 1804603682)),
        (a = g(a, r, n, i, e[13], 12, -40341101)),
        (i = g(i, a, r, n, e[14], 17, -1502002290)),
        (r = m(
            r,
            (n = g(n, i, a, r, e[15], 22, 1236535329)),
            i,
            a,
            e[1],
            5,
            -165796510,
        )),
        (a = m(a, r, n, i, e[6], 9, -1069501632)),
        (i = m(i, a, r, n, e[11], 14, 643717713)),
        (n = m(n, i, a, r, e[0], 20, -373897302)),
        (r = m(r, n, i, a, e[5], 5, -701558691)),
        (a = m(a, r, n, i, e[10], 9, 38016083)),
        (i = m(i, a, r, n, e[15], 14, -660478335)),
        (n = m(n, i, a, r, e[4], 20, -405537848)),
        (r = m(r, n, i, a, e[9], 5, 568446438)),
        (a = m(a, r, n, i, e[14], 9, -1019803690)),
        (i = m(i, a, r, n, e[3], 14, -187363961)),
        (n = m(n, i, a, r, e[8], 20, 1163531501)),
        (r = m(r, n, i, a, e[13], 5, -1444681467)),
        (a = m(a, r, n, i, e[2], 9, -51403784)),
        (i = m(i, a, r, n, e[7], 14, 1735328473)),
        (r = v(
            r,
            (n = m(n, i, a, r, e[12], 20, -1926607734)),
            i,
            a,
            e[5],
            4,
            -378558,
        )),
        (a = v(a, r, n, i, e[8], 11, -2022574463)),
        (i = v(i, a, r, n, e[11], 16, 1839030562)),
        (n = v(n, i, a, r, e[14], 23, -35309556)),
        (r = v(r, n, i, a, e[1], 4, -1530992060)),
        (a = v(a, r, n, i, e[4], 11, 1272893353)),
        (i = v(i, a, r, n, e[7], 16, -155497632)),
        (n = v(n, i, a, r, e[10], 23, -1094730640)),
        (r = v(r, n, i, a, e[13], 4, 681279174)),
        (a = v(a, r, n, i, e[0], 11, -358537222)),
        (i = v(i, a, r, n, e[3], 16, -722521979)),
        (n = v(n, i, a, r, e[6], 23, 76029189)),
        (r = v(r, n, i, a, e[9], 4, -640364487)),
        (a = v(a, r, n, i, e[12], 11, -421815835)),
        (i = v(i, a, r, n, e[15], 16, 530742520)),
        (r = b(
            r,
            (n = v(n, i, a, r, e[2], 23, -995338651)),
            i,
            a,
            e[0],
            6,
            -198630844,
        )),
        (a = b(a, r, n, i, e[7], 10, 1126891415)),
        (i = b(i, a, r, n, e[14], 15, -1416354905)),
        (n = b(n, i, a, r, e[5], 21, -57434055)),
        (r = b(r, n, i, a, e[12], 6, 1700485571)),
        (a = b(a, r, n, i, e[3], 10, -1894986606)),
        (i = b(i, a, r, n, e[10], 15, -1051523)),
        (n = b(n, i, a, r, e[1], 21, -2054922799)),
        (r = b(r, n, i, a, e[8], 6, 1873313359)),
        (a = b(a, r, n, i, e[15], 10, -30611744)),
        (i = b(i, a, r, n, e[6], 15, -1560198380)),
        (n = b(n, i, a, r, e[13], 21, 1309151649)),
        (r = b(r, n, i, a, e[4], 6, -145523070)),
        (a = b(a, r, n, i, e[11], 10, -1120210379)),
        (i = b(i, a, r, n, e[2], 15, 718787259)),
        (n = b(n, i, a, r, e[9], 21, -343485551)),
        (t[0] = _(r, t[0])),
        (t[1] = _(n, t[1])),
        (t[2] = _(i, t[2])),
        (t[3] = _(a, t[3]));
}
function p(t, e, r, n, i, a) {
    return (e = _(_(e, t), _(n, a))), _((e << i) | (e >>> (32 - i)), r);
}
function g(t, e, r, n, i, a, o) {
    return p((e & r) | (~e & n), t, e, i, a, o);
}
function m(t, e, r, n, i, a, o) {
    return p((e & n) | (r & ~n), t, e, i, a, o);
}
function v(t, e, r, n, i, a, o) {
    return p(e ^ r ^ n, t, e, i, a, o);
}
function b(t, e, r, n, i, a, o) {
    return p(r ^ (e | ~n), t, e, i, a, o);
}
function y(t) {
    var e,
        r = t.length,
        n = [1732584193, -271733879, -1732584194, 271733878];
    for (e = 64; e <= t.length; e += 64) d(n, w(t.substring(e - 64, e)));
    t = t.substring(e - 64);
    var i = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    for (e = 0; e < t.length; e++) i[e >> 2] |= t.charCodeAt(e) << (e % 4 << 3);
    if (((i[e >> 2] |= 128 << (e % 4 << 3)), e > 55))
        for (d(n, i), e = 0; e < 16; e++) i[e] = 0;
    return (i[14] = 8 * r), d(n, i), n;
}
function w(t) {
    var e,
        r = [];
    for (e = 0; e < 64; e += 4)
        r[e >> 2] =
            t.charCodeAt(e) +
            (t.charCodeAt(e + 1) << 8) +
            (t.charCodeAt(e + 2) << 16) +
            (t.charCodeAt(e + 3) << 24);
    return r;
}
(u = n.atob.bind(n)), (h = n.btoa.bind(n));
var N = "0123456789abcdef".split("");
function L(t) {
    for (var e = "", r = 0; r < 4; r++)
        e += N[(t >> (8 * r + 4)) & 15] + N[(t >> (8 * r)) & 15];
    return e;
}
function A(t) {
    return String.fromCharCode(
        (255 & t) >> 0,
        (65280 & t) >> 8,
        (16711680 & t) >> 16,
        (4278190080 & t) >> 24,
    );
}
function x(t) {
    return y(t).map(A).join("");
}
var S =
    "5d41402abc4b2a76b9719d911017c592" !=
    (function (t) {
        for (var e = 0; e < t.length; e++) t[e] = L(t[e]);
        return t.join("");
    })(y("hello"));
function _(t, e) {
    if (S) {
        var r = (65535 & t) + (65535 & e);
        return (((t >> 16) + (e >> 16) + (r >> 16)) << 16) | (65535 & r);
    }
    return (t + e) & 4294967295;
}
/**
 * @license
 * FPDF is released under a permissive license: there is no usage restriction.
 * You may embed it freely in your application (commercial or not), with or
 * without modifications.
 *
 * Reference: http://www.fpdf.org/en/script/script37.php
 */
function P(t, e) {
    var r, n, i, a;
    if (t !== r) {
        for (
            var o =
                    ((i = t),
                    (a = 1 + ((256 / t.length) >> 0)),
                    new Array(a + 1).join(i)),
                s = [],
                c = 0;
            c < 256;
            c++
        )
            s[c] = c;
        var u = 0;
        for (c = 0; c < 256; c++) {
            var h = s[c];
            (u = (u + h + o.charCodeAt(c)) % 256), (s[c] = s[u]), (s[u] = h);
        }
        (r = t), (n = s);
    } else s = n;
    var l = e.length,
        f = 0,
        d = 0,
        p = "";
    for (c = 0; c < l; c++)
        (d = (d + (h = s[(f = (f + 1) % 256)])) % 256),
            (s[f] = s[d]),
            (s[d] = h),
            (o = s[(s[f] + s[d]) % 256]),
            (p += String.fromCharCode(e.charCodeAt(c) ^ o));
    return p;
}
/**
 * @license
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 * Author: Owen Leong (@owenl131)
 * Date: 15 Oct 2020
 * References:
 * https://www.cs.cmu.edu/~dst/Adobe/Gallery/anon21jul01-pdf-encryption.txt
 * https://github.com/foliojs/pdfkit/blob/master/lib/security.js
 * http://www.fpdf.org/en/script/script37.php
 */
var k = {
    print: 4,
    modify: 8,
    copy: 16,
    "annot-forms": 32,
};
function I(t, e, r, n) {
    (this.v = 1), (this.r = 2);
    var i = 192;
    t.forEach(function (t) {
        if (void 0 !== k.perm) throw new Error("Invalid permission: " + t);
        i += k[t];
    }),
        (this.padding = "(¿N^NuAd\0NVÿú\b..\0¶Ðh>/\f©þdSiz");
    var a = (e + this.padding).substr(0, 32),
        o = (r + this.padding).substr(0, 32);
    (this.O = this.processOwnerPassword(a, o)),
        (this.P = -(1 + (255 ^ i))),
        (this.encryptionKey = x(
            a + this.O + this.lsbFirstWord(this.P) + this.hexToBytes(n),
        ).substr(0, 5)),
        (this.U = P(this.encryptionKey, this.padding));
}
function F(t) {
    if (/[^\u0000-\u00ff]/.test(t))
        throw new Error(
            "Invalid PDF Name Object: " + t + ", Only accept ASCII characters.",
        );
    for (var e = "", r = t.length, n = 0; n < r; n++) {
        var i = t.charCodeAt(n);
        if (
            i < 33 ||
            35 === i ||
            37 === i ||
            40 === i ||
            41 === i ||
            47 === i ||
            60 === i ||
            62 === i ||
            91 === i ||
            93 === i ||
            123 === i ||
            125 === i ||
            i > 126
        )
            e += "#" + ("0" + i.toString(16)).slice(-2);
        else e += t[n];
    }
    return e;
}
function C(e) {
    if ("object" !== _typeof(e))
        throw new Error(
            "Invalid Context passed to initialize PubSub (jsPDF-module)",
        );
    var r = {};
    (this.subscribe = function (t, e, n) {
        if (
            ((n = n || !1),
            "string" != typeof t ||
                "function" != typeof e ||
                "boolean" != typeof n)
        )
            throw new Error(
                "Invalid arguments passed to PubSub.subscribe (jsPDF-module)",
            );
        r.hasOwnProperty(t) || (r[t] = {});
        var i = Math.random().toString(35);
        return (r[t][i] = [e, !!n]), i;
    }),
        (this.unsubscribe = function (t) {
            for (var e in r)
                if (r[e][t])
                    return (
                        delete r[e][t],
                        0 === Object.keys(r[e]).length && delete r[e],
                        !0
                    );
            return !1;
        }),
        (this.publish = function (t) {
            if (r.hasOwnProperty(t)) {
                var i = Array.prototype.slice.call(arguments, 1),
                    o = [];
                for (var s in r[t]) {
                    var c = r[t][s];
                    try {
                        c[0].apply(e, i);
                    } catch (t) {
                        n.console &&
                            a.error("jsPDF PubSub Error", t.message, t);
                    }
                    c[1] && o.push(s);
                }
                o.length && o.forEach(this.unsubscribe);
            }
        }),
        (this.getTopics = function () {
            return r;
        });
}
function j(t) {
    if (!(this instanceof j)) return new j(t);
    var e = "opacity,stroke-opacity".split(",");
    for (var r in t)
        t.hasOwnProperty(r) && e.indexOf(r) >= 0 && (this[r] = t[r]);
    (this.id = ""), (this.objectNumber = -1);
}
function O(t, e) {
    (this.gState = t),
        (this.matrix = e),
        (this.id = ""),
        (this.objectNumber = -1);
}
function B(t, e, r, n, i) {
    if (!(this instanceof B)) return new B(t, e, r, n, i);
    (this.type = "axial" === t ? 2 : 3),
        (this.coords = e),
        (this.colors = r),
        O.call(this, n, i);
}
function M(t, e, r, n, i) {
    if (!(this instanceof M)) return new M(t, e, r, n, i);
    (this.boundingBox = t),
        (this.xStep = e),
        (this.yStep = r),
        (this.stream = ""),
        (this.cloneIndex = 0),
        O.call(this, n, i);
}
function E(e) {
    var r,
        i = "string" == typeof arguments[0] ? arguments[0] : "p",
        o = arguments[1],
        s = arguments[2],
        c = arguments[3],
        u = [],
        d = 1,
        p = 16,
        g = "S",
        m = null;
    "object" === _typeof((e = e || {})) &&
        ((i = e.orientation),
        (o = e.unit || o),
        (s = e.format || s),
        (c = e.compress || e.compressPdf || c),
        null !== (m = e.encryption || null) &&
            ((m.userPassword = m.userPassword || ""),
            (m.ownerPassword = m.ownerPassword || ""),
            (m.userPermissions = m.userPermissions || [])),
        (d = "number" == typeof e.userUnit ? Math.abs(e.userUnit) : 1),
        void 0 !== e.precision && (r = e.precision),
        void 0 !== e.floatPrecision && (p = e.floatPrecision),
        (g = e.defaultPathOperation || "S")),
        (u = e.filters || (!0 === c ? ["FlateEncode"] : u)),
        (o = o || "mm"),
        (i = ("" + (i || "P")).toLowerCase());
    var v = e.putOnlyUsedFonts || !1,
        b = {},
        y = {
            internal: {},
            __private__: {},
        };
    y.__private__.PubSub = C;
    var w = "1.3",
        N = (y.__private__.getPdfVersion = function () {
            return w;
        });
    y.__private__.setPdfVersion = function (t) {
        w = t;
    };
    var L = {
        a0: [2383.94, 3370.39],
        a1: [1683.78, 2383.94],
        a2: [1190.55, 1683.78],
        a3: [841.89, 1190.55],
        a4: [595.28, 841.89],
        a5: [419.53, 595.28],
        a6: [297.64, 419.53],
        a7: [209.76, 297.64],
        a8: [147.4, 209.76],
        a9: [104.88, 147.4],
        a10: [73.7, 104.88],
        b0: [2834.65, 4008.19],
        b1: [2004.09, 2834.65],
        b2: [1417.32, 2004.09],
        b3: [1000.63, 1417.32],
        b4: [708.66, 1000.63],
        b5: [498.9, 708.66],
        b6: [354.33, 498.9],
        b7: [249.45, 354.33],
        b8: [175.75, 249.45],
        b9: [124.72, 175.75],
        b10: [87.87, 124.72],
        c0: [2599.37, 3676.54],
        c1: [1836.85, 2599.37],
        c2: [1298.27, 1836.85],
        c3: [918.43, 1298.27],
        c4: [649.13, 918.43],
        c5: [459.21, 649.13],
        c6: [323.15, 459.21],
        c7: [229.61, 323.15],
        c8: [161.57, 229.61],
        c9: [113.39, 161.57],
        c10: [79.37, 113.39],
        dl: [311.81, 623.62],
        letter: [612, 792],
        "government-letter": [576, 756],
        legal: [612, 1008],
        "junior-legal": [576, 360],
        ledger: [1224, 792],
        tabloid: [792, 1224],
        "credit-card": [153, 243],
    };
    y.__private__.getPageFormats = function () {
        return L;
    };
    var A = (y.__private__.getPageFormat = function (t) {
        return L[t];
    });
    s = s || "a4";
    var x = {
            COMPAT: "compat",
            ADVANCED: "advanced",
        },
        S = x.COMPAT;
    function _() {
        this.saveGraphicsState(),
            lt(new Vt(_t, 0, 0, -_t, 0, Rr() * _t).toString() + " cm"),
            this.setFontSize(this.getFontSize() / _t),
            (g = "n"),
            (S = x.ADVANCED);
    }
    function P() {
        this.restoreGraphicsState(), (g = "S"), (S = x.COMPAT);
    }
    var k = (y.__private__.combineFontStyleAndFontWeight = function (t, e) {
        if (
            ("bold" == t && "normal" == e) ||
            ("bold" == t && 400 == e) ||
            ("normal" == t && "italic" == e) ||
            ("bold" == t && "italic" == e)
        )
            throw new Error("Invalid Combination of fontweight and fontstyle");
        return (
            e &&
                (t =
                    400 == e || "normal" === e
                        ? "italic" === t
                            ? "italic"
                            : "normal"
                        : (700 != e && "bold" !== e) || "normal" !== t
                          ? (700 == e ? "bold" : e) + "" + t
                          : "bold"),
            t
        );
    });
    (y.advancedAPI = function (t) {
        var e = S === x.COMPAT;
        return (
            e && _.call(this),
            "function" != typeof t || (t(this), e && P.call(this)),
            this
        );
    }),
        (y.compatAPI = function (t) {
            var e = S === x.ADVANCED;
            return (
                e && P.call(this),
                "function" != typeof t || (t(this), e && _.call(this)),
                this
            );
        }),
        (y.isAdvancedAPI = function () {
            return S === x.ADVANCED;
        });
    var O,
        q = function (t) {
            if (S !== x.ADVANCED)
                throw new Error(
                    t +
                        " is only available in 'advanced' API mode. You need to call advancedAPI() first.",
                );
        },
        D =
            (y.roundToPrecision =
            y.__private__.roundToPrecision =
                function (t, e) {
                    var n = r || e;
                    if (isNaN(t) || isNaN(n))
                        throw new Error(
                            "Invalid argument passed to jsPDF.roundToPrecision",
                        );
                    return t.toFixed(n).replace(/0+$/, "");
                });
    O =
        y.hpf =
        y.__private__.hpf =
            "number" == typeof p
                ? function (t) {
                      if (isNaN(t))
                          throw new Error(
                              "Invalid argument passed to jsPDF.hpf",
                          );
                      return D(t, p);
                  }
                : "smart" === p
                  ? function (t) {
                        if (isNaN(t))
                            throw new Error(
                                "Invalid argument passed to jsPDF.hpf",
                            );
                        return D(t, t > -1 && t < 1 ? 16 : 5);
                    }
                  : function (t) {
                        if (isNaN(t))
                            throw new Error(
                                "Invalid argument passed to jsPDF.hpf",
                            );
                        return D(t, 16);
                    };
    var R =
            (y.f2 =
            y.__private__.f2 =
                function (t) {
                    if (isNaN(t))
                        throw new Error("Invalid argument passed to jsPDF.f2");
                    return D(t, 2);
                }),
        T = (y.__private__.f3 = function (t) {
            if (isNaN(t))
                throw new Error("Invalid argument passed to jsPDF.f3");
            return D(t, 3);
        }),
        U =
            (y.scale =
            y.__private__.scale =
                function (t) {
                    if (isNaN(t))
                        throw new Error(
                            "Invalid argument passed to jsPDF.scale",
                        );
                    return S === x.COMPAT
                        ? t * _t
                        : S === x.ADVANCED
                          ? t
                          : void 0;
                }),
        z = function (t) {
            return S === x.COMPAT ? Rr() - t : S === x.ADVANCED ? t : void 0;
        },
        H = function (t) {
            return U(z(t));
        };
    y.__private__.setPrecision = y.setPrecision = function (t) {
        "number" == typeof parseInt(t, 10) && (r = parseInt(t, 10));
    };
    var W,
        V = "00000000000000000000000000000000",
        G = (y.__private__.getFileId = function () {
            return V;
        }),
        Y = (y.__private__.setFileId = function (t) {
            return (
                (V =
                    void 0 !== t && /^[a-fA-F0-9]{32}$/.test(t)
                        ? t.toUpperCase()
                        : V.split("")
                              .map(function () {
                                  return "ABCDEF0123456789".charAt(
                                      Math.floor(16 * Math.random()),
                                  );
                              })
                              .join("")),
                null !== m &&
                    (Ye = new I(
                        m.userPermissions,
                        m.userPassword,
                        m.ownerPassword,
                        V,
                    )),
                V
            );
        });
    (y.setFileId = function (t) {
        return Y(t), this;
    }),
        (y.getFileId = function () {
            return G();
        });
    var J = (y.__private__.convertDateToPDFDate = function (t) {
            var e = t.getTimezoneOffset(),
                r = e < 0 ? "+" : "-",
                n = Math.floor(Math.abs(e / 60)),
                i = Math.abs(e % 60),
                a = [r, Q(n), "'", Q(i), "'"].join("");
            return [
                "D:",
                t.getFullYear(),
                Q(t.getMonth() + 1),
                Q(t.getDate()),
                Q(t.getHours()),
                Q(t.getMinutes()),
                Q(t.getSeconds()),
                a,
            ].join("");
        }),
        X = (y.__private__.convertPDFDateToDate = function (t) {
            var e = parseInt(t.substr(2, 4), 10),
                r = parseInt(t.substr(6, 2), 10) - 1,
                n = parseInt(t.substr(8, 2), 10),
                i = parseInt(t.substr(10, 2), 10),
                a = parseInt(t.substr(12, 2), 10),
                o = parseInt(t.substr(14, 2), 10);
            return new Date(e, r, n, i, a, o, 0);
        }),
        K = (y.__private__.setCreationDate = function (t) {
            var e;
            if ((void 0 === t && (t = new Date()), t instanceof Date)) e = J(t);
            else {
                if (
                    !/^D:(20[0-2][0-9]|203[0-7]|19[7-9][0-9])(0[0-9]|1[0-2])([0-2][0-9]|3[0-1])(0[0-9]|1[0-9]|2[0-3])(0[0-9]|[1-5][0-9])(0[0-9]|[1-5][0-9])(\+0[0-9]|\+1[0-4]|-0[0-9]|-1[0-1])'(0[0-9]|[1-5][0-9])'?$/.test(
                        t,
                    )
                )
                    throw new Error(
                        "Invalid argument passed to jsPDF.setCreationDate",
                    );
                e = t;
            }
            return (W = e);
        }),
        Z = (y.__private__.getCreationDate = function (t) {
            var e = W;
            return "jsDate" === t && (e = X(W)), e;
        });
    (y.setCreationDate = function (t) {
        return K(t), this;
    }),
        (y.getCreationDate = function (t) {
            return Z(t);
        });
    var $,
        Q = (y.__private__.padd2 = function (t) {
            return ("0" + parseInt(t)).slice(-2);
        }),
        tt = (y.__private__.padd2Hex = function (t) {
            return ("00" + (t = t.toString())).substr(t.length);
        }),
        et = 0,
        rt = [],
        nt = [],
        it = 0,
        at = [],
        ot = [],
        st = !1,
        ct = nt,
        ut = function () {
            (et = 0),
                (it = 0),
                (nt = []),
                (rt = []),
                (at = []),
                (Qt = Kt()),
                (te = Kt());
        };
    y.__private__.setCustomOutputDestination = function (t) {
        (st = !0), (ct = t);
    };
    var ht = function (t) {
        st || (ct = t);
    };
    y.__private__.resetCustomOutputDestination = function () {
        (st = !1), (ct = nt);
    };
    var lt = (y.__private__.out = function (t) {
            return (t = t.toString()), (it += t.length + 1), ct.push(t), ct;
        }),
        ft = (y.__private__.write = function (t) {
            return lt(
                1 === arguments.length
                    ? t.toString()
                    : Array.prototype.join.call(arguments, " "),
            );
        }),
        dt = (y.__private__.getArrayBuffer = function (t) {
            for (
                var e = t.length, r = new ArrayBuffer(e), n = new Uint8Array(r);
                e--;

            )
                n[e] = t.charCodeAt(e);
            return r;
        }),
        pt = [
            ["Helvetica", "helvetica", "normal", "WinAnsiEncoding"],
            ["Helvetica-Bold", "helvetica", "bold", "WinAnsiEncoding"],
            ["Helvetica-Oblique", "helvetica", "italic", "WinAnsiEncoding"],
            [
                "Helvetica-BoldOblique",
                "helvetica",
                "bolditalic",
                "WinAnsiEncoding",
            ],
            ["Courier", "courier", "normal", "WinAnsiEncoding"],
            ["Courier-Bold", "courier", "bold", "WinAnsiEncoding"],
            ["Courier-Oblique", "courier", "italic", "WinAnsiEncoding"],
            ["Courier-BoldOblique", "courier", "bolditalic", "WinAnsiEncoding"],
            ["Times-Roman", "times", "normal", "WinAnsiEncoding"],
            ["Times-Bold", "times", "bold", "WinAnsiEncoding"],
            ["Times-Italic", "times", "italic", "WinAnsiEncoding"],
            ["Times-BoldItalic", "times", "bolditalic", "WinAnsiEncoding"],
            ["ZapfDingbats", "zapfdingbats", "normal", null],
            ["Symbol", "symbol", "normal", null],
        ];
    y.__private__.getStandardFonts = function () {
        return pt;
    };
    var gt = e.fontSize || 16;
    y.__private__.setFontSize = y.setFontSize = function (t) {
        return (gt = S === x.ADVANCED ? t / _t : t), this;
    };
    var mt,
        vt =
            (y.__private__.getFontSize =
            y.getFontSize =
                function () {
                    return S === x.COMPAT ? gt : gt * _t;
                }),
        bt = e.R2L || !1;
    (y.__private__.setR2L = y.setR2L =
        function (t) {
            return (bt = t), this;
        }),
        (y.__private__.getR2L = y.getR2L =
            function () {
                return bt;
            });
    var yt,
        wt = (y.__private__.setZoomMode = function (t) {
            var e = [
                void 0,
                null,
                "fullwidth",
                "fullheight",
                "fullpage",
                "original",
            ];
            if (/^(?:\d+\.\d*|\d*\.\d+|\d+)%$/.test(t)) mt = t;
            else if (isNaN(t)) {
                if (-1 === e.indexOf(t))
                    throw new Error(
                        'zoom must be Integer (e.g. 2), a percentage Value (e.g. 300%) or fullwidth, fullheight, fullpage, original. "' +
                            t +
                            '" is not recognized.',
                    );
                mt = t;
            } else mt = parseInt(t, 10);
        });
    y.__private__.getZoomMode = function () {
        return mt;
    };
    var Nt,
        Lt = (y.__private__.setPageMode = function (t) {
            if (
                -1 ==
                [
                    void 0,
                    null,
                    "UseNone",
                    "UseOutlines",
                    "UseThumbs",
                    "FullScreen",
                ].indexOf(t)
            )
                throw new Error(
                    'Page mode must be one of UseNone, UseOutlines, UseThumbs, or FullScreen. "' +
                        t +
                        '" is not recognized.',
                );
            yt = t;
        });
    y.__private__.getPageMode = function () {
        return yt;
    };
    var At = (y.__private__.setLayoutMode = function (t) {
        if (
            -1 ==
            [
                void 0,
                null,
                "continuous",
                "single",
                "twoleft",
                "tworight",
                "two",
            ].indexOf(t)
        )
            throw new Error(
                'Layout mode must be one of continuous, single, twoleft, tworight. "' +
                    t +
                    '" is not recognized.',
            );
        Nt = t;
    });
    (y.__private__.getLayoutMode = function () {
        return Nt;
    }),
        (y.__private__.setDisplayMode = y.setDisplayMode =
            function (t, e, r) {
                return wt(t), At(e), Lt(r), this;
            });
    var xt = {
        title: "",
        subject: "",
        author: "",
        keywords: "",
        creator: "",
    };
    (y.__private__.getDocumentProperty = function (t) {
        if (-1 === Object.keys(xt).indexOf(t))
            throw new Error(
                "Invalid argument passed to jsPDF.getDocumentProperty",
            );
        return xt[t];
    }),
        (y.__private__.getDocumentProperties = function () {
            return xt;
        }),
        (y.__private__.setDocumentProperties =
            y.setProperties =
            y.setDocumentProperties =
                function (t) {
                    for (var e in xt)
                        xt.hasOwnProperty(e) && t[e] && (xt[e] = t[e]);
                    return this;
                }),
        (y.__private__.setDocumentProperty = function (t, e) {
            if (-1 === Object.keys(xt).indexOf(t))
                throw new Error(
                    "Invalid arguments passed to jsPDF.setDocumentProperty",
                );
            return (xt[t] = e);
        });
    var St,
        _t,
        Pt,
        kt,
        It,
        Ft = {},
        Ct = {},
        jt = [],
        Ot = {},
        Bt = {},
        Mt = {},
        Et = {},
        qt = null,
        Dt = 0,
        Rt = [],
        Tt = new C(y),
        Ut = e.hotfixes || [],
        zt = {},
        Ht = {},
        Wt = [],
        Vt = function t(e, r, n, i, a, o) {
            if (!(this instanceof t)) return new t(e, r, n, i, a, o);
            isNaN(e) && (e = 1),
                isNaN(r) && (r = 0),
                isNaN(n) && (n = 0),
                isNaN(i) && (i = 1),
                isNaN(a) && (a = 0),
                isNaN(o) && (o = 0),
                (this._matrix = [e, r, n, i, a, o]);
        };
    Object.defineProperty(Vt.prototype, "sx", {
        get: function () {
            return this._matrix[0];
        },
        set: function (t) {
            this._matrix[0] = t;
        },
    }),
        Object.defineProperty(Vt.prototype, "shy", {
            get: function () {
                return this._matrix[1];
            },
            set: function (t) {
                this._matrix[1] = t;
            },
        }),
        Object.defineProperty(Vt.prototype, "shx", {
            get: function () {
                return this._matrix[2];
            },
            set: function (t) {
                this._matrix[2] = t;
            },
        }),
        Object.defineProperty(Vt.prototype, "sy", {
            get: function () {
                return this._matrix[3];
            },
            set: function (t) {
                this._matrix[3] = t;
            },
        }),
        Object.defineProperty(Vt.prototype, "tx", {
            get: function () {
                return this._matrix[4];
            },
            set: function (t) {
                this._matrix[4] = t;
            },
        }),
        Object.defineProperty(Vt.prototype, "ty", {
            get: function () {
                return this._matrix[5];
            },
            set: function (t) {
                this._matrix[5] = t;
            },
        }),
        Object.defineProperty(Vt.prototype, "a", {
            get: function () {
                return this._matrix[0];
            },
            set: function (t) {
                this._matrix[0] = t;
            },
        }),
        Object.defineProperty(Vt.prototype, "b", {
            get: function () {
                return this._matrix[1];
            },
            set: function (t) {
                this._matrix[1] = t;
            },
        }),
        Object.defineProperty(Vt.prototype, "c", {
            get: function () {
                return this._matrix[2];
            },
            set: function (t) {
                this._matrix[2] = t;
            },
        }),
        Object.defineProperty(Vt.prototype, "d", {
            get: function () {
                return this._matrix[3];
            },
            set: function (t) {
                this._matrix[3] = t;
            },
        }),
        Object.defineProperty(Vt.prototype, "e", {
            get: function () {
                return this._matrix[4];
            },
            set: function (t) {
                this._matrix[4] = t;
            },
        }),
        Object.defineProperty(Vt.prototype, "f", {
            get: function () {
                return this._matrix[5];
            },
            set: function (t) {
                this._matrix[5] = t;
            },
        }),
        Object.defineProperty(Vt.prototype, "rotation", {
            get: function () {
                return Math.atan2(this.shx, this.sx);
            },
        }),
        Object.defineProperty(Vt.prototype, "scaleX", {
            get: function () {
                return this.decompose().scale.sx;
            },
        }),
        Object.defineProperty(Vt.prototype, "scaleY", {
            get: function () {
                return this.decompose().scale.sy;
            },
        }),
        Object.defineProperty(Vt.prototype, "isIdentity", {
            get: function () {
                return (
                    1 === this.sx &&
                    0 === this.shy &&
                    0 === this.shx &&
                    1 === this.sy &&
                    0 === this.tx &&
                    0 === this.ty
                );
            },
        }),
        (Vt.prototype.join = function (t) {
            return [this.sx, this.shy, this.shx, this.sy, this.tx, this.ty]
                .map(O)
                .join(t);
        }),
        (Vt.prototype.multiply = function (t) {
            var e = t.sx * this.sx + t.shy * this.shx,
                r = t.sx * this.shy + t.shy * this.sy,
                n = t.shx * this.sx + t.sy * this.shx,
                i = t.shx * this.shy + t.sy * this.sy,
                a = t.tx * this.sx + t.ty * this.shx + this.tx,
                o = t.tx * this.shy + t.ty * this.sy + this.ty;
            return new Vt(e, r, n, i, a, o);
        }),
        (Vt.prototype.decompose = function () {
            var t = this.sx,
                e = this.shy,
                r = this.shx,
                n = this.sy,
                i = this.tx,
                a = this.ty,
                o = Math.sqrt(t * t + e * e),
                s = (t /= o) * r + (e /= o) * n;
            (r -= t * s), (n -= e * s);
            var c = Math.sqrt(r * r + n * n);
            return (
                (s /= c),
                t * (n /= c) < e * (r /= c) &&
                    ((t = -t), (e = -e), (s = -s), (o = -o)),
                {
                    scale: new Vt(o, 0, 0, c, 0, 0),
                    translate: new Vt(1, 0, 0, 1, i, a),
                    rotate: new Vt(t, e, -e, t, 0, 0),
                    skew: new Vt(1, 0, s, 1, 0, 0),
                }
            );
        }),
        (Vt.prototype.toString = function (t) {
            return this.join(" ");
        }),
        (Vt.prototype.inversed = function () {
            var t = this.sx,
                e = this.shy,
                r = this.shx,
                n = this.sy,
                i = this.tx,
                a = this.ty,
                o = 1 / (t * n - e * r),
                s = n * o,
                c = -e * o,
                u = -r * o,
                h = t * o;
            return new Vt(s, c, u, h, -s * i - u * a, -c * i - h * a);
        }),
        (Vt.prototype.applyToPoint = function (t) {
            var e = t.x * this.sx + t.y * this.shx + this.tx,
                r = t.x * this.shy + t.y * this.sy + this.ty;
            return new Cr(e, r);
        }),
        (Vt.prototype.applyToRectangle = function (t) {
            var e = this.applyToPoint(t),
                r = this.applyToPoint(new Cr(t.x + t.w, t.y + t.h));
            return new jr(e.x, e.y, r.x - e.x, r.y - e.y);
        }),
        (Vt.prototype.clone = function () {
            var t = this.sx,
                e = this.shy,
                r = this.shx,
                n = this.sy,
                i = this.tx,
                a = this.ty;
            return new Vt(t, e, r, n, i, a);
        }),
        (y.Matrix = Vt);
    var Gt = (y.matrixMult = function (t, e) {
            return e.multiply(t);
        }),
        Yt = new Vt(1, 0, 0, 1, 0, 0);
    y.unitMatrix = y.identityMatrix = Yt;
    var Jt = function (t, e) {
        if (!Bt[t]) {
            var r =
                (e instanceof B ? "Sh" : "P") +
                (Object.keys(Ot).length + 1).toString(10);
            (e.id = r), (Bt[t] = r), (Ot[r] = e), Tt.publish("addPattern", e);
        }
    };
    (y.ShadingPattern = B),
        (y.TilingPattern = M),
        (y.addShadingPattern = function (t, e) {
            return q("addShadingPattern()"), Jt(t, e), this;
        }),
        (y.beginTilingPattern = function (t) {
            q("beginTilingPattern()"),
                Br(
                    t.boundingBox[0],
                    t.boundingBox[1],
                    t.boundingBox[2] - t.boundingBox[0],
                    t.boundingBox[3] - t.boundingBox[1],
                    t.matrix,
                );
        }),
        (y.endTilingPattern = function (t, e) {
            q("endTilingPattern()"),
                (e.stream = ot[$].join("\n")),
                Jt(t, e),
                Tt.publish("endTilingPattern", e),
                Wt.pop().restore();
        });
    var Xt = (y.__private__.newObject = function () {
            var t = Kt();
            return Zt(t, !0), t;
        }),
        Kt = (y.__private__.newObjectDeferred = function () {
            return (
                et++,
                (rt[et] = function () {
                    return it;
                }),
                et
            );
        }),
        Zt = function (t, e) {
            return (
                (e = "boolean" == typeof e && e),
                (rt[t] = it),
                e && lt(t + " 0 obj"),
                t
            );
        },
        $t = (y.__private__.newAdditionalObject = function () {
            var t = {
                objId: Kt(),
                content: "",
            };
            return at.push(t), t;
        }),
        Qt = Kt(),
        te = Kt(),
        ee = (y.__private__.decodeColorString = function (t) {
            var e = t.split(" ");
            if (2 !== e.length || ("g" !== e[1] && "G" !== e[1])) {
                if (5 === e.length && ("k" === e[4] || "K" === e[4])) {
                    e = [
                        (1 - e[0]) * (1 - e[3]),
                        (1 - e[1]) * (1 - e[3]),
                        (1 - e[2]) * (1 - e[3]),
                        "r",
                    ];
                }
            } else {
                var r = parseFloat(e[0]);
                e = [r, r, r, "r"];
            }
            for (var n = "#", i = 0; i < 3; i++)
                n += (
                    "0" + Math.floor(255 * parseFloat(e[i])).toString(16)
                ).slice(-2);
            return n;
        }),
        re = (y.__private__.encodeColorString = function (e) {
            var r;
            "string" == typeof e &&
                (e = {
                    ch1: e,
                });
            var n = e.ch1,
                i = e.ch2,
                a = e.ch3,
                o = e.ch4,
                s =
                    "draw" === e.pdfColorType
                        ? ["G", "RG", "K"]
                        : ["g", "rg", "k"];
            if ("string" == typeof n && "#" !== n.charAt(0)) {
                var c = new f(n);
                if (c.ok) n = c.toHex();
                else if (!/^\d*\.?\d*$/.test(n))
                    throw new Error(
                        'Invalid color "' +
                            n +
                            '" passed to jsPDF.encodeColorString.',
                    );
            }
            if (
                ("string" == typeof n &&
                    /^#[0-9A-Fa-f]{3}$/.test(n) &&
                    (n = "#" + n[1] + n[1] + n[2] + n[2] + n[3] + n[3]),
                "string" == typeof n && /^#[0-9A-Fa-f]{6}$/.test(n))
            ) {
                var u = parseInt(n.substr(1), 16);
                (n = (u >> 16) & 255), (i = (u >> 8) & 255), (a = 255 & u);
            }
            if (void 0 === i || (void 0 === o && n === i && i === a)) {
                if ("string" == typeof n) r = n + " " + s[0];
                else
                    switch (e.precision) {
                        case 2:
                            r = R(n / 255) + " " + s[0];
                            break;
                        case 3:
                        default:
                            r = T(n / 255) + " " + s[0];
                    }
            } else if (void 0 === o || "object" === _typeof(o)) {
                if (o && !isNaN(o.a) && 0 === o.a)
                    return (r = ["1.", "1.", "1.", s[1]].join(" "));
                if ("string" == typeof n) r = [n, i, a, s[1]].join(" ");
                else
                    switch (e.precision) {
                        case 2:
                            r = [R(n / 255), R(i / 255), R(a / 255), s[1]].join(
                                " ",
                            );
                            break;
                        default:
                        case 3:
                            r = [T(n / 255), T(i / 255), T(a / 255), s[1]].join(
                                " ",
                            );
                    }
            } else if ("string" == typeof n) r = [n, i, a, o, s[2]].join(" ");
            else
                switch (e.precision) {
                    case 2:
                        r = [R(n), R(i), R(a), R(o), s[2]].join(" ");
                        break;
                    case 3:
                    default:
                        r = [T(n), T(i), T(a), T(o), s[2]].join(" ");
                }
            return r;
        }),
        ne = (y.__private__.getFilters = function () {
            return u;
        }),
        ie = (y.__private__.putStream = function (t) {
            var e = (t = t || {}).data || "",
                r = t.filters || ne(),
                n = t.alreadyAppliedFilters || [],
                i = t.addLength1 || !1,
                a = e.length,
                o = t.objectId,
                s = function (t) {
                    return t;
                };
            if (null !== m && void 0 === o)
                throw new Error(
                    "ObjectId must be passed to putStream for file encryption",
                );
            null !== m && (s = Ye.encryptor(o, 0));
            var c = {};
            !0 === r && (r = ["FlateEncode"]);
            var u = t.additionalKeyValues || [],
                h =
                    (c =
                        void 0 !== E.API.processDataByFilters
                            ? E.API.processDataByFilters(e, r)
                            : {
                                  data: e,
                                  reverseChain: [],
                              }).reverseChain +
                    (Array.isArray(n) ? n.join(" ") : n.toString());
            if (
                (0 !== c.data.length &&
                    (u.push({
                        key: "Length",
                        value: c.data.length,
                    }),
                    !0 === i &&
                        u.push({
                            key: "Length1",
                            value: a,
                        })),
                0 != h.length)
            )
                if (h.split("/").length - 1 == 1)
                    u.push({
                        key: "Filter",
                        value: h,
                    });
                else {
                    u.push({
                        key: "Filter",
                        value: "[" + h + "]",
                    });
                    for (var l = 0; l < u.length; l += 1)
                        if ("DecodeParms" === u[l].key) {
                            for (
                                var f = [], d = 0;
                                d < c.reverseChain.split("/").length - 1;
                                d += 1
                            )
                                f.push("null");
                            f.push(u[l].value),
                                (u[l].value = "[" + f.join(" ") + "]");
                        }
                }
            lt("<<");
            for (var p = 0; p < u.length; p++)
                lt("/" + u[p].key + " " + u[p].value);
            lt(">>"),
                0 !== c.data.length &&
                    (lt("stream"), lt(s(c.data)), lt("endstream"));
        }),
        ae = (y.__private__.putPage = function (t) {
            var e = t.number,
                r = t.data,
                n = t.objId,
                i = t.contentsObjId;
            Zt(n, !0),
                lt("<</Type /Page"),
                lt("/Parent " + t.rootDictionaryObjId + " 0 R"),
                lt("/Resources " + t.resourceDictionaryObjId + " 0 R"),
                lt(
                    "/MediaBox [" +
                        parseFloat(O(t.mediaBox.bottomLeftX)) +
                        " " +
                        parseFloat(O(t.mediaBox.bottomLeftY)) +
                        " " +
                        O(t.mediaBox.topRightX) +
                        " " +
                        O(t.mediaBox.topRightY) +
                        "]",
                ),
                null !== t.cropBox &&
                    lt(
                        "/CropBox [" +
                            O(t.cropBox.bottomLeftX) +
                            " " +
                            O(t.cropBox.bottomLeftY) +
                            " " +
                            O(t.cropBox.topRightX) +
                            " " +
                            O(t.cropBox.topRightY) +
                            "]",
                    ),
                null !== t.bleedBox &&
                    lt(
                        "/BleedBox [" +
                            O(t.bleedBox.bottomLeftX) +
                            " " +
                            O(t.bleedBox.bottomLeftY) +
                            " " +
                            O(t.bleedBox.topRightX) +
                            " " +
                            O(t.bleedBox.topRightY) +
                            "]",
                    ),
                null !== t.trimBox &&
                    lt(
                        "/TrimBox [" +
                            O(t.trimBox.bottomLeftX) +
                            " " +
                            O(t.trimBox.bottomLeftY) +
                            " " +
                            O(t.trimBox.topRightX) +
                            " " +
                            O(t.trimBox.topRightY) +
                            "]",
                    ),
                null !== t.artBox &&
                    lt(
                        "/ArtBox [" +
                            O(t.artBox.bottomLeftX) +
                            " " +
                            O(t.artBox.bottomLeftY) +
                            " " +
                            O(t.artBox.topRightX) +
                            " " +
                            O(t.artBox.topRightY) +
                            "]",
                    ),
                "number" == typeof t.userUnit &&
                    1 !== t.userUnit &&
                    lt("/UserUnit " + t.userUnit),
                Tt.publish("putPage", {
                    objId: n,
                    pageContext: Rt[e],
                    pageNumber: e,
                    page: r,
                }),
                lt("/Contents " + i + " 0 R"),
                lt(">>"),
                lt("endobj");
            var a = r.join("\n");
            return (
                S === x.ADVANCED && (a += "\nQ"),
                Zt(i, !0),
                ie({
                    data: a,
                    filters: ne(),
                    objectId: i,
                }),
                lt("endobj"),
                n
            );
        }),
        oe = (y.__private__.putPages = function () {
            var t,
                e,
                r = [];
            for (t = 1; t <= Dt; t++)
                (Rt[t].objId = Kt()), (Rt[t].contentsObjId = Kt());
            for (t = 1; t <= Dt; t++)
                r.push(
                    ae({
                        number: t,
                        data: ot[t],
                        objId: Rt[t].objId,
                        contentsObjId: Rt[t].contentsObjId,
                        mediaBox: Rt[t].mediaBox,
                        cropBox: Rt[t].cropBox,
                        bleedBox: Rt[t].bleedBox,
                        trimBox: Rt[t].trimBox,
                        artBox: Rt[t].artBox,
                        userUnit: Rt[t].userUnit,
                        rootDictionaryObjId: Qt,
                        resourceDictionaryObjId: te,
                    }),
                );
            Zt(Qt, !0), lt("<</Type /Pages");
            var n = "/Kids [";
            for (e = 0; e < Dt; e++) n += r[e] + " 0 R ";
            lt(n + "]"),
                lt("/Count " + Dt),
                lt(">>"),
                lt("endobj"),
                Tt.publish("postPutPages");
        }),
        se = function (t) {
            Tt.publish("putFont", {
                font: t,
                out: lt,
                newObject: Xt,
                putStream: ie,
            }),
                !0 !== t.isAlreadyPutted &&
                    ((t.objectNumber = Xt()),
                    lt("<<"),
                    lt("/Type /Font"),
                    lt("/BaseFont /" + F(t.postScriptName)),
                    lt("/Subtype /Type1"),
                    "string" == typeof t.encoding &&
                        lt("/Encoding /" + t.encoding),
                    lt("/FirstChar 32"),
                    lt("/LastChar 255"),
                    lt(">>"),
                    lt("endobj"));
        },
        ce = function () {
            for (var t in Ft)
                Ft.hasOwnProperty(t) &&
                    (!1 === v || (!0 === v && b.hasOwnProperty(t))) &&
                    se(Ft[t]);
        },
        ue = function (t) {
            t.objectNumber = Xt();
            var e = [];
            e.push({
                key: "Type",
                value: "/XObject",
            }),
                e.push({
                    key: "Subtype",
                    value: "/Form",
                }),
                e.push({
                    key: "BBox",
                    value:
                        "[" +
                        [
                            O(t.x),
                            O(t.y),
                            O(t.x + t.width),
                            O(t.y + t.height),
                        ].join(" ") +
                        "]",
                }),
                e.push({
                    key: "Matrix",
                    value: "[" + t.matrix.toString() + "]",
                });
            var r = t.pages[1].join("\n");
            ie({
                data: r,
                additionalKeyValues: e,
                objectId: t.objectNumber,
            }),
                lt("endobj");
        },
        he = function () {
            for (var t in zt) zt.hasOwnProperty(t) && ue(zt[t]);
        },
        le = function (t, e) {
            var r,
                n = [],
                i = 1 / (e - 1);
            for (r = 0; r < 1; r += i) n.push(r);
            if ((n.push(1), 0 != t[0].offset)) {
                var a = {
                    offset: 0,
                    color: t[0].color,
                };
                t.unshift(a);
            }
            if (1 != t[t.length - 1].offset) {
                var o = {
                    offset: 1,
                    color: t[t.length - 1].color,
                };
                t.push(o);
            }
            for (var s = "", c = 0, u = 0; u < n.length; u++) {
                for (r = n[u]; r > t[c + 1].offset; ) c++;
                var h = t[c].offset,
                    l = (r - h) / (t[c + 1].offset - h),
                    f = t[c].color,
                    d = t[c + 1].color;
                s +=
                    tt(Math.round((1 - l) * f[0] + l * d[0]).toString(16)) +
                    tt(Math.round((1 - l) * f[1] + l * d[1]).toString(16)) +
                    tt(Math.round((1 - l) * f[2] + l * d[2]).toString(16));
            }
            return s.trim();
        },
        fe = function (t, e) {
            e || (e = 21);
            var r = Xt(),
                n = le(t.colors, e),
                i = [];
            i.push({
                key: "FunctionType",
                value: "0",
            }),
                i.push({
                    key: "Domain",
                    value: "[0.0 1.0]",
                }),
                i.push({
                    key: "Size",
                    value: "[" + e + "]",
                }),
                i.push({
                    key: "BitsPerSample",
                    value: "8",
                }),
                i.push({
                    key: "Range",
                    value: "[0.0 1.0 0.0 1.0 0.0 1.0]",
                }),
                i.push({
                    key: "Decode",
                    value: "[0.0 1.0 0.0 1.0 0.0 1.0]",
                }),
                ie({
                    data: n,
                    additionalKeyValues: i,
                    alreadyAppliedFilters: ["/ASCIIHexDecode"],
                    objectId: r,
                }),
                lt("endobj"),
                (t.objectNumber = Xt()),
                lt("<< /ShadingType " + t.type),
                lt("/ColorSpace /DeviceRGB");
            var a =
                "/Coords [" +
                O(parseFloat(t.coords[0])) +
                " " +
                O(parseFloat(t.coords[1])) +
                " ";
            2 === t.type
                ? (a +=
                      O(parseFloat(t.coords[2])) +
                      " " +
                      O(parseFloat(t.coords[3])))
                : (a +=
                      O(parseFloat(t.coords[2])) +
                      " " +
                      O(parseFloat(t.coords[3])) +
                      " " +
                      O(parseFloat(t.coords[4])) +
                      " " +
                      O(parseFloat(t.coords[5]))),
                lt((a += "]")),
                t.matrix && lt("/Matrix [" + t.matrix.toString() + "]"),
                lt("/Function " + r + " 0 R"),
                lt("/Extend [true true]"),
                lt(">>"),
                lt("endobj");
        },
        de = function (t, e) {
            var r = Kt(),
                n = Xt();
            e.push({
                resourcesOid: r,
                objectOid: n,
            }),
                (t.objectNumber = n);
            var i = [];
            i.push({
                key: "Type",
                value: "/Pattern",
            }),
                i.push({
                    key: "PatternType",
                    value: "1",
                }),
                i.push({
                    key: "PaintType",
                    value: "1",
                }),
                i.push({
                    key: "TilingType",
                    value: "1",
                }),
                i.push({
                    key: "BBox",
                    value: "[" + t.boundingBox.map(O).join(" ") + "]",
                }),
                i.push({
                    key: "XStep",
                    value: O(t.xStep),
                }),
                i.push({
                    key: "YStep",
                    value: O(t.yStep),
                }),
                i.push({
                    key: "Resources",
                    value: r + " 0 R",
                }),
                t.matrix &&
                    i.push({
                        key: "Matrix",
                        value: "[" + t.matrix.toString() + "]",
                    }),
                ie({
                    data: t.stream,
                    additionalKeyValues: i,
                    objectId: t.objectNumber,
                }),
                lt("endobj");
        },
        pe = function (t) {
            var e;
            for (e in Ot)
                Ot.hasOwnProperty(e) &&
                    (Ot[e] instanceof B
                        ? fe(Ot[e])
                        : Ot[e] instanceof M && de(Ot[e], t));
        },
        ge = function (t) {
            for (var e in ((t.objectNumber = Xt()), lt("<<"), t))
                switch (e) {
                    case "opacity":
                        lt("/ca " + R(t[e]));
                        break;
                    case "stroke-opacity":
                        lt("/CA " + R(t[e]));
                }
            lt(">>"), lt("endobj");
        },
        me = function () {
            var t;
            for (t in Mt) Mt.hasOwnProperty(t) && ge(Mt[t]);
        },
        ve = function () {
            for (var t in (lt("/XObject <<"), zt))
                zt.hasOwnProperty(t) &&
                    zt[t].objectNumber >= 0 &&
                    lt("/" + t + " " + zt[t].objectNumber + " 0 R");
            Tt.publish("putXobjectDict"), lt(">>");
        },
        be = function () {
            (Ye.oid = Xt()),
                lt("<<"),
                lt("/Filter /Standard"),
                lt("/V " + Ye.v),
                lt("/R " + Ye.r),
                lt("/U <" + Ye.toHexString(Ye.U) + ">"),
                lt("/O <" + Ye.toHexString(Ye.O) + ">"),
                lt("/P " + Ye.P),
                lt(">>"),
                lt("endobj");
        },
        ye = function () {
            for (var t in (lt("/Font <<"), Ft))
                Ft.hasOwnProperty(t) &&
                    (!1 === v || (!0 === v && b.hasOwnProperty(t))) &&
                    lt("/" + t + " " + Ft[t].objectNumber + " 0 R");
            lt(">>");
        },
        we = function () {
            if (Object.keys(Ot).length > 0) {
                for (var t in (lt("/Shading <<"), Ot))
                    Ot.hasOwnProperty(t) &&
                        Ot[t] instanceof B &&
                        Ot[t].objectNumber >= 0 &&
                        lt("/" + t + " " + Ot[t].objectNumber + " 0 R");
                Tt.publish("putShadingPatternDict"), lt(">>");
            }
        },
        Ne = function (t) {
            if (Object.keys(Ot).length > 0) {
                for (var e in (lt("/Pattern <<"), Ot))
                    Ot.hasOwnProperty(e) &&
                        Ot[e] instanceof y.TilingPattern &&
                        Ot[e].objectNumber >= 0 &&
                        Ot[e].objectNumber < t &&
                        lt("/" + e + " " + Ot[e].objectNumber + " 0 R");
                Tt.publish("putTilingPatternDict"), lt(">>");
            }
        },
        Le = function () {
            if (Object.keys(Mt).length > 0) {
                var t;
                for (t in (lt("/ExtGState <<"), Mt))
                    Mt.hasOwnProperty(t) &&
                        Mt[t].objectNumber >= 0 &&
                        lt("/" + t + " " + Mt[t].objectNumber + " 0 R");
                Tt.publish("putGStateDict"), lt(">>");
            }
        },
        Ae = function (t) {
            Zt(t.resourcesOid, !0),
                lt("<<"),
                lt("/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]"),
                ye(),
                we(),
                Ne(t.objectOid),
                Le(),
                ve(),
                lt(">>"),
                lt("endobj");
        },
        xe = function () {
            var t = [];
            ce(),
                me(),
                he(),
                pe(t),
                Tt.publish("putResources"),
                t.forEach(Ae),
                Ae({
                    resourcesOid: te,
                    objectOid: Number.MAX_SAFE_INTEGER,
                }),
                Tt.publish("postPutResources");
        },
        Se = function () {
            Tt.publish("putAdditionalObjects");
            for (var t = 0; t < at.length; t++) {
                var e = at[t];
                Zt(e.objId, !0), lt(e.content), lt("endobj");
            }
            Tt.publish("postPutAdditionalObjects");
        },
        _e = function (t) {
            (Ct[t.fontName] = Ct[t.fontName] || {}),
                (Ct[t.fontName][t.fontStyle] = t.id);
        },
        Pe = function (t, e, r, n, i) {
            var a = {
                id: "F" + (Object.keys(Ft).length + 1).toString(10),
                postScriptName: t,
                fontName: e,
                fontStyle: r,
                encoding: n,
                isStandardFont: i || !1,
                metadata: {},
            };
            return (
                Tt.publish("addFont", {
                    font: a,
                    instance: this,
                }),
                (Ft[a.id] = a),
                _e(a),
                a.id
            );
        },
        ke = function (t) {
            for (var e = 0, r = pt.length; e < r; e++) {
                var n = Pe.call(this, t[e][0], t[e][1], t[e][2], pt[e][3], !0);
                !1 === v && (b[n] = !0);
                var i = t[e][0].split("-");
                _e({
                    id: n,
                    fontName: i[0],
                    fontStyle: i[1] || "",
                });
            }
            Tt.publish("addFonts", {
                fonts: Ft,
                dictionary: Ct,
            });
        },
        Ie = function (t) {
            return (
                (t.foo = function () {
                    try {
                        return t.apply(this, arguments);
                    } catch (t) {
                        var e = t.stack || "";
                        ~e.indexOf(" at ") && (e = e.split(" at ")[1]);
                        var r =
                            "Error in function " +
                            e.split("\n")[0].split("<")[0] +
                            ": " +
                            t.message;
                        if (!n.console) throw new Error(r);
                        n.console.error(r, t), n.alert && alert(r);
                    }
                }),
                (t.foo.bar = t),
                t.foo
            );
        },
        Fe = function (t, e) {
            var r, n, i, a, o, s, c, u, h;
            if (
                ((i = (e = e || {}).sourceEncoding || "Unicode"),
                (o = e.outputEncoding),
                (e.autoencode || o) &&
                    Ft[St].metadata &&
                    Ft[St].metadata[i] &&
                    Ft[St].metadata[i].encoding &&
                    ((a = Ft[St].metadata[i].encoding),
                    !o && Ft[St].encoding && (o = Ft[St].encoding),
                    !o && a.codePages && (o = a.codePages[0]),
                    "string" == typeof o && (o = a[o]),
                    o))
            ) {
                for (c = !1, s = [], r = 0, n = t.length; r < n; r++)
                    (u = o[t.charCodeAt(r)])
                        ? s.push(String.fromCharCode(u))
                        : s.push(t[r]),
                        s[r].charCodeAt(0) >> 8 && (c = !0);
                t = s.join("");
            }
            for (r = t.length; void 0 === c && 0 !== r; )
                t.charCodeAt(r - 1) >> 8 && (c = !0), r--;
            if (!c) return t;
            for (
                s = e.noBOM ? [] : [254, 255], r = 0, n = t.length;
                r < n;
                r++
            ) {
                if ((h = (u = t.charCodeAt(r)) >> 8) >> 8)
                    throw new Error(
                        "Character at position " +
                            r +
                            " of string '" +
                            t +
                            "' exceeds 16bits. Cannot be encoded into UCS-2 BE",
                    );
                s.push(h), s.push(u - (h << 8));
            }
            return String.fromCharCode.apply(void 0, s);
        },
        Ce =
            (y.__private__.pdfEscape =
            y.pdfEscape =
                function (t, e) {
                    return Fe(t, e)
                        .replace(/\\/g, "\\\\")
                        .replace(/\(/g, "\\(")
                        .replace(/\)/g, "\\)");
                }),
        je = (y.__private__.beginPage = function (t) {
            (ot[++Dt] = []),
                (Rt[Dt] = {
                    objId: 0,
                    contentsObjId: 0,
                    userUnit: Number(d),
                    artBox: null,
                    bleedBox: null,
                    cropBox: null,
                    trimBox: null,
                    mediaBox: {
                        bottomLeftX: 0,
                        bottomLeftY: 0,
                        topRightX: Number(t[0]),
                        topRightY: Number(t[1]),
                    },
                }),
                Me(Dt),
                ht(ot[$]);
        }),
        Oe = function (t, e) {
            var r, n, o;
            switch (
                ((i = e || i),
                "string" == typeof t &&
                    ((r = A(t.toLowerCase())),
                    Array.isArray(r) && ((n = r[0]), (o = r[1]))),
                Array.isArray(t) && ((n = t[0] * _t), (o = t[1] * _t)),
                isNaN(n) && ((n = s[0]), (o = s[1])),
                (n > 14400 || o > 14400) &&
                    (a.warn(
                        "A page in a PDF can not be wider or taller than 14400 userUnit. jsPDF limits the width/height to 14400",
                    ),
                    (n = Math.min(14400, n)),
                    (o = Math.min(14400, o))),
                (s = [n, o]),
                i.substr(0, 1))
            ) {
                case "l":
                    o > n && (s = [o, n]);
                    break;
                case "p":
                    n > o && (s = [o, n]);
            }
            je(s),
                pr(fr),
                lt(Lr),
                0 !== kr && lt(kr + " J"),
                0 !== Ir && lt(Ir + " j"),
                Tt.publish("addPage", {
                    pageNumber: Dt,
                });
        },
        Be = function (t) {
            t > 0 &&
                t <= Dt &&
                (ot.splice(t, 1),
                Rt.splice(t, 1),
                Dt--,
                $ > Dt && ($ = Dt),
                this.setPage($));
        },
        Me = function (t) {
            t > 0 && t <= Dt && ($ = t);
        },
        Ee =
            (y.__private__.getNumberOfPages =
            y.getNumberOfPages =
                function () {
                    return ot.length - 1;
                }),
        qe = function (t, e, r) {
            var n,
                i = void 0;
            return (
                (r = r || {}),
                (t = void 0 !== t ? t : Ft[St].fontName),
                (e = void 0 !== e ? e : Ft[St].fontStyle),
                (n = t.toLowerCase()),
                void 0 !== Ct[n] && void 0 !== Ct[n][e]
                    ? (i = Ct[n][e])
                    : void 0 !== Ct[t] && void 0 !== Ct[t][e]
                      ? (i = Ct[t][e])
                      : !1 === r.disableWarning &&
                        a.warn(
                            "Unable to look up font label for font '" +
                                t +
                                "', '" +
                                e +
                                "'. Refer to getFontList() for available fonts.",
                        ),
                i ||
                    r.noFallback ||
                    (null == (i = Ct.times[e]) && (i = Ct.times.normal)),
                i
            );
        },
        De = (y.__private__.putInfo = function () {
            var t = Xt(),
                e = function (t) {
                    return t;
                };
            for (var r in (null !== m && (e = Ye.encryptor(t, 0)),
            lt("<<"),
            lt("/Producer (" + Ce(e("jsPDF " + E.version)) + ")"),
            xt))
                xt.hasOwnProperty(r) &&
                    xt[r] &&
                    lt(
                        "/" +
                            r.substr(0, 1).toUpperCase() +
                            r.substr(1) +
                            " (" +
                            Ce(e(xt[r])) +
                            ")",
                    );
            lt("/CreationDate (" + Ce(e(W)) + ")"), lt(">>"), lt("endobj");
        }),
        Re = (y.__private__.putCatalog = function (t) {
            var e = (t = t || {}).rootDictionaryObjId || Qt;
            switch (
                (Xt(),
                lt("<<"),
                lt("/Type /Catalog"),
                lt("/Pages " + e + " 0 R"),
                mt || (mt = "fullwidth"),
                mt)
            ) {
                case "fullwidth":
                    lt("/OpenAction [3 0 R /FitH null]");
                    break;
                case "fullheight":
                    lt("/OpenAction [3 0 R /FitV null]");
                    break;
                case "fullpage":
                    lt("/OpenAction [3 0 R /Fit]");
                    break;
                case "original":
                    lt("/OpenAction [3 0 R /XYZ null null 1]");
                    break;
                default:
                    var r = "" + mt;
                    "%" === r.substr(r.length - 1) && (mt = parseInt(mt) / 100),
                        "number" == typeof mt &&
                            lt(
                                "/OpenAction [3 0 R /XYZ null null " +
                                    R(mt) +
                                    "]",
                            );
            }
            switch ((Nt || (Nt = "continuous"), Nt)) {
                case "continuous":
                    lt("/PageLayout /OneColumn");
                    break;
                case "single":
                    lt("/PageLayout /SinglePage");
                    break;
                case "two":
                case "twoleft":
                    lt("/PageLayout /TwoColumnLeft");
                    break;
                case "tworight":
                    lt("/PageLayout /TwoColumnRight");
            }
            yt && lt("/PageMode /" + yt),
                Tt.publish("putCatalog"),
                lt(">>"),
                lt("endobj");
        }),
        Te = (y.__private__.putTrailer = function () {
            lt("trailer"),
                lt("<<"),
                lt("/Size " + (et + 1)),
                lt("/Root " + et + " 0 R"),
                lt("/Info " + (et - 1) + " 0 R"),
                null !== m && lt("/Encrypt " + Ye.oid + " 0 R"),
                lt("/ID [ <" + V + "> <" + V + "> ]"),
                lt(">>");
        }),
        Ue = (y.__private__.putHeader = function () {
            lt("%PDF-" + w), lt("%ºß¬à");
        }),
        ze = (y.__private__.putXRef = function () {
            var t = "0000000000";
            lt("xref"), lt("0 " + (et + 1)), lt("0000000000 65535 f ");
            for (var e = 1; e <= et; e++) {
                "function" == typeof rt[e]
                    ? lt((t + rt[e]()).slice(-10) + " 00000 n ")
                    : void 0 !== rt[e]
                      ? lt((t + rt[e]).slice(-10) + " 00000 n ")
                      : lt("0000000000 00000 n ");
            }
        }),
        He = (y.__private__.buildDocument = function () {
            ut(),
                ht(nt),
                Tt.publish("buildDocument"),
                Ue(),
                oe(),
                Se(),
                xe(),
                null !== m && be(),
                De(),
                Re();
            var t = it;
            return (
                ze(),
                Te(),
                lt("startxref"),
                lt("" + t),
                lt("%%EOF"),
                ht(ot[$]),
                nt.join("\n")
            );
        }),
        We = (y.__private__.getBlob = function (t) {
            return new Blob([dt(t)], {
                type: "application/pdf",
            });
        }),
        Ve =
            (y.output =
            y.__private__.output =
                Ie(function (t, e) {
                    switch (
                        ("string" == typeof (e = e || {})
                            ? (e = {
                                  filename: e,
                              })
                            : (e.filename = e.filename || "generated.pdf"),
                        t)
                    ) {
                        case void 0:
                            return He();
                        case "save":
                            y.save(e.filename);
                            break;
                        case "arraybuffer":
                            return dt(He());
                        case "blob":
                            return We(He());
                        case "bloburi":
                        case "bloburl":
                            if (
                                void 0 !== n.URL &&
                                "function" == typeof n.URL.createObjectURL
                            )
                                return (
                                    (n.URL &&
                                        n.URL.createObjectURL(We(He()))) ||
                                    void 0
                                );
                            a.warn(
                                "bloburl is not supported by your system, because URL.createObjectURL is not supported by your browser.",
                            );
                            break;
                        case "datauristring":
                        case "dataurlstring":
                            var r = "",
                                i = He();
                            try {
                                r = h(i);
                            } catch (t) {
                                r = h(unescape(encodeURIComponent(i)));
                            }
                            return (
                                "data:application/pdf;filename=" +
                                e.filename +
                                ";base64," +
                                r
                            );
                        case "pdfobjectnewwindow":
                            if (
                                "[object Window]" ===
                                Object.prototype.toString.call(n)
                            ) {
                                var o =
                                        "https://cdnjs.cloudflare.com/ajax/libs/pdfobject/2.1.1/pdfobject.min.js",
                                    s =
                                        ' integrity="sha512-4ze/a9/4jqu+tX9dfOqJYSvyYd5M6qum/3HpCLr+/Jqf0whc37VUbkpNGHR7/8pSnCFw47T1fmIpwBV7UySh3g==" crossorigin="anonymous"';
                                e.pdfObjectUrl &&
                                    ((o = e.pdfObjectUrl), (s = ""));
                                var c =
                                        '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><script src="' +
                                        o +
                                        '"' +
                                        s +
                                        '><\/script><script >PDFObject.embed("' +
                                        this.output("dataurlstring") +
                                        '", ' +
                                        JSON.stringify(e) +
                                        ");<\/script></body></html>",
                                    u = n.open();
                                return null !== u && u.document.write(c), u;
                            }
                            throw new Error(
                                "The option pdfobjectnewwindow just works in a browser-environment.",
                            );
                        case "pdfjsnewwindow":
                            if (
                                "[object Window]" ===
                                Object.prototype.toString.call(n)
                            ) {
                                var l =
                                        '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe id="pdfViewer" src="' +
                                        (e.pdfJsUrl ||
                                            "examples/PDF.js/web/viewer.html") +
                                        "?file=&downloadName=" +
                                        e.filename +
                                        '" width="500px" height="400px" /></body></html>',
                                    f = n.open();
                                if (null !== f) {
                                    f.document.write(l);
                                    var d = this;
                                    f.document.documentElement.querySelector(
                                        "#pdfViewer",
                                    ).onload = function () {
                                        (f.document.title = e.filename),
                                            f.document.documentElement
                                                .querySelector("#pdfViewer")
                                                .contentWindow.PDFViewerApplication.open(
                                                    d.output("bloburl"),
                                                );
                                    };
                                }
                                return f;
                            }
                            throw new Error(
                                "The option pdfjsnewwindow just works in a browser-environment.",
                            );
                        case "dataurlnewwindow":
                            if (
                                "[object Window]" !==
                                Object.prototype.toString.call(n)
                            )
                                throw new Error(
                                    "The option dataurlnewwindow just works in a browser-environment.",
                                );
                            var p =
                                    '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe src="' +
                                    this.output("datauristring", e) +
                                    '"></iframe></body></html>',
                                g = n.open();
                            if (
                                (null !== g &&
                                    (g.document.write(p),
                                    (g.document.title = e.filename)),
                                g || "undefined" == typeof safari)
                            )
                                return g;
                            break;
                        case "datauri":
                        case "dataurl":
                            return (n.document.location.href = this.output(
                                "datauristring",
                                e,
                            ));
                        default:
                            return null;
                    }
                })),
        Ge = function (t) {
            return !0 === Array.isArray(Ut) && Ut.indexOf(t) > -1;
        };
    switch (o) {
        case "pt":
            _t = 1;
            break;
        case "mm":
            _t = 72 / 25.4;
            break;
        case "cm":
            _t = 72 / 2.54;
            break;
        case "in":
            _t = 72;
            break;
        case "px":
            _t = 1 == Ge("px_scaling") ? 0.75 : 96 / 72;
            break;
        case "pc":
        case "em":
            _t = 12;
            break;
        case "ex":
            _t = 6;
            break;
        default:
            if ("number" != typeof o) throw new Error("Invalid unit: " + o);
            _t = o;
    }
    var Ye = null;
    K(), Y();
    var Je = function (t) {
            return null !== m
                ? Ye.encryptor(t, 0)
                : function (t) {
                      return t;
                  };
        },
        Xe =
            (y.__private__.getPageInfo =
            y.getPageInfo =
                function (t) {
                    if (isNaN(t) || t % 1 != 0)
                        throw new Error(
                            "Invalid argument passed to jsPDF.getPageInfo",
                        );
                    return {
                        objId: Rt[t].objId,
                        pageNumber: t,
                        pageContext: Rt[t],
                    };
                }),
        Ke = (y.__private__.getPageInfoByObjId = function (t) {
            if (isNaN(t) || t % 1 != 0)
                throw new Error(
                    "Invalid argument passed to jsPDF.getPageInfoByObjId",
                );
            for (var e in Rt) if (Rt[e].objId === t) break;
            return Xe(e);
        }),
        Ze =
            (y.__private__.getCurrentPageInfo =
            y.getCurrentPageInfo =
                function () {
                    return {
                        objId: Rt[$].objId,
                        pageNumber: $,
                        pageContext: Rt[$],
                    };
                });
    (y.addPage = function () {
        return Oe.apply(this, arguments), this;
    }),
        (y.setPage = function () {
            return Me.apply(this, arguments), ht.call(this, ot[$]), this;
        }),
        (y.insertPage = function (t) {
            return this.addPage(), this.movePage($, t), this;
        }),
        (y.movePage = function (t, e) {
            var r, n;
            if (t > e) {
                (r = ot[t]), (n = Rt[t]);
                for (var i = t; i > e; i--)
                    (ot[i] = ot[i - 1]), (Rt[i] = Rt[i - 1]);
                (ot[e] = r), (Rt[e] = n), this.setPage(e);
            } else if (t < e) {
                (r = ot[t]), (n = Rt[t]);
                for (var a = t; a < e; a++)
                    (ot[a] = ot[a + 1]), (Rt[a] = Rt[a + 1]);
                (ot[e] = r), (Rt[e] = n), this.setPage(e);
            }
            return this;
        }),
        (y.deletePage = function () {
            return Be.apply(this, arguments), this;
        }),
        (y.__private__.text = y.text =
            function (e, r, n, i, a) {
                var o,
                    s,
                    c,
                    u,
                    h,
                    l,
                    f,
                    d,
                    p,
                    g = (i = i || {}).scope || this;
                if (
                    "number" == typeof e &&
                    "number" == typeof r &&
                    ("string" == typeof n || Array.isArray(n))
                ) {
                    var m = n;
                    (n = r), (r = e), (e = m);
                }
                if (
                    (arguments[3] instanceof Vt == !1
                        ? ((c = arguments[4]),
                          (u = arguments[5]),
                          ("object" === _typeof((f = arguments[3])) &&
                              null !== f) ||
                              ("string" == typeof c && ((u = c), (c = null)),
                              "string" == typeof f && ((u = f), (f = null)),
                              "number" == typeof f && ((c = f), (f = null)),
                              (i = {
                                  flags: f,
                                  angle: c,
                                  align: u,
                              })))
                        : (q(
                              "The transform parameter of text() with a Matrix value",
                          ),
                          (p = a)),
                    isNaN(r) || isNaN(n) || null == e)
                )
                    throw new Error("Invalid arguments passed to jsPDF.text");
                if (0 === e.length) return g;
                var v = "",
                    y = !1,
                    w =
                        "number" == typeof i.lineHeightFactor
                            ? i.lineHeightFactor
                            : lr,
                    N = g.internal.scaleFactor;
                function L(t) {
                    return (
                        (t = t
                            .split("\t")
                            .join(Array(i.TabLen || 9).join(" "))),
                        Ce(t, f)
                    );
                }
                function A(t) {
                    for (var e, r = t.concat(), n = [], i = r.length; i--; )
                        "string" == typeof (e = r.shift())
                            ? n.push(e)
                            : Array.isArray(t) &&
                                (1 === e.length ||
                                    (void 0 === e[1] && void 0 === e[2]))
                              ? n.push(e[0])
                              : n.push([e[0], e[1], e[2]]);
                    return n;
                }
                function _(t, e) {
                    var r;
                    if ("string" == typeof t) r = e(t)[0];
                    else if (Array.isArray(t)) {
                        for (
                            var n, i, a = t.concat(), o = [], s = a.length;
                            s--;

                        )
                            "string" == typeof (n = a.shift())
                                ? o.push(e(n)[0])
                                : Array.isArray(n) &&
                                  "string" == typeof n[0] &&
                                  ((i = e(n[0], n[1], n[2])),
                                  o.push([i[0], i[1], i[2]]));
                        r = o;
                    }
                    return r;
                }
                var P = !1,
                    k = !0;
                if ("string" == typeof e) P = !0;
                else if (Array.isArray(e)) {
                    var I = e.concat();
                    s = [];
                    for (var F, C = I.length; C--; )
                        ("string" != typeof (F = I.shift()) ||
                            (Array.isArray(F) && "string" != typeof F[0])) &&
                            (k = !1);
                    P = k;
                }
                if (!1 === P)
                    throw new Error(
                        'Type of text must be string or Array. "' +
                            e +
                            '" is not recognized.',
                    );
                "string" == typeof e &&
                    (e = e.match(/[\r?\n]/) ? e.split(/\r\n|\r|\n/g) : [e]);
                var j = gt / g.internal.scaleFactor,
                    B = j * (w - 1);
                switch (i.baseline) {
                    case "bottom":
                        n -= B;
                        break;
                    case "top":
                        n += j - B;
                        break;
                    case "hanging":
                        n += j - 2 * B;
                        break;
                    case "middle":
                        n += j / 2 - B;
                }
                if (
                    ((l = i.maxWidth || 0) > 0 &&
                        ("string" == typeof e
                            ? (e = g.splitTextToSize(e, l))
                            : "[object Array]" ===
                                  Object.prototype.toString.call(e) &&
                              (e = e.reduce(function (t, e) {
                                  return t.concat(g.splitTextToSize(e, l));
                              }, []))),
                    (o = {
                        text: e,
                        x: r,
                        y: n,
                        options: i,
                        mutex: {
                            pdfEscape: Ce,
                            activeFontKey: St,
                            fonts: Ft,
                            activeFontSize: gt,
                        },
                    }),
                    Tt.publish("preProcessText", o),
                    (e = o.text),
                    (c = (i = o.options).angle),
                    p instanceof Vt == !1 && c && "number" == typeof c)
                ) {
                    (c *= Math.PI / 180),
                        0 === i.rotationDirection && (c = -c),
                        S === x.ADVANCED && (c = -c);
                    var M = Math.cos(c),
                        E = Math.sin(c);
                    p = new Vt(M, E, -E, M, 0, 0);
                } else c && c instanceof Vt && (p = c);
                S !== x.ADVANCED || p || (p = Yt),
                    void 0 !== (h = i.charSpace || _r) &&
                        ((v += O(U(h)) + " Tc\n"),
                        this.setCharSpace(this.getCharSpace() || 0)),
                    void 0 !== (d = i.horizontalScale) &&
                        (v += O(100 * d) + " Tz\n");
                i.lang;
                var D = -1,
                    R = void 0 !== i.renderingMode ? i.renderingMode : i.stroke,
                    T = g.internal.getCurrentPageInfo().pageContext;
                switch (R) {
                    case 0:
                    case !1:
                    case "fill":
                        D = 0;
                        break;
                    case 1:
                    case !0:
                    case "stroke":
                        D = 1;
                        break;
                    case 2:
                    case "fillThenStroke":
                        D = 2;
                        break;
                    case 3:
                    case "invisible":
                        D = 3;
                        break;
                    case 4:
                    case "fillAndAddForClipping":
                        D = 4;
                        break;
                    case 5:
                    case "strokeAndAddPathForClipping":
                        D = 5;
                        break;
                    case 6:
                    case "fillThenStrokeAndAddToPathForClipping":
                        D = 6;
                        break;
                    case 7:
                    case "addToPathForClipping":
                        D = 7;
                }
                var z =
                    void 0 !== T.usedRenderingMode ? T.usedRenderingMode : -1;
                -1 !== D ? (v += D + " Tr\n") : -1 !== z && (v += "0 Tr\n"),
                    -1 !== D && (T.usedRenderingMode = D),
                    (u = i.align || "left");
                var H,
                    W = gt * w,
                    V = g.internal.pageSize.getWidth(),
                    G = Ft[St];
                (h = i.charSpace || _r),
                    (l = i.maxWidth || 0),
                    (f = Object.assign(
                        {
                            autoencode: !0,
                            noBOM: !0,
                        },
                        i.flags,
                    ));
                var Y = [];
                if ("[object Array]" === Object.prototype.toString.call(e)) {
                    var J;
                    (s = A(e)),
                        "left" !== u &&
                            (H = s.map(function (t) {
                                return (
                                    (g.getStringUnitWidth(t, {
                                        font: G,
                                        charSpace: h,
                                        fontSize: gt,
                                        doKerning: !1,
                                    }) *
                                        gt) /
                                    N
                                );
                            }));
                    var X,
                        K = 0;
                    if ("right" === u) {
                        (r -= H[0]), (e = []), (C = s.length);
                        for (var Z = 0; Z < C; Z++)
                            0 === Z
                                ? ((X = br(r)), (J = yr(n)))
                                : ((X = U(K - H[Z])), (J = -W)),
                                e.push([s[Z], X, J]),
                                (K = H[Z]);
                    } else if ("center" === u) {
                        (r -= H[0] / 2), (e = []), (C = s.length);
                        for (var $ = 0; $ < C; $++)
                            0 === $
                                ? ((X = br(r)), (J = yr(n)))
                                : ((X = U((K - H[$]) / 2)), (J = -W)),
                                e.push([s[$], X, J]),
                                (K = H[$]);
                    } else if ("left" === u) {
                        (e = []), (C = s.length);
                        for (var Q = 0; Q < C; Q++) e.push(s[Q]);
                    } else {
                        if ("justify" !== u)
                            throw new Error(
                                'Unrecognized alignment option, use "left", "center", "right" or "justify".',
                            );
                        (e = []), (C = s.length), (l = 0 !== l ? l : V);
                        for (var tt = 0; tt < C; tt++)
                            (J = 0 === tt ? yr(n) : -W),
                                (X = 0 === tt ? br(r) : 0),
                                tt < C - 1
                                    ? Y.push(
                                          O(
                                              U(
                                                  (l - H[tt]) /
                                                      (s[tt].split(" ").length -
                                                          1),
                                              ),
                                          ),
                                      )
                                    : Y.push(0),
                                e.push([s[tt], X, J]);
                    }
                }
                var et = "boolean" == typeof i.R2L ? i.R2L : bt;
                !0 === et &&
                    (e = _(e, function (t, e, r) {
                        return [t.split("").reverse().join(""), e, r];
                    })),
                    (o = {
                        text: e,
                        x: r,
                        y: n,
                        options: i,
                        mutex: {
                            pdfEscape: Ce,
                            activeFontKey: St,
                            fonts: Ft,
                            activeFontSize: gt,
                        },
                    }),
                    Tt.publish("postProcessText", o),
                    (e = o.text),
                    (y = o.mutex.isHex || !1);
                var rt = Ft[St].encoding;
                ("WinAnsiEncoding" !== rt && "StandardEncoding" !== rt) ||
                    (e = _(e, function (t, e, r) {
                        return [L(t), e, r];
                    })),
                    (s = A(e)),
                    (e = []);
                for (
                    var nt,
                        it,
                        at,
                        ot = 0,
                        st = 1,
                        ct = Array.isArray(s[0]) ? st : ot,
                        ut = "",
                        ht = function (t, e, r) {
                            var n = "";
                            return (
                                r instanceof Vt
                                    ? ((r =
                                          "number" == typeof i.angle
                                              ? Gt(r, new Vt(1, 0, 0, 1, t, e))
                                              : Gt(
                                                    new Vt(1, 0, 0, 1, t, e),
                                                    r,
                                                )),
                                      S === x.ADVANCED &&
                                          (r = Gt(
                                              new Vt(1, 0, 0, -1, 0, 0),
                                              r,
                                          )),
                                      (n = r.join(" ") + " Tm\n"))
                                    : (n = O(t) + " " + O(e) + " Td\n"),
                                n
                            );
                        },
                        ft = 0;
                    ft < s.length;
                    ft++
                ) {
                    switch (((ut = ""), ct)) {
                        case st:
                            (at = (y ? "<" : "(") + s[ft][0] + (y ? ">" : ")")),
                                (nt = parseFloat(s[ft][1])),
                                (it = parseFloat(s[ft][2]));
                            break;
                        case ot:
                            (at = (y ? "<" : "(") + s[ft] + (y ? ">" : ")")),
                                (nt = br(r)),
                                (it = yr(n));
                    }
                    void 0 !== Y && void 0 !== Y[ft] && (ut = Y[ft] + " Tw\n"),
                        0 === ft
                            ? e.push(ut + ht(nt, it, p) + at)
                            : ct === ot
                              ? e.push(ut + at)
                              : ct === st && e.push(ut + ht(nt, it, p) + at);
                }
                (e = ct === ot ? e.join(" Tj\nT* ") : e.join(" Tj\n")),
                    (e += " Tj\n");
                var dt = "BT\n/";
                return (
                    (dt += St + " " + gt + " Tf\n"),
                    (dt += O(gt * w) + " TL\n"),
                    (dt += xr + "\n"),
                    (dt += v),
                    (dt += e),
                    lt((dt += "ET")),
                    (b[St] = !0),
                    g
                );
            });
    var $e =
        (y.__private__.clip =
        y.clip =
            function (t) {
                return lt("evenodd" === t ? "W*" : "W"), this;
            });
    (y.clipEvenOdd = function () {
        return $e("evenodd");
    }),
        (y.__private__.discardPath = y.discardPath =
            function () {
                return lt("n"), this;
            });
    var Qe = (y.__private__.isValidStyle = function (t) {
        var e = !1;
        return (
            -1 !==
                [
                    void 0,
                    null,
                    "S",
                    "D",
                    "F",
                    "DF",
                    "FD",
                    "f",
                    "f*",
                    "B",
                    "B*",
                    "n",
                ].indexOf(t) && (e = !0),
            e
        );
    });
    y.__private__.setDefaultPathOperation = y.setDefaultPathOperation =
        function (t) {
            return Qe(t) && (g = t), this;
        };
    var tr =
            (y.__private__.getStyle =
            y.getStyle =
                function (t) {
                    var e = g;
                    switch (t) {
                        case "D":
                        case "S":
                            e = "S";
                            break;
                        case "F":
                            e = "f";
                            break;
                        case "FD":
                        case "DF":
                            e = "B";
                            break;
                        case "f":
                        case "f*":
                        case "B":
                        case "B*":
                            e = t;
                    }
                    return e;
                }),
        er = (y.close = function () {
            return lt("h"), this;
        });
    (y.stroke = function () {
        return lt("S"), this;
    }),
        (y.fill = function (t) {
            return rr("f", t), this;
        }),
        (y.fillEvenOdd = function (t) {
            return rr("f*", t), this;
        }),
        (y.fillStroke = function (t) {
            return rr("B", t), this;
        }),
        (y.fillStrokeEvenOdd = function (t) {
            return rr("B*", t), this;
        });
    var rr = function (e, r) {
            "object" === _typeof(r) ? ar(r, e) : lt(e);
        },
        nr = function (t) {
            null === t ||
                (S === x.ADVANCED && void 0 === t) ||
                ((t = tr(t)), lt(t));
        };
    function ir(t, e, r, n, i) {
        var a = new M(
            e || this.boundingBox,
            r || this.xStep,
            n || this.yStep,
            this.gState,
            i || this.matrix,
        );
        a.stream = this.stream;
        var o = t + "$$" + this.cloneIndex++ + "$$";
        return Jt(o, a), a;
    }
    var ar = function (t, e) {
            var r = Bt[t.key],
                n = Ot[r];
            if (n instanceof B)
                lt("q"),
                    lt(or(e)),
                    n.gState && y.setGState(n.gState),
                    lt(t.matrix.toString() + " cm"),
                    lt("/" + r + " sh"),
                    lt("Q");
            else if (n instanceof M) {
                var i = new Vt(1, 0, 0, -1, 0, Rr());
                t.matrix &&
                    ((i = i.multiply(t.matrix || Yt)),
                    (r = ir.call(
                        n,
                        t.key,
                        t.boundingBox,
                        t.xStep,
                        t.yStep,
                        i,
                    ).id)),
                    lt("q"),
                    lt("/Pattern cs"),
                    lt("/" + r + " scn"),
                    n.gState && y.setGState(n.gState),
                    lt(e),
                    lt("Q");
            }
        },
        or = function (t) {
            switch (t) {
                case "f":
                case "F":
                    return "W n";
                case "f*":
                    return "W* n";
                case "B":
                    return "W S";
                case "B*":
                    return "W* S";
                case "S":
                    return "W S";
                case "n":
                    return "W n";
            }
        },
        sr = (y.moveTo = function (t, e) {
            return lt(O(U(t)) + " " + O(H(e)) + " m"), this;
        }),
        cr = (y.lineTo = function (t, e) {
            return lt(O(U(t)) + " " + O(H(e)) + " l"), this;
        }),
        ur = (y.curveTo = function (t, e, r, n, i, a) {
            return (
                lt(
                    [
                        O(U(t)),
                        O(H(e)),
                        O(U(r)),
                        O(H(n)),
                        O(U(i)),
                        O(H(a)),
                        "c",
                    ].join(" "),
                ),
                this
            );
        });
    (y.__private__.line = y.line =
        function (t, e, r, n, i) {
            if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n) || !Qe(i))
                throw new Error("Invalid arguments passed to jsPDF.line");
            return S === x.COMPAT
                ? this.lines([[r - t, n - e]], t, e, [1, 1], i || "S")
                : this.lines([[r - t, n - e]], t, e, [1, 1]).stroke();
        }),
        (y.__private__.lines = y.lines =
            function (t, e, r, n, i, a) {
                var o, s, c, u, h, l, f, d, p, g, m, v;
                if (
                    ("number" == typeof t &&
                        ((v = r), (r = e), (e = t), (t = v)),
                    (n = n || [1, 1]),
                    (a = a || !1),
                    isNaN(e) ||
                        isNaN(r) ||
                        !Array.isArray(t) ||
                        !Array.isArray(n) ||
                        !Qe(i) ||
                        "boolean" != typeof a)
                )
                    throw new Error("Invalid arguments passed to jsPDF.lines");
                for (
                    sr(e, r),
                        o = n[0],
                        s = n[1],
                        u = t.length,
                        g = e,
                        m = r,
                        c = 0;
                    c < u;
                    c++
                )
                    2 === (h = t[c]).length
                        ? ((g = h[0] * o + g), (m = h[1] * s + m), cr(g, m))
                        : ((l = h[0] * o + g),
                          (f = h[1] * s + m),
                          (d = h[2] * o + g),
                          (p = h[3] * s + m),
                          (g = h[4] * o + g),
                          (m = h[5] * s + m),
                          ur(l, f, d, p, g, m));
                return a && er(), nr(i), this;
            }),
        (y.path = function (t) {
            for (var e = 0; e < t.length; e++) {
                var r = t[e],
                    n = r.c;
                switch (r.op) {
                    case "m":
                        sr(n[0], n[1]);
                        break;
                    case "l":
                        cr(n[0], n[1]);
                        break;
                    case "c":
                        ur.apply(this, n);
                        break;
                    case "h":
                        er();
                }
            }
            return this;
        }),
        (y.__private__.rect = y.rect =
            function (t, e, r, n, i) {
                if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n) || !Qe(i))
                    throw new Error("Invalid arguments passed to jsPDF.rect");
                return (
                    S === x.COMPAT && (n = -n),
                    lt([O(U(t)), O(H(e)), O(U(r)), O(U(n)), "re"].join(" ")),
                    nr(i),
                    this
                );
            }),
        (y.__private__.triangle = y.triangle =
            function (t, e, r, n, i, a, o) {
                if (
                    isNaN(t) ||
                    isNaN(e) ||
                    isNaN(r) ||
                    isNaN(n) ||
                    isNaN(i) ||
                    isNaN(a) ||
                    !Qe(o)
                )
                    throw new Error(
                        "Invalid arguments passed to jsPDF.triangle",
                    );
                return (
                    this.lines(
                        [
                            [r - t, n - e],
                            [i - r, a - n],
                            [t - i, e - a],
                        ],
                        t,
                        e,
                        [1, 1],
                        o,
                        !0,
                    ),
                    this
                );
            }),
        (y.__private__.roundedRect = y.roundedRect =
            function (t, e, r, n, i, a, o) {
                if (
                    isNaN(t) ||
                    isNaN(e) ||
                    isNaN(r) ||
                    isNaN(n) ||
                    isNaN(i) ||
                    isNaN(a) ||
                    !Qe(o)
                )
                    throw new Error(
                        "Invalid arguments passed to jsPDF.roundedRect",
                    );
                var s = (4 / 3) * (Math.SQRT2 - 1);
                return (
                    (i = Math.min(i, 0.5 * r)),
                    (a = Math.min(a, 0.5 * n)),
                    this.lines(
                        [
                            [r - 2 * i, 0],
                            [i * s, 0, i, a - a * s, i, a],
                            [0, n - 2 * a],
                            [0, a * s, -i * s, a, -i, a],
                            [2 * i - r, 0],
                            [-i * s, 0, -i, -a * s, -i, -a],
                            [0, 2 * a - n],
                            [0, -a * s, i * s, -a, i, -a],
                        ],
                        t + i,
                        e,
                        [1, 1],
                        o,
                        !0,
                    ),
                    this
                );
            }),
        (y.__private__.ellipse = y.ellipse =
            function (t, e, r, n, i) {
                if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n) || !Qe(i))
                    throw new Error(
                        "Invalid arguments passed to jsPDF.ellipse",
                    );
                var a = (4 / 3) * (Math.SQRT2 - 1) * r,
                    o = (4 / 3) * (Math.SQRT2 - 1) * n;
                return (
                    sr(t + r, e),
                    ur(t + r, e - o, t + a, e - n, t, e - n),
                    ur(t - a, e - n, t - r, e - o, t - r, e),
                    ur(t - r, e + o, t - a, e + n, t, e + n),
                    ur(t + a, e + n, t + r, e + o, t + r, e),
                    nr(i),
                    this
                );
            }),
        (y.__private__.circle = y.circle =
            function (t, e, r, n) {
                if (isNaN(t) || isNaN(e) || isNaN(r) || !Qe(n))
                    throw new Error("Invalid arguments passed to jsPDF.circle");
                return this.ellipse(t, e, r, r, n);
            }),
        (y.setFont = function (t, e, r) {
            return (
                r && (e = k(e, r)),
                (St = qe(t, e, {
                    disableWarning: !1,
                })),
                this
            );
        });
    var hr =
        (y.__private__.getFont =
        y.getFont =
            function () {
                return Ft[qe.apply(y, arguments)];
            });
    (y.__private__.getFontList = y.getFontList =
        function () {
            var t,
                e,
                r = {};
            for (t in Ct)
                if (Ct.hasOwnProperty(t))
                    for (e in ((r[t] = []), Ct[t]))
                        Ct[t].hasOwnProperty(e) && r[t].push(e);
            return r;
        }),
        (y.addFont = function (t, e, r, n, i) {
            var a = [
                "StandardEncoding",
                "MacRomanEncoding",
                "Identity-H",
                "WinAnsiEncoding",
            ];
            return (
                arguments[3] && -1 !== a.indexOf(arguments[3])
                    ? (i = arguments[3])
                    : arguments[3] &&
                      -1 == a.indexOf(arguments[3]) &&
                      (r = k(r, n)),
                (i = i || "Identity-H"),
                Pe.call(this, t, e, r, i)
            );
        });
    var lr,
        fr = e.lineWidth || 0.200025,
        dr =
            (y.__private__.getLineWidth =
            y.getLineWidth =
                function () {
                    return fr;
                }),
        pr =
            (y.__private__.setLineWidth =
            y.setLineWidth =
                function (t) {
                    return (fr = t), lt(O(U(t)) + " w"), this;
                });
    y.__private__.setLineDash =
        E.API.setLineDash =
        E.API.setLineDashPattern =
            function (t, e) {
                if (
                    ((t = t || []), (e = e || 0), isNaN(e) || !Array.isArray(t))
                )
                    throw new Error(
                        "Invalid arguments passed to jsPDF.setLineDash",
                    );
                return (
                    (t = t
                        .map(function (t) {
                            return O(U(t));
                        })
                        .join(" ")),
                    (e = O(U(e))),
                    lt("[" + t + "] " + e + " d"),
                    this
                );
            };
    var gr =
        (y.__private__.getLineHeight =
        y.getLineHeight =
            function () {
                return gt * lr;
            });
    y.__private__.getLineHeight = y.getLineHeight = function () {
        return gt * lr;
    };
    var mr =
            (y.__private__.setLineHeightFactor =
            y.setLineHeightFactor =
                function (t) {
                    return "number" == typeof (t = t || 1.15) && (lr = t), this;
                }),
        vr =
            (y.__private__.getLineHeightFactor =
            y.getLineHeightFactor =
                function () {
                    return lr;
                });
    mr(e.lineHeight);
    var br = (y.__private__.getHorizontalCoordinate = function (t) {
            return U(t);
        }),
        yr = (y.__private__.getVerticalCoordinate = function (t) {
            return S === x.ADVANCED
                ? t
                : Rt[$].mediaBox.topRightY - Rt[$].mediaBox.bottomLeftY - U(t);
        }),
        wr =
            (y.__private__.getHorizontalCoordinateString =
            y.getHorizontalCoordinateString =
                function (t) {
                    return O(br(t));
                }),
        Nr =
            (y.__private__.getVerticalCoordinateString =
            y.getVerticalCoordinateString =
                function (t) {
                    return O(yr(t));
                }),
        Lr = e.strokeColor || "0 G";
    (y.__private__.getStrokeColor = y.getDrawColor =
        function () {
            return ee(Lr);
        }),
        (y.__private__.setStrokeColor = y.setDrawColor =
            function (t, e, r, n) {
                return (
                    (Lr = re({
                        ch1: t,
                        ch2: e,
                        ch3: r,
                        ch4: n,
                        pdfColorType: "draw",
                        precision: 2,
                    })),
                    lt(Lr),
                    this
                );
            });
    var Ar = e.fillColor || "0 g";
    (y.__private__.getFillColor = y.getFillColor =
        function () {
            return ee(Ar);
        }),
        (y.__private__.setFillColor = y.setFillColor =
            function (t, e, r, n) {
                return (
                    (Ar = re({
                        ch1: t,
                        ch2: e,
                        ch3: r,
                        ch4: n,
                        pdfColorType: "fill",
                        precision: 2,
                    })),
                    lt(Ar),
                    this
                );
            });
    var xr = e.textColor || "0 g",
        Sr =
            (y.__private__.getTextColor =
            y.getTextColor =
                function () {
                    return ee(xr);
                });
    y.__private__.setTextColor = y.setTextColor = function (t, e, r, n) {
        return (
            (xr = re({
                ch1: t,
                ch2: e,
                ch3: r,
                ch4: n,
                pdfColorType: "text",
                precision: 3,
            })),
            this
        );
    };
    var _r = e.charSpace,
        Pr =
            (y.__private__.getCharSpace =
            y.getCharSpace =
                function () {
                    return parseFloat(_r || 0);
                });
    y.__private__.setCharSpace = y.setCharSpace = function (t) {
        if (isNaN(t))
            throw new Error("Invalid argument passed to jsPDF.setCharSpace");
        return (_r = t), this;
    };
    var kr = 0;
    (y.CapJoinStyles = {
        0: 0,
        butt: 0,
        but: 0,
        miter: 0,
        1: 1,
        round: 1,
        rounded: 1,
        circle: 1,
        2: 2,
        projecting: 2,
        project: 2,
        square: 2,
        bevel: 2,
    }),
        (y.__private__.setLineCap = y.setLineCap =
            function (t) {
                var e = y.CapJoinStyles[t];
                if (void 0 === e)
                    throw new Error(
                        "Line cap style of '" +
                            t +
                            "' is not recognized. See or extend .CapJoinStyles property for valid styles",
                    );
                return (kr = e), lt(e + " J"), this;
            });
    var Ir = 0;
    (y.__private__.setLineJoin = y.setLineJoin =
        function (t) {
            var e = y.CapJoinStyles[t];
            if (void 0 === e)
                throw new Error(
                    "Line join style of '" +
                        t +
                        "' is not recognized. See or extend .CapJoinStyles property for valid styles",
                );
            return (Ir = e), lt(e + " j"), this;
        }),
        (y.__private__.setLineMiterLimit =
            y.__private__.setMiterLimit =
            y.setLineMiterLimit =
            y.setMiterLimit =
                function (t) {
                    if (((t = t || 0), isNaN(t)))
                        throw new Error(
                            "Invalid argument passed to jsPDF.setLineMiterLimit",
                        );
                    return lt(O(U(t)) + " M"), this;
                }),
        (y.GState = j),
        (y.setGState = function (t) {
            (t = "string" == typeof t ? Mt[Et[t]] : Fr(null, t)).equals(qt) ||
                (lt("/" + t.id + " gs"), (qt = t));
        });
    var Fr = function (t, e) {
        if (!t || !Et[t]) {
            var r = !1;
            for (var n in Mt)
                if (Mt.hasOwnProperty(n) && Mt[n].equals(e)) {
                    r = !0;
                    break;
                }
            if (r) e = Mt[n];
            else {
                var i = "GS" + (Object.keys(Mt).length + 1).toString(10);
                (Mt[i] = e), (e.id = i);
            }
            return t && (Et[t] = e.id), Tt.publish("addGState", e), e;
        }
    };
    (y.addGState = function (t, e) {
        return Fr(t, e), this;
    }),
        (y.saveGraphicsState = function () {
            return (
                lt("q"),
                jt.push({
                    key: St,
                    size: gt,
                    color: xr,
                }),
                this
            );
        }),
        (y.restoreGraphicsState = function () {
            lt("Q");
            var t = jt.pop();
            return (
                (St = t.key), (gt = t.size), (xr = t.color), (qt = null), this
            );
        }),
        (y.setCurrentTransformationMatrix = function (t) {
            return lt(t.toString() + " cm"), this;
        }),
        (y.comment = function (t) {
            return lt("#" + t), this;
        });
    var Cr = function (t, e) {
            var r = t || 0;
            Object.defineProperty(this, "x", {
                enumerable: !0,
                get: function () {
                    return r;
                },
                set: function (t) {
                    isNaN(t) || (r = parseFloat(t));
                },
            });
            var n = e || 0;
            Object.defineProperty(this, "y", {
                enumerable: !0,
                get: function () {
                    return n;
                },
                set: function (t) {
                    isNaN(t) || (n = parseFloat(t));
                },
            });
            var i = "pt";
            return (
                Object.defineProperty(this, "type", {
                    enumerable: !0,
                    get: function () {
                        return i;
                    },
                    set: function (t) {
                        i = t.toString();
                    },
                }),
                this
            );
        },
        jr = function (t, e, r, n) {
            Cr.call(this, t, e), (this.type = "rect");
            var i = r || 0;
            Object.defineProperty(this, "w", {
                enumerable: !0,
                get: function () {
                    return i;
                },
                set: function (t) {
                    isNaN(t) || (i = parseFloat(t));
                },
            });
            var a = n || 0;
            return (
                Object.defineProperty(this, "h", {
                    enumerable: !0,
                    get: function () {
                        return a;
                    },
                    set: function (t) {
                        isNaN(t) || (a = parseFloat(t));
                    },
                }),
                this
            );
        },
        Or = function () {
            (this.page = Dt),
                (this.currentPage = $),
                (this.pages = ot.slice(0)),
                (this.pagesContext = Rt.slice(0)),
                (this.x = Pt),
                (this.y = kt),
                (this.matrix = It),
                (this.width = qr($)),
                (this.height = Rr($)),
                (this.outputDestination = ct),
                (this.id = ""),
                (this.objectNumber = -1);
        };
    Or.prototype.restore = function () {
        (Dt = this.page),
            ($ = this.currentPage),
            (Rt = this.pagesContext),
            (ot = this.pages),
            (Pt = this.x),
            (kt = this.y),
            (It = this.matrix),
            Dr($, this.width),
            Tr($, this.height),
            (ct = this.outputDestination);
    };
    var Br = function (t, e, r, n, i) {
            Wt.push(new Or()),
                (Dt = $ = 0),
                (ot = []),
                (Pt = t),
                (kt = e),
                (It = i),
                je([r, n]);
        },
        Mr = function (t) {
            if (Ht[t]) Wt.pop().restore();
            else {
                var e = new Or(),
                    r = "Xo" + (Object.keys(zt).length + 1).toString(10);
                (e.id = r),
                    (Ht[t] = r),
                    (zt[r] = e),
                    Tt.publish("addFormObject", e),
                    Wt.pop().restore();
            }
        };
    for (var Er in ((y.beginFormObject = function (t, e, r, n, i) {
        return Br(t, e, r, n, i), this;
    }),
    (y.endFormObject = function (t) {
        return Mr(t), this;
    }),
    (y.doFormObject = function (t, e) {
        var r = zt[Ht[t]];
        return (
            lt("q"),
            lt(e.toString() + " cm"),
            lt("/" + r.id + " Do"),
            lt("Q"),
            this
        );
    }),
    (y.getFormObject = function (t) {
        var e = zt[Ht[t]];
        return {
            x: e.x,
            y: e.y,
            width: e.width,
            height: e.height,
            matrix: e.matrix,
        };
    }),
    (y.save = function (t, e) {
        return (
            (t = t || "generated.pdf"),
            ((e = e || {}).returnPromise = e.returnPromise || !1),
            !1 === e.returnPromise
                ? (l(We(He()), t),
                  "function" == typeof l.unload &&
                      n.setTimeout &&
                      setTimeout(l.unload, 911),
                  this)
                : new Promise(function (e, r) {
                      try {
                          var i = l(We(He()), t);
                          "function" == typeof l.unload &&
                              n.setTimeout &&
                              setTimeout(l.unload, 911),
                              e(i);
                      } catch (t) {
                          r(t.message);
                      }
                  })
        );
    }),
    E.API))
        E.API.hasOwnProperty(Er) &&
            ("events" === Er && E.API.events.length
                ? (function (t, e) {
                      var r, n, i;
                      for (i = e.length - 1; -1 !== i; i--)
                          (r = e[i][0]),
                              (n = e[i][1]),
                              t.subscribe.apply(
                                  t,
                                  [r].concat("function" == typeof n ? [n] : n),
                              );
                  })(Tt, E.API.events)
                : (y[Er] = E.API[Er]));
    var qr = (y.getPageWidth = function (t) {
            return (
                (Rt[(t = t || $)].mediaBox.topRightX -
                    Rt[t].mediaBox.bottomLeftX) /
                _t
            );
        }),
        Dr = (y.setPageWidth = function (t, e) {
            Rt[t].mediaBox.topRightX = e * _t + Rt[t].mediaBox.bottomLeftX;
        }),
        Rr = (y.getPageHeight = function (t) {
            return (
                (Rt[(t = t || $)].mediaBox.topRightY -
                    Rt[t].mediaBox.bottomLeftY) /
                _t
            );
        }),
        Tr = (y.setPageHeight = function (t, e) {
            Rt[t].mediaBox.topRightY = e * _t + Rt[t].mediaBox.bottomLeftY;
        });
    return (
        (y.internal = {
            pdfEscape: Ce,
            getStyle: tr,
            getFont: hr,
            getFontSize: vt,
            getCharSpace: Pr,
            getTextColor: Sr,
            getLineHeight: gr,
            getLineHeightFactor: vr,
            getLineWidth: dr,
            write: ft,
            getHorizontalCoordinate: br,
            getVerticalCoordinate: yr,
            getCoordinateString: wr,
            getVerticalCoordinateString: Nr,
            collections: {},
            newObject: Xt,
            newAdditionalObject: $t,
            newObjectDeferred: Kt,
            newObjectDeferredBegin: Zt,
            getFilters: ne,
            putStream: ie,
            events: Tt,
            scaleFactor: _t,
            pageSize: {
                getWidth: function () {
                    return qr($);
                },
                setWidth: function (t) {
                    Dr($, t);
                },
                getHeight: function () {
                    return Rr($);
                },
                setHeight: function (t) {
                    Tr($, t);
                },
            },
            encryptionOptions: m,
            encryption: Ye,
            getEncryptor: Je,
            output: Ve,
            getNumberOfPages: Ee,
            pages: ot,
            out: lt,
            f2: R,
            f3: T,
            getPageInfo: Xe,
            getPageInfoByObjId: Ke,
            getCurrentPageInfo: Ze,
            getPDFVersion: N,
            Point: Cr,
            Rectangle: jr,
            Matrix: Vt,
            hasHotfix: Ge,
        }),
        Object.defineProperty(y.internal.pageSize, "width", {
            get: function () {
                return qr($);
            },
            set: function (t) {
                Dr($, t);
            },
            enumerable: !0,
            configurable: !0,
        }),
        Object.defineProperty(y.internal.pageSize, "height", {
            get: function () {
                return Rr($);
            },
            set: function (t) {
                Tr($, t);
            },
            enumerable: !0,
            configurable: !0,
        }),
        ke.call(y, pt),
        (St = "F1"),
        Oe(s, i),
        Tt.publish("initialized"),
        y
    );
}
(I.prototype.lsbFirstWord = function (t) {
    return String.fromCharCode(
        (t >> 0) & 255,
        (t >> 8) & 255,
        (t >> 16) & 255,
        (t >> 24) & 255,
    );
}),
    (I.prototype.toHexString = function (t) {
        return t
            .split("")
            .map(function (t) {
                return ("0" + (255 & t.charCodeAt(0)).toString(16)).slice(-2);
            })
            .join("");
    }),
    (I.prototype.hexToBytes = function (t) {
        for (var e = [], r = 0; r < t.length; r += 2)
            e.push(String.fromCharCode(parseInt(t.substr(r, 2), 16)));
        return e.join("");
    }),
    (I.prototype.processOwnerPassword = function (t, e) {
        return P(x(e).substr(0, 5), t);
    }),
    (I.prototype.encryptor = function (t, e) {
        var r = x(
            this.encryptionKey +
                String.fromCharCode(
                    255 & t,
                    (t >> 8) & 255,
                    (t >> 16) & 255,
                    255 & e,
                    (e >> 8) & 255,
                ),
        ).substr(0, 10);
        return function (t) {
            return P(r, t);
        };
    }),
    (j.prototype.equals = function (e) {
        var r,
            n = "id,objectNumber,equals";
        if (!e || _typeof(e) !== _typeof(this)) return !1;
        var i = 0;
        for (r in this)
            if (!(n.indexOf(r) >= 0)) {
                if (this.hasOwnProperty(r) && !e.hasOwnProperty(r)) return !1;
                if (this[r] !== e[r]) return !1;
                i++;
            }
        for (r in e) e.hasOwnProperty(r) && n.indexOf(r) < 0 && i--;
        return 0 === i;
    }),
    (E.API = {
        events: [],
    }),
    (E.version = "2.5.1");
var q = E.API,
    D = 1,
    R = function (t) {
        return t
            .replace(/\\/g, "\\\\")
            .replace(/\(/g, "\\(")
            .replace(/\)/g, "\\)");
    },
    T = function (t) {
        return t
            .replace(/\\\\/g, "\\")
            .replace(/\\\(/g, "(")
            .replace(/\\\)/g, ")");
    },
    U = function (t) {
        return t.toFixed(2);
    },
    z = function (t) {
        return t.toFixed(5);
    };
q.__acroform__ = {};
var H = function (t, e) {
        (t.prototype = Object.create(e.prototype)),
            (t.prototype.constructor = t);
    },
    W = function (t) {
        return t * D;
    },
    V = function (t) {
        var e = new ut(),
            r = At.internal.getHeight(t) || 0,
            n = At.internal.getWidth(t) || 0;
        return (e.BBox = [0, 0, Number(U(n)), Number(U(r))]), e;
    },
    G = (q.__acroform__.setBit = function (t, e) {
        if (((t = t || 0), (e = e || 0), isNaN(t) || isNaN(e)))
            throw new Error(
                "Invalid arguments passed to jsPDF.API.__acroform__.setBit",
            );
        return (t |= 1 << e);
    }),
    Y = (q.__acroform__.clearBit = function (t, e) {
        if (((t = t || 0), (e = e || 0), isNaN(t) || isNaN(e)))
            throw new Error(
                "Invalid arguments passed to jsPDF.API.__acroform__.clearBit",
            );
        return (t &= ~(1 << e));
    }),
    J = (q.__acroform__.getBit = function (t, e) {
        if (isNaN(t) || isNaN(e))
            throw new Error(
                "Invalid arguments passed to jsPDF.API.__acroform__.getBit",
            );
        return 0 == (t & (1 << e)) ? 0 : 1;
    }),
    X = (q.__acroform__.getBitForPdf = function (t, e) {
        if (isNaN(t) || isNaN(e))
            throw new Error(
                "Invalid arguments passed to jsPDF.API.__acroform__.getBitForPdf",
            );
        return J(t, e - 1);
    }),
    K = (q.__acroform__.setBitForPdf = function (t, e) {
        if (isNaN(t) || isNaN(e))
            throw new Error(
                "Invalid arguments passed to jsPDF.API.__acroform__.setBitForPdf",
            );
        return G(t, e - 1);
    }),
    Z = (q.__acroform__.clearBitForPdf = function (t, e) {
        if (isNaN(t) || isNaN(e))
            throw new Error(
                "Invalid arguments passed to jsPDF.API.__acroform__.clearBitForPdf",
            );
        return Y(t, e - 1);
    }),
    $ = (q.__acroform__.calculateCoordinates = function (t, e) {
        var r = e.internal.getHorizontalCoordinate,
            n = e.internal.getVerticalCoordinate,
            i = t[0],
            a = t[1],
            o = t[2],
            s = t[3],
            c = {};
        return (
            (c.lowerLeft_X = r(i) || 0),
            (c.lowerLeft_Y = n(a + s) || 0),
            (c.upperRight_X = r(i + o) || 0),
            (c.upperRight_Y = n(a) || 0),
            [
                Number(U(c.lowerLeft_X)),
                Number(U(c.lowerLeft_Y)),
                Number(U(c.upperRight_X)),
                Number(U(c.upperRight_Y)),
            ]
        );
    }),
    Q = function (t) {
        if (t.appearanceStreamContent) return t.appearanceStreamContent;
        if (t.V || t.DV) {
            var e = [],
                r = t._V || t.DV,
                n = tt(t, r),
                i = t.scope.internal.getFont(t.fontName, t.fontStyle).id;
            e.push("/Tx BMC"),
                e.push("q"),
                e.push("BT"),
                e.push(t.scope.__private__.encodeColorString(t.color)),
                e.push("/" + i + " " + U(n.fontSize) + " Tf"),
                e.push("1 0 0 1 0 0 Tm"),
                e.push(n.text),
                e.push("ET"),
                e.push("Q"),
                e.push("EMC");
            var a = V(t);
            return (a.scope = t.scope), (a.stream = e.join("\n")), a;
        }
    },
    tt = function (t, e) {
        var r = 0 === t.fontSize ? t.maxFontSize : t.fontSize,
            n = {
                text: "",
                fontSize: "",
            },
            i = (e =
                ")" ==
                (e = "(" == e.substr(0, 1) ? e.substr(1) : e).substr(
                    e.length - 1,
                )
                    ? e.substr(0, e.length - 1)
                    : e).split(" ");
        i = t.multiline
            ? i.map(function (t) {
                  return t.split("\n");
              })
            : i.map(function (t) {
                  return [t];
              });
        var a = r,
            o = At.internal.getHeight(t) || 0;
        o = o < 0 ? -o : o;
        var s = At.internal.getWidth(t) || 0;
        s = s < 0 ? -s : s;
        var c = function (e, r, n) {
            if (e + 1 < i.length) {
                var a = r + " " + i[e + 1][0];
                return et(a, t, n).width <= s - 4;
            }
            return !1;
        };
        a++;
        t: for (; a > 0; ) {
            (e = ""), a--;
            var u,
                h,
                l = et("3", t, a).height,
                f = t.multiline ? o - a : (o - l) / 2,
                d = (f += 2),
                p = 0,
                g = 0,
                m = 0;
            if (a <= 0) {
                (e = "(...) Tj\n"),
                    (e +=
                        "% Width of Text: " +
                        et(e, t, (a = 12)).width +
                        ", FieldWidth:" +
                        s +
                        "\n");
                break;
            }
            for (var v = "", b = 0, y = 0; y < i.length; y++)
                if (i.hasOwnProperty(y)) {
                    var w = !1;
                    if (1 !== i[y].length && m !== i[y].length - 1) {
                        if ((l + 2) * (b + 2) + 2 > o) continue t;
                        (v += i[y][m]), (w = !0), (g = y), y--;
                    } else {
                        v =
                            " " == (v += i[y][m] + " ").substr(v.length - 1)
                                ? v.substr(0, v.length - 1)
                                : v;
                        var N = parseInt(y),
                            L = c(N, v, a),
                            A = y >= i.length - 1;
                        if (L && !A) {
                            (v += " "), (m = 0);
                            continue;
                        }
                        if (L || A) {
                            if (A) g = N;
                            else if (t.multiline && (l + 2) * (b + 2) + 2 > o)
                                continue t;
                        } else {
                            if (!t.multiline) continue t;
                            if ((l + 2) * (b + 2) + 2 > o) continue t;
                            g = N;
                        }
                    }
                    for (var x = "", S = p; S <= g; S++) {
                        var _ = i[S];
                        if (t.multiline) {
                            if (S === g) {
                                (x += _[m] + " "), (m = (m + 1) % _.length);
                                continue;
                            }
                            if (S === p) {
                                x += _[_.length - 1] + " ";
                                continue;
                            }
                        }
                        x += _[0] + " ";
                    }
                    switch (
                        ((x =
                            " " == x.substr(x.length - 1)
                                ? x.substr(0, x.length - 1)
                                : x),
                        (h = et(x, t, a).width),
                        t.textAlign)
                    ) {
                        case "right":
                            u = s - h - 2;
                            break;
                        case "center":
                            u = (s - h) / 2;
                            break;
                        case "left":
                        default:
                            u = 2;
                    }
                    (e += U(u) + " " + U(d) + " Td\n"),
                        (e += "(" + R(x) + ") Tj\n"),
                        (e += -U(u) + " 0 Td\n"),
                        (d = -(a + 2)),
                        (h = 0),
                        (p = w ? g : g + 1),
                        b++,
                        (v = "");
                }
            break;
        }
        return (n.text = e), (n.fontSize = a), n;
    },
    et = function (t, e, r) {
        var n = e.scope.internal.getFont(e.fontName, e.fontStyle),
            i =
                e.scope.getStringUnitWidth(t, {
                    font: n,
                    fontSize: parseFloat(r),
                    charSpace: 0,
                }) * parseFloat(r);
        return {
            height:
                e.scope.getStringUnitWidth("3", {
                    font: n,
                    fontSize: parseFloat(r),
                    charSpace: 0,
                }) *
                parseFloat(r) *
                1.5,
            width: i,
        };
    },
    rt = {
        fields: [],
        xForms: [],
        acroFormDictionaryRoot: null,
        printedOut: !1,
        internal: null,
        isInitialized: !1,
    },
    nt = function (t, e) {
        var r = {
            type: "reference",
            object: t,
        };
        void 0 ===
            e.internal
                .getPageInfo(t.page)
                .pageContext.annotations.find(function (t) {
                    return t.type === r.type && t.object === r.object;
                }) &&
            e.internal.getPageInfo(t.page).pageContext.annotations.push(r);
    },
    it = function (e, r) {
        for (var n in e)
            if (e.hasOwnProperty(n)) {
                var i = n,
                    a = e[n];
                r.internal.newObjectDeferredBegin(a.objId, !0),
                    "object" === _typeof(a) &&
                        "function" == typeof a.putStream &&
                        a.putStream(),
                    delete e[i];
            }
    },
    at = function (e, r) {
        if (
            ((r.scope = e),
            void 0 !== e.internal &&
                (void 0 === e.internal.acroformPlugin ||
                    !1 === e.internal.acroformPlugin.isInitialized))
        ) {
            if (
                ((lt.FieldNum = 0),
                (e.internal.acroformPlugin = JSON.parse(JSON.stringify(rt))),
                e.internal.acroformPlugin.acroFormDictionaryRoot)
            )
                throw new Error("Exception while creating AcroformDictionary");
            (D = e.internal.scaleFactor),
                (e.internal.acroformPlugin.acroFormDictionaryRoot = new ht()),
                (e.internal.acroformPlugin.acroFormDictionaryRoot.scope = e),
                (e.internal.acroformPlugin.acroFormDictionaryRoot._eventID =
                    e.internal.events.subscribe(
                        "postPutResources",
                        function () {
                            !(function (t) {
                                t.internal.events.unsubscribe(
                                    t.internal.acroformPlugin
                                        .acroFormDictionaryRoot._eventID,
                                ),
                                    delete t.internal.acroformPlugin
                                        .acroFormDictionaryRoot._eventID,
                                    (t.internal.acroformPlugin.printedOut = !0);
                            })(e);
                        },
                    )),
                e.internal.events.subscribe("buildDocument", function () {
                    !(function (t) {
                        t.internal.acroformPlugin.acroFormDictionaryRoot.objId =
                            void 0;
                        var e =
                            t.internal.acroformPlugin.acroFormDictionaryRoot
                                .Fields;
                        for (var r in e)
                            if (e.hasOwnProperty(r)) {
                                var n = e[r];
                                (n.objId = void 0), n.hasAnnotation && nt(n, t);
                            }
                    })(e);
                }),
                e.internal.events.subscribe("putCatalog", function () {
                    !(function (t) {
                        if (
                            void 0 ===
                            t.internal.acroformPlugin.acroFormDictionaryRoot
                        )
                            throw new Error(
                                "putCatalogCallback: Root missing.",
                            );
                        t.internal.write(
                            "/AcroForm " +
                                t.internal.acroformPlugin.acroFormDictionaryRoot
                                    .objId +
                                " 0 R",
                        );
                    })(e);
                }),
                e.internal.events.subscribe("postPutPages", function (r) {
                    !(function (e, r) {
                        var n = !e;
                        for (var i in (e ||
                            (r.internal.newObjectDeferredBegin(
                                r.internal.acroformPlugin.acroFormDictionaryRoot
                                    .objId,
                                !0,
                            ),
                            r.internal.acroformPlugin.acroFormDictionaryRoot.putStream()),
                        (e =
                            e ||
                            r.internal.acroformPlugin.acroFormDictionaryRoot
                                .Kids)))
                            if (e.hasOwnProperty(i)) {
                                var a = e[i],
                                    o = [],
                                    s = a.Rect;
                                if (
                                    (a.Rect && (a.Rect = $(a.Rect, r)),
                                    r.internal.newObjectDeferredBegin(
                                        a.objId,
                                        !0,
                                    ),
                                    (a.DA =
                                        At.createDefaultAppearanceStream(a)),
                                    "object" === _typeof(a) &&
                                        "function" ==
                                            typeof a.getKeyValueListForStream &&
                                        (o = a.getKeyValueListForStream()),
                                    (a.Rect = s),
                                    a.hasAppearanceStream &&
                                        !a.appearanceStreamContent)
                                ) {
                                    var c = Q(a);
                                    o.push({
                                        key: "AP",
                                        value: "<</N " + c + ">>",
                                    }),
                                        r.internal.acroformPlugin.xForms.push(
                                            c,
                                        );
                                }
                                if (a.appearanceStreamContent) {
                                    var u = "";
                                    for (var h in a.appearanceStreamContent)
                                        if (
                                            a.appearanceStreamContent.hasOwnProperty(
                                                h,
                                            )
                                        ) {
                                            var l =
                                                a.appearanceStreamContent[h];
                                            if (
                                                ((u += "/" + h + " "),
                                                (u += "<<"),
                                                Object.keys(l).length >= 1 ||
                                                    Array.isArray(l))
                                            ) {
                                                for (var i in l)
                                                    if (l.hasOwnProperty(i)) {
                                                        var f = l[i];
                                                        "function" ==
                                                            typeof f &&
                                                            (f = f.call(r, a)),
                                                            (u +=
                                                                "/" +
                                                                i +
                                                                " " +
                                                                f +
                                                                " "),
                                                            r.internal.acroformPlugin.xForms.indexOf(
                                                                f,
                                                            ) >= 0 ||
                                                                r.internal.acroformPlugin.xForms.push(
                                                                    f,
                                                                );
                                                    }
                                            } else
                                                "function" == typeof (f = l) &&
                                                    (f = f.call(r, a)),
                                                    (u += "/" + i + " " + f),
                                                    r.internal.acroformPlugin.xForms.indexOf(
                                                        f,
                                                    ) >= 0 ||
                                                        r.internal.acroformPlugin.xForms.push(
                                                            f,
                                                        );
                                            u += ">>";
                                        }
                                    o.push({
                                        key: "AP",
                                        value: "<<\n" + u + ">>",
                                    });
                                }
                                r.internal.putStream({
                                    additionalKeyValues: o,
                                    objectId: a.objId,
                                }),
                                    r.internal.out("endobj");
                            }
                        n && it(r.internal.acroformPlugin.xForms, r);
                    })(r, e);
                }),
                (e.internal.acroformPlugin.isInitialized = !0);
        }
    },
    ot = (q.__acroform__.arrayToPdfArray = function (e, r, n) {
        var i = function (t) {
            return t;
        };
        if (Array.isArray(e)) {
            for (var a = "[", o = 0; o < e.length; o++)
                switch ((0 !== o && (a += " "), _typeof(e[o]))) {
                    case "boolean":
                    case "number":
                    case "object":
                        a += e[o].toString();
                        break;
                    case "string":
                        "/" !== e[o].substr(0, 1)
                            ? (void 0 !== r &&
                                  n &&
                                  (i = n.internal.getEncryptor(r)),
                              (a += "(" + R(i(e[o].toString())) + ")"))
                            : (a += e[o].toString());
                }
            return (a += "]");
        }
        throw new Error(
            "Invalid argument passed to jsPDF.__acroform__.arrayToPdfArray",
        );
    });
var st = function (t, e, r) {
        var n = function (t) {
            return t;
        };
        return (
            void 0 !== e && r && (n = r.internal.getEncryptor(e)),
            (t = t || "").toString(),
            (t = "(" + R(n(t)) + ")")
        );
    },
    ct = function () {
        (this._objId = void 0),
            (this._scope = void 0),
            Object.defineProperty(this, "objId", {
                get: function () {
                    if (void 0 === this._objId) {
                        if (void 0 === this.scope) return;
                        this._objId = this.scope.internal.newObjectDeferred();
                    }
                    return this._objId;
                },
                set: function (t) {
                    this._objId = t;
                },
            }),
            Object.defineProperty(this, "scope", {
                value: this._scope,
                writable: !0,
            });
    };
(ct.prototype.toString = function () {
    return this.objId + " 0 R";
}),
    (ct.prototype.putStream = function () {
        var t = this.getKeyValueListForStream();
        this.scope.internal.putStream({
            data: this.stream,
            additionalKeyValues: t,
            objectId: this.objId,
        }),
            this.scope.internal.out("endobj");
    }),
    (ct.prototype.getKeyValueListForStream = function () {
        var t = [],
            e = Object.getOwnPropertyNames(this).filter(function (t) {
                return (
                    "content" != t &&
                    "appearanceStreamContent" != t &&
                    "scope" != t &&
                    "objId" != t &&
                    "_" != t.substring(0, 1)
                );
            });
        for (var r in e)
            if (
                !1 === Object.getOwnPropertyDescriptor(this, e[r]).configurable
            ) {
                var n = e[r],
                    i = this[n];
                i &&
                    (Array.isArray(i)
                        ? t.push({
                              key: n,
                              value: ot(i, this.objId, this.scope),
                          })
                        : i instanceof ct
                          ? ((i.scope = this.scope),
                            t.push({
                                key: n,
                                value: i.objId + " 0 R",
                            }))
                          : "function" != typeof i &&
                            t.push({
                                key: n,
                                value: i,
                            }));
            }
        return t;
    });
var ut = function () {
    ct.call(this),
        Object.defineProperty(this, "Type", {
            value: "/XObject",
            configurable: !1,
            writable: !0,
        }),
        Object.defineProperty(this, "Subtype", {
            value: "/Form",
            configurable: !1,
            writable: !0,
        }),
        Object.defineProperty(this, "FormType", {
            value: 1,
            configurable: !1,
            writable: !0,
        });
    var t,
        e = [];
    Object.defineProperty(this, "BBox", {
        configurable: !1,
        get: function () {
            return e;
        },
        set: function (t) {
            e = t;
        },
    }),
        Object.defineProperty(this, "Resources", {
            value: "2 0 R",
            configurable: !1,
            writable: !0,
        }),
        Object.defineProperty(this, "stream", {
            enumerable: !1,
            configurable: !0,
            set: function (e) {
                t = e.trim();
            },
            get: function () {
                return t || null;
            },
        });
};
H(ut, ct);
var ht = function () {
    ct.call(this);
    var t,
        e = [];
    Object.defineProperty(this, "Kids", {
        enumerable: !1,
        configurable: !0,
        get: function () {
            return e.length > 0 ? e : void 0;
        },
    }),
        Object.defineProperty(this, "Fields", {
            enumerable: !1,
            configurable: !1,
            get: function () {
                return e;
            },
        }),
        Object.defineProperty(this, "DA", {
            enumerable: !1,
            configurable: !1,
            get: function () {
                if (t) {
                    var e = function (t) {
                        return t;
                    };
                    return (
                        this.scope &&
                            (e = this.scope.internal.getEncryptor(this.objId)),
                        "(" + R(e(t)) + ")"
                    );
                }
            },
            set: function (e) {
                t = e;
            },
        });
};
H(ht, ct);
var lt = function t() {
    ct.call(this);
    var e = 4;
    Object.defineProperty(this, "F", {
        enumerable: !1,
        configurable: !1,
        get: function () {
            return e;
        },
        set: function (t) {
            if (isNaN(t))
                throw new Error(
                    'Invalid value "' + t + '" for attribute F supplied.',
                );
            e = t;
        },
    }),
        Object.defineProperty(this, "showWhenPrinted", {
            enumerable: !0,
            configurable: !0,
            get: function () {
                return Boolean(X(e, 3));
            },
            set: function (t) {
                !0 === Boolean(t) ? (this.F = K(e, 3)) : (this.F = Z(e, 3));
            },
        });
    var r = 0;
    Object.defineProperty(this, "Ff", {
        enumerable: !1,
        configurable: !1,
        get: function () {
            return r;
        },
        set: function (t) {
            if (isNaN(t))
                throw new Error(
                    'Invalid value "' + t + '" for attribute Ff supplied.',
                );
            r = t;
        },
    });
    var n = [];
    Object.defineProperty(this, "Rect", {
        enumerable: !1,
        configurable: !1,
        get: function () {
            if (0 !== n.length) return n;
        },
        set: function (t) {
            n = void 0 !== t ? t : [];
        },
    }),
        Object.defineProperty(this, "x", {
            enumerable: !0,
            configurable: !0,
            get: function () {
                return !n || isNaN(n[0]) ? 0 : n[0];
            },
            set: function (t) {
                n[0] = t;
            },
        }),
        Object.defineProperty(this, "y", {
            enumerable: !0,
            configurable: !0,
            get: function () {
                return !n || isNaN(n[1]) ? 0 : n[1];
            },
            set: function (t) {
                n[1] = t;
            },
        }),
        Object.defineProperty(this, "width", {
            enumerable: !0,
            configurable: !0,
            get: function () {
                return !n || isNaN(n[2]) ? 0 : n[2];
            },
            set: function (t) {
                n[2] = t;
            },
        }),
        Object.defineProperty(this, "height", {
            enumerable: !0,
            configurable: !0,
            get: function () {
                return !n || isNaN(n[3]) ? 0 : n[3];
            },
            set: function (t) {
                n[3] = t;
            },
        });
    var i = "";
    Object.defineProperty(this, "FT", {
        enumerable: !0,
        configurable: !1,
        get: function () {
            return i;
        },
        set: function (t) {
            switch (t) {
                case "/Btn":
                case "/Tx":
                case "/Ch":
                case "/Sig":
                    i = t;
                    break;
                default:
                    throw new Error(
                        'Invalid value "' + t + '" for attribute FT supplied.',
                    );
            }
        },
    });
    var a = null;
    Object.defineProperty(this, "T", {
        enumerable: !0,
        configurable: !1,
        get: function () {
            if (!a || a.length < 1) {
                if (this instanceof yt) return;
                a = "FieldObject" + t.FieldNum++;
            }
            var e = function (t) {
                return t;
            };
            return (
                this.scope &&
                    (e = this.scope.internal.getEncryptor(this.objId)),
                "(" + R(e(a)) + ")"
            );
        },
        set: function (t) {
            a = t.toString();
        },
    }),
        Object.defineProperty(this, "fieldName", {
            configurable: !0,
            enumerable: !0,
            get: function () {
                return a;
            },
            set: function (t) {
                a = t;
            },
        });
    var o = "helvetica";
    Object.defineProperty(this, "fontName", {
        enumerable: !0,
        configurable: !0,
        get: function () {
            return o;
        },
        set: function (t) {
            o = t;
        },
    });
    var s = "normal";
    Object.defineProperty(this, "fontStyle", {
        enumerable: !0,
        configurable: !0,
        get: function () {
            return s;
        },
        set: function (t) {
            s = t;
        },
    });
    var c = 0;
    Object.defineProperty(this, "fontSize", {
        enumerable: !0,
        configurable: !0,
        get: function () {
            return c;
        },
        set: function (t) {
            c = t;
        },
    });
    var u = void 0;
    Object.defineProperty(this, "maxFontSize", {
        enumerable: !0,
        configurable: !0,
        get: function () {
            return void 0 === u ? 50 / D : u;
        },
        set: function (t) {
            u = t;
        },
    });
    var h = "black";
    Object.defineProperty(this, "color", {
        enumerable: !0,
        configurable: !0,
        get: function () {
            return h;
        },
        set: function (t) {
            h = t;
        },
    });
    var l = "/F1 0 Tf 0 g";
    Object.defineProperty(this, "DA", {
        enumerable: !0,
        configurable: !1,
        get: function () {
            if (!(!l || this instanceof yt || this instanceof Nt))
                return st(l, this.objId, this.scope);
        },
        set: function (t) {
            (t = t.toString()), (l = t);
        },
    });
    var f = null;
    Object.defineProperty(this, "DV", {
        enumerable: !1,
        configurable: !1,
        get: function () {
            if (f)
                return this instanceof mt == !1
                    ? st(f, this.objId, this.scope)
                    : f;
        },
        set: function (t) {
            (t = t.toString()),
                (f =
                    this instanceof mt == !1
                        ? "(" === t.substr(0, 1)
                            ? T(t.substr(1, t.length - 2))
                            : T(t)
                        : t);
        },
    }),
        Object.defineProperty(this, "defaultValue", {
            enumerable: !0,
            configurable: !0,
            get: function () {
                return this instanceof mt == !0
                    ? T(f.substr(1, f.length - 1))
                    : f;
            },
            set: function (t) {
                (t = t.toString()),
                    (f = this instanceof mt == !0 ? "/" + t : t);
            },
        });
    var d = null;
    Object.defineProperty(this, "_V", {
        enumerable: !1,
        configurable: !1,
        get: function () {
            if (d) return d;
        },
        set: function (t) {
            this.V = t;
        },
    }),
        Object.defineProperty(this, "V", {
            enumerable: !1,
            configurable: !1,
            get: function () {
                if (d)
                    return this instanceof mt == !1
                        ? st(d, this.objId, this.scope)
                        : d;
            },
            set: function (t) {
                (t = t.toString()),
                    (d =
                        this instanceof mt == !1
                            ? "(" === t.substr(0, 1)
                                ? T(t.substr(1, t.length - 2))
                                : T(t)
                            : t);
            },
        }),
        Object.defineProperty(this, "value", {
            enumerable: !0,
            configurable: !0,
            get: function () {
                return this instanceof mt == !0
                    ? T(d.substr(1, d.length - 1))
                    : d;
            },
            set: function (t) {
                (t = t.toString()),
                    (d = this instanceof mt == !0 ? "/" + t : t);
            },
        }),
        Object.defineProperty(this, "hasAnnotation", {
            enumerable: !0,
            configurable: !0,
            get: function () {
                return this.Rect;
            },
        }),
        Object.defineProperty(this, "Type", {
            enumerable: !0,
            configurable: !1,
            get: function () {
                return this.hasAnnotation ? "/Annot" : null;
            },
        }),
        Object.defineProperty(this, "Subtype", {
            enumerable: !0,
            configurable: !1,
            get: function () {
                return this.hasAnnotation ? "/Widget" : null;
            },
        });
    var p,
        g = !1;
    Object.defineProperty(this, "hasAppearanceStream", {
        enumerable: !0,
        configurable: !0,
        get: function () {
            return g;
        },
        set: function (t) {
            (t = Boolean(t)), (g = t);
        },
    }),
        Object.defineProperty(this, "page", {
            enumerable: !0,
            configurable: !0,
            get: function () {
                if (p) return p;
            },
            set: function (t) {
                p = t;
            },
        }),
        Object.defineProperty(this, "readOnly", {
            enumerable: !0,
            configurable: !0,
            get: function () {
                return Boolean(X(this.Ff, 1));
            },
            set: function (t) {
                !0 === Boolean(t)
                    ? (this.Ff = K(this.Ff, 1))
                    : (this.Ff = Z(this.Ff, 1));
            },
        }),
        Object.defineProperty(this, "required", {
            enumerable: !0,
            configurable: !0,
            get: function () {
                return Boolean(X(this.Ff, 2));
            },
            set: function (t) {
                !0 === Boolean(t)
                    ? (this.Ff = K(this.Ff, 2))
                    : (this.Ff = Z(this.Ff, 2));
            },
        }),
        Object.defineProperty(this, "noExport", {
            enumerable: !0,
            configurable: !0,
            get: function () {
                return Boolean(X(this.Ff, 3));
            },
            set: function (t) {
                !0 === Boolean(t)
                    ? (this.Ff = K(this.Ff, 3))
                    : (this.Ff = Z(this.Ff, 3));
            },
        });
    var m = null;
    Object.defineProperty(this, "Q", {
        enumerable: !0,
        configurable: !1,
        get: function () {
            if (null !== m) return m;
        },
        set: function (t) {
            if (-1 === [0, 1, 2].indexOf(t))
                throw new Error(
                    'Invalid value "' + t + '" for attribute Q supplied.',
                );
            m = t;
        },
    }),
        Object.defineProperty(this, "textAlign", {
            get: function () {
                var t;
                switch (m) {
                    case 0:
                    default:
                        t = "left";
                        break;
                    case 1:
                        t = "center";
                        break;
                    case 2:
                        t = "right";
                }
                return t;
            },
            configurable: !0,
            enumerable: !0,
            set: function (t) {
                switch (t) {
                    case "right":
                    case 2:
                        m = 2;
                        break;
                    case "center":
                    case 1:
                        m = 1;
                        break;
                    case "left":
                    case 0:
                    default:
                        m = 0;
                }
            },
        });
};
H(lt, ct);
var ft = function () {
    lt.call(this),
        (this.FT = "/Ch"),
        (this.V = "()"),
        (this.fontName = "zapfdingbats");
    var t = 0;
    Object.defineProperty(this, "TI", {
        enumerable: !0,
        configurable: !1,
        get: function () {
            return t;
        },
        set: function (e) {
            t = e;
        },
    }),
        Object.defineProperty(this, "topIndex", {
            enumerable: !0,
            configurable: !0,
            get: function () {
                return t;
            },
            set: function (e) {
                t = e;
            },
        });
    var e = [];
    Object.defineProperty(this, "Opt", {
        enumerable: !0,
        configurable: !1,
        get: function () {
            return ot(e, this.objId, this.scope);
        },
        set: function (t) {
            var r, n;
            (n = []),
                "string" == typeof (r = t) &&
                    (n = (function (t, e, r) {
                        r || (r = 1);
                        for (var n, i = []; (n = e.exec(t)); ) i.push(n[r]);
                        return i;
                    })(r, /\((.*?)\)/g)),
                (e = n);
        },
    }),
        (this.getOptions = function () {
            return e;
        }),
        (this.setOptions = function (t) {
            (e = t), this.sort && e.sort();
        }),
        (this.addOption = function (t) {
            (t = (t = t || "").toString()), e.push(t), this.sort && e.sort();
        }),
        (this.removeOption = function (t, r) {
            for (
                r = r || !1, t = (t = t || "").toString();
                -1 !== e.indexOf(t) && (e.splice(e.indexOf(t), 1), !1 !== r);

            );
        }),
        Object.defineProperty(this, "combo", {
            enumerable: !0,
            configurable: !0,
            get: function () {
                return Boolean(X(this.Ff, 18));
            },
            set: function (t) {
                !0 === Boolean(t)
                    ? (this.Ff = K(this.Ff, 18))
                    : (this.Ff = Z(this.Ff, 18));
            },
        }),
        Object.defineProperty(this, "edit", {
            enumerable: !0,
            configurable: !0,
            get: function () {
                return Boolean(X(this.Ff, 19));
            },
            set: function (t) {
                !0 === this.combo &&
                    (!0 === Boolean(t)
                        ? (this.Ff = K(this.Ff, 19))
                        : (this.Ff = Z(this.Ff, 19)));
            },
        }),
        Object.defineProperty(this, "sort", {
            enumerable: !0,
            configurable: !0,
            get: function () {
                return Boolean(X(this.Ff, 20));
            },
            set: function (t) {
                !0 === Boolean(t)
                    ? ((this.Ff = K(this.Ff, 20)), e.sort())
                    : (this.Ff = Z(this.Ff, 20));
            },
        }),
        Object.defineProperty(this, "multiSelect", {
            enumerable: !0,
            configurable: !0,
            get: function () {
                return Boolean(X(this.Ff, 22));
            },
            set: function (t) {
                !0 === Boolean(t)
                    ? (this.Ff = K(this.Ff, 22))
                    : (this.Ff = Z(this.Ff, 22));
            },
        }),
        Object.defineProperty(this, "doNotSpellCheck", {
            enumerable: !0,
            configurable: !0,
            get: function () {
                return Boolean(X(this.Ff, 23));
            },
            set: function (t) {
                !0 === Boolean(t)
                    ? (this.Ff = K(this.Ff, 23))
                    : (this.Ff = Z(this.Ff, 23));
            },
        }),
        Object.defineProperty(this, "commitOnSelChange", {
            enumerable: !0,
            configurable: !0,
            get: function () {
                return Boolean(X(this.Ff, 27));
            },
            set: function (t) {
                !0 === Boolean(t)
                    ? (this.Ff = K(this.Ff, 27))
                    : (this.Ff = Z(this.Ff, 27));
            },
        }),
        (this.hasAppearanceStream = !1);
};
H(ft, lt);
var dt = function () {
    ft.call(this), (this.fontName = "helvetica"), (this.combo = !1);
};
H(dt, ft);
var pt = function () {
    dt.call(this), (this.combo = !0);
};
H(pt, dt);
var gt = function () {
    pt.call(this), (this.edit = !0);
};
H(gt, pt);
var mt = function () {
    lt.call(this),
        (this.FT = "/Btn"),
        Object.defineProperty(this, "noToggleToOff", {
            enumerable: !0,
            configurable: !0,
            get: function () {
                return Boolean(X(this.Ff, 15));
            },
            set: function (t) {
                !0 === Boolean(t)
                    ? (this.Ff = K(this.Ff, 15))
                    : (this.Ff = Z(this.Ff, 15));
            },
        }),
        Object.defineProperty(this, "radio", {
            enumerable: !0,
            configurable: !0,
            get: function () {
                return Boolean(X(this.Ff, 16));
            },
            set: function (t) {
                !0 === Boolean(t)
                    ? (this.Ff = K(this.Ff, 16))
                    : (this.Ff = Z(this.Ff, 16));
            },
        }),
        Object.defineProperty(this, "pushButton", {
            enumerable: !0,
            configurable: !0,
            get: function () {
                return Boolean(X(this.Ff, 17));
            },
            set: function (t) {
                !0 === Boolean(t)
                    ? (this.Ff = K(this.Ff, 17))
                    : (this.Ff = Z(this.Ff, 17));
            },
        }),
        Object.defineProperty(this, "radioIsUnison", {
            enumerable: !0,
            configurable: !0,
            get: function () {
                return Boolean(X(this.Ff, 26));
            },
            set: function (t) {
                !0 === Boolean(t)
                    ? (this.Ff = K(this.Ff, 26))
                    : (this.Ff = Z(this.Ff, 26));
            },
        });
    var e,
        r = {};
    Object.defineProperty(this, "MK", {
        enumerable: !1,
        configurable: !1,
        get: function () {
            var t = function (t) {
                return t;
            };
            if (
                (this.scope &&
                    (t = this.scope.internal.getEncryptor(this.objId)),
                0 !== Object.keys(r).length)
            ) {
                var e,
                    n = [];
                for (e in (n.push("<<"), r))
                    n.push("/" + e + " (" + R(t(r[e])) + ")");
                return n.push(">>"), n.join("\n");
            }
        },
        set: function (e) {
            "object" === _typeof(e) && (r = e);
        },
    }),
        Object.defineProperty(this, "caption", {
            enumerable: !0,
            configurable: !0,
            get: function () {
                return r.CA || "";
            },
            set: function (t) {
                "string" == typeof t && (r.CA = t);
            },
        }),
        Object.defineProperty(this, "AS", {
            enumerable: !1,
            configurable: !1,
            get: function () {
                return e;
            },
            set: function (t) {
                e = t;
            },
        }),
        Object.defineProperty(this, "appearanceState", {
            enumerable: !0,
            configurable: !0,
            get: function () {
                return e.substr(1, e.length - 1);
            },
            set: function (t) {
                e = "/" + t;
            },
        });
};
H(mt, lt);
var vt = function () {
    mt.call(this), (this.pushButton = !0);
};
H(vt, mt);
var bt = function () {
    mt.call(this), (this.radio = !0), (this.pushButton = !1);
    var t = [];
    Object.defineProperty(this, "Kids", {
        enumerable: !0,
        configurable: !1,
        get: function () {
            return t;
        },
        set: function (e) {
            t = void 0 !== e ? e : [];
        },
    });
};
H(bt, mt);
var yt = function () {
    var e, r;
    lt.call(this),
        Object.defineProperty(this, "Parent", {
            enumerable: !1,
            configurable: !1,
            get: function () {
                return e;
            },
            set: function (t) {
                e = t;
            },
        }),
        Object.defineProperty(this, "optionName", {
            enumerable: !1,
            configurable: !0,
            get: function () {
                return r;
            },
            set: function (t) {
                r = t;
            },
        });
    var n,
        i = {};
    Object.defineProperty(this, "MK", {
        enumerable: !1,
        configurable: !1,
        get: function () {
            var t = function (t) {
                return t;
            };
            this.scope && (t = this.scope.internal.getEncryptor(this.objId));
            var e,
                r = [];
            for (e in (r.push("<<"), i))
                r.push("/" + e + " (" + R(t(i[e])) + ")");
            return r.push(">>"), r.join("\n");
        },
        set: function (e) {
            "object" === _typeof(e) && (i = e);
        },
    }),
        Object.defineProperty(this, "caption", {
            enumerable: !0,
            configurable: !0,
            get: function () {
                return i.CA || "";
            },
            set: function (t) {
                "string" == typeof t && (i.CA = t);
            },
        }),
        Object.defineProperty(this, "AS", {
            enumerable: !1,
            configurable: !1,
            get: function () {
                return n;
            },
            set: function (t) {
                n = t;
            },
        }),
        Object.defineProperty(this, "appearanceState", {
            enumerable: !0,
            configurable: !0,
            get: function () {
                return n.substr(1, n.length - 1);
            },
            set: function (t) {
                n = "/" + t;
            },
        }),
        (this.caption = "l"),
        (this.appearanceState = "Off"),
        (this._AppearanceType = At.RadioButton.Circle),
        (this.appearanceStreamContent =
            this._AppearanceType.createAppearanceStream(this.optionName));
};
H(yt, lt),
    (bt.prototype.setAppearance = function (t) {
        if (!("createAppearanceStream" in t) || !("getCA" in t))
            throw new Error(
                "Couldn't assign Appearance to RadioButton. Appearance was Invalid!",
            );
        for (var e in this.Kids)
            if (this.Kids.hasOwnProperty(e)) {
                var r = this.Kids[e];
                (r.appearanceStreamContent = t.createAppearanceStream(
                    r.optionName,
                )),
                    (r.caption = t.getCA());
            }
    }),
    (bt.prototype.createOption = function (t) {
        var e = new yt();
        return (
            (e.Parent = this),
            (e.optionName = t),
            this.Kids.push(e),
            xt.call(this.scope, e),
            e
        );
    });
var wt = function () {
    mt.call(this),
        (this.fontName = "zapfdingbats"),
        (this.caption = "3"),
        (this.appearanceState = "On"),
        (this.value = "On"),
        (this.textAlign = "center"),
        (this.appearanceStreamContent = At.CheckBox.createAppearanceStream());
};
H(wt, mt);
var Nt = function () {
    lt.call(this),
        (this.FT = "/Tx"),
        Object.defineProperty(this, "multiline", {
            enumerable: !0,
            configurable: !0,
            get: function () {
                return Boolean(X(this.Ff, 13));
            },
            set: function (t) {
                !0 === Boolean(t)
                    ? (this.Ff = K(this.Ff, 13))
                    : (this.Ff = Z(this.Ff, 13));
            },
        }),
        Object.defineProperty(this, "fileSelect", {
            enumerable: !0,
            configurable: !0,
            get: function () {
                return Boolean(X(this.Ff, 21));
            },
            set: function (t) {
                !0 === Boolean(t)
                    ? (this.Ff = K(this.Ff, 21))
                    : (this.Ff = Z(this.Ff, 21));
            },
        }),
        Object.defineProperty(this, "doNotSpellCheck", {
            enumerable: !0,
            configurable: !0,
            get: function () {
                return Boolean(X(this.Ff, 23));
            },
            set: function (t) {
                !0 === Boolean(t)
                    ? (this.Ff = K(this.Ff, 23))
                    : (this.Ff = Z(this.Ff, 23));
            },
        }),
        Object.defineProperty(this, "doNotScroll", {
            enumerable: !0,
            configurable: !0,
            get: function () {
                return Boolean(X(this.Ff, 24));
            },
            set: function (t) {
                !0 === Boolean(t)
                    ? (this.Ff = K(this.Ff, 24))
                    : (this.Ff = Z(this.Ff, 24));
            },
        }),
        Object.defineProperty(this, "comb", {
            enumerable: !0,
            configurable: !0,
            get: function () {
                return Boolean(X(this.Ff, 25));
            },
            set: function (t) {
                !0 === Boolean(t)
                    ? (this.Ff = K(this.Ff, 25))
                    : (this.Ff = Z(this.Ff, 25));
            },
        }),
        Object.defineProperty(this, "richText", {
            enumerable: !0,
            configurable: !0,
            get: function () {
                return Boolean(X(this.Ff, 26));
            },
            set: function (t) {
                !0 === Boolean(t)
                    ? (this.Ff = K(this.Ff, 26))
                    : (this.Ff = Z(this.Ff, 26));
            },
        });
    var t = null;
    Object.defineProperty(this, "MaxLen", {
        enumerable: !0,
        configurable: !1,
        get: function () {
            return t;
        },
        set: function (e) {
            t = e;
        },
    }),
        Object.defineProperty(this, "maxLength", {
            enumerable: !0,
            configurable: !0,
            get: function () {
                return t;
            },
            set: function (e) {
                Number.isInteger(e) && (t = e);
            },
        }),
        Object.defineProperty(this, "hasAppearanceStream", {
            enumerable: !0,
            configurable: !0,
            get: function () {
                return this.V || this.DV;
            },
        });
};
H(Nt, lt);
var Lt = function () {
    Nt.call(this),
        Object.defineProperty(this, "password", {
            enumerable: !0,
            configurable: !0,
            get: function () {
                return Boolean(X(this.Ff, 14));
            },
            set: function (t) {
                !0 === Boolean(t)
                    ? (this.Ff = K(this.Ff, 14))
                    : (this.Ff = Z(this.Ff, 14));
            },
        }),
        (this.password = !0);
};
H(Lt, Nt);
var At = {
    CheckBox: {
        createAppearanceStream: function () {
            return {
                N: {
                    On: At.CheckBox.YesNormal,
                },
                D: {
                    On: At.CheckBox.YesPushDown,
                    Off: At.CheckBox.OffPushDown,
                },
            };
        },
        YesPushDown: function (t) {
            var e = V(t);
            e.scope = t.scope;
            var r = [],
                n = t.scope.internal.getFont(t.fontName, t.fontStyle).id,
                i = t.scope.__private__.encodeColorString(t.color),
                a = tt(t, t.caption);
            return (
                r.push("0.749023 g"),
                r.push(
                    "0 0 " +
                        U(At.internal.getWidth(t)) +
                        " " +
                        U(At.internal.getHeight(t)) +
                        " re",
                ),
                r.push("f"),
                r.push("BMC"),
                r.push("q"),
                r.push("0 0 1 rg"),
                r.push("/" + n + " " + U(a.fontSize) + " Tf " + i),
                r.push("BT"),
                r.push(a.text),
                r.push("ET"),
                r.push("Q"),
                r.push("EMC"),
                (e.stream = r.join("\n")),
                e
            );
        },
        YesNormal: function (t) {
            var e = V(t);
            e.scope = t.scope;
            var r = t.scope.internal.getFont(t.fontName, t.fontStyle).id,
                n = t.scope.__private__.encodeColorString(t.color),
                i = [],
                a = At.internal.getHeight(t),
                o = At.internal.getWidth(t),
                s = tt(t, t.caption);
            return (
                i.push("1 g"),
                i.push("0 0 " + U(o) + " " + U(a) + " re"),
                i.push("f"),
                i.push("q"),
                i.push("0 0 1 rg"),
                i.push("0 0 " + U(o - 1) + " " + U(a - 1) + " re"),
                i.push("W"),
                i.push("n"),
                i.push("0 g"),
                i.push("BT"),
                i.push("/" + r + " " + U(s.fontSize) + " Tf " + n),
                i.push(s.text),
                i.push("ET"),
                i.push("Q"),
                (e.stream = i.join("\n")),
                e
            );
        },
        OffPushDown: function (t) {
            var e = V(t);
            e.scope = t.scope;
            var r = [];
            return (
                r.push("0.749023 g"),
                r.push(
                    "0 0 " +
                        U(At.internal.getWidth(t)) +
                        " " +
                        U(At.internal.getHeight(t)) +
                        " re",
                ),
                r.push("f"),
                (e.stream = r.join("\n")),
                e
            );
        },
    },
    RadioButton: {
        Circle: {
            createAppearanceStream: function (t) {
                var e = {
                    D: {
                        Off: At.RadioButton.Circle.OffPushDown,
                    },
                    N: {},
                };
                return (
                    (e.N[t] = At.RadioButton.Circle.YesNormal),
                    (e.D[t] = At.RadioButton.Circle.YesPushDown),
                    e
                );
            },
            getCA: function () {
                return "l";
            },
            YesNormal: function (t) {
                var e = V(t);
                e.scope = t.scope;
                var r = [],
                    n =
                        At.internal.getWidth(t) <= At.internal.getHeight(t)
                            ? At.internal.getWidth(t) / 4
                            : At.internal.getHeight(t) / 4;
                n = Number((0.9 * n).toFixed(5));
                var i = At.internal.Bezier_C,
                    a = Number((n * i).toFixed(5));
                return (
                    r.push("q"),
                    r.push(
                        "1 0 0 1 " +
                            z(At.internal.getWidth(t) / 2) +
                            " " +
                            z(At.internal.getHeight(t) / 2) +
                            " cm",
                    ),
                    r.push(n + " 0 m"),
                    r.push(n + " " + a + " " + a + " " + n + " 0 " + n + " c"),
                    r.push(
                        "-" +
                            a +
                            " " +
                            n +
                            " -" +
                            n +
                            " " +
                            a +
                            " -" +
                            n +
                            " 0 c",
                    ),
                    r.push(
                        "-" +
                            n +
                            " -" +
                            a +
                            " -" +
                            a +
                            " -" +
                            n +
                            " 0 -" +
                            n +
                            " c",
                    ),
                    r.push(
                        a + " -" + n + " " + n + " -" + a + " " + n + " 0 c",
                    ),
                    r.push("f"),
                    r.push("Q"),
                    (e.stream = r.join("\n")),
                    e
                );
            },
            YesPushDown: function (t) {
                var e = V(t);
                e.scope = t.scope;
                var r = [],
                    n =
                        At.internal.getWidth(t) <= At.internal.getHeight(t)
                            ? At.internal.getWidth(t) / 4
                            : At.internal.getHeight(t) / 4;
                n = Number((0.9 * n).toFixed(5));
                var i = Number((2 * n).toFixed(5)),
                    a = Number((i * At.internal.Bezier_C).toFixed(5)),
                    o = Number((n * At.internal.Bezier_C).toFixed(5));
                return (
                    r.push("0.749023 g"),
                    r.push("q"),
                    r.push(
                        "1 0 0 1 " +
                            z(At.internal.getWidth(t) / 2) +
                            " " +
                            z(At.internal.getHeight(t) / 2) +
                            " cm",
                    ),
                    r.push(i + " 0 m"),
                    r.push(i + " " + a + " " + a + " " + i + " 0 " + i + " c"),
                    r.push(
                        "-" +
                            a +
                            " " +
                            i +
                            " -" +
                            i +
                            " " +
                            a +
                            " -" +
                            i +
                            " 0 c",
                    ),
                    r.push(
                        "-" +
                            i +
                            " -" +
                            a +
                            " -" +
                            a +
                            " -" +
                            i +
                            " 0 -" +
                            i +
                            " c",
                    ),
                    r.push(
                        a + " -" + i + " " + i + " -" + a + " " + i + " 0 c",
                    ),
                    r.push("f"),
                    r.push("Q"),
                    r.push("0 g"),
                    r.push("q"),
                    r.push(
                        "1 0 0 1 " +
                            z(At.internal.getWidth(t) / 2) +
                            " " +
                            z(At.internal.getHeight(t) / 2) +
                            " cm",
                    ),
                    r.push(n + " 0 m"),
                    r.push(n + " " + o + " " + o + " " + n + " 0 " + n + " c"),
                    r.push(
                        "-" +
                            o +
                            " " +
                            n +
                            " -" +
                            n +
                            " " +
                            o +
                            " -" +
                            n +
                            " 0 c",
                    ),
                    r.push(
                        "-" +
                            n +
                            " -" +
                            o +
                            " -" +
                            o +
                            " -" +
                            n +
                            " 0 -" +
                            n +
                            " c",
                    ),
                    r.push(
                        o + " -" + n + " " + n + " -" + o + " " + n + " 0 c",
                    ),
                    r.push("f"),
                    r.push("Q"),
                    (e.stream = r.join("\n")),
                    e
                );
            },
            OffPushDown: function (t) {
                var e = V(t);
                e.scope = t.scope;
                var r = [],
                    n =
                        At.internal.getWidth(t) <= At.internal.getHeight(t)
                            ? At.internal.getWidth(t) / 4
                            : At.internal.getHeight(t) / 4;
                n = Number((0.9 * n).toFixed(5));
                var i = Number((2 * n).toFixed(5)),
                    a = Number((i * At.internal.Bezier_C).toFixed(5));
                return (
                    r.push("0.749023 g"),
                    r.push("q"),
                    r.push(
                        "1 0 0 1 " +
                            z(At.internal.getWidth(t) / 2) +
                            " " +
                            z(At.internal.getHeight(t) / 2) +
                            " cm",
                    ),
                    r.push(i + " 0 m"),
                    r.push(i + " " + a + " " + a + " " + i + " 0 " + i + " c"),
                    r.push(
                        "-" +
                            a +
                            " " +
                            i +
                            " -" +
                            i +
                            " " +
                            a +
                            " -" +
                            i +
                            " 0 c",
                    ),
                    r.push(
                        "-" +
                            i +
                            " -" +
                            a +
                            " -" +
                            a +
                            " -" +
                            i +
                            " 0 -" +
                            i +
                            " c",
                    ),
                    r.push(
                        a + " -" + i + " " + i + " -" + a + " " + i + " 0 c",
                    ),
                    r.push("f"),
                    r.push("Q"),
                    (e.stream = r.join("\n")),
                    e
                );
            },
        },
        Cross: {
            createAppearanceStream: function (t) {
                var e = {
                    D: {
                        Off: At.RadioButton.Cross.OffPushDown,
                    },
                    N: {},
                };
                return (
                    (e.N[t] = At.RadioButton.Cross.YesNormal),
                    (e.D[t] = At.RadioButton.Cross.YesPushDown),
                    e
                );
            },
            getCA: function () {
                return "8";
            },
            YesNormal: function (t) {
                var e = V(t);
                e.scope = t.scope;
                var r = [],
                    n = At.internal.calculateCross(t);
                return (
                    r.push("q"),
                    r.push(
                        "1 1 " +
                            U(At.internal.getWidth(t) - 2) +
                            " " +
                            U(At.internal.getHeight(t) - 2) +
                            " re",
                    ),
                    r.push("W"),
                    r.push("n"),
                    r.push(U(n.x1.x) + " " + U(n.x1.y) + " m"),
                    r.push(U(n.x2.x) + " " + U(n.x2.y) + " l"),
                    r.push(U(n.x4.x) + " " + U(n.x4.y) + " m"),
                    r.push(U(n.x3.x) + " " + U(n.x3.y) + " l"),
                    r.push("s"),
                    r.push("Q"),
                    (e.stream = r.join("\n")),
                    e
                );
            },
            YesPushDown: function (t) {
                var e = V(t);
                e.scope = t.scope;
                var r = At.internal.calculateCross(t),
                    n = [];
                return (
                    n.push("0.749023 g"),
                    n.push(
                        "0 0 " +
                            U(At.internal.getWidth(t)) +
                            " " +
                            U(At.internal.getHeight(t)) +
                            " re",
                    ),
                    n.push("f"),
                    n.push("q"),
                    n.push(
                        "1 1 " +
                            U(At.internal.getWidth(t) - 2) +
                            " " +
                            U(At.internal.getHeight(t) - 2) +
                            " re",
                    ),
                    n.push("W"),
                    n.push("n"),
                    n.push(U(r.x1.x) + " " + U(r.x1.y) + " m"),
                    n.push(U(r.x2.x) + " " + U(r.x2.y) + " l"),
                    n.push(U(r.x4.x) + " " + U(r.x4.y) + " m"),
                    n.push(U(r.x3.x) + " " + U(r.x3.y) + " l"),
                    n.push("s"),
                    n.push("Q"),
                    (e.stream = n.join("\n")),
                    e
                );
            },
            OffPushDown: function (t) {
                var e = V(t);
                e.scope = t.scope;
                var r = [];
                return (
                    r.push("0.749023 g"),
                    r.push(
                        "0 0 " +
                            U(At.internal.getWidth(t)) +
                            " " +
                            U(At.internal.getHeight(t)) +
                            " re",
                    ),
                    r.push("f"),
                    (e.stream = r.join("\n")),
                    e
                );
            },
        },
    },
    createDefaultAppearanceStream: function (t) {
        var e = t.scope.internal.getFont(t.fontName, t.fontStyle).id,
            r = t.scope.__private__.encodeColorString(t.color);
        return "/" + e + " " + t.fontSize + " Tf " + r;
    },
};
(At.internal = {
    Bezier_C: 0.551915024494,
    calculateCross: function (t) {
        var e = At.internal.getWidth(t),
            r = At.internal.getHeight(t),
            n = Math.min(e, r);
        return {
            x1: {
                x: (e - n) / 2,
                y: (r - n) / 2 + n,
            },
            x2: {
                x: (e - n) / 2 + n,
                y: (r - n) / 2,
            },
            x3: {
                x: (e - n) / 2,
                y: (r - n) / 2,
            },
            x4: {
                x: (e - n) / 2 + n,
                y: (r - n) / 2 + n,
            },
        };
    },
}),
    (At.internal.getWidth = function (e) {
        var r = 0;
        return "object" === _typeof(e) && (r = W(e.Rect[2])), r;
    }),
    (At.internal.getHeight = function (e) {
        var r = 0;
        return "object" === _typeof(e) && (r = W(e.Rect[3])), r;
    });
var xt = (q.addField = function (t) {
    if ((at(this, t), !(t instanceof lt)))
        throw new Error("Invalid argument passed to jsPDF.addField.");
    var e;
    return (
        (e = t).scope.internal.acroformPlugin.printedOut &&
            ((e.scope.internal.acroformPlugin.printedOut = !1),
            (e.scope.internal.acroformPlugin.acroFormDictionaryRoot = null)),
        e.scope.internal.acroformPlugin.acroFormDictionaryRoot.Fields.push(e),
        (t.page = t.scope.internal.getCurrentPageInfo().pageNumber),
        this
    );
});
(q.AcroFormChoiceField = ft),
    (q.AcroFormListBox = dt),
    (q.AcroFormComboBox = pt),
    (q.AcroFormEditBox = gt),
    (q.AcroFormButton = mt),
    (q.AcroFormPushButton = vt),
    (q.AcroFormRadioButton = bt),
    (q.AcroFormCheckBox = wt),
    (q.AcroFormTextField = Nt),
    (q.AcroFormPasswordField = Lt),
    (q.AcroFormAppearance = At),
    (q.AcroForm = {
        ChoiceField: ft,
        ListBox: dt,
        ComboBox: pt,
        EditBox: gt,
        Button: mt,
        PushButton: vt,
        RadioButton: bt,
        CheckBox: wt,
        TextField: Nt,
        PasswordField: Lt,
        Appearance: At,
    }),
    (E.AcroForm = {
        ChoiceField: ft,
        ListBox: dt,
        ComboBox: pt,
        EditBox: gt,
        Button: mt,
        PushButton: vt,
        RadioButton: bt,
        CheckBox: wt,
        TextField: Nt,
        PasswordField: Lt,
        Appearance: At,
    });
function _t(t) {
    return t.reduce(function (t, e, r) {
        return (t[e] = r), t;
    }, {});
}
!(function (e) {
    e.__addimage__ = {};
    var r = "UNKNOWN",
        n = {
            PNG: [[137, 80, 78, 71]],
            TIFF: [
                [77, 77, 0, 42],
                [73, 73, 42, 0],
            ],
            JPEG: [
                [255, 216, 255, 224, void 0, void 0, 74, 70, 73, 70, 0],
                [255, 216, 255, 225, void 0, void 0, 69, 120, 105, 102, 0, 0],
                [255, 216, 255, 219],
                [255, 216, 255, 238],
            ],
            JPEG2000: [[0, 0, 0, 12, 106, 80, 32, 32]],
            GIF87a: [[71, 73, 70, 56, 55, 97]],
            GIF89a: [[71, 73, 70, 56, 57, 97]],
            WEBP: [
                [
                    82,
                    73,
                    70,
                    70,
                    void 0,
                    void 0,
                    void 0,
                    void 0,
                    87,
                    69,
                    66,
                    80,
                ],
            ],
            BMP: [
                [66, 77],
                [66, 65],
                [67, 73],
                [67, 80],
                [73, 67],
                [80, 84],
            ],
        },
        i = (e.__addimage__.getImageFileTypeByImageData = function (t, e) {
            var i,
                a,
                o,
                s,
                c,
                u = r;
            if (
                "RGBA" === (e = e || r) ||
                (void 0 !== t.data &&
                    t.data instanceof Uint8ClampedArray &&
                    "height" in t &&
                    "width" in t)
            )
                return "RGBA";
            if (x(t))
                for (c in n)
                    for (o = n[c], i = 0; i < o.length; i += 1) {
                        for (s = !0, a = 0; a < o[i].length; a += 1)
                            if (void 0 !== o[i][a] && o[i][a] !== t[a]) {
                                s = !1;
                                break;
                            }
                        if (!0 === s) {
                            u = c;
                            break;
                        }
                    }
            else
                for (c in n)
                    for (o = n[c], i = 0; i < o.length; i += 1) {
                        for (s = !0, a = 0; a < o[i].length; a += 1)
                            if (
                                void 0 !== o[i][a] &&
                                o[i][a] !== t.charCodeAt(a)
                            ) {
                                s = !1;
                                break;
                            }
                        if (!0 === s) {
                            u = c;
                            break;
                        }
                    }
            return u === r && e !== r && (u = e), u;
        }),
        a = function t(e) {
            for (
                var r = this.internal.write,
                    n = this.internal.putStream,
                    i = (0, this.internal.getFilters)();
                -1 !== i.indexOf("FlateEncode");

            )
                i.splice(i.indexOf("FlateEncode"), 1);
            e.objectId = this.internal.newObject();
            var a = [];
            if (
                (a.push({
                    key: "Type",
                    value: "/XObject",
                }),
                a.push({
                    key: "Subtype",
                    value: "/Image",
                }),
                a.push({
                    key: "Width",
                    value: e.width,
                }),
                a.push({
                    key: "Height",
                    value: e.height,
                }),
                e.colorSpace === b.INDEXED
                    ? a.push({
                          key: "ColorSpace",
                          value:
                              "[/Indexed /DeviceRGB " +
                              (e.palette.length / 3 - 1) +
                              " " +
                              ("sMask" in e && void 0 !== e.sMask
                                  ? e.objectId + 2
                                  : e.objectId + 1) +
                              " 0 R]",
                      })
                    : (a.push({
                          key: "ColorSpace",
                          value: "/" + e.colorSpace,
                      }),
                      e.colorSpace === b.DEVICE_CMYK &&
                          a.push({
                              key: "Decode",
                              value: "[1 0 1 0 1 0 1 0]",
                          })),
                a.push({
                    key: "BitsPerComponent",
                    value: e.bitsPerComponent,
                }),
                "decodeParameters" in e &&
                    void 0 !== e.decodeParameters &&
                    a.push({
                        key: "DecodeParms",
                        value: "<<" + e.decodeParameters + ">>",
                    }),
                "transparency" in e && Array.isArray(e.transparency))
            ) {
                for (var o = "", s = 0, c = e.transparency.length; s < c; s++)
                    o += e.transparency[s] + " " + e.transparency[s] + " ";
                a.push({
                    key: "Mask",
                    value: "[" + o + "]",
                });
            }
            void 0 !== e.sMask &&
                a.push({
                    key: "SMask",
                    value: e.objectId + 1 + " 0 R",
                });
            var u = void 0 !== e.filter ? ["/" + e.filter] : void 0;
            if (
                (n({
                    data: e.data,
                    additionalKeyValues: a,
                    alreadyAppliedFilters: u,
                    objectId: e.objectId,
                }),
                r("endobj"),
                "sMask" in e && void 0 !== e.sMask)
            ) {
                var h =
                        "/Predictor " +
                        e.predictor +
                        " /Colors 1 /BitsPerComponent " +
                        e.bitsPerComponent +
                        " /Columns " +
                        e.width,
                    l = {
                        width: e.width,
                        height: e.height,
                        colorSpace: "DeviceGray",
                        bitsPerComponent: e.bitsPerComponent,
                        decodeParameters: h,
                        data: e.sMask,
                    };
                "filter" in e && (l.filter = e.filter), t.call(this, l);
            }
            if (e.colorSpace === b.INDEXED) {
                var f = this.internal.newObject();
                n({
                    data: _(new Uint8Array(e.palette)),
                    objectId: f,
                }),
                    r("endobj");
            }
        },
        o = function () {
            var t = this.internal.collections.addImage_images;
            for (var e in t) a.call(this, t[e]);
        },
        s = function () {
            var t,
                e = this.internal.collections.addImage_images,
                r = this.internal.write;
            for (var n in e) r("/I" + (t = e[n]).index, t.objectId, "0", "R");
        },
        c = function () {
            this.internal.collections.addImage_images ||
                ((this.internal.collections.addImage_images = {}),
                this.internal.events.subscribe("putResources", o),
                this.internal.events.subscribe("putXobjectDict", s));
        },
        h = function () {
            var t = this.internal.collections.addImage_images;
            return c.call(this), t;
        },
        l = function () {
            return Object.keys(this.internal.collections.addImage_images)
                .length;
        },
        f = function (t) {
            return "function" == typeof e["process" + t.toUpperCase()];
        },
        d = function (e) {
            return "object" === _typeof(e) && 1 === e.nodeType;
        },
        p = function (t, r) {
            if ("IMG" === t.nodeName && t.hasAttribute("src")) {
                var n = "" + t.getAttribute("src");
                if (0 === n.indexOf("data:image/"))
                    return u(unescape(n).split("base64,").pop());
                var i = e.loadFile(n, !0);
                if (void 0 !== i) return i;
            }
            if ("CANVAS" === t.nodeName) {
                if (0 === t.width || 0 === t.height)
                    throw new Error(
                        "Given canvas must have data. Canvas width: " +
                            t.width +
                            ", height: " +
                            t.height,
                    );
                var a;
                switch (r) {
                    case "PNG":
                        a = "image/png";
                        break;
                    case "WEBP":
                        a = "image/webp";
                        break;
                    case "JPEG":
                    case "JPG":
                    default:
                        a = "image/jpeg";
                }
                return u(t.toDataURL(a, 1).split("base64,").pop());
            }
        },
        g = function (t) {
            var e = this.internal.collections.addImage_images;
            if (e) for (var r in e) if (t === e[r].alias) return e[r];
        },
        m = function (t, e, r) {
            return (
                t || e || ((t = -96), (e = -96)),
                t < 0 &&
                    (t = (-1 * r.width * 72) / t / this.internal.scaleFactor),
                e < 0 &&
                    (e = (-1 * r.height * 72) / e / this.internal.scaleFactor),
                0 === t && (t = (e * r.width) / r.height),
                0 === e && (e = (t * r.height) / r.width),
                [t, e]
            );
        },
        v = function (t, e, r, n, i, a) {
            var o = m.call(this, r, n, i),
                s = this.internal.getCoordinateString,
                c = this.internal.getVerticalCoordinateString,
                u = h.call(this);
            if (((r = o[0]), (n = o[1]), (u[i.index] = i), a)) {
                a *= Math.PI / 180;
                var l = Math.cos(a),
                    f = Math.sin(a),
                    d = function (t) {
                        return t.toFixed(4);
                    },
                    p = [d(l), d(f), d(-1 * f), d(l), 0, 0, "cm"];
            }
            this.internal.write("q"),
                a
                    ? (this.internal.write(
                          [1, "0", "0", 1, s(t), c(e + n), "cm"].join(" "),
                      ),
                      this.internal.write(p.join(" ")),
                      this.internal.write(
                          [s(r), "0", "0", s(n), "0", "0", "cm"].join(" "),
                      ))
                    : this.internal.write(
                          [s(r), "0", "0", s(n), s(t), c(e + n), "cm"].join(
                              " ",
                          ),
                      ),
                this.isAdvancedAPI() &&
                    this.internal.write([1, 0, 0, -1, 0, 0, "cm"].join(" ")),
                this.internal.write("/I" + i.index + " Do"),
                this.internal.write("Q");
        },
        b = (e.color_spaces = {
            DEVICE_RGB: "DeviceRGB",
            DEVICE_GRAY: "DeviceGray",
            DEVICE_CMYK: "DeviceCMYK",
            CAL_GREY: "CalGray",
            CAL_RGB: "CalRGB",
            LAB: "Lab",
            ICC_BASED: "ICCBased",
            INDEXED: "Indexed",
            PATTERN: "Pattern",
            SEPARATION: "Separation",
            DEVICE_N: "DeviceN",
        });
    e.decode = {
        DCT_DECODE: "DCTDecode",
        FLATE_DECODE: "FlateDecode",
        LZW_DECODE: "LZWDecode",
        JPX_DECODE: "JPXDecode",
        JBIG2_DECODE: "JBIG2Decode",
        ASCII85_DECODE: "ASCII85Decode",
        ASCII_HEX_DECODE: "ASCIIHexDecode",
        RUN_LENGTH_DECODE: "RunLengthDecode",
        CCITT_FAX_DECODE: "CCITTFaxDecode",
    };
    var y = (e.image_compression = {
            NONE: "NONE",
            FAST: "FAST",
            MEDIUM: "MEDIUM",
            SLOW: "SLOW",
        }),
        w = (e.__addimage__.sHashCode = function (t) {
            var e,
                r,
                n = 0;
            if ("string" == typeof t)
                for (r = t.length, e = 0; e < r; e++)
                    (n = (n << 5) - n + t.charCodeAt(e)), (n |= 0);
            else if (x(t))
                for (r = t.byteLength / 2, e = 0; e < r; e++)
                    (n = (n << 5) - n + t[e]), (n |= 0);
            return n;
        }),
        N = (e.__addimage__.validateStringAsBase64 = function (t) {
            (t = t || "").toString().trim();
            var e = !0;
            return (
                0 === t.length && (e = !1),
                t.length % 4 != 0 && (e = !1),
                !1 === /^[A-Za-z0-9+/]+$/.test(t.substr(0, t.length - 2)) &&
                    (e = !1),
                !1 ===
                    /^[A-Za-z0-9/][A-Za-z0-9+/]|[A-Za-z0-9+/]=|==$/.test(
                        t.substr(-2),
                    ) && (e = !1),
                e
            );
        }),
        L = (e.__addimage__.extractImageFromDataUrl = function (t) {
            var e = (t = t || "").split("base64,"),
                r = null;
            if (2 === e.length) {
                var n =
                    /^data:(\w*\/\w*);*(charset=(?!charset=)[\w=-]*)*;*$/.exec(
                        e[0],
                    );
                Array.isArray(n) &&
                    (r = {
                        mimeType: n[1],
                        charset: n[2],
                        data: e[1],
                    });
            }
            return r;
        }),
        A = (e.__addimage__.supportsArrayBuffer = function () {
            return (
                "undefined" != typeof ArrayBuffer &&
                "undefined" != typeof Uint8Array
            );
        });
    e.__addimage__.isArrayBuffer = function (t) {
        return A() && t instanceof ArrayBuffer;
    };
    var x = (e.__addimage__.isArrayBufferView = function (t) {
            return (
                A() &&
                "undefined" != typeof Uint32Array &&
                (t instanceof Int8Array ||
                    t instanceof Uint8Array ||
                    ("undefined" != typeof Uint8ClampedArray &&
                        t instanceof Uint8ClampedArray) ||
                    t instanceof Int16Array ||
                    t instanceof Uint16Array ||
                    t instanceof Int32Array ||
                    t instanceof Uint32Array ||
                    t instanceof Float32Array ||
                    t instanceof Float64Array)
            );
        }),
        S = (e.__addimage__.binaryStringToUint8Array = function (t) {
            for (var e = t.length, r = new Uint8Array(e), n = 0; n < e; n++)
                r[n] = t.charCodeAt(n);
            return r;
        }),
        _ = (e.__addimage__.arrayBufferToBinaryString = function (t) {
            for (
                var e = "", r = x(t) ? t : new Uint8Array(t), n = 0;
                n < r.length;
                n += 8192
            )
                e += String.fromCharCode.apply(null, r.subarray(n, n + 8192));
            return e;
        });
    e.addImage = function () {
        var e, n, i, a, o, s, u, h, l;
        if (
            ("number" == typeof arguments[1]
                ? ((n = r),
                  (i = arguments[1]),
                  (a = arguments[2]),
                  (o = arguments[3]),
                  (s = arguments[4]),
                  (u = arguments[5]),
                  (h = arguments[6]),
                  (l = arguments[7]))
                : ((n = arguments[1]),
                  (i = arguments[2]),
                  (a = arguments[3]),
                  (o = arguments[4]),
                  (s = arguments[5]),
                  (u = arguments[6]),
                  (h = arguments[7]),
                  (l = arguments[8])),
            "object" === _typeof((e = arguments[0])) &&
                !d(e) &&
                "imageData" in e)
        ) {
            var f = e;
            (e = f.imageData),
                (n = f.format || n || r),
                (i = f.x || i || 0),
                (a = f.y || a || 0),
                (o = f.w || f.width || o),
                (s = f.h || f.height || s),
                (u = f.alias || u),
                (h = f.compression || h),
                (l = f.rotation || f.angle || l);
        }
        var p = this.internal.getFilters();
        if (
            (void 0 === h && -1 !== p.indexOf("FlateEncode") && (h = "SLOW"),
            isNaN(i) || isNaN(a))
        )
            throw new Error("Invalid coordinates passed to jsPDF.addImage");
        c.call(this);
        var g = P.call(this, e, n, u, h);
        return v.call(this, i, a, o, s, g, l), this;
    };
    var P = function (t, n, a, o) {
            var s, c, u;
            if ("string" == typeof t && i(t) === r) {
                t = unescape(t);
                var h = k(t, !1);
                ("" !== h || void 0 !== (h = e.loadFile(t, !0))) && (t = h);
            }
            if ((d(t) && (t = p(t, n)), (n = i(t, n)), !f(n)))
                throw new Error(
                    "addImage does not support files of type '" +
                        n +
                        "', please ensure that a plugin for '" +
                        n +
                        "' support is added.",
                );
            if (
                ((null == (u = a) || 0 === u.length) &&
                    (a = (function (t) {
                        return "string" == typeof t || x(t)
                            ? w(t)
                            : x(t.data)
                              ? w(t.data)
                              : null;
                    })(t)),
                (s = g.call(this, a)) ||
                    (A() &&
                        (t instanceof Uint8Array ||
                            "RGBA" === n ||
                            ((c = t), (t = S(t)))),
                    (s = this["process" + n.toUpperCase()](
                        t,
                        l.call(this),
                        a,
                        (function (t) {
                            return (
                                t &&
                                    "string" == typeof t &&
                                    (t = t.toUpperCase()),
                                t in e.image_compression ? t : y.NONE
                            );
                        })(o),
                        c,
                    ))),
                !s)
            )
                throw new Error(
                    "An unknown error occurred whilst processing the image.",
                );
            return s;
        },
        k = (e.__addimage__.convertBase64ToBinaryString = function (t, e) {
            var r;
            e = "boolean" != typeof e || e;
            var n,
                i = "";
            if ("string" == typeof t) {
                n = null !== (r = L(t)) ? r.data : t;
                try {
                    i = u(n);
                } catch (t) {
                    if (e)
                        throw N(n)
                            ? new Error(
                                  "atob-Error in jsPDF.convertBase64ToBinaryString " +
                                      t.message,
                              )
                            : new Error(
                                  "Supplied Data is not a valid base64-String jsPDF.convertBase64ToBinaryString ",
                              );
                }
            }
            return i;
        });
    e.getImageProperties = function (t) {
        var n,
            a,
            o = "";
        if (
            (d(t) && (t = p(t)),
            "string" == typeof t &&
                i(t) === r &&
                ("" === (o = k(t, !1)) && (o = e.loadFile(t) || ""), (t = o)),
            (a = i(t)),
            !f(a))
        )
            throw new Error(
                "addImage does not support files of type '" +
                    a +
                    "', please ensure that a plugin for '" +
                    a +
                    "' support is added.",
            );
        if (
            (!A() || t instanceof Uint8Array || (t = S(t)),
            !(n = this["process" + a.toUpperCase()](t)))
        )
            throw new Error(
                "An unknown error occurred whilst processing the image",
            );
        return (n.fileType = a), n;
    };
})(E.API),
    /**
     * @license
     * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
     *
     * Licensed under the MIT License.
     * http://opensource.org/licenses/mit-license
     */
    (function (t) {
        var e = function (t) {
            if (void 0 !== t && "" != t) return !0;
        };
        E.API.events.push([
            "addPage",
            function (t) {
                this.internal.getPageInfo(
                    t.pageNumber,
                ).pageContext.annotations = [];
            },
        ]),
            t.events.push([
                "putPage",
                function (t) {
                    for (
                        var r,
                            n,
                            i,
                            a = this.internal.getCoordinateString,
                            o = this.internal.getVerticalCoordinateString,
                            s = this.internal.getPageInfoByObjId(t.objId),
                            c = t.pageContext.annotations,
                            u = !1,
                            h = 0;
                        h < c.length && !u;
                        h++
                    )
                        switch ((r = c[h]).type) {
                            case "link":
                                (e(r.options.url) || e(r.options.pageNumber)) &&
                                    (u = !0);
                                break;
                            case "reference":
                            case "text":
                            case "freetext":
                                u = !0;
                        }
                    if (0 != u) {
                        this.internal.write("/Annots [");
                        for (var l = 0; l < c.length; l++) {
                            r = c[l];
                            var f = this.internal.pdfEscape,
                                d = this.internal.getEncryptor(t.objId);
                            switch (r.type) {
                                case "reference":
                                    this.internal.write(
                                        " " + r.object.objId + " 0 R ",
                                    );
                                    break;
                                case "text":
                                    var p = this.internal.newAdditionalObject(),
                                        g = this.internal.newAdditionalObject(),
                                        m = this.internal.getEncryptor(p.objId),
                                        v = r.title || "Note";
                                    (i =
                                        "<</Type /Annot /Subtype /Text " +
                                        (n =
                                            "/Rect [" +
                                            a(r.bounds.x) +
                                            " " +
                                            o(r.bounds.y + r.bounds.h) +
                                            " " +
                                            a(r.bounds.x + r.bounds.w) +
                                            " " +
                                            o(r.bounds.y) +
                                            "] ") +
                                        "/Contents (" +
                                        f(m(r.contents)) +
                                        ")"),
                                        (i += " /Popup " + g.objId + " 0 R"),
                                        (i += " /P " + s.objId + " 0 R"),
                                        (i += " /T (" + f(m(v)) + ") >>"),
                                        (p.content = i);
                                    var b = p.objId + " 0 R";
                                    (i =
                                        "<</Type /Annot /Subtype /Popup " +
                                        (n =
                                            "/Rect [" +
                                            a(r.bounds.x + 30) +
                                            " " +
                                            o(r.bounds.y + r.bounds.h) +
                                            " " +
                                            a(r.bounds.x + r.bounds.w + 30) +
                                            " " +
                                            o(r.bounds.y) +
                                            "] ") +
                                        " /Parent " +
                                        b),
                                        r.open && (i += " /Open true"),
                                        (i += " >>"),
                                        (g.content = i),
                                        this.internal.write(
                                            p.objId,
                                            "0 R",
                                            g.objId,
                                            "0 R",
                                        );
                                    break;
                                case "freetext":
                                    n =
                                        "/Rect [" +
                                        a(r.bounds.x) +
                                        " " +
                                        o(r.bounds.y) +
                                        " " +
                                        a(r.bounds.x + r.bounds.w) +
                                        " " +
                                        o(r.bounds.y + r.bounds.h) +
                                        "] ";
                                    var y = r.color || "#000000";
                                    (i =
                                        "<</Type /Annot /Subtype /FreeText " +
                                        n +
                                        "/Contents (" +
                                        f(d(r.contents)) +
                                        ")"),
                                        (i +=
                                            " /DS(font: Helvetica,sans-serif 12.0pt; text-align:left; color:#" +
                                            y +
                                            ")"),
                                        (i += " /Border [0 0 0]"),
                                        (i += " >>"),
                                        this.internal.write(i);
                                    break;
                                case "link":
                                    if (r.options.name) {
                                        var w =
                                            this.annotations._nameMap[
                                                r.options.name
                                            ];
                                        (r.options.pageNumber = w.page),
                                            (r.options.top = w.y);
                                    } else r.options.top || (r.options.top = 0);
                                    if (
                                        ((n =
                                            "/Rect [" +
                                            r.finalBounds.x +
                                            " " +
                                            r.finalBounds.y +
                                            " " +
                                            r.finalBounds.w +
                                            " " +
                                            r.finalBounds.h +
                                            "] "),
                                        (i = ""),
                                        r.options.url)
                                    )
                                        i =
                                            "<</Type /Annot /Subtype /Link " +
                                            n +
                                            "/Border [0 0 0] /A <</S /URI /URI (" +
                                            f(d(r.options.url)) +
                                            ") >>";
                                    else if (r.options.pageNumber) {
                                        switch (
                                            ((i =
                                                "<</Type /Annot /Subtype /Link " +
                                                n +
                                                "/Border [0 0 0] /Dest [" +
                                                this.internal.getPageInfo(
                                                    r.options.pageNumber,
                                                ).objId +
                                                " 0 R"),
                                            (r.options.magFactor =
                                                r.options.magFactor || "XYZ"),
                                            r.options.magFactor)
                                        ) {
                                            case "Fit":
                                                i += " /Fit]";
                                                break;
                                            case "FitH":
                                                i +=
                                                    " /FitH " +
                                                    r.options.top +
                                                    "]";
                                                break;
                                            case "FitV":
                                                (r.options.left =
                                                    r.options.left || 0),
                                                    (i +=
                                                        " /FitV " +
                                                        r.options.left +
                                                        "]");
                                                break;
                                            case "XYZ":
                                            default:
                                                var N = o(r.options.top);
                                                (r.options.left =
                                                    r.options.left || 0),
                                                    void 0 === r.options.zoom &&
                                                        (r.options.zoom = 0),
                                                    (i +=
                                                        " /XYZ " +
                                                        r.options.left +
                                                        " " +
                                                        N +
                                                        " " +
                                                        r.options.zoom +
                                                        "]");
                                        }
                                    }
                                    "" != i &&
                                        ((i += " >>"), this.internal.write(i));
                            }
                        }
                        this.internal.write("]");
                    }
                },
            ]),
            (t.createAnnotation = function (t) {
                var e = this.internal.getCurrentPageInfo();
                switch (t.type) {
                    case "link":
                        this.link(
                            t.bounds.x,
                            t.bounds.y,
                            t.bounds.w,
                            t.bounds.h,
                            t,
                        );
                        break;
                    case "text":
                    case "freetext":
                        e.pageContext.annotations.push(t);
                }
            }),
            (t.link = function (t, e, r, n, i) {
                var a = this.internal.getCurrentPageInfo(),
                    o = this.internal.getCoordinateString,
                    s = this.internal.getVerticalCoordinateString;
                a.pageContext.annotations.push({
                    finalBounds: {
                        x: o(t),
                        y: s(e),
                        w: o(t + r),
                        h: s(e + n),
                    },
                    options: i,
                    type: "link",
                });
            }),
            (t.textWithLink = function (t, e, r, n) {
                var i,
                    a,
                    o = this.getTextWidth(t),
                    s =
                        this.internal.getLineHeight() /
                        this.internal.scaleFactor;
                if (void 0 !== n.maxWidth) {
                    a = n.maxWidth;
                    var c = this.splitTextToSize(t, a).length;
                    i = Math.ceil(s * c);
                } else (a = o), (i = s);
                return (
                    this.text(t, e, r, n),
                    (r += 0.2 * s),
                    "center" === n.align && (e -= o / 2),
                    "right" === n.align && (e -= o),
                    this.link(e, r - s, a, i, n),
                    o
                );
            }),
            (t.getTextWidth = function (t) {
                var e = this.internal.getFontSize();
                return (
                    (this.getStringUnitWidth(t) * e) / this.internal.scaleFactor
                );
            });
    })(E.API),
    /**
     * @license
     * Copyright (c) 2017 Aras Abbasi
     *
     * Licensed under the MIT License.
     * http://opensource.org/licenses/mit-license
     */
    (function (t) {
        var e = {
                1569: [65152],
                1570: [65153, 65154],
                1571: [65155, 65156],
                1572: [65157, 65158],
                1573: [65159, 65160],
                1574: [65161, 65162, 65163, 65164],
                1575: [65165, 65166],
                1576: [65167, 65168, 65169, 65170],
                1577: [65171, 65172],
                1578: [65173, 65174, 65175, 65176],
                1579: [65177, 65178, 65179, 65180],
                1580: [65181, 65182, 65183, 65184],
                1581: [65185, 65186, 65187, 65188],
                1582: [65189, 65190, 65191, 65192],
                1583: [65193, 65194],
                1584: [65195, 65196],
                1585: [65197, 65198],
                1586: [65199, 65200],
                1587: [65201, 65202, 65203, 65204],
                1588: [65205, 65206, 65207, 65208],
                1589: [65209, 65210, 65211, 65212],
                1590: [65213, 65214, 65215, 65216],
                1591: [65217, 65218, 65219, 65220],
                1592: [65221, 65222, 65223, 65224],
                1593: [65225, 65226, 65227, 65228],
                1594: [65229, 65230, 65231, 65232],
                1601: [65233, 65234, 65235, 65236],
                1602: [65237, 65238, 65239, 65240],
                1603: [65241, 65242, 65243, 65244],
                1604: [65245, 65246, 65247, 65248],
                1605: [65249, 65250, 65251, 65252],
                1606: [65253, 65254, 65255, 65256],
                1607: [65257, 65258, 65259, 65260],
                1608: [65261, 65262],
                1609: [65263, 65264, 64488, 64489],
                1610: [65265, 65266, 65267, 65268],
                1649: [64336, 64337],
                1655: [64477],
                1657: [64358, 64359, 64360, 64361],
                1658: [64350, 64351, 64352, 64353],
                1659: [64338, 64339, 64340, 64341],
                1662: [64342, 64343, 64344, 64345],
                1663: [64354, 64355, 64356, 64357],
                1664: [64346, 64347, 64348, 64349],
                1667: [64374, 64375, 64376, 64377],
                1668: [64370, 64371, 64372, 64373],
                1670: [64378, 64379, 64380, 64381],
                1671: [64382, 64383, 64384, 64385],
                1672: [64392, 64393],
                1676: [64388, 64389],
                1677: [64386, 64387],
                1678: [64390, 64391],
                1681: [64396, 64397],
                1688: [64394, 64395],
                1700: [64362, 64363, 64364, 64365],
                1702: [64366, 64367, 64368, 64369],
                1705: [64398, 64399, 64400, 64401],
                1709: [64467, 64468, 64469, 64470],
                1711: [64402, 64403, 64404, 64405],
                1713: [64410, 64411, 64412, 64413],
                1715: [64406, 64407, 64408, 64409],
                1722: [64414, 64415],
                1723: [64416, 64417, 64418, 64419],
                1726: [64426, 64427, 64428, 64429],
                1728: [64420, 64421],
                1729: [64422, 64423, 64424, 64425],
                1733: [64480, 64481],
                1734: [64473, 64474],
                1735: [64471, 64472],
                1736: [64475, 64476],
                1737: [64482, 64483],
                1739: [64478, 64479],
                1740: [64508, 64509, 64510, 64511],
                1744: [64484, 64485, 64486, 64487],
                1746: [64430, 64431],
                1747: [64432, 64433],
            },
            r = {
                65247: {
                    65154: 65269,
                    65156: 65271,
                    65160: 65273,
                    65166: 65275,
                },
                65248: {
                    65154: 65270,
                    65156: 65272,
                    65160: 65274,
                    65166: 65276,
                },
                65165: {
                    65247: {
                        65248: {
                            65258: 65010,
                        },
                    },
                },
                1617: {
                    1612: 64606,
                    1613: 64607,
                    1614: 64608,
                    1615: 64609,
                    1616: 64610,
                },
            },
            n = {
                1612: 64606,
                1613: 64607,
                1614: 64608,
                1615: 64609,
                1616: 64610,
            },
            i = [1570, 1571, 1573, 1575];
        t.__arabicParser__ = {};
        var a = (t.__arabicParser__.isInArabicSubstitutionA = function (t) {
                return void 0 !== e[t.charCodeAt(0)];
            }),
            o = (t.__arabicParser__.isArabicLetter = function (t) {
                return (
                    "string" == typeof t &&
                    /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]+$/.test(
                        t,
                    )
                );
            }),
            s = (t.__arabicParser__.isArabicEndLetter = function (t) {
                return o(t) && a(t) && e[t.charCodeAt(0)].length <= 2;
            }),
            c = (t.__arabicParser__.isArabicAlfLetter = function (t) {
                return o(t) && i.indexOf(t.charCodeAt(0)) >= 0;
            });
        t.__arabicParser__.arabicLetterHasIsolatedForm = function (t) {
            return o(t) && a(t) && e[t.charCodeAt(0)].length >= 1;
        };
        var u = (t.__arabicParser__.arabicLetterHasFinalForm = function (t) {
            return o(t) && a(t) && e[t.charCodeAt(0)].length >= 2;
        });
        t.__arabicParser__.arabicLetterHasInitialForm = function (t) {
            return o(t) && a(t) && e[t.charCodeAt(0)].length >= 3;
        };
        var h = (t.__arabicParser__.arabicLetterHasMedialForm = function (t) {
                return o(t) && a(t) && 4 == e[t.charCodeAt(0)].length;
            }),
            l = (t.__arabicParser__.resolveLigatures = function (t) {
                var e = 0,
                    n = r,
                    i = "",
                    a = 0;
                for (e = 0; e < t.length; e += 1)
                    void 0 !== n[t.charCodeAt(e)]
                        ? (a++,
                          "number" == typeof (n = n[t.charCodeAt(e)]) &&
                              ((i += String.fromCharCode(n)), (n = r), (a = 0)),
                          e === t.length - 1 &&
                              ((n = r),
                              (i += t.charAt(e - (a - 1))),
                              (e -= a - 1),
                              (a = 0)))
                        : ((n = r), (i += t.charAt(e - a)), (e -= a), (a = 0));
                return i;
            });
        t.__arabicParser__.isArabicDiacritic = function (t) {
            return void 0 !== t && void 0 !== n[t.charCodeAt(0)];
        };
        var f = (t.__arabicParser__.getCorrectForm = function (t, e, r) {
                return o(t)
                    ? !1 === a(t)
                        ? -1
                        : !u(t) ||
                            (!o(e) && !o(r)) ||
                            (!o(r) && s(e)) ||
                            (s(t) && !o(e)) ||
                            (s(t) && c(e)) ||
                            (s(t) && s(e))
                          ? 0
                          : h(t) && o(e) && !s(e) && o(r) && u(r)
                            ? 3
                            : s(t) || !o(r)
                              ? 1
                              : 2
                    : -1;
            }),
            d = function (t) {
                var r = 0,
                    n = 0,
                    i = 0,
                    a = "",
                    s = "",
                    c = "",
                    u = (t = t || "").split("\\s+"),
                    h = [];
                for (r = 0; r < u.length; r += 1) {
                    for (h.push(""), n = 0; n < u[r].length; n += 1)
                        (a = u[r][n]),
                            (s = u[r][n - 1]),
                            (c = u[r][n + 1]),
                            o(a)
                                ? ((i = f(a, s, c)),
                                  (h[r] +=
                                      -1 !== i
                                          ? String.fromCharCode(
                                                e[a.charCodeAt(0)][i],
                                            )
                                          : a))
                                : (h[r] += a);
                    h[r] = l(h[r]);
                }
                return h.join(" ");
            },
            p =
                (t.__arabicParser__.processArabic =
                t.processArabic =
                    function () {
                        var t,
                            e =
                                "string" == typeof arguments[0]
                                    ? arguments[0]
                                    : arguments[0].text,
                            r = [];
                        if (Array.isArray(e)) {
                            var n = 0;
                            for (r = [], n = 0; n < e.length; n += 1)
                                Array.isArray(e[n])
                                    ? r.push([d(e[n][0]), e[n][1], e[n][2]])
                                    : r.push([d(e[n])]);
                            t = r;
                        } else t = d(e);
                        return "string" == typeof arguments[0]
                            ? t
                            : ((arguments[0].text = t), arguments[0]);
                    });
        t.events.push(["preProcessText", p]);
    })(E.API),
    (E.API.autoPrint = function (t) {
        var e;
        switch (
            (((t = t || {}).variant = t.variant || "non-conform"), t.variant)
        ) {
            case "javascript":
                this.addJS("print({});");
                break;
            case "non-conform":
            default:
                this.internal.events.subscribe("postPutResources", function () {
                    (e = this.internal.newObject()),
                        this.internal.out("<<"),
                        this.internal.out("/S /Named"),
                        this.internal.out("/Type /Action"),
                        this.internal.out("/N /Print"),
                        this.internal.out(">>"),
                        this.internal.out("endobj");
                }),
                    this.internal.events.subscribe("putCatalog", function () {
                        this.internal.out("/OpenAction " + e + " 0 R");
                    });
        }
        return this;
    }),
    /**
     * @license
     * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
     *
     * Licensed under the MIT License.
     * http://opensource.org/licenses/mit-license
     */
    (function (t) {
        var e = function () {
            var t = void 0;
            Object.defineProperty(this, "pdf", {
                get: function () {
                    return t;
                },
                set: function (e) {
                    t = e;
                },
            });
            var e = 150;
            Object.defineProperty(this, "width", {
                get: function () {
                    return e;
                },
                set: function (t) {
                    (e =
                        isNaN(t) || !1 === Number.isInteger(t) || t < 0
                            ? 150
                            : t),
                        this.getContext("2d").pageWrapXEnabled &&
                            (this.getContext("2d").pageWrapX = e + 1);
                },
            });
            var r = 300;
            Object.defineProperty(this, "height", {
                get: function () {
                    return r;
                },
                set: function (t) {
                    (r =
                        isNaN(t) || !1 === Number.isInteger(t) || t < 0
                            ? 300
                            : t),
                        this.getContext("2d").pageWrapYEnabled &&
                            (this.getContext("2d").pageWrapY = r + 1);
                },
            });
            var n = [];
            Object.defineProperty(this, "childNodes", {
                get: function () {
                    return n;
                },
                set: function (t) {
                    n = t;
                },
            });
            var i = {};
            Object.defineProperty(this, "style", {
                get: function () {
                    return i;
                },
                set: function (t) {
                    i = t;
                },
            }),
                Object.defineProperty(this, "parentNode", {});
        };
        (e.prototype.getContext = function (t, e) {
            var r;
            if ("2d" !== (t = t || "2d")) return null;
            for (r in e)
                this.pdf.context2d.hasOwnProperty(r) &&
                    (this.pdf.context2d[r] = e[r]);
            return (this.pdf.context2d._canvas = this), this.pdf.context2d;
        }),
            (e.prototype.toDataURL = function () {
                throw new Error("toDataURL is not implemented.");
            }),
            t.events.push([
                "initialized",
                function () {
                    (this.canvas = new e()), (this.canvas.pdf = this);
                },
            ]);
    })(E.API),
    (function (e) {
        var r = {
                left: 0,
                top: 0,
                bottom: 0,
                right: 0,
            },
            n = !1,
            i = function () {
                void 0 === this.internal.__cell__ &&
                    ((this.internal.__cell__ = {}),
                    (this.internal.__cell__.padding = 3),
                    (this.internal.__cell__.headerFunction = void 0),
                    (this.internal.__cell__.margins = Object.assign({}, r)),
                    (this.internal.__cell__.margins.width =
                        this.getPageWidth()),
                    a.call(this));
            },
            a = function () {
                (this.internal.__cell__.lastCell = new o()),
                    (this.internal.__cell__.pages = 1);
            },
            o = function () {
                var t = arguments[0];
                Object.defineProperty(this, "x", {
                    enumerable: !0,
                    get: function () {
                        return t;
                    },
                    set: function (e) {
                        t = e;
                    },
                });
                var e = arguments[1];
                Object.defineProperty(this, "y", {
                    enumerable: !0,
                    get: function () {
                        return e;
                    },
                    set: function (t) {
                        e = t;
                    },
                });
                var r = arguments[2];
                Object.defineProperty(this, "width", {
                    enumerable: !0,
                    get: function () {
                        return r;
                    },
                    set: function (t) {
                        r = t;
                    },
                });
                var n = arguments[3];
                Object.defineProperty(this, "height", {
                    enumerable: !0,
                    get: function () {
                        return n;
                    },
                    set: function (t) {
                        n = t;
                    },
                });
                var i = arguments[4];
                Object.defineProperty(this, "text", {
                    enumerable: !0,
                    get: function () {
                        return i;
                    },
                    set: function (t) {
                        i = t;
                    },
                });
                var a = arguments[5];
                Object.defineProperty(this, "lineNumber", {
                    enumerable: !0,
                    get: function () {
                        return a;
                    },
                    set: function (t) {
                        a = t;
                    },
                });
                var o = arguments[6];
                return (
                    Object.defineProperty(this, "align", {
                        enumerable: !0,
                        get: function () {
                            return o;
                        },
                        set: function (t) {
                            o = t;
                        },
                    }),
                    this
                );
            };
        (o.prototype.clone = function () {
            return new o(
                this.x,
                this.y,
                this.width,
                this.height,
                this.text,
                this.lineNumber,
                this.align,
            );
        }),
            (o.prototype.toArray = function () {
                return [
                    this.x,
                    this.y,
                    this.width,
                    this.height,
                    this.text,
                    this.lineNumber,
                    this.align,
                ];
            }),
            (e.setHeaderFunction = function (t) {
                return (
                    i.call(this),
                    (this.internal.__cell__.headerFunction =
                        "function" == typeof t ? t : void 0),
                    this
                );
            }),
            (e.getTextDimensions = function (t, e) {
                i.call(this);
                var r = (e = e || {}).fontSize || this.getFontSize(),
                    n = e.font || this.getFont(),
                    a = e.scaleFactor || this.internal.scaleFactor,
                    o = 0,
                    s = 0,
                    c = 0,
                    u = this;
                if (!Array.isArray(t) && "string" != typeof t) {
                    if ("number" != typeof t)
                        throw new Error(
                            "getTextDimensions expects text-parameter to be of type String or type Number or an Array of Strings.",
                        );
                    t = String(t);
                }
                var h = e.maxWidth;
                h > 0
                    ? "string" == typeof t
                        ? (t = this.splitTextToSize(t, h))
                        : "[object Array]" ===
                              Object.prototype.toString.call(t) &&
                          (t = t.reduce(function (t, e) {
                              return t.concat(u.splitTextToSize(e, h));
                          }, []))
                    : (t = Array.isArray(t) ? t : [t]);
                for (var l = 0; l < t.length; l++)
                    o <
                        (c =
                            this.getStringUnitWidth(t[l], {
                                font: n,
                            }) * r) && (o = c);
                return (
                    0 !== o && (s = t.length),
                    {
                        w: (o /= a),
                        h: Math.max(
                            (s * r * this.getLineHeightFactor() -
                                r * (this.getLineHeightFactor() - 1)) /
                                a,
                            0,
                        ),
                    }
                );
            }),
            (e.cellAddPage = function () {
                i.call(this), this.addPage();
                var t = this.internal.__cell__.margins || r;
                return (
                    (this.internal.__cell__.lastCell = new o(
                        t.left,
                        t.top,
                        void 0,
                        void 0,
                    )),
                    (this.internal.__cell__.pages += 1),
                    this
                );
            });
        var s = (e.cell = function () {
            var t;
            (t =
                arguments[0] instanceof o
                    ? arguments[0]
                    : new o(
                          arguments[0],
                          arguments[1],
                          arguments[2],
                          arguments[3],
                          arguments[4],
                          arguments[5],
                      )),
                i.call(this);
            var e = this.internal.__cell__.lastCell,
                a = this.internal.__cell__.padding,
                s = this.internal.__cell__.margins || r,
                c = this.internal.__cell__.tableHeaderRow,
                u = this.internal.__cell__.printHeaders;
            return (
                void 0 !== e.lineNumber &&
                    (e.lineNumber === t.lineNumber
                        ? ((t.x = (e.x || 0) + (e.width || 0)),
                          (t.y = e.y || 0))
                        : e.y + e.height + t.height + s.bottom >
                            this.getPageHeight()
                          ? (this.cellAddPage(),
                            (t.y = s.top),
                            u &&
                                c &&
                                (this.printHeaderRow(t.lineNumber, !0),
                                (t.y += c[0].height)))
                          : (t.y = e.y + e.height || t.y)),
                void 0 !== t.text[0] &&
                    (this.rect(
                        t.x,
                        t.y,
                        t.width,
                        t.height,
                        !0 === n ? "FD" : void 0,
                    ),
                    "right" === t.align
                        ? this.text(t.text, t.x + t.width - a, t.y + a, {
                              align: "right",
                              baseline: "top",
                          })
                        : "center" === t.align
                          ? this.text(t.text, t.x + t.width / 2, t.y + a, {
                                align: "center",
                                baseline: "top",
                                maxWidth: t.width - a - a,
                            })
                          : this.text(t.text, t.x + a, t.y + a, {
                                align: "left",
                                baseline: "top",
                                maxWidth: t.width - a - a,
                            })),
                (this.internal.__cell__.lastCell = t),
                this
            );
        });
        e.table = function (e, n, u, h, l) {
            if ((i.call(this), !u)) throw new Error("No data for PDF table.");
            var f,
                d,
                p,
                g,
                m = [],
                v = [],
                b = [],
                y = {},
                w = {},
                N = [],
                L = [],
                A = (l = l || {}).autoSize || !1,
                x = !1 !== l.printHeaders,
                S =
                    l.css && void 0 !== l.css["font-size"]
                        ? 16 * l.css["font-size"]
                        : l.fontSize || 12,
                _ =
                    l.margins ||
                    Object.assign(
                        {
                            width: this.getPageWidth(),
                        },
                        r,
                    ),
                P = "number" == typeof l.padding ? l.padding : 3,
                k = l.headerBackgroundColor || "#c8c8c8",
                I = l.headerTextColor || "#000";
            if (
                (a.call(this),
                (this.internal.__cell__.printHeaders = x),
                (this.internal.__cell__.margins = _),
                (this.internal.__cell__.table_font_size = S),
                (this.internal.__cell__.padding = P),
                (this.internal.__cell__.headerBackgroundColor = k),
                (this.internal.__cell__.headerTextColor = I),
                this.setFontSize(S),
                null == h)
            )
                (v = m = Object.keys(u[0])),
                    (b = m.map(function () {
                        return "left";
                    }));
            else if (Array.isArray(h) && "object" === _typeof(h[0]))
                for (
                    m = h.map(function (t) {
                        return t.name;
                    }),
                        v = h.map(function (t) {
                            return t.prompt || t.name || "";
                        }),
                        b = h.map(function (t) {
                            return t.align || "left";
                        }),
                        f = 0;
                    f < h.length;
                    f += 1
                )
                    w[h[f].name] = h[f].width * (19.049976 / 25.4);
            else
                Array.isArray(h) &&
                    "string" == typeof h[0] &&
                    ((v = m = h),
                    (b = m.map(function () {
                        return "left";
                    })));
            if (A || (Array.isArray(h) && "string" == typeof h[0]))
                for (f = 0; f < m.length; f += 1) {
                    for (
                        y[(g = m[f])] = u.map(function (t) {
                            return t[g];
                        }),
                            this.setFont(void 0, "bold"),
                            N.push(
                                this.getTextDimensions(v[f], {
                                    fontSize:
                                        this.internal.__cell__.table_font_size,
                                    scaleFactor: this.internal.scaleFactor,
                                }).w,
                            ),
                            d = y[g],
                            this.setFont(void 0, "normal"),
                            p = 0;
                        p < d.length;
                        p += 1
                    )
                        N.push(
                            this.getTextDimensions(d[p], {
                                fontSize:
                                    this.internal.__cell__.table_font_size,
                                scaleFactor: this.internal.scaleFactor,
                            }).w,
                        );
                    (w[g] = Math.max.apply(null, N) + P + P), (N = []);
                }
            if (x) {
                var F = {};
                for (f = 0; f < m.length; f += 1)
                    (F[m[f]] = {}),
                        (F[m[f]].text = v[f]),
                        (F[m[f]].align = b[f]);
                var C = c.call(this, F, w);
                (L = m.map(function (t) {
                    return new o(e, n, w[t], C, F[t].text, void 0, F[t].align);
                })),
                    this.setTableHeaderRow(L),
                    this.printHeaderRow(1, !1);
            }
            var j = h.reduce(function (t, e) {
                return (t[e.name] = e.align), t;
            }, {});
            for (f = 0; f < u.length; f += 1) {
                "rowStart" in l &&
                    l.rowStart instanceof Function &&
                    l.rowStart(
                        {
                            row: f,
                            data: u[f],
                        },
                        this,
                    );
                var O = c.call(this, u[f], w);
                for (p = 0; p < m.length; p += 1) {
                    var B = u[f][m[p]];
                    "cellStart" in l &&
                        l.cellStart instanceof Function &&
                        l.cellStart(
                            {
                                row: f,
                                col: p,
                                data: B,
                            },
                            this,
                        ),
                        s.call(
                            this,
                            new o(e, n, w[m[p]], O, B, f + 2, j[m[p]]),
                        );
                }
            }
            return (
                (this.internal.__cell__.table_x = e),
                (this.internal.__cell__.table_y = n),
                this
            );
        };
        var c = function (t, e) {
            var r = this.internal.__cell__.padding,
                n = this.internal.__cell__.table_font_size,
                i = this.internal.scaleFactor;
            return Object.keys(t)
                .map(function (n) {
                    var i = t[n];
                    return this.splitTextToSize(
                        i.hasOwnProperty("text") ? i.text : i,
                        e[n] - r - r,
                    );
                }, this)
                .map(function (t) {
                    return (
                        (this.getLineHeightFactor() * t.length * n) / i + r + r
                    );
                }, this)
                .reduce(function (t, e) {
                    return Math.max(t, e);
                }, 0);
        };
        (e.setTableHeaderRow = function (t) {
            i.call(this), (this.internal.__cell__.tableHeaderRow = t);
        }),
            (e.printHeaderRow = function (t, e) {
                if ((i.call(this), !this.internal.__cell__.tableHeaderRow))
                    throw new Error("Property tableHeaderRow does not exist.");
                var r;
                if (
                    ((n = !0),
                    "function" == typeof this.internal.__cell__.headerFunction)
                ) {
                    var a = this.internal.__cell__.headerFunction(
                        this,
                        this.internal.__cell__.pages,
                    );
                    this.internal.__cell__.lastCell = new o(
                        a[0],
                        a[1],
                        a[2],
                        a[3],
                        void 0,
                        -1,
                    );
                }
                this.setFont(void 0, "bold");
                for (
                    var c = [], u = 0;
                    u < this.internal.__cell__.tableHeaderRow.length;
                    u += 1
                ) {
                    (r = this.internal.__cell__.tableHeaderRow[u].clone()),
                        e &&
                            ((r.y = this.internal.__cell__.margins.top || 0),
                            c.push(r)),
                        (r.lineNumber = t);
                    var h = this.getTextColor();
                    this.setTextColor(this.internal.__cell__.headerTextColor),
                        this.setFillColor(
                            this.internal.__cell__.headerBackgroundColor,
                        ),
                        s.call(this, r),
                        this.setTextColor(h);
                }
                c.length > 0 && this.setTableHeaderRow(c),
                    this.setFont(void 0, "normal"),
                    (n = !1);
            });
    })(E.API);
var Pt = {
        italic: ["italic", "oblique", "normal"],
        oblique: ["oblique", "italic", "normal"],
        normal: ["normal", "oblique", "italic"],
    },
    kt = [
        "ultra-condensed",
        "extra-condensed",
        "condensed",
        "semi-condensed",
        "normal",
        "semi-expanded",
        "expanded",
        "extra-expanded",
        "ultra-expanded",
    ],
    It = _t(kt),
    Ft = [100, 200, 300, 400, 500, 600, 700, 800, 900],
    Ct = _t(Ft);
function jt(t) {
    var e = t.family.replace(/"|'/g, "").toLowerCase(),
        r = (function (t) {
            return Pt[(t = t || "normal")] ? t : "normal";
        })(t.style),
        n = (function (t) {
            if (!t) return 400;
            if ("number" == typeof t)
                return t >= 100 && t <= 900 && t % 100 == 0 ? t : 400;
            if (/^\d00$/.test(t)) return parseInt(t);
            switch (t) {
                case "bold":
                    return 700;
                case "normal":
                default:
                    return 400;
            }
        })(t.weight),
        i = (function (t) {
            return "number" == typeof It[(t = t || "normal")] ? t : "normal";
        })(t.stretch);
    return {
        family: e,
        style: r,
        weight: n,
        stretch: i,
        src: t.src || [],
        ref: t.ref || {
            name: e,
            style: [i, r, n].join(" "),
        },
    };
}
function Ot(t, e, r, n) {
    var i;
    for (i = r; i >= 0 && i < e.length; i += n) if (t[e[i]]) return t[e[i]];
    for (i = r; i >= 0 && i < e.length; i -= n) if (t[e[i]]) return t[e[i]];
}
var Bt = {
        "sans-serif": "helvetica",
        fixed: "courier",
        monospace: "courier",
        terminal: "courier",
        cursive: "times",
        fantasy: "times",
        serif: "times",
    },
    Mt = {
        caption: "times",
        icon: "times",
        menu: "times",
        "message-box": "times",
        "small-caption": "times",
        "status-bar": "times",
    };
function Et(t) {
    return [t.stretch, t.style, t.weight, t.family].join(" ");
}
function qt(t, e, r) {
    for (
        var n = (r = r || {}).defaultFontFamily || "times",
            i = Object.assign({}, Bt, r.genericFontFamilies || {}),
            a = null,
            o = null,
            s = 0;
        s < e.length;
        ++s
    )
        if (
            (i[(a = jt(e[s])).family] && (a.family = i[a.family]),
            t.hasOwnProperty(a.family))
        ) {
            o = t[a.family];
            break;
        }
    if (!(o = o || t[n]))
        throw new Error(
            "Could not find a font-family for the rule '" +
                Et(a) +
                "' and default family '" +
                n +
                "'.",
        );
    if (
        ((o = (function (t, e) {
            if (e[t]) return e[t];
            var r = It[t],
                n = r <= It.normal ? -1 : 1,
                i = Ot(e, kt, r, n);
            if (!i)
                throw new Error(
                    "Could not find a matching font-stretch value for " + t,
                );
            return i;
        })(a.stretch, o)),
        (o = (function (t, e) {
            if (e[t]) return e[t];
            for (var r = Pt[t], n = 0; n < r.length; ++n)
                if (e[r[n]]) return e[r[n]];
            throw new Error("Could not find a matching font-style for " + t);
        })(a.style, o)),
        !(o = (function (t, e) {
            if (e[t]) return e[t];
            if (400 === t && e[500]) return e[500];
            if (500 === t && e[400]) return e[400];
            var r = Ct[t],
                n = Ot(e, Ft, r, t < 400 ? -1 : 1);
            if (!n)
                throw new Error(
                    "Could not find a matching font-weight for value " + t,
                );
            return n;
        })(a.weight, o)))
    )
        throw new Error(
            "Failed to resolve a font for the rule '" + Et(a) + "'.",
        );
    return o;
}
function Dt(t) {
    return t.trimLeft();
}
function Rt(t, e) {
    for (var r = 0; r < t.length; ) {
        if (t.charAt(r) === e) return [t.substring(0, r), t.substring(r + 1)];
        r += 1;
    }
    return null;
}
function Tt(t) {
    var e = t.match(/^(-[a-z_]|[a-z_])[a-z0-9_-]*/i);
    return null === e ? null : [e[0], t.substring(e[0].length)];
}
var Ut,
    zt,
    Ht,
    Wt = ["times"];
!(function (e) {
    var r,
        n,
        i,
        o,
        s,
        c,
        u,
        h,
        l,
        d = function (t) {
            return (
                (t = t || {}),
                (this.isStrokeTransparent = t.isStrokeTransparent || !1),
                (this.strokeOpacity = t.strokeOpacity || 1),
                (this.strokeStyle = t.strokeStyle || "#000000"),
                (this.fillStyle = t.fillStyle || "#000000"),
                (this.isFillTransparent = t.isFillTransparent || !1),
                (this.fillOpacity = t.fillOpacity || 1),
                (this.font = t.font || "10px sans-serif"),
                (this.textBaseline = t.textBaseline || "alphabetic"),
                (this.textAlign = t.textAlign || "left"),
                (this.lineWidth = t.lineWidth || 1),
                (this.lineJoin = t.lineJoin || "miter"),
                (this.lineCap = t.lineCap || "butt"),
                (this.path = t.path || []),
                (this.transform =
                    void 0 !== t.transform ? t.transform.clone() : new h()),
                (this.globalCompositeOperation =
                    t.globalCompositeOperation || "normal"),
                (this.globalAlpha = t.globalAlpha || 1),
                (this.clip_path = t.clip_path || []),
                (this.currentPoint = t.currentPoint || new c()),
                (this.miterLimit = t.miterLimit || 10),
                (this.lastPoint = t.lastPoint || new c()),
                (this.lineDashOffset = t.lineDashOffset || 0),
                (this.lineDash = t.lineDash || []),
                (this.margin = t.margin || [0, 0, 0, 0]),
                (this.prevPageLastElemOffset = t.prevPageLastElemOffset || 0),
                (this.ignoreClearRect =
                    "boolean" != typeof t.ignoreClearRect || t.ignoreClearRect),
                this
            );
        };
    e.events.push([
        "initialized",
        function () {
            (this.context2d = new p(this)),
                (r = this.internal.f2),
                (n = this.internal.getCoordinateString),
                (i = this.internal.getVerticalCoordinateString),
                (o = this.internal.getHorizontalCoordinate),
                (s = this.internal.getVerticalCoordinate),
                (c = this.internal.Point),
                (u = this.internal.Rectangle),
                (h = this.internal.Matrix),
                (l = new d());
        },
    ]);
    var p = function (t) {
        Object.defineProperty(this, "canvas", {
            get: function () {
                return {
                    parentNode: !1,
                    style: !1,
                };
            },
        });
        var e = t;
        Object.defineProperty(this, "pdf", {
            get: function () {
                return e;
            },
        });
        var r = !1;
        Object.defineProperty(this, "pageWrapXEnabled", {
            get: function () {
                return r;
            },
            set: function (t) {
                r = Boolean(t);
            },
        });
        var n = !1;
        Object.defineProperty(this, "pageWrapYEnabled", {
            get: function () {
                return n;
            },
            set: function (t) {
                n = Boolean(t);
            },
        });
        var i = 0;
        Object.defineProperty(this, "posX", {
            get: function () {
                return i;
            },
            set: function (t) {
                isNaN(t) || (i = t);
            },
        });
        var a = 0;
        Object.defineProperty(this, "posY", {
            get: function () {
                return a;
            },
            set: function (t) {
                isNaN(t) || (a = t);
            },
        }),
            Object.defineProperty(this, "margin", {
                get: function () {
                    return l.margin;
                },
                set: function (t) {
                    var e;
                    "number" == typeof t
                        ? (e = [t, t, t, t])
                        : (((e = new Array(4))[0] = t[0]),
                          (e[1] = t.length >= 2 ? t[1] : e[0]),
                          (e[2] = t.length >= 3 ? t[2] : e[0]),
                          (e[3] = t.length >= 4 ? t[3] : e[1])),
                        (l.margin = e);
                },
            });
        var o = !1;
        Object.defineProperty(this, "autoPaging", {
            get: function () {
                return o;
            },
            set: function (t) {
                o = t;
            },
        });
        var s = 0;
        Object.defineProperty(this, "lastBreak", {
            get: function () {
                return s;
            },
            set: function (t) {
                s = t;
            },
        });
        var c = [];
        Object.defineProperty(this, "pageBreaks", {
            get: function () {
                return c;
            },
            set: function (t) {
                c = t;
            },
        }),
            Object.defineProperty(this, "ctx", {
                get: function () {
                    return l;
                },
                set: function (t) {
                    t instanceof d && (l = t);
                },
            }),
            Object.defineProperty(this, "path", {
                get: function () {
                    return l.path;
                },
                set: function (t) {
                    l.path = t;
                },
            });
        var u = [];
        Object.defineProperty(this, "ctxStack", {
            get: function () {
                return u;
            },
            set: function (t) {
                u = t;
            },
        }),
            Object.defineProperty(this, "fillStyle", {
                get: function () {
                    return this.ctx.fillStyle;
                },
                set: function (t) {
                    var e;
                    (e = g(t)),
                        (this.ctx.fillStyle = e.style),
                        (this.ctx.isFillTransparent = 0 === e.a),
                        (this.ctx.fillOpacity = e.a),
                        this.pdf.setFillColor(e.r, e.g, e.b, {
                            a: e.a,
                        }),
                        this.pdf.setTextColor(e.r, e.g, e.b, {
                            a: e.a,
                        });
                },
            }),
            Object.defineProperty(this, "strokeStyle", {
                get: function () {
                    return this.ctx.strokeStyle;
                },
                set: function (t) {
                    var e = g(t);
                    (this.ctx.strokeStyle = e.style),
                        (this.ctx.isStrokeTransparent = 0 === e.a),
                        (this.ctx.strokeOpacity = e.a),
                        0 === e.a
                            ? this.pdf.setDrawColor(255, 255, 255)
                            : (e.a, this.pdf.setDrawColor(e.r, e.g, e.b));
                },
            }),
            Object.defineProperty(this, "lineCap", {
                get: function () {
                    return this.ctx.lineCap;
                },
                set: function (t) {
                    -1 !== ["butt", "round", "square"].indexOf(t) &&
                        ((this.ctx.lineCap = t), this.pdf.setLineCap(t));
                },
            }),
            Object.defineProperty(this, "lineWidth", {
                get: function () {
                    return this.ctx.lineWidth;
                },
                set: function (t) {
                    isNaN(t) ||
                        ((this.ctx.lineWidth = t), this.pdf.setLineWidth(t));
                },
            }),
            Object.defineProperty(this, "lineJoin", {
                get: function () {
                    return this.ctx.lineJoin;
                },
                set: function (t) {
                    -1 !== ["bevel", "round", "miter"].indexOf(t) &&
                        ((this.ctx.lineJoin = t), this.pdf.setLineJoin(t));
                },
            }),
            Object.defineProperty(this, "miterLimit", {
                get: function () {
                    return this.ctx.miterLimit;
                },
                set: function (t) {
                    isNaN(t) ||
                        ((this.ctx.miterLimit = t), this.pdf.setMiterLimit(t));
                },
            }),
            Object.defineProperty(this, "textBaseline", {
                get: function () {
                    return this.ctx.textBaseline;
                },
                set: function (t) {
                    this.ctx.textBaseline = t;
                },
            }),
            Object.defineProperty(this, "textAlign", {
                get: function () {
                    return this.ctx.textAlign;
                },
                set: function (t) {
                    -1 !==
                        ["right", "end", "center", "left", "start"].indexOf(
                            t,
                        ) && (this.ctx.textAlign = t);
                },
            });
        var h = null;
        function f(t, e) {
            if (null === h) {
                var r = (function (t) {
                    var e = [];
                    return (
                        Object.keys(t).forEach(function (r) {
                            t[r].forEach(function (t) {
                                var n = null;
                                switch (t) {
                                    case "bold":
                                        n = {
                                            family: r,
                                            weight: "bold",
                                        };
                                        break;
                                    case "italic":
                                        n = {
                                            family: r,
                                            style: "italic",
                                        };
                                        break;
                                    case "bolditalic":
                                        n = {
                                            family: r,
                                            weight: "bold",
                                            style: "italic",
                                        };
                                        break;
                                    case "":
                                    case "normal":
                                        n = {
                                            family: r,
                                        };
                                }
                                null !== n &&
                                    ((n.ref = {
                                        name: r,
                                        style: t,
                                    }),
                                    e.push(n));
                            });
                        }),
                        e
                    );
                })(t.getFontList());
                h = (function (t) {
                    for (var e = {}, r = 0; r < t.length; ++r) {
                        var n = jt(t[r]),
                            i = n.family,
                            a = n.stretch,
                            o = n.style,
                            s = n.weight;
                        (e[i] = e[i] || {}),
                            (e[i][a] = e[i][a] || {}),
                            (e[i][a][o] = e[i][a][o] || {}),
                            (e[i][a][o][s] = n);
                    }
                    return e;
                })(r.concat(e));
            }
            return h;
        }
        var p = null;
        Object.defineProperty(this, "fontFaces", {
            get: function () {
                return p;
            },
            set: function (t) {
                (h = null), (p = t);
            },
        }),
            Object.defineProperty(this, "font", {
                get: function () {
                    return this.ctx.font;
                },
                set: function (t) {
                    var e;
                    if (
                        ((this.ctx.font = t),
                        null !==
                            (e =
                                /^\s*(?=(?:(?:[-a-z]+\s*){0,2}(italic|oblique))?)(?=(?:(?:[-a-z]+\s*){0,2}(small-caps))?)(?=(?:(?:[-a-z]+\s*){0,2}(bold(?:er)?|lighter|[1-9]00))?)(?:(?:normal|\1|\2|\3)\s*){0,3}((?:xx?-)?(?:small|large)|medium|smaller|larger|[.\d]+(?:\%|in|[cem]m|ex|p[ctx]))(?:\s*\/\s*(normal|[.\d]+(?:\%|in|[cem]m|ex|p[ctx])))?\s*([-_,\"\'\sa-z]+?)\s*$/i.exec(
                                    t,
                                )))
                    ) {
                        var r = e[1],
                            n = (e[2], e[3]),
                            i = e[4],
                            a = (e[5], e[6]),
                            o = /^([.\d]+)((?:%|in|[cem]m|ex|p[ctx]))$/i.exec(
                                i,
                            )[2];
                        (i =
                            "px" === o
                                ? Math.floor(
                                      parseFloat(i) *
                                          this.pdf.internal.scaleFactor,
                                  )
                                : "em" === o
                                  ? Math.floor(
                                        parseFloat(i) * this.pdf.getFontSize(),
                                    )
                                  : Math.floor(
                                        parseFloat(i) *
                                            this.pdf.internal.scaleFactor,
                                    )),
                            this.pdf.setFontSize(i);
                        var s = (function (t) {
                            var e,
                                r,
                                n = [],
                                i = t.trim();
                            if ("" === i) return Wt;
                            if (i in Mt) return [Mt[i]];
                            for (; "" !== i; ) {
                                switch (
                                    ((r = null), (e = (i = Dt(i)).charAt(0)))
                                ) {
                                    case '"':
                                    case "'":
                                        r = Rt(i.substring(1), e);
                                        break;
                                    default:
                                        r = Tt(i);
                                }
                                if (null === r) return Wt;
                                if (
                                    (n.push(r[0]),
                                    "" !== (i = Dt(r[1])) &&
                                        "," !== i.charAt(0))
                                )
                                    return Wt;
                                i = i.replace(/^,/, "");
                            }
                            return n;
                        })(a);
                        if (this.fontFaces) {
                            var c = qt(
                                f(this.pdf, this.fontFaces),
                                s.map(function (t) {
                                    return {
                                        family: t,
                                        stretch: "normal",
                                        weight: n,
                                        style: r,
                                    };
                                }),
                            );
                            this.pdf.setFont(c.ref.name, c.ref.style);
                        } else {
                            var u = "";
                            ("bold" === n ||
                                parseInt(n, 10) >= 700 ||
                                "bold" === r) &&
                                (u = "bold"),
                                "italic" === r && (u += "italic"),
                                0 === u.length && (u = "normal");
                            for (
                                var h = "",
                                    l = {
                                        arial: "Helvetica",
                                        Arial: "Helvetica",
                                        verdana: "Helvetica",
                                        Verdana: "Helvetica",
                                        helvetica: "Helvetica",
                                        Helvetica: "Helvetica",
                                        "sans-serif": "Helvetica",
                                        fixed: "Courier",
                                        monospace: "Courier",
                                        terminal: "Courier",
                                        cursive: "Times",
                                        fantasy: "Times",
                                        serif: "Times",
                                    },
                                    d = 0;
                                d < s.length;
                                d++
                            ) {
                                if (
                                    void 0 !==
                                    this.pdf.internal.getFont(s[d], u, {
                                        noFallback: !0,
                                        disableWarning: !0,
                                    })
                                ) {
                                    h = s[d];
                                    break;
                                }
                                if (
                                    "bolditalic" === u &&
                                    void 0 !==
                                        this.pdf.internal.getFont(
                                            s[d],
                                            "bold",
                                            {
                                                noFallback: !0,
                                                disableWarning: !0,
                                            },
                                        )
                                )
                                    (h = s[d]), (u = "bold");
                                else if (
                                    void 0 !==
                                    this.pdf.internal.getFont(s[d], "normal", {
                                        noFallback: !0,
                                        disableWarning: !0,
                                    })
                                ) {
                                    (h = s[d]), (u = "normal");
                                    break;
                                }
                            }
                            if ("" === h)
                                for (var p = 0; p < s.length; p++)
                                    if (l[s[p]]) {
                                        h = l[s[p]];
                                        break;
                                    }
                            (h = "" === h ? "Times" : h),
                                this.pdf.setFont(h, u);
                        }
                    }
                },
            }),
            Object.defineProperty(this, "globalCompositeOperation", {
                get: function () {
                    return this.ctx.globalCompositeOperation;
                },
                set: function (t) {
                    this.ctx.globalCompositeOperation = t;
                },
            }),
            Object.defineProperty(this, "globalAlpha", {
                get: function () {
                    return this.ctx.globalAlpha;
                },
                set: function (t) {
                    this.ctx.globalAlpha = t;
                },
            }),
            Object.defineProperty(this, "lineDashOffset", {
                get: function () {
                    return this.ctx.lineDashOffset;
                },
                set: function (t) {
                    (this.ctx.lineDashOffset = t), T.call(this);
                },
            }),
            Object.defineProperty(this, "lineDash", {
                get: function () {
                    return this.ctx.lineDash;
                },
                set: function (t) {
                    (this.ctx.lineDash = t), T.call(this);
                },
            }),
            Object.defineProperty(this, "ignoreClearRect", {
                get: function () {
                    return this.ctx.ignoreClearRect;
                },
                set: function (t) {
                    this.ctx.ignoreClearRect = Boolean(t);
                },
            });
    };
    (p.prototype.setLineDash = function (t) {
        this.lineDash = t;
    }),
        (p.prototype.getLineDash = function () {
            return this.lineDash.length % 2
                ? this.lineDash.concat(this.lineDash)
                : this.lineDash.slice();
        }),
        (p.prototype.fill = function () {
            A.call(this, "fill", !1);
        }),
        (p.prototype.stroke = function () {
            A.call(this, "stroke", !1);
        }),
        (p.prototype.beginPath = function () {
            this.path = [
                {
                    type: "begin",
                },
            ];
        }),
        (p.prototype.moveTo = function (t, e) {
            if (isNaN(t) || isNaN(e))
                throw (
                    (a.error(
                        "jsPDF.context2d.moveTo: Invalid arguments",
                        arguments,
                    ),
                    new Error(
                        "Invalid arguments passed to jsPDF.context2d.moveTo",
                    ))
                );
            var r = this.ctx.transform.applyToPoint(new c(t, e));
            this.path.push({
                type: "mt",
                x: r.x,
                y: r.y,
            }),
                (this.ctx.lastPoint = new c(t, e));
        }),
        (p.prototype.closePath = function () {
            var e = new c(0, 0),
                r = 0;
            for (r = this.path.length - 1; -1 !== r; r--)
                if (
                    "begin" === this.path[r].type &&
                    "object" === _typeof(this.path[r + 1]) &&
                    "number" == typeof this.path[r + 1].x
                ) {
                    e = new c(this.path[r + 1].x, this.path[r + 1].y);
                    break;
                }
            this.path.push({
                type: "close",
            }),
                (this.ctx.lastPoint = new c(e.x, e.y));
        }),
        (p.prototype.lineTo = function (t, e) {
            if (isNaN(t) || isNaN(e))
                throw (
                    (a.error(
                        "jsPDF.context2d.lineTo: Invalid arguments",
                        arguments,
                    ),
                    new Error(
                        "Invalid arguments passed to jsPDF.context2d.lineTo",
                    ))
                );
            var r = this.ctx.transform.applyToPoint(new c(t, e));
            this.path.push({
                type: "lt",
                x: r.x,
                y: r.y,
            }),
                (this.ctx.lastPoint = new c(r.x, r.y));
        }),
        (p.prototype.clip = function () {
            (this.ctx.clip_path = JSON.parse(JSON.stringify(this.path))),
                A.call(this, null, !0);
        }),
        (p.prototype.quadraticCurveTo = function (t, e, r, n) {
            if (isNaN(r) || isNaN(n) || isNaN(t) || isNaN(e))
                throw (
                    (a.error(
                        "jsPDF.context2d.quadraticCurveTo: Invalid arguments",
                        arguments,
                    ),
                    new Error(
                        "Invalid arguments passed to jsPDF.context2d.quadraticCurveTo",
                    ))
                );
            var i = this.ctx.transform.applyToPoint(new c(r, n)),
                o = this.ctx.transform.applyToPoint(new c(t, e));
            this.path.push({
                type: "qct",
                x1: o.x,
                y1: o.y,
                x: i.x,
                y: i.y,
            }),
                (this.ctx.lastPoint = new c(i.x, i.y));
        }),
        (p.prototype.bezierCurveTo = function (t, e, r, n, i, o) {
            if (
                isNaN(i) ||
                isNaN(o) ||
                isNaN(t) ||
                isNaN(e) ||
                isNaN(r) ||
                isNaN(n)
            )
                throw (
                    (a.error(
                        "jsPDF.context2d.bezierCurveTo: Invalid arguments",
                        arguments,
                    ),
                    new Error(
                        "Invalid arguments passed to jsPDF.context2d.bezierCurveTo",
                    ))
                );
            var s = this.ctx.transform.applyToPoint(new c(i, o)),
                u = this.ctx.transform.applyToPoint(new c(t, e)),
                h = this.ctx.transform.applyToPoint(new c(r, n));
            this.path.push({
                type: "bct",
                x1: u.x,
                y1: u.y,
                x2: h.x,
                y2: h.y,
                x: s.x,
                y: s.y,
            }),
                (this.ctx.lastPoint = new c(s.x, s.y));
        }),
        (p.prototype.arc = function (t, e, r, n, i, o) {
            if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n) || isNaN(i))
                throw (
                    (a.error(
                        "jsPDF.context2d.arc: Invalid arguments",
                        arguments,
                    ),
                    new Error(
                        "Invalid arguments passed to jsPDF.context2d.arc",
                    ))
                );
            if (((o = Boolean(o)), !this.ctx.transform.isIdentity)) {
                var s = this.ctx.transform.applyToPoint(new c(t, e));
                (t = s.x), (e = s.y);
                var u = this.ctx.transform.applyToPoint(new c(0, r)),
                    h = this.ctx.transform.applyToPoint(new c(0, 0));
                r = Math.sqrt(Math.pow(u.x - h.x, 2) + Math.pow(u.y - h.y, 2));
            }
            Math.abs(i - n) >= 2 * Math.PI && ((n = 0), (i = 2 * Math.PI)),
                this.path.push({
                    type: "arc",
                    x: t,
                    y: e,
                    radius: r,
                    startAngle: n,
                    endAngle: i,
                    counterclockwise: o,
                });
        }),
        (p.prototype.arcTo = function (t, e, r, n, i) {
            throw new Error("arcTo not implemented.");
        }),
        (p.prototype.rect = function (t, e, r, n) {
            if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n))
                throw (
                    (a.error(
                        "jsPDF.context2d.rect: Invalid arguments",
                        arguments,
                    ),
                    new Error(
                        "Invalid arguments passed to jsPDF.context2d.rect",
                    ))
                );
            this.moveTo(t, e),
                this.lineTo(t + r, e),
                this.lineTo(t + r, e + n),
                this.lineTo(t, e + n),
                this.lineTo(t, e),
                this.lineTo(t + r, e),
                this.lineTo(t, e);
        }),
        (p.prototype.fillRect = function (t, e, r, n) {
            if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n))
                throw (
                    (a.error(
                        "jsPDF.context2d.fillRect: Invalid arguments",
                        arguments,
                    ),
                    new Error(
                        "Invalid arguments passed to jsPDF.context2d.fillRect",
                    ))
                );
            if (!m.call(this)) {
                var i = {};
                "butt" !== this.lineCap &&
                    ((i.lineCap = this.lineCap), (this.lineCap = "butt")),
                    "miter" !== this.lineJoin &&
                        ((i.lineJoin = this.lineJoin),
                        (this.lineJoin = "miter")),
                    this.beginPath(),
                    this.rect(t, e, r, n),
                    this.fill(),
                    i.hasOwnProperty("lineCap") && (this.lineCap = i.lineCap),
                    i.hasOwnProperty("lineJoin") &&
                        (this.lineJoin = i.lineJoin);
            }
        }),
        (p.prototype.strokeRect = function (t, e, r, n) {
            if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n))
                throw (
                    (a.error(
                        "jsPDF.context2d.strokeRect: Invalid arguments",
                        arguments,
                    ),
                    new Error(
                        "Invalid arguments passed to jsPDF.context2d.strokeRect",
                    ))
                );
            v.call(this) ||
                (this.beginPath(), this.rect(t, e, r, n), this.stroke());
        }),
        (p.prototype.clearRect = function (t, e, r, n) {
            if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n))
                throw (
                    (a.error(
                        "jsPDF.context2d.clearRect: Invalid arguments",
                        arguments,
                    ),
                    new Error(
                        "Invalid arguments passed to jsPDF.context2d.clearRect",
                    ))
                );
            this.ignoreClearRect ||
                ((this.fillStyle = "#ffffff"), this.fillRect(t, e, r, n));
        }),
        (p.prototype.save = function (t) {
            t = "boolean" != typeof t || t;
            for (
                var e = this.pdf.internal.getCurrentPageInfo().pageNumber,
                    r = 0;
                r < this.pdf.internal.getNumberOfPages();
                r++
            )
                this.pdf.setPage(r + 1), this.pdf.internal.out("q");
            if ((this.pdf.setPage(e), t)) {
                this.ctx.fontSize = this.pdf.internal.getFontSize();
                var n = new d(this.ctx);
                this.ctxStack.push(this.ctx), (this.ctx = n);
            }
        }),
        (p.prototype.restore = function (t) {
            t = "boolean" != typeof t || t;
            for (
                var e = this.pdf.internal.getCurrentPageInfo().pageNumber,
                    r = 0;
                r < this.pdf.internal.getNumberOfPages();
                r++
            )
                this.pdf.setPage(r + 1), this.pdf.internal.out("Q");
            this.pdf.setPage(e),
                t &&
                    0 !== this.ctxStack.length &&
                    ((this.ctx = this.ctxStack.pop()),
                    (this.fillStyle = this.ctx.fillStyle),
                    (this.strokeStyle = this.ctx.strokeStyle),
                    (this.font = this.ctx.font),
                    (this.lineCap = this.ctx.lineCap),
                    (this.lineWidth = this.ctx.lineWidth),
                    (this.lineJoin = this.ctx.lineJoin),
                    (this.lineDash = this.ctx.lineDash),
                    (this.lineDashOffset = this.ctx.lineDashOffset));
        }),
        (p.prototype.toDataURL = function () {
            throw new Error("toDataUrl not implemented.");
        });
    var g = function (t) {
            var e, r, n, i;
            if ((!0 === t.isCanvasGradient && (t = t.getColor()), !t))
                return {
                    r: 0,
                    g: 0,
                    b: 0,
                    a: 0,
                    style: t,
                };
            if (
                /transparent|rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*0+\s*\)/.test(
                    t,
                )
            )
                (e = 0), (r = 0), (n = 0), (i = 0);
            else {
                var a = /rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/.exec(t);
                if (null !== a)
                    (e = parseInt(a[1])),
                        (r = parseInt(a[2])),
                        (n = parseInt(a[3])),
                        (i = 1);
                else if (
                    null !==
                    (a =
                        /rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d.]+)\s*\)/.exec(
                            t,
                        ))
                )
                    (e = parseInt(a[1])),
                        (r = parseInt(a[2])),
                        (n = parseInt(a[3])),
                        (i = parseFloat(a[4]));
                else {
                    if (
                        ((i = 1), "string" == typeof t && "#" !== t.charAt(0))
                    ) {
                        var o = new f(t);
                        t = o.ok ? o.toHex() : "#000000";
                    }
                    4 === t.length
                        ? ((e = t.substring(1, 2)),
                          (e += e),
                          (r = t.substring(2, 3)),
                          (r += r),
                          (n = t.substring(3, 4)),
                          (n += n))
                        : ((e = t.substring(1, 3)),
                          (r = t.substring(3, 5)),
                          (n = t.substring(5, 7))),
                        (e = parseInt(e, 16)),
                        (r = parseInt(r, 16)),
                        (n = parseInt(n, 16));
                }
            }
            return {
                r: e,
                g: r,
                b: n,
                a: i,
                style: t,
            };
        },
        m = function () {
            return this.ctx.isFillTransparent || 0 == this.globalAlpha;
        },
        v = function () {
            return Boolean(
                this.ctx.isStrokeTransparent || 0 == this.globalAlpha,
            );
        };
    (p.prototype.fillText = function (t, e, r, n) {
        if (isNaN(e) || isNaN(r) || "string" != typeof t)
            throw (
                (a.error(
                    "jsPDF.context2d.fillText: Invalid arguments",
                    arguments,
                ),
                new Error(
                    "Invalid arguments passed to jsPDF.context2d.fillText",
                ))
            );
        if (((n = isNaN(n) ? void 0 : n), !m.call(this))) {
            var i = q(this.ctx.transform.rotation),
                o = this.ctx.transform.scaleX;
            C.call(this, {
                text: t,
                x: e,
                y: r,
                scale: o,
                angle: i,
                align: this.textAlign,
                maxWidth: n,
            });
        }
    }),
        (p.prototype.strokeText = function (t, e, r, n) {
            if (isNaN(e) || isNaN(r) || "string" != typeof t)
                throw (
                    (a.error(
                        "jsPDF.context2d.strokeText: Invalid arguments",
                        arguments,
                    ),
                    new Error(
                        "Invalid arguments passed to jsPDF.context2d.strokeText",
                    ))
                );
            if (!v.call(this)) {
                n = isNaN(n) ? void 0 : n;
                var i = q(this.ctx.transform.rotation),
                    o = this.ctx.transform.scaleX;
                C.call(this, {
                    text: t,
                    x: e,
                    y: r,
                    scale: o,
                    renderingMode: "stroke",
                    angle: i,
                    align: this.textAlign,
                    maxWidth: n,
                });
            }
        }),
        (p.prototype.measureText = function (t) {
            if ("string" != typeof t)
                throw (
                    (a.error(
                        "jsPDF.context2d.measureText: Invalid arguments",
                        arguments,
                    ),
                    new Error(
                        "Invalid arguments passed to jsPDF.context2d.measureText",
                    ))
                );
            var e = this.pdf,
                r = this.pdf.internal.scaleFactor,
                n = e.internal.getFontSize(),
                i = (e.getStringUnitWidth(t) * n) / e.internal.scaleFactor,
                o = function (t) {
                    var e = (t = t || {}).width || 0;
                    return (
                        Object.defineProperty(this, "width", {
                            get: function () {
                                return e;
                            },
                        }),
                        this
                    );
                };
            return new o({
                width: (i *= Math.round(((96 * r) / 72) * 1e4) / 1e4),
            });
        }),
        (p.prototype.scale = function (t, e) {
            if (isNaN(t) || isNaN(e))
                throw (
                    (a.error(
                        "jsPDF.context2d.scale: Invalid arguments",
                        arguments,
                    ),
                    new Error(
                        "Invalid arguments passed to jsPDF.context2d.scale",
                    ))
                );
            var r = new h(t, 0, 0, e, 0, 0);
            this.ctx.transform = this.ctx.transform.multiply(r);
        }),
        (p.prototype.rotate = function (t) {
            if (isNaN(t))
                throw (
                    (a.error(
                        "jsPDF.context2d.rotate: Invalid arguments",
                        arguments,
                    ),
                    new Error(
                        "Invalid arguments passed to jsPDF.context2d.rotate",
                    ))
                );
            var e = new h(
                Math.cos(t),
                Math.sin(t),
                -Math.sin(t),
                Math.cos(t),
                0,
                0,
            );
            this.ctx.transform = this.ctx.transform.multiply(e);
        }),
        (p.prototype.translate = function (t, e) {
            if (isNaN(t) || isNaN(e))
                throw (
                    (a.error(
                        "jsPDF.context2d.translate: Invalid arguments",
                        arguments,
                    ),
                    new Error(
                        "Invalid arguments passed to jsPDF.context2d.translate",
                    ))
                );
            var r = new h(1, 0, 0, 1, t, e);
            this.ctx.transform = this.ctx.transform.multiply(r);
        }),
        (p.prototype.transform = function (t, e, r, n, i, o) {
            if (
                isNaN(t) ||
                isNaN(e) ||
                isNaN(r) ||
                isNaN(n) ||
                isNaN(i) ||
                isNaN(o)
            )
                throw (
                    (a.error(
                        "jsPDF.context2d.transform: Invalid arguments",
                        arguments,
                    ),
                    new Error(
                        "Invalid arguments passed to jsPDF.context2d.transform",
                    ))
                );
            var s = new h(t, e, r, n, i, o);
            this.ctx.transform = this.ctx.transform.multiply(s);
        }),
        (p.prototype.setTransform = function (t, e, r, n, i, a) {
            (t = isNaN(t) ? 1 : t),
                (e = isNaN(e) ? 0 : e),
                (r = isNaN(r) ? 0 : r),
                (n = isNaN(n) ? 1 : n),
                (i = isNaN(i) ? 0 : i),
                (a = isNaN(a) ? 0 : a),
                (this.ctx.transform = new h(t, e, r, n, i, a));
        });
    var b = function () {
        return (
            this.margin[0] > 0 ||
            this.margin[1] > 0 ||
            this.margin[2] > 0 ||
            this.margin[3] > 0
        );
    };
    p.prototype.drawImage = function (t, e, r, n, i, a, o, s, c) {
        var l = this.pdf.getImageProperties(t),
            f = 1,
            d = 1,
            p = 1,
            g = 1;
        void 0 !== n &&
            void 0 !== s &&
            ((p = s / n),
            (g = c / i),
            (f = ((l.width / n) * s) / n),
            (d = ((l.height / i) * c) / i)),
            void 0 === a && ((a = e), (o = r), (e = 0), (r = 0)),
            void 0 !== n && void 0 === s && ((s = n), (c = i)),
            void 0 === n && void 0 === s && ((s = l.width), (c = l.height));
        for (
            var m,
                v = this.ctx.transform.decompose(),
                w = q(v.rotate.shx),
                A = new h(),
                S = (A = (A = (A = A.multiply(v.translate)).multiply(
                    v.skew,
                )).multiply(v.scale)).applyToRectangle(
                    new u(a - e * p, o - r * g, n * f, i * d),
                ),
                _ = y.call(this, S),
                P = [],
                k = 0;
            k < _.length;
            k += 1
        )
            -1 === P.indexOf(_[k]) && P.push(_[k]);
        if ((L(P), this.autoPaging))
            for (var I = P[0], F = P[P.length - 1], C = I; C < F + 1; C++) {
                this.pdf.setPage(C);
                var j =
                        this.pdf.internal.pageSize.width -
                        this.margin[3] -
                        this.margin[1],
                    O = 1 === C ? this.posY + this.margin[0] : this.margin[0],
                    B =
                        this.pdf.internal.pageSize.height -
                        this.posY -
                        this.margin[0] -
                        this.margin[2],
                    M =
                        this.pdf.internal.pageSize.height -
                        this.margin[0] -
                        this.margin[2],
                    E = 1 === C ? 0 : B + (C - 2) * M;
                if (0 !== this.ctx.clip_path.length) {
                    var D = this.path;
                    (m = JSON.parse(JSON.stringify(this.ctx.clip_path))),
                        (this.path = N(
                            m,
                            this.posX + this.margin[3],
                            -E + O + this.ctx.prevPageLastElemOffset,
                        )),
                        x.call(this, "fill", !0),
                        (this.path = D);
                }
                var R = JSON.parse(JSON.stringify(S));
                R = N(
                    [R],
                    this.posX + this.margin[3],
                    -E + O + this.ctx.prevPageLastElemOffset,
                )[0];
                var T = (C > I || C < F) && b.call(this);
                T &&
                    (this.pdf.saveGraphicsState(),
                    this.pdf
                        .rect(this.margin[3], this.margin[0], j, M, null)
                        .clip()
                        .discardPath()),
                    this.pdf.addImage(
                        t,
                        "JPEG",
                        R.x,
                        R.y,
                        R.w,
                        R.h,
                        null,
                        null,
                        w,
                    ),
                    T && this.pdf.restoreGraphicsState();
            }
        else this.pdf.addImage(t, "JPEG", S.x, S.y, S.w, S.h, null, null, w);
    };
    var y = function (t, e, r) {
            var n = [];
            (e = e || this.pdf.internal.pageSize.width),
                (r =
                    r ||
                    this.pdf.internal.pageSize.height -
                        this.margin[0] -
                        this.margin[2]);
            var i = this.posY + this.ctx.prevPageLastElemOffset;
            switch (t.type) {
                default:
                case "mt":
                case "lt":
                    n.push(Math.floor((t.y + i) / r) + 1);
                    break;
                case "arc":
                    n.push(Math.floor((t.y + i - t.radius) / r) + 1),
                        n.push(Math.floor((t.y + i + t.radius) / r) + 1);
                    break;
                case "qct":
                    var a = D(
                        this.ctx.lastPoint.x,
                        this.ctx.lastPoint.y,
                        t.x1,
                        t.y1,
                        t.x,
                        t.y,
                    );
                    n.push(Math.floor((a.y + i) / r) + 1),
                        n.push(Math.floor((a.y + a.h + i) / r) + 1);
                    break;
                case "bct":
                    var o = R(
                        this.ctx.lastPoint.x,
                        this.ctx.lastPoint.y,
                        t.x1,
                        t.y1,
                        t.x2,
                        t.y2,
                        t.x,
                        t.y,
                    );
                    n.push(Math.floor((o.y + i) / r) + 1),
                        n.push(Math.floor((o.y + o.h + i) / r) + 1);
                    break;
                case "rect":
                    n.push(Math.floor((t.y + i) / r) + 1),
                        n.push(Math.floor((t.y + t.h + i) / r) + 1);
            }
            for (var s = 0; s < n.length; s += 1)
                for (; this.pdf.internal.getNumberOfPages() < n[s]; )
                    w.call(this);
            return n;
        },
        w = function () {
            var t = this.fillStyle,
                e = this.strokeStyle,
                r = this.font,
                n = this.lineCap,
                i = this.lineWidth,
                a = this.lineJoin;
            this.pdf.addPage(),
                (this.fillStyle = t),
                (this.strokeStyle = e),
                (this.font = r),
                (this.lineCap = n),
                (this.lineWidth = i),
                (this.lineJoin = a);
        },
        N = function (t, e, r) {
            for (var n = 0; n < t.length; n++)
                switch (t[n].type) {
                    case "bct":
                        (t[n].x2 += e), (t[n].y2 += r);
                    case "qct":
                        (t[n].x1 += e), (t[n].y1 += r);
                    case "mt":
                    case "lt":
                    case "arc":
                    default:
                        (t[n].x += e), (t[n].y += r);
                }
            return t;
        },
        L = function (t) {
            return t.sort(function (t, e) {
                return t - e;
            });
        },
        A = function (t, e) {
            for (
                var r,
                    n,
                    i = this.fillStyle,
                    a = this.strokeStyle,
                    o = this.lineCap,
                    s = this.lineWidth,
                    c = Math.abs(s * this.ctx.transform.scaleX),
                    u = this.lineJoin,
                    h = JSON.parse(JSON.stringify(this.path)),
                    l = JSON.parse(JSON.stringify(this.path)),
                    f = [],
                    d = 0;
                d < l.length;
                d++
            )
                if (void 0 !== l[d].x)
                    for (
                        var p = y.call(this, l[d]), g = 0;
                        g < p.length;
                        g += 1
                    )
                        -1 === f.indexOf(p[g]) && f.push(p[g]);
            for (var m = 0; m < f.length; m++)
                for (; this.pdf.internal.getNumberOfPages() < f[m]; )
                    w.call(this);
            if ((L(f), this.autoPaging))
                for (var v = f[0], A = f[f.length - 1], S = v; S < A + 1; S++) {
                    this.pdf.setPage(S),
                        (this.fillStyle = i),
                        (this.strokeStyle = a),
                        (this.lineCap = o),
                        (this.lineWidth = c),
                        (this.lineJoin = u);
                    var _ =
                            this.pdf.internal.pageSize.width -
                            this.margin[3] -
                            this.margin[1],
                        P =
                            1 === S
                                ? this.posY + this.margin[0]
                                : this.margin[0],
                        k =
                            this.pdf.internal.pageSize.height -
                            this.posY -
                            this.margin[0] -
                            this.margin[2],
                        I =
                            this.pdf.internal.pageSize.height -
                            this.margin[0] -
                            this.margin[2],
                        F = 1 === S ? 0 : k + (S - 2) * I;
                    if (0 !== this.ctx.clip_path.length) {
                        var C = this.path;
                        (r = JSON.parse(JSON.stringify(this.ctx.clip_path))),
                            (this.path = N(
                                r,
                                this.posX + this.margin[3],
                                -F + P + this.ctx.prevPageLastElemOffset,
                            )),
                            x.call(this, t, !0),
                            (this.path = C);
                    }
                    if (
                        ((n = JSON.parse(JSON.stringify(h))),
                        (this.path = N(
                            n,
                            this.posX + this.margin[3],
                            -F + P + this.ctx.prevPageLastElemOffset,
                        )),
                        !1 === e || 0 === S)
                    ) {
                        var j = (S > v || S < A) && b.call(this);
                        j &&
                            (this.pdf.saveGraphicsState(),
                            this.pdf
                                .rect(
                                    this.margin[3],
                                    this.margin[0],
                                    _,
                                    I,
                                    null,
                                )
                                .clip()
                                .discardPath()),
                            x.call(this, t, e),
                            j && this.pdf.restoreGraphicsState();
                    }
                    this.lineWidth = s;
                }
            else (this.lineWidth = c), x.call(this, t, e), (this.lineWidth = s);
            this.path = h;
        },
        x = function (t, e) {
            if (
                ("stroke" !== t || e || !v.call(this)) &&
                ("stroke" === t || e || !m.call(this))
            ) {
                for (
                    var r, n, i = [], a = this.path, o = 0;
                    o < a.length;
                    o++
                ) {
                    var s = a[o];
                    switch (s.type) {
                        case "begin":
                            i.push({
                                begin: !0,
                            });
                            break;
                        case "close":
                            i.push({
                                close: !0,
                            });
                            break;
                        case "mt":
                            i.push({
                                start: s,
                                deltas: [],
                                abs: [],
                            });
                            break;
                        case "lt":
                            var c = i.length;
                            if (
                                a[o - 1] &&
                                !isNaN(a[o - 1].x) &&
                                ((r = [s.x - a[o - 1].x, s.y - a[o - 1].y]),
                                c > 0)
                            )
                                for (; c >= 0; c--)
                                    if (
                                        !0 !== i[c - 1].close &&
                                        !0 !== i[c - 1].begin
                                    ) {
                                        i[c - 1].deltas.push(r),
                                            i[c - 1].abs.push(s);
                                        break;
                                    }
                            break;
                        case "bct":
                            (r = [
                                s.x1 - a[o - 1].x,
                                s.y1 - a[o - 1].y,
                                s.x2 - a[o - 1].x,
                                s.y2 - a[o - 1].y,
                                s.x - a[o - 1].x,
                                s.y - a[o - 1].y,
                            ]),
                                i[i.length - 1].deltas.push(r);
                            break;
                        case "qct":
                            var u = a[o - 1].x + (2 / 3) * (s.x1 - a[o - 1].x),
                                h = a[o - 1].y + (2 / 3) * (s.y1 - a[o - 1].y),
                                l = s.x + (2 / 3) * (s.x1 - s.x),
                                f = s.y + (2 / 3) * (s.y1 - s.y),
                                d = s.x,
                                p = s.y;
                            (r = [
                                u - a[o - 1].x,
                                h - a[o - 1].y,
                                l - a[o - 1].x,
                                f - a[o - 1].y,
                                d - a[o - 1].x,
                                p - a[o - 1].y,
                            ]),
                                i[i.length - 1].deltas.push(r);
                            break;
                        case "arc":
                            i.push({
                                deltas: [],
                                abs: [],
                                arc: !0,
                            }),
                                Array.isArray(i[i.length - 1].abs) &&
                                    i[i.length - 1].abs.push(s);
                    }
                }
                n = e ? null : "stroke" === t ? "stroke" : "fill";
                for (var g = !1, b = 0; b < i.length; b++)
                    if (i[b].arc)
                        for (var y = i[b].abs, w = 0; w < y.length; w++) {
                            var N = y[w];
                            "arc" === N.type
                                ? P.call(
                                      this,
                                      N.x,
                                      N.y,
                                      N.radius,
                                      N.startAngle,
                                      N.endAngle,
                                      N.counterclockwise,
                                      void 0,
                                      e,
                                      !g,
                                  )
                                : j.call(this, N.x, N.y),
                                (g = !0);
                        }
                    else if (!0 === i[b].close)
                        this.pdf.internal.out("h"), (g = !1);
                    else if (!0 !== i[b].begin) {
                        var L = i[b].start.x,
                            A = i[b].start.y;
                        O.call(this, i[b].deltas, L, A), (g = !0);
                    }
                n && k.call(this, n), e && I.call(this);
            }
        },
        S = function (t) {
            var e =
                    this.pdf.internal.getFontSize() /
                    this.pdf.internal.scaleFactor,
                r = e * (this.pdf.internal.getLineHeightFactor() - 1);
            switch (this.ctx.textBaseline) {
                case "bottom":
                    return t - r;
                case "top":
                    return t + e - r;
                case "hanging":
                    return t + e - 2 * r;
                case "middle":
                    return t + e / 2 - r;
                case "ideographic":
                    return t;
                case "alphabetic":
                default:
                    return t;
            }
        },
        _ = function (t) {
            return (
                t +
                (this.pdf.internal.getFontSize() /
                    this.pdf.internal.scaleFactor) *
                    (this.pdf.internal.getLineHeightFactor() - 1)
            );
        };
    (p.prototype.createLinearGradient = function () {
        var t = function () {};
        return (
            (t.colorStops = []),
            (t.addColorStop = function (t, e) {
                this.colorStops.push([t, e]);
            }),
            (t.getColor = function () {
                return 0 === this.colorStops.length
                    ? "#000000"
                    : this.colorStops[0][1];
            }),
            (t.isCanvasGradient = !0),
            t
        );
    }),
        (p.prototype.createPattern = function () {
            return this.createLinearGradient();
        }),
        (p.prototype.createRadialGradient = function () {
            return this.createLinearGradient();
        });
    var P = function (t, e, r, n, i, a, o, s, c) {
            for (var u = M.call(this, r, n, i, a), h = 0; h < u.length; h++) {
                var l = u[h];
                0 === h &&
                    (c
                        ? F.call(this, l.x1 + t, l.y1 + e)
                        : j.call(this, l.x1 + t, l.y1 + e)),
                    B.call(this, t, e, l.x2, l.y2, l.x3, l.y3, l.x4, l.y4);
            }
            s ? I.call(this) : k.call(this, o);
        },
        k = function (t) {
            switch (t) {
                case "stroke":
                    this.pdf.internal.out("S");
                    break;
                case "fill":
                    this.pdf.internal.out("f");
            }
        },
        I = function () {
            this.pdf.clip(), this.pdf.discardPath();
        },
        F = function (t, e) {
            this.pdf.internal.out(n(t) + " " + i(e) + " m");
        },
        C = function (t) {
            var e;
            switch (t.align) {
                case "right":
                case "end":
                    e = "right";
                    break;
                case "center":
                    e = "center";
                    break;
                case "left":
                case "start":
                default:
                    e = "left";
            }
            var r = this.pdf.getTextDimensions(t.text),
                n = S.call(this, t.y),
                i = _.call(this, n) - r.h,
                a = this.ctx.transform.applyToPoint(new c(t.x, n)),
                o = this.ctx.transform.decompose(),
                s = new h();
            s = (s = (s = s.multiply(o.translate)).multiply(o.skew)).multiply(
                o.scale,
            );
            for (
                var l,
                    f,
                    d,
                    p = this.ctx.transform.applyToRectangle(
                        new u(t.x, n, r.w, r.h),
                    ),
                    g = s.applyToRectangle(new u(t.x, i, r.w, r.h)),
                    m = y.call(this, g),
                    v = [],
                    w = 0;
                w < m.length;
                w += 1
            )
                -1 === v.indexOf(m[w]) && v.push(m[w]);
            if ((L(v), this.autoPaging))
                for (var A = v[0], P = v[v.length - 1], k = A; k < P + 1; k++) {
                    this.pdf.setPage(k);
                    var I =
                            1 === k
                                ? this.posY + this.margin[0]
                                : this.margin[0],
                        F =
                            this.pdf.internal.pageSize.height -
                            this.posY -
                            this.margin[0] -
                            this.margin[2],
                        C = this.pdf.internal.pageSize.height - this.margin[2],
                        j = C - this.margin[0],
                        O = this.pdf.internal.pageSize.width - this.margin[1],
                        B = O - this.margin[3],
                        M = 1 === k ? 0 : F + (k - 2) * j;
                    if (0 !== this.ctx.clip_path.length) {
                        var E = this.path;
                        (l = JSON.parse(JSON.stringify(this.ctx.clip_path))),
                            (this.path = N(
                                l,
                                this.posX + this.margin[3],
                                -1 * M + I,
                            )),
                            x.call(this, "fill", !0),
                            (this.path = E);
                    }
                    var q = N(
                        [JSON.parse(JSON.stringify(g))],
                        this.posX + this.margin[3],
                        -M + I + this.ctx.prevPageLastElemOffset,
                    )[0];
                    t.scale >= 0.01 &&
                        ((f = this.pdf.internal.getFontSize()),
                        this.pdf.setFontSize(f * t.scale),
                        (d = this.lineWidth),
                        (this.lineWidth = d * t.scale));
                    var D = "text" !== this.autoPaging;
                    if (D || q.y + q.h <= C) {
                        if (D || (q.y >= I && q.x <= O)) {
                            var R = D
                                    ? t.text
                                    : this.pdf.splitTextToSize(
                                          t.text,
                                          t.maxWidth || O - q.x,
                                      )[0],
                                T = N(
                                    [JSON.parse(JSON.stringify(p))],
                                    this.posX + this.margin[3],
                                    -M + I + this.ctx.prevPageLastElemOffset,
                                )[0],
                                U = D && (k > A || k < P) && b.call(this);
                            U &&
                                (this.pdf.saveGraphicsState(),
                                this.pdf
                                    .rect(
                                        this.margin[3],
                                        this.margin[0],
                                        B,
                                        j,
                                        null,
                                    )
                                    .clip()
                                    .discardPath()),
                                this.pdf.text(R, T.x, T.y, {
                                    angle: t.angle,
                                    align: e,
                                    renderingMode: t.renderingMode,
                                }),
                                U && this.pdf.restoreGraphicsState();
                        }
                    } else
                        q.y < C && (this.ctx.prevPageLastElemOffset += C - q.y);
                    t.scale >= 0.01 &&
                        (this.pdf.setFontSize(f), (this.lineWidth = d));
                }
            else
                t.scale >= 0.01 &&
                    ((f = this.pdf.internal.getFontSize()),
                    this.pdf.setFontSize(f * t.scale),
                    (d = this.lineWidth),
                    (this.lineWidth = d * t.scale)),
                    this.pdf.text(t.text, a.x + this.posX, a.y + this.posY, {
                        angle: t.angle,
                        align: e,
                        renderingMode: t.renderingMode,
                        maxWidth: t.maxWidth,
                    }),
                    t.scale >= 0.01 &&
                        (this.pdf.setFontSize(f), (this.lineWidth = d));
        },
        j = function (t, e, r, a) {
            (r = r || 0),
                (a = a || 0),
                this.pdf.internal.out(n(t + r) + " " + i(e + a) + " l");
        },
        O = function (t, e, r) {
            return this.pdf.lines(t, e, r, null, null);
        },
        B = function (t, e, n, i, a, c, u, h) {
            this.pdf.internal.out(
                [
                    r(o(n + t)),
                    r(s(i + e)),
                    r(o(a + t)),
                    r(s(c + e)),
                    r(o(u + t)),
                    r(s(h + e)),
                    "c",
                ].join(" "),
            );
        },
        M = function (t, e, r, n) {
            for (var i = 2 * Math.PI, a = Math.PI / 2; e > r; ) e -= i;
            var o = Math.abs(r - e);
            o < i && n && (o = i - o);
            for (var s = [], c = n ? -1 : 1, u = e; o > 1e-5; ) {
                var h = u + c * Math.min(o, a);
                s.push(E.call(this, t, u, h)), (o -= Math.abs(h - u)), (u = h);
            }
            return s;
        },
        E = function (t, e, r) {
            var n = (r - e) / 2,
                i = t * Math.cos(n),
                a = t * Math.sin(n),
                o = i,
                s = -a,
                c = o * o + s * s,
                u = c + o * i + s * a,
                h = ((4 / 3) * (Math.sqrt(2 * c * u) - u)) / (o * a - s * i),
                l = o - h * s,
                f = s + h * o,
                d = l,
                p = -f,
                g = n + e,
                m = Math.cos(g),
                v = Math.sin(g);
            return {
                x1: t * Math.cos(e),
                y1: t * Math.sin(e),
                x2: l * m - f * v,
                y2: l * v + f * m,
                x3: d * m - p * v,
                y3: d * v + p * m,
                x4: t * Math.cos(r),
                y4: t * Math.sin(r),
            };
        },
        q = function (t) {
            return (180 * t) / Math.PI;
        },
        D = function (t, e, r, n, i, a) {
            var o = t + 0.5 * (r - t),
                s = e + 0.5 * (n - e),
                c = i + 0.5 * (r - i),
                h = a + 0.5 * (n - a),
                l = Math.min(t, i, o, c),
                f = Math.max(t, i, o, c),
                d = Math.min(e, a, s, h),
                p = Math.max(e, a, s, h);
            return new u(l, d, f - l, p - d);
        },
        R = function (t, e, r, n, i, a, o, s) {
            var c,
                h,
                l,
                f,
                d,
                p,
                g,
                m,
                v,
                b,
                y,
                w,
                N,
                L,
                A = r - t,
                x = n - e,
                S = i - r,
                _ = a - n,
                P = o - i,
                k = s - a;
            for (h = 0; h < 41; h++)
                (v =
                    (g =
                        (l = t + (c = h / 40) * A) +
                        c * ((d = r + c * S) - l)) +
                    c * (d + c * (i + c * P - d) - g)),
                    (b =
                        (m = (f = e + c * x) + c * ((p = n + c * _) - f)) +
                        c * (p + c * (a + c * k - p) - m)),
                    0 == h
                        ? ((y = v), (w = b), (N = v), (L = b))
                        : ((y = Math.min(y, v)),
                          (w = Math.min(w, b)),
                          (N = Math.max(N, v)),
                          (L = Math.max(L, b)));
            return new u(
                Math.round(y),
                Math.round(w),
                Math.round(N - y),
                Math.round(L - w),
            );
        },
        T = function () {
            if (
                this.prevLineDash ||
                this.ctx.lineDash.length ||
                this.ctx.lineDashOffset
            ) {
                var t,
                    e,
                    r =
                        ((t = this.ctx.lineDash),
                        (e = this.ctx.lineDashOffset),
                        JSON.stringify({
                            lineDash: t,
                            lineDashOffset: e,
                        }));
                this.prevLineDash !== r &&
                    (this.pdf.setLineDash(
                        this.ctx.lineDash,
                        this.ctx.lineDashOffset,
                    ),
                    (this.prevLineDash = r));
            }
        };
})(E.API),
    /**
     * @license
     * jsPDF filters PlugIn
     * Copyright (c) 2014 Aras Abbasi
     *
     * Licensed under the MIT License.
     * http://opensource.org/licenses/mit-license
     */
    (function (t) {
        var r = function (t) {
                var e, r, n, i, a, o, s, c, u, h;
                for (
                    r = [],
                        n = 0,
                        i = (t += e = "\0\0\0\0".slice(t.length % 4 || 4))
                            .length;
                    i > n;
                    n += 4
                )
                    0 !==
                    (a =
                        (t.charCodeAt(n) << 24) +
                        (t.charCodeAt(n + 1) << 16) +
                        (t.charCodeAt(n + 2) << 8) +
                        t.charCodeAt(n + 3))
                        ? ((o =
                              (a =
                                  ((a =
                                      ((a =
                                          ((a = (a - (h = a % 85)) / 85) -
                                              (u = a % 85)) /
                                          85) -
                                          (c = a % 85)) /
                                      85) -
                                      (s = a % 85)) /
                                  85) % 85),
                          r.push(o + 33, s + 33, c + 33, u + 33, h + 33))
                        : r.push(122);
                return (
                    (function (t, e) {
                        for (var r = e; r > 0; r--) t.pop();
                    })(r, e.length),
                    String.fromCharCode.apply(String, r) + "~>"
                );
            },
            n = function (t) {
                var e,
                    r,
                    n,
                    i,
                    a,
                    o = String,
                    s = "length",
                    c = 255,
                    u = "charCodeAt",
                    h = "slice",
                    l = "replace";
                for (
                    t[h](-2),
                        t = t[h](0, -2)[l](/\s/g, "")[l]("z", "!!!!!"),
                        n = [],
                        i = 0,
                        a = (t += e = "uuuuu"[h](t[s] % 5 || 5))[s];
                    a > i;
                    i += 5
                )
                    (r =
                        52200625 * (t[u](i) - 33) +
                        614125 * (t[u](i + 1) - 33) +
                        7225 * (t[u](i + 2) - 33) +
                        85 * (t[u](i + 3) - 33) +
                        (t[u](i + 4) - 33)),
                        n.push(
                            c & (r >> 24),
                            c & (r >> 16),
                            c & (r >> 8),
                            c & r,
                        );
                return (
                    (function (t, e) {
                        for (var r = e; r > 0; r--) t.pop();
                    })(n, e[s]),
                    o.fromCharCode.apply(o, n)
                );
            },
            i = function (t) {
                var e = new RegExp(/^([0-9A-Fa-f]{2})+$/);
                if (
                    (-1 !== (t = t.replace(/\s/g, "")).indexOf(">") &&
                        (t = t.substr(0, t.indexOf(">"))),
                    t.length % 2 && (t += "0"),
                    !1 === e.test(t))
                )
                    return "";
                for (var r = "", n = 0; n < t.length; n += 2)
                    r += String.fromCharCode("0x" + (t[n] + t[n + 1]));
                return r;
            },
            a = function (t) {
                for (var r = new Uint8Array(t.length), n = t.length; n--; )
                    r[n] = t.charCodeAt(n);
                return (t = (r = zlibSync(r)).reduce(function (t, e) {
                    return t + String.fromCharCode(e);
                }, ""));
            };
        t.processDataByFilters = function (t, e) {
            var o = 0,
                s = t || "",
                c = [];
            for (
                "string" == typeof (e = e || []) && (e = [e]), o = 0;
                o < e.length;
                o += 1
            )
                switch (e[o]) {
                    case "ASCII85Decode":
                    case "/ASCII85Decode":
                        (s = n(s)), c.push("/ASCII85Encode");
                        break;
                    case "ASCII85Encode":
                    case "/ASCII85Encode":
                        (s = r(s)), c.push("/ASCII85Decode");
                        break;
                    case "ASCIIHexDecode":
                    case "/ASCIIHexDecode":
                        (s = i(s)), c.push("/ASCIIHexEncode");
                        break;
                    case "ASCIIHexEncode":
                    case "/ASCIIHexEncode":
                        (s =
                            s
                                .split("")
                                .map(function (t) {
                                    return (
                                        "0" + t.charCodeAt().toString(16)
                                    ).slice(-2);
                                })
                                .join("") + ">"),
                            c.push("/ASCIIHexDecode");
                        break;
                    case "FlateEncode":
                    case "/FlateEncode":
                        (s = a(s)), c.push("/FlateDecode");
                        break;
                    default:
                        throw new Error(
                            'The filter: "' + e[o] + '" is not implemented',
                        );
                }
            return {
                data: s,
                reverseChain: c.reverse().join(" "),
            };
        };
    })(E.API),
    /**
     * @license
     * jsPDF fileloading PlugIn
     * Copyright (c) 2018 Aras Abbasi (aras.abbasi@gmail.com)
     *
     * Licensed under the MIT License.
     * http://opensource.org/licenses/mit-license
     */
    (function (t) {
        (t.loadFile = function (t, e, r) {
            return (function (t, e, r) {
                (e = !1 !== e),
                    (r = "function" == typeof r ? r : function () {});
                var n = void 0;
                try {
                    n = (function (t, e, r) {
                        var n = new XMLHttpRequest(),
                            i = 0,
                            a = function (t) {
                                var e = t.length,
                                    r = [],
                                    n = String.fromCharCode;
                                for (i = 0; i < e; i += 1)
                                    r.push(n(255 & t.charCodeAt(i)));
                                return r.join("");
                            };
                        if (
                            (n.open("GET", t, !e),
                            n.overrideMimeType(
                                "text/plain; charset=x-user-defined",
                            ),
                            !1 === e &&
                                (n.onload = function () {
                                    200 === n.status
                                        ? r(a(this.responseText))
                                        : r(void 0);
                                }),
                            n.send(null),
                            e && 200 === n.status)
                        )
                            return a(n.responseText);
                    })(t, e, r);
                } catch (t) {}
                return n;
            })(t, e, r);
        }),
            (t.loadImageFile = t.loadFile);
    })(E.API),
    (function (e) {
        function r() {
            return (
                n.html2canvas
                    ? Promise.resolve(n.html2canvas)
                    : Promise.resolve().then(function () {
                          return html2canvas$1;
                      })
            )
                .catch(function (t) {
                    return Promise.reject(
                        new Error("Could not load html2canvas: " + t),
                    );
                })
                .then(function (t) {
                    return t.default ? t.default : t;
                });
        }
        function i() {
            return (
                n.DOMPurify
                    ? Promise.resolve(n.DOMPurify)
                    : import("./purify-41b570df.js").then(function (n) {
                          return n.p;
                      })
            )
                .catch(function (t) {
                    return Promise.reject(
                        new Error("Could not load dompurify: " + t),
                    );
                })
                .then(function (t) {
                    return t.default ? t.default : t;
                });
        }
        var a = function (e) {
                var r = _typeof(e);
                return "undefined" === r
                    ? "undefined"
                    : "string" === r || e instanceof String
                      ? "string"
                      : "number" === r || e instanceof Number
                        ? "number"
                        : "function" === r || e instanceof Function
                          ? "function"
                          : e && e.constructor === Array
                            ? "array"
                            : e && 1 === e.nodeType
                              ? "element"
                              : "object" === r
                                ? "object"
                                : "unknown";
            },
            o = function (t, e) {
                var r = document.createElement(t);
                for (var n in (e.className && (r.className = e.className),
                e.innerHTML &&
                    e.dompurify &&
                    (r.innerHTML = e.dompurify.sanitize(e.innerHTML)),
                e.style))
                    r.style[n] = e.style[n];
                return r;
            },
            s = function t(e) {
                var r = Object.assign(
                        t.convert(Promise.resolve()),
                        JSON.parse(JSON.stringify(t.template)),
                    ),
                    n = t.convert(Promise.resolve(), r);
                return (n = (n = n.setProgress(1, t, 1, [t])).set(e));
            };
        ((s.prototype = Object.create(Promise.prototype)).constructor = s),
            (s.convert = function (t, e) {
                return (t.__proto__ = e || s.prototype), t;
            }),
            (s.template = {
                prop: {
                    src: null,
                    container: null,
                    overlay: null,
                    canvas: null,
                    img: null,
                    pdf: null,
                    pageSize: null,
                    callback: function () {},
                },
                progress: {
                    val: 0,
                    state: null,
                    n: 0,
                    stack: [],
                },
                opt: {
                    filename: "file.pdf",
                    margin: [0, 0, 0, 0],
                    enableLinks: !0,
                    x: 0,
                    y: 0,
                    html2canvas: {},
                    jsPDF: {},
                    backgroundColor: "transparent",
                },
            }),
            (s.prototype.from = function (t, e) {
                return this.then(function () {
                    switch (
                        (e =
                            e ||
                            (function (t) {
                                switch (a(t)) {
                                    case "string":
                                        return "string";
                                    case "element":
                                        return "canvas" ===
                                            t.nodeName.toLowerCase()
                                            ? "canvas"
                                            : "element";
                                    default:
                                        return "unknown";
                                }
                            })(t))
                    ) {
                        case "string":
                            return this.then(i).then(function (e) {
                                return this.set({
                                    src: o("div", {
                                        innerHTML: t,
                                        dompurify: e,
                                    }),
                                });
                            });
                        case "element":
                            return this.set({
                                src: t,
                            });
                        case "canvas":
                            return this.set({
                                canvas: t,
                            });
                        case "img":
                            return this.set({
                                img: t,
                            });
                        default:
                            return this.error("Unknown source type.");
                    }
                });
            }),
            (s.prototype.to = function (t) {
                switch (t) {
                    case "container":
                        return this.toContainer();
                    case "canvas":
                        return this.toCanvas();
                    case "img":
                        return this.toImg();
                    case "pdf":
                        return this.toPdf();
                    default:
                        return this.error("Invalid target.");
                }
            }),
            (s.prototype.toContainer = function () {
                return this.thenList([
                    function () {
                        return (
                            this.prop.src ||
                            this.error("Cannot duplicate - no source HTML.")
                        );
                    },
                    function () {
                        return this.prop.pageSize || this.setPageSize();
                    },
                ]).then(function () {
                    var t = {
                            position: "relative",
                            display: "inline-block",
                            width:
                                ("number" != typeof this.opt.width ||
                                isNaN(this.opt.width) ||
                                "number" != typeof this.opt.windowWidth ||
                                isNaN(this.opt.windowWidth)
                                    ? Math.max(
                                          this.prop.src.clientWidth,
                                          this.prop.src.scrollWidth,
                                          this.prop.src.offsetWidth,
                                      )
                                    : this.opt.windowWidth) + "px",
                            left: 0,
                            right: 0,
                            top: 0,
                            margin: "auto",
                            backgroundColor: this.opt.backgroundColor,
                        },
                        e = (function t(e, r) {
                            for (
                                var n =
                                        3 === e.nodeType
                                            ? document.createTextNode(
                                                  e.nodeValue,
                                              )
                                            : e.cloneNode(!1),
                                    i = e.firstChild;
                                i;
                                i = i.nextSibling
                            )
                                (!0 !== r &&
                                    1 === i.nodeType &&
                                    "SCRIPT" === i.nodeName) ||
                                    n.appendChild(t(i, r));
                            return (
                                1 === e.nodeType &&
                                    ("CANVAS" === e.nodeName
                                        ? ((n.width = e.width),
                                          (n.height = e.height),
                                          n.getContext("2d").drawImage(e, 0, 0))
                                        : ("TEXTAREA" !== e.nodeName &&
                                              "SELECT" !== e.nodeName) ||
                                          (n.value = e.value),
                                    n.addEventListener(
                                        "load",
                                        function () {
                                            (n.scrollTop = e.scrollTop),
                                                (n.scrollLeft = e.scrollLeft);
                                        },
                                        !0,
                                    )),
                                n
                            );
                        })(
                            this.prop.src,
                            this.opt.html2canvas.javascriptEnabled,
                        );
                    "BODY" === e.tagName &&
                        (t.height =
                            Math.max(
                                document.body.scrollHeight,
                                document.body.offsetHeight,
                                document.documentElement.clientHeight,
                                document.documentElement.scrollHeight,
                                document.documentElement.offsetHeight,
                            ) + "px"),
                        (this.prop.overlay = o("div", {
                            className: "html2pdf__overlay",
                            style: {
                                position: "fixed",
                                overflow: "hidden",
                                zIndex: 1e3,
                                left: "-100000px",
                                right: 0,
                                bottom: 0,
                                top: 0,
                            },
                        })),
                        (this.prop.container = o("div", {
                            className: "html2pdf__container",
                            style: t,
                        })),
                        this.prop.container.appendChild(e),
                        this.prop.container.firstChild.appendChild(
                            o("div", {
                                style: {
                                    clear: "both",
                                    border: "0 none transparent",
                                    margin: 0,
                                    padding: 0,
                                    height: 0,
                                },
                            }),
                        ),
                        (this.prop.container.style.float = "none"),
                        this.prop.overlay.appendChild(this.prop.container),
                        document.body.appendChild(this.prop.overlay),
                        (this.prop.container.firstChild.style.position =
                            "relative"),
                        (this.prop.container.height =
                            Math.max(
                                this.prop.container.firstChild.clientHeight,
                                this.prop.container.firstChild.scrollHeight,
                                this.prop.container.firstChild.offsetHeight,
                            ) + "px");
                });
            }),
            (s.prototype.toCanvas = function () {
                var t = [
                    function () {
                        return (
                            document.body.contains(this.prop.container) ||
                            this.toContainer()
                        );
                    },
                ];
                return this.thenList(t)
                    .then(r)
                    .then(function (t) {
                        var e = Object.assign({}, this.opt.html2canvas);
                        return delete e.onrendered, t(this.prop.container, e);
                    })
                    .then(function (t) {
                        (this.opt.html2canvas.onrendered || function () {})(t),
                            (this.prop.canvas = t),
                            document.body.removeChild(this.prop.overlay);
                    });
            }),
            (s.prototype.toContext2d = function () {
                var t = [
                    function () {
                        return (
                            document.body.contains(this.prop.container) ||
                            this.toContainer()
                        );
                    },
                ];
                return this.thenList(t)
                    .then(r)
                    .then(function (t) {
                        var e = this.opt.jsPDF,
                            r = this.opt.fontFaces,
                            n =
                                "number" != typeof this.opt.width ||
                                isNaN(this.opt.width) ||
                                "number" != typeof this.opt.windowWidth ||
                                isNaN(this.opt.windowWidth)
                                    ? 1
                                    : this.opt.width / this.opt.windowWidth,
                            i = Object.assign(
                                {
                                    async: !0,
                                    allowTaint: !0,
                                    scale: n,
                                    scrollX: this.opt.scrollX || 0,
                                    scrollY: this.opt.scrollY || 0,
                                    backgroundColor: "#ffffff",
                                    imageTimeout: 15e3,
                                    logging: !0,
                                    proxy: null,
                                    removeContainer: !0,
                                    foreignObjectRendering: !1,
                                    useCORS: !1,
                                },
                                this.opt.html2canvas,
                            );
                        if (
                            (delete i.onrendered,
                            (e.context2d.autoPaging =
                                void 0 === this.opt.autoPaging ||
                                this.opt.autoPaging),
                            (e.context2d.posX = this.opt.x),
                            (e.context2d.posY = this.opt.y),
                            (e.context2d.margin = this.opt.margin),
                            (e.context2d.fontFaces = r),
                            r)
                        )
                            for (var a = 0; a < r.length; ++a) {
                                var o = r[a],
                                    s = o.src.find(function (t) {
                                        return "truetype" === t.format;
                                    });
                                s && e.addFont(s.url, o.ref.name, o.ref.style);
                            }
                        return (
                            (i.windowHeight = i.windowHeight || 0),
                            (i.windowHeight =
                                0 == i.windowHeight
                                    ? Math.max(
                                          this.prop.container.clientHeight,
                                          this.prop.container.scrollHeight,
                                          this.prop.container.offsetHeight,
                                      )
                                    : i.windowHeight),
                            e.context2d.save(!0),
                            t(this.prop.container, i)
                        );
                    })
                    .then(function (t) {
                        this.opt.jsPDF.context2d.restore(!0),
                            (this.opt.html2canvas.onrendered || function () {})(
                                t,
                            ),
                            (this.prop.canvas = t),
                            document.body.removeChild(this.prop.overlay);
                    });
            }),
            (s.prototype.toImg = function () {
                return this.thenList([
                    function () {
                        return this.prop.canvas || this.toCanvas();
                    },
                ]).then(function () {
                    var t = this.prop.canvas.toDataURL(
                        "image/" + this.opt.image.type,
                        this.opt.image.quality,
                    );
                    (this.prop.img = document.createElement("img")),
                        (this.prop.img.src = t);
                });
            }),
            (s.prototype.toPdf = function () {
                return this.thenList([
                    function () {
                        return this.toContext2d();
                    },
                ]).then(function () {
                    this.prop.pdf = this.prop.pdf || this.opt.jsPDF;
                });
            }),
            (s.prototype.output = function (t, e, r) {
                return "img" === (r = r || "pdf").toLowerCase() ||
                    "image" === r.toLowerCase()
                    ? this.outputImg(t, e)
                    : this.outputPdf(t, e);
            }),
            (s.prototype.outputPdf = function (t, e) {
                return this.thenList([
                    function () {
                        return this.prop.pdf || this.toPdf();
                    },
                ]).then(function () {
                    return this.prop.pdf.output(t, e);
                });
            }),
            (s.prototype.outputImg = function (t) {
                return this.thenList([
                    function () {
                        return this.prop.img || this.toImg();
                    },
                ]).then(function () {
                    switch (t) {
                        case void 0:
                        case "img":
                            return this.prop.img;
                        case "datauristring":
                        case "dataurlstring":
                            return this.prop.img.src;
                        case "datauri":
                        case "dataurl":
                            return (document.location.href = this.prop.img.src);
                        default:
                            throw (
                                'Image output type "' +
                                t +
                                '" is not supported.'
                            );
                    }
                });
            }),
            (s.prototype.save = function (t) {
                return this.thenList([
                    function () {
                        return this.prop.pdf || this.toPdf();
                    },
                ])
                    .set(
                        t
                            ? {
                                  filename: t,
                              }
                            : null,
                    )
                    .then(function () {
                        this.prop.pdf.save(this.opt.filename);
                    });
            }),
            (s.prototype.doCallback = function () {
                return this.thenList([
                    function () {
                        return this.prop.pdf || this.toPdf();
                    },
                ]).then(function () {
                    this.prop.callback(this.prop.pdf);
                });
            }),
            (s.prototype.set = function (t) {
                if ("object" !== a(t)) return this;
                var e = Object.keys(t || {}).map(function (e) {
                    if (e in s.template.prop)
                        return function () {
                            this.prop[e] = t[e];
                        };
                    switch (e) {
                        case "margin":
                            return this.setMargin.bind(this, t.margin);
                        case "jsPDF":
                            return function () {
                                return (
                                    (this.opt.jsPDF = t.jsPDF),
                                    this.setPageSize()
                                );
                            };
                        case "pageSize":
                            return this.setPageSize.bind(this, t.pageSize);
                        default:
                            return function () {
                                this.opt[e] = t[e];
                            };
                    }
                }, this);
                return this.then(function () {
                    return this.thenList(e);
                });
            }),
            (s.prototype.get = function (t, e) {
                return this.then(function () {
                    var r = t in s.template.prop ? this.prop[t] : this.opt[t];
                    return e ? e(r) : r;
                });
            }),
            (s.prototype.setMargin = function (t) {
                return this.then(function () {
                    switch (a(t)) {
                        case "number":
                            t = [t, t, t, t];
                        case "array":
                            if (
                                (2 === t.length &&
                                    (t = [t[0], t[1], t[0], t[1]]),
                                4 === t.length)
                            )
                                break;
                        default:
                            return this.error("Invalid margin array.");
                    }
                    this.opt.margin = t;
                }).then(this.setPageSize);
            }),
            (s.prototype.setPageSize = function (t) {
                function e(t, e) {
                    return Math.floor(((t * e) / 72) * 96);
                }
                return this.then(function () {
                    (t = t || E.getPageSize(this.opt.jsPDF)).hasOwnProperty(
                        "inner",
                    ) ||
                        ((t.inner = {
                            width:
                                t.width -
                                this.opt.margin[1] -
                                this.opt.margin[3],
                            height:
                                t.height -
                                this.opt.margin[0] -
                                this.opt.margin[2],
                        }),
                        (t.inner.px = {
                            width: e(t.inner.width, t.k),
                            height: e(t.inner.height, t.k),
                        }),
                        (t.inner.ratio = t.inner.height / t.inner.width)),
                        (this.prop.pageSize = t);
                });
            }),
            (s.prototype.setProgress = function (t, e, r, n) {
                return (
                    null != t && (this.progress.val = t),
                    null != e && (this.progress.state = e),
                    null != r && (this.progress.n = r),
                    null != n && (this.progress.stack = n),
                    (this.progress.ratio =
                        this.progress.val / this.progress.state),
                    this
                );
            }),
            (s.prototype.updateProgress = function (t, e, r, n) {
                return this.setProgress(
                    t ? this.progress.val + t : null,
                    e || null,
                    r ? this.progress.n + r : null,
                    n ? this.progress.stack.concat(n) : null,
                );
            }),
            (s.prototype.then = function (t, e) {
                var r = this;
                return this.thenCore(t, e, function (t, e) {
                    return (
                        r.updateProgress(null, null, 1, [t]),
                        Promise.prototype.then
                            .call(this, function (e) {
                                return r.updateProgress(null, t), e;
                            })
                            .then(t, e)
                            .then(function (t) {
                                return r.updateProgress(1), t;
                            })
                    );
                });
            }),
            (s.prototype.thenCore = function (t, e, r) {
                r = r || Promise.prototype.then;
                t && (t = t.bind(this)), e && (e = e.bind(this));
                var n =
                        -1 !== Promise.toString().indexOf("[native code]") &&
                        "Promise" === Promise.name
                            ? this
                            : s.convert(
                                  Object.assign({}, this),
                                  Promise.prototype,
                              ),
                    i = r.call(n, t, e);
                return s.convert(i, this.__proto__);
            }),
            (s.prototype.thenExternal = function (t, e) {
                return Promise.prototype.then.call(this, t, e);
            }),
            (s.prototype.thenList = function (t) {
                var e = this;
                return (
                    t.forEach(function (t) {
                        e = e.thenCore(t);
                    }),
                    e
                );
            }),
            (s.prototype.catch = function (t) {
                t && (t = t.bind(this));
                var e = Promise.prototype.catch.call(this, t);
                return s.convert(e, this);
            }),
            (s.prototype.catchExternal = function (t) {
                return Promise.prototype.catch.call(this, t);
            }),
            (s.prototype.error = function (t) {
                return this.then(function () {
                    throw new Error(t);
                });
            }),
            (s.prototype.using = s.prototype.set),
            (s.prototype.saveAs = s.prototype.save),
            (s.prototype.export = s.prototype.output),
            (s.prototype.run = s.prototype.then),
            (E.getPageSize = function (e, r, n) {
                if ("object" === _typeof(e)) {
                    var i = e;
                    (e = i.orientation), (r = i.unit || r), (n = i.format || n);
                }
                (r = r || "mm"),
                    (n = n || "a4"),
                    (e = ("" + (e || "P")).toLowerCase());
                var a,
                    o = ("" + n).toLowerCase(),
                    s = {
                        a0: [2383.94, 3370.39],
                        a1: [1683.78, 2383.94],
                        a2: [1190.55, 1683.78],
                        a3: [841.89, 1190.55],
                        a4: [595.28, 841.89],
                        a5: [419.53, 595.28],
                        a6: [297.64, 419.53],
                        a7: [209.76, 297.64],
                        a8: [147.4, 209.76],
                        a9: [104.88, 147.4],
                        a10: [73.7, 104.88],
                        b0: [2834.65, 4008.19],
                        b1: [2004.09, 2834.65],
                        b2: [1417.32, 2004.09],
                        b3: [1000.63, 1417.32],
                        b4: [708.66, 1000.63],
                        b5: [498.9, 708.66],
                        b6: [354.33, 498.9],
                        b7: [249.45, 354.33],
                        b8: [175.75, 249.45],
                        b9: [124.72, 175.75],
                        b10: [87.87, 124.72],
                        c0: [2599.37, 3676.54],
                        c1: [1836.85, 2599.37],
                        c2: [1298.27, 1836.85],
                        c3: [918.43, 1298.27],
                        c4: [649.13, 918.43],
                        c5: [459.21, 649.13],
                        c6: [323.15, 459.21],
                        c7: [229.61, 323.15],
                        c8: [161.57, 229.61],
                        c9: [113.39, 161.57],
                        c10: [79.37, 113.39],
                        dl: [311.81, 623.62],
                        letter: [612, 792],
                        "government-letter": [576, 756],
                        legal: [612, 1008],
                        "junior-legal": [576, 360],
                        ledger: [1224, 792],
                        tabloid: [792, 1224],
                        "credit-card": [153, 243],
                    };
                switch (r) {
                    case "pt":
                        a = 1;
                        break;
                    case "mm":
                        a = 72 / 25.4;
                        break;
                    case "cm":
                        a = 72 / 2.54;
                        break;
                    case "in":
                        a = 72;
                        break;
                    case "px":
                        a = 0.75;
                        break;
                    case "pc":
                    case "em":
                        a = 12;
                        break;
                    case "ex":
                        a = 6;
                        break;
                    default:
                        throw "Invalid unit: " + r;
                }
                var c,
                    u = 0,
                    h = 0;
                if (s.hasOwnProperty(o)) (u = s[o][1] / a), (h = s[o][0] / a);
                else
                    try {
                        (u = n[1]), (h = n[0]);
                    } catch (t) {
                        throw new Error("Invalid format: " + n);
                    }
                if ("p" === e || "portrait" === e)
                    (e = "p"), h > u && ((c = h), (h = u), (u = c));
                else {
                    if ("l" !== e && "landscape" !== e)
                        throw "Invalid orientation: " + e;
                    (e = "l"), u > h && ((c = h), (h = u), (u = c));
                }
                return {
                    width: h,
                    height: u,
                    unit: r,
                    k: a,
                    orientation: e,
                };
            }),
            (e.html = function (t, e) {
                ((e = e || {}).callback = e.callback || function () {}),
                    (e.html2canvas = e.html2canvas || {}),
                    (e.html2canvas.canvas =
                        e.html2canvas.canvas || this.canvas),
                    (e.jsPDF = e.jsPDF || this),
                    (e.fontFaces = e.fontFaces ? e.fontFaces.map(jt) : null);
                var r = new s(e);
                return e.worker ? r : r.from(t).doCallback();
            });
    })(E.API),
    (E.API.addJS = function (t) {
        return (
            (Ht = t),
            this.internal.events.subscribe("postPutResources", function () {
                (Ut = this.internal.newObject()),
                    this.internal.out("<<"),
                    this.internal.out(
                        "/Names [(EmbeddedJS) " + (Ut + 1) + " 0 R]",
                    ),
                    this.internal.out(">>"),
                    this.internal.out("endobj"),
                    (zt = this.internal.newObject()),
                    this.internal.out("<<"),
                    this.internal.out("/S /JavaScript"),
                    this.internal.out("/JS (" + Ht + ")"),
                    this.internal.out(">>"),
                    this.internal.out("endobj");
            }),
            this.internal.events.subscribe("putCatalog", function () {
                void 0 !== Ut &&
                    void 0 !== zt &&
                    this.internal.out("/Names <</JavaScript " + Ut + " 0 R>>");
            }),
            this
        );
    }),
    /**
     * @license
     * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
     *
     * Licensed under the MIT License.
     * http://opensource.org/licenses/mit-license
     */
    (function (t) {
        var e;
        t.events.push([
            "postPutResources",
            function () {
                var t = this,
                    r = /^(\d+) 0 obj$/;
                if (this.outline.root.children.length > 0)
                    for (
                        var n = t.outline.render().split(/\r\n/), i = 0;
                        i < n.length;
                        i++
                    ) {
                        var a = n[i],
                            o = r.exec(a);
                        if (null != o) {
                            var s = o[1];
                            t.internal.newObjectDeferredBegin(s, !1);
                        }
                        t.internal.write(a);
                    }
                if (this.outline.createNamedDestinations) {
                    var c = this.internal.pages.length,
                        u = [];
                    for (i = 0; i < c; i++) {
                        var h = t.internal.newObject();
                        u.push(h);
                        var l = t.internal.getPageInfo(i + 1);
                        t.internal.write(
                            "<< /D[" +
                                l.objId +
                                " 0 R /XYZ null null null]>> endobj",
                        );
                    }
                    var f = t.internal.newObject();
                    t.internal.write("<< /Names [ ");
                    for (i = 0; i < u.length; i++)
                        t.internal.write(
                            "(page_" + (i + 1) + ")" + u[i] + " 0 R",
                        );
                    t.internal.write(" ] >>", "endobj"),
                        (e = t.internal.newObject()),
                        t.internal.write("<< /Dests " + f + " 0 R"),
                        t.internal.write(">>", "endobj");
                }
            },
        ]),
            t.events.push([
                "putCatalog",
                function () {
                    this.outline.root.children.length > 0 &&
                        (this.internal.write(
                            "/Outlines",
                            this.outline.makeRef(this.outline.root),
                        ),
                        this.outline.createNamedDestinations &&
                            this.internal.write("/Names " + e + " 0 R"));
                },
            ]),
            t.events.push([
                "initialized",
                function () {
                    var t = this;
                    (t.outline = {
                        createNamedDestinations: !1,
                        root: {
                            children: [],
                        },
                    }),
                        (t.outline.add = function (t, e, r) {
                            var n = {
                                title: e,
                                options: r,
                                children: [],
                            };
                            return (
                                null == t && (t = this.root),
                                t.children.push(n),
                                n
                            );
                        }),
                        (t.outline.render = function () {
                            return (
                                (this.ctx = {}),
                                (this.ctx.val = ""),
                                (this.ctx.pdf = t),
                                this.genIds_r(this.root),
                                this.renderRoot(this.root),
                                this.renderItems(this.root),
                                this.ctx.val
                            );
                        }),
                        (t.outline.genIds_r = function (e) {
                            e.id = t.internal.newObjectDeferred();
                            for (var r = 0; r < e.children.length; r++)
                                this.genIds_r(e.children[r]);
                        }),
                        (t.outline.renderRoot = function (t) {
                            this.objStart(t),
                                this.line("/Type /Outlines"),
                                t.children.length > 0 &&
                                    (this.line(
                                        "/First " + this.makeRef(t.children[0]),
                                    ),
                                    this.line(
                                        "/Last " +
                                            this.makeRef(
                                                t.children[
                                                    t.children.length - 1
                                                ],
                                            ),
                                    )),
                                this.line(
                                    "/Count " +
                                        this.count_r(
                                            {
                                                count: 0,
                                            },
                                            t,
                                        ),
                                ),
                                this.objEnd();
                        }),
                        (t.outline.renderItems = function (e) {
                            for (
                                var r =
                                        this.ctx.pdf.internal
                                            .getVerticalCoordinateString,
                                    n = 0;
                                n < e.children.length;
                                n++
                            ) {
                                var i = e.children[n];
                                this.objStart(i),
                                    this.line(
                                        "/Title " + this.makeString(i.title),
                                    ),
                                    this.line("/Parent " + this.makeRef(e)),
                                    n > 0 &&
                                        this.line(
                                            "/Prev " +
                                                this.makeRef(e.children[n - 1]),
                                        ),
                                    n < e.children.length - 1 &&
                                        this.line(
                                            "/Next " +
                                                this.makeRef(e.children[n + 1]),
                                        ),
                                    i.children.length > 0 &&
                                        (this.line(
                                            "/First " +
                                                this.makeRef(i.children[0]),
                                        ),
                                        this.line(
                                            "/Last " +
                                                this.makeRef(
                                                    i.children[
                                                        i.children.length - 1
                                                    ],
                                                ),
                                        ));
                                var a = (this.count = this.count_r(
                                    {
                                        count: 0,
                                    },
                                    i,
                                ));
                                if (
                                    (a > 0 && this.line("/Count " + a),
                                    i.options && i.options.pageNumber)
                                ) {
                                    var o = t.internal.getPageInfo(
                                        i.options.pageNumber,
                                    );
                                    this.line(
                                        "/Dest [" +
                                            o.objId +
                                            " 0 R /XYZ 0 " +
                                            r(0) +
                                            " 0]",
                                    );
                                }
                                this.objEnd();
                            }
                            for (var s = 0; s < e.children.length; s++)
                                this.renderItems(e.children[s]);
                        }),
                        (t.outline.line = function (t) {
                            this.ctx.val += t + "\r\n";
                        }),
                        (t.outline.makeRef = function (t) {
                            return t.id + " 0 R";
                        }),
                        (t.outline.makeString = function (e) {
                            return "(" + t.internal.pdfEscape(e) + ")";
                        }),
                        (t.outline.objStart = function (t) {
                            this.ctx.val += "\r\n" + t.id + " 0 obj\r\n<<\r\n";
                        }),
                        (t.outline.objEnd = function () {
                            this.ctx.val += ">> \r\nendobj\r\n";
                        }),
                        (t.outline.count_r = function (t, e) {
                            for (var r = 0; r < e.children.length; r++)
                                t.count++, this.count_r(t, e.children[r]);
                            return t.count;
                        });
                },
            ]);
    })(E.API),
    /**
     * @license
     *
     * Licensed under the MIT License.
     * http://opensource.org/licenses/mit-license
     */
    (function (t) {
        var e = [192, 193, 194, 195, 196, 197, 198, 199];
        t.processJPEG = function (t, r, n, i, a, o) {
            var s,
                c = this.decode.DCT_DECODE,
                u = null;
            if (
                "string" == typeof t ||
                this.__addimage__.isArrayBuffer(t) ||
                this.__addimage__.isArrayBufferView(t)
            ) {
                switch (
                    ((t = a || t),
                    (t = this.__addimage__.isArrayBuffer(t)
                        ? new Uint8Array(t)
                        : t),
                    (s = (function (t) {
                        for (
                            var r,
                                n = 256 * t.charCodeAt(4) + t.charCodeAt(5),
                                i = t.length,
                                a = {
                                    width: 0,
                                    height: 0,
                                    numcomponents: 1,
                                },
                                o = 4;
                            o < i;
                            o += 2
                        ) {
                            if (
                                ((o += n),
                                -1 !== e.indexOf(t.charCodeAt(o + 1)))
                            ) {
                                (r =
                                    256 * t.charCodeAt(o + 5) +
                                    t.charCodeAt(o + 6)),
                                    (a = {
                                        width:
                                            256 * t.charCodeAt(o + 7) +
                                            t.charCodeAt(o + 8),
                                        height: r,
                                        numcomponents: t.charCodeAt(o + 9),
                                    });
                                break;
                            }
                            n = 256 * t.charCodeAt(o + 2) + t.charCodeAt(o + 3);
                        }
                        return a;
                    })(
                        (t = this.__addimage__.isArrayBufferView(t)
                            ? this.__addimage__.arrayBufferToBinaryString(t)
                            : t),
                    )).numcomponents)
                ) {
                    case 1:
                        o = this.color_spaces.DEVICE_GRAY;
                        break;
                    case 4:
                        o = this.color_spaces.DEVICE_CMYK;
                        break;
                    case 3:
                        o = this.color_spaces.DEVICE_RGB;
                }
                u = {
                    data: t,
                    width: s.width,
                    height: s.height,
                    colorSpace: o,
                    bitsPerComponent: 8,
                    filter: c,
                    index: r,
                    alias: n,
                };
            }
            return u;
        };
    })(E.API);
var Vt,
    Gt,
    Yt,
    Jt,
    Xt,
    Kt = (function () {
        var t, e, i;
        function a(t) {
            var e, r, n, i, a, o, s, c, u, h, l, f, d, p;
            for (
                this.data = t,
                    this.pos = 8,
                    this.palette = [],
                    this.imgData = [],
                    this.transparency = {},
                    this.animation = null,
                    this.text = {},
                    o = null;
                ;

            ) {
                switch (
                    ((e = this.readUInt32()),
                    (u = function () {
                        var t, e;
                        for (e = [], t = 0; t < 4; ++t)
                            e.push(String.fromCharCode(this.data[this.pos++]));
                        return e;
                    }
                        .call(this)
                        .join("")))
                ) {
                    case "IHDR":
                        (this.width = this.readUInt32()),
                            (this.height = this.readUInt32()),
                            (this.bits = this.data[this.pos++]),
                            (this.colorType = this.data[this.pos++]),
                            (this.compressionMethod = this.data[this.pos++]),
                            (this.filterMethod = this.data[this.pos++]),
                            (this.interlaceMethod = this.data[this.pos++]);
                        break;
                    case "acTL":
                        this.animation = {
                            numFrames: this.readUInt32(),
                            numPlays: this.readUInt32() || 1 / 0,
                            frames: [],
                        };
                        break;
                    case "PLTE":
                        this.palette = this.read(e);
                        break;
                    case "fcTL":
                        o && this.animation.frames.push(o),
                            (this.pos += 4),
                            (o = {
                                width: this.readUInt32(),
                                height: this.readUInt32(),
                                xOffset: this.readUInt32(),
                                yOffset: this.readUInt32(),
                            }),
                            (a = this.readUInt16()),
                            (i = this.readUInt16() || 100),
                            (o.delay = (1e3 * a) / i),
                            (o.disposeOp = this.data[this.pos++]),
                            (o.blendOp = this.data[this.pos++]),
                            (o.data = []);
                        break;
                    case "IDAT":
                    case "fdAT":
                        for (
                            "fdAT" === u && ((this.pos += 4), (e -= 4)),
                                t =
                                    (null != o ? o.data : void 0) ||
                                    this.imgData,
                                f = 0;
                            0 <= e ? f < e : f > e;
                            0 <= e ? ++f : --f
                        )
                            t.push(this.data[this.pos++]);
                        break;
                    case "tRNS":
                        switch (((this.transparency = {}), this.colorType)) {
                            case 3:
                                if (
                                    ((n = this.palette.length / 3),
                                    (this.transparency.indexed = this.read(e)),
                                    this.transparency.indexed.length > n)
                                )
                                    throw new Error(
                                        "More transparent colors than palette size",
                                    );
                                if (
                                    (h = n - this.transparency.indexed.length) >
                                    0
                                )
                                    for (
                                        d = 0;
                                        0 <= h ? d < h : d > h;
                                        0 <= h ? ++d : --d
                                    )
                                        this.transparency.indexed.push(255);
                                break;
                            case 0:
                                this.transparency.grayscale = this.read(e)[0];
                                break;
                            case 2:
                                this.transparency.rgb = this.read(e);
                        }
                        break;
                    case "tEXt":
                        (s = (l = this.read(e)).indexOf(0)),
                            (c = String.fromCharCode.apply(
                                String,
                                l.slice(0, s),
                            )),
                            (this.text[c] = String.fromCharCode.apply(
                                String,
                                l.slice(s + 1),
                            ));
                        break;
                    case "IEND":
                        return (
                            o && this.animation.frames.push(o),
                            (this.colors = function () {
                                switch (this.colorType) {
                                    case 0:
                                    case 3:
                                    case 4:
                                        return 1;
                                    case 2:
                                    case 6:
                                        return 3;
                                }
                            }.call(this)),
                            (this.hasAlphaChannel =
                                4 === (p = this.colorType) || 6 === p),
                            (r = this.colors + (this.hasAlphaChannel ? 1 : 0)),
                            (this.pixelBitlength = this.bits * r),
                            (this.colorSpace = function () {
                                switch (this.colors) {
                                    case 1:
                                        return "DeviceGray";
                                    case 3:
                                        return "DeviceRGB";
                                }
                            }.call(this)),
                            void (this.imgData = new Uint8Array(this.imgData))
                        );
                    default:
                        this.pos += e;
                }
                if (((this.pos += 4), this.pos > this.data.length))
                    throw new Error("Incomplete or corrupt PNG file");
            }
        }
        (a.prototype.read = function (t) {
            var e, r;
            for (r = [], e = 0; 0 <= t ? e < t : e > t; 0 <= t ? ++e : --e)
                r.push(this.data[this.pos++]);
            return r;
        }),
            (a.prototype.readUInt32 = function () {
                return (
                    (this.data[this.pos++] << 24) |
                    (this.data[this.pos++] << 16) |
                    (this.data[this.pos++] << 8) |
                    this.data[this.pos++]
                );
            }),
            (a.prototype.readUInt16 = function () {
                return (this.data[this.pos++] << 8) | this.data[this.pos++];
            }),
            (a.prototype.decodePixels = function (t) {
                var e = this.pixelBitlength / 8,
                    n = new Uint8Array(this.width * this.height * e),
                    i = 0,
                    a = this;
                if ((null == t && (t = this.imgData), 0 === t.length))
                    return new Uint8Array(0);
                function o(r, o, s, c) {
                    var u,
                        h,
                        l,
                        f,
                        d,
                        p,
                        g,
                        m,
                        v,
                        b,
                        y,
                        w,
                        N,
                        L,
                        A,
                        x,
                        S,
                        _,
                        P,
                        k,
                        I,
                        F = Math.ceil((a.width - r) / s),
                        C = Math.ceil((a.height - o) / c),
                        j = a.width == F && a.height == C;
                    for (
                        L = e * F,
                            w = j ? n : new Uint8Array(L * C),
                            p = t.length,
                            N = 0,
                            h = 0;
                        N < C && i < p;

                    ) {
                        switch (t[i++]) {
                            case 0:
                                for (f = S = 0; S < L; f = S += 1)
                                    w[h++] = t[i++];
                                break;
                            case 1:
                                for (f = _ = 0; _ < L; f = _ += 1)
                                    (u = t[i++]),
                                        (d = f < e ? 0 : w[h - e]),
                                        (w[h++] = (u + d) % 256);
                                break;
                            case 2:
                                for (f = P = 0; P < L; f = P += 1)
                                    (u = t[i++]),
                                        (l = (f - (f % e)) / e),
                                        (A =
                                            N &&
                                            w[(N - 1) * L + l * e + (f % e)]),
                                        (w[h++] = (A + u) % 256);
                                break;
                            case 3:
                                for (f = k = 0; k < L; f = k += 1)
                                    (u = t[i++]),
                                        (l = (f - (f % e)) / e),
                                        (d = f < e ? 0 : w[h - e]),
                                        (A =
                                            N &&
                                            w[(N - 1) * L + l * e + (f % e)]),
                                        (w[h++] =
                                            (u + Math.floor((d + A) / 2)) %
                                            256);
                                break;
                            case 4:
                                for (f = I = 0; I < L; f = I += 1)
                                    (u = t[i++]),
                                        (l = (f - (f % e)) / e),
                                        (d = f < e ? 0 : w[h - e]),
                                        0 === N
                                            ? (A = x = 0)
                                            : ((A =
                                                  w[
                                                      (N - 1) * L +
                                                          l * e +
                                                          (f % e)
                                                  ]),
                                              (x =
                                                  l &&
                                                  w[
                                                      (N - 1) * L +
                                                          (l - 1) * e +
                                                          (f % e)
                                                  ])),
                                        (g = d + A - x),
                                        (m = Math.abs(g - d)),
                                        (b = Math.abs(g - A)),
                                        (y = Math.abs(g - x)),
                                        (v =
                                            m <= b && m <= y
                                                ? d
                                                : b <= y
                                                  ? A
                                                  : x),
                                        (w[h++] = (u + v) % 256);
                                break;
                            default:
                                throw new Error(
                                    "Invalid filter algorithm: " + t[i - 1],
                                );
                        }
                        if (!j) {
                            var O = ((o + N * c) * a.width + r) * e,
                                B = N * L;
                            for (f = 0; f < F; f += 1) {
                                for (var M = 0; M < e; M += 1) n[O++] = w[B++];
                                O += (s - 1) * e;
                            }
                        }
                        N++;
                    }
                }
                return (
                    (t = unzlibSync(t)),
                    1 == a.interlaceMethod
                        ? (o(0, 0, 8, 8),
                          o(4, 0, 8, 8),
                          o(0, 4, 4, 8),
                          o(2, 0, 4, 4),
                          o(0, 2, 2, 4),
                          o(1, 0, 2, 2),
                          o(0, 1, 1, 2))
                        : o(0, 0, 1, 1),
                    n
                );
            }),
            (a.prototype.decodePalette = function () {
                var t, e, r, n, i, a, o, s, c;
                for (
                    r = this.palette,
                        a = this.transparency.indexed || [],
                        i = new Uint8Array((a.length || 0) + r.length),
                        n = 0,
                        t = 0,
                        e = o = 0,
                        s = r.length;
                    o < s;
                    e = o += 3
                )
                    (i[n++] = r[e]),
                        (i[n++] = r[e + 1]),
                        (i[n++] = r[e + 2]),
                        (i[n++] = null != (c = a[t++]) ? c : 255);
                return i;
            }),
            (a.prototype.copyToImageData = function (t, e) {
                var r, n, i, a, o, s, c, u, h, l, f;
                if (
                    ((n = this.colors),
                    (h = null),
                    (r = this.hasAlphaChannel),
                    this.palette.length &&
                        ((h =
                            null != (f = this._decodedPalette)
                                ? f
                                : (this._decodedPalette =
                                      this.decodePalette())),
                        (n = 4),
                        (r = !0)),
                    (u = (i = t.data || t).length),
                    (o = h || e),
                    (a = s = 0),
                    1 === n)
                )
                    for (; a < u; )
                        (c = h ? 4 * e[a / 4] : s),
                            (l = o[c++]),
                            (i[a++] = l),
                            (i[a++] = l),
                            (i[a++] = l),
                            (i[a++] = r ? o[c++] : 255),
                            (s = c);
                else
                    for (; a < u; )
                        (c = h ? 4 * e[a / 4] : s),
                            (i[a++] = o[c++]),
                            (i[a++] = o[c++]),
                            (i[a++] = o[c++]),
                            (i[a++] = r ? o[c++] : 255),
                            (s = c);
            }),
            (a.prototype.decode = function () {
                var t;
                return (
                    (t = new Uint8Array(this.width * this.height * 4)),
                    this.copyToImageData(t, this.decodePixels()),
                    t
                );
            });
        var o = function () {
            if ("[object Window]" === Object.prototype.toString.call(n)) {
                try {
                    (e = n.document.createElement("canvas")),
                        (i = e.getContext("2d"));
                } catch (t) {
                    return !1;
                }
                return !0;
            }
            return !1;
        };
        return (
            o(),
            (t = function (t) {
                var r;
                if (!0 === o())
                    return (
                        (i.width = t.width),
                        (i.height = t.height),
                        i.clearRect(0, 0, t.width, t.height),
                        i.putImageData(t, 0, 0),
                        ((r = new Image()).src = e.toDataURL()),
                        r
                    );
                throw new Error(
                    "This method requires a Browser with Canvas-capability.",
                );
            }),
            (a.prototype.decodeFrames = function (e) {
                var r, n, i, a, o, s, c, u;
                if (this.animation) {
                    for (
                        u = [],
                            n = o = 0,
                            s = (c = this.animation.frames).length;
                        o < s;
                        n = ++o
                    )
                        (r = c[n]),
                            (i = e.createImageData(r.width, r.height)),
                            (a = this.decodePixels(new Uint8Array(r.data))),
                            this.copyToImageData(i, a),
                            (r.imageData = i),
                            u.push((r.image = t(i)));
                    return u;
                }
            }),
            (a.prototype.renderFrame = function (t, e) {
                var r, n, i;
                return (
                    (r = (n = this.animation.frames)[e]),
                    (i = n[e - 1]),
                    0 === e && t.clearRect(0, 0, this.width, this.height),
                    1 === (null != i ? i.disposeOp : void 0)
                        ? t.clearRect(i.xOffset, i.yOffset, i.width, i.height)
                        : 2 === (null != i ? i.disposeOp : void 0) &&
                          t.putImageData(i.imageData, i.xOffset, i.yOffset),
                    0 === r.blendOp &&
                        t.clearRect(r.xOffset, r.yOffset, r.width, r.height),
                    t.drawImage(r.image, r.xOffset, r.yOffset)
                );
            }),
            (a.prototype.animate = function (t) {
                var e,
                    r,
                    n,
                    i,
                    a,
                    o,
                    s = this;
                return (
                    (r = 0),
                    (o = this.animation),
                    (i = o.numFrames),
                    (n = o.frames),
                    (a = o.numPlays),
                    (e = function () {
                        var o, c;
                        if (
                            ((o = r++ % i),
                            (c = n[o]),
                            s.renderFrame(t, o),
                            i > 1 && r / i < a)
                        )
                            return (s.animation._timeout = setTimeout(
                                e,
                                c.delay,
                            ));
                    })()
                );
            }),
            (a.prototype.stopAnimation = function () {
                var t;
                return clearTimeout(
                    null != (t = this.animation) ? t._timeout : void 0,
                );
            }),
            (a.prototype.render = function (t) {
                var e, r;
                return (
                    t._png && t._png.stopAnimation(),
                    (t._png = this),
                    (t.width = this.width),
                    (t.height = this.height),
                    (e = t.getContext("2d")),
                    this.animation
                        ? (this.decodeFrames(e), this.animate(e))
                        : ((r = e.createImageData(this.width, this.height)),
                          this.copyToImageData(r, this.decodePixels()),
                          e.putImageData(r, 0, 0))
                );
            }),
            a
        );
    })();
/**
 * @license
 *
 * Copyright (c) 2014 James Robb, https://github.com/jamesbrobb
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */
/**
 * @license
 * (c) Dean McNamee <dean@gmail.com>, 2013.
 *
 * https://github.com/deanm/omggif
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to
 * deal in the Software without restriction, including without limitation the
 * rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
 * sell copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
 * IN THE SOFTWARE.
 *
 * omggif is a JavaScript implementation of a GIF 89a encoder and decoder,
 * including animation and compression.  It does not rely on any specific
 * underlying system, so should run in the browser, Node, or Plask.
 */
function Zt(t) {
    var e = 0;
    if (
        71 !== t[e++] ||
        73 !== t[e++] ||
        70 !== t[e++] ||
        56 !== t[e++] ||
        56 != ((t[e++] + 1) & 253) ||
        97 !== t[e++]
    )
        throw new Error("Invalid GIF 87a/89a header.");
    var r = t[e++] | (t[e++] << 8),
        n = t[e++] | (t[e++] << 8),
        i = t[e++],
        a = i >> 7,
        o = 1 << ((7 & i) + 1);
    t[e++];
    t[e++];
    var s = null,
        c = null;
    a && ((s = e), (c = o), (e += 3 * o));
    var u = !0,
        h = [],
        l = 0,
        f = null,
        d = 0,
        p = null;
    for (this.width = r, this.height = n; u && e < t.length; )
        switch (t[e++]) {
            case 33:
                switch (t[e++]) {
                    case 255:
                        if (
                            11 !== t[e] ||
                            (78 == t[e + 1] &&
                                69 == t[e + 2] &&
                                84 == t[e + 3] &&
                                83 == t[e + 4] &&
                                67 == t[e + 5] &&
                                65 == t[e + 6] &&
                                80 == t[e + 7] &&
                                69 == t[e + 8] &&
                                50 == t[e + 9] &&
                                46 == t[e + 10] &&
                                48 == t[e + 11] &&
                                3 == t[e + 12] &&
                                1 == t[e + 13] &&
                                0 == t[e + 16])
                        )
                            (e += 14), (p = t[e++] | (t[e++] << 8)), e++;
                        else
                            for (e += 12; ; ) {
                                if (!((P = t[e++]) >= 0))
                                    throw Error("Invalid block size");
                                if (0 === P) break;
                                e += P;
                            }
                        break;
                    case 249:
                        if (4 !== t[e++] || 0 !== t[e + 4])
                            throw new Error(
                                "Invalid graphics extension block.",
                            );
                        var g = t[e++];
                        (l = t[e++] | (t[e++] << 8)),
                            (f = t[e++]),
                            0 == (1 & g) && (f = null),
                            (d = (g >> 2) & 7),
                            e++;
                        break;
                    case 254:
                        for (;;) {
                            if (!((P = t[e++]) >= 0))
                                throw Error("Invalid block size");
                            if (0 === P) break;
                            e += P;
                        }
                        break;
                    default:
                        throw new Error(
                            "Unknown graphic control label: 0x" +
                                t[e - 1].toString(16),
                        );
                }
                break;
            case 44:
                var m = t[e++] | (t[e++] << 8),
                    v = t[e++] | (t[e++] << 8),
                    b = t[e++] | (t[e++] << 8),
                    y = t[e++] | (t[e++] << 8),
                    w = t[e++],
                    N = (w >> 6) & 1,
                    L = 1 << ((7 & w) + 1),
                    A = s,
                    x = c,
                    S = !1;
                if (w >> 7) {
                    S = !0;
                    (A = e), (x = L), (e += 3 * L);
                }
                var _ = e;
                for (e++; ; ) {
                    var P;
                    if (!((P = t[e++]) >= 0)) throw Error("Invalid block size");
                    if (0 === P) break;
                    e += P;
                }
                h.push({
                    x: m,
                    y: v,
                    width: b,
                    height: y,
                    has_local_palette: S,
                    palette_offset: A,
                    palette_size: x,
                    data_offset: _,
                    data_length: e - _,
                    transparent_index: f,
                    interlaced: !!N,
                    delay: l,
                    disposal: d,
                });
                break;
            case 59:
                u = !1;
                break;
            default:
                throw new Error(
                    "Unknown gif block: 0x" + t[e - 1].toString(16),
                );
        }
    (this.numFrames = function () {
        return h.length;
    }),
        (this.loopCount = function () {
            return p;
        }),
        (this.frameInfo = function (t) {
            if (t < 0 || t >= h.length)
                throw new Error("Frame index out of range.");
            return h[t];
        }),
        (this.decodeAndBlitFrameBGRA = function (e, n) {
            var i = this.frameInfo(e),
                a = i.width * i.height,
                o = new Uint8Array(a);
            $t(t, i.data_offset, o, a);
            var s = i.palette_offset,
                c = i.transparent_index;
            null === c && (c = 256);
            var u = i.width,
                h = r - u,
                l = u,
                f = 4 * (i.y * r + i.x),
                d = 4 * ((i.y + i.height) * r + i.x),
                p = f,
                g = 4 * h;
            !0 === i.interlaced && (g += 4 * r * 7);
            for (var m = 8, v = 0, b = o.length; v < b; ++v) {
                var y = o[v];
                if (
                    (0 === l &&
                        ((l = u),
                        (p += g) >= d &&
                            ((g = 4 * h + 4 * r * (m - 1)),
                            (p = f + (u + h) * (m << 1)),
                            (m >>= 1))),
                    y === c)
                )
                    p += 4;
                else {
                    var w = t[s + 3 * y],
                        N = t[s + 3 * y + 1],
                        L = t[s + 3 * y + 2];
                    (n[p++] = L), (n[p++] = N), (n[p++] = w), (n[p++] = 255);
                }
                --l;
            }
        }),
        (this.decodeAndBlitFrameRGBA = function (e, n) {
            var i = this.frameInfo(e),
                a = i.width * i.height,
                o = new Uint8Array(a);
            $t(t, i.data_offset, o, a);
            var s = i.palette_offset,
                c = i.transparent_index;
            null === c && (c = 256);
            var u = i.width,
                h = r - u,
                l = u,
                f = 4 * (i.y * r + i.x),
                d = 4 * ((i.y + i.height) * r + i.x),
                p = f,
                g = 4 * h;
            !0 === i.interlaced && (g += 4 * r * 7);
            for (var m = 8, v = 0, b = o.length; v < b; ++v) {
                var y = o[v];
                if (
                    (0 === l &&
                        ((l = u),
                        (p += g) >= d &&
                            ((g = 4 * h + 4 * r * (m - 1)),
                            (p = f + (u + h) * (m << 1)),
                            (m >>= 1))),
                    y === c)
                )
                    p += 4;
                else {
                    var w = t[s + 3 * y],
                        N = t[s + 3 * y + 1],
                        L = t[s + 3 * y + 2];
                    (n[p++] = w), (n[p++] = N), (n[p++] = L), (n[p++] = 255);
                }
                --l;
            }
        });
}
function $t(t, e, r, n) {
    for (
        var i = t[e++],
            o = 1 << i,
            s = o + 1,
            c = s + 1,
            u = i + 1,
            h = (1 << u) - 1,
            l = 0,
            f = 0,
            d = 0,
            p = t[e++],
            g = new Int32Array(4096),
            m = null;
        ;

    ) {
        for (; l < 16 && 0 !== p; )
            (f |= t[e++] << l), (l += 8), 1 === p ? (p = t[e++]) : --p;
        if (l < u) break;
        var v = f & h;
        if (((f >>= u), (l -= u), v !== o)) {
            if (v === s) break;
            for (var b = v < c ? v : m, y = 0, w = b; w > o; )
                (w = g[w] >> 8), ++y;
            var N = w;
            if (d + y + (b !== v ? 1 : 0) > n)
                return void a.log("Warning, gif stream longer than expected.");
            r[d++] = N;
            var L = (d += y);
            for (b !== v && (r[d++] = N), w = b; y--; )
                (w = g[w]), (r[--L] = 255 & w), (w >>= 8);
            null !== m &&
                c < 4096 &&
                ((g[c++] = (m << 8) | N),
                c >= h + 1 && u < 12 && (++u, (h = (h << 1) | 1))),
                (m = v);
        } else (c = s + 1), (h = (1 << (u = i + 1)) - 1), (m = null);
    }
    return d !== n && a.log("Warning, gif stream shorter than expected."), r;
}
/**
 * @license
  Copyright (c) 2008, Adobe Systems Incorporated
  All rights reserved.

  Redistribution and use in source and binary forms, with or without 
  modification, are permitted provided that the following conditions are
  met:

  * Redistributions of source code must retain the above copyright notice, 
    this list of conditions and the following disclaimer.
  
  * Redistributions in binary form must reproduce the above copyright
    notice, this list of conditions and the following disclaimer in the 
    documentation and/or other materials provided with the distribution.
  
  * Neither the name of Adobe Systems Incorporated nor the names of its 
    contributors may be used to endorse or promote products derived from 
    this software without specific prior written permission.

  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS
  IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
  THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
  PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR 
  CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
  EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
  PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
  LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
  NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
  SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/
function Qt(t) {
    var e,
        r,
        n,
        i,
        a,
        o = Math.floor,
        s = new Array(64),
        c = new Array(64),
        u = new Array(64),
        h = new Array(64),
        l = new Array(65535),
        f = new Array(65535),
        d = new Array(64),
        p = new Array(64),
        g = [],
        m = 0,
        v = 7,
        b = new Array(64),
        y = new Array(64),
        w = new Array(64),
        N = new Array(256),
        L = new Array(2048),
        A = [
            0, 1, 5, 6, 14, 15, 27, 28, 2, 4, 7, 13, 16, 26, 29, 42, 3, 8, 12,
            17, 25, 30, 41, 43, 9, 11, 18, 24, 31, 40, 44, 53, 10, 19, 23, 32,
            39, 45, 52, 54, 20, 22, 33, 38, 46, 51, 55, 60, 21, 34, 37, 47, 50,
            56, 59, 61, 35, 36, 48, 49, 57, 58, 62, 63,
        ],
        x = [0, 0, 1, 5, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0],
        S = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
        _ = [0, 0, 2, 1, 3, 3, 2, 4, 3, 5, 5, 4, 4, 0, 0, 1, 125],
        P = [
            1, 2, 3, 0, 4, 17, 5, 18, 33, 49, 65, 6, 19, 81, 97, 7, 34, 113, 20,
            50, 129, 145, 161, 8, 35, 66, 177, 193, 21, 82, 209, 240, 36, 51,
            98, 114, 130, 9, 10, 22, 23, 24, 25, 26, 37, 38, 39, 40, 41, 42, 52,
            53, 54, 55, 56, 57, 58, 67, 68, 69, 70, 71, 72, 73, 74, 83, 84, 85,
            86, 87, 88, 89, 90, 99, 100, 101, 102, 103, 104, 105, 106, 115, 116,
            117, 118, 119, 120, 121, 122, 131, 132, 133, 134, 135, 136, 137,
            138, 146, 147, 148, 149, 150, 151, 152, 153, 154, 162, 163, 164,
            165, 166, 167, 168, 169, 170, 178, 179, 180, 181, 182, 183, 184,
            185, 186, 194, 195, 196, 197, 198, 199, 200, 201, 202, 210, 211,
            212, 213, 214, 215, 216, 217, 218, 225, 226, 227, 228, 229, 230,
            231, 232, 233, 234, 241, 242, 243, 244, 245, 246, 247, 248, 249,
            250,
        ],
        k = [0, 0, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0],
        I = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
        F = [0, 0, 2, 1, 2, 4, 4, 3, 4, 7, 5, 4, 4, 0, 1, 2, 119],
        C = [
            0, 1, 2, 3, 17, 4, 5, 33, 49, 6, 18, 65, 81, 7, 97, 113, 19, 34, 50,
            129, 8, 20, 66, 145, 161, 177, 193, 9, 35, 51, 82, 240, 21, 98, 114,
            209, 10, 22, 36, 52, 225, 37, 241, 23, 24, 25, 26, 38, 39, 40, 41,
            42, 53, 54, 55, 56, 57, 58, 67, 68, 69, 70, 71, 72, 73, 74, 83, 84,
            85, 86, 87, 88, 89, 90, 99, 100, 101, 102, 103, 104, 105, 106, 115,
            116, 117, 118, 119, 120, 121, 122, 130, 131, 132, 133, 134, 135,
            136, 137, 138, 146, 147, 148, 149, 150, 151, 152, 153, 154, 162,
            163, 164, 165, 166, 167, 168, 169, 170, 178, 179, 180, 181, 182,
            183, 184, 185, 186, 194, 195, 196, 197, 198, 199, 200, 201, 202,
            210, 211, 212, 213, 214, 215, 216, 217, 218, 226, 227, 228, 229,
            230, 231, 232, 233, 234, 242, 243, 244, 245, 246, 247, 248, 249,
            250,
        ];
    function j(t, e) {
        for (var r = 0, n = 0, i = new Array(), a = 1; a <= 16; a++) {
            for (var o = 1; o <= t[a]; o++)
                (i[e[n]] = []), (i[e[n]][0] = r), (i[e[n]][1] = a), n++, r++;
            r *= 2;
        }
        return i;
    }
    function O(t) {
        for (var e = t[0], r = t[1] - 1; r >= 0; )
            e & (1 << r) && (m |= 1 << v),
                r--,
                --v < 0 && (255 == m ? (B(255), B(0)) : B(m), (v = 7), (m = 0));
    }
    function B(t) {
        g.push(t);
    }
    function M(t) {
        B((t >> 8) & 255), B(255 & t);
    }
    function E(t, e, r, n, i) {
        for (
            var a,
                o = i[0],
                s = i[240],
                c = (function (t, e) {
                    var r,
                        n,
                        i,
                        a,
                        o,
                        s,
                        c,
                        u,
                        h,
                        l,
                        f = 0;
                    for (h = 0; h < 8; ++h) {
                        (r = t[f]),
                            (n = t[f + 1]),
                            (i = t[f + 2]),
                            (a = t[f + 3]),
                            (o = t[f + 4]),
                            (s = t[f + 5]),
                            (c = t[f + 6]);
                        var p = r + (u = t[f + 7]),
                            g = r - u,
                            m = n + c,
                            v = n - c,
                            b = i + s,
                            y = i - s,
                            w = a + o,
                            N = a - o,
                            L = p + w,
                            A = p - w,
                            x = m + b,
                            S = m - b;
                        (t[f] = L + x), (t[f + 4] = L - x);
                        var _ = 0.707106781 * (S + A);
                        (t[f + 2] = A + _), (t[f + 6] = A - _);
                        var P = 0.382683433 * ((L = N + y) - (S = v + g)),
                            k = 0.5411961 * L + P,
                            I = 1.306562965 * S + P,
                            F = 0.707106781 * (x = y + v),
                            C = g + F,
                            j = g - F;
                        (t[f + 5] = j + k),
                            (t[f + 3] = j - k),
                            (t[f + 1] = C + I),
                            (t[f + 7] = C - I),
                            (f += 8);
                    }
                    for (f = 0, h = 0; h < 8; ++h) {
                        (r = t[f]),
                            (n = t[f + 8]),
                            (i = t[f + 16]),
                            (a = t[f + 24]),
                            (o = t[f + 32]),
                            (s = t[f + 40]),
                            (c = t[f + 48]);
                        var O = r + (u = t[f + 56]),
                            B = r - u,
                            M = n + c,
                            E = n - c,
                            q = i + s,
                            D = i - s,
                            R = a + o,
                            T = a - o,
                            U = O + R,
                            z = O - R,
                            H = M + q,
                            W = M - q;
                        (t[f] = U + H), (t[f + 32] = U - H);
                        var V = 0.707106781 * (W + z);
                        (t[f + 16] = z + V), (t[f + 48] = z - V);
                        var G = 0.382683433 * ((U = T + D) - (W = E + B)),
                            Y = 0.5411961 * U + G,
                            J = 1.306562965 * W + G,
                            X = 0.707106781 * (H = D + E),
                            K = B + X,
                            Z = B - X;
                        (t[f + 40] = Z + Y),
                            (t[f + 24] = Z - Y),
                            (t[f + 8] = K + J),
                            (t[f + 56] = K - J),
                            f++;
                    }
                    for (h = 0; h < 64; ++h)
                        (l = t[h] * e[h]),
                            (d[h] = l > 0 ? (l + 0.5) | 0 : (l - 0.5) | 0);
                    return d;
                })(t, e),
                u = 0;
            u < 64;
            ++u
        )
            p[A[u]] = c[u];
        var h = p[0] - r;
        (r = p[0]), 0 == h ? O(n[0]) : (O(n[f[(a = 32767 + h)]]), O(l[a]));
        for (var g = 63; g > 0 && 0 == p[g]; ) g--;
        if (0 == g) return O(o), r;
        for (var m, v = 1; v <= g; ) {
            for (var b = v; 0 == p[v] && v <= g; ) ++v;
            var y = v - b;
            if (y >= 16) {
                m = y >> 4;
                for (var w = 1; w <= m; ++w) O(s);
                y &= 15;
            }
            (a = 32767 + p[v]), O(i[(y << 4) + f[a]]), O(l[a]), v++;
        }
        return 63 != g && O(o), r;
    }
    function q(t) {
        ((t = Math.min(Math.max(t, 1), 100)), a != t) &&
            (!(function (t) {
                for (
                    var e = [
                            16, 11, 10, 16, 24, 40, 51, 61, 12, 12, 14, 19, 26,
                            58, 60, 55, 14, 13, 16, 24, 40, 57, 69, 56, 14, 17,
                            22, 29, 51, 87, 80, 62, 18, 22, 37, 56, 68, 109,
                            103, 77, 24, 35, 55, 64, 81, 104, 113, 92, 49, 64,
                            78, 87, 103, 121, 120, 101, 72, 92, 95, 98, 112,
                            100, 103, 99,
                        ],
                        r = 0;
                    r < 64;
                    r++
                ) {
                    var n = o((e[r] * t + 50) / 100);
                    (n = Math.min(Math.max(n, 1), 255)), (s[A[r]] = n);
                }
                for (
                    var i = [
                            17, 18, 24, 47, 99, 99, 99, 99, 18, 21, 26, 66, 99,
                            99, 99, 99, 24, 26, 56, 99, 99, 99, 99, 99, 47, 66,
                            99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99,
                            99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99,
                            99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99,
                        ],
                        a = 0;
                    a < 64;
                    a++
                ) {
                    var l = o((i[a] * t + 50) / 100);
                    (l = Math.min(Math.max(l, 1), 255)), (c[A[a]] = l);
                }
                for (
                    var f = [
                            1, 1.387039845, 1.306562965, 1.175875602, 1,
                            0.785694958, 0.5411961, 0.275899379,
                        ],
                        d = 0,
                        p = 0;
                    p < 8;
                    p++
                )
                    for (var g = 0; g < 8; g++)
                        (u[d] = 1 / (s[A[d]] * f[p] * f[g] * 8)),
                            (h[d] = 1 / (c[A[d]] * f[p] * f[g] * 8)),
                            d++;
            })(t < 50 ? Math.floor(5e3 / t) : Math.floor(200 - 2 * t)),
            (a = t));
    }
    (this.encode = function (t, a) {
        a && q(a),
            (g = new Array()),
            (m = 0),
            (v = 7),
            M(65496),
            M(65504),
            M(16),
            B(74),
            B(70),
            B(73),
            B(70),
            B(0),
            B(1),
            B(1),
            B(0),
            M(1),
            M(1),
            B(0),
            B(0),
            (function () {
                M(65499), M(132), B(0);
                for (var t = 0; t < 64; t++) B(s[t]);
                B(1);
                for (var e = 0; e < 64; e++) B(c[e]);
            })(),
            (function (t, e) {
                M(65472),
                    M(17),
                    B(8),
                    M(e),
                    M(t),
                    B(3),
                    B(1),
                    B(17),
                    B(0),
                    B(2),
                    B(17),
                    B(1),
                    B(3),
                    B(17),
                    B(1);
            })(t.width, t.height),
            (function () {
                M(65476), M(418), B(0);
                for (var t = 0; t < 16; t++) B(x[t + 1]);
                for (var e = 0; e <= 11; e++) B(S[e]);
                B(16);
                for (var r = 0; r < 16; r++) B(_[r + 1]);
                for (var n = 0; n <= 161; n++) B(P[n]);
                B(1);
                for (var i = 0; i < 16; i++) B(k[i + 1]);
                for (var a = 0; a <= 11; a++) B(I[a]);
                B(17);
                for (var o = 0; o < 16; o++) B(F[o + 1]);
                for (var s = 0; s <= 161; s++) B(C[s]);
            })(),
            M(65498),
            M(12),
            B(3),
            B(1),
            B(0),
            B(2),
            B(17),
            B(3),
            B(17),
            B(0),
            B(63),
            B(0);
        var o = 0,
            l = 0,
            f = 0;
        (m = 0), (v = 7), (this.encode.displayName = "_encode_");
        for (
            var d,
                p,
                N,
                A,
                j,
                D,
                R,
                T,
                U,
                z = t.data,
                H = t.width,
                W = t.height,
                V = 4 * H,
                G = 0;
            G < W;

        ) {
            for (d = 0; d < V; ) {
                for (j = V * G + d, R = -1, T = 0, U = 0; U < 64; U++)
                    (D = j + (T = U >> 3) * V + (R = 4 * (7 & U))),
                        G + T >= W && (D -= V * (G + 1 + T - W)),
                        d + R >= V && (D -= d + R - V + 4),
                        (p = z[D++]),
                        (N = z[D++]),
                        (A = z[D++]),
                        (b[U] =
                            ((L[p] + L[(N + 256) >> 0] + L[(A + 512) >> 0]) >>
                                16) -
                            128),
                        (y[U] =
                            ((L[(p + 768) >> 0] +
                                L[(N + 1024) >> 0] +
                                L[(A + 1280) >> 0]) >>
                                16) -
                            128),
                        (w[U] =
                            ((L[(p + 1280) >> 0] +
                                L[(N + 1536) >> 0] +
                                L[(A + 1792) >> 0]) >>
                                16) -
                            128);
                (o = E(b, u, o, e, n)),
                    (l = E(y, h, l, r, i)),
                    (f = E(w, h, f, r, i)),
                    (d += 32);
            }
            G += 8;
        }
        if (v >= 0) {
            var Y = [];
            (Y[1] = v + 1), (Y[0] = (1 << (v + 1)) - 1), O(Y);
        }
        return M(65497), new Uint8Array(g);
    }),
        (t = t || 50),
        (function () {
            for (var t = String.fromCharCode, e = 0; e < 256; e++) N[e] = t(e);
        })(),
        (e = j(x, S)),
        (r = j(k, I)),
        (n = j(_, P)),
        (i = j(F, C)),
        (function () {
            for (var t = 1, e = 2, r = 1; r <= 15; r++) {
                for (var n = t; n < e; n++)
                    (f[32767 + n] = r),
                        (l[32767 + n] = []),
                        (l[32767 + n][1] = r),
                        (l[32767 + n][0] = n);
                for (var i = -(e - 1); i <= -t; i++)
                    (f[32767 + i] = r),
                        (l[32767 + i] = []),
                        (l[32767 + i][1] = r),
                        (l[32767 + i][0] = e - 1 + i);
                (t <<= 1), (e <<= 1);
            }
        })(),
        (function () {
            for (var t = 0; t < 256; t++)
                (L[t] = 19595 * t),
                    (L[(t + 256) >> 0] = 38470 * t),
                    (L[(t + 512) >> 0] = 7471 * t + 32768),
                    (L[(t + 768) >> 0] = -11059 * t),
                    (L[(t + 1024) >> 0] = -21709 * t),
                    (L[(t + 1280) >> 0] = 32768 * t + 8421375),
                    (L[(t + 1536) >> 0] = -27439 * t),
                    (L[(t + 1792) >> 0] = -5329 * t);
        })(),
        q(t);
}
/**
 * @license
 * Copyright (c) 2017 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function te(t, e) {
    if (
        ((this.pos = 0),
        (this.buffer = t),
        (this.datav = new DataView(t.buffer)),
        (this.is_with_alpha = !!e),
        (this.bottom_up = !0),
        (this.flag =
            String.fromCharCode(this.buffer[0]) +
            String.fromCharCode(this.buffer[1])),
        (this.pos += 2),
        -1 === ["BM", "BA", "CI", "CP", "IC", "PT"].indexOf(this.flag))
    )
        throw new Error("Invalid BMP File");
    this.parseHeader(), this.parseBGR();
}
function ee(t) {
    function e(t) {
        if (!t) throw Error("assert :P");
    }
    function r(t, e, r) {
        for (var n = 0; 4 > n; n++) if (t[e + n] != r.charCodeAt(n)) return !0;
        return !1;
    }
    function n(t, e, r, n, i) {
        for (var a = 0; a < i; a++) t[e + a] = r[n + a];
    }
    function i(t, e, r, n) {
        for (var i = 0; i < n; i++) t[e + i] = r;
    }
    function a(t) {
        return new Int32Array(t);
    }
    function o(t, e) {
        for (var r = [], n = 0; n < t; n++) r.push(new e());
        return r;
    }
    function s(t, e) {
        var r = [];
        return (
            (function t(r, n, i) {
                for (
                    var a = i[n], o = 0;
                    o < a &&
                    (r.push(i.length > n + 1 ? [] : new e()),
                    !(i.length < n + 1));
                    o++
                )
                    t(r[o], n + 1, i);
            })(r, 0, t),
            r
        );
    }
    var c = function () {
        var t = this;
        function c(t, e) {
            for (var r = (1 << (e - 1)) >>> 0; t & r; ) r >>>= 1;
            return r ? (t & (r - 1)) + r : t;
        }
        function u(t, r, n, i, a) {
            e(!(i % n));
            do {
                t[r + (i -= n)] = a;
            } while (0 < i);
        }
        function h(t, r, n, i, o) {
            if ((e(2328 >= o), 512 >= o)) var s = a(512);
            else if (null == (s = a(o))) return 0;
            return (function (t, r, n, i, o, s) {
                var h,
                    f,
                    d = r,
                    p = 1 << n,
                    g = a(16),
                    m = a(16);
                for (
                    e(0 != o), e(null != i), e(null != t), e(0 < n), f = 0;
                    f < o;
                    ++f
                ) {
                    if (15 < i[f]) return 0;
                    ++g[i[f]];
                }
                if (g[0] == o) return 0;
                for (m[1] = 0, h = 1; 15 > h; ++h) {
                    if (g[h] > 1 << h) return 0;
                    m[h + 1] = m[h] + g[h];
                }
                for (f = 0; f < o; ++f) (h = i[f]), 0 < i[f] && (s[m[h]++] = f);
                if (1 == m[15])
                    return (
                        ((i = new l()).g = 0),
                        (i.value = s[0]),
                        u(t, d, 1, p, i),
                        p
                    );
                var v,
                    b = -1,
                    y = p - 1,
                    w = 0,
                    N = 1,
                    L = 1,
                    A = 1 << n;
                for (f = 0, h = 1, o = 2; h <= n; ++h, o <<= 1) {
                    if (((N += L <<= 1), 0 > (L -= g[h]))) return 0;
                    for (; 0 < g[h]; --g[h])
                        ((i = new l()).g = h),
                            (i.value = s[f++]),
                            u(t, d + w, o, A, i),
                            (w = c(w, h));
                }
                for (h = n + 1, o = 2; 15 >= h; ++h, o <<= 1) {
                    if (((N += L <<= 1), 0 > (L -= g[h]))) return 0;
                    for (; 0 < g[h]; --g[h]) {
                        if (((i = new l()), (w & y) != b)) {
                            for (
                                d += A, v = 1 << ((b = h) - n);
                                15 > b && !(0 >= (v -= g[b]));

                            )
                                ++b, (v <<= 1);
                            (p += A = 1 << (v = b - n)),
                                (t[r + (b = w & y)].g = v + n),
                                (t[r + b].value = d - r - b);
                        }
                        (i.g = h - n),
                            (i.value = s[f++]),
                            u(t, d + (w >> n), o, A, i),
                            (w = c(w, h));
                    }
                }
                return N != 2 * m[15] - 1 ? 0 : p;
            })(t, r, n, i, o, s);
        }
        function l() {
            this.value = this.g = 0;
        }
        function f() {
            this.value = this.g = 0;
        }
        function d() {
            (this.G = o(5, l)),
                (this.H = a(5)),
                (this.jc = this.Qb = this.qb = this.nd = 0),
                (this.pd = o(Dr, f));
        }
        function p(t, r, n, i) {
            e(null != t),
                e(null != r),
                e(2147483648 > i),
                (t.Ca = 254),
                (t.I = 0),
                (t.b = -8),
                (t.Ka = 0),
                (t.oa = r),
                (t.pa = n),
                (t.Jd = r),
                (t.Yc = n + i),
                (t.Zc = 4 <= i ? n + i - 4 + 1 : n),
                _(t);
        }
        function g(t, e) {
            for (var r = 0; 0 < e--; ) r |= k(t, 128) << e;
            return r;
        }
        function m(t, e) {
            var r = g(t, e);
            return P(t) ? -r : r;
        }
        function v(t, r, n, i) {
            var a,
                o = 0;
            for (
                e(null != t),
                    e(null != r),
                    e(4294967288 > i),
                    t.Sb = i,
                    t.Ra = 0,
                    t.u = 0,
                    t.h = 0,
                    4 < i && (i = 4),
                    a = 0;
                a < i;
                ++a
            )
                o += r[n + a] << (8 * a);
            (t.Ra = o), (t.bb = i), (t.oa = r), (t.pa = n);
        }
        function b(t) {
            for (; 8 <= t.u && t.bb < t.Sb; )
                (t.Ra >>>= 8),
                    (t.Ra += (t.oa[t.pa + t.bb] << (Ur - 8)) >>> 0),
                    ++t.bb,
                    (t.u -= 8);
            A(t) && ((t.h = 1), (t.u = 0));
        }
        function y(t, r) {
            if ((e(0 <= r), !t.h && r <= Tr)) {
                var n = L(t) & Rr[r];
                return (t.u += r), b(t), n;
            }
            return (t.h = 1), (t.u = 0);
        }
        function w() {
            (this.b = this.Ca = this.I = 0),
                (this.oa = []),
                (this.pa = 0),
                (this.Jd = []),
                (this.Yc = 0),
                (this.Zc = []),
                (this.Ka = 0);
        }
        function N() {
            (this.Ra = 0),
                (this.oa = []),
                (this.h = this.u = this.bb = this.Sb = this.pa = 0);
        }
        function L(t) {
            return (t.Ra >>> (t.u & (Ur - 1))) >>> 0;
        }
        function A(t) {
            return e(t.bb <= t.Sb), t.h || (t.bb == t.Sb && t.u > Ur);
        }
        function x(t, e) {
            (t.u = e), (t.h = A(t));
        }
        function S(t) {
            t.u >= zr && (e(t.u >= zr), b(t));
        }
        function _(t) {
            e(null != t && null != t.oa),
                t.pa < t.Zc
                    ? ((t.I = (t.oa[t.pa++] | (t.I << 8)) >>> 0), (t.b += 8))
                    : (e(null != t && null != t.oa),
                      t.pa < t.Yc
                          ? ((t.b += 8), (t.I = t.oa[t.pa++] | (t.I << 8)))
                          : t.Ka
                            ? (t.b = 0)
                            : ((t.I <<= 8), (t.b += 8), (t.Ka = 1)));
        }
        function P(t) {
            return g(t, 1);
        }
        function k(t, e) {
            var r = t.Ca;
            0 > t.b && _(t);
            var n = t.b,
                i = (r * e) >>> 8,
                a = (t.I >>> n > i) + 0;
            for (
                a ? ((r -= i), (t.I -= ((i + 1) << n) >>> 0)) : (r = i + 1),
                    n = r,
                    i = 0;
                256 <= n;

            )
                (i += 8), (n >>= 8);
            return (n = 7 ^ (i + Hr[n])), (t.b -= n), (t.Ca = (r << n) - 1), a;
        }
        function I(t, e, r) {
            (t[e + 0] = (r >> 24) & 255),
                (t[e + 1] = (r >> 16) & 255),
                (t[e + 2] = (r >> 8) & 255),
                (t[e + 3] = (r >> 0) & 255);
        }
        function F(t, e) {
            return (t[e + 0] << 0) | (t[e + 1] << 8);
        }
        function C(t, e) {
            return F(t, e) | (t[e + 2] << 16);
        }
        function j(t, e) {
            return F(t, e) | (F(t, e + 2) << 16);
        }
        function O(t, r) {
            var n = 1 << r;
            return (
                e(null != t),
                e(0 < r),
                (t.X = a(n)),
                null == t.X ? 0 : ((t.Mb = 32 - r), (t.Xa = r), 1)
            );
        }
        function B(t, r) {
            e(null != t),
                e(null != r),
                e(t.Xa == r.Xa),
                n(r.X, 0, t.X, 0, 1 << r.Xa);
        }
        function M() {
            (this.X = []), (this.Xa = this.Mb = 0);
        }
        function E(t, r, n, i) {
            e(null != n), e(null != i);
            var a = n[0],
                o = i[0];
            return (
                0 == a && (a = (t * o + r / 2) / r),
                0 == o && (o = (r * a + t / 2) / t),
                0 >= a || 0 >= o ? 0 : ((n[0] = a), (i[0] = o), 1)
            );
        }
        function q(t, e) {
            return (t + (1 << e) - 1) >>> e;
        }
        function D(t, e) {
            return (
                (((((4278255360 & t) + (4278255360 & e)) >>> 0) & 4278255360) +
                    ((((16711935 & t) + (16711935 & e)) >>> 0) & 16711935)) >>>
                0
            );
        }
        function R(e, r) {
            t[r] = function (r, n, i, a, o, s, c) {
                var u;
                for (u = 0; u < o; ++u) {
                    var h = t[e](s[c + u - 1], i, a + u);
                    s[c + u] = D(r[n + u], h);
                }
            };
        }
        function T() {
            this.ud = this.hd = this.jd = 0;
        }
        function U(t, e) {
            return (((4278124286 & (t ^ e)) >>> 1) + (t & e)) >>> 0;
        }
        function z(t) {
            return 0 <= t && 256 > t ? t : 0 > t ? 0 : 255 < t ? 255 : void 0;
        }
        function H(t, e) {
            return z(t + ((t - e + 0.5) >> 1));
        }
        function W(t, e, r) {
            return Math.abs(e - r) - Math.abs(t - r);
        }
        function V(t, e, r, n, i, a, o) {
            for (n = a[o - 1], r = 0; r < i; ++r) a[o + r] = n = D(t[e + r], n);
        }
        function G(t, e, r, n, i) {
            var a;
            for (a = 0; a < r; ++a) {
                var o = t[e + a],
                    s = (o >> 8) & 255,
                    c = 16711935 & (c = (c = 16711935 & o) + ((s << 16) + s));
                n[i + a] = ((4278255360 & o) + c) >>> 0;
            }
        }
        function Y(t, e) {
            (e.jd = (t >> 0) & 255),
                (e.hd = (t >> 8) & 255),
                (e.ud = (t >> 16) & 255);
        }
        function J(t, e, r, n, i, a) {
            var o;
            for (o = 0; o < n; ++o) {
                var s = e[r + o],
                    c = s >>> 8,
                    u = s,
                    h =
                        255 &
                        (h =
                            (h = s >>> 16) +
                            ((((t.jd << 24) >> 24) * ((c << 24) >> 24)) >>> 5));
                u =
                    255 &
                    (u =
                        (u =
                            u +
                            ((((t.hd << 24) >> 24) * ((c << 24) >> 24)) >>>
                                5)) +
                        ((((t.ud << 24) >> 24) * ((h << 24) >> 24)) >>> 5));
                i[a + o] = (4278255360 & s) + (h << 16) + u;
            }
        }
        function X(e, r, n, i, a) {
            (t[r] = function (t, e, r, n, o, s, c, u, h) {
                for (n = c; n < u; ++n)
                    for (c = 0; c < h; ++c) o[s++] = a(r[i(t[e++])]);
            }),
                (t[e] = function (e, r, o, s, c, u, h) {
                    var l = 8 >> e.b,
                        f = e.Ea,
                        d = e.K[0],
                        p = e.w;
                    if (8 > l)
                        for (e = (1 << e.b) - 1, p = (1 << l) - 1; r < o; ++r) {
                            var g,
                                m = 0;
                            for (g = 0; g < f; ++g)
                                g & e || (m = i(s[c++])),
                                    (u[h++] = a(d[m & p])),
                                    (m >>= l);
                        }
                    else t["VP8LMapColor" + n](s, c, d, p, u, h, r, o, f);
                });
        }
        function K(t, e, r, n, i) {
            for (r = e + r; e < r; ) {
                var a = t[e++];
                (n[i++] = (a >> 16) & 255),
                    (n[i++] = (a >> 8) & 255),
                    (n[i++] = (a >> 0) & 255);
            }
        }
        function Z(t, e, r, n, i) {
            for (r = e + r; e < r; ) {
                var a = t[e++];
                (n[i++] = (a >> 16) & 255),
                    (n[i++] = (a >> 8) & 255),
                    (n[i++] = (a >> 0) & 255),
                    (n[i++] = (a >> 24) & 255);
            }
        }
        function $(t, e, r, n, i) {
            for (r = e + r; e < r; ) {
                var a = (((o = t[e++]) >> 16) & 240) | ((o >> 12) & 15),
                    o = ((o >> 0) & 240) | ((o >> 28) & 15);
                (n[i++] = a), (n[i++] = o);
            }
        }
        function Q(t, e, r, n, i) {
            for (r = e + r; e < r; ) {
                var a = (((o = t[e++]) >> 16) & 248) | ((o >> 13) & 7),
                    o = ((o >> 5) & 224) | ((o >> 3) & 31);
                (n[i++] = a), (n[i++] = o);
            }
        }
        function tt(t, e, r, n, i) {
            for (r = e + r; e < r; ) {
                var a = t[e++];
                (n[i++] = (a >> 0) & 255),
                    (n[i++] = (a >> 8) & 255),
                    (n[i++] = (a >> 16) & 255);
            }
        }
        function et(t, e, r, i, a, o) {
            if (0 == o)
                for (r = e + r; e < r; )
                    I(
                        i,
                        (((o = t[e++])[0] >> 24) |
                            ((o[1] >> 8) & 65280) |
                            ((o[2] << 8) & 16711680) |
                            (o[3] << 24)) >>>
                            0,
                    ),
                        (a += 32);
            else n(i, a, t, e, r);
        }
        function rt(e, r) {
            (t[r][0] = t[e + "0"]),
                (t[r][1] = t[e + "1"]),
                (t[r][2] = t[e + "2"]),
                (t[r][3] = t[e + "3"]),
                (t[r][4] = t[e + "4"]),
                (t[r][5] = t[e + "5"]),
                (t[r][6] = t[e + "6"]),
                (t[r][7] = t[e + "7"]),
                (t[r][8] = t[e + "8"]),
                (t[r][9] = t[e + "9"]),
                (t[r][10] = t[e + "10"]),
                (t[r][11] = t[e + "11"]),
                (t[r][12] = t[e + "12"]),
                (t[r][13] = t[e + "13"]),
                (t[r][14] = t[e + "0"]),
                (t[r][15] = t[e + "0"]);
        }
        function nt(t) {
            return t == Hn || t == Wn || t == Vn || t == Gn;
        }
        function it() {
            (this.eb = []), (this.size = this.A = this.fb = 0);
        }
        function at() {
            (this.y = []),
                (this.f = []),
                (this.ea = []),
                (this.F = []),
                (this.Tc =
                    this.Ed =
                    this.Cd =
                    this.Fd =
                    this.lb =
                    this.Db =
                    this.Ab =
                    this.fa =
                    this.J =
                    this.W =
                    this.N =
                    this.O =
                        0);
        }
        function ot() {
            (this.Rd = this.height = this.width = this.S = 0),
                (this.f = {}),
                (this.f.RGBA = new it()),
                (this.f.kb = new at()),
                (this.sd = null);
        }
        function st() {
            (this.width = [0]),
                (this.height = [0]),
                (this.Pd = [0]),
                (this.Qd = [0]),
                (this.format = [0]);
        }
        function ct() {
            this.Id =
                this.fd =
                this.Md =
                this.hb =
                this.ib =
                this.da =
                this.bd =
                this.cd =
                this.j =
                this.v =
                this.Da =
                this.Sd =
                this.ob =
                    0;
        }
        function ut(t) {
            return alert("todo:WebPSamplerProcessPlane"), t.T;
        }
        function ht(t, e) {
            var r = t.T,
                i = e.ba.f.RGBA,
                a = i.eb,
                o = i.fb + t.ka * i.A,
                s = vi[e.ba.S],
                c = t.y,
                u = t.O,
                h = t.f,
                l = t.N,
                f = t.ea,
                d = t.W,
                p = e.cc,
                g = e.dc,
                m = e.Mc,
                v = e.Nc,
                b = t.ka,
                y = t.ka + t.T,
                w = t.U,
                N = (w + 1) >> 1;
            for (
                0 == b
                    ? s(
                          c,
                          u,
                          null,
                          null,
                          h,
                          l,
                          f,
                          d,
                          h,
                          l,
                          f,
                          d,
                          a,
                          o,
                          null,
                          null,
                          w,
                      )
                    : (s(
                          e.ec,
                          e.fc,
                          c,
                          u,
                          p,
                          g,
                          m,
                          v,
                          h,
                          l,
                          f,
                          d,
                          a,
                          o - i.A,
                          a,
                          o,
                          w,
                      ),
                      ++r);
                b + 2 < y;
                b += 2
            )
                (p = h),
                    (g = l),
                    (m = f),
                    (v = d),
                    (l += t.Rc),
                    (d += t.Rc),
                    (o += 2 * i.A),
                    s(
                        c,
                        (u += 2 * t.fa) - t.fa,
                        c,
                        u,
                        p,
                        g,
                        m,
                        v,
                        h,
                        l,
                        f,
                        d,
                        a,
                        o - i.A,
                        a,
                        o,
                        w,
                    );
            return (
                (u += t.fa),
                t.j + y < t.o
                    ? (n(e.ec, e.fc, c, u, w),
                      n(e.cc, e.dc, h, l, N),
                      n(e.Mc, e.Nc, f, d, N),
                      r--)
                    : 1 & y ||
                      s(
                          c,
                          u,
                          null,
                          null,
                          h,
                          l,
                          f,
                          d,
                          h,
                          l,
                          f,
                          d,
                          a,
                          o + i.A,
                          null,
                          null,
                          w,
                      ),
                r
            );
        }
        function lt(t, r, n) {
            var i = t.F,
                a = [t.J];
            if (null != i) {
                var o = t.U,
                    s = r.ba.S,
                    c = s == Tn || s == Vn;
                r = r.ba.f.RGBA;
                var u = [0],
                    h = t.ka;
                (u[0] = t.T),
                    t.Kb &&
                        (0 == h ? --u[0] : (--h, (a[0] -= t.width)),
                        t.j + t.ka + t.T == t.o && (u[0] = t.o - t.j - h));
                var l = r.eb;
                h = r.fb + h * r.A;
                (t = Sn(i, a[0], t.width, o, u, l, h + (c ? 0 : 3), r.A)),
                    e(n == u),
                    t && nt(s) && An(l, h, c, o, u, r.A);
            }
            return 0;
        }
        function ft(t) {
            var e = t.ma,
                r = e.ba.S,
                n = 11 > r,
                i =
                    r == qn ||
                    r == Rn ||
                    r == Tn ||
                    r == Un ||
                    12 == r ||
                    nt(r);
            if (
                ((e.memory = null),
                (e.Ib = null),
                (e.Jb = null),
                (e.Nd = null),
                !Mr(e.Oa, t, i ? 11 : 12))
            )
                return 0;
            if ((i && nt(r) && br(), t.da)) alert("todo:use_scaling");
            else {
                if (n) {
                    if (((e.Ib = ut), t.Kb)) {
                        if (
                            ((r = (t.U + 1) >> 1),
                            (e.memory = a(t.U + 2 * r)),
                            null == e.memory)
                        )
                            return 0;
                        (e.ec = e.memory),
                            (e.fc = 0),
                            (e.cc = e.ec),
                            (e.dc = e.fc + t.U),
                            (e.Mc = e.cc),
                            (e.Nc = e.dc + r),
                            (e.Ib = ht),
                            br();
                    }
                } else alert("todo:EmitYUV");
                i && ((e.Jb = lt), n && mr());
            }
            if (n && !Ci) {
                for (t = 0; 256 > t; ++t)
                    (ji[t] = (89858 * (t - 128) + _i) >> Si),
                        (Mi[t] = -22014 * (t - 128) + _i),
                        (Bi[t] = -45773 * (t - 128)),
                        (Oi[t] = (113618 * (t - 128) + _i) >> Si);
                for (t = Pi; t < ki; ++t)
                    (e = (76283 * (t - 16) + _i) >> Si),
                        (Ei[t - Pi] = Vt(e, 255)),
                        (qi[t - Pi] = Vt((e + 8) >> 4, 15));
                Ci = 1;
            }
            return 1;
        }
        function dt(t) {
            var r = t.ma,
                n = t.U,
                i = t.T;
            return (
                e(!(1 & t.ka)),
                0 >= n || 0 >= i
                    ? 0
                    : ((n = r.Ib(t, r)),
                      null != r.Jb && r.Jb(t, r, n),
                      (r.Dc += n),
                      1)
            );
        }
        function pt(t) {
            t.ma.memory = null;
        }
        function gt(t, e, r, n) {
            return 47 != y(t, 8)
                ? 0
                : ((e[0] = y(t, 14) + 1),
                  (r[0] = y(t, 14) + 1),
                  (n[0] = y(t, 1)),
                  0 != y(t, 3) ? 0 : !t.h);
        }
        function mt(t, e) {
            if (4 > t) return t + 1;
            var r = (t - 2) >> 1;
            return ((2 + (1 & t)) << r) + y(e, r) + 1;
        }
        function vt(t, e) {
            return 120 < e
                ? e - 120
                : 1 <= (r = ((r = $n[e - 1]) >> 4) * t + (8 - (15 & r)))
                  ? r
                  : 1;
            var r;
        }
        function bt(t, e, r) {
            var n = L(r),
                i = t[(e += 255 & n)].g - 8;
            return (
                0 < i &&
                    (x(r, r.u + 8),
                    (n = L(r)),
                    (e += t[e].value),
                    (e += n & ((1 << i) - 1))),
                x(r, r.u + t[e].g),
                t[e].value
            );
        }
        function yt(t, r, n) {
            return (
                (n.g += t.g),
                (n.value += (t.value << r) >>> 0),
                e(8 >= n.g),
                t.g
            );
        }
        function wt(t, r, n) {
            var i = t.xc;
            return (
                e((r = 0 == i ? 0 : t.vc[t.md * (n >> i) + (r >> i)]) < t.Wb),
                t.Ya[r]
            );
        }
        function Nt(t, r, i, a) {
            var o = t.ab,
                s = t.c * r,
                c = t.C;
            r = c + r;
            var u = i,
                h = a;
            for (a = t.Ta, i = t.Ua; 0 < o--; ) {
                var l = t.gc[o],
                    f = c,
                    d = r,
                    p = u,
                    g = h,
                    m = ((h = a), (u = i), l.Ea);
                switch ((e(f < d), e(d <= l.nc), l.hc)) {
                    case 2:
                        Gr(p, g, (d - f) * m, h, u);
                        break;
                    case 0:
                        var v = f,
                            b = d,
                            y = h,
                            w = u,
                            N = (_ = l).Ea;
                        0 == v &&
                            (Wr(p, g, null, null, 1, y, w),
                            V(p, g + 1, 0, 0, N - 1, y, w + 1),
                            (g += N),
                            (w += N),
                            ++v);
                        for (
                            var L = 1 << _.b,
                                A = L - 1,
                                x = q(N, _.b),
                                S = _.K,
                                _ = _.w + (v >> _.b) * x;
                            v < b;

                        ) {
                            var P = S,
                                k = _,
                                I = 1;
                            for (Vr(p, g, y, w - N, 1, y, w); I < N; ) {
                                var F = (I & ~A) + L;
                                F > N && (F = N),
                                    (0, Zr[(P[k++] >> 8) & 15])(
                                        p,
                                        g + +I,
                                        y,
                                        w + I - N,
                                        F - I,
                                        y,
                                        w + I,
                                    ),
                                    (I = F);
                            }
                            (g += N), (w += N), ++v & A || (_ += x);
                        }
                        d != l.nc && n(h, u - m, h, u + (d - f - 1) * m, m);
                        break;
                    case 1:
                        for (
                            m = p,
                                b = g,
                                N =
                                    (p = l.Ea) -
                                    (w = p & ~(y = (g = 1 << l.b) - 1)),
                                v = q(p, l.b),
                                L = l.K,
                                l = l.w + (f >> l.b) * v;
                            f < d;

                        ) {
                            for (
                                A = L, x = l, S = new T(), _ = b + w, P = b + p;
                                b < _;

                            )
                                Y(A[x++], S),
                                    $r(S, m, b, g, h, u),
                                    (b += g),
                                    (u += g);
                            b < P &&
                                (Y(A[x++], S),
                                $r(S, m, b, N, h, u),
                                (b += N),
                                (u += N)),
                                ++f & y || (l += v);
                        }
                        break;
                    case 3:
                        if (p == h && g == u && 0 < l.b) {
                            for (
                                b = h,
                                    p = m =
                                        u +
                                        (d - f) * m -
                                        (w = (d - f) * q(l.Ea, l.b)),
                                    g = h,
                                    y = u,
                                    v = [],
                                    w = (N = w) - 1;
                                0 <= w;
                                --w
                            )
                                v[w] = g[y + w];
                            for (w = N - 1; 0 <= w; --w) b[p + w] = v[w];
                            Yr(l, f, d, h, m, h, u);
                        } else Yr(l, f, d, p, g, h, u);
                }
                (u = a), (h = i);
            }
            h != i && n(a, i, u, h, s);
        }
        function Lt(t, r) {
            var n = t.V,
                i = t.Ba + t.c * t.C,
                a = r - t.C;
            if ((e(r <= t.l.o), e(16 >= a), 0 < a)) {
                var o = t.l,
                    s = t.Ta,
                    c = t.Ua,
                    u = o.width;
                if (
                    (Nt(t, a, n, i),
                    (a = c = [c]),
                    e((n = t.C) < (i = r)),
                    e(o.v < o.va),
                    i > o.o && (i = o.o),
                    n < o.j)
                ) {
                    var h = o.j - n;
                    n = o.j;
                    a[0] += h * u;
                }
                if (
                    (n >= i
                        ? (n = 0)
                        : ((a[0] += 4 * o.v),
                          (o.ka = n - o.j),
                          (o.U = o.va - o.v),
                          (o.T = i - n),
                          (n = 1)),
                    n)
                ) {
                    if (((c = c[0]), 11 > (n = t.ca).S)) {
                        var l = n.f.RGBA,
                            f =
                                ((i = n.S),
                                (a = o.U),
                                (o = o.T),
                                (h = l.eb),
                                l.A),
                            d = o;
                        for (l = l.fb + t.Ma * l.A; 0 < d--; ) {
                            var p = s,
                                g = c,
                                m = a,
                                v = h,
                                b = l;
                            switch (i) {
                                case En:
                                    Qr(p, g, m, v, b);
                                    break;
                                case qn:
                                    tn(p, g, m, v, b);
                                    break;
                                case Hn:
                                    tn(p, g, m, v, b), An(v, b, 0, m, 1, 0);
                                    break;
                                case Dn:
                                    nn(p, g, m, v, b);
                                    break;
                                case Rn:
                                    et(p, g, m, v, b, 1);
                                    break;
                                case Wn:
                                    et(p, g, m, v, b, 1), An(v, b, 0, m, 1, 0);
                                    break;
                                case Tn:
                                    et(p, g, m, v, b, 0);
                                    break;
                                case Vn:
                                    et(p, g, m, v, b, 0), An(v, b, 1, m, 1, 0);
                                    break;
                                case Un:
                                    en(p, g, m, v, b);
                                    break;
                                case Gn:
                                    en(p, g, m, v, b), xn(v, b, m, 1, 0);
                                    break;
                                case zn:
                                    rn(p, g, m, v, b);
                                    break;
                                default:
                                    e(0);
                            }
                            (c += u), (l += f);
                        }
                        t.Ma += o;
                    } else alert("todo:EmitRescaledRowsYUVA");
                    e(t.Ma <= n.height);
                }
            }
            (t.C = r), e(t.C <= t.i);
        }
        function At(t) {
            var e;
            if (0 < t.ua) return 0;
            for (e = 0; e < t.Wb; ++e) {
                var r = t.Ya[e].G,
                    n = t.Ya[e].H;
                if (
                    0 < r[1][n[1] + 0].g ||
                    0 < r[2][n[2] + 0].g ||
                    0 < r[3][n[3] + 0].g
                )
                    return 0;
            }
            return 1;
        }
        function xt(t, r, n, i, a, o) {
            if (0 != t.Z) {
                var s = t.qd,
                    c = t.rd;
                for (e(null != mi[t.Z]); r < n; ++r)
                    mi[t.Z](s, c, i, a, i, a, o), (s = i), (c = a), (a += o);
                (t.qd = s), (t.rd = c);
            }
        }
        function St(t, r) {
            var n = t.l.ma,
                i = 0 == n.Z || 1 == n.Z ? t.l.j : t.C;
            i = t.C < i ? i : t.C;
            if ((e(r <= t.l.o), r > i)) {
                var a = t.l.width,
                    o = n.ca,
                    s = n.tb + a * i,
                    c = t.V,
                    u = t.Ba + t.c * i,
                    h = t.gc;
                e(1 == t.ab),
                    e(3 == h[0].hc),
                    Xr(h[0], i, r, c, u, o, s),
                    xt(n, i, r, o, s, a);
            }
            t.C = t.Ma = r;
        }
        function _t(t, r, n, i, a, o, s) {
            var c = t.$ / i,
                u = t.$ % i,
                h = t.m,
                l = t.s,
                f = n + t.$,
                d = f;
            a = n + i * a;
            var p = n + i * o,
                g = 280 + l.ua,
                m = t.Pb ? c : 16777216,
                v = 0 < l.ua ? l.Wa : null,
                b = l.wc,
                y = f < p ? wt(l, u, c) : null;
            e(t.C < o), e(p <= a);
            var w = !1;
            t: for (;;) {
                for (; w || f < p; ) {
                    var N = 0;
                    if (c >= m) {
                        var _ = f - n;
                        e((m = t).Pb),
                            (m.wd = m.m),
                            (m.xd = _),
                            0 < m.s.ua && B(m.s.Wa, m.s.vb),
                            (m = c + ti);
                    }
                    if (
                        (u & b || (y = wt(l, u, c)),
                        e(null != y),
                        y.Qb && ((r[f] = y.qb), (w = !0)),
                        !w)
                    )
                        if ((S(h), y.jc)) {
                            (N = h), (_ = r);
                            var P = f,
                                k = y.pd[L(N) & (Dr - 1)];
                            e(y.jc),
                                256 > k.g
                                    ? (x(N, N.u + k.g),
                                      (_[P] = k.value),
                                      (N = 0))
                                    : (x(N, N.u + k.g - 256),
                                      e(256 <= k.value),
                                      (N = k.value)),
                                0 == N && (w = !0);
                        } else N = bt(y.G[0], y.H[0], h);
                    if (h.h) break;
                    if (w || 256 > N) {
                        if (!w)
                            if (y.nd) r[f] = (y.qb | (N << 8)) >>> 0;
                            else {
                                if (
                                    (S(h),
                                    (w = bt(y.G[1], y.H[1], h)),
                                    S(h),
                                    (_ = bt(y.G[2], y.H[2], h)),
                                    (P = bt(y.G[3], y.H[3], h)),
                                    h.h)
                                )
                                    break;
                                r[f] =
                                    ((P << 24) | (w << 16) | (N << 8) | _) >>>
                                    0;
                            }
                        if (
                            ((w = !1),
                            ++f,
                            ++u >= i &&
                                ((u = 0),
                                ++c,
                                null != s && c <= o && !(c % 16) && s(t, c),
                                null != v))
                        )
                            for (; d < f; )
                                (N = r[d++]),
                                    (v.X[
                                        ((506832829 * N) & 4294967295) >>> v.Mb
                                    ] = N);
                    } else if (280 > N) {
                        if (
                            ((N = mt(N - 256, h)),
                            (_ = bt(y.G[4], y.H[4], h)),
                            S(h),
                            (_ = vt(i, (_ = mt(_, h)))),
                            h.h)
                        )
                            break;
                        if (f - n < _ || a - f < N) break t;
                        for (P = 0; P < N; ++P) r[f + P] = r[f + P - _];
                        for (f += N, u += N; u >= i; )
                            (u -= i),
                                ++c,
                                null != s && c <= o && !(c % 16) && s(t, c);
                        if ((e(f <= a), u & b && (y = wt(l, u, c)), null != v))
                            for (; d < f; )
                                (N = r[d++]),
                                    (v.X[
                                        ((506832829 * N) & 4294967295) >>> v.Mb
                                    ] = N);
                    } else {
                        if (!(N < g)) break t;
                        for (w = N - 280, e(null != v); d < f; )
                            (N = r[d++]),
                                (v.X[((506832829 * N) & 4294967295) >>> v.Mb] =
                                    N);
                        (N = f),
                            e(!(w >>> (_ = v).Xa)),
                            (r[N] = _.X[w]),
                            (w = !0);
                    }
                    w || e(h.h == A(h));
                }
                if (t.Pb && h.h && f < a)
                    e(t.m.h),
                        (t.a = 5),
                        (t.m = t.wd),
                        (t.$ = t.xd),
                        0 < t.s.ua && B(t.s.vb, t.s.Wa);
                else {
                    if (h.h) break t;
                    null != s && s(t, c > o ? o : c), (t.a = 0), (t.$ = f - n);
                }
                return 1;
            }
            return (t.a = 3), 0;
        }
        function Pt(t) {
            e(null != t), (t.vc = null), (t.yc = null), (t.Ya = null);
            var r = t.Wa;
            null != r && (r.X = null), (t.vb = null), e(null != t);
        }
        function kt() {
            var e = new or();
            return null == e
                ? null
                : ((e.a = 0),
                  (e.xb = gi),
                  rt("Predictor", "VP8LPredictors"),
                  rt("Predictor", "VP8LPredictors_C"),
                  rt("PredictorAdd", "VP8LPredictorsAdd"),
                  rt("PredictorAdd", "VP8LPredictorsAdd_C"),
                  (Gr = G),
                  ($r = J),
                  (Qr = K),
                  (tn = Z),
                  (en = $),
                  (rn = Q),
                  (nn = tt),
                  (t.VP8LMapColor32b = Jr),
                  (t.VP8LMapColor8b = Kr),
                  e);
        }
        function It(t, r, n, s, c) {
            var u = 1,
                f = [t],
                p = [r],
                g = s.m,
                m = s.s,
                v = null,
                b = 0;
            t: for (;;) {
                if (n)
                    for (; u && y(g, 1); ) {
                        var w = f,
                            N = p,
                            A = s,
                            _ = 1,
                            P = A.m,
                            k = A.gc[A.ab],
                            I = y(P, 2);
                        if (A.Oc & (1 << I)) u = 0;
                        else {
                            switch (
                                ((A.Oc |= 1 << I),
                                (k.hc = I),
                                (k.Ea = w[0]),
                                (k.nc = N[0]),
                                (k.K = [null]),
                                ++A.ab,
                                e(4 >= A.ab),
                                I)
                            ) {
                                case 0:
                                case 1:
                                    (k.b = y(P, 3) + 2),
                                        (_ = It(
                                            q(k.Ea, k.b),
                                            q(k.nc, k.b),
                                            0,
                                            A,
                                            k.K,
                                        )),
                                        (k.K = k.K[0]);
                                    break;
                                case 3:
                                    var F,
                                        C = y(P, 8) + 1,
                                        j =
                                            16 < C
                                                ? 0
                                                : 4 < C
                                                  ? 1
                                                  : 2 < C
                                                    ? 2
                                                    : 3;
                                    if (
                                        ((w[0] = q(k.Ea, j)),
                                        (k.b = j),
                                        (F = _ = It(C, 1, 0, A, k.K)))
                                    ) {
                                        var B,
                                            M = C,
                                            E = k,
                                            R = 1 << (8 >> E.b),
                                            T = a(R);
                                        if (null == T) F = 0;
                                        else {
                                            var U = E.K[0],
                                                z = E.w;
                                            for (
                                                T[0] = E.K[0][0], B = 1;
                                                B < 1 * M;
                                                ++B
                                            )
                                                T[B] = D(U[z + B], T[B - 1]);
                                            for (; B < 4 * R; ++B) T[B] = 0;
                                            (E.K[0] = null),
                                                (E.K[0] = T),
                                                (F = 1);
                                        }
                                    }
                                    _ = F;
                                    break;
                                case 2:
                                    break;
                                default:
                                    e(0);
                            }
                            u = _;
                        }
                    }
                if (
                    ((f = f[0]),
                    (p = p[0]),
                    u && y(g, 1) && !(u = 1 <= (b = y(g, 4)) && 11 >= b))
                ) {
                    s.a = 3;
                    break t;
                }
                var H;
                if ((H = u))
                    e: {
                        var W,
                            V,
                            G,
                            Y = s,
                            J = f,
                            X = p,
                            K = b,
                            Z = n,
                            $ = Y.m,
                            Q = Y.s,
                            tt = [null],
                            et = 1,
                            rt = 0,
                            nt = Qn[K];
                        r: for (;;) {
                            if (Z && y($, 1)) {
                                var it = y($, 3) + 2,
                                    at = q(J, it),
                                    ot = q(X, it),
                                    st = at * ot;
                                if (!It(at, ot, 0, Y, tt)) break r;
                                for (
                                    tt = tt[0], Q.xc = it, W = 0;
                                    W < st;
                                    ++W
                                ) {
                                    var ct = (tt[W] >> 8) & 65535;
                                    (tt[W] = ct), ct >= et && (et = ct + 1);
                                }
                            }
                            if ($.h) break r;
                            for (V = 0; 5 > V; ++V) {
                                var ut = Xn[V];
                                !V && 0 < K && (ut += 1 << K),
                                    rt < ut && (rt = ut);
                            }
                            var ht = o(et * nt, l),
                                lt = et,
                                ft = o(lt, d);
                            if (null == ft) var dt = null;
                            else e(65536 >= lt), (dt = ft);
                            var pt = a(rt);
                            if (null == dt || null == pt || null == ht) {
                                Y.a = 1;
                                break r;
                            }
                            var gt = ht;
                            for (W = G = 0; W < et; ++W) {
                                var mt = dt[W],
                                    vt = mt.G,
                                    bt = mt.H,
                                    wt = 0,
                                    Nt = 1,
                                    Lt = 0;
                                for (V = 0; 5 > V; ++V) {
                                    (ut = Xn[V]),
                                        (vt[V] = gt),
                                        (bt[V] = G),
                                        !V && 0 < K && (ut += 1 << K);
                                    n: {
                                        var At,
                                            xt = ut,
                                            St = Y,
                                            kt = pt,
                                            Ft = gt,
                                            Ct = G,
                                            jt = 0,
                                            Ot = St.m,
                                            Bt = y(Ot, 1);
                                        if ((i(kt, 0, 0, xt), Bt)) {
                                            var Mt = y(Ot, 1) + 1,
                                                Et = y(Ot, 1),
                                                qt = y(Ot, 0 == Et ? 1 : 8);
                                            (kt[qt] = 1),
                                                2 == Mt &&
                                                    (kt[(qt = y(Ot, 8))] = 1);
                                            var Dt = 1;
                                        } else {
                                            var Rt = a(19),
                                                Tt = y(Ot, 4) + 4;
                                            if (19 < Tt) {
                                                St.a = 3;
                                                var Ut = 0;
                                                break n;
                                            }
                                            for (At = 0; At < Tt; ++At)
                                                Rt[Zn[At]] = y(Ot, 3);
                                            var zt = void 0,
                                                Ht = void 0,
                                                Wt = St,
                                                Vt = Rt,
                                                Gt = xt,
                                                Yt = kt,
                                                Jt = 0,
                                                Xt = Wt.m,
                                                Kt = 8,
                                                Zt = o(128, l);
                                            i: for (; h(Zt, 0, 7, Vt, 19); ) {
                                                if (y(Xt, 1)) {
                                                    var $t = 2 + 2 * y(Xt, 3);
                                                    if (
                                                        (zt = 2 + y(Xt, $t)) >
                                                        Gt
                                                    )
                                                        break i;
                                                } else zt = Gt;
                                                for (
                                                    Ht = 0;
                                                    Ht < Gt && zt--;

                                                ) {
                                                    S(Xt);
                                                    var Qt =
                                                        Zt[0 + (127 & L(Xt))];
                                                    x(Xt, Xt.u + Qt.g);
                                                    var te = Qt.value;
                                                    if (16 > te)
                                                        (Yt[Ht++] = te),
                                                            0 != te &&
                                                                (Kt = te);
                                                    else {
                                                        var ee = 16 == te,
                                                            re = te - 16,
                                                            ne = Jn[re],
                                                            ie =
                                                                y(Xt, Yn[re]) +
                                                                ne;
                                                        if (Ht + ie > Gt)
                                                            break i;
                                                        for (
                                                            var ae = ee
                                                                ? Kt
                                                                : 0;
                                                            0 < ie--;

                                                        )
                                                            Yt[Ht++] = ae;
                                                    }
                                                }
                                                Jt = 1;
                                                break i;
                                            }
                                            Jt || (Wt.a = 3), (Dt = Jt);
                                        }
                                        (Dt = Dt && !Ot.h) &&
                                            (jt = h(Ft, Ct, 8, kt, xt)),
                                            Dt && 0 != jt
                                                ? (Ut = jt)
                                                : ((St.a = 3), (Ut = 0));
                                    }
                                    if (0 == Ut) break r;
                                    if (
                                        (Nt &&
                                            1 == Kn[V] &&
                                            (Nt = 0 == gt[G].g),
                                        (wt += gt[G].g),
                                        (G += Ut),
                                        3 >= V)
                                    ) {
                                        var oe,
                                            se = pt[0];
                                        for (oe = 1; oe < ut; ++oe)
                                            pt[oe] > se && (se = pt[oe]);
                                        Lt += se;
                                    }
                                }
                                if (
                                    ((mt.nd = Nt),
                                    (mt.Qb = 0),
                                    Nt &&
                                        ((mt.qb =
                                            ((vt[3][bt[3] + 0].value << 24) |
                                                (vt[1][bt[1] + 0].value << 16) |
                                                vt[2][bt[2] + 0].value) >>>
                                            0),
                                        0 == wt &&
                                            256 > vt[0][bt[0] + 0].value &&
                                            ((mt.Qb = 1),
                                            (mt.qb +=
                                                vt[0][bt[0] + 0].value << 8))),
                                    (mt.jc = !mt.Qb && 6 > Lt),
                                    mt.jc)
                                ) {
                                    var ce,
                                        ue = mt;
                                    for (ce = 0; ce < Dr; ++ce) {
                                        var he = ce,
                                            le = ue.pd[he],
                                            fe = ue.G[0][ue.H[0] + he];
                                        256 <= fe.value
                                            ? ((le.g = fe.g + 256),
                                              (le.value = fe.value))
                                            : ((le.g = 0),
                                              (le.value = 0),
                                              (he >>= yt(fe, 8, le)),
                                              (he >>= yt(
                                                  ue.G[1][ue.H[1] + he],
                                                  16,
                                                  le,
                                              )),
                                              (he >>= yt(
                                                  ue.G[2][ue.H[2] + he],
                                                  0,
                                                  le,
                                              )),
                                              yt(
                                                  ue.G[3][ue.H[3] + he],
                                                  24,
                                                  le,
                                              ));
                                    }
                                }
                            }
                            (Q.vc = tt),
                                (Q.Wb = et),
                                (Q.Ya = dt),
                                (Q.yc = ht),
                                (H = 1);
                            break e;
                        }
                        H = 0;
                    }
                if (!(u = H)) {
                    s.a = 3;
                    break t;
                }
                if (0 < b) {
                    if (((m.ua = 1 << b), !O(m.Wa, b))) {
                        (s.a = 1), (u = 0);
                        break t;
                    }
                } else m.ua = 0;
                var de = s,
                    pe = f,
                    ge = p,
                    me = de.s,
                    ve = me.xc;
                if (
                    ((de.c = pe),
                    (de.i = ge),
                    (me.md = q(pe, ve)),
                    (me.wc = 0 == ve ? -1 : (1 << ve) - 1),
                    n)
                ) {
                    s.xb = pi;
                    break t;
                }
                if (null == (v = a(f * p))) {
                    (s.a = 1), (u = 0);
                    break t;
                }
                u = (u = _t(s, v, 0, f, p, p, null)) && !g.h;
                break t;
            }
            return (
                u
                    ? (null != c ? (c[0] = v) : (e(null == v), e(n)),
                      (s.$ = 0),
                      n || Pt(m))
                    : Pt(m),
                u
            );
        }
        function Ft(t, r) {
            var n = t.c * t.i,
                i = n + r + 16 * r;
            return (
                e(t.c <= r),
                (t.V = a(i)),
                null == t.V
                    ? ((t.Ta = null), (t.Ua = 0), (t.a = 1), 0)
                    : ((t.Ta = t.V), (t.Ua = t.Ba + n + r), 1)
            );
        }
        function Ct(t, r) {
            var n = t.C,
                i = r - n,
                a = t.V,
                o = t.Ba + t.c * n;
            for (e(r <= t.l.o); 0 < i; ) {
                var s = 16 < i ? 16 : i,
                    c = t.l.ma,
                    u = t.l.width,
                    h = u * s,
                    l = c.ca,
                    f = c.tb + u * n,
                    d = t.Ta,
                    p = t.Ua;
                Nt(t, s, a, o),
                    _n(d, p, l, f, h),
                    xt(c, n, n + s, l, f, u),
                    (i -= s),
                    (a += s * t.c),
                    (n += s);
            }
            e(n == r), (t.C = t.Ma = r);
        }
        function jt() {
            this.ub = this.yd = this.td = this.Rb = 0;
        }
        function Ot() {
            this.Kd = this.Ld = this.Ud = this.Td = this.i = this.c = 0;
        }
        function Bt() {
            (this.Fb = this.Bb = this.Cb = 0),
                (this.Zb = a(4)),
                (this.Lb = a(4));
        }
        function Mt() {
            this.Yb = (function () {
                var t = [];
                return (
                    (function t(e, r, n) {
                        for (
                            var i = n[r], a = 0;
                            a < i &&
                            (e.push(n.length > r + 1 ? [] : 0),
                            !(n.length < r + 1));
                            a++
                        )
                            t(e[a], r + 1, n);
                    })(t, 0, [3, 11]),
                    t
                );
            })();
        }
        function Et() {
            (this.jb = a(3)),
                (this.Wc = s([4, 8], Mt)),
                (this.Xc = s([4, 17], Mt));
        }
        function qt() {
            (this.Pc = this.wb = this.Tb = this.zd = 0),
                (this.vd = new a(4)),
                (this.od = new a(4));
        }
        function Dt() {
            this.ld = this.La = this.dd = this.tc = 0;
        }
        function Rt() {
            this.Na = this.la = 0;
        }
        function Tt() {
            (this.Sc = [0, 0]),
                (this.Eb = [0, 0]),
                (this.Qc = [0, 0]),
                (this.ia = this.lc = 0);
        }
        function Ut() {
            (this.ad = a(384)),
                (this.Za = 0),
                (this.Ob = a(16)),
                (this.$b = this.Ad = this.ia = this.Gc = this.Hc = this.Dd = 0);
        }
        function zt() {
            (this.uc = this.M = this.Nb = 0),
                (this.wa = Array(new Dt())),
                (this.Y = 0),
                (this.ya = Array(new Ut())),
                (this.aa = 0),
                (this.l = new Gt());
        }
        function Ht() {
            (this.y = a(16)), (this.f = a(8)), (this.ea = a(8));
        }
        function Wt() {
            (this.cb = this.a = 0),
                (this.sc = ""),
                (this.m = new w()),
                (this.Od = new jt()),
                (this.Kc = new Ot()),
                (this.ed = new qt()),
                (this.Qa = new Bt()),
                (this.Ic = this.$c = this.Aa = 0),
                (this.D = new zt()),
                (this.Xb =
                    this.Va =
                    this.Hb =
                    this.zb =
                    this.yb =
                    this.Ub =
                    this.za =
                        0),
                (this.Jc = o(8, w)),
                (this.ia = 0),
                (this.pb = o(4, Tt)),
                (this.Pa = new Et()),
                (this.Bd = this.kc = 0),
                (this.Ac = []),
                (this.Bc = 0),
                (this.zc = [0, 0, 0, 0]),
                (this.Gd = Array(new Ht())),
                (this.Hd = 0),
                (this.rb = Array(new Rt())),
                (this.sb = 0),
                (this.wa = Array(new Dt())),
                (this.Y = 0),
                (this.oc = []),
                (this.pc = 0),
                (this.sa = []),
                (this.ta = 0),
                (this.qa = []),
                (this.ra = 0),
                (this.Ha = []),
                (this.B = this.R = this.Ia = 0),
                (this.Ec = []),
                (this.M = this.ja = this.Vb = this.Fc = 0),
                (this.ya = Array(new Ut())),
                (this.L = this.aa = 0),
                (this.gd = s([4, 2], Dt)),
                (this.ga = null),
                (this.Fa = []),
                (this.Cc = this.qc = this.P = 0),
                (this.Gb = []),
                (this.Uc = 0),
                (this.mb = []),
                (this.nb = 0),
                (this.rc = []),
                (this.Ga = this.Vc = 0);
        }
        function Vt(t, e) {
            return 0 > t ? 0 : t > e ? e : t;
        }
        function Gt() {
            (this.T = this.U = this.ka = this.height = this.width = 0),
                (this.y = []),
                (this.f = []),
                (this.ea = []),
                (this.Rc = this.fa = this.W = this.N = this.O = 0),
                (this.ma = "void"),
                (this.put = "VP8IoPutHook"),
                (this.ac = "VP8IoSetupHook"),
                (this.bc = "VP8IoTeardownHook"),
                (this.ha = this.Kb = 0),
                (this.data = []),
                (this.hb =
                    this.ib =
                    this.da =
                    this.o =
                    this.j =
                    this.va =
                    this.v =
                    this.Da =
                    this.ob =
                    this.w =
                        0),
                (this.F = []),
                (this.J = 0);
        }
        function Yt() {
            var t = new Wt();
            return (
                null != t &&
                    ((t.a = 0),
                    (t.sc = "OK"),
                    (t.cb = 0),
                    (t.Xb = 0),
                    ni || (ni = Zt)),
                t
            );
        }
        function Jt(t, e, r) {
            return 0 == t.a && ((t.a = e), (t.sc = r), (t.cb = 0)), 0;
        }
        function Xt(t, e, r) {
            return 3 <= r && 157 == t[e + 0] && 1 == t[e + 1] && 42 == t[e + 2];
        }
        function Kt(t, r) {
            if (null == t) return 0;
            if (((t.a = 0), (t.sc = "OK"), null == r))
                return Jt(t, 2, "null VP8Io passed to VP8GetHeaders()");
            var n = r.data,
                a = r.w,
                o = r.ha;
            if (4 > o) return Jt(t, 7, "Truncated header.");
            var s = n[a + 0] | (n[a + 1] << 8) | (n[a + 2] << 16),
                c = t.Od;
            if (
                ((c.Rb = !(1 & s)),
                (c.td = (s >> 1) & 7),
                (c.yd = (s >> 4) & 1),
                (c.ub = s >> 5),
                3 < c.td)
            )
                return Jt(t, 3, "Incorrect keyframe parameters.");
            if (!c.yd) return Jt(t, 4, "Frame not displayable.");
            (a += 3), (o -= 3);
            var u = t.Kc;
            if (c.Rb) {
                if (7 > o) return Jt(t, 7, "cannot parse picture header");
                if (!Xt(n, a, o)) return Jt(t, 3, "Bad code word");
                (u.c = 16383 & ((n[a + 4] << 8) | n[a + 3])),
                    (u.Td = n[a + 4] >> 6),
                    (u.i = 16383 & ((n[a + 6] << 8) | n[a + 5])),
                    (u.Ud = n[a + 6] >> 6),
                    (a += 7),
                    (o -= 7),
                    (t.za = (u.c + 15) >> 4),
                    (t.Ub = (u.i + 15) >> 4),
                    (r.width = u.c),
                    (r.height = u.i),
                    (r.Da = 0),
                    (r.j = 0),
                    (r.v = 0),
                    (r.va = r.width),
                    (r.o = r.height),
                    (r.da = 0),
                    (r.ib = r.width),
                    (r.hb = r.height),
                    (r.U = r.width),
                    (r.T = r.height),
                    i((s = t.Pa).jb, 0, 255, s.jb.length),
                    e(null != (s = t.Qa)),
                    (s.Cb = 0),
                    (s.Bb = 0),
                    (s.Fb = 1),
                    i(s.Zb, 0, 0, s.Zb.length),
                    i(s.Lb, 0, 0, s.Lb);
            }
            if (c.ub > o) return Jt(t, 7, "bad partition length");
            p((s = t.m), n, a, c.ub),
                (a += c.ub),
                (o -= c.ub),
                c.Rb && ((u.Ld = P(s)), (u.Kd = P(s))),
                (u = t.Qa);
            var h,
                l = t.Pa;
            if ((e(null != s), e(null != u), (u.Cb = P(s)), u.Cb)) {
                if (((u.Bb = P(s)), P(s))) {
                    for (u.Fb = P(s), h = 0; 4 > h; ++h)
                        u.Zb[h] = P(s) ? m(s, 7) : 0;
                    for (h = 0; 4 > h; ++h) u.Lb[h] = P(s) ? m(s, 6) : 0;
                }
                if (u.Bb)
                    for (h = 0; 3 > h; ++h) l.jb[h] = P(s) ? g(s, 8) : 255;
            } else u.Bb = 0;
            if (s.Ka) return Jt(t, 3, "cannot parse segment header");
            if (
                (((u = t.ed).zd = P(s)),
                (u.Tb = g(s, 6)),
                (u.wb = g(s, 3)),
                (u.Pc = P(s)),
                u.Pc && P(s))
            ) {
                for (l = 0; 4 > l; ++l) P(s) && (u.vd[l] = m(s, 6));
                for (l = 0; 4 > l; ++l) P(s) && (u.od[l] = m(s, 6));
            }
            if (((t.L = 0 == u.Tb ? 0 : u.zd ? 1 : 2), s.Ka))
                return Jt(t, 3, "cannot parse filter header");
            var f = o;
            if (
                ((o = h = a),
                (a = h + f),
                (u = f),
                (t.Xb = (1 << g(t.m, 2)) - 1),
                f < 3 * (l = t.Xb))
            )
                n = 7;
            else {
                for (h += 3 * l, u -= 3 * l, f = 0; f < l; ++f) {
                    var d = n[o + 0] | (n[o + 1] << 8) | (n[o + 2] << 16);
                    d > u && (d = u),
                        p(t.Jc[+f], n, h, d),
                        (h += d),
                        (u -= d),
                        (o += 3);
                }
                p(t.Jc[+l], n, h, u), (n = h < a ? 0 : 5);
            }
            if (0 != n) return Jt(t, n, "cannot parse partitions");
            for (
                n = g((h = t.m), 7),
                    o = P(h) ? m(h, 4) : 0,
                    a = P(h) ? m(h, 4) : 0,
                    u = P(h) ? m(h, 4) : 0,
                    l = P(h) ? m(h, 4) : 0,
                    h = P(h) ? m(h, 4) : 0,
                    f = t.Qa,
                    d = 0;
                4 > d;
                ++d
            ) {
                if (f.Cb) {
                    var v = f.Zb[d];
                    f.Fb || (v += n);
                } else {
                    if (0 < d) {
                        t.pb[d] = t.pb[0];
                        continue;
                    }
                    v = n;
                }
                var b = t.pb[d];
                (b.Sc[0] = ei[Vt(v + o, 127)]),
                    (b.Sc[1] = ri[Vt(v + 0, 127)]),
                    (b.Eb[0] = 2 * ei[Vt(v + a, 127)]),
                    (b.Eb[1] = (101581 * ri[Vt(v + u, 127)]) >> 16),
                    8 > b.Eb[1] && (b.Eb[1] = 8),
                    (b.Qc[0] = ei[Vt(v + l, 117)]),
                    (b.Qc[1] = ri[Vt(v + h, 127)]),
                    (b.lc = v + h);
            }
            if (!c.Rb) return Jt(t, 4, "Not a key frame.");
            for (P(s), c = t.Pa, n = 0; 4 > n; ++n) {
                for (o = 0; 8 > o; ++o)
                    for (a = 0; 3 > a; ++a)
                        for (u = 0; 11 > u; ++u)
                            (l = k(s, ui[n][o][a][u])
                                ? g(s, 8)
                                : si[n][o][a][u]),
                                (c.Wc[n][o].Yb[a][u] = l);
                for (o = 0; 17 > o; ++o) c.Xc[n][o] = c.Wc[n][hi[o]];
            }
            return (t.kc = P(s)), t.kc && (t.Bd = g(s, 8)), (t.cb = 1);
        }
        function Zt(t, e, r, n, i, a, o) {
            var s = e[i].Yb[r];
            for (r = 0; 16 > i; ++i) {
                if (!k(t, s[r + 0])) return i;
                for (; !k(t, s[r + 1]); )
                    if (((s = e[++i].Yb[0]), (r = 0), 16 == i)) return 16;
                var c = e[i + 1].Yb;
                if (k(t, s[r + 2])) {
                    var u = t,
                        h = 0;
                    if (k(u, (f = s)[(l = r) + 3])) {
                        if (k(u, f[l + 6])) {
                            for (
                                s = 0,
                                    l =
                                        2 * (h = k(u, f[l + 8])) +
                                        (f = k(u, f[l + 9 + h])),
                                    h = 0,
                                    f = ii[l];
                                f[s];
                                ++s
                            )
                                h += h + k(u, f[s]);
                            h += 3 + (8 << l);
                        } else
                            k(u, f[l + 7])
                                ? ((h = 7 + 2 * k(u, 165)), (h += k(u, 145)))
                                : (h = 5 + k(u, 159));
                    } else h = k(u, f[l + 4]) ? 3 + k(u, f[l + 5]) : 2;
                    s = c[2];
                } else (h = 1), (s = c[1]);
                (c = o + ai[i]), 0 > (u = t).b && _(u);
                var l,
                    f = u.b,
                    d = ((l = u.Ca >> 1) - (u.I >> f)) >> 31;
                --u.b,
                    (u.Ca += d),
                    (u.Ca |= 1),
                    (u.I -= ((l + 1) & d) << f),
                    (a[c] = ((h ^ d) - d) * n[(0 < i) + 0]);
            }
            return 16;
        }
        function $t(t) {
            var e = t.rb[t.sb - 1];
            (e.la = 0), (e.Na = 0), i(t.zc, 0, 0, t.zc.length), (t.ja = 0);
        }
        function Qt(t, r) {
            if (null == t) return 0;
            if (null == r)
                return Jt(t, 2, "NULL VP8Io parameter in VP8Decode().");
            if (!t.cb && !Kt(t, r)) return 0;
            if ((e(t.cb), null == r.ac || r.ac(r))) {
                r.ob && (t.L = 0);
                var s = Ri[t.L];
                if (
                    (2 == t.L
                        ? ((t.yb = 0), (t.zb = 0))
                        : ((t.yb = (r.v - s) >> 4),
                          (t.zb = (r.j - s) >> 4),
                          0 > t.yb && (t.yb = 0),
                          0 > t.zb && (t.zb = 0)),
                    (t.Va = (r.o + 15 + s) >> 4),
                    (t.Hb = (r.va + 15 + s) >> 4),
                    t.Hb > t.za && (t.Hb = t.za),
                    t.Va > t.Ub && (t.Va = t.Ub),
                    0 < t.L)
                ) {
                    var c = t.ed;
                    for (s = 0; 4 > s; ++s) {
                        var u;
                        if (t.Qa.Cb) {
                            var h = t.Qa.Lb[s];
                            t.Qa.Fb || (h += c.Tb);
                        } else h = c.Tb;
                        for (u = 0; 1 >= u; ++u) {
                            var l = t.gd[s][u],
                                f = h;
                            if (
                                (c.Pc && ((f += c.vd[0]), u && (f += c.od[0])),
                                0 < (f = 0 > f ? 0 : 63 < f ? 63 : f))
                            ) {
                                var d = f;
                                0 < c.wb &&
                                    (d = 4 < c.wb ? d >> 2 : d >> 1) >
                                        9 - c.wb &&
                                    (d = 9 - c.wb),
                                    1 > d && (d = 1),
                                    (l.dd = d),
                                    (l.tc = 2 * f + d),
                                    (l.ld = 40 <= f ? 2 : 15 <= f ? 1 : 0);
                            } else l.tc = 0;
                            l.La = u;
                        }
                    }
                }
                s = 0;
            } else Jt(t, 6, "Frame setup failed"), (s = t.a);
            if ((s = 0 == s)) {
                if (s) {
                    (t.$c = 0), 0 < t.Aa || (t.Ic = Ui);
                    t: {
                        s = t.Ic;
                        c = 4 * (d = t.za);
                        var p = 32 * d,
                            g = d + 1,
                            m = 0 < t.L ? d * (0 < t.Aa ? 2 : 1) : 0,
                            v = (2 == t.Aa ? 2 : 1) * d;
                        if (
                            (l =
                                c +
                                832 +
                                (u = ((3 * (16 * s + Ri[t.L])) / 2) * p) +
                                (h =
                                    null != t.Fa && 0 < t.Fa.length
                                        ? t.Kc.c * t.Kc.i
                                        : 0)) != l
                        )
                            s = 0;
                        else {
                            if (l > t.Vb) {
                                if (
                                    ((t.Vb = 0),
                                    (t.Ec = a(l)),
                                    (t.Fc = 0),
                                    null == t.Ec)
                                ) {
                                    s = Jt(
                                        t,
                                        1,
                                        "no memory during frame initialization.",
                                    );
                                    break t;
                                }
                                t.Vb = l;
                            }
                            (l = t.Ec),
                                (f = t.Fc),
                                (t.Ac = l),
                                (t.Bc = f),
                                (f += c),
                                (t.Gd = o(p, Ht)),
                                (t.Hd = 0),
                                (t.rb = o(g + 1, Rt)),
                                (t.sb = 1),
                                (t.wa = m ? o(m, Dt) : null),
                                (t.Y = 0),
                                (t.D.Nb = 0),
                                (t.D.wa = t.wa),
                                (t.D.Y = t.Y),
                                0 < t.Aa && (t.D.Y += d),
                                e(!0),
                                (t.oc = l),
                                (t.pc = f),
                                (f += 832),
                                (t.ya = o(v, Ut)),
                                (t.aa = 0),
                                (t.D.ya = t.ya),
                                (t.D.aa = t.aa),
                                2 == t.Aa && (t.D.aa += d),
                                (t.R = 16 * d),
                                (t.B = 8 * d),
                                (d = (p = Ri[t.L]) * t.R),
                                (p = (p / 2) * t.B),
                                (t.sa = l),
                                (t.ta = f + d),
                                (t.qa = t.sa),
                                (t.ra = t.ta + 16 * s * t.R + p),
                                (t.Ha = t.qa),
                                (t.Ia = t.ra + 8 * s * t.B + p),
                                (t.$c = 0),
                                (f += u),
                                (t.mb = h ? l : null),
                                (t.nb = h ? f : null),
                                e(f + h <= t.Fc + t.Vb),
                                $t(t),
                                i(t.Ac, t.Bc, 0, c),
                                (s = 1);
                        }
                    }
                    if (s) {
                        if (
                            ((r.ka = 0),
                            (r.y = t.sa),
                            (r.O = t.ta),
                            (r.f = t.qa),
                            (r.N = t.ra),
                            (r.ea = t.Ha),
                            (r.Vd = t.Ia),
                            (r.fa = t.R),
                            (r.Rc = t.B),
                            (r.F = null),
                            (r.J = 0),
                            !Cn)
                        ) {
                            for (s = -255; 255 >= s; ++s)
                                Pn[255 + s] = 0 > s ? -s : s;
                            for (s = -1020; 1020 >= s; ++s)
                                kn[1020 + s] =
                                    -128 > s ? -128 : 127 < s ? 127 : s;
                            for (s = -112; 112 >= s; ++s)
                                In[112 + s] = -16 > s ? -16 : 15 < s ? 15 : s;
                            for (s = -255; 510 >= s; ++s)
                                Fn[255 + s] = 0 > s ? 0 : 255 < s ? 255 : s;
                            Cn = 1;
                        }
                        (an = ue),
                            (on = ae),
                            (cn = oe),
                            (un = se),
                            (hn = ce),
                            (sn = ie),
                            (ln = Je),
                            (fn = Xe),
                            (dn = $e),
                            (pn = Qe),
                            (gn = Ke),
                            (mn = Ze),
                            (vn = tr),
                            (bn = er),
                            (yn = ze),
                            (wn = He),
                            (Nn = We),
                            (Ln = Ve),
                            (fi[0] = xe),
                            (fi[1] = le),
                            (fi[2] = Le),
                            (fi[3] = Ae),
                            (fi[4] = Se),
                            (fi[5] = Pe),
                            (fi[6] = _e),
                            (fi[7] = ke),
                            (fi[8] = Fe),
                            (fi[9] = Ie),
                            (li[0] = ve),
                            (li[1] = de),
                            (li[2] = pe),
                            (li[3] = ge),
                            (li[4] = be),
                            (li[5] = ye),
                            (li[6] = we),
                            (di[0] = Be),
                            (di[1] = fe),
                            (di[2] = Ce),
                            (di[3] = je),
                            (di[4] = Ee),
                            (di[5] = Me),
                            (di[6] = qe),
                            (s = 1);
                    } else s = 0;
                }
                s &&
                    (s = (function (t, r) {
                        for (t.M = 0; t.M < t.Va; ++t.M) {
                            var o,
                                s = t.Jc[t.M & t.Xb],
                                c = t.m,
                                u = t;
                            for (o = 0; o < u.za; ++o) {
                                var h = c,
                                    l = u,
                                    f = l.Ac,
                                    d = l.Bc + 4 * o,
                                    p = l.zc,
                                    g = l.ya[l.aa + o];
                                if (
                                    (l.Qa.Bb
                                        ? (g.$b = k(h, l.Pa.jb[0])
                                              ? 2 + k(h, l.Pa.jb[2])
                                              : k(h, l.Pa.jb[1]))
                                        : (g.$b = 0),
                                    l.kc && (g.Ad = k(h, l.Bd)),
                                    (g.Za = !k(h, 145) + 0),
                                    g.Za)
                                ) {
                                    var m = g.Ob,
                                        v = 0;
                                    for (l = 0; 4 > l; ++l) {
                                        var b,
                                            y = p[0 + l];
                                        for (b = 0; 4 > b; ++b) {
                                            y = ci[f[d + b]][y];
                                            for (
                                                var w = oi[k(h, y[0])];
                                                0 < w;

                                            )
                                                w = oi[2 * w + k(h, y[w])];
                                            (y = -w), (f[d + b] = y);
                                        }
                                        n(m, v, f, d, 4),
                                            (v += 4),
                                            (p[0 + l] = y);
                                    }
                                } else
                                    (y = k(h, 156)
                                        ? k(h, 128)
                                            ? 1
                                            : 3
                                        : k(h, 163)
                                          ? 2
                                          : 0),
                                        (g.Ob[0] = y),
                                        i(f, d, y, 4),
                                        i(p, 0, y, 4);
                                g.Dd = k(h, 142)
                                    ? k(h, 114)
                                        ? k(h, 183)
                                            ? 1
                                            : 3
                                        : 2
                                    : 0;
                            }
                            if (u.m.Ka)
                                return Jt(
                                    t,
                                    7,
                                    "Premature end-of-partition0 encountered.",
                                );
                            for (; t.ja < t.za; ++t.ja) {
                                if (
                                    ((u = s),
                                    (h = (c = t).rb[c.sb - 1]),
                                    (f = c.rb[c.sb + c.ja]),
                                    (o = c.ya[c.aa + c.ja]),
                                    (d = c.kc ? o.Ad : 0))
                                )
                                    (h.la = f.la = 0),
                                        o.Za || (h.Na = f.Na = 0),
                                        (o.Hc = 0),
                                        (o.Gc = 0),
                                        (o.ia = 0);
                                else {
                                    var N, L;
                                    (h = f),
                                        (f = u),
                                        (d = c.Pa.Xc),
                                        (p = c.ya[c.aa + c.ja]),
                                        (g = c.pb[p.$b]);
                                    if (
                                        ((l = p.ad),
                                        (m = 0),
                                        (v = c.rb[c.sb - 1]),
                                        (y = b = 0),
                                        i(l, m, 0, 384),
                                        p.Za)
                                    )
                                        var A = 0,
                                            x = d[3];
                                    else {
                                        w = a(16);
                                        var S = h.Na + v.Na;
                                        if (
                                            ((S = ni(
                                                f,
                                                d[1],
                                                S,
                                                g.Eb,
                                                0,
                                                w,
                                                0,
                                            )),
                                            (h.Na = v.Na = (0 < S) + 0),
                                            1 < S)
                                        )
                                            an(w, 0, l, m);
                                        else {
                                            var _ = (w[0] + 3) >> 3;
                                            for (w = 0; 256 > w; w += 16)
                                                l[m + w] = _;
                                        }
                                        (A = 1), (x = d[0]);
                                    }
                                    var P = 15 & h.la,
                                        I = 15 & v.la;
                                    for (w = 0; 4 > w; ++w) {
                                        var F = 1 & I;
                                        for (_ = L = 0; 4 > _; ++_)
                                            (P =
                                                (P >> 1) |
                                                ((F =
                                                    (S = ni(
                                                        f,
                                                        x,
                                                        (S = F + (1 & P)),
                                                        g.Sc,
                                                        A,
                                                        l,
                                                        m,
                                                    )) > A) <<
                                                    7)),
                                                (L =
                                                    (L << 2) |
                                                    (3 < S
                                                        ? 3
                                                        : 1 < S
                                                          ? 2
                                                          : 0 != l[m + 0])),
                                                (m += 16);
                                        (P >>= 4),
                                            (I = (I >> 1) | (F << 7)),
                                            (b = ((b << 8) | L) >>> 0);
                                    }
                                    for (
                                        x = P, A = I >> 4, N = 0;
                                        4 > N;
                                        N += 2
                                    ) {
                                        for (
                                            L = 0,
                                                P = h.la >> (4 + N),
                                                I = v.la >> (4 + N),
                                                w = 0;
                                            2 > w;
                                            ++w
                                        ) {
                                            for (F = 1 & I, _ = 0; 2 > _; ++_)
                                                (S = F + (1 & P)),
                                                    (P =
                                                        (P >> 1) |
                                                        ((F =
                                                            0 <
                                                            (S = ni(
                                                                f,
                                                                d[2],
                                                                S,
                                                                g.Qc,
                                                                0,
                                                                l,
                                                                m,
                                                            ))) <<
                                                            3)),
                                                    (L =
                                                        (L << 2) |
                                                        (3 < S
                                                            ? 3
                                                            : 1 < S
                                                              ? 2
                                                              : 0 != l[m + 0])),
                                                    (m += 16);
                                            (P >>= 2),
                                                (I = (I >> 1) | (F << 5));
                                        }
                                        (y |= L << (4 * N)),
                                            (x |= (P << 4) << N),
                                            (A |= (240 & I) << N);
                                    }
                                    (h.la = x),
                                        (v.la = A),
                                        (p.Hc = b),
                                        (p.Gc = y),
                                        (p.ia = 43690 & y ? 0 : g.ia),
                                        (d = !(b | y));
                                }
                                if (
                                    (0 < c.L &&
                                        ((c.wa[c.Y + c.ja] = c.gd[o.$b][o.Za]),
                                        (c.wa[c.Y + c.ja].La |= !d)),
                                    u.Ka)
                                )
                                    return Jt(
                                        t,
                                        7,
                                        "Premature end-of-file encountered.",
                                    );
                            }
                            if (
                                ($t(t),
                                (c = r),
                                (u = 1),
                                (o = (s = t).D),
                                (h = 0 < s.L && s.M >= s.zb && s.M <= s.Va),
                                0 == s.Aa)
                            )
                                t: {
                                    if (
                                        ((o.M = s.M),
                                        (o.uc = h),
                                        Or(s, o),
                                        (u = 1),
                                        (o = (L = s.D).Nb),
                                        (h = (y = Ri[s.L]) * s.R),
                                        (f = (y / 2) * s.B),
                                        (w = 16 * o * s.R),
                                        (_ = 8 * o * s.B),
                                        (d = s.sa),
                                        (p = s.ta - h + w),
                                        (g = s.qa),
                                        (l = s.ra - f + _),
                                        (m = s.Ha),
                                        (v = s.Ia - f + _),
                                        (I = 0 == (P = L.M)),
                                        (b = P >= s.Va - 1),
                                        2 == s.Aa && Or(s, L),
                                        L.uc)
                                    )
                                        for (
                                            F = (S = s).D.M,
                                                e(S.D.uc),
                                                L = S.yb;
                                            L < S.Hb;
                                            ++L
                                        ) {
                                            (A = L), (x = F);
                                            var C = (j = (U = S).D).Nb;
                                            N = U.R;
                                            var j = j.wa[j.Y + A],
                                                O = U.sa,
                                                B = U.ta + 16 * C * N + 16 * A,
                                                M = j.dd,
                                                E = j.tc;
                                            if (0 != E)
                                                if ((e(3 <= E), 1 == U.L))
                                                    0 < A && wn(O, B, N, E + 4),
                                                        j.La && Ln(O, B, N, E),
                                                        0 < x &&
                                                            yn(O, B, N, E + 4),
                                                        j.La && Nn(O, B, N, E);
                                                else {
                                                    var q = U.B,
                                                        D = U.qa,
                                                        R =
                                                            U.ra +
                                                            8 * C * q +
                                                            8 * A,
                                                        T = U.Ha,
                                                        U =
                                                            U.Ia +
                                                            8 * C * q +
                                                            8 * A;
                                                    C = j.ld;
                                                    0 < A &&
                                                        (fn(
                                                            O,
                                                            B,
                                                            N,
                                                            E + 4,
                                                            M,
                                                            C,
                                                        ),
                                                        pn(
                                                            D,
                                                            R,
                                                            T,
                                                            U,
                                                            q,
                                                            E + 4,
                                                            M,
                                                            C,
                                                        )),
                                                        j.La &&
                                                            (mn(
                                                                O,
                                                                B,
                                                                N,
                                                                E,
                                                                M,
                                                                C,
                                                            ),
                                                            bn(
                                                                D,
                                                                R,
                                                                T,
                                                                U,
                                                                q,
                                                                E,
                                                                M,
                                                                C,
                                                            )),
                                                        0 < x &&
                                                            (ln(
                                                                O,
                                                                B,
                                                                N,
                                                                E + 4,
                                                                M,
                                                                C,
                                                            ),
                                                            dn(
                                                                D,
                                                                R,
                                                                T,
                                                                U,
                                                                q,
                                                                E + 4,
                                                                M,
                                                                C,
                                                            )),
                                                        j.La &&
                                                            (gn(
                                                                O,
                                                                B,
                                                                N,
                                                                E,
                                                                M,
                                                                C,
                                                            ),
                                                            vn(
                                                                D,
                                                                R,
                                                                T,
                                                                U,
                                                                q,
                                                                E,
                                                                M,
                                                                C,
                                                            ));
                                                }
                                        }
                                    if (
                                        (s.ia && alert("todo:DitherRow"),
                                        null != c.put)
                                    ) {
                                        if (
                                            ((L = 16 * P),
                                            (P = 16 * (P + 1)),
                                            I
                                                ? ((c.y = s.sa),
                                                  (c.O = s.ta + w),
                                                  (c.f = s.qa),
                                                  (c.N = s.ra + _),
                                                  (c.ea = s.Ha),
                                                  (c.W = s.Ia + _))
                                                : ((L -= y),
                                                  (c.y = d),
                                                  (c.O = p),
                                                  (c.f = g),
                                                  (c.N = l),
                                                  (c.ea = m),
                                                  (c.W = v)),
                                            b || (P -= y),
                                            P > c.o && (P = c.o),
                                            (c.F = null),
                                            (c.J = null),
                                            null != s.Fa &&
                                                0 < s.Fa.length &&
                                                L < P &&
                                                ((c.J = lr(s, c, L, P - L)),
                                                (c.F = s.mb),
                                                null == c.F && 0 == c.F.length))
                                        ) {
                                            u = Jt(
                                                s,
                                                3,
                                                "Could not decode alpha data.",
                                            );
                                            break t;
                                        }
                                        L < c.j &&
                                            ((y = c.j - L),
                                            (L = c.j),
                                            e(!(1 & y)),
                                            (c.O += s.R * y),
                                            (c.N += s.B * (y >> 1)),
                                            (c.W += s.B * (y >> 1)),
                                            null != c.F &&
                                                (c.J += c.width * y)),
                                            L < P &&
                                                ((c.O += c.v),
                                                (c.N += c.v >> 1),
                                                (c.W += c.v >> 1),
                                                null != c.F && (c.J += c.v),
                                                (c.ka = L - c.j),
                                                (c.U = c.va - c.v),
                                                (c.T = P - L),
                                                (u = c.put(c)));
                                    }
                                    o + 1 != s.Ic ||
                                        b ||
                                        (n(s.sa, s.ta - h, d, p + 16 * s.R, h),
                                        n(s.qa, s.ra - f, g, l + 8 * s.B, f),
                                        n(s.Ha, s.Ia - f, m, v + 8 * s.B, f));
                                }
                            if (!u) return Jt(t, 6, "Output aborted.");
                        }
                        return 1;
                    })(t, r)),
                    null != r.bc && r.bc(r),
                    (s &= 1);
            }
            return s ? ((t.cb = 0), s) : 0;
        }
        function te(t, e, r, n, i) {
            (i = t[e + r + 32 * n] + (i >> 3)),
                (t[e + r + 32 * n] = -256 & i ? (0 > i ? 0 : 255) : i);
        }
        function ee(t, e, r, n, i, a) {
            te(t, e, 0, r, n + i),
                te(t, e, 1, r, n + a),
                te(t, e, 2, r, n - a),
                te(t, e, 3, r, n - i);
        }
        function re(t) {
            return ((20091 * t) >> 16) + t;
        }
        function ne(t, e, r, n) {
            var i,
                o = 0,
                s = a(16);
            for (i = 0; 4 > i; ++i) {
                var c = t[e + 0] + t[e + 8],
                    u = t[e + 0] - t[e + 8],
                    h = ((35468 * t[e + 4]) >> 16) - re(t[e + 12]),
                    l = re(t[e + 4]) + ((35468 * t[e + 12]) >> 16);
                (s[o + 0] = c + l),
                    (s[o + 1] = u + h),
                    (s[o + 2] = u - h),
                    (s[o + 3] = c - l),
                    (o += 4),
                    e++;
            }
            for (i = o = 0; 4 > i; ++i)
                (c = (t = s[o + 0] + 4) + s[o + 8]),
                    (u = t - s[o + 8]),
                    (h = ((35468 * s[o + 4]) >> 16) - re(s[o + 12])),
                    te(
                        r,
                        n,
                        0,
                        0,
                        c + (l = re(s[o + 4]) + ((35468 * s[o + 12]) >> 16)),
                    ),
                    te(r, n, 1, 0, u + h),
                    te(r, n, 2, 0, u - h),
                    te(r, n, 3, 0, c - l),
                    o++,
                    (n += 32);
        }
        function ie(t, e, r, n) {
            var i = t[e + 0] + 4,
                a = (35468 * t[e + 4]) >> 16,
                o = re(t[e + 4]),
                s = (35468 * t[e + 1]) >> 16;
            ee(r, n, 0, i + o, (t = re(t[e + 1])), s),
                ee(r, n, 1, i + a, t, s),
                ee(r, n, 2, i - a, t, s),
                ee(r, n, 3, i - o, t, s);
        }
        function ae(t, e, r, n, i) {
            ne(t, e, r, n), i && ne(t, e + 16, r, n + 4);
        }
        function oe(t, e, r, n) {
            on(t, e + 0, r, n, 1), on(t, e + 32, r, n + 128, 1);
        }
        function se(t, e, r, n) {
            var i;
            for (t = t[e + 0] + 4, i = 0; 4 > i; ++i)
                for (e = 0; 4 > e; ++e) te(r, n, e, i, t);
        }
        function ce(t, e, r, n) {
            t[e + 0] && un(t, e + 0, r, n),
                t[e + 16] && un(t, e + 16, r, n + 4),
                t[e + 32] && un(t, e + 32, r, n + 128),
                t[e + 48] && un(t, e + 48, r, n + 128 + 4);
        }
        function ue(t, e, r, n) {
            var i,
                o = a(16);
            for (i = 0; 4 > i; ++i) {
                var s = t[e + 0 + i] + t[e + 12 + i],
                    c = t[e + 4 + i] + t[e + 8 + i],
                    u = t[e + 4 + i] - t[e + 8 + i],
                    h = t[e + 0 + i] - t[e + 12 + i];
                (o[0 + i] = s + c),
                    (o[8 + i] = s - c),
                    (o[4 + i] = h + u),
                    (o[12 + i] = h - u);
            }
            for (i = 0; 4 > i; ++i)
                (s = (t = o[0 + 4 * i] + 3) + o[3 + 4 * i]),
                    (c = o[1 + 4 * i] + o[2 + 4 * i]),
                    (u = o[1 + 4 * i] - o[2 + 4 * i]),
                    (h = t - o[3 + 4 * i]),
                    (r[n + 0] = (s + c) >> 3),
                    (r[n + 16] = (h + u) >> 3),
                    (r[n + 32] = (s - c) >> 3),
                    (r[n + 48] = (h - u) >> 3),
                    (n += 64);
        }
        function he(t, e, r) {
            var n,
                i = e - 32,
                a = Bn,
                o = 255 - t[i - 1];
            for (n = 0; n < r; ++n) {
                var s,
                    c = a,
                    u = o + t[e - 1];
                for (s = 0; s < r; ++s) t[e + s] = c[u + t[i + s]];
                e += 32;
            }
        }
        function le(t, e) {
            he(t, e, 4);
        }
        function fe(t, e) {
            he(t, e, 8);
        }
        function de(t, e) {
            he(t, e, 16);
        }
        function pe(t, e) {
            var r;
            for (r = 0; 16 > r; ++r) n(t, e + 32 * r, t, e - 32, 16);
        }
        function ge(t, e) {
            var r;
            for (r = 16; 0 < r; --r) i(t, e, t[e - 1], 16), (e += 32);
        }
        function me(t, e, r) {
            var n;
            for (n = 0; 16 > n; ++n) i(e, r + 32 * n, t, 16);
        }
        function ve(t, e) {
            var r,
                n = 16;
            for (r = 0; 16 > r; ++r) n += t[e - 1 + 32 * r] + t[e + r - 32];
            me(n >> 5, t, e);
        }
        function be(t, e) {
            var r,
                n = 8;
            for (r = 0; 16 > r; ++r) n += t[e - 1 + 32 * r];
            me(n >> 4, t, e);
        }
        function ye(t, e) {
            var r,
                n = 8;
            for (r = 0; 16 > r; ++r) n += t[e + r - 32];
            me(n >> 4, t, e);
        }
        function we(t, e) {
            me(128, t, e);
        }
        function Ne(t, e, r) {
            return (t + 2 * e + r + 2) >> 2;
        }
        function Le(t, e) {
            var r,
                i = e - 32;
            i = new Uint8Array([
                Ne(t[i - 1], t[i + 0], t[i + 1]),
                Ne(t[i + 0], t[i + 1], t[i + 2]),
                Ne(t[i + 1], t[i + 2], t[i + 3]),
                Ne(t[i + 2], t[i + 3], t[i + 4]),
            ]);
            for (r = 0; 4 > r; ++r) n(t, e + 32 * r, i, 0, i.length);
        }
        function Ae(t, e) {
            var r = t[e - 1],
                n = t[e - 1 + 32],
                i = t[e - 1 + 64],
                a = t[e - 1 + 96];
            I(t, e + 0, 16843009 * Ne(t[e - 1 - 32], r, n)),
                I(t, e + 32, 16843009 * Ne(r, n, i)),
                I(t, e + 64, 16843009 * Ne(n, i, a)),
                I(t, e + 96, 16843009 * Ne(i, a, a));
        }
        function xe(t, e) {
            var r,
                n = 4;
            for (r = 0; 4 > r; ++r) n += t[e + r - 32] + t[e - 1 + 32 * r];
            for (n >>= 3, r = 0; 4 > r; ++r) i(t, e + 32 * r, n, 4);
        }
        function Se(t, e) {
            var r = t[e - 1 + 0],
                n = t[e - 1 + 32],
                i = t[e - 1 + 64],
                a = t[e - 1 - 32],
                o = t[e + 0 - 32],
                s = t[e + 1 - 32],
                c = t[e + 2 - 32],
                u = t[e + 3 - 32];
            (t[e + 0 + 96] = Ne(n, i, t[e - 1 + 96])),
                (t[e + 1 + 96] = t[e + 0 + 64] = Ne(r, n, i)),
                (t[e + 2 + 96] = t[e + 1 + 64] = t[e + 0 + 32] = Ne(a, r, n)),
                (t[e + 3 + 96] =
                    t[e + 2 + 64] =
                    t[e + 1 + 32] =
                    t[e + 0 + 0] =
                        Ne(o, a, r)),
                (t[e + 3 + 64] = t[e + 2 + 32] = t[e + 1 + 0] = Ne(s, o, a)),
                (t[e + 3 + 32] = t[e + 2 + 0] = Ne(c, s, o)),
                (t[e + 3 + 0] = Ne(u, c, s));
        }
        function _e(t, e) {
            var r = t[e + 1 - 32],
                n = t[e + 2 - 32],
                i = t[e + 3 - 32],
                a = t[e + 4 - 32],
                o = t[e + 5 - 32],
                s = t[e + 6 - 32],
                c = t[e + 7 - 32];
            (t[e + 0 + 0] = Ne(t[e + 0 - 32], r, n)),
                (t[e + 1 + 0] = t[e + 0 + 32] = Ne(r, n, i)),
                (t[e + 2 + 0] = t[e + 1 + 32] = t[e + 0 + 64] = Ne(n, i, a)),
                (t[e + 3 + 0] =
                    t[e + 2 + 32] =
                    t[e + 1 + 64] =
                    t[e + 0 + 96] =
                        Ne(i, a, o)),
                (t[e + 3 + 32] = t[e + 2 + 64] = t[e + 1 + 96] = Ne(a, o, s)),
                (t[e + 3 + 64] = t[e + 2 + 96] = Ne(o, s, c)),
                (t[e + 3 + 96] = Ne(s, c, c));
        }
        function Pe(t, e) {
            var r = t[e - 1 + 0],
                n = t[e - 1 + 32],
                i = t[e - 1 + 64],
                a = t[e - 1 - 32],
                o = t[e + 0 - 32],
                s = t[e + 1 - 32],
                c = t[e + 2 - 32],
                u = t[e + 3 - 32];
            (t[e + 0 + 0] = t[e + 1 + 64] = (a + o + 1) >> 1),
                (t[e + 1 + 0] = t[e + 2 + 64] = (o + s + 1) >> 1),
                (t[e + 2 + 0] = t[e + 3 + 64] = (s + c + 1) >> 1),
                (t[e + 3 + 0] = (c + u + 1) >> 1),
                (t[e + 0 + 96] = Ne(i, n, r)),
                (t[e + 0 + 64] = Ne(n, r, a)),
                (t[e + 0 + 32] = t[e + 1 + 96] = Ne(r, a, o)),
                (t[e + 1 + 32] = t[e + 2 + 96] = Ne(a, o, s)),
                (t[e + 2 + 32] = t[e + 3 + 96] = Ne(o, s, c)),
                (t[e + 3 + 32] = Ne(s, c, u));
        }
        function ke(t, e) {
            var r = t[e + 0 - 32],
                n = t[e + 1 - 32],
                i = t[e + 2 - 32],
                a = t[e + 3 - 32],
                o = t[e + 4 - 32],
                s = t[e + 5 - 32],
                c = t[e + 6 - 32],
                u = t[e + 7 - 32];
            (t[e + 0 + 0] = (r + n + 1) >> 1),
                (t[e + 1 + 0] = t[e + 0 + 64] = (n + i + 1) >> 1),
                (t[e + 2 + 0] = t[e + 1 + 64] = (i + a + 1) >> 1),
                (t[e + 3 + 0] = t[e + 2 + 64] = (a + o + 1) >> 1),
                (t[e + 0 + 32] = Ne(r, n, i)),
                (t[e + 1 + 32] = t[e + 0 + 96] = Ne(n, i, a)),
                (t[e + 2 + 32] = t[e + 1 + 96] = Ne(i, a, o)),
                (t[e + 3 + 32] = t[e + 2 + 96] = Ne(a, o, s)),
                (t[e + 3 + 64] = Ne(o, s, c)),
                (t[e + 3 + 96] = Ne(s, c, u));
        }
        function Ie(t, e) {
            var r = t[e - 1 + 0],
                n = t[e - 1 + 32],
                i = t[e - 1 + 64],
                a = t[e - 1 + 96];
            (t[e + 0 + 0] = (r + n + 1) >> 1),
                (t[e + 2 + 0] = t[e + 0 + 32] = (n + i + 1) >> 1),
                (t[e + 2 + 32] = t[e + 0 + 64] = (i + a + 1) >> 1),
                (t[e + 1 + 0] = Ne(r, n, i)),
                (t[e + 3 + 0] = t[e + 1 + 32] = Ne(n, i, a)),
                (t[e + 3 + 32] = t[e + 1 + 64] = Ne(i, a, a)),
                (t[e + 3 + 64] =
                    t[e + 2 + 64] =
                    t[e + 0 + 96] =
                    t[e + 1 + 96] =
                    t[e + 2 + 96] =
                    t[e + 3 + 96] =
                        a);
        }
        function Fe(t, e) {
            var r = t[e - 1 + 0],
                n = t[e - 1 + 32],
                i = t[e - 1 + 64],
                a = t[e - 1 + 96],
                o = t[e - 1 - 32],
                s = t[e + 0 - 32],
                c = t[e + 1 - 32],
                u = t[e + 2 - 32];
            (t[e + 0 + 0] = t[e + 2 + 32] = (r + o + 1) >> 1),
                (t[e + 0 + 32] = t[e + 2 + 64] = (n + r + 1) >> 1),
                (t[e + 0 + 64] = t[e + 2 + 96] = (i + n + 1) >> 1),
                (t[e + 0 + 96] = (a + i + 1) >> 1),
                (t[e + 3 + 0] = Ne(s, c, u)),
                (t[e + 2 + 0] = Ne(o, s, c)),
                (t[e + 1 + 0] = t[e + 3 + 32] = Ne(r, o, s)),
                (t[e + 1 + 32] = t[e + 3 + 64] = Ne(n, r, o)),
                (t[e + 1 + 64] = t[e + 3 + 96] = Ne(i, n, r)),
                (t[e + 1 + 96] = Ne(a, i, n));
        }
        function Ce(t, e) {
            var r;
            for (r = 0; 8 > r; ++r) n(t, e + 32 * r, t, e - 32, 8);
        }
        function je(t, e) {
            var r;
            for (r = 0; 8 > r; ++r) i(t, e, t[e - 1], 8), (e += 32);
        }
        function Oe(t, e, r) {
            var n;
            for (n = 0; 8 > n; ++n) i(e, r + 32 * n, t, 8);
        }
        function Be(t, e) {
            var r,
                n = 8;
            for (r = 0; 8 > r; ++r) n += t[e + r - 32] + t[e - 1 + 32 * r];
            Oe(n >> 4, t, e);
        }
        function Me(t, e) {
            var r,
                n = 4;
            for (r = 0; 8 > r; ++r) n += t[e + r - 32];
            Oe(n >> 3, t, e);
        }
        function Ee(t, e) {
            var r,
                n = 4;
            for (r = 0; 8 > r; ++r) n += t[e - 1 + 32 * r];
            Oe(n >> 3, t, e);
        }
        function qe(t, e) {
            Oe(128, t, e);
        }
        function De(t, e, r) {
            var n = t[e - r],
                i = t[e + 0],
                a = 3 * (i - n) + jn[1020 + t[e - 2 * r] - t[e + r]],
                o = On[112 + ((a + 4) >> 3)];
            (t[e - r] = Bn[255 + n + On[112 + ((a + 3) >> 3)]]),
                (t[e + 0] = Bn[255 + i - o]);
        }
        function Re(t, e, r, n) {
            var i = t[e + 0],
                a = t[e + r];
            return Mn[255 + t[e - 2 * r] - t[e - r]] > n || Mn[255 + a - i] > n;
        }
        function Te(t, e, r, n) {
            return (
                4 * Mn[255 + t[e - r] - t[e + 0]] +
                    Mn[255 + t[e - 2 * r] - t[e + r]] <=
                n
            );
        }
        function Ue(t, e, r, n, i) {
            var a = t[e - 3 * r],
                o = t[e - 2 * r],
                s = t[e - r],
                c = t[e + 0],
                u = t[e + r],
                h = t[e + 2 * r],
                l = t[e + 3 * r];
            return 4 * Mn[255 + s - c] + Mn[255 + o - u] > n
                ? 0
                : Mn[255 + t[e - 4 * r] - a] <= i &&
                      Mn[255 + a - o] <= i &&
                      Mn[255 + o - s] <= i &&
                      Mn[255 + l - h] <= i &&
                      Mn[255 + h - u] <= i &&
                      Mn[255 + u - c] <= i;
        }
        function ze(t, e, r, n) {
            var i = 2 * n + 1;
            for (n = 0; 16 > n; ++n) Te(t, e + n, r, i) && De(t, e + n, r);
        }
        function He(t, e, r, n) {
            var i = 2 * n + 1;
            for (n = 0; 16 > n; ++n)
                Te(t, e + n * r, 1, i) && De(t, e + n * r, 1);
        }
        function We(t, e, r, n) {
            var i;
            for (i = 3; 0 < i; --i) ze(t, (e += 4 * r), r, n);
        }
        function Ve(t, e, r, n) {
            var i;
            for (i = 3; 0 < i; --i) He(t, (e += 4), r, n);
        }
        function Ge(t, e, r, n, i, a, o, s) {
            for (a = 2 * a + 1; 0 < i--; ) {
                if (Ue(t, e, r, a, o))
                    if (Re(t, e, r, s)) De(t, e, r);
                    else {
                        var c = t,
                            u = e,
                            h = r,
                            l = c[u - 2 * h],
                            f = c[u - h],
                            d = c[u + 0],
                            p = c[u + h],
                            g = c[u + 2 * h],
                            m =
                                (27 *
                                    (b =
                                        jn[
                                            1020 +
                                                3 * (d - f) +
                                                jn[1020 + l - p]
                                        ]) +
                                    63) >>
                                7,
                            v = (18 * b + 63) >> 7,
                            b = (9 * b + 63) >> 7;
                        (c[u - 3 * h] = Bn[255 + c[u - 3 * h] + b]),
                            (c[u - 2 * h] = Bn[255 + l + v]),
                            (c[u - h] = Bn[255 + f + m]),
                            (c[u + 0] = Bn[255 + d - m]),
                            (c[u + h] = Bn[255 + p - v]),
                            (c[u + 2 * h] = Bn[255 + g - b]);
                    }
                e += n;
            }
        }
        function Ye(t, e, r, n, i, a, o, s) {
            for (a = 2 * a + 1; 0 < i--; ) {
                if (Ue(t, e, r, a, o))
                    if (Re(t, e, r, s)) De(t, e, r);
                    else {
                        var c = t,
                            u = e,
                            h = r,
                            l = c[u - h],
                            f = c[u + 0],
                            d = c[u + h],
                            p = On[112 + (((g = 3 * (f - l)) + 4) >> 3)],
                            g = On[112 + ((g + 3) >> 3)],
                            m = (p + 1) >> 1;
                        (c[u - 2 * h] = Bn[255 + c[u - 2 * h] + m]),
                            (c[u - h] = Bn[255 + l + g]),
                            (c[u + 0] = Bn[255 + f - p]),
                            (c[u + h] = Bn[255 + d - m]);
                    }
                e += n;
            }
        }
        function Je(t, e, r, n, i, a) {
            Ge(t, e, r, 1, 16, n, i, a);
        }
        function Xe(t, e, r, n, i, a) {
            Ge(t, e, 1, r, 16, n, i, a);
        }
        function Ke(t, e, r, n, i, a) {
            var o;
            for (o = 3; 0 < o; --o) Ye(t, (e += 4 * r), r, 1, 16, n, i, a);
        }
        function Ze(t, e, r, n, i, a) {
            var o;
            for (o = 3; 0 < o; --o) Ye(t, (e += 4), 1, r, 16, n, i, a);
        }
        function $e(t, e, r, n, i, a, o, s) {
            Ge(t, e, i, 1, 8, a, o, s), Ge(r, n, i, 1, 8, a, o, s);
        }
        function Qe(t, e, r, n, i, a, o, s) {
            Ge(t, e, 1, i, 8, a, o, s), Ge(r, n, 1, i, 8, a, o, s);
        }
        function tr(t, e, r, n, i, a, o, s) {
            Ye(t, e + 4 * i, i, 1, 8, a, o, s),
                Ye(r, n + 4 * i, i, 1, 8, a, o, s);
        }
        function er(t, e, r, n, i, a, o, s) {
            Ye(t, e + 4, 1, i, 8, a, o, s), Ye(r, n + 4, 1, i, 8, a, o, s);
        }
        function rr() {
            (this.ba = new ot()),
                (this.ec = []),
                (this.cc = []),
                (this.Mc = []),
                (this.Dc = this.Nc = this.dc = this.fc = 0),
                (this.Oa = new ct()),
                (this.memory = 0),
                (this.Ib = "OutputFunc"),
                (this.Jb = "OutputAlphaFunc"),
                (this.Nd = "OutputRowFunc");
        }
        function nr() {
            (this.data = []),
                (this.offset = this.kd = this.ha = this.w = 0),
                (this.na = []),
                (this.xa = this.gb = this.Ja = this.Sa = this.P = 0);
        }
        function ir() {
            (this.nc = this.Ea = this.b = this.hc = 0),
                (this.K = []),
                (this.w = 0);
        }
        function ar() {
            (this.ua = 0),
                (this.Wa = new M()),
                (this.vb = new M()),
                (this.md = this.xc = this.wc = 0),
                (this.vc = []),
                (this.Wb = 0),
                (this.Ya = new d()),
                (this.yc = new l());
        }
        function or() {
            (this.xb = this.a = 0),
                (this.l = new Gt()),
                (this.ca = new ot()),
                (this.V = []),
                (this.Ba = 0),
                (this.Ta = []),
                (this.Ua = 0),
                (this.m = new N()),
                (this.Pb = 0),
                (this.wd = new N()),
                (this.Ma = this.$ = this.C = this.i = this.c = this.xd = 0),
                (this.s = new ar()),
                (this.ab = 0),
                (this.gc = o(4, ir)),
                (this.Oc = 0);
        }
        function sr() {
            (this.Lc = this.Z = this.$a = this.i = this.c = 0),
                (this.l = new Gt()),
                (this.ic = 0),
                (this.ca = []),
                (this.tb = 0),
                (this.qd = null),
                (this.rd = 0);
        }
        function cr(t, e, r, n, i, a, o) {
            for (t = null == t ? 0 : t[e + 0], e = 0; e < o; ++e)
                (i[a + e] = (t + r[n + e]) & 255), (t = i[a + e]);
        }
        function ur(t, e, r, n, i, a, o) {
            var s;
            if (null == t) cr(null, null, r, n, i, a, o);
            else for (s = 0; s < o; ++s) i[a + s] = (t[e + s] + r[n + s]) & 255;
        }
        function hr(t, e, r, n, i, a, o) {
            if (null == t) cr(null, null, r, n, i, a, o);
            else {
                var s,
                    c = t[e + 0],
                    u = c,
                    h = c;
                for (s = 0; s < o; ++s)
                    (u = h + (c = t[e + s]) - u),
                        (h =
                            (r[n + s] + (-256 & u ? (0 > u ? 0 : 255) : u)) &
                            255),
                        (u = c),
                        (i[a + s] = h);
            }
        }
        function lr(t, r, i, o) {
            var s = r.width,
                c = r.o;
            if ((e(null != t && null != r), 0 > i || 0 >= o || i + o > c))
                return null;
            if (!t.Cc) {
                if (null == t.ga) {
                    var u;
                    if (
                        ((t.ga = new sr()),
                        (u = null == t.ga) ||
                            ((u = r.width * r.o),
                            e(0 == t.Gb.length),
                            (t.Gb = a(u)),
                            (t.Uc = 0),
                            null == t.Gb
                                ? (u = 0)
                                : ((t.mb = t.Gb),
                                  (t.nb = t.Uc),
                                  (t.rc = null),
                                  (u = 1)),
                            (u = !u)),
                        !u)
                    ) {
                        u = t.ga;
                        var h = t.Fa,
                            l = t.P,
                            f = t.qc,
                            d = t.mb,
                            p = t.nb,
                            g = l + 1,
                            m = f - 1,
                            b = u.l;
                        if (
                            (e(null != h && null != d && null != r),
                            (mi[0] = null),
                            (mi[1] = cr),
                            (mi[2] = ur),
                            (mi[3] = hr),
                            (u.ca = d),
                            (u.tb = p),
                            (u.c = r.width),
                            (u.i = r.height),
                            e(0 < u.c && 0 < u.i),
                            1 >= f)
                        )
                            r = 0;
                        else if (
                            ((u.$a = (h[l + 0] >> 0) & 3),
                            (u.Z = (h[l + 0] >> 2) & 3),
                            (u.Lc = (h[l + 0] >> 4) & 3),
                            (l = (h[l + 0] >> 6) & 3),
                            0 > u.$a || 1 < u.$a || 4 <= u.Z || 1 < u.Lc || l)
                        )
                            r = 0;
                        else if (
                            ((b.put = dt),
                            (b.ac = ft),
                            (b.bc = pt),
                            (b.ma = u),
                            (b.width = r.width),
                            (b.height = r.height),
                            (b.Da = r.Da),
                            (b.v = r.v),
                            (b.va = r.va),
                            (b.j = r.j),
                            (b.o = r.o),
                            u.$a)
                        )
                            t: {
                                e(1 == u.$a), (r = kt());
                                e: for (;;) {
                                    if (null == r) {
                                        r = 0;
                                        break t;
                                    }
                                    if (
                                        (e(null != u),
                                        (u.mc = r),
                                        (r.c = u.c),
                                        (r.i = u.i),
                                        (r.l = u.l),
                                        (r.l.ma = u),
                                        (r.l.width = u.c),
                                        (r.l.height = u.i),
                                        (r.a = 0),
                                        v(r.m, h, g, m),
                                        !It(u.c, u.i, 1, r, null))
                                    )
                                        break e;
                                    if (
                                        (1 == r.ab && 3 == r.gc[0].hc && At(r.s)
                                            ? ((u.ic = 1),
                                              (h = r.c * r.i),
                                              (r.Ta = null),
                                              (r.Ua = 0),
                                              (r.V = a(h)),
                                              (r.Ba = 0),
                                              null == r.V
                                                  ? ((r.a = 1), (r = 0))
                                                  : (r = 1))
                                            : ((u.ic = 0), (r = Ft(r, u.c))),
                                        !r)
                                    )
                                        break e;
                                    r = 1;
                                    break t;
                                }
                                (u.mc = null), (r = 0);
                            }
                        else r = m >= u.c * u.i;
                        u = !r;
                    }
                    if (u) return null;
                    1 != t.ga.Lc ? (t.Ga = 0) : (o = c - i);
                }
                e(null != t.ga), e(i + o <= c);
                t: {
                    if (((r = (h = t.ga).c), (c = h.l.o), 0 == h.$a)) {
                        if (
                            ((g = t.rc),
                            (m = t.Vc),
                            (b = t.Fa),
                            (l = t.P + 1 + i * r),
                            (f = t.mb),
                            (d = t.nb + i * r),
                            e(l <= t.P + t.qc),
                            0 != h.Z)
                        )
                            for (e(null != mi[h.Z]), u = 0; u < o; ++u)
                                mi[h.Z](g, m, b, l, f, d, r),
                                    (g = f),
                                    (m = d),
                                    (d += r),
                                    (l += r);
                        else
                            for (u = 0; u < o; ++u)
                                n(f, d, b, l, r),
                                    (g = f),
                                    (m = d),
                                    (d += r),
                                    (l += r);
                        (t.rc = g), (t.Vc = m);
                    } else {
                        if (
                            (e(null != h.mc),
                            (r = i + o),
                            e(null != (u = h.mc)),
                            e(r <= u.i),
                            u.C >= r)
                        )
                            r = 1;
                        else if ((h.ic || mr(), h.ic)) {
                            (h = u.V), (g = u.Ba), (m = u.c);
                            var y = u.i,
                                w =
                                    ((b = 1),
                                    (l = u.$ / m),
                                    (f = u.$ % m),
                                    (d = u.m),
                                    (p = u.s),
                                    u.$),
                                N = m * y,
                                L = m * r,
                                x = p.wc,
                                _ = w < L ? wt(p, f, l) : null;
                            e(w <= N), e(r <= y), e(At(p));
                            e: for (;;) {
                                for (; !d.h && w < L; ) {
                                    if (
                                        (f & x || (_ = wt(p, f, l)),
                                        e(null != _),
                                        S(d),
                                        256 > (y = bt(_.G[0], _.H[0], d)))
                                    )
                                        (h[g + w] = y),
                                            ++w,
                                            ++f >= m &&
                                                ((f = 0),
                                                ++l <= r &&
                                                    !(l % 16) &&
                                                    St(u, l));
                                    else {
                                        if (!(280 > y)) {
                                            b = 0;
                                            break e;
                                        }
                                        y = mt(y - 256, d);
                                        var P,
                                            k = bt(_.G[4], _.H[4], d);
                                        if (
                                            (S(d),
                                            !(
                                                w >=
                                                    (k = vt(
                                                        m,
                                                        (k = mt(k, d)),
                                                    )) && N - w >= y
                                            ))
                                        ) {
                                            b = 0;
                                            break e;
                                        }
                                        for (P = 0; P < y; ++P)
                                            h[g + w + P] = h[g + w + P - k];
                                        for (w += y, f += y; f >= m; )
                                            (f -= m),
                                                ++l <= r &&
                                                    !(l % 16) &&
                                                    St(u, l);
                                        w < L && f & x && (_ = wt(p, f, l));
                                    }
                                    e(d.h == A(d));
                                }
                                St(u, l > r ? r : l);
                                break e;
                            }
                            !b || (d.h && w < N)
                                ? ((b = 0), (u.a = d.h ? 5 : 3))
                                : (u.$ = w),
                                (r = b);
                        } else r = _t(u, u.V, u.Ba, u.c, u.i, r, Ct);
                        if (!r) {
                            o = 0;
                            break t;
                        }
                    }
                    i + o >= c && (t.Cc = 1), (o = 1);
                }
                if (!o) return null;
                if (
                    t.Cc &&
                    (null != (o = t.ga) && (o.mc = null),
                    (t.ga = null),
                    0 < t.Ga)
                )
                    return alert("todo:WebPDequantizeLevels"), null;
            }
            return t.nb + i * s;
        }
        function fr(t, e, r, n, i, a) {
            for (; 0 < i--; ) {
                var o,
                    s = t,
                    c = e + (r ? 1 : 0),
                    u = t,
                    h = e + (r ? 0 : 3);
                for (o = 0; o < n; ++o) {
                    var l = u[h + 4 * o];
                    255 != l &&
                        ((l *= 32897),
                        (s[c + 4 * o + 0] = (s[c + 4 * o + 0] * l) >> 23),
                        (s[c + 4 * o + 1] = (s[c + 4 * o + 1] * l) >> 23),
                        (s[c + 4 * o + 2] = (s[c + 4 * o + 2] * l) >> 23));
                }
                e += a;
            }
        }
        function dr(t, e, r, n, i) {
            for (; 0 < n--; ) {
                var a;
                for (a = 0; a < r; ++a) {
                    var o = t[e + 2 * a + 0],
                        s = 15 & (u = t[e + 2 * a + 1]),
                        c = 4369 * s,
                        u = (((240 & u) | (u >> 4)) * c) >> 16;
                    (t[e + 2 * a + 0] =
                        (((((240 & o) | (o >> 4)) * c) >> 16) & 240) |
                        ((((((15 & o) | (o << 4)) * c) >> 16) >> 4) & 15)),
                        (t[e + 2 * a + 1] = (240 & u) | s);
                }
                e += i;
            }
        }
        function pr(t, e, r, n, i, a, o, s) {
            var c,
                u,
                h = 255;
            for (u = 0; u < i; ++u) {
                for (c = 0; c < n; ++c) {
                    var l = t[e + c];
                    (a[o + 4 * c] = l), (h &= l);
                }
                (e += r), (o += s);
            }
            return 255 != h;
        }
        function gr(t, e, r, n, i) {
            var a;
            for (a = 0; a < i; ++a) r[n + a] = t[e + a] >> 8;
        }
        function mr() {
            (An = fr), (xn = dr), (Sn = pr), (_n = gr);
        }
        function vr(r, n, i) {
            t[r] = function (
                t,
                r,
                a,
                o,
                s,
                c,
                u,
                h,
                l,
                f,
                d,
                p,
                g,
                m,
                v,
                b,
                y,
            ) {
                var w,
                    N = (y - 1) >> 1,
                    L = s[c + 0] | (u[h + 0] << 16),
                    A = l[f + 0] | (d[p + 0] << 16);
                e(null != t);
                var x = (3 * L + A + 131074) >> 2;
                for (
                    n(t[r + 0], 255 & x, x >> 16, g, m),
                        null != a &&
                            ((x = (3 * A + L + 131074) >> 2),
                            n(a[o + 0], 255 & x, x >> 16, v, b)),
                        w = 1;
                    w <= N;
                    ++w
                ) {
                    var S = s[c + w] | (u[h + w] << 16),
                        _ = l[f + w] | (d[p + w] << 16),
                        P = L + S + A + _ + 524296,
                        k = (P + 2 * (S + A)) >> 3;
                    (x = (k + L) >> 1),
                        (L = ((P = (P + 2 * (L + _)) >> 3) + S) >> 1),
                        n(
                            t[r + 2 * w - 1],
                            255 & x,
                            x >> 16,
                            g,
                            m + (2 * w - 1) * i,
                        ),
                        n(
                            t[r + 2 * w - 0],
                            255 & L,
                            L >> 16,
                            g,
                            m + (2 * w - 0) * i,
                        ),
                        null != a &&
                            ((x = (P + A) >> 1),
                            (L = (k + _) >> 1),
                            n(
                                a[o + 2 * w - 1],
                                255 & x,
                                x >> 16,
                                v,
                                b + (2 * w - 1) * i,
                            ),
                            n(
                                a[o + 2 * w + 0],
                                255 & L,
                                L >> 16,
                                v,
                                b + (2 * w + 0) * i,
                            )),
                        (L = S),
                        (A = _);
                }
                1 & y ||
                    ((x = (3 * L + A + 131074) >> 2),
                    n(t[r + y - 1], 255 & x, x >> 16, g, m + (y - 1) * i),
                    null != a &&
                        ((x = (3 * A + L + 131074) >> 2),
                        n(a[o + y - 1], 255 & x, x >> 16, v, b + (y - 1) * i)));
            };
        }
        function br() {
            (vi[En] = bi),
                (vi[qn] = wi),
                (vi[Dn] = yi),
                (vi[Rn] = Ni),
                (vi[Tn] = Li),
                (vi[Un] = Ai),
                (vi[zn] = xi),
                (vi[Hn] = wi),
                (vi[Wn] = Ni),
                (vi[Vn] = Li),
                (vi[Gn] = Ai);
        }
        function yr(t) {
            return t & ~Fi ? (0 > t ? 0 : 255) : t >> Ii;
        }
        function wr(t, e) {
            return yr(((19077 * t) >> 8) + ((26149 * e) >> 8) - 14234);
        }
        function Nr(t, e, r) {
            return yr(
                ((19077 * t) >> 8) -
                    ((6419 * e) >> 8) -
                    ((13320 * r) >> 8) +
                    8708,
            );
        }
        function Lr(t, e) {
            return yr(((19077 * t) >> 8) + ((33050 * e) >> 8) - 17685);
        }
        function Ar(t, e, r, n, i) {
            (n[i + 0] = wr(t, r)),
                (n[i + 1] = Nr(t, e, r)),
                (n[i + 2] = Lr(t, e));
        }
        function xr(t, e, r, n, i) {
            (n[i + 0] = Lr(t, e)),
                (n[i + 1] = Nr(t, e, r)),
                (n[i + 2] = wr(t, r));
        }
        function Sr(t, e, r, n, i) {
            var a = Nr(t, e, r);
            (e = ((a << 3) & 224) | (Lr(t, e) >> 3)),
                (n[i + 0] = (248 & wr(t, r)) | (a >> 5)),
                (n[i + 1] = e);
        }
        function _r(t, e, r, n, i) {
            var a = (240 & Lr(t, e)) | 15;
            (n[i + 0] = (240 & wr(t, r)) | (Nr(t, e, r) >> 4)), (n[i + 1] = a);
        }
        function Pr(t, e, r, n, i) {
            (n[i + 0] = 255), Ar(t, e, r, n, i + 1);
        }
        function kr(t, e, r, n, i) {
            xr(t, e, r, n, i), (n[i + 3] = 255);
        }
        function Ir(t, e, r, n, i) {
            Ar(t, e, r, n, i), (n[i + 3] = 255);
        }
        function Vt(t, e) {
            return 0 > t ? 0 : t > e ? e : t;
        }
        function Fr(e, r, n) {
            t[e] = function (t, e, i, a, o, s, c, u, h) {
                for (var l = u + (-2 & h) * n; u != l; )
                    r(t[e + 0], i[a + 0], o[s + 0], c, u),
                        r(t[e + 1], i[a + 0], o[s + 0], c, u + n),
                        (e += 2),
                        ++a,
                        ++s,
                        (u += 2 * n);
                1 & h && r(t[e + 0], i[a + 0], o[s + 0], c, u);
            };
        }
        function Cr(t, e, r) {
            return 0 == r ? (0 == t ? (0 == e ? 6 : 5) : 0 == e ? 4 : 0) : r;
        }
        function jr(t, e, r, n, i) {
            switch (t >>> 30) {
                case 3:
                    on(e, r, n, i, 0);
                    break;
                case 2:
                    sn(e, r, n, i);
                    break;
                case 1:
                    un(e, r, n, i);
            }
        }
        function Or(t, e) {
            var r,
                a,
                o = e.M,
                s = e.Nb,
                c = t.oc,
                u = t.pc + 40,
                h = t.oc,
                l = t.pc + 584,
                f = t.oc,
                d = t.pc + 600;
            for (r = 0; 16 > r; ++r) c[u + 32 * r - 1] = 129;
            for (r = 0; 8 > r; ++r)
                (h[l + 32 * r - 1] = 129), (f[d + 32 * r - 1] = 129);
            for (
                0 < o
                    ? (c[u - 1 - 32] = h[l - 1 - 32] = f[d - 1 - 32] = 129)
                    : (i(c, u - 32 - 1, 127, 21),
                      i(h, l - 32 - 1, 127, 9),
                      i(f, d - 32 - 1, 127, 9)),
                    a = 0;
                a < t.za;
                ++a
            ) {
                var p = e.ya[e.aa + a];
                if (0 < a) {
                    for (r = -1; 16 > r; ++r)
                        n(c, u + 32 * r - 4, c, u + 32 * r + 12, 4);
                    for (r = -1; 8 > r; ++r)
                        n(h, l + 32 * r - 4, h, l + 32 * r + 4, 4),
                            n(f, d + 32 * r - 4, f, d + 32 * r + 4, 4);
                }
                var g = t.Gd,
                    m = t.Hd + a,
                    v = p.ad,
                    b = p.Hc;
                if (
                    (0 < o &&
                        (n(c, u - 32, g[m].y, 0, 16),
                        n(h, l - 32, g[m].f, 0, 8),
                        n(f, d - 32, g[m].ea, 0, 8)),
                    p.Za)
                ) {
                    var y = c,
                        w = u - 32 + 16;
                    for (
                        0 < o &&
                            (a >= t.za - 1
                                ? i(y, w, g[m].y[15], 4)
                                : n(y, w, g[m + 1].y, 0, 4)),
                            r = 0;
                        4 > r;
                        r++
                    )
                        y[w + 128 + r] =
                            y[w + 256 + r] =
                            y[w + 384 + r] =
                                y[w + 0 + r];
                    for (r = 0; 16 > r; ++r, b <<= 2)
                        (y = c),
                            (w = u + Di[r]),
                            fi[p.Ob[r]](y, w),
                            jr(b, v, 16 * +r, y, w);
                } else if (((y = Cr(a, o, p.Ob[0])), li[y](c, u), 0 != b))
                    for (r = 0; 16 > r; ++r, b <<= 2)
                        jr(b, v, 16 * +r, c, u + Di[r]);
                for (
                    r = p.Gc,
                        y = Cr(a, o, p.Dd),
                        di[y](h, l),
                        di[y](f, d),
                        b = v,
                        y = h,
                        w = l,
                        255 & (p = r >> 0) &&
                            (170 & p ? cn(b, 256, y, w) : hn(b, 256, y, w)),
                        p = f,
                        b = d,
                        255 & (r >>= 8) &&
                            (170 & r ? cn(v, 320, p, b) : hn(v, 320, p, b)),
                        o < t.Ub - 1 &&
                            (n(g[m].y, 0, c, u + 480, 16),
                            n(g[m].f, 0, h, l + 224, 8),
                            n(g[m].ea, 0, f, d + 224, 8)),
                        r = 8 * s * t.B,
                        g = t.sa,
                        m = t.ta + 16 * a + 16 * s * t.R,
                        v = t.qa,
                        p = t.ra + 8 * a + r,
                        b = t.Ha,
                        y = t.Ia + 8 * a + r,
                        r = 0;
                    16 > r;
                    ++r
                )
                    n(g, m + r * t.R, c, u + 32 * r, 16);
                for (r = 0; 8 > r; ++r)
                    n(v, p + r * t.B, h, l + 32 * r, 8),
                        n(b, y + r * t.B, f, d + 32 * r, 8);
            }
        }
        function Br(t, n, i, a, o, s, c, u, h) {
            var l = [0],
                f = [0],
                d = 0,
                p = null != h ? h.kd : 0,
                g = null != h ? h : new nr();
            if (null == t || 12 > i) return 7;
            (g.data = t),
                (g.w = n),
                (g.ha = i),
                (n = [n]),
                (i = [i]),
                (g.gb = [g.gb]);
            t: {
                var m = n,
                    b = i,
                    y = g.gb;
                if (
                    (e(null != t),
                    e(null != b),
                    e(null != y),
                    (y[0] = 0),
                    12 <= b[0] && !r(t, m[0], "RIFF"))
                ) {
                    if (r(t, m[0] + 8, "WEBP")) {
                        y = 3;
                        break t;
                    }
                    var w = j(t, m[0] + 4);
                    if (12 > w || 4294967286 < w) {
                        y = 3;
                        break t;
                    }
                    if (p && w > b[0] - 8) {
                        y = 7;
                        break t;
                    }
                    (y[0] = w), (m[0] += 12), (b[0] -= 12);
                }
                y = 0;
            }
            if (0 != y) return y;
            for (w = 0 < g.gb[0], i = i[0]; ; ) {
                t: {
                    var L = t;
                    (b = n), (y = i);
                    var A = l,
                        x = f,
                        S = (m = [0]);
                    if ((((k = d = [d])[0] = 0), 8 > y[0])) y = 7;
                    else {
                        if (!r(L, b[0], "VP8X")) {
                            if (10 != j(L, b[0] + 4)) {
                                y = 3;
                                break t;
                            }
                            if (18 > y[0]) {
                                y = 7;
                                break t;
                            }
                            var _ = j(L, b[0] + 8),
                                P = 1 + C(L, b[0] + 12);
                            if (2147483648 <= P * (L = 1 + C(L, b[0] + 15))) {
                                y = 3;
                                break t;
                            }
                            null != S && (S[0] = _),
                                null != A && (A[0] = P),
                                null != x && (x[0] = L),
                                (b[0] += 18),
                                (y[0] -= 18),
                                (k[0] = 1);
                        }
                        y = 0;
                    }
                }
                if (((d = d[0]), (m = m[0]), 0 != y)) return y;
                if (((b = !!(2 & m)), !w && d)) return 3;
                if (
                    (null != s && (s[0] = !!(16 & m)),
                    null != c && (c[0] = b),
                    null != u && (u[0] = 0),
                    (c = l[0]),
                    (m = f[0]),
                    d && b && null == h)
                ) {
                    y = 0;
                    break;
                }
                if (4 > i) {
                    y = 7;
                    break;
                }
                if ((w && d) || (!w && !d && !r(t, n[0], "ALPH"))) {
                    (i = [i]), (g.na = [g.na]), (g.P = [g.P]), (g.Sa = [g.Sa]);
                    t: {
                        (_ = t), (y = n), (w = i);
                        var k = g.gb;
                        (A = g.na), (x = g.P), (S = g.Sa);
                        (P = 22), e(null != _), e(null != w), (L = y[0]);
                        var I = w[0];
                        for (
                            e(null != A),
                                e(null != S),
                                A[0] = null,
                                x[0] = null,
                                S[0] = 0;
                            ;

                        ) {
                            if (((y[0] = L), (w[0] = I), 8 > I)) {
                                y = 7;
                                break t;
                            }
                            var F = j(_, L + 4);
                            if (4294967286 < F) {
                                y = 3;
                                break t;
                            }
                            var O = (8 + F + 1) & -2;
                            if (((P += O), 0 < k && P > k)) {
                                y = 3;
                                break t;
                            }
                            if (!r(_, L, "VP8 ") || !r(_, L, "VP8L")) {
                                y = 0;
                                break t;
                            }
                            if (I[0] < O) {
                                y = 7;
                                break t;
                            }
                            r(_, L, "ALPH") ||
                                ((A[0] = _), (x[0] = L + 8), (S[0] = F)),
                                (L += O),
                                (I -= O);
                        }
                    }
                    if (
                        ((i = i[0]),
                        (g.na = g.na[0]),
                        (g.P = g.P[0]),
                        (g.Sa = g.Sa[0]),
                        0 != y)
                    )
                        break;
                }
                (i = [i]), (g.Ja = [g.Ja]), (g.xa = [g.xa]);
                t: if (
                    ((k = t),
                    (y = n),
                    (w = i),
                    (A = g.gb[0]),
                    (x = g.Ja),
                    (S = g.xa),
                    (_ = y[0]),
                    (L = !r(k, _, "VP8 ")),
                    (P = !r(k, _, "VP8L")),
                    e(null != k),
                    e(null != w),
                    e(null != x),
                    e(null != S),
                    8 > w[0])
                )
                    y = 7;
                else {
                    if (L || P) {
                        if (((k = j(k, _ + 4)), 12 <= A && k > A - 12)) {
                            y = 3;
                            break t;
                        }
                        if (p && k > w[0] - 8) {
                            y = 7;
                            break t;
                        }
                        (x[0] = k), (y[0] += 8), (w[0] -= 8), (S[0] = P);
                    } else
                        (S[0] =
                            5 <= w[0] && 47 == k[_ + 0] && !(k[_ + 4] >> 5)),
                            (x[0] = w[0]);
                    y = 0;
                }
                if (
                    ((i = i[0]),
                    (g.Ja = g.Ja[0]),
                    (g.xa = g.xa[0]),
                    (n = n[0]),
                    0 != y)
                )
                    break;
                if (4294967286 < g.Ja) return 3;
                if (
                    (null == u || b || (u[0] = g.xa ? 2 : 1),
                    (c = [c]),
                    (m = [m]),
                    g.xa)
                ) {
                    if (5 > i) {
                        y = 7;
                        break;
                    }
                    (u = c),
                        (p = m),
                        (b = s),
                        null == t || 5 > i
                            ? (t = 0)
                            : 5 <= i && 47 == t[n + 0] && !(t[n + 4] >> 5)
                              ? ((w = [0]),
                                (k = [0]),
                                (A = [0]),
                                v((x = new N()), t, n, i),
                                gt(x, w, k, A)
                                    ? (null != u && (u[0] = w[0]),
                                      null != p && (p[0] = k[0]),
                                      null != b && (b[0] = A[0]),
                                      (t = 1))
                                    : (t = 0))
                              : (t = 0);
                } else {
                    if (10 > i) {
                        y = 7;
                        break;
                    }
                    (u = m),
                        null == t || 10 > i || !Xt(t, n + 3, i - 3)
                            ? (t = 0)
                            : ((p =
                                  t[n + 0] |
                                  (t[n + 1] << 8) |
                                  (t[n + 2] << 16)),
                              (b = 16383 & ((t[n + 7] << 8) | t[n + 6])),
                              (t = 16383 & ((t[n + 9] << 8) | t[n + 8])),
                              1 & p ||
                              3 < ((p >> 1) & 7) ||
                              !((p >> 4) & 1) ||
                              p >> 5 >= g.Ja ||
                              !b ||
                              !t
                                  ? (t = 0)
                                  : (c && (c[0] = b),
                                    u && (u[0] = t),
                                    (t = 1)));
                }
                if (!t) return 3;
                if (((c = c[0]), (m = m[0]), d && (l[0] != c || f[0] != m)))
                    return 3;
                null != h &&
                    ((h[0] = g),
                    (h.offset = n - h.w),
                    e(4294967286 > n - h.w),
                    e(h.offset == h.ha - i));
                break;
            }
            return 0 == y || (7 == y && d && null == h)
                ? (null != s && (s[0] |= null != g.na && 0 < g.na.length),
                  null != a && (a[0] = c),
                  null != o && (o[0] = m),
                  0)
                : y;
        }
        function Mr(t, e, r) {
            var n = e.width,
                i = e.height,
                a = 0,
                o = 0,
                s = n,
                c = i;
            if (
                ((e.Da = null != t && 0 < t.Da),
                e.Da &&
                    ((s = t.cd),
                    (c = t.bd),
                    (a = t.v),
                    (o = t.j),
                    11 > r || ((a &= -2), (o &= -2)),
                    0 > a ||
                        0 > o ||
                        0 >= s ||
                        0 >= c ||
                        a + s > n ||
                        o + c > i))
            )
                return 0;
            if (
                ((e.v = a),
                (e.j = o),
                (e.va = a + s),
                (e.o = o + c),
                (e.U = s),
                (e.T = c),
                (e.da = null != t && 0 < t.da),
                e.da)
            ) {
                if (!E(s, c, (r = [t.ib]), (a = [t.hb]))) return 0;
                (e.ib = r[0]), (e.hb = a[0]);
            }
            return (
                (e.ob = null != t && t.ob),
                (e.Kb = null == t || !t.Sd),
                e.da &&
                    ((e.ob = e.ib < (3 * n) / 4 && e.hb < (3 * i) / 4),
                    (e.Kb = 0)),
                1
            );
        }
        function Er(t) {
            if (null == t) return 2;
            if (11 > t.S) {
                var e = t.f.RGBA;
                (e.fb += (t.height - 1) * e.A), (e.A = -e.A);
            } else
                (e = t.f.kb),
                    (t = t.height),
                    (e.O += (t - 1) * e.fa),
                    (e.fa = -e.fa),
                    (e.N += ((t - 1) >> 1) * e.Ab),
                    (e.Ab = -e.Ab),
                    (e.W += ((t - 1) >> 1) * e.Db),
                    (e.Db = -e.Db),
                    null != e.F && ((e.J += (t - 1) * e.lb), (e.lb = -e.lb));
            return 0;
        }
        function qr(t, e, r, n) {
            if (null == n || 0 >= t || 0 >= e) return 2;
            if (null != r) {
                if (r.Da) {
                    var i = r.cd,
                        o = r.bd,
                        s = -2 & r.v,
                        c = -2 & r.j;
                    if (
                        0 > s ||
                        0 > c ||
                        0 >= i ||
                        0 >= o ||
                        s + i > t ||
                        c + o > e
                    )
                        return 2;
                    (t = i), (e = o);
                }
                if (r.da) {
                    if (!E(t, e, (i = [r.ib]), (o = [r.hb]))) return 2;
                    (t = i[0]), (e = o[0]);
                }
            }
            (n.width = t), (n.height = e);
            t: {
                var u = n.width,
                    h = n.height;
                if (((t = n.S), 0 >= u || 0 >= h || !(t >= En && 13 > t)))
                    t = 2;
                else {
                    if (0 >= n.Rd && null == n.sd) {
                        s = o = i = e = 0;
                        var l = (c = u * zi[t]) * h;
                        if (
                            (11 > t ||
                                ((o = ((h + 1) / 2) * (e = (u + 1) / 2)),
                                12 == t && (s = (i = u) * h)),
                            null == (h = a(l + 2 * o + s)))
                        ) {
                            t = 1;
                            break t;
                        }
                        (n.sd = h),
                            11 > t
                                ? (((u = n.f.RGBA).eb = h),
                                  (u.fb = 0),
                                  (u.A = c),
                                  (u.size = l))
                                : (((u = n.f.kb).y = h),
                                  (u.O = 0),
                                  (u.fa = c),
                                  (u.Fd = l),
                                  (u.f = h),
                                  (u.N = 0 + l),
                                  (u.Ab = e),
                                  (u.Cd = o),
                                  (u.ea = h),
                                  (u.W = 0 + l + o),
                                  (u.Db = e),
                                  (u.Ed = o),
                                  12 == t && ((u.F = h), (u.J = 0 + l + 2 * o)),
                                  (u.Tc = s),
                                  (u.lb = i));
                    }
                    if (
                        ((e = 1),
                        (i = n.S),
                        (o = n.width),
                        (s = n.height),
                        i >= En && 13 > i)
                    ) {
                        if (11 > i)
                            (t = n.f.RGBA),
                                (e &=
                                    (c = Math.abs(t.A)) * (s - 1) + o <=
                                    t.size),
                                (e &= c >= o * zi[i]),
                                (e &= null != t.eb);
                        else {
                            (t = n.f.kb),
                                (c = (o + 1) / 2),
                                (l = (s + 1) / 2),
                                (u = Math.abs(t.fa));
                            h = Math.abs(t.Ab);
                            var f = Math.abs(t.Db),
                                d = Math.abs(t.lb),
                                p = d * (s - 1) + o;
                            (e &= u * (s - 1) + o <= t.Fd),
                                (e &= h * (l - 1) + c <= t.Cd),
                                (e =
                                    (e &= f * (l - 1) + c <= t.Ed) &
                                    (u >= o) &
                                    (h >= c) &
                                    (f >= c)),
                                (e &= null != t.y),
                                (e &= null != t.f),
                                (e &= null != t.ea),
                                12 == i &&
                                    ((e &= d >= o),
                                    (e &= p <= t.Tc),
                                    (e &= null != t.F));
                        }
                    } else e = 0;
                    t = e ? 0 : 2;
                }
            }
            return 0 != t || (null != r && r.fd && (t = Er(n))), t;
        }
        var Dr = 64,
            Rr = [
                0, 1, 3, 7, 15, 31, 63, 127, 255, 511, 1023, 2047, 4095, 8191,
                16383, 32767, 65535, 131071, 262143, 524287, 1048575, 2097151,
                4194303, 8388607, 16777215,
            ],
            Tr = 24,
            Ur = 32,
            zr = 8,
            Hr = [
                0, 0, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 3, 3, 3, 3, 4, 4, 4, 4, 4,
                4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5,
                5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5,
                5, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6,
                6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6,
                6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6,
                6, 6, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7,
                7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7,
                7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7,
                7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7,
                7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7,
                7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7,
                7, 7, 7, 7,
            ];
        R("Predictor0", "PredictorAdd0"),
            (t.Predictor0 = function () {
                return 4278190080;
            }),
            (t.Predictor1 = function (t) {
                return t;
            }),
            (t.Predictor2 = function (t, e, r) {
                return e[r + 0];
            }),
            (t.Predictor3 = function (t, e, r) {
                return e[r + 1];
            }),
            (t.Predictor4 = function (t, e, r) {
                return e[r - 1];
            }),
            (t.Predictor5 = function (t, e, r) {
                return U(U(t, e[r + 1]), e[r + 0]);
            }),
            (t.Predictor6 = function (t, e, r) {
                return U(t, e[r - 1]);
            }),
            (t.Predictor7 = function (t, e, r) {
                return U(t, e[r + 0]);
            }),
            (t.Predictor8 = function (t, e, r) {
                return U(e[r - 1], e[r + 0]);
            }),
            (t.Predictor9 = function (t, e, r) {
                return U(e[r + 0], e[r + 1]);
            }),
            (t.Predictor10 = function (t, e, r) {
                return U(U(t, e[r - 1]), U(e[r + 0], e[r + 1]));
            }),
            (t.Predictor11 = function (t, e, r) {
                var n = e[r + 0];
                return 0 >=
                    W(
                        (n >> 24) & 255,
                        (t >> 24) & 255,
                        ((e = e[r - 1]) >> 24) & 255,
                    ) +
                        W((n >> 16) & 255, (t >> 16) & 255, (e >> 16) & 255) +
                        W((n >> 8) & 255, (t >> 8) & 255, (e >> 8) & 255) +
                        W(255 & n, 255 & t, 255 & e)
                    ? n
                    : t;
            }),
            (t.Predictor12 = function (t, e, r) {
                var n = e[r + 0];
                return (
                    ((z(
                        ((t >> 24) & 255) +
                            ((n >> 24) & 255) -
                            (((e = e[r - 1]) >> 24) & 255),
                    ) <<
                        24) |
                        (z(
                            ((t >> 16) & 255) +
                                ((n >> 16) & 255) -
                                ((e >> 16) & 255),
                        ) <<
                            16) |
                        (z(
                            ((t >> 8) & 255) +
                                ((n >> 8) & 255) -
                                ((e >> 8) & 255),
                        ) <<
                            8) |
                        z((255 & t) + (255 & n) - (255 & e))) >>>
                    0
                );
            }),
            (t.Predictor13 = function (t, e, r) {
                var n = e[r - 1];
                return (
                    ((H(((t = U(t, e[r + 0])) >> 24) & 255, (n >> 24) & 255) <<
                        24) |
                        (H((t >> 16) & 255, (n >> 16) & 255) << 16) |
                        (H((t >> 8) & 255, (n >> 8) & 255) << 8) |
                        H((t >> 0) & 255, (n >> 0) & 255)) >>>
                    0
                );
            });
        var Wr = t.PredictorAdd0;
        (t.PredictorAdd1 = V),
            R("Predictor2", "PredictorAdd2"),
            R("Predictor3", "PredictorAdd3"),
            R("Predictor4", "PredictorAdd4"),
            R("Predictor5", "PredictorAdd5"),
            R("Predictor6", "PredictorAdd6"),
            R("Predictor7", "PredictorAdd7"),
            R("Predictor8", "PredictorAdd8"),
            R("Predictor9", "PredictorAdd9"),
            R("Predictor10", "PredictorAdd10"),
            R("Predictor11", "PredictorAdd11"),
            R("Predictor12", "PredictorAdd12"),
            R("Predictor13", "PredictorAdd13");
        var Vr = t.PredictorAdd2;
        X(
            "ColorIndexInverseTransform",
            "MapARGB",
            "32b",
            function (t) {
                return (t >> 8) & 255;
            },
            function (t) {
                return t;
            },
        ),
            X(
                "VP8LColorIndexInverseTransformAlpha",
                "MapAlpha",
                "8b",
                function (t) {
                    return t;
                },
                function (t) {
                    return (t >> 8) & 255;
                },
            );
        var Gr,
            Yr = t.ColorIndexInverseTransform,
            Jr = t.MapARGB,
            Xr = t.VP8LColorIndexInverseTransformAlpha,
            Kr = t.MapAlpha,
            Zr = (t.VP8LPredictorsAdd = []);
        (Zr.length = 16),
            ((t.VP8LPredictors = []).length = 16),
            ((t.VP8LPredictorsAdd_C = []).length = 16),
            ((t.VP8LPredictors_C = []).length = 16);
        var $r,
            Qr,
            tn,
            en,
            rn,
            nn,
            an,
            on,
            sn,
            cn,
            un,
            hn,
            ln,
            fn,
            dn,
            pn,
            gn,
            mn,
            vn,
            bn,
            yn,
            wn,
            Nn,
            Ln,
            An,
            xn,
            Sn,
            _n,
            Pn = a(511),
            kn = a(2041),
            In = a(225),
            Fn = a(767),
            Cn = 0,
            jn = kn,
            On = In,
            Bn = Fn,
            Mn = Pn,
            En = 0,
            qn = 1,
            Dn = 2,
            Rn = 3,
            Tn = 4,
            Un = 5,
            zn = 6,
            Hn = 7,
            Wn = 8,
            Vn = 9,
            Gn = 10,
            Yn = [2, 3, 7],
            Jn = [3, 3, 11],
            Xn = [280, 256, 256, 256, 40],
            Kn = [0, 1, 1, 1, 0],
            Zn = [
                17, 18, 0, 1, 2, 3, 4, 5, 16, 6, 7, 8, 9, 10, 11, 12, 13, 14,
                15,
            ],
            $n = [
                24, 7, 23, 25, 40, 6, 39, 41, 22, 26, 38, 42, 56, 5, 55, 57, 21,
                27, 54, 58, 37, 43, 72, 4, 71, 73, 20, 28, 53, 59, 70, 74, 36,
                44, 88, 69, 75, 52, 60, 3, 87, 89, 19, 29, 86, 90, 35, 45, 68,
                76, 85, 91, 51, 61, 104, 2, 103, 105, 18, 30, 102, 106, 34, 46,
                84, 92, 67, 77, 101, 107, 50, 62, 120, 1, 119, 121, 83, 93, 17,
                31, 100, 108, 66, 78, 118, 122, 33, 47, 117, 123, 49, 63, 99,
                109, 82, 94, 0, 116, 124, 65, 79, 16, 32, 98, 110, 48, 115, 125,
                81, 95, 64, 114, 126, 97, 111, 80, 113, 127, 96, 112,
            ],
            Qn = [
                2954, 2956, 2958, 2962, 2970, 2986, 3018, 3082, 3212, 3468,
                3980, 5004,
            ],
            ti = 8,
            ei = [
                4, 5, 6, 7, 8, 9, 10, 10, 11, 12, 13, 14, 15, 16, 17, 17, 18,
                19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 25, 25, 26, 27, 28, 29,
                30, 31, 32, 33, 34, 35, 36, 37, 37, 38, 39, 40, 41, 42, 43, 44,
                45, 46, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59,
                60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75,
                76, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 91,
                93, 95, 96, 98, 100, 101, 102, 104, 106, 108, 110, 112, 114,
                116, 118, 122, 124, 126, 128, 130, 132, 134, 136, 138, 140, 143,
                145, 148, 151, 154, 157,
            ],
            ri = [
                4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
                21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36,
                37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52,
                53, 54, 55, 56, 57, 58, 60, 62, 64, 66, 68, 70, 72, 74, 76, 78,
                80, 82, 84, 86, 88, 90, 92, 94, 96, 98, 100, 102, 104, 106, 108,
                110, 112, 114, 116, 119, 122, 125, 128, 131, 134, 137, 140, 143,
                146, 149, 152, 155, 158, 161, 164, 167, 170, 173, 177, 181, 185,
                189, 193, 197, 201, 205, 209, 213, 217, 221, 225, 229, 234, 239,
                245, 249, 254, 259, 264, 269, 274, 279, 284,
            ],
            ni = null,
            ii = [
                [173, 148, 140, 0],
                [176, 155, 140, 135, 0],
                [180, 157, 141, 134, 130, 0],
                [254, 254, 243, 230, 196, 177, 153, 140, 133, 130, 129, 0],
            ],
            ai = [0, 1, 4, 8, 5, 2, 3, 6, 9, 12, 13, 10, 7, 11, 14, 15],
            oi = [
                -0, 1, -1, 2, -2, 3, 4, 6, -3, 5, -4, -5, -6, 7, -7, 8, -8, -9,
            ],
            si = [
                [
                    [
                        [128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128],
                        [128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128],
                        [128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128],
                    ],
                    [
                        [253, 136, 254, 255, 228, 219, 128, 128, 128, 128, 128],
                        [189, 129, 242, 255, 227, 213, 255, 219, 128, 128, 128],
                        [106, 126, 227, 252, 214, 209, 255, 255, 128, 128, 128],
                    ],
                    [
                        [1, 98, 248, 255, 236, 226, 255, 255, 128, 128, 128],
                        [181, 133, 238, 254, 221, 234, 255, 154, 128, 128, 128],
                        [78, 134, 202, 247, 198, 180, 255, 219, 128, 128, 128],
                    ],
                    [
                        [1, 185, 249, 255, 243, 255, 128, 128, 128, 128, 128],
                        [184, 150, 247, 255, 236, 224, 128, 128, 128, 128, 128],
                        [77, 110, 216, 255, 236, 230, 128, 128, 128, 128, 128],
                    ],
                    [
                        [1, 101, 251, 255, 241, 255, 128, 128, 128, 128, 128],
                        [170, 139, 241, 252, 236, 209, 255, 255, 128, 128, 128],
                        [37, 116, 196, 243, 228, 255, 255, 255, 128, 128, 128],
                    ],
                    [
                        [1, 204, 254, 255, 245, 255, 128, 128, 128, 128, 128],
                        [207, 160, 250, 255, 238, 128, 128, 128, 128, 128, 128],
                        [102, 103, 231, 255, 211, 171, 128, 128, 128, 128, 128],
                    ],
                    [
                        [1, 152, 252, 255, 240, 255, 128, 128, 128, 128, 128],
                        [177, 135, 243, 255, 234, 225, 128, 128, 128, 128, 128],
                        [80, 129, 211, 255, 194, 224, 128, 128, 128, 128, 128],
                    ],
                    [
                        [1, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128],
                        [246, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128],
                        [255, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128],
                    ],
                ],
                [
                    [
                        [198, 35, 237, 223, 193, 187, 162, 160, 145, 155, 62],
                        [131, 45, 198, 221, 172, 176, 220, 157, 252, 221, 1],
                        [68, 47, 146, 208, 149, 167, 221, 162, 255, 223, 128],
                    ],
                    [
                        [1, 149, 241, 255, 221, 224, 255, 255, 128, 128, 128],
                        [184, 141, 234, 253, 222, 220, 255, 199, 128, 128, 128],
                        [81, 99, 181, 242, 176, 190, 249, 202, 255, 255, 128],
                    ],
                    [
                        [1, 129, 232, 253, 214, 197, 242, 196, 255, 255, 128],
                        [99, 121, 210, 250, 201, 198, 255, 202, 128, 128, 128],
                        [23, 91, 163, 242, 170, 187, 247, 210, 255, 255, 128],
                    ],
                    [
                        [1, 200, 246, 255, 234, 255, 128, 128, 128, 128, 128],
                        [109, 178, 241, 255, 231, 245, 255, 255, 128, 128, 128],
                        [44, 130, 201, 253, 205, 192, 255, 255, 128, 128, 128],
                    ],
                    [
                        [1, 132, 239, 251, 219, 209, 255, 165, 128, 128, 128],
                        [94, 136, 225, 251, 218, 190, 255, 255, 128, 128, 128],
                        [22, 100, 174, 245, 186, 161, 255, 199, 128, 128, 128],
                    ],
                    [
                        [1, 182, 249, 255, 232, 235, 128, 128, 128, 128, 128],
                        [124, 143, 241, 255, 227, 234, 128, 128, 128, 128, 128],
                        [35, 77, 181, 251, 193, 211, 255, 205, 128, 128, 128],
                    ],
                    [
                        [1, 157, 247, 255, 236, 231, 255, 255, 128, 128, 128],
                        [121, 141, 235, 255, 225, 227, 255, 255, 128, 128, 128],
                        [45, 99, 188, 251, 195, 217, 255, 224, 128, 128, 128],
                    ],
                    [
                        [1, 1, 251, 255, 213, 255, 128, 128, 128, 128, 128],
                        [203, 1, 248, 255, 255, 128, 128, 128, 128, 128, 128],
                        [137, 1, 177, 255, 224, 255, 128, 128, 128, 128, 128],
                    ],
                ],
                [
                    [
                        [253, 9, 248, 251, 207, 208, 255, 192, 128, 128, 128],
                        [175, 13, 224, 243, 193, 185, 249, 198, 255, 255, 128],
                        [73, 17, 171, 221, 161, 179, 236, 167, 255, 234, 128],
                    ],
                    [
                        [1, 95, 247, 253, 212, 183, 255, 255, 128, 128, 128],
                        [239, 90, 244, 250, 211, 209, 255, 255, 128, 128, 128],
                        [155, 77, 195, 248, 188, 195, 255, 255, 128, 128, 128],
                    ],
                    [
                        [1, 24, 239, 251, 218, 219, 255, 205, 128, 128, 128],
                        [201, 51, 219, 255, 196, 186, 128, 128, 128, 128, 128],
                        [69, 46, 190, 239, 201, 218, 255, 228, 128, 128, 128],
                    ],
                    [
                        [1, 191, 251, 255, 255, 128, 128, 128, 128, 128, 128],
                        [223, 165, 249, 255, 213, 255, 128, 128, 128, 128, 128],
                        [141, 124, 248, 255, 255, 128, 128, 128, 128, 128, 128],
                    ],
                    [
                        [1, 16, 248, 255, 255, 128, 128, 128, 128, 128, 128],
                        [190, 36, 230, 255, 236, 255, 128, 128, 128, 128, 128],
                        [149, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128],
                    ],
                    [
                        [1, 226, 255, 128, 128, 128, 128, 128, 128, 128, 128],
                        [247, 192, 255, 128, 128, 128, 128, 128, 128, 128, 128],
                        [240, 128, 255, 128, 128, 128, 128, 128, 128, 128, 128],
                    ],
                    [
                        [1, 134, 252, 255, 255, 128, 128, 128, 128, 128, 128],
                        [213, 62, 250, 255, 255, 128, 128, 128, 128, 128, 128],
                        [55, 93, 255, 128, 128, 128, 128, 128, 128, 128, 128],
                    ],
                    [
                        [128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128],
                        [128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128],
                        [128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128],
                    ],
                ],
                [
                    [
                        [202, 24, 213, 235, 186, 191, 220, 160, 240, 175, 255],
                        [126, 38, 182, 232, 169, 184, 228, 174, 255, 187, 128],
                        [61, 46, 138, 219, 151, 178, 240, 170, 255, 216, 128],
                    ],
                    [
                        [1, 112, 230, 250, 199, 191, 247, 159, 255, 255, 128],
                        [166, 109, 228, 252, 211, 215, 255, 174, 128, 128, 128],
                        [39, 77, 162, 232, 172, 180, 245, 178, 255, 255, 128],
                    ],
                    [
                        [1, 52, 220, 246, 198, 199, 249, 220, 255, 255, 128],
                        [124, 74, 191, 243, 183, 193, 250, 221, 255, 255, 128],
                        [24, 71, 130, 219, 154, 170, 243, 182, 255, 255, 128],
                    ],
                    [
                        [1, 182, 225, 249, 219, 240, 255, 224, 128, 128, 128],
                        [149, 150, 226, 252, 216, 205, 255, 171, 128, 128, 128],
                        [28, 108, 170, 242, 183, 194, 254, 223, 255, 255, 128],
                    ],
                    [
                        [1, 81, 230, 252, 204, 203, 255, 192, 128, 128, 128],
                        [123, 102, 209, 247, 188, 196, 255, 233, 128, 128, 128],
                        [20, 95, 153, 243, 164, 173, 255, 203, 128, 128, 128],
                    ],
                    [
                        [1, 222, 248, 255, 216, 213, 128, 128, 128, 128, 128],
                        [168, 175, 246, 252, 235, 205, 255, 255, 128, 128, 128],
                        [47, 116, 215, 255, 211, 212, 255, 255, 128, 128, 128],
                    ],
                    [
                        [1, 121, 236, 253, 212, 214, 255, 255, 128, 128, 128],
                        [141, 84, 213, 252, 201, 202, 255, 219, 128, 128, 128],
                        [42, 80, 160, 240, 162, 185, 255, 205, 128, 128, 128],
                    ],
                    [
                        [1, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128],
                        [244, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128],
                        [238, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128],
                    ],
                ],
            ],
            ci = [
                [
                    [231, 120, 48, 89, 115, 113, 120, 152, 112],
                    [152, 179, 64, 126, 170, 118, 46, 70, 95],
                    [175, 69, 143, 80, 85, 82, 72, 155, 103],
                    [56, 58, 10, 171, 218, 189, 17, 13, 152],
                    [114, 26, 17, 163, 44, 195, 21, 10, 173],
                    [121, 24, 80, 195, 26, 62, 44, 64, 85],
                    [144, 71, 10, 38, 171, 213, 144, 34, 26],
                    [170, 46, 55, 19, 136, 160, 33, 206, 71],
                    [63, 20, 8, 114, 114, 208, 12, 9, 226],
                    [81, 40, 11, 96, 182, 84, 29, 16, 36],
                ],
                [
                    [134, 183, 89, 137, 98, 101, 106, 165, 148],
                    [72, 187, 100, 130, 157, 111, 32, 75, 80],
                    [66, 102, 167, 99, 74, 62, 40, 234, 128],
                    [41, 53, 9, 178, 241, 141, 26, 8, 107],
                    [74, 43, 26, 146, 73, 166, 49, 23, 157],
                    [65, 38, 105, 160, 51, 52, 31, 115, 128],
                    [104, 79, 12, 27, 217, 255, 87, 17, 7],
                    [87, 68, 71, 44, 114, 51, 15, 186, 23],
                    [47, 41, 14, 110, 182, 183, 21, 17, 194],
                    [66, 45, 25, 102, 197, 189, 23, 18, 22],
                ],
                [
                    [88, 88, 147, 150, 42, 46, 45, 196, 205],
                    [43, 97, 183, 117, 85, 38, 35, 179, 61],
                    [39, 53, 200, 87, 26, 21, 43, 232, 171],
                    [56, 34, 51, 104, 114, 102, 29, 93, 77],
                    [39, 28, 85, 171, 58, 165, 90, 98, 64],
                    [34, 22, 116, 206, 23, 34, 43, 166, 73],
                    [107, 54, 32, 26, 51, 1, 81, 43, 31],
                    [68, 25, 106, 22, 64, 171, 36, 225, 114],
                    [34, 19, 21, 102, 132, 188, 16, 76, 124],
                    [62, 18, 78, 95, 85, 57, 50, 48, 51],
                ],
                [
                    [193, 101, 35, 159, 215, 111, 89, 46, 111],
                    [60, 148, 31, 172, 219, 228, 21, 18, 111],
                    [112, 113, 77, 85, 179, 255, 38, 120, 114],
                    [40, 42, 1, 196, 245, 209, 10, 25, 109],
                    [88, 43, 29, 140, 166, 213, 37, 43, 154],
                    [61, 63, 30, 155, 67, 45, 68, 1, 209],
                    [100, 80, 8, 43, 154, 1, 51, 26, 71],
                    [142, 78, 78, 16, 255, 128, 34, 197, 171],
                    [41, 40, 5, 102, 211, 183, 4, 1, 221],
                    [51, 50, 17, 168, 209, 192, 23, 25, 82],
                ],
                [
                    [138, 31, 36, 171, 27, 166, 38, 44, 229],
                    [67, 87, 58, 169, 82, 115, 26, 59, 179],
                    [63, 59, 90, 180, 59, 166, 93, 73, 154],
                    [40, 40, 21, 116, 143, 209, 34, 39, 175],
                    [47, 15, 16, 183, 34, 223, 49, 45, 183],
                    [46, 17, 33, 183, 6, 98, 15, 32, 183],
                    [57, 46, 22, 24, 128, 1, 54, 17, 37],
                    [65, 32, 73, 115, 28, 128, 23, 128, 205],
                    [40, 3, 9, 115, 51, 192, 18, 6, 223],
                    [87, 37, 9, 115, 59, 77, 64, 21, 47],
                ],
                [
                    [104, 55, 44, 218, 9, 54, 53, 130, 226],
                    [64, 90, 70, 205, 40, 41, 23, 26, 57],
                    [54, 57, 112, 184, 5, 41, 38, 166, 213],
                    [30, 34, 26, 133, 152, 116, 10, 32, 134],
                    [39, 19, 53, 221, 26, 114, 32, 73, 255],
                    [31, 9, 65, 234, 2, 15, 1, 118, 73],
                    [75, 32, 12, 51, 192, 255, 160, 43, 51],
                    [88, 31, 35, 67, 102, 85, 55, 186, 85],
                    [56, 21, 23, 111, 59, 205, 45, 37, 192],
                    [55, 38, 70, 124, 73, 102, 1, 34, 98],
                ],
                [
                    [125, 98, 42, 88, 104, 85, 117, 175, 82],
                    [95, 84, 53, 89, 128, 100, 113, 101, 45],
                    [75, 79, 123, 47, 51, 128, 81, 171, 1],
                    [57, 17, 5, 71, 102, 57, 53, 41, 49],
                    [38, 33, 13, 121, 57, 73, 26, 1, 85],
                    [41, 10, 67, 138, 77, 110, 90, 47, 114],
                    [115, 21, 2, 10, 102, 255, 166, 23, 6],
                    [101, 29, 16, 10, 85, 128, 101, 196, 26],
                    [57, 18, 10, 102, 102, 213, 34, 20, 43],
                    [117, 20, 15, 36, 163, 128, 68, 1, 26],
                ],
                [
                    [102, 61, 71, 37, 34, 53, 31, 243, 192],
                    [69, 60, 71, 38, 73, 119, 28, 222, 37],
                    [68, 45, 128, 34, 1, 47, 11, 245, 171],
                    [62, 17, 19, 70, 146, 85, 55, 62, 70],
                    [37, 43, 37, 154, 100, 163, 85, 160, 1],
                    [63, 9, 92, 136, 28, 64, 32, 201, 85],
                    [75, 15, 9, 9, 64, 255, 184, 119, 16],
                    [86, 6, 28, 5, 64, 255, 25, 248, 1],
                    [56, 8, 17, 132, 137, 255, 55, 116, 128],
                    [58, 15, 20, 82, 135, 57, 26, 121, 40],
                ],
                [
                    [164, 50, 31, 137, 154, 133, 25, 35, 218],
                    [51, 103, 44, 131, 131, 123, 31, 6, 158],
                    [86, 40, 64, 135, 148, 224, 45, 183, 128],
                    [22, 26, 17, 131, 240, 154, 14, 1, 209],
                    [45, 16, 21, 91, 64, 222, 7, 1, 197],
                    [56, 21, 39, 155, 60, 138, 23, 102, 213],
                    [83, 12, 13, 54, 192, 255, 68, 47, 28],
                    [85, 26, 85, 85, 128, 128, 32, 146, 171],
                    [18, 11, 7, 63, 144, 171, 4, 4, 246],
                    [35, 27, 10, 146, 174, 171, 12, 26, 128],
                ],
                [
                    [190, 80, 35, 99, 180, 80, 126, 54, 45],
                    [85, 126, 47, 87, 176, 51, 41, 20, 32],
                    [101, 75, 128, 139, 118, 146, 116, 128, 85],
                    [56, 41, 15, 176, 236, 85, 37, 9, 62],
                    [71, 30, 17, 119, 118, 255, 17, 18, 138],
                    [101, 38, 60, 138, 55, 70, 43, 26, 142],
                    [146, 36, 19, 30, 171, 255, 97, 27, 20],
                    [138, 45, 61, 62, 219, 1, 81, 188, 64],
                    [32, 41, 20, 117, 151, 142, 20, 21, 163],
                    [112, 19, 12, 61, 195, 128, 48, 4, 24],
                ],
            ],
            ui = [
                [
                    [
                        [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255],
                        [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255],
                        [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255],
                    ],
                    [
                        [176, 246, 255, 255, 255, 255, 255, 255, 255, 255, 255],
                        [223, 241, 252, 255, 255, 255, 255, 255, 255, 255, 255],
                        [249, 253, 253, 255, 255, 255, 255, 255, 255, 255, 255],
                    ],
                    [
                        [255, 244, 252, 255, 255, 255, 255, 255, 255, 255, 255],
                        [234, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255],
                        [253, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255],
                    ],
                    [
                        [255, 246, 254, 255, 255, 255, 255, 255, 255, 255, 255],
                        [239, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255],
                        [254, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255],
                    ],
                    [
                        [255, 248, 254, 255, 255, 255, 255, 255, 255, 255, 255],
                        [251, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255],
                        [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255],
                    ],
                    [
                        [255, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255],
                        [251, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255],
                        [254, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255],
                    ],
                    [
                        [255, 254, 253, 255, 254, 255, 255, 255, 255, 255, 255],
                        [250, 255, 254, 255, 254, 255, 255, 255, 255, 255, 255],
                        [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255],
                    ],
                    [
                        [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255],
                        [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255],
                        [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255],
                    ],
                ],
                [
                    [
                        [217, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255],
                        [225, 252, 241, 253, 255, 255, 254, 255, 255, 255, 255],
                        [234, 250, 241, 250, 253, 255, 253, 254, 255, 255, 255],
                    ],
                    [
                        [255, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255],
                        [223, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255],
                        [238, 253, 254, 254, 255, 255, 255, 255, 255, 255, 255],
                    ],
                    [
                        [255, 248, 254, 255, 255, 255, 255, 255, 255, 255, 255],
                        [249, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255],
                        [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255],
                    ],
                    [
                        [255, 253, 255, 255, 255, 255, 255, 255, 255, 255, 255],
                        [247, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255],
                        [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255],
                    ],
                    [
                        [255, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255],
                        [252, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255],
                        [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255],
                    ],
                    [
                        [255, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255],
                        [253, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255],
                        [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255],
                    ],
                    [
                        [255, 254, 253, 255, 255, 255, 255, 255, 255, 255, 255],
                        [250, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255],
                        [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255],
                    ],
                    [
                        [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255],
                        [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255],
                        [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255],
                    ],
                ],
                [
                    [
                        [186, 251, 250, 255, 255, 255, 255, 255, 255, 255, 255],
                        [234, 251, 244, 254, 255, 255, 255, 255, 255, 255, 255],
                        [251, 251, 243, 253, 254, 255, 254, 255, 255, 255, 255],
                    ],
                    [
                        [255, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255],
                        [236, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255],
                        [251, 253, 253, 254, 254, 255, 255, 255, 255, 255, 255],
                    ],
                    [
                        [255, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255],
                        [254, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255],
                        [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255],
                    ],
                    [
                        [255, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255],
                        [254, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255],
                        [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255],
                    ],
                    [
                        [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255],
                        [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255],
                        [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255],
                    ],
                    [
                        [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255],
                        [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255],
                        [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255],
                    ],
                    [
                        [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255],
                        [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255],
                        [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255],
                    ],
                    [
                        [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255],
                        [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255],
                        [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255],
                    ],
                ],
                [
                    [
                        [248, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255],
                        [250, 254, 252, 254, 255, 255, 255, 255, 255, 255, 255],
                        [248, 254, 249, 253, 255, 255, 255, 255, 255, 255, 255],
                    ],
                    [
                        [255, 253, 253, 255, 255, 255, 255, 255, 255, 255, 255],
                        [246, 253, 253, 255, 255, 255, 255, 255, 255, 255, 255],
                        [252, 254, 251, 254, 254, 255, 255, 255, 255, 255, 255],
                    ],
                    [
                        [255, 254, 252, 255, 255, 255, 255, 255, 255, 255, 255],
                        [248, 254, 253, 255, 255, 255, 255, 255, 255, 255, 255],
                        [253, 255, 254, 254, 255, 255, 255, 255, 255, 255, 255],
                    ],
                    [
                        [255, 251, 254, 255, 255, 255, 255, 255, 255, 255, 255],
                        [245, 251, 254, 255, 255, 255, 255, 255, 255, 255, 255],
                        [253, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255],
                    ],
                    [
                        [255, 251, 253, 255, 255, 255, 255, 255, 255, 255, 255],
                        [252, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255],
                        [255, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255],
                    ],
                    [
                        [255, 252, 255, 255, 255, 255, 255, 255, 255, 255, 255],
                        [249, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255],
                        [255, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255],
                    ],
                    [
                        [255, 255, 253, 255, 255, 255, 255, 255, 255, 255, 255],
                        [250, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255],
                        [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255],
                    ],
                    [
                        [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255],
                        [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255],
                        [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255],
                    ],
                ],
            ],
            hi = [0, 1, 2, 3, 6, 4, 5, 6, 6, 6, 6, 6, 6, 6, 6, 7, 0],
            li = [],
            fi = [],
            di = [],
            pi = 1,
            gi = 2,
            mi = [],
            vi = [];
        vr("UpsampleRgbLinePair", Ar, 3),
            vr("UpsampleBgrLinePair", xr, 3),
            vr("UpsampleRgbaLinePair", Ir, 4),
            vr("UpsampleBgraLinePair", kr, 4),
            vr("UpsampleArgbLinePair", Pr, 4),
            vr("UpsampleRgba4444LinePair", _r, 2),
            vr("UpsampleRgb565LinePair", Sr, 2);
        var bi = t.UpsampleRgbLinePair,
            yi = t.UpsampleBgrLinePair,
            wi = t.UpsampleRgbaLinePair,
            Ni = t.UpsampleBgraLinePair,
            Li = t.UpsampleArgbLinePair,
            Ai = t.UpsampleRgba4444LinePair,
            xi = t.UpsampleRgb565LinePair,
            Si = 16,
            _i = 1 << (Si - 1),
            Pi = -227,
            ki = 482,
            Ii = 6,
            Fi = (256 << Ii) - 1,
            Ci = 0,
            ji = a(256),
            Oi = a(256),
            Bi = a(256),
            Mi = a(256),
            Ei = a(ki - Pi),
            qi = a(ki - Pi);
        Fr("YuvToRgbRow", Ar, 3),
            Fr("YuvToBgrRow", xr, 3),
            Fr("YuvToRgbaRow", Ir, 4),
            Fr("YuvToBgraRow", kr, 4),
            Fr("YuvToArgbRow", Pr, 4),
            Fr("YuvToRgba4444Row", _r, 2),
            Fr("YuvToRgb565Row", Sr, 2);
        var Di = [
                0, 4, 8, 12, 128, 132, 136, 140, 256, 260, 264, 268, 384, 388,
                392, 396,
            ],
            Ri = [0, 2, 8],
            Ti = [8, 7, 6, 4, 4, 2, 2, 2, 1, 1, 1, 1],
            Ui = 1;
        this.WebPDecodeRGBA = function (t, r, n, i, a) {
            var o = qn,
                s = new rr(),
                c = new ot();
            (s.ba = c),
                (c.S = o),
                (c.width = [c.width]),
                (c.height = [c.height]);
            var u = c.width,
                h = c.height,
                l = new st();
            if (null == l || null == t) var f = 2;
            else
                e(null != l),
                    (f = Br(
                        t,
                        r,
                        n,
                        l.width,
                        l.height,
                        l.Pd,
                        l.Qd,
                        l.format,
                        null,
                    ));
            if (
                (0 != f
                    ? (u = 0)
                    : (null != u && (u[0] = l.width[0]),
                      null != h && (h[0] = l.height[0]),
                      (u = 1)),
                u)
            ) {
                (c.width = c.width[0]),
                    (c.height = c.height[0]),
                    null != i && (i[0] = c.width),
                    null != a && (a[0] = c.height);
                t: {
                    if (
                        ((i = new Gt()),
                        ((a = new nr()).data = t),
                        (a.w = r),
                        (a.ha = n),
                        (a.kd = 1),
                        (r = [0]),
                        e(null != a),
                        (0 ==
                            (t = Br(
                                a.data,
                                a.w,
                                a.ha,
                                null,
                                null,
                                null,
                                r,
                                null,
                                a,
                            )) ||
                            7 == t) &&
                            r[0] &&
                            (t = 4),
                        0 == (r = t))
                    ) {
                        if (
                            (e(null != s),
                            (i.data = a.data),
                            (i.w = a.w + a.offset),
                            (i.ha = a.ha - a.offset),
                            (i.put = dt),
                            (i.ac = ft),
                            (i.bc = pt),
                            (i.ma = s),
                            a.xa)
                        ) {
                            if (null == (t = kt())) {
                                s = 1;
                                break t;
                            }
                            if (
                                (function (t, r) {
                                    var n = [0],
                                        i = [0],
                                        a = [0];
                                    e: for (;;) {
                                        if (null == t) return 0;
                                        if (null == r) return (t.a = 2), 0;
                                        if (
                                            ((t.l = r),
                                            (t.a = 0),
                                            v(t.m, r.data, r.w, r.ha),
                                            !gt(t.m, n, i, a))
                                        ) {
                                            t.a = 3;
                                            break e;
                                        }
                                        if (
                                            ((t.xb = gi),
                                            (r.width = n[0]),
                                            (r.height = i[0]),
                                            !It(n[0], i[0], 1, t, null))
                                        )
                                            break e;
                                        return 1;
                                    }
                                    return e(0 != t.a), 0;
                                })(t, i)
                            ) {
                                if (
                                    (i =
                                        0 ==
                                        (r = qr(i.width, i.height, s.Oa, s.ba)))
                                ) {
                                    e: {
                                        i = t;
                                        r: for (;;) {
                                            if (null == i) {
                                                i = 0;
                                                break e;
                                            }
                                            if (
                                                (e(null != i.s.yc),
                                                e(null != i.s.Ya),
                                                e(0 < i.s.Wb),
                                                e(null != (n = i.l)),
                                                e(null != (a = n.ma)),
                                                0 != i.xb)
                                            ) {
                                                if (
                                                    ((i.ca = a.ba),
                                                    (i.tb = a.tb),
                                                    e(null != i.ca),
                                                    !Mr(a.Oa, n, Rn))
                                                ) {
                                                    i.a = 2;
                                                    break r;
                                                }
                                                if (!Ft(i, n.width)) break r;
                                                if (n.da) break r;
                                                if (
                                                    ((n.da || nt(i.ca.S)) &&
                                                        mr(),
                                                    11 > i.ca.S ||
                                                        (alert(
                                                            "todo:WebPInitConvertARGBToYUV",
                                                        ),
                                                        null != i.ca.f.kb.F &&
                                                            mr()),
                                                    i.Pb &&
                                                        0 < i.s.ua &&
                                                        null == i.s.vb.X &&
                                                        !O(i.s.vb, i.s.Wa.Xa))
                                                ) {
                                                    i.a = 1;
                                                    break r;
                                                }
                                                i.xb = 0;
                                            }
                                            if (
                                                !_t(
                                                    i,
                                                    i.V,
                                                    i.Ba,
                                                    i.c,
                                                    i.i,
                                                    n.o,
                                                    Lt,
                                                )
                                            )
                                                break r;
                                            (a.Dc = i.Ma), (i = 1);
                                            break e;
                                        }
                                        e(0 != i.a), (i = 0);
                                    }
                                    i = !i;
                                }
                                i && (r = t.a);
                            } else r = t.a;
                        } else {
                            if (null == (t = new Yt())) {
                                s = 1;
                                break t;
                            }
                            if (
                                ((t.Fa = a.na),
                                (t.P = a.P),
                                (t.qc = a.Sa),
                                Kt(t, i))
                            ) {
                                if (
                                    0 == (r = qr(i.width, i.height, s.Oa, s.ba))
                                ) {
                                    if (
                                        ((t.Aa = 0),
                                        (n = s.Oa),
                                        e(null != (a = t)),
                                        null != n)
                                    ) {
                                        if (
                                            0 <
                                            (u =
                                                0 > (u = n.Md)
                                                    ? 0
                                                    : 100 < u
                                                      ? 255
                                                      : (255 * u) / 100)
                                        ) {
                                            for (h = l = 0; 4 > h; ++h)
                                                12 > (f = a.pb[h]).lc &&
                                                    (f.ia =
                                                        (u *
                                                            Ti[
                                                                0 > f.lc
                                                                    ? 0
                                                                    : f.lc
                                                            ]) >>
                                                        3),
                                                    (l |= f.ia);
                                            l &&
                                                (alert("todo:VP8InitRandom"),
                                                (a.ia = 1));
                                        }
                                        (a.Ga = n.Id),
                                            100 < a.Ga
                                                ? (a.Ga = 100)
                                                : 0 > a.Ga && (a.Ga = 0);
                                    }
                                    Qt(t, i) || (r = t.a);
                                }
                            } else r = t.a;
                        }
                        0 == r && null != s.Oa && s.Oa.fd && (r = Er(s.ba));
                    }
                    s = r;
                }
                o = 0 != s ? null : 11 > o ? c.f.RGBA.eb : c.f.kb.y;
            } else o = null;
            return o;
        };
        var zi = [3, 4, 3, 4, 4, 2, 2, 4, 4, 4, 2, 1, 1];
    };
    function u(t, e) {
        for (var r = "", n = 0; n < 4; n++) r += String.fromCharCode(t[e++]);
        return r;
    }
    function h(t, e) {
        return ((t[e + 0] << 0) | (t[e + 1] << 8) | (t[e + 2] << 16)) >>> 0;
    }
    function l(t, e) {
        return (
            ((t[e + 0] << 0) |
                (t[e + 1] << 8) |
                (t[e + 2] << 16) |
                (t[e + 3] << 24)) >>>
            0
        );
    }
    new c();
    var f = [0],
        d = [0],
        p = [],
        g = new c(),
        m = t,
        v = (function (t, e) {
            var r = {},
                n = 0,
                i = !1,
                a = 0,
                o = 0;
            if (
                ((r.frames = []),
                !(
                    /** @license
         * Copyright (c) 2017 Dominik Homberger
        Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
        The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
        THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
        https://webpjs.appspot.com
        WebPRiffParser dominikhlbg@gmail.com
        */
                    (function (t, e, r, n) {
                        for (var i = 0; i < n; i++)
                            if (t[e + i] != r.charCodeAt(i)) return !0;
                        return !1;
                    })(t, e, "RIFF", 4)
                ))
            ) {
                var s, c;
                l(t, (e += 4));
                for (e += 8; e < t.length; ) {
                    var f = u(t, e),
                        d = l(t, (e += 4));
                    e += 4;
                    var p = d + (1 & d);
                    switch (f) {
                        case "VP8 ":
                        case "VP8L":
                            void 0 === r.frames[n] && (r.frames[n] = {});
                            ((v = r.frames[n]).src_off = i ? o : e - 8),
                                (v.src_size = a + d + 8),
                                n++,
                                i && ((i = !1), (a = 0), (o = 0));
                            break;
                        case "VP8X":
                            (v = r.header = {}).feature_flags = t[e];
                            var g = e + 4;
                            v.canvas_width = 1 + h(t, g);
                            g += 3;
                            v.canvas_height = 1 + h(t, g);
                            g += 3;
                            break;
                        case "ALPH":
                            (i = !0), (a = p + 8), (o = e - 8);
                            break;
                        case "ANIM":
                            (v = r.header).bgcolor = l(t, e);
                            g = e + 4;
                            v.loop_count =
                                ((s = t)[(c = g) + 0] << 0) | (s[c + 1] << 8);
                            g += 2;
                            break;
                        case "ANMF":
                            var m, v;
                            ((v = r.frames[n] = {}).offset_x = 2 * h(t, e)),
                                (e += 3),
                                (v.offset_y = 2 * h(t, e)),
                                (e += 3),
                                (v.width = 1 + h(t, e)),
                                (e += 3),
                                (v.height = 1 + h(t, e)),
                                (e += 3),
                                (v.duration = h(t, e)),
                                (e += 3),
                                (m = t[e++]),
                                (v.dispose = 1 & m),
                                (v.blend = (m >> 1) & 1);
                    }
                    "ANMF" != f && (e += p);
                }
                return r;
            }
        })(m, 0);
    (v.response = m), (v.rgbaoutput = !0), (v.dataurl = !1);
    var b = v.header ? v.header : null,
        y = v.frames ? v.frames : null;
    if (b) {
        (b.loop_counter = b.loop_count),
            (f = [b.canvas_height]),
            (d = [b.canvas_width]);
        for (var w = 0; w < y.length && 0 != y[w].blend; w++);
    }
    var N = y[0],
        L = g.WebPDecodeRGBA(m, N.src_off, N.src_size, d, f);
    (N.rgba = L), (N.imgwidth = d[0]), (N.imgheight = f[0]);
    for (var A = 0; A < d[0] * f[0] * 4; A++) p[A] = L[A];
    return (this.width = d), (this.height = f), (this.data = p), this;
}
!(function (t) {
    var r = function () {
            return "function" == typeof zlibSync;
        },
        n = function (r, n, a, h) {
            var l = 4,
                f = s;
            switch (h) {
                case t.image_compression.FAST:
                    (l = 1), (f = o);
                    break;
                case t.image_compression.MEDIUM:
                    (l = 6), (f = c);
                    break;
                case t.image_compression.SLOW:
                    (l = 9), (f = u);
            }
            r = i(r, n, a, f);
            var d = zlibSync(r, {
                level: l,
            });
            return t.__addimage__.arrayBufferToBinaryString(d);
        },
        i = function (t, e, r, n) {
            for (
                var i,
                    a,
                    o,
                    s = t.length / e,
                    c = new Uint8Array(t.length + s),
                    u = l(),
                    h = 0;
                h < s;
                h += 1
            ) {
                if (((o = h * e), (i = t.subarray(o, o + e)), n))
                    c.set(n(i, r, a), o + h);
                else {
                    for (var d, p = u.length, g = []; d < p; d += 1)
                        g[d] = u[d](i, r, a);
                    var m = f(g.concat());
                    c.set(g[m], o + h);
                }
                a = i;
            }
            return c;
        },
        a = function (t) {
            var e = Array.apply([], t);
            return e.unshift(0), e;
        },
        o = function (t, e) {
            var r,
                n = [],
                i = t.length;
            n[0] = 1;
            for (var a = 0; a < i; a += 1)
                (r = t[a - e] || 0), (n[a + 1] = (t[a] - r + 256) & 255);
            return n;
        },
        s = function (t, e, r) {
            var n,
                i = [],
                a = t.length;
            i[0] = 2;
            for (var o = 0; o < a; o += 1)
                (n = (r && r[o]) || 0), (i[o + 1] = (t[o] - n + 256) & 255);
            return i;
        },
        c = function (t, e, r) {
            var n,
                i,
                a = [],
                o = t.length;
            a[0] = 3;
            for (var s = 0; s < o; s += 1)
                (n = t[s - e] || 0),
                    (i = (r && r[s]) || 0),
                    (a[s + 1] = (t[s] + 256 - ((n + i) >>> 1)) & 255);
            return a;
        },
        u = function (t, e, r) {
            var n,
                i,
                a,
                o,
                s = [],
                c = t.length;
            s[0] = 4;
            for (var u = 0; u < c; u += 1)
                (n = t[u - e] || 0),
                    (i = (r && r[u]) || 0),
                    (a = (r && r[u - e]) || 0),
                    (o = h(n, i, a)),
                    (s[u + 1] = (t[u] - o + 256) & 255);
            return s;
        },
        h = function (t, e, r) {
            if (t === e && e === r) return t;
            var n = Math.abs(e - r),
                i = Math.abs(t - r),
                a = Math.abs(t + e - r - r);
            return n <= i && n <= a ? t : i <= a ? e : r;
        },
        l = function () {
            return [a, o, s, c, u];
        },
        f = function (t) {
            var e = t.map(function (t) {
                return t.reduce(function (t, e) {
                    return t + Math.abs(e);
                }, 0);
            });
            return e.indexOf(Math.min.apply(null, e));
        };
    t.processPNG = function (e, i, a, o) {
        var s,
            c,
            u,
            h,
            l,
            f,
            d,
            p,
            g,
            m,
            v,
            b,
            y,
            w,
            N,
            L = this.decode.FLATE_DECODE,
            A = "";
        if (
            (this.__addimage__.isArrayBuffer(e) && (e = new Uint8Array(e)),
            this.__addimage__.isArrayBufferView(e))
        ) {
            if (
                ((e = (u = new Kt(e)).imgData),
                (c = u.bits),
                (s = u.colorSpace),
                (l = u.colors),
                -1 !== [4, 6].indexOf(u.colorType))
            ) {
                if (8 === u.bits) {
                    (g = (p =
                        32 == u.pixelBitlength
                            ? new Uint32Array(u.decodePixels().buffer)
                            : 16 == u.pixelBitlength
                              ? new Uint16Array(u.decodePixels().buffer)
                              : new Uint8Array(u.decodePixels().buffer))
                        .length),
                        (v = new Uint8Array(g * u.colors)),
                        (m = new Uint8Array(g));
                    var x,
                        S = u.pixelBitlength - u.bits;
                    for (w = 0, N = 0; w < g; w++) {
                        for (y = p[w], x = 0; x < S; )
                            (v[N++] = (y >>> x) & 255), (x += u.bits);
                        m[w] = (y >>> x) & 255;
                    }
                }
                if (16 === u.bits) {
                    (g = (p = new Uint32Array(u.decodePixels().buffer)).length),
                        (v = new Uint8Array(
                            g * (32 / u.pixelBitlength) * u.colors,
                        )),
                        (m = new Uint8Array(g * (32 / u.pixelBitlength))),
                        (b = u.colors > 1),
                        (w = 0),
                        (N = 0);
                    for (var _ = 0; w < g; )
                        (y = p[w++]),
                            (v[N++] = (y >>> 0) & 255),
                            b &&
                                ((v[N++] = (y >>> 16) & 255),
                                (y = p[w++]),
                                (v[N++] = (y >>> 0) & 255)),
                            (m[_++] = (y >>> 16) & 255);
                    c = 8;
                }
                o !== t.image_compression.NONE && r()
                    ? ((e = n(v, u.width * u.colors, u.colors, o)),
                      (d = n(m, u.width, 1, o)))
                    : ((e = v), (d = m), (L = void 0));
            }
            if (
                3 === u.colorType &&
                ((s = this.color_spaces.INDEXED),
                (f = u.palette),
                u.transparency.indexed)
            ) {
                var P = u.transparency.indexed,
                    k = 0;
                for (w = 0, g = P.length; w < g; ++w) k += P[w];
                if ((k /= 255) === g - 1 && -1 !== P.indexOf(0))
                    h = [P.indexOf(0)];
                else if (k !== g) {
                    for (
                        p = u.decodePixels(),
                            m = new Uint8Array(p.length),
                            w = 0,
                            g = p.length;
                        w < g;
                        w++
                    )
                        m[w] = P[p[w]];
                    d = n(m, u.width, 1);
                }
            }
            var I = (function (e) {
                var r;
                switch (e) {
                    case t.image_compression.FAST:
                        r = 11;
                        break;
                    case t.image_compression.MEDIUM:
                        r = 13;
                        break;
                    case t.image_compression.SLOW:
                        r = 14;
                        break;
                    default:
                        r = 12;
                }
                return r;
            })(o);
            return (
                L === this.decode.FLATE_DECODE && (A = "/Predictor " + I + " "),
                (A +=
                    "/Colors " +
                    l +
                    " /BitsPerComponent " +
                    c +
                    " /Columns " +
                    u.width),
                (this.__addimage__.isArrayBuffer(e) ||
                    this.__addimage__.isArrayBufferView(e)) &&
                    (e = this.__addimage__.arrayBufferToBinaryString(e)),
                ((d && this.__addimage__.isArrayBuffer(d)) ||
                    this.__addimage__.isArrayBufferView(d)) &&
                    (d = this.__addimage__.arrayBufferToBinaryString(d)),
                {
                    alias: a,
                    data: e,
                    index: i,
                    filter: L,
                    decodeParameters: A,
                    transparency: h,
                    palette: f,
                    sMask: d,
                    predictor: I,
                    width: u.width,
                    height: u.height,
                    bitsPerComponent: c,
                    colorSpace: s,
                }
            );
        }
    };
})(E.API),
    (function (t) {
        (t.processGIF89A = function (e, r, n, i) {
            var a = new Zt(e),
                o = a.width,
                s = a.height,
                c = [];
            a.decodeAndBlitFrameRGBA(0, c);
            var u = {
                    data: c,
                    width: o,
                    height: s,
                },
                h = new Qt(100).encode(u, 100);
            return t.processJPEG.call(this, h, r, n, i);
        }),
            (t.processGIF87A = t.processGIF89A);
    })(E.API),
    (te.prototype.parseHeader = function () {
        if (
            ((this.fileSize = this.datav.getUint32(this.pos, !0)),
            (this.pos += 4),
            (this.reserved = this.datav.getUint32(this.pos, !0)),
            (this.pos += 4),
            (this.offset = this.datav.getUint32(this.pos, !0)),
            (this.pos += 4),
            (this.headerSize = this.datav.getUint32(this.pos, !0)),
            (this.pos += 4),
            (this.width = this.datav.getUint32(this.pos, !0)),
            (this.pos += 4),
            (this.height = this.datav.getInt32(this.pos, !0)),
            (this.pos += 4),
            (this.planes = this.datav.getUint16(this.pos, !0)),
            (this.pos += 2),
            (this.bitPP = this.datav.getUint16(this.pos, !0)),
            (this.pos += 2),
            (this.compress = this.datav.getUint32(this.pos, !0)),
            (this.pos += 4),
            (this.rawSize = this.datav.getUint32(this.pos, !0)),
            (this.pos += 4),
            (this.hr = this.datav.getUint32(this.pos, !0)),
            (this.pos += 4),
            (this.vr = this.datav.getUint32(this.pos, !0)),
            (this.pos += 4),
            (this.colors = this.datav.getUint32(this.pos, !0)),
            (this.pos += 4),
            (this.importantColors = this.datav.getUint32(this.pos, !0)),
            (this.pos += 4),
            16 === this.bitPP && this.is_with_alpha && (this.bitPP = 15),
            this.bitPP < 15)
        ) {
            var t = 0 === this.colors ? 1 << this.bitPP : this.colors;
            this.palette = new Array(t);
            for (var e = 0; e < t; e++) {
                var r = this.datav.getUint8(this.pos++, !0),
                    n = this.datav.getUint8(this.pos++, !0),
                    i = this.datav.getUint8(this.pos++, !0),
                    a = this.datav.getUint8(this.pos++, !0);
                this.palette[e] = {
                    red: i,
                    green: n,
                    blue: r,
                    quad: a,
                };
            }
        }
        this.height < 0 && ((this.height *= -1), (this.bottom_up = !1));
    }),
    (te.prototype.parseBGR = function () {
        this.pos = this.offset;
        try {
            var t = "bit" + this.bitPP,
                e = this.width * this.height * 4;
            (this.data = new Uint8Array(e)), this[t]();
        } catch (t) {
            a.log("bit decode error:" + t);
        }
    }),
    (te.prototype.bit1 = function () {
        var t,
            e = Math.ceil(this.width / 8),
            r = e % 4;
        for (t = this.height - 1; t >= 0; t--) {
            for (
                var n = this.bottom_up ? t : this.height - 1 - t, i = 0;
                i < e;
                i++
            )
                for (
                    var a = this.datav.getUint8(this.pos++, !0),
                        o = n * this.width * 4 + 8 * i * 4,
                        s = 0;
                    s < 8 && 8 * i + s < this.width;
                    s++
                ) {
                    var c = this.palette[(a >> (7 - s)) & 1];
                    (this.data[o + 4 * s] = c.blue),
                        (this.data[o + 4 * s + 1] = c.green),
                        (this.data[o + 4 * s + 2] = c.red),
                        (this.data[o + 4 * s + 3] = 255);
                }
            0 !== r && (this.pos += 4 - r);
        }
    }),
    (te.prototype.bit4 = function () {
        for (
            var t = Math.ceil(this.width / 2), e = t % 4, r = this.height - 1;
            r >= 0;
            r--
        ) {
            for (
                var n = this.bottom_up ? r : this.height - 1 - r, i = 0;
                i < t;
                i++
            ) {
                var a = this.datav.getUint8(this.pos++, !0),
                    o = n * this.width * 4 + 2 * i * 4,
                    s = a >> 4,
                    c = 15 & a,
                    u = this.palette[s];
                if (
                    ((this.data[o] = u.blue),
                    (this.data[o + 1] = u.green),
                    (this.data[o + 2] = u.red),
                    (this.data[o + 3] = 255),
                    2 * i + 1 >= this.width)
                )
                    break;
                (u = this.palette[c]),
                    (this.data[o + 4] = u.blue),
                    (this.data[o + 4 + 1] = u.green),
                    (this.data[o + 4 + 2] = u.red),
                    (this.data[o + 4 + 3] = 255);
            }
            0 !== e && (this.pos += 4 - e);
        }
    }),
    (te.prototype.bit8 = function () {
        for (var t = this.width % 4, e = this.height - 1; e >= 0; e--) {
            for (
                var r = this.bottom_up ? e : this.height - 1 - e, n = 0;
                n < this.width;
                n++
            ) {
                var i = this.datav.getUint8(this.pos++, !0),
                    a = r * this.width * 4 + 4 * n;
                if (i < this.palette.length) {
                    var o = this.palette[i];
                    (this.data[a] = o.red),
                        (this.data[a + 1] = o.green),
                        (this.data[a + 2] = o.blue),
                        (this.data[a + 3] = 255);
                } else
                    (this.data[a] = 255),
                        (this.data[a + 1] = 255),
                        (this.data[a + 2] = 255),
                        (this.data[a + 3] = 255);
            }
            0 !== t && (this.pos += 4 - t);
        }
    }),
    (te.prototype.bit15 = function () {
        for (
            var t = this.width % 3,
                e = parseInt("11111", 2),
                r = this.height - 1;
            r >= 0;
            r--
        ) {
            for (
                var n = this.bottom_up ? r : this.height - 1 - r, i = 0;
                i < this.width;
                i++
            ) {
                var a = this.datav.getUint16(this.pos, !0);
                this.pos += 2;
                var o = (((a & e) / e) * 255) | 0,
                    s = ((((a >> 5) & e) / e) * 255) | 0,
                    c = ((((a >> 10) & e) / e) * 255) | 0,
                    u = a >> 15 ? 255 : 0,
                    h = n * this.width * 4 + 4 * i;
                (this.data[h] = c),
                    (this.data[h + 1] = s),
                    (this.data[h + 2] = o),
                    (this.data[h + 3] = u);
            }
            this.pos += t;
        }
    }),
    (te.prototype.bit16 = function () {
        for (
            var t = this.width % 3,
                e = parseInt("11111", 2),
                r = parseInt("111111", 2),
                n = this.height - 1;
            n >= 0;
            n--
        ) {
            for (
                var i = this.bottom_up ? n : this.height - 1 - n, a = 0;
                a < this.width;
                a++
            ) {
                var o = this.datav.getUint16(this.pos, !0);
                this.pos += 2;
                var s = (((o & e) / e) * 255) | 0,
                    c = ((((o >> 5) & r) / r) * 255) | 0,
                    u = (((o >> 11) / e) * 255) | 0,
                    h = i * this.width * 4 + 4 * a;
                (this.data[h] = u),
                    (this.data[h + 1] = c),
                    (this.data[h + 2] = s),
                    (this.data[h + 3] = 255);
            }
            this.pos += t;
        }
    }),
    (te.prototype.bit24 = function () {
        for (var t = this.height - 1; t >= 0; t--) {
            for (
                var e = this.bottom_up ? t : this.height - 1 - t, r = 0;
                r < this.width;
                r++
            ) {
                var n = this.datav.getUint8(this.pos++, !0),
                    i = this.datav.getUint8(this.pos++, !0),
                    a = this.datav.getUint8(this.pos++, !0),
                    o = e * this.width * 4 + 4 * r;
                (this.data[o] = a),
                    (this.data[o + 1] = i),
                    (this.data[o + 2] = n),
                    (this.data[o + 3] = 255);
            }
            this.pos += this.width % 4;
        }
    }),
    (te.prototype.bit32 = function () {
        for (var t = this.height - 1; t >= 0; t--)
            for (
                var e = this.bottom_up ? t : this.height - 1 - t, r = 0;
                r < this.width;
                r++
            ) {
                var n = this.datav.getUint8(this.pos++, !0),
                    i = this.datav.getUint8(this.pos++, !0),
                    a = this.datav.getUint8(this.pos++, !0),
                    o = this.datav.getUint8(this.pos++, !0),
                    s = e * this.width * 4 + 4 * r;
                (this.data[s] = a),
                    (this.data[s + 1] = i),
                    (this.data[s + 2] = n),
                    (this.data[s + 3] = o);
            }
    }),
    (te.prototype.getData = function () {
        return this.data;
    }),
    /**
     * @license
     * Copyright (c) 2018 Aras Abbasi
     *
     * Licensed under the MIT License.
     * http://opensource.org/licenses/mit-license
     */
    (function (t) {
        t.processBMP = function (e, r, n, i) {
            var a = new te(e, !1),
                o = a.width,
                s = a.height,
                c = {
                    data: a.getData(),
                    width: o,
                    height: s,
                },
                u = new Qt(100).encode(c, 100);
            return t.processJPEG.call(this, u, r, n, i);
        };
    })(E.API),
    (ee.prototype.getData = function () {
        return this.data;
    }),
    /**
     * @license
     * Copyright (c) 2019 Aras Abbasi
     *
     * Licensed under the MIT License.
     * http://opensource.org/licenses/mit-license
     */
    (function (t) {
        t.processWEBP = function (e, r, n, i) {
            var a = new ee(e),
                o = a.width,
                s = a.height,
                c = {
                    data: a.getData(),
                    width: o,
                    height: s,
                },
                u = new Qt(100).encode(c, 100);
            return t.processJPEG.call(this, u, r, n, i);
        };
    })(E.API),
    (E.API.processRGBA = function (t, e, r) {
        for (
            var n = t.data,
                i = n.length,
                a = new Uint8Array((i / 4) * 3),
                o = new Uint8Array(i / 4),
                s = 0,
                c = 0,
                u = 0;
            u < i;
            u += 4
        ) {
            var h = n[u],
                l = n[u + 1],
                f = n[u + 2],
                d = n[u + 3];
            (a[s++] = h), (a[s++] = l), (a[s++] = f), (o[c++] = d);
        }
        var p = this.__addimage__.arrayBufferToBinaryString(a);
        return {
            alpha: this.__addimage__.arrayBufferToBinaryString(o),
            data: p,
            index: e,
            alias: r,
            colorSpace: "DeviceRGB",
            bitsPerComponent: 8,
            width: t.width,
            height: t.height,
        };
    }),
    (E.API.setLanguage = function (t) {
        return (
            void 0 === this.internal.languageSettings &&
                ((this.internal.languageSettings = {}),
                (this.internal.languageSettings.isSubscribed = !1)),
            void 0 !==
                {
                    af: "Afrikaans",
                    sq: "Albanian",
                    ar: "Arabic (Standard)",
                    "ar-DZ": "Arabic (Algeria)",
                    "ar-BH": "Arabic (Bahrain)",
                    "ar-EG": "Arabic (Egypt)",
                    "ar-IQ": "Arabic (Iraq)",
                    "ar-JO": "Arabic (Jordan)",
                    "ar-KW": "Arabic (Kuwait)",
                    "ar-LB": "Arabic (Lebanon)",
                    "ar-LY": "Arabic (Libya)",
                    "ar-MA": "Arabic (Morocco)",
                    "ar-OM": "Arabic (Oman)",
                    "ar-QA": "Arabic (Qatar)",
                    "ar-SA": "Arabic (Saudi Arabia)",
                    "ar-SY": "Arabic (Syria)",
                    "ar-TN": "Arabic (Tunisia)",
                    "ar-AE": "Arabic (U.A.E.)",
                    "ar-YE": "Arabic (Yemen)",
                    an: "Aragonese",
                    hy: "Armenian",
                    as: "Assamese",
                    ast: "Asturian",
                    az: "Azerbaijani",
                    eu: "Basque",
                    be: "Belarusian",
                    bn: "Bengali",
                    bs: "Bosnian",
                    br: "Breton",
                    bg: "Bulgarian",
                    my: "Burmese",
                    ca: "Catalan",
                    ch: "Chamorro",
                    ce: "Chechen",
                    zh: "Chinese",
                    "zh-HK": "Chinese (Hong Kong)",
                    "zh-CN": "Chinese (PRC)",
                    "zh-SG": "Chinese (Singapore)",
                    "zh-TW": "Chinese (Taiwan)",
                    cv: "Chuvash",
                    co: "Corsican",
                    cr: "Cree",
                    hr: "Croatian",
                    cs: "Czech",
                    da: "Danish",
                    nl: "Dutch (Standard)",
                    "nl-BE": "Dutch (Belgian)",
                    en: "English",
                    "en-AU": "English (Australia)",
                    "en-BZ": "English (Belize)",
                    "en-CA": "English (Canada)",
                    "en-IE": "English (Ireland)",
                    "en-JM": "English (Jamaica)",
                    "en-NZ": "English (New Zealand)",
                    "en-PH": "English (Philippines)",
                    "en-ZA": "English (South Africa)",
                    "en-TT": "English (Trinidad & Tobago)",
                    "en-GB": "English (United Kingdom)",
                    "en-US": "English (United States)",
                    "en-ZW": "English (Zimbabwe)",
                    eo: "Esperanto",
                    et: "Estonian",
                    fo: "Faeroese",
                    fj: "Fijian",
                    fi: "Finnish",
                    fr: "French (Standard)",
                    "fr-BE": "French (Belgium)",
                    "fr-CA": "French (Canada)",
                    "fr-FR": "French (France)",
                    "fr-LU": "French (Luxembourg)",
                    "fr-MC": "French (Monaco)",
                    "fr-CH": "French (Switzerland)",
                    fy: "Frisian",
                    fur: "Friulian",
                    gd: "Gaelic (Scots)",
                    "gd-IE": "Gaelic (Irish)",
                    gl: "Galacian",
                    ka: "Georgian",
                    de: "German (Standard)",
                    "de-AT": "German (Austria)",
                    "de-DE": "German (Germany)",
                    "de-LI": "German (Liechtenstein)",
                    "de-LU": "German (Luxembourg)",
                    "de-CH": "German (Switzerland)",
                    el: "Greek",
                    gu: "Gujurati",
                    ht: "Haitian",
                    he: "Hebrew",
                    hi: "Hindi",
                    hu: "Hungarian",
                    is: "Icelandic",
                    id: "Indonesian",
                    iu: "Inuktitut",
                    ga: "Irish",
                    it: "Italian (Standard)",
                    "it-CH": "Italian (Switzerland)",
                    ja: "Japanese",
                    kn: "Kannada",
                    ks: "Kashmiri",
                    kk: "Kazakh",
                    km: "Khmer",
                    ky: "Kirghiz",
                    tlh: "Klingon",
                    ko: "Korean",
                    "ko-KP": "Korean (North Korea)",
                    "ko-KR": "Korean (South Korea)",
                    la: "Latin",
                    lv: "Latvian",
                    lt: "Lithuanian",
                    lb: "Luxembourgish",
                    mk: "North Macedonia",
                    ms: "Malay",
                    ml: "Malayalam",
                    mt: "Maltese",
                    mi: "Maori",
                    mr: "Marathi",
                    mo: "Moldavian",
                    nv: "Navajo",
                    ng: "Ndonga",
                    ne: "Nepali",
                    no: "Norwegian",
                    nb: "Norwegian (Bokmal)",
                    nn: "Norwegian (Nynorsk)",
                    oc: "Occitan",
                    or: "Oriya",
                    om: "Oromo",
                    fa: "Persian",
                    "fa-IR": "Persian/Iran",
                    pl: "Polish",
                    pt: "Portuguese",
                    "pt-BR": "Portuguese (Brazil)",
                    pa: "Punjabi",
                    "pa-IN": "Punjabi (India)",
                    "pa-PK": "Punjabi (Pakistan)",
                    qu: "Quechua",
                    rm: "Rhaeto-Romanic",
                    ro: "Romanian",
                    "ro-MO": "Romanian (Moldavia)",
                    ru: "Russian",
                    "ru-MO": "Russian (Moldavia)",
                    sz: "Sami (Lappish)",
                    sg: "Sango",
                    sa: "Sanskrit",
                    sc: "Sardinian",
                    sd: "Sindhi",
                    si: "Singhalese",
                    sr: "Serbian",
                    sk: "Slovak",
                    sl: "Slovenian",
                    so: "Somani",
                    sb: "Sorbian",
                    es: "Spanish",
                    "es-AR": "Spanish (Argentina)",
                    "es-BO": "Spanish (Bolivia)",
                    "es-CL": "Spanish (Chile)",
                    "es-CO": "Spanish (Colombia)",
                    "es-CR": "Spanish (Costa Rica)",
                    "es-DO": "Spanish (Dominican Republic)",
                    "es-EC": "Spanish (Ecuador)",
                    "es-SV": "Spanish (El Salvador)",
                    "es-GT": "Spanish (Guatemala)",
                    "es-HN": "Spanish (Honduras)",
                    "es-MX": "Spanish (Mexico)",
                    "es-NI": "Spanish (Nicaragua)",
                    "es-PA": "Spanish (Panama)",
                    "es-PY": "Spanish (Paraguay)",
                    "es-PE": "Spanish (Peru)",
                    "es-PR": "Spanish (Puerto Rico)",
                    "es-ES": "Spanish (Spain)",
                    "es-UY": "Spanish (Uruguay)",
                    "es-VE": "Spanish (Venezuela)",
                    sx: "Sutu",
                    sw: "Swahili",
                    sv: "Swedish",
                    "sv-FI": "Swedish (Finland)",
                    "sv-SV": "Swedish (Sweden)",
                    ta: "Tamil",
                    tt: "Tatar",
                    te: "Teluga",
                    th: "Thai",
                    tig: "Tigre",
                    ts: "Tsonga",
                    tn: "Tswana",
                    tr: "Turkish",
                    tk: "Turkmen",
                    uk: "Ukrainian",
                    hsb: "Upper Sorbian",
                    ur: "Urdu",
                    ve: "Venda",
                    vi: "Vietnamese",
                    vo: "Volapuk",
                    wa: "Walloon",
                    cy: "Welsh",
                    xh: "Xhosa",
                    ji: "Yiddish",
                    zu: "Zulu",
                }[t] &&
                ((this.internal.languageSettings.languageCode = t),
                !1 === this.internal.languageSettings.isSubscribed &&
                    (this.internal.events.subscribe("putCatalog", function () {
                        this.internal.write(
                            "/Lang (" +
                                this.internal.languageSettings.languageCode +
                                ")",
                        );
                    }),
                    (this.internal.languageSettings.isSubscribed = !0))),
            this
        );
    }),
    (Vt = E.API),
    (Gt = Vt.getCharWidthsArray =
        function (e, r) {
            var n,
                i,
                a = (r = r || {}).font || this.internal.getFont(),
                o = r.fontSize || this.internal.getFontSize(),
                s = r.charSpace || this.internal.getCharSpace(),
                c = r.widths ? r.widths : a.metadata.Unicode.widths,
                u = c.fof ? c.fof : 1,
                h = r.kerning ? r.kerning : a.metadata.Unicode.kerning,
                l = h.fof ? h.fof : 1,
                f = !1 !== r.doKerning,
                d = 0,
                p = e.length,
                g = 0,
                m = c[0] || u,
                v = [];
            for (n = 0; n < p; n++)
                (i = e.charCodeAt(n)),
                    "function" == typeof a.metadata.widthOfString
                        ? v.push(
                              (a.metadata.widthOfGlyph(
                                  a.metadata.characterToGlyph(i),
                              ) +
                                  s * (1e3 / o) || 0) / 1e3,
                          )
                        : ((d =
                              f &&
                              "object" === _typeof(h[i]) &&
                              !isNaN(parseInt(h[i][g], 10))
                                  ? h[i][g] / l
                                  : 0),
                          v.push((c[i] || m) / u + d)),
                    (g = i);
            return v;
        }),
    (Yt = Vt.getStringUnitWidth =
        function (t, e) {
            var r = (e = e || {}).fontSize || this.internal.getFontSize(),
                n = e.font || this.internal.getFont(),
                i = e.charSpace || this.internal.getCharSpace();
            return (
                Vt.processArabic && (t = Vt.processArabic(t)),
                "function" == typeof n.metadata.widthOfString
                    ? n.metadata.widthOfString(t, r, i) / r
                    : Gt.apply(this, arguments).reduce(function (t, e) {
                          return t + e;
                      }, 0)
            );
        }),
    (Jt = function (t, e, r, n) {
        for (var i = [], a = 0, o = t.length, s = 0; a !== o && s + e[a] < r; )
            (s += e[a]), a++;
        i.push(t.slice(0, a));
        var c = a;
        for (s = 0; a !== o; )
            s + e[a] > n && (i.push(t.slice(c, a)), (s = 0), (c = a)),
                (s += e[a]),
                a++;
        return c !== a && i.push(t.slice(c, a)), i;
    }),
    (Xt = function (t, e, r) {
        r || (r = {});
        var n,
            i,
            a,
            o,
            s,
            c,
            u,
            h = [],
            l = [h],
            f = r.textIndent || 0,
            d = 0,
            p = 0,
            g = t.split(" "),
            m = Gt.apply(this, [" ", r])[0];
        if ((c = -1 === r.lineIndent ? g[0].length + 2 : r.lineIndent || 0)) {
            var v = Array(c).join(" "),
                b = [];
            g.map(function (t) {
                (t = t.split(/\s*\n/)).length > 1
                    ? (b = b.concat(
                          t.map(function (t, e) {
                              return (e && t.length ? "\n" : "") + t;
                          }),
                      ))
                    : b.push(t[0]);
            }),
                (g = b),
                (c = Yt.apply(this, [v, r]));
        }
        for (a = 0, o = g.length; a < o; a++) {
            var y = 0;
            if (
                ((n = g[a]),
                c && "\n" == n[0] && ((n = n.substr(1)), (y = 1)),
                f +
                    d +
                    (p = (i = Gt.apply(this, [n, r])).reduce(function (t, e) {
                        return t + e;
                    }, 0)) >
                    e || y)
            ) {
                if (p > e) {
                    for (
                        s = Jt.apply(this, [n, i, e - (f + d), e]),
                            h.push(s.shift()),
                            h = [s.pop()];
                        s.length;

                    )
                        l.push([s.shift()]);
                    p = i
                        .slice(n.length - (h[0] ? h[0].length : 0))
                        .reduce(function (t, e) {
                            return t + e;
                        }, 0);
                } else h = [n];
                l.push(h), (f = p + c), (d = m);
            } else h.push(n), (f += d + p), (d = m);
        }
        return (
            (u = c
                ? function (t, e) {
                      return (e ? v : "") + t.join(" ");
                  }
                : function (t) {
                      return t.join(" ");
                  }),
            l.map(u)
        );
    }),
    (Vt.splitTextToSize = function (t, e, r) {
        var n,
            i = (r = r || {}).fontSize || this.internal.getFontSize(),
            a = function (t) {
                if (t.widths && t.kerning)
                    return {
                        widths: t.widths,
                        kerning: t.kerning,
                    };
                var e = this.internal.getFont(t.fontName, t.fontStyle);
                return e.metadata.Unicode
                    ? {
                          widths: e.metadata.Unicode.widths || {
                              0: 1,
                          },
                          kerning: e.metadata.Unicode.kerning || {},
                      }
                    : {
                          font: e.metadata,
                          fontSize: this.internal.getFontSize(),
                          charSpace: this.internal.getCharSpace(),
                      };
            }.call(this, r);
        n = Array.isArray(t) ? t : String(t).split(/\r?\n/);
        var o = (1 * this.internal.scaleFactor * e) / i;
        (a.textIndent = r.textIndent
            ? (1 * r.textIndent * this.internal.scaleFactor) / i
            : 0),
            (a.lineIndent = r.lineIndent);
        var s,
            c,
            u = [];
        for (s = 0, c = n.length; s < c; s++)
            u = u.concat(Xt.apply(this, [n[s], o, a]));
        return u;
    }),
    (function (e) {
        e.__fontmetrics__ = e.__fontmetrics__ || {};
        for (
            var r = "klmnopqrstuvwxyz", n = {}, i = {}, a = 0;
            a < r.length;
            a++
        )
            (n[r[a]] = "0123456789abcdef"[a]),
                (i["0123456789abcdef"[a]] = r[a]);
        var o = function (t) {
                return "0x" + parseInt(t, 10).toString(16);
            },
            s = (e.__fontmetrics__.compress = function (e) {
                var r,
                    n,
                    a,
                    c,
                    u = ["{"];
                for (var h in e) {
                    if (
                        ((r = e[h]),
                        isNaN(parseInt(h, 10))
                            ? (n = "'" + h + "'")
                            : ((h = parseInt(h, 10)),
                              (n =
                                  (n = o(h).slice(2)).slice(0, -1) +
                                  i[n.slice(-1)])),
                        "number" == typeof r)
                    )
                        r < 0
                            ? ((a = o(r).slice(3)), (c = "-"))
                            : ((a = o(r).slice(2)), (c = "")),
                            (a = c + a.slice(0, -1) + i[a.slice(-1)]);
                    else {
                        if ("object" !== _typeof(r))
                            throw new Error(
                                "Don't know what to do with value type " +
                                    _typeof(r) +
                                    ".",
                            );
                        a = s(r);
                    }
                    u.push(n + a);
                }
                return u.push("}"), u.join("");
            }),
            c = (e.__fontmetrics__.uncompress = function (t) {
                if ("string" != typeof t)
                    throw new Error("Invalid argument passed to uncompress.");
                for (
                    var e,
                        r,
                        i,
                        a,
                        o = {},
                        s = 1,
                        c = o,
                        u = [],
                        h = "",
                        l = "",
                        f = t.length - 1,
                        d = 1;
                    d < f;
                    d += 1
                )
                    "'" == (a = t[d])
                        ? e
                            ? ((i = e.join("")), (e = void 0))
                            : (e = [])
                        : e
                          ? e.push(a)
                          : "{" == a
                            ? (u.push([c, i]), (c = {}), (i = void 0))
                            : "}" == a
                              ? (((r = u.pop())[0][r[1]] = c),
                                (i = void 0),
                                (c = r[0]))
                              : "-" == a
                                ? (s = -1)
                                : void 0 === i
                                  ? n.hasOwnProperty(a)
                                      ? ((h += n[a]),
                                        (i = parseInt(h, 16) * s),
                                        (s = 1),
                                        (h = ""))
                                      : (h += a)
                                  : n.hasOwnProperty(a)
                                    ? ((l += n[a]),
                                      (c[i] = parseInt(l, 16) * s),
                                      (s = 1),
                                      (i = void 0),
                                      (l = ""))
                                    : (l += a);
                return o;
            }),
            u = {
                codePages: ["WinAnsiEncoding"],
                WinAnsiEncoding: c(
                    "{19m8n201n9q201o9r201s9l201t9m201u8m201w9n201x9o201y8o202k8q202l8r202m9p202q8p20aw8k203k8t203t8v203u9v2cq8s212m9t15m8w15n9w2dw9s16k8u16l9u17s9z17x8y17y9y}",
                ),
            },
            h = {
                Unicode: {
                    Courier: u,
                    "Courier-Bold": u,
                    "Courier-BoldOblique": u,
                    "Courier-Oblique": u,
                    Helvetica: u,
                    "Helvetica-Bold": u,
                    "Helvetica-BoldOblique": u,
                    "Helvetica-Oblique": u,
                    "Times-Roman": u,
                    "Times-Bold": u,
                    "Times-BoldItalic": u,
                    "Times-Italic": u,
                },
            },
            l = {
                Unicode: {
                    "Courier-Oblique": c(
                        "{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}",
                    ),
                    "Times-BoldItalic": c(
                        "{'widths'{k3o2q4ycx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2r202m2n2n3m2o3m2p5n202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5n4l4m4m4m4n4m4o4s4p4m4q4m4r4s4s4y4t2r4u3m4v4m4w3x4x5t4y4s4z4s5k3x5l4s5m4m5n3r5o3x5p4s5q4m5r5t5s4m5t3x5u3x5v2l5w1w5x2l5y3t5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q2l6r3m6s3r6t1w6u1w6v3m6w1w6x4y6y3r6z3m7k3m7l3m7m2r7n2r7o1w7p3r7q2w7r4m7s3m7t2w7u2r7v2n7w1q7x2n7y3t202l3mcl4mal2ram3man3mao3map3mar3mas2lat4uau1uav3maw3way4uaz2lbk2sbl3t'fof'6obo2lbp3tbq3mbr1tbs2lbu1ybv3mbz3mck4m202k3mcm4mcn4mco4mcp4mcq5ycr4mcs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz2w203k6o212m6o2dw2l2cq2l3t3m3u2l17s3x19m3m}'kerning'{cl{4qu5kt5qt5rs17ss5ts}201s{201ss}201t{cks4lscmscnscoscpscls2wu2yu201ts}201x{2wu2yu}2k{201ts}2w{4qx5kx5ou5qx5rs17su5tu}2x{17su5tu5ou}2y{4qx5kx5ou5qx5rs17ss5ts}'fof'-6ofn{17sw5tw5ou5qw5rs}7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qs}3v{17su5tu5os5qs}7p{17su5tu}ck{4qu5kt5qt5rs17ss5ts}4l{4qu5kt5qt5rs17ss5ts}cm{4qu5kt5qt5rs17ss5ts}cn{4qu5kt5qt5rs17ss5ts}co{4qu5kt5qt5rs17ss5ts}cp{4qu5kt5qt5rs17ss5ts}6l{4qu5ou5qw5rt17su5tu}5q{ckuclucmucnucoucpu4lu}5r{ckuclucmucnucoucpu4lu}7q{cksclscmscnscoscps4ls}6p{4qu5ou5qw5rt17sw5tw}ek{4qu5ou5qw5rt17su5tu}el{4qu5ou5qw5rt17su5tu}em{4qu5ou5qw5rt17su5tu}en{4qu5ou5qw5rt17su5tu}eo{4qu5ou5qw5rt17su5tu}ep{4qu5ou5qw5rt17su5tu}es{17ss5ts5qs4qu}et{4qu5ou5qw5rt17sw5tw}eu{4qu5ou5qw5rt17ss5ts}ev{17ss5ts5qs4qu}6z{17sw5tw5ou5qw5rs}fm{17sw5tw5ou5qw5rs}7n{201ts}fo{17sw5tw5ou5qw5rs}fp{17sw5tw5ou5qw5rs}fq{17sw5tw5ou5qw5rs}7r{cksclscmscnscoscps4ls}fs{17sw5tw5ou5qw5rs}ft{17su5tu}fu{17su5tu}fv{17su5tu}fw{17su5tu}fz{cksclscmscnscoscps4ls}}}",
                    ),
                    "Helvetica-Bold": c(
                        "{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}",
                    ),
                    Courier: c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
                    "Courier-BoldOblique": c(
                        "{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}",
                    ),
                    "Times-Bold": c(
                        "{'widths'{k3q2q5ncx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2l202m2n2n3m2o3m2p6o202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5x4l4s4m4m4n4s4o4s4p4m4q3x4r4y4s4y4t2r4u3m4v4y4w4m4x5y4y4s4z4y5k3x5l4y5m4s5n3r5o4m5p4s5q4s5r6o5s4s5t4s5u4m5v2l5w1w5x2l5y3u5z3m6k2l6l3m6m3r6n2w6o3r6p2w6q2l6r3m6s3r6t1w6u2l6v3r6w1w6x5n6y3r6z3m7k3r7l3r7m2w7n2r7o2l7p3r7q3m7r4s7s3m7t3m7u2w7v2r7w1q7x2r7y3o202l3mcl4sal2lam3man3mao3map3mar3mas2lat4uau1yav3maw3tay4uaz2lbk2sbl3t'fof'6obo2lbp3rbr1tbs2lbu2lbv3mbz3mck4s202k3mcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3rek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3m3u2l17s4s19m3m}'kerning'{cl{4qt5ks5ot5qy5rw17sv5tv}201t{cks4lscmscnscoscpscls4wv}2k{201ts}2w{4qu5ku7mu5os5qx5ru17su5tu}2x{17su5tu5ou5qs}2y{4qv5kv7mu5ot5qz5ru17su5tu}'fof'-6o7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qu}3v{17su5tu5os5qu}fu{17su5tu5ou5qu}7p{17su5tu5ou5qu}ck{4qt5ks5ot5qy5rw17sv5tv}4l{4qt5ks5ot5qy5rw17sv5tv}cm{4qt5ks5ot5qy5rw17sv5tv}cn{4qt5ks5ot5qy5rw17sv5tv}co{4qt5ks5ot5qy5rw17sv5tv}cp{4qt5ks5ot5qy5rw17sv5tv}6l{17st5tt5ou5qu}17s{ckuclucmucnucoucpu4lu4wu}5o{ckuclucmucnucoucpu4lu4wu}5q{ckzclzcmzcnzcozcpz4lz4wu}5r{ckxclxcmxcnxcoxcpx4lx4wu}5t{ckuclucmucnucoucpu4lu4wu}7q{ckuclucmucnucoucpu4lu}6p{17sw5tw5ou5qu}ek{17st5tt5qu}el{17st5tt5ou5qu}em{17st5tt5qu}en{17st5tt5qu}eo{17st5tt5qu}ep{17st5tt5ou5qu}es{17ss5ts5qu}et{17sw5tw5ou5qu}eu{17sw5tw5ou5qu}ev{17ss5ts5qu}6z{17sw5tw5ou5qu5rs}fm{17sw5tw5ou5qu5rs}fn{17sw5tw5ou5qu5rs}fo{17sw5tw5ou5qu5rs}fp{17sw5tw5ou5qu5rs}fq{17sw5tw5ou5qu5rs}7r{cktcltcmtcntcotcpt4lt5os}fs{17sw5tw5ou5qu5rs}ft{17su5tu5ou5qu}7m{5os}fv{17su5tu5ou5qu}fw{17su5tu5ou5qu}fz{cksclscmscnscoscps4ls}}}",
                    ),
                    Symbol: c(
                        "{'widths'{k3uaw4r19m3m2k1t2l2l202m2y2n3m2p5n202q6o3k3m2s2l2t2l2v3r2w1t3m3m2y1t2z1wbk2sbl3r'fof'6o3n3m3o3m3p3m3q3m3r3m3s3m3t3m3u1w3v1w3w3r3x3r3y3r3z2wbp3t3l3m5v2l5x2l5z3m2q4yfr3r7v3k7w1o7x3k}'kerning'{'fof'-6o}}",
                    ),
                    Helvetica: c(
                        "{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}",
                    ),
                    "Helvetica-BoldOblique": c(
                        "{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}",
                    ),
                    ZapfDingbats: c(
                        "{'widths'{k4u2k1w'fof'6o}'kerning'{'fof'-6o}}",
                    ),
                    "Courier-Bold": c(
                        "{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}",
                    ),
                    "Times-Italic": c(
                        "{'widths'{k3n2q4ycx2l201n3m201o5t201s2l201t2l201u2l201w3r201x3r201y3r2k1t2l2l202m2n2n3m2o3m2p5n202q5t2r1p2s2l2t2l2u3m2v4n2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w4n3x4n3y4n3z3m4k5w4l3x4m3x4n4m4o4s4p3x4q3x4r4s4s4s4t2l4u2w4v4m4w3r4x5n4y4m4z4s5k3x5l4s5m3x5n3m5o3r5p4s5q3x5r5n5s3x5t3r5u3r5v2r5w1w5x2r5y2u5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q1w6r3m6s3m6t1w6u1w6v2w6w1w6x4s6y3m6z3m7k3m7l3m7m2r7n2r7o1w7p3m7q2w7r4m7s2w7t2w7u2r7v2s7w1v7x2s7y3q202l3mcl3xal2ram3man3mao3map3mar3mas2lat4wau1vav3maw4nay4waz2lbk2sbl4n'fof'6obo2lbp3mbq3obr1tbs2lbu1zbv3mbz3mck3x202k3mcm3xcn3xco3xcp3xcq5tcr4mcs3xct3xcu3xcv3xcw2l2m2ucy2lcz2ldl4mdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr4nfs3mft3mfu3mfv3mfw3mfz2w203k6o212m6m2dw2l2cq2l3t3m3u2l17s3r19m3m}'kerning'{cl{5kt4qw}201s{201sw}201t{201tw2wy2yy6q-t}201x{2wy2yy}2k{201tw}2w{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}2x{17ss5ts5os}2y{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}'fof'-6o6t{17ss5ts5qs}7t{5os}3v{5qs}7p{17su5tu5qs}ck{5kt4qw}4l{5kt4qw}cm{5kt4qw}cn{5kt4qw}co{5kt4qw}cp{5kt4qw}6l{4qs5ks5ou5qw5ru17su5tu}17s{2ks}5q{ckvclvcmvcnvcovcpv4lv}5r{ckuclucmucnucoucpu4lu}5t{2ks}6p{4qs5ks5ou5qw5ru17su5tu}ek{4qs5ks5ou5qw5ru17su5tu}el{4qs5ks5ou5qw5ru17su5tu}em{4qs5ks5ou5qw5ru17su5tu}en{4qs5ks5ou5qw5ru17su5tu}eo{4qs5ks5ou5qw5ru17su5tu}ep{4qs5ks5ou5qw5ru17su5tu}es{5ks5qs4qs}et{4qs5ks5ou5qw5ru17su5tu}eu{4qs5ks5qw5ru17su5tu}ev{5ks5qs4qs}ex{17ss5ts5qs}6z{4qv5ks5ou5qw5ru17su5tu}fm{4qv5ks5ou5qw5ru17su5tu}fn{4qv5ks5ou5qw5ru17su5tu}fo{4qv5ks5ou5qw5ru17su5tu}fp{4qv5ks5ou5qw5ru17su5tu}fq{4qv5ks5ou5qw5ru17su5tu}7r{5os}fs{4qv5ks5ou5qw5ru17su5tu}ft{17su5tu5qs}fu{17su5tu5qs}fv{17su5tu5qs}fw{17su5tu5qs}}}",
                    ),
                    "Times-Roman": c(
                        "{'widths'{k3n2q4ycx2l201n3m201o6o201s2l201t2l201u2l201w2w201x2w201y2w2k1t2l2l202m2n2n3m2o3m2p5n202q6o2r1m2s2l2t2l2u3m2v3s2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v1w3w3s3x3s3y3s3z2w4k5w4l4s4m4m4n4m4o4s4p3x4q3r4r4s4s4s4t2l4u2r4v4s4w3x4x5t4y4s4z4s5k3r5l4s5m4m5n3r5o3x5p4s5q4s5r5y5s4s5t4s5u3x5v2l5w1w5x2l5y2z5z3m6k2l6l2w6m3m6n2w6o3m6p2w6q2l6r3m6s3m6t1w6u1w6v3m6w1w6x4y6y3m6z3m7k3m7l3m7m2l7n2r7o1w7p3m7q3m7r4s7s3m7t3m7u2w7v3k7w1o7x3k7y3q202l3mcl4sal2lam3man3mao3map3mar3mas2lat4wau1vav3maw3say4waz2lbk2sbl3s'fof'6obo2lbp3mbq2xbr1tbs2lbu1zbv3mbz2wck4s202k3mcm4scn4sco4scp4scq5tcr4mcs3xct3xcu3xcv3xcw2l2m2tcy2lcz2ldl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek2wel2wem2wen2weo2wep2weq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr3sfs3mft3mfu3mfv3mfw3mfz3m203k6o212m6m2dw2l2cq2l3t3m3u1w17s4s19m3m}'kerning'{cl{4qs5ku17sw5ou5qy5rw201ss5tw201ws}201s{201ss}201t{ckw4lwcmwcnwcowcpwclw4wu201ts}2k{201ts}2w{4qs5kw5os5qx5ru17sx5tx}2x{17sw5tw5ou5qu}2y{4qs5kw5os5qx5ru17sx5tx}'fof'-6o7t{ckuclucmucnucoucpu4lu5os5rs}3u{17su5tu5qs}3v{17su5tu5qs}7p{17sw5tw5qs}ck{4qs5ku17sw5ou5qy5rw201ss5tw201ws}4l{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cm{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cn{4qs5ku17sw5ou5qy5rw201ss5tw201ws}co{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cp{4qs5ku17sw5ou5qy5rw201ss5tw201ws}6l{17su5tu5os5qw5rs}17s{2ktclvcmvcnvcovcpv4lv4wuckv}5o{ckwclwcmwcnwcowcpw4lw4wu}5q{ckyclycmycnycoycpy4ly4wu5ms}5r{cktcltcmtcntcotcpt4lt4ws}5t{2ktclvcmvcnvcovcpv4lv4wuckv}7q{cksclscmscnscoscps4ls}6p{17su5tu5qw5rs}ek{5qs5rs}el{17su5tu5os5qw5rs}em{17su5tu5os5qs5rs}en{17su5qs5rs}eo{5qs5rs}ep{17su5tu5os5qw5rs}es{5qs}et{17su5tu5qw5rs}eu{17su5tu5qs5rs}ev{5qs}6z{17sv5tv5os5qx5rs}fm{5os5qt5rs}fn{17sv5tv5os5qx5rs}fo{17sv5tv5os5qx5rs}fp{5os5qt5rs}fq{5os5qt5rs}7r{ckuclucmucnucoucpu4lu5os}fs{17sv5tv5os5qx5rs}ft{17ss5ts5qs}fu{17sw5tw5qs}fv{17sw5tw5qs}fw{17ss5ts5qs}fz{ckuclucmucnucoucpu4lu5os5rs}}}",
                    ),
                    "Helvetica-Oblique": c(
                        "{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}",
                    ),
                },
            };
        e.events.push([
            "addFont",
            function (t) {
                var e = t.font,
                    r = l.Unicode[e.postScriptName];
                r &&
                    ((e.metadata.Unicode = {}),
                    (e.metadata.Unicode.widths = r.widths),
                    (e.metadata.Unicode.kerning = r.kerning));
                var n = h.Unicode[e.postScriptName];
                n &&
                    ((e.metadata.Unicode.encoding = n),
                    (e.encoding = n.codePages[0]));
            },
        ]);
    })(E.API),
    /**
     * @license
     * Licensed under the MIT License.
     * http://opensource.org/licenses/mit-license
     */
    (function (t) {
        var e = function (t) {
            for (var e = t.length, r = new Uint8Array(e), n = 0; n < e; n++)
                r[n] = t.charCodeAt(n);
            return r;
        };
        t.API.events.push([
            "addFont",
            function (r) {
                var n = void 0,
                    i = r.font,
                    a = r.instance;
                if (!i.isStandardFont) {
                    if (void 0 === a)
                        throw new Error(
                            "Font does not exist in vFS, import fonts or remove declaration doc.addFont('" +
                                i.postScriptName +
                                "').",
                        );
                    if (
                        "string" !=
                        typeof (n =
                            !1 === a.existsFileInVFS(i.postScriptName)
                                ? a.loadFile(i.postScriptName)
                                : a.getFileFromVFS(i.postScriptName))
                    )
                        throw new Error(
                            "Font is not stored as string-data in vFS, import fonts or remove declaration doc.addFont('" +
                                i.postScriptName +
                                "').",
                        );
                    !(function (r, n) {
                        (n = /^\x00\x01\x00\x00/.test(n) ? e(n) : e(u(n))),
                            (r.metadata = t.API.TTFFont.open(n)),
                            (r.metadata.Unicode = r.metadata.Unicode || {
                                encoding: {},
                                kerning: {},
                                widths: [],
                            }),
                            (r.metadata.glyIdsUsed = [0]);
                    })(i, n);
                }
            },
        ]);
    })(E),
    /** @license
     * Copyright (c) 2012 Willow Systems Corporation, https://github.com/willowsystems
     *
     * Permission is hereby granted, free of charge, to any person obtaining
     * a copy of this software and associated documentation files (the
     * "Software"), to deal in the Software without restriction, including
     * without limitation the rights to use, copy, modify, merge, publish,
     * distribute, sublicense, and/or sell copies of the Software, and to
     * permit persons to whom the Software is furnished to do so, subject to
     * the following conditions:
     *
     * The above copyright notice and this permission notice shall be
     * included in all copies or substantial portions of the Software.
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
     * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
     * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
     * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
     * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
     * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
     * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
     * ====================================================================
     */
    (function (t) {
        function e() {
            return (
                n.canvg
                    ? Promise.resolve(n.canvg)
                    : import("./index.es-63264c2d.js")
            )
                .catch(function (t) {
                    return Promise.reject(
                        new Error("Could not load canvg: " + t),
                    );
                })
                .then(function (t) {
                    return t.default ? t.default : t;
                });
        }
        E.API.addSvgAsImage = function (t, r, n, i, o, s, c, u) {
            if (isNaN(r) || isNaN(n))
                throw (
                    (a.error(
                        "jsPDF.addSvgAsImage: Invalid coordinates",
                        arguments,
                    ),
                    new Error(
                        "Invalid coordinates passed to jsPDF.addSvgAsImage",
                    ))
                );
            if (isNaN(i) || isNaN(o))
                throw (
                    (a.error(
                        "jsPDF.addSvgAsImage: Invalid measurements",
                        arguments,
                    ),
                    new Error(
                        "Invalid measurements (width and/or height) passed to jsPDF.addSvgAsImage",
                    ))
                );
            var h = document.createElement("canvas");
            (h.width = i), (h.height = o);
            var l = h.getContext("2d");
            (l.fillStyle = "#fff"), l.fillRect(0, 0, h.width, h.height);
            var f = {
                    ignoreMouse: !0,
                    ignoreAnimation: !0,
                    ignoreDimensions: !0,
                },
                d = this;
            return e()
                .then(
                    function (e) {
                        return e.fromString(l, t, f);
                    },
                    function () {
                        return Promise.reject(
                            new Error("Could not load canvg."),
                        );
                    },
                )
                .then(function (t) {
                    return t.render(f);
                })
                .then(function () {
                    d.addImage(h.toDataURL("image/jpeg", 1), r, n, i, o, c, u);
                });
        };
    })(),
    (E.API.putTotalPages = function (t) {
        var e,
            r = 0;
        parseInt(this.internal.getFont().id.substr(1), 10) < 15
            ? ((e = new RegExp(t, "g")), (r = this.internal.getNumberOfPages()))
            : ((e = new RegExp(
                  this.pdfEscape16(t, this.internal.getFont()),
                  "g",
              )),
              (r = this.pdfEscape16(
                  this.internal.getNumberOfPages() + "",
                  this.internal.getFont(),
              )));
        for (var n = 1; n <= this.internal.getNumberOfPages(); n++)
            for (var i = 0; i < this.internal.pages[n].length; i++)
                this.internal.pages[n][i] = this.internal.pages[n][i].replace(
                    e,
                    r,
                );
        return this;
    }),
    (E.API.viewerPreferences = function (e, r) {
        var n;
        (e = e || {}), (r = r || !1);
        var i,
            a,
            o,
            s = {
                HideToolbar: {
                    defaultValue: !1,
                    value: !1,
                    type: "boolean",
                    explicitSet: !1,
                    valueSet: [!0, !1],
                    pdfVersion: 1.3,
                },
                HideMenubar: {
                    defaultValue: !1,
                    value: !1,
                    type: "boolean",
                    explicitSet: !1,
                    valueSet: [!0, !1],
                    pdfVersion: 1.3,
                },
                HideWindowUI: {
                    defaultValue: !1,
                    value: !1,
                    type: "boolean",
                    explicitSet: !1,
                    valueSet: [!0, !1],
                    pdfVersion: 1.3,
                },
                FitWindow: {
                    defaultValue: !1,
                    value: !1,
                    type: "boolean",
                    explicitSet: !1,
                    valueSet: [!0, !1],
                    pdfVersion: 1.3,
                },
                CenterWindow: {
                    defaultValue: !1,
                    value: !1,
                    type: "boolean",
                    explicitSet: !1,
                    valueSet: [!0, !1],
                    pdfVersion: 1.3,
                },
                DisplayDocTitle: {
                    defaultValue: !1,
                    value: !1,
                    type: "boolean",
                    explicitSet: !1,
                    valueSet: [!0, !1],
                    pdfVersion: 1.4,
                },
                NonFullScreenPageMode: {
                    defaultValue: "UseNone",
                    value: "UseNone",
                    type: "name",
                    explicitSet: !1,
                    valueSet: ["UseNone", "UseOutlines", "UseThumbs", "UseOC"],
                    pdfVersion: 1.3,
                },
                Direction: {
                    defaultValue: "L2R",
                    value: "L2R",
                    type: "name",
                    explicitSet: !1,
                    valueSet: ["L2R", "R2L"],
                    pdfVersion: 1.3,
                },
                ViewArea: {
                    defaultValue: "CropBox",
                    value: "CropBox",
                    type: "name",
                    explicitSet: !1,
                    valueSet: [
                        "MediaBox",
                        "CropBox",
                        "TrimBox",
                        "BleedBox",
                        "ArtBox",
                    ],
                    pdfVersion: 1.4,
                },
                ViewClip: {
                    defaultValue: "CropBox",
                    value: "CropBox",
                    type: "name",
                    explicitSet: !1,
                    valueSet: [
                        "MediaBox",
                        "CropBox",
                        "TrimBox",
                        "BleedBox",
                        "ArtBox",
                    ],
                    pdfVersion: 1.4,
                },
                PrintArea: {
                    defaultValue: "CropBox",
                    value: "CropBox",
                    type: "name",
                    explicitSet: !1,
                    valueSet: [
                        "MediaBox",
                        "CropBox",
                        "TrimBox",
                        "BleedBox",
                        "ArtBox",
                    ],
                    pdfVersion: 1.4,
                },
                PrintClip: {
                    defaultValue: "CropBox",
                    value: "CropBox",
                    type: "name",
                    explicitSet: !1,
                    valueSet: [
                        "MediaBox",
                        "CropBox",
                        "TrimBox",
                        "BleedBox",
                        "ArtBox",
                    ],
                    pdfVersion: 1.4,
                },
                PrintScaling: {
                    defaultValue: "AppDefault",
                    value: "AppDefault",
                    type: "name",
                    explicitSet: !1,
                    valueSet: ["AppDefault", "None"],
                    pdfVersion: 1.6,
                },
                Duplex: {
                    defaultValue: "",
                    value: "none",
                    type: "name",
                    explicitSet: !1,
                    valueSet: [
                        "Simplex",
                        "DuplexFlipShortEdge",
                        "DuplexFlipLongEdge",
                        "none",
                    ],
                    pdfVersion: 1.7,
                },
                PickTrayByPDFSize: {
                    defaultValue: !1,
                    value: !1,
                    type: "boolean",
                    explicitSet: !1,
                    valueSet: [!0, !1],
                    pdfVersion: 1.7,
                },
                PrintPageRange: {
                    defaultValue: "",
                    value: "",
                    type: "array",
                    explicitSet: !1,
                    valueSet: null,
                    pdfVersion: 1.7,
                },
                NumCopies: {
                    defaultValue: 1,
                    value: 1,
                    type: "integer",
                    explicitSet: !1,
                    valueSet: null,
                    pdfVersion: 1.7,
                },
            },
            c = Object.keys(s),
            u = [],
            h = 0,
            l = 0,
            f = 0;
        function d(t, e) {
            var r,
                n = !1;
            for (r = 0; r < t.length; r += 1) t[r] === e && (n = !0);
            return n;
        }
        if (
            (void 0 === this.internal.viewerpreferences &&
                ((this.internal.viewerpreferences = {}),
                (this.internal.viewerpreferences.configuration = JSON.parse(
                    JSON.stringify(s),
                )),
                (this.internal.viewerpreferences.isSubscribed = !1)),
            (n = this.internal.viewerpreferences.configuration),
            "reset" === e || !0 === r)
        ) {
            var p = c.length;
            for (f = 0; f < p; f += 1)
                (n[c[f]].value = n[c[f]].defaultValue),
                    (n[c[f]].explicitSet = !1);
        }
        if ("object" === _typeof(e))
            for (a in e)
                if (((o = e[a]), d(c, a) && void 0 !== o)) {
                    if ("boolean" === n[a].type && "boolean" == typeof o)
                        n[a].value = o;
                    else if ("name" === n[a].type && d(n[a].valueSet, o))
                        n[a].value = o;
                    else if ("integer" === n[a].type && Number.isInteger(o))
                        n[a].value = o;
                    else if ("array" === n[a].type) {
                        for (h = 0; h < o.length; h += 1)
                            if (
                                ((i = !0),
                                1 === o[h].length && "number" == typeof o[h][0])
                            )
                                u.push(String(o[h] - 1));
                            else if (o[h].length > 1) {
                                for (l = 0; l < o[h].length; l += 1)
                                    "number" != typeof o[h][l] && (i = !1);
                                !0 === i &&
                                    u.push(
                                        [o[h][0] - 1, o[h][1] - 1].join(" "),
                                    );
                            }
                        n[a].value = "[" + u.join(" ") + "]";
                    } else n[a].value = n[a].defaultValue;
                    n[a].explicitSet = !0;
                }
        return (
            !1 === this.internal.viewerpreferences.isSubscribed &&
                (this.internal.events.subscribe("putCatalog", function () {
                    var t,
                        e = [];
                    for (t in n)
                        !0 === n[t].explicitSet &&
                            ("name" === n[t].type
                                ? e.push("/" + t + " /" + n[t].value)
                                : e.push("/" + t + " " + n[t].value));
                    0 !== e.length &&
                        this.internal.write(
                            "/ViewerPreferences\n<<\n" + e.join("\n") + "\n>>",
                        );
                }),
                (this.internal.viewerpreferences.isSubscribed = !0)),
            (this.internal.viewerpreferences.configuration = n),
            this
        );
    }),
    /** ====================================================================
     * @license
     * jsPDF XMP metadata plugin
     * Copyright (c) 2016 Jussi Utunen, u-jussi@suomi24.fi
     *
     * Permission is hereby granted, free of charge, to any person obtaining
     * a copy of this software and associated documentation files (the
     * "Software"), to deal in the Software without restriction, including
     * without limitation the rights to use, copy, modify, merge, publish,
     * distribute, sublicense, and/or sell copies of the Software, and to
     * permit persons to whom the Software is furnished to do so, subject to
     * the following conditions:
     *
     * The above copyright notice and this permission notice shall be
     * included in all copies or substantial portions of the Software.
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
     * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
     * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
     * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
     * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
     * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
     * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
     * ====================================================================
     */
    (function (t) {
        var e = function () {
                var t =
                        '<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><rdf:Description rdf:about="" xmlns:jspdf="' +
                        this.internal.__metadata__.namespaceuri +
                        '"><jspdf:metadata>',
                    e = unescape(
                        encodeURIComponent(
                            '<x:xmpmeta xmlns:x="adobe:ns:meta/">',
                        ),
                    ),
                    r = unescape(encodeURIComponent(t)),
                    n = unescape(
                        encodeURIComponent(this.internal.__metadata__.metadata),
                    ),
                    i = unescape(
                        encodeURIComponent(
                            "</jspdf:metadata></rdf:Description></rdf:RDF>",
                        ),
                    ),
                    a = unescape(encodeURIComponent("</x:xmpmeta>")),
                    o = r.length + n.length + i.length + e.length + a.length;
                (this.internal.__metadata__.metadata_object_number =
                    this.internal.newObject()),
                    this.internal.write(
                        "<< /Type /Metadata /Subtype /XML /Length " + o + " >>",
                    ),
                    this.internal.write("stream"),
                    this.internal.write(e + r + n + i + a),
                    this.internal.write("endstream"),
                    this.internal.write("endobj");
            },
            r = function () {
                this.internal.__metadata__.metadata_object_number &&
                    this.internal.write(
                        "/Metadata " +
                            this.internal.__metadata__.metadata_object_number +
                            " 0 R",
                    );
            };
        t.addMetadata = function (t, n) {
            return (
                void 0 === this.internal.__metadata__ &&
                    ((this.internal.__metadata__ = {
                        metadata: t,
                        namespaceuri: n || "http://jspdf.default.namespaceuri/",
                    }),
                    this.internal.events.subscribe("putCatalog", r),
                    this.internal.events.subscribe("postPutResources", e)),
                this
            );
        };
    })(E.API),
    (function (t) {
        var e = t.API,
            r = (e.pdfEscape16 = function (t, e) {
                for (
                    var r,
                        n = e.metadata.Unicode.widths,
                        i = ["", "0", "00", "000", "0000"],
                        a = [""],
                        o = 0,
                        s = t.length;
                    o < s;
                    ++o
                ) {
                    if (
                        ((r = e.metadata.characterToGlyph(t.charCodeAt(o))),
                        e.metadata.glyIdsUsed.push(r),
                        (e.metadata.toUnicode[r] = t.charCodeAt(o)),
                        -1 == n.indexOf(r) &&
                            (n.push(r),
                            n.push([parseInt(e.metadata.widthOfGlyph(r), 10)])),
                        "0" == r)
                    )
                        return a.join("");
                    (r = r.toString(16)), a.push(i[4 - r.length], r);
                }
                return a.join("");
            }),
            n = function (t) {
                var e, r, n, i, a, o, s;
                for (
                    a =
                        "/CIDInit /ProcSet findresource begin\n12 dict begin\nbegincmap\n/CIDSystemInfo <<\n  /Registry (Adobe)\n  /Ordering (UCS)\n  /Supplement 0\n>> def\n/CMapName /Adobe-Identity-UCS def\n/CMapType 2 def\n1 begincodespacerange\n<0000><ffff>\nendcodespacerange",
                        n = [],
                        o = 0,
                        s = (r = Object.keys(t).sort(function (t, e) {
                            return t - e;
                        })).length;
                    o < s;
                    o++
                )
                    (e = r[o]),
                        n.length >= 100 &&
                            ((a +=
                                "\n" +
                                n.length +
                                " beginbfchar\n" +
                                n.join("\n") +
                                "\nendbfchar"),
                            (n = [])),
                        void 0 !== t[e] &&
                            null !== t[e] &&
                            "function" == typeof t[e].toString &&
                            ((i = ("0000" + t[e].toString(16)).slice(-4)),
                            (e = ("0000" + (+e).toString(16)).slice(-4)),
                            n.push("<" + e + "><" + i + ">"));
                return (
                    n.length &&
                        (a +=
                            "\n" +
                            n.length +
                            " beginbfchar\n" +
                            n.join("\n") +
                            "\nendbfchar\n"),
                    (a +=
                        "endcmap\nCMapName currentdict /CMap defineresource pop\nend\nend")
                );
            };
        e.events.push([
            "putFont",
            function (e) {
                !(function (e) {
                    var r = e.font,
                        i = e.out,
                        a = e.newObject,
                        o = e.putStream;
                    if (
                        r.metadata instanceof t.API.TTFFont &&
                        "Identity-H" === r.encoding
                    ) {
                        for (
                            var s = r.metadata.Unicode.widths,
                                c = r.metadata.subset.encode(
                                    r.metadata.glyIdsUsed,
                                    1,
                                ),
                                u = "",
                                h = 0;
                            h < c.length;
                            h++
                        )
                            u += String.fromCharCode(c[h]);
                        var l = a();
                        o({
                            data: u,
                            addLength1: !0,
                            objectId: l,
                        }),
                            i("endobj");
                        var f = a();
                        o({
                            data: n(r.metadata.toUnicode),
                            addLength1: !0,
                            objectId: f,
                        }),
                            i("endobj");
                        var d = a();
                        i("<<"),
                            i("/Type /FontDescriptor"),
                            i("/FontName /" + F(r.fontName)),
                            i("/FontFile2 " + l + " 0 R"),
                            i(
                                "/FontBBox " +
                                    t.API.PDFObject.convert(r.metadata.bbox),
                            ),
                            i("/Flags " + r.metadata.flags),
                            i("/StemV " + r.metadata.stemV),
                            i("/ItalicAngle " + r.metadata.italicAngle),
                            i("/Ascent " + r.metadata.ascender),
                            i("/Descent " + r.metadata.decender),
                            i("/CapHeight " + r.metadata.capHeight),
                            i(">>"),
                            i("endobj");
                        var p = a();
                        i("<<"),
                            i("/Type /Font"),
                            i("/BaseFont /" + F(r.fontName)),
                            i("/FontDescriptor " + d + " 0 R"),
                            i("/W " + t.API.PDFObject.convert(s)),
                            i("/CIDToGIDMap /Identity"),
                            i("/DW 1000"),
                            i("/Subtype /CIDFontType2"),
                            i("/CIDSystemInfo"),
                            i("<<"),
                            i("/Supplement 0"),
                            i("/Registry (Adobe)"),
                            i("/Ordering (" + r.encoding + ")"),
                            i(">>"),
                            i(">>"),
                            i("endobj"),
                            (r.objectNumber = a()),
                            i("<<"),
                            i("/Type /Font"),
                            i("/Subtype /Type0"),
                            i("/ToUnicode " + f + " 0 R"),
                            i("/BaseFont /" + F(r.fontName)),
                            i("/Encoding /" + r.encoding),
                            i("/DescendantFonts [" + p + " 0 R]"),
                            i(">>"),
                            i("endobj"),
                            (r.isAlreadyPutted = !0);
                    }
                })(e);
            },
        ]);
        e.events.push([
            "putFont",
            function (e) {
                !(function (e) {
                    var r = e.font,
                        i = e.out,
                        a = e.newObject,
                        o = e.putStream;
                    if (
                        r.metadata instanceof t.API.TTFFont &&
                        "WinAnsiEncoding" === r.encoding
                    ) {
                        for (
                            var s = r.metadata.rawData, c = "", u = 0;
                            u < s.length;
                            u++
                        )
                            c += String.fromCharCode(s[u]);
                        var h = a();
                        o({
                            data: c,
                            addLength1: !0,
                            objectId: h,
                        }),
                            i("endobj");
                        var l = a();
                        o({
                            data: n(r.metadata.toUnicode),
                            addLength1: !0,
                            objectId: l,
                        }),
                            i("endobj");
                        var f = a();
                        i("<<"),
                            i("/Descent " + r.metadata.decender),
                            i("/CapHeight " + r.metadata.capHeight),
                            i("/StemV " + r.metadata.stemV),
                            i("/Type /FontDescriptor"),
                            i("/FontFile2 " + h + " 0 R"),
                            i("/Flags 96"),
                            i(
                                "/FontBBox " +
                                    t.API.PDFObject.convert(r.metadata.bbox),
                            ),
                            i("/FontName /" + F(r.fontName)),
                            i("/ItalicAngle " + r.metadata.italicAngle),
                            i("/Ascent " + r.metadata.ascender),
                            i(">>"),
                            i("endobj"),
                            (r.objectNumber = a());
                        for (var d = 0; d < r.metadata.hmtx.widths.length; d++)
                            r.metadata.hmtx.widths[d] = parseInt(
                                r.metadata.hmtx.widths[d] *
                                    (1e3 / r.metadata.head.unitsPerEm),
                            );
                        i(
                            "<</Subtype/TrueType/Type/Font/ToUnicode " +
                                l +
                                " 0 R/BaseFont/" +
                                F(r.fontName) +
                                "/FontDescriptor " +
                                f +
                                " 0 R/Encoding/" +
                                r.encoding +
                                " /FirstChar 29 /LastChar 255 /Widths " +
                                t.API.PDFObject.convert(
                                    r.metadata.hmtx.widths,
                                ) +
                                ">>",
                        ),
                            i("endobj"),
                            (r.isAlreadyPutted = !0);
                    }
                })(e);
            },
        ]);
        var i = function (t) {
            var e,
                n = t.text || "",
                i = t.x,
                a = t.y,
                o = t.options || {},
                s = t.mutex || {},
                c = s.pdfEscape,
                u = s.activeFontKey,
                h = s.fonts,
                l = u,
                f = "",
                d = 0,
                p = "",
                g = h[l].encoding;
            if ("Identity-H" !== h[l].encoding)
                return {
                    text: n,
                    x: i,
                    y: a,
                    options: o,
                    mutex: s,
                };
            for (
                p = n, l = u, Array.isArray(n) && (p = n[0]), d = 0;
                d < p.length;
                d += 1
            )
                h[l].metadata.hasOwnProperty("cmap") &&
                    (e =
                        h[l].metadata.cmap.unicode.codeMap[p[d].charCodeAt(0)]),
                    e ||
                    (p[d].charCodeAt(0) < 256 &&
                        h[l].metadata.hasOwnProperty("Unicode"))
                        ? (f += p[d])
                        : (f += "");
            var m = "";
            return (
                parseInt(l.slice(1)) < 14 || "WinAnsiEncoding" === g
                    ? (m = c(f, l)
                          .split("")
                          .map(function (t) {
                              return t.charCodeAt(0).toString(16);
                          })
                          .join(""))
                    : "Identity-H" === g && (m = r(f, h[l])),
                (s.isHex = !0),
                {
                    text: m,
                    x: i,
                    y: a,
                    options: o,
                    mutex: s,
                }
            );
        };
        e.events.push([
            "postProcessText",
            function (t) {
                var e = t.text || "",
                    r = [],
                    n = {
                        text: e,
                        x: t.x,
                        y: t.y,
                        options: t.options,
                        mutex: t.mutex,
                    };
                if (Array.isArray(e)) {
                    var a = 0;
                    for (a = 0; a < e.length; a += 1)
                        Array.isArray(e[a]) && 3 === e[a].length
                            ? r.push([
                                  i(
                                      Object.assign({}, n, {
                                          text: e[a][0],
                                      }),
                                  ).text,
                                  e[a][1],
                                  e[a][2],
                              ])
                            : r.push(
                                  i(
                                      Object.assign({}, n, {
                                          text: e[a],
                                      }),
                                  ).text,
                              );
                    t.text = r;
                } else
                    t.text = i(
                        Object.assign({}, n, {
                            text: e,
                        }),
                    ).text;
            },
        ]);
    })(E),
    /**
     * @license
     * jsPDF virtual FileSystem functionality
     *
     * Licensed under the MIT License.
     * http://opensource.org/licenses/mit-license
     */
    (function (t) {
        var e = function () {
            return void 0 === this.internal.vFS && (this.internal.vFS = {}), !0;
        };
        (t.existsFileInVFS = function (t) {
            return e.call(this), void 0 !== this.internal.vFS[t];
        }),
            (t.addFileToVFS = function (t, r) {
                return e.call(this), (this.internal.vFS[t] = r), this;
            }),
            (t.getFileFromVFS = function (t) {
                return (
                    e.call(this),
                    void 0 !== this.internal.vFS[t]
                        ? this.internal.vFS[t]
                        : null
                );
            });
    })(E.API),
    /**
     * @license
     * Unicode Bidi Engine based on the work of Alex Shensis (@asthensis)
     * MIT License
     */
    (function (t) {
        t.__bidiEngine__ = t.prototype.__bidiEngine__ = function (t) {
            var r,
                n,
                i,
                a,
                o,
                s,
                c,
                u = e,
                h = [
                    [0, 3, 0, 1, 0, 0, 0],
                    [0, 3, 0, 1, 2, 2, 0],
                    [0, 3, 0, 17, 2, 0, 1],
                    [0, 3, 5, 5, 4, 1, 0],
                    [0, 3, 21, 21, 4, 0, 1],
                    [0, 3, 5, 5, 4, 2, 0],
                ],
                l = [
                    [2, 0, 1, 1, 0, 1, 0],
                    [2, 0, 1, 1, 0, 2, 0],
                    [2, 0, 2, 1, 3, 2, 0],
                    [2, 0, 2, 33, 3, 1, 1],
                ],
                f = {
                    L: 0,
                    R: 1,
                    EN: 2,
                    AN: 3,
                    N: 4,
                    B: 5,
                    S: 6,
                },
                d = {
                    0: 0,
                    5: 1,
                    6: 2,
                    7: 3,
                    32: 4,
                    251: 5,
                    254: 6,
                    255: 7,
                },
                p = [
                    "(",
                    ")",
                    "(",
                    "<",
                    ">",
                    "<",
                    "[",
                    "]",
                    "[",
                    "{",
                    "}",
                    "{",
                    "«",
                    "»",
                    "«",
                    "‹",
                    "›",
                    "‹",
                    "⁅",
                    "⁆",
                    "⁅",
                    "⁽",
                    "⁾",
                    "⁽",
                    "₍",
                    "₎",
                    "₍",
                    "≤",
                    "≥",
                    "≤",
                    "〈",
                    "〉",
                    "〈",
                    "﹙",
                    "﹚",
                    "﹙",
                    "﹛",
                    "﹜",
                    "﹛",
                    "﹝",
                    "﹞",
                    "﹝",
                    "﹤",
                    "﹥",
                    "﹤",
                ],
                g = new RegExp(
                    /^([1-4|9]|1[0-9]|2[0-9]|3[0168]|4[04589]|5[012]|7[78]|159|16[0-9]|17[0-2]|21[569]|22[03489]|250)$/,
                ),
                m = !1,
                v = 0;
            this.__bidiEngine__ = {};
            var b = function (t) {
                    var e = t.charCodeAt(),
                        r = e >> 8,
                        n = d[r];
                    return void 0 !== n
                        ? u[256 * n + (255 & e)]
                        : 252 === r || 253 === r
                          ? "AL"
                          : g.test(r)
                            ? "L"
                            : 8 === r
                              ? "R"
                              : "N";
                },
                y = function (t) {
                    for (var e, r = 0; r < t.length; r++) {
                        if ("L" === (e = b(t.charAt(r)))) return !1;
                        if ("R" === e) return !0;
                    }
                    return !1;
                },
                w = function (t, e, o, s) {
                    var c,
                        u,
                        h,
                        l,
                        f = e[s];
                    switch (f) {
                        case "L":
                        case "R":
                            m = !1;
                            break;
                        case "N":
                        case "AN":
                            break;
                        case "EN":
                            m && (f = "AN");
                            break;
                        case "AL":
                            (m = !0), (f = "R");
                            break;
                        case "WS":
                            f = "N";
                            break;
                        case "CS":
                            s < 1 ||
                            s + 1 >= e.length ||
                            ("EN" !== (c = o[s - 1]) && "AN" !== c) ||
                            ("EN" !== (u = e[s + 1]) && "AN" !== u)
                                ? (f = "N")
                                : m && (u = "AN"),
                                (f = u === c ? u : "N");
                            break;
                        case "ES":
                            f =
                                "EN" === (c = s > 0 ? o[s - 1] : "B") &&
                                s + 1 < e.length &&
                                "EN" === e[s + 1]
                                    ? "EN"
                                    : "N";
                            break;
                        case "ET":
                            if (s > 0 && "EN" === o[s - 1]) {
                                f = "EN";
                                break;
                            }
                            if (m) {
                                f = "N";
                                break;
                            }
                            for (
                                h = s + 1, l = e.length;
                                h < l && "ET" === e[h];

                            )
                                h++;
                            f = h < l && "EN" === e[h] ? "EN" : "N";
                            break;
                        case "NSM":
                            if (i && !a) {
                                for (
                                    l = e.length, h = s + 1;
                                    h < l && "NSM" === e[h];

                                )
                                    h++;
                                if (h < l) {
                                    var d = t[s],
                                        p =
                                            (d >= 1425 && d <= 2303) ||
                                            64286 === d;
                                    if (
                                        ((c = e[h]),
                                        p && ("R" === c || "AL" === c))
                                    ) {
                                        f = "R";
                                        break;
                                    }
                                }
                            }
                            f =
                                s < 1 || "B" === (c = e[s - 1])
                                    ? "N"
                                    : o[s - 1];
                            break;
                        case "B":
                            (m = !1), (r = !0), (f = v);
                            break;
                        case "S":
                            (n = !0), (f = "N");
                            break;
                        case "LRE":
                        case "RLE":
                        case "LRO":
                        case "RLO":
                        case "PDF":
                            m = !1;
                            break;
                        case "BN":
                            f = "N";
                    }
                    return f;
                },
                N = function (t, e, r) {
                    var n = t.split("");
                    return (
                        r &&
                            L(n, r, {
                                hiLevel: v,
                            }),
                        n.reverse(),
                        e && e.reverse(),
                        n.join("")
                    );
                },
                L = function (t, e, i) {
                    var a,
                        o,
                        s,
                        c,
                        u,
                        d = -1,
                        p = t.length,
                        g = 0,
                        y = [],
                        N = v ? l : h,
                        L = [];
                    for (m = !1, r = !1, n = !1, o = 0; o < p; o++)
                        L[o] = b(t[o]);
                    for (s = 0; s < p; s++) {
                        if (
                            ((u = g),
                            (y[s] = w(t, L, y, s)),
                            (a = 240 & (g = N[u][f[y[s]]])),
                            (g &= 15),
                            (e[s] = c = N[g][5]),
                            a > 0)
                        )
                            if (16 === a) {
                                for (o = d; o < s; o++) e[o] = 1;
                                d = -1;
                            } else d = -1;
                        if (N[g][6]) -1 === d && (d = s);
                        else if (d > -1) {
                            for (o = d; o < s; o++) e[o] = c;
                            d = -1;
                        }
                        "B" === L[s] && (e[s] = 0), (i.hiLevel |= c);
                    }
                    n &&
                        (function (t, e, r) {
                            for (var n = 0; n < r; n++)
                                if ("S" === t[n]) {
                                    e[n] = v;
                                    for (
                                        var i = n - 1;
                                        i >= 0 && "WS" === t[i];
                                        i--
                                    )
                                        e[i] = v;
                                }
                        })(L, e, p);
                },
                A = function (t, e, n, i, a) {
                    if (!(a.hiLevel < t)) {
                        if (1 === t && 1 === v && !r)
                            return e.reverse(), void (n && n.reverse());
                        for (var o, s, c, u, h = e.length, l = 0; l < h; ) {
                            if (i[l] >= t) {
                                for (c = l + 1; c < h && i[c] >= t; ) c++;
                                for (u = l, s = c - 1; u < s; u++, s--)
                                    (o = e[u]),
                                        (e[u] = e[s]),
                                        (e[s] = o),
                                        n &&
                                            ((o = n[u]),
                                            (n[u] = n[s]),
                                            (n[s] = o));
                                l = c;
                            }
                            l++;
                        }
                    }
                },
                x = function (t, e, r) {
                    var n = t.split(""),
                        i = {
                            hiLevel: v,
                        };
                    return (
                        r || (r = []),
                        L(n, r, i),
                        (function (t, e, r) {
                            if (0 !== r.hiLevel && c)
                                for (var n, i = 0; i < t.length; i++)
                                    1 === e[i] &&
                                        (n = p.indexOf(t[i])) >= 0 &&
                                        (t[i] = p[n + 1]);
                        })(n, r, i),
                        A(2, n, e, r, i),
                        A(1, n, e, r, i),
                        n.join("")
                    );
                };
            return (
                (this.__bidiEngine__.doBidiReorder = function (t, e, r) {
                    if (
                        ((function (t, e) {
                            if (e) for (var r = 0; r < t.length; r++) e[r] = r;
                            void 0 === a && (a = y(t)),
                                void 0 === s && (s = y(t));
                        })(t, e),
                        i || !o || s)
                    ) {
                        if (i && o && a ^ s) (v = a ? 1 : 0), (t = N(t, e, r));
                        else if (!i && o && s)
                            (v = a ? 1 : 0), (t = x(t, e, r)), (t = N(t, e));
                        else if (!i || a || o || s) {
                            if (i && !o && a ^ s)
                                (t = N(t, e)),
                                    a
                                        ? ((v = 0), (t = x(t, e, r)))
                                        : ((v = 1),
                                          (t = x(t, e, r)),
                                          (t = N(t, e)));
                            else if (i && a && !o && s)
                                (v = 1), (t = x(t, e, r)), (t = N(t, e));
                            else if (!i && !o && a ^ s) {
                                var n = c;
                                a
                                    ? ((v = 1),
                                      (t = x(t, e, r)),
                                      (v = 0),
                                      (c = !1),
                                      (t = x(t, e, r)),
                                      (c = n))
                                    : ((v = 0),
                                      (t = x(t, e, r)),
                                      (t = N(t, e)),
                                      (v = 1),
                                      (c = !1),
                                      (t = x(t, e, r)),
                                      (c = n),
                                      (t = N(t, e)));
                            }
                        } else (v = 0), (t = x(t, e, r));
                    } else (v = a ? 1 : 0), (t = x(t, e, r));
                    return t;
                }),
                (this.__bidiEngine__.setOptions = function (t) {
                    t &&
                        ((i = t.isInputVisual),
                        (o = t.isOutputVisual),
                        (a = t.isInputRtl),
                        (s = t.isOutputRtl),
                        (c = t.isSymmetricSwapping));
                }),
                this.__bidiEngine__.setOptions(t),
                this.__bidiEngine__
            );
        };
        var e = [
                "BN",
                "BN",
                "BN",
                "BN",
                "BN",
                "BN",
                "BN",
                "BN",
                "BN",
                "S",
                "B",
                "S",
                "WS",
                "B",
                "BN",
                "BN",
                "BN",
                "BN",
                "BN",
                "BN",
                "BN",
                "BN",
                "BN",
                "BN",
                "BN",
                "BN",
                "BN",
                "BN",
                "B",
                "B",
                "B",
                "S",
                "WS",
                "N",
                "N",
                "ET",
                "ET",
                "ET",
                "N",
                "N",
                "N",
                "N",
                "N",
                "ES",
                "CS",
                "ES",
                "CS",
                "CS",
                "EN",
                "EN",
                "EN",
                "EN",
                "EN",
                "EN",
                "EN",
                "EN",
                "EN",
                "EN",
                "CS",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "N",
                "N",
                "N",
                "N",
                "BN",
                "BN",
                "BN",
                "BN",
                "BN",
                "BN",
                "B",
                "BN",
                "BN",
                "BN",
                "BN",
                "BN",
                "BN",
                "BN",
                "BN",
                "BN",
                "BN",
                "BN",
                "BN",
                "BN",
                "BN",
                "BN",
                "BN",
                "BN",
                "BN",
                "BN",
                "BN",
                "BN",
                "BN",
                "BN",
                "BN",
                "BN",
                "BN",
                "CS",
                "N",
                "ET",
                "ET",
                "ET",
                "ET",
                "N",
                "N",
                "N",
                "N",
                "L",
                "N",
                "N",
                "BN",
                "N",
                "N",
                "ET",
                "ET",
                "EN",
                "EN",
                "N",
                "L",
                "N",
                "N",
                "N",
                "EN",
                "L",
                "N",
                "N",
                "N",
                "N",
                "N",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "N",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "N",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "N",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "N",
                "N",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "N",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "N",
                "L",
                "N",
                "N",
                "N",
                "N",
                "N",
                "ET",
                "N",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "R",
                "NSM",
                "R",
                "NSM",
                "NSM",
                "R",
                "NSM",
                "NSM",
                "R",
                "NSM",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "N",
                "N",
                "N",
                "N",
                "N",
                "R",
                "R",
                "R",
                "R",
                "R",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "AN",
                "AN",
                "AN",
                "AN",
                "AN",
                "AN",
                "N",
                "N",
                "AL",
                "ET",
                "ET",
                "AL",
                "CS",
                "AL",
                "N",
                "N",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "AL",
                "AL",
                "N",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "AN",
                "AN",
                "AN",
                "AN",
                "AN",
                "AN",
                "AN",
                "AN",
                "AN",
                "AN",
                "ET",
                "AN",
                "AN",
                "AL",
                "AL",
                "AL",
                "NSM",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "AN",
                "N",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "AL",
                "AL",
                "NSM",
                "NSM",
                "N",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "AL",
                "AL",
                "EN",
                "EN",
                "EN",
                "EN",
                "EN",
                "EN",
                "EN",
                "EN",
                "EN",
                "EN",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "N",
                "AL",
                "AL",
                "NSM",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "N",
                "N",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "AL",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "R",
                "R",
                "N",
                "N",
                "N",
                "N",
                "R",
                "N",
                "N",
                "N",
                "N",
                "N",
                "WS",
                "WS",
                "WS",
                "WS",
                "WS",
                "WS",
                "WS",
                "WS",
                "WS",
                "WS",
                "WS",
                "BN",
                "BN",
                "BN",
                "L",
                "R",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "WS",
                "B",
                "LRE",
                "RLE",
                "PDF",
                "LRO",
                "RLO",
                "CS",
                "ET",
                "ET",
                "ET",
                "ET",
                "ET",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "CS",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "WS",
                "BN",
                "BN",
                "BN",
                "BN",
                "BN",
                "N",
                "LRI",
                "RLI",
                "FSI",
                "PDI",
                "BN",
                "BN",
                "BN",
                "BN",
                "BN",
                "BN",
                "EN",
                "L",
                "N",
                "N",
                "EN",
                "EN",
                "EN",
                "EN",
                "EN",
                "EN",
                "ES",
                "ES",
                "N",
                "N",
                "N",
                "L",
                "EN",
                "EN",
                "EN",
                "EN",
                "EN",
                "EN",
                "EN",
                "EN",
                "EN",
                "EN",
                "ES",
                "ES",
                "N",
                "N",
                "N",
                "N",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "N",
                "N",
                "N",
                "ET",
                "ET",
                "ET",
                "ET",
                "ET",
                "ET",
                "ET",
                "ET",
                "ET",
                "ET",
                "ET",
                "ET",
                "ET",
                "ET",
                "ET",
                "ET",
                "ET",
                "ET",
                "ET",
                "ET",
                "ET",
                "ET",
                "ET",
                "ET",
                "ET",
                "ET",
                "ET",
                "ET",
                "ET",
                "ET",
                "ET",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "L",
                "L",
                "L",
                "L",
                "L",
                "N",
                "N",
                "N",
                "N",
                "N",
                "R",
                "NSM",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "ES",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "N",
                "R",
                "R",
                "R",
                "R",
                "R",
                "N",
                "R",
                "N",
                "R",
                "R",
                "N",
                "R",
                "R",
                "N",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "R",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "NSM",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "CS",
                "N",
                "CS",
                "N",
                "N",
                "CS",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "ET",
                "N",
                "N",
                "ES",
                "ES",
                "N",
                "N",
                "N",
                "N",
                "N",
                "ET",
                "ET",
                "N",
                "N",
                "N",
                "N",
                "N",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "N",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "AL",
                "N",
                "N",
                "BN",
                "N",
                "N",
                "N",
                "ET",
                "ET",
                "ET",
                "N",
                "N",
                "N",
                "N",
                "N",
                "ES",
                "CS",
                "ES",
                "CS",
                "CS",
                "EN",
                "EN",
                "EN",
                "EN",
                "EN",
                "EN",
                "EN",
                "EN",
                "EN",
                "EN",
                "CS",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "N",
                "N",
                "N",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "N",
                "N",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "N",
                "N",
                "L",
                "L",
                "L",
                "L",
                "L",
                "L",
                "N",
                "N",
                "L",
                "L",
                "L",
                "N",
                "N",
                "N",
                "ET",
                "ET",
                "N",
                "N",
                "N",
                "ET",
                "ET",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
                "N",
            ],
            r = new t.__bidiEngine__({
                isInputVisual: !0,
            });
        t.API.events.push([
            "postProcessText",
            function (t) {
                var e = t.text,
                    n = (t.x, t.y, t.options || {}),
                    i = (t.mutex, n.lang, []);
                if (
                    ((n.isInputVisual =
                        "boolean" != typeof n.isInputVisual || n.isInputVisual),
                    r.setOptions(n),
                    "[object Array]" === Object.prototype.toString.call(e))
                ) {
                    var a = 0;
                    for (i = [], a = 0; a < e.length; a += 1)
                        "[object Array]" ===
                        Object.prototype.toString.call(e[a])
                            ? i.push([
                                  r.doBidiReorder(e[a][0]),
                                  e[a][1],
                                  e[a][2],
                              ])
                            : i.push([r.doBidiReorder(e[a])]);
                    t.text = i;
                } else t.text = r.doBidiReorder(e);
                r.setOptions({
                    isInputVisual: !0,
                });
            },
        ]);
    })(E),
    (E.API.TTFFont = (function () {
        function t(t) {
            var e;
            if (
                ((this.rawData = t),
                (e = this.contents = new ne(t)),
                (this.contents.pos = 4),
                "ttcf" === e.readString(4))
            )
                throw new Error("TTCF not supported.");
            (e.pos = 0),
                this.parse(),
                (this.subset = new Le(this)),
                this.registerTTF();
        }
        return (
            (t.open = function (e) {
                return new t(e);
            }),
            (t.prototype.parse = function () {
                return (
                    (this.directory = new ie(this.contents)),
                    (this.head = new se(this)),
                    (this.name = new pe(this)),
                    (this.cmap = new ue(this)),
                    (this.toUnicode = {}),
                    (this.hhea = new he(this)),
                    (this.maxp = new ge(this)),
                    (this.hmtx = new me(this)),
                    (this.post = new fe(this)),
                    (this.os2 = new le(this)),
                    (this.loca = new Ne(this)),
                    (this.glyf = new be(this)),
                    (this.ascender =
                        (this.os2.exists && this.os2.ascender) ||
                        this.hhea.ascender),
                    (this.decender =
                        (this.os2.exists && this.os2.decender) ||
                        this.hhea.decender),
                    (this.lineGap =
                        (this.os2.exists && this.os2.lineGap) ||
                        this.hhea.lineGap),
                    (this.bbox = [
                        this.head.xMin,
                        this.head.yMin,
                        this.head.xMax,
                        this.head.yMax,
                    ])
                );
            }),
            (t.prototype.registerTTF = function () {
                var t, e, r, n, i;
                if (
                    ((this.scaleFactor = 1e3 / this.head.unitsPerEm),
                    (this.bbox = function () {
                        var e, r, n, i;
                        for (
                            i = [], e = 0, r = (n = this.bbox).length;
                            e < r;
                            e++
                        )
                            (t = n[e]),
                                i.push(Math.round(t * this.scaleFactor));
                        return i;
                    }.call(this)),
                    (this.stemV = 0),
                    this.post.exists
                        ? ((r = 255 & (n = this.post.italic_angle)),
                          0 != (32768 & (e = n >> 16)) &&
                              (e = -(1 + (65535 ^ e))),
                          (this.italicAngle = +(e + "." + r)))
                        : (this.italicAngle = 0),
                    (this.ascender = Math.round(
                        this.ascender * this.scaleFactor,
                    )),
                    (this.decender = Math.round(
                        this.decender * this.scaleFactor,
                    )),
                    (this.lineGap = Math.round(
                        this.lineGap * this.scaleFactor,
                    )),
                    (this.capHeight =
                        (this.os2.exists && this.os2.capHeight) ||
                        this.ascender),
                    (this.xHeight = (this.os2.exists && this.os2.xHeight) || 0),
                    (this.familyClass =
                        ((this.os2.exists && this.os2.familyClass) || 0) >> 8),
                    (this.isSerif =
                        1 === (i = this.familyClass) ||
                        2 === i ||
                        3 === i ||
                        4 === i ||
                        5 === i ||
                        7 === i),
                    (this.isScript = 10 === this.familyClass),
                    (this.flags = 0),
                    this.post.isFixedPitch && (this.flags |= 1),
                    this.isSerif && (this.flags |= 2),
                    this.isScript && (this.flags |= 8),
                    0 !== this.italicAngle && (this.flags |= 64),
                    (this.flags |= 32),
                    !this.cmap.unicode)
                )
                    throw new Error("No unicode cmap for font");
            }),
            (t.prototype.characterToGlyph = function (t) {
                var e;
                return (
                    (null != (e = this.cmap.unicode) ? e.codeMap[t] : void 0) ||
                    0
                );
            }),
            (t.prototype.widthOfGlyph = function (t) {
                var e;
                return (
                    (e = 1e3 / this.head.unitsPerEm),
                    this.hmtx.forGlyph(t).advance * e
                );
            }),
            (t.prototype.widthOfString = function (t, e, r) {
                var n, i, a, o;
                for (
                    a = 0, i = 0, o = (t = "" + t).length;
                    0 <= o ? i < o : i > o;
                    i = 0 <= o ? ++i : --i
                )
                    (n = t.charCodeAt(i)),
                        (a +=
                            this.widthOfGlyph(this.characterToGlyph(n)) +
                                r * (1e3 / e) || 0);
                return a * (e / 1e3);
            }),
            (t.prototype.lineHeight = function (t, e) {
                var r;
                return (
                    null == e && (e = !1),
                    (r = e ? this.lineGap : 0),
                    ((this.ascender + r - this.decender) / 1e3) * t
                );
            }),
            t
        );
    })());
var re,
    ne = (function () {
        function t(t) {
            (this.data = null != t ? t : []),
                (this.pos = 0),
                (this.length = this.data.length);
        }
        return (
            (t.prototype.readByte = function () {
                return this.data[this.pos++];
            }),
            (t.prototype.writeByte = function (t) {
                return (this.data[this.pos++] = t);
            }),
            (t.prototype.readUInt32 = function () {
                return (
                    16777216 * this.readByte() +
                    (this.readByte() << 16) +
                    (this.readByte() << 8) +
                    this.readByte()
                );
            }),
            (t.prototype.writeUInt32 = function (t) {
                return (
                    this.writeByte((t >>> 24) & 255),
                    this.writeByte((t >> 16) & 255),
                    this.writeByte((t >> 8) & 255),
                    this.writeByte(255 & t)
                );
            }),
            (t.prototype.readInt32 = function () {
                var t;
                return (t = this.readUInt32()) >= 2147483648
                    ? t - 4294967296
                    : t;
            }),
            (t.prototype.writeInt32 = function (t) {
                return t < 0 && (t += 4294967296), this.writeUInt32(t);
            }),
            (t.prototype.readUInt16 = function () {
                return (this.readByte() << 8) | this.readByte();
            }),
            (t.prototype.writeUInt16 = function (t) {
                return this.writeByte((t >> 8) & 255), this.writeByte(255 & t);
            }),
            (t.prototype.readInt16 = function () {
                var t;
                return (t = this.readUInt16()) >= 32768 ? t - 65536 : t;
            }),
            (t.prototype.writeInt16 = function (t) {
                return t < 0 && (t += 65536), this.writeUInt16(t);
            }),
            (t.prototype.readString = function (t) {
                var e, r;
                for (
                    r = [], e = 0;
                    0 <= t ? e < t : e > t;
                    e = 0 <= t ? ++e : --e
                )
                    r[e] = String.fromCharCode(this.readByte());
                return r.join("");
            }),
            (t.prototype.writeString = function (t) {
                var e, r, n;
                for (
                    n = [], e = 0, r = t.length;
                    0 <= r ? e < r : e > r;
                    e = 0 <= r ? ++e : --e
                )
                    n.push(this.writeByte(t.charCodeAt(e)));
                return n;
            }),
            (t.prototype.readShort = function () {
                return this.readInt16();
            }),
            (t.prototype.writeShort = function (t) {
                return this.writeInt16(t);
            }),
            (t.prototype.readLongLong = function () {
                var t, e, r, n, i, a, o, s;
                return (
                    (t = this.readByte()),
                    (e = this.readByte()),
                    (r = this.readByte()),
                    (n = this.readByte()),
                    (i = this.readByte()),
                    (a = this.readByte()),
                    (o = this.readByte()),
                    (s = this.readByte()),
                    128 & t
                        ? -1 *
                          (72057594037927940 * (255 ^ t) +
                              281474976710656 * (255 ^ e) +
                              1099511627776 * (255 ^ r) +
                              4294967296 * (255 ^ n) +
                              16777216 * (255 ^ i) +
                              65536 * (255 ^ a) +
                              256 * (255 ^ o) +
                              (255 ^ s) +
                              1)
                        : 72057594037927940 * t +
                          281474976710656 * e +
                          1099511627776 * r +
                          4294967296 * n +
                          16777216 * i +
                          65536 * a +
                          256 * o +
                          s
                );
            }),
            (t.prototype.writeLongLong = function (t) {
                var e, r;
                return (
                    (e = Math.floor(t / 4294967296)),
                    (r = 4294967295 & t),
                    this.writeByte((e >> 24) & 255),
                    this.writeByte((e >> 16) & 255),
                    this.writeByte((e >> 8) & 255),
                    this.writeByte(255 & e),
                    this.writeByte((r >> 24) & 255),
                    this.writeByte((r >> 16) & 255),
                    this.writeByte((r >> 8) & 255),
                    this.writeByte(255 & r)
                );
            }),
            (t.prototype.readInt = function () {
                return this.readInt32();
            }),
            (t.prototype.writeInt = function (t) {
                return this.writeInt32(t);
            }),
            (t.prototype.read = function (t) {
                var e, r;
                for (
                    e = [], r = 0;
                    0 <= t ? r < t : r > t;
                    r = 0 <= t ? ++r : --r
                )
                    e.push(this.readByte());
                return e;
            }),
            (t.prototype.write = function (t) {
                var e, r, n, i;
                for (i = [], r = 0, n = t.length; r < n; r++)
                    (e = t[r]), i.push(this.writeByte(e));
                return i;
            }),
            t
        );
    })(),
    ie = (function () {
        var t;
        function e(t) {
            var e, r, n;
            for (
                this.scalarType = t.readInt(),
                    this.tableCount = t.readShort(),
                    this.searchRange = t.readShort(),
                    this.entrySelector = t.readShort(),
                    this.rangeShift = t.readShort(),
                    this.tables = {},
                    r = 0,
                    n = this.tableCount;
                0 <= n ? r < n : r > n;
                r = 0 <= n ? ++r : --r
            )
                (e = {
                    tag: t.readString(4),
                    checksum: t.readInt(),
                    offset: t.readInt(),
                    length: t.readInt(),
                }),
                    (this.tables[e.tag] = e);
        }
        return (
            (e.prototype.encode = function (e) {
                var r, n, i, a, o, s, c, u, h, l, f, d, p;
                for (p in ((f = Object.keys(e).length),
                (s = Math.log(2)),
                (h = 16 * Math.floor(Math.log(f) / s)),
                (a = Math.floor(h / s)),
                (u = 16 * f - h),
                (n = new ne()).writeInt(this.scalarType),
                n.writeShort(f),
                n.writeShort(h),
                n.writeShort(a),
                n.writeShort(u),
                (i = 16 * f),
                (c = n.pos + i),
                (o = null),
                (d = []),
                e))
                    for (
                        l = e[p],
                            n.writeString(p),
                            n.writeInt(t(l)),
                            n.writeInt(c),
                            n.writeInt(l.length),
                            d = d.concat(l),
                            "head" === p && (o = c),
                            c += l.length;
                        c % 4;

                    )
                        d.push(0), c++;
                return (
                    n.write(d),
                    (r = 2981146554 - t(n.data)),
                    (n.pos = o + 8),
                    n.writeUInt32(r),
                    n.data
                );
            }),
            (t = function (t) {
                var e, r, n, i;
                for (t = ve.call(t); t.length % 4; ) t.push(0);
                for (
                    n = new ne(t), r = 0, e = 0, i = t.length;
                    e < i;
                    e = e += 4
                )
                    r += n.readUInt32();
                return 4294967295 & r;
            }),
            e
        );
    })(),
    ae = {}.hasOwnProperty,
    oe = function (t, e) {
        for (var r in e) ae.call(e, r) && (t[r] = e[r]);
        function n() {
            this.constructor = t;
        }
        return (
            (n.prototype = e.prototype),
            (t.prototype = new n()),
            (t.__super__ = e.prototype),
            t
        );
    };
re = (function () {
    function t(t) {
        var e;
        (this.file = t),
            (e = this.file.directory.tables[this.tag]),
            (this.exists = !!e),
            e &&
                ((this.offset = e.offset),
                (this.length = e.length),
                this.parse(this.file.contents));
    }
    return (
        (t.prototype.parse = function () {}),
        (t.prototype.encode = function () {}),
        (t.prototype.raw = function () {
            return this.exists
                ? ((this.file.contents.pos = this.offset),
                  this.file.contents.read(this.length))
                : null;
        }),
        t
    );
})();
var se = (function (t) {
        function e() {
            return e.__super__.constructor.apply(this, arguments);
        }
        return (
            oe(e, re),
            (e.prototype.tag = "head"),
            (e.prototype.parse = function (t) {
                return (
                    (t.pos = this.offset),
                    (this.version = t.readInt()),
                    (this.revision = t.readInt()),
                    (this.checkSumAdjustment = t.readInt()),
                    (this.magicNumber = t.readInt()),
                    (this.flags = t.readShort()),
                    (this.unitsPerEm = t.readShort()),
                    (this.created = t.readLongLong()),
                    (this.modified = t.readLongLong()),
                    (this.xMin = t.readShort()),
                    (this.yMin = t.readShort()),
                    (this.xMax = t.readShort()),
                    (this.yMax = t.readShort()),
                    (this.macStyle = t.readShort()),
                    (this.lowestRecPPEM = t.readShort()),
                    (this.fontDirectionHint = t.readShort()),
                    (this.indexToLocFormat = t.readShort()),
                    (this.glyphDataFormat = t.readShort())
                );
            }),
            (e.prototype.encode = function (t) {
                var e;
                return (
                    (e = new ne()).writeInt(this.version),
                    e.writeInt(this.revision),
                    e.writeInt(this.checkSumAdjustment),
                    e.writeInt(this.magicNumber),
                    e.writeShort(this.flags),
                    e.writeShort(this.unitsPerEm),
                    e.writeLongLong(this.created),
                    e.writeLongLong(this.modified),
                    e.writeShort(this.xMin),
                    e.writeShort(this.yMin),
                    e.writeShort(this.xMax),
                    e.writeShort(this.yMax),
                    e.writeShort(this.macStyle),
                    e.writeShort(this.lowestRecPPEM),
                    e.writeShort(this.fontDirectionHint),
                    e.writeShort(t),
                    e.writeShort(this.glyphDataFormat),
                    e.data
                );
            }),
            e
        );
    })(),
    ce = (function () {
        function t(t, e) {
            var r, n, i, a, o, s, c, u, h, l, f, d, p, g, m, v, b;
            switch (
                ((this.platformID = t.readUInt16()),
                (this.encodingID = t.readShort()),
                (this.offset = e + t.readInt()),
                (h = t.pos),
                (t.pos = this.offset),
                (this.format = t.readUInt16()),
                (this.length = t.readUInt16()),
                (this.language = t.readUInt16()),
                (this.isUnicode =
                    (3 === this.platformID &&
                        1 === this.encodingID &&
                        4 === this.format) ||
                    (0 === this.platformID && 4 === this.format)),
                (this.codeMap = {}),
                this.format)
            ) {
                case 0:
                    for (s = 0; s < 256; ++s) this.codeMap[s] = t.readByte();
                    break;
                case 4:
                    for (
                        f = t.readUInt16(),
                            l = f / 2,
                            t.pos += 6,
                            i = (function () {
                                var e, r;
                                for (
                                    r = [], s = e = 0;
                                    0 <= l ? e < l : e > l;
                                    s = 0 <= l ? ++e : --e
                                )
                                    r.push(t.readUInt16());
                                return r;
                            })(),
                            t.pos += 2,
                            p = (function () {
                                var e, r;
                                for (
                                    r = [], s = e = 0;
                                    0 <= l ? e < l : e > l;
                                    s = 0 <= l ? ++e : --e
                                )
                                    r.push(t.readUInt16());
                                return r;
                            })(),
                            c = (function () {
                                var e, r;
                                for (
                                    r = [], s = e = 0;
                                    0 <= l ? e < l : e > l;
                                    s = 0 <= l ? ++e : --e
                                )
                                    r.push(t.readUInt16());
                                return r;
                            })(),
                            u = (function () {
                                var e, r;
                                for (
                                    r = [], s = e = 0;
                                    0 <= l ? e < l : e > l;
                                    s = 0 <= l ? ++e : --e
                                )
                                    r.push(t.readUInt16());
                                return r;
                            })(),
                            n = (this.length - t.pos + this.offset) / 2,
                            o = (function () {
                                var e, r;
                                for (
                                    r = [], s = e = 0;
                                    0 <= n ? e < n : e > n;
                                    s = 0 <= n ? ++e : --e
                                )
                                    r.push(t.readUInt16());
                                return r;
                            })(),
                            s = m = 0,
                            b = i.length;
                        m < b;
                        s = ++m
                    )
                        for (
                            g = i[s], r = v = d = p[s];
                            d <= g ? v <= g : v >= g;
                            r = d <= g ? ++v : --v
                        )
                            0 === u[s]
                                ? (a = r + c[s])
                                : 0 !==
                                      (a =
                                          o[u[s] / 2 + (r - d) - (l - s)] ||
                                          0) && (a += c[s]),
                                (this.codeMap[r] = 65535 & a);
            }
            t.pos = h;
        }
        return (
            (t.encode = function (t, e) {
                var r,
                    n,
                    i,
                    a,
                    o,
                    s,
                    c,
                    u,
                    h,
                    l,
                    f,
                    d,
                    p,
                    g,
                    m,
                    v,
                    b,
                    y,
                    w,
                    N,
                    L,
                    A,
                    x,
                    S,
                    _,
                    P,
                    k,
                    I,
                    F,
                    C,
                    j,
                    O,
                    B,
                    M,
                    E,
                    q,
                    D,
                    R,
                    T,
                    U,
                    z,
                    H,
                    W,
                    V,
                    G,
                    Y;
                switch (
                    ((I = new ne()),
                    (a = Object.keys(t).sort(function (t, e) {
                        return t - e;
                    })),
                    e)
                ) {
                    case "macroman":
                        for (
                            p = 0,
                                g = (function () {
                                    var t = [];
                                    for (d = 0; d < 256; ++d) t.push(0);
                                    return t;
                                })(),
                                v = {
                                    0: 0,
                                },
                                i = {},
                                F = 0,
                                B = a.length;
                            F < B;
                            F++
                        )
                            null == v[(W = t[(n = a[F])])] && (v[W] = ++p),
                                (i[n] = {
                                    old: t[n],
                                    new: v[t[n]],
                                }),
                                (g[n] = v[t[n]]);
                        return (
                            I.writeUInt16(1),
                            I.writeUInt16(0),
                            I.writeUInt32(12),
                            I.writeUInt16(0),
                            I.writeUInt16(262),
                            I.writeUInt16(0),
                            I.write(g),
                            {
                                charMap: i,
                                subtable: I.data,
                                maxGlyphID: p + 1,
                            }
                        );
                    case "unicode":
                        for (
                            P = [],
                                h = [],
                                b = 0,
                                v = {},
                                r = {},
                                m = c = null,
                                C = 0,
                                M = a.length;
                            C < M;
                            C++
                        )
                            null == v[(w = t[(n = a[C])])] && (v[w] = ++b),
                                (r[n] = {
                                    old: w,
                                    new: v[w],
                                }),
                                (o = v[w] - n),
                                (null != m && o === c) ||
                                    (m && h.push(m), P.push(n), (c = o)),
                                (m = n);
                        for (
                            m && h.push(m),
                                h.push(65535),
                                P.push(65535),
                                S = 2 * (x = P.length),
                                A = 2 * Math.pow(Math.log(x) / Math.LN2, 2),
                                l = Math.log(A / 2) / Math.LN2,
                                L = 2 * x - A,
                                s = [],
                                N = [],
                                f = [],
                                d = j = 0,
                                E = P.length;
                            j < E;
                            d = ++j
                        ) {
                            if (((_ = P[d]), (u = h[d]), 65535 === _)) {
                                s.push(0), N.push(0);
                                break;
                            }
                            if (_ - (k = r[_].new) >= 32768)
                                for (
                                    s.push(0),
                                        N.push(2 * (f.length + x - d)),
                                        n = O = _;
                                    _ <= u ? O <= u : O >= u;
                                    n = _ <= u ? ++O : --O
                                )
                                    f.push(r[n].new);
                            else s.push(k - _), N.push(0);
                        }
                        for (
                            I.writeUInt16(3),
                                I.writeUInt16(1),
                                I.writeUInt32(12),
                                I.writeUInt16(4),
                                I.writeUInt16(16 + 8 * x + 2 * f.length),
                                I.writeUInt16(0),
                                I.writeUInt16(S),
                                I.writeUInt16(A),
                                I.writeUInt16(l),
                                I.writeUInt16(L),
                                z = 0,
                                q = h.length;
                            z < q;
                            z++
                        )
                            (n = h[z]), I.writeUInt16(n);
                        for (I.writeUInt16(0), H = 0, D = P.length; H < D; H++)
                            (n = P[H]), I.writeUInt16(n);
                        for (V = 0, R = s.length; V < R; V++)
                            (o = s[V]), I.writeUInt16(o);
                        for (G = 0, T = N.length; G < T; G++)
                            (y = N[G]), I.writeUInt16(y);
                        for (Y = 0, U = f.length; Y < U; Y++)
                            (p = f[Y]), I.writeUInt16(p);
                        return {
                            charMap: r,
                            subtable: I.data,
                            maxGlyphID: b + 1,
                        };
                }
            }),
            t
        );
    })(),
    ue = (function (t) {
        function e() {
            return e.__super__.constructor.apply(this, arguments);
        }
        return (
            oe(e, re),
            (e.prototype.tag = "cmap"),
            (e.prototype.parse = function (t) {
                var e, r, n;
                for (
                    t.pos = this.offset,
                        this.version = t.readUInt16(),
                        n = t.readUInt16(),
                        this.tables = [],
                        this.unicode = null,
                        r = 0;
                    0 <= n ? r < n : r > n;
                    r = 0 <= n ? ++r : --r
                )
                    (e = new ce(t, this.offset)),
                        this.tables.push(e),
                        e.isUnicode &&
                            null == this.unicode &&
                            (this.unicode = e);
                return !0;
            }),
            (e.encode = function (t, e) {
                var r, n;
                return (
                    null == e && (e = "macroman"),
                    (r = ce.encode(t, e)),
                    (n = new ne()).writeUInt16(0),
                    n.writeUInt16(1),
                    (r.table = n.data.concat(r.subtable)),
                    r
                );
            }),
            e
        );
    })(),
    he = (function (t) {
        function e() {
            return e.__super__.constructor.apply(this, arguments);
        }
        return (
            oe(e, re),
            (e.prototype.tag = "hhea"),
            (e.prototype.parse = function (t) {
                return (
                    (t.pos = this.offset),
                    (this.version = t.readInt()),
                    (this.ascender = t.readShort()),
                    (this.decender = t.readShort()),
                    (this.lineGap = t.readShort()),
                    (this.advanceWidthMax = t.readShort()),
                    (this.minLeftSideBearing = t.readShort()),
                    (this.minRightSideBearing = t.readShort()),
                    (this.xMaxExtent = t.readShort()),
                    (this.caretSlopeRise = t.readShort()),
                    (this.caretSlopeRun = t.readShort()),
                    (this.caretOffset = t.readShort()),
                    (t.pos += 8),
                    (this.metricDataFormat = t.readShort()),
                    (this.numberOfMetrics = t.readUInt16())
                );
            }),
            e
        );
    })(),
    le = (function (t) {
        function e() {
            return e.__super__.constructor.apply(this, arguments);
        }
        return (
            oe(e, re),
            (e.prototype.tag = "OS/2"),
            (e.prototype.parse = function (t) {
                if (
                    ((t.pos = this.offset),
                    (this.version = t.readUInt16()),
                    (this.averageCharWidth = t.readShort()),
                    (this.weightClass = t.readUInt16()),
                    (this.widthClass = t.readUInt16()),
                    (this.type = t.readShort()),
                    (this.ySubscriptXSize = t.readShort()),
                    (this.ySubscriptYSize = t.readShort()),
                    (this.ySubscriptXOffset = t.readShort()),
                    (this.ySubscriptYOffset = t.readShort()),
                    (this.ySuperscriptXSize = t.readShort()),
                    (this.ySuperscriptYSize = t.readShort()),
                    (this.ySuperscriptXOffset = t.readShort()),
                    (this.ySuperscriptYOffset = t.readShort()),
                    (this.yStrikeoutSize = t.readShort()),
                    (this.yStrikeoutPosition = t.readShort()),
                    (this.familyClass = t.readShort()),
                    (this.panose = (function () {
                        var e, r;
                        for (r = [], e = 0; e < 10; ++e) r.push(t.readByte());
                        return r;
                    })()),
                    (this.charRange = (function () {
                        var e, r;
                        for (r = [], e = 0; e < 4; ++e) r.push(t.readInt());
                        return r;
                    })()),
                    (this.vendorID = t.readString(4)),
                    (this.selection = t.readShort()),
                    (this.firstCharIndex = t.readShort()),
                    (this.lastCharIndex = t.readShort()),
                    this.version > 0 &&
                        ((this.ascent = t.readShort()),
                        (this.descent = t.readShort()),
                        (this.lineGap = t.readShort()),
                        (this.winAscent = t.readShort()),
                        (this.winDescent = t.readShort()),
                        (this.codePageRange = (function () {
                            var e, r;
                            for (r = [], e = 0; e < 2; e = ++e)
                                r.push(t.readInt());
                            return r;
                        })()),
                        this.version > 1))
                )
                    return (
                        (this.xHeight = t.readShort()),
                        (this.capHeight = t.readShort()),
                        (this.defaultChar = t.readShort()),
                        (this.breakChar = t.readShort()),
                        (this.maxContext = t.readShort())
                    );
            }),
            e
        );
    })(),
    fe = (function (t) {
        function e() {
            return e.__super__.constructor.apply(this, arguments);
        }
        return (
            oe(e, re),
            (e.prototype.tag = "post"),
            (e.prototype.parse = function (t) {
                var e, r, n;
                switch (
                    ((t.pos = this.offset),
                    (this.format = t.readInt()),
                    (this.italicAngle = t.readInt()),
                    (this.underlinePosition = t.readShort()),
                    (this.underlineThickness = t.readShort()),
                    (this.isFixedPitch = t.readInt()),
                    (this.minMemType42 = t.readInt()),
                    (this.maxMemType42 = t.readInt()),
                    (this.minMemType1 = t.readInt()),
                    (this.maxMemType1 = t.readInt()),
                    this.format)
                ) {
                    case 65536:
                        break;
                    case 131072:
                        var i;
                        for (
                            r = t.readUInt16(), this.glyphNameIndex = [], i = 0;
                            0 <= r ? i < r : i > r;
                            i = 0 <= r ? ++i : --i
                        )
                            this.glyphNameIndex.push(t.readUInt16());
                        for (
                            this.names = [], n = [];
                            t.pos < this.offset + this.length;

                        )
                            (e = t.readByte()),
                                n.push(this.names.push(t.readString(e)));
                        return n;
                    case 151552:
                        return (r = t.readUInt16()), (this.offsets = t.read(r));
                    case 196608:
                        break;
                    case 262144:
                        return (this.map = function () {
                            var e, r, n;
                            for (
                                n = [], i = e = 0, r = this.file.maxp.numGlyphs;
                                0 <= r ? e < r : e > r;
                                i = 0 <= r ? ++e : --e
                            )
                                n.push(t.readUInt32());
                            return n;
                        }.call(this));
                }
            }),
            e
        );
    })(),
    de = function (t, e) {
        (this.raw = t),
            (this.length = t.length),
            (this.platformID = e.platformID),
            (this.encodingID = e.encodingID),
            (this.languageID = e.languageID);
    },
    pe = (function (t) {
        function e() {
            return e.__super__.constructor.apply(this, arguments);
        }
        return (
            oe(e, re),
            (e.prototype.tag = "name"),
            (e.prototype.parse = function (t) {
                var e, r, n, i, a, o, s, c, u, h, l;
                for (
                    t.pos = this.offset,
                        t.readShort(),
                        e = t.readShort(),
                        o = t.readShort(),
                        r = [],
                        i = 0;
                    0 <= e ? i < e : i > e;
                    i = 0 <= e ? ++i : --i
                )
                    r.push({
                        platformID: t.readShort(),
                        encodingID: t.readShort(),
                        languageID: t.readShort(),
                        nameID: t.readShort(),
                        length: t.readShort(),
                        offset: this.offset + o + t.readShort(),
                    });
                for (s = {}, i = u = 0, h = r.length; u < h; i = ++u)
                    (n = r[i]),
                        (t.pos = n.offset),
                        (c = t.readString(n.length)),
                        (a = new de(c, n)),
                        null == s[(l = n.nameID)] && (s[l] = []),
                        s[n.nameID].push(a);
                (this.strings = s),
                    (this.copyright = s[0]),
                    (this.fontFamily = s[1]),
                    (this.fontSubfamily = s[2]),
                    (this.uniqueSubfamily = s[3]),
                    (this.fontName = s[4]),
                    (this.version = s[5]);
                try {
                    this.postscriptName = s[6][0].raw.replace(
                        /[\x00-\x19\x80-\xff]/g,
                        "",
                    );
                } catch (t) {
                    this.postscriptName = s[4][0].raw.replace(
                        /[\x00-\x19\x80-\xff]/g,
                        "",
                    );
                }
                return (
                    (this.trademark = s[7]),
                    (this.manufacturer = s[8]),
                    (this.designer = s[9]),
                    (this.description = s[10]),
                    (this.vendorUrl = s[11]),
                    (this.designerUrl = s[12]),
                    (this.license = s[13]),
                    (this.licenseUrl = s[14]),
                    (this.preferredFamily = s[15]),
                    (this.preferredSubfamily = s[17]),
                    (this.compatibleFull = s[18]),
                    (this.sampleText = s[19])
                );
            }),
            e
        );
    })(),
    ge = (function (t) {
        function e() {
            return e.__super__.constructor.apply(this, arguments);
        }
        return (
            oe(e, re),
            (e.prototype.tag = "maxp"),
            (e.prototype.parse = function (t) {
                return (
                    (t.pos = this.offset),
                    (this.version = t.readInt()),
                    (this.numGlyphs = t.readUInt16()),
                    (this.maxPoints = t.readUInt16()),
                    (this.maxContours = t.readUInt16()),
                    (this.maxCompositePoints = t.readUInt16()),
                    (this.maxComponentContours = t.readUInt16()),
                    (this.maxZones = t.readUInt16()),
                    (this.maxTwilightPoints = t.readUInt16()),
                    (this.maxStorage = t.readUInt16()),
                    (this.maxFunctionDefs = t.readUInt16()),
                    (this.maxInstructionDefs = t.readUInt16()),
                    (this.maxStackElements = t.readUInt16()),
                    (this.maxSizeOfInstructions = t.readUInt16()),
                    (this.maxComponentElements = t.readUInt16()),
                    (this.maxComponentDepth = t.readUInt16())
                );
            }),
            e
        );
    })(),
    me = (function (t) {
        function e() {
            return e.__super__.constructor.apply(this, arguments);
        }
        return (
            oe(e, re),
            (e.prototype.tag = "hmtx"),
            (e.prototype.parse = function (t) {
                var e, r, n, i, a, o, s;
                for (
                    t.pos = this.offset,
                        this.metrics = [],
                        e = 0,
                        o = this.file.hhea.numberOfMetrics;
                    0 <= o ? e < o : e > o;
                    e = 0 <= o ? ++e : --e
                )
                    this.metrics.push({
                        advance: t.readUInt16(),
                        lsb: t.readInt16(),
                    });
                for (
                    n =
                        this.file.maxp.numGlyphs -
                        this.file.hhea.numberOfMetrics,
                        this.leftSideBearings = (function () {
                            var r, i;
                            for (
                                i = [], e = r = 0;
                                0 <= n ? r < n : r > n;
                                e = 0 <= n ? ++r : --r
                            )
                                i.push(t.readInt16());
                            return i;
                        })(),
                        this.widths = function () {
                            var t, e, r, n;
                            for (
                                n = [], t = 0, e = (r = this.metrics).length;
                                t < e;
                                t++
                            )
                                (i = r[t]), n.push(i.advance);
                            return n;
                        }.call(this),
                        r = this.widths[this.widths.length - 1],
                        s = [],
                        e = a = 0;
                    0 <= n ? a < n : a > n;
                    e = 0 <= n ? ++a : --a
                )
                    s.push(this.widths.push(r));
                return s;
            }),
            (e.prototype.forGlyph = function (t) {
                return t in this.metrics
                    ? this.metrics[t]
                    : {
                          advance:
                              this.metrics[this.metrics.length - 1].advance,
                          lsb: this.leftSideBearings[t - this.metrics.length],
                      };
            }),
            e
        );
    })(),
    ve = [].slice,
    be = (function (t) {
        function e() {
            return e.__super__.constructor.apply(this, arguments);
        }
        return (
            oe(e, re),
            (e.prototype.tag = "glyf"),
            (e.prototype.parse = function () {
                return (this.cache = {});
            }),
            (e.prototype.glyphFor = function (t) {
                var e, r, n, i, a, o, s, c, u, h;
                return t in this.cache
                    ? this.cache[t]
                    : ((i = this.file.loca),
                      (e = this.file.contents),
                      (r = i.indexOf(t)),
                      0 === (n = i.lengthOf(t))
                          ? (this.cache[t] = null)
                          : ((e.pos = this.offset + r),
                            (a = (o = new ne(e.read(n))).readShort()),
                            (c = o.readShort()),
                            (h = o.readShort()),
                            (s = o.readShort()),
                            (u = o.readShort()),
                            (this.cache[t] =
                                -1 === a
                                    ? new we(o, c, h, s, u)
                                    : new ye(o, a, c, h, s, u)),
                            this.cache[t]));
            }),
            (e.prototype.encode = function (t, e, r) {
                var n, i, a, o, s;
                for (a = [], i = [], o = 0, s = e.length; o < s; o++)
                    (n = t[e[o]]),
                        i.push(a.length),
                        n && (a = a.concat(n.encode(r)));
                return (
                    i.push(a.length),
                    {
                        table: a,
                        offsets: i,
                    }
                );
            }),
            e
        );
    })(),
    ye = (function () {
        function t(t, e, r, n, i, a) {
            (this.raw = t),
                (this.numberOfContours = e),
                (this.xMin = r),
                (this.yMin = n),
                (this.xMax = i),
                (this.yMax = a),
                (this.compound = !1);
        }
        return (
            (t.prototype.encode = function () {
                return this.raw.data;
            }),
            t
        );
    })(),
    we = (function () {
        function t(t, e, r, n, i) {
            var a, o;
            for (
                this.raw = t,
                    this.xMin = e,
                    this.yMin = r,
                    this.xMax = n,
                    this.yMax = i,
                    this.compound = !0,
                    this.glyphIDs = [],
                    this.glyphOffsets = [],
                    a = this.raw;
                (o = a.readShort()),
                    this.glyphOffsets.push(a.pos),
                    this.glyphIDs.push(a.readUInt16()),
                    32 & o;

            )
                (a.pos += 1 & o ? 4 : 2),
                    128 & o
                        ? (a.pos += 8)
                        : 64 & o
                          ? (a.pos += 4)
                          : 8 & o && (a.pos += 2);
        }
        return (
            (t.prototype.encode = function () {
                var t, e, r;
                for (
                    e = new ne(ve.call(this.raw.data)),
                        t = 0,
                        r = this.glyphIDs.length;
                    t < r;
                    ++t
                )
                    e.pos = this.glyphOffsets[t];
                return e.data;
            }),
            t
        );
    })(),
    Ne = (function (t) {
        function e() {
            return e.__super__.constructor.apply(this, arguments);
        }
        return (
            oe(e, re),
            (e.prototype.tag = "loca"),
            (e.prototype.parse = function (t) {
                var e, r;
                return (
                    (t.pos = this.offset),
                    (e = this.file.head.indexToLocFormat),
                    (this.offsets =
                        0 === e
                            ? function () {
                                  var e, n;
                                  for (
                                      n = [], r = 0, e = this.length;
                                      r < e;
                                      r += 2
                                  )
                                      n.push(2 * t.readUInt16());
                                  return n;
                              }.call(this)
                            : function () {
                                  var e, n;
                                  for (
                                      n = [], r = 0, e = this.length;
                                      r < e;
                                      r += 4
                                  )
                                      n.push(t.readUInt32());
                                  return n;
                              }.call(this))
                );
            }),
            (e.prototype.indexOf = function (t) {
                return this.offsets[t];
            }),
            (e.prototype.lengthOf = function (t) {
                return this.offsets[t + 1] - this.offsets[t];
            }),
            (e.prototype.encode = function (t, e) {
                for (
                    var r = new Uint32Array(this.offsets.length),
                        n = 0,
                        i = 0,
                        a = 0;
                    a < r.length;
                    ++a
                )
                    if (((r[a] = n), i < e.length && e[i] == a)) {
                        ++i, (r[a] = n);
                        var o = this.offsets[a],
                            s = this.offsets[a + 1] - o;
                        s > 0 && (n += s);
                    }
                for (var c = new Array(4 * r.length), u = 0; u < r.length; ++u)
                    (c[4 * u + 3] = 255 & r[u]),
                        (c[4 * u + 2] = (65280 & r[u]) >> 8),
                        (c[4 * u + 1] = (16711680 & r[u]) >> 16),
                        (c[4 * u] = (4278190080 & r[u]) >> 24);
                return c;
            }),
            e
        );
    })(),
    Le = (function () {
        function t(t) {
            (this.font = t),
                (this.subset = {}),
                (this.unicodes = {}),
                (this.next = 33);
        }
        return (
            (t.prototype.generateCmap = function () {
                var t, e, r, n, i;
                for (e in ((n = this.font.cmap.tables[0].codeMap),
                (t = {}),
                (i = this.subset)))
                    (r = i[e]), (t[e] = n[r]);
                return t;
            }),
            (t.prototype.glyphsFor = function (t) {
                var e, r, n, i, a, o, s;
                for (n = {}, a = 0, o = t.length; a < o; a++)
                    n[(i = t[a])] = this.font.glyf.glyphFor(i);
                for (i in ((e = []), n))
                    (null != (r = n[i]) ? r.compound : void 0) &&
                        e.push.apply(e, r.glyphIDs);
                if (e.length > 0)
                    for (i in (s = this.glyphsFor(e))) (r = s[i]), (n[i] = r);
                return n;
            }),
            (t.prototype.encode = function (t, e) {
                var r, n, i, a, o, s, c, u, h, l, f, d, p, g, m;
                for (n in ((r = ue.encode(this.generateCmap(), "unicode")),
                (a = this.glyphsFor(t)),
                (f = {
                    0: 0,
                }),
                (m = r.charMap)))
                    f[(s = m[n]).old] = s.new;
                for (d in ((l = r.maxGlyphID), a)) d in f || (f[d] = l++);
                return (
                    (u = (function (t) {
                        var e, r;
                        for (e in ((r = {}), t)) r[t[e]] = e;
                        return r;
                    })(f)),
                    (h = Object.keys(u).sort(function (t, e) {
                        return t - e;
                    })),
                    (p = (function () {
                        var t, e, r;
                        for (r = [], t = 0, e = h.length; t < e; t++)
                            (o = h[t]), r.push(u[o]);
                        return r;
                    })()),
                    (i = this.font.glyf.encode(a, p, f)),
                    (c = this.font.loca.encode(i.offsets, p)),
                    (g = {
                        cmap: this.font.cmap.raw(),
                        glyf: i.table,
                        loca: c,
                        hmtx: this.font.hmtx.raw(),
                        hhea: this.font.hhea.raw(),
                        maxp: this.font.maxp.raw(),
                        post: this.font.post.raw(),
                        name: this.font.name.raw(),
                        head: this.font.head.encode(e),
                    }),
                    this.font.os2.exists && (g["OS/2"] = this.font.os2.raw()),
                    this.font.directory.encode(g)
                );
            }),
            t
        );
    })();
E.API.PDFObject = (function () {
    var t;
    function e() {}
    return (
        (t = function (t, e) {
            return (Array(e + 1).join("0") + t).slice(-e);
        }),
        (e.convert = function (r) {
            var n, i, a, o;
            if (Array.isArray(r))
                return (
                    "[" +
                    (function () {
                        var t, i, a;
                        for (a = [], t = 0, i = r.length; t < i; t++)
                            (n = r[t]), a.push(e.convert(n));
                        return a;
                    })().join(" ") +
                    "]"
                );
            if ("string" == typeof r) return "/" + r;
            if (null != r ? r.isString : void 0) return "(" + r + ")";
            if (r instanceof Date)
                return (
                    "(D:" +
                    t(r.getUTCFullYear(), 4) +
                    t(r.getUTCMonth(), 2) +
                    t(r.getUTCDate(), 2) +
                    t(r.getUTCHours(), 2) +
                    t(r.getUTCMinutes(), 2) +
                    t(r.getUTCSeconds(), 2) +
                    "Z)"
                );
            if ("[object Object]" === {}.toString.call(r)) {
                for (i in ((a = ["<<"]), r))
                    (o = r[i]), a.push("/" + i + " " + e.convert(o));
                return a.push(">>"), a.join("\n");
            }
            return "" + r;
        }),
        e
    );
})();

var commonjsGlobal =
    typeof globalThis !== "undefined"
        ? globalThis
        : typeof window !== "undefined"
          ? window
          : typeof global !== "undefined"
            ? global
            : typeof self !== "undefined"
              ? self
              : {};

function getDefaultExportFromCjs(x) {
    return x &&
        x.__esModule &&
        Object.prototype.hasOwnProperty.call(x, "default")
        ? x["default"]
        : x;
}

/*! https://mths.be/cssesc v3.0.0 by @mathias */
var object = {};
var hasOwnProperty = object.hasOwnProperty;
var merge = function merge(options, defaults) {
    if (!options) {
        return defaults;
    }
    var result = {};
    for (var key in defaults) {
        // `if (defaults.hasOwnProperty(key) { … }` is not needed here, since
        // only recognized option names are used.
        result[key] = hasOwnProperty.call(options, key)
            ? options[key]
            : defaults[key];
    }
    return result;
};
var regexAnySingleEscape = /[ -,\.\/:-@\[-\^`\{-~]/;
var regexSingleEscape = /[ -,\.\/:-@\[\]\^`\{-~]/;
var regexExcessiveSpaces = /(^|\\+)?(\\[A-F0-9]{1,6})\x20(?![a-fA-F0-9\x20])/g;

// https://mathiasbynens.be/notes/css-escapes#css
var cssesc = function cssesc(string, options) {
    options = merge(options, cssesc.options);
    if (options.quotes != "single" && options.quotes != "double") {
        options.quotes = "single";
    }
    var quote = options.quotes == "double" ? '"' : "'";
    var isIdentifier = options.isIdentifier;
    var firstChar = string.charAt(0);
    var output = "";
    var counter = 0;
    var length = string.length;
    while (counter < length) {
        var character = string.charAt(counter++);
        var codePoint = character.charCodeAt();
        var value = void 0;
        // If it’s not a printable ASCII character…
        if (codePoint < 0x20 || codePoint > 0x7e) {
            if (
                codePoint >= 0xd800 &&
                codePoint <= 0xdbff &&
                counter < length
            ) {
                // It’s a high surrogate, and there is a next character.
                var extra = string.charCodeAt(counter++);
                if ((extra & 0xfc00) == 0xdc00) {
                    // next character is low surrogate
                    codePoint =
                        ((codePoint & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000;
                } else {
                    // It’s an unmatched surrogate; only append this code unit, in case
                    // the next code unit is the high surrogate of a surrogate pair.
                    counter--;
                }
            }
            value = "\\" + codePoint.toString(16).toUpperCase() + " ";
        } else {
            if (options.escapeEverything) {
                if (regexAnySingleEscape.test(character)) {
                    value = "\\" + character;
                } else {
                    value = "\\" + codePoint.toString(16).toUpperCase() + " ";
                }
            } else if (/[\t\n\f\r\x0B]/.test(character)) {
                value = "\\" + codePoint.toString(16).toUpperCase() + " ";
            } else if (
                character == "\\" ||
                (!isIdentifier &&
                    ((character == '"' && quote == character) ||
                        (character == "'" && quote == character))) ||
                (isIdentifier && regexSingleEscape.test(character))
            ) {
                value = "\\" + character;
            } else {
                value = character;
            }
        }
        output += value;
    }
    if (isIdentifier) {
        if (/^-[-\d]/.test(output)) {
            output = "\\-" + output.slice(1);
        } else if (/\d/.test(firstChar)) {
            output = "\\3" + firstChar + " " + output.slice(1);
        }
    }

    // Remove spaces after `\HEX` escapes that are not followed by a hex digit,
    // since they’re redundant. Note that this is only possible if the escape
    // sequence isn’t preceded by an odd number of backslashes.
    output = output.replace(regexExcessiveSpaces, function ($0, $1, $2) {
        if ($1 && $1.length % 2) {
            // It’s not safe to remove the space, so don’t.
            return $0;
        }
        // Strip the space.
        return ($1 || "") + $2;
    });
    if (!isIdentifier && options.wrap) {
        return quote + output + quote;
    }
    return output;
};

// Expose default options (so they can be overridden globally).
cssesc.options = {
    escapeEverything: false,
    isIdentifier: false,
    quotes: "single",
    wrap: false,
};
cssesc.version = "3.0.0";
var cssesc_1 = cssesc;

// parse
// =====

// states
// ------

var PLAIN = 0;
var STRINGS = 1;
var ESCAPING = 2;
var IDENTIFIER = 3;
var SEPARATING = 4;
var SPACEAFTERIDENTIFIER = 5;
var ESCAPINGIDENTIFIER = 6;

// patterns
// --------

var identifierPattern = /[a-z0-9_-]/i;
var spacePattern = /[\s\t]/;

// ---

var parse$1 = function (str) {
    // vars
    // ----

    var starting = true;
    var state = PLAIN;
    var buffer = "";
    var i = 0;
    var quote;
    var c;

    // result
    // ------

    var names = [];

    // parse
    // -----

    while (true) {
        c = str[i];
        if (state === PLAIN) {
            if (!c && starting) {
                break;
            } else if (!c && !starting) {
                throw new Error("Parse error");
            } else if (c === '"' || c === "'") {
                quote = c;
                state = STRINGS;
                starting = false;
            } else if (spacePattern.test(c));
            else if (identifierPattern.test(c)) {
                state = IDENTIFIER;
                starting = false;
                i--;
            } else {
                throw new Error("Parse error");
            }
        } else if (state === STRINGS) {
            if (!c) {
                throw new Error("Parse Error");
            } else if (c === "\\") {
                state = ESCAPING;
            } else if (c === quote) {
                names.push(buffer);
                buffer = "";
                state = SEPARATING;
            } else {
                buffer += c;
            }
        } else if (state === ESCAPING) {
            if (c === quote || c === "\\") {
                buffer += c;
                state = STRINGS;
            } else {
                throw new Error("Parse error");
            }
        } else if (state === IDENTIFIER) {
            if (!c) {
                names.push(buffer);
                break;
            } else if (identifierPattern.test(c)) {
                buffer += c;
            } else if (c === ",") {
                names.push(buffer);
                buffer = "";
                state = PLAIN;
            } else if (spacePattern.test(c)) {
                state = SPACEAFTERIDENTIFIER;
            } else if (c === "\\") {
                state = ESCAPINGIDENTIFIER;
            } else;
        } else if (state === ESCAPINGIDENTIFIER) {
            if (/[0-9a-f]/i.test(c)) {
                // TODO: Support escaped unicode characters (backslash followed by hex digits)
                // https://developer.mozilla.org/en-US/docs/Web/CSS/custom-ident

                throw new Error("Parse error");
            } else {
                buffer += c;
                state = IDENTIFIER;
            }
        } else if (state === SPACEAFTERIDENTIFIER) {
            if (!c) {
                names.push(buffer);
                break;
            } else if (identifierPattern.test(c)) {
                buffer += " " + c;
                state = IDENTIFIER;
            } else if (c === ",") {
                names.push(buffer);
                buffer = "";
                state = PLAIN;
            } else if (spacePattern.test(c));
            else {
                throw new Error("Parse error");
            }
        } else if (state === SEPARATING) {
            if (!c) {
                break;
            } else if (c === ",") {
                state = PLAIN;
            } else if (spacePattern.test(c));
            else {
                throw new Error("Parse error");
            }
        }
        i++;
    }

    // result
    // ------

    return names;
};

// stringify
// =========

// pattern
// -------

var stringsPattern = /[^a-z0-9_-]/i;

// ---

var stringify = function (names, options) {
    // quote
    // -----

    var quote = (options && options.quote) || '"';
    if (quote !== '"' && quote !== "'") {
        throw new Error("Quote must be `'` or `\"`");
    }
    var quotePattern = new RegExp(quote, "g");

    // stringify
    // ---------

    var safeNames = [];
    for (var i = 0; i < names.length; ++i) {
        var name = names[i];
        if (stringsPattern.test(name)) {
            name = name
                .replace(/\\/g, "\\\\")
                .replace(quotePattern, "\\" + quote);
            name = quote + name + quote;
        }
        safeNames.push(name);
    }

    // result
    // ------

    return safeNames.join(", ");
};

// export
// ======

var fontFamilyPapandreou = {
    parse: parse$1,
    stringify: stringify,
};

var svgpathExports = {};
var svgpath$1 = {
    get exports() {
        return svgpathExports;
    },
    set exports(v) {
        svgpathExports = v;
    },
};

var paramCounts = {
    a: 7,
    c: 6,
    h: 1,
    l: 2,
    m: 2,
    r: 4,
    q: 4,
    s: 4,
    t: 2,
    v: 1,
    z: 0,
};
var SPECIAL_SPACES = [
    0x1680, 0x180e, 0x2000, 0x2001, 0x2002, 0x2003, 0x2004, 0x2005, 0x2006,
    0x2007, 0x2008, 0x2009, 0x200a, 0x202f, 0x205f, 0x3000, 0xfeff,
];
function isSpace(ch) {
    return (
        ch === 0x0a ||
        ch === 0x0d ||
        ch === 0x2028 ||
        ch === 0x2029 ||
        // Line terminators
        // White spaces
        ch === 0x20 ||
        ch === 0x09 ||
        ch === 0x0b ||
        ch === 0x0c ||
        ch === 0xa0 ||
        (ch >= 0x1680 && SPECIAL_SPACES.indexOf(ch) >= 0)
    );
}
function isCommand(code) {
    /*eslint-disable no-bitwise*/
    switch (code | 0x20) {
        case 0x6d /* m */:
        case 0x7a /* z */:
        case 0x6c /* l */:
        case 0x68 /* h */:
        case 0x76 /* v */:
        case 0x63 /* c */:
        case 0x73 /* s */:
        case 0x71 /* q */:
        case 0x74 /* t */:
        case 0x61 /* a */:
        case 0x72 /* r */:
            return true;
    }
    return false;
}
function isArc(code) {
    return (code | 0x20) === 0x61;
}
function isDigit(code) {
    return code >= 48 && code <= 57; // 0..9
}

function isDigitStart(code) {
    return (
        (code >= 48 && code <= 57) /* 0..9 */ ||
        code === 0x2b /* + */ ||
        code === 0x2d /* - */ ||
        code === 0x2e
    ); /* . */
}

function State(path) {
    this.index = 0;
    this.path = path;
    this.max = path.length;
    this.result = [];
    this.param = 0.0;
    this.err = "";
    this.segmentStart = 0;
    this.data = [];
}
function skipSpaces(state) {
    while (
        state.index < state.max &&
        isSpace(state.path.charCodeAt(state.index))
    ) {
        state.index++;
    }
}
function scanFlag(state) {
    var ch = state.path.charCodeAt(state.index);
    if (ch === 0x30 /* 0 */) {
        state.param = 0;
        state.index++;
        return;
    }
    if (ch === 0x31 /* 1 */) {
        state.param = 1;
        state.index++;
        return;
    }
    state.err =
        "SvgPath: arc flag can be 0 or 1 only (at pos " + state.index + ")";
}
function scanParam(state) {
    var start = state.index,
        index = start,
        max = state.max,
        zeroFirst = false,
        hasCeiling = false,
        hasDecimal = false,
        hasDot = false,
        ch;
    if (index >= max) {
        state.err = "SvgPath: missed param (at pos " + index + ")";
        return;
    }
    ch = state.path.charCodeAt(index);
    if (ch === 0x2b /* + */ || ch === 0x2d /* - */) {
        index++;
        ch = index < max ? state.path.charCodeAt(index) : 0;
    }

    // This logic is shamelessly borrowed from Esprima
    // https://github.com/ariya/esprimas
    //
    if (!isDigit(ch) && ch !== 0x2e /* . */) {
        state.err =
            "SvgPath: param should start with 0..9 or `.` (at pos " +
            index +
            ")";
        return;
    }
    if (ch !== 0x2e /* . */) {
        zeroFirst = ch === 0x30 /* 0 */;
        index++;
        ch = index < max ? state.path.charCodeAt(index) : 0;
        if (zeroFirst && index < max) {
            // decimal number starts with '0' such as '09' is illegal.
            if (ch && isDigit(ch)) {
                state.err =
                    "SvgPath: numbers started with `0` such as `09` are illegal (at pos " +
                    start +
                    ")";
                return;
            }
        }
        while (index < max && isDigit(state.path.charCodeAt(index))) {
            index++;
            hasCeiling = true;
        }
        ch = index < max ? state.path.charCodeAt(index) : 0;
    }
    if (ch === 0x2e /* . */) {
        hasDot = true;
        index++;
        while (isDigit(state.path.charCodeAt(index))) {
            index++;
            hasDecimal = true;
        }
        ch = index < max ? state.path.charCodeAt(index) : 0;
    }
    if (ch === 0x65 /* e */ || ch === 0x45 /* E */) {
        if (hasDot && !hasCeiling && !hasDecimal) {
            state.err =
                "SvgPath: invalid float exponent (at pos " + index + ")";
            return;
        }
        index++;
        ch = index < max ? state.path.charCodeAt(index) : 0;
        if (ch === 0x2b /* + */ || ch === 0x2d /* - */) {
            index++;
        }
        if (index < max && isDigit(state.path.charCodeAt(index))) {
            while (index < max && isDigit(state.path.charCodeAt(index))) {
                index++;
            }
        } else {
            state.err =
                "SvgPath: invalid float exponent (at pos " + index + ")";
            return;
        }
    }
    state.index = index;
    state.param = parseFloat(state.path.slice(start, index)) + 0.0;
}
function finalizeSegment(state) {
    var cmd, cmdLC;

    // Process duplicated commands (without comand name)

    // This logic is shamelessly borrowed from Raphael
    // https://github.com/DmitryBaranovskiy/raphael/
    //
    cmd = state.path[state.segmentStart];
    cmdLC = cmd.toLowerCase();
    var params = state.data;
    if (cmdLC === "m" && params.length > 2) {
        state.result.push([cmd, params[0], params[1]]);
        params = params.slice(2);
        cmdLC = "l";
        cmd = cmd === "m" ? "l" : "L";
    }
    if (cmdLC === "r") {
        state.result.push([cmd].concat(params));
    } else {
        while (params.length >= paramCounts[cmdLC]) {
            state.result.push(
                [cmd].concat(params.splice(0, paramCounts[cmdLC])),
            );
            if (!paramCounts[cmdLC]) {
                break;
            }
        }
    }
}
function scanSegment(state) {
    var max = state.max,
        cmdCode,
        is_arc,
        comma_found,
        need_params,
        i;
    state.segmentStart = state.index;
    cmdCode = state.path.charCodeAt(state.index);
    is_arc = isArc(cmdCode);
    if (!isCommand(cmdCode)) {
        state.err =
            "SvgPath: bad command " +
            state.path[state.index] +
            " (at pos " +
            state.index +
            ")";
        return;
    }
    need_params = paramCounts[state.path[state.index].toLowerCase()];
    state.index++;
    skipSpaces(state);
    state.data = [];
    if (!need_params) {
        // Z
        finalizeSegment(state);
        return;
    }
    comma_found = false;
    for (;;) {
        for (i = need_params; i > 0; i--) {
            if (is_arc && (i === 3 || i === 4)) scanFlag(state);
            else scanParam(state);
            if (state.err.length) {
                return;
            }
            state.data.push(state.param);
            skipSpaces(state);
            comma_found = false;
            if (
                state.index < max &&
                state.path.charCodeAt(state.index) === 0x2c /* , */
            ) {
                state.index++;
                skipSpaces(state);
                comma_found = true;
            }
        }

        // after ',' param is mandatory
        if (comma_found) {
            continue;
        }
        if (state.index >= state.max) {
            break;
        }

        // Stop on next segment
        if (!isDigitStart(state.path.charCodeAt(state.index))) {
            break;
        }
    }
    finalizeSegment(state);
}

/* Returns array of segments:
 *
 * [
 *   [ command, coord1, coord2, ... ]
 * ]
 */
var path_parse = function pathParse(svgPath) {
    var state = new State(svgPath);
    var max = state.max;
    skipSpaces(state);
    while (state.index < max && !state.err.length) {
        scanSegment(state);
    }
    if (state.err.length) {
        state.result = [];
    } else if (state.result.length) {
        if ("mM".indexOf(state.result[0][0]) < 0) {
            state.err = "SvgPath: string should start with `M` or `m`";
            state.result = [];
        } else {
            state.result[0][0] = "M";
        }
    }
    return {
        err: state.err,
        segments: state.result,
    };
};

// combine 2 matrixes
// m1, m2 - [a, b, c, d, e, g]
//
function combine(m1, m2) {
    return [
        m1[0] * m2[0] + m1[2] * m2[1],
        m1[1] * m2[0] + m1[3] * m2[1],
        m1[0] * m2[2] + m1[2] * m2[3],
        m1[1] * m2[2] + m1[3] * m2[3],
        m1[0] * m2[4] + m1[2] * m2[5] + m1[4],
        m1[1] * m2[4] + m1[3] * m2[5] + m1[5],
    ];
}
function Matrix$1() {
    if (!(this instanceof Matrix$1)) {
        return new Matrix$1();
    }
    this.queue = []; // list of matrixes to apply
    this.cache = null; // combined matrix cache
}

Matrix$1.prototype.matrix = function (m) {
    if (
        m[0] === 1 &&
        m[1] === 0 &&
        m[2] === 0 &&
        m[3] === 1 &&
        m[4] === 0 &&
        m[5] === 0
    ) {
        return this;
    }
    this.cache = null;
    this.queue.push(m);
    return this;
};
Matrix$1.prototype.translate = function (tx, ty) {
    if (tx !== 0 || ty !== 0) {
        this.cache = null;
        this.queue.push([1, 0, 0, 1, tx, ty]);
    }
    return this;
};
Matrix$1.prototype.scale = function (sx, sy) {
    if (sx !== 1 || sy !== 1) {
        this.cache = null;
        this.queue.push([sx, 0, 0, sy, 0, 0]);
    }
    return this;
};
Matrix$1.prototype.rotate = function (angle, rx, ry) {
    var rad, cos, sin;
    if (angle !== 0) {
        this.translate(rx, ry);
        rad = (angle * Math.PI) / 180;
        cos = Math.cos(rad);
        sin = Math.sin(rad);
        this.queue.push([cos, sin, -sin, cos, 0, 0]);
        this.cache = null;
        this.translate(-rx, -ry);
    }
    return this;
};
Matrix$1.prototype.skewX = function (angle) {
    if (angle !== 0) {
        this.cache = null;
        this.queue.push([1, 0, Math.tan((angle * Math.PI) / 180), 1, 0, 0]);
    }
    return this;
};
Matrix$1.prototype.skewY = function (angle) {
    if (angle !== 0) {
        this.cache = null;
        this.queue.push([1, Math.tan((angle * Math.PI) / 180), 0, 1, 0, 0]);
    }
    return this;
};

// Flatten queue
//
Matrix$1.prototype.toArray = function () {
    if (this.cache) {
        return this.cache;
    }
    if (!this.queue.length) {
        this.cache = [1, 0, 0, 1, 0, 0];
        return this.cache;
    }
    this.cache = this.queue[0];
    if (this.queue.length === 1) {
        return this.cache;
    }
    for (var i = 1; i < this.queue.length; i++) {
        this.cache = combine(this.cache, this.queue[i]);
    }
    return this.cache;
};

// Apply list of matrixes to (x,y) point.
// If `isRelative` set, `translate` component of matrix will be skipped
//
Matrix$1.prototype.calc = function (x, y, isRelative) {
    var m;

    // Don't change point on empty transforms queue
    if (!this.queue.length) {
        return [x, y];
    }

    // Calculate final matrix, if not exists
    //
    // NB. if you deside to apply transforms to point one-by-one,
    // they should be taken in reverse order

    if (!this.cache) {
        this.cache = this.toArray();
    }
    m = this.cache;

    // Apply matrix to point
    return [
        x * m[0] + y * m[2] + (isRelative ? 0 : m[4]),
        x * m[1] + y * m[3] + (isRelative ? 0 : m[5]),
    ];
};
var matrix$1 = Matrix$1;

var Matrix = matrix$1;
var operations = {
    matrix: true,
    scale: true,
    rotate: true,
    translate: true,
    skewX: true,
    skewY: true,
};
var CMD_SPLIT_RE =
    /\s*(matrix|translate|scale|rotate|skewX|skewY)\s*\(\s*(.+?)\s*\)[\s,]*/;
var PARAMS_SPLIT_RE = /[\s,]+/;
var transform_parse = function transformParse(transformString) {
    var matrix = new Matrix();
    var cmd, params;

    // Split value into ['', 'translate', '10 50', '', 'scale', '2', '', 'rotate',  '-45', '']
    transformString.split(CMD_SPLIT_RE).forEach(function (item) {
        // Skip empty elements
        if (!item.length) {
            return;
        }

        // remember operation
        if (typeof operations[item] !== "undefined") {
            cmd = item;
            return;
        }

        // extract params & att operation to matrix
        params = item.split(PARAMS_SPLIT_RE).map(function (i) {
            return +i || 0;
        });

        // If params count is not correct - ignore command
        switch (cmd) {
            case "matrix":
                if (params.length === 6) {
                    matrix.matrix(params);
                }
                return;
            case "scale":
                if (params.length === 1) {
                    matrix.scale(params[0], params[0]);
                } else if (params.length === 2) {
                    matrix.scale(params[0], params[1]);
                }
                return;
            case "rotate":
                if (params.length === 1) {
                    matrix.rotate(params[0], 0, 0);
                } else if (params.length === 3) {
                    matrix.rotate(params[0], params[1], params[2]);
                }
                return;
            case "translate":
                if (params.length === 1) {
                    matrix.translate(params[0], 0);
                } else if (params.length === 2) {
                    matrix.translate(params[0], params[1]);
                }
                return;
            case "skewX":
                if (params.length === 1) {
                    matrix.skewX(params[0]);
                }
                return;
            case "skewY":
                if (params.length === 1) {
                    matrix.skewY(params[0]);
                }
                return;
        }
    });
    return matrix;
};

var TAU = Math.PI * 2;

/* eslint-disable space-infix-ops */

// Calculate an angle between two unit vectors
//
// Since we measure angle between radii of circular arcs,
// we can use simplified math (without length normalization)
//
function unit_vector_angle(ux, uy, vx, vy) {
    var sign = ux * vy - uy * vx < 0 ? -1 : 1;
    var dot = ux * vx + uy * vy;

    // Add this to work with arbitrary vectors:
    // dot /= Math.sqrt(ux * ux + uy * uy) * Math.sqrt(vx * vx + vy * vy);

    // rounding errors, e.g. -1.0000000000000002 can screw up this
    if (dot > 1.0) {
        dot = 1.0;
    }
    if (dot < -1.0) {
        dot = -1.0;
    }
    return sign * Math.acos(dot);
}

// Convert from endpoint to center parameterization,
// see http://www.w3.org/TR/SVG11/implnote.html#ArcImplementationNotes
//
// Return [cx, cy, theta1, delta_theta]
//
function get_arc_center(x1, y1, x2, y2, fa, fs, rx, ry, sin_phi, cos_phi) {
    // Step 1.
    //
    // Moving an ellipse so origin will be the middlepoint between our two
    // points. After that, rotate it to line up ellipse axes with coordinate
    // axes.
    //
    var x1p = (cos_phi * (x1 - x2)) / 2 + (sin_phi * (y1 - y2)) / 2;
    var y1p = (-sin_phi * (x1 - x2)) / 2 + (cos_phi * (y1 - y2)) / 2;
    var rx_sq = rx * rx;
    var ry_sq = ry * ry;
    var x1p_sq = x1p * x1p;
    var y1p_sq = y1p * y1p;

    // Step 2.
    //
    // Compute coordinates of the centre of this ellipse (cx', cy')
    // in the new coordinate system.
    //
    var radicant = rx_sq * ry_sq - rx_sq * y1p_sq - ry_sq * x1p_sq;
    if (radicant < 0) {
        // due to rounding errors it might be e.g. -1.3877787807814457e-17
        radicant = 0;
    }
    radicant /= rx_sq * y1p_sq + ry_sq * x1p_sq;
    radicant = Math.sqrt(radicant) * (fa === fs ? -1 : 1);
    var cxp = ((radicant * rx) / ry) * y1p;
    var cyp = ((radicant * -ry) / rx) * x1p;

    // Step 3.
    //
    // Transform back to get centre coordinates (cx, cy) in the original
    // coordinate system.
    //
    var cx = cos_phi * cxp - sin_phi * cyp + (x1 + x2) / 2;
    var cy = sin_phi * cxp + cos_phi * cyp + (y1 + y2) / 2;

    // Step 4.
    //
    // Compute angles (theta1, delta_theta).
    //
    var v1x = (x1p - cxp) / rx;
    var v1y = (y1p - cyp) / ry;
    var v2x = (-x1p - cxp) / rx;
    var v2y = (-y1p - cyp) / ry;
    var theta1 = unit_vector_angle(1, 0, v1x, v1y);
    var delta_theta = unit_vector_angle(v1x, v1y, v2x, v2y);
    if (fs === 0 && delta_theta > 0) {
        delta_theta -= TAU;
    }
    if (fs === 1 && delta_theta < 0) {
        delta_theta += TAU;
    }
    return [cx, cy, theta1, delta_theta];
}

//
// Approximate one unit arc segment with bézier curves,
// see http://math.stackexchange.com/questions/873224
//
function approximate_unit_arc(theta1, delta_theta) {
    var alpha = (4 / 3) * Math.tan(delta_theta / 4);
    var x1 = Math.cos(theta1);
    var y1 = Math.sin(theta1);
    var x2 = Math.cos(theta1 + delta_theta);
    var y2 = Math.sin(theta1 + delta_theta);
    return [
        x1,
        y1,
        x1 - y1 * alpha,
        y1 + x1 * alpha,
        x2 + y2 * alpha,
        y2 - x2 * alpha,
        x2,
        y2,
    ];
}
var a2c$1 = function a2c(x1, y1, x2, y2, fa, fs, rx, ry, phi) {
    var sin_phi = Math.sin((phi * TAU) / 360);
    var cos_phi = Math.cos((phi * TAU) / 360);

    // Make sure radii are valid
    //
    var x1p = (cos_phi * (x1 - x2)) / 2 + (sin_phi * (y1 - y2)) / 2;
    var y1p = (-sin_phi * (x1 - x2)) / 2 + (cos_phi * (y1 - y2)) / 2;
    if (x1p === 0 && y1p === 0) {
        // we're asked to draw line to itself
        return [];
    }
    if (rx === 0 || ry === 0) {
        // one of the radii is zero
        return [];
    }

    // Compensate out-of-range radii
    //
    rx = Math.abs(rx);
    ry = Math.abs(ry);
    var lambda = (x1p * x1p) / (rx * rx) + (y1p * y1p) / (ry * ry);
    if (lambda > 1) {
        rx *= Math.sqrt(lambda);
        ry *= Math.sqrt(lambda);
    }

    // Get center parameters (cx, cy, theta1, delta_theta)
    //
    var cc = get_arc_center(x1, y1, x2, y2, fa, fs, rx, ry, sin_phi, cos_phi);
    var result = [];
    var theta1 = cc[2];
    var delta_theta = cc[3];

    // Split an arc to multiple segments, so each segment
    // will be less than τ/4 (= 90°)
    //
    var segments = Math.max(Math.ceil(Math.abs(delta_theta) / (TAU / 4)), 1);
    delta_theta /= segments;
    for (var i = 0; i < segments; i++) {
        result.push(approximate_unit_arc(theta1, delta_theta));
        theta1 += delta_theta;
    }

    // We have a bezier approximation of a unit circle,
    // now need to transform back to the original ellipse
    //
    return result.map(function (curve) {
        for (var i = 0; i < curve.length; i += 2) {
            var x = curve[i + 0];
            var y = curve[i + 1];

            // scale
            x *= rx;
            y *= ry;

            // rotate
            var xp = cos_phi * x - sin_phi * y;
            var yp = sin_phi * x + cos_phi * y;

            // translate
            curve[i + 0] = xp + cc[0];
            curve[i + 1] = yp + cc[1];
        }
        return curve;
    });
};

/* eslint-disable space-infix-ops */

// The precision used to consider an ellipse as a circle
//
var epsilon = 0.0000000001;

// To convert degree in radians
//
var torad = Math.PI / 180;

// Class constructor :
//  an ellipse centred at 0 with radii rx,ry and x - axis - angle ax.
//
function Ellipse$1(rx, ry, ax) {
    if (!(this instanceof Ellipse$1)) {
        return new Ellipse$1(rx, ry, ax);
    }
    this.rx = rx;
    this.ry = ry;
    this.ax = ax;
}

// Apply a linear transform m to the ellipse
// m is an array representing a matrix :
//    -         -
//   | m[0] m[2] |
//   | m[1] m[3] |
//    -         -
//
Ellipse$1.prototype.transform = function (m) {
    // We consider the current ellipse as image of the unit circle
    // by first scale(rx,ry) and then rotate(ax) ...
    // So we apply ma =  m x rotate(ax) x scale(rx,ry) to the unit circle.
    var c = Math.cos(this.ax * torad),
        s = Math.sin(this.ax * torad);
    var ma = [
        this.rx * (m[0] * c + m[2] * s),
        this.rx * (m[1] * c + m[3] * s),
        this.ry * (-m[0] * s + m[2] * c),
        this.ry * (-m[1] * s + m[3] * c),
    ];

    // ma * transpose(ma) = [ J L ]
    //                      [ L K ]
    // L is calculated later (if the image is not a circle)
    var J = ma[0] * ma[0] + ma[2] * ma[2],
        K = ma[1] * ma[1] + ma[3] * ma[3];

    // the discriminant of the characteristic polynomial of ma * transpose(ma)
    var D =
        ((ma[0] - ma[3]) * (ma[0] - ma[3]) +
            (ma[2] + ma[1]) * (ma[2] + ma[1])) *
        ((ma[0] + ma[3]) * (ma[0] + ma[3]) + (ma[2] - ma[1]) * (ma[2] - ma[1]));

    // the "mean eigenvalue"
    var JK = (J + K) / 2;

    // check if the image is (almost) a circle
    if (D < epsilon * JK) {
        // if it is
        this.rx = this.ry = Math.sqrt(JK);
        this.ax = 0;
        return this;
    }

    // if it is not a circle
    var L = ma[0] * ma[1] + ma[2] * ma[3];
    D = Math.sqrt(D);

    // {l1,l2} = the two eigen values of ma * transpose(ma)
    var l1 = JK + D / 2,
        l2 = JK - D / 2;
    // the x - axis - rotation angle is the argument of the l1 - eigenvector
    /*eslint-disable indent*/
    this.ax =
        Math.abs(L) < epsilon && Math.abs(l1 - K) < epsilon
            ? 90
            : (Math.atan(
                  Math.abs(L) > Math.abs(l1 - K) ? (l1 - J) / L : L / (l1 - K),
              ) *
                  180) /
              Math.PI;
    /*eslint-enable indent*/

    // if ax > 0 => rx = sqrt(l1), ry = sqrt(l2), else exchange axes and ax += 90
    if (this.ax >= 0) {
        // if ax in [0,90]
        this.rx = Math.sqrt(l1);
        this.ry = Math.sqrt(l2);
    } else {
        // if ax in ]-90,0[ => exchange axes
        this.ax += 90;
        this.rx = Math.sqrt(l2);
        this.ry = Math.sqrt(l1);
    }
    return this;
};

// Check if the ellipse is (almost) degenerate, i.e. rx = 0 or ry = 0
//
Ellipse$1.prototype.isDegenerate = function () {
    return this.rx < epsilon * this.ry || this.ry < epsilon * this.rx;
};
var ellipse$1 = Ellipse$1;

var pathParse = path_parse;
var transformParse = transform_parse;
var matrix = matrix$1;
var a2c = a2c$1;
var ellipse = ellipse$1;

// Class constructor
//
function SvgPath$1(path) {
    if (!(this instanceof SvgPath$1)) {
        return new SvgPath$1(path);
    }
    var pstate = pathParse(path);

    // Array of path segments.
    // Each segment is array [command, param1, param2, ...]
    this.segments = pstate.segments;

    // Error message on parse error.
    this.err = pstate.err;

    // Transforms stack for lazy evaluation
    this.__stack = [];
}
SvgPath$1.from = function (src) {
    if (typeof src === "string") return new SvgPath$1(src);
    if (src instanceof SvgPath$1) {
        // Create empty object
        var s = new SvgPath$1("");

        // Clone properies
        s.err = src.err;
        s.segments = src.segments.map(function (sgm) {
            return sgm.slice();
        });
        s.__stack = src.__stack.map(function (m) {
            return matrix().matrix(m.toArray());
        });
        return s;
    }
    throw new Error("SvgPath.from: invalid param type " + src);
};
SvgPath$1.prototype.__matrix = function (m) {
    var self = this,
        i;

    // Quick leave for empty matrix
    if (!m.queue.length) {
        return;
    }
    this.iterate(function (s, index, x, y) {
        var p, result, name, isRelative;
        switch (s[0]) {
            // Process 'assymetric' commands separately
            case "v":
                p = m.calc(0, s[1], true);
                result = p[0] === 0 ? ["v", p[1]] : ["l", p[0], p[1]];
                break;
            case "V":
                p = m.calc(x, s[1], false);
                result =
                    p[0] === m.calc(x, y, false)[0]
                        ? ["V", p[1]]
                        : ["L", p[0], p[1]];
                break;
            case "h":
                p = m.calc(s[1], 0, true);
                result = p[1] === 0 ? ["h", p[0]] : ["l", p[0], p[1]];
                break;
            case "H":
                p = m.calc(s[1], y, false);
                result =
                    p[1] === m.calc(x, y, false)[1]
                        ? ["H", p[0]]
                        : ["L", p[0], p[1]];
                break;
            case "a":
            case "A":
                // ARC is: ['A', rx, ry, x-axis-rotation, large-arc-flag, sweep-flag, x, y]

                // Drop segment if arc is empty (end point === start point)
                /*if ((s[0] === 'A' && s[6] === x && s[7] === y) ||
            (s[0] === 'a' && s[6] === 0 && s[7] === 0)) {
          return [];
        }*/

                // Transform rx, ry and the x-axis-rotation
                var ma = m.toArray();
                var e = ellipse(s[1], s[2], s[3]).transform(ma);

                // flip sweep-flag if matrix is not orientation-preserving
                if (ma[0] * ma[3] - ma[1] * ma[2] < 0) {
                    s[5] = s[5] ? "0" : "1";
                }

                // Transform end point as usual (without translation for relative notation)
                p = m.calc(s[6], s[7], s[0] === "a");

                // Empty arcs can be ignored by renderer, but should not be dropped
                // to avoid collisions with `S A S` and so on. Replace with empty line.
                if (
                    (s[0] === "A" && s[6] === x && s[7] === y) ||
                    (s[0] === "a" && s[6] === 0 && s[7] === 0)
                ) {
                    result = [s[0] === "a" ? "l" : "L", p[0], p[1]];
                    break;
                }

                // if the resulting ellipse is (almost) a segment ...
                if (e.isDegenerate()) {
                    // replace the arc by a line
                    result = [s[0] === "a" ? "l" : "L", p[0], p[1]];
                } else {
                    // if it is a real ellipse
                    // s[0], s[4] and s[5] are not modified
                    result = [s[0], e.rx, e.ry, e.ax, s[4], s[5], p[0], p[1]];
                }
                break;
            case "m":
                // Edge case. The very first `m` should be processed as absolute, if happens.
                // Make sense for coord shift transforms.
                isRelative = index > 0;
                p = m.calc(s[1], s[2], isRelative);
                result = ["m", p[0], p[1]];
                break;
            default:
                name = s[0];
                result = [name];
                isRelative = name.toLowerCase() === name;

                // Apply transformations to the segment
                for (i = 1; i < s.length; i += 2) {
                    p = m.calc(s[i], s[i + 1], isRelative);
                    result.push(p[0], p[1]);
                }
        }
        self.segments[index] = result;
    }, true);
};

// Apply stacked commands
//
SvgPath$1.prototype.__evaluateStack = function () {
    var m, i;
    if (!this.__stack.length) {
        return;
    }
    if (this.__stack.length === 1) {
        this.__matrix(this.__stack[0]);
        this.__stack = [];
        return;
    }
    m = matrix();
    i = this.__stack.length;
    while (--i >= 0) {
        m.matrix(this.__stack[i].toArray());
    }
    this.__matrix(m);
    this.__stack = [];
};

// Convert processed SVG Path back to string
//
SvgPath$1.prototype.toString = function () {
    var elements = [],
        skipCmd,
        cmd;
    this.__evaluateStack();
    for (var i = 0; i < this.segments.length; i++) {
        // remove repeating commands names
        cmd = this.segments[i][0];
        skipCmd =
            i > 0 &&
            cmd !== "m" &&
            cmd !== "M" &&
            cmd === this.segments[i - 1][0];
        elements = elements.concat(
            skipCmd ? this.segments[i].slice(1) : this.segments[i],
        );
    }
    return (
        elements
            .join(" ")
            // Optimizations: remove spaces around commands & before `-`
            //
            // We could also remove leading zeros for `0.5`-like values,
            // but their count is too small to spend time for.
            .replace(/ ?([achlmqrstvz]) ?/gi, "$1")
            .replace(/ \-/g, "-")
            // workaround for FontForge SVG importing bug
            .replace(/zm/g, "z m")
    );
};

// Translate path to (x [, y])
//
SvgPath$1.prototype.translate = function (x, y) {
    this.__stack.push(matrix().translate(x, y || 0));
    return this;
};

// Scale path to (sx [, sy])
// sy = sx if not defined
//
SvgPath$1.prototype.scale = function (sx, sy) {
    this.__stack.push(matrix().scale(sx, !sy && sy !== 0 ? sx : sy));
    return this;
};

// Rotate path around point (sx [, sy])
// sy = sx if not defined
//
SvgPath$1.prototype.rotate = function (angle, rx, ry) {
    this.__stack.push(matrix().rotate(angle, rx || 0, ry || 0));
    return this;
};

// Skew path along the X axis by `degrees` angle
//
SvgPath$1.prototype.skewX = function (degrees) {
    this.__stack.push(matrix().skewX(degrees));
    return this;
};

// Skew path along the Y axis by `degrees` angle
//
SvgPath$1.prototype.skewY = function (degrees) {
    this.__stack.push(matrix().skewY(degrees));
    return this;
};

// Apply matrix transform (array of 6 elements)
//
SvgPath$1.prototype.matrix = function (m) {
    this.__stack.push(matrix().matrix(m));
    return this;
};

// Transform path according to "transform" attr of SVG spec
//
SvgPath$1.prototype.transform = function (transformString) {
    if (!transformString.trim()) {
        return this;
    }
    this.__stack.push(transformParse(transformString));
    return this;
};

// Round coords with given decimal precition.
// 0 by default (to integers)
//
SvgPath$1.prototype.round = function (d) {
    var contourStartDeltaX = 0,
        contourStartDeltaY = 0,
        deltaX = 0,
        deltaY = 0,
        l;
    d = d || 0;
    this.__evaluateStack();
    this.segments.forEach(function (s) {
        var isRelative = s[0].toLowerCase() === s[0];
        switch (s[0]) {
            case "H":
            case "h":
                if (isRelative) {
                    s[1] += deltaX;
                }
                deltaX = s[1] - s[1].toFixed(d);
                s[1] = +s[1].toFixed(d);
                return;
            case "V":
            case "v":
                if (isRelative) {
                    s[1] += deltaY;
                }
                deltaY = s[1] - s[1].toFixed(d);
                s[1] = +s[1].toFixed(d);
                return;
            case "Z":
            case "z":
                deltaX = contourStartDeltaX;
                deltaY = contourStartDeltaY;
                return;
            case "M":
            case "m":
                if (isRelative) {
                    s[1] += deltaX;
                    s[2] += deltaY;
                }
                deltaX = s[1] - s[1].toFixed(d);
                deltaY = s[2] - s[2].toFixed(d);
                contourStartDeltaX = deltaX;
                contourStartDeltaY = deltaY;
                s[1] = +s[1].toFixed(d);
                s[2] = +s[2].toFixed(d);
                return;
            case "A":
            case "a":
                // [cmd, rx, ry, x-axis-rotation, large-arc-flag, sweep-flag, x, y]
                if (isRelative) {
                    s[6] += deltaX;
                    s[7] += deltaY;
                }
                deltaX = s[6] - s[6].toFixed(d);
                deltaY = s[7] - s[7].toFixed(d);
                s[1] = +s[1].toFixed(d);
                s[2] = +s[2].toFixed(d);
                s[3] = +s[3].toFixed(d + 2); // better precision for rotation
                s[6] = +s[6].toFixed(d);
                s[7] = +s[7].toFixed(d);
                return;
            default:
                // a c l q s t
                l = s.length;
                if (isRelative) {
                    s[l - 2] += deltaX;
                    s[l - 1] += deltaY;
                }
                deltaX = s[l - 2] - s[l - 2].toFixed(d);
                deltaY = s[l - 1] - s[l - 1].toFixed(d);
                s.forEach(function (val, i) {
                    if (!i) {
                        return;
                    }
                    s[i] = +s[i].toFixed(d);
                });
                return;
        }
    });
    return this;
};

// Apply iterator function to all segments. If function returns result,
// current segment will be replaced to array of returned segments.
// If empty array is returned, current regment will be deleted.
//
SvgPath$1.prototype.iterate = function (iterator, keepLazyStack) {
    var segments = this.segments,
        replacements = {},
        needReplace = false,
        lastX = 0,
        lastY = 0,
        countourStartX = 0,
        countourStartY = 0;
    var i, j, newSegments;
    if (!keepLazyStack) {
        this.__evaluateStack();
    }
    segments.forEach(function (s, index) {
        var res = iterator(s, index, lastX, lastY);
        if (Array.isArray(res)) {
            replacements[index] = res;
            needReplace = true;
        }
        var isRelative = s[0] === s[0].toLowerCase();

        // calculate absolute X and Y
        switch (s[0]) {
            case "m":
            case "M":
                lastX = s[1] + (isRelative ? lastX : 0);
                lastY = s[2] + (isRelative ? lastY : 0);
                countourStartX = lastX;
                countourStartY = lastY;
                return;
            case "h":
            case "H":
                lastX = s[1] + (isRelative ? lastX : 0);
                return;
            case "v":
            case "V":
                lastY = s[1] + (isRelative ? lastY : 0);
                return;
            case "z":
            case "Z":
                // That make sence for multiple contours
                lastX = countourStartX;
                lastY = countourStartY;
                return;
            default:
                lastX = s[s.length - 2] + (isRelative ? lastX : 0);
                lastY = s[s.length - 1] + (isRelative ? lastY : 0);
        }
    });

    // Replace segments if iterator return results

    if (!needReplace) {
        return this;
    }
    newSegments = [];
    for (i = 0; i < segments.length; i++) {
        if (typeof replacements[i] !== "undefined") {
            for (j = 0; j < replacements[i].length; j++) {
                newSegments.push(replacements[i][j]);
            }
        } else {
            newSegments.push(segments[i]);
        }
    }
    this.segments = newSegments;
    return this;
};

// Converts segments from relative to absolute
//
SvgPath$1.prototype.abs = function () {
    this.iterate(function (s, index, x, y) {
        var name = s[0],
            nameUC = name.toUpperCase(),
            i;

        // Skip absolute commands
        if (name === nameUC) {
            return;
        }
        s[0] = nameUC;
        switch (name) {
            case "v":
                // v has shifted coords parity
                s[1] += y;
                return;
            case "a":
                // ARC is: ['A', rx, ry, x-axis-rotation, large-arc-flag, sweep-flag, x, y]
                // touch x, y only
                s[6] += x;
                s[7] += y;
                return;
            default:
                for (i = 1; i < s.length; i++) {
                    s[i] += i % 2 ? x : y; // odd values are X, even - Y
                }
        }
    }, true);
    return this;
};

// Converts segments from absolute to relative
//
SvgPath$1.prototype.rel = function () {
    this.iterate(function (s, index, x, y) {
        var name = s[0],
            nameLC = name.toLowerCase(),
            i;

        // Skip relative commands
        if (name === nameLC) {
            return;
        }

        // Don't touch the first M to avoid potential confusions.
        if (index === 0 && name === "M") {
            return;
        }
        s[0] = nameLC;
        switch (name) {
            case "V":
                // V has shifted coords parity
                s[1] -= y;
                return;
            case "A":
                // ARC is: ['A', rx, ry, x-axis-rotation, large-arc-flag, sweep-flag, x, y]
                // touch x, y only
                s[6] -= x;
                s[7] -= y;
                return;
            default:
                for (i = 1; i < s.length; i++) {
                    s[i] -= i % 2 ? x : y; // odd values are X, even - Y
                }
        }
    }, true);
    return this;
};

// Converts arcs to cubic bézier curves
//
SvgPath$1.prototype.unarc = function () {
    this.iterate(function (s, index, x, y) {
        var new_segments,
            nextX,
            nextY,
            result = [],
            name = s[0];

        // Skip anything except arcs
        if (name !== "A" && name !== "a") {
            return null;
        }
        if (name === "a") {
            // convert relative arc coordinates to absolute
            nextX = x + s[6];
            nextY = y + s[7];
        } else {
            nextX = s[6];
            nextY = s[7];
        }
        new_segments = a2c(x, y, nextX, nextY, s[4], s[5], s[1], s[2], s[3]);

        // Degenerated arcs can be ignored by renderer, but should not be dropped
        // to avoid collisions with `S A S` and so on. Replace with empty line.
        if (new_segments.length === 0) {
            return [[s[0] === "a" ? "l" : "L", s[6], s[7]]];
        }
        new_segments.forEach(function (s) {
            result.push(["C", s[2], s[3], s[4], s[5], s[6], s[7]]);
        });
        return result;
    });
    return this;
};

// Converts smooth curves (with missed control point) to generic curves
//
SvgPath$1.prototype.unshort = function () {
    var segments = this.segments;
    var prevControlX, prevControlY, prevSegment;
    var curControlX, curControlY;

    // TODO: add lazy evaluation flag when relative commands supported

    this.iterate(function (s, idx, x, y) {
        var name = s[0],
            nameUC = name.toUpperCase(),
            isRelative;

        // First command MUST be M|m, it's safe to skip.
        // Protect from access to [-1] for sure.
        if (!idx) {
            return;
        }
        if (nameUC === "T") {
            // quadratic curve
            isRelative = name === "t";
            prevSegment = segments[idx - 1];
            if (prevSegment[0] === "Q") {
                prevControlX = prevSegment[1] - x;
                prevControlY = prevSegment[2] - y;
            } else if (prevSegment[0] === "q") {
                prevControlX = prevSegment[1] - prevSegment[3];
                prevControlY = prevSegment[2] - prevSegment[4];
            } else {
                prevControlX = 0;
                prevControlY = 0;
            }
            curControlX = -prevControlX;
            curControlY = -prevControlY;
            if (!isRelative) {
                curControlX += x;
                curControlY += y;
            }
            segments[idx] = [
                isRelative ? "q" : "Q",
                curControlX,
                curControlY,
                s[1],
                s[2],
            ];
        } else if (nameUC === "S") {
            // cubic curve
            isRelative = name === "s";
            prevSegment = segments[idx - 1];
            if (prevSegment[0] === "C") {
                prevControlX = prevSegment[3] - x;
                prevControlY = prevSegment[4] - y;
            } else if (prevSegment[0] === "c") {
                prevControlX = prevSegment[3] - prevSegment[5];
                prevControlY = prevSegment[4] - prevSegment[6];
            } else {
                prevControlX = 0;
                prevControlY = 0;
            }
            curControlX = -prevControlX;
            curControlY = -prevControlY;
            if (!isRelative) {
                curControlX += x;
                curControlY += y;
            }
            segments[idx] = [
                isRelative ? "c" : "C",
                curControlX,
                curControlY,
                s[1],
                s[2],
                s[3],
                s[4],
            ];
        }
    });
    return this;
};
var svgpath = SvgPath$1;

(function (module) {
    module.exports = svgpath;
})(svgpath$1);
var SvgPath = /*@__PURE__*/ getDefaultExportFromCjs(svgpathExports);

// Calculate the specificity for a selector by dividing it into simple selectors and counting them

/**
 * Calculates the specificity of CSS selectors
 * http://www.w3.org/TR/css3-selectors/#specificity
 *
 * Returns an object with the following properties:
 *  - selector: the input
 *  - specificity: e.g. 0,1,0,0
 *  - parts: array with details about each part of the selector that counts towards the specificity
 *  - specificityArray: e.g. [0, 1, 0, 0]
 */
var calculateSingle = function (input) {
    var selector = input,
        findMatch,
        typeCount = {
            a: 0,
            b: 0,
            c: 0,
        },
        parts = [],
        // The following regular expressions assume that selectors matching the preceding regular expressions have been removed
        attributeRegex = /(\[[^\]]+\])/g,
        idRegex = /(#[^\#\s\+>~\.\[:\)]+)/g,
        classRegex = /(\.[^\s\+>~\.\[:\)]+)/g,
        pseudoElementRegex =
            /(::[^\s\+>~\.\[:]+|:first-line|:first-letter|:before|:after)/gi,
        // A regex for pseudo classes with brackets - :nth-child(), :nth-last-child(), :nth-of-type(), :nth-last-type(), :lang()
        // The negation psuedo class (:not) is filtered out because specificity is calculated on its argument
        // :global and :local are filtered out - they look like psuedo classes but are an identifier for CSS Modules
        pseudoClassWithBracketsRegex =
            /(:(?!not|global|local)[\w-]+\([^\)]*\))/gi,
        // A regex for other pseudo classes, which don't have brackets
        pseudoClassRegex = /(:(?!not|global|local)[^\s\+>~\.\[:]+)/g,
        elementRegex = /([^\s\+>~\.\[:]+)/g;

    // Find matches for a regular expression in a string and push their details to parts
    // Type is "a" for IDs, "b" for classes, attributes and pseudo-classes and "c" for elements and pseudo-elements
    findMatch = function (regex, type) {
        var matches, i, len, match, index, length;
        if (regex.test(selector)) {
            matches = selector.match(regex);
            for (i = 0, len = matches.length; i < len; i += 1) {
                typeCount[type] += 1;
                match = matches[i];
                index = selector.indexOf(match);
                length = match.length;
                parts.push({
                    selector: input.substr(index, length),
                    type: type,
                    index: index,
                    length: length,
                });
                // Replace this simple selector with whitespace so it won't be counted in further simple selectors
                selector = selector.replace(match, Array(length + 1).join(" "));
            }
        }
    };

    // Replace escaped characters with plain text, using the "A" character
    // https://www.w3.org/TR/CSS21/syndata.html#characters
    (function () {
        var replaceWithPlainText = function (regex) {
                var matches, i, len, match;
                if (regex.test(selector)) {
                    matches = selector.match(regex);
                    for (i = 0, len = matches.length; i < len; i += 1) {
                        match = matches[i];
                        selector = selector.replace(
                            match,
                            Array(match.length + 1).join("A"),
                        );
                    }
                }
            },
            // Matches a backslash followed by six hexadecimal digits followed by an optional single whitespace character
            escapeHexadecimalRegex = /\\[0-9A-Fa-f]{6}\s?/g,
            // Matches a backslash followed by fewer than six hexadecimal digits followed by a mandatory single whitespace character
            escapeHexadecimalRegex2 = /\\[0-9A-Fa-f]{1,5}\s/g,
            // Matches a backslash followed by any character
            escapeSpecialCharacter = /\\./g;
        replaceWithPlainText(escapeHexadecimalRegex);
        replaceWithPlainText(escapeHexadecimalRegex2);
        replaceWithPlainText(escapeSpecialCharacter);
    })();

    // Remove anything after a left brace in case a user has pasted in a rule, not just a selector
    (function () {
        var regex = /{[^]*/gm,
            matches,
            i,
            len,
            match;
        if (regex.test(selector)) {
            matches = selector.match(regex);
            for (i = 0, len = matches.length; i < len; i += 1) {
                match = matches[i];
                selector = selector.replace(
                    match,
                    Array(match.length + 1).join(" "),
                );
            }
        }
    })();

    // Add attribute selectors to parts collection (type b)
    findMatch(attributeRegex, "b");

    // Add ID selectors to parts collection (type a)
    findMatch(idRegex, "a");

    // Add class selectors to parts collection (type b)
    findMatch(classRegex, "b");

    // Add pseudo-element selectors to parts collection (type c)
    findMatch(pseudoElementRegex, "c");

    // Add pseudo-class selectors to parts collection (type b)
    findMatch(pseudoClassWithBracketsRegex, "b");
    findMatch(pseudoClassRegex, "b");

    // Remove universal selector and separator characters
    selector = selector.replace(/[\*\s\+>~]/g, " ");

    // Remove any stray dots or hashes which aren't attached to words
    // These may be present if the user is live-editing this selector
    selector = selector.replace(/[#\.]/g, " ");

    // Remove the negation psuedo-class (:not) but leave its argument because specificity is calculated on its argument
    // Remove non-standard :local and :global CSS Module identifiers because they do not effect the specificity
    selector = selector.replace(/:not/g, "    ");
    selector = selector.replace(/:local/g, "      ");
    selector = selector.replace(/:global/g, "       ");
    selector = selector.replace(/[\(\)]/g, " ");

    // The only things left should be element selectors (type c)
    findMatch(elementRegex, "c");

    // Order the parts in the order they appear in the original selector
    // This is neater for external apps to deal with
    parts.sort(function (a, b) {
        return a.index - b.index;
    });
    return {
        selector: input,
        specificity:
            "0," +
            typeCount.a.toString() +
            "," +
            typeCount.b.toString() +
            "," +
            typeCount.c.toString(),
        specificityArray: [0, typeCount.a, typeCount.b, typeCount.c],
        parts: parts,
    };
};

/**
 * Compares two CSS selectors for specificity
 * Alternatively you can replace one of the CSS selectors with a specificity array
 *
 *  - it returns -1 if a has a lower specificity than b
 *  - it returns 1 if a has a higher specificity than b
 *  - it returns 0 if a has the same specificity than b
 */
var compare = function (a, b) {
    var aSpecificity, bSpecificity, i;
    if (typeof a === "string") {
        if (a.indexOf(",") !== -1) {
            throw "Invalid CSS selector";
        } else {
            aSpecificity = calculateSingle(a)["specificityArray"];
        }
    } else if (Array.isArray(a)) {
        if (
            a.filter(function (e) {
                return typeof e === "number";
            }).length !== 4
        ) {
            throw "Invalid specificity array";
        } else {
            aSpecificity = a;
        }
    } else {
        throw "Invalid CSS selector or specificity array";
    }
    if (typeof b === "string") {
        if (b.indexOf(",") !== -1) {
            throw "Invalid CSS selector";
        } else {
            bSpecificity = calculateSingle(b)["specificityArray"];
        }
    } else if (Array.isArray(b)) {
        if (
            b.filter(function (e) {
                return typeof e === "number";
            }).length !== 4
        ) {
            throw "Invalid specificity array";
        } else {
            bSpecificity = b;
        }
    } else {
        throw "Invalid CSS selector or specificity array";
    }
    for (i = 0; i < 4; i += 1) {
        if (aSpecificity[i] < bSpecificity[i]) {
            return -1;
        } else if (aSpecificity[i] > bSpecificity[i]) {
            return 1;
        }
    }
    return 0;
};

/**
 * The MIT License (MIT)
 *
 * Copyright (c) 2015-2021 yWorks GmbH
 * Copyright (c) 2013-2015 by Vitaly Puzrin
 *
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function (d, b) {
    extendStatics =
        Object.setPrototypeOf ||
        ({
            __proto__: [],
        } instanceof Array &&
            function (d, b) {
                d.__proto__ = b;
            }) ||
        function (d, b) {
            for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype =
        b === null
            ? Object.create(b)
            : ((__.prototype = b.prototype), new __());
}
var __assign = function () {
    __assign =
        Object.assign ||
        function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s)
                    if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
    return __assign.apply(this, arguments);
};
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P
            ? value
            : new P(function (resolve) {
                  resolve(value);
              });
    }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done
                ? resolve(result.value)
                : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
            label: 0,
            sent: function () {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: [],
        },
        f,
        y,
        t,
        g;
    return (
        (g = {
            next: verb(0),
            throw: verb(1),
            return: verb(2),
        }),
        typeof Symbol === "function" &&
            (g[Symbol.iterator] = function () {
                return this;
            }),
        g
    );
    function verb(n) {
        return function (v) {
            return step([n, v]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_)
            try {
                if (
                    ((f = 1),
                    y &&
                        (t =
                            op[0] & 2
                                ? y["return"]
                                : op[0]
                                  ? y["throw"] ||
                                    ((t = y["return"]) && t.call(y), 0)
                                  : y.next) &&
                        !(t = t.call(y, op[1])).done)
                )
                    return t;
                if (((y = 0), t)) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false,
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (
                            !((t = _.trys),
                            (t = t.length > 0 && t[t.length - 1])) &&
                            (op[0] === 6 || op[0] === 2)
                        ) {
                            _ = 0;
                            continue;
                        }
                        if (
                            op[0] === 3 &&
                            (!t || (op[1] > t[0] && op[1] < t[3]))
                        ) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [6, e];
                y = 0;
            } finally {
                f = t = 0;
            }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true,
        };
    }
}

/* eslint-disable @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types */
var RGBColor = /** @class */ (function () {
    function RGBColor(colorString) {
        this.a = undefined;
        this.r = 0;
        this.g = 0;
        this.b = 0;
        this.simpleColors = {};
        // eslint-disable-next-line @typescript-eslint/ban-types
        this.colorDefs = [];
        this.ok = false;
        if (!colorString) {
            return;
        }
        // strip any leading #
        if (colorString.charAt(0) == "#") {
            // remove # if any
            colorString = colorString.substr(1, 6);
        }
        colorString = colorString.replace(/ /g, "");
        colorString = colorString.toLowerCase();
        // before getting into regexps, try simple matches
        // and overwrite the input
        this.simpleColors = {
            aliceblue: "f0f8ff",
            antiquewhite: "faebd7",
            aqua: "00ffff",
            aquamarine: "7fffd4",
            azure: "f0ffff",
            beige: "f5f5dc",
            bisque: "ffe4c4",
            black: "000000",
            blanchedalmond: "ffebcd",
            blue: "0000ff",
            blueviolet: "8a2be2",
            brown: "a52a2a",
            burlywood: "deb887",
            cadetblue: "5f9ea0",
            chartreuse: "7fff00",
            chocolate: "d2691e",
            coral: "ff7f50",
            cornflowerblue: "6495ed",
            cornsilk: "fff8dc",
            crimson: "dc143c",
            cyan: "00ffff",
            darkblue: "00008b",
            darkcyan: "008b8b",
            darkgoldenrod: "b8860b",
            darkgray: "a9a9a9",
            darkgrey: "a9a9a9",
            darkgreen: "006400",
            darkkhaki: "bdb76b",
            darkmagenta: "8b008b",
            darkolivegreen: "556b2f",
            darkorange: "ff8c00",
            darkorchid: "9932cc",
            darkred: "8b0000",
            darksalmon: "e9967a",
            darkseagreen: "8fbc8f",
            darkslateblue: "483d8b",
            darkslategray: "2f4f4f",
            darkslategrey: "2f4f4f",
            darkturquoise: "00ced1",
            darkviolet: "9400d3",
            deeppink: "ff1493",
            deepskyblue: "00bfff",
            dimgray: "696969",
            dimgrey: "696969",
            dodgerblue: "1e90ff",
            feldspar: "d19275",
            firebrick: "b22222",
            floralwhite: "fffaf0",
            forestgreen: "228b22",
            fuchsia: "ff00ff",
            gainsboro: "dcdcdc",
            ghostwhite: "f8f8ff",
            gold: "ffd700",
            goldenrod: "daa520",
            gray: "808080",
            grey: "808080",
            green: "008000",
            greenyellow: "adff2f",
            honeydew: "f0fff0",
            hotpink: "ff69b4",
            indianred: "cd5c5c",
            indigo: "4b0082",
            ivory: "fffff0",
            khaki: "f0e68c",
            lavender: "e6e6fa",
            lavenderblush: "fff0f5",
            lawngreen: "7cfc00",
            lemonchiffon: "fffacd",
            lightblue: "add8e6",
            lightcoral: "f08080",
            lightcyan: "e0ffff",
            lightgoldenrodyellow: "fafad2",
            lightgray: "d3d3d3",
            lightgrey: "d3d3d3",
            lightgreen: "90ee90",
            lightpink: "ffb6c1",
            lightsalmon: "ffa07a",
            lightseagreen: "20b2aa",
            lightskyblue: "87cefa",
            lightslateblue: "8470ff",
            lightslategray: "778899",
            lightslategrey: "778899",
            lightsteelblue: "b0c4de",
            lightyellow: "ffffe0",
            lime: "00ff00",
            limegreen: "32cd32",
            linen: "faf0e6",
            magenta: "ff00ff",
            maroon: "800000",
            mediumaquamarine: "66cdaa",
            mediumblue: "0000cd",
            mediumorchid: "ba55d3",
            mediumpurple: "9370d8",
            mediumseagreen: "3cb371",
            mediumslateblue: "7b68ee",
            mediumspringgreen: "00fa9a",
            mediumturquoise: "48d1cc",
            mediumvioletred: "c71585",
            midnightblue: "191970",
            mintcream: "f5fffa",
            mistyrose: "ffe4e1",
            moccasin: "ffe4b5",
            navajowhite: "ffdead",
            navy: "000080",
            oldlace: "fdf5e6",
            olive: "808000",
            olivedrab: "6b8e23",
            orange: "ffa500",
            orangered: "ff4500",
            orchid: "da70d6",
            palegoldenrod: "eee8aa",
            palegreen: "98fb98",
            paleturquoise: "afeeee",
            palevioletred: "d87093",
            papayawhip: "ffefd5",
            peachpuff: "ffdab9",
            peru: "cd853f",
            pink: "ffc0cb",
            plum: "dda0dd",
            powderblue: "b0e0e6",
            purple: "800080",
            red: "ff0000",
            rosybrown: "bc8f8f",
            royalblue: "4169e1",
            saddlebrown: "8b4513",
            salmon: "fa8072",
            sandybrown: "f4a460",
            seagreen: "2e8b57",
            seashell: "fff5ee",
            sienna: "a0522d",
            silver: "c0c0c0",
            skyblue: "87ceeb",
            slateblue: "6a5acd",
            slategray: "708090",
            slategrey: "708090",
            snow: "fffafa",
            springgreen: "00ff7f",
            steelblue: "4682b4",
            tan: "d2b48c",
            teal: "008080",
            thistle: "d8bfd8",
            tomato: "ff6347",
            turquoise: "40e0d0",
            violet: "ee82ee",
            violetred: "d02090",
            wheat: "f5deb3",
            white: "ffffff",
            whitesmoke: "f5f5f5",
            yellow: "ffff00",
            yellowgreen: "9acd32",
        };
        for (var key in this.simpleColors) {
            if (colorString == key) {
                colorString = this.simpleColors[key];
            }
        }
        // emd of simple type-in colors
        // array of color definition objects
        this.colorDefs = [
            {
                re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
                example: ["rgb(123, 234, 45)", "rgb(255,234,245)"],
                process: function (bits) {
                    return [
                        parseInt(bits[1]),
                        parseInt(bits[2]),
                        parseInt(bits[3]),
                    ];
                },
            },
            {
                re: /^(\w{2})(\w{2})(\w{2})$/,
                example: ["#00ff00", "336699"],
                process: function (bits) {
                    return [
                        parseInt(bits[1], 16),
                        parseInt(bits[2], 16),
                        parseInt(bits[3], 16),
                    ];
                },
            },
            {
                re: /^(\w{1})(\w{1})(\w{1})$/,
                example: ["#fb0", "f0f"],
                process: function (bits) {
                    return [
                        parseInt(bits[1] + bits[1], 16),
                        parseInt(bits[2] + bits[2], 16),
                        parseInt(bits[3] + bits[3], 16),
                    ];
                },
            },
        ];
        // search through the definitions to find a match
        for (var i = 0; i < this.colorDefs.length; i++) {
            var re = this.colorDefs[i].re;
            var processor = this.colorDefs[i].process;
            var bits = re.exec(colorString);
            if (bits) {
                var channels = processor(bits);
                this.r = channels[0];
                this.g = channels[1];
                this.b = channels[2];
                this.ok = true;
            }
        }
        // validate/cleanup values
        this.r = this.r < 0 || isNaN(this.r) ? 0 : this.r > 255 ? 255 : this.r;
        this.g = this.g < 0 || isNaN(this.g) ? 0 : this.g > 255 ? 255 : this.g;
        this.b = this.b < 0 || isNaN(this.b) ? 0 : this.b > 255 ? 255 : this.b;
    }
    RGBColor.prototype.toRGB = function () {
        return "rgb(" + this.r + ", " + this.g + ", " + this.b + ")";
    };
    RGBColor.prototype.toRGBA = function () {
        return (
            "rgba(" +
            this.r +
            ", " +
            this.g +
            ", " +
            this.b +
            ", " +
            (this.a || "1") +
            ")"
        );
    };
    RGBColor.prototype.toHex = function () {
        var r = this.r.toString(16);
        var g = this.g.toString(16);
        var b = this.b.toString(16);
        if (r.length == 1) r = "0" + r;
        if (g.length == 1) g = "0" + g;
        if (b.length == 1) b = "0" + b;
        return "#" + r + g + b;
    };
    // help
    RGBColor.prototype.getHelpXML = function () {
        var examples = [];
        // add regexps
        for (var i = 0; i < this.colorDefs.length; i++) {
            var example = this.colorDefs[i].example;
            for (var j = 0; j < example.length; j++) {
                examples[examples.length] = example[j];
            }
        }
        // add type-in colors
        for (var sc in this.simpleColors) {
            examples[examples.length] = sc;
        }
        var xml = document.createElement("ul");
        xml.setAttribute("id", "rgbcolor-examples");
        for (var i = 0; i < examples.length; i++) {
            try {
                var listItem = document.createElement("li");
                var listColor = new RGBColor(examples[i]);
                var exampleDiv = document.createElement("div");
                exampleDiv.style.cssText =
                    "margin: 3px; " +
                    "border: 1px solid black; " +
                    "background:" +
                    listColor.toHex() +
                    "; " +
                    "color:" +
                    listColor.toHex();
                exampleDiv.appendChild(document.createTextNode("test"));
                var listItemValue = document.createTextNode(
                    " " +
                        examples[i] +
                        " -> " +
                        listColor.toRGB() +
                        " -> " +
                        listColor.toHex(),
                );
                listItem.appendChild(exampleDiv);
                listItem.appendChild(listItemValue);
                xml.appendChild(listItem);
            } catch (e) {}
        }
        return xml;
    };
    return RGBColor;
})();
var ColorFill = /** @class */ (function () {
    function ColorFill(color) {
        this.color = color;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ColorFill.prototype.getFillData = function (forNode, context) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, undefined];
            });
        });
    };
    return ColorFill;
})();
var AttributeState = /** @class */ (function () {
    function AttributeState() {
        this.xmlSpace = "";
        this.fill = null;
        this.fillOpacity = 1.0;
        // public fillRule: string = null
        this.fontFamily = "";
        this.fontSize = 16;
        this.fontStyle = "";
        // public fontVariant: string
        this.fontWeight = "";
        this.opacity = 1.0;
        this.stroke = null;
        this.strokeDasharray = null;
        this.strokeDashoffset = 0;
        this.strokeLinecap = "";
        this.strokeLinejoin = "";
        this.strokeMiterlimit = 4.0;
        this.strokeOpacity = 1.0;
        this.strokeWidth = 1.0;
        // public textAlign: string
        this.alignmentBaseline = "";
        this.textAnchor = "";
        this.visibility = "";
        this.color = null;
    }
    AttributeState.prototype.clone = function () {
        var clone = new AttributeState();
        clone.xmlSpace = this.xmlSpace;
        clone.fill = this.fill;
        clone.fillOpacity = this.fillOpacity;
        // clone.fillRule = this.fillRule;
        clone.fontFamily = this.fontFamily;
        clone.fontSize = this.fontSize;
        clone.fontStyle = this.fontStyle;
        // clone.fontVariant = this.fontVariant;
        clone.fontWeight = this.fontWeight;
        clone.opacity = this.opacity;
        clone.stroke = this.stroke;
        clone.strokeDasharray = this.strokeDasharray;
        clone.strokeDashoffset = this.strokeDashoffset;
        clone.strokeLinecap = this.strokeLinecap;
        clone.strokeLinejoin = this.strokeLinejoin;
        clone.strokeMiterlimit = this.strokeMiterlimit;
        clone.strokeOpacity = this.strokeOpacity;
        clone.strokeWidth = this.strokeWidth;
        // clone.textAlign = this.textAlign;
        clone.textAnchor = this.textAnchor;
        clone.alignmentBaseline = this.alignmentBaseline;
        clone.visibility = this.visibility;
        clone.color = this.color;
        return clone;
    };
    AttributeState.default = function () {
        var attributeState = new AttributeState();
        attributeState.xmlSpace = "default";
        attributeState.fill = new ColorFill(new RGBColor("rgb(0, 0, 0)"));
        attributeState.fillOpacity = 1.0;
        // attributeState.fillRule = "nonzero";
        attributeState.fontFamily = "times";
        attributeState.fontSize = 16;
        attributeState.fontStyle = "normal";
        // attributeState.fontVariant = "normal";
        attributeState.fontWeight = "normal";
        attributeState.opacity = 1.0;
        attributeState.stroke = null;
        attributeState.strokeDasharray = null;
        attributeState.strokeDashoffset = 0;
        attributeState.strokeLinecap = "butt";
        attributeState.strokeLinejoin = "miter";
        attributeState.strokeMiterlimit = 4.0;
        attributeState.strokeOpacity = 1.0;
        attributeState.strokeWidth = 1.0;
        // attributeState.textAlign = "start";
        attributeState.alignmentBaseline = "baseline";
        attributeState.textAnchor = "start";
        attributeState.visibility = "visible";
        attributeState.color = new RGBColor("rgb(0, 0, 0)");
        return attributeState;
    };
    return AttributeState;
})();
var iriReference = /url\(["']?#([^"']+)["']?\)/;
var alignmentBaselineMap = {
    bottom: "bottom",
    "text-bottom": "bottom",
    top: "top",
    "text-top": "top",
    hanging: "hanging",
    middle: "middle",
    central: "middle",
    center: "middle",
    mathematical: "middle",
    ideographic: "ideographic",
    alphabetic: "alphabetic",
    baseline: "alphabetic",
};
var svgNamespaceURI = "http://www.w3.org/2000/svg";
var TextMeasure = /** @class */ (function () {
    function TextMeasure() {
        this.measureMethods = {};
    }
    TextMeasure.prototype.getTextOffset = function (text, attributeState) {
        var textAnchor = attributeState.textAnchor;
        if (textAnchor === "start") {
            return 0;
        }
        var width = this.measureTextWidth(text, attributeState);
        var xOffset = 0;
        switch (textAnchor) {
            case "end":
                xOffset = width;
                break;
            case "middle":
                xOffset = width / 2;
                break;
        }
        return xOffset;
    };
    TextMeasure.prototype.measureTextWidth = function (text, attributeState) {
        if (text.length === 0) {
            return 0;
        }
        var fontFamily = attributeState.fontFamily;
        var measure = this.getMeasureFunction(fontFamily);
        return measure.call(
            this,
            text,
            attributeState.fontFamily,
            attributeState.fontSize + "px",
            attributeState.fontStyle,
            attributeState.fontWeight,
        );
    };
    TextMeasure.prototype.getMeasurementTextNode = function () {
        if (!this.textMeasuringTextElement) {
            this.textMeasuringTextElement = document.createElementNS(
                svgNamespaceURI,
                "text",
            );
            var svg = document.createElementNS(svgNamespaceURI, "svg");
            svg.appendChild(this.textMeasuringTextElement);
            svg.style.setProperty("position", "absolute");
            svg.style.setProperty("visibility", "hidden");
            document.body.appendChild(svg);
        }
        return this.textMeasuringTextElement;
    };
    TextMeasure.prototype.canvasTextMeasure = function (
        text,
        fontFamily,
        fontSize,
        fontStyle,
        fontWeight,
    ) {
        var canvas = document.createElement("canvas");
        var context = canvas.getContext("2d");
        if (context != null) {
            context.font = [fontStyle, fontWeight, fontSize, fontFamily].join(
                " ",
            );
            return context.measureText(text).width;
        }
        return 0;
    };
    TextMeasure.prototype.svgTextMeasure = function (
        text,
        fontFamily,
        fontSize,
        fontStyle,
        fontWeight,
        measurementTextNode,
    ) {
        if (measurementTextNode === void 0) {
            measurementTextNode = this.getMeasurementTextNode();
        }
        var textNode = measurementTextNode;
        textNode.setAttribute("font-family", fontFamily);
        textNode.setAttribute("font-size", fontSize);
        textNode.setAttribute("font-style", fontStyle);
        textNode.setAttribute("font-weight", fontWeight);
        textNode.setAttributeNS(
            "http://www.w3.org/XML/1998/namespace",
            "xml:space",
            "preserve",
        );
        textNode.textContent = text;
        return textNode.getBBox().width;
    };
    /**
     * Canvas text measuring is a lot faster than svg measuring. However, it is inaccurate for some fonts. So test each
     * font once and decide if canvas is accurate enough.
     */
    TextMeasure.prototype.getMeasureFunction = function (fontFamily) {
        var method = this.measureMethods[fontFamily];
        if (!method) {
            var fontSize = "16px";
            var fontStyle = "normal";
            var fontWeight = "normal";
            var canvasWidth = this.canvasTextMeasure(
                TextMeasure.testString,
                fontFamily,
                fontSize,
                fontStyle,
                fontWeight,
            );
            var svgWidth = this.svgTextMeasure(
                TextMeasure.testString,
                fontFamily,
                fontSize,
                fontStyle,
                fontWeight,
            );
            method =
                Math.abs(canvasWidth - svgWidth) < TextMeasure.epsilon
                    ? this.canvasTextMeasure
                    : this.svgTextMeasure;
            this.measureMethods[fontFamily] = method;
        }
        return method;
    };
    TextMeasure.prototype.cleanupTextMeasuring = function () {
        if (this.textMeasuringTextElement) {
            var parentNode = this.textMeasuringTextElement.parentNode;
            if (parentNode) {
                document.body.removeChild(parentNode);
            }
            this.textMeasuringTextElement = undefined;
        }
    };
    TextMeasure.testString =
        "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ 0123456789!\"$%&/()=?'\\+*-_.:,;^}][{#~|<>";
    TextMeasure.epsilon = 0.1;
    return TextMeasure;
})();

/**
 *
 * @package
 * @param values
 * @constructor
 * @property pdf
 * @property attributeState  Keeps track of parent attributes that are inherited automatically
 * @property refsHandler  The handler that will render references on demand
 * @property styleSheets
 * @property textMeasure
 * @property transform The current transformation matrix
 * @property withinClipPath
 */
var Context = /** @class */ (function () {
    function Context(pdf, values) {
        var _a, _b, _c, _d, _e, _f;
        this.pdf = pdf;
        this.svg2pdfParameters = values.svg2pdfParameters;
        this.attributeState = values.attributeState
            ? values.attributeState.clone()
            : AttributeState.default();
        this.viewport = values.viewport;
        this.refsHandler =
            (_a = values.refsHandler) !== null && _a !== void 0 ? _a : null;
        this.styleSheets =
            (_b = values.styleSheets) !== null && _b !== void 0 ? _b : null;
        this.textMeasure =
            (_c = values.textMeasure) !== null && _c !== void 0
                ? _c
                : new TextMeasure();
        this.transform =
            (_d = values.transform) !== null && _d !== void 0
                ? _d
                : this.pdf.unitMatrix;
        this.withinClipPath =
            (_e = values.withinClipPath) !== null && _e !== void 0 ? _e : false;
        this.withinUse =
            (_f = values.withinUse) !== null && _f !== void 0 ? _f : false;
    }
    Context.prototype.clone = function (values) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (values === void 0) {
            values = {};
        }
        return new Context(this.pdf, {
            svg2pdfParameters:
                (_a = values.svg2pdfParameters) !== null && _a !== void 0
                    ? _a
                    : this.svg2pdfParameters,
            attributeState: values.attributeState
                ? values.attributeState.clone()
                : this.attributeState.clone(),
            viewport:
                (_b = values.viewport) !== null && _b !== void 0
                    ? _b
                    : this.viewport,
            refsHandler:
                (_c = values.refsHandler) !== null && _c !== void 0
                    ? _c
                    : this.refsHandler,
            styleSheets:
                (_d = values.styleSheets) !== null && _d !== void 0
                    ? _d
                    : this.styleSheets,
            textMeasure:
                (_e = values.textMeasure) !== null && _e !== void 0
                    ? _e
                    : this.textMeasure,
            transform:
                (_f = values.transform) !== null && _f !== void 0
                    ? _f
                    : this.transform,
            withinClipPath:
                (_g = values.withinClipPath) !== null && _g !== void 0
                    ? _g
                    : this.withinClipPath,
            withinUse:
                (_h = values.withinUse) !== null && _h !== void 0
                    ? _h
                    : this.withinUse,
        });
    };
    return Context;
})();
var ReferencesHandler = /** @class */ (function () {
    function ReferencesHandler(idMap) {
        this.renderedElements = {};
        this.idMap = idMap;
        this.idPrefix = String(ReferencesHandler.instanceCounter++);
    }
    ReferencesHandler.prototype.getRendered = function (
        id,
        color,
        renderCallback,
    ) {
        return __awaiter(this, void 0, void 0, function () {
            var key, svgNode;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        key = this.generateKey(id, color);
                        if (this.renderedElements.hasOwnProperty(key)) {
                            return [2 /*return*/, this.renderedElements[id]];
                        }
                        svgNode = this.get(id);
                        this.renderedElements[key] = svgNode;
                        return [4 /*yield*/, renderCallback(svgNode)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, svgNode];
                }
            });
        });
    };
    ReferencesHandler.prototype.get = function (id) {
        return this.idMap[
            cssesc_1(id, {
                isIdentifier: true,
            })
        ];
    };
    ReferencesHandler.prototype.generateKey = function (id, color) {
        return (
            this.idPrefix +
            "|" +
            id +
            "|" +
            (color || new RGBColor("rgb(0,0,0)")).toRGBA()
        );
    };
    ReferencesHandler.instanceCounter = 0;
    return ReferencesHandler;
})();
function getAngle(from, to) {
    return Math.atan2(to[1] - from[1], to[0] - from[0]);
}
var cToQ = 2 / 3; // ratio to convert quadratic bezier curves to cubic ones
// transforms a cubic bezier control point to a quadratic one: returns from + (2/3) * (to - from)
function toCubic(from, to) {
    return [
        cToQ * (to[0] - from[0]) + from[0],
        cToQ * (to[1] - from[1]) + from[1],
    ];
}
function normalize(v) {
    var length = Math.sqrt(v[0] * v[0] + v[1] * v[1]);
    return [v[0] / length, v[1] / length];
}
function getDirectionVector(from, to) {
    var v = [to[0] - from[0], to[1] - from[1]];
    return normalize(v);
}
function addVectors(v1, v2) {
    return [v1[0] + v2[0], v1[1] + v2[1]];
}
// multiplies a vector with a matrix: vec' = vec * matrix
function multVecMatrix(vec, matrix) {
    var x = vec[0];
    var y = vec[1];
    return [
        matrix.a * x + matrix.c * y + matrix.e,
        matrix.b * x + matrix.d * y + matrix.f,
    ];
}
var Path = /** @class */ (function () {
    function Path() {
        this.segments = [];
    }
    Path.prototype.moveTo = function (x, y) {
        this.segments.push(new MoveTo(x, y));
        return this;
    };
    Path.prototype.lineTo = function (x, y) {
        this.segments.push(new LineTo(x, y));
        return this;
    };
    Path.prototype.curveTo = function (x1, y1, x2, y2, x, y) {
        this.segments.push(new CurveTo(x1, y1, x2, y2, x, y));
        return this;
    };
    Path.prototype.close = function () {
        this.segments.push(new Close());
        return this;
    };
    /**
     * Transforms the path in place
     */
    Path.prototype.transform = function (matrix) {
        this.segments.forEach(function (seg) {
            if (
                seg instanceof MoveTo ||
                seg instanceof LineTo ||
                seg instanceof CurveTo
            ) {
                var p = multVecMatrix([seg.x, seg.y], matrix);
                seg.x = p[0];
                seg.y = p[1];
            }
            if (seg instanceof CurveTo) {
                var p1 = multVecMatrix([seg.x1, seg.y1], matrix);
                var p2 = multVecMatrix([seg.x2, seg.y2], matrix);
                seg.x1 = p1[0];
                seg.y1 = p1[1];
                seg.x2 = p2[0];
                seg.y2 = p2[1];
            }
        });
    };
    Path.prototype.draw = function (context) {
        var p = context.pdf;
        this.segments.forEach(function (s) {
            if (s instanceof MoveTo) {
                p.moveTo(s.x, s.y);
            } else if (s instanceof LineTo) {
                p.lineTo(s.x, s.y);
            } else if (s instanceof CurveTo) {
                p.curveTo(s.x1, s.y1, s.x2, s.y2, s.x, s.y);
            } else {
                p.close();
            }
        });
    };
    return Path;
})();
var MoveTo = /** @class */ (function () {
    function MoveTo(x, y) {
        this.x = x;
        this.y = y;
    }
    return MoveTo;
})();
var LineTo = /** @class */ (function () {
    function LineTo(x, y) {
        this.x = x;
        this.y = y;
    }
    return LineTo;
})();
var CurveTo = /** @class */ (function () {
    function CurveTo(x1, y1, x2, y2, x, y) {
        this.x1 = x1;
        this.y1 = y1;
        this.x2 = x2;
        this.y2 = y2;
        this.x = x;
        this.y = y;
    }
    return CurveTo;
})();
var Close = /** @class */ (function () {
    function Close() {}
    return Close;
})();
function nodeIs(node, tagsString) {
    return (
        tagsString
            .split(",")
            .indexOf((node.nodeName || node.tagName).toLowerCase()) >= 0
    );
}
function forEachChild(node, fn) {
    // copy list of children, as the original might be modified
    var children = [];
    for (var i = 0; i < node.childNodes.length; i++) {
        var childNode = node.childNodes[i];
        if (childNode.nodeName.charAt(0) !== "#") children.push(childNode);
    }
    for (var i = 0; i < children.length; i++) {
        fn(i, children[i]);
    }
}
// returns an attribute of a node, either from the node directly or from css
function getAttribute(node, styleSheets, propertyNode, propertyCss) {
    var _a;
    if (propertyCss === void 0) {
        propertyCss = propertyNode;
    }
    var attribute =
        (_a = node.style) === null || _a === void 0
            ? void 0
            : _a.getPropertyValue(propertyCss);
    if (attribute) {
        return attribute;
    } else {
        var propertyValue = styleSheets.getPropertyValue(node, propertyCss);
        if (propertyValue) {
            return propertyValue;
        } else if (node.hasAttribute(propertyNode)) {
            return node.getAttribute(propertyNode) || undefined;
        } else {
            return undefined;
        }
    }
}
function svgNodeIsVisible(svgNode, parentVisible, context) {
    if (
        getAttribute(svgNode.element, context.styleSheets, "display") === "none"
    ) {
        return false;
    }
    var visible = parentVisible;
    var visibility = getAttribute(
        svgNode.element,
        context.styleSheets,
        "visibility",
    );
    if (visibility) {
        visible = visibility !== "hidden";
    }
    return visible;
}
function svgNodeAndChildrenVisible(svgNode, parentVisible, context) {
    var visible = svgNodeIsVisible(svgNode, parentVisible, context);
    if (svgNode.element.childNodes.length === 0) {
        return false;
    }
    svgNode.children.forEach(function (child) {
        if (child.isVisible(visible, context)) {
            visible = true;
        }
    });
    return visible;
}

/**
 * @constructor
 * @property {Marker[]} markers
 */
var MarkerList = /** @class */ (function () {
    function MarkerList() {
        this.markers = [];
    }
    MarkerList.prototype.addMarker = function (markers) {
        this.markers.push(markers);
    };
    MarkerList.prototype.draw = function (context) {
        return __awaiter(this, void 0, void 0, function () {
            var i, marker, tf, angle, anchor, cos, sin;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        i = 0;
                        _a.label = 1;
                    case 1:
                        if (!(i < this.markers.length)) return [3 /*break*/, 4];
                        marker = this.markers[i];
                        tf = void 0;
                        (angle = marker.angle), (anchor = marker.anchor);
                        cos = Math.cos(angle);
                        sin = Math.sin(angle);
                        // position at and rotate around anchor
                        tf = context.pdf.Matrix(
                            cos,
                            sin,
                            -sin,
                            cos,
                            anchor[0],
                            anchor[1],
                        );
                        // scale with stroke-width
                        tf = context.pdf.matrixMult(
                            context.pdf.Matrix(
                                context.attributeState.strokeWidth,
                                0,
                                0,
                                context.attributeState.strokeWidth,
                                0,
                                0,
                            ),
                            tf,
                        );
                        tf = context.pdf.matrixMult(tf, context.transform);
                        // as the marker is already scaled by the current line width we must not apply the line width twice!
                        context.pdf.saveGraphicsState();
                        return [
                            4 /*yield*/,
                            context.refsHandler.getRendered(
                                marker.id,
                                null,
                                function (node) {
                                    return node.apply(context);
                                },
                            ),
                        ];
                    case 2:
                        _a.sent();
                        context.pdf.doFormObject(marker.id, tf);
                        context.pdf.restoreGraphicsState();
                        _a.label = 3;
                    case 3:
                        i++;
                        return [3 /*break*/, 1];
                    case 4:
                        return [2 /*return*/];
                }
            });
        });
    };

    return MarkerList;
})();
/**
 * @param {string} id
 * @param {[number,number]} anchor
 * @param {number} angle
 */
var Marker = /** @class */ (function () {
    function Marker(id, anchor, angle) {
        this.id = id;
        this.anchor = anchor;
        this.angle = angle;
    }
    return Marker;
})();

/**
 * Convert em, px and bare number attributes to pixel values
 * @param {string} value
 * @param {number} pdfFontSize
 */
function toPixels(value, pdfFontSize) {
    var match;
    // em
    match = value && value.toString().match(/^([\-0-9.]+)em$/);
    if (match) {
        return parseFloat(match[1]) * pdfFontSize;
    }
    // pixels
    match = value && value.toString().match(/^([\-0-9.]+)(px|)$/);
    if (match) {
        return parseFloat(match[1]);
    }
    return 0;
}
function mapAlignmentBaseline(value) {
    return alignmentBaselineMap[value] || "alphabetic";
}

/**
 * parses a comma, sign and/or whitespace separated string of floats and returns
 * the single floats in an array
 */
function parseFloats(str) {
    var floats = [];
    var regex = /[+-]?(?:(?:\d+\.?\d*)|(?:\d*\.?\d+))(?:[eE][+-]?\d+)?/g;
    var match;
    while ((match = regex.exec(str))) {
        floats.push(parseFloat(match[0]));
    }
    return floats;
}
/**
 * extends RGBColor by rgba colors as RGBColor is not capable of it
 * currentcolor: the color to return if colorString === 'currentcolor'
 */
function parseColor(colorString, currentcolor) {
    if (colorString === "transparent") {
        var transparent = new RGBColor("rgb(0,0,0)");
        transparent.a = 0;
        return transparent;
    }
    if (colorString.toLowerCase() === "currentcolor") {
        return currentcolor || new RGBColor("rgb(0,0,0)");
    }
    var match = /\s*rgba\(((?:[^,\)]*,){3}[^,\)]*)\)\s*/.exec(colorString);
    if (match) {
        var floats = parseFloats(match[1]);
        var color = new RGBColor("rgb(" + floats.slice(0, 3).join(",") + ")");
        color.a = floats[3];
        return color;
    } else {
        return new RGBColor(colorString);
    }
}
var fontAliases = {
    "sans-serif": "helvetica",
    verdana: "helvetica",
    arial: "helvetica",
    fixed: "courier",
    monospace: "courier",
    terminal: "courier",
    serif: "times",
    cursive: "times",
    fantasy: "times",
};
function findFirstAvailableFontFamily(attributeState, fontFamilies, context) {
    var fontType = combineFontStyleAndFontWeight(
        attributeState.fontStyle,
        attributeState.fontWeight,
    );
    var availableFonts = context.pdf.getFontList();
    var firstAvailable = "";
    var fontIsAvailable = fontFamilies.some(function (font) {
        var availableStyles = availableFonts[font];
        if (availableStyles && availableStyles.indexOf(fontType) >= 0) {
            firstAvailable = font;
            return true;
        }
        font = font.toLowerCase();
        if (fontAliases.hasOwnProperty(font)) {
            firstAvailable = font;
            return true;
        }
        return false;
    });
    if (!fontIsAvailable) {
        firstAvailable = "times";
    }
    return firstAvailable;
}
var isJsPDF23 = (function () {
    var parts = E.version.split(".");
    return parseFloat(parts[0]) === 2 && parseFloat(parts[1]) === 3;
})();
function combineFontStyleAndFontWeight(fontStyle, fontWeight) {
    if (isJsPDF23) {
        return fontWeight == 400
            ? fontStyle == "italic"
                ? "italic"
                : "normal"
            : fontWeight == 700 && fontStyle !== "italic"
              ? "bold"
              : fontStyle + "" + fontWeight;
    } else {
        return fontWeight == 400 || fontWeight === "normal"
            ? fontStyle === "italic"
                ? "italic"
                : "normal"
            : (fontWeight == 700 || fontWeight === "bold") &&
                fontStyle === "normal"
              ? "bold"
              : (fontWeight == 700 ? "bold" : fontWeight) + "" + fontStyle;
    }
}
function getBoundingBoxByChildren(context, svgnode) {
    if (
        getAttribute(svgnode.element, context.styleSheets, "display") === "none"
    ) {
        return [0, 0, 0, 0];
    }
    var boundingBox = [0, 0, 0, 0];
    svgnode.children.forEach(function (child) {
        var nodeBox = child.getBoundingBox(context);
        boundingBox = [
            Math.min(boundingBox[0], nodeBox[0]),
            Math.min(boundingBox[1], nodeBox[1]),
            Math.max(boundingBox[0] + boundingBox[2], nodeBox[0] + nodeBox[2]) -
                Math.min(boundingBox[0], nodeBox[0]),
            Math.max(boundingBox[1] + boundingBox[3], nodeBox[1] + nodeBox[3]) -
                Math.min(boundingBox[1], nodeBox[1]),
        ];
    });
    return boundingBox;
}
function defaultBoundingBox(element, context) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var pf = parseFloat;
    // TODO: check if there are other possible coordinate attributes
    var x1 =
        pf(element.getAttribute("x1")) ||
        pf(getAttribute(element, context.styleSheets, "x")) ||
        pf(getAttribute(element, context.styleSheets, "cx")) -
            pf(getAttribute(element, context.styleSheets, "r")) ||
        0;
    var x2 =
        pf(element.getAttribute("x2")) ||
        x1 + pf(getAttribute(element, context.styleSheets, "width")) ||
        pf(getAttribute(element, context.styleSheets, "cx")) +
            pf(getAttribute(element, context.styleSheets, "r")) ||
        0;
    var y1 =
        pf(element.getAttribute("y1")) ||
        pf(getAttribute(element, context.styleSheets, "y")) ||
        pf(getAttribute(element, context.styleSheets, "cy")) -
            pf(getAttribute(element, context.styleSheets, "r")) ||
        0;
    var y2 =
        pf(element.getAttribute("y2")) ||
        y1 + pf(getAttribute(element, context.styleSheets, "height")) ||
        pf(getAttribute(element, context.styleSheets, "cy")) +
            pf(getAttribute(element, context.styleSheets, "r")) ||
        0;
    return [
        Math.min(x1, x2),
        Math.min(y1, y2),
        Math.max(x1, x2) - Math.min(x1, x2),
        Math.max(y1, y2) - Math.min(y1, y2),
    ];
}
function computeViewBoxTransform(
    node,
    viewBox,
    eX,
    eY,
    eWidth,
    eHeight,
    context,
    noTranslate,
) {
    if (noTranslate === void 0) {
        noTranslate = false;
    }
    var vbX = viewBox[0];
    var vbY = viewBox[1];
    var vbWidth = viewBox[2];
    var vbHeight = viewBox[3];
    var scaleX = eWidth / vbWidth;
    var scaleY = eHeight / vbHeight;
    var align, meetOrSlice;
    var preserveAspectRatio = node.getAttribute("preserveAspectRatio");
    if (preserveAspectRatio) {
        var alignAndMeetOrSlice = preserveAspectRatio.split(" ");
        if (alignAndMeetOrSlice[0] === "defer") {
            alignAndMeetOrSlice = alignAndMeetOrSlice.slice(1);
        }
        align = alignAndMeetOrSlice[0];
        meetOrSlice = alignAndMeetOrSlice[1] || "meet";
    } else {
        align = "xMidYMid";
        meetOrSlice = "meet";
    }
    if (align !== "none") {
        if (meetOrSlice === "meet") {
            // uniform scaling with min scale
            scaleX = scaleY = Math.min(scaleX, scaleY);
        } else if (meetOrSlice === "slice") {
            // uniform scaling with max scale
            scaleX = scaleY = Math.max(scaleX, scaleY);
        }
    }
    if (noTranslate) {
        return context.pdf.Matrix(scaleX, 0, 0, scaleY, 0, 0);
    }
    var translateX = eX - vbX * scaleX;
    var translateY = eY - vbY * scaleY;
    if (align.indexOf("xMid") >= 0) {
        translateX += (eWidth - vbWidth * scaleX) / 2;
    } else if (align.indexOf("xMax") >= 0) {
        translateX += eWidth - vbWidth * scaleX;
    }
    if (align.indexOf("YMid") >= 0) {
        translateY += (eHeight - vbHeight * scaleY) / 2;
    } else if (align.indexOf("YMax") >= 0) {
        translateY += eHeight - vbHeight * scaleY;
    }
    var translate = context.pdf.Matrix(1, 0, 0, 1, translateX, translateY);
    var scale = context.pdf.Matrix(scaleX, 0, 0, scaleY, 0, 0);
    return context.pdf.matrixMult(scale, translate);
}
// parses the "transform" string
function parseTransform(transformString, context) {
    if (!transformString || transformString === "none")
        return context.pdf.unitMatrix;
    var mRegex = /^[\s,]*matrix\(([^)]+)\)\s*/,
        tRegex = /^[\s,]*translate\(([^)]+)\)\s*/,
        rRegex = /^[\s,]*rotate\(([^)]+)\)\s*/,
        sRegex = /^[\s,]*scale\(([^)]+)\)\s*/,
        sXRegex = /^[\s,]*skewX\(([^)]+)\)\s*/,
        sYRegex = /^[\s,]*skewY\(([^)]+)\)\s*/;
    var resultMatrix = context.pdf.unitMatrix;
    var m;
    var tSLength;
    while (transformString.length > 0 && transformString.length !== tSLength) {
        tSLength = transformString.length;
        var match = mRegex.exec(transformString);
        if (match) {
            m = parseFloats(match[1]);
            resultMatrix = context.pdf.matrixMult(
                context.pdf.Matrix(m[0], m[1], m[2], m[3], m[4], m[5]),
                resultMatrix,
            );
            transformString = transformString.substr(match[0].length);
        }
        match = rRegex.exec(transformString);
        if (match) {
            m = parseFloats(match[1]);
            var a = (Math.PI * m[0]) / 180;
            resultMatrix = context.pdf.matrixMult(
                context.pdf.Matrix(
                    Math.cos(a),
                    Math.sin(a),
                    -Math.sin(a),
                    Math.cos(a),
                    0,
                    0,
                ),
                resultMatrix,
            );
            if (m[1] || m[2]) {
                var t1 = context.pdf.Matrix(1, 0, 0, 1, m[1], m[2]);
                var t2 = context.pdf.Matrix(1, 0, 0, 1, -m[1], -m[2]);
                resultMatrix = context.pdf.matrixMult(
                    t2,
                    context.pdf.matrixMult(resultMatrix, t1),
                );
            }
            transformString = transformString.substr(match[0].length);
        }
        match = tRegex.exec(transformString);
        if (match) {
            m = parseFloats(match[1]);
            resultMatrix = context.pdf.matrixMult(
                context.pdf.Matrix(1, 0, 0, 1, m[0], m[1] || 0),
                resultMatrix,
            );
            transformString = transformString.substr(match[0].length);
        }
        match = sRegex.exec(transformString);
        if (match) {
            m = parseFloats(match[1]);
            if (!m[1]) m[1] = m[0];
            resultMatrix = context.pdf.matrixMult(
                context.pdf.Matrix(m[0], 0, 0, m[1], 0, 0),
                resultMatrix,
            );
            transformString = transformString.substr(match[0].length);
        }
        match = sXRegex.exec(transformString);
        if (match) {
            m = parseFloat(match[1]);
            m *= Math.PI / 180;
            resultMatrix = context.pdf.matrixMult(
                context.pdf.Matrix(1, 0, Math.tan(m), 1, 0, 0),
                resultMatrix,
            );
            transformString = transformString.substr(match[0].length);
        }
        match = sYRegex.exec(transformString);
        if (match) {
            m = parseFloat(match[1]);
            m *= Math.PI / 180;
            resultMatrix = context.pdf.matrixMult(
                context.pdf.Matrix(1, Math.tan(m), 0, 1, 0, 0),
                resultMatrix,
            );
            transformString = transformString.substr(match[0].length);
        }
    }
    return resultMatrix;
}
var SvgNode = /** @class */ (function () {
    function SvgNode(element, children) {
        this.element = element;
        this.children = children;
        this.parent = null;
    }
    SvgNode.prototype.setParent = function (parent) {
        this.parent = parent;
    };
    SvgNode.prototype.getParent = function () {
        return this.parent;
    };
    SvgNode.prototype.getBoundingBox = function (context) {
        if (
            getAttribute(this.element, context.styleSheets, "display") ===
            "none"
        ) {
            return [0, 0, 0, 0];
        }
        return this.getBoundingBoxCore(context);
    };
    SvgNode.prototype.computeNodeTransform = function (context) {
        var nodeTransform = this.computeNodeTransformCore(context);
        var transformString = getAttribute(
            this.element,
            context.styleSheets,
            "transform",
        );
        if (!transformString) return nodeTransform;
        else
            return context.pdf.matrixMult(
                nodeTransform,
                parseTransform(transformString, context),
            );
    };
    return SvgNode;
})();
var NonRenderedNode = /** @class */ (function (_super) {
    __extends(NonRenderedNode, _super);
    function NonRenderedNode() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    NonRenderedNode.prototype.render = function (parentContext) {
        return Promise.resolve();
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    NonRenderedNode.prototype.getBoundingBoxCore = function (context) {
        return [];
    };
    NonRenderedNode.prototype.computeNodeTransformCore = function (context) {
        return context.pdf.unitMatrix;
    };
    return NonRenderedNode;
})(SvgNode);
var Gradient = /** @class */ (function (_super) {
    __extends(Gradient, _super);
    function Gradient(pdfGradientType, element, children) {
        var _this = _super.call(this, element, children) || this;
        _this.pdfGradientType = pdfGradientType;
        _this.contextColor = undefined;
        return _this;
    }
    Gradient.prototype.apply = function (context) {
        return __awaiter(this, void 0, void 0, function () {
            var id, colors, opacitySum, hasOpacity, gState, pattern;
            return __generator(this, function (_a) {
                id = this.element.getAttribute("id");
                if (!id) {
                    return [2 /*return*/];
                }

                colors = this.getStops(context.styleSheets);
                opacitySum = 0;
                hasOpacity = false;
                colors.forEach(function (_a) {
                    var opacity = _a.opacity;
                    if (opacity && opacity !== 1) {
                        opacitySum += opacity;
                        hasOpacity = true;
                    }
                });
                if (hasOpacity) {
                    gState = new j({
                        opacity: opacitySum / colors.length,
                    });
                }
                pattern = new B(
                    this.pdfGradientType,
                    this.getCoordinates(),
                    colors,
                    gState,
                );
                context.pdf.addShadingPattern(id, pattern);
                return [2 /*return*/];
            });
        });
    };

    Gradient.prototype.getStops = function (styleSheets) {
        var _this = this;
        if (this.stops) {
            return this.stops;
        }
        // Only need to calculate contextColor once
        if (this.contextColor === undefined) {
            this.contextColor = null;
            var ancestor = this;
            while (ancestor) {
                var colorAttr = getAttribute(
                    ancestor.element,
                    styleSheets,
                    "color",
                );
                if (colorAttr) {
                    this.contextColor = parseColor(colorAttr, null);
                    break;
                }
                ancestor = ancestor.getParent();
            }
        }
        var stops = [];
        this.children.forEach(function (stop) {
            if (stop.element.tagName.toLowerCase() === "stop") {
                var colorAttr = getAttribute(
                    stop.element,
                    styleSheets,
                    "color",
                );
                var color = parseColor(
                    getAttribute(stop.element, styleSheets, "stop-color") || "",
                    colorAttr
                        ? parseColor(colorAttr, null)
                        : _this.contextColor,
                );
                var opacity = parseFloat(
                    getAttribute(stop.element, styleSheets, "stop-opacity") ||
                        "1",
                );
                stops.push({
                    offset: Gradient.parseGradientOffset(
                        stop.element.getAttribute("offset") || "0",
                    ),
                    color: [color.r, color.g, color.b],
                    opacity: opacity,
                });
            }
        });
        return (this.stops = stops);
    };
    Gradient.prototype.getBoundingBoxCore = function (context) {
        return defaultBoundingBox(this.element, context);
    };
    Gradient.prototype.computeNodeTransformCore = function (context) {
        return context.pdf.unitMatrix;
    };
    Gradient.prototype.isVisible = function (parentVisible, context) {
        return svgNodeAndChildrenVisible(this, parentVisible, context);
    };
    /**
     * Convert percentage to decimal
     */
    Gradient.parseGradientOffset = function (value) {
        var parsedValue = parseFloat(value);
        if (!isNaN(parsedValue) && value.indexOf("%") >= 0) {
            return parsedValue / 100;
        }
        return parsedValue;
    };
    return Gradient;
})(NonRenderedNode);
var LinearGradient = /** @class */ (function (_super) {
    __extends(LinearGradient, _super);
    function LinearGradient(element, children) {
        return _super.call(this, "axial", element, children) || this;
    }
    LinearGradient.prototype.getCoordinates = function () {
        return [
            parseFloat(this.element.getAttribute("x1") || "0"),
            parseFloat(this.element.getAttribute("y1") || "0"),
            parseFloat(this.element.getAttribute("x2") || "1"),
            parseFloat(this.element.getAttribute("y2") || "0"),
        ];
    };
    return LinearGradient;
})(Gradient);
var RadialGradient = /** @class */ (function (_super) {
    __extends(RadialGradient, _super);
    function RadialGradient(element, children) {
        return _super.call(this, "radial", element, children) || this;
    }
    RadialGradient.prototype.getCoordinates = function () {
        var cx = this.element.getAttribute("cx");
        var cy = this.element.getAttribute("cy");
        var fx = this.element.getAttribute("fx");
        var fy = this.element.getAttribute("fy");
        return [
            parseFloat(fx || cx || "0.5"),
            parseFloat(fy || cy || "0.5"),
            0,
            parseFloat(cx || "0.5"),
            parseFloat(cy || "0.5"),
            parseFloat(this.element.getAttribute("r") || "0.5"),
        ];
    };
    return RadialGradient;
})(Gradient);
var GradientFill = /** @class */ (function () {
    function GradientFill(key, gradient) {
        this.key = key;
        this.gradient = gradient;
    }
    GradientFill.prototype.getFillData = function (forNode, context) {
        return __awaiter(this, void 0, void 0, function () {
            var gradientUnitsMatrix, bBox, gradientTransform;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        return [
                            4 /*yield*/,
                            context.refsHandler.getRendered(
                                this.key,
                                null,
                                function (node) {
                                    return node.apply(
                                        new Context(context.pdf, {
                                            refsHandler: context.refsHandler,
                                            textMeasure: context.textMeasure,
                                            styleSheets: context.styleSheets,
                                            viewport: context.viewport,
                                            svg2pdfParameters:
                                                context.svg2pdfParameters,
                                        }),
                                    );
                                },
                            ),
                            // matrix to convert between gradient space and user space
                            // for "userSpaceOnUse" this is the current transformation: tfMatrix
                            // for "objectBoundingBox" or default, the gradient gets scaled and transformed to the bounding box
                        ];

                    case 1:
                        _a.sent();
                        if (
                            !this.gradient.element.hasAttribute(
                                "gradientUnits",
                            ) ||
                            this.gradient.element
                                .getAttribute("gradientUnits")
                                .toLowerCase() === "objectboundingbox"
                        ) {
                            bBox = forNode.getBoundingBox(context);
                            gradientUnitsMatrix = context.pdf.Matrix(
                                bBox[2],
                                0,
                                0,
                                bBox[3],
                                bBox[0],
                                bBox[1],
                            );
                        } else {
                            gradientUnitsMatrix = context.pdf.unitMatrix;
                        }
                        gradientTransform = parseTransform(
                            getAttribute(
                                this.gradient.element,
                                context.styleSheets,
                                "gradientTransform",
                                "transform",
                            ),
                            context,
                        );
                        return [
                            2 /*return*/,
                            {
                                key: this.key,
                                matrix: context.pdf.matrixMult(
                                    gradientTransform,
                                    gradientUnitsMatrix,
                                ),
                            },
                        ];
                }
            });
        });
    };
    return GradientFill;
})();
var Pattern = /** @class */ (function (_super) {
    __extends(Pattern, _super);
    function Pattern() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    Pattern.prototype.apply = function (context) {
        return __awaiter(this, void 0, void 0, function () {
            var id, bBox, pattern, _i, _a, child;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        id = this.element.getAttribute("id");
                        if (!id) {
                            return [2 /*return*/];
                        }

                        bBox = this.getBoundingBox(context);
                        pattern = new M(
                            [
                                bBox[0],
                                bBox[1],
                                bBox[0] + bBox[2],
                                bBox[1] + bBox[3],
                            ],
                            bBox[2],
                            bBox[3],
                        );
                        context.pdf.beginTilingPattern(pattern);
                        (_i = 0), (_a = this.children);
                        _b.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 4];
                        child = _a[_i];
                        return [
                            4 /*yield*/,
                            child.render(
                                new Context(context.pdf, {
                                    attributeState: context.attributeState,
                                    refsHandler: context.refsHandler,
                                    styleSheets: context.styleSheets,
                                    viewport: context.viewport,
                                    svg2pdfParameters:
                                        context.svg2pdfParameters,
                                }),
                            ),
                        ];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4:
                        context.pdf.endTilingPattern(id, pattern);
                        return [2 /*return*/];
                }
            });
        });
    };

    Pattern.prototype.getBoundingBoxCore = function (context) {
        return defaultBoundingBox(this.element, context);
    };
    Pattern.prototype.computeNodeTransformCore = function (context) {
        return context.pdf.unitMatrix;
    };
    Pattern.prototype.isVisible = function (parentVisible, context) {
        return svgNodeAndChildrenVisible(this, parentVisible, context);
    };
    return Pattern;
})(NonRenderedNode);
var PatternFill = /** @class */ (function () {
    function PatternFill(key, pattern) {
        this.key = key;
        this.pattern = pattern;
    }
    PatternFill.prototype.getFillData = function (forNode, context) {
        return __awaiter(this, void 0, void 0, function () {
            var patternData,
                bBox,
                patternUnitsMatrix,
                fillBBox,
                x,
                y,
                width,
                height,
                patternContentUnitsMatrix,
                fillBBox,
                x,
                y,
                width,
                height,
                patternTransformMatrix,
                patternTransform,
                matrix;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        return [
                            4 /*yield*/,
                            context.refsHandler.getRendered(
                                this.key,
                                null,
                                function (node) {
                                    return node.apply(
                                        new Context(context.pdf, {
                                            refsHandler: context.refsHandler,
                                            textMeasure: context.textMeasure,
                                            styleSheets: context.styleSheets,
                                            viewport: context.viewport,
                                            svg2pdfParameters:
                                                context.svg2pdfParameters,
                                        }),
                                    );
                                },
                            ),
                        ];
                    case 1:
                        _a.sent();
                        patternData = {
                            key: this.key,
                            boundingBox: undefined,
                            xStep: 0,
                            yStep: 0,
                            matrix: undefined,
                        };
                        patternUnitsMatrix = context.pdf.unitMatrix;
                        if (
                            !this.pattern.element.hasAttribute(
                                "patternUnits",
                            ) ||
                            this.pattern.element
                                .getAttribute("patternUnits")
                                .toLowerCase() === "objectboundingbox"
                        ) {
                            bBox = forNode.getBoundingBox(context);
                            patternUnitsMatrix = context.pdf.Matrix(
                                1,
                                0,
                                0,
                                1,
                                bBox[0],
                                bBox[1],
                            );
                            fillBBox = this.pattern.getBoundingBox(context);
                            x = fillBBox[0] * bBox[0] || 0;
                            y = fillBBox[1] * bBox[1] || 0;
                            width = fillBBox[2] * bBox[2] || 0;
                            height = fillBBox[3] * bBox[3] || 0;
                            patternData.boundingBox = [
                                x,
                                y,
                                x + width,
                                y + height,
                            ];
                            patternData.xStep = width;
                            patternData.yStep = height;
                        }
                        patternContentUnitsMatrix = context.pdf.unitMatrix;
                        if (
                            this.pattern.element.hasAttribute(
                                "patternContentUnits",
                            ) &&
                            this.pattern.element
                                .getAttribute("patternContentUnits")
                                .toLowerCase() === "objectboundingbox"
                        ) {
                            bBox || (bBox = forNode.getBoundingBox(context));
                            patternContentUnitsMatrix = context.pdf.Matrix(
                                bBox[2],
                                0,
                                0,
                                bBox[3],
                                0,
                                0,
                            );
                            fillBBox =
                                patternData.boundingBox ||
                                this.pattern.getBoundingBox(context);
                            x = fillBBox[0] / bBox[0] || 0;
                            y = fillBBox[1] / bBox[1] || 0;
                            width = fillBBox[2] / bBox[2] || 0;
                            height = fillBBox[3] / bBox[3] || 0;
                            patternData.boundingBox = [
                                x,
                                y,
                                x + width,
                                y + height,
                            ];
                            patternData.xStep = width;
                            patternData.yStep = height;
                        }
                        patternTransformMatrix = context.pdf.unitMatrix;
                        patternTransform = getAttribute(
                            this.pattern.element,
                            context.styleSheets,
                            "patternTransform",
                            "transform",
                        );
                        if (patternTransform) {
                            patternTransformMatrix = parseTransform(
                                patternTransform,
                                context,
                            );
                        }
                        matrix = patternContentUnitsMatrix;
                        matrix = context.pdf.matrixMult(
                            matrix,
                            patternUnitsMatrix,
                        ); // translate by
                        matrix = context.pdf.matrixMult(
                            matrix,
                            patternTransformMatrix,
                        );
                        matrix = context.pdf.matrixMult(
                            matrix,
                            context.transform,
                        );
                        patternData.matrix = matrix;
                        return [2 /*return*/, patternData];
                }
            });
        });
    };
    return PatternFill;
})();
function parseFill(fill, context) {
    var url = iriReference.exec(fill);
    if (url) {
        var fillUrl = url[1];
        var fillNode = context.refsHandler.get(fillUrl);
        if (
            fillNode &&
            (fillNode instanceof LinearGradient ||
                fillNode instanceof RadialGradient)
        ) {
            return getGradientFill(fillUrl, fillNode, context);
        } else if (fillNode && fillNode instanceof Pattern) {
            return new PatternFill(fillUrl, fillNode);
        } else {
            // unsupported fill argument -> fill black
            return new ColorFill(new RGBColor("rgb(0, 0, 0)"));
        }
    } else {
        // plain color
        var fillColor = parseColor(fill, context.attributeState.color);
        if (fillColor.ok) {
            return new ColorFill(fillColor);
        } else if (fill === "none") {
            return null;
        } else {
            return null;
        }
    }
}
function getGradientFill(fillUrl, gradient, context) {
    // "It is necessary that at least two stops are defined to have a gradient effect. If no stops are
    // defined, then painting shall occur as if 'none' were specified as the paint style. If one stop
    // is defined, then paint with the solid color fill using the color defined for that gradient
    // stop."
    var stops = gradient.getStops(context.styleSheets);
    if (stops.length === 0) {
        return null;
    }
    if (stops.length === 1) {
        var stopColor = stops[0].color;
        var rgbColor = new RGBColor();
        rgbColor.ok = true;
        rgbColor.r = stopColor[0];
        rgbColor.g = stopColor[1];
        rgbColor.b = stopColor[2];
        rgbColor.a = stops[0].opacity;
        return new ColorFill(rgbColor);
    }
    return new GradientFill(fillUrl, gradient);
}
function parseAttributes(context, svgNode, node) {
    var domNode = node || svgNode.element;
    // update color first so currentColor becomes available for this node
    var color = getAttribute(domNode, context.styleSheets, "color");
    if (color) {
        var fillColor = parseColor(color, context.attributeState.color);
        if (fillColor.ok) {
            context.attributeState.color = fillColor;
        } else {
            // invalid color passed, reset to black
            context.attributeState.color = new RGBColor("rgb(0,0,0)");
        }
    }
    var visibility = getAttribute(domNode, context.styleSheets, "visibility");
    if (visibility) {
        context.attributeState.visibility = visibility;
    }
    // fill mode
    var fill = getAttribute(domNode, context.styleSheets, "fill");
    if (fill) {
        context.attributeState.fill = parseFill(fill, context);
    }
    // opacity is realized via a pdf graphics state
    var fillOpacity = getAttribute(
        domNode,
        context.styleSheets,
        "fill-opacity",
    );
    if (fillOpacity) {
        context.attributeState.fillOpacity = parseFloat(fillOpacity);
    }
    var strokeOpacity = getAttribute(
        domNode,
        context.styleSheets,
        "stroke-opacity",
    );
    if (strokeOpacity) {
        context.attributeState.strokeOpacity = parseFloat(strokeOpacity);
    }
    var opacity = getAttribute(domNode, context.styleSheets, "opacity");
    if (opacity) {
        context.attributeState.opacity = parseFloat(opacity);
    }
    // stroke mode
    var strokeWidth = getAttribute(
        domNode,
        context.styleSheets,
        "stroke-width",
    );
    if (strokeWidth !== void 0 && strokeWidth !== "") {
        context.attributeState.strokeWidth = Math.abs(parseFloat(strokeWidth));
    }
    var stroke = getAttribute(domNode, context.styleSheets, "stroke");
    if (stroke) {
        if (stroke === "none") {
            context.attributeState.stroke = null;
        } else {
            // gradients, patterns not supported for strokes ...
            var strokeRGB = parseColor(stroke, context.attributeState.color);
            if (strokeRGB.ok) {
                context.attributeState.stroke = new ColorFill(strokeRGB);
            }
        }
    }
    var lineCap = getAttribute(domNode, context.styleSheets, "stroke-linecap");
    if (lineCap) {
        context.attributeState.strokeLinecap = lineCap;
    }
    var lineJoin = getAttribute(
        domNode,
        context.styleSheets,
        "stroke-linejoin",
    );
    if (lineJoin) {
        context.attributeState.strokeLinejoin = lineJoin;
    }
    var dashArray = getAttribute(
        domNode,
        context.styleSheets,
        "stroke-dasharray",
    );
    if (dashArray) {
        var dashOffset = parseInt(
            getAttribute(domNode, context.styleSheets, "stroke-dashoffset") ||
                "0",
        );
        context.attributeState.strokeDasharray = parseFloats(dashArray);
        context.attributeState.strokeDashoffset = dashOffset;
    }
    var miterLimit = getAttribute(
        domNode,
        context.styleSheets,
        "stroke-miterlimit",
    );
    if (miterLimit !== void 0 && miterLimit !== "") {
        context.attributeState.strokeMiterlimit = parseFloat(miterLimit);
    }
    var xmlSpace = domNode.getAttribute("xml:space");
    if (xmlSpace) {
        context.attributeState.xmlSpace = xmlSpace;
    }
    var fontWeight = getAttribute(domNode, context.styleSheets, "font-weight");
    if (fontWeight) {
        context.attributeState.fontWeight = fontWeight;
    }
    var fontStyle = getAttribute(domNode, context.styleSheets, "font-style");
    if (fontStyle) {
        context.attributeState.fontStyle = fontStyle;
    }
    var fontFamily = getAttribute(domNode, context.styleSheets, "font-family");
    if (fontFamily) {
        var fontFamilies = fontFamilyPapandreou.parse(fontFamily);
        context.attributeState.fontFamily = findFirstAvailableFontFamily(
            context.attributeState,
            fontFamilies,
            context,
        );
    }
    var fontSize = getAttribute(domNode, context.styleSheets, "font-size");
    if (fontSize) {
        var pdfFontSize = context.pdf.getFontSize();
        context.attributeState.fontSize = toPixels(fontSize, pdfFontSize);
    }
    var alignmentBaseline =
        getAttribute(domNode, context.styleSheets, "vertical-align") ||
        getAttribute(domNode, context.styleSheets, "alignment-baseline");
    if (alignmentBaseline) {
        var matchArr = alignmentBaseline.match(
            /(baseline|text-bottom|alphabetic|ideographic|middle|central|mathematical|text-top|bottom|center|top|hanging)/,
        );
        if (matchArr) {
            context.attributeState.alignmentBaseline = matchArr[0];
        }
    }
    var textAnchor = getAttribute(domNode, context.styleSheets, "text-anchor");
    if (textAnchor) {
        context.attributeState.textAnchor = textAnchor;
    }
}
function applyAttributes(childContext, parentContext, node) {
    var fillOpacity = 1.0,
        strokeOpacity = 1.0;
    fillOpacity *= childContext.attributeState.fillOpacity;
    fillOpacity *= childContext.attributeState.opacity;
    if (
        childContext.attributeState.fill instanceof ColorFill &&
        typeof childContext.attributeState.fill.color.a !== "undefined"
    ) {
        fillOpacity *= childContext.attributeState.fill.color.a;
    }
    strokeOpacity *= childContext.attributeState.strokeOpacity;
    strokeOpacity *= childContext.attributeState.opacity;
    if (
        childContext.attributeState.stroke instanceof ColorFill &&
        typeof childContext.attributeState.stroke.color.a !== "undefined"
    ) {
        strokeOpacity *= childContext.attributeState.stroke.color.a;
    }
    var hasFillOpacity = fillOpacity < 1.0;
    var hasStrokeOpacity = strokeOpacity < 1.0;
    // This is a workaround for symbols that are used multiple times with different
    // fill/stroke attributes. All paths within symbols are both filled and stroked
    // and we set the fill/stroke to transparent if the use element has
    // fill/stroke="none".
    if (nodeIs(node, "use")) {
        hasFillOpacity = true;
        hasStrokeOpacity = true;
        fillOpacity *= childContext.attributeState.fill ? 1 : 0;
        strokeOpacity *= childContext.attributeState.stroke ? 1 : 0;
    } else if (childContext.withinUse) {
        if (
            childContext.attributeState.fill !==
            parentContext.attributeState.fill
        ) {
            hasFillOpacity = true;
            fillOpacity *= childContext.attributeState.fill ? 1 : 0;
        } else if (hasFillOpacity && !childContext.attributeState.fill) {
            fillOpacity = 0;
        }
        if (
            childContext.attributeState.stroke !==
            parentContext.attributeState.stroke
        ) {
            hasStrokeOpacity = true;
            strokeOpacity *= childContext.attributeState.stroke ? 1 : 0;
        } else if (hasStrokeOpacity && !childContext.attributeState.stroke) {
            strokeOpacity = 0;
        }
    }
    if (hasFillOpacity || hasStrokeOpacity) {
        var gState = {};
        hasFillOpacity && (gState["opacity"] = fillOpacity);
        hasStrokeOpacity && (gState["stroke-opacity"] = strokeOpacity);
        childContext.pdf.setGState(new j(gState));
    }
    if (
        childContext.attributeState.fill &&
        childContext.attributeState.fill !==
            parentContext.attributeState.fill &&
        childContext.attributeState.fill instanceof ColorFill &&
        childContext.attributeState.fill.color.ok &&
        !nodeIs(node, "text")
    ) {
        // text fill color will be applied through setTextColor()
        childContext.pdf.setFillColor(
            childContext.attributeState.fill.color.r,
            childContext.attributeState.fill.color.g,
            childContext.attributeState.fill.color.b,
        );
    }
    if (
        childContext.attributeState.strokeWidth !==
        parentContext.attributeState.strokeWidth
    ) {
        childContext.pdf.setLineWidth(childContext.attributeState.strokeWidth);
    }
    if (
        childContext.attributeState.stroke !==
            parentContext.attributeState.stroke &&
        childContext.attributeState.stroke instanceof ColorFill
    ) {
        childContext.pdf.setDrawColor(
            childContext.attributeState.stroke.color.r,
            childContext.attributeState.stroke.color.g,
            childContext.attributeState.stroke.color.b,
        );
    }
    if (
        childContext.attributeState.strokeLinecap !==
        parentContext.attributeState.strokeLinecap
    ) {
        childContext.pdf.setLineCap(childContext.attributeState.strokeLinecap);
    }
    if (
        childContext.attributeState.strokeLinejoin !==
        parentContext.attributeState.strokeLinejoin
    ) {
        childContext.pdf.setLineJoin(
            childContext.attributeState.strokeLinejoin,
        );
    }
    if (
        (childContext.attributeState.strokeDasharray !==
            parentContext.attributeState.strokeDasharray ||
            childContext.attributeState.strokeDashoffset !==
                parentContext.attributeState.strokeDashoffset) &&
        childContext.attributeState.strokeDasharray
    ) {
        childContext.pdf.setLineDashPattern(
            childContext.attributeState.strokeDasharray,
            childContext.attributeState.strokeDashoffset,
        );
    }
    if (
        childContext.attributeState.strokeMiterlimit !==
        parentContext.attributeState.strokeMiterlimit
    ) {
        childContext.pdf.setLineMiterLimit(
            childContext.attributeState.strokeMiterlimit,
        );
    }
    var font;
    if (
        childContext.attributeState.fontFamily !==
        parentContext.attributeState.fontFamily
    ) {
        if (
            fontAliases.hasOwnProperty(childContext.attributeState.fontFamily)
        ) {
            font = fontAliases[childContext.attributeState.fontFamily];
        } else {
            font = childContext.attributeState.fontFamily;
        }
    }
    if (
        childContext.attributeState.fill &&
        childContext.attributeState.fill !==
            parentContext.attributeState.fill &&
        childContext.attributeState.fill instanceof ColorFill &&
        childContext.attributeState.fill.color.ok
    ) {
        var fillColor = childContext.attributeState.fill.color;
        childContext.pdf.setTextColor(fillColor.r, fillColor.g, fillColor.b);
    }
    var fontStyle;
    if (
        childContext.attributeState.fontWeight !==
            parentContext.attributeState.fontWeight ||
        childContext.attributeState.fontStyle !==
            parentContext.attributeState.fontStyle
    ) {
        fontStyle = combineFontStyleAndFontWeight(
            childContext.attributeState.fontStyle,
            childContext.attributeState.fontWeight,
        );
    }
    if (font !== undefined || fontStyle !== undefined) {
        if (font === undefined) {
            if (
                fontAliases.hasOwnProperty(
                    childContext.attributeState.fontFamily,
                )
            ) {
                font = fontAliases[childContext.attributeState.fontFamily];
            } else {
                font = childContext.attributeState.fontFamily;
            }
        }
        childContext.pdf.setFont(font, fontStyle);
    }
    if (
        childContext.attributeState.fontSize !==
        parentContext.attributeState.fontSize
    ) {
        // correct for a jsPDF-instance measurement unit that differs from `pt`
        childContext.pdf.setFontSize(
            childContext.attributeState.fontSize *
                childContext.pdf.internal.scaleFactor,
        );
    }
}
function applyContext(context) {
    var attributeState = context.attributeState,
        pdf = context.pdf;
    var fillOpacity = 1.0,
        strokeOpacity = 1.0;
    fillOpacity *= attributeState.fillOpacity;
    fillOpacity *= attributeState.opacity;
    if (
        attributeState.fill instanceof ColorFill &&
        typeof attributeState.fill.color.a !== "undefined"
    ) {
        fillOpacity *= attributeState.fill.color.a;
    }
    strokeOpacity *= attributeState.strokeOpacity;
    strokeOpacity *= attributeState.opacity;
    if (
        attributeState.stroke instanceof ColorFill &&
        typeof attributeState.stroke.color.a !== "undefined"
    ) {
        strokeOpacity *= attributeState.stroke.color.a;
    }
    var gState = {};
    gState["opacity"] = fillOpacity;
    gState["stroke-opacity"] = strokeOpacity;
    pdf.setGState(new j(gState));
    if (
        attributeState.fill &&
        attributeState.fill instanceof ColorFill &&
        attributeState.fill.color.ok
    ) {
        // text fill color will be applied through setTextColor()
        pdf.setFillColor(
            attributeState.fill.color.r,
            attributeState.fill.color.g,
            attributeState.fill.color.b,
        );
    } else {
        pdf.setFillColor(0, 0, 0);
    }
    pdf.setLineWidth(attributeState.strokeWidth);
    if (attributeState.stroke instanceof ColorFill) {
        pdf.setDrawColor(
            attributeState.stroke.color.r,
            attributeState.stroke.color.g,
            attributeState.stroke.color.b,
        );
    } else {
        pdf.setDrawColor(0, 0, 0);
    }
    pdf.setLineCap(attributeState.strokeLinecap);
    pdf.setLineJoin(attributeState.strokeLinejoin);
    if (attributeState.strokeDasharray) {
        pdf.setLineDashPattern(
            attributeState.strokeDasharray,
            attributeState.strokeDashoffset,
        );
    } else {
        pdf.setLineDashPattern([], 0);
    }
    pdf.setLineMiterLimit(attributeState.strokeMiterlimit);
    var font;
    if (fontAliases.hasOwnProperty(attributeState.fontFamily)) {
        font = fontAliases[attributeState.fontFamily];
    } else {
        font = attributeState.fontFamily;
    }
    if (
        attributeState.fill &&
        attributeState.fill instanceof ColorFill &&
        attributeState.fill.color.ok
    ) {
        var fillColor = attributeState.fill.color;
        pdf.setTextColor(fillColor.r, fillColor.g, fillColor.b);
    } else {
        pdf.setTextColor(0, 0, 0);
    }
    var fontStyle = "";
    if (attributeState.fontWeight === "bold") {
        fontStyle = "bold";
    }
    if (attributeState.fontStyle === "italic") {
        fontStyle += "italic";
    }
    if (fontStyle === "") {
        fontStyle = "normal";
    }
    if (font !== undefined || fontStyle !== undefined) {
        if (font === undefined) {
            if (fontAliases.hasOwnProperty(attributeState.fontFamily)) {
                font = fontAliases[attributeState.fontFamily];
            } else {
                font = attributeState.fontFamily;
            }
        }
        pdf.setFont(font, fontStyle);
    } else {
        pdf.setFont("helvetica", fontStyle);
    }
    // correct for a jsPDF-instance measurement unit that differs from `pt`
    pdf.setFontSize(attributeState.fontSize * pdf.internal.scaleFactor);
}
function getClipPathNode(clipPathAttr, targetNode, context) {
    var match = iriReference.exec(clipPathAttr);
    if (!match) {
        return undefined;
    }
    var clipPathId = match[1];
    var clipNode = context.refsHandler.get(clipPathId);
    return clipNode || undefined;
}
function applyClipPath(targetNode, clipPathNode, context) {
    return __awaiter(this, void 0, void 0, function () {
        var clipContext, bBox;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    clipContext = context.clone();
                    if (
                        clipPathNode.element.hasAttribute("clipPathUnits") &&
                        clipPathNode.element
                            .getAttribute("clipPathUnits")
                            .toLowerCase() === "objectboundingbox"
                    ) {
                        bBox = targetNode.getBoundingBox(context);
                        clipContext.transform = context.pdf.matrixMult(
                            context.pdf.Matrix(
                                bBox[2],
                                0,
                                0,
                                bBox[3],
                                bBox[0],
                                bBox[1],
                            ),
                            context.transform,
                        );
                    }
                    return [4 /*yield*/, clipPathNode.apply(clipContext)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}

var RenderedNode = /** @class */ (function (_super) {
    __extends(RenderedNode, _super);
    function RenderedNode() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    RenderedNode.prototype.render = function (parentContext) {
        return __awaiter(this, void 0, void 0, function () {
            var context, clipPathAttribute, hasClipPath, clipNode;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (
                            !this.isVisible(
                                parentContext.attributeState.visibility !==
                                    "hidden",
                                parentContext,
                            )
                        ) {
                            return [2 /*return*/];
                        }

                        context = parentContext.clone();
                        context.transform = context.pdf.matrixMult(
                            this.computeNodeTransform(context),
                            parentContext.transform,
                        );
                        parseAttributes(context, this);
                        clipPathAttribute = getAttribute(
                            this.element,
                            context.styleSheets,
                            "clip-path",
                        );
                        hasClipPath =
                            clipPathAttribute && clipPathAttribute !== "none";
                        if (!hasClipPath) return [3 /*break*/, 5];
                        clipNode = getClipPathNode(
                            clipPathAttribute,
                            this,
                            context,
                        );
                        if (!clipNode) return [3 /*break*/, 4];
                        if (!clipNode.isVisible(true, context))
                            return [3 /*break*/, 2];
                        context.pdf.saveGraphicsState();
                        return [
                            4 /*yield*/,
                            applyClipPath(this, clipNode, context),
                        ];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        return [2 /*return*/];
                    case 3:
                        return [3 /*break*/, 5];
                    case 4:
                        hasClipPath = false;
                        _a.label = 5;
                    case 5:
                        if (!context.withinClipPath) {
                            context.pdf.saveGraphicsState();
                        }
                        applyAttributes(context, parentContext, this.element);
                        return [4 /*yield*/, this.renderCore(context)];
                    case 6:
                        _a.sent();
                        if (!context.withinClipPath) {
                            context.pdf.restoreGraphicsState();
                        }
                        if (hasClipPath) {
                            context.pdf.restoreGraphicsState();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };

    return RenderedNode;
})(SvgNode);
var GraphicsNode = /** @class */ (function (_super) {
    __extends(GraphicsNode, _super);
    function GraphicsNode() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    return GraphicsNode;
})(RenderedNode);
var GeometryNode = /** @class */ (function (_super) {
    __extends(GeometryNode, _super);
    function GeometryNode(hasMarkers, element, children) {
        var _this = _super.call(this, element, children) || this;
        _this.cachedPath = null;
        _this.hasMarkers = hasMarkers;
        return _this;
    }
    GeometryNode.prototype.renderCore = function (context) {
        return __awaiter(this, void 0, void 0, function () {
            var path;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = this.getCachedPath(context);
                        if (path === null || path.segments.length === 0) {
                            return [2 /*return*/];
                        }

                        if (context.withinClipPath) {
                            path.transform(context.transform);
                        } else {
                            context.pdf.setCurrentTransformationMatrix(
                                context.transform,
                            );
                        }
                        path.draw(context);
                        return [4 /*yield*/, this.fillOrStroke(context)];
                    case 1:
                        _a.sent();
                        if (!this.hasMarkers) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.drawMarkers(context, path)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        return [2 /*return*/];
                }
            });
        });
    };

    GeometryNode.prototype.getCachedPath = function (context) {
        return this.cachedPath || (this.cachedPath = this.getPath(context));
    };
    GeometryNode.prototype.drawMarkers = function (context, path) {
        return __awaiter(this, void 0, void 0, function () {
            var markers;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        markers = this.getMarkers(path, context);
                        return [
                            4 /*yield*/,
                            markers.draw(
                                context.clone({
                                    transform: context.pdf.unitMatrix,
                                }),
                            ),
                        ];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };

    GeometryNode.prototype.fillOrStroke = function (context) {
        return __awaiter(this, void 0, void 0, function () {
            var fill, stroke, fillData, _a, isNodeFillRuleEvenOdd;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (context.withinClipPath) {
                            return [2 /*return*/];
                        }

                        fill = context.attributeState.fill;
                        stroke =
                            context.attributeState.stroke &&
                            context.attributeState.strokeWidth !== 0;
                        if (!fill) return [3 /*break*/, 2];
                        return [4 /*yield*/, fill.getFillData(this, context)];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = undefined;
                        _b.label = 3;
                    case 3:
                        fillData = _a;
                        isNodeFillRuleEvenOdd =
                            getAttribute(
                                this.element,
                                context.styleSheets,
                                "fill-rule",
                            ) === "evenodd";
                        // This is a workaround for symbols that are used multiple times with different
                        // fill/stroke attributes. All paths within symbols are both filled and stroked
                        // and we set the fill/stroke to transparent if the use element has
                        // fill/stroke="none".
                        if ((fill && stroke) || context.withinUse) {
                            if (isNodeFillRuleEvenOdd) {
                                context.pdf.fillStrokeEvenOdd(fillData);
                            } else {
                                context.pdf.fillStroke(fillData);
                            }
                        } else if (fill) {
                            if (isNodeFillRuleEvenOdd) {
                                context.pdf.fillEvenOdd(fillData);
                            } else {
                                context.pdf.fill(fillData);
                            }
                        } else if (stroke) {
                            context.pdf.stroke();
                        } else {
                            context.pdf.discardPath();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };

    GeometryNode.prototype.getBoundingBoxCore = function (context) {
        var path = this.getCachedPath(context);
        if (!path) {
            return [0, 0, 0, 0];
        }
        var minX = Number.POSITIVE_INFINITY;
        var minY = Number.POSITIVE_INFINITY;
        var maxX = Number.NEGATIVE_INFINITY;
        var maxY = Number.NEGATIVE_INFINITY;
        var x = 0,
            y = 0;
        for (var i = 0; i < path.segments.length; i++) {
            var seg = path.segments[i];
            if (
                seg instanceof MoveTo ||
                seg instanceof LineTo ||
                seg instanceof CurveTo
            ) {
                x = seg.x;
                y = seg.y;
            }
            if (seg instanceof CurveTo) {
                minX = Math.min(minX, x, seg.x1, seg.x2, seg.x);
                maxX = Math.max(maxX, x, seg.x1, seg.x2, seg.x);
                minY = Math.min(minY, y, seg.y1, seg.y2, seg.y);
                maxY = Math.max(maxY, y, seg.y1, seg.y2, seg.y);
            } else {
                minX = Math.min(minX, x);
                maxX = Math.max(maxX, x);
                minY = Math.min(minY, y);
                maxY = Math.max(maxY, y);
            }
        }
        return [minX, minY, maxX - minX, maxY - minY];
    };
    GeometryNode.prototype.getMarkers = function (path, context) {
        var markerStart = getAttribute(
            this.element,
            context.styleSheets,
            "marker-start",
        );
        var markerMid = getAttribute(
            this.element,
            context.styleSheets,
            "marker-mid",
        );
        var markerEnd = getAttribute(
            this.element,
            context.styleSheets,
            "marker-end",
        );
        var markers = new MarkerList();
        if (markerStart || markerMid || markerEnd) {
            markerEnd && (markerEnd = iri(markerEnd));
            markerStart && (markerStart = iri(markerStart));
            markerMid && (markerMid = iri(markerMid));
            var list_1 = path.segments;
            var prevAngle = [1, 0],
                curAngle = void 0,
                first = false,
                firstAngle = [1, 0],
                last_1 = false;
            var _loop_1 = function (i) {
                var curr = list_1[i];
                var hasStartMarker =
                    markerStart &&
                    (i === 1 ||
                        (!(list_1[i] instanceof MoveTo) &&
                            list_1[i - 1] instanceof MoveTo));
                if (hasStartMarker) {
                    list_1.forEach(function (value, index) {
                        if (!last_1 && value instanceof Close && index > i) {
                            var tmp = list_1[index - 1];
                            last_1 =
                                (tmp instanceof MoveTo ||
                                    tmp instanceof LineTo ||
                                    tmp instanceof CurveTo) &&
                                tmp;
                        }
                    });
                }
                var hasEndMarker =
                    markerEnd &&
                    (i === list_1.length - 1 ||
                        (!(list_1[i] instanceof MoveTo) &&
                            list_1[i + 1] instanceof MoveTo));
                var hasMidMarker =
                    markerMid &&
                    i > 0 &&
                    !(i === 1 && list_1[i - 1] instanceof MoveTo);
                var prev = list_1[i - 1] || null;
                if (
                    prev instanceof MoveTo ||
                    prev instanceof LineTo ||
                    prev instanceof CurveTo
                ) {
                    if (curr instanceof CurveTo) {
                        hasStartMarker &&
                            markers.addMarker(
                                new Marker(
                                    markerStart,
                                    [prev.x, prev.y],
                                    // @ts-ignore
                                    getAngle(
                                        last_1
                                            ? [last_1.x, last_1.y]
                                            : [prev.x, prev.y],
                                        [curr.x1, curr.y1],
                                    ),
                                ),
                            );
                        hasEndMarker &&
                            markers.addMarker(
                                new Marker(
                                    markerEnd,
                                    [curr.x, curr.y],
                                    getAngle(
                                        [curr.x2, curr.y2],
                                        [curr.x, curr.y],
                                    ),
                                ),
                            );
                        if (hasMidMarker) {
                            curAngle = getDirectionVector(
                                [prev.x, prev.y],
                                [curr.x1, curr.y1],
                            );
                            curAngle =
                                prev instanceof MoveTo
                                    ? curAngle
                                    : normalize(
                                          addVectors(prevAngle, curAngle),
                                      );
                            markers.addMarker(
                                new Marker(
                                    markerMid,
                                    [prev.x, prev.y],
                                    Math.atan2(curAngle[1], curAngle[0]),
                                ),
                            );
                        }
                        prevAngle = getDirectionVector(
                            [curr.x2, curr.y2],
                            [curr.x, curr.y],
                        );
                    } else if (
                        curr instanceof MoveTo ||
                        curr instanceof LineTo
                    ) {
                        curAngle = getDirectionVector(
                            [prev.x, prev.y],
                            [curr.x, curr.y],
                        );
                        if (hasStartMarker) {
                            // @ts-ignore
                            var angle = last_1
                                ? getDirectionVector(
                                      [last_1.x, last_1.y],
                                      [curr.x, curr.y],
                                  )
                                : curAngle;
                            markers.addMarker(
                                new Marker(
                                    markerStart,
                                    [prev.x, prev.y],
                                    Math.atan2(angle[1], angle[0]),
                                ),
                            );
                        }
                        hasEndMarker &&
                            markers.addMarker(
                                new Marker(
                                    markerEnd,
                                    [curr.x, curr.y],
                                    Math.atan2(curAngle[1], curAngle[0]),
                                ),
                            );
                        if (hasMidMarker) {
                            var angle =
                                curr instanceof MoveTo
                                    ? prevAngle
                                    : prev instanceof MoveTo
                                      ? curAngle
                                      : normalize(
                                            addVectors(prevAngle, curAngle),
                                        );
                            markers.addMarker(
                                new Marker(
                                    markerMid,
                                    [prev.x, prev.y],
                                    Math.atan2(angle[1], angle[0]),
                                ),
                            );
                        }
                        prevAngle = curAngle;
                    } else if (curr instanceof Close) {
                        // @ts-ignore
                        curAngle = getDirectionVector(
                            [prev.x, prev.y],
                            [first.x, first.y],
                        );
                        if (hasMidMarker) {
                            var angle =
                                prev instanceof MoveTo
                                    ? curAngle
                                    : normalize(
                                          addVectors(prevAngle, curAngle),
                                      );
                            markers.addMarker(
                                new Marker(
                                    markerMid,
                                    [prev.x, prev.y],
                                    Math.atan2(angle[1], angle[0]),
                                ),
                            );
                        }
                        if (hasEndMarker) {
                            var angle = normalize(
                                addVectors(curAngle, firstAngle),
                            );
                            markers.addMarker(
                                // @ts-ignore
                                new Marker(
                                    markerEnd,
                                    [first.x, first.y],
                                    Math.atan2(angle[1], angle[0]),
                                ),
                            );
                        }
                        prevAngle = curAngle;
                    }
                } else {
                    first = curr instanceof MoveTo && curr;
                    var next = list_1[i + 1];
                    if (
                        next instanceof MoveTo ||
                        next instanceof LineTo ||
                        next instanceof CurveTo
                    ) {
                        // @ts-ignore
                        firstAngle = getDirectionVector(
                            [first.x, first.y],
                            [next.x, next.y],
                        );
                    }
                }
            };
            for (var i = 0; i < list_1.length; i++) {
                _loop_1(i);
            }
        }
        return markers;
    };
    return GeometryNode;
})(GraphicsNode);
function iri(attribute) {
    var match = iriReference.exec(attribute);
    return (match && match[1]) || undefined;
}
var Line = /** @class */ (function (_super) {
    __extends(Line, _super);
    function Line(node, children) {
        return _super.call(this, true, node, children) || this;
    }
    Line.prototype.getPath = function (context) {
        if (context.withinClipPath || context.attributeState.stroke === null) {
            return null;
        }
        var x1 = parseFloat(this.element.getAttribute("x1") || "0"),
            y1 = parseFloat(this.element.getAttribute("y1") || "0");
        var x2 = parseFloat(this.element.getAttribute("x2") || "0"),
            y2 = parseFloat(this.element.getAttribute("y2") || "0");
        if (!(x1 || x2 || y1 || y2)) {
            return null;
        }
        return new Path().moveTo(x1, y1).lineTo(x2, y2);
    };
    Line.prototype.computeNodeTransformCore = function (context) {
        return context.pdf.unitMatrix;
    };
    Line.prototype.isVisible = function (parentVisible, context) {
        return svgNodeIsVisible(this, parentVisible, context);
    };
    Line.prototype.fillOrStroke = function (context) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        context.attributeState.fill = null;
                        return [
                            4 /*yield*/,
                            _super.prototype.fillOrStroke.call(this, context),
                        ];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };

    return Line;
})(GeometryNode);
var Symbol$1 = /** @class */ (function (_super) {
    __extends(Symbol, _super);
    function Symbol() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    Symbol.prototype.apply = function (parentContext) {
        return __awaiter(this, void 0, void 0, function () {
            var context,
                clipPathAttribute,
                hasClipPath,
                clipNode,
                _i,
                _a,
                child;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (
                            !this.isVisible(
                                parentContext.attributeState.visibility !==
                                    "hidden",
                                parentContext,
                            )
                        ) {
                            return [2 /*return*/];
                        }

                        context = parentContext.clone();
                        context.transform = context.pdf.unitMatrix;
                        parseAttributes(context, this);
                        clipPathAttribute = getAttribute(
                            this.element,
                            context.styleSheets,
                            "clip-path",
                        );
                        hasClipPath =
                            clipPathAttribute && clipPathAttribute !== "none";
                        if (!hasClipPath) return [3 /*break*/, 3];
                        clipNode = getClipPathNode(
                            clipPathAttribute,
                            this,
                            context,
                        );
                        if (!clipNode) return [3 /*break*/, 3];
                        if (!clipNode.isVisible(true, context))
                            return [3 /*break*/, 2];
                        return [
                            4 /*yield*/,
                            applyClipPath(this, clipNode, context),
                        ];
                    case 1:
                        _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        return [2 /*return*/];
                    case 3:
                        applyAttributes(context, parentContext, this.element);
                        (_i = 0), (_a = this.children);
                        _b.label = 4;
                    case 4:
                        if (!(_i < _a.length)) return [3 /*break*/, 7];
                        child = _a[_i];
                        return [4 /*yield*/, child.render(context)];
                    case 5:
                        _b.sent();
                        _b.label = 6;
                    case 6:
                        _i++;
                        return [3 /*break*/, 4];
                    case 7:
                        return [2 /*return*/];
                }
            });
        });
    };

    Symbol.prototype.getBoundingBoxCore = function (context) {
        return getBoundingBoxByChildren(context, this);
    };
    Symbol.prototype.isVisible = function (parentVisible, context) {
        return svgNodeAndChildrenVisible(this, parentVisible, context);
    };
    Symbol.prototype.computeNodeTransformCore = function (context) {
        var x = parseFloat(
            getAttribute(this.element, context.styleSheets, "x") || "0",
        );
        var y = parseFloat(
            getAttribute(this.element, context.styleSheets, "y") || "0",
        );
        // TODO: implement refX/refY - this is still to do because common browsers don't seem to support the feature yet
        // x += parseFloat(this.element.getAttribute("refX")) || 0; ???
        // y += parseFloat(this.element.getAttribute("refY")) || 0; ???
        var viewBox = this.element.getAttribute("viewBox");
        if (viewBox) {
            var box = parseFloats(viewBox);
            var width = parseFloat(
                getAttribute(this.element, context.styleSheets, "width") ||
                    getAttribute(
                        this.element.ownerSVGElement,
                        context.styleSheets,
                        "width",
                    ) ||
                    viewBox[2],
            );
            var height = parseFloat(
                getAttribute(this.element, context.styleSheets, "height") ||
                    getAttribute(
                        this.element.ownerSVGElement,
                        context.styleSheets,
                        "height",
                    ) ||
                    viewBox[3],
            );
            return computeViewBoxTransform(
                this.element,
                box,
                x,
                y,
                width,
                height,
                context,
            );
        } else {
            return context.pdf.Matrix(1, 0, 0, 1, x, y);
        }
    };
    return Symbol;
})(NonRenderedNode);
var Viewport = /** @class */ (function () {
    function Viewport(width, height) {
        this.width = width;
        this.height = height;
    }
    return Viewport;
})();

/**
 * Draws the element referenced by a use node, makes use of pdf's XObjects/FormObjects so nodes are only written once
 * to the pdf document. This highly reduces the file size and computation time.
 */
var Use = /** @class */ (function (_super) {
    __extends(Use, _super);
    function Use() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    Use.prototype.renderCore = function (context) {
        return __awaiter(this, void 0, void 0, function () {
            var pf,
                url,
                id,
                refNode,
                refNodeOpensViewport,
                x,
                y,
                width,
                height,
                t,
                viewBox,
                refContext,
                color;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        pf = parseFloat;
                        url =
                            this.element.getAttribute("href") ||
                            this.element.getAttribute("xlink:href");
                        // just in case someone has the idea to use empty use-tags, wtf???
                        if (!url) return [2 /*return*/];
                        id = url.substring(1);
                        refNode = context.refsHandler.get(id);
                        refNodeOpensViewport =
                            nodeIs(refNode.element, "symbol,svg") &&
                            refNode.element.hasAttribute("viewBox");
                        x = pf(
                            getAttribute(
                                this.element,
                                context.styleSheets,
                                "x",
                            ) || "0",
                        );
                        y = pf(
                            getAttribute(
                                this.element,
                                context.styleSheets,
                                "y",
                            ) || "0",
                        );
                        width = undefined;
                        height = undefined;
                        if (refNodeOpensViewport) {
                            //  <use> inherits width/height only to svg/symbol
                            // if there is no viewBox attribute, width/height don't have an effect
                            // in theory, the default value for width/height is 100%, but we currently don't support this
                            width = pf(
                                getAttribute(
                                    this.element,
                                    context.styleSheets,
                                    "width",
                                ) ||
                                    getAttribute(
                                        refNode.element,
                                        context.styleSheets,
                                        "width",
                                    ) ||
                                    "0",
                            );
                            height = pf(
                                getAttribute(
                                    this.element,
                                    context.styleSheets,
                                    "height",
                                ) ||
                                    getAttribute(
                                        refNode.element,
                                        context.styleSheets,
                                        "height",
                                    ) ||
                                    "0",
                            );
                            //  accumulate x/y to calculate the viewBox transform
                            x += pf(
                                getAttribute(
                                    refNode.element,
                                    context.styleSheets,
                                    "x",
                                ) || "0",
                            );
                            y += pf(
                                getAttribute(
                                    refNode.element,
                                    context.styleSheets,
                                    "y",
                                ) || "0",
                            );
                            viewBox = parseFloats(
                                refNode.element.getAttribute("viewBox"),
                            );
                            t = computeViewBoxTransform(
                                refNode.element,
                                viewBox,
                                x,
                                y,
                                width,
                                height,
                                context,
                            );
                        } else {
                            t = context.pdf.Matrix(1, 0, 0, 1, x, y);
                        }
                        refContext = new Context(context.pdf, {
                            refsHandler: context.refsHandler,
                            styleSheets: context.styleSheets,
                            withinUse: true,
                            viewport: refNodeOpensViewport
                                ? new Viewport(width, height)
                                : context.viewport,
                            svg2pdfParameters: context.svg2pdfParameters,
                        });
                        color = context.attributeState.color;
                        return [
                            4 /*yield*/,
                            context.refsHandler.getRendered(
                                id,
                                color,
                                function (node) {
                                    return Use.renderReferencedNode(
                                        node,
                                        id,
                                        color,
                                        refContext,
                                    );
                                },
                            ),
                        ];
                    case 1:
                        _a.sent();
                        context.pdf.saveGraphicsState();
                        context.pdf.setCurrentTransformationMatrix(
                            context.transform,
                        );
                        //  apply the bbox (i.e. clip) if needed
                        if (
                            refNodeOpensViewport &&
                            getAttribute(
                                refNode.element,
                                context.styleSheets,
                                "overflow",
                            ) !== "visible"
                        ) {
                            context.pdf.rect(x, y, width, height);
                            context.pdf.clip().discardPath();
                        }
                        context.pdf.doFormObject(
                            context.refsHandler.generateKey(id, color),
                            t,
                        );
                        context.pdf.restoreGraphicsState();
                        return [2 /*return*/];
                }
            });
        });
    };

    Use.renderReferencedNode = function (node, id, color, refContext) {
        return __awaiter(this, void 0, void 0, function () {
            var bBox;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        bBox = node.getBoundingBox(refContext);
                        // The content of a PDF form object is implicitly clipped at its /BBox property.
                        // SVG, however, applies its clip rect at the <use> attribute, which may modify it.
                        // So, make the bBox a lot larger than it needs to be and hope any thick strokes are
                        // still within.
                        bBox = [
                            bBox[0] - 0.5 * bBox[2],
                            bBox[1] - 0.5 * bBox[3],
                            bBox[2] * 2,
                            bBox[3] * 2,
                        ];
                        // set the color to use for the referenced node
                        refContext.attributeState.color = color;
                        refContext.pdf.beginFormObject(
                            bBox[0],
                            bBox[1],
                            bBox[2],
                            bBox[3],
                            refContext.pdf.unitMatrix,
                        );
                        if (!(node instanceof Symbol$1))
                            return [3 /*break*/, 2];
                        return [4 /*yield*/, node.apply(refContext)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        return [4 /*yield*/, node.render(refContext)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        refContext.pdf.endFormObject(
                            refContext.refsHandler.generateKey(id, color),
                        );
                        return [2 /*return*/];
                }
            });
        });
    };

    Use.prototype.getBoundingBoxCore = function (context) {
        return defaultBoundingBox(this.element, context);
    };
    Use.prototype.isVisible = function (parentVisible, context) {
        return svgNodeIsVisible(this, parentVisible, context);
    };
    Use.prototype.computeNodeTransformCore = function (context) {
        return context.pdf.unitMatrix;
    };
    return Use;
})(GraphicsNode);
var Rect = /** @class */ (function (_super) {
    __extends(Rect, _super);
    function Rect(element, children) {
        return _super.call(this, false, element, children) || this;
    }
    Rect.prototype.getPath = function (context) {
        var w = parseFloat(
            getAttribute(this.element, context.styleSheets, "width") || "0",
        );
        var h = parseFloat(
            getAttribute(this.element, context.styleSheets, "height") || "0",
        );
        if (!isFinite(w) || w <= 0 || !isFinite(h) || h <= 0) {
            return null;
        }
        var rxAttr = getAttribute(this.element, context.styleSheets, "rx");
        var ryAttr = getAttribute(this.element, context.styleSheets, "ry");
        var rx = Math.min(parseFloat(rxAttr || ryAttr || "0"), w * 0.5);
        var ry = Math.min(parseFloat(ryAttr || rxAttr || "0"), h * 0.5);
        var x = parseFloat(
            getAttribute(this.element, context.styleSheets, "x") || "0",
        );
        var y = parseFloat(
            getAttribute(this.element, context.styleSheets, "y") || "0",
        );
        var arc = (4 / 3) * (Math.SQRT2 - 1);
        if (rx === 0 && ry === 0) {
            return new Path()
                .moveTo(x, y)
                .lineTo(x + w, y)
                .lineTo(x + w, y + h)
                .lineTo(x, y + h)
                .close();
        } else {
            return new Path()
                .moveTo((x += rx), y)
                .lineTo((x += w - 2 * rx), y)
                .curveTo(
                    x + rx * arc,
                    y,
                    x + rx,
                    y + (ry - ry * arc),
                    (x += rx),
                    (y += ry),
                )
                .lineTo(x, (y += h - 2 * ry))
                .curveTo(
                    x,
                    y + ry * arc,
                    x - rx * arc,
                    y + ry,
                    (x -= rx),
                    (y += ry),
                )
                .lineTo((x += -w + 2 * rx), y)
                .curveTo(
                    x - rx * arc,
                    y,
                    x - rx,
                    y - ry * arc,
                    (x -= rx),
                    (y -= ry),
                )
                .lineTo(x, (y += -h + 2 * ry))
                .curveTo(
                    x,
                    y - ry * arc,
                    x + rx * arc,
                    y - ry,
                    (x += rx),
                    (y -= ry),
                )
                .close();
        }
    };
    Rect.prototype.computeNodeTransformCore = function (context) {
        return context.pdf.unitMatrix;
    };
    Rect.prototype.isVisible = function (parentVisible, context) {
        return svgNodeIsVisible(this, parentVisible, context);
    };
    return Rect;
})(GeometryNode);
var EllipseBase = /** @class */ (function (_super) {
    __extends(EllipseBase, _super);
    function EllipseBase(element, children) {
        return _super.call(this, false, element, children) || this;
    }
    EllipseBase.prototype.getPath = function (context) {
        var rx = this.getRx(context);
        var ry = this.getRy(context);
        if (!isFinite(rx) || ry <= 0 || !isFinite(ry) || ry <= 0) {
            return null;
        }
        var x = parseFloat(
                getAttribute(this.element, context.styleSheets, "cx") || "0",
            ),
            y = parseFloat(
                getAttribute(this.element, context.styleSheets, "cy") || "0",
            );
        var lx = (4 / 3) * (Math.SQRT2 - 1) * rx,
            ly = (4 / 3) * (Math.SQRT2 - 1) * ry;
        return new Path()
            .moveTo(x + rx, y)
            .curveTo(x + rx, y - ly, x + lx, y - ry, x, y - ry)
            .curveTo(x - lx, y - ry, x - rx, y - ly, x - rx, y)
            .curveTo(x - rx, y + ly, x - lx, y + ry, x, y + ry)
            .curveTo(x + lx, y + ry, x + rx, y + ly, x + rx, y);
    };
    EllipseBase.prototype.computeNodeTransformCore = function (context) {
        return context.pdf.unitMatrix;
    };
    EllipseBase.prototype.isVisible = function (parentVisible, context) {
        return svgNodeIsVisible(this, parentVisible, context);
    };
    return EllipseBase;
})(GeometryNode);
var Ellipse = /** @class */ (function (_super) {
    __extends(Ellipse, _super);
    function Ellipse(element, children) {
        return _super.call(this, element, children) || this;
    }
    Ellipse.prototype.getRx = function (context) {
        return parseFloat(
            getAttribute(this.element, context.styleSheets, "rx") || "0",
        );
    };
    Ellipse.prototype.getRy = function (context) {
        return parseFloat(
            getAttribute(this.element, context.styleSheets, "ry") || "0",
        );
    };
    return Ellipse;
})(EllipseBase);
function getTextRenderingMode(attributeState) {
    var renderingMode = "invisible";
    if (attributeState.fill && attributeState.stroke) {
        renderingMode = "fillThenStroke";
    } else if (attributeState.fill) {
        renderingMode = "fill";
    } else if (attributeState.stroke) {
        renderingMode = "stroke";
    }
    return renderingMode;
}
function transformXmlSpace(trimmedText, attributeState) {
    trimmedText = removeNewlines(trimmedText);
    trimmedText = replaceTabsBySpace(trimmedText);
    if (attributeState.xmlSpace === "default") {
        trimmedText = trimmedText.trim();
        trimmedText = consolidateSpaces(trimmedText);
    }
    return trimmedText;
}
function removeNewlines(str) {
    return str.replace(/[\n\r]/g, "");
}
function replaceTabsBySpace(str) {
    return str.replace(/[\t]/g, " ");
}
function consolidateSpaces(str) {
    return str.replace(/ +/g, " ");
}
// applies text transformations to a text node
function transformText(node, text, context) {
    var textTransform = getAttribute(
        node,
        context.styleSheets,
        "text-transform",
    );
    switch (textTransform) {
        case "uppercase":
            return text.toUpperCase();
        case "lowercase":
            return text.toLowerCase();
        default:
            return text;
        // TODO: capitalize, full-width
    }
}

function trimLeft(str) {
    return str.replace(/^\s+/, "");
}
function trimRight(str) {
    return str.replace(/\s+$/, "");
}

/**
 * @param {string} textAnchor
 * @param {number} originX
 * @param {number} originY
 * @constructor
 */
var TextChunk = /** @class */ (function () {
    function TextChunk(parent, textAnchor, originX, originY) {
        this.textNode = parent;
        this.texts = [];
        this.textNodes = [];
        this.contexts = [];
        this.textAnchor = textAnchor;
        this.originX = originX;
        this.originY = originY;
        this.textMeasures = [];
    }
    TextChunk.prototype.setX = function (originX) {
        this.originX = originX;
    };
    TextChunk.prototype.setY = function (originY) {
        this.originY = originY;
    };
    TextChunk.prototype.add = function (tSpan, text, context) {
        this.texts.push(text);
        this.textNodes.push(tSpan);
        this.contexts.push(context);
    };
    TextChunk.prototype.rightTrimText = function () {
        for (var r = this.texts.length - 1; r >= 0; r--) {
            if (this.contexts[r].attributeState.xmlSpace === "default") {
                this.texts[r] = trimRight(this.texts[r]);
            }
            // If find a letter, stop right-trimming
            if (this.texts[r].match(/[^\s]/)) {
                return false;
            }
        }
        return true;
    };
    TextChunk.prototype.measureText = function (context) {
        for (var i = 0; i < this.texts.length; i++) {
            this.textMeasures.push({
                width: context.textMeasure.measureTextWidth(
                    this.texts[i],
                    this.contexts[i].attributeState,
                ),
                length: this.texts[i].length,
            });
        }
    };
    TextChunk.prototype.put = function (context, charSpace) {
        var i, textNode, textNodeContext, textMeasure;
        var alreadySeen = [];
        var xs = [],
            ys = [];
        var currentTextX = this.originX,
            currentTextY = this.originY;
        var minX = currentTextX,
            maxX = currentTextX;
        for (i = 0; i < this.textNodes.length; i++) {
            textNode = this.textNodes[i];
            textNodeContext = this.contexts[i];
            textMeasure = this.textMeasures[i] || {
                width: context.textMeasure.measureTextWidth(
                    this.texts[i],
                    this.contexts[i].attributeState,
                ),
                length: this.texts[i].length,
            };
            var x = currentTextX;
            var y = currentTextY;
            if (textNode.nodeName !== "#text") {
                if (!alreadySeen.includes(textNode)) {
                    alreadySeen.push(textNode);
                    var tSpanDx = textNode.getAttribute("dx");
                    if (tSpanDx !== null) {
                        x += toPixels(
                            tSpanDx,
                            textNodeContext.attributeState.fontSize,
                        );
                    }
                    var tSpanDy = textNode.getAttribute("dy");
                    if (tSpanDy !== null) {
                        y += toPixels(
                            tSpanDy,
                            textNodeContext.attributeState.fontSize,
                        );
                    }
                }
            }
            xs[i] = x;
            ys[i] = y;
            currentTextX =
                x + textMeasure.width + textMeasure.length * charSpace;
            currentTextY = y;
            minX = Math.min(minX, x);
            maxX = Math.max(maxX, currentTextX);
        }
        var textOffset = 0;
        switch (this.textAnchor) {
            case "start":
                textOffset = 0;
                break;
            case "middle":
                textOffset = (maxX - minX) / 2;
                break;
            case "end":
                textOffset = maxX - minX;
                break;
        }
        for (i = 0; i < this.textNodes.length; i++) {
            textNode = this.textNodes[i];
            textNodeContext = this.contexts[i];
            if (textNode.nodeName !== "#text") {
                if (textNodeContext.attributeState.visibility === "hidden") {
                    continue;
                }
            }
            context.pdf.saveGraphicsState();
            applyAttributes(textNodeContext, context, textNode);
            var alignmentBaseline =
                textNodeContext.attributeState.alignmentBaseline;
            var textRenderingMode = getTextRenderingMode(
                textNodeContext.attributeState,
            );
            context.pdf.text(this.texts[i], xs[i] - textOffset, ys[i], {
                baseline: mapAlignmentBaseline(alignmentBaseline),
                angle: context.transform,
                renderingMode:
                    textRenderingMode === "fill" ? void 0 : textRenderingMode,
                charSpace: charSpace === 0 ? void 0 : charSpace,
            });
            context.pdf.restoreGraphicsState();
        }
        return [currentTextX, currentTextY];
    };
    return TextChunk;
})();
var TextNode = /** @class */ (function (_super) {
    __extends(TextNode, _super);
    function TextNode() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    TextNode.prototype.processTSpans = function (
        textNode,
        node,
        context,
        textChunks,
        currentTextSegment,
        trimInfo,
    ) {
        var pdfFontSize = context.pdf.getFontSize();
        var xmlSpace = context.attributeState.xmlSpace;
        var firstText = true,
            initialSpace = false;
        for (var i = 0; i < node.childNodes.length; i++) {
            var childNode = node.childNodes[i];
            if (!childNode.textContent) {
                continue;
            }
            var textContent = childNode.textContent;
            if (childNode.nodeName === "#text") {
                var trimmedText = removeNewlines(textContent);
                trimmedText = replaceTabsBySpace(trimmedText);
                if (xmlSpace === "default") {
                    trimmedText = consolidateSpaces(trimmedText);
                    // If first text in tspan and starts with a space
                    if (firstText && trimmedText.match(/^\s/)) {
                        initialSpace = true;
                    }
                    // No longer the first text if we've found a letter
                    if (trimmedText.match(/[^\s]/)) {
                        firstText = false;
                    }
                    // Consolidate spaces across different children
                    if (trimInfo.prevText.match(/\s$/)) {
                        trimmedText = trimLeft(trimmedText);
                    }
                }
                var transformedText = transformText(node, trimmedText, context);
                currentTextSegment.add(node, transformedText, context);
                trimInfo.prevText = textContent;
                trimInfo.prevContext = context;
            } else if (nodeIs(childNode, "title"));
            else if (nodeIs(childNode, "tspan")) {
                var tSpan = childNode;
                var tSpanAbsX = tSpan.getAttribute("x");
                if (tSpanAbsX !== null) {
                    var x = toPixels(tSpanAbsX, pdfFontSize);
                    currentTextSegment = new TextChunk(
                        this,
                        getAttribute(
                            tSpan,
                            context.styleSheets,
                            "text-anchor",
                        ) || context.attributeState.textAnchor,
                        x,
                        0,
                    );
                    textChunks.push({
                        type: "y",
                        chunk: currentTextSegment,
                    });
                }
                var tSpanAbsY = tSpan.getAttribute("y");
                if (tSpanAbsY !== null) {
                    var y = toPixels(tSpanAbsY, pdfFontSize);
                    currentTextSegment = new TextChunk(
                        this,
                        getAttribute(
                            tSpan,
                            context.styleSheets,
                            "text-anchor",
                        ) || context.attributeState.textAnchor,
                        0,
                        y,
                    );
                    textChunks.push({
                        type: "x",
                        chunk: currentTextSegment,
                    });
                }
                var childContext = context.clone();
                parseAttributes(childContext, textNode, tSpan);
                this.processTSpans(
                    textNode,
                    tSpan,
                    childContext,
                    textChunks,
                    currentTextSegment,
                    trimInfo,
                );
            }
        }
        return initialSpace;
    };
    TextNode.prototype.renderCore = function (context) {
        return __awaiter(this, void 0, void 0, function () {
            var xOffset,
                charSpace,
                lengthAdjustment,
                pdfFontSize,
                textX,
                textY,
                dx,
                dy,
                textLength,
                visibility,
                tSpanCount,
                textContent,
                trimmedText,
                transformedText,
                defaultSize,
                alignmentBaseline,
                textRenderingMode,
                textChunks,
                currentTextSegment,
                initialSpace,
                trimRight,
                r,
                totalDefaultWidth_1,
                totalLength_1;
            return __generator(this, function (_a) {
                context.pdf.saveGraphicsState();
                xOffset = 0;
                charSpace = 0;
                lengthAdjustment = 1;
                pdfFontSize = context.pdf.getFontSize();
                textX = toPixels(this.element.getAttribute("x"), pdfFontSize);
                textY = toPixels(this.element.getAttribute("y"), pdfFontSize);
                dx = toPixels(this.element.getAttribute("dx"), pdfFontSize);
                dy = toPixels(this.element.getAttribute("dy"), pdfFontSize);
                textLength = parseFloat(
                    this.element.getAttribute("textLength") || "0",
                );
                visibility = context.attributeState.visibility;
                tSpanCount = this.element.childElementCount;
                if (tSpanCount === 0) {
                    textContent = this.element.textContent || "";
                    trimmedText = transformXmlSpace(
                        textContent,
                        context.attributeState,
                    );
                    transformedText = transformText(
                        this.element,
                        trimmedText,
                        context,
                    );
                    xOffset = context.textMeasure.getTextOffset(
                        transformedText,
                        context.attributeState,
                    );
                    if (textLength > 0) {
                        defaultSize = context.textMeasure.measureTextWidth(
                            transformedText,
                            context.attributeState,
                        );
                        if (
                            context.attributeState.xmlSpace === "default" &&
                            textContent.match(/^\s/)
                        ) {
                            lengthAdjustment = 0;
                        }
                        charSpace =
                            (textLength - defaultSize) /
                                (transformedText.length - lengthAdjustment) ||
                            0;
                    }
                    if (visibility === "visible") {
                        alignmentBaseline =
                            context.attributeState.alignmentBaseline;
                        textRenderingMode = getTextRenderingMode(
                            context.attributeState,
                        );
                        context.pdf.text(
                            transformedText,
                            textX + dx - xOffset,
                            textY + dy,
                            {
                                baseline:
                                    mapAlignmentBaseline(alignmentBaseline),
                                angle: context.transform,
                                renderingMode:
                                    textRenderingMode === "fill"
                                        ? void 0
                                        : textRenderingMode,
                                charSpace: charSpace === 0 ? void 0 : charSpace,
                            },
                        );
                    }
                } else {
                    textChunks = [];
                    currentTextSegment = new TextChunk(
                        this,
                        context.attributeState.textAnchor,
                        textX + dx,
                        textY + dy,
                    );
                    textChunks.push({
                        type: "",
                        chunk: currentTextSegment,
                    });
                    initialSpace = this.processTSpans(
                        this,
                        this.element,
                        context,
                        textChunks,
                        currentTextSegment,
                        // Set prevText to ' ' so any spaces on left of <text> are trimmed
                        {
                            prevText: " ",
                            prevContext: context,
                        },
                    );
                    lengthAdjustment = initialSpace ? 0 : 1;
                    trimRight = true;
                    for (r = textChunks.length - 1; r >= 0; r--) {
                        if (trimRight) {
                            trimRight = textChunks[r].chunk.rightTrimText();
                        }
                    }
                    if (textLength > 0) {
                        totalDefaultWidth_1 = 0;
                        totalLength_1 = 0;
                        textChunks.forEach(function (_a) {
                            var chunk = _a.chunk;
                            chunk.measureText(context);
                            chunk.textMeasures.forEach(function (_a) {
                                var width = _a.width,
                                    length = _a.length;
                                totalDefaultWidth_1 += width;
                                totalLength_1 += length;
                            });
                        });
                        charSpace =
                            (textLength - totalDefaultWidth_1) /
                            (totalLength_1 - lengthAdjustment);
                    }
                    // Put the textchunks
                    textChunks.reduce(
                        function (lastPositions, _a) {
                            var type = _a.type,
                                chunk = _a.chunk;
                            if (type === "x") {
                                chunk.setX(lastPositions[0]);
                            } else if (type === "y") {
                                chunk.setY(lastPositions[1]);
                            }
                            return chunk.put(context, charSpace);
                        },
                        [0, 0],
                    );
                }
                context.pdf.restoreGraphicsState();
                return [2 /*return*/];
            });
        });
    };

    TextNode.prototype.isVisible = function (parentVisible, context) {
        return svgNodeAndChildrenVisible(this, parentVisible, context);
    };
    TextNode.prototype.getBoundingBoxCore = function (context) {
        return defaultBoundingBox(this.element, context);
    };
    TextNode.prototype.computeNodeTransformCore = function (context) {
        return context.pdf.unitMatrix;
    };
    return TextNode;
})(GraphicsNode);
var PathNode = /** @class */ (function (_super) {
    __extends(PathNode, _super);
    function PathNode(node, children) {
        return _super.call(this, true, node, children) || this;
    }
    PathNode.prototype.computeNodeTransformCore = function (context) {
        return context.pdf.unitMatrix;
    };
    PathNode.prototype.isVisible = function (parentVisible, context) {
        return svgNodeIsVisible(this, parentVisible, context);
    };
    PathNode.prototype.getPath = function (context) {
        var svgPath = new SvgPath(
            getAttribute(this.element, context.styleSheets, "d") || "",
        )
            .unshort()
            .unarc()
            .abs();
        var path = new Path();
        var prevX;
        var prevY;
        svgPath.iterate(function (seg) {
            switch (seg[0]) {
                case "M":
                    path.moveTo(seg[1], seg[2]);
                    break;
                case "L":
                    path.lineTo(seg[1], seg[2]);
                    break;
                case "H":
                    path.lineTo(seg[1], prevY);
                    break;
                case "V":
                    path.lineTo(prevX, seg[1]);
                    break;
                case "C":
                    path.curveTo(
                        seg[1],
                        seg[2],
                        seg[3],
                        seg[4],
                        seg[5],
                        seg[6],
                    );
                    break;
                case "Q":
                    var p2 = toCubic([prevX, prevY], [seg[1], seg[2]]);
                    var p3 = toCubic([seg[3], seg[4]], [seg[1], seg[2]]);
                    path.curveTo(p2[0], p2[1], p3[0], p3[1], seg[3], seg[4]);
                    break;
                case "Z":
                    path.close();
                    break;
            }
            switch (seg[0]) {
                case "M":
                case "L":
                    prevX = seg[1];
                    prevY = seg[2];
                    break;
                case "H":
                    prevX = seg[1];
                    break;
                case "V":
                    prevY = seg[1];
                    break;
                case "C":
                    prevX = seg[5];
                    prevY = seg[6];
                    break;
                case "Q":
                    prevX = seg[3];
                    prevY = seg[4];
                    break;
            }
        });
        return path;
    };
    return PathNode;
})(GeometryNode);

// groups: 1: mime-type (+ charset), 2: mime-type (w/o charset), 3: charset, 4: base64?, 5: body
var dataUriRegex =
    /^\s*data:(([^/,;]+\/[^/,;]+)(?:;([^,;=]+=[^,;=]+))?)?(?:;(base64))?,(.*\s*)$/i;
var ImageNode = /** @class */ (function (_super) {
    __extends(ImageNode, _super);
    function ImageNode(element, children) {
        var _this = _super.call(this, element, children) || this;
        _this.imageLoadingPromise = null;
        _this.imageUrl =
            _this.element.getAttribute("xlink:href") ||
            _this.element.getAttribute("href");
        if (_this.imageUrl) {
            // start loading the image as early as possible
            _this.imageLoadingPromise = ImageNode.fetchImageData(
                _this.imageUrl,
            );
        }
        return _this;
    }
    ImageNode.prototype.renderCore = function (context) {
        return __awaiter(this, void 0, void 0, function () {
            var width,
                height,
                x,
                y,
                _a,
                data,
                format,
                parser,
                svgElement,
                preserveAspectRatio,
                idMap,
                svgnode,
                dataUri;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.imageLoadingPromise) {
                            return [2 /*return*/];
                        }

                        context.pdf.setCurrentTransformationMatrix(
                            context.transform,
                        );
                        (width = parseFloat(
                            getAttribute(
                                this.element,
                                context.styleSheets,
                                "width",
                            ) || "0",
                        )),
                            (height = parseFloat(
                                getAttribute(
                                    this.element,
                                    context.styleSheets,
                                    "height",
                                ) || "0",
                            )),
                            (x = parseFloat(
                                getAttribute(
                                    this.element,
                                    context.styleSheets,
                                    "x",
                                ) || "0",
                            )),
                            (y = parseFloat(
                                getAttribute(
                                    this.element,
                                    context.styleSheets,
                                    "y",
                                ) || "0",
                            ));
                        if (
                            !isFinite(width) ||
                            width <= 0 ||
                            !isFinite(height) ||
                            height <= 0
                        ) {
                            return [2 /*return*/];
                        }

                        return [4 /*yield*/, this.imageLoadingPromise];
                    case 1:
                        (_a = _b.sent()),
                            (data = _a.data),
                            (format = _a.format);
                        if (!(format.indexOf("svg") === 0))
                            return [3 /*break*/, 3];
                        parser = new DOMParser();
                        svgElement = parser.parseFromString(
                            data,
                            "image/svg+xml",
                        ).firstElementChild;
                        preserveAspectRatio = this.element.getAttribute(
                            "preserveAspectRatio",
                        );
                        if (
                            !preserveAspectRatio ||
                            preserveAspectRatio.indexOf("defer") < 0 ||
                            !svgElement.getAttribute("preserveAspectRatio")
                        ) {
                            svgElement.setAttribute(
                                "preserveAspectRatio",
                                preserveAspectRatio || "",
                            );
                        }
                        svgElement.setAttribute("x", String(x));
                        svgElement.setAttribute("y", String(y));
                        svgElement.setAttribute("width", String(width));
                        svgElement.setAttribute("height", String(height));
                        idMap = {};
                        svgnode = parse(svgElement, idMap);
                        return [
                            4 /*yield*/,
                            svgnode.render(
                                new Context(context.pdf, {
                                    refsHandler: new ReferencesHandler(idMap),
                                    styleSheets: context.styleSheets,
                                    viewport: new Viewport(width, height),
                                    svg2pdfParameters:
                                        context.svg2pdfParameters,
                                }),
                            ),
                        ];
                    case 2:
                        _b.sent();
                        return [2 /*return*/];
                    case 3:
                        dataUri =
                            "data:image/" + format + ";base64," + btoa(data);
                        try {
                            context.pdf.addImage(
                                dataUri,
                                "",
                                // will be ignored anyways if imageUrl is a data url
                                x,
                                y,
                                width,
                                height,
                            );
                        } catch (e) {
                            typeof console === "object" &&
                                console.warn &&
                                console.warn(
                                    "Could not load image " +
                                        this.imageUrl +
                                        ".\n" +
                                        e,
                                );
                        }
                        _b.label = 4;
                    case 4:
                        return [2 /*return*/];
                }
            });
        });
    };

    ImageNode.prototype.getBoundingBoxCore = function (context) {
        return defaultBoundingBox(this.element, context);
    };
    ImageNode.prototype.computeNodeTransformCore = function (context) {
        return context.pdf.unitMatrix;
    };
    ImageNode.prototype.isVisible = function (parentVisible, context) {
        return svgNodeIsVisible(this, parentVisible, context);
    };
    ImageNode.fetchImageData = function (imageUrl) {
        return __awaiter(this, void 0, void 0, function () {
            var data, format, match, mimeType, mimeTypeParts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        match = imageUrl.match(dataUriRegex);
                        if (!match) return [3 /*break*/, 1];
                        mimeType = match[2];
                        mimeTypeParts = mimeType.split("/");
                        if (mimeTypeParts[0] !== "image") {
                            throw new Error(
                                "Unsupported image URL: " + imageUrl,
                            );
                        }
                        format = mimeTypeParts[1];
                        data = match[5];
                        if (match[4] === "base64") {
                            data = atob(data);
                        } else {
                            data = decodeURIComponent(data);
                        }
                        return [3 /*break*/, 3];
                    case 1:
                        return [4 /*yield*/, ImageNode.fetchImage(imageUrl)];
                    case 2:
                        data = _a.sent();
                        format = imageUrl.substring(
                            imageUrl.lastIndexOf(".") + 1,
                        );
                        _a.label = 3;
                    case 3:
                        return [
                            2 /*return*/,
                            {
                                data: data,
                                format: format,
                            },
                        ];
                }
            });
        });
    };
    ImageNode.fetchImage = function (imageUrl) {
        return new Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.open("GET", imageUrl, true);
            xhr.responseType = "arraybuffer";
            xhr.onload = function () {
                if (xhr.status !== 200) {
                    throw new Error(
                        "Error " +
                            xhr.status +
                            ": Failed to load image '" +
                            imageUrl +
                            "'",
                    );
                }
                var bytes = new Uint8Array(xhr.response);
                var data = "";
                for (var i = 0; i < bytes.length; i++) {
                    data += String.fromCharCode(bytes[i]);
                }
                resolve(data);
            };
            xhr.onerror = reject;
            xhr.onabort = reject;
            xhr.send(null);
        });
    };
    ImageNode.getMimeType = function (format) {
        format = format.toLowerCase();
        switch (format) {
            case "jpg":
            case "jpeg":
                return "image/jpeg";
            default:
                return "image/" + format;
        }
    };
    return ImageNode;
})(GraphicsNode);
var Traverse = /** @class */ (function (_super) {
    __extends(Traverse, _super);
    function Traverse(closed, node, children) {
        var _this = _super.call(this, true, node, children) || this;
        _this.closed = closed;
        return _this;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Traverse.prototype.getPath = function (context) {
        if (
            !this.element.hasAttribute("points") ||
            this.element.getAttribute("points") === ""
        ) {
            return null;
        }
        // @ts-ignore
        var points = Traverse.parsePointsString(
            this.element.getAttribute("points"),
        );
        var path = new Path();
        if (points.length < 1) {
            return path;
        }
        path.moveTo(points[0][0], points[0][1]);
        for (var i = 1; i < points.length; i++) {
            path.lineTo(points[i][0], points[i][1]);
        }
        if (this.closed) {
            path.close();
        }
        return path;
    };
    Traverse.prototype.isVisible = function (parentVisible, context) {
        return svgNodeIsVisible(this, parentVisible, context);
    };
    Traverse.prototype.computeNodeTransformCore = function (context) {
        return context.pdf.unitMatrix;
    };
    Traverse.parsePointsString = function (string) {
        var floats = parseFloats(string);
        var result = [];
        for (var i = 0; i < floats.length - 1; i += 2) {
            var x = floats[i];
            var y = floats[i + 1];
            result.push([x, y]);
        }
        return result;
    };
    return Traverse;
})(GeometryNode);
var Polygon = /** @class */ (function (_super) {
    __extends(Polygon, _super);
    function Polygon(node, children) {
        return _super.call(this, true, node, children) || this;
    }
    return Polygon;
})(Traverse);
var VoidNode = /** @class */ (function (_super) {
    __extends(VoidNode, _super);
    function VoidNode() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    VoidNode.prototype.render = function (parentContext) {
        return Promise.resolve();
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    VoidNode.prototype.getBoundingBoxCore = function (context) {
        return [0, 0, 0, 0];
    };
    VoidNode.prototype.computeNodeTransformCore = function (context) {
        return context.pdf.unitMatrix;
    };
    VoidNode.prototype.isVisible = function (parentVisible, context) {
        return svgNodeIsVisible(this, parentVisible, context);
    };
    return VoidNode;
})(SvgNode);
var MarkerNode = /** @class */ (function (_super) {
    __extends(MarkerNode, _super);
    function MarkerNode() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    MarkerNode.prototype.apply = function (parentContext) {
        return __awaiter(this, void 0, void 0, function () {
            var tfMatrix, bBox, childContext, _i, _a, child;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        tfMatrix = this.computeNodeTransform(parentContext);
                        bBox = this.getBoundingBox(parentContext);
                        parentContext.pdf.beginFormObject(
                            bBox[0],
                            bBox[1],
                            bBox[2],
                            bBox[3],
                            tfMatrix,
                        );
                        childContext = new Context(parentContext.pdf, {
                            refsHandler: parentContext.refsHandler,
                            styleSheets: parentContext.styleSheets,
                            viewport: parentContext.viewport,
                            svg2pdfParameters: parentContext.svg2pdfParameters,
                        });
                        // "Properties do not inherit from the element referencing the 'marker' into the contents of the
                        // marker. However, by using the context-stroke value for the fill or stroke on elements in its
                        // definition, a single marker can be designed to match the style of the element referencing the
                        // marker."
                        // -> we need to reset all attributes
                        applyContext(childContext);
                        (_i = 0), (_a = this.children);
                        _b.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 4];
                        child = _a[_i];
                        return [4 /*yield*/, child.render(childContext)];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4:
                        parentContext.pdf.endFormObject(
                            this.element.getAttribute("id"),
                        );
                        return [2 /*return*/];
                }
            });
        });
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    MarkerNode.prototype.getBoundingBoxCore = function (context) {
        var viewBox = this.element.getAttribute("viewBox");
        var vb;
        if (viewBox) {
            vb = parseFloats(viewBox);
        }
        return [
            (vb && vb[0]) || 0,
            (vb && vb[1]) || 0,
            (vb && vb[2]) ||
                parseFloat(this.element.getAttribute("markerWidth") || "3"),
            (vb && vb[3]) ||
                parseFloat(this.element.getAttribute("markerHeight") || "3"),
        ];
    };
    MarkerNode.prototype.computeNodeTransformCore = function (context) {
        var refX = parseFloat(this.element.getAttribute("refX") || "0");
        var refY = parseFloat(this.element.getAttribute("refY") || "0");
        var viewBox = this.element.getAttribute("viewBox");
        var nodeTransform;
        if (viewBox) {
            var bounds = parseFloats(viewBox);
            // "Markers are drawn such that their reference point (i.e., attributes ‘refX’ and ‘refY’)
            // is positioned at the given vertex." - The "translate" part of the viewBox transform is
            // ignored.
            nodeTransform = computeViewBoxTransform(
                this.element,
                bounds,
                0,
                0,
                parseFloat(this.element.getAttribute("markerWidth") || "3"),
                parseFloat(this.element.getAttribute("markerHeight") || "3"),
                context,
                true,
            );
            nodeTransform = context.pdf.matrixMult(
                context.pdf.Matrix(1, 0, 0, 1, -refX, -refY),
                nodeTransform,
            );
        } else {
            nodeTransform = context.pdf.Matrix(1, 0, 0, 1, -refX, -refY);
        }
        return nodeTransform;
    };
    MarkerNode.prototype.isVisible = function (parentVisible, context) {
        return svgNodeAndChildrenVisible(this, parentVisible, context);
    };
    return MarkerNode;
})(NonRenderedNode);
var Circle = /** @class */ (function (_super) {
    __extends(Circle, _super);
    function Circle(node, children) {
        return _super.call(this, node, children) || this;
    }
    Circle.prototype.getR = function (context) {
        var _a;
        return (_a = this.r) !== null && _a !== void 0
            ? _a
            : (this.r = parseFloat(
                  getAttribute(this.element, context.styleSheets, "r") || "0",
              ));
    };
    Circle.prototype.getRx = function (context) {
        return this.getR(context);
    };
    Circle.prototype.getRy = function (context) {
        return this.getR(context);
    };
    return Circle;
})(EllipseBase);
var Polyline = /** @class */ (function (_super) {
    __extends(Polyline, _super);
    function Polyline(node, children) {
        return _super.call(this, false, node, children) || this;
    }
    return Polyline;
})(Traverse);
var ContainerNode = /** @class */ (function (_super) {
    __extends(ContainerNode, _super);
    function ContainerNode() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    ContainerNode.prototype.renderCore = function (context) {
        return __awaiter(this, void 0, void 0, function () {
            var _i, _a, child;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        (_i = 0), (_a = this.children);
                        _b.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 4];
                        child = _a[_i];
                        return [4 /*yield*/, child.render(context)];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4:
                        return [2 /*return*/];
                }
            });
        });
    };

    ContainerNode.prototype.getBoundingBoxCore = function (context) {
        return getBoundingBoxByChildren(context, this);
    };
    return ContainerNode;
})(RenderedNode);
var Svg = /** @class */ (function (_super) {
    __extends(Svg, _super);
    function Svg() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    Svg.prototype.isVisible = function (parentVisible, context) {
        return svgNodeAndChildrenVisible(this, parentVisible, context);
    };
    Svg.prototype.render = function (context) {
        return __awaiter(this, void 0, void 0, function () {
            var x, y, width, height, transform;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (
                            !this.isVisible(
                                context.attributeState.visibility !== "hidden",
                                context,
                            )
                        ) {
                            return [2 /*return*/];
                        }

                        x = this.getX(context);
                        y = this.getY(context);
                        width = this.getWidth(context);
                        height = this.getHeight(context);
                        context.pdf.saveGraphicsState();
                        transform = context.transform;
                        if (this.element.hasAttribute("transform")) {
                            // SVG 2 allows transforms on SVG elements
                            // "The transform should be applied as if the ‘svg’ had a parent element with that transform set."
                            transform = context.pdf.matrixMult(
                                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                parseTransform(
                                    this.element.getAttribute("transform"),
                                    context,
                                ),
                                transform,
                            );
                        }
                        context.pdf.setCurrentTransformationMatrix(transform);
                        if (
                            !context.withinUse &&
                            getAttribute(
                                this.element,
                                context.styleSheets,
                                "overflow",
                            ) !== "visible"
                        ) {
                            // establish a new viewport
                            context.pdf
                                .rect(x, y, width, height)
                                .clip()
                                .discardPath();
                        }
                        return [
                            4 /*yield*/,
                            _super.prototype.render.call(
                                this,
                                context.clone({
                                    transform: context.pdf.unitMatrix,
                                    viewport: context.withinUse
                                        ? context.viewport
                                        : new Viewport(width, height),
                                }),
                            ),
                        ];
                    case 1:
                        _a.sent();
                        context.pdf.restoreGraphicsState();
                        return [2 /*return*/];
                }
            });
        });
    };

    Svg.prototype.computeNodeTransform = function (context) {
        return this.computeNodeTransformCore(context);
    };
    Svg.prototype.computeNodeTransformCore = function (context) {
        if (context.withinUse) {
            return context.pdf.unitMatrix;
        }
        var x = this.getX(context);
        var y = this.getY(context);
        var viewBox = this.getViewBox();
        var nodeTransform;
        if (viewBox) {
            var width = this.getWidth(context);
            var height = this.getHeight(context);
            nodeTransform = computeViewBoxTransform(
                this.element,
                viewBox,
                x,
                y,
                width,
                height,
                context,
            );
        } else {
            nodeTransform = context.pdf.Matrix(1, 0, 0, 1, x, y);
        }
        return nodeTransform;
    };
    Svg.prototype.getWidth = function (context) {
        if (this.width !== undefined) {
            return this.width;
        }
        var width;
        var parameters = context.svg2pdfParameters;
        if (this.isOutermostSvg(context)) {
            // special treatment for the outermost SVG element
            if (parameters.width != null) {
                // if there is a user defined width, use it
                width = parameters.width;
            } else {
                // otherwise check if the SVG element defines the width itself
                var widthAttr = getAttribute(
                    this.element,
                    context.styleSheets,
                    "width",
                );
                if (widthAttr) {
                    width = parseFloat(widthAttr);
                } else {
                    // if not, check if we can figure out the aspect ratio from the viewBox attribute
                    var viewBox = this.getViewBox();
                    if (
                        viewBox &&
                        (parameters.height != null ||
                            getAttribute(
                                this.element,
                                context.styleSheets,
                                "height",
                            ))
                    ) {
                        // if there is a viewBox and the height is defined, use the width that matches the height together with the aspect ratio
                        var aspectRatio = viewBox[2] / viewBox[3];
                        width = this.getHeight(context) * aspectRatio;
                    } else {
                        // if there is no viewBox use a default of 300 or the largest size that fits into the outer viewport
                        // at an aspect ratio of 2:1
                        width = Math.min(
                            300,
                            context.viewport.width,
                            context.viewport.height * 2,
                        );
                    }
                }
            }
        } else {
            var widthAttr = getAttribute(
                this.element,
                context.styleSheets,
                "width",
            );
            width = widthAttr ? parseFloat(widthAttr) : context.viewport.width;
        }
        return (this.width = width);
    };
    Svg.prototype.getHeight = function (context) {
        if (this.height !== undefined) {
            return this.height;
        }
        var height;
        var parameters = context.svg2pdfParameters;
        if (this.isOutermostSvg(context)) {
            // special treatment for the outermost SVG element
            if (parameters.height != null) {
                // if there is a user defined height, use it
                height = parameters.height;
            } else {
                // otherwise check if the SVG element defines the height itself
                var heightAttr = getAttribute(
                    this.element,
                    context.styleSheets,
                    "height",
                );
                if (heightAttr) {
                    height = parseFloat(heightAttr);
                } else {
                    // if not, check if we can figure out the aspect ratio from the viewBox attribute
                    var viewBox = this.getViewBox();
                    if (viewBox) {
                        // if there is a viewBox, use the height that matches the width together with the aspect ratio
                        var aspectRatio = viewBox[2] / viewBox[3];
                        height = this.getWidth(context) / aspectRatio;
                    } else {
                        // if there is no viewBox use a default of 150 or the largest size that fits into the outer viewport
                        // at an aspect ratio of 2:1
                        height = Math.min(
                            150,
                            context.viewport.width / 2,
                            context.viewport.height,
                        );
                    }
                }
            }
        } else {
            var heightAttr = getAttribute(
                this.element,
                context.styleSheets,
                "height",
            );
            height = heightAttr
                ? parseFloat(heightAttr)
                : context.viewport.height;
        }
        return (this.height = height);
    };
    Svg.prototype.getX = function (context) {
        if (this.x !== undefined) {
            return this.x;
        }
        if (this.isOutermostSvg(context)) {
            return (this.x = 0);
        }
        var xAttr = getAttribute(this.element, context.styleSheets, "x");
        return (this.x = xAttr ? parseFloat(xAttr) : 0);
    };
    Svg.prototype.getY = function (context) {
        if (this.y !== undefined) {
            return this.y;
        }
        if (this.isOutermostSvg(context)) {
            return (this.y = 0);
        }
        var yAttr = getAttribute(this.element, context.styleSheets, "y");
        return (this.y = yAttr ? parseFloat(yAttr) : 0);
    };
    Svg.prototype.getViewBox = function () {
        if (this.viewBox !== undefined) {
            return this.viewBox;
        }
        var viewBox = this.element.getAttribute("viewBox");
        return (this.viewBox = viewBox ? parseFloats(viewBox) : undefined);
    };
    Svg.prototype.isOutermostSvg = function (context) {
        return context.svg2pdfParameters.element === this.element;
    };
    return Svg;
})(ContainerNode);
var Group = /** @class */ (function (_super) {
    __extends(Group, _super);
    function Group() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    Group.prototype.isVisible = function (parentVisible, context) {
        return svgNodeAndChildrenVisible(this, parentVisible, context);
    };
    Group.prototype.computeNodeTransformCore = function (context) {
        return context.pdf.unitMatrix;
    };
    return Group;
})(ContainerNode);
var ClipPath = /** @class */ (function (_super) {
    __extends(ClipPath, _super);
    function ClipPath() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    ClipPath.prototype.apply = function (context) {
        return __awaiter(this, void 0, void 0, function () {
            var clipPathMatrix, _i, _a, child;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.isVisible(true, context)) {
                            return [2 /*return*/];
                        }

                        clipPathMatrix = context.pdf.matrixMult(
                            this.computeNodeTransform(context),
                            context.transform,
                        );
                        context.pdf.setCurrentTransformationMatrix(
                            clipPathMatrix,
                        );
                        (_i = 0), (_a = this.children);
                        _b.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 4];
                        child = _a[_i];
                        return [
                            4 /*yield*/,
                            child.render(
                                new Context(context.pdf, {
                                    refsHandler: context.refsHandler,
                                    styleSheets: context.styleSheets,
                                    viewport: context.viewport,
                                    withinClipPath: true,
                                    svg2pdfParameters:
                                        context.svg2pdfParameters,
                                }),
                            ),
                        ];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4:
                        context.pdf.clip().discardPath();
                        // as we cannot use restoreGraphicsState() to reset the transform (this would reset the clipping path, as well),
                        // we must append the inverse instead
                        context.pdf.setCurrentTransformationMatrix(
                            clipPathMatrix.inversed(),
                        );
                        return [2 /*return*/];
                }
            });
        });
    };

    ClipPath.prototype.getBoundingBoxCore = function (context) {
        return getBoundingBoxByChildren(context, this);
    };
    ClipPath.prototype.isVisible = function (parentVisible, context) {
        return svgNodeAndChildrenVisible(this, parentVisible, context);
    };
    return ClipPath;
})(NonRenderedNode);
function parse(node, idMap) {
    var svgnode;
    var children = [];
    forEachChild(node, function (i, n) {
        return children.push(parse(n, idMap));
    });
    switch (node.tagName.toLowerCase()) {
        case "a":
        case "g":
            svgnode = new Group(node, children);
            break;
        case "circle":
            svgnode = new Circle(node, children);
            break;
        case "clippath":
            svgnode = new ClipPath(node, children);
            break;
        case "ellipse":
            svgnode = new Ellipse(node, children);
            break;
        case "lineargradient":
            svgnode = new LinearGradient(node, children);
            break;
        case "image":
            svgnode = new ImageNode(node, children);
            break;
        case "line":
            svgnode = new Line(node, children);
            break;
        case "marker":
            svgnode = new MarkerNode(node, children);
            break;
        case "path":
            svgnode = new PathNode(node, children);
            break;
        case "pattern":
            svgnode = new Pattern(node, children);
            break;
        case "polygon":
            svgnode = new Polygon(node, children);
            break;
        case "polyline":
            svgnode = new Polyline(node, children);
            break;
        case "radialgradient":
            svgnode = new RadialGradient(node, children);
            break;
        case "rect":
            svgnode = new Rect(node, children);
            break;
        case "svg":
            svgnode = new Svg(node, children);
            break;
        case "symbol":
            svgnode = new Symbol$1(node, children);
            break;
        case "text":
            svgnode = new TextNode(node, children);
            break;
        case "use":
            svgnode = new Use(node, children);
            break;
        default:
            svgnode = new VoidNode(node, children);
            break;
    }
    if (idMap != undefined && svgnode.element.hasAttribute("id")) {
        var id = cssesc_1(svgnode.element.id, {
            isIdentifier: true,
        });
        idMap[id] = idMap[id] || svgnode;
    }
    svgnode.children.forEach(function (c) {
        return c.setParent(svgnode);
    });
    return svgnode;
}
var StyleSheets = /** @class */ (function () {
    function StyleSheets(rootSvg, loadExtSheets) {
        this.rootSvg = rootSvg;
        this.loadExternalSheets = loadExtSheets;
        this.styleSheets = [];
    }
    StyleSheets.prototype.load = function () {
        return __awaiter(this, void 0, void 0, function () {
            var sheetTexts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        return [4 /*yield*/, this.collectStyleSheetTexts()];
                    case 1:
                        sheetTexts = _a.sent();
                        this.parseCssSheets(sheetTexts);
                        return [2 /*return*/];
                }
            });
        });
    };

    StyleSheets.prototype.collectStyleSheetTexts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var sheetTexts, i, node, styleElements, i, styleElement;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        sheetTexts = [];
                        if (
                            this.loadExternalSheets &&
                            this.rootSvg.ownerDocument
                        ) {
                            for (
                                i = 0;
                                i <
                                this.rootSvg.ownerDocument.childNodes.length;
                                i++
                            ) {
                                node = this.rootSvg.ownerDocument.childNodes[i];
                                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                // @ts-ignore
                                if (
                                    node.nodeName === "xml-stylesheet" &&
                                    typeof node.data === "string"
                                ) {
                                    sheetTexts.push(
                                        StyleSheets.loadSheet(
                                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                            // @ts-ignore
                                            node.data
                                                .match(/href=["'].*?["']/)[0]
                                                .split("=")[1]
                                                .slice(1, -1),
                                        ),
                                    );
                                }
                            }
                        }
                        styleElements =
                            this.rootSvg.querySelectorAll("style,link");
                        for (i = 0; i < styleElements.length; i++) {
                            styleElement = styleElements[i];
                            if (nodeIs(styleElement, "style")) {
                                sheetTexts.push(styleElement.textContent);
                            } else if (
                                this.loadExternalSheets &&
                                nodeIs(styleElement, "link") &&
                                styleElement.getAttribute("rel") ===
                                    "stylesheet" &&
                                styleElement.hasAttribute("href")
                            ) {
                                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                sheetTexts.push(
                                    StyleSheets.loadSheet(
                                        styleElement.getAttribute("href"),
                                    ),
                                );
                            }
                        }
                        return [4 /*yield*/, Promise.all(sheetTexts)];
                    case 1:
                        return [
                            2 /*return*/,
                            _a.sent().filter(function (sheet) {
                                return sheet !== null;
                            }),
                        ];
                }
            });
        });
    };
    StyleSheets.prototype.parseCssSheets = function (sheetTexts) {
        var styleDoc = document.implementation.createHTMLDocument("");
        for (
            var _i = 0, sheetTexts_1 = sheetTexts;
            _i < sheetTexts_1.length;
            _i++
        ) {
            var sheetText = sheetTexts_1[_i];
            var style = styleDoc.createElement("style");
            style.textContent = sheetText;
            styleDoc.body.appendChild(style);
            var sheet = style.sheet;
            if (sheet instanceof CSSStyleSheet) {
                for (var i = sheet.cssRules.length - 1; i >= 0; i--) {
                    var cssRule = sheet.cssRules[i];
                    if (!(cssRule instanceof CSSStyleRule)) {
                        sheet.deleteRule(i);
                        continue;
                    }
                    var cssStyleRule = cssRule;
                    if (cssStyleRule.selectorText.indexOf(",") >= 0) {
                        sheet.deleteRule(i);
                        var body = cssStyleRule.cssText.substring(
                            cssStyleRule.selectorText.length,
                        );
                        var selectors = StyleSheets.splitSelectorAtCommas(
                            cssStyleRule.selectorText,
                        );
                        for (var j = 0; j < selectors.length; j++) {
                            sheet.insertRule(selectors[j] + body, i + j);
                        }
                    }
                }
                this.styleSheets.push(sheet);
            }
        }
    };
    StyleSheets.splitSelectorAtCommas = function (selectorText) {
        var initialRegex = /,|["']/g;
        var closingDoubleQuotesRegex = /[^\\]["]/g;
        var closingSingleQuotesRegex = /[^\\][']/g;
        var parts = [];
        var state = "initial";
        var match;
        var lastCommaIndex = -1;
        var closingQuotesRegex = closingDoubleQuotesRegex;
        for (var i = 0; i < selectorText.length; ) {
            switch (state) {
                case "initial":
                    initialRegex.lastIndex = i;
                    match = initialRegex.exec(selectorText);
                    if (match) {
                        if (match[0] === ",") {
                            parts.push(
                                selectorText
                                    .substring(
                                        lastCommaIndex + 1,
                                        initialRegex.lastIndex - 1,
                                    )
                                    .trim(),
                            );
                            lastCommaIndex = initialRegex.lastIndex - 1;
                        } else {
                            state = "withinQuotes";
                            closingQuotesRegex =
                                match[0] === '"'
                                    ? closingDoubleQuotesRegex
                                    : closingSingleQuotesRegex;
                        }
                        i = initialRegex.lastIndex;
                    } else {
                        parts.push(
                            selectorText.substring(lastCommaIndex + 1).trim(),
                        );
                        i = selectorText.length;
                    }
                    break;
                case "withinQuotes":
                    closingQuotesRegex.lastIndex = i;
                    match = closingQuotesRegex.exec(selectorText);
                    if (match) {
                        i = closingQuotesRegex.lastIndex;
                        state = "initial";
                    }
                    // else this is a syntax error - omit the last part...
                    break;
            }
        }
        return parts;
    };
    StyleSheets.loadSheet = function (url) {
        return (
            new Promise(function (resolve, reject) {
                var xhr = new XMLHttpRequest();
                xhr.open("GET", url, true);
                xhr.responseType = "text";
                xhr.onload = function () {
                    if (xhr.status !== 200) {
                        reject(
                            new Error(
                                "Error " +
                                    xhr.status +
                                    ": Failed to load '" +
                                    url +
                                    "'",
                            ),
                        );
                    }
                    resolve(xhr.responseText);
                };
                xhr.onerror = reject;
                xhr.onabort = reject;
                xhr.send(null);
            })
                // ignore the error since some stylesheets may not be accessible
                // due to CORS policies
                .catch(function () {
                    return null;
                })
        );
    };
    StyleSheets.prototype.getPropertyValue = function (node, propertyCss) {
        var matchingRules = [];
        for (var _i = 0, _a = this.styleSheets; _i < _a.length; _i++) {
            var sheet = _a[_i];
            for (var i = 0; i < sheet.cssRules.length; i++) {
                var rule = sheet.cssRules[i];
                if (
                    rule.style.getPropertyValue(propertyCss) &&
                    node.matches(rule.selectorText)
                ) {
                    matchingRules.push(rule);
                }
            }
        }
        if (matchingRules.length === 0) {
            return undefined;
        }
        var compare$1 = function (a, b) {
            var priorityA = a.style.getPropertyPriority(propertyCss);
            var priorityB = b.style.getPropertyPriority(propertyCss);
            if (priorityA !== priorityB) {
                return priorityA === "important" ? 1 : -1;
            }
            return compare(a.selectorText, b.selectorText);
        };
        var mostSpecificRule = matchingRules.reduce(
            function (previousValue, currentValue) {
                return compare$1(previousValue, currentValue) === 1
                    ? previousValue
                    : currentValue;
            },
        );
        return (
            mostSpecificRule.style.getPropertyValue(propertyCss) || undefined
        );
    };
    return StyleSheets;
})();
function svg2pdf(element, pdf, options) {
    var _a, _b, _c;
    if (options === void 0) {
        options = {};
    }
    return __awaiter(this, void 0, void 0, function () {
        var x,
            y,
            extCss,
            idMap,
            refsHandler,
            styleSheets,
            viewport,
            svg2pdfParameters,
            context,
            fill,
            node;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    x = (_a = options.x) !== null && _a !== void 0 ? _a : 0.0;
                    y = (_b = options.y) !== null && _b !== void 0 ? _b : 0.0;
                    extCss =
                        (_c = options.loadExternalStyleSheets) !== null &&
                        _c !== void 0
                            ? _c
                            : false;
                    idMap = {};
                    refsHandler = new ReferencesHandler(idMap);
                    styleSheets = new StyleSheets(element, extCss);
                    return [
                        4 /*yield*/,
                        styleSheets.load(),
                        // start with the entire page size as viewport
                    ];

                case 1:
                    _d.sent();
                    viewport = new Viewport(
                        pdf.internal.pageSize.getWidth(),
                        pdf.internal.pageSize.getHeight(),
                    );
                    svg2pdfParameters = __assign(__assign({}, options), {
                        element: element,
                    });
                    context = new Context(pdf, {
                        refsHandler: refsHandler,
                        styleSheets: styleSheets,
                        viewport: viewport,
                        svg2pdfParameters: svg2pdfParameters,
                    });
                    pdf.advancedAPI();
                    pdf.saveGraphicsState();
                    // set offsets
                    pdf.setCurrentTransformationMatrix(
                        pdf.Matrix(1, 0, 0, 1, x, y),
                    );
                    // set default values that differ from pdf defaults
                    pdf.setLineWidth(context.attributeState.strokeWidth);
                    fill = context.attributeState.fill.color;
                    pdf.setFillColor(fill.r, fill.g, fill.b);
                    pdf.setFont(context.attributeState.fontFamily);
                    // correct for a jsPDF-instance measurement unit that differs from `pt`
                    pdf.setFontSize(
                        context.attributeState.fontSize *
                            pdf.internal.scaleFactor,
                    );
                    node = parse(element, idMap);
                    return [4 /*yield*/, node.render(context)];
                case 2:
                    _d.sent();
                    pdf.restoreGraphicsState();
                    pdf.compatAPI();
                    context.textMeasure.cleanupTextMeasuring();
                    return [2 /*return*/, pdf];
            }
        });
    });
}
E.API.svg = function (element, options) {
    if (options === void 0) {
        options = {};
    }
    return svg2pdf(element, this, options);
};

var html2canvasExports = {};
var html2canvas$2 = {
    get exports() {
        return html2canvasExports;
    },
    set exports(v) {
        html2canvasExports = v;
    },
};

/*!
 * html2canvas 1.4.1 <https://html2canvas.hertzen.com>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */
(function (module, exports) {
    (function (global, factory) {
        module.exports = factory();
    })(commonjsGlobal, function () {
        /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.
      Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.
      THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */
        /* global Reflect, Promise */
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({
                    __proto__: [],
                } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b)
                        if (Object.prototype.hasOwnProperty.call(b, p))
                            d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        function __extends(d, b) {
            if (typeof b !== "function" && b !== null)
                throw new TypeError(
                    "Class extends value " +
                        String(b) +
                        " is not a constructor or null",
                );
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype =
                b === null
                    ? Object.create(b)
                    : ((__.prototype = b.prototype), new __());
        }
        var __assign = function () {
            __assign =
                Object.assign ||
                function __assign(t) {
                    for (var s, i = 1, n = arguments.length; i < n; i++) {
                        s = arguments[i];
                        for (var p in s)
                            if (Object.prototype.hasOwnProperty.call(s, p))
                                t[p] = s[p];
                    }
                    return t;
                };
            return __assign.apply(this, arguments);
        };
        function __awaiter(thisArg, _arguments, P, generator) {
            function adopt(value) {
                return value instanceof P
                    ? value
                    : new P(function (resolve) {
                          resolve(value);
                      });
            }
            return new (P || (P = Promise))(function (resolve, reject) {
                function fulfilled(value) {
                    try {
                        step(generator.next(value));
                    } catch (e) {
                        reject(e);
                    }
                }
                function rejected(value) {
                    try {
                        step(generator["throw"](value));
                    } catch (e) {
                        reject(e);
                    }
                }
                function step(result) {
                    result.done
                        ? resolve(result.value)
                        : adopt(result.value).then(fulfilled, rejected);
                }
                step(
                    (generator = generator.apply(
                        thisArg,
                        _arguments || [],
                    )).next(),
                );
            });
        }
        function __generator(thisArg, body) {
            var _ = {
                    label: 0,
                    sent: function () {
                        if (t[0] & 1) throw t[1];
                        return t[1];
                    },
                    trys: [],
                    ops: [],
                },
                f,
                y,
                t,
                g;
            return (
                (g = {
                    next: verb(0),
                    throw: verb(1),
                    return: verb(2),
                }),
                typeof Symbol === "function" &&
                    (g[Symbol.iterator] = function () {
                        return this;
                    }),
                g
            );
            function verb(n) {
                return function (v) {
                    return step([n, v]);
                };
            }
            function step(op) {
                if (f) throw new TypeError("Generator is already executing.");
                while (_)
                    try {
                        if (
                            ((f = 1),
                            y &&
                                (t =
                                    op[0] & 2
                                        ? y["return"]
                                        : op[0]
                                          ? y["throw"] ||
                                            ((t = y["return"]) && t.call(y), 0)
                                          : y.next) &&
                                !(t = t.call(y, op[1])).done)
                        )
                            return t;
                        if (((y = 0), t)) op = [op[0] & 2, t.value];
                        switch (op[0]) {
                            case 0:
                            case 1:
                                t = op;
                                break;
                            case 4:
                                _.label++;
                                return {
                                    value: op[1],
                                    done: false,
                                };
                            case 5:
                                _.label++;
                                y = op[1];
                                op = [0];
                                continue;
                            case 7:
                                op = _.ops.pop();
                                _.trys.pop();
                                continue;
                            default:
                                if (
                                    !((t = _.trys),
                                    (t = t.length > 0 && t[t.length - 1])) &&
                                    (op[0] === 6 || op[0] === 2)
                                ) {
                                    _ = 0;
                                    continue;
                                }
                                if (
                                    op[0] === 3 &&
                                    (!t || (op[1] > t[0] && op[1] < t[3]))
                                ) {
                                    _.label = op[1];
                                    break;
                                }
                                if (op[0] === 6 && _.label < t[1]) {
                                    _.label = t[1];
                                    t = op;
                                    break;
                                }
                                if (t && _.label < t[2]) {
                                    _.label = t[2];
                                    _.ops.push(op);
                                    break;
                                }
                                if (t[2]) _.ops.pop();
                                _.trys.pop();
                                continue;
                        }
                        op = body.call(thisArg, _);
                    } catch (e) {
                        op = [6, e];
                        y = 0;
                    } finally {
                        f = t = 0;
                    }
                if (op[0] & 5) throw op[1];
                return {
                    value: op[0] ? op[1] : void 0,
                    done: true,
                };
            }
        }
        function __spreadArray(to, from, pack) {
            if (pack || arguments.length === 2)
                for (var i = 0, l = from.length, ar; i < l; i++) {
                    if (ar || !(i in from)) {
                        if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                        ar[i] = from[i];
                    }
                }
            return to.concat(ar || from);
        }
        var Bounds = /** @class */ (function () {
            function Bounds(left, top, width, height) {
                this.left = left;
                this.top = top;
                this.width = width;
                this.height = height;
            }
            Bounds.prototype.add = function (x, y, w, h) {
                return new Bounds(
                    this.left + x,
                    this.top + y,
                    this.width + w,
                    this.height + h,
                );
            };
            Bounds.fromClientRect = function (context, clientRect) {
                return new Bounds(
                    clientRect.left + context.windowBounds.left,
                    clientRect.top + context.windowBounds.top,
                    clientRect.width,
                    clientRect.height,
                );
            };
            Bounds.fromDOMRectList = function (context, domRectList) {
                var domRect = Array.from(domRectList).find(function (rect) {
                    return rect.width !== 0;
                });
                return domRect
                    ? new Bounds(
                          domRect.left + context.windowBounds.left,
                          domRect.top + context.windowBounds.top,
                          domRect.width,
                          domRect.height,
                      )
                    : Bounds.EMPTY;
            };
            Bounds.EMPTY = new Bounds(0, 0, 0, 0);
            return Bounds;
        })();
        var parseBounds = function (context, node) {
            return Bounds.fromClientRect(context, node.getBoundingClientRect());
        };
        var parseDocumentSize = function (document) {
            var body = document.body;
            var documentElement = document.documentElement;
            if (!body || !documentElement) {
                throw new Error("Unable to get document size");
            }
            var width = Math.max(
                Math.max(body.scrollWidth, documentElement.scrollWidth),
                Math.max(body.offsetWidth, documentElement.offsetWidth),
                Math.max(body.clientWidth, documentElement.clientWidth),
            );
            var height = Math.max(
                Math.max(body.scrollHeight, documentElement.scrollHeight),
                Math.max(body.offsetHeight, documentElement.offsetHeight),
                Math.max(body.clientHeight, documentElement.clientHeight),
            );
            return new Bounds(0, 0, width, height);
        };

        /*
         * css-line-break 2.1.0 <https://github.com/niklasvh/css-line-break#readme>
         * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
         * Released under MIT License
         */
        var toCodePoints$1 = function (str) {
            var codePoints = [];
            var i = 0;
            var length = str.length;
            while (i < length) {
                var value = str.charCodeAt(i++);
                if (value >= 0xd800 && value <= 0xdbff && i < length) {
                    var extra = str.charCodeAt(i++);
                    if ((extra & 0xfc00) === 0xdc00) {
                        codePoints.push(
                            ((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000,
                        );
                    } else {
                        codePoints.push(value);
                        i--;
                    }
                } else {
                    codePoints.push(value);
                }
            }
            return codePoints;
        };
        var fromCodePoint$1 = function () {
            var codePoints = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                codePoints[_i] = arguments[_i];
            }
            if (String.fromCodePoint) {
                return String.fromCodePoint.apply(String, codePoints);
            }
            var length = codePoints.length;
            if (!length) {
                return "";
            }
            var codeUnits = [];
            var index = -1;
            var result = "";
            while (++index < length) {
                var codePoint = codePoints[index];
                if (codePoint <= 0xffff) {
                    codeUnits.push(codePoint);
                } else {
                    codePoint -= 0x10000;
                    codeUnits.push(
                        (codePoint >> 10) + 0xd800,
                        (codePoint % 0x400) + 0xdc00,
                    );
                }
                if (index + 1 === length || codeUnits.length > 0x4000) {
                    result += String.fromCharCode.apply(String, codeUnits);
                    codeUnits.length = 0;
                }
            }
            return result;
        };
        var chars$2 =
            "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
        // Use a lookup table to find the index.
        var lookup$2 =
            typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
        for (var i$2 = 0; i$2 < chars$2.length; i$2++) {
            lookup$2[chars$2.charCodeAt(i$2)] = i$2;
        }

        /*
         * utrie 1.0.2 <https://github.com/niklasvh/utrie>
         * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
         * Released under MIT License
         */
        var chars$1$1 =
            "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
        // Use a lookup table to find the index.
        var lookup$1$1 =
            typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
        for (var i$1$1 = 0; i$1$1 < chars$1$1.length; i$1$1++) {
            lookup$1$1[chars$1$1.charCodeAt(i$1$1)] = i$1$1;
        }
        var decode$1 = function (base64) {
            var bufferLength = base64.length * 0.75,
                len = base64.length,
                i,
                p = 0,
                encoded1,
                encoded2,
                encoded3,
                encoded4;
            if (base64[base64.length - 1] === "=") {
                bufferLength--;
                if (base64[base64.length - 2] === "=") {
                    bufferLength--;
                }
            }
            var buffer =
                typeof ArrayBuffer !== "undefined" &&
                typeof Uint8Array !== "undefined" &&
                typeof Uint8Array.prototype.slice !== "undefined"
                    ? new ArrayBuffer(bufferLength)
                    : new Array(bufferLength);
            var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
            for (i = 0; i < len; i += 4) {
                encoded1 = lookup$1$1[base64.charCodeAt(i)];
                encoded2 = lookup$1$1[base64.charCodeAt(i + 1)];
                encoded3 = lookup$1$1[base64.charCodeAt(i + 2)];
                encoded4 = lookup$1$1[base64.charCodeAt(i + 3)];
                bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
                bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
                bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
            }
            return buffer;
        };
        var polyUint16Array$1 = function (buffer) {
            var length = buffer.length;
            var bytes = [];
            for (var i = 0; i < length; i += 2) {
                bytes.push((buffer[i + 1] << 8) | buffer[i]);
            }
            return bytes;
        };
        var polyUint32Array$1 = function (buffer) {
            var length = buffer.length;
            var bytes = [];
            for (var i = 0; i < length; i += 4) {
                bytes.push(
                    (buffer[i + 3] << 24) |
                        (buffer[i + 2] << 16) |
                        (buffer[i + 1] << 8) |
                        buffer[i],
                );
            }
            return bytes;
        };

        /** Shift size for getting the index-2 table offset. */
        var UTRIE2_SHIFT_2$1 = 5;
        /** Shift size for getting the index-1 table offset. */
        var UTRIE2_SHIFT_1$1 = 6 + 5;
        /**
         * Shift size for shifting left the index array values.
         * Increases possible data size with 16-bit index values at the cost
         * of compactability.
         * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
         */
        var UTRIE2_INDEX_SHIFT$1 = 2;
        /**
         * Difference between the two shift sizes,
         * for getting an index-1 offset from an index-2 offset. 6=11-5
         */
        var UTRIE2_SHIFT_1_2$1 = UTRIE2_SHIFT_1$1 - UTRIE2_SHIFT_2$1;
        /**
         * The part of the index-2 table for U+D800..U+DBFF stores values for
         * lead surrogate code _units_ not code _points_.
         * Values for lead surrogate code _points_ are indexed with this portion of the table.
         * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
         */
        var UTRIE2_LSCP_INDEX_2_OFFSET$1 = 0x10000 >> UTRIE2_SHIFT_2$1;
        /** Number of entries in a data block. 32=0x20 */
        var UTRIE2_DATA_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_2$1;
        /** Mask for getting the lower bits for the in-data-block offset. */
        var UTRIE2_DATA_MASK$1 = UTRIE2_DATA_BLOCK_LENGTH$1 - 1;
        var UTRIE2_LSCP_INDEX_2_LENGTH$1 = 0x400 >> UTRIE2_SHIFT_2$1;
        /** Count the lengths of both BMP pieces. 2080=0x820 */
        var UTRIE2_INDEX_2_BMP_LENGTH$1 =
            UTRIE2_LSCP_INDEX_2_OFFSET$1 + UTRIE2_LSCP_INDEX_2_LENGTH$1;
        /**
         * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
         * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
         */
        var UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 = UTRIE2_INDEX_2_BMP_LENGTH$1;
        var UTRIE2_UTF8_2B_INDEX_2_LENGTH$1 =
            0x800 >> 6; /* U+0800 is the first code point after 2-byte UTF-8 */
        /**
         * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
         * Variable length, for code points up to highStart, where the last single-value range starts.
         * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
         * (For 0x100000 supplementary code points U+10000..U+10ffff.)
         *
         * The part of the index-2 table for supplementary code points starts
         * after this index-1 table.
         *
         * Both the index-1 table and the following part of the index-2 table
         * are omitted completely if there is only BMP data.
         */
        var UTRIE2_INDEX_1_OFFSET$1 =
            UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 + UTRIE2_UTF8_2B_INDEX_2_LENGTH$1;
        /**
         * Number of index-1 entries for the BMP. 32=0x20
         * This part of the index-1 table is omitted from the serialized form.
         */
        var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 = 0x10000 >> UTRIE2_SHIFT_1$1;
        /** Number of entries in an index-2 block. 64=0x40 */
        var UTRIE2_INDEX_2_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_1_2$1;
        /** Mask for getting the lower bits for the in-index-2-block offset. */
        var UTRIE2_INDEX_2_MASK$1 = UTRIE2_INDEX_2_BLOCK_LENGTH$1 - 1;
        var slice16$1 = function (view, start, end) {
            if (view.slice) {
                return view.slice(start, end);
            }
            return new Uint16Array(
                Array.prototype.slice.call(view, start, end),
            );
        };
        var slice32$1 = function (view, start, end) {
            if (view.slice) {
                return view.slice(start, end);
            }
            return new Uint32Array(
                Array.prototype.slice.call(view, start, end),
            );
        };
        var createTrieFromBase64$1 = function (base64, _byteLength) {
            var buffer = decode$1(base64);
            var view32 = Array.isArray(buffer)
                ? polyUint32Array$1(buffer)
                : new Uint32Array(buffer);
            var view16 = Array.isArray(buffer)
                ? polyUint16Array$1(buffer)
                : new Uint16Array(buffer);
            var headerLength = 24;
            var index = slice16$1(view16, headerLength / 2, view32[4] / 2);
            var data =
                view32[5] === 2
                    ? slice16$1(view16, (headerLength + view32[4]) / 2)
                    : slice32$1(
                          view32,
                          Math.ceil((headerLength + view32[4]) / 4),
                      );
            return new Trie$1(
                view32[0],
                view32[1],
                view32[2],
                view32[3],
                index,
                data,
            );
        };
        var Trie$1 = /** @class */ (function () {
            function Trie(
                initialValue,
                errorValue,
                highStart,
                highValueIndex,
                index,
                data,
            ) {
                this.initialValue = initialValue;
                this.errorValue = errorValue;
                this.highStart = highStart;
                this.highValueIndex = highValueIndex;
                this.index = index;
                this.data = data;
            }
            /**
             * Get the value for a code point as stored in the Trie.
             *
             * @param codePoint the code point
             * @return the value
             */
            Trie.prototype.get = function (codePoint) {
                var ix;
                if (codePoint >= 0) {
                    if (
                        codePoint < 0x0d800 ||
                        (codePoint > 0x0dbff && codePoint <= 0x0ffff)
                    ) {
                        // Ordinary BMP code point, excluding leading surrogates.
                        // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                        // 16 bit data is stored in the index array itself.
                        ix = this.index[codePoint >> UTRIE2_SHIFT_2$1];
                        ix =
                            (ix << UTRIE2_INDEX_SHIFT$1) +
                            (codePoint & UTRIE2_DATA_MASK$1);
                        return this.data[ix];
                    }
                    if (codePoint <= 0xffff) {
                        // Lead Surrogate Code Point.  A Separate index section is stored for
                        // lead surrogate code units and code points.
                        //   The main index has the code unit data.
                        //   For this function, we need the code point data.
                        // Note: this expression could be refactored for slightly improved efficiency, but
                        //       surrogate code points will be so rare in practice that it's not worth it.
                        ix =
                            this.index[
                                UTRIE2_LSCP_INDEX_2_OFFSET$1 +
                                    ((codePoint - 0xd800) >> UTRIE2_SHIFT_2$1)
                            ];
                        ix =
                            (ix << UTRIE2_INDEX_SHIFT$1) +
                            (codePoint & UTRIE2_DATA_MASK$1);
                        return this.data[ix];
                    }
                    if (codePoint < this.highStart) {
                        // Supplemental code point, use two-level lookup.
                        ix =
                            UTRIE2_INDEX_1_OFFSET$1 -
                            UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 +
                            (codePoint >> UTRIE2_SHIFT_1$1);
                        ix = this.index[ix];
                        ix +=
                            (codePoint >> UTRIE2_SHIFT_2$1) &
                            UTRIE2_INDEX_2_MASK$1;
                        ix = this.index[ix];
                        ix =
                            (ix << UTRIE2_INDEX_SHIFT$1) +
                            (codePoint & UTRIE2_DATA_MASK$1);
                        return this.data[ix];
                    }
                    if (codePoint <= 0x10ffff) {
                        return this.data[this.highValueIndex];
                    }
                }
                // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
                return this.errorValue;
            };
            return Trie;
        })();

        /*
         * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
         * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
         * Released under MIT License
         */
        var chars$3 =
            "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
        // Use a lookup table to find the index.
        var lookup$3 =
            typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
        for (var i$3 = 0; i$3 < chars$3.length; i$3++) {
            lookup$3[chars$3.charCodeAt(i$3)] = i$3;
        }
        var base64$1 =
            "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";
        var LETTER_NUMBER_MODIFIER = 50;
        // Non-tailorable Line Breaking Classes
        var BK = 1; //  Cause a line break (after)
        var CR$1 = 2; //  Cause a line break (after), except between CR and LF
        var LF$1 = 3; //  Cause a line break (after)
        var CM = 4; //  Prohibit a line break between the character and the preceding character
        var NL = 5; //  Cause a line break (after)
        var WJ = 7; //  Prohibit line breaks before and after
        var ZW = 8; //  Provide a break opportunity
        var GL = 9; //  Prohibit line breaks before and after
        var SP = 10; // Enable indirect line breaks
        var ZWJ$1 = 11; // Prohibit line breaks within joiner sequences
        // Break Opportunities
        var B2 = 12; //  Provide a line break opportunity before and after the character
        var BA = 13; //  Generally provide a line break opportunity after the character
        var BB = 14; //  Generally provide a line break opportunity before the character
        var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
        var CB = 16; //   Provide a line break opportunity contingent on additional information
        // Characters Prohibiting Certain Breaks
        var CL = 17; //  Prohibit line breaks before
        var CP = 18; //  Prohibit line breaks before
        var EX = 19; //  Prohibit line breaks before
        var IN = 20; //  Allow only indirect line breaks between pairs
        var NS = 21; //  Allow only indirect line breaks before
        var OP = 22; //  Prohibit line breaks after
        var QU = 23; //  Act like they are both opening and closing
        // Numeric Context
        var IS = 24; //  Prevent breaks after any and before numeric
        var NU = 25; //  Form numeric expressions for line breaking purposes
        var PO = 26; //  Do not break following a numeric expression
        var PR = 27; //  Do not break in front of a numeric expression
        var SY = 28; //  Prevent a break before; and allow a break after
        // Other Characters
        var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
        var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
        var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
        var EB = 32; //  Do not break from following Emoji Modifier
        var EM = 33; //  Do not break from preceding Emoji Base
        var H2 = 34; //  Form Korean syllable blocks
        var H3 = 35; //  Form Korean syllable blocks
        var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
        var ID = 37; //  Break before or after; except in some numeric context
        var JL = 38; //  Form Korean syllable blocks
        var JV = 39; //  Form Korean syllable blocks
        var JT = 40; //  Form Korean syllable blocks
        var RI$1 = 41; //  Keep pairs together. For pairs; break before and after other classes
        var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
        var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
        var ea_OP = [0x2329, 0xff08];
        var BREAK_MANDATORY = "!";
        var BREAK_NOT_ALLOWED$1 = "×";
        var BREAK_ALLOWED$1 = "÷";
        var UnicodeTrie$1 = createTrieFromBase64$1(base64$1);
        var ALPHABETICS = [AL, HL];
        var HARD_LINE_BREAKS = [BK, CR$1, LF$1, NL];
        var SPACE$1 = [SP, ZW];
        var PREFIX_POSTFIX = [PR, PO];
        var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE$1);
        var KOREAN_SYLLABLE_BLOCK = [JL, JV, JT, H2, H3];
        var HYPHEN = [HY, BA];
        var codePointsToCharacterClasses = function (codePoints, lineBreak) {
            if (lineBreak === void 0) {
                lineBreak = "strict";
            }
            var types = [];
            var indices = [];
            var categories = [];
            codePoints.forEach(function (codePoint, index) {
                var classType = UnicodeTrie$1.get(codePoint);
                if (classType > LETTER_NUMBER_MODIFIER) {
                    categories.push(true);
                    classType -= LETTER_NUMBER_MODIFIER;
                } else {
                    categories.push(false);
                }
                if (["normal", "auto", "loose"].indexOf(lineBreak) !== -1) {
                    // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
                    if (
                        [0x2010, 0x2013, 0x301c, 0x30a0].indexOf(codePoint) !==
                        -1
                    ) {
                        indices.push(index);
                        return types.push(CB);
                    }
                }
                if (classType === CM || classType === ZWJ$1) {
                    // LB10 Treat any remaining combining mark or ZWJ as AL.
                    if (index === 0) {
                        indices.push(index);
                        return types.push(AL);
                    }
                    // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
                    // the base character in all of the following rules. Treat ZWJ as if it were CM.
                    var prev = types[index - 1];
                    if (LINE_BREAKS.indexOf(prev) === -1) {
                        indices.push(indices[index - 1]);
                        return types.push(prev);
                    }
                    indices.push(index);
                    return types.push(AL);
                }
                indices.push(index);
                if (classType === CJ) {
                    return types.push(lineBreak === "strict" ? NS : ID);
                }
                if (classType === SA) {
                    return types.push(AL);
                }
                if (classType === AI) {
                    return types.push(AL);
                }
                // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
                // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
                // to take into account the actual line breaking properties for these characters.
                if (classType === XX) {
                    if (
                        (codePoint >= 0x20000 && codePoint <= 0x2fffd) ||
                        (codePoint >= 0x30000 && codePoint <= 0x3fffd)
                    ) {
                        return types.push(ID);
                    } else {
                        return types.push(AL);
                    }
                }
                types.push(classType);
            });
            return [indices, types, categories];
        };
        var isAdjacentWithSpaceIgnored = function (
            a,
            b,
            currentIndex,
            classTypes,
        ) {
            var current = classTypes[currentIndex];
            if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
                var i = currentIndex;
                while (i <= classTypes.length) {
                    i++;
                    var next = classTypes[i];
                    if (next === b) {
                        return true;
                    }
                    if (next !== SP) {
                        break;
                    }
                }
            }
            if (current === SP) {
                var i = currentIndex;
                while (i > 0) {
                    i--;
                    var prev = classTypes[i];
                    if (
                        Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev
                    ) {
                        var n = currentIndex;
                        while (n <= classTypes.length) {
                            n++;
                            var next = classTypes[n];
                            if (next === b) {
                                return true;
                            }
                            if (next !== SP) {
                                break;
                            }
                        }
                    }
                    if (prev !== SP) {
                        break;
                    }
                }
            }
            return false;
        };
        var previousNonSpaceClassType = function (currentIndex, classTypes) {
            var i = currentIndex;
            while (i >= 0) {
                var type = classTypes[i];
                if (type === SP) {
                    i--;
                } else {
                    return type;
                }
            }
            return 0;
        };
        var _lineBreakAtIndex = function (
            codePoints,
            classTypes,
            indicies,
            index,
            forbiddenBreaks,
        ) {
            if (indicies[index] === 0) {
                return BREAK_NOT_ALLOWED$1;
            }
            var currentIndex = index - 1;
            if (
                Array.isArray(forbiddenBreaks) &&
                forbiddenBreaks[currentIndex] === true
            ) {
                return BREAK_NOT_ALLOWED$1;
            }
            var beforeIndex = currentIndex - 1;
            var afterIndex = currentIndex + 1;
            var current = classTypes[currentIndex];
            // LB4 Always break after hard line breaks.
            // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
            var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
            var next = classTypes[afterIndex];
            if (current === CR$1 && next === LF$1) {
                return BREAK_NOT_ALLOWED$1;
            }
            if (HARD_LINE_BREAKS.indexOf(current) !== -1) {
                return BREAK_MANDATORY;
            }
            // LB6 Do not break before hard line breaks.
            if (HARD_LINE_BREAKS.indexOf(next) !== -1) {
                return BREAK_NOT_ALLOWED$1;
            }
            // LB7 Do not break before spaces or zero width space.
            if (SPACE$1.indexOf(next) !== -1) {
                return BREAK_NOT_ALLOWED$1;
            }
            // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
            if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) {
                return BREAK_ALLOWED$1;
            }
            // LB8a Do not break after a zero width joiner.
            if (UnicodeTrie$1.get(codePoints[currentIndex]) === ZWJ$1) {
                return BREAK_NOT_ALLOWED$1;
            }
            // zwj emojis
            if (
                (current === EB || current === EM) &&
                UnicodeTrie$1.get(codePoints[afterIndex]) === ZWJ$1
            ) {
                return BREAK_NOT_ALLOWED$1;
            }
            // LB11 Do not break before or after Word joiner and related characters.
            if (current === WJ || next === WJ) {
                return BREAK_NOT_ALLOWED$1;
            }
            // LB12 Do not break after NBSP and related characters.
            if (current === GL) {
                return BREAK_NOT_ALLOWED$1;
            }
            // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
            if ([SP, BA, HY].indexOf(current) === -1 && next === GL) {
                return BREAK_NOT_ALLOWED$1;
            }
            // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
            if ([CL, CP, EX, IS, SY].indexOf(next) !== -1) {
                return BREAK_NOT_ALLOWED$1;
            }
            // LB14 Do not break after ‘[’, even after spaces.
            if (previousNonSpaceClassType(currentIndex, classTypes) === OP) {
                return BREAK_NOT_ALLOWED$1;
            }
            // LB15 Do not break within ‘”[’, even with intervening spaces.
            if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) {
                return BREAK_NOT_ALLOWED$1;
            }
            // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
            if (
                isAdjacentWithSpaceIgnored(
                    [CL, CP],
                    NS,
                    currentIndex,
                    classTypes,
                )
            ) {
                return BREAK_NOT_ALLOWED$1;
            }
            // LB17 Do not break within ‘——’, even with intervening spaces.
            if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) {
                return BREAK_NOT_ALLOWED$1;
            }
            // LB18 Break after spaces.
            if (current === SP) {
                return BREAK_ALLOWED$1;
            }
            // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
            if (current === QU || next === QU) {
                return BREAK_NOT_ALLOWED$1;
            }
            // LB20 Break before and after unresolved CB.
            if (next === CB || current === CB) {
                return BREAK_ALLOWED$1;
            }
            // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
            if ([BA, HY, NS].indexOf(next) !== -1 || current === BB) {
                return BREAK_NOT_ALLOWED$1;
            }
            // LB21a Don't break after Hebrew + Hyphen.
            if (before === HL && HYPHEN.indexOf(current) !== -1) {
                return BREAK_NOT_ALLOWED$1;
            }
            // LB21b Don’t break between Solidus and Hebrew letters.
            if (current === SY && next === HL) {
                return BREAK_NOT_ALLOWED$1;
            }
            // LB22 Do not break before ellipsis.
            if (next === IN) {
                return BREAK_NOT_ALLOWED$1;
            }
            // LB23 Do not break between digits and letters.
            if (
                (ALPHABETICS.indexOf(next) !== -1 && current === NU) ||
                (ALPHABETICS.indexOf(current) !== -1 && next === NU)
            ) {
                return BREAK_NOT_ALLOWED$1;
            }
            // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
            if (
                (current === PR && [ID, EB, EM].indexOf(next) !== -1) ||
                ([ID, EB, EM].indexOf(current) !== -1 && next === PO)
            ) {
                return BREAK_NOT_ALLOWED$1;
            }
            // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
            if (
                (ALPHABETICS.indexOf(current) !== -1 &&
                    PREFIX_POSTFIX.indexOf(next) !== -1) ||
                (PREFIX_POSTFIX.indexOf(current) !== -1 &&
                    ALPHABETICS.indexOf(next) !== -1)
            ) {
                return BREAK_NOT_ALLOWED$1;
            }
            // LB25 Do not break between the following pairs of classes relevant to numbers:
            if (
                // (PR | PO) × ( OP | HY )? NU
                ([PR, PO].indexOf(current) !== -1 &&
                    (next === NU ||
                        ([OP, HY].indexOf(next) !== -1 &&
                            classTypes[afterIndex + 1] === NU))) ||
                // ( OP | HY ) × NU
                ([OP, HY].indexOf(current) !== -1 && next === NU) ||
                // NU ×	(NU | SY | IS)
                (current === NU && [NU, SY, IS].indexOf(next) !== -1)
            ) {
                return BREAK_NOT_ALLOWED$1;
            }
            // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
            if ([NU, SY, IS, CL, CP].indexOf(next) !== -1) {
                var prevIndex = currentIndex;
                while (prevIndex >= 0) {
                    var type = classTypes[prevIndex];
                    if (type === NU) {
                        return BREAK_NOT_ALLOWED$1;
                    } else if ([SY, IS].indexOf(type) !== -1) {
                        prevIndex--;
                    } else {
                        break;
                    }
                }
            }
            // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
            if ([PR, PO].indexOf(next) !== -1) {
                var prevIndex =
                    [CL, CP].indexOf(current) !== -1
                        ? beforeIndex
                        : currentIndex;
                while (prevIndex >= 0) {
                    var type = classTypes[prevIndex];
                    if (type === NU) {
                        return BREAK_NOT_ALLOWED$1;
                    } else if ([SY, IS].indexOf(type) !== -1) {
                        prevIndex--;
                    } else {
                        break;
                    }
                }
            }
            // LB26 Do not break a Korean syllable.
            if (
                (JL === current && [JL, JV, H2, H3].indexOf(next) !== -1) ||
                ([JV, H2].indexOf(current) !== -1 &&
                    [JV, JT].indexOf(next) !== -1) ||
                ([JT, H3].indexOf(current) !== -1 && next === JT)
            ) {
                return BREAK_NOT_ALLOWED$1;
            }
            // LB27 Treat a Korean Syllable Block the same as ID.
            if (
                (KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 &&
                    [IN, PO].indexOf(next) !== -1) ||
                (KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR)
            ) {
                return BREAK_NOT_ALLOWED$1;
            }
            // LB28 Do not break between alphabetics (“at”).
            if (
                ALPHABETICS.indexOf(current) !== -1 &&
                ALPHABETICS.indexOf(next) !== -1
            ) {
                return BREAK_NOT_ALLOWED$1;
            }
            // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
            if (current === IS && ALPHABETICS.indexOf(next) !== -1) {
                return BREAK_NOT_ALLOWED$1;
            }
            // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
            if (
                (ALPHABETICS.concat(NU).indexOf(current) !== -1 &&
                    next === OP &&
                    ea_OP.indexOf(codePoints[afterIndex]) === -1) ||
                (ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP)
            ) {
                return BREAK_NOT_ALLOWED$1;
            }
            // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
            // indicators preceding the position of the break.
            if (current === RI$1 && next === RI$1) {
                var i = indicies[currentIndex];
                var count = 1;
                while (i > 0) {
                    i--;
                    if (classTypes[i] === RI$1) {
                        count++;
                    } else {
                        break;
                    }
                }
                if (count % 2 !== 0) {
                    return BREAK_NOT_ALLOWED$1;
                }
            }
            // LB30b Do not break between an emoji base and an emoji modifier.
            if (current === EB && next === EM) {
                return BREAK_NOT_ALLOWED$1;
            }
            return BREAK_ALLOWED$1;
        };
        var cssFormattedClasses = function (codePoints, options) {
            if (!options) {
                options = {
                    lineBreak: "normal",
                    wordBreak: "normal",
                };
            }
            var _a = codePointsToCharacterClasses(
                    codePoints,
                    options.lineBreak,
                ),
                indicies = _a[0],
                classTypes = _a[1],
                isLetterNumber = _a[2];
            if (
                options.wordBreak === "break-all" ||
                options.wordBreak === "break-word"
            ) {
                classTypes = classTypes.map(function (type) {
                    return [NU, AL, SA].indexOf(type) !== -1 ? ID : type;
                });
            }
            var forbiddenBreakpoints =
                options.wordBreak === "keep-all"
                    ? isLetterNumber.map(function (letterNumber, i) {
                          return (
                              letterNumber &&
                              codePoints[i] >= 0x4e00 &&
                              codePoints[i] <= 0x9fff
                          );
                      })
                    : undefined;
            return [indicies, classTypes, forbiddenBreakpoints];
        };
        var Break = /** @class */ (function () {
            function Break(codePoints, lineBreak, start, end) {
                this.codePoints = codePoints;
                this.required = lineBreak === BREAK_MANDATORY;
                this.start = start;
                this.end = end;
            }
            Break.prototype.slice = function () {
                return fromCodePoint$1.apply(
                    void 0,
                    this.codePoints.slice(this.start, this.end),
                );
            };
            return Break;
        })();
        var LineBreaker = function (str, options) {
            var codePoints = toCodePoints$1(str);
            var _a = cssFormattedClasses(codePoints, options),
                indicies = _a[0],
                classTypes = _a[1],
                forbiddenBreakpoints = _a[2];
            var length = codePoints.length;
            var lastEnd = 0;
            var nextIndex = 0;
            return {
                next: function () {
                    if (nextIndex >= length) {
                        return {
                            done: true,
                            value: null,
                        };
                    }
                    var lineBreak = BREAK_NOT_ALLOWED$1;
                    while (
                        nextIndex < length &&
                        (lineBreak = _lineBreakAtIndex(
                            codePoints,
                            classTypes,
                            indicies,
                            ++nextIndex,
                            forbiddenBreakpoints,
                        )) === BREAK_NOT_ALLOWED$1
                    ) {}
                    if (
                        lineBreak !== BREAK_NOT_ALLOWED$1 ||
                        nextIndex === length
                    ) {
                        var value = new Break(
                            codePoints,
                            lineBreak,
                            lastEnd,
                            nextIndex,
                        );
                        lastEnd = nextIndex;
                        return {
                            value: value,
                            done: false,
                        };
                    }
                    return {
                        done: true,
                        value: null,
                    };
                },
            };
        };

        // https://www.w3.org/TR/css-syntax-3
        var FLAG_UNRESTRICTED = 1 << 0;
        var FLAG_ID = 1 << 1;
        var FLAG_INTEGER = 1 << 2;
        var FLAG_NUMBER = 1 << 3;
        var LINE_FEED = 0x000a;
        var SOLIDUS = 0x002f;
        var REVERSE_SOLIDUS = 0x005c;
        var CHARACTER_TABULATION = 0x0009;
        var SPACE = 0x0020;
        var QUOTATION_MARK = 0x0022;
        var EQUALS_SIGN = 0x003d;
        var NUMBER_SIGN = 0x0023;
        var DOLLAR_SIGN = 0x0024;
        var PERCENTAGE_SIGN = 0x0025;
        var APOSTROPHE = 0x0027;
        var LEFT_PARENTHESIS = 0x0028;
        var RIGHT_PARENTHESIS = 0x0029;
        var LOW_LINE = 0x005f;
        var HYPHEN_MINUS = 0x002d;
        var EXCLAMATION_MARK = 0x0021;
        var LESS_THAN_SIGN = 0x003c;
        var GREATER_THAN_SIGN = 0x003e;
        var COMMERCIAL_AT = 0x0040;
        var LEFT_SQUARE_BRACKET = 0x005b;
        var RIGHT_SQUARE_BRACKET = 0x005d;
        var CIRCUMFLEX_ACCENT = 0x003d;
        var LEFT_CURLY_BRACKET = 0x007b;
        var QUESTION_MARK = 0x003f;
        var RIGHT_CURLY_BRACKET = 0x007d;
        var VERTICAL_LINE = 0x007c;
        var TILDE = 0x007e;
        var CONTROL = 0x0080;
        var REPLACEMENT_CHARACTER = 0xfffd;
        var ASTERISK = 0x002a;
        var PLUS_SIGN = 0x002b;
        var COMMA = 0x002c;
        var COLON = 0x003a;
        var SEMICOLON = 0x003b;
        var FULL_STOP = 0x002e;
        var NULL = 0x0000;
        var BACKSPACE = 0x0008;
        var LINE_TABULATION = 0x000b;
        var SHIFT_OUT = 0x000e;
        var INFORMATION_SEPARATOR_ONE = 0x001f;
        var DELETE = 0x007f;
        var EOF = -1;
        var ZERO = 0x0030;
        var a = 0x0061;
        var e = 0x0065;
        var f = 0x0066;
        var u = 0x0075;
        var z = 0x007a;
        var A = 0x0041;
        var E = 0x0045;
        var F = 0x0046;
        var U = 0x0055;
        var Z = 0x005a;
        var isDigit = function (codePoint) {
            return codePoint >= ZERO && codePoint <= 0x0039;
        };
        var isSurrogateCodePoint = function (codePoint) {
            return codePoint >= 0xd800 && codePoint <= 0xdfff;
        };
        var isHex = function (codePoint) {
            return (
                isDigit(codePoint) ||
                (codePoint >= A && codePoint <= F) ||
                (codePoint >= a && codePoint <= f)
            );
        };
        var isLowerCaseLetter = function (codePoint) {
            return codePoint >= a && codePoint <= z;
        };
        var isUpperCaseLetter = function (codePoint) {
            return codePoint >= A && codePoint <= Z;
        };
        var isLetter = function (codePoint) {
            return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint);
        };
        var isNonASCIICodePoint = function (codePoint) {
            return codePoint >= CONTROL;
        };
        var isWhiteSpace = function (codePoint) {
            return (
                codePoint === LINE_FEED ||
                codePoint === CHARACTER_TABULATION ||
                codePoint === SPACE
            );
        };
        var isNameStartCodePoint = function (codePoint) {
            return (
                isLetter(codePoint) ||
                isNonASCIICodePoint(codePoint) ||
                codePoint === LOW_LINE
            );
        };
        var isNameCodePoint = function (codePoint) {
            return (
                isNameStartCodePoint(codePoint) ||
                isDigit(codePoint) ||
                codePoint === HYPHEN_MINUS
            );
        };
        var isNonPrintableCodePoint = function (codePoint) {
            return (
                (codePoint >= NULL && codePoint <= BACKSPACE) ||
                codePoint === LINE_TABULATION ||
                (codePoint >= SHIFT_OUT &&
                    codePoint <= INFORMATION_SEPARATOR_ONE) ||
                codePoint === DELETE
            );
        };
        var isValidEscape = function (c1, c2) {
            if (c1 !== REVERSE_SOLIDUS) {
                return false;
            }
            return c2 !== LINE_FEED;
        };
        var isIdentifierStart = function (c1, c2, c3) {
            if (c1 === HYPHEN_MINUS) {
                return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
            } else if (isNameStartCodePoint(c1)) {
                return true;
            } else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) {
                return true;
            }
            return false;
        };
        var isNumberStart = function (c1, c2, c3) {
            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
                if (isDigit(c2)) {
                    return true;
                }
                return c2 === FULL_STOP && isDigit(c3);
            }
            if (c1 === FULL_STOP) {
                return isDigit(c2);
            }
            return isDigit(c1);
        };
        var stringToNumber = function (codePoints) {
            var c = 0;
            var sign = 1;
            if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
                if (codePoints[c] === HYPHEN_MINUS) {
                    sign = -1;
                }
                c++;
            }
            var integers = [];
            while (isDigit(codePoints[c])) {
                integers.push(codePoints[c++]);
            }
            var int = integers.length
                ? parseInt(fromCodePoint$1.apply(void 0, integers), 10)
                : 0;
            if (codePoints[c] === FULL_STOP) {
                c++;
            }
            var fraction = [];
            while (isDigit(codePoints[c])) {
                fraction.push(codePoints[c++]);
            }
            var fracd = fraction.length;
            var frac = fracd
                ? parseInt(fromCodePoint$1.apply(void 0, fraction), 10)
                : 0;
            if (codePoints[c] === E || codePoints[c] === e) {
                c++;
            }
            var expsign = 1;
            if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
                if (codePoints[c] === HYPHEN_MINUS) {
                    expsign = -1;
                }
                c++;
            }
            var exponent = [];
            while (isDigit(codePoints[c])) {
                exponent.push(codePoints[c++]);
            }
            var exp = exponent.length
                ? parseInt(fromCodePoint$1.apply(void 0, exponent), 10)
                : 0;
            return (
                sign *
                (int + frac * Math.pow(10, -fracd)) *
                Math.pow(10, expsign * exp)
            );
        };
        var LEFT_PARENTHESIS_TOKEN = {
            type: 2 /* LEFT_PARENTHESIS_TOKEN */,
        };

        var RIGHT_PARENTHESIS_TOKEN = {
            type: 3 /* RIGHT_PARENTHESIS_TOKEN */,
        };

        var COMMA_TOKEN = {
            type: 4 /* COMMA_TOKEN */,
        };
        var SUFFIX_MATCH_TOKEN = {
            type: 13 /* SUFFIX_MATCH_TOKEN */,
        };
        var PREFIX_MATCH_TOKEN = {
            type: 8 /* PREFIX_MATCH_TOKEN */,
        };
        var COLUMN_TOKEN = {
            type: 21 /* COLUMN_TOKEN */,
        };
        var DASH_MATCH_TOKEN = {
            type: 9 /* DASH_MATCH_TOKEN */,
        };
        var INCLUDE_MATCH_TOKEN = {
            type: 10 /* INCLUDE_MATCH_TOKEN */,
        };
        var LEFT_CURLY_BRACKET_TOKEN = {
            type: 11 /* LEFT_CURLY_BRACKET_TOKEN */,
        };

        var RIGHT_CURLY_BRACKET_TOKEN = {
            type: 12 /* RIGHT_CURLY_BRACKET_TOKEN */,
        };

        var SUBSTRING_MATCH_TOKEN = {
            type: 14 /* SUBSTRING_MATCH_TOKEN */,
        };
        var BAD_URL_TOKEN = {
            type: 23 /* BAD_URL_TOKEN */,
        };
        var BAD_STRING_TOKEN = {
            type: 1 /* BAD_STRING_TOKEN */,
        };
        var CDO_TOKEN = {
            type: 25 /* CDO_TOKEN */,
        };
        var CDC_TOKEN = {
            type: 24 /* CDC_TOKEN */,
        };
        var COLON_TOKEN = {
            type: 26 /* COLON_TOKEN */,
        };
        var SEMICOLON_TOKEN = {
            type: 27 /* SEMICOLON_TOKEN */,
        };
        var LEFT_SQUARE_BRACKET_TOKEN = {
            type: 28 /* LEFT_SQUARE_BRACKET_TOKEN */,
        };

        var RIGHT_SQUARE_BRACKET_TOKEN = {
            type: 29 /* RIGHT_SQUARE_BRACKET_TOKEN */,
        };

        var WHITESPACE_TOKEN = {
            type: 31 /* WHITESPACE_TOKEN */,
        };
        var EOF_TOKEN = {
            type: 32 /* EOF_TOKEN */,
        };
        var Tokenizer = /** @class */ (function () {
            function Tokenizer() {
                this._value = [];
            }
            Tokenizer.prototype.write = function (chunk) {
                this._value = this._value.concat(toCodePoints$1(chunk));
            };
            Tokenizer.prototype.read = function () {
                var tokens = [];
                var token = this.consumeToken();
                while (token !== EOF_TOKEN) {
                    tokens.push(token);
                    token = this.consumeToken();
                }
                return tokens;
            };
            Tokenizer.prototype.consumeToken = function () {
                var codePoint = this.consumeCodePoint();
                switch (codePoint) {
                    case QUOTATION_MARK:
                        return this.consumeStringToken(QUOTATION_MARK);
                    case NUMBER_SIGN:
                        var c1 = this.peekCodePoint(0);
                        var c2 = this.peekCodePoint(1);
                        var c3 = this.peekCodePoint(2);
                        if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
                            var flags = isIdentifierStart(c1, c2, c3)
                                ? FLAG_ID
                                : FLAG_UNRESTRICTED;
                            var value = this.consumeName();
                            return {
                                type: 5 /* HASH_TOKEN */,
                                value: value,
                                flags: flags,
                            };
                        }
                        break;
                    case DOLLAR_SIGN:
                        if (this.peekCodePoint(0) === EQUALS_SIGN) {
                            this.consumeCodePoint();
                            return SUFFIX_MATCH_TOKEN;
                        }
                        break;
                    case APOSTROPHE:
                        return this.consumeStringToken(APOSTROPHE);
                    case LEFT_PARENTHESIS:
                        return LEFT_PARENTHESIS_TOKEN;
                    case RIGHT_PARENTHESIS:
                        return RIGHT_PARENTHESIS_TOKEN;
                    case ASTERISK:
                        if (this.peekCodePoint(0) === EQUALS_SIGN) {
                            this.consumeCodePoint();
                            return SUBSTRING_MATCH_TOKEN;
                        }
                        break;
                    case PLUS_SIGN:
                        if (
                            isNumberStart(
                                codePoint,
                                this.peekCodePoint(0),
                                this.peekCodePoint(1),
                            )
                        ) {
                            this.reconsumeCodePoint(codePoint);
                            return this.consumeNumericToken();
                        }
                        break;
                    case COMMA:
                        return COMMA_TOKEN;
                    case HYPHEN_MINUS:
                        var e1 = codePoint;
                        var e2 = this.peekCodePoint(0);
                        var e3 = this.peekCodePoint(1);
                        if (isNumberStart(e1, e2, e3)) {
                            this.reconsumeCodePoint(codePoint);
                            return this.consumeNumericToken();
                        }
                        if (isIdentifierStart(e1, e2, e3)) {
                            this.reconsumeCodePoint(codePoint);
                            return this.consumeIdentLikeToken();
                        }
                        if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                            this.consumeCodePoint();
                            this.consumeCodePoint();
                            return CDC_TOKEN;
                        }
                        break;
                    case FULL_STOP:
                        if (
                            isNumberStart(
                                codePoint,
                                this.peekCodePoint(0),
                                this.peekCodePoint(1),
                            )
                        ) {
                            this.reconsumeCodePoint(codePoint);
                            return this.consumeNumericToken();
                        }
                        break;
                    case SOLIDUS:
                        if (this.peekCodePoint(0) === ASTERISK) {
                            this.consumeCodePoint();
                            while (true) {
                                var c = this.consumeCodePoint();
                                if (c === ASTERISK) {
                                    c = this.consumeCodePoint();
                                    if (c === SOLIDUS) {
                                        return this.consumeToken();
                                    }
                                }
                                if (c === EOF) {
                                    return this.consumeToken();
                                }
                            }
                        }
                        break;
                    case COLON:
                        return COLON_TOKEN;
                    case SEMICOLON:
                        return SEMICOLON_TOKEN;
                    case LESS_THAN_SIGN:
                        if (
                            this.peekCodePoint(0) === EXCLAMATION_MARK &&
                            this.peekCodePoint(1) === HYPHEN_MINUS &&
                            this.peekCodePoint(2) === HYPHEN_MINUS
                        ) {
                            this.consumeCodePoint();
                            this.consumeCodePoint();
                            return CDO_TOKEN;
                        }
                        break;
                    case COMMERCIAL_AT:
                        var a1 = this.peekCodePoint(0);
                        var a2 = this.peekCodePoint(1);
                        var a3 = this.peekCodePoint(2);
                        if (isIdentifierStart(a1, a2, a3)) {
                            var value = this.consumeName();
                            return {
                                type: 7 /* AT_KEYWORD_TOKEN */,
                                value: value,
                            };
                        }
                        break;
                    case LEFT_SQUARE_BRACKET:
                        return LEFT_SQUARE_BRACKET_TOKEN;
                    case REVERSE_SOLIDUS:
                        if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                            this.reconsumeCodePoint(codePoint);
                            return this.consumeIdentLikeToken();
                        }
                        break;
                    case RIGHT_SQUARE_BRACKET:
                        return RIGHT_SQUARE_BRACKET_TOKEN;
                    case CIRCUMFLEX_ACCENT:
                        if (this.peekCodePoint(0) === EQUALS_SIGN) {
                            this.consumeCodePoint();
                            return PREFIX_MATCH_TOKEN;
                        }
                        break;
                    case LEFT_CURLY_BRACKET:
                        return LEFT_CURLY_BRACKET_TOKEN;
                    case RIGHT_CURLY_BRACKET:
                        return RIGHT_CURLY_BRACKET_TOKEN;
                    case u:
                    case U:
                        var u1 = this.peekCodePoint(0);
                        var u2 = this.peekCodePoint(1);
                        if (
                            u1 === PLUS_SIGN &&
                            (isHex(u2) || u2 === QUESTION_MARK)
                        ) {
                            this.consumeCodePoint();
                            this.consumeUnicodeRangeToken();
                        }
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    case VERTICAL_LINE:
                        if (this.peekCodePoint(0) === EQUALS_SIGN) {
                            this.consumeCodePoint();
                            return DASH_MATCH_TOKEN;
                        }
                        if (this.peekCodePoint(0) === VERTICAL_LINE) {
                            this.consumeCodePoint();
                            return COLUMN_TOKEN;
                        }
                        break;
                    case TILDE:
                        if (this.peekCodePoint(0) === EQUALS_SIGN) {
                            this.consumeCodePoint();
                            return INCLUDE_MATCH_TOKEN;
                        }
                        break;
                    case EOF:
                        return EOF_TOKEN;
                }
                if (isWhiteSpace(codePoint)) {
                    this.consumeWhiteSpace();
                    return WHITESPACE_TOKEN;
                }
                if (isDigit(codePoint)) {
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeNumericToken();
                }
                if (isNameStartCodePoint(codePoint)) {
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                }
                return {
                    type: 6 /* DELIM_TOKEN */,
                    value: fromCodePoint$1(codePoint),
                };
            };
            Tokenizer.prototype.consumeCodePoint = function () {
                var value = this._value.shift();
                return typeof value === "undefined" ? -1 : value;
            };
            Tokenizer.prototype.reconsumeCodePoint = function (codePoint) {
                this._value.unshift(codePoint);
            };
            Tokenizer.prototype.peekCodePoint = function (delta) {
                if (delta >= this._value.length) {
                    return -1;
                }
                return this._value[delta];
            };
            Tokenizer.prototype.consumeUnicodeRangeToken = function () {
                var digits = [];
                var codePoint = this.consumeCodePoint();
                while (isHex(codePoint) && digits.length < 6) {
                    digits.push(codePoint);
                    codePoint = this.consumeCodePoint();
                }
                var questionMarks = false;
                while (codePoint === QUESTION_MARK && digits.length < 6) {
                    digits.push(codePoint);
                    codePoint = this.consumeCodePoint();
                    questionMarks = true;
                }
                if (questionMarks) {
                    var start_1 = parseInt(
                        fromCodePoint$1.apply(
                            void 0,
                            digits.map(function (digit) {
                                return digit === QUESTION_MARK ? ZERO : digit;
                            }),
                        ),
                        16,
                    );
                    var end = parseInt(
                        fromCodePoint$1.apply(
                            void 0,
                            digits.map(function (digit) {
                                return digit === QUESTION_MARK ? F : digit;
                            }),
                        ),
                        16,
                    );
                    return {
                        type: 30 /* UNICODE_RANGE_TOKEN */,
                        start: start_1,
                        end: end,
                    };
                }
                var start = parseInt(fromCodePoint$1.apply(void 0, digits), 16);
                if (
                    this.peekCodePoint(0) === HYPHEN_MINUS &&
                    isHex(this.peekCodePoint(1))
                ) {
                    this.consumeCodePoint();
                    codePoint = this.consumeCodePoint();
                    var endDigits = [];
                    while (isHex(codePoint) && endDigits.length < 6) {
                        endDigits.push(codePoint);
                        codePoint = this.consumeCodePoint();
                    }
                    var end = parseInt(
                        fromCodePoint$1.apply(void 0, endDigits),
                        16,
                    );
                    return {
                        type: 30 /* UNICODE_RANGE_TOKEN */,
                        start: start,
                        end: end,
                    };
                } else {
                    return {
                        type: 30 /* UNICODE_RANGE_TOKEN */,
                        start: start,
                        end: start,
                    };
                }
            };
            Tokenizer.prototype.consumeIdentLikeToken = function () {
                var value = this.consumeName();
                if (
                    value.toLowerCase() === "url" &&
                    this.peekCodePoint(0) === LEFT_PARENTHESIS
                ) {
                    this.consumeCodePoint();
                    return this.consumeUrlToken();
                } else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                    this.consumeCodePoint();
                    return {
                        type: 19 /* FUNCTION_TOKEN */,
                        value: value,
                    };
                }
                return {
                    type: 20 /* IDENT_TOKEN */,
                    value: value,
                };
            };
            Tokenizer.prototype.consumeUrlToken = function () {
                var value = [];
                this.consumeWhiteSpace();
                if (this.peekCodePoint(0) === EOF) {
                    return {
                        type: 22 /* URL_TOKEN */,
                        value: "",
                    };
                }
                var next = this.peekCodePoint(0);
                if (next === APOSTROPHE || next === QUOTATION_MARK) {
                    var stringToken = this.consumeStringToken(
                        this.consumeCodePoint(),
                    );
                    if (stringToken.type === 0 /* STRING_TOKEN */) {
                        this.consumeWhiteSpace();
                        if (
                            this.peekCodePoint(0) === EOF ||
                            this.peekCodePoint(0) === RIGHT_PARENTHESIS
                        ) {
                            this.consumeCodePoint();
                            return {
                                type: 22 /* URL_TOKEN */,
                                value: stringToken.value,
                            };
                        }
                    }
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                }
                while (true) {
                    var codePoint = this.consumeCodePoint();
                    if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) {
                        return {
                            type: 22 /* URL_TOKEN */,
                            value: fromCodePoint$1.apply(void 0, value),
                        };
                    } else if (isWhiteSpace(codePoint)) {
                        this.consumeWhiteSpace();
                        if (
                            this.peekCodePoint(0) === EOF ||
                            this.peekCodePoint(0) === RIGHT_PARENTHESIS
                        ) {
                            this.consumeCodePoint();
                            return {
                                type: 22 /* URL_TOKEN */,
                                value: fromCodePoint$1.apply(void 0, value),
                            };
                        }
                        this.consumeBadUrlRemnants();
                        return BAD_URL_TOKEN;
                    } else if (
                        codePoint === QUOTATION_MARK ||
                        codePoint === APOSTROPHE ||
                        codePoint === LEFT_PARENTHESIS ||
                        isNonPrintableCodePoint(codePoint)
                    ) {
                        this.consumeBadUrlRemnants();
                        return BAD_URL_TOKEN;
                    } else if (codePoint === REVERSE_SOLIDUS) {
                        if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                            value.push(this.consumeEscapedCodePoint());
                        } else {
                            this.consumeBadUrlRemnants();
                            return BAD_URL_TOKEN;
                        }
                    } else {
                        value.push(codePoint);
                    }
                }
            };
            Tokenizer.prototype.consumeWhiteSpace = function () {
                while (isWhiteSpace(this.peekCodePoint(0))) {
                    this.consumeCodePoint();
                }
            };
            Tokenizer.prototype.consumeBadUrlRemnants = function () {
                while (true) {
                    var codePoint = this.consumeCodePoint();
                    if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) {
                        return;
                    }
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        this.consumeEscapedCodePoint();
                    }
                }
            };
            Tokenizer.prototype.consumeStringSlice = function (count) {
                var SLICE_STACK_SIZE = 50000;
                var value = "";
                while (count > 0) {
                    var amount = Math.min(SLICE_STACK_SIZE, count);
                    value += fromCodePoint$1.apply(
                        void 0,
                        this._value.splice(0, amount),
                    );
                    count -= amount;
                }
                this._value.shift();
                return value;
            };
            Tokenizer.prototype.consumeStringToken = function (
                endingCodePoint,
            ) {
                var value = "";
                var i = 0;
                do {
                    var codePoint = this._value[i];
                    if (
                        codePoint === EOF ||
                        codePoint === undefined ||
                        codePoint === endingCodePoint
                    ) {
                        value += this.consumeStringSlice(i);
                        return {
                            type: 0 /* STRING_TOKEN */,
                            value: value,
                        };
                    }
                    if (codePoint === LINE_FEED) {
                        this._value.splice(0, i);
                        return BAD_STRING_TOKEN;
                    }
                    if (codePoint === REVERSE_SOLIDUS) {
                        var next = this._value[i + 1];
                        if (next !== EOF && next !== undefined) {
                            if (next === LINE_FEED) {
                                value += this.consumeStringSlice(i);
                                i = -1;
                                this._value.shift();
                            } else if (isValidEscape(codePoint, next)) {
                                value += this.consumeStringSlice(i);
                                value += fromCodePoint$1(
                                    this.consumeEscapedCodePoint(),
                                );
                                i = -1;
                            }
                        }
                    }
                    i++;
                } while (true);
            };
            Tokenizer.prototype.consumeNumber = function () {
                var repr = [];
                var type = FLAG_INTEGER;
                var c1 = this.peekCodePoint(0);
                if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
                    repr.push(this.consumeCodePoint());
                }
                while (isDigit(this.peekCodePoint(0))) {
                    repr.push(this.consumeCodePoint());
                }
                c1 = this.peekCodePoint(0);
                var c2 = this.peekCodePoint(1);
                if (c1 === FULL_STOP && isDigit(c2)) {
                    repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                    type = FLAG_NUMBER;
                    while (isDigit(this.peekCodePoint(0))) {
                        repr.push(this.consumeCodePoint());
                    }
                }
                c1 = this.peekCodePoint(0);
                c2 = this.peekCodePoint(1);
                var c3 = this.peekCodePoint(2);
                if (
                    (c1 === E || c1 === e) &&
                    (((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) &&
                        isDigit(c3)) ||
                        isDigit(c2))
                ) {
                    repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                    type = FLAG_NUMBER;
                    while (isDigit(this.peekCodePoint(0))) {
                        repr.push(this.consumeCodePoint());
                    }
                }
                return [stringToNumber(repr), type];
            };
            Tokenizer.prototype.consumeNumericToken = function () {
                var _a = this.consumeNumber(),
                    number = _a[0],
                    flags = _a[1];
                var c1 = this.peekCodePoint(0);
                var c2 = this.peekCodePoint(1);
                var c3 = this.peekCodePoint(2);
                if (isIdentifierStart(c1, c2, c3)) {
                    var unit = this.consumeName();
                    return {
                        type: 15 /* DIMENSION_TOKEN */,
                        number: number,
                        flags: flags,
                        unit: unit,
                    };
                }
                if (c1 === PERCENTAGE_SIGN) {
                    this.consumeCodePoint();
                    return {
                        type: 16 /* PERCENTAGE_TOKEN */,
                        number: number,
                        flags: flags,
                    };
                }
                return {
                    type: 17 /* NUMBER_TOKEN */,
                    number: number,
                    flags: flags,
                };
            };
            Tokenizer.prototype.consumeEscapedCodePoint = function () {
                var codePoint = this.consumeCodePoint();
                if (isHex(codePoint)) {
                    var hex = fromCodePoint$1(codePoint);
                    while (isHex(this.peekCodePoint(0)) && hex.length < 6) {
                        hex += fromCodePoint$1(this.consumeCodePoint());
                    }
                    if (isWhiteSpace(this.peekCodePoint(0))) {
                        this.consumeCodePoint();
                    }
                    var hexCodePoint = parseInt(hex, 16);
                    if (
                        hexCodePoint === 0 ||
                        isSurrogateCodePoint(hexCodePoint) ||
                        hexCodePoint > 0x10ffff
                    ) {
                        return REPLACEMENT_CHARACTER;
                    }
                    return hexCodePoint;
                }
                if (codePoint === EOF) {
                    return REPLACEMENT_CHARACTER;
                }
                return codePoint;
            };
            Tokenizer.prototype.consumeName = function () {
                var result = "";
                while (true) {
                    var codePoint = this.consumeCodePoint();
                    if (isNameCodePoint(codePoint)) {
                        result += fromCodePoint$1(codePoint);
                    } else if (
                        isValidEscape(codePoint, this.peekCodePoint(0))
                    ) {
                        result += fromCodePoint$1(
                            this.consumeEscapedCodePoint(),
                        );
                    } else {
                        this.reconsumeCodePoint(codePoint);
                        return result;
                    }
                }
            };
            return Tokenizer;
        })();
        var Parser = /** @class */ (function () {
            function Parser(tokens) {
                this._tokens = tokens;
            }
            Parser.create = function (value) {
                var tokenizer = new Tokenizer();
                tokenizer.write(value);
                return new Parser(tokenizer.read());
            };
            Parser.parseValue = function (value) {
                return Parser.create(value).parseComponentValue();
            };
            Parser.parseValues = function (value) {
                return Parser.create(value).parseComponentValues();
            };
            Parser.prototype.parseComponentValue = function () {
                var token = this.consumeToken();
                while (token.type === 31 /* WHITESPACE_TOKEN */) {
                    token = this.consumeToken();
                }
                if (token.type === 32 /* EOF_TOKEN */) {
                    throw new SyntaxError(
                        "Error parsing CSS component value, unexpected EOF",
                    );
                }
                this.reconsumeToken(token);
                var value = this.consumeComponentValue();
                do {
                    token = this.consumeToken();
                } while (token.type === 31 /* WHITESPACE_TOKEN */);
                if (token.type === 32 /* EOF_TOKEN */) {
                    return value;
                }
                throw new SyntaxError(
                    "Error parsing CSS component value, multiple values found when expecting only one",
                );
            };
            Parser.prototype.parseComponentValues = function () {
                var values = [];
                while (true) {
                    var value = this.consumeComponentValue();
                    if (value.type === 32 /* EOF_TOKEN */) {
                        return values;
                    }
                    values.push(value);
                    values.push();
                }
            };
            Parser.prototype.consumeComponentValue = function () {
                var token = this.consumeToken();
                switch (token.type) {
                    case 11 /* LEFT_CURLY_BRACKET_TOKEN */:
                    case 28 /* LEFT_SQUARE_BRACKET_TOKEN */:
                    case 2 /* LEFT_PARENTHESIS_TOKEN */:
                        return this.consumeSimpleBlock(token.type);
                    case 19 /* FUNCTION_TOKEN */:
                        return this.consumeFunction(token);
                }
                return token;
            };
            Parser.prototype.consumeSimpleBlock = function (type) {
                var block = {
                    type: type,
                    values: [],
                };
                var token = this.consumeToken();
                while (true) {
                    if (
                        token.type === 32 /* EOF_TOKEN */ ||
                        isEndingTokenFor(token, type)
                    ) {
                        return block;
                    }
                    this.reconsumeToken(token);
                    block.values.push(this.consumeComponentValue());
                    token = this.consumeToken();
                }
            };
            Parser.prototype.consumeFunction = function (functionToken) {
                var cssFunction = {
                    name: functionToken.value,
                    values: [],
                    type: 18 /* FUNCTION */,
                };

                while (true) {
                    var token = this.consumeToken();
                    if (
                        token.type === 32 /* EOF_TOKEN */ ||
                        token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */
                    ) {
                        return cssFunction;
                    }
                    this.reconsumeToken(token);
                    cssFunction.values.push(this.consumeComponentValue());
                }
            };
            Parser.prototype.consumeToken = function () {
                var token = this._tokens.shift();
                return typeof token === "undefined" ? EOF_TOKEN : token;
            };
            Parser.prototype.reconsumeToken = function (token) {
                this._tokens.unshift(token);
            };
            return Parser;
        })();
        var isDimensionToken = function (token) {
            return token.type === 15 /* DIMENSION_TOKEN */;
        };
        var isNumberToken = function (token) {
            return token.type === 17 /* NUMBER_TOKEN */;
        };
        var isIdentToken = function (token) {
            return token.type === 20 /* IDENT_TOKEN */;
        };
        var isStringToken = function (token) {
            return token.type === 0 /* STRING_TOKEN */;
        };
        var isIdentWithValue = function (token, value) {
            return isIdentToken(token) && token.value === value;
        };
        var nonWhiteSpace = function (token) {
            return token.type !== 31 /* WHITESPACE_TOKEN */;
        };
        var nonFunctionArgSeparator = function (token) {
            return (
                token.type !== 31 /* WHITESPACE_TOKEN */ &&
                token.type !== 4 /* COMMA_TOKEN */
            );
        };

        var parseFunctionArgs = function (tokens) {
            var args = [];
            var arg = [];
            tokens.forEach(function (token) {
                if (token.type === 4 /* COMMA_TOKEN */) {
                    if (arg.length === 0) {
                        throw new Error(
                            "Error parsing function args, zero tokens for arg",
                        );
                    }
                    args.push(arg);
                    arg = [];
                    return;
                }
                if (token.type !== 31 /* WHITESPACE_TOKEN */) {
                    arg.push(token);
                }
            });
            if (arg.length) {
                args.push(arg);
            }
            return args;
        };
        var isEndingTokenFor = function (token, type) {
            if (
                type === 11 /* LEFT_CURLY_BRACKET_TOKEN */ &&
                token.type === 12 /* RIGHT_CURLY_BRACKET_TOKEN */
            ) {
                return true;
            }
            if (
                type === 28 /* LEFT_SQUARE_BRACKET_TOKEN */ &&
                token.type === 29 /* RIGHT_SQUARE_BRACKET_TOKEN */
            ) {
                return true;
            }
            return (
                type === 2 /* LEFT_PARENTHESIS_TOKEN */ &&
                token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */
            );
        };

        var isLength = function (token) {
            return (
                token.type === 17 /* NUMBER_TOKEN */ ||
                token.type === 15 /* DIMENSION_TOKEN */
            );
        };

        var isLengthPercentage = function (token) {
            return token.type === 16 /* PERCENTAGE_TOKEN */ || isLength(token);
        };
        var parseLengthPercentageTuple = function (tokens) {
            return tokens.length > 1 ? [tokens[0], tokens[1]] : [tokens[0]];
        };
        var ZERO_LENGTH = {
            type: 17 /* NUMBER_TOKEN */,
            number: 0,
            flags: FLAG_INTEGER,
        };
        var FIFTY_PERCENT = {
            type: 16 /* PERCENTAGE_TOKEN */,
            number: 50,
            flags: FLAG_INTEGER,
        };
        var HUNDRED_PERCENT = {
            type: 16 /* PERCENTAGE_TOKEN */,
            number: 100,
            flags: FLAG_INTEGER,
        };
        var getAbsoluteValueForTuple = function (tuple, width, height) {
            var x = tuple[0],
                y = tuple[1];
            return [
                getAbsoluteValue(x, width),
                getAbsoluteValue(typeof y !== "undefined" ? y : x, height),
            ];
        };
        var getAbsoluteValue = function (token, parent) {
            if (token.type === 16 /* PERCENTAGE_TOKEN */) {
                return (token.number / 100) * parent;
            }
            if (isDimensionToken(token)) {
                switch (token.unit) {
                    case "rem":
                    case "em":
                        return 16 * token.number;
                    // TODO use correct font-size
                    case "px":
                    default:
                        return token.number;
                }
            }
            return token.number;
        };
        var DEG = "deg";
        var GRAD = "grad";
        var RAD = "rad";
        var TURN = "turn";
        var angle = {
            name: "angle",
            parse: function (_context, value) {
                if (value.type === 15 /* DIMENSION_TOKEN */) {
                    switch (value.unit) {
                        case DEG:
                            return (Math.PI * value.number) / 180;
                        case GRAD:
                            return (Math.PI / 200) * value.number;
                        case RAD:
                            return value.number;
                        case TURN:
                            return Math.PI * 2 * value.number;
                    }
                }
                throw new Error("Unsupported angle type");
            },
        };
        var isAngle = function (value) {
            if (value.type === 15 /* DIMENSION_TOKEN */) {
                if (
                    value.unit === DEG ||
                    value.unit === GRAD ||
                    value.unit === RAD ||
                    value.unit === TURN
                ) {
                    return true;
                }
            }
            return false;
        };
        var parseNamedSide = function (tokens) {
            var sideOrCorner = tokens
                .filter(isIdentToken)
                .map(function (ident) {
                    return ident.value;
                })
                .join(" ");
            switch (sideOrCorner) {
                case "to bottom right":
                case "to right bottom":
                case "left top":
                case "top left":
                    return [ZERO_LENGTH, ZERO_LENGTH];
                case "to top":
                case "bottom":
                    return deg(0);
                case "to bottom left":
                case "to left bottom":
                case "right top":
                case "top right":
                    return [ZERO_LENGTH, HUNDRED_PERCENT];
                case "to right":
                case "left":
                    return deg(90);
                case "to top left":
                case "to left top":
                case "right bottom":
                case "bottom right":
                    return [HUNDRED_PERCENT, HUNDRED_PERCENT];
                case "to bottom":
                case "top":
                    return deg(180);
                case "to top right":
                case "to right top":
                case "left bottom":
                case "bottom left":
                    return [HUNDRED_PERCENT, ZERO_LENGTH];
                case "to left":
                case "right":
                    return deg(270);
            }
            return 0;
        };
        var deg = function (deg) {
            return (Math.PI * deg) / 180;
        };
        var color$1 = {
            name: "color",
            parse: function (context, value) {
                if (value.type === 18 /* FUNCTION */) {
                    var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
                    if (typeof colorFunction === "undefined") {
                        throw new Error(
                            'Attempting to parse an unsupported color function "' +
                                value.name +
                                '"',
                        );
                    }
                    return colorFunction(context, value.values);
                }
                if (value.type === 5 /* HASH_TOKEN */) {
                    if (value.value.length === 3) {
                        var r = value.value.substring(0, 1);
                        var g = value.value.substring(1, 2);
                        var b = value.value.substring(2, 3);
                        return pack(
                            parseInt(r + r, 16),
                            parseInt(g + g, 16),
                            parseInt(b + b, 16),
                            1,
                        );
                    }
                    if (value.value.length === 4) {
                        var r = value.value.substring(0, 1);
                        var g = value.value.substring(1, 2);
                        var b = value.value.substring(2, 3);
                        var a = value.value.substring(3, 4);
                        return pack(
                            parseInt(r + r, 16),
                            parseInt(g + g, 16),
                            parseInt(b + b, 16),
                            parseInt(a + a, 16) / 255,
                        );
                    }
                    if (value.value.length === 6) {
                        var r = value.value.substring(0, 2);
                        var g = value.value.substring(2, 4);
                        var b = value.value.substring(4, 6);
                        return pack(
                            parseInt(r, 16),
                            parseInt(g, 16),
                            parseInt(b, 16),
                            1,
                        );
                    }
                    if (value.value.length === 8) {
                        var r = value.value.substring(0, 2);
                        var g = value.value.substring(2, 4);
                        var b = value.value.substring(4, 6);
                        var a = value.value.substring(6, 8);
                        return pack(
                            parseInt(r, 16),
                            parseInt(g, 16),
                            parseInt(b, 16),
                            parseInt(a, 16) / 255,
                        );
                    }
                }
                if (value.type === 20 /* IDENT_TOKEN */) {
                    var namedColor = COLORS[value.value.toUpperCase()];
                    if (typeof namedColor !== "undefined") {
                        return namedColor;
                    }
                }
                return COLORS.TRANSPARENT;
            },
        };
        var isTransparent = function (color) {
            return (0xff & color) === 0;
        };
        var asString = function (color) {
            var alpha = 0xff & color;
            var blue = 0xff & (color >> 8);
            var green = 0xff & (color >> 16);
            var red = 0xff & (color >> 24);
            return alpha < 255
                ? "rgba(" +
                      red +
                      "," +
                      green +
                      "," +
                      blue +
                      "," +
                      alpha / 255 +
                      ")"
                : "rgb(" + red + "," + green + "," + blue + ")";
        };
        var pack = function (r, g, b, a) {
            return (
                ((r << 24) |
                    (g << 16) |
                    (b << 8) |
                    (Math.round(a * 255) << 0)) >>>
                0
            );
        };
        var getTokenColorValue = function (token, i) {
            if (token.type === 17 /* NUMBER_TOKEN */) {
                return token.number;
            }
            if (token.type === 16 /* PERCENTAGE_TOKEN */) {
                var max = i === 3 ? 1 : 255;
                return i === 3
                    ? (token.number / 100) * max
                    : Math.round((token.number / 100) * max);
            }
            return 0;
        };
        var rgb = function (_context, args) {
            var tokens = args.filter(nonFunctionArgSeparator);
            if (tokens.length === 3) {
                var _a = tokens.map(getTokenColorValue),
                    r = _a[0],
                    g = _a[1],
                    b = _a[2];
                return pack(r, g, b, 1);
            }
            if (tokens.length === 4) {
                var _b = tokens.map(getTokenColorValue),
                    r = _b[0],
                    g = _b[1],
                    b = _b[2],
                    a = _b[3];
                return pack(r, g, b, a);
            }
            return 0;
        };
        function hue2rgb(t1, t2, hue) {
            if (hue < 0) {
                hue += 1;
            }
            if (hue >= 1) {
                hue -= 1;
            }
            if (hue < 1 / 6) {
                return (t2 - t1) * hue * 6 + t1;
            } else if (hue < 1 / 2) {
                return t2;
            } else if (hue < 2 / 3) {
                return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
            } else {
                return t1;
            }
        }
        var hsl = function (context, args) {
            var tokens = args.filter(nonFunctionArgSeparator);
            var hue = tokens[0],
                saturation = tokens[1],
                lightness = tokens[2],
                alpha = tokens[3];
            var h =
                (hue.type === 17 /* NUMBER_TOKEN */
                    ? deg(hue.number)
                    : angle.parse(context, hue)) /
                (Math.PI * 2);
            var s = isLengthPercentage(saturation)
                ? saturation.number / 100
                : 0;
            var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
            var a =
                typeof alpha !== "undefined" && isLengthPercentage(alpha)
                    ? getAbsoluteValue(alpha, 1)
                    : 1;
            if (s === 0) {
                return pack(l * 255, l * 255, l * 255, 1);
            }
            var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
            var t1 = l * 2 - t2;
            var r = hue2rgb(t1, t2, h + 1 / 3);
            var g = hue2rgb(t1, t2, h);
            var b = hue2rgb(t1, t2, h - 1 / 3);
            return pack(r * 255, g * 255, b * 255, a);
        };
        var SUPPORTED_COLOR_FUNCTIONS = {
            hsl: hsl,
            hsla: hsl,
            rgb: rgb,
            rgba: rgb,
        };
        var parseColor = function (context, value) {
            return color$1.parse(
                context,
                Parser.create(value).parseComponentValue(),
            );
        };
        var COLORS = {
            ALICEBLUE: 0xf0f8ffff,
            ANTIQUEWHITE: 0xfaebd7ff,
            AQUA: 0x00ffffff,
            AQUAMARINE: 0x7fffd4ff,
            AZURE: 0xf0ffffff,
            BEIGE: 0xf5f5dcff,
            BISQUE: 0xffe4c4ff,
            BLACK: 0x000000ff,
            BLANCHEDALMOND: 0xffebcdff,
            BLUE: 0x0000ffff,
            BLUEVIOLET: 0x8a2be2ff,
            BROWN: 0xa52a2aff,
            BURLYWOOD: 0xdeb887ff,
            CADETBLUE: 0x5f9ea0ff,
            CHARTREUSE: 0x7fff00ff,
            CHOCOLATE: 0xd2691eff,
            CORAL: 0xff7f50ff,
            CORNFLOWERBLUE: 0x6495edff,
            CORNSILK: 0xfff8dcff,
            CRIMSON: 0xdc143cff,
            CYAN: 0x00ffffff,
            DARKBLUE: 0x00008bff,
            DARKCYAN: 0x008b8bff,
            DARKGOLDENROD: 0xb886bbff,
            DARKGRAY: 0xa9a9a9ff,
            DARKGREEN: 0x006400ff,
            DARKGREY: 0xa9a9a9ff,
            DARKKHAKI: 0xbdb76bff,
            DARKMAGENTA: 0x8b008bff,
            DARKOLIVEGREEN: 0x556b2fff,
            DARKORANGE: 0xff8c00ff,
            DARKORCHID: 0x9932ccff,
            DARKRED: 0x8b0000ff,
            DARKSALMON: 0xe9967aff,
            DARKSEAGREEN: 0x8fbc8fff,
            DARKSLATEBLUE: 0x483d8bff,
            DARKSLATEGRAY: 0x2f4f4fff,
            DARKSLATEGREY: 0x2f4f4fff,
            DARKTURQUOISE: 0x00ced1ff,
            DARKVIOLET: 0x9400d3ff,
            DEEPPINK: 0xff1493ff,
            DEEPSKYBLUE: 0x00bfffff,
            DIMGRAY: 0x696969ff,
            DIMGREY: 0x696969ff,
            DODGERBLUE: 0x1e90ffff,
            FIREBRICK: 0xb22222ff,
            FLORALWHITE: 0xfffaf0ff,
            FORESTGREEN: 0x228b22ff,
            FUCHSIA: 0xff00ffff,
            GAINSBORO: 0xdcdcdcff,
            GHOSTWHITE: 0xf8f8ffff,
            GOLD: 0xffd700ff,
            GOLDENROD: 0xdaa520ff,
            GRAY: 0x808080ff,
            GREEN: 0x008000ff,
            GREENYELLOW: 0xadff2fff,
            GREY: 0x808080ff,
            HONEYDEW: 0xf0fff0ff,
            HOTPINK: 0xff69b4ff,
            INDIANRED: 0xcd5c5cff,
            INDIGO: 0x4b0082ff,
            IVORY: 0xfffff0ff,
            KHAKI: 0xf0e68cff,
            LAVENDER: 0xe6e6faff,
            LAVENDERBLUSH: 0xfff0f5ff,
            LAWNGREEN: 0x7cfc00ff,
            LEMONCHIFFON: 0xfffacdff,
            LIGHTBLUE: 0xadd8e6ff,
            LIGHTCORAL: 0xf08080ff,
            LIGHTCYAN: 0xe0ffffff,
            LIGHTGOLDENRODYELLOW: 0xfafad2ff,
            LIGHTGRAY: 0xd3d3d3ff,
            LIGHTGREEN: 0x90ee90ff,
            LIGHTGREY: 0xd3d3d3ff,
            LIGHTPINK: 0xffb6c1ff,
            LIGHTSALMON: 0xffa07aff,
            LIGHTSEAGREEN: 0x20b2aaff,
            LIGHTSKYBLUE: 0x87cefaff,
            LIGHTSLATEGRAY: 0x778899ff,
            LIGHTSLATEGREY: 0x778899ff,
            LIGHTSTEELBLUE: 0xb0c4deff,
            LIGHTYELLOW: 0xffffe0ff,
            LIME: 0x00ff00ff,
            LIMEGREEN: 0x32cd32ff,
            LINEN: 0xfaf0e6ff,
            MAGENTA: 0xff00ffff,
            MAROON: 0x800000ff,
            MEDIUMAQUAMARINE: 0x66cdaaff,
            MEDIUMBLUE: 0x0000cdff,
            MEDIUMORCHID: 0xba55d3ff,
            MEDIUMPURPLE: 0x9370dbff,
            MEDIUMSEAGREEN: 0x3cb371ff,
            MEDIUMSLATEBLUE: 0x7b68eeff,
            MEDIUMSPRINGGREEN: 0x00fa9aff,
            MEDIUMTURQUOISE: 0x48d1ccff,
            MEDIUMVIOLETRED: 0xc71585ff,
            MIDNIGHTBLUE: 0x191970ff,
            MINTCREAM: 0xf5fffaff,
            MISTYROSE: 0xffe4e1ff,
            MOCCASIN: 0xffe4b5ff,
            NAVAJOWHITE: 0xffdeadff,
            NAVY: 0x000080ff,
            OLDLACE: 0xfdf5e6ff,
            OLIVE: 0x808000ff,
            OLIVEDRAB: 0x6b8e23ff,
            ORANGE: 0xffa500ff,
            ORANGERED: 0xff4500ff,
            ORCHID: 0xda70d6ff,
            PALEGOLDENROD: 0xeee8aaff,
            PALEGREEN: 0x98fb98ff,
            PALETURQUOISE: 0xafeeeeff,
            PALEVIOLETRED: 0xdb7093ff,
            PAPAYAWHIP: 0xffefd5ff,
            PEACHPUFF: 0xffdab9ff,
            PERU: 0xcd853fff,
            PINK: 0xffc0cbff,
            PLUM: 0xdda0ddff,
            POWDERBLUE: 0xb0e0e6ff,
            PURPLE: 0x800080ff,
            REBECCAPURPLE: 0x663399ff,
            RED: 0xff0000ff,
            ROSYBROWN: 0xbc8f8fff,
            ROYALBLUE: 0x4169e1ff,
            SADDLEBROWN: 0x8b4513ff,
            SALMON: 0xfa8072ff,
            SANDYBROWN: 0xf4a460ff,
            SEAGREEN: 0x2e8b57ff,
            SEASHELL: 0xfff5eeff,
            SIENNA: 0xa0522dff,
            SILVER: 0xc0c0c0ff,
            SKYBLUE: 0x87ceebff,
            SLATEBLUE: 0x6a5acdff,
            SLATEGRAY: 0x708090ff,
            SLATEGREY: 0x708090ff,
            SNOW: 0xfffafaff,
            SPRINGGREEN: 0x00ff7fff,
            STEELBLUE: 0x4682b4ff,
            TAN: 0xd2b48cff,
            TEAL: 0x008080ff,
            THISTLE: 0xd8bfd8ff,
            TOMATO: 0xff6347ff,
            TRANSPARENT: 0x00000000,
            TURQUOISE: 0x40e0d0ff,
            VIOLET: 0xee82eeff,
            WHEAT: 0xf5deb3ff,
            WHITE: 0xffffffff,
            WHITESMOKE: 0xf5f5f5ff,
            YELLOW: 0xffff00ff,
            YELLOWGREEN: 0x9acd32ff,
        };
        var backgroundClip = {
            name: "background-clip",
            initialValue: "border-box",
            prefix: false,
            type: 1 /* LIST */,
            parse: function (_context, tokens) {
                return tokens.map(function (token) {
                    if (isIdentToken(token)) {
                        switch (token.value) {
                            case "padding-box":
                                return 1 /* PADDING_BOX */;
                            case "content-box":
                                return 2 /* CONTENT_BOX */;
                        }
                    }

                    return 0 /* BORDER_BOX */;
                });
            },
        };

        var backgroundColor = {
            name: "background-color",
            initialValue: "transparent",
            prefix: false,
            type: 3 /* TYPE_VALUE */,
            format: "color",
        };
        var parseColorStop = function (context, args) {
            var color = color$1.parse(context, args[0]);
            var stop = args[1];
            return stop && isLengthPercentage(stop)
                ? {
                      color: color,
                      stop: stop,
                  }
                : {
                      color: color,
                      stop: null,
                  };
        };
        var processColorStops = function (stops, lineLength) {
            var first = stops[0];
            var last = stops[stops.length - 1];
            if (first.stop === null) {
                first.stop = ZERO_LENGTH;
            }
            if (last.stop === null) {
                last.stop = HUNDRED_PERCENT;
            }
            var processStops = [];
            var previous = 0;
            for (var i = 0; i < stops.length; i++) {
                var stop_1 = stops[i].stop;
                if (stop_1 !== null) {
                    var absoluteValue = getAbsoluteValue(stop_1, lineLength);
                    if (absoluteValue > previous) {
                        processStops.push(absoluteValue);
                    } else {
                        processStops.push(previous);
                    }
                    previous = absoluteValue;
                } else {
                    processStops.push(null);
                }
            }
            var gapBegin = null;
            for (var i = 0; i < processStops.length; i++) {
                var stop_2 = processStops[i];
                if (stop_2 === null) {
                    if (gapBegin === null) {
                        gapBegin = i;
                    }
                } else if (gapBegin !== null) {
                    var gapLength = i - gapBegin;
                    var beforeGap = processStops[gapBegin - 1];
                    var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
                    for (var g = 1; g <= gapLength; g++) {
                        processStops[gapBegin + g - 1] = gapValue * g;
                    }
                    gapBegin = null;
                }
            }
            return stops.map(function (_a, i) {
                var color = _a.color;
                return {
                    color: color,
                    stop: Math.max(
                        Math.min(1, processStops[i] / lineLength),
                        0,
                    ),
                };
            });
        };
        var getAngleFromCorner = function (corner, width, height) {
            var centerX = width / 2;
            var centerY = height / 2;
            var x = getAbsoluteValue(corner[0], width) - centerX;
            var y = centerY - getAbsoluteValue(corner[1], height);
            return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
        };
        var calculateGradientDirection = function (angle, width, height) {
            var radian =
                typeof angle === "number"
                    ? angle
                    : getAngleFromCorner(angle, width, height);
            var lineLength =
                Math.abs(width * Math.sin(radian)) +
                Math.abs(height * Math.cos(radian));
            var halfWidth = width / 2;
            var halfHeight = height / 2;
            var halfLineLength = lineLength / 2;
            var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
            var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
            return [
                lineLength,
                halfWidth - xDiff,
                halfWidth + xDiff,
                halfHeight - yDiff,
                halfHeight + yDiff,
            ];
        };
        var distance = function (a, b) {
            return Math.sqrt(a * a + b * b);
        };
        var findCorner = function (width, height, x, y, closest) {
            var corners = [
                [0, 0],
                [0, height],
                [width, 0],
                [width, height],
            ];
            return corners.reduce(
                function (stat, corner) {
                    var cx = corner[0],
                        cy = corner[1];
                    var d = distance(x - cx, y - cy);
                    if (
                        closest
                            ? d < stat.optimumDistance
                            : d > stat.optimumDistance
                    ) {
                        return {
                            optimumCorner: corner,
                            optimumDistance: d,
                        };
                    }
                    return stat;
                },
                {
                    optimumDistance: closest ? Infinity : -Infinity,
                    optimumCorner: null,
                },
            ).optimumCorner;
        };
        var calculateRadius = function (gradient, x, y, width, height) {
            var rx = 0;
            var ry = 0;
            switch (gradient.size) {
                case 0 /* CLOSEST_SIDE */:
                    // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
                    // If the shape is an ellipse, it exactly meets the closest side in each dimension.
                    if (gradient.shape === 0 /* CIRCLE */) {
                        rx = ry = Math.min(
                            Math.abs(x),
                            Math.abs(x - width),
                            Math.abs(y),
                            Math.abs(y - height),
                        );
                    } else if (gradient.shape === 1 /* ELLIPSE */) {
                        rx = Math.min(Math.abs(x), Math.abs(x - width));
                        ry = Math.min(Math.abs(y), Math.abs(y - height));
                    }
                    break;
                case 2 /* CLOSEST_CORNER */:
                    // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
                    // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
                    if (gradient.shape === 0 /* CIRCLE */) {
                        rx = ry = Math.min(
                            distance(x, y),
                            distance(x, y - height),
                            distance(x - width, y),
                            distance(x - width, y - height),
                        );
                    } else if (gradient.shape === 1 /* ELLIPSE */) {
                        // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                        var c =
                            Math.min(Math.abs(y), Math.abs(y - height)) /
                            Math.min(Math.abs(x), Math.abs(x - width));
                        var _a = findCorner(width, height, x, y, true),
                            cx = _a[0],
                            cy = _a[1];
                        rx = distance(cx - x, (cy - y) / c);
                        ry = c * rx;
                    }
                    break;
                case 1 /* FARTHEST_SIDE */:
                    // Same as closest-side, except the ending shape is sized based on the farthest side(s)
                    if (gradient.shape === 0 /* CIRCLE */) {
                        rx = ry = Math.max(
                            Math.abs(x),
                            Math.abs(x - width),
                            Math.abs(y),
                            Math.abs(y - height),
                        );
                    } else if (gradient.shape === 1 /* ELLIPSE */) {
                        rx = Math.max(Math.abs(x), Math.abs(x - width));
                        ry = Math.max(Math.abs(y), Math.abs(y - height));
                    }
                    break;
                case 3 /* FARTHEST_CORNER */:
                    // Same as closest-corner, except the ending shape is sized based on the farthest corner.
                    // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
                    if (gradient.shape === 0 /* CIRCLE */) {
                        rx = ry = Math.max(
                            distance(x, y),
                            distance(x, y - height),
                            distance(x - width, y),
                            distance(x - width, y - height),
                        );
                    } else if (gradient.shape === 1 /* ELLIPSE */) {
                        // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                        var c =
                            Math.max(Math.abs(y), Math.abs(y - height)) /
                            Math.max(Math.abs(x), Math.abs(x - width));
                        var _b = findCorner(width, height, x, y, false),
                            cx = _b[0],
                            cy = _b[1];
                        rx = distance(cx - x, (cy - y) / c);
                        ry = c * rx;
                    }
                    break;
            }
            if (Array.isArray(gradient.size)) {
                rx = getAbsoluteValue(gradient.size[0], width);
                ry =
                    gradient.size.length === 2
                        ? getAbsoluteValue(gradient.size[1], height)
                        : rx;
            }
            return [rx, ry];
        };
        var linearGradient = function (context, tokens) {
            var angle$1 = deg(180);
            var stops = [];
            parseFunctionArgs(tokens).forEach(function (arg, i) {
                if (i === 0) {
                    var firstToken = arg[0];
                    if (
                        firstToken.type === 20 /* IDENT_TOKEN */ &&
                        firstToken.value === "to"
                    ) {
                        angle$1 = parseNamedSide(arg);
                        return;
                    } else if (isAngle(firstToken)) {
                        angle$1 = angle.parse(context, firstToken);
                        return;
                    }
                }
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            });
            return {
                angle: angle$1,
                stops: stops,
                type: 1 /* LINEAR_GRADIENT */,
            };
        };

        var prefixLinearGradient = function (context, tokens) {
            var angle$1 = deg(180);
            var stops = [];
            parseFunctionArgs(tokens).forEach(function (arg, i) {
                if (i === 0) {
                    var firstToken = arg[0];
                    if (
                        firstToken.type === 20 /* IDENT_TOKEN */ &&
                        ["top", "left", "right", "bottom"].indexOf(
                            firstToken.value,
                        ) !== -1
                    ) {
                        angle$1 = parseNamedSide(arg);
                        return;
                    } else if (isAngle(firstToken)) {
                        angle$1 =
                            (angle.parse(context, firstToken) + deg(270)) %
                            deg(360);
                        return;
                    }
                }
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            });
            return {
                angle: angle$1,
                stops: stops,
                type: 1 /* LINEAR_GRADIENT */,
            };
        };

        var webkitGradient = function (context, tokens) {
            var angle = deg(180);
            var stops = [];
            var type = 1; /* LINEAR_GRADIENT */
            var shape = 0; /* CIRCLE */
            var size = 3; /* FARTHEST_CORNER */
            var position = [];
            parseFunctionArgs(tokens).forEach(function (arg, i) {
                var firstToken = arg[0];
                if (i === 0) {
                    if (
                        isIdentToken(firstToken) &&
                        firstToken.value === "linear"
                    ) {
                        type = 1 /* LINEAR_GRADIENT */;
                        return;
                    } else if (
                        isIdentToken(firstToken) &&
                        firstToken.value === "radial"
                    ) {
                        type = 2 /* RADIAL_GRADIENT */;
                        return;
                    }
                }
                if (firstToken.type === 18 /* FUNCTION */) {
                    if (firstToken.name === "from") {
                        var color = color$1.parse(
                            context,
                            firstToken.values[0],
                        );
                        stops.push({
                            stop: ZERO_LENGTH,
                            color: color,
                        });
                    } else if (firstToken.name === "to") {
                        var color = color$1.parse(
                            context,
                            firstToken.values[0],
                        );
                        stops.push({
                            stop: HUNDRED_PERCENT,
                            color: color,
                        });
                    } else if (firstToken.name === "color-stop") {
                        var values = firstToken.values.filter(
                            nonFunctionArgSeparator,
                        );
                        if (values.length === 2) {
                            var color = color$1.parse(context, values[1]);
                            var stop_1 = values[0];
                            if (isNumberToken(stop_1)) {
                                stops.push({
                                    stop: {
                                        type: 16 /* PERCENTAGE_TOKEN */,
                                        number: stop_1.number * 100,
                                        flags: stop_1.flags,
                                    },
                                    color: color,
                                });
                            }
                        }
                    }
                }
            });
            return type === 1 /* LINEAR_GRADIENT */
                ? {
                      angle: (angle + deg(180)) % deg(360),
                      stops: stops,
                      type: type,
                  }
                : {
                      size: size,
                      shape: shape,
                      stops: stops,
                      position: position,
                      type: type,
                  };
        };
        var CLOSEST_SIDE = "closest-side";
        var FARTHEST_SIDE = "farthest-side";
        var CLOSEST_CORNER = "closest-corner";
        var FARTHEST_CORNER = "farthest-corner";
        var CIRCLE = "circle";
        var ELLIPSE = "ellipse";
        var COVER = "cover";
        var CONTAIN = "contain";
        var radialGradient = function (context, tokens) {
            var shape = 0; /* CIRCLE */
            var size = 3; /* FARTHEST_CORNER */
            var stops = [];
            var position = [];
            parseFunctionArgs(tokens).forEach(function (arg, i) {
                var isColorStop = true;
                if (i === 0) {
                    var isAtPosition_1 = false;
                    isColorStop = arg.reduce(function (acc, token) {
                        if (isAtPosition_1) {
                            if (isIdentToken(token)) {
                                switch (token.value) {
                                    case "center":
                                        position.push(FIFTY_PERCENT);
                                        return acc;
                                    case "top":
                                    case "left":
                                        position.push(ZERO_LENGTH);
                                        return acc;
                                    case "right":
                                    case "bottom":
                                        position.push(HUNDRED_PERCENT);
                                        return acc;
                                }
                            } else if (
                                isLengthPercentage(token) ||
                                isLength(token)
                            ) {
                                position.push(token);
                            }
                        } else if (isIdentToken(token)) {
                            switch (token.value) {
                                case CIRCLE:
                                    shape = 0 /* CIRCLE */;
                                    return false;
                                case ELLIPSE:
                                    shape = 1 /* ELLIPSE */;
                                    return false;
                                case "at":
                                    isAtPosition_1 = true;
                                    return false;
                                case CLOSEST_SIDE:
                                    size = 0 /* CLOSEST_SIDE */;
                                    return false;
                                case COVER:
                                case FARTHEST_SIDE:
                                    size = 1 /* FARTHEST_SIDE */;
                                    return false;
                                case CONTAIN:
                                case CLOSEST_CORNER:
                                    size = 2 /* CLOSEST_CORNER */;
                                    return false;
                                case FARTHEST_CORNER:
                                    size = 3 /* FARTHEST_CORNER */;
                                    return false;
                            }
                        } else if (
                            isLength(token) ||
                            isLengthPercentage(token)
                        ) {
                            if (!Array.isArray(size)) {
                                size = [];
                            }
                            size.push(token);
                            return false;
                        }
                        return acc;
                    }, isColorStop);
                }
                if (isColorStop) {
                    var colorStop = parseColorStop(context, arg);
                    stops.push(colorStop);
                }
            });
            return {
                size: size,
                shape: shape,
                stops: stops,
                position: position,
                type: 2 /* RADIAL_GRADIENT */,
            };
        };

        var prefixRadialGradient = function (context, tokens) {
            var shape = 0; /* CIRCLE */
            var size = 3; /* FARTHEST_CORNER */
            var stops = [];
            var position = [];
            parseFunctionArgs(tokens).forEach(function (arg, i) {
                var isColorStop = true;
                if (i === 0) {
                    isColorStop = arg.reduce(function (acc, token) {
                        if (isIdentToken(token)) {
                            switch (token.value) {
                                case "center":
                                    position.push(FIFTY_PERCENT);
                                    return false;
                                case "top":
                                case "left":
                                    position.push(ZERO_LENGTH);
                                    return false;
                                case "right":
                                case "bottom":
                                    position.push(HUNDRED_PERCENT);
                                    return false;
                            }
                        } else if (
                            isLengthPercentage(token) ||
                            isLength(token)
                        ) {
                            position.push(token);
                            return false;
                        }
                        return acc;
                    }, isColorStop);
                } else if (i === 1) {
                    isColorStop = arg.reduce(function (acc, token) {
                        if (isIdentToken(token)) {
                            switch (token.value) {
                                case CIRCLE:
                                    shape = 0 /* CIRCLE */;
                                    return false;
                                case ELLIPSE:
                                    shape = 1 /* ELLIPSE */;
                                    return false;
                                case CONTAIN:
                                case CLOSEST_SIDE:
                                    size = 0 /* CLOSEST_SIDE */;
                                    return false;
                                case FARTHEST_SIDE:
                                    size = 1 /* FARTHEST_SIDE */;
                                    return false;
                                case CLOSEST_CORNER:
                                    size = 2 /* CLOSEST_CORNER */;
                                    return false;
                                case COVER:
                                case FARTHEST_CORNER:
                                    size = 3 /* FARTHEST_CORNER */;
                                    return false;
                            }
                        } else if (
                            isLength(token) ||
                            isLengthPercentage(token)
                        ) {
                            if (!Array.isArray(size)) {
                                size = [];
                            }
                            size.push(token);
                            return false;
                        }
                        return acc;
                    }, isColorStop);
                }
                if (isColorStop) {
                    var colorStop = parseColorStop(context, arg);
                    stops.push(colorStop);
                }
            });
            return {
                size: size,
                shape: shape,
                stops: stops,
                position: position,
                type: 2 /* RADIAL_GRADIENT */,
            };
        };

        var isLinearGradient = function (background) {
            return background.type === 1 /* LINEAR_GRADIENT */;
        };

        var isRadialGradient = function (background) {
            return background.type === 2 /* RADIAL_GRADIENT */;
        };

        var image = {
            name: "image",
            parse: function (context, value) {
                if (value.type === 22 /* URL_TOKEN */) {
                    var image_1 = {
                        url: value.value,
                        type: 0 /* URL */,
                    };
                    context.cache.addImage(value.value);
                    return image_1;
                }
                if (value.type === 18 /* FUNCTION */) {
                    var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
                    if (typeof imageFunction === "undefined") {
                        throw new Error(
                            'Attempting to parse an unsupported image function "' +
                                value.name +
                                '"',
                        );
                    }
                    return imageFunction(context, value.values);
                }
                throw new Error("Unsupported image type " + value.type);
            },
        };
        function isSupportedImage(value) {
            return (
                !(
                    value.type === 20 /* IDENT_TOKEN */ &&
                    value.value === "none"
                ) &&
                (value.type !== 18 /* FUNCTION */ ||
                    !!SUPPORTED_IMAGE_FUNCTIONS[value.name])
            );
        }
        var SUPPORTED_IMAGE_FUNCTIONS = {
            "linear-gradient": linearGradient,
            "-moz-linear-gradient": prefixLinearGradient,
            "-ms-linear-gradient": prefixLinearGradient,
            "-o-linear-gradient": prefixLinearGradient,
            "-webkit-linear-gradient": prefixLinearGradient,
            "radial-gradient": radialGradient,
            "-moz-radial-gradient": prefixRadialGradient,
            "-ms-radial-gradient": prefixRadialGradient,
            "-o-radial-gradient": prefixRadialGradient,
            "-webkit-radial-gradient": prefixRadialGradient,
            "-webkit-gradient": webkitGradient,
        };
        var backgroundImage = {
            name: "background-image",
            initialValue: "none",
            type: 1 /* LIST */,
            prefix: false,
            parse: function (context, tokens) {
                if (tokens.length === 0) {
                    return [];
                }
                var first = tokens[0];
                if (
                    first.type === 20 /* IDENT_TOKEN */ &&
                    first.value === "none"
                ) {
                    return [];
                }
                return tokens
                    .filter(function (value) {
                        return (
                            nonFunctionArgSeparator(value) &&
                            isSupportedImage(value)
                        );
                    })
                    .map(function (value) {
                        return image.parse(context, value);
                    });
            },
        };
        var backgroundOrigin = {
            name: "background-origin",
            initialValue: "border-box",
            prefix: false,
            type: 1 /* LIST */,
            parse: function (_context, tokens) {
                return tokens.map(function (token) {
                    if (isIdentToken(token)) {
                        switch (token.value) {
                            case "padding-box":
                                return 1 /* PADDING_BOX */;
                            case "content-box":
                                return 2 /* CONTENT_BOX */;
                        }
                    }

                    return 0 /* BORDER_BOX */;
                });
            },
        };

        var backgroundPosition = {
            name: "background-position",
            initialValue: "0% 0%",
            type: 1 /* LIST */,
            prefix: false,
            parse: function (_context, tokens) {
                return parseFunctionArgs(tokens)
                    .map(function (values) {
                        return values.filter(isLengthPercentage);
                    })
                    .map(parseLengthPercentageTuple);
            },
        };
        var backgroundRepeat = {
            name: "background-repeat",
            initialValue: "repeat",
            prefix: false,
            type: 1 /* LIST */,
            parse: function (_context, tokens) {
                return parseFunctionArgs(tokens)
                    .map(function (values) {
                        return values
                            .filter(isIdentToken)
                            .map(function (token) {
                                return token.value;
                            })
                            .join(" ");
                    })
                    .map(parseBackgroundRepeat);
            },
        };
        var parseBackgroundRepeat = function (value) {
            switch (value) {
                case "no-repeat":
                    return 1 /* NO_REPEAT */;
                case "repeat-x":
                case "repeat no-repeat":
                    return 2 /* REPEAT_X */;
                case "repeat-y":
                case "no-repeat repeat":
                    return 3 /* REPEAT_Y */;
                case "repeat":
                default:
                    return 0 /* REPEAT */;
            }
        };

        var BACKGROUND_SIZE;
        (function (BACKGROUND_SIZE) {
            BACKGROUND_SIZE["AUTO"] = "auto";
            BACKGROUND_SIZE["CONTAIN"] = "contain";
            BACKGROUND_SIZE["COVER"] = "cover";
        })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
        var backgroundSize = {
            name: "background-size",
            initialValue: "0",
            prefix: false,
            type: 1 /* LIST */,
            parse: function (_context, tokens) {
                return parseFunctionArgs(tokens).map(function (values) {
                    return values.filter(isBackgroundSizeInfoToken);
                });
            },
        };
        var isBackgroundSizeInfoToken = function (value) {
            return isIdentToken(value) || isLengthPercentage(value);
        };
        var borderColorForSide = function (side) {
            return {
                name: "border-" + side + "-color",
                initialValue: "transparent",
                prefix: false,
                type: 3 /* TYPE_VALUE */,
                format: "color",
            };
        };
        var borderTopColor = borderColorForSide("top");
        var borderRightColor = borderColorForSide("right");
        var borderBottomColor = borderColorForSide("bottom");
        var borderLeftColor = borderColorForSide("left");
        var borderRadiusForSide = function (side) {
            return {
                name: "border-radius-" + side,
                initialValue: "0 0",
                prefix: false,
                type: 1 /* LIST */,
                parse: function (_context, tokens) {
                    return parseLengthPercentageTuple(
                        tokens.filter(isLengthPercentage),
                    );
                },
            };
        };
        var borderTopLeftRadius = borderRadiusForSide("top-left");
        var borderTopRightRadius = borderRadiusForSide("top-right");
        var borderBottomRightRadius = borderRadiusForSide("bottom-right");
        var borderBottomLeftRadius = borderRadiusForSide("bottom-left");
        var borderStyleForSide = function (side) {
            return {
                name: "border-" + side + "-style",
                initialValue: "solid",
                prefix: false,
                type: 2 /* IDENT_VALUE */,
                parse: function (_context, style) {
                    switch (style) {
                        case "none":
                            return 0 /* NONE */;
                        case "dashed":
                            return 2 /* DASHED */;
                        case "dotted":
                            return 3 /* DOTTED */;
                        case "double":
                            return 4 /* DOUBLE */;
                    }

                    return 1 /* SOLID */;
                },
            };
        };

        var borderTopStyle = borderStyleForSide("top");
        var borderRightStyle = borderStyleForSide("right");
        var borderBottomStyle = borderStyleForSide("bottom");
        var borderLeftStyle = borderStyleForSide("left");
        var borderWidthForSide = function (side) {
            return {
                name: "border-" + side + "-width",
                initialValue: "0",
                type: 0 /* VALUE */,
                prefix: false,
                parse: function (_context, token) {
                    if (isDimensionToken(token)) {
                        return token.number;
                    }
                    return 0;
                },
            };
        };
        var borderTopWidth = borderWidthForSide("top");
        var borderRightWidth = borderWidthForSide("right");
        var borderBottomWidth = borderWidthForSide("bottom");
        var borderLeftWidth = borderWidthForSide("left");
        var color = {
            name: "color",
            initialValue: "transparent",
            prefix: false,
            type: 3 /* TYPE_VALUE */,
            format: "color",
        };
        var direction = {
            name: "direction",
            initialValue: "ltr",
            prefix: false,
            type: 2 /* IDENT_VALUE */,
            parse: function (_context, direction) {
                switch (direction) {
                    case "rtl":
                        return 1 /* RTL */;
                    case "ltr":
                    default:
                        return 0 /* LTR */;
                }
            },
        };

        var display = {
            name: "display",
            initialValue: "inline-block",
            prefix: false,
            type: 1 /* LIST */,
            parse: function (_context, tokens) {
                return tokens.filter(isIdentToken).reduce(function (
                    bit,
                    token,
                ) {
                    return bit | parseDisplayValue(token.value);
                }, 0 /* NONE */);
            },
        };

        var parseDisplayValue = function (display) {
            switch (display) {
                case "block":
                case "-webkit-box":
                    return 2 /* BLOCK */;
                case "inline":
                    return 4 /* INLINE */;
                case "run-in":
                    return 8 /* RUN_IN */;
                case "flow":
                    return 16 /* FLOW */;
                case "flow-root":
                    return 32 /* FLOW_ROOT */;
                case "table":
                    return 64 /* TABLE */;
                case "flex":
                case "-webkit-flex":
                    return 128 /* FLEX */;
                case "grid":
                case "-ms-grid":
                    return 256 /* GRID */;
                case "ruby":
                    return 512 /* RUBY */;
                case "subgrid":
                    return 1024 /* SUBGRID */;
                case "list-item":
                    return 2048 /* LIST_ITEM */;
                case "table-row-group":
                    return 4096 /* TABLE_ROW_GROUP */;
                case "table-header-group":
                    return 8192 /* TABLE_HEADER_GROUP */;
                case "table-footer-group":
                    return 16384 /* TABLE_FOOTER_GROUP */;
                case "table-row":
                    return 32768 /* TABLE_ROW */;
                case "table-cell":
                    return 65536 /* TABLE_CELL */;
                case "table-column-group":
                    return 131072 /* TABLE_COLUMN_GROUP */;
                case "table-column":
                    return 262144 /* TABLE_COLUMN */;
                case "table-caption":
                    return 524288 /* TABLE_CAPTION */;
                case "ruby-base":
                    return 1048576 /* RUBY_BASE */;
                case "ruby-text":
                    return 2097152 /* RUBY_TEXT */;
                case "ruby-base-container":
                    return 4194304 /* RUBY_BASE_CONTAINER */;
                case "ruby-text-container":
                    return 8388608 /* RUBY_TEXT_CONTAINER */;
                case "contents":
                    return 16777216 /* CONTENTS */;
                case "inline-block":
                    return 33554432 /* INLINE_BLOCK */;
                case "inline-list-item":
                    return 67108864 /* INLINE_LIST_ITEM */;
                case "inline-table":
                    return 134217728 /* INLINE_TABLE */;
                case "inline-flex":
                    return 268435456 /* INLINE_FLEX */;
                case "inline-grid":
                    return 536870912 /* INLINE_GRID */;
            }

            return 0 /* NONE */;
        };

        var float = {
            name: "float",
            initialValue: "none",
            prefix: false,
            type: 2 /* IDENT_VALUE */,
            parse: function (_context, float) {
                switch (float) {
                    case "left":
                        return 1 /* LEFT */;
                    case "right":
                        return 2 /* RIGHT */;
                    case "inline-start":
                        return 3 /* INLINE_START */;
                    case "inline-end":
                        return 4 /* INLINE_END */;
                }

                return 0 /* NONE */;
            },
        };

        var letterSpacing = {
            name: "letter-spacing",
            initialValue: "0",
            prefix: false,
            type: 0 /* VALUE */,
            parse: function (_context, token) {
                if (
                    token.type === 20 /* IDENT_TOKEN */ &&
                    token.value === "normal"
                ) {
                    return 0;
                }
                if (token.type === 17 /* NUMBER_TOKEN */) {
                    return token.number;
                }
                if (token.type === 15 /* DIMENSION_TOKEN */) {
                    return token.number;
                }
                return 0;
            },
        };
        var LINE_BREAK;
        (function (LINE_BREAK) {
            LINE_BREAK["NORMAL"] = "normal";
            LINE_BREAK["STRICT"] = "strict";
        })(LINE_BREAK || (LINE_BREAK = {}));
        var lineBreak = {
            name: "line-break",
            initialValue: "normal",
            prefix: false,
            type: 2 /* IDENT_VALUE */,
            parse: function (_context, lineBreak) {
                switch (lineBreak) {
                    case "strict":
                        return LINE_BREAK.STRICT;
                    case "normal":
                    default:
                        return LINE_BREAK.NORMAL;
                }
            },
        };
        var lineHeight = {
            name: "line-height",
            initialValue: "normal",
            prefix: false,
            type: 4 /* TOKEN_VALUE */,
        };

        var computeLineHeight = function (token, fontSize) {
            if (isIdentToken(token) && token.value === "normal") {
                return 1.2 * fontSize;
            } else if (token.type === 17 /* NUMBER_TOKEN */) {
                return fontSize * token.number;
            } else if (isLengthPercentage(token)) {
                return getAbsoluteValue(token, fontSize);
            }
            return fontSize;
        };
        var listStyleImage = {
            name: "list-style-image",
            initialValue: "none",
            type: 0 /* VALUE */,
            prefix: false,
            parse: function (context, token) {
                if (
                    token.type === 20 /* IDENT_TOKEN */ &&
                    token.value === "none"
                ) {
                    return null;
                }
                return image.parse(context, token);
            },
        };
        var listStylePosition = {
            name: "list-style-position",
            initialValue: "outside",
            prefix: false,
            type: 2 /* IDENT_VALUE */,
            parse: function (_context, position) {
                switch (position) {
                    case "inside":
                        return 0 /* INSIDE */;
                    case "outside":
                    default:
                        return 1 /* OUTSIDE */;
                }
            },
        };

        var listStyleType = {
            name: "list-style-type",
            initialValue: "none",
            prefix: false,
            type: 2 /* IDENT_VALUE */,
            parse: function (_context, type) {
                switch (type) {
                    case "disc":
                        return 0 /* DISC */;
                    case "circle":
                        return 1 /* CIRCLE */;
                    case "square":
                        return 2 /* SQUARE */;
                    case "decimal":
                        return 3 /* DECIMAL */;
                    case "cjk-decimal":
                        return 4 /* CJK_DECIMAL */;
                    case "decimal-leading-zero":
                        return 5 /* DECIMAL_LEADING_ZERO */;
                    case "lower-roman":
                        return 6 /* LOWER_ROMAN */;
                    case "upper-roman":
                        return 7 /* UPPER_ROMAN */;
                    case "lower-greek":
                        return 8 /* LOWER_GREEK */;
                    case "lower-alpha":
                        return 9 /* LOWER_ALPHA */;
                    case "upper-alpha":
                        return 10 /* UPPER_ALPHA */;
                    case "arabic-indic":
                        return 11 /* ARABIC_INDIC */;
                    case "armenian":
                        return 12 /* ARMENIAN */;
                    case "bengali":
                        return 13 /* BENGALI */;
                    case "cambodian":
                        return 14 /* CAMBODIAN */;
                    case "cjk-earthly-branch":
                        return 15 /* CJK_EARTHLY_BRANCH */;
                    case "cjk-heavenly-stem":
                        return 16 /* CJK_HEAVENLY_STEM */;
                    case "cjk-ideographic":
                        return 17 /* CJK_IDEOGRAPHIC */;
                    case "devanagari":
                        return 18 /* DEVANAGARI */;
                    case "ethiopic-numeric":
                        return 19 /* ETHIOPIC_NUMERIC */;
                    case "georgian":
                        return 20 /* GEORGIAN */;
                    case "gujarati":
                        return 21 /* GUJARATI */;
                    case "gurmukhi":
                        return 22 /* GURMUKHI */;
                    case "hebrew":
                        return 22 /* HEBREW */;
                    case "hiragana":
                        return 23 /* HIRAGANA */;
                    case "hiragana-iroha":
                        return 24 /* HIRAGANA_IROHA */;
                    case "japanese-formal":
                        return 25 /* JAPANESE_FORMAL */;
                    case "japanese-informal":
                        return 26 /* JAPANESE_INFORMAL */;
                    case "kannada":
                        return 27 /* KANNADA */;
                    case "katakana":
                        return 28 /* KATAKANA */;
                    case "katakana-iroha":
                        return 29 /* KATAKANA_IROHA */;
                    case "khmer":
                        return 30 /* KHMER */;
                    case "korean-hangul-formal":
                        return 31 /* KOREAN_HANGUL_FORMAL */;
                    case "korean-hanja-formal":
                        return 32 /* KOREAN_HANJA_FORMAL */;
                    case "korean-hanja-informal":
                        return 33 /* KOREAN_HANJA_INFORMAL */;
                    case "lao":
                        return 34 /* LAO */;
                    case "lower-armenian":
                        return 35 /* LOWER_ARMENIAN */;
                    case "malayalam":
                        return 36 /* MALAYALAM */;
                    case "mongolian":
                        return 37 /* MONGOLIAN */;
                    case "myanmar":
                        return 38 /* MYANMAR */;
                    case "oriya":
                        return 39 /* ORIYA */;
                    case "persian":
                        return 40 /* PERSIAN */;
                    case "simp-chinese-formal":
                        return 41 /* SIMP_CHINESE_FORMAL */;
                    case "simp-chinese-informal":
                        return 42 /* SIMP_CHINESE_INFORMAL */;
                    case "tamil":
                        return 43 /* TAMIL */;
                    case "telugu":
                        return 44 /* TELUGU */;
                    case "thai":
                        return 45 /* THAI */;
                    case "tibetan":
                        return 46 /* TIBETAN */;
                    case "trad-chinese-formal":
                        return 47 /* TRAD_CHINESE_FORMAL */;
                    case "trad-chinese-informal":
                        return 48 /* TRAD_CHINESE_INFORMAL */;
                    case "upper-armenian":
                        return 49 /* UPPER_ARMENIAN */;
                    case "disclosure-open":
                        return 50 /* DISCLOSURE_OPEN */;
                    case "disclosure-closed":
                        return 51 /* DISCLOSURE_CLOSED */;
                    case "none":
                    default:
                        return -1 /* NONE */;
                }
            },
        };

        var marginForSide = function (side) {
            return {
                name: "margin-" + side,
                initialValue: "0",
                prefix: false,
                type: 4 /* TOKEN_VALUE */,
            };
        };

        var marginTop = marginForSide("top");
        var marginRight = marginForSide("right");
        var marginBottom = marginForSide("bottom");
        var marginLeft = marginForSide("left");
        var overflow = {
            name: "overflow",
            initialValue: "visible",
            prefix: false,
            type: 1 /* LIST */,
            parse: function (_context, tokens) {
                return tokens.filter(isIdentToken).map(function (overflow) {
                    switch (overflow.value) {
                        case "hidden":
                            return 1 /* HIDDEN */;
                        case "scroll":
                            return 2 /* SCROLL */;
                        case "clip":
                            return 3 /* CLIP */;
                        case "auto":
                            return 4 /* AUTO */;
                        case "visible":
                        default:
                            return 0 /* VISIBLE */;
                    }
                });
            },
        };

        var overflowWrap = {
            name: "overflow-wrap",
            initialValue: "normal",
            prefix: false,
            type: 2 /* IDENT_VALUE */,
            parse: function (_context, overflow) {
                switch (overflow) {
                    case "break-word":
                        return "break-word" /* BREAK_WORD */;
                    case "normal":
                    default:
                        return "normal" /* NORMAL */;
                }
            },
        };

        var paddingForSide = function (side) {
            return {
                name: "padding-" + side,
                initialValue: "0",
                prefix: false,
                type: 3 /* TYPE_VALUE */,
                format: "length-percentage",
            };
        };
        var paddingTop = paddingForSide("top");
        var paddingRight = paddingForSide("right");
        var paddingBottom = paddingForSide("bottom");
        var paddingLeft = paddingForSide("left");
        var textAlign = {
            name: "text-align",
            initialValue: "left",
            prefix: false,
            type: 2 /* IDENT_VALUE */,
            parse: function (_context, textAlign) {
                switch (textAlign) {
                    case "right":
                        return 2 /* RIGHT */;
                    case "center":
                    case "justify":
                        return 1 /* CENTER */;
                    case "left":
                    default:
                        return 0 /* LEFT */;
                }
            },
        };

        var position = {
            name: "position",
            initialValue: "static",
            prefix: false,
            type: 2 /* IDENT_VALUE */,
            parse: function (_context, position) {
                switch (position) {
                    case "relative":
                        return 1 /* RELATIVE */;
                    case "absolute":
                        return 2 /* ABSOLUTE */;
                    case "fixed":
                        return 3 /* FIXED */;
                    case "sticky":
                        return 4 /* STICKY */;
                }

                return 0 /* STATIC */;
            },
        };

        var textShadow = {
            name: "text-shadow",
            initialValue: "none",
            type: 1 /* LIST */,
            prefix: false,
            parse: function (context, tokens) {
                if (
                    tokens.length === 1 &&
                    isIdentWithValue(tokens[0], "none")
                ) {
                    return [];
                }
                return parseFunctionArgs(tokens).map(function (values) {
                    var shadow = {
                        color: COLORS.TRANSPARENT,
                        offsetX: ZERO_LENGTH,
                        offsetY: ZERO_LENGTH,
                        blur: ZERO_LENGTH,
                    };
                    var c = 0;
                    for (var i = 0; i < values.length; i++) {
                        var token = values[i];
                        if (isLength(token)) {
                            if (c === 0) {
                                shadow.offsetX = token;
                            } else if (c === 1) {
                                shadow.offsetY = token;
                            } else {
                                shadow.blur = token;
                            }
                            c++;
                        } else {
                            shadow.color = color$1.parse(context, token);
                        }
                    }
                    return shadow;
                });
            },
        };
        var textTransform = {
            name: "text-transform",
            initialValue: "none",
            prefix: false,
            type: 2 /* IDENT_VALUE */,
            parse: function (_context, textTransform) {
                switch (textTransform) {
                    case "uppercase":
                        return 2 /* UPPERCASE */;
                    case "lowercase":
                        return 1 /* LOWERCASE */;
                    case "capitalize":
                        return 3 /* CAPITALIZE */;
                }

                return 0 /* NONE */;
            },
        };

        var transform$1 = {
            name: "transform",
            initialValue: "none",
            prefix: true,
            type: 0 /* VALUE */,
            parse: function (_context, token) {
                if (
                    token.type === 20 /* IDENT_TOKEN */ &&
                    token.value === "none"
                ) {
                    return null;
                }
                if (token.type === 18 /* FUNCTION */) {
                    var transformFunction =
                        SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
                    if (typeof transformFunction === "undefined") {
                        throw new Error(
                            'Attempting to parse an unsupported transform function "' +
                                token.name +
                                '"',
                        );
                    }
                    return transformFunction(token.values);
                }
                return null;
            },
        };
        var matrix = function (args) {
            var values = args
                .filter(function (arg) {
                    return arg.type === 17 /* NUMBER_TOKEN */;
                })
                .map(function (arg) {
                    return arg.number;
                });
            return values.length === 6 ? values : null;
        };
        // doesn't support 3D transforms at the moment
        var matrix3d = function (args) {
            var values = args
                .filter(function (arg) {
                    return arg.type === 17 /* NUMBER_TOKEN */;
                })
                .map(function (arg) {
                    return arg.number;
                });
            var a1 = values[0],
                b1 = values[1];
            values[2];
            values[3];
            var a2 = values[4],
                b2 = values[5];
            values[6];
            values[7];
            values[8];
            values[9];
            values[10];
            values[11];
            var a4 = values[12],
                b4 = values[13];
            values[14];
            values[15];
            return values.length === 16 ? [a1, b1, a2, b2, a4, b4] : null;
        };
        var SUPPORTED_TRANSFORM_FUNCTIONS = {
            matrix: matrix,
            matrix3d: matrix3d,
        };
        var DEFAULT_VALUE = {
            type: 16 /* PERCENTAGE_TOKEN */,
            number: 50,
            flags: FLAG_INTEGER,
        };
        var DEFAULT = [DEFAULT_VALUE, DEFAULT_VALUE];
        var transformOrigin = {
            name: "transform-origin",
            initialValue: "50% 50%",
            prefix: true,
            type: 1 /* LIST */,
            parse: function (_context, tokens) {
                var origins = tokens.filter(isLengthPercentage);
                if (origins.length !== 2) {
                    return DEFAULT;
                }
                return [origins[0], origins[1]];
            },
        };
        var visibility = {
            name: "visible",
            initialValue: "none",
            prefix: false,
            type: 2 /* IDENT_VALUE */,
            parse: function (_context, visibility) {
                switch (visibility) {
                    case "hidden":
                        return 1 /* HIDDEN */;
                    case "collapse":
                        return 2 /* COLLAPSE */;
                    case "visible":
                    default:
                        return 0 /* VISIBLE */;
                }
            },
        };

        var WORD_BREAK;
        (function (WORD_BREAK) {
            WORD_BREAK["NORMAL"] = "normal";
            WORD_BREAK["BREAK_ALL"] = "break-all";
            WORD_BREAK["KEEP_ALL"] = "keep-all";
        })(WORD_BREAK || (WORD_BREAK = {}));
        var wordBreak = {
            name: "word-break",
            initialValue: "normal",
            prefix: false,
            type: 2 /* IDENT_VALUE */,
            parse: function (_context, wordBreak) {
                switch (wordBreak) {
                    case "break-all":
                        return WORD_BREAK.BREAK_ALL;
                    case "keep-all":
                        return WORD_BREAK.KEEP_ALL;
                    case "normal":
                    default:
                        return WORD_BREAK.NORMAL;
                }
            },
        };
        var zIndex = {
            name: "z-index",
            initialValue: "auto",
            prefix: false,
            type: 0 /* VALUE */,
            parse: function (_context, token) {
                if (token.type === 20 /* IDENT_TOKEN */) {
                    return {
                        auto: true,
                        order: 0,
                    };
                }
                if (isNumberToken(token)) {
                    return {
                        auto: false,
                        order: token.number,
                    };
                }
                throw new Error("Invalid z-index number parsed");
            },
        };
        var time = {
            name: "time",
            parse: function (_context, value) {
                if (value.type === 15 /* DIMENSION_TOKEN */) {
                    switch (value.unit.toLowerCase()) {
                        case "s":
                            return 1000 * value.number;
                        case "ms":
                            return value.number;
                    }
                }
                throw new Error("Unsupported time type");
            },
        };
        var opacity = {
            name: "opacity",
            initialValue: "1",
            type: 0 /* VALUE */,
            prefix: false,
            parse: function (_context, token) {
                if (isNumberToken(token)) {
                    return token.number;
                }
                return 1;
            },
        };
        var textDecorationColor = {
            name: "text-decoration-color",
            initialValue: "transparent",
            prefix: false,
            type: 3 /* TYPE_VALUE */,
            format: "color",
        };
        var textDecorationLine = {
            name: "text-decoration-line",
            initialValue: "none",
            prefix: false,
            type: 1 /* LIST */,
            parse: function (_context, tokens) {
                return tokens
                    .filter(isIdentToken)
                    .map(function (token) {
                        switch (token.value) {
                            case "underline":
                                return 1 /* UNDERLINE */;
                            case "overline":
                                return 2 /* OVERLINE */;
                            case "line-through":
                                return 3 /* LINE_THROUGH */;
                            case "none":
                                return 4 /* BLINK */;
                        }

                        return 0 /* NONE */;
                    })
                    .filter(function (line) {
                        return line !== 0 /* NONE */;
                    });
            },
        };

        var fontFamily = {
            name: "font-family",
            initialValue: "",
            prefix: false,
            type: 1 /* LIST */,
            parse: function (_context, tokens) {
                var accumulator = [];
                var results = [];
                tokens.forEach(function (token) {
                    switch (token.type) {
                        case 20 /* IDENT_TOKEN */:
                        case 0 /* STRING_TOKEN */:
                            accumulator.push(token.value);
                            break;
                        case 17 /* NUMBER_TOKEN */:
                            accumulator.push(token.number.toString());
                            break;
                        case 4 /* COMMA_TOKEN */:
                            results.push(accumulator.join(" "));
                            accumulator.length = 0;
                            break;
                    }
                });
                if (accumulator.length) {
                    results.push(accumulator.join(" "));
                }
                return results.map(function (result) {
                    return result.indexOf(" ") === -1
                        ? result
                        : "'" + result + "'";
                });
            },
        };
        var fontSize = {
            name: "font-size",
            initialValue: "0",
            prefix: false,
            type: 3 /* TYPE_VALUE */,
            format: "length",
        };
        var fontWeight = {
            name: "font-weight",
            initialValue: "normal",
            type: 0 /* VALUE */,
            prefix: false,
            parse: function (_context, token) {
                if (isNumberToken(token)) {
                    return token.number;
                }
                if (isIdentToken(token)) {
                    switch (token.value) {
                        case "bold":
                            return 700;
                        case "normal":
                        default:
                            return 400;
                    }
                }
                return 400;
            },
        };
        var fontVariant = {
            name: "font-variant",
            initialValue: "none",
            type: 1 /* LIST */,
            prefix: false,
            parse: function (_context, tokens) {
                return tokens.filter(isIdentToken).map(function (token) {
                    return token.value;
                });
            },
        };
        var fontStyle = {
            name: "font-style",
            initialValue: "normal",
            prefix: false,
            type: 2 /* IDENT_VALUE */,
            parse: function (_context, overflow) {
                switch (overflow) {
                    case "oblique":
                        return "oblique" /* OBLIQUE */;
                    case "italic":
                        return "italic" /* ITALIC */;
                    case "normal":
                    default:
                        return "normal" /* NORMAL */;
                }
            },
        };

        var contains = function (bit, value) {
            return (bit & value) !== 0;
        };
        var content = {
            name: "content",
            initialValue: "none",
            type: 1 /* LIST */,
            prefix: false,
            parse: function (_context, tokens) {
                if (tokens.length === 0) {
                    return [];
                }
                var first = tokens[0];
                if (
                    first.type === 20 /* IDENT_TOKEN */ &&
                    first.value === "none"
                ) {
                    return [];
                }
                return tokens;
            },
        };
        var counterIncrement = {
            name: "counter-increment",
            initialValue: "none",
            prefix: true,
            type: 1 /* LIST */,
            parse: function (_context, tokens) {
                if (tokens.length === 0) {
                    return null;
                }
                var first = tokens[0];
                if (
                    first.type === 20 /* IDENT_TOKEN */ &&
                    first.value === "none"
                ) {
                    return null;
                }
                var increments = [];
                var filtered = tokens.filter(nonWhiteSpace);
                for (var i = 0; i < filtered.length; i++) {
                    var counter = filtered[i];
                    var next = filtered[i + 1];
                    if (counter.type === 20 /* IDENT_TOKEN */) {
                        var increment =
                            next && isNumberToken(next) ? next.number : 1;
                        increments.push({
                            counter: counter.value,
                            increment: increment,
                        });
                    }
                }
                return increments;
            },
        };
        var counterReset = {
            name: "counter-reset",
            initialValue: "none",
            prefix: true,
            type: 1 /* LIST */,
            parse: function (_context, tokens) {
                if (tokens.length === 0) {
                    return [];
                }
                var resets = [];
                var filtered = tokens.filter(nonWhiteSpace);
                for (var i = 0; i < filtered.length; i++) {
                    var counter = filtered[i];
                    var next = filtered[i + 1];
                    if (isIdentToken(counter) && counter.value !== "none") {
                        var reset =
                            next && isNumberToken(next) ? next.number : 0;
                        resets.push({
                            counter: counter.value,
                            reset: reset,
                        });
                    }
                }
                return resets;
            },
        };
        var duration = {
            name: "duration",
            initialValue: "0s",
            prefix: false,
            type: 1 /* LIST */,
            parse: function (context, tokens) {
                return tokens.filter(isDimensionToken).map(function (token) {
                    return time.parse(context, token);
                });
            },
        };
        var quotes = {
            name: "quotes",
            initialValue: "none",
            prefix: true,
            type: 1 /* LIST */,
            parse: function (_context, tokens) {
                if (tokens.length === 0) {
                    return null;
                }
                var first = tokens[0];
                if (
                    first.type === 20 /* IDENT_TOKEN */ &&
                    first.value === "none"
                ) {
                    return null;
                }
                var quotes = [];
                var filtered = tokens.filter(isStringToken);
                if (filtered.length % 2 !== 0) {
                    return null;
                }
                for (var i = 0; i < filtered.length; i += 2) {
                    var open_1 = filtered[i].value;
                    var close_1 = filtered[i + 1].value;
                    quotes.push({
                        open: open_1,
                        close: close_1,
                    });
                }
                return quotes;
            },
        };
        var getQuote = function (quotes, depth, open) {
            if (!quotes) {
                return "";
            }
            var quote = quotes[Math.min(depth, quotes.length - 1)];
            if (!quote) {
                return "";
            }
            return open ? quote.open : quote.close;
        };
        var boxShadow = {
            name: "box-shadow",
            initialValue: "none",
            type: 1 /* LIST */,
            prefix: false,
            parse: function (context, tokens) {
                if (
                    tokens.length === 1 &&
                    isIdentWithValue(tokens[0], "none")
                ) {
                    return [];
                }
                return parseFunctionArgs(tokens).map(function (values) {
                    var shadow = {
                        color: 0x000000ff,
                        offsetX: ZERO_LENGTH,
                        offsetY: ZERO_LENGTH,
                        blur: ZERO_LENGTH,
                        spread: ZERO_LENGTH,
                        inset: false,
                    };
                    var c = 0;
                    for (var i = 0; i < values.length; i++) {
                        var token = values[i];
                        if (isIdentWithValue(token, "inset")) {
                            shadow.inset = true;
                        } else if (isLength(token)) {
                            if (c === 0) {
                                shadow.offsetX = token;
                            } else if (c === 1) {
                                shadow.offsetY = token;
                            } else if (c === 2) {
                                shadow.blur = token;
                            } else {
                                shadow.spread = token;
                            }
                            c++;
                        } else {
                            shadow.color = color$1.parse(context, token);
                        }
                    }
                    return shadow;
                });
            },
        };
        var paintOrder = {
            name: "paint-order",
            initialValue: "normal",
            prefix: false,
            type: 1 /* LIST */,
            parse: function (_context, tokens) {
                var DEFAULT_VALUE = [
                    0 /* FILL */, 1 /* STROKE */, 2 /* MARKERS */,
                ];
                var layers = [];
                tokens.filter(isIdentToken).forEach(function (token) {
                    switch (token.value) {
                        case "stroke":
                            layers.push(1 /* STROKE */);
                            break;
                        case "fill":
                            layers.push(0 /* FILL */);
                            break;
                        case "markers":
                            layers.push(2 /* MARKERS */);
                            break;
                    }
                });
                DEFAULT_VALUE.forEach(function (value) {
                    if (layers.indexOf(value) === -1) {
                        layers.push(value);
                    }
                });
                return layers;
            },
        };
        var webkitTextStrokeColor = {
            name: "-webkit-text-stroke-color",
            initialValue: "currentcolor",
            prefix: false,
            type: 3 /* TYPE_VALUE */,
            format: "color",
        };
        var webkitTextStrokeWidth = {
            name: "-webkit-text-stroke-width",
            initialValue: "0",
            type: 0 /* VALUE */,
            prefix: false,
            parse: function (_context, token) {
                if (isDimensionToken(token)) {
                    return token.number;
                }
                return 0;
            },
        };
        var CSSParsedDeclaration = /** @class */ (function () {
            function CSSParsedDeclaration(context, declaration) {
                var _a, _b;
                this.animationDuration = parse(
                    context,
                    duration,
                    declaration.animationDuration,
                );
                this.backgroundClip = parse(
                    context,
                    backgroundClip,
                    declaration.backgroundClip,
                );
                this.backgroundColor = parse(
                    context,
                    backgroundColor,
                    declaration.backgroundColor,
                );
                this.backgroundImage = parse(
                    context,
                    backgroundImage,
                    declaration.backgroundImage,
                );
                this.backgroundOrigin = parse(
                    context,
                    backgroundOrigin,
                    declaration.backgroundOrigin,
                );
                this.backgroundPosition = parse(
                    context,
                    backgroundPosition,
                    declaration.backgroundPosition,
                );
                this.backgroundRepeat = parse(
                    context,
                    backgroundRepeat,
                    declaration.backgroundRepeat,
                );
                this.backgroundSize = parse(
                    context,
                    backgroundSize,
                    declaration.backgroundSize,
                );
                this.borderTopColor = parse(
                    context,
                    borderTopColor,
                    declaration.borderTopColor,
                );
                this.borderRightColor = parse(
                    context,
                    borderRightColor,
                    declaration.borderRightColor,
                );
                this.borderBottomColor = parse(
                    context,
                    borderBottomColor,
                    declaration.borderBottomColor,
                );
                this.borderLeftColor = parse(
                    context,
                    borderLeftColor,
                    declaration.borderLeftColor,
                );
                this.borderTopLeftRadius = parse(
                    context,
                    borderTopLeftRadius,
                    declaration.borderTopLeftRadius,
                );
                this.borderTopRightRadius = parse(
                    context,
                    borderTopRightRadius,
                    declaration.borderTopRightRadius,
                );
                this.borderBottomRightRadius = parse(
                    context,
                    borderBottomRightRadius,
                    declaration.borderBottomRightRadius,
                );
                this.borderBottomLeftRadius = parse(
                    context,
                    borderBottomLeftRadius,
                    declaration.borderBottomLeftRadius,
                );
                this.borderTopStyle = parse(
                    context,
                    borderTopStyle,
                    declaration.borderTopStyle,
                );
                this.borderRightStyle = parse(
                    context,
                    borderRightStyle,
                    declaration.borderRightStyle,
                );
                this.borderBottomStyle = parse(
                    context,
                    borderBottomStyle,
                    declaration.borderBottomStyle,
                );
                this.borderLeftStyle = parse(
                    context,
                    borderLeftStyle,
                    declaration.borderLeftStyle,
                );
                this.borderTopWidth = parse(
                    context,
                    borderTopWidth,
                    declaration.borderTopWidth,
                );
                this.borderRightWidth = parse(
                    context,
                    borderRightWidth,
                    declaration.borderRightWidth,
                );
                this.borderBottomWidth = parse(
                    context,
                    borderBottomWidth,
                    declaration.borderBottomWidth,
                );
                this.borderLeftWidth = parse(
                    context,
                    borderLeftWidth,
                    declaration.borderLeftWidth,
                );
                this.boxShadow = parse(
                    context,
                    boxShadow,
                    declaration.boxShadow,
                );
                this.color = parse(context, color, declaration.color);
                this.direction = parse(
                    context,
                    direction,
                    declaration.direction,
                );
                this.display = parse(context, display, declaration.display);
                this.float = parse(context, float, declaration.cssFloat);
                this.fontFamily = parse(
                    context,
                    fontFamily,
                    declaration.fontFamily,
                );
                this.fontSize = parse(context, fontSize, declaration.fontSize);
                this.fontStyle = parse(
                    context,
                    fontStyle,
                    declaration.fontStyle,
                );
                this.fontVariant = parse(
                    context,
                    fontVariant,
                    declaration.fontVariant,
                );
                this.fontWeight = parse(
                    context,
                    fontWeight,
                    declaration.fontWeight,
                );
                this.letterSpacing = parse(
                    context,
                    letterSpacing,
                    declaration.letterSpacing,
                );
                this.lineBreak = parse(
                    context,
                    lineBreak,
                    declaration.lineBreak,
                );
                this.lineHeight = parse(
                    context,
                    lineHeight,
                    declaration.lineHeight,
                );
                this.listStyleImage = parse(
                    context,
                    listStyleImage,
                    declaration.listStyleImage,
                );
                this.listStylePosition = parse(
                    context,
                    listStylePosition,
                    declaration.listStylePosition,
                );
                this.listStyleType = parse(
                    context,
                    listStyleType,
                    declaration.listStyleType,
                );
                this.marginTop = parse(
                    context,
                    marginTop,
                    declaration.marginTop,
                );
                this.marginRight = parse(
                    context,
                    marginRight,
                    declaration.marginRight,
                );
                this.marginBottom = parse(
                    context,
                    marginBottom,
                    declaration.marginBottom,
                );
                this.marginLeft = parse(
                    context,
                    marginLeft,
                    declaration.marginLeft,
                );
                this.opacity = parse(context, opacity, declaration.opacity);
                var overflowTuple = parse(
                    context,
                    overflow,
                    declaration.overflow,
                );
                this.overflowX = overflowTuple[0];
                this.overflowY =
                    overflowTuple[overflowTuple.length > 1 ? 1 : 0];
                this.overflowWrap = parse(
                    context,
                    overflowWrap,
                    declaration.overflowWrap,
                );
                this.paddingTop = parse(
                    context,
                    paddingTop,
                    declaration.paddingTop,
                );
                this.paddingRight = parse(
                    context,
                    paddingRight,
                    declaration.paddingRight,
                );
                this.paddingBottom = parse(
                    context,
                    paddingBottom,
                    declaration.paddingBottom,
                );
                this.paddingLeft = parse(
                    context,
                    paddingLeft,
                    declaration.paddingLeft,
                );
                this.paintOrder = parse(
                    context,
                    paintOrder,
                    declaration.paintOrder,
                );
                this.position = parse(context, position, declaration.position);
                this.textAlign = parse(
                    context,
                    textAlign,
                    declaration.textAlign,
                );
                this.textDecorationColor = parse(
                    context,
                    textDecorationColor,
                    (_a = declaration.textDecorationColor) !== null &&
                        _a !== void 0
                        ? _a
                        : declaration.color,
                );
                this.textDecorationLine = parse(
                    context,
                    textDecorationLine,
                    (_b = declaration.textDecorationLine) !== null &&
                        _b !== void 0
                        ? _b
                        : declaration.textDecoration,
                );
                this.textShadow = parse(
                    context,
                    textShadow,
                    declaration.textShadow,
                );
                this.textTransform = parse(
                    context,
                    textTransform,
                    declaration.textTransform,
                );
                this.transform = parse(
                    context,
                    transform$1,
                    declaration.transform,
                );
                this.transformOrigin = parse(
                    context,
                    transformOrigin,
                    declaration.transformOrigin,
                );
                this.visibility = parse(
                    context,
                    visibility,
                    declaration.visibility,
                );
                this.webkitTextStrokeColor = parse(
                    context,
                    webkitTextStrokeColor,
                    declaration.webkitTextStrokeColor,
                );
                this.webkitTextStrokeWidth = parse(
                    context,
                    webkitTextStrokeWidth,
                    declaration.webkitTextStrokeWidth,
                );
                this.wordBreak = parse(
                    context,
                    wordBreak,
                    declaration.wordBreak,
                );
                this.zIndex = parse(context, zIndex, declaration.zIndex);
            }
            CSSParsedDeclaration.prototype.isVisible = function () {
                return (
                    this.display > 0 &&
                    this.opacity > 0 &&
                    this.visibility === 0 /* VISIBLE */
                );
            };

            CSSParsedDeclaration.prototype.isTransparent = function () {
                return isTransparent(this.backgroundColor);
            };
            CSSParsedDeclaration.prototype.isTransformed = function () {
                return this.transform !== null;
            };
            CSSParsedDeclaration.prototype.isPositioned = function () {
                return this.position !== 0 /* STATIC */;
            };

            CSSParsedDeclaration.prototype.isPositionedWithZIndex =
                function () {
                    return this.isPositioned() && !this.zIndex.auto;
                };
            CSSParsedDeclaration.prototype.isFloating = function () {
                return this.float !== 0 /* NONE */;
            };

            CSSParsedDeclaration.prototype.isInlineLevel = function () {
                return (
                    contains(this.display, 4 /* INLINE */) ||
                    contains(this.display, 33554432 /* INLINE_BLOCK */) ||
                    contains(this.display, 268435456 /* INLINE_FLEX */) ||
                    contains(this.display, 536870912 /* INLINE_GRID */) ||
                    contains(this.display, 67108864 /* INLINE_LIST_ITEM */) ||
                    contains(this.display, 134217728 /* INLINE_TABLE */)
                );
            };

            return CSSParsedDeclaration;
        })();
        var CSSParsedPseudoDeclaration = /** @class */ (function () {
            function CSSParsedPseudoDeclaration(context, declaration) {
                this.content = parse(context, content, declaration.content);
                this.quotes = parse(context, quotes, declaration.quotes);
            }
            return CSSParsedPseudoDeclaration;
        })();
        var CSSParsedCounterDeclaration = /** @class */ (function () {
            function CSSParsedCounterDeclaration(context, declaration) {
                this.counterIncrement = parse(
                    context,
                    counterIncrement,
                    declaration.counterIncrement,
                );
                this.counterReset = parse(
                    context,
                    counterReset,
                    declaration.counterReset,
                );
            }
            return CSSParsedCounterDeclaration;
        })();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var parse = function (context, descriptor, style) {
            var tokenizer = new Tokenizer();
            var value =
                style !== null && typeof style !== "undefined"
                    ? style.toString()
                    : descriptor.initialValue;
            tokenizer.write(value);
            var parser = new Parser(tokenizer.read());
            switch (descriptor.type) {
                case 2 /* IDENT_VALUE */:
                    var token = parser.parseComponentValue();
                    return descriptor.parse(
                        context,
                        isIdentToken(token)
                            ? token.value
                            : descriptor.initialValue,
                    );
                case 0 /* VALUE */:
                    return descriptor.parse(
                        context,
                        parser.parseComponentValue(),
                    );
                case 1 /* LIST */:
                    return descriptor.parse(
                        context,
                        parser.parseComponentValues(),
                    );
                case 4 /* TOKEN_VALUE */:
                    return parser.parseComponentValue();
                case 3 /* TYPE_VALUE */:
                    switch (descriptor.format) {
                        case "angle":
                            return angle.parse(
                                context,
                                parser.parseComponentValue(),
                            );
                        case "color":
                            return color$1.parse(
                                context,
                                parser.parseComponentValue(),
                            );
                        case "image":
                            return image.parse(
                                context,
                                parser.parseComponentValue(),
                            );
                        case "length":
                            var length_1 = parser.parseComponentValue();
                            return isLength(length_1) ? length_1 : ZERO_LENGTH;
                        case "length-percentage":
                            var value_1 = parser.parseComponentValue();
                            return isLengthPercentage(value_1)
                                ? value_1
                                : ZERO_LENGTH;
                        case "time":
                            return time.parse(
                                context,
                                parser.parseComponentValue(),
                            );
                    }
                    break;
            }
        };
        var elementDebuggerAttribute = "data-html2canvas-debug";
        var getElementDebugType = function (element) {
            var attribute = element.getAttribute(elementDebuggerAttribute);
            switch (attribute) {
                case "all":
                    return 1 /* ALL */;
                case "clone":
                    return 2 /* CLONE */;
                case "parse":
                    return 3 /* PARSE */;
                case "render":
                    return 4 /* RENDER */;
                default:
                    return 0 /* NONE */;
            }
        };

        var isDebugging = function (element, type) {
            var elementType = getElementDebugType(element);
            return elementType === 1 /* ALL */ || type === elementType;
        };
        var ElementContainer = /** @class */ (function () {
            function ElementContainer(context, element) {
                this.context = context;
                this.textNodes = [];
                this.elements = [];
                this.flags = 0;
                if (isDebugging(element, 3 /* PARSE */)) {
                    debugger;
                }
                this.styles = new CSSParsedDeclaration(
                    context,
                    window.getComputedStyle(element, null),
                );
                if (isHTMLElementNode(element)) {
                    if (
                        this.styles.animationDuration.some(function (duration) {
                            return duration > 0;
                        })
                    ) {
                        element.style.animationDuration = "0s";
                    }
                    if (this.styles.transform !== null) {
                        // getBoundingClientRect takes transforms into account
                        element.style.transform = "none";
                    }
                }
                this.bounds = parseBounds(this.context, element);
                if (isDebugging(element, 4 /* RENDER */)) {
                    this.flags |= 16 /* DEBUG_RENDER */;
                }
            }

            return ElementContainer;
        })();

        /*
         * text-segmentation 1.0.3 <https://github.com/niklasvh/text-segmentation>
         * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
         * Released under MIT License
         */
        var base64 =
            "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";

        /*
         * utrie 1.0.2 <https://github.com/niklasvh/utrie>
         * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
         * Released under MIT License
         */
        var chars$1 =
            "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
        // Use a lookup table to find the index.
        var lookup$1 =
            typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
        for (var i$1 = 0; i$1 < chars$1.length; i$1++) {
            lookup$1[chars$1.charCodeAt(i$1)] = i$1;
        }
        var decode = function (base64) {
            var bufferLength = base64.length * 0.75,
                len = base64.length,
                i,
                p = 0,
                encoded1,
                encoded2,
                encoded3,
                encoded4;
            if (base64[base64.length - 1] === "=") {
                bufferLength--;
                if (base64[base64.length - 2] === "=") {
                    bufferLength--;
                }
            }
            var buffer =
                typeof ArrayBuffer !== "undefined" &&
                typeof Uint8Array !== "undefined" &&
                typeof Uint8Array.prototype.slice !== "undefined"
                    ? new ArrayBuffer(bufferLength)
                    : new Array(bufferLength);
            var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
            for (i = 0; i < len; i += 4) {
                encoded1 = lookup$1[base64.charCodeAt(i)];
                encoded2 = lookup$1[base64.charCodeAt(i + 1)];
                encoded3 = lookup$1[base64.charCodeAt(i + 2)];
                encoded4 = lookup$1[base64.charCodeAt(i + 3)];
                bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
                bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
                bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
            }
            return buffer;
        };
        var polyUint16Array = function (buffer) {
            var length = buffer.length;
            var bytes = [];
            for (var i = 0; i < length; i += 2) {
                bytes.push((buffer[i + 1] << 8) | buffer[i]);
            }
            return bytes;
        };
        var polyUint32Array = function (buffer) {
            var length = buffer.length;
            var bytes = [];
            for (var i = 0; i < length; i += 4) {
                bytes.push(
                    (buffer[i + 3] << 24) |
                        (buffer[i + 2] << 16) |
                        (buffer[i + 1] << 8) |
                        buffer[i],
                );
            }
            return bytes;
        };

        /** Shift size for getting the index-2 table offset. */
        var UTRIE2_SHIFT_2 = 5;
        /** Shift size for getting the index-1 table offset. */
        var UTRIE2_SHIFT_1 = 6 + 5;
        /**
         * Shift size for shifting left the index array values.
         * Increases possible data size with 16-bit index values at the cost
         * of compactability.
         * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
         */
        var UTRIE2_INDEX_SHIFT = 2;
        /**
         * Difference between the two shift sizes,
         * for getting an index-1 offset from an index-2 offset. 6=11-5
         */
        var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
        /**
         * The part of the index-2 table for U+D800..U+DBFF stores values for
         * lead surrogate code _units_ not code _points_.
         * Values for lead surrogate code _points_ are indexed with this portion of the table.
         * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
         */
        var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
        /** Number of entries in a data block. 32=0x20 */
        var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
        /** Mask for getting the lower bits for the in-data-block offset. */
        var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
        var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
        /** Count the lengths of both BMP pieces. 2080=0x820 */
        var UTRIE2_INDEX_2_BMP_LENGTH =
            UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
        /**
         * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
         * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
         */
        var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
        var UTRIE2_UTF8_2B_INDEX_2_LENGTH =
            0x800 >> 6; /* U+0800 is the first code point after 2-byte UTF-8 */
        /**
         * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
         * Variable length, for code points up to highStart, where the last single-value range starts.
         * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
         * (For 0x100000 supplementary code points U+10000..U+10ffff.)
         *
         * The part of the index-2 table for supplementary code points starts
         * after this index-1 table.
         *
         * Both the index-1 table and the following part of the index-2 table
         * are omitted completely if there is only BMP data.
         */
        var UTRIE2_INDEX_1_OFFSET =
            UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
        /**
         * Number of index-1 entries for the BMP. 32=0x20
         * This part of the index-1 table is omitted from the serialized form.
         */
        var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
        /** Number of entries in an index-2 block. 64=0x40 */
        var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
        /** Mask for getting the lower bits for the in-index-2-block offset. */
        var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
        var slice16 = function (view, start, end) {
            if (view.slice) {
                return view.slice(start, end);
            }
            return new Uint16Array(
                Array.prototype.slice.call(view, start, end),
            );
        };
        var slice32 = function (view, start, end) {
            if (view.slice) {
                return view.slice(start, end);
            }
            return new Uint32Array(
                Array.prototype.slice.call(view, start, end),
            );
        };
        var createTrieFromBase64 = function (base64, _byteLength) {
            var buffer = decode(base64);
            var view32 = Array.isArray(buffer)
                ? polyUint32Array(buffer)
                : new Uint32Array(buffer);
            var view16 = Array.isArray(buffer)
                ? polyUint16Array(buffer)
                : new Uint16Array(buffer);
            var headerLength = 24;
            var index = slice16(view16, headerLength / 2, view32[4] / 2);
            var data =
                view32[5] === 2
                    ? slice16(view16, (headerLength + view32[4]) / 2)
                    : slice32(
                          view32,
                          Math.ceil((headerLength + view32[4]) / 4),
                      );
            return new Trie(
                view32[0],
                view32[1],
                view32[2],
                view32[3],
                index,
                data,
            );
        };
        var Trie = /** @class */ (function () {
            function Trie(
                initialValue,
                errorValue,
                highStart,
                highValueIndex,
                index,
                data,
            ) {
                this.initialValue = initialValue;
                this.errorValue = errorValue;
                this.highStart = highStart;
                this.highValueIndex = highValueIndex;
                this.index = index;
                this.data = data;
            }
            /**
             * Get the value for a code point as stored in the Trie.
             *
             * @param codePoint the code point
             * @return the value
             */
            Trie.prototype.get = function (codePoint) {
                var ix;
                if (codePoint >= 0) {
                    if (
                        codePoint < 0x0d800 ||
                        (codePoint > 0x0dbff && codePoint <= 0x0ffff)
                    ) {
                        // Ordinary BMP code point, excluding leading surrogates.
                        // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                        // 16 bit data is stored in the index array itself.
                        ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                        ix =
                            (ix << UTRIE2_INDEX_SHIFT) +
                            (codePoint & UTRIE2_DATA_MASK);
                        return this.data[ix];
                    }
                    if (codePoint <= 0xffff) {
                        // Lead Surrogate Code Point.  A Separate index section is stored for
                        // lead surrogate code units and code points.
                        //   The main index has the code unit data.
                        //   For this function, we need the code point data.
                        // Note: this expression could be refactored for slightly improved efficiency, but
                        //       surrogate code points will be so rare in practice that it's not worth it.
                        ix =
                            this.index[
                                UTRIE2_LSCP_INDEX_2_OFFSET +
                                    ((codePoint - 0xd800) >> UTRIE2_SHIFT_2)
                            ];
                        ix =
                            (ix << UTRIE2_INDEX_SHIFT) +
                            (codePoint & UTRIE2_DATA_MASK);
                        return this.data[ix];
                    }
                    if (codePoint < this.highStart) {
                        // Supplemental code point, use two-level lookup.
                        ix =
                            UTRIE2_INDEX_1_OFFSET -
                            UTRIE2_OMITTED_BMP_INDEX_1_LENGTH +
                            (codePoint >> UTRIE2_SHIFT_1);
                        ix = this.index[ix];
                        ix +=
                            (codePoint >> UTRIE2_SHIFT_2) & UTRIE2_INDEX_2_MASK;
                        ix = this.index[ix];
                        ix =
                            (ix << UTRIE2_INDEX_SHIFT) +
                            (codePoint & UTRIE2_DATA_MASK);
                        return this.data[ix];
                    }
                    if (codePoint <= 0x10ffff) {
                        return this.data[this.highValueIndex];
                    }
                }
                // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
                return this.errorValue;
            };
            return Trie;
        })();

        /*
         * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
         * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
         * Released under MIT License
         */
        var chars =
            "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
        // Use a lookup table to find the index.
        var lookup =
            typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
        for (var i = 0; i < chars.length; i++) {
            lookup[chars.charCodeAt(i)] = i;
        }
        var Prepend = 1;
        var CR = 2;
        var LF = 3;
        var Control = 4;
        var Extend = 5;
        var SpacingMark = 7;
        var L = 8;
        var V = 9;
        var T = 10;
        var LV = 11;
        var LVT = 12;
        var ZWJ = 13;
        var Extended_Pictographic = 14;
        var RI = 15;
        var toCodePoints = function (str) {
            var codePoints = [];
            var i = 0;
            var length = str.length;
            while (i < length) {
                var value = str.charCodeAt(i++);
                if (value >= 0xd800 && value <= 0xdbff && i < length) {
                    var extra = str.charCodeAt(i++);
                    if ((extra & 0xfc00) === 0xdc00) {
                        codePoints.push(
                            ((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000,
                        );
                    } else {
                        codePoints.push(value);
                        i--;
                    }
                } else {
                    codePoints.push(value);
                }
            }
            return codePoints;
        };
        var fromCodePoint = function () {
            var codePoints = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                codePoints[_i] = arguments[_i];
            }
            if (String.fromCodePoint) {
                return String.fromCodePoint.apply(String, codePoints);
            }
            var length = codePoints.length;
            if (!length) {
                return "";
            }
            var codeUnits = [];
            var index = -1;
            var result = "";
            while (++index < length) {
                var codePoint = codePoints[index];
                if (codePoint <= 0xffff) {
                    codeUnits.push(codePoint);
                } else {
                    codePoint -= 0x10000;
                    codeUnits.push(
                        (codePoint >> 10) + 0xd800,
                        (codePoint % 0x400) + 0xdc00,
                    );
                }
                if (index + 1 === length || codeUnits.length > 0x4000) {
                    result += String.fromCharCode.apply(String, codeUnits);
                    codeUnits.length = 0;
                }
            }
            return result;
        };
        var UnicodeTrie = createTrieFromBase64(base64);
        var BREAK_NOT_ALLOWED = "×";
        var BREAK_ALLOWED = "÷";
        var codePointToClass = function (codePoint) {
            return UnicodeTrie.get(codePoint);
        };
        var _graphemeBreakAtIndex = function (_codePoints, classTypes, index) {
            var prevIndex = index - 2;
            var prev = classTypes[prevIndex];
            var current = classTypes[index - 1];
            var next = classTypes[index];
            // GB3 Do not break between a CR and LF
            if (current === CR && next === LF) {
                return BREAK_NOT_ALLOWED;
            }
            // GB4 Otherwise, break before and after controls.
            if (current === CR || current === LF || current === Control) {
                return BREAK_ALLOWED;
            }
            // GB5
            if (next === CR || next === LF || next === Control) {
                return BREAK_ALLOWED;
            }
            // Do not break Hangul syllable sequences.
            // GB6
            if (current === L && [L, V, LV, LVT].indexOf(next) !== -1) {
                return BREAK_NOT_ALLOWED;
            }
            // GB7
            if (
                (current === LV || current === V) &&
                (next === V || next === T)
            ) {
                return BREAK_NOT_ALLOWED;
            }
            // GB8
            if ((current === LVT || current === T) && next === T) {
                return BREAK_NOT_ALLOWED;
            }
            // GB9 Do not break before extending characters or ZWJ.
            if (next === ZWJ || next === Extend) {
                return BREAK_NOT_ALLOWED;
            }
            // Do not break before SpacingMarks, or after Prepend characters.
            // GB9a
            if (next === SpacingMark) {
                return BREAK_NOT_ALLOWED;
            }
            // GB9a
            if (current === Prepend) {
                return BREAK_NOT_ALLOWED;
            }
            // GB11 Do not break within emoji modifier sequences or emoji zwj sequences.
            if (current === ZWJ && next === Extended_Pictographic) {
                while (prev === Extend) {
                    prev = classTypes[--prevIndex];
                }
                if (prev === Extended_Pictographic) {
                    return BREAK_NOT_ALLOWED;
                }
            }
            // GB12 Do not break within emoji flag sequences.
            // That is, do not break between regional indicator (RI) symbols
            // if there is an odd number of RI characters before the break point.
            if (current === RI && next === RI) {
                var countRI = 0;
                while (prev === RI) {
                    countRI++;
                    prev = classTypes[--prevIndex];
                }
                if (countRI % 2 === 0) {
                    return BREAK_NOT_ALLOWED;
                }
            }
            return BREAK_ALLOWED;
        };
        var GraphemeBreaker = function (str) {
            var codePoints = toCodePoints(str);
            var length = codePoints.length;
            var index = 0;
            var lastEnd = 0;
            var classTypes = codePoints.map(codePointToClass);
            return {
                next: function () {
                    if (index >= length) {
                        return {
                            done: true,
                            value: null,
                        };
                    }
                    var graphemeBreak = BREAK_NOT_ALLOWED;
                    while (
                        index < length &&
                        (graphemeBreak = _graphemeBreakAtIndex(
                            codePoints,
                            classTypes,
                            ++index,
                        )) === BREAK_NOT_ALLOWED
                    ) {}
                    if (
                        graphemeBreak !== BREAK_NOT_ALLOWED ||
                        index === length
                    ) {
                        var value = fromCodePoint.apply(
                            null,
                            codePoints.slice(lastEnd, index),
                        );
                        lastEnd = index;
                        return {
                            value: value,
                            done: false,
                        };
                    }
                    return {
                        done: true,
                        value: null,
                    };
                },
            };
        };
        var splitGraphemes = function (str) {
            var breaker = GraphemeBreaker(str);
            var graphemes = [];
            var bk;
            while (!(bk = breaker.next()).done) {
                if (bk.value) {
                    graphemes.push(bk.value.slice());
                }
            }
            return graphemes;
        };
        var testRangeBounds = function (document) {
            var TEST_HEIGHT = 123;
            if (document.createRange) {
                var range = document.createRange();
                if (range.getBoundingClientRect) {
                    var testElement = document.createElement("boundtest");
                    testElement.style.height = TEST_HEIGHT + "px";
                    testElement.style.display = "block";
                    document.body.appendChild(testElement);
                    range.selectNode(testElement);
                    var rangeBounds = range.getBoundingClientRect();
                    var rangeHeight = Math.round(rangeBounds.height);
                    document.body.removeChild(testElement);
                    if (rangeHeight === TEST_HEIGHT) {
                        return true;
                    }
                }
            }
            return false;
        };
        var testIOSLineBreak = function (document) {
            var testElement = document.createElement("boundtest");
            testElement.style.width = "50px";
            testElement.style.display = "block";
            testElement.style.fontSize = "12px";
            testElement.style.letterSpacing = "0px";
            testElement.style.wordSpacing = "0px";
            document.body.appendChild(testElement);
            var range = document.createRange();
            testElement.innerHTML =
                typeof "".repeat === "function" ? "&#128104;".repeat(10) : "";
            var node = testElement.firstChild;
            var textList = toCodePoints$1(node.data).map(function (i) {
                return fromCodePoint$1(i);
            });
            var offset = 0;
            var prev = {};
            // ios 13 does not handle range getBoundingClientRect line changes correctly #2177
            var supports = textList.every(function (text, i) {
                range.setStart(node, offset);
                range.setEnd(node, offset + text.length);
                var rect = range.getBoundingClientRect();
                offset += text.length;
                var boundAhead = rect.x > prev.x || rect.y > prev.y;
                prev = rect;
                if (i === 0) {
                    return true;
                }
                return boundAhead;
            });
            document.body.removeChild(testElement);
            return supports;
        };
        var testCORS = function () {
            return typeof new Image().crossOrigin !== "undefined";
        };
        var testResponseType = function () {
            return typeof new XMLHttpRequest().responseType === "string";
        };
        var testSVG = function (document) {
            var img = new Image();
            var canvas = document.createElement("canvas");
            var ctx = canvas.getContext("2d");
            if (!ctx) {
                return false;
            }
            img.src =
                "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
            try {
                ctx.drawImage(img, 0, 0);
                canvas.toDataURL();
            } catch (e) {
                return false;
            }
            return true;
        };
        var isGreenPixel = function (data) {
            return (
                data[0] === 0 &&
                data[1] === 255 &&
                data[2] === 0 &&
                data[3] === 255
            );
        };
        var testForeignObject = function (document) {
            var canvas = document.createElement("canvas");
            var size = 100;
            canvas.width = size;
            canvas.height = size;
            var ctx = canvas.getContext("2d");
            if (!ctx) {
                return Promise.reject(false);
            }
            ctx.fillStyle = "rgb(0, 255, 0)";
            ctx.fillRect(0, 0, size, size);
            var img = new Image();
            var greenImageSrc = canvas.toDataURL();
            img.src = greenImageSrc;
            var svg = createForeignObjectSVG(size, size, 0, 0, img);
            ctx.fillStyle = "red";
            ctx.fillRect(0, 0, size, size);
            return loadSerializedSVG$1(svg)
                .then(function (img) {
                    ctx.drawImage(img, 0, 0);
                    var data = ctx.getImageData(0, 0, size, size).data;
                    ctx.fillStyle = "red";
                    ctx.fillRect(0, 0, size, size);
                    var node = document.createElement("div");
                    node.style.backgroundImage = "url(" + greenImageSrc + ")";
                    node.style.height = size + "px";
                    // Firefox 55 does not render inline <img /> tags
                    return isGreenPixel(data)
                        ? loadSerializedSVG$1(
                              createForeignObjectSVG(size, size, 0, 0, node),
                          )
                        : Promise.reject(false);
                })
                .then(function (img) {
                    ctx.drawImage(img, 0, 0);
                    // Edge does not render background-images
                    return isGreenPixel(
                        ctx.getImageData(0, 0, size, size).data,
                    );
                })
                .catch(function () {
                    return false;
                });
        };
        var createForeignObjectSVG = function (width, height, x, y, node) {
            var xmlns = "http://www.w3.org/2000/svg";
            var svg = document.createElementNS(xmlns, "svg");
            var foreignObject = document.createElementNS(
                xmlns,
                "foreignObject",
            );
            svg.setAttributeNS(null, "width", width.toString());
            svg.setAttributeNS(null, "height", height.toString());
            foreignObject.setAttributeNS(null, "width", "100%");
            foreignObject.setAttributeNS(null, "height", "100%");
            foreignObject.setAttributeNS(null, "x", x.toString());
            foreignObject.setAttributeNS(null, "y", y.toString());
            foreignObject.setAttributeNS(
                null,
                "externalResourcesRequired",
                "true",
            );
            svg.appendChild(foreignObject);
            foreignObject.appendChild(node);
            return svg;
        };
        var loadSerializedSVG$1 = function (svg) {
            return new Promise(function (resolve, reject) {
                var img = new Image();
                img.onload = function () {
                    return resolve(img);
                };
                img.onerror = reject;
                img.src =
                    "data:image/svg+xml;charset=utf-8," +
                    encodeURIComponent(
                        new XMLSerializer().serializeToString(svg),
                    );
            });
        };
        var FEATURES = {
            get SUPPORT_RANGE_BOUNDS() {
                var value = testRangeBounds(document);
                Object.defineProperty(FEATURES, "SUPPORT_RANGE_BOUNDS", {
                    value: value,
                });
                return value;
            },
            get SUPPORT_WORD_BREAKING() {
                var value =
                    FEATURES.SUPPORT_RANGE_BOUNDS && testIOSLineBreak(document);
                Object.defineProperty(FEATURES, "SUPPORT_WORD_BREAKING", {
                    value: value,
                });
                return value;
            },
            get SUPPORT_SVG_DRAWING() {
                var value = testSVG(document);
                Object.defineProperty(FEATURES, "SUPPORT_SVG_DRAWING", {
                    value: value,
                });
                return value;
            },
            get SUPPORT_FOREIGNOBJECT_DRAWING() {
                var value =
                    typeof Array.from === "function" &&
                    typeof window.fetch === "function"
                        ? testForeignObject(document)
                        : Promise.resolve(false);
                Object.defineProperty(
                    FEATURES,
                    "SUPPORT_FOREIGNOBJECT_DRAWING",
                    {
                        value: value,
                    },
                );
                return value;
            },
            get SUPPORT_CORS_IMAGES() {
                var value = testCORS();
                Object.defineProperty(FEATURES, "SUPPORT_CORS_IMAGES", {
                    value: value,
                });
                return value;
            },
            get SUPPORT_RESPONSE_TYPE() {
                var value = testResponseType();
                Object.defineProperty(FEATURES, "SUPPORT_RESPONSE_TYPE", {
                    value: value,
                });
                return value;
            },
            get SUPPORT_CORS_XHR() {
                var value = "withCredentials" in new XMLHttpRequest();
                Object.defineProperty(FEATURES, "SUPPORT_CORS_XHR", {
                    value: value,
                });
                return value;
            },
            get SUPPORT_NATIVE_TEXT_SEGMENTATION() {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                var value = !!(typeof Intl !== "undefined" && Intl.Segmenter);
                Object.defineProperty(
                    FEATURES,
                    "SUPPORT_NATIVE_TEXT_SEGMENTATION",
                    {
                        value: value,
                    },
                );
                return value;
            },
        };
        var TextBounds = /** @class */ (function () {
            function TextBounds(text, bounds) {
                this.text = text;
                this.bounds = bounds;
            }
            return TextBounds;
        })();
        var parseTextBounds = function (context, value, styles, node) {
            var textList = breakText(value, styles);
            var textBounds = [];
            var offset = 0;
            textList.forEach(function (text) {
                if (
                    styles.textDecorationLine.length ||
                    text.trim().length > 0
                ) {
                    if (FEATURES.SUPPORT_RANGE_BOUNDS) {
                        var clientRects = createRange(
                            node,
                            offset,
                            text.length,
                        ).getClientRects();
                        if (clientRects.length > 1) {
                            var subSegments = segmentGraphemes(text);
                            var subOffset_1 = 0;
                            subSegments.forEach(function (subSegment) {
                                textBounds.push(
                                    new TextBounds(
                                        subSegment,
                                        Bounds.fromDOMRectList(
                                            context,
                                            createRange(
                                                node,
                                                subOffset_1 + offset,
                                                subSegment.length,
                                            ).getClientRects(),
                                        ),
                                    ),
                                );
                                subOffset_1 += subSegment.length;
                            });
                        } else {
                            textBounds.push(
                                new TextBounds(
                                    text,
                                    Bounds.fromDOMRectList(
                                        context,
                                        clientRects,
                                    ),
                                ),
                            );
                        }
                    } else {
                        var replacementNode = node.splitText(text.length);
                        textBounds.push(
                            new TextBounds(
                                text,
                                getWrapperBounds(context, node),
                            ),
                        );
                        node = replacementNode;
                    }
                } else if (!FEATURES.SUPPORT_RANGE_BOUNDS) {
                    node = node.splitText(text.length);
                }
                offset += text.length;
            });
            return textBounds;
        };
        var getWrapperBounds = function (context, node) {
            var ownerDocument = node.ownerDocument;
            if (ownerDocument) {
                var wrapper = ownerDocument.createElement("html2canvaswrapper");
                wrapper.appendChild(node.cloneNode(true));
                var parentNode = node.parentNode;
                if (parentNode) {
                    parentNode.replaceChild(wrapper, node);
                    var bounds = parseBounds(context, wrapper);
                    if (wrapper.firstChild) {
                        parentNode.replaceChild(wrapper.firstChild, wrapper);
                    }
                    return bounds;
                }
            }
            return Bounds.EMPTY;
        };
        var createRange = function (node, offset, length) {
            var ownerDocument = node.ownerDocument;
            if (!ownerDocument) {
                throw new Error("Node has no owner document");
            }
            var range = ownerDocument.createRange();
            range.setStart(node, offset);
            range.setEnd(node, offset + length);
            return range;
        };
        var segmentGraphemes = function (value) {
            if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                var segmenter = new Intl.Segmenter(void 0, {
                    granularity: "grapheme",
                });
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return Array.from(segmenter.segment(value)).map(
                    function (segment) {
                        return segment.segment;
                    },
                );
            }
            return splitGraphemes(value);
        };
        var segmentWords = function (value, styles) {
            if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                var segmenter = new Intl.Segmenter(void 0, {
                    granularity: "word",
                });
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return Array.from(segmenter.segment(value)).map(
                    function (segment) {
                        return segment.segment;
                    },
                );
            }
            return breakWords(value, styles);
        };
        var breakText = function (value, styles) {
            return styles.letterSpacing !== 0
                ? segmentGraphemes(value)
                : segmentWords(value, styles);
        };
        // https://drafts.csswg.org/css-text/#word-separator
        var wordSeparators = [
            0x0020, 0x00a0, 0x1361, 0x10100, 0x10101, 0x1039, 0x1091,
        ];
        var breakWords = function (str, styles) {
            var breaker = LineBreaker(str, {
                lineBreak: styles.lineBreak,
                wordBreak:
                    styles.overflowWrap === "break-word" /* BREAK_WORD */
                        ? "break-word"
                        : styles.wordBreak,
            });
            var words = [];
            var bk;
            var _loop_1 = function () {
                if (bk.value) {
                    var value = bk.value.slice();
                    var codePoints = toCodePoints$1(value);
                    var word_1 = "";
                    codePoints.forEach(function (codePoint) {
                        if (wordSeparators.indexOf(codePoint) === -1) {
                            word_1 += fromCodePoint$1(codePoint);
                        } else {
                            if (word_1.length) {
                                words.push(word_1);
                            }
                            words.push(fromCodePoint$1(codePoint));
                            word_1 = "";
                        }
                    });
                    if (word_1.length) {
                        words.push(word_1);
                    }
                }
            };
            while (!(bk = breaker.next()).done) {
                _loop_1();
            }
            return words;
        };
        var TextContainer = /** @class */ (function () {
            function TextContainer(context, node, styles) {
                this.text = transform(node.data, styles.textTransform);
                this.textBounds = parseTextBounds(
                    context,
                    this.text,
                    styles,
                    node,
                );
            }
            return TextContainer;
        })();
        var transform = function (text, transform) {
            switch (transform) {
                case 1 /* LOWERCASE */:
                    return text.toLowerCase();
                case 3 /* CAPITALIZE */:
                    return text.replace(CAPITALIZE, capitalize);
                case 2 /* UPPERCASE */:
                    return text.toUpperCase();
                default:
                    return text;
            }
        };
        var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
        var capitalize = function (m, p1, p2) {
            if (m.length > 0) {
                return p1 + p2.toUpperCase();
            }
            return m;
        };
        var ImageElementContainer = /** @class */ (function (_super) {
            __extends(ImageElementContainer, _super);
            function ImageElementContainer(context, img) {
                var _this = _super.call(this, context, img) || this;
                _this.src = img.currentSrc || img.src;
                _this.intrinsicWidth = img.naturalWidth;
                _this.intrinsicHeight = img.naturalHeight;
                _this.context.cache.addImage(_this.src);
                return _this;
            }
            return ImageElementContainer;
        })(ElementContainer);
        var CanvasElementContainer = /** @class */ (function (_super) {
            __extends(CanvasElementContainer, _super);
            function CanvasElementContainer(context, canvas) {
                var _this = _super.call(this, context, canvas) || this;
                _this.canvas = canvas;
                _this.intrinsicWidth = canvas.width;
                _this.intrinsicHeight = canvas.height;
                return _this;
            }
            return CanvasElementContainer;
        })(ElementContainer);
        var SVGElementContainer = /** @class */ (function (_super) {
            __extends(SVGElementContainer, _super);
            function SVGElementContainer(context, img) {
                var _this = _super.call(this, context, img) || this;
                var s = new XMLSerializer();
                var bounds = parseBounds(context, img);
                img.setAttribute("width", bounds.width + "px");
                img.setAttribute("height", bounds.height + "px");
                _this.svg =
                    "data:image/svg+xml," +
                    encodeURIComponent(s.serializeToString(img));
                _this.intrinsicWidth = img.width.baseVal.value;
                _this.intrinsicHeight = img.height.baseVal.value;
                _this.context.cache.addImage(_this.svg);
                return _this;
            }
            return SVGElementContainer;
        })(ElementContainer);
        var LIElementContainer = /** @class */ (function (_super) {
            __extends(LIElementContainer, _super);
            function LIElementContainer(context, element) {
                var _this = _super.call(this, context, element) || this;
                _this.value = element.value;
                return _this;
            }
            return LIElementContainer;
        })(ElementContainer);
        var OLElementContainer = /** @class */ (function (_super) {
            __extends(OLElementContainer, _super);
            function OLElementContainer(context, element) {
                var _this = _super.call(this, context, element) || this;
                _this.start = element.start;
                _this.reversed =
                    typeof element.reversed === "boolean" &&
                    element.reversed === true;
                return _this;
            }
            return OLElementContainer;
        })(ElementContainer);
        var CHECKBOX_BORDER_RADIUS = [
            {
                type: 15 /* DIMENSION_TOKEN */,
                flags: 0,
                unit: "px",
                number: 3,
            },
        ];
        var RADIO_BORDER_RADIUS = [
            {
                type: 16 /* PERCENTAGE_TOKEN */,
                flags: 0,
                number: 50,
            },
        ];
        var reformatInputBounds = function (bounds) {
            if (bounds.width > bounds.height) {
                return new Bounds(
                    bounds.left + (bounds.width - bounds.height) / 2,
                    bounds.top,
                    bounds.height,
                    bounds.height,
                );
            } else if (bounds.width < bounds.height) {
                return new Bounds(
                    bounds.left,
                    bounds.top + (bounds.height - bounds.width) / 2,
                    bounds.width,
                    bounds.width,
                );
            }
            return bounds;
        };
        var getInputValue = function (node) {
            var value =
                node.type === PASSWORD
                    ? new Array(node.value.length + 1).join("\u2022")
                    : node.value;
            return value.length === 0 ? node.placeholder || "" : value;
        };
        var CHECKBOX = "checkbox";
        var RADIO = "radio";
        var PASSWORD = "password";
        var INPUT_COLOR = 0x2a2a2aff;
        var InputElementContainer = /** @class */ (function (_super) {
            __extends(InputElementContainer, _super);
            function InputElementContainer(context, input) {
                var _this = _super.call(this, context, input) || this;
                _this.type = input.type.toLowerCase();
                _this.checked = input.checked;
                _this.value = getInputValue(input);
                if (_this.type === CHECKBOX || _this.type === RADIO) {
                    _this.styles.backgroundColor = 0xdededeff;
                    _this.styles.borderTopColor =
                        _this.styles.borderRightColor =
                        _this.styles.borderBottomColor =
                        _this.styles.borderLeftColor =
                            0xa5a5a5ff;
                    _this.styles.borderTopWidth =
                        _this.styles.borderRightWidth =
                        _this.styles.borderBottomWidth =
                        _this.styles.borderLeftWidth =
                            1;
                    _this.styles.borderTopStyle =
                        _this.styles.borderRightStyle =
                        _this.styles.borderBottomStyle =
                        _this.styles.borderLeftStyle =
                            1 /* SOLID */;
                    _this.styles.backgroundClip = [0 /* BORDER_BOX */];
                    _this.styles.backgroundOrigin = [0 /* BORDER_BOX */];
                    _this.bounds = reformatInputBounds(_this.bounds);
                }
                switch (_this.type) {
                    case CHECKBOX:
                        _this.styles.borderTopRightRadius =
                            _this.styles.borderTopLeftRadius =
                            _this.styles.borderBottomRightRadius =
                            _this.styles.borderBottomLeftRadius =
                                CHECKBOX_BORDER_RADIUS;
                        break;
                    case RADIO:
                        _this.styles.borderTopRightRadius =
                            _this.styles.borderTopLeftRadius =
                            _this.styles.borderBottomRightRadius =
                            _this.styles.borderBottomLeftRadius =
                                RADIO_BORDER_RADIUS;
                        break;
                }
                return _this;
            }
            return InputElementContainer;
        })(ElementContainer);
        var SelectElementContainer = /** @class */ (function (_super) {
            __extends(SelectElementContainer, _super);
            function SelectElementContainer(context, element) {
                var _this = _super.call(this, context, element) || this;
                var option = element.options[element.selectedIndex || 0];
                _this.value = option ? option.text || "" : "";
                return _this;
            }
            return SelectElementContainer;
        })(ElementContainer);
        var TextareaElementContainer = /** @class */ (function (_super) {
            __extends(TextareaElementContainer, _super);
            function TextareaElementContainer(context, element) {
                var _this = _super.call(this, context, element) || this;
                _this.value = element.value;
                return _this;
            }
            return TextareaElementContainer;
        })(ElementContainer);
        var IFrameElementContainer = /** @class */ (function (_super) {
            __extends(IFrameElementContainer, _super);
            function IFrameElementContainer(context, iframe) {
                var _this = _super.call(this, context, iframe) || this;
                _this.src = iframe.src;
                _this.width = parseInt(iframe.width, 10) || 0;
                _this.height = parseInt(iframe.height, 10) || 0;
                _this.backgroundColor = _this.styles.backgroundColor;
                try {
                    if (
                        iframe.contentWindow &&
                        iframe.contentWindow.document &&
                        iframe.contentWindow.document.documentElement
                    ) {
                        _this.tree = parseTree(
                            context,
                            iframe.contentWindow.document.documentElement,
                        );
                        // http://www.w3.org/TR/css3-background/#special-backgrounds
                        var documentBackgroundColor = iframe.contentWindow
                            .document.documentElement
                            ? parseColor(
                                  context,
                                  getComputedStyle(
                                      iframe.contentWindow.document
                                          .documentElement,
                                  ).backgroundColor,
                              )
                            : COLORS.TRANSPARENT;
                        var bodyBackgroundColor = iframe.contentWindow.document
                            .body
                            ? parseColor(
                                  context,
                                  getComputedStyle(
                                      iframe.contentWindow.document.body,
                                  ).backgroundColor,
                              )
                            : COLORS.TRANSPARENT;
                        _this.backgroundColor = isTransparent(
                            documentBackgroundColor,
                        )
                            ? isTransparent(bodyBackgroundColor)
                                ? _this.styles.backgroundColor
                                : bodyBackgroundColor
                            : documentBackgroundColor;
                    }
                } catch (e) {}
                return _this;
            }
            return IFrameElementContainer;
        })(ElementContainer);
        var LIST_OWNERS = ["OL", "UL", "MENU"];
        var parseNodeTree = function (context, node, parent, root) {
            for (
                var childNode = node.firstChild, nextNode = void 0;
                childNode;
                childNode = nextNode
            ) {
                nextNode = childNode.nextSibling;
                if (isTextNode(childNode) && childNode.data.trim().length > 0) {
                    parent.textNodes.push(
                        new TextContainer(context, childNode, parent.styles),
                    );
                } else if (isElementNode(childNode)) {
                    if (isSlotElement(childNode) && childNode.assignedNodes) {
                        childNode.assignedNodes().forEach(function (childNode) {
                            return parseNodeTree(
                                context,
                                childNode,
                                parent,
                                root,
                            );
                        });
                    } else {
                        var container = createContainer(context, childNode);
                        if (container.styles.isVisible()) {
                            if (
                                createsRealStackingContext(
                                    childNode,
                                    container,
                                    root,
                                )
                            ) {
                                container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */;
                            } else if (
                                createsStackingContext(container.styles)
                            ) {
                                container.flags |= 2 /* CREATES_STACKING_CONTEXT */;
                            }

                            if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) {
                                container.flags |= 8 /* IS_LIST_OWNER */;
                            }

                            parent.elements.push(container);
                            childNode.slot;
                            if (childNode.shadowRoot) {
                                parseNodeTree(
                                    context,
                                    childNode.shadowRoot,
                                    container,
                                    root,
                                );
                            } else if (
                                !isTextareaElement(childNode) &&
                                !isSVGElement(childNode) &&
                                !isSelectElement(childNode)
                            ) {
                                parseNodeTree(
                                    context,
                                    childNode,
                                    container,
                                    root,
                                );
                            }
                        }
                    }
                }
            }
        };
        var createContainer = function (context, element) {
            if (isImageElement(element)) {
                return new ImageElementContainer(context, element);
            }
            if (isCanvasElement(element)) {
                return new CanvasElementContainer(context, element);
            }
            if (isSVGElement(element)) {
                return new SVGElementContainer(context, element);
            }
            if (isLIElement(element)) {
                return new LIElementContainer(context, element);
            }
            if (isOLElement(element)) {
                return new OLElementContainer(context, element);
            }
            if (isInputElement(element)) {
                return new InputElementContainer(context, element);
            }
            if (isSelectElement(element)) {
                return new SelectElementContainer(context, element);
            }
            if (isTextareaElement(element)) {
                return new TextareaElementContainer(context, element);
            }
            if (isIFrameElement(element)) {
                return new IFrameElementContainer(context, element);
            }
            return new ElementContainer(context, element);
        };
        var parseTree = function (context, element) {
            var container = createContainer(context, element);
            container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */;
            parseNodeTree(context, element, container, container);
            return container;
        };
        var createsRealStackingContext = function (node, container, root) {
            return (
                container.styles.isPositionedWithZIndex() ||
                container.styles.opacity < 1 ||
                container.styles.isTransformed() ||
                (isBodyElement(node) && root.styles.isTransparent())
            );
        };
        var createsStackingContext = function (styles) {
            return styles.isPositioned() || styles.isFloating();
        };
        var isTextNode = function (node) {
            return node.nodeType === Node.TEXT_NODE;
        };
        var isElementNode = function (node) {
            return node.nodeType === Node.ELEMENT_NODE;
        };
        var isHTMLElementNode = function (node) {
            return (
                isElementNode(node) &&
                typeof node.style !== "undefined" &&
                !isSVGElementNode(node)
            );
        };
        var isSVGElementNode = function (element) {
            return typeof element.className === "object";
        };
        var isLIElement = function (node) {
            return node.tagName === "LI";
        };
        var isOLElement = function (node) {
            return node.tagName === "OL";
        };
        var isInputElement = function (node) {
            return node.tagName === "INPUT";
        };
        var isHTMLElement = function (node) {
            return node.tagName === "HTML";
        };
        var isSVGElement = function (node) {
            return node.tagName === "svg";
        };
        var isBodyElement = function (node) {
            return node.tagName === "BODY";
        };
        var isCanvasElement = function (node) {
            return node.tagName === "CANVAS";
        };
        var isVideoElement = function (node) {
            return node.tagName === "VIDEO";
        };
        var isImageElement = function (node) {
            return node.tagName === "IMG";
        };
        var isIFrameElement = function (node) {
            return node.tagName === "IFRAME";
        };
        var isStyleElement = function (node) {
            return node.tagName === "STYLE";
        };
        var isScriptElement = function (node) {
            return node.tagName === "SCRIPT";
        };
        var isTextareaElement = function (node) {
            return node.tagName === "TEXTAREA";
        };
        var isSelectElement = function (node) {
            return node.tagName === "SELECT";
        };
        var isSlotElement = function (node) {
            return node.tagName === "SLOT";
        };
        // https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
        var isCustomElement = function (node) {
            return node.tagName.indexOf("-") > 0;
        };
        var CounterState = /** @class */ (function () {
            function CounterState() {
                this.counters = {};
            }
            CounterState.prototype.getCounterValue = function (name) {
                var counter = this.counters[name];
                if (counter && counter.length) {
                    return counter[counter.length - 1];
                }
                return 1;
            };
            CounterState.prototype.getCounterValues = function (name) {
                var counter = this.counters[name];
                return counter ? counter : [];
            };
            CounterState.prototype.pop = function (counters) {
                var _this = this;
                counters.forEach(function (counter) {
                    return _this.counters[counter].pop();
                });
            };
            CounterState.prototype.parse = function (style) {
                var _this = this;
                var counterIncrement = style.counterIncrement;
                var counterReset = style.counterReset;
                var canReset = true;
                if (counterIncrement !== null) {
                    counterIncrement.forEach(function (entry) {
                        var counter = _this.counters[entry.counter];
                        if (counter && entry.increment !== 0) {
                            canReset = false;
                            if (!counter.length) {
                                counter.push(1);
                            }
                            counter[Math.max(0, counter.length - 1)] +=
                                entry.increment;
                        }
                    });
                }
                var counterNames = [];
                if (canReset) {
                    counterReset.forEach(function (entry) {
                        var counter = _this.counters[entry.counter];
                        counterNames.push(entry.counter);
                        if (!counter) {
                            counter = _this.counters[entry.counter] = [];
                        }
                        counter.push(entry.reset);
                    });
                }
                return counterNames;
            };
            return CounterState;
        })();
        var ROMAN_UPPER = {
            integers: [1000, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1],
            values: [
                "M",
                "CM",
                "D",
                "CD",
                "C",
                "XC",
                "L",
                "XL",
                "X",
                "IX",
                "V",
                "IV",
                "I",
            ],
        };
        var ARMENIAN = {
            integers: [
                9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 900, 800,
                700, 600, 500, 400, 300, 200, 100, 90, 80, 70, 60, 50, 40, 30,
                20, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1,
            ],
            values: [
                "Ք",
                "Փ",
                "Ւ",
                "Ց",
                "Ր",
                "Տ",
                "Վ",
                "Ս",
                "Ռ",
                "Ջ",
                "Պ",
                "Չ",
                "Ո",
                "Շ",
                "Ն",
                "Յ",
                "Մ",
                "Ճ",
                "Ղ",
                "Ձ",
                "Հ",
                "Կ",
                "Ծ",
                "Խ",
                "Լ",
                "Ի",
                "Ժ",
                "Թ",
                "Ը",
                "Է",
                "Զ",
                "Ե",
                "Դ",
                "Գ",
                "Բ",
                "Ա",
            ],
        };
        var HEBREW = {
            integers: [
                10000, 9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000,
                400, 300, 200, 100, 90, 80, 70, 60, 50, 40, 30, 20, 19, 18, 17,
                16, 15, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1,
            ],
            values: [
                "י׳",
                "ט׳",
                "ח׳",
                "ז׳",
                "ו׳",
                "ה׳",
                "ד׳",
                "ג׳",
                "ב׳",
                "א׳",
                "ת",
                "ש",
                "ר",
                "ק",
                "צ",
                "פ",
                "ע",
                "ס",
                "נ",
                "מ",
                "ל",
                "כ",
                "יט",
                "יח",
                "יז",
                "טז",
                "טו",
                "י",
                "ט",
                "ח",
                "ז",
                "ו",
                "ה",
                "ד",
                "ג",
                "ב",
                "א",
            ],
        };
        var GEORGIAN = {
            integers: [
                10000, 9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000,
                900, 800, 700, 600, 500, 400, 300, 200, 100, 90, 80, 70, 60, 50,
                40, 30, 20, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1,
            ],
            values: [
                "ჵ",
                "ჰ",
                "ჯ",
                "ჴ",
                "ხ",
                "ჭ",
                "წ",
                "ძ",
                "ც",
                "ჩ",
                "შ",
                "ყ",
                "ღ",
                "ქ",
                "ფ",
                "ჳ",
                "ტ",
                "ს",
                "რ",
                "ჟ",
                "პ",
                "ო",
                "ჲ",
                "ნ",
                "მ",
                "ლ",
                "კ",
                "ი",
                "თ",
                "ჱ",
                "ზ",
                "ვ",
                "ე",
                "დ",
                "გ",
                "ბ",
                "ა",
            ],
        };
        var createAdditiveCounter = function (
            value,
            min,
            max,
            symbols,
            fallback,
            suffix,
        ) {
            if (value < min || value > max) {
                return createCounterText(value, fallback, suffix.length > 0);
            }
            return (
                symbols.integers.reduce(function (string, integer, index) {
                    while (value >= integer) {
                        value -= integer;
                        string += symbols.values[index];
                    }
                    return string;
                }, "") + suffix
            );
        };
        var createCounterStyleWithSymbolResolver = function (
            value,
            codePointRangeLength,
            isNumeric,
            resolver,
        ) {
            var string = "";
            do {
                if (!isNumeric) {
                    value--;
                }
                string = resolver(value) + string;
                value /= codePointRangeLength;
            } while (value * codePointRangeLength >= codePointRangeLength);
            return string;
        };
        var createCounterStyleFromRange = function (
            value,
            codePointRangeStart,
            codePointRangeEnd,
            isNumeric,
            suffix,
        ) {
            var codePointRangeLength =
                codePointRangeEnd - codePointRangeStart + 1;
            return (
                (value < 0 ? "-" : "") +
                (createCounterStyleWithSymbolResolver(
                    Math.abs(value),
                    codePointRangeLength,
                    isNumeric,
                    function (codePoint) {
                        return fromCodePoint$1(
                            Math.floor(codePoint % codePointRangeLength) +
                                codePointRangeStart,
                        );
                    },
                ) +
                    suffix)
            );
        };
        var createCounterStyleFromSymbols = function (value, symbols, suffix) {
            if (suffix === void 0) {
                suffix = ". ";
            }
            var codePointRangeLength = symbols.length;
            return (
                createCounterStyleWithSymbolResolver(
                    Math.abs(value),
                    codePointRangeLength,
                    false,
                    function (codePoint) {
                        return symbols[
                            Math.floor(codePoint % codePointRangeLength)
                        ];
                    },
                ) + suffix
            );
        };
        var CJK_ZEROS = 1 << 0;
        var CJK_TEN_COEFFICIENTS = 1 << 1;
        var CJK_TEN_HIGH_COEFFICIENTS = 1 << 2;
        var CJK_HUNDRED_COEFFICIENTS = 1 << 3;
        var createCJKCounter = function (
            value,
            numbers,
            multipliers,
            negativeSign,
            suffix,
            flags,
        ) {
            if (value < -9999 || value > 9999) {
                return createCounterText(
                    value,
                    4 /* CJK_DECIMAL */,
                    suffix.length > 0,
                );
            }
            var tmp = Math.abs(value);
            var string = suffix;
            if (tmp === 0) {
                return numbers[0] + string;
            }
            for (var digit = 0; tmp > 0 && digit <= 4; digit++) {
                var coefficient = tmp % 10;
                if (
                    coefficient === 0 &&
                    contains(flags, CJK_ZEROS) &&
                    string !== ""
                ) {
                    string = numbers[coefficient] + string;
                } else if (
                    coefficient > 1 ||
                    (coefficient === 1 && digit === 0) ||
                    (coefficient === 1 &&
                        digit === 1 &&
                        contains(flags, CJK_TEN_COEFFICIENTS)) ||
                    (coefficient === 1 &&
                        digit === 1 &&
                        contains(flags, CJK_TEN_HIGH_COEFFICIENTS) &&
                        value > 100) ||
                    (coefficient === 1 &&
                        digit > 1 &&
                        contains(flags, CJK_HUNDRED_COEFFICIENTS))
                ) {
                    string =
                        numbers[coefficient] +
                        (digit > 0 ? multipliers[digit - 1] : "") +
                        string;
                } else if (coefficient === 1 && digit > 0) {
                    string = multipliers[digit - 1] + string;
                }
                tmp = Math.floor(tmp / 10);
            }
            return (value < 0 ? negativeSign : "") + string;
        };
        var CHINESE_INFORMAL_MULTIPLIERS = "十百千萬";
        var CHINESE_FORMAL_MULTIPLIERS = "拾佰仟萬";
        var JAPANESE_NEGATIVE = "マイナス";
        var KOREAN_NEGATIVE = "마이너스";
        var createCounterText = function (value, type, appendSuffix) {
            var defaultSuffix = appendSuffix ? ". " : "";
            var cjkSuffix = appendSuffix ? "、" : "";
            var koreanSuffix = appendSuffix ? ", " : "";
            var spaceSuffix = appendSuffix ? " " : "";
            switch (type) {
                case 0 /* DISC */:
                    return "•" + spaceSuffix;
                case 1 /* CIRCLE */:
                    return "◦" + spaceSuffix;
                case 2 /* SQUARE */:
                    return "◾" + spaceSuffix;
                case 5 /* DECIMAL_LEADING_ZERO */:
                    var string = createCounterStyleFromRange(
                        value,
                        48,
                        57,
                        true,
                        defaultSuffix,
                    );
                    return string.length < 4 ? "0" + string : string;
                case 4 /* CJK_DECIMAL */:
                    return createCounterStyleFromSymbols(
                        value,
                        "〇一二三四五六七八九",
                        cjkSuffix,
                    );
                case 6 /* LOWER_ROMAN */:
                    return createAdditiveCounter(
                        value,
                        1,
                        3999,
                        ROMAN_UPPER,
                        3 /* DECIMAL */,
                        defaultSuffix,
                    ).toLowerCase();
                case 7 /* UPPER_ROMAN */:
                    return createAdditiveCounter(
                        value,
                        1,
                        3999,
                        ROMAN_UPPER,
                        3 /* DECIMAL */,
                        defaultSuffix,
                    );
                case 8 /* LOWER_GREEK */:
                    return createCounterStyleFromRange(
                        value,
                        945,
                        969,
                        false,
                        defaultSuffix,
                    );
                case 9 /* LOWER_ALPHA */:
                    return createCounterStyleFromRange(
                        value,
                        97,
                        122,
                        false,
                        defaultSuffix,
                    );
                case 10 /* UPPER_ALPHA */:
                    return createCounterStyleFromRange(
                        value,
                        65,
                        90,
                        false,
                        defaultSuffix,
                    );
                case 11 /* ARABIC_INDIC */:
                    return createCounterStyleFromRange(
                        value,
                        1632,
                        1641,
                        true,
                        defaultSuffix,
                    );
                case 12 /* ARMENIAN */:
                case 49 /* UPPER_ARMENIAN */:
                    return createAdditiveCounter(
                        value,
                        1,
                        9999,
                        ARMENIAN,
                        3 /* DECIMAL */,
                        defaultSuffix,
                    );
                case 35 /* LOWER_ARMENIAN */:
                    return createAdditiveCounter(
                        value,
                        1,
                        9999,
                        ARMENIAN,
                        3 /* DECIMAL */,
                        defaultSuffix,
                    ).toLowerCase();
                case 13 /* BENGALI */:
                    return createCounterStyleFromRange(
                        value,
                        2534,
                        2543,
                        true,
                        defaultSuffix,
                    );
                case 14 /* CAMBODIAN */:
                case 30 /* KHMER */:
                    return createCounterStyleFromRange(
                        value,
                        6112,
                        6121,
                        true,
                        defaultSuffix,
                    );
                case 15 /* CJK_EARTHLY_BRANCH */:
                    return createCounterStyleFromSymbols(
                        value,
                        "子丑寅卯辰巳午未申酉戌亥",
                        cjkSuffix,
                    );
                case 16 /* CJK_HEAVENLY_STEM */:
                    return createCounterStyleFromSymbols(
                        value,
                        "甲乙丙丁戊己庚辛壬癸",
                        cjkSuffix,
                    );
                case 17 /* CJK_IDEOGRAPHIC */:
                case 48 /* TRAD_CHINESE_INFORMAL */:
                    return createCJKCounter(
                        value,
                        "零一二三四五六七八九",
                        CHINESE_INFORMAL_MULTIPLIERS,
                        "負",
                        cjkSuffix,
                        CJK_TEN_COEFFICIENTS |
                            CJK_TEN_HIGH_COEFFICIENTS |
                            CJK_HUNDRED_COEFFICIENTS,
                    );
                case 47 /* TRAD_CHINESE_FORMAL */:
                    return createCJKCounter(
                        value,
                        "零壹貳參肆伍陸柒捌玖",
                        CHINESE_FORMAL_MULTIPLIERS,
                        "負",
                        cjkSuffix,
                        CJK_ZEROS |
                            CJK_TEN_COEFFICIENTS |
                            CJK_TEN_HIGH_COEFFICIENTS |
                            CJK_HUNDRED_COEFFICIENTS,
                    );
                case 42 /* SIMP_CHINESE_INFORMAL */:
                    return createCJKCounter(
                        value,
                        "零一二三四五六七八九",
                        CHINESE_INFORMAL_MULTIPLIERS,
                        "负",
                        cjkSuffix,
                        CJK_TEN_COEFFICIENTS |
                            CJK_TEN_HIGH_COEFFICIENTS |
                            CJK_HUNDRED_COEFFICIENTS,
                    );
                case 41 /* SIMP_CHINESE_FORMAL */:
                    return createCJKCounter(
                        value,
                        "零壹贰叁肆伍陆柒捌玖",
                        CHINESE_FORMAL_MULTIPLIERS,
                        "负",
                        cjkSuffix,
                        CJK_ZEROS |
                            CJK_TEN_COEFFICIENTS |
                            CJK_TEN_HIGH_COEFFICIENTS |
                            CJK_HUNDRED_COEFFICIENTS,
                    );
                case 26 /* JAPANESE_INFORMAL */:
                    return createCJKCounter(
                        value,
                        "〇一二三四五六七八九",
                        "十百千万",
                        JAPANESE_NEGATIVE,
                        cjkSuffix,
                        0,
                    );
                case 25 /* JAPANESE_FORMAL */:
                    return createCJKCounter(
                        value,
                        "零壱弐参四伍六七八九",
                        "拾百千万",
                        JAPANESE_NEGATIVE,
                        cjkSuffix,
                        CJK_ZEROS |
                            CJK_TEN_COEFFICIENTS |
                            CJK_TEN_HIGH_COEFFICIENTS,
                    );
                case 31 /* KOREAN_HANGUL_FORMAL */:
                    return createCJKCounter(
                        value,
                        "영일이삼사오육칠팔구",
                        "십백천만",
                        KOREAN_NEGATIVE,
                        koreanSuffix,
                        CJK_ZEROS |
                            CJK_TEN_COEFFICIENTS |
                            CJK_TEN_HIGH_COEFFICIENTS,
                    );
                case 33 /* KOREAN_HANJA_INFORMAL */:
                    return createCJKCounter(
                        value,
                        "零一二三四五六七八九",
                        "十百千萬",
                        KOREAN_NEGATIVE,
                        koreanSuffix,
                        0,
                    );
                case 32 /* KOREAN_HANJA_FORMAL */:
                    return createCJKCounter(
                        value,
                        "零壹貳參四五六七八九",
                        "拾百千",
                        KOREAN_NEGATIVE,
                        koreanSuffix,
                        CJK_ZEROS |
                            CJK_TEN_COEFFICIENTS |
                            CJK_TEN_HIGH_COEFFICIENTS,
                    );
                case 18 /* DEVANAGARI */:
                    return createCounterStyleFromRange(
                        value,
                        0x966,
                        0x96f,
                        true,
                        defaultSuffix,
                    );
                case 20 /* GEORGIAN */:
                    return createAdditiveCounter(
                        value,
                        1,
                        19999,
                        GEORGIAN,
                        3 /* DECIMAL */,
                        defaultSuffix,
                    );
                case 21 /* GUJARATI */:
                    return createCounterStyleFromRange(
                        value,
                        0xae6,
                        0xaef,
                        true,
                        defaultSuffix,
                    );
                case 22 /* GURMUKHI */:
                    return createCounterStyleFromRange(
                        value,
                        0xa66,
                        0xa6f,
                        true,
                        defaultSuffix,
                    );
                case 22 /* HEBREW */:
                    return createAdditiveCounter(
                        value,
                        1,
                        10999,
                        HEBREW,
                        3 /* DECIMAL */,
                        defaultSuffix,
                    );
                case 23 /* HIRAGANA */:
                    return createCounterStyleFromSymbols(
                        value,
                        "あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわゐゑをん",
                    );
                case 24 /* HIRAGANA_IROHA */:
                    return createCounterStyleFromSymbols(
                        value,
                        "いろはにほへとちりぬるをわかよたれそつねならむうゐのおくやまけふこえてあさきゆめみしゑひもせす",
                    );
                case 27 /* KANNADA */:
                    return createCounterStyleFromRange(
                        value,
                        0xce6,
                        0xcef,
                        true,
                        defaultSuffix,
                    );
                case 28 /* KATAKANA */:
                    return createCounterStyleFromSymbols(
                        value,
                        "アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヰヱヲン",
                        cjkSuffix,
                    );
                case 29 /* KATAKANA_IROHA */:
                    return createCounterStyleFromSymbols(
                        value,
                        "イロハニホヘトチリヌルヲワカヨタレソツネナラムウヰノオクヤマケフコエテアサキユメミシヱヒモセス",
                        cjkSuffix,
                    );
                case 34 /* LAO */:
                    return createCounterStyleFromRange(
                        value,
                        0xed0,
                        0xed9,
                        true,
                        defaultSuffix,
                    );
                case 37 /* MONGOLIAN */:
                    return createCounterStyleFromRange(
                        value,
                        0x1810,
                        0x1819,
                        true,
                        defaultSuffix,
                    );
                case 38 /* MYANMAR */:
                    return createCounterStyleFromRange(
                        value,
                        0x1040,
                        0x1049,
                        true,
                        defaultSuffix,
                    );
                case 39 /* ORIYA */:
                    return createCounterStyleFromRange(
                        value,
                        0xb66,
                        0xb6f,
                        true,
                        defaultSuffix,
                    );
                case 40 /* PERSIAN */:
                    return createCounterStyleFromRange(
                        value,
                        0x6f0,
                        0x6f9,
                        true,
                        defaultSuffix,
                    );
                case 43 /* TAMIL */:
                    return createCounterStyleFromRange(
                        value,
                        0xbe6,
                        0xbef,
                        true,
                        defaultSuffix,
                    );
                case 44 /* TELUGU */:
                    return createCounterStyleFromRange(
                        value,
                        0xc66,
                        0xc6f,
                        true,
                        defaultSuffix,
                    );
                case 45 /* THAI */:
                    return createCounterStyleFromRange(
                        value,
                        0xe50,
                        0xe59,
                        true,
                        defaultSuffix,
                    );
                case 46 /* TIBETAN */:
                    return createCounterStyleFromRange(
                        value,
                        0xf20,
                        0xf29,
                        true,
                        defaultSuffix,
                    );
                case 3 /* DECIMAL */:
                default:
                    return createCounterStyleFromRange(
                        value,
                        48,
                        57,
                        true,
                        defaultSuffix,
                    );
            }
        };
        var IGNORE_ATTRIBUTE = "data-html2canvas-ignore";
        var DocumentCloner = /** @class */ (function () {
            function DocumentCloner(context, element, options) {
                this.context = context;
                this.options = options;
                this.scrolledElements = [];
                this.referenceElement = element;
                this.counters = new CounterState();
                this.quoteDepth = 0;
                if (!element.ownerDocument) {
                    throw new Error(
                        "Cloned element does not have an owner document",
                    );
                }
                this.documentElement = this.cloneNode(
                    element.ownerDocument.documentElement,
                    false,
                );
            }
            DocumentCloner.prototype.toIFrame = function (
                ownerDocument,
                windowSize,
            ) {
                var _this = this;
                var iframe = createIFrameContainer(ownerDocument, windowSize);
                if (!iframe.contentWindow) {
                    return Promise.reject("Unable to find iframe window");
                }
                var scrollX = ownerDocument.defaultView.pageXOffset;
                var scrollY = ownerDocument.defaultView.pageYOffset;
                var cloneWindow = iframe.contentWindow;
                var documentClone = cloneWindow.document;
                /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
         if window url is about:blank, we can assign the url to current by writing onto the document
         */
                var iframeLoad = iframeLoader(iframe).then(function () {
                    return __awaiter(_this, void 0, void 0, function () {
                        var onclone, referenceElement;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    this.scrolledElements.forEach(
                                        restoreNodeScroll,
                                    );
                                    if (cloneWindow) {
                                        cloneWindow.scrollTo(
                                            windowSize.left,
                                            windowSize.top,
                                        );
                                        if (
                                            /(iPad|iPhone|iPod)/g.test(
                                                navigator.userAgent,
                                            ) &&
                                            (cloneWindow.scrollY !==
                                                windowSize.top ||
                                                cloneWindow.scrollX !==
                                                    windowSize.left)
                                        ) {
                                            this.context.logger.warn(
                                                "Unable to restore scroll position for cloned document",
                                            );
                                            this.context.windowBounds =
                                                this.context.windowBounds.add(
                                                    cloneWindow.scrollX -
                                                        windowSize.left,
                                                    cloneWindow.scrollY -
                                                        windowSize.top,
                                                    0,
                                                    0,
                                                );
                                        }
                                    }
                                    onclone = this.options.onclone;
                                    referenceElement =
                                        this.clonedReferenceElement;
                                    if (
                                        typeof referenceElement === "undefined"
                                    ) {
                                        return [
                                            2 /*return*/,
                                            Promise.reject(
                                                "Error finding the " +
                                                    this.referenceElement
                                                        .nodeName +
                                                    " in the cloned document",
                                            ),
                                        ];
                                    }
                                    if (
                                        !(
                                            documentClone.fonts &&
                                            documentClone.fonts.ready
                                        )
                                    )
                                        return [3 /*break*/, 2];
                                    return [
                                        4 /*yield*/,
                                        documentClone.fonts.ready,
                                    ];
                                case 1:
                                    _a.sent();
                                    _a.label = 2;
                                case 2:
                                    if (
                                        !/(AppleWebKit)/g.test(
                                            navigator.userAgent,
                                        )
                                    )
                                        return [3 /*break*/, 4];
                                    return [
                                        4 /*yield*/,
                                        imagesReady(documentClone),
                                    ];
                                case 3:
                                    _a.sent();
                                    _a.label = 4;
                                case 4:
                                    if (typeof onclone === "function") {
                                        return [
                                            2 /*return*/,
                                            Promise.resolve()
                                                .then(function () {
                                                    return onclone(
                                                        documentClone,
                                                        referenceElement,
                                                    );
                                                })
                                                .then(function () {
                                                    return iframe;
                                                }),
                                        ];
                                    }
                                    return [2 /*return*/, iframe];
                            }
                        });
                    });
                });
                documentClone.open();
                documentClone.write(
                    serializeDoctype(document.doctype) + "<html></html>",
                );
                // Chrome scrolls the parent document for some reason after the write to the cloned window???
                restoreOwnerScroll(
                    this.referenceElement.ownerDocument,
                    scrollX,
                    scrollY,
                );
                documentClone.replaceChild(
                    documentClone.adoptNode(this.documentElement),
                    documentClone.documentElement,
                );
                documentClone.close();
                return iframeLoad;
            };
            DocumentCloner.prototype.createElementClone = function (node) {
                if (isDebugging(node, 2 /* CLONE */)) {
                    debugger;
                }
                if (isCanvasElement(node)) {
                    return this.createCanvasClone(node);
                }
                if (isVideoElement(node)) {
                    return this.createVideoClone(node);
                }
                if (isStyleElement(node)) {
                    return this.createStyleClone(node);
                }
                var clone = node.cloneNode(false);
                if (isImageElement(clone)) {
                    if (
                        isImageElement(node) &&
                        node.currentSrc &&
                        node.currentSrc !== node.src
                    ) {
                        clone.src = node.currentSrc;
                        clone.srcset = "";
                    }
                    if (clone.loading === "lazy") {
                        clone.loading = "eager";
                    }
                }
                if (isCustomElement(clone)) {
                    return this.createCustomElementClone(clone);
                }
                return clone;
            };
            DocumentCloner.prototype.createCustomElementClone = function (
                node,
            ) {
                var clone = document.createElement("html2canvascustomelement");
                copyCSSStyles(node.style, clone);
                return clone;
            };
            DocumentCloner.prototype.createStyleClone = function (node) {
                try {
                    var sheet = node.sheet;
                    if (sheet && sheet.cssRules) {
                        var css = [].slice
                            .call(sheet.cssRules, 0)
                            .reduce(function (css, rule) {
                                if (rule && typeof rule.cssText === "string") {
                                    return css + rule.cssText;
                                }
                                return css;
                            }, "");
                        var style = node.cloneNode(false);
                        style.textContent = css;
                        return style;
                    }
                } catch (e) {
                    // accessing node.sheet.cssRules throws a DOMException
                    this.context.logger.error(
                        "Unable to access cssRules property",
                        e,
                    );
                    if (e.name !== "SecurityError") {
                        throw e;
                    }
                }
                return node.cloneNode(false);
            };
            DocumentCloner.prototype.createCanvasClone = function (canvas) {
                var _a;
                if (this.options.inlineImages && canvas.ownerDocument) {
                    var img = canvas.ownerDocument.createElement("img");
                    try {
                        img.src = canvas.toDataURL();
                        return img;
                    } catch (e) {
                        this.context.logger.info(
                            "Unable to inline canvas contents, canvas is tainted",
                            canvas,
                        );
                    }
                }
                var clonedCanvas = canvas.cloneNode(false);
                try {
                    clonedCanvas.width = canvas.width;
                    clonedCanvas.height = canvas.height;
                    var ctx = canvas.getContext("2d");
                    var clonedCtx = clonedCanvas.getContext("2d");
                    if (clonedCtx) {
                        if (!this.options.allowTaint && ctx) {
                            clonedCtx.putImageData(
                                ctx.getImageData(
                                    0,
                                    0,
                                    canvas.width,
                                    canvas.height,
                                ),
                                0,
                                0,
                            );
                        } else {
                            var gl =
                                (_a = canvas.getContext("webgl2")) !== null &&
                                _a !== void 0
                                    ? _a
                                    : canvas.getContext("webgl");
                            if (gl) {
                                var attribs = gl.getContextAttributes();
                                if (
                                    (attribs === null || attribs === void 0
                                        ? void 0
                                        : attribs.preserveDrawingBuffer) ===
                                    false
                                ) {
                                    this.context.logger.warn(
                                        "Unable to clone WebGL context as it has preserveDrawingBuffer=false",
                                        canvas,
                                    );
                                }
                            }
                            clonedCtx.drawImage(canvas, 0, 0);
                        }
                    }
                    return clonedCanvas;
                } catch (e) {
                    this.context.logger.info(
                        "Unable to clone canvas as it is tainted",
                        canvas,
                    );
                }
                return clonedCanvas;
            };
            DocumentCloner.prototype.createVideoClone = function (video) {
                var canvas = video.ownerDocument.createElement("canvas");
                canvas.width = video.offsetWidth;
                canvas.height = video.offsetHeight;
                var ctx = canvas.getContext("2d");
                try {
                    if (ctx) {
                        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                        if (!this.options.allowTaint) {
                            ctx.getImageData(0, 0, canvas.width, canvas.height);
                        }
                    }
                    return canvas;
                } catch (e) {
                    this.context.logger.info(
                        "Unable to clone video as it is tainted",
                        video,
                    );
                }
                var blankCanvas = video.ownerDocument.createElement("canvas");
                blankCanvas.width = video.offsetWidth;
                blankCanvas.height = video.offsetHeight;
                return blankCanvas;
            };
            DocumentCloner.prototype.appendChildNode = function (
                clone,
                child,
                copyStyles,
            ) {
                if (
                    !isElementNode(child) ||
                    (!isScriptElement(child) &&
                        !child.hasAttribute(IGNORE_ATTRIBUTE) &&
                        (typeof this.options.ignoreElements !== "function" ||
                            !this.options.ignoreElements(child)))
                ) {
                    if (
                        !this.options.copyStyles ||
                        !isElementNode(child) ||
                        !isStyleElement(child)
                    ) {
                        clone.appendChild(this.cloneNode(child, copyStyles));
                    }
                }
            };
            DocumentCloner.prototype.cloneChildNodes = function (
                node,
                clone,
                copyStyles,
            ) {
                var _this = this;
                for (
                    var child = node.shadowRoot
                        ? node.shadowRoot.firstChild
                        : node.firstChild;
                    child;
                    child = child.nextSibling
                ) {
                    if (
                        isElementNode(child) &&
                        isSlotElement(child) &&
                        typeof child.assignedNodes === "function"
                    ) {
                        var assignedNodes = child.assignedNodes();
                        if (assignedNodes.length) {
                            assignedNodes.forEach(function (assignedNode) {
                                return _this.appendChildNode(
                                    clone,
                                    assignedNode,
                                    copyStyles,
                                );
                            });
                        }
                    } else {
                        this.appendChildNode(clone, child, copyStyles);
                    }
                }
            };
            DocumentCloner.prototype.cloneNode = function (node, copyStyles) {
                if (isTextNode(node)) {
                    return document.createTextNode(node.data);
                }
                if (!node.ownerDocument) {
                    return node.cloneNode(false);
                }
                var window = node.ownerDocument.defaultView;
                if (
                    window &&
                    isElementNode(node) &&
                    (isHTMLElementNode(node) || isSVGElementNode(node))
                ) {
                    var clone = this.createElementClone(node);
                    clone.style.transitionProperty = "none";
                    var style = window.getComputedStyle(node);
                    var styleBefore = window.getComputedStyle(node, ":before");
                    var styleAfter = window.getComputedStyle(node, ":after");
                    if (
                        this.referenceElement === node &&
                        isHTMLElementNode(clone)
                    ) {
                        this.clonedReferenceElement = clone;
                    }
                    if (isBodyElement(clone)) {
                        createPseudoHideStyles(clone);
                    }
                    var counters = this.counters.parse(
                        new CSSParsedCounterDeclaration(this.context, style),
                    );
                    var before = this.resolvePseudoContent(
                        node,
                        clone,
                        styleBefore,
                        PseudoElementType.BEFORE,
                    );
                    if (isCustomElement(node)) {
                        copyStyles = true;
                    }
                    if (!isVideoElement(node)) {
                        this.cloneChildNodes(node, clone, copyStyles);
                    }
                    if (before) {
                        clone.insertBefore(before, clone.firstChild);
                    }
                    var after = this.resolvePseudoContent(
                        node,
                        clone,
                        styleAfter,
                        PseudoElementType.AFTER,
                    );
                    if (after) {
                        clone.appendChild(after);
                    }
                    this.counters.pop(counters);
                    if (
                        (style &&
                            (this.options.copyStyles ||
                                isSVGElementNode(node)) &&
                            !isIFrameElement(node)) ||
                        copyStyles
                    ) {
                        copyCSSStyles(style, clone);
                    }
                    if (node.scrollTop !== 0 || node.scrollLeft !== 0) {
                        this.scrolledElements.push([
                            clone,
                            node.scrollLeft,
                            node.scrollTop,
                        ]);
                    }
                    if (
                        (isTextareaElement(node) || isSelectElement(node)) &&
                        (isTextareaElement(clone) || isSelectElement(clone))
                    ) {
                        clone.value = node.value;
                    }
                    return clone;
                }
                return node.cloneNode(false);
            };
            DocumentCloner.prototype.resolvePseudoContent = function (
                node,
                clone,
                style,
                pseudoElt,
            ) {
                var _this = this;
                if (!style) {
                    return;
                }
                var value = style.content;
                var document = clone.ownerDocument;
                if (
                    !document ||
                    !value ||
                    value === "none" ||
                    value === "-moz-alt-content" ||
                    style.display === "none"
                ) {
                    return;
                }
                this.counters.parse(
                    new CSSParsedCounterDeclaration(this.context, style),
                );
                var declaration = new CSSParsedPseudoDeclaration(
                    this.context,
                    style,
                );
                var anonymousReplacedElement = document.createElement(
                    "html2canvaspseudoelement",
                );
                copyCSSStyles(style, anonymousReplacedElement);
                declaration.content.forEach(function (token) {
                    if (token.type === 0 /* STRING_TOKEN */) {
                        anonymousReplacedElement.appendChild(
                            document.createTextNode(token.value),
                        );
                    } else if (token.type === 22 /* URL_TOKEN */) {
                        var img = document.createElement("img");
                        img.src = token.value;
                        img.style.opacity = "1";
                        anonymousReplacedElement.appendChild(img);
                    } else if (token.type === 18 /* FUNCTION */) {
                        if (token.name === "attr") {
                            var attr = token.values.filter(isIdentToken);
                            if (attr.length) {
                                anonymousReplacedElement.appendChild(
                                    document.createTextNode(
                                        node.getAttribute(attr[0].value) || "",
                                    ),
                                );
                            }
                        } else if (token.name === "counter") {
                            var _a = token.values.filter(
                                    nonFunctionArgSeparator,
                                ),
                                counter = _a[0],
                                counterStyle = _a[1];
                            if (counter && isIdentToken(counter)) {
                                var counterState =
                                    _this.counters.getCounterValue(
                                        counter.value,
                                    );
                                var counterType =
                                    counterStyle && isIdentToken(counterStyle)
                                        ? listStyleType.parse(
                                              _this.context,
                                              counterStyle.value,
                                          )
                                        : 3; /* DECIMAL */
                                anonymousReplacedElement.appendChild(
                                    document.createTextNode(
                                        createCounterText(
                                            counterState,
                                            counterType,
                                            false,
                                        ),
                                    ),
                                );
                            }
                        } else if (token.name === "counters") {
                            var _b = token.values.filter(
                                    nonFunctionArgSeparator,
                                ),
                                counter = _b[0],
                                delim = _b[1],
                                counterStyle = _b[2];
                            if (counter && isIdentToken(counter)) {
                                var counterStates =
                                    _this.counters.getCounterValues(
                                        counter.value,
                                    );
                                var counterType_1 =
                                    counterStyle && isIdentToken(counterStyle)
                                        ? listStyleType.parse(
                                              _this.context,
                                              counterStyle.value,
                                          )
                                        : 3; /* DECIMAL */
                                var separator =
                                    delim && delim.type === 0 /* STRING_TOKEN */
                                        ? delim.value
                                        : "";
                                var text = counterStates
                                    .map(function (value) {
                                        return createCounterText(
                                            value,
                                            counterType_1,
                                            false,
                                        );
                                    })
                                    .join(separator);
                                anonymousReplacedElement.appendChild(
                                    document.createTextNode(text),
                                );
                            }
                        } else;
                    } else if (token.type === 20 /* IDENT_TOKEN */) {
                        switch (token.value) {
                            case "open-quote":
                                anonymousReplacedElement.appendChild(
                                    document.createTextNode(
                                        getQuote(
                                            declaration.quotes,
                                            _this.quoteDepth++,
                                            true,
                                        ),
                                    ),
                                );
                                break;
                            case "close-quote":
                                anonymousReplacedElement.appendChild(
                                    document.createTextNode(
                                        getQuote(
                                            declaration.quotes,
                                            --_this.quoteDepth,
                                            false,
                                        ),
                                    ),
                                );
                                break;
                            default:
                                // safari doesn't parse string tokens correctly because of lack of quotes
                                anonymousReplacedElement.appendChild(
                                    document.createTextNode(token.value),
                                );
                        }
                    }
                });
                anonymousReplacedElement.className =
                    PSEUDO_HIDE_ELEMENT_CLASS_BEFORE +
                    " " +
                    PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
                var newClassName =
                    pseudoElt === PseudoElementType.BEFORE
                        ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE
                        : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
                if (isSVGElementNode(clone)) {
                    clone.className.baseValue += newClassName;
                } else {
                    clone.className += newClassName;
                }
                return anonymousReplacedElement;
            };
            DocumentCloner.destroy = function (container) {
                if (container.parentNode) {
                    container.parentNode.removeChild(container);
                    return true;
                }
                return false;
            };
            return DocumentCloner;
        })();
        var PseudoElementType;
        (function (PseudoElementType) {
            PseudoElementType[(PseudoElementType["BEFORE"] = 0)] = "BEFORE";
            PseudoElementType[(PseudoElementType["AFTER"] = 1)] = "AFTER";
        })(PseudoElementType || (PseudoElementType = {}));
        var createIFrameContainer = function (ownerDocument, bounds) {
            var cloneIframeContainer = ownerDocument.createElement("iframe");
            cloneIframeContainer.className = "html2canvas-container";
            cloneIframeContainer.style.visibility = "hidden";
            cloneIframeContainer.style.position = "fixed";
            cloneIframeContainer.style.left = "-10000px";
            cloneIframeContainer.style.top = "0px";
            cloneIframeContainer.style.border = "0";
            cloneIframeContainer.width = bounds.width.toString();
            cloneIframeContainer.height = bounds.height.toString();
            cloneIframeContainer.scrolling = "no"; // ios won't scroll without it
            cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, "true");
            ownerDocument.body.appendChild(cloneIframeContainer);
            return cloneIframeContainer;
        };
        var imageReady = function (img) {
            return new Promise(function (resolve) {
                if (img.complete) {
                    resolve();
                    return;
                }
                if (!img.src) {
                    resolve();
                    return;
                }
                img.onload = resolve;
                img.onerror = resolve;
            });
        };
        var imagesReady = function (document) {
            return Promise.all(
                [].slice.call(document.images, 0).map(imageReady),
            );
        };
        var iframeLoader = function (iframe) {
            return new Promise(function (resolve, reject) {
                var cloneWindow = iframe.contentWindow;
                if (!cloneWindow) {
                    return reject("No window assigned for iframe");
                }
                var documentClone = cloneWindow.document;
                cloneWindow.onload = iframe.onload = function () {
                    cloneWindow.onload = iframe.onload = null;
                    var interval = setInterval(function () {
                        if (
                            documentClone.body.childNodes.length > 0 &&
                            documentClone.readyState === "complete"
                        ) {
                            clearInterval(interval);
                            resolve(iframe);
                        }
                    }, 50);
                };
            });
        };
        var ignoredStyleProperties = [
            "all",
            "d",
            "content", // Safari shows pseudoelements if content is set
        ];

        var copyCSSStyles = function (style, target) {
            // Edge does not provide value for cssText
            for (var i = style.length - 1; i >= 0; i--) {
                var property = style.item(i);
                if (ignoredStyleProperties.indexOf(property) === -1) {
                    target.style.setProperty(
                        property,
                        style.getPropertyValue(property),
                    );
                }
            }
            return target;
        };
        var serializeDoctype = function (doctype) {
            var str = "";
            if (doctype) {
                str += "<!DOCTYPE ";
                if (doctype.name) {
                    str += doctype.name;
                }
                if (doctype.internalSubset) {
                    str += doctype.internalSubset;
                }
                if (doctype.publicId) {
                    str += '"' + doctype.publicId + '"';
                }
                if (doctype.systemId) {
                    str += '"' + doctype.systemId + '"';
                }
                str += ">";
            }
            return str;
        };
        var restoreOwnerScroll = function (ownerDocument, x, y) {
            if (
                ownerDocument &&
                ownerDocument.defaultView &&
                (x !== ownerDocument.defaultView.pageXOffset ||
                    y !== ownerDocument.defaultView.pageYOffset)
            ) {
                ownerDocument.defaultView.scrollTo(x, y);
            }
        };
        var restoreNodeScroll = function (_a) {
            var element = _a[0],
                x = _a[1],
                y = _a[2];
            element.scrollLeft = x;
            element.scrollTop = y;
        };
        var PSEUDO_BEFORE = ":before";
        var PSEUDO_AFTER = ":after";
        var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE =
            "___html2canvas___pseudoelement_before";
        var PSEUDO_HIDE_ELEMENT_CLASS_AFTER =
            "___html2canvas___pseudoelement_after";
        var PSEUDO_HIDE_ELEMENT_STYLE =
            '{\n    content: "" !important;\n    display: none !important;\n}';
        var createPseudoHideStyles = function (body) {
            createStyles(
                body,
                "." +
                    PSEUDO_HIDE_ELEMENT_CLASS_BEFORE +
                    PSEUDO_BEFORE +
                    PSEUDO_HIDE_ELEMENT_STYLE +
                    "\n         ." +
                    PSEUDO_HIDE_ELEMENT_CLASS_AFTER +
                    PSEUDO_AFTER +
                    PSEUDO_HIDE_ELEMENT_STYLE,
            );
        };
        var createStyles = function (body, styles) {
            var document = body.ownerDocument;
            if (document) {
                var style = document.createElement("style");
                style.textContent = styles;
                body.appendChild(style);
            }
        };
        var CacheStorage = /** @class */ (function () {
            function CacheStorage() {}
            CacheStorage.getOrigin = function (url) {
                var link = CacheStorage._link;
                if (!link) {
                    return "about:blank";
                }
                link.href = url;
                link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
                return link.protocol + link.hostname + link.port;
            };
            CacheStorage.isSameOrigin = function (src) {
                return CacheStorage.getOrigin(src) === CacheStorage._origin;
            };
            CacheStorage.setContext = function (window) {
                CacheStorage._link = window.document.createElement("a");
                CacheStorage._origin = CacheStorage.getOrigin(
                    window.location.href,
                );
            };
            CacheStorage._origin = "about:blank";
            return CacheStorage;
        })();
        var Cache = /** @class */ (function () {
            function Cache(context, _options) {
                this.context = context;
                this._options = _options;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                this._cache = {};
            }
            Cache.prototype.addImage = function (src) {
                var result = Promise.resolve();
                if (this.has(src)) {
                    return result;
                }
                if (isBlobImage(src) || isRenderable(src)) {
                    (this._cache[src] = this.loadImage(src)).catch(function () {
                        // prevent unhandled rejection
                    });
                    return result;
                }
                return result;
            };
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            Cache.prototype.match = function (src) {
                return this._cache[src];
            };
            Cache.prototype.loadImage = function (key) {
                return __awaiter(this, void 0, void 0, function () {
                    var isSameOrigin, useCORS, useProxy, src;
                    var _this = this;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                isSameOrigin = CacheStorage.isSameOrigin(key);
                                useCORS =
                                    !isInlineImage(key) &&
                                    this._options.useCORS === true &&
                                    FEATURES.SUPPORT_CORS_IMAGES &&
                                    !isSameOrigin;
                                useProxy =
                                    !isInlineImage(key) &&
                                    !isSameOrigin &&
                                    !isBlobImage(key) &&
                                    typeof this._options.proxy === "string" &&
                                    FEATURES.SUPPORT_CORS_XHR &&
                                    !useCORS;
                                if (
                                    !isSameOrigin &&
                                    this._options.allowTaint === false &&
                                    !isInlineImage(key) &&
                                    !isBlobImage(key) &&
                                    !useProxy &&
                                    !useCORS
                                ) {
                                    return [2 /*return*/];
                                }

                                src = key;
                                if (!useProxy) return [3 /*break*/, 2];
                                return [4 /*yield*/, this.proxy(src)];
                            case 1:
                                src = _a.sent();
                                _a.label = 2;
                            case 2:
                                this.context.logger.debug(
                                    "Added image " + key.substring(0, 256),
                                );
                                return [
                                    4 /*yield*/,
                                    new Promise(function (resolve, reject) {
                                        var img = new Image();
                                        img.onload = function () {
                                            return resolve(img);
                                        };
                                        img.onerror = reject;
                                        //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                                        if (
                                            isInlineBase64Image(src) ||
                                            useCORS
                                        ) {
                                            img.crossOrigin = "anonymous";
                                        }
                                        img.src = src;
                                        if (img.complete === true) {
                                            // Inline XML images may fail to parse, throwing an Error later on
                                            setTimeout(function () {
                                                return resolve(img);
                                            }, 500);
                                        }
                                        if (_this._options.imageTimeout > 0) {
                                            setTimeout(function () {
                                                return reject(
                                                    "Timed out (" +
                                                        _this._options
                                                            .imageTimeout +
                                                        "ms) loading image",
                                                );
                                            }, _this._options.imageTimeout);
                                        }
                                    }),
                                ];
                            case 3:
                                return [2 /*return*/, _a.sent()];
                        }
                    });
                });
            };
            Cache.prototype.has = function (key) {
                return typeof this._cache[key] !== "undefined";
            };
            Cache.prototype.keys = function () {
                return Promise.resolve(Object.keys(this._cache));
            };
            Cache.prototype.proxy = function (src) {
                var _this = this;
                var proxy = this._options.proxy;
                if (!proxy) {
                    throw new Error("No proxy defined");
                }
                var key = src.substring(0, 256);
                return new Promise(function (resolve, reject) {
                    var responseType = FEATURES.SUPPORT_RESPONSE_TYPE
                        ? "blob"
                        : "text";
                    var xhr = new XMLHttpRequest();
                    xhr.onload = function () {
                        if (xhr.status === 200) {
                            if (responseType === "text") {
                                resolve(xhr.response);
                            } else {
                                var reader_1 = new FileReader();
                                reader_1.addEventListener(
                                    "load",
                                    function () {
                                        return resolve(reader_1.result);
                                    },
                                    false,
                                );
                                reader_1.addEventListener(
                                    "error",
                                    function (e) {
                                        return reject(e);
                                    },
                                    false,
                                );
                                reader_1.readAsDataURL(xhr.response);
                            }
                        } else {
                            reject(
                                "Failed to proxy resource " +
                                    key +
                                    " with status code " +
                                    xhr.status,
                            );
                        }
                    };
                    xhr.onerror = reject;
                    var queryString = proxy.indexOf("?") > -1 ? "&" : "?";
                    xhr.open(
                        "GET",
                        "" +
                            proxy +
                            queryString +
                            "url=" +
                            encodeURIComponent(src) +
                            "&responseType=" +
                            responseType,
                    );
                    if (
                        responseType !== "text" &&
                        xhr instanceof XMLHttpRequest
                    ) {
                        xhr.responseType = responseType;
                    }
                    if (_this._options.imageTimeout) {
                        var timeout_1 = _this._options.imageTimeout;
                        xhr.timeout = timeout_1;
                        xhr.ontimeout = function () {
                            return reject(
                                "Timed out (" +
                                    timeout_1 +
                                    "ms) proxying " +
                                    key,
                            );
                        };
                    }
                    xhr.send();
                });
            };
            return Cache;
        })();
        var INLINE_SVG = /^data:image\/svg\+xml/i;
        var INLINE_BASE64 = /^data:image\/.*;base64,/i;
        var INLINE_IMG = /^data:image\/.*/i;
        var isRenderable = function (src) {
            return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src);
        };
        var isInlineImage = function (src) {
            return INLINE_IMG.test(src);
        };
        var isInlineBase64Image = function (src) {
            return INLINE_BASE64.test(src);
        };
        var isBlobImage = function (src) {
            return src.substr(0, 4) === "blob";
        };
        var isSVG = function (src) {
            return (
                src.substr(-3).toLowerCase() === "svg" || INLINE_SVG.test(src)
            );
        };
        var Vector = /** @class */ (function () {
            function Vector(x, y) {
                this.type = 0 /* VECTOR */;
                this.x = x;
                this.y = y;
            }
            Vector.prototype.add = function (deltaX, deltaY) {
                return new Vector(this.x + deltaX, this.y + deltaY);
            };
            return Vector;
        })();
        var lerp = function (a, b, t) {
            return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
        };
        var BezierCurve = /** @class */ (function () {
            function BezierCurve(start, startControl, endControl, end) {
                this.type = 1 /* BEZIER_CURVE */;
                this.start = start;
                this.startControl = startControl;
                this.endControl = endControl;
                this.end = end;
            }
            BezierCurve.prototype.subdivide = function (t, firstHalf) {
                var ab = lerp(this.start, this.startControl, t);
                var bc = lerp(this.startControl, this.endControl, t);
                var cd = lerp(this.endControl, this.end, t);
                var abbc = lerp(ab, bc, t);
                var bccd = lerp(bc, cd, t);
                var dest = lerp(abbc, bccd, t);
                return firstHalf
                    ? new BezierCurve(this.start, ab, abbc, dest)
                    : new BezierCurve(dest, bccd, cd, this.end);
            };
            BezierCurve.prototype.add = function (deltaX, deltaY) {
                return new BezierCurve(
                    this.start.add(deltaX, deltaY),
                    this.startControl.add(deltaX, deltaY),
                    this.endControl.add(deltaX, deltaY),
                    this.end.add(deltaX, deltaY),
                );
            };
            BezierCurve.prototype.reverse = function () {
                return new BezierCurve(
                    this.end,
                    this.endControl,
                    this.startControl,
                    this.start,
                );
            };
            return BezierCurve;
        })();
        var isBezierCurve = function (path) {
            return path.type === 1 /* BEZIER_CURVE */;
        };

        var BoundCurves = /** @class */ (function () {
            function BoundCurves(element) {
                var styles = element.styles;
                var bounds = element.bounds;
                var _a = getAbsoluteValueForTuple(
                        styles.borderTopLeftRadius,
                        bounds.width,
                        bounds.height,
                    ),
                    tlh = _a[0],
                    tlv = _a[1];
                var _b = getAbsoluteValueForTuple(
                        styles.borderTopRightRadius,
                        bounds.width,
                        bounds.height,
                    ),
                    trh = _b[0],
                    trv = _b[1];
                var _c = getAbsoluteValueForTuple(
                        styles.borderBottomRightRadius,
                        bounds.width,
                        bounds.height,
                    ),
                    brh = _c[0],
                    brv = _c[1];
                var _d = getAbsoluteValueForTuple(
                        styles.borderBottomLeftRadius,
                        bounds.width,
                        bounds.height,
                    ),
                    blh = _d[0],
                    blv = _d[1];
                var factors = [];
                factors.push((tlh + trh) / bounds.width);
                factors.push((blh + brh) / bounds.width);
                factors.push((tlv + blv) / bounds.height);
                factors.push((trv + brv) / bounds.height);
                var maxFactor = Math.max.apply(Math, factors);
                if (maxFactor > 1) {
                    tlh /= maxFactor;
                    tlv /= maxFactor;
                    trh /= maxFactor;
                    trv /= maxFactor;
                    brh /= maxFactor;
                    brv /= maxFactor;
                    blh /= maxFactor;
                    blv /= maxFactor;
                }
                var topWidth = bounds.width - trh;
                var rightHeight = bounds.height - brv;
                var bottomWidth = bounds.width - brh;
                var leftHeight = bounds.height - blv;
                var borderTopWidth = styles.borderTopWidth;
                var borderRightWidth = styles.borderRightWidth;
                var borderBottomWidth = styles.borderBottomWidth;
                var borderLeftWidth = styles.borderLeftWidth;
                var paddingTop = getAbsoluteValue(
                    styles.paddingTop,
                    element.bounds.width,
                );
                var paddingRight = getAbsoluteValue(
                    styles.paddingRight,
                    element.bounds.width,
                );
                var paddingBottom = getAbsoluteValue(
                    styles.paddingBottom,
                    element.bounds.width,
                );
                var paddingLeft = getAbsoluteValue(
                    styles.paddingLeft,
                    element.bounds.width,
                );
                this.topLeftBorderDoubleOuterBox =
                    tlh > 0 || tlv > 0
                        ? getCurvePoints(
                              bounds.left + borderLeftWidth / 3,
                              bounds.top + borderTopWidth / 3,
                              tlh - borderLeftWidth / 3,
                              tlv - borderTopWidth / 3,
                              CORNER.TOP_LEFT,
                          )
                        : new Vector(
                              bounds.left + borderLeftWidth / 3,
                              bounds.top + borderTopWidth / 3,
                          );
                this.topRightBorderDoubleOuterBox =
                    tlh > 0 || tlv > 0
                        ? getCurvePoints(
                              bounds.left + topWidth,
                              bounds.top + borderTopWidth / 3,
                              trh - borderRightWidth / 3,
                              trv - borderTopWidth / 3,
                              CORNER.TOP_RIGHT,
                          )
                        : new Vector(
                              bounds.left + bounds.width - borderRightWidth / 3,
                              bounds.top + borderTopWidth / 3,
                          );
                this.bottomRightBorderDoubleOuterBox =
                    brh > 0 || brv > 0
                        ? getCurvePoints(
                              bounds.left + bottomWidth,
                              bounds.top + rightHeight,
                              brh - borderRightWidth / 3,
                              brv - borderBottomWidth / 3,
                              CORNER.BOTTOM_RIGHT,
                          )
                        : new Vector(
                              bounds.left + bounds.width - borderRightWidth / 3,
                              bounds.top +
                                  bounds.height -
                                  borderBottomWidth / 3,
                          );
                this.bottomLeftBorderDoubleOuterBox =
                    blh > 0 || blv > 0
                        ? getCurvePoints(
                              bounds.left + borderLeftWidth / 3,
                              bounds.top + leftHeight,
                              blh - borderLeftWidth / 3,
                              blv - borderBottomWidth / 3,
                              CORNER.BOTTOM_LEFT,
                          )
                        : new Vector(
                              bounds.left + borderLeftWidth / 3,
                              bounds.top +
                                  bounds.height -
                                  borderBottomWidth / 3,
                          );
                this.topLeftBorderDoubleInnerBox =
                    tlh > 0 || tlv > 0
                        ? getCurvePoints(
                              bounds.left + (borderLeftWidth * 2) / 3,
                              bounds.top + (borderTopWidth * 2) / 3,
                              tlh - (borderLeftWidth * 2) / 3,
                              tlv - (borderTopWidth * 2) / 3,
                              CORNER.TOP_LEFT,
                          )
                        : new Vector(
                              bounds.left + (borderLeftWidth * 2) / 3,
                              bounds.top + (borderTopWidth * 2) / 3,
                          );
                this.topRightBorderDoubleInnerBox =
                    tlh > 0 || tlv > 0
                        ? getCurvePoints(
                              bounds.left + topWidth,
                              bounds.top + (borderTopWidth * 2) / 3,
                              trh - (borderRightWidth * 2) / 3,
                              trv - (borderTopWidth * 2) / 3,
                              CORNER.TOP_RIGHT,
                          )
                        : new Vector(
                              bounds.left +
                                  bounds.width -
                                  (borderRightWidth * 2) / 3,
                              bounds.top + (borderTopWidth * 2) / 3,
                          );
                this.bottomRightBorderDoubleInnerBox =
                    brh > 0 || brv > 0
                        ? getCurvePoints(
                              bounds.left + bottomWidth,
                              bounds.top + rightHeight,
                              brh - (borderRightWidth * 2) / 3,
                              brv - (borderBottomWidth * 2) / 3,
                              CORNER.BOTTOM_RIGHT,
                          )
                        : new Vector(
                              bounds.left +
                                  bounds.width -
                                  (borderRightWidth * 2) / 3,
                              bounds.top +
                                  bounds.height -
                                  (borderBottomWidth * 2) / 3,
                          );
                this.bottomLeftBorderDoubleInnerBox =
                    blh > 0 || blv > 0
                        ? getCurvePoints(
                              bounds.left + (borderLeftWidth * 2) / 3,
                              bounds.top + leftHeight,
                              blh - (borderLeftWidth * 2) / 3,
                              blv - (borderBottomWidth * 2) / 3,
                              CORNER.BOTTOM_LEFT,
                          )
                        : new Vector(
                              bounds.left + (borderLeftWidth * 2) / 3,
                              bounds.top +
                                  bounds.height -
                                  (borderBottomWidth * 2) / 3,
                          );
                this.topLeftBorderStroke =
                    tlh > 0 || tlv > 0
                        ? getCurvePoints(
                              bounds.left + borderLeftWidth / 2,
                              bounds.top + borderTopWidth / 2,
                              tlh - borderLeftWidth / 2,
                              tlv - borderTopWidth / 2,
                              CORNER.TOP_LEFT,
                          )
                        : new Vector(
                              bounds.left + borderLeftWidth / 2,
                              bounds.top + borderTopWidth / 2,
                          );
                this.topRightBorderStroke =
                    tlh > 0 || tlv > 0
                        ? getCurvePoints(
                              bounds.left + topWidth,
                              bounds.top + borderTopWidth / 2,
                              trh - borderRightWidth / 2,
                              trv - borderTopWidth / 2,
                              CORNER.TOP_RIGHT,
                          )
                        : new Vector(
                              bounds.left + bounds.width - borderRightWidth / 2,
                              bounds.top + borderTopWidth / 2,
                          );
                this.bottomRightBorderStroke =
                    brh > 0 || brv > 0
                        ? getCurvePoints(
                              bounds.left + bottomWidth,
                              bounds.top + rightHeight,
                              brh - borderRightWidth / 2,
                              brv - borderBottomWidth / 2,
                              CORNER.BOTTOM_RIGHT,
                          )
                        : new Vector(
                              bounds.left + bounds.width - borderRightWidth / 2,
                              bounds.top +
                                  bounds.height -
                                  borderBottomWidth / 2,
                          );
                this.bottomLeftBorderStroke =
                    blh > 0 || blv > 0
                        ? getCurvePoints(
                              bounds.left + borderLeftWidth / 2,
                              bounds.top + leftHeight,
                              blh - borderLeftWidth / 2,
                              blv - borderBottomWidth / 2,
                              CORNER.BOTTOM_LEFT,
                          )
                        : new Vector(
                              bounds.left + borderLeftWidth / 2,
                              bounds.top +
                                  bounds.height -
                                  borderBottomWidth / 2,
                          );
                this.topLeftBorderBox =
                    tlh > 0 || tlv > 0
                        ? getCurvePoints(
                              bounds.left,
                              bounds.top,
                              tlh,
                              tlv,
                              CORNER.TOP_LEFT,
                          )
                        : new Vector(bounds.left, bounds.top);
                this.topRightBorderBox =
                    trh > 0 || trv > 0
                        ? getCurvePoints(
                              bounds.left + topWidth,
                              bounds.top,
                              trh,
                              trv,
                              CORNER.TOP_RIGHT,
                          )
                        : new Vector(bounds.left + bounds.width, bounds.top);
                this.bottomRightBorderBox =
                    brh > 0 || brv > 0
                        ? getCurvePoints(
                              bounds.left + bottomWidth,
                              bounds.top + rightHeight,
                              brh,
                              brv,
                              CORNER.BOTTOM_RIGHT,
                          )
                        : new Vector(
                              bounds.left + bounds.width,
                              bounds.top + bounds.height,
                          );
                this.bottomLeftBorderBox =
                    blh > 0 || blv > 0
                        ? getCurvePoints(
                              bounds.left,
                              bounds.top + leftHeight,
                              blh,
                              blv,
                              CORNER.BOTTOM_LEFT,
                          )
                        : new Vector(bounds.left, bounds.top + bounds.height);
                this.topLeftPaddingBox =
                    tlh > 0 || tlv > 0
                        ? getCurvePoints(
                              bounds.left + borderLeftWidth,
                              bounds.top + borderTopWidth,
                              Math.max(0, tlh - borderLeftWidth),
                              Math.max(0, tlv - borderTopWidth),
                              CORNER.TOP_LEFT,
                          )
                        : new Vector(
                              bounds.left + borderLeftWidth,
                              bounds.top + borderTopWidth,
                          );
                this.topRightPaddingBox =
                    trh > 0 || trv > 0
                        ? getCurvePoints(
                              bounds.left +
                                  Math.min(
                                      topWidth,
                                      bounds.width - borderRightWidth,
                                  ),
                              bounds.top + borderTopWidth,
                              topWidth > bounds.width + borderRightWidth
                                  ? 0
                                  : Math.max(0, trh - borderRightWidth),
                              Math.max(0, trv - borderTopWidth),
                              CORNER.TOP_RIGHT,
                          )
                        : new Vector(
                              bounds.left + bounds.width - borderRightWidth,
                              bounds.top + borderTopWidth,
                          );
                this.bottomRightPaddingBox =
                    brh > 0 || brv > 0
                        ? getCurvePoints(
                              bounds.left +
                                  Math.min(
                                      bottomWidth,
                                      bounds.width - borderLeftWidth,
                                  ),
                              bounds.top +
                                  Math.min(
                                      rightHeight,
                                      bounds.height - borderBottomWidth,
                                  ),
                              Math.max(0, brh - borderRightWidth),
                              Math.max(0, brv - borderBottomWidth),
                              CORNER.BOTTOM_RIGHT,
                          )
                        : new Vector(
                              bounds.left + bounds.width - borderRightWidth,
                              bounds.top + bounds.height - borderBottomWidth,
                          );
                this.bottomLeftPaddingBox =
                    blh > 0 || blv > 0
                        ? getCurvePoints(
                              bounds.left + borderLeftWidth,
                              bounds.top +
                                  Math.min(
                                      leftHeight,
                                      bounds.height - borderBottomWidth,
                                  ),
                              Math.max(0, blh - borderLeftWidth),
                              Math.max(0, blv - borderBottomWidth),
                              CORNER.BOTTOM_LEFT,
                          )
                        : new Vector(
                              bounds.left + borderLeftWidth,
                              bounds.top + bounds.height - borderBottomWidth,
                          );
                this.topLeftContentBox =
                    tlh > 0 || tlv > 0
                        ? getCurvePoints(
                              bounds.left + borderLeftWidth + paddingLeft,
                              bounds.top + borderTopWidth + paddingTop,
                              Math.max(
                                  0,
                                  tlh - (borderLeftWidth + paddingLeft),
                              ),
                              Math.max(0, tlv - (borderTopWidth + paddingTop)),
                              CORNER.TOP_LEFT,
                          )
                        : new Vector(
                              bounds.left + borderLeftWidth + paddingLeft,
                              bounds.top + borderTopWidth + paddingTop,
                          );
                this.topRightContentBox =
                    trh > 0 || trv > 0
                        ? getCurvePoints(
                              bounds.left +
                                  Math.min(
                                      topWidth,
                                      bounds.width +
                                          borderLeftWidth +
                                          paddingLeft,
                                  ),
                              bounds.top + borderTopWidth + paddingTop,
                              topWidth >
                                  bounds.width + borderLeftWidth + paddingLeft
                                  ? 0
                                  : trh - borderLeftWidth + paddingLeft,
                              trv - (borderTopWidth + paddingTop),
                              CORNER.TOP_RIGHT,
                          )
                        : new Vector(
                              bounds.left +
                                  bounds.width -
                                  (borderRightWidth + paddingRight),
                              bounds.top + borderTopWidth + paddingTop,
                          );
                this.bottomRightContentBox =
                    brh > 0 || brv > 0
                        ? getCurvePoints(
                              bounds.left +
                                  Math.min(
                                      bottomWidth,
                                      bounds.width -
                                          (borderLeftWidth + paddingLeft),
                                  ),
                              bounds.top +
                                  Math.min(
                                      rightHeight,
                                      bounds.height +
                                          borderTopWidth +
                                          paddingTop,
                                  ),
                              Math.max(
                                  0,
                                  brh - (borderRightWidth + paddingRight),
                              ),
                              brv - (borderBottomWidth + paddingBottom),
                              CORNER.BOTTOM_RIGHT,
                          )
                        : new Vector(
                              bounds.left +
                                  bounds.width -
                                  (borderRightWidth + paddingRight),
                              bounds.top +
                                  bounds.height -
                                  (borderBottomWidth + paddingBottom),
                          );
                this.bottomLeftContentBox =
                    blh > 0 || blv > 0
                        ? getCurvePoints(
                              bounds.left + borderLeftWidth + paddingLeft,
                              bounds.top + leftHeight,
                              Math.max(
                                  0,
                                  blh - (borderLeftWidth + paddingLeft),
                              ),
                              blv - (borderBottomWidth + paddingBottom),
                              CORNER.BOTTOM_LEFT,
                          )
                        : new Vector(
                              bounds.left + borderLeftWidth + paddingLeft,
                              bounds.top +
                                  bounds.height -
                                  (borderBottomWidth + paddingBottom),
                          );
            }
            return BoundCurves;
        })();
        var CORNER;
        (function (CORNER) {
            CORNER[(CORNER["TOP_LEFT"] = 0)] = "TOP_LEFT";
            CORNER[(CORNER["TOP_RIGHT"] = 1)] = "TOP_RIGHT";
            CORNER[(CORNER["BOTTOM_RIGHT"] = 2)] = "BOTTOM_RIGHT";
            CORNER[(CORNER["BOTTOM_LEFT"] = 3)] = "BOTTOM_LEFT";
        })(CORNER || (CORNER = {}));
        var getCurvePoints = function (x, y, r1, r2, position) {
            var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
            var ox = r1 * kappa; // control point offset horizontal
            var oy = r2 * kappa; // control point offset vertical
            var xm = x + r1; // x-middle
            var ym = y + r2; // y-middle
            switch (position) {
                case CORNER.TOP_LEFT:
                    return new BezierCurve(
                        new Vector(x, ym),
                        new Vector(x, ym - oy),
                        new Vector(xm - ox, y),
                        new Vector(xm, y),
                    );
                case CORNER.TOP_RIGHT:
                    return new BezierCurve(
                        new Vector(x, y),
                        new Vector(x + ox, y),
                        new Vector(xm, ym - oy),
                        new Vector(xm, ym),
                    );
                case CORNER.BOTTOM_RIGHT:
                    return new BezierCurve(
                        new Vector(xm, y),
                        new Vector(xm, y + oy),
                        new Vector(x + ox, ym),
                        new Vector(x, ym),
                    );
                case CORNER.BOTTOM_LEFT:
                default:
                    return new BezierCurve(
                        new Vector(xm, ym),
                        new Vector(xm - ox, ym),
                        new Vector(x, y + oy),
                        new Vector(x, y),
                    );
            }
        };
        var calculateBorderBoxPath = function (curves) {
            return [
                curves.topLeftBorderBox,
                curves.topRightBorderBox,
                curves.bottomRightBorderBox,
                curves.bottomLeftBorderBox,
            ];
        };
        var calculateContentBoxPath = function (curves) {
            return [
                curves.topLeftContentBox,
                curves.topRightContentBox,
                curves.bottomRightContentBox,
                curves.bottomLeftContentBox,
            ];
        };
        var calculatePaddingBoxPath = function (curves) {
            return [
                curves.topLeftPaddingBox,
                curves.topRightPaddingBox,
                curves.bottomRightPaddingBox,
                curves.bottomLeftPaddingBox,
            ];
        };
        var TransformEffect = /** @class */ (function () {
            function TransformEffect(offsetX, offsetY, matrix) {
                this.offsetX = offsetX;
                this.offsetY = offsetY;
                this.matrix = matrix;
                this.type = 0 /* TRANSFORM */;
                this.target = 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */;
            }

            return TransformEffect;
        })();
        var ClipEffect = /** @class */ (function () {
            function ClipEffect(path, target) {
                this.path = path;
                this.target = target;
                this.type = 1 /* CLIP */;
            }

            return ClipEffect;
        })();
        var OpacityEffect = /** @class */ (function () {
            function OpacityEffect(opacity) {
                this.opacity = opacity;
                this.type = 2 /* OPACITY */;
                this.target = 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */;
            }

            return OpacityEffect;
        })();
        var isTransformEffect = function (effect) {
            return effect.type === 0 /* TRANSFORM */;
        };

        var isClipEffect = function (effect) {
            return effect.type === 1 /* CLIP */;
        };
        var isOpacityEffect = function (effect) {
            return effect.type === 2 /* OPACITY */;
        };

        var equalPath = function (a, b) {
            if (a.length === b.length) {
                return a.some(function (v, i) {
                    return v === b[i];
                });
            }
            return false;
        };
        var transformPath = function (path, deltaX, deltaY, deltaW, deltaH) {
            return path.map(function (point, index) {
                switch (index) {
                    case 0:
                        return point.add(deltaX, deltaY);
                    case 1:
                        return point.add(deltaX + deltaW, deltaY);
                    case 2:
                        return point.add(deltaX + deltaW, deltaY + deltaH);
                    case 3:
                        return point.add(deltaX, deltaY + deltaH);
                }
                return point;
            });
        };
        var StackingContext = /** @class */ (function () {
            function StackingContext(container) {
                this.element = container;
                this.inlineLevel = [];
                this.nonInlineLevel = [];
                this.negativeZIndex = [];
                this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
                this.positiveZIndex = [];
                this.nonPositionedFloats = [];
                this.nonPositionedInlineLevel = [];
            }
            return StackingContext;
        })();
        var ElementPaint = /** @class */ (function () {
            function ElementPaint(container, parent) {
                this.container = container;
                this.parent = parent;
                this.effects = [];
                this.curves = new BoundCurves(this.container);
                if (this.container.styles.opacity < 1) {
                    this.effects.push(
                        new OpacityEffect(this.container.styles.opacity),
                    );
                }
                if (this.container.styles.transform !== null) {
                    var offsetX =
                        this.container.bounds.left +
                        this.container.styles.transformOrigin[0].number;
                    var offsetY =
                        this.container.bounds.top +
                        this.container.styles.transformOrigin[1].number;
                    var matrix = this.container.styles.transform;
                    this.effects.push(
                        new TransformEffect(offsetX, offsetY, matrix),
                    );
                }
                if (this.container.styles.overflowX !== 0 /* VISIBLE */) {
                    var borderBox = calculateBorderBoxPath(this.curves);
                    var paddingBox = calculatePaddingBoxPath(this.curves);
                    if (equalPath(borderBox, paddingBox)) {
                        this.effects.push(
                            new ClipEffect(
                                borderBox,
                                2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */,
                            ),
                        );
                    } else {
                        this.effects.push(
                            new ClipEffect(
                                borderBox,
                                2 /* BACKGROUND_BORDERS */,
                            ),
                        );
                        this.effects.push(
                            new ClipEffect(paddingBox, 4 /* CONTENT */),
                        );
                    }
                }
            }

            ElementPaint.prototype.getEffects = function (target) {
                var inFlow =
                    [2 /* ABSOLUTE */, 3 /* FIXED */].indexOf(
                        this.container.styles.position,
                    ) === -1;
                var parent = this.parent;
                var effects = this.effects.slice(0);
                while (parent) {
                    var croplessEffects = parent.effects.filter(
                        function (effect) {
                            return !isClipEffect(effect);
                        },
                    );
                    if (
                        inFlow ||
                        parent.container.styles.position !== 0 /* STATIC */ ||
                        !parent.parent
                    ) {
                        effects.unshift.apply(effects, croplessEffects);
                        inFlow =
                            [2 /* ABSOLUTE */, 3 /* FIXED */].indexOf(
                                parent.container.styles.position,
                            ) === -1;
                        if (
                            parent.container.styles.overflowX !==
                            0 /* VISIBLE */
                        ) {
                            var borderBox = calculateBorderBoxPath(
                                parent.curves,
                            );
                            var paddingBox = calculatePaddingBoxPath(
                                parent.curves,
                            );
                            if (!equalPath(borderBox, paddingBox)) {
                                effects.unshift(
                                    new ClipEffect(
                                        paddingBox,
                                        2 /* BACKGROUND_BORDERS */ |
                                            4 /* CONTENT */,
                                    ),
                                );
                            }
                        }
                    } else {
                        effects.unshift.apply(effects, croplessEffects);
                    }
                    parent = parent.parent;
                }
                return effects.filter(function (effect) {
                    return contains(effect.target, target);
                });
            };
            return ElementPaint;
        })();
        var parseStackTree = function (
            parent,
            stackingContext,
            realStackingContext,
            listItems,
        ) {
            parent.container.elements.forEach(function (child) {
                var treatAsRealStackingContext = contains(
                    child.flags,
                    4 /* CREATES_REAL_STACKING_CONTEXT */,
                );
                var createsStackingContext = contains(
                    child.flags,
                    2 /* CREATES_STACKING_CONTEXT */,
                );
                var paintContainer = new ElementPaint(child, parent);
                if (contains(child.styles.display, 2048 /* LIST_ITEM */)) {
                    listItems.push(paintContainer);
                }
                var listOwnerItems = contains(
                    child.flags,
                    8 /* IS_LIST_OWNER */,
                )
                    ? []
                    : listItems;
                if (treatAsRealStackingContext || createsStackingContext) {
                    var parentStack =
                        treatAsRealStackingContext ||
                        child.styles.isPositioned()
                            ? realStackingContext
                            : stackingContext;
                    var stack = new StackingContext(paintContainer);
                    if (
                        child.styles.isPositioned() ||
                        child.styles.opacity < 1 ||
                        child.styles.isTransformed()
                    ) {
                        var order_1 = child.styles.zIndex.order;
                        if (order_1 < 0) {
                            var index_1 = 0;
                            parentStack.negativeZIndex.some(
                                function (current, i) {
                                    if (
                                        order_1 >
                                        current.element.container.styles.zIndex
                                            .order
                                    ) {
                                        index_1 = i;
                                        return false;
                                    } else if (index_1 > 0) {
                                        return true;
                                    }
                                    return false;
                                },
                            );
                            parentStack.negativeZIndex.splice(
                                index_1,
                                0,
                                stack,
                            );
                        } else if (order_1 > 0) {
                            var index_2 = 0;
                            parentStack.positiveZIndex.some(
                                function (current, i) {
                                    if (
                                        order_1 >=
                                        current.element.container.styles.zIndex
                                            .order
                                    ) {
                                        index_2 = i + 1;
                                        return false;
                                    } else if (index_2 > 0) {
                                        return true;
                                    }
                                    return false;
                                },
                            );
                            parentStack.positiveZIndex.splice(
                                index_2,
                                0,
                                stack,
                            );
                        } else {
                            parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(
                                stack,
                            );
                        }
                    } else {
                        if (child.styles.isFloating()) {
                            parentStack.nonPositionedFloats.push(stack);
                        } else {
                            parentStack.nonPositionedInlineLevel.push(stack);
                        }
                    }
                    parseStackTree(
                        paintContainer,
                        stack,
                        treatAsRealStackingContext
                            ? stack
                            : realStackingContext,
                        listOwnerItems,
                    );
                } else {
                    if (child.styles.isInlineLevel()) {
                        stackingContext.inlineLevel.push(paintContainer);
                    } else {
                        stackingContext.nonInlineLevel.push(paintContainer);
                    }
                    parseStackTree(
                        paintContainer,
                        stackingContext,
                        realStackingContext,
                        listOwnerItems,
                    );
                }
                if (contains(child.flags, 8 /* IS_LIST_OWNER */)) {
                    processListItems(child, listOwnerItems);
                }
            });
        };
        var processListItems = function (owner, elements) {
            var numbering =
                owner instanceof OLElementContainer ? owner.start : 1;
            var reversed =
                owner instanceof OLElementContainer ? owner.reversed : false;
            for (var i = 0; i < elements.length; i++) {
                var item = elements[i];
                if (
                    item.container instanceof LIElementContainer &&
                    typeof item.container.value === "number" &&
                    item.container.value !== 0
                ) {
                    numbering = item.container.value;
                }
                item.listValue = createCounterText(
                    numbering,
                    item.container.styles.listStyleType,
                    true,
                );
                numbering += reversed ? -1 : 1;
            }
        };
        var parseStackingContexts = function (container) {
            var paintContainer = new ElementPaint(container, null);
            var root = new StackingContext(paintContainer);
            var listItems = [];
            parseStackTree(paintContainer, root, root, listItems);
            processListItems(paintContainer.container, listItems);
            return root;
        };
        var parsePathForBorder = function (curves, borderSide) {
            switch (borderSide) {
                case 0:
                    return createPathFromCurves(
                        curves.topLeftBorderBox,
                        curves.topLeftPaddingBox,
                        curves.topRightBorderBox,
                        curves.topRightPaddingBox,
                    );
                case 1:
                    return createPathFromCurves(
                        curves.topRightBorderBox,
                        curves.topRightPaddingBox,
                        curves.bottomRightBorderBox,
                        curves.bottomRightPaddingBox,
                    );
                case 2:
                    return createPathFromCurves(
                        curves.bottomRightBorderBox,
                        curves.bottomRightPaddingBox,
                        curves.bottomLeftBorderBox,
                        curves.bottomLeftPaddingBox,
                    );
                case 3:
                default:
                    return createPathFromCurves(
                        curves.bottomLeftBorderBox,
                        curves.bottomLeftPaddingBox,
                        curves.topLeftBorderBox,
                        curves.topLeftPaddingBox,
                    );
            }
        };
        var parsePathForBorderDoubleOuter = function (curves, borderSide) {
            switch (borderSide) {
                case 0:
                    return createPathFromCurves(
                        curves.topLeftBorderBox,
                        curves.topLeftBorderDoubleOuterBox,
                        curves.topRightBorderBox,
                        curves.topRightBorderDoubleOuterBox,
                    );
                case 1:
                    return createPathFromCurves(
                        curves.topRightBorderBox,
                        curves.topRightBorderDoubleOuterBox,
                        curves.bottomRightBorderBox,
                        curves.bottomRightBorderDoubleOuterBox,
                    );
                case 2:
                    return createPathFromCurves(
                        curves.bottomRightBorderBox,
                        curves.bottomRightBorderDoubleOuterBox,
                        curves.bottomLeftBorderBox,
                        curves.bottomLeftBorderDoubleOuterBox,
                    );
                case 3:
                default:
                    return createPathFromCurves(
                        curves.bottomLeftBorderBox,
                        curves.bottomLeftBorderDoubleOuterBox,
                        curves.topLeftBorderBox,
                        curves.topLeftBorderDoubleOuterBox,
                    );
            }
        };
        var parsePathForBorderDoubleInner = function (curves, borderSide) {
            switch (borderSide) {
                case 0:
                    return createPathFromCurves(
                        curves.topLeftBorderDoubleInnerBox,
                        curves.topLeftPaddingBox,
                        curves.topRightBorderDoubleInnerBox,
                        curves.topRightPaddingBox,
                    );
                case 1:
                    return createPathFromCurves(
                        curves.topRightBorderDoubleInnerBox,
                        curves.topRightPaddingBox,
                        curves.bottomRightBorderDoubleInnerBox,
                        curves.bottomRightPaddingBox,
                    );
                case 2:
                    return createPathFromCurves(
                        curves.bottomRightBorderDoubleInnerBox,
                        curves.bottomRightPaddingBox,
                        curves.bottomLeftBorderDoubleInnerBox,
                        curves.bottomLeftPaddingBox,
                    );
                case 3:
                default:
                    return createPathFromCurves(
                        curves.bottomLeftBorderDoubleInnerBox,
                        curves.bottomLeftPaddingBox,
                        curves.topLeftBorderDoubleInnerBox,
                        curves.topLeftPaddingBox,
                    );
            }
        };
        var parsePathForBorderStroke = function (curves, borderSide) {
            switch (borderSide) {
                case 0:
                    return createStrokePathFromCurves(
                        curves.topLeftBorderStroke,
                        curves.topRightBorderStroke,
                    );
                case 1:
                    return createStrokePathFromCurves(
                        curves.topRightBorderStroke,
                        curves.bottomRightBorderStroke,
                    );
                case 2:
                    return createStrokePathFromCurves(
                        curves.bottomRightBorderStroke,
                        curves.bottomLeftBorderStroke,
                    );
                case 3:
                default:
                    return createStrokePathFromCurves(
                        curves.bottomLeftBorderStroke,
                        curves.topLeftBorderStroke,
                    );
            }
        };
        var createStrokePathFromCurves = function (outer1, outer2) {
            var path = [];
            if (isBezierCurve(outer1)) {
                path.push(outer1.subdivide(0.5, false));
            } else {
                path.push(outer1);
            }
            if (isBezierCurve(outer2)) {
                path.push(outer2.subdivide(0.5, true));
            } else {
                path.push(outer2);
            }
            return path;
        };
        var createPathFromCurves = function (outer1, inner1, outer2, inner2) {
            var path = [];
            if (isBezierCurve(outer1)) {
                path.push(outer1.subdivide(0.5, false));
            } else {
                path.push(outer1);
            }
            if (isBezierCurve(outer2)) {
                path.push(outer2.subdivide(0.5, true));
            } else {
                path.push(outer2);
            }
            if (isBezierCurve(inner2)) {
                path.push(inner2.subdivide(0.5, true).reverse());
            } else {
                path.push(inner2);
            }
            if (isBezierCurve(inner1)) {
                path.push(inner1.subdivide(0.5, false).reverse());
            } else {
                path.push(inner1);
            }
            return path;
        };
        var paddingBox = function (element) {
            var bounds = element.bounds;
            var styles = element.styles;
            return bounds.add(
                styles.borderLeftWidth,
                styles.borderTopWidth,
                -(styles.borderRightWidth + styles.borderLeftWidth),
                -(styles.borderTopWidth + styles.borderBottomWidth),
            );
        };
        var contentBox = function (element) {
            var styles = element.styles;
            var bounds = element.bounds;
            var paddingLeft = getAbsoluteValue(
                styles.paddingLeft,
                bounds.width,
            );
            var paddingRight = getAbsoluteValue(
                styles.paddingRight,
                bounds.width,
            );
            var paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width);
            var paddingBottom = getAbsoluteValue(
                styles.paddingBottom,
                bounds.width,
            );
            return bounds.add(
                paddingLeft + styles.borderLeftWidth,
                paddingTop + styles.borderTopWidth,
                -(
                    styles.borderRightWidth +
                    styles.borderLeftWidth +
                    paddingLeft +
                    paddingRight
                ),
                -(
                    styles.borderTopWidth +
                    styles.borderBottomWidth +
                    paddingTop +
                    paddingBottom
                ),
            );
        };
        var calculateBackgroundPositioningArea = function (
            backgroundOrigin,
            element,
        ) {
            if (backgroundOrigin === 0 /* BORDER_BOX */) {
                return element.bounds;
            }
            if (backgroundOrigin === 2 /* CONTENT_BOX */) {
                return contentBox(element);
            }
            return paddingBox(element);
        };
        var calculateBackgroundPaintingArea = function (
            backgroundClip,
            element,
        ) {
            if (backgroundClip === 0 /* BORDER_BOX */) {
                return element.bounds;
            }
            if (backgroundClip === 2 /* CONTENT_BOX */) {
                return contentBox(element);
            }
            return paddingBox(element);
        };
        var calculateBackgroundRendering = function (
            container,
            index,
            intrinsicSize,
        ) {
            var backgroundPositioningArea = calculateBackgroundPositioningArea(
                getBackgroundValueForIndex(
                    container.styles.backgroundOrigin,
                    index,
                ),
                container,
            );
            var backgroundPaintingArea = calculateBackgroundPaintingArea(
                getBackgroundValueForIndex(
                    container.styles.backgroundClip,
                    index,
                ),
                container,
            );
            var backgroundImageSize = calculateBackgroundSize(
                getBackgroundValueForIndex(
                    container.styles.backgroundSize,
                    index,
                ),
                intrinsicSize,
                backgroundPositioningArea,
            );
            var sizeWidth = backgroundImageSize[0],
                sizeHeight = backgroundImageSize[1];
            var position = getAbsoluteValueForTuple(
                getBackgroundValueForIndex(
                    container.styles.backgroundPosition,
                    index,
                ),
                backgroundPositioningArea.width - sizeWidth,
                backgroundPositioningArea.height - sizeHeight,
            );
            var path = calculateBackgroundRepeatPath(
                getBackgroundValueForIndex(
                    container.styles.backgroundRepeat,
                    index,
                ),
                position,
                backgroundImageSize,
                backgroundPositioningArea,
                backgroundPaintingArea,
            );
            var offsetX = Math.round(
                backgroundPositioningArea.left + position[0],
            );
            var offsetY = Math.round(
                backgroundPositioningArea.top + position[1],
            );
            return [path, offsetX, offsetY, sizeWidth, sizeHeight];
        };
        var isAuto = function (token) {
            return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO;
        };
        var hasIntrinsicValue = function (value) {
            return typeof value === "number";
        };
        var calculateBackgroundSize = function (size, _a, bounds) {
            var intrinsicWidth = _a[0],
                intrinsicHeight = _a[1],
                intrinsicProportion = _a[2];
            var first = size[0],
                second = size[1];
            if (!first) {
                return [0, 0];
            }
            if (
                isLengthPercentage(first) &&
                second &&
                isLengthPercentage(second)
            ) {
                return [
                    getAbsoluteValue(first, bounds.width),
                    getAbsoluteValue(second, bounds.height),
                ];
            }
            var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
            if (
                isIdentToken(first) &&
                (first.value === BACKGROUND_SIZE.CONTAIN ||
                    first.value === BACKGROUND_SIZE.COVER)
            ) {
                if (hasIntrinsicValue(intrinsicProportion)) {
                    var targetRatio = bounds.width / bounds.height;
                    return targetRatio < intrinsicProportion !==
                        (first.value === BACKGROUND_SIZE.COVER)
                        ? [bounds.width, bounds.width / intrinsicProportion]
                        : [bounds.height * intrinsicProportion, bounds.height];
                }
                return [bounds.width, bounds.height];
            }
            var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
            var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
            var hasIntrinsicDimensions =
                hasIntrinsicWidth || hasIntrinsicHeight;
            // If the background-size is auto or auto auto:
            if (isAuto(first) && (!second || isAuto(second))) {
                // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
                if (hasIntrinsicWidth && hasIntrinsicHeight) {
                    return [intrinsicWidth, intrinsicHeight];
                }
                // If the image has no intrinsic dimensions and has no intrinsic proportions,
                // it's rendered at the size of the background positioning area.
                if (!hasIntrinsicProportion && !hasIntrinsicDimensions) {
                    return [bounds.width, bounds.height];
                }
                // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
                // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
                // The other dimension is computed using the specified dimension and the intrinsic proportions.
                if (hasIntrinsicDimensions && hasIntrinsicProportion) {
                    var width_1 = hasIntrinsicWidth
                        ? intrinsicWidth
                        : intrinsicHeight * intrinsicProportion;
                    var height_1 = hasIntrinsicHeight
                        ? intrinsicHeight
                        : intrinsicWidth / intrinsicProportion;
                    return [width_1, height_1];
                }
                // If the image has only one intrinsic dimension but has no intrinsic proportions,
                // it's rendered using the specified dimension and the other dimension of the background positioning area.
                var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
                var height_2 = hasIntrinsicHeight
                    ? intrinsicHeight
                    : bounds.height;
                return [width_2, height_2];
            }
            // If the image has intrinsic proportions, it's stretched to the specified dimension.
            // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
            if (hasIntrinsicProportion) {
                var width_3 = 0;
                var height_3 = 0;
                if (isLengthPercentage(first)) {
                    width_3 = getAbsoluteValue(first, bounds.width);
                } else if (isLengthPercentage(second)) {
                    height_3 = getAbsoluteValue(second, bounds.height);
                }
                if (isAuto(first)) {
                    width_3 = height_3 * intrinsicProportion;
                } else if (!second || isAuto(second)) {
                    height_3 = width_3 / intrinsicProportion;
                }
                return [width_3, height_3];
            }
            // If the image has no intrinsic proportions, it's stretched to the specified dimension.
            // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
            // if there is one. If there is no such intrinsic dimension,
            // it becomes the corresponding dimension of the background positioning area.
            var width = null;
            var height = null;
            if (isLengthPercentage(first)) {
                width = getAbsoluteValue(first, bounds.width);
            } else if (second && isLengthPercentage(second)) {
                height = getAbsoluteValue(second, bounds.height);
            }
            if (width !== null && (!second || isAuto(second))) {
                height =
                    hasIntrinsicWidth && hasIntrinsicHeight
                        ? (width / intrinsicWidth) * intrinsicHeight
                        : bounds.height;
            }
            if (height !== null && isAuto(first)) {
                width =
                    hasIntrinsicWidth && hasIntrinsicHeight
                        ? (height / intrinsicHeight) * intrinsicWidth
                        : bounds.width;
            }
            if (width !== null && height !== null) {
                return [width, height];
            }
            throw new Error("Unable to calculate background-size for element");
        };
        var getBackgroundValueForIndex = function (values, index) {
            var value = values[index];
            if (typeof value === "undefined") {
                return values[0];
            }
            return value;
        };
        var calculateBackgroundRepeatPath = function (
            repeat,
            _a,
            _b,
            backgroundPositioningArea,
            backgroundPaintingArea,
        ) {
            var x = _a[0],
                y = _a[1];
            var width = _b[0],
                height = _b[1];
            switch (repeat) {
                case 2 /* REPEAT_X */:
                    return [
                        new Vector(
                            Math.round(backgroundPositioningArea.left),
                            Math.round(backgroundPositioningArea.top + y),
                        ),
                        new Vector(
                            Math.round(
                                backgroundPositioningArea.left +
                                    backgroundPositioningArea.width,
                            ),
                            Math.round(backgroundPositioningArea.top + y),
                        ),
                        new Vector(
                            Math.round(
                                backgroundPositioningArea.left +
                                    backgroundPositioningArea.width,
                            ),
                            Math.round(
                                height + backgroundPositioningArea.top + y,
                            ),
                        ),
                        new Vector(
                            Math.round(backgroundPositioningArea.left),
                            Math.round(
                                height + backgroundPositioningArea.top + y,
                            ),
                        ),
                    ];
                case 3 /* REPEAT_Y */:
                    return [
                        new Vector(
                            Math.round(backgroundPositioningArea.left + x),
                            Math.round(backgroundPositioningArea.top),
                        ),
                        new Vector(
                            Math.round(
                                backgroundPositioningArea.left + x + width,
                            ),
                            Math.round(backgroundPositioningArea.top),
                        ),
                        new Vector(
                            Math.round(
                                backgroundPositioningArea.left + x + width,
                            ),
                            Math.round(
                                backgroundPositioningArea.height +
                                    backgroundPositioningArea.top,
                            ),
                        ),
                        new Vector(
                            Math.round(backgroundPositioningArea.left + x),
                            Math.round(
                                backgroundPositioningArea.height +
                                    backgroundPositioningArea.top,
                            ),
                        ),
                    ];
                case 1 /* NO_REPEAT */:
                    return [
                        new Vector(
                            Math.round(backgroundPositioningArea.left + x),
                            Math.round(backgroundPositioningArea.top + y),
                        ),
                        new Vector(
                            Math.round(
                                backgroundPositioningArea.left + x + width,
                            ),
                            Math.round(backgroundPositioningArea.top + y),
                        ),
                        new Vector(
                            Math.round(
                                backgroundPositioningArea.left + x + width,
                            ),
                            Math.round(
                                backgroundPositioningArea.top + y + height,
                            ),
                        ),
                        new Vector(
                            Math.round(backgroundPositioningArea.left + x),
                            Math.round(
                                backgroundPositioningArea.top + y + height,
                            ),
                        ),
                    ];
                default:
                    return [
                        new Vector(
                            Math.round(backgroundPaintingArea.left),
                            Math.round(backgroundPaintingArea.top),
                        ),
                        new Vector(
                            Math.round(
                                backgroundPaintingArea.left +
                                    backgroundPaintingArea.width,
                            ),
                            Math.round(backgroundPaintingArea.top),
                        ),
                        new Vector(
                            Math.round(
                                backgroundPaintingArea.left +
                                    backgroundPaintingArea.width,
                            ),
                            Math.round(
                                backgroundPaintingArea.height +
                                    backgroundPaintingArea.top,
                            ),
                        ),
                        new Vector(
                            Math.round(backgroundPaintingArea.left),
                            Math.round(
                                backgroundPaintingArea.height +
                                    backgroundPaintingArea.top,
                            ),
                        ),
                    ];
            }
        };
        var SMALL_IMAGE =
            "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
        var SAMPLE_TEXT = "Hidden Text";
        var FontMetrics = /** @class */ (function () {
            function FontMetrics(document) {
                this._data = {};
                this._document = document;
            }
            FontMetrics.prototype.parseMetrics = function (
                fontFamily,
                fontSize,
            ) {
                var container = this._document.createElement("div");
                var img = this._document.createElement("img");
                var span = this._document.createElement("span");
                var body = this._document.body;
                container.style.visibility = "hidden";
                container.style.fontFamily = fontFamily;
                container.style.fontSize = fontSize;
                container.style.margin = "0";
                container.style.padding = "0";
                container.style.whiteSpace = "nowrap";
                body.appendChild(container);
                img.src = SMALL_IMAGE;
                img.width = 1;
                img.height = 1;
                img.style.margin = "0";
                img.style.padding = "0";
                img.style.verticalAlign = "baseline";
                span.style.fontFamily = fontFamily;
                span.style.fontSize = fontSize;
                span.style.margin = "0";
                span.style.padding = "0";
                span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
                container.appendChild(span);
                container.appendChild(img);
                var baseline = img.offsetTop - span.offsetTop + 2;
                container.removeChild(span);
                container.appendChild(
                    this._document.createTextNode(SAMPLE_TEXT),
                );
                container.style.lineHeight = "normal";
                img.style.verticalAlign = "super";
                var middle = img.offsetTop - container.offsetTop + 2;
                body.removeChild(container);
                return {
                    baseline: baseline,
                    middle: middle,
                };
            };
            FontMetrics.prototype.getMetrics = function (fontFamily, fontSize) {
                var key = fontFamily + " " + fontSize;
                if (typeof this._data[key] === "undefined") {
                    this._data[key] = this.parseMetrics(fontFamily, fontSize);
                }
                return this._data[key];
            };
            return FontMetrics;
        })();
        var Renderer = /** @class */ (function () {
            function Renderer(context, options) {
                this.context = context;
                this.options = options;
            }
            return Renderer;
        })();
        var MASK_OFFSET = 10000;
        var CanvasRenderer = /** @class */ (function (_super) {
            __extends(CanvasRenderer, _super);
            function CanvasRenderer(context, options) {
                var _this = _super.call(this, context, options) || this;
                _this._activeEffects = [];
                _this.canvas = options.canvas
                    ? options.canvas
                    : document.createElement("canvas");
                _this.ctx = _this.canvas.getContext("2d");
                if (!options.canvas) {
                    _this.canvas.width = Math.floor(
                        options.width * options.scale,
                    );
                    _this.canvas.height = Math.floor(
                        options.height * options.scale,
                    );
                    _this.canvas.style.width = options.width + "px";
                    _this.canvas.style.height = options.height + "px";
                }
                _this.fontMetrics = new FontMetrics(document);
                _this.ctx.scale(_this.options.scale, _this.options.scale);
                _this.ctx.translate(-options.x, -options.y);
                _this.ctx.textBaseline = "bottom";
                _this._activeEffects = [];
                _this.context.logger.debug(
                    "Canvas renderer initialized (" +
                        options.width +
                        "x" +
                        options.height +
                        ") with scale " +
                        options.scale,
                );
                return _this;
            }
            CanvasRenderer.prototype.applyEffects = function (effects) {
                var _this = this;
                while (this._activeEffects.length) {
                    this.popEffect();
                }
                effects.forEach(function (effect) {
                    return _this.applyEffect(effect);
                });
            };
            CanvasRenderer.prototype.applyEffect = function (effect) {
                this.ctx.save();
                if (isOpacityEffect(effect)) {
                    this.ctx.globalAlpha = effect.opacity;
                }
                if (isTransformEffect(effect)) {
                    this.ctx.translate(effect.offsetX, effect.offsetY);
                    this.ctx.transform(
                        effect.matrix[0],
                        effect.matrix[1],
                        effect.matrix[2],
                        effect.matrix[3],
                        effect.matrix[4],
                        effect.matrix[5],
                    );
                    this.ctx.translate(-effect.offsetX, -effect.offsetY);
                }
                if (isClipEffect(effect)) {
                    this.path(effect.path);
                    this.ctx.clip();
                }
                this._activeEffects.push(effect);
            };
            CanvasRenderer.prototype.popEffect = function () {
                this._activeEffects.pop();
                this.ctx.restore();
            };
            CanvasRenderer.prototype.renderStack = function (stack) {
                return __awaiter(this, void 0, void 0, function () {
                    var styles;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                styles = stack.element.container.styles;
                                if (!styles.isVisible())
                                    return [3 /*break*/, 2];
                                return [
                                    4 /*yield*/,
                                    this.renderStackContent(stack),
                                ];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                return [2 /*return*/];
                        }
                    });
                });
            };

            CanvasRenderer.prototype.renderNode = function (paint) {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (
                                    contains(
                                        paint.container.flags,
                                        16 /* DEBUG_RENDER */,
                                    )
                                ) {
                                    debugger;
                                }
                                if (!paint.container.styles.isVisible())
                                    return [3 /*break*/, 3];
                                return [
                                    4 /*yield*/,
                                    this.renderNodeBackgroundAndBorders(paint),
                                ];
                            case 1:
                                _a.sent();
                                return [
                                    4 /*yield*/,
                                    this.renderNodeContent(paint),
                                ];
                            case 2:
                                _a.sent();
                                _a.label = 3;
                            case 3:
                                return [2 /*return*/];
                        }
                    });
                });
            };

            CanvasRenderer.prototype.renderTextWithLetterSpacing = function (
                text,
                letterSpacing,
                baseline,
            ) {
                var _this = this;
                if (letterSpacing === 0) {
                    this.ctx.fillText(
                        text.text,
                        text.bounds.left,
                        text.bounds.top + baseline,
                    );
                } else {
                    var letters = segmentGraphemes(text.text);
                    letters.reduce(function (left, letter) {
                        _this.ctx.fillText(
                            letter,
                            left,
                            text.bounds.top + baseline,
                        );
                        return left + _this.ctx.measureText(letter).width;
                    }, text.bounds.left);
                }
            };
            CanvasRenderer.prototype.createFontStyle = function (styles) {
                var fontVariant = styles.fontVariant
                    .filter(function (variant) {
                        return variant === "normal" || variant === "small-caps";
                    })
                    .join("");
                var fontFamily = fixIOSSystemFonts(styles.fontFamily).join(
                    ", ",
                );
                var fontSize = isDimensionToken(styles.fontSize)
                    ? "" + styles.fontSize.number + styles.fontSize.unit
                    : styles.fontSize.number + "px";
                return [
                    [
                        styles.fontStyle,
                        fontVariant,
                        styles.fontWeight,
                        fontSize,
                        fontFamily,
                    ].join(" "),
                    fontFamily,
                    fontSize,
                ];
            };
            CanvasRenderer.prototype.renderTextNode = function (text, styles) {
                return __awaiter(this, void 0, void 0, function () {
                    var _a,
                        font,
                        fontFamily,
                        fontSize,
                        _b,
                        baseline,
                        middle,
                        paintOrder;
                    var _this = this;
                    return __generator(this, function (_c) {
                        (_a = this.createFontStyle(styles)),
                            (font = _a[0]),
                            (fontFamily = _a[1]),
                            (fontSize = _a[2]);
                        this.ctx.font = font;
                        this.ctx.direction =
                            styles.direction === 1 /* RTL */ ? "rtl" : "ltr";
                        this.ctx.textAlign = "left";
                        this.ctx.textBaseline = "alphabetic";
                        (_b = this.fontMetrics.getMetrics(
                            fontFamily,
                            fontSize,
                        )),
                            (baseline = _b.baseline),
                            (middle = _b.middle);
                        paintOrder = styles.paintOrder;
                        text.textBounds.forEach(function (text) {
                            paintOrder.forEach(function (paintOrderLayer) {
                                switch (paintOrderLayer) {
                                    case 0 /* FILL */:
                                        _this.ctx.fillStyle = asString(
                                            styles.color,
                                        );
                                        _this.renderTextWithLetterSpacing(
                                            text,
                                            styles.letterSpacing,
                                            baseline,
                                        );
                                        var textShadows = styles.textShadow;
                                        if (
                                            textShadows.length &&
                                            text.text.trim().length
                                        ) {
                                            textShadows
                                                .slice(0)
                                                .reverse()
                                                .forEach(function (textShadow) {
                                                    _this.ctx.shadowColor =
                                                        asString(
                                                            textShadow.color,
                                                        );
                                                    _this.ctx.shadowOffsetX =
                                                        textShadow.offsetX
                                                            .number *
                                                        _this.options.scale;
                                                    _this.ctx.shadowOffsetY =
                                                        textShadow.offsetY
                                                            .number *
                                                        _this.options.scale;
                                                    _this.ctx.shadowBlur =
                                                        textShadow.blur.number;
                                                    _this.renderTextWithLetterSpacing(
                                                        text,
                                                        styles.letterSpacing,
                                                        baseline,
                                                    );
                                                });
                                            _this.ctx.shadowColor = "";
                                            _this.ctx.shadowOffsetX = 0;
                                            _this.ctx.shadowOffsetY = 0;
                                            _this.ctx.shadowBlur = 0;
                                        }
                                        if (styles.textDecorationLine.length) {
                                            _this.ctx.fillStyle = asString(
                                                styles.textDecorationColor ||
                                                    styles.color,
                                            );
                                            styles.textDecorationLine.forEach(
                                                function (textDecorationLine) {
                                                    switch (
                                                        textDecorationLine
                                                    ) {
                                                        case 1 /* UNDERLINE */:
                                                            // Draws a line at the baseline of the font
                                                            // TODO As some browsers display the line as more than 1px if the font-size is big,
                                                            // need to take that into account both in position and size
                                                            _this.ctx.fillRect(
                                                                text.bounds
                                                                    .left,
                                                                Math.round(
                                                                    text.bounds
                                                                        .top +
                                                                        baseline,
                                                                ),
                                                                text.bounds
                                                                    .width,
                                                                1,
                                                            );
                                                            break;
                                                        case 2 /* OVERLINE */:
                                                            _this.ctx.fillRect(
                                                                text.bounds
                                                                    .left,
                                                                Math.round(
                                                                    text.bounds
                                                                        .top,
                                                                ),
                                                                text.bounds
                                                                    .width,
                                                                1,
                                                            );
                                                            break;
                                                        case 3 /* LINE_THROUGH */:
                                                            // TODO try and find exact position for line-through
                                                            _this.ctx.fillRect(
                                                                text.bounds
                                                                    .left,
                                                                Math.ceil(
                                                                    text.bounds
                                                                        .top +
                                                                        middle,
                                                                ),
                                                                text.bounds
                                                                    .width,
                                                                1,
                                                            );
                                                            break;
                                                    }
                                                },
                                            );
                                        }
                                        break;
                                    case 1 /* STROKE */:
                                        if (
                                            styles.webkitTextStrokeWidth &&
                                            text.text.trim().length
                                        ) {
                                            _this.ctx.strokeStyle = asString(
                                                styles.webkitTextStrokeColor,
                                            );
                                            _this.ctx.lineWidth =
                                                styles.webkitTextStrokeWidth;
                                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                            _this.ctx.lineJoin = !!window.chrome
                                                ? "miter"
                                                : "round";
                                            _this.ctx.strokeText(
                                                text.text,
                                                text.bounds.left,
                                                text.bounds.top + baseline,
                                            );
                                        }
                                        _this.ctx.strokeStyle = "";
                                        _this.ctx.lineWidth = 0;
                                        _this.ctx.lineJoin = "miter";
                                        break;
                                }
                            });
                        });
                        return [2 /*return*/];
                    });
                });
            };

            CanvasRenderer.prototype.renderReplacedElement = function (
                container,
                curves,
                image,
            ) {
                if (
                    image &&
                    container.intrinsicWidth > 0 &&
                    container.intrinsicHeight > 0
                ) {
                    var box = contentBox(container);
                    var path = calculatePaddingBoxPath(curves);
                    this.path(path);
                    this.ctx.save();
                    this.ctx.clip();
                    this.ctx.drawImage(
                        image,
                        0,
                        0,
                        container.intrinsicWidth,
                        container.intrinsicHeight,
                        box.left,
                        box.top,
                        box.width,
                        box.height,
                    );
                    this.ctx.restore();
                }
            };
            CanvasRenderer.prototype.renderNodeContent = function (paint) {
                return __awaiter(this, void 0, void 0, function () {
                    var container,
                        curves,
                        styles,
                        _i,
                        _a,
                        child,
                        image,
                        image,
                        iframeRenderer,
                        canvas,
                        size,
                        _b,
                        fontFamily,
                        fontSize,
                        baseline,
                        bounds,
                        x,
                        textBounds,
                        img,
                        image,
                        url,
                        fontFamily,
                        bounds;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0:
                                this.applyEffects(
                                    paint.getEffects(4 /* CONTENT */),
                                );
                                container = paint.container;
                                curves = paint.curves;
                                styles = container.styles;
                                (_i = 0), (_a = container.textNodes);
                                _c.label = 1;
                            case 1:
                                if (!(_i < _a.length)) return [3 /*break*/, 4];
                                child = _a[_i];
                                return [
                                    4 /*yield*/,
                                    this.renderTextNode(child, styles),
                                ];
                            case 2:
                                _c.sent();
                                _c.label = 3;
                            case 3:
                                _i++;
                                return [3 /*break*/, 1];
                            case 4:
                                if (
                                    !(
                                        container instanceof
                                        ImageElementContainer
                                    )
                                )
                                    return [3 /*break*/, 8];
                                _c.label = 5;
                            case 5:
                                _c.trys.push([5, 7, , 8]);
                                return [
                                    4 /*yield*/,
                                    this.context.cache.match(container.src),
                                ];
                            case 6:
                                image = _c.sent();
                                this.renderReplacedElement(
                                    container,
                                    curves,
                                    image,
                                );
                                return [3 /*break*/, 8];
                            case 7:
                                _c.sent();
                                this.context.logger.error(
                                    "Error loading image " + container.src,
                                );
                                return [3 /*break*/, 8];
                            case 8:
                                if (
                                    container instanceof CanvasElementContainer
                                ) {
                                    this.renderReplacedElement(
                                        container,
                                        curves,
                                        container.canvas,
                                    );
                                }
                                if (!(container instanceof SVGElementContainer))
                                    return [3 /*break*/, 12];
                                _c.label = 9;
                            case 9:
                                _c.trys.push([9, 11, , 12]);
                                return [
                                    4 /*yield*/,
                                    this.context.cache.match(container.svg),
                                ];
                            case 10:
                                image = _c.sent();
                                this.renderReplacedElement(
                                    container,
                                    curves,
                                    image,
                                );
                                return [3 /*break*/, 12];
                            case 11:
                                _c.sent();
                                this.context.logger.error(
                                    "Error loading svg " +
                                        container.svg.substring(0, 255),
                                );
                                return [3 /*break*/, 12];
                            case 12:
                                if (
                                    !(
                                        container instanceof
                                            IFrameElementContainer &&
                                        container.tree
                                    )
                                )
                                    return [3 /*break*/, 14];
                                iframeRenderer = new CanvasRenderer(
                                    this.context,
                                    {
                                        scale: this.options.scale,
                                        backgroundColor:
                                            container.backgroundColor,
                                        x: 0,
                                        y: 0,
                                        width: container.width,
                                        height: container.height,
                                    },
                                );
                                return [
                                    4 /*yield*/,
                                    iframeRenderer.render(container.tree),
                                ];
                            case 13:
                                canvas = _c.sent();
                                if (container.width && container.height) {
                                    this.ctx.drawImage(
                                        canvas,
                                        0,
                                        0,
                                        container.width,
                                        container.height,
                                        container.bounds.left,
                                        container.bounds.top,
                                        container.bounds.width,
                                        container.bounds.height,
                                    );
                                }
                                _c.label = 14;
                            case 14:
                                if (
                                    container instanceof InputElementContainer
                                ) {
                                    size = Math.min(
                                        container.bounds.width,
                                        container.bounds.height,
                                    );
                                    if (container.type === CHECKBOX) {
                                        if (container.checked) {
                                            this.ctx.save();
                                            this.path([
                                                new Vector(
                                                    container.bounds.left +
                                                        size * 0.39363,
                                                    container.bounds.top +
                                                        size * 0.79,
                                                ),
                                                new Vector(
                                                    container.bounds.left +
                                                        size * 0.16,
                                                    container.bounds.top +
                                                        size * 0.5549,
                                                ),
                                                new Vector(
                                                    container.bounds.left +
                                                        size * 0.27347,
                                                    container.bounds.top +
                                                        size * 0.44071,
                                                ),
                                                new Vector(
                                                    container.bounds.left +
                                                        size * 0.39694,
                                                    container.bounds.top +
                                                        size * 0.5649,
                                                ),
                                                new Vector(
                                                    container.bounds.left +
                                                        size * 0.72983,
                                                    container.bounds.top +
                                                        size * 0.23,
                                                ),
                                                new Vector(
                                                    container.bounds.left +
                                                        size * 0.84,
                                                    container.bounds.top +
                                                        size * 0.34085,
                                                ),
                                                new Vector(
                                                    container.bounds.left +
                                                        size * 0.39363,
                                                    container.bounds.top +
                                                        size * 0.79,
                                                ),
                                            ]);
                                            this.ctx.fillStyle =
                                                asString(INPUT_COLOR);
                                            this.ctx.fill();
                                            this.ctx.restore();
                                        }
                                    } else if (container.type === RADIO) {
                                        if (container.checked) {
                                            this.ctx.save();
                                            this.ctx.beginPath();
                                            this.ctx.arc(
                                                container.bounds.left +
                                                    size / 2,
                                                container.bounds.top + size / 2,
                                                size / 4,
                                                0,
                                                Math.PI * 2,
                                                true,
                                            );
                                            this.ctx.fillStyle =
                                                asString(INPUT_COLOR);
                                            this.ctx.fill();
                                            this.ctx.restore();
                                        }
                                    }
                                }
                                if (
                                    isTextInputElement(container) &&
                                    container.value.length
                                ) {
                                    (_b = this.createFontStyle(styles)),
                                        (fontFamily = _b[0]),
                                        (fontSize = _b[1]);
                                    baseline = this.fontMetrics.getMetrics(
                                        fontFamily,
                                        fontSize,
                                    ).baseline;
                                    this.ctx.font = fontFamily;
                                    this.ctx.fillStyle = asString(styles.color);
                                    this.ctx.textBaseline = "alphabetic";
                                    this.ctx.textAlign = canvasTextAlign(
                                        container.styles.textAlign,
                                    );
                                    bounds = contentBox(container);
                                    x = 0;
                                    switch (container.styles.textAlign) {
                                        case 1 /* CENTER */:
                                            x += bounds.width / 2;
                                            break;
                                        case 2 /* RIGHT */:
                                            x += bounds.width;
                                            break;
                                    }
                                    textBounds = bounds.add(
                                        x,
                                        0,
                                        0,
                                        -bounds.height / 2 + 1,
                                    );
                                    this.ctx.save();
                                    this.path([
                                        new Vector(bounds.left, bounds.top),
                                        new Vector(
                                            bounds.left + bounds.width,
                                            bounds.top,
                                        ),
                                        new Vector(
                                            bounds.left + bounds.width,
                                            bounds.top + bounds.height,
                                        ),
                                        new Vector(
                                            bounds.left,
                                            bounds.top + bounds.height,
                                        ),
                                    ]);
                                    this.ctx.clip();
                                    this.renderTextWithLetterSpacing(
                                        new TextBounds(
                                            container.value,
                                            textBounds,
                                        ),
                                        styles.letterSpacing,
                                        baseline,
                                    );
                                    this.ctx.restore();
                                    this.ctx.textBaseline = "alphabetic";
                                    this.ctx.textAlign = "left";
                                }
                                if (
                                    !contains(
                                        container.styles.display,
                                        2048 /* LIST_ITEM */,
                                    )
                                )
                                    return [3 /*break*/, 20];
                                if (!(container.styles.listStyleImage !== null))
                                    return [3 /*break*/, 19];
                                img = container.styles.listStyleImage;
                                if (!((img.type === 0) /* URL */))
                                    return [3 /*break*/, 18];
                                image = void 0;
                                url = img.url;
                                _c.label = 15;
                            case 15:
                                _c.trys.push([15, 17, , 18]);
                                return [
                                    4 /*yield*/,
                                    this.context.cache.match(url),
                                ];
                            case 16:
                                image = _c.sent();
                                this.ctx.drawImage(
                                    image,
                                    container.bounds.left - (image.width + 10),
                                    container.bounds.top,
                                );
                                return [3 /*break*/, 18];
                            case 17:
                                _c.sent();
                                this.context.logger.error(
                                    "Error loading list-style-image " + url,
                                );
                                return [3 /*break*/, 18];
                            case 18:
                                return [3 /*break*/, 20];
                            case 19:
                                if (
                                    paint.listValue &&
                                    container.styles.listStyleType !==
                                        -1 /* NONE */
                                ) {
                                    fontFamily =
                                        this.createFontStyle(styles)[0];
                                    this.ctx.font = fontFamily;
                                    this.ctx.fillStyle = asString(styles.color);
                                    this.ctx.textBaseline = "middle";
                                    this.ctx.textAlign = "right";
                                    bounds = new Bounds(
                                        container.bounds.left,
                                        container.bounds.top +
                                            getAbsoluteValue(
                                                container.styles.paddingTop,
                                                container.bounds.width,
                                            ),
                                        container.bounds.width,
                                        computeLineHeight(
                                            styles.lineHeight,
                                            styles.fontSize.number,
                                        ) /
                                            2 +
                                            1,
                                    );
                                    this.renderTextWithLetterSpacing(
                                        new TextBounds(paint.listValue, bounds),
                                        styles.letterSpacing,
                                        computeLineHeight(
                                            styles.lineHeight,
                                            styles.fontSize.number,
                                        ) /
                                            2 +
                                            2,
                                    );
                                    this.ctx.textBaseline = "bottom";
                                    this.ctx.textAlign = "left";
                                }
                                _c.label = 20;
                            case 20:
                                return [2 /*return*/];
                        }
                    });
                });
            };

            CanvasRenderer.prototype.renderStackContent = function (stack) {
                return __awaiter(this, void 0, void 0, function () {
                    var _i,
                        _a,
                        child,
                        _b,
                        _c,
                        child,
                        _d,
                        _e,
                        child,
                        _f,
                        _g,
                        child,
                        _h,
                        _j,
                        child,
                        _k,
                        _l,
                        child,
                        _m,
                        _o,
                        child;
                    return __generator(this, function (_p) {
                        switch (_p.label) {
                            case 0:
                                if (
                                    contains(
                                        stack.element.container.flags,
                                        16 /* DEBUG_RENDER */,
                                    )
                                ) {
                                    debugger;
                                }
                                // https://www.w3.org/TR/css-position-3/#painting-order
                                // 1. the background and borders of the element forming the stacking context.
                                return [
                                    4 /*yield*/,
                                    this.renderNodeBackgroundAndBorders(
                                        stack.element,
                                    ),
                                ];
                            case 1:
                                // https://www.w3.org/TR/css-position-3/#painting-order
                                // 1. the background and borders of the element forming the stacking context.
                                _p.sent();
                                (_i = 0), (_a = stack.negativeZIndex);
                                _p.label = 2;
                            case 2:
                                if (!(_i < _a.length)) return [3 /*break*/, 5];
                                child = _a[_i];
                                return [4 /*yield*/, this.renderStack(child)];
                            case 3:
                                _p.sent();
                                _p.label = 4;
                            case 4:
                                _i++;
                                return [3 /*break*/, 2];
                            case 5:
                                // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                                return [
                                    4 /*yield*/,
                                    this.renderNodeContent(stack.element),
                                ];
                            case 6:
                                // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                                _p.sent();
                                (_b = 0), (_c = stack.nonInlineLevel);
                                _p.label = 7;
                            case 7:
                                if (!(_b < _c.length)) return [3 /*break*/, 10];
                                child = _c[_b];
                                return [4 /*yield*/, this.renderNode(child)];
                            case 8:
                                _p.sent();
                                _p.label = 9;
                            case 9:
                                _b++;
                                return [3 /*break*/, 7];
                            case 10:
                                (_d = 0), (_e = stack.nonPositionedFloats);
                                _p.label = 11;
                            case 11:
                                if (!(_d < _e.length)) return [3 /*break*/, 14];
                                child = _e[_d];
                                return [4 /*yield*/, this.renderStack(child)];
                            case 12:
                                _p.sent();
                                _p.label = 13;
                            case 13:
                                _d++;
                                return [3 /*break*/, 11];
                            case 14:
                                (_f = 0), (_g = stack.nonPositionedInlineLevel);
                                _p.label = 15;
                            case 15:
                                if (!(_f < _g.length)) return [3 /*break*/, 18];
                                child = _g[_f];
                                return [4 /*yield*/, this.renderStack(child)];
                            case 16:
                                _p.sent();
                                _p.label = 17;
                            case 17:
                                _f++;
                                return [3 /*break*/, 15];
                            case 18:
                                (_h = 0), (_j = stack.inlineLevel);
                                _p.label = 19;
                            case 19:
                                if (!(_h < _j.length)) return [3 /*break*/, 22];
                                child = _j[_h];
                                return [4 /*yield*/, this.renderNode(child)];
                            case 20:
                                _p.sent();
                                _p.label = 21;
                            case 21:
                                _h++;
                                return [3 /*break*/, 19];
                            case 22:
                                (_k = 0),
                                    (_l =
                                        stack.zeroOrAutoZIndexOrTransformedOrOpacity);
                                _p.label = 23;
                            case 23:
                                if (!(_k < _l.length)) return [3 /*break*/, 26];
                                child = _l[_k];
                                return [4 /*yield*/, this.renderStack(child)];
                            case 24:
                                _p.sent();
                                _p.label = 25;
                            case 25:
                                _k++;
                                return [3 /*break*/, 23];
                            case 26:
                                (_m = 0), (_o = stack.positiveZIndex);
                                _p.label = 27;
                            case 27:
                                if (!(_m < _o.length)) return [3 /*break*/, 30];
                                child = _o[_m];
                                return [4 /*yield*/, this.renderStack(child)];
                            case 28:
                                _p.sent();
                                _p.label = 29;
                            case 29:
                                _m++;
                                return [3 /*break*/, 27];
                            case 30:
                                return [2 /*return*/];
                        }
                    });
                });
            };

            CanvasRenderer.prototype.mask = function (paths) {
                this.ctx.beginPath();
                this.ctx.moveTo(0, 0);
                this.ctx.lineTo(this.canvas.width, 0);
                this.ctx.lineTo(this.canvas.width, this.canvas.height);
                this.ctx.lineTo(0, this.canvas.height);
                this.ctx.lineTo(0, 0);
                this.formatPath(paths.slice(0).reverse());
                this.ctx.closePath();
            };
            CanvasRenderer.prototype.path = function (paths) {
                this.ctx.beginPath();
                this.formatPath(paths);
                this.ctx.closePath();
            };
            CanvasRenderer.prototype.formatPath = function (paths) {
                var _this = this;
                paths.forEach(function (point, index) {
                    var start = isBezierCurve(point) ? point.start : point;
                    if (index === 0) {
                        _this.ctx.moveTo(start.x, start.y);
                    } else {
                        _this.ctx.lineTo(start.x, start.y);
                    }
                    if (isBezierCurve(point)) {
                        _this.ctx.bezierCurveTo(
                            point.startControl.x,
                            point.startControl.y,
                            point.endControl.x,
                            point.endControl.y,
                            point.end.x,
                            point.end.y,
                        );
                    }
                });
            };
            CanvasRenderer.prototype.renderRepeat = function (
                path,
                pattern,
                offsetX,
                offsetY,
            ) {
                this.path(path);
                this.ctx.fillStyle = pattern;
                this.ctx.translate(offsetX, offsetY);
                this.ctx.fill();
                this.ctx.translate(-offsetX, -offsetY);
            };
            CanvasRenderer.prototype.resizeImage = function (
                image,
                width,
                height,
            ) {
                var _a;
                if (image.width === width && image.height === height) {
                    return image;
                }
                var ownerDocument =
                    (_a = this.canvas.ownerDocument) !== null && _a !== void 0
                        ? _a
                        : document;
                var canvas = ownerDocument.createElement("canvas");
                canvas.width = Math.max(1, width);
                canvas.height = Math.max(1, height);
                var ctx = canvas.getContext("2d");
                ctx.drawImage(
                    image,
                    0,
                    0,
                    image.width,
                    image.height,
                    0,
                    0,
                    width,
                    height,
                );
                return canvas;
            };
            CanvasRenderer.prototype.renderBackgroundImage = function (
                container,
            ) {
                return __awaiter(this, void 0, void 0, function () {
                    var index, _loop_1, this_1, _i, _a, backgroundImage;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                index =
                                    container.styles.backgroundImage.length - 1;
                                _loop_1 = function (backgroundImage) {
                                    var image,
                                        url,
                                        _c,
                                        path,
                                        x,
                                        y,
                                        width,
                                        height,
                                        pattern,
                                        _d,
                                        path,
                                        x,
                                        y,
                                        width,
                                        height,
                                        _e,
                                        lineLength,
                                        x0,
                                        x1,
                                        y0,
                                        y1,
                                        canvas,
                                        ctx,
                                        gradient_1,
                                        pattern,
                                        _f,
                                        path,
                                        left,
                                        top_1,
                                        width,
                                        height,
                                        position,
                                        x,
                                        y,
                                        _g,
                                        rx,
                                        ry,
                                        radialGradient_1,
                                        midX,
                                        midY,
                                        f,
                                        invF;
                                    return __generator(this, function (_h) {
                                        switch (_h.label) {
                                            case 0:
                                                if (
                                                    !(
                                                        (
                                                            backgroundImage.type ===
                                                            0
                                                        ) /* URL */
                                                    )
                                                )
                                                    return [3 /*break*/, 5];
                                                image = void 0;
                                                url = backgroundImage.url;
                                                _h.label = 1;
                                            case 1:
                                                _h.trys.push([1, 3, , 4]);
                                                return [
                                                    4 /*yield*/,
                                                    this_1.context.cache.match(
                                                        url,
                                                    ),
                                                ];
                                            case 2:
                                                image = _h.sent();
                                                return [3 /*break*/, 4];
                                            case 3:
                                                _h.sent();
                                                this_1.context.logger.error(
                                                    "Error loading background-image " +
                                                        url,
                                                );
                                                return [3 /*break*/, 4];
                                            case 4:
                                                if (image) {
                                                    (_c =
                                                        calculateBackgroundRendering(
                                                            container,
                                                            index,
                                                            [
                                                                image.width,
                                                                image.height,
                                                                image.width /
                                                                    image.height,
                                                            ],
                                                        )),
                                                        (path = _c[0]),
                                                        (x = _c[1]),
                                                        (y = _c[2]),
                                                        (width = _c[3]),
                                                        (height = _c[4]);
                                                    pattern =
                                                        this_1.ctx.createPattern(
                                                            this_1.resizeImage(
                                                                image,
                                                                width,
                                                                height,
                                                            ),
                                                            "repeat",
                                                        );
                                                    this_1.renderRepeat(
                                                        path,
                                                        pattern,
                                                        x,
                                                        y,
                                                    );
                                                }
                                                return [3 /*break*/, 6];
                                            case 5:
                                                if (
                                                    isLinearGradient(
                                                        backgroundImage,
                                                    )
                                                ) {
                                                    (_d =
                                                        calculateBackgroundRendering(
                                                            container,
                                                            index,
                                                            [null, null, null],
                                                        )),
                                                        (path = _d[0]),
                                                        (x = _d[1]),
                                                        (y = _d[2]),
                                                        (width = _d[3]),
                                                        (height = _d[4]);
                                                    (_e =
                                                        calculateGradientDirection(
                                                            backgroundImage.angle,
                                                            width,
                                                            height,
                                                        )),
                                                        (lineLength = _e[0]),
                                                        (x0 = _e[1]),
                                                        (x1 = _e[2]),
                                                        (y0 = _e[3]),
                                                        (y1 = _e[4]);
                                                    canvas =
                                                        document.createElement(
                                                            "canvas",
                                                        );
                                                    canvas.width = width;
                                                    canvas.height = height;
                                                    ctx =
                                                        canvas.getContext("2d");
                                                    gradient_1 =
                                                        ctx.createLinearGradient(
                                                            x0,
                                                            y0,
                                                            x1,
                                                            y1,
                                                        );
                                                    processColorStops(
                                                        backgroundImage.stops,
                                                        lineLength,
                                                    ).forEach(
                                                        function (colorStop) {
                                                            return gradient_1.addColorStop(
                                                                colorStop.stop,
                                                                asString(
                                                                    colorStop.color,
                                                                ),
                                                            );
                                                        },
                                                    );
                                                    ctx.fillStyle = gradient_1;
                                                    ctx.fillRect(
                                                        0,
                                                        0,
                                                        width,
                                                        height,
                                                    );
                                                    if (
                                                        width > 0 &&
                                                        height > 0
                                                    ) {
                                                        pattern =
                                                            this_1.ctx.createPattern(
                                                                canvas,
                                                                "repeat",
                                                            );
                                                        this_1.renderRepeat(
                                                            path,
                                                            pattern,
                                                            x,
                                                            y,
                                                        );
                                                    }
                                                } else if (
                                                    isRadialGradient(
                                                        backgroundImage,
                                                    )
                                                ) {
                                                    (_f =
                                                        calculateBackgroundRendering(
                                                            container,
                                                            index,
                                                            [null, null, null],
                                                        )),
                                                        (path = _f[0]),
                                                        (left = _f[1]),
                                                        (top_1 = _f[2]),
                                                        (width = _f[3]),
                                                        (height = _f[4]);
                                                    position =
                                                        backgroundImage.position
                                                            .length === 0
                                                            ? [FIFTY_PERCENT]
                                                            : backgroundImage.position;
                                                    x = getAbsoluteValue(
                                                        position[0],
                                                        width,
                                                    );
                                                    y = getAbsoluteValue(
                                                        position[
                                                            position.length - 1
                                                        ],
                                                        height,
                                                    );
                                                    (_g = calculateRadius(
                                                        backgroundImage,
                                                        x,
                                                        y,
                                                        width,
                                                        height,
                                                    )),
                                                        (rx = _g[0]),
                                                        (ry = _g[1]);
                                                    if (rx > 0 && ry > 0) {
                                                        radialGradient_1 =
                                                            this_1.ctx.createRadialGradient(
                                                                left + x,
                                                                top_1 + y,
                                                                0,
                                                                left + x,
                                                                top_1 + y,
                                                                rx,
                                                            );
                                                        processColorStops(
                                                            backgroundImage.stops,
                                                            rx * 2,
                                                        ).forEach(
                                                            function (
                                                                colorStop,
                                                            ) {
                                                                return radialGradient_1.addColorStop(
                                                                    colorStop.stop,
                                                                    asString(
                                                                        colorStop.color,
                                                                    ),
                                                                );
                                                            },
                                                        );
                                                        this_1.path(path);
                                                        this_1.ctx.fillStyle =
                                                            radialGradient_1;
                                                        if (rx !== ry) {
                                                            midX =
                                                                container.bounds
                                                                    .left +
                                                                0.5 *
                                                                    container
                                                                        .bounds
                                                                        .width;
                                                            midY =
                                                                container.bounds
                                                                    .top +
                                                                0.5 *
                                                                    container
                                                                        .bounds
                                                                        .height;
                                                            f = ry / rx;
                                                            invF = 1 / f;
                                                            this_1.ctx.save();
                                                            this_1.ctx.translate(
                                                                midX,
                                                                midY,
                                                            );
                                                            this_1.ctx.transform(
                                                                1,
                                                                0,
                                                                0,
                                                                f,
                                                                0,
                                                                0,
                                                            );
                                                            this_1.ctx.translate(
                                                                -midX,
                                                                -midY,
                                                            );
                                                            this_1.ctx.fillRect(
                                                                left,
                                                                invF *
                                                                    (top_1 -
                                                                        midY) +
                                                                    midY,
                                                                width,
                                                                height * invF,
                                                            );
                                                            this_1.ctx.restore();
                                                        } else {
                                                            this_1.ctx.fill();
                                                        }
                                                    }
                                                }
                                                _h.label = 6;
                                            case 6:
                                                index--;
                                                return [2 /*return*/];
                                        }
                                    });
                                };

                                this_1 = this;
                                (_i = 0),
                                    (_a = container.styles.backgroundImage
                                        .slice(0)
                                        .reverse());
                                _b.label = 1;
                            case 1:
                                if (!(_i < _a.length)) return [3 /*break*/, 4];
                                backgroundImage = _a[_i];
                                return [5 /*yield**/, _loop_1(backgroundImage)];
                            case 2:
                                _b.sent();
                                _b.label = 3;
                            case 3:
                                _i++;
                                return [3 /*break*/, 1];
                            case 4:
                                return [2 /*return*/];
                        }
                    });
                });
            };

            CanvasRenderer.prototype.renderSolidBorder = function (
                color,
                side,
                curvePoints,
            ) {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        this.path(parsePathForBorder(curvePoints, side));
                        this.ctx.fillStyle = asString(color);
                        this.ctx.fill();
                        return [2 /*return*/];
                    });
                });
            };

            CanvasRenderer.prototype.renderDoubleBorder = function (
                color,
                width,
                side,
                curvePoints,
            ) {
                return __awaiter(this, void 0, void 0, function () {
                    var outerPaths, innerPaths;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!(width < 3)) return [3 /*break*/, 2];
                                return [
                                    4 /*yield*/,
                                    this.renderSolidBorder(
                                        color,
                                        side,
                                        curvePoints,
                                    ),
                                ];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                            case 2:
                                outerPaths = parsePathForBorderDoubleOuter(
                                    curvePoints,
                                    side,
                                );
                                this.path(outerPaths);
                                this.ctx.fillStyle = asString(color);
                                this.ctx.fill();
                                innerPaths = parsePathForBorderDoubleInner(
                                    curvePoints,
                                    side,
                                );
                                this.path(innerPaths);
                                this.ctx.fill();
                                return [2 /*return*/];
                        }
                    });
                });
            };

            CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function (
                paint,
            ) {
                return __awaiter(this, void 0, void 0, function () {
                    var styles,
                        hasBackground,
                        borders,
                        backgroundPaintingArea,
                        side,
                        _i,
                        borders_1,
                        border;
                    var _this = this;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                this.applyEffects(
                                    paint.getEffects(
                                        2 /* BACKGROUND_BORDERS */,
                                    ),
                                );
                                styles = paint.container.styles;
                                hasBackground =
                                    !isTransparent(styles.backgroundColor) ||
                                    styles.backgroundImage.length;
                                borders = [
                                    {
                                        style: styles.borderTopStyle,
                                        color: styles.borderTopColor,
                                        width: styles.borderTopWidth,
                                    },
                                    {
                                        style: styles.borderRightStyle,
                                        color: styles.borderRightColor,
                                        width: styles.borderRightWidth,
                                    },
                                    {
                                        style: styles.borderBottomStyle,
                                        color: styles.borderBottomColor,
                                        width: styles.borderBottomWidth,
                                    },
                                    {
                                        style: styles.borderLeftStyle,
                                        color: styles.borderLeftColor,
                                        width: styles.borderLeftWidth,
                                    },
                                ];
                                backgroundPaintingArea =
                                    calculateBackgroundCurvedPaintingArea(
                                        getBackgroundValueForIndex(
                                            styles.backgroundClip,
                                            0,
                                        ),
                                        paint.curves,
                                    );
                                if (!(hasBackground || styles.boxShadow.length))
                                    return [3 /*break*/, 2];
                                this.ctx.save();
                                this.path(backgroundPaintingArea);
                                this.ctx.clip();
                                if (!isTransparent(styles.backgroundColor)) {
                                    this.ctx.fillStyle = asString(
                                        styles.backgroundColor,
                                    );
                                    this.ctx.fill();
                                }
                                return [
                                    4 /*yield*/,
                                    this.renderBackgroundImage(paint.container),
                                ];
                            case 1:
                                _a.sent();
                                this.ctx.restore();
                                styles.boxShadow
                                    .slice(0)
                                    .reverse()
                                    .forEach(function (shadow) {
                                        _this.ctx.save();
                                        var borderBoxArea =
                                            calculateBorderBoxPath(
                                                paint.curves,
                                            );
                                        var maskOffset = shadow.inset
                                            ? 0
                                            : MASK_OFFSET;
                                        var shadowPaintingArea = transformPath(
                                            borderBoxArea,
                                            -maskOffset +
                                                (shadow.inset ? 1 : -1) *
                                                    shadow.spread.number,
                                            (shadow.inset ? 1 : -1) *
                                                shadow.spread.number,
                                            shadow.spread.number *
                                                (shadow.inset ? -2 : 2),
                                            shadow.spread.number *
                                                (shadow.inset ? -2 : 2),
                                        );
                                        if (shadow.inset) {
                                            _this.path(borderBoxArea);
                                            _this.ctx.clip();
                                            _this.mask(shadowPaintingArea);
                                        } else {
                                            _this.mask(borderBoxArea);
                                            _this.ctx.clip();
                                            _this.path(shadowPaintingArea);
                                        }
                                        _this.ctx.shadowOffsetX =
                                            shadow.offsetX.number + maskOffset;
                                        _this.ctx.shadowOffsetY =
                                            shadow.offsetY.number;
                                        _this.ctx.shadowColor = asString(
                                            shadow.color,
                                        );
                                        _this.ctx.shadowBlur =
                                            shadow.blur.number;
                                        _this.ctx.fillStyle = shadow.inset
                                            ? asString(shadow.color)
                                            : "rgba(0,0,0,1)";
                                        _this.ctx.fill();
                                        _this.ctx.restore();
                                    });
                                _a.label = 2;
                            case 2:
                                side = 0;
                                (_i = 0), (borders_1 = borders);
                                _a.label = 3;
                            case 3:
                                if (!(_i < borders_1.length))
                                    return [3 /*break*/, 13];
                                border = borders_1[_i];
                                if (
                                    !(
                                        border.style !== 0 /* NONE */ &&
                                        !isTransparent(border.color) &&
                                        border.width > 0
                                    )
                                )
                                    return [3 /*break*/, 11];
                                if (!((border.style === 2) /* DASHED */))
                                    return [3 /*break*/, 5];
                                return [
                                    4 /*yield*/,
                                    this.renderDashedDottedBorder(
                                        border.color,
                                        border.width,
                                        side,
                                        paint.curves,
                                        2 /* DASHED */,
                                    ),
                                ];
                            case 4:
                                _a.sent();
                                return [3 /*break*/, 11];
                            case 5:
                                if (!((border.style === 3) /* DOTTED */))
                                    return [3 /*break*/, 7];
                                return [
                                    4 /*yield*/,
                                    this.renderDashedDottedBorder(
                                        border.color,
                                        border.width,
                                        side,
                                        paint.curves,
                                        3 /* DOTTED */,
                                    ),
                                ];
                            case 6:
                                _a.sent();
                                return [3 /*break*/, 11];
                            case 7:
                                if (!((border.style === 4) /* DOUBLE */))
                                    return [3 /*break*/, 9];
                                return [
                                    4 /*yield*/,
                                    this.renderDoubleBorder(
                                        border.color,
                                        border.width,
                                        side,
                                        paint.curves,
                                    ),
                                ];
                            case 8:
                                _a.sent();
                                return [3 /*break*/, 11];
                            case 9:
                                return [
                                    4 /*yield*/,
                                    this.renderSolidBorder(
                                        border.color,
                                        side,
                                        paint.curves,
                                    ),
                                ];
                            case 10:
                                _a.sent();
                                _a.label = 11;
                            case 11:
                                side++;
                                _a.label = 12;
                            case 12:
                                _i++;
                                return [3 /*break*/, 3];
                            case 13:
                                return [2 /*return*/];
                        }
                    });
                });
            };

            CanvasRenderer.prototype.renderDashedDottedBorder = function (
                color,
                width,
                side,
                curvePoints,
                style,
            ) {
                return __awaiter(this, void 0, void 0, function () {
                    var strokePaths,
                        boxPaths,
                        startX,
                        startY,
                        endX,
                        endY,
                        length,
                        dashLength,
                        spaceLength,
                        useLineDash,
                        multiplier,
                        numberOfDashes,
                        minSpace,
                        maxSpace,
                        path1,
                        path2,
                        path1,
                        path2;
                    return __generator(this, function (_a) {
                        this.ctx.save();
                        strokePaths = parsePathForBorderStroke(
                            curvePoints,
                            side,
                        );
                        boxPaths = parsePathForBorder(curvePoints, side);
                        if (style === 2 /* DASHED */) {
                            this.path(boxPaths);
                            this.ctx.clip();
                        }
                        if (isBezierCurve(boxPaths[0])) {
                            startX = boxPaths[0].start.x;
                            startY = boxPaths[0].start.y;
                        } else {
                            startX = boxPaths[0].x;
                            startY = boxPaths[0].y;
                        }
                        if (isBezierCurve(boxPaths[1])) {
                            endX = boxPaths[1].end.x;
                            endY = boxPaths[1].end.y;
                        } else {
                            endX = boxPaths[1].x;
                            endY = boxPaths[1].y;
                        }
                        if (side === 0 || side === 2) {
                            length = Math.abs(startX - endX);
                        } else {
                            length = Math.abs(startY - endY);
                        }
                        this.ctx.beginPath();
                        if (style === 3 /* DOTTED */) {
                            this.formatPath(strokePaths);
                        } else {
                            this.formatPath(boxPaths.slice(0, 2));
                        }
                        dashLength = width < 3 ? width * 3 : width * 2;
                        spaceLength = width < 3 ? width * 2 : width;
                        if (style === 3 /* DOTTED */) {
                            dashLength = width;
                            spaceLength = width;
                        }
                        useLineDash = true;
                        if (length <= dashLength * 2) {
                            useLineDash = false;
                        } else if (length <= dashLength * 2 + spaceLength) {
                            multiplier =
                                length / (2 * dashLength + spaceLength);
                            dashLength *= multiplier;
                            spaceLength *= multiplier;
                        } else {
                            numberOfDashes = Math.floor(
                                (length + spaceLength) /
                                    (dashLength + spaceLength),
                            );
                            minSpace =
                                (length - numberOfDashes * dashLength) /
                                (numberOfDashes - 1);
                            maxSpace =
                                (length - (numberOfDashes + 1) * dashLength) /
                                numberOfDashes;
                            spaceLength =
                                maxSpace <= 0 ||
                                Math.abs(spaceLength - minSpace) <
                                    Math.abs(spaceLength - maxSpace)
                                    ? minSpace
                                    : maxSpace;
                        }
                        if (useLineDash) {
                            if (style === 3 /* DOTTED */) {
                                this.ctx.setLineDash([
                                    0,
                                    dashLength + spaceLength,
                                ]);
                            } else {
                                this.ctx.setLineDash([dashLength, spaceLength]);
                            }
                        }
                        if (style === 3 /* DOTTED */) {
                            this.ctx.lineCap = "round";
                            this.ctx.lineWidth = width;
                        } else {
                            this.ctx.lineWidth = width * 2 + 1.1;
                        }
                        this.ctx.strokeStyle = asString(color);
                        this.ctx.stroke();
                        this.ctx.setLineDash([]);
                        // dashed round edge gap
                        if (style === 2 /* DASHED */) {
                            if (isBezierCurve(boxPaths[0])) {
                                path1 = boxPaths[3];
                                path2 = boxPaths[0];
                                this.ctx.beginPath();
                                this.formatPath([
                                    new Vector(path1.end.x, path1.end.y),
                                    new Vector(path2.start.x, path2.start.y),
                                ]);
                                this.ctx.stroke();
                            }
                            if (isBezierCurve(boxPaths[1])) {
                                path1 = boxPaths[1];
                                path2 = boxPaths[2];
                                this.ctx.beginPath();
                                this.formatPath([
                                    new Vector(path1.end.x, path1.end.y),
                                    new Vector(path2.start.x, path2.start.y),
                                ]);
                                this.ctx.stroke();
                            }
                        }
                        this.ctx.restore();
                        return [2 /*return*/];
                    });
                });
            };

            CanvasRenderer.prototype.render = function (element) {
                return __awaiter(this, void 0, void 0, function () {
                    var stack;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (this.options.backgroundColor) {
                                    this.ctx.fillStyle = asString(
                                        this.options.backgroundColor,
                                    );
                                    this.ctx.fillRect(
                                        this.options.x,
                                        this.options.y,
                                        this.options.width,
                                        this.options.height,
                                    );
                                }
                                stack = parseStackingContexts(element);
                                return [4 /*yield*/, this.renderStack(stack)];
                            case 1:
                                _a.sent();
                                this.applyEffects([]);
                                return [2 /*return*/, this.canvas];
                        }
                    });
                });
            };
            return CanvasRenderer;
        })(Renderer);
        var isTextInputElement = function (container) {
            if (container instanceof TextareaElementContainer) {
                return true;
            } else if (container instanceof SelectElementContainer) {
                return true;
            } else if (
                container instanceof InputElementContainer &&
                container.type !== RADIO &&
                container.type !== CHECKBOX
            ) {
                return true;
            }
            return false;
        };
        var calculateBackgroundCurvedPaintingArea = function (clip, curves) {
            switch (clip) {
                case 0 /* BORDER_BOX */:
                    return calculateBorderBoxPath(curves);
                case 2 /* CONTENT_BOX */:
                    return calculateContentBoxPath(curves);
                case 1 /* PADDING_BOX */:
                default:
                    return calculatePaddingBoxPath(curves);
            }
        };
        var canvasTextAlign = function (textAlign) {
            switch (textAlign) {
                case 1 /* CENTER */:
                    return "center";
                case 2 /* RIGHT */:
                    return "right";
                case 0 /* LEFT */:
                default:
                    return "left";
            }
        };
        // see https://github.com/niklasvh/html2canvas/pull/2645
        var iOSBrokenFonts = ["-apple-system", "system-ui"];
        var fixIOSSystemFonts = function (fontFamilies) {
            return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent)
                ? fontFamilies.filter(function (fontFamily) {
                      return iOSBrokenFonts.indexOf(fontFamily) === -1;
                  })
                : fontFamilies;
        };
        var ForeignObjectRenderer = /** @class */ (function (_super) {
            __extends(ForeignObjectRenderer, _super);
            function ForeignObjectRenderer(context, options) {
                var _this = _super.call(this, context, options) || this;
                _this.canvas = options.canvas
                    ? options.canvas
                    : document.createElement("canvas");
                _this.ctx = _this.canvas.getContext("2d");
                _this.options = options;
                _this.canvas.width = Math.floor(options.width * options.scale);
                _this.canvas.height = Math.floor(
                    options.height * options.scale,
                );
                _this.canvas.style.width = options.width + "px";
                _this.canvas.style.height = options.height + "px";
                _this.ctx.scale(_this.options.scale, _this.options.scale);
                _this.ctx.translate(-options.x, -options.y);
                _this.context.logger.debug(
                    "EXPERIMENTAL ForeignObject renderer initialized (" +
                        options.width +
                        "x" +
                        options.height +
                        " at " +
                        options.x +
                        "," +
                        options.y +
                        ") with scale " +
                        options.scale,
                );
                return _this;
            }
            ForeignObjectRenderer.prototype.render = function (element) {
                return __awaiter(this, void 0, void 0, function () {
                    var svg, img;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                svg = createForeignObjectSVG(
                                    this.options.width * this.options.scale,
                                    this.options.height * this.options.scale,
                                    this.options.scale,
                                    this.options.scale,
                                    element,
                                );
                                return [4 /*yield*/, loadSerializedSVG(svg)];
                            case 1:
                                img = _a.sent();
                                if (this.options.backgroundColor) {
                                    this.ctx.fillStyle = asString(
                                        this.options.backgroundColor,
                                    );
                                    this.ctx.fillRect(
                                        0,
                                        0,
                                        this.options.width * this.options.scale,
                                        this.options.height *
                                            this.options.scale,
                                    );
                                }
                                this.ctx.drawImage(
                                    img,
                                    -this.options.x * this.options.scale,
                                    -this.options.y * this.options.scale,
                                );
                                return [2 /*return*/, this.canvas];
                        }
                    });
                });
            };
            return ForeignObjectRenderer;
        })(Renderer);
        var loadSerializedSVG = function (svg) {
            return new Promise(function (resolve, reject) {
                var img = new Image();
                img.onload = function () {
                    resolve(img);
                };
                img.onerror = reject;
                img.src =
                    "data:image/svg+xml;charset=utf-8," +
                    encodeURIComponent(
                        new XMLSerializer().serializeToString(svg),
                    );
            });
        };
        var Logger = /** @class */ (function () {
            function Logger(_a) {
                var id = _a.id,
                    enabled = _a.enabled;
                this.id = id;
                this.enabled = enabled;
                this.start = Date.now();
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            Logger.prototype.debug = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                if (this.enabled) {
                    // eslint-disable-next-line no-console
                    if (
                        typeof window !== "undefined" &&
                        window.console &&
                        typeof console.debug === "function"
                    ) {
                        // eslint-disable-next-line no-console
                        console.debug.apply(
                            console,
                            __spreadArray(
                                [this.id, this.getTime() + "ms"],
                                args,
                            ),
                        );
                    } else {
                        this.info.apply(this, args);
                    }
                }
            };
            Logger.prototype.getTime = function () {
                return Date.now() - this.start;
            };
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            Logger.prototype.info = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                if (this.enabled) {
                    // eslint-disable-next-line no-console
                    if (
                        typeof window !== "undefined" &&
                        window.console &&
                        typeof console.info === "function"
                    ) {
                        // eslint-disable-next-line no-console
                        console.info.apply(
                            console,
                            __spreadArray(
                                [this.id, this.getTime() + "ms"],
                                args,
                            ),
                        );
                    }
                }
            };
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            Logger.prototype.warn = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                if (this.enabled) {
                    // eslint-disable-next-line no-console
                    if (
                        typeof window !== "undefined" &&
                        window.console &&
                        typeof console.warn === "function"
                    ) {
                        // eslint-disable-next-line no-console
                        console.warn.apply(
                            console,
                            __spreadArray(
                                [this.id, this.getTime() + "ms"],
                                args,
                            ),
                        );
                    } else {
                        this.info.apply(this, args);
                    }
                }
            };
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            Logger.prototype.error = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                if (this.enabled) {
                    // eslint-disable-next-line no-console
                    if (
                        typeof window !== "undefined" &&
                        window.console &&
                        typeof console.error === "function"
                    ) {
                        // eslint-disable-next-line no-console
                        console.error.apply(
                            console,
                            __spreadArray(
                                [this.id, this.getTime() + "ms"],
                                args,
                            ),
                        );
                    } else {
                        this.info.apply(this, args);
                    }
                }
            };
            Logger.instances = {};
            return Logger;
        })();
        var Context = /** @class */ (function () {
            function Context(options, windowBounds) {
                var _a;
                this.windowBounds = windowBounds;
                this.instanceName = "#" + Context.instanceCount++;
                this.logger = new Logger({
                    id: this.instanceName,
                    enabled: options.logging,
                });
                this.cache =
                    (_a = options.cache) !== null && _a !== void 0
                        ? _a
                        : new Cache(this, options);
            }
            Context.instanceCount = 1;
            return Context;
        })();
        var html2canvas = function (element, options) {
            if (options === void 0) {
                options = {};
            }
            return renderElement(element, options);
        };
        if (typeof window !== "undefined") {
            CacheStorage.setContext(window);
        }
        var renderElement = function (element, opts) {
            return __awaiter(void 0, void 0, void 0, function () {
                var ownerDocument,
                    defaultView,
                    resourceOptions,
                    contextOptions,
                    windowOptions,
                    windowBounds,
                    context,
                    foreignObjectRendering,
                    cloneOptions,
                    documentCloner,
                    clonedElement,
                    container,
                    _a,
                    width,
                    height,
                    left,
                    top,
                    backgroundColor,
                    renderOptions,
                    canvas,
                    renderer,
                    root,
                    renderer;
                var _b,
                    _c,
                    _d,
                    _e,
                    _f,
                    _g,
                    _h,
                    _j,
                    _k,
                    _l,
                    _m,
                    _o,
                    _p,
                    _q,
                    _r,
                    _s,
                    _t;
                return __generator(this, function (_u) {
                    switch (_u.label) {
                        case 0:
                            if (!element || typeof element !== "object") {
                                return [
                                    2 /*return*/,
                                    Promise.reject(
                                        "Invalid element provided as first argument",
                                    ),
                                ];
                            }
                            ownerDocument = element.ownerDocument;
                            if (!ownerDocument) {
                                throw new Error(
                                    "Element is not attached to a Document",
                                );
                            }
                            defaultView = ownerDocument.defaultView;
                            if (!defaultView) {
                                throw new Error(
                                    "Document is not attached to a Window",
                                );
                            }
                            resourceOptions = {
                                allowTaint:
                                    (_b = opts.allowTaint) !== null &&
                                    _b !== void 0
                                        ? _b
                                        : false,
                                imageTimeout:
                                    (_c = opts.imageTimeout) !== null &&
                                    _c !== void 0
                                        ? _c
                                        : 15000,
                                proxy: opts.proxy,
                                useCORS:
                                    (_d = opts.useCORS) !== null &&
                                    _d !== void 0
                                        ? _d
                                        : false,
                            };
                            contextOptions = __assign(
                                {
                                    logging:
                                        (_e = opts.logging) !== null &&
                                        _e !== void 0
                                            ? _e
                                            : true,
                                    cache: opts.cache,
                                },
                                resourceOptions,
                            );
                            windowOptions = {
                                windowWidth:
                                    (_f = opts.windowWidth) !== null &&
                                    _f !== void 0
                                        ? _f
                                        : defaultView.innerWidth,
                                windowHeight:
                                    (_g = opts.windowHeight) !== null &&
                                    _g !== void 0
                                        ? _g
                                        : defaultView.innerHeight,
                                scrollX:
                                    (_h = opts.scrollX) !== null &&
                                    _h !== void 0
                                        ? _h
                                        : defaultView.pageXOffset,
                                scrollY:
                                    (_j = opts.scrollY) !== null &&
                                    _j !== void 0
                                        ? _j
                                        : defaultView.pageYOffset,
                            };
                            windowBounds = new Bounds(
                                windowOptions.scrollX,
                                windowOptions.scrollY,
                                windowOptions.windowWidth,
                                windowOptions.windowHeight,
                            );
                            context = new Context(contextOptions, windowBounds);
                            foreignObjectRendering =
                                (_k = opts.foreignObjectRendering) !== null &&
                                _k !== void 0
                                    ? _k
                                    : false;
                            cloneOptions = {
                                allowTaint:
                                    (_l = opts.allowTaint) !== null &&
                                    _l !== void 0
                                        ? _l
                                        : false,
                                onclone: opts.onclone,
                                ignoreElements: opts.ignoreElements,
                                inlineImages: foreignObjectRendering,
                                copyStyles: foreignObjectRendering,
                            };
                            context.logger.debug(
                                "Starting document clone with size " +
                                    windowBounds.width +
                                    "x" +
                                    windowBounds.height +
                                    " scrolled to " +
                                    -windowBounds.left +
                                    "," +
                                    -windowBounds.top,
                            );
                            documentCloner = new DocumentCloner(
                                context,
                                element,
                                cloneOptions,
                            );
                            clonedElement =
                                documentCloner.clonedReferenceElement;
                            if (!clonedElement) {
                                return [
                                    2 /*return*/,
                                    Promise.reject(
                                        "Unable to find element in cloned iframe",
                                    ),
                                ];
                            }
                            return [
                                4 /*yield*/,
                                documentCloner.toIFrame(
                                    ownerDocument,
                                    windowBounds,
                                ),
                            ];
                        case 1:
                            container = _u.sent();
                            (_a =
                                isBodyElement(clonedElement) ||
                                isHTMLElement(clonedElement)
                                    ? parseDocumentSize(
                                          clonedElement.ownerDocument,
                                      )
                                    : parseBounds(context, clonedElement)),
                                (width = _a.width),
                                (height = _a.height),
                                (left = _a.left),
                                (top = _a.top);
                            backgroundColor = parseBackgroundColor(
                                context,
                                clonedElement,
                                opts.backgroundColor,
                            );
                            renderOptions = {
                                canvas: opts.canvas,
                                backgroundColor: backgroundColor,
                                scale:
                                    (_o =
                                        (_m = opts.scale) !== null &&
                                        _m !== void 0
                                            ? _m
                                            : defaultView.devicePixelRatio) !==
                                        null && _o !== void 0
                                        ? _o
                                        : 1,
                                x:
                                    ((_p = opts.x) !== null && _p !== void 0
                                        ? _p
                                        : 0) + left,
                                y:
                                    ((_q = opts.y) !== null && _q !== void 0
                                        ? _q
                                        : 0) + top,
                                width:
                                    (_r = opts.width) !== null && _r !== void 0
                                        ? _r
                                        : Math.ceil(width),
                                height:
                                    (_s = opts.height) !== null && _s !== void 0
                                        ? _s
                                        : Math.ceil(height),
                            };
                            if (!foreignObjectRendering)
                                return [3 /*break*/, 3];
                            context.logger.debug(
                                "Document cloned, using foreign object rendering",
                            );
                            renderer = new ForeignObjectRenderer(
                                context,
                                renderOptions,
                            );
                            return [
                                4 /*yield*/,
                                renderer.render(clonedElement),
                            ];
                        case 2:
                            canvas = _u.sent();
                            return [3 /*break*/, 5];
                        case 3:
                            context.logger.debug(
                                "Document cloned, element located at " +
                                    left +
                                    "," +
                                    top +
                                    " with size " +
                                    width +
                                    "x" +
                                    height +
                                    " using computed rendering",
                            );
                            context.logger.debug("Starting DOM parsing");
                            root = parseTree(context, clonedElement);
                            if (
                                backgroundColor === root.styles.backgroundColor
                            ) {
                                root.styles.backgroundColor =
                                    COLORS.TRANSPARENT;
                            }
                            context.logger.debug(
                                "Starting renderer for element at " +
                                    renderOptions.x +
                                    "," +
                                    renderOptions.y +
                                    " with size " +
                                    renderOptions.width +
                                    "x" +
                                    renderOptions.height,
                            );
                            renderer = new CanvasRenderer(
                                context,
                                renderOptions,
                            );
                            return [4 /*yield*/, renderer.render(root)];
                        case 4:
                            canvas = _u.sent();
                            _u.label = 5;
                        case 5:
                            if (
                                (_t = opts.removeContainer) !== null &&
                                _t !== void 0
                                    ? _t
                                    : true
                            ) {
                                if (!DocumentCloner.destroy(container)) {
                                    context.logger.error(
                                        "Cannot detach cloned iframe as it is not in the DOM anymore",
                                    );
                                }
                            }
                            context.logger.debug("Finished rendering");
                            return [2 /*return*/, canvas];
                    }
                });
            });
        };
        var parseBackgroundColor = function (
            context,
            element,
            backgroundColorOverride,
        ) {
            var ownerDocument = element.ownerDocument;
            // http://www.w3.org/TR/css3-background/#special-backgrounds
            var documentBackgroundColor = ownerDocument.documentElement
                ? parseColor(
                      context,
                      getComputedStyle(ownerDocument.documentElement)
                          .backgroundColor,
                  )
                : COLORS.TRANSPARENT;
            var bodyBackgroundColor = ownerDocument.body
                ? parseColor(
                      context,
                      getComputedStyle(ownerDocument.body).backgroundColor,
                  )
                : COLORS.TRANSPARENT;
            var defaultBackgroundColor =
                typeof backgroundColorOverride === "string"
                    ? parseColor(context, backgroundColorOverride)
                    : backgroundColorOverride === null
                      ? COLORS.TRANSPARENT
                      : 0xffffffff;
            return element === ownerDocument.documentElement
                ? isTransparent(documentBackgroundColor)
                    ? isTransparent(bodyBackgroundColor)
                        ? defaultBackgroundColor
                        : bodyBackgroundColor
                    : documentBackgroundColor
                : defaultBackgroundColor;
        };
        return html2canvas;
    });
})(html2canvas$2);
var html2canvas = html2canvasExports;

var html2canvas$1 = /*#__PURE__*/ _mergeNamespaces(
    {
        __proto__: null,
        default: html2canvas,
    },
    [html2canvasExports],
);

/**
 * Tools for svg.
 * @module svg
 * @license MIT
 * @copyright 2011 Jeff Schiller
 */
const {
    InsertElementCommand,
    RemoveElementCommand,
    ChangeElementCommand,
    BatchCommand,
} = history;
let svgCanvas$2 = null;

/**
 * @function module:svg-exec.init
 * @param {module:svg-exec.SvgCanvas#init} svgContext
 * @returns {void}
 */
const init$2 = (canvas) => {
    svgCanvas$2 = canvas;
    svgCanvas$2.setSvgString = setSvgString;
    svgCanvas$2.importSvgString = importSvgString;
    svgCanvas$2.uniquifyElems = uniquifyElemsMethod;
    svgCanvas$2.setUseData = setUseDataMethod;
    svgCanvas$2.convertGradients = convertGradientsMethod;
    svgCanvas$2.removeUnusedDefElems = removeUnusedDefElemsMethod; // remove DOM elements inside the `<defs>` if they are notreferred to,
    svgCanvas$2.svgCanvasToString = svgCanvasToString; // Main function to set up the SVG content for output.
    svgCanvas$2.svgToString = svgToString; // Sub function ran on each SVG element to convert it to a string as desired.
    svgCanvas$2.embedImage = embedImage; // Converts a given image file to a data URL when possibl
    svgCanvas$2.rasterExport = rasterExport; // Generates a PNG (or JPG, BMP, WEBP) Data URL based on the current image
    svgCanvas$2.exportPDF = exportPDF; // Generates a PDF based on the current image, then calls "exportedPDF"
};

/**
 * Main function to set up the SVG content for output.
 * @function module:svgcanvas.SvgCanvas#svgCanvasToString
 * @returns {string} The SVG image for output
 */
const svgCanvasToString = () => {
    // keep calling it until there are none to remove
    while (svgCanvas$2.removeUnusedDefElems() > 0) {} // eslint-disable-line no-empty

    svgCanvas$2.pathActions.clear(true);

    // Keep SVG-Edit comment on top
    const childNodesElems = svgCanvas$2.getSvgContent().childNodes;
    childNodesElems.forEach((node, i) => {
        if (i && node.nodeType === 8 && node.data.includes("Created with")) {
            svgCanvas$2.getSvgContent().firstChild.before(node);
        }
    });

    // Move out of in-group editing mode
    if (svgCanvas$2.getCurrentGroup()) {
        leaveContext();
        svgCanvas$2.selectOnly([svgCanvas$2.getCurrentGroup()]);
    }
    const nakedSvgs = [];

    // Unwrap gsvg if it has no special attributes (only id and style)
    const gsvgElems = svgCanvas$2
        .getSvgContent()
        .querySelectorAll("g[data-gsvg]");
    Array.prototype.forEach.call(gsvgElems, (element) => {
        const attrs = element.attributes;
        let len = attrs.length;
        for (let i = 0; i < len; i++) {
            if (attrs[i].nodeName === "id" || attrs[i].nodeName === "style") {
                len--;
            }
        }
        // No significant attributes, so ungroup
        if (len <= 0) {
            const svg = element.firstChild;
            nakedSvgs.push(svg);
            element.replaceWith(svg);
        }
    });
    const output = svgCanvas$2.svgToString(svgCanvas$2.getSvgContent(), 0);

    // Rewrap gsvg
    if (nakedSvgs.length) {
        Array.prototype.forEach.call(nakedSvgs, (el) => {
            svgCanvas$2.groupSvgElem(el);
        });
    }
    return output;
};

/**
 * Sub function ran on each SVG element to convert it to a string as desired.
 * @function module:svgcanvas.SvgCanvas#svgToString
 * @param {Element} elem - The SVG element to convert
 * @param {Integer} indent - Number of spaces to indent this tag
 * @returns {string} The given element as an SVG tag
 */
const svgToString = (elem, indent) => {
    const curConfig = svgCanvas$2.getCurConfig();
    const nsMap = svgCanvas$2.getNsMap();
    const out = [];
    const unit = curConfig.baseUnit;
    const unitRe = new RegExp("^-?[\\d\\.]+" + unit + "$");
    if (elem) {
        cleanupElement(elem);
        const attrs = [...elem.attributes];
        const childs = elem.childNodes;
        attrs.sort((a, b) => {
            return a.name > b.name ? -1 : 1;
        });
        for (let i = 0; i < indent; i++) {
            out.push(" ");
        }
        out.push("<");
        out.push(elem.nodeName);
        if (elem.id === "svgcontent") {
            // Process root element separately
            const res = svgCanvas$2.getResolution();
            let vb = "";
            // TODO: Allow this by dividing all values by current baseVal
            // Note that this also means we should properly deal with this on import
            // if (curConfig.baseUnit !== 'px') {
            //   const unit = curConfig.baseUnit;
            //   const unitM = getTypeMap()[unit];
            //   res.w = shortFloat(res.w / unitM);
            //   res.h = shortFloat(res.h / unitM);
            //   vb = ' viewBox="' + [0, 0, res.w, res.h].join(' ') + '"';
            //   res.w += unit;
            //   res.h += unit;
            // }
            if (curConfig.dynamicOutput) {
                vb = elem.getAttribute("viewBox");
                out.push(' viewBox="' + vb + '" xmlns="' + NS.SVG + '"');
            } else {
                if (unit !== "px") {
                    res.w = convertUnit(res.w, unit) + unit;
                    res.h = convertUnit(res.h, unit) + unit;
                }
                out.push(
                    ' width="' +
                        res.w +
                        '" height="' +
                        res.h +
                        '" xmlns="' +
                        NS.SVG +
                        '"',
                );
            }
            const nsuris = {};

            // Check elements for namespaces, add if found
            const csElements = elem.querySelectorAll("*");
            const cElements = Array.prototype.slice.call(csElements);
            cElements.push(elem);
            Array.prototype.forEach.call(cElements, (el) => {
                // const el = this;
                // for some elements have no attribute
                const uri = el.namespaceURI;
                if (
                    uri &&
                    !nsuris[uri] &&
                    nsMap[uri] &&
                    nsMap[uri] !== "xmlns" &&
                    nsMap[uri] !== "xml"
                ) {
                    nsuris[uri] = true;
                    out.push(" xmlns:" + nsMap[uri] + '="' + uri + '"');
                }
                if (el.attributes.length > 0) {
                    for (const [, attr] of Object.entries(el.attributes)) {
                        const u = attr.namespaceURI;
                        if (
                            u &&
                            !nsuris[u] &&
                            nsMap[u] !== "xmlns" &&
                            nsMap[u] !== "xml"
                        ) {
                            nsuris[u] = true;
                            out.push(" xmlns:" + nsMap[u] + '="' + u + '"');
                        }
                    }
                }
            });
            let i = attrs.length;
            const attrNames = [
                "width",
                "height",
                "xmlns",
                "x",
                "y",
                "viewBox",
                "id",
                "overflow",
            ];
            while (i--) {
                const attr = attrs[i];
                const attrVal = toXml(attr.value);

                // Namespaces have already been dealt with, so skip
                if (attr.nodeName.startsWith("xmlns:")) {
                    continue;
                }

                // only serialize attributes we don't use internally
                if (
                    attrVal !== "" &&
                    !attrNames.includes(attr.localName) &&
                    (!attr.namespaceURI || nsMap[attr.namespaceURI])
                ) {
                    out.push(" ");
                    out.push(attr.nodeName);
                    out.push('="');
                    out.push(attrVal);
                    out.push('"');
                }
            }
        } else {
            // Skip empty defs
            if (elem.nodeName === "defs" && !elem.firstChild) {
                return "";
            }
            const mozAttrs = ["-moz-math-font-style", "_moz-math-font-style"];
            for (let i = attrs.length - 1; i >= 0; i--) {
                const attr = attrs[i];
                let attrVal = toXml(attr.value);
                // remove bogus attributes added by Gecko
                if (mozAttrs.includes(attr.localName)) {
                    continue;
                }
                if (attrVal === "null") {
                    const styleName = attr.localName.replace(/-[a-z]/g, (s) =>
                        s[1].toUpperCase(),
                    );
                    if (
                        Object.prototype.hasOwnProperty.call(
                            elem.style,
                            styleName,
                        )
                    ) {
                        continue;
                    }
                }
                if (attrVal !== "") {
                    if (attrVal.startsWith("pointer-events")) {
                        continue;
                    }
                    if (
                        attr.localName === "class" &&
                        attrVal.startsWith("se_")
                    ) {
                        continue;
                    }
                    out.push(" ");
                    if (attr.localName === "d") {
                        attrVal = svgCanvas$2.pathActions.convertPath(
                            elem,
                            true,
                        );
                    }
                    if (!isNaN(attrVal)) {
                        attrVal = shortFloat(attrVal);
                    } else if (unitRe.test(attrVal)) {
                        attrVal = shortFloat(attrVal) + unit;
                    }

                    // Embed images when saving
                    if (
                        svgCanvas$2.getSvgOptionApply() &&
                        elem.nodeName === "image" &&
                        attr.localName === "href" &&
                        svgCanvas$2.getSvgOptionImages() &&
                        svgCanvas$2.getSvgOptionImages() === "embed"
                    ) {
                        const img = svgCanvas$2.getEncodableImages(attrVal);
                        if (img) {
                            attrVal = img;
                        }
                    }

                    // map various namespaces to our fixed namespace prefixes
                    // (the default xmlns attribute itself does not get a prefix)
                    if (
                        !attr.namespaceURI ||
                        attr.namespaceURI === NS.SVG ||
                        nsMap[attr.namespaceURI]
                    ) {
                        out.push(attr.nodeName);
                        out.push('="');
                        out.push(attrVal);
                        out.push('"');
                    }
                }
            }
        }
        if (elem.hasChildNodes()) {
            out.push(">");
            indent++;
            let bOneLine = false;
            for (let i = 0; i < childs.length; i++) {
                const child = childs.item(i);
                switch (child.nodeType) {
                    case 1:
                        // element node
                        out.push("\n");
                        out.push(svgCanvas$2.svgToString(child, indent));
                        break;
                    case 3: {
                        // text node
                        const str = child.nodeValue.replace(/^\s+|\s+$/g, "");
                        if (str !== "") {
                            bOneLine = true;
                            out.push(String(toXml(str)));
                        }
                        break;
                    }
                    case 4:
                        // cdata node
                        out.push("\n");
                        out.push(new Array(indent + 1).join(" "));
                        out.push("<![CDATA[");
                        out.push(child.nodeValue);
                        out.push("]]>");
                        break;
                    case 8:
                        // comment
                        out.push("\n");
                        out.push(new Array(indent + 1).join(" "));
                        out.push("<!--");
                        out.push(child.data);
                        out.push("-->");
                        break;
                } // switch on node type
            }

            indent--;
            if (!bOneLine) {
                out.push("\n");
                for (let i = 0; i < indent; i++) {
                    out.push(" ");
                }
            }
            out.push("</");
            out.push(elem.nodeName);
            out.push(">");
        } else {
            out.push("/>");
        }
    }
    return out.join("");
}; // end svgToString()

/**
 * This function sets the current drawing as the input SVG XML.
 * @function module:svgcanvas.SvgCanvas#setSvgString
 * @param {string} xmlString - The SVG as XML text.
 * @param {boolean} [preventUndo=false] - Indicates if we want to do the
 * changes without adding them to the undo stack - e.g. for initializing a
 * drawing on page load.
 * @fires module:svgcanvas.SvgCanvas#event:setnonce
 * @fires module:svgcanvas.SvgCanvas#event:unsetnonce
 * @fires module:svgcanvas.SvgCanvas#event:changed
 * @returns {boolean} This function returns `false` if the set was
 *     unsuccessful, `true` otherwise.
 */
const setSvgString = (xmlString, preventUndo) => {
    const curConfig = svgCanvas$2.getCurConfig();
    const dataStorage = svgCanvas$2.getDataStorage();
    try {
        // convert string into XML document
        const newDoc = text2xml(xmlString);
        if (
            newDoc.firstElementChild &&
            newDoc.firstElementChild.namespaceURI !== NS.SVG
        ) {
            return false;
        }
        svgCanvas$2.prepareSvg(newDoc);
        const batchCmd = new BatchCommand("Change Source");

        // remove old svg document
        const { nextSibling } = svgCanvas$2.getSvgContent();
        svgCanvas$2.getSvgContent().remove();
        const oldzoom = svgCanvas$2.getSvgContent();
        batchCmd.addSubCommand(
            new RemoveElementCommand(
                oldzoom,
                nextSibling,
                svgCanvas$2.getSvgRoot(),
            ),
        );

        // set new svg document
        // If DOM3 adoptNode() available, use it. Otherwise fall back to DOM2 importNode()
        if (svgCanvas$2.getDOMDocument().adoptNode) {
            svgCanvas$2.setSvgContent(
                svgCanvas$2.getDOMDocument().adoptNode(newDoc.documentElement),
            );
        } else {
            svgCanvas$2.setSvgContent(
                svgCanvas$2
                    .getDOMDocument()
                    .importNode(newDoc.documentElement, true),
            );
        }
        svgCanvas$2.getSvgRoot().append(svgCanvas$2.getSvgContent());
        const content = svgCanvas$2.getSvgContent();
        svgCanvas$2.current_drawing_ = new Drawing(
            svgCanvas$2.getSvgContent(),
            svgCanvas$2.getIdPrefix(),
        );

        // retrieve or set the nonce
        const nonce = svgCanvas$2.getCurrentDrawing().getNonce();
        if (nonce) {
            svgCanvas$2.call("setnonce", nonce);
        } else {
            svgCanvas$2.call("unsetnonce");
        }

        // change image href vals if possible
        const elements = content.querySelectorAll("image");
        Array.prototype.forEach.call(elements, (image) => {
            preventClickDefault(image);
            const val = svgCanvas$2.getHref(image);
            if (val) {
                if (val.startsWith("data:")) {
                    // Check if an SVG-edit data URI
                    const m = val.match(/svgedit_url=(.*?);/);
                    // const m = val.match(/svgedit_url=(?<url>.*?);/);
                    if (m) {
                        const url = decodeURIComponent(m[1]);
                        // const url = decodeURIComponent(m.groups.url);
                        const iimg = new Image();
                        iimg.addEventListener("load", () => {
                            image.setAttributeNS(NS.XLINK, "xlink:href", url);
                        });
                        iimg.src = url;
                    }
                }
                // Add to encodableImages if it loads
                svgCanvas$2.embedImage(val);
            }
        });
        // Duplicate id replace changes
        const nodes = content.querySelectorAll("[id]");
        const ids = {};
        const totalNodes = nodes.length;
        for (let i = 0; i < totalNodes; i++) {
            const currentId = nodes[i].id ? nodes[i].id : "undefined";
            if (isNaN(ids[currentId])) {
                ids[currentId] = 0;
            }
            ids[currentId]++;
        }
        Object.entries(ids).forEach(([key, value]) => {
            if (value > 1) {
                const nodes = content.querySelectorAll('[id="' + key + '"]');
                for (let i = 1; i < nodes.length; i++) {
                    nodes[i].setAttribute("id", svgCanvas$2.getNextId());
                }
            }
        });

        // Wrap child SVGs in group elements
        const svgElements = content.querySelectorAll("svg");
        Array.prototype.forEach.call(svgElements, (element) => {
            // Skip if it's in a <defs>
            if (getClosest(element.parentNode, "defs")) {
                return;
            }
            svgCanvas$2.uniquifyElems(element);

            // Check if it already has a gsvg group
            const pa = element.parentNode;
            if (pa.childNodes.length === 1 && pa.nodeName === "g") {
                dataStorage.put(pa, "gsvg", element);
                pa.id = pa.id || svgCanvas$2.getNextId();
            } else {
                svgCanvas$2.groupSvgElem(element);
            }
        });

        // For Firefox: Put all paint elems in defs
        if (isGecko()) {
            const svgDefs = findDefs();
            const findElems = content.querySelectorAll(
                "linearGradient, radialGradient, pattern",
            );
            Array.prototype.forEach.call(findElems, (ele) => {
                svgDefs.appendChild(ele);
            });
        }

        // Set ref element for <use> elements

        // TODO: This should also be done if the object is re-added through "redo"
        svgCanvas$2.setUseData(content);
        svgCanvas$2.convertGradients(content);
        const attrs = {
            id: "svgcontent",
            overflow: curConfig.show_outside_canvas ? "visible" : "hidden",
        };
        let percs = false;

        // determine proper size
        if (content.getAttribute("viewBox")) {
            const viBox = content.getAttribute("viewBox");
            const vb = viBox.split(" ");
            attrs.width = vb[2];
            attrs.height = vb[3];
            // handle content that doesn't have a viewBox
        } else {
            ["width", "height"].forEach((dim) => {
                // Set to 100 if not given
                const val = content.getAttribute(dim) || "100%";
                if (String(val).substr(-1) === "%") {
                    // Use user units if percentage given
                    percs = true;
                } else {
                    attrs[dim] = convertToNum(dim, val);
                }
            });
        }

        // identify layers
        identifyLayers();

        // Give ID for any visible layer children missing one
        const chiElems = content.children;
        Array.prototype.forEach.call(chiElems, (chiElem) => {
            const visElems = chiElem.querySelectorAll(
                svgCanvas$2.getVisElems(),
            );
            Array.prototype.forEach.call(visElems, (elem) => {
                if (!elem.id) {
                    elem.id = svgCanvas$2.getNextId();
                }
            });
        });

        // Percentage width/height, so let's base it on visible elements
        if (percs) {
            const bb = getStrokedBBoxDefaultVisible();
            attrs.width = bb.width + bb.x;
            attrs.height = bb.height + bb.y;
        }

        // Just in case negative numbers are given or
        // result from the percs calculation
        if (attrs.width <= 0) {
            attrs.width = 100;
        }
        if (attrs.height <= 0) {
            attrs.height = 100;
        }
        for (const [key, value] of Object.entries(attrs)) {
            content.setAttribute(key, value);
        }
        svgCanvas$2.contentW = attrs.width;
        svgCanvas$2.contentH = attrs.height;
        batchCmd.addSubCommand(
            new InsertElementCommand(svgCanvas$2.getSvgContent()),
        );
        // update root to the correct size
        const width = content.getAttribute("width");
        const height = content.getAttribute("height");
        const changes = {
            width,
            height,
        };
        batchCmd.addSubCommand(
            new ChangeElementCommand(svgCanvas$2.getSvgRoot(), changes),
        );

        // reset zoom
        svgCanvas$2.setZoom(1);
        svgCanvas$2.clearSelection();
        clearData();
        svgCanvas$2
            .getSvgRoot()
            .append(svgCanvas$2.selectorManager.selectorParentGroup);
        if (!preventUndo) svgCanvas$2.addCommandToHistory(batchCmd);
        svgCanvas$2.call("sourcechanged", [svgCanvas$2.getSvgContent()]);

        const gridContainer = document.getElementById("gridContainer");
        if (gridContainer) {
            svgCanvas$2.getSvgRoot().removeChild(gridContainer);
            svgCanvas$2.getSvgRoot().append(gridContainer);
        }
    } catch (e) {
        console.error(e);
        return false;
    }
    return true;
};

/**
 * This function imports the input SVG XML as a `<symbol>` in the `<defs>`, then adds a
 * `<use>` to the current layer.
 * @function module:svgcanvas.SvgCanvas#importSvgString
 * @param {string} xmlString - The SVG as XML text.
 * @param {boolean} preserveDimension - A boolean to force to preserve initial dimension of the imported svg (force svgEdit don't apply a transformation on the imported svg)
 * @fires module:svgcanvas.SvgCanvas#event:changed
 * @returns {null|Element} This function returns null if the import was unsuccessful, or the element otherwise.
 * @todo
 * - properly handle if namespace is introduced by imported content (must add to svgcontent
 * and update all prefixes in the imported node)
 * - properly handle recalculating dimensions, `recalculateDimensions()` doesn't handle
 * arbitrary transform lists, but makes some assumptions about how the transform list
 * was obtained
 */
const importSvgString = (xmlString, preserveDimension) => {
    const dataStorage = svgCanvas$2.getDataStorage();
    let j;
    let ts;
    let useEl;
    try {
        // Get unique ID
        const uid = hashCode(xmlString);
        let useExisting = false;
        // Look for symbol and make sure symbol exists in image
        if (
            svgCanvas$2.getImportIds(uid) &&
            svgCanvas$2.getImportIds(uid).symbol
        ) {
            const parents = getParents(
                svgCanvas$2.getImportIds(uid).symbol,
                "#svgroot",
            );
            if (parents?.length) {
                useExisting = true;
            }
        }
        const batchCmd = new BatchCommand("Import Image");
        let symbol;
        if (useExisting) {
            symbol = svgCanvas$2.getImportIds(uid).symbol;
            ts = svgCanvas$2.getImportIds(uid).xform;
        } else {
            // convert string into XML document
            const newDoc = text2xml(xmlString);
            svgCanvas$2.prepareSvg(newDoc);

            // import new svg document into our document
            // If DOM3 adoptNode() available, use it. Otherwise fall back to DOM2 importNode()
            const svg = svgCanvas$2.getDOMDocument().adoptNode
                ? svgCanvas$2.getDOMDocument().adoptNode(newDoc.documentElement)
                : svgCanvas$2
                      .getDOMDocument()
                      .importNode(newDoc.documentElement, true);
            svgCanvas$2.uniquifyElems(svg);
            const innerw = convertToNum("width", svg.getAttribute("width"));
            const innerh = convertToNum("height", svg.getAttribute("height"));
            const innervb = svg.getAttribute("viewBox");
            // if no explicit viewbox, create one out of the width and height
            const vb = innervb ? innervb.split(" ") : [0, 0, innerw, innerh];
            for (j = 0; j < 4; ++j) {
                vb[j] = Number(vb[j]);
            }

            // TODO: properly handle preserveAspectRatio
            const // canvasw = +svgContent.getAttribute('width'),
                canvash = Number(
                    svgCanvas$2.getSvgContent().getAttribute("height"),
                );
            // imported content should be 1/3 of the canvas on its largest dimension

            ts =
                innerh > innerw
                    ? "scale(" + canvash / 3 / vb[3] + ")"
                    : "scale(" + canvash / 3 / vb[2] + ")";

            // Hack to make recalculateDimensions understand how to scale
            ts = "translate(0) " + ts + " translate(0)";
            symbol = svgCanvas$2
                .getDOMDocument()
                .createElementNS(NS.SVG, "symbol");
            const defs = findDefs();
            if (isGecko()) {
                // Move all gradients into root for Firefox, workaround for this bug:
                // https://bugzilla.mozilla.org/show_bug.cgi?id=353575
                // TODO: Make this properly undo-able.
                const elements = svg.querySelectorAll(
                    "linearGradient, radialGradient, pattern",
                );
                Array.prototype.forEach.call(elements, (el) => {
                    defs.appendChild(el);
                });
            }
            while (svg.firstChild) {
                const first = svg.firstChild;
                symbol.append(first);
            }
            const attrs = svg.attributes;
            for (const attr of attrs) {
                // Ok for `NamedNodeMap`
                symbol.setAttribute(attr.nodeName, attr.value);
            }
            symbol.id = svgCanvas$2.getNextId();

            // Store data
            svgCanvas$2.setImportIds(uid, {
                symbol,
                xform: ts,
            });
            findDefs().append(symbol);
            batchCmd.addSubCommand(new InsertElementCommand(symbol));
        }
        useEl = svgCanvas$2.getDOMDocument().createElementNS(NS.SVG, "use");
        useEl.id = svgCanvas$2.getNextId();
        svgCanvas$2.setHref(useEl, "#" + symbol.id);
        (
            svgCanvas$2.getCurrentGroup() ||
            svgCanvas$2.getCurrentDrawing().getCurrentLayer()
        ).append(useEl);
        batchCmd.addSubCommand(new InsertElementCommand(useEl));
        svgCanvas$2.clearSelection();
        if (!preserveDimension) {
            useEl.setAttribute("transform", ts);
            recalculateDimensions(useEl);
        }
        dataStorage.put(useEl, "symbol", symbol);
        dataStorage.put(useEl, "ref", symbol);
        svgCanvas$2.addToSelection([useEl]);

        // TODO: Find way to add this in a recalculateDimensions-parsable way
        // if (vb[0] !== 0 || vb[1] !== 0) {
        //   ts = 'translate(' + (-vb[0]) + ',' + (-vb[1]) + ') ' + ts;
        // }
        svgCanvas$2.addCommandToHistory(batchCmd);
        svgCanvas$2.call("changed", [svgCanvas$2.getSvgContent()]);
    } catch (e) {
        console.error(e);
        return null;
    }

    // we want to return the element so we can automatically select it
    return useEl;
};
/**
 * Function to run when image data is found.
 * @callback module:svgcanvas.ImageEmbeddedCallback
 * @param {string|false} result Data URL
 * @returns {void}
 */
/**
 * Converts a given image file to a data URL when possible, then runs a given callback.
 * @function module:svgcanvas.SvgCanvas#embedImage
 * @param {string} src - The path/URL of the image
 * @returns {Promise<string|false>} Resolves to a Data URL (string|false)
 */
const embedImage = (src) => {
    // Todo: Remove this Promise in favor of making an async/await `Image.load` utility
    return new Promise((resolve, reject) => {
        // load in the image and once it's loaded, get the dimensions
        const imgI = new Image();
        imgI.addEventListener("load", (e) => {
            // create a canvas the same size as the raster image
            const cvs = document.createElement("canvas");
            cvs.width = e.currentTarget.width;
            cvs.height = e.currentTarget.height;
            // load the raster image into the canvas
            cvs.getContext("2d").drawImage(e.currentTarget, 0, 0);
            // retrieve the data: URL
            try {
                let urldata = ";svgedit_url=" + encodeURIComponent(src);
                urldata = cvs
                    .toDataURL()
                    .replace(";base64", urldata + ";base64");
                svgCanvas$2.setEncodableImages(src, urldata);
            } catch (e) {
                svgCanvas$2.setEncodableImages(src, false);
            }
            svgCanvas$2.setGoodImage(src);
            resolve(svgCanvas$2.getEncodableImages(src));
        });
        imgI.addEventListener("error", (e) => {
            reject(
                new Error(
                    `error loading image: ${e.currentTarget.attributes.src.value}`,
                ),
            );
        });
        imgI.setAttribute("src", src);
    });
};

/**
 * @typedef {PlainObject} module:svgcanvas.IssuesAndCodes
 * @property {string[]} issueCodes The locale-independent code names
 * @property {string[]} issues The localized descriptions
 */

/**
 * Codes only is useful for locale-independent detection.
 * @returns {module:svgcanvas.IssuesAndCodes}
 */
const getIssues = () => {
    const uiStrings = svgCanvas$2.getUIStrings();
    // remove the selected outline before serializing
    svgCanvas$2.clearSelection();

    // Check for known CanVG issues
    const issues = [];
    const issueCodes = [];

    // Selector and notice
    const issueList = {
        feGaussianBlur: uiStrings.NoBlur,
        foreignObject: uiStrings.NoforeignObject,
        "[stroke-dasharray]": uiStrings.NoDashArray,
    };
    const content = svgCanvas$2.getSvgContent();

    // Add font/text check if Canvas Text API is not implemented
    if (!("font" in document.querySelector("CANVAS").getContext("2d"))) {
        issueList.text = uiStrings.NoText;
    }
    for (const [sel, descr] of Object.entries(issueList)) {
        if (content.querySelectorAll(sel).length) {
            issueCodes.push(sel);
            issues.push(descr);
        }
    }
    return {
        issues,
        issueCodes,
    };
};
/**
 * @typedef {PlainObject} module:svgcanvas.ImageedResults
 * @property {string} datauri Contents as a Data URL
 * @property {string} bloburl May be the empty string
 * @property {string} svg The SVG contents as a string
 * @property {string[]} issues The localization messages of `issueCodes`
 * @property {module:svgcanvas.IssueCode[]} issueCodes CanVG issues found with the SVG
 * @property {"PNG"|"JPEG"|"BMP"|"WEBP"|"ICO"} type The chosen image type
 * @property {"image/png"|"image/jpeg"|"image/bmp"|"image/webp"} mimeType The image MIME type
 * @property {Float} quality A decimal between 0 and 1 (for use with JPEG or WEBP)
 * @property {string} WindowName A convenience for passing along a `window.name` to target a window on which the  could be added
 */

/**
 * Generates a PNG (or JPG, BMP, WEBP) Data URL based on the current image,
 * then calls "ed" with an object including the string, image
 * information, and any issues found.
 * @function module:svgcanvas.SvgCanvas#raster
 * @param {"PNG"|"JPEG"|"BMP"|"WEBP"|"ICO"} [imgType="PNG"]
 * @param {Float} [quality] Between 0 and 1
 * @param {string} [WindowName]
 * @param {PlainObject} [opts]
 * @param {boolean} [opts.avoidEvent]
 * @fires module:svgcanvas.SvgCanvas#event:ed
 * @todo Confirm/fix ICO type
 * @returns {Promise<module:svgcanvas.ImageedResults>} Resolves to {@link module:svgcanvas.ImageedResults}
 */
const rasterExport = async (imgType, quality, WindowName, opts = {}) => {
    const type = imgType === "ICO" ? "BMP" : imgType || "PNG";
    const mimeType = "image/" + type.toLowerCase();
    const { issues, issueCodes } = getIssues();
    const svg = svgCanvas$2.svgCanvasToString();
    const iframe = document.createElement("iframe");
    iframe.onload = () => {
        const iframedoc =
            iframe.contentDocument || iframe.contentWindow.document;
        const ele = svgCanvas$2.getSvgContent();
        const cln = ele.cloneNode(true);
        iframedoc.body.appendChild(cln);
        setTimeout(() => {
            // eslint-disable-next-line promise/catch-or-return
            html2canvas(iframedoc.body, {
                useCORS: true,
                allowTaint: true,
            }).then((canvas) => {
                return new Promise((resolve) => {
                    const dataURLType = type.toLowerCase();
                    const datauri = quality
                        ? canvas.toDataURL("image/" + dataURLType, quality)
                        : canvas.toDataURL("image/" + dataURLType);
                    iframe.parentNode.removeChild(iframe);
                    let bloburl;
                    const done = () => {
                        const obj = {
                            datauri,
                            bloburl,
                            svg,
                            issues,
                            issueCodes,
                            type: imgType,
                            mimeType,
                            quality,
                            WindowName,
                        };
                        if (!opts.avoidEvent) {
                            svgCanvas$2.call("ed", obj);
                        }
                        resolve(obj);
                    };
                    if (canvas.toBlob) {
                        canvas.toBlob(
                            (blob) => {
                                bloburl = createObjectURL(blob);
                                done();
                            },
                            mimeType,
                            quality,
                        );
                        return;
                    }
                    bloburl = dataURLToObjectURL(datauri);
                    done();
                });
            });
        }, 1000);
    };
    document.body.appendChild(iframe);
};

/**
 * @typedef {void|"save"|"arraybuffer"|"blob"|"datauristring"|"dataurlstring"|"dataurlnewwindow"|"datauri"|"dataurl"} external:jsPDF.OutputType
 * @todo Newer version to add also allows these `outputType` values "bloburi"|"bloburl" which return strings, so document here and for `outputType` of `module:svgcanvas.PDFedResults` below if added
 */
/**
 * @typedef {PlainObject} module:svgcanvas.PDFedResults
 * @property {string} svg The SVG PDF output
 * @property {string|ArrayBuffer|Blob|window} output The output based on the `outputType`;
 * if `undefined`, "datauristring", "dataurlstring", "datauri",
 * or "dataurl", will be a string (`undefined` gives a document, while the others
 * build as Data URLs; "datauri" and "dataurl" change the location of the current page); if
 * "arraybuffer", will return `ArrayBuffer`; if "blob", returns a `Blob`;
 * if "dataurlnewwindow", will change the current page's location and return a string
 * if in Safari and no window object is found; otherwise opens in, and returns, a new `window`
 * object; if "save", will have the same return as "dataurlnewwindow" if
 * `navigator.getUserMedia` support is found without `URL.createObjectURL` support; otherwise
 * returns `undefined` but attempts to save
 * @property {external:jsPDF.OutputType} outputType
 * @property {string[]} issues The human-readable localization messages of corresponding `issueCodes`
 * @property {module:svgcanvas.IssueCode[]} issueCodes
 * @property {string} WindowName
 */

/**
 * Generates a PDF based on the current image, then calls "edPDF" with
 * an object including the string, the data URL, and any issues found.
 * @function module:svgcanvas.SvgCanvas#PDF
 * @param {string} [WindowName] Will also be used for the download file name here
 * @param {external:jsPDF.OutputType} [outputType="dataurlstring"]
 * @fires module:svgcanvas.SvgCanvas#event:edPDF
 * @returns {Promise<module:svgcanvas.PDFedResults>} Resolves to {@link module:svgcanvas.PDFedResults}
 */
const exportPDF = async (
    WindowName,
    outputType = isChrome() ? "save" : undefined,
) => {
    const res = svgCanvas$2.getResolution();
    const orientation = res.w > res.h ? "landscape" : "portrait";
    const unit = "pt"; // curConfig.baseUnit; // We could use baseUnit, but that is presumably not intended for  purposes
    const iframe = document.createElement("iframe");
    iframe.onload = () => {
        const iframedoc =
            iframe.contentDocument || iframe.contentWindow.document;
        const ele = svgCanvas$2.getSvgContent();
        const cln = ele.cloneNode(true);
        iframedoc.body.appendChild(cln);
        setTimeout(() => {
            // eslint-disable-next-line promise/catch-or-return
            html2canvas(iframedoc.body, {
                useCORS: true,
                allowTaint: true,
            }).then((canvas) => {
                const imgData = canvas.toDataURL("image/png");
                const doc = new E({
                    orientation,
                    unit,
                    format: [res.w, res.h],
                });
                const docTitle = svgCanvas$2.getDocumentTitle();
                doc.setProperties({
                    title: docTitle,
                });
                doc.addImage(imgData, "PNG", 0, 0, res.w, res.h);
                iframe.parentNode.removeChild(iframe);
                const { issues, issueCodes } = getIssues();
                outputType = outputType || "dataurlstring";
                const obj = {
                    issues,
                    issueCodes,
                    WindowName,
                    outputType,
                };
                obj.output = doc.output(
                    outputType,
                    outputType === "save" ? WindowName || "svg.pdf" : undefined,
                );
                svgCanvas$2.call("edPDF", obj);
                return obj;
            });
        }, 1000);
    };
    document.body.appendChild(iframe);
};
/**
 * Ensure each element has a unique ID.
 * @function module:svgcanvas.SvgCanvas#uniquifyElems
 * @param {Element} g - The parent element of the tree to give unique IDs
 * @returns {void}
 */
const uniquifyElemsMethod = (g, shouldSkip) => {
    const ids = {};
    // TODO: Handle markers and connectors. These are not yet re-identified properly
    // as their referring elements do not get remapped.
    //
    // <marker id='se_marker_end_svg_7'/>
    // <polyline id='svg_7' se:connector='svg_1 svg_6' marker-end='url(#se_marker_end_svg_7)'/>
    //
    // Problem #1: if svg_1 gets renamed, we do not update the polyline's se:connector attribute
    // Problem #2: if the polyline svg_7 gets renamed, we do not update the marker id nor the polyline's marker-end attribute
    const refElems = [
        "filter",
        "linearGradient",
        "pattern",
        "radialGradient",
        "symbol",
        "textPath",
        "use",
    ];
    walkTree(g, (n) => {
        // if it's an element node
        if (n.nodeType === 1) {
            // and the element has an ID
            if (n.id) {
                // and we haven't tracked this ID yet
                if (!(n.id in ids)) {
                    // add this id to our map
                    ids[n.id] = {
                        elem: null,
                        attrs: [],
                        hrefs: [],
                    };
                }
                ids[n.id].elem = n;
            }

            // now search for all attributes on this element that might refer
            // to other elements
            svgCanvas$2.getrefAttrs().forEach((attr) => {
                const attrnode = n.getAttributeNode(attr);
                if (attrnode) {
                    // the incoming file has been sanitized, so we should be able to safely just strip off the leading #
                    const url = svgCanvas$2.getUrlFromAttr(attrnode.value);
                    const refid = url ? url.substr(1) : null;
                    if (refid) {
                        if (!(refid in ids)) {
                            // add this id to our map
                            ids[refid] = {
                                elem: null,
                                attrs: [],
                                hrefs: [],
                            };
                        }
                        ids[refid].attrs.push(attrnode);
                    }
                }
            });

            // check xlink:href now
            const href = svgCanvas$2.getHref(n);
            // TODO: what if an <image> or <a> element refers to an element internally?
            if (href && refElems.includes(n.nodeName)) {
                const refid = href.substr(1);
                if (refid) {
                    if (!(refid in ids)) {
                        // add this id to our map
                        ids[refid] = {
                            elem: null,
                            attrs: [],
                            hrefs: [],
                        };
                    }
                    ids[refid].hrefs.push(n);
                }
            }
        }
    });

    // in ids, we now have a map of ids, elements and attributes, let's re-identify
    for (const oldid in ids) {
        if (!oldid) {
            continue;
        }
        const { elem } = ids[oldid];
        if (elem) {
            if (elem.id && shouldSkip) {
                return;
            }
            const newid = svgCanvas$2.getNextId();

            // assign element its new id
            elem.id = newid;

            // remap all url() attributes
            const { attrs } = ids[oldid];
            let j = attrs.length;
            while (j--) {
                const attr = attrs[j];
                attr.ownerElement.setAttribute(
                    attr.name,
                    "url(#" + newid + ")",
                );
            }

            // remap all href attributes
            const hreffers = ids[oldid].hrefs;
            let k = hreffers.length;
            while (k--) {
                const hreffer = hreffers[k];
                svgCanvas$2.setHref(hreffer, "#" + newid);
            }
        }
    }
};

/**
 * Assigns reference data for each use element.
 * @function module:svgcanvas.SvgCanvas#setUseData
 * @param {Element} parent
 * @returns {void}
 */
const setUseDataMethod = (parent) => {
    let elems = parent;
    if (parent.tagName !== "use") {
        // elems = elems.find('use');
        elems = elems.querySelectorAll("use");
    }
    Array.prototype.forEach.call(elems, (el, _) => {
        const dataStorage = svgCanvas$2.getDataStorage();
        const id = svgCanvas$2.getHref(el).substr(1);
        const refElem = svgCanvas$2.getElement(id);
        if (!refElem) {
            return;
        }
        dataStorage.put(el, "ref", refElem);
        if (refElem.tagName === "symbol" || refElem.tagName === "svg") {
            dataStorage.put(el, "symbol", refElem);
            dataStorage.put(el, "ref", refElem);
        }
    });
};

/**
 * Looks at DOM elements inside the `<defs>` to see if they are referred to,
 * removes them from the DOM if they are not.
 * @function module:svgcanvas.SvgCanvas#removeUnusedDefElems
 * @returns {Integer} The number of elements that were removed
 */
const removeUnusedDefElemsMethod = () => {
    const defs = svgCanvas$2
        .getSvgContent()
        .getElementsByTagNameNS(NS.SVG, "defs");
    if (!defs || !defs.length) {
        return 0;
    }

    // if (!defs.firstChild) { return; }

    const defelemUses = [];
    let numRemoved = 0;
    const attrs = [
        "fill",
        "stroke",
        "filter",
        "marker-start",
        "marker-mid",
        "marker-end",
    ];
    const alen = attrs.length;
    const allEls = svgCanvas$2
        .getSvgContent()
        .getElementsByTagNameNS(NS.SVG, "*");
    const allLen = allEls.length;
    let i;
    let j;
    for (i = 0; i < allLen; i++) {
        const el = allEls[i];
        for (j = 0; j < alen; j++) {
            const ref = svgCanvas$2.getUrlFromAttr(el.getAttribute(attrs[j]));
            if (ref) {
                defelemUses.push(ref.substr(1));
            }
        }

        // gradients can refer to other gradients
        const href = getHref(el);
        if (href && href.startsWith("#")) {
            defelemUses.push(href.substr(1));
        }
    }
    Array.prototype.forEach.call(defs, (def, i) => {
        const defelems = def.querySelectorAll(
            "linearGradient, radialGradient, filter, marker, svg, symbol",
        );
        i = defelems.length;
        while (i--) {
            const defelem = defelems[i];
            const { id } = defelem;
            if (!defelemUses.includes(id)) {
                // Not found, so remove (but remember)
                svgCanvas$2.setRemovedElements(id, defelem);
                defelem.remove();
                numRemoved++;
            }
        }
    });
    return numRemoved;
};
/**
 * Converts gradients from userSpaceOnUse to objectBoundingBox.
 * @function module:svgcanvas.SvgCanvas#convertGradients
 * @param {Element} elem
 * @returns {void}
 */
const convertGradientsMethod = (elem) => {
    let elems = elem.querySelectorAll("linearGradient, radialGradient");
    if (!elems.length && isWebkit()) {
        // Bug in webkit prevents regular *Gradient selector search
        elems = Array.prototype.filter.call(
            elem.querySelectorAll("*"),
            (curThis) => {
                return curThis.tagName.includes("Gradient");
            },
        );
    }
    Array.prototype.forEach.call(elems, (grad) => {
        if (grad.getAttribute("gradientUnits") === "userSpaceOnUse") {
            const svgContent = svgCanvas$2.getSvgContent();
            // TODO: Support more than one element with this ref by duplicating parent grad
            let fillStrokeElems = svgContent.querySelectorAll(
                '[fill="url(#' +
                    grad.id +
                    ')"],[stroke="url(#' +
                    grad.id +
                    ')"]',
            );
            if (!fillStrokeElems.length) {
                const tmpFillStrokeElems = svgContent.querySelectorAll(
                    '[*|href="#' + grad.id + '"]',
                );
                if (!tmpFillStrokeElems.length) {
                    return;
                } else {
                    if (
                        (tmpFillStrokeElems[0].tagName === "linearGradient" ||
                            tmpFillStrokeElems[0].tagName ===
                                "radialGradient") &&
                        tmpFillStrokeElems[0].getAttribute("gradientUnits") ===
                            "userSpaceOnUse"
                    ) {
                        fillStrokeElems = svgContent.querySelectorAll(
                            '[fill="url(#' +
                                tmpFillStrokeElems[0].id +
                                ')"],[stroke="url(#' +
                                tmpFillStrokeElems[0].id +
                                ')"]',
                        );
                    } else {
                        return;
                    }
                }
            }
            // get object's bounding box
            const bb = getBBox(fillStrokeElems[0]);

            // This will occur if the element is inside a <defs> or a <symbol>,
            // in which we shouldn't need to convert anyway.
            if (!bb) {
                return;
            }
            if (grad.tagName === "linearGradient") {
                const gCoords = {
                    x1: grad.getAttribute("x1"),
                    y1: grad.getAttribute("y1"),
                    x2: grad.getAttribute("x2"),
                    y2: grad.getAttribute("y2"),
                };

                // If has transform, convert
                const tlist = getTransformList(grad);
                if (tlist?.numberOfItems > 0) {
                    const m = transformListToTransform(tlist).matrix;
                    const pt1 = transformPoint(gCoords.x1, gCoords.y1, m);
                    const pt2 = transformPoint(gCoords.x2, gCoords.y2, m);
                    gCoords.x1 = pt1.x;
                    gCoords.y1 = pt1.y;
                    gCoords.x2 = pt2.x;
                    gCoords.y2 = pt2.y;
                    grad.removeAttribute("gradientTransform");
                }
                grad.setAttribute("x1", (gCoords.x1 - bb.x) / bb.width);
                grad.setAttribute("y1", (gCoords.y1 - bb.y) / bb.height);
                grad.setAttribute("x2", (gCoords.x2 - bb.x) / bb.width);
                grad.setAttribute("y2", (gCoords.y2 - bb.y) / bb.height);
                grad.removeAttribute("gradientUnits");
            }
        }
    });
};

/**
 * DOM element selection box tools.
 * @module select
 * @license MIT
 *
 * @copyright 2010 Alexis Deveria, 2010 Jeff Schiller
 */
let svgCanvas$1;
let selectorManager_; // A Singleton
// change radius if touch screen
const gripRadius = window.ontouchstart ? 10 : 4;

function getSelectionStrokeColor() {
    const bg = document.getElementById("canvasBackground");
    const rect = bg && bg.querySelector("rect");
    const fill = rect ? rect.getAttribute("fill") : "#ffffff";
    const hex = fill.replace("#", "");
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance > 0.5 ? "#000000" : "#ffffff";
}

/**
 * Private class for DOM element selection boxes.
 */
class Selector {
    /**
     * @param {Integer} id - Internally identify the selector
     * @param {Element} elem - DOM element associated with this selector
     * @param {module:utilities.BBoxObject} [bbox] - Optional bbox to use for initialization (prevents duplicate `getBBox` call).
     */
    constructor(id, elem, bbox) {
        // this is the selector's unique number
        this.id = id;

        // this holds a reference to the element for which this selector is being used
        this.selectedElement = elem;

        // this is a flag used internally to track whether the selector is being used or not
        this.locked = true;

        // this holds a reference to the <g> element that holds all visual elements of the selector
        this.selectorGroup = svgCanvas$1.createSVGElement({
            element: "g",
            attr: {
                id: "selectorGroup" + this.id,
            },
        });

        // this holds a reference to the path rect
        this.selectorRect = svgCanvas$1.createSVGElement({
            element: "path",
            attr: {
                id: "selectedBox" + this.id,
                fill: "none",
                stroke: getSelectionStrokeColor(),
                "stroke-width": "1",
                "stroke-dasharray": "5,5",
                // need to specify this so that the rect is not selectable
                style: "pointer-events:none",
            },
        });
        this.selectorGroup.append(this.selectorRect);

        // this holds a reference to the grip coordinates for this selector
        this.gripCoords = {
            nw: null,
            n: null,
            ne: null,
            e: null,
            se: null,
            s: null,
            sw: null,
            w: null,
        };
        this.reset(this.selectedElement, bbox);
    }

    /**
     * Used to reset the id and element that the selector is attached to.
     * @param {Element} e - DOM element associated with this selector
     * @param {module:utilities.BBoxObject} bbox - Optional bbox to use for reset (prevents duplicate getBBox call).
     * @returns {void}
     */
    reset(e, bbox) {
        this.locked = true;
        this.selectedElement = e;
        this.selectorRect.setAttribute("stroke", getSelectionStrokeColor());
        this.resize(bbox);
        this.selectorGroup.setAttribute("display", "inline");
    }

    /**
     * Show the resize grips of this selector.
     * @param {boolean} show - Indicates whether grips should be shown or not
     * @returns {void}
     */
    showGrips(show) {
        const isGroup =
            this.selectedElement &&
            this.selectedElement.tagName === "g" &&
            !this.selectedElement.getAttribute("data-icreate-resizable");
        const bShow = show && !isGroup ? "inline" : "none";
        selectorManager_.selectorGripsGroup.setAttribute("display", bShow);
        const elem = this.selectedElement;
        this.hasGrips = show;
        if (elem && show) {
            this.selectorGroup.append(selectorManager_.selectorGripsGroup);
            Selector.updateGripCursors(getRotationAngle(elem));
        }
    }

    /**
     * Updates the selector to match the element's size.
     * @param {module:utilities.BBoxObject} [bbox] - BBox to use for resize (prevents duplicate getBBox call).
     * @returns {void}
     */
    resize(bbox) {
        const dataStorage = svgCanvas$1.getDataStorage();
        const selectedBox = this.selectorRect;
        const mgr = selectorManager_;
        const selectedGrips = mgr.selectorGrips;
        const selected = this.selectedElement;
        const zoom = svgCanvas$1.getZoom();
        let offset = 1 / zoom;
        const sw = selected.getAttribute("stroke-width");
        if (selected.getAttribute("stroke") !== "none" && !isNaN(sw)) {
            offset += sw / 2;
        }
        const { tagName } = selected;
        if (tagName === "text") {
            offset += 2 / zoom;
        }

        // find the transformations applied to the parent of the selected element
        const svg = document.createElementNS(NS.SVG, "svg");
        let parentTransformationMatrix = svg.createSVGMatrix();
        let currentElt = selected;
        while (currentElt.parentNode) {
            if (
                currentElt.parentNode &&
                currentElt.parentNode.tagName === "g" &&
                currentElt.parentNode.transform
            ) {
                if (currentElt.parentNode.transform.baseVal.numberOfItems) {
                    parentTransformationMatrix = matrixMultiply(
                        transformListToTransform(
                            getTransformList(selected.parentNode),
                        ).matrix,
                        parentTransformationMatrix,
                    );
                }
            }
            currentElt = currentElt.parentNode;
        }

        // loop and transform our bounding box until we reach our first rotation
        const tlist = getTransformList(selected);

        // combines the parent transformation with that of the selected element if necessary
        const m = parentTransformationMatrix
            ? matrixMultiply(
                  parentTransformationMatrix,
                  transformListToTransform(tlist).matrix,
              )
            : transformListToTransform(tlist).matrix;

        // This should probably be handled somewhere else, but for now
        // it keeps the selection box correctly positioned when zoomed
        m.e *= zoom;
        m.f *= zoom;
        if (!bbox) {
            bbox = getBBox(selected);
        }
        // TODO: getBBox (previous line) already knows to call getStrokedBBox when tagName === 'g'. Remove this?
        // TODO: getBBox doesn't exclude 'gsvg' and calls getStrokedBBox for any 'g'. Should getBBox be updated?
        if (tagName === "g" && !dataStorage.has(selected, "gsvg")) {
            // The bbox for a group does not include stroke vals, so we
            // get the bbox based on its children.
            const strokedBbox = getStrokedBBox([selected.childNodes]);
            if (strokedBbox) {
                bbox = strokedBbox;
            }
        }
        if (bbox) {
            // apply the transforms
            const l = bbox.x;
            const t = bbox.y;
            const w = bbox.width;
            const h = bbox.height;
            // bbox = {x: l, y: t, width: w, height: h}; // Not in use

            // we need to handle temporary transforms too
            // if skewed, get its transformed box, then find its axis-aligned bbox

            // *
            offset *= zoom;
            const nbox = transformBox(
                l * zoom,
                t * zoom,
                w * zoom,
                h * zoom,
                m,
            );
            const { aabox } = nbox;
            let nbax = aabox.x - offset;
            let nbay = aabox.y - offset;
            let nbaw = aabox.width + offset * 2;
            let nbah = aabox.height + offset * 2;

            // now if the shape is rotated, un-rotate it
            const cx = nbax + nbaw / 2;
            const cy = nbay + nbah / 2;
            const angle = getRotationAngle(selected);
            if (angle) {
                const rot = svgCanvas$1.getSvgRoot().createSVGTransform();
                rot.setRotate(-angle, cx, cy);
                const rotm = rot.matrix;
                nbox.tl = transformPoint(nbox.tl.x, nbox.tl.y, rotm);
                nbox.tr = transformPoint(nbox.tr.x, nbox.tr.y, rotm);
                nbox.bl = transformPoint(nbox.bl.x, nbox.bl.y, rotm);
                nbox.br = transformPoint(nbox.br.x, nbox.br.y, rotm);

                // calculate the axis-aligned bbox
                const { tl } = nbox;
                let minx = tl.x;
                let miny = tl.y;
                let maxx = tl.x;
                let maxy = tl.y;
                const { min, max } = Math;
                minx =
                    min(minx, min(nbox.tr.x, min(nbox.bl.x, nbox.br.x))) -
                    offset;
                miny =
                    min(miny, min(nbox.tr.y, min(nbox.bl.y, nbox.br.y))) -
                    offset;
                maxx =
                    max(maxx, max(nbox.tr.x, max(nbox.bl.x, nbox.br.x))) +
                    offset;
                maxy =
                    max(maxy, max(nbox.tr.y, max(nbox.bl.y, nbox.br.y))) +
                    offset;
                nbax = minx;
                nbay = miny;
                nbaw = maxx - minx;
                nbah = maxy - miny;
            }
            const dstr =
                "M" +
                nbax +
                "," +
                nbay +
                " L" +
                (nbax + nbaw) +
                "," +
                nbay +
                " " +
                (nbax + nbaw) +
                "," +
                (nbay + nbah) +
                " " +
                nbax +
                "," +
                (nbay + nbah) +
                "z";
            const xform = angle
                ? "rotate(" + [angle, cx, cy].join(",") + ")"
                : "";

            // TODO(codedread): Is this needed?
            //  if (selected === selectedElements[0]) {
            this.gripCoords = {
                nw: [nbax, nbay],
                ne: [nbax + nbaw, nbay],
                sw: [nbax, nbay + nbah],
                se: [nbax + nbaw, nbay + nbah],
                n: [nbax + nbaw / 2, nbay],
                w: [nbax, nbay + nbah / 2],
                e: [nbax + nbaw, nbay + nbah / 2],
                s: [nbax + nbaw / 2, nbay + nbah],
            };
            selectedBox.setAttribute("d", dstr);
            this.selectorGroup.setAttribute("transform", xform);
            Object.entries(this.gripCoords).forEach(([dir, coords]) => {
                selectedGrips[dir].setAttribute("cx", coords[0]);
                selectedGrips[dir].setAttribute("cy", coords[1]);
            });

            // we want to go 20 pixels in the negative transformed y direction, ignoring scale
            mgr.rotateGripConnector.setAttribute("x1", nbax + nbaw / 2);
            mgr.rotateGripConnector.setAttribute("y1", nbay);
            mgr.rotateGripConnector.setAttribute("x2", nbax + nbaw / 2);
            mgr.rotateGripConnector.setAttribute("y2", nbay - gripRadius * 5);
            mgr.rotateGrip.setAttribute("cx", nbax + nbaw / 2);
            mgr.rotateGrip.setAttribute("cy", nbay - gripRadius * 5);
        }
    }

    // STATIC methods
    /**
     * Updates cursors for corner grips on rotation so arrows point the right way.
     * @param {Float} angle - Current rotation angle in degrees
     * @returns {void}
     */
    static updateGripCursors(angle) {
        const dirArr = Object.keys(selectorManager_.selectorGrips);
        let steps = Math.round(angle / 45);
        if (steps < 0) {
            steps += 8;
        }
        while (steps > 0) {
            dirArr.push(dirArr.shift());
            steps--;
        }
        Object.values(selectorManager_.selectorGrips).forEach(
            (gripElement, i) => {
                gripElement.setAttribute(
                    "style",
                    "cursor:" + dirArr[i] + "-resize",
                );
            },
        );
    }
}

/**
 * Manage all selector objects (selection boxes).
 */
class SelectorManager {
    /**
     * Sets up properties and calls `initGroup`.
     */
    constructor() {
        // this will hold the <g> element that contains all selector rects/grips
        this.selectorParentGroup = null;

        // this is a special rect that is used for multi-select
        this.rubberBandBox = null;

        // this will hold objects of type Selector (see above)
        this.selectors = [];

        // this holds a map of SVG elements to their Selector object
        this.selectorMap = {};

        // this holds a reference to the grip elements
        this.selectorGrips = {
            nw: null,
            n: null,
            ne: null,
            e: null,
            se: null,
            s: null,
            sw: null,
            w: null,
        };
        this.selectorGripsGroup = null;
        this.rotateGripConnector = null;
        this.rotateGrip = null;
        this.initGroup();
    }

    /**
     * Resets the parent selector group element.
     * @returns {void}
     */
    initGroup() {
        const dataStorage = svgCanvas$1.getDataStorage();
        // remove old selector parent group if it existed
        if (this.selectorParentGroup?.parentNode) {
            this.selectorParentGroup.remove();
        }

        // create parent selector group and add it to svgroot
        this.selectorParentGroup = svgCanvas$1.createSVGElement({
            element: "g",
            attr: {
                id: "selectorParentGroup",
            },
        });
        this.selectorGripsGroup = svgCanvas$1.createSVGElement({
            element: "g",
            attr: {
                display: "none",
            },
        });
        this.selectorParentGroup.append(this.selectorGripsGroup);
        svgCanvas$1.getSvgRoot().append(this.selectorParentGroup);
        this.selectorMap = {};
        this.selectors = [];
        this.rubberBandBox = null;

        // add the corner grips
        Object.keys(this.selectorGrips).forEach((dir) => {
            const grip = svgCanvas$1.createSVGElement({
                element: "circle",
                attr: {
                    id: "selectorGrip_resize_" + dir,
                    fill: "#22C",
                    r: gripRadius,
                    style: "cursor:" + dir + "-resize",
                    // This expands the mouse-able area of the grips making them
                    // easier to grab with the mouse.
                    // This works in Opera and WebKit, but does not work in Firefox
                    // see https://bugzilla.mozilla.org/show_bug.cgi?id=500174
                    "stroke-width": 2,
                    "pointer-events": "all",
                },
            });
            dataStorage.put(grip, "dir", dir);
            dataStorage.put(grip, "type", "resize");
            this.selectorGrips[dir] = grip;
            this.selectorGripsGroup.append(grip);
        });

        // add rotator elems
        this.rotateGripConnector = svgCanvas$1.createSVGElement({
            element: "line",
            attr: {
                id: "selectorGrip_rotateconnector",
                stroke: "#22C",
                "stroke-width": "1",
            },
        });
        this.selectorGripsGroup.append(this.rotateGripConnector);
        this.rotateGrip = svgCanvas$1.createSVGElement({
            element: "circle",
            attr: {
                id: "selectorGrip_rotate",
                fill: "lime",
                r: gripRadius,
                stroke: "#22C",
                "stroke-width": 2,
                style: `cursor:url(${svgCanvas$1.curConfig.imgPath}/rotate.svg) 12 12, auto;`,
            },
        });
        this.selectorGripsGroup.append(this.rotateGrip);
        dataStorage.put(this.rotateGrip, "type", "rotate");
        if (document.getElementById("canvasBackground")) {
            return;
        }
        const [width, height] = svgCanvas$1.curConfig.dimensions;
        const canvasbg = svgCanvas$1.createSVGElement({
            element: "svg",
            attr: {
                id: "canvasBackground",
                width,
                height,
                x: 0,
                y: 0,
                overflow: isWebkit() ? "none" : "visible",
                // Chrome 7 has a problem with this when zooming out
                style: "pointer-events:none",
            },
        });
        const rect = svgCanvas$1.createSVGElement({
            element: "rect",
            attr: {
                width: "100%",
                height: "100%",
                x: 0,
                y: 0,
                "stroke-width": 1,
                stroke: "#000",
                fill: "#FFF",
                style: "pointer-events:none",
            },
        });
        const gridContainer = svgCanvas$1.createSVGElement({
            element: "svg",
            attr: {
                id: "gridContainer",
                width,
                height,
                x: 0,
                y: 0,
                overflow: isWebkit() ? "none" : "visible",
                // Chrome 7 has a problem with this when zooming out
                style: "pointer-events:none",
            },
        });
        canvasbg.append(rect);
        svgCanvas$1
            .getSvgRoot()
            .insertBefore(canvasbg, svgCanvas$1.getSvgContent());
        svgCanvas$1.getSvgRoot().appendChild(gridContainer);
    }

    /**
     *
     * @param {Element} elem - DOM element to get the selector for
     * @param {module:utilities.BBoxObject} [bbox] - Optional bbox to use for reset (prevents duplicate getBBox call).
     * @returns {Selector} The selector based on the given element
     */
    requestSelector(elem, bbox) {
        if (!elem) {
            return null;
        }
        const N = this.selectors.length;
        // If we've already acquired one for this element, return it.
        if (typeof this.selectorMap[elem.id] === "object") {
            this.selectorMap[elem.id].locked = true;
            return this.selectorMap[elem.id];
        }
        for (let i = 0; i < N; ++i) {
            if (!this.selectors[i]?.locked) {
                this.selectors[i].locked = true;
                this.selectors[i].reset(elem, bbox);
                this.selectorMap[elem.id] = this.selectors[i];
                return this.selectors[i];
            }
        }
        // if we reached here, no available selectors were found, we create one
        this.selectors[N] = new Selector(N, elem, bbox);
        this.selectorParentGroup.append(this.selectors[N].selectorGroup);
        this.selectorMap[elem.id] = this.selectors[N];
        return this.selectors[N];
    }

    /**
     * Removes the selector of the given element (hides selection box).
     *
     * @param {Element} elem - DOM element to remove the selector for
     * @returns {void}
     */
    releaseSelector(elem) {
        if (!elem) {
            return;
        }
        const N = this.selectors.length;
        const sel = this.selectorMap[elem.id];
        if (!sel?.locked) {
            // TODO(codedread): Ensure this exists in this module.
            console.warn(
                "WARNING! selector was released but was already unlocked",
            );
        }
        for (let i = 0; i < N; ++i) {
            if (this.selectors[i] && this.selectors[i] === sel) {
                delete this.selectorMap[elem.id];
                sel.locked = false;
                sel.selectedElement = null;
                sel.showGrips(false);

                // remove from DOM and store reference in JS but only if it exists in the DOM
                try {
                    sel.selectorGroup.setAttribute("display", "none");
                } catch (e) {
                    /* empty fn */
                }
                break;
            }
        }
    }

    /**
     * @returns {SVGRectElement} The rubberBandBox DOM element. This is the rectangle drawn by
     * the user for selecting/zooming
     */
    getRubberBandBox() {
        if (!this.rubberBandBox) {
            this.rubberBandBox = svgCanvas$1.createSVGElement({
                element: "rect",
                attr: {
                    id: "selectorRubberBand",
                    fill: "#22C",
                    "fill-opacity": 0.15,
                    stroke: "#22C",
                    "stroke-width": 0.5,
                    display: "none",
                    style: "pointer-events:none",
                },
            });
            this.selectorParentGroup.append(this.rubberBandBox);
        }
        return this.rubberBandBox;
    }
}

/**
 * An object that creates SVG elements for the canvas.
 *
 * @interface module:select.SVGFactory
 */
/**
 * @function module:select.SVGFactory#createSVGElement
 * @param {module:utilities.EditorContext#addSVGElementsFromJson} jsonMap
 * @returns {SVGElement}
 */
/**
 * @function module:select.SVGFactory#svgRoot
 * @returns {SVGSVGElement}
 */
/**
 * @function module:select.SVGFactory#svgContent
 * @returns {SVGSVGElement}
 */
/**
 * @function module:select.SVGFactory#getZoom
 * @returns {Float} The current zoom level
 */

/**
 * @typedef {GenericArray} module:select.Dimensions
 * @property {Integer} length 2
 * @property {Float} 0 Width
 * @property {Float} 1 Height
 */
/**
 * @typedef {PlainObject} module:select.Config
 * @property {string} imgPath
 * @property {module:select.Dimensions} dimensions
 */

/**
 * Initializes this module.
 * @function module:select.init
 * @param {module:select.Config} config - An object containing configurable parameters (imgPath)
 * @param {module:select.SVGFactory} svgFactory - An object implementing the SVGFactory interface.
 * @returns {void}
 */
const init$1 = (canvas) => {
    svgCanvas$1 = canvas;
    selectorManager_ = new SelectorManager();
};

/**
 * @function module:select.getSelectorManager
 * @returns {module:select.SelectorManager} The SelectorManager instance.
 */
const getSelectorManager = () => selectorManager_;

/**
 * Tools for clear.
 * @module clear
 * @license MIT
 * @copyright 2011 Jeff Schiller
 */
let svgCanvas = null;

/**
 * @function module:clear.init
 * @param {module:clear.SvgCanvas#init} clearContext
 * @returns {void}
 */
const init = (canvas) => {
    svgCanvas = canvas;
};
const clearSvgContentElementInit = () => {
    const curConfig = svgCanvas.getCurConfig();
    const { dimensions } = curConfig;
    const el = svgCanvas.getSvgContent();
    // empty
    while (el.firstChild) {
        el.removeChild(el.firstChild);
    }

    // TODO: Clear out all other attributes first?
    const pel = svgCanvas.getSvgRoot();
    el.setAttribute("id", "svgcontent");
    el.setAttribute("width", dimensions[0]);
    el.setAttribute("height", dimensions[1]);
    el.setAttribute("x", dimensions[0]);
    el.setAttribute("y", dimensions[1]);
    el.setAttribute(
        "overflow",
        curConfig.show_outside_canvas ? "visible" : "hidden",
    );
    el.setAttribute("xmlns", NS.SVG);
    el.setAttribute("xmlns:se", NS.SE);
    el.setAttribute("xmlns:xlink", NS.XLINK);
    pel.appendChild(el);

    // TODO: make this string optional and set by the client
    const comment = svgCanvas
        .getDOMDocument()
        .createComment(
            " Created with SVG-edit - https://github.com/SVG-Edit/svgedit",
        );
    svgCanvas.getSvgContent().append(comment);
};

/** A storage solution aimed at replacing jQuerys data function.
 * Implementation Note: Elements are stored in a (WeakMap)[https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/WeakMap].
 * This makes sure the data is garbage collected when the node is removed.
 */
const dataStorage = {
    _storage: new WeakMap(),
    put: function (element, key, obj) {
        if (!this._storage.has(element)) {
            this._storage.set(element, new Map());
        }
        this._storage.get(element).set(key, obj);
    },
    get: function (element, key) {
        return this._storage.get(element)?.get(key);
    },
    has: function (element, key) {
        return (
            this._storage.has(element) && this._storage.get(element).has(key)
        );
    },
    remove: function (element, key) {
        const ret = this._storage.get(element).delete(key);
        if (this._storage.get(element).size === 0) {
            this._storage.delete(element);
        }
        return ret;
    },
};

/**
 * Numerous tools for working with the editor's "canvas".
 * @module svgcanvas
 *
 * @license MIT
 *
 * @copyright 2010 Alexis Deveria, 2010 Pavol Rusnak, 2010 Jeff Schiller, 2021 OptimistikSAS
 *
 */
const visElems =
    "a,circle,ellipse,foreignObject,g,image,line,path,polygon,polyline,rect,svg,text,tspan,use";
const refAttrs = [
    "clip-path",
    "fill",
    "filter",
    "marker-end",
    "marker-mid",
    "marker-start",
    "mask",
    "stroke",
];
const THRESHOLD_DIST = 0.8;
const STEP_COUNT = 10;
const CLIPBOARD_ID = "svgedit_clipboard";

/**
 * The main SvgCanvas class that manages all SVG-related functions.
 * @memberof module:svgcanvas
 *
 */
class SvgCanvas {
    /**
     * @param {HTMLElement} container - The container HTML element that should hold the SVG root element
     * @param {module:SVGeditor.configObj.curConfig} config - An object that contains configuration data
     */
    constructor(container, config) {
        // imported function made available as methods
        this.initializeSvgCanvasMethods();
        init$j(this);
        const { pathActions } = pathModule;

        // initialize class variables
        this.saveOptions = {
            round_digits: 2,
        }; // Object with save options
        this.importIds = {}; // Object with IDs for imported files, to see if one was already added
        this.extensions = {}; // Object to contain all included extensions
        this.removedElements = {}; // Map of deleted reference elements
        this.started = false; // Boolean indicating whether or not a draw action has been this.started
        this.startTransform = null; // String with an element's initial transform attribute value
        this.currentMode = "select"; // String indicating the current editor mode
        this.currentResizeMode = "none"; // String with the current direction in which an element is being resized
        this.justSelected = null; // The DOM element that was just selected
        this.rubberBox = null; // DOM element for selection rectangle drawn by the user
        this.curBBoxes = []; // Array of current BBoxes, used in getIntersectionList().
        this.lastClickPoint = null; // Canvas point for the most recent right click
        this.events = {}; // Object to contain editor event names and callback functions
        this.rootSctm = null; // Root Current Transformation Matrix in user units
        this.drawnPath = null;
        this.freehand = {
            // Mouse events
            minx: null,
            miny: null,
            maxx: null,
            maxy: null,
        };
        this.dAttr = null;
        this.startX = null;
        this.startY = null;
        this.rStartX = null;
        this.rStartY = null;
        this.initBbox = {};
        this.sumDistance = 0;
        this.controllPoint2 = {
            x: 0,
            y: 0,
        };
        this.controllPoint1 = {
            x: 0,
            y: 0,
        };
        this.start = {
            x: 0,
            y: 0,
        };
        this.end = {
            x: 0,
            y: 0,
        };
        this.bSpline = {
            x: 0,
            y: 0,
        };
        this.nextPos = {
            x: 0,
            y: 0,
        };
        this.idprefix = "svg_"; // Prefix string for element IDs
        this.encodableImages = {};
        this.curConfig = {
            // Default configuration options
            show_outside_canvas: true,
            selectNew: true,
            dimensions: [640, 480],
        };
        // Update config with new one if given
        if (config) {
            this.curConfig = SvgCanvas.mergeDeep(this.curConfig, config);
        }
        this.lastGoodImgUrl = `${this.curConfig.imgPath}/logo.svg`; // String with image URL of last loadable image
        const { dimensions } = this.curConfig; // Array with width/height of canvas

        // "document" element associated with the container (same as window.document using default svg-editor.js)
        // NOTE: This is not actually a SVG document, but an HTML document.
        this.svgdoc = window.document;
        this.container = container;
        // This is a container for the document being edited, not the document itself.
        this.svgroot = svgRootElement(this.svgdoc, dimensions);
        container.append(this.svgroot);
        // The actual element that represents the final output SVG element.
        this.svgContent = this.svgdoc.createElementNS(NS.SVG, "svg");
        init$d(this);
        init(this);
        this.clearSvgContentElement();
        // Current `draw.Drawing` object.
        this.current_drawing_ = new Drawing(this.svgContent, this.idprefix);
        // Float displaying the current zoom level (1 = 100%, .5 = 50%, etc.).
        this.zoom = 1;

        //Lock canvas to lock mouse events
        this.canvasIsLocked = false;

        // pointer to current group (for in-group editing)
        this.currentGroup = null;

        // Object containing data for the currently selected styles
        const allProperties = {
            shape: {
                fill: "#FFFFFF",
                fill_paint: null,
                fill_opacity: this.curConfig.initFill.opacity,
                stroke: "#000000",
                stroke_paint: null,
                stroke_opacity: this.curConfig.initStroke.opacity,
                stroke_width: this.curConfig.initStroke.width,
                stroke_dasharray: "none",
                stroke_linejoin: "miter",
                stroke_linecap: "butt",
                opacity: this.curConfig.initOpacity,
            },
        };
        allProperties.text = SvgCanvas.mergeDeep({}, allProperties.shape);
        allProperties.text = SvgCanvas.mergeDeep(allProperties.text, {
            fill: "#000000",
            stroke_width: this.curConfig.text?.stroke_width,
            font_size: this.curConfig.text?.font_size,
            font_family: "Inter-Regular",
        });
        this.curText = allProperties.text; // Current text style properties

        // Current shape style properties
        this.curShape = allProperties.shape;
        this.curProperties = this.curShape; // Current general properties

        // Array with all the currently selected elements
        // default size of 1 until it needs to grow bigger
        this.selectedElements = [];
        init$8(this);
        init$k(this);
        init$6(this);
        init$5(this);
        init$1(this);
        init$c(this);
        init$b(this);
        this.nsMap = getReverseNS();
        this.selectorManager = getSelectorManager();
        this.pathActions = pathActions;
        init$g(this);
        // Interface strings, usually for title elements
        this.uiStrings = {};

        // Animation element to change the opacity of any newly created element
        this.opacAni = document.createElementNS(NS.SVG, "animate");
        this.opacAni.setAttribute("attributeName", "opacity");
        this.opacAni.setAttribute("begin", "indefinite");
        this.opacAni.setAttribute("dur", 1);
        this.opacAni.setAttribute("fill", "freeze");
        this.svgroot.appendChild(this.opacAni);
        init$9(this);
        init$a(this);
        init$2(this);
        init$f(this);
        init$7(this);

        // prevent links from being followed in the canvas
        const handleLinkInCanvas = (e) => {
            e.preventDefault();
            return false;
        };
        container.addEventListener("mousedown", this.mouseDownEvent);
        container.addEventListener("mousemove", this.mouseMoveEvent);
        $click(container, handleLinkInCanvas);
        container.addEventListener("dblclick", this.dblClickEvent);
        container.addEventListener("mouseup", this.mouseUpEvent);
        // container.addEventListener('mousewheel', this.DOMMouseScrollEvent);
        // container.addEventListener('DOMMouseScroll', this.DOMMouseScrollEvent);

        // Alias function
        this.linkControlPoints = pathActions.linkControlPoints;
        this.curCommand = null;
        this.filter = null;
        this.filterHidden = false;
        init$3(this);
        init$4(this);

        /**
         * Transfers sessionStorage from one tab to another.
         * @param {!Event} ev Storage event.
         * @returns {void}
         */
        const storageChange = (ev) => {
            if (!ev.newValue) return; // This is a call from removeItem.
            if (ev.key === CLIPBOARD_ID + "_startup") {
                // Another tab asked for our sessionStorage.
                localStorage.removeItem(CLIPBOARD_ID + "_startup");
                this.flashStorage();
            } else if (ev.key === CLIPBOARD_ID) {
                // Another tab sent data.
                sessionStorage.setItem(CLIPBOARD_ID, ev.newValue);
            }
        };

        // Listen for changes to localStorage.
        window.addEventListener("storage", storageChange, false);
        // Ask other tabs for sessionStorage (this is ONLY to trigger event).
        localStorage.setItem(CLIPBOARD_ID + "_startup", Math.random());
        init$e(this);
        this.contentW = this.getResolution().w;
        this.contentH = this.getResolution().h;
        this.clear();
    } // End constructor

    getSvgOption() {
        return this.saveOptions;
    }
    setSvgOption(key, value) {
        this.saveOptions[key] = value;
    }
    getCanvasIsLocked() {
        return this.canvasIsLocked;
    }
    setCanvasIsLocked(isLocked) {
        this.canvasIsLocked = isLocked;
    }
    getSelectedElements() {
        return this.selectedElements;
    }
    setSelectedElements(key, value) {
        this.selectedElements[key] = value;
    }
    setEmptySelectedElements() {
        this.selectedElements = [];
    }
    getSvgRoot() {
        return this.svgroot;
    }
    getDOMDocument() {
        return this.svgdoc;
    }
    getDOMContainer() {
        return this.container;
    }
    getCurConfig() {
        return this.curConfig;
    }
    setIdPrefix(p) {
        this.idprefix = p;
    }
    getCurrentDrawing() {
        return this.current_drawing_;
    }
    getCurShape() {
        return this.curShape;
    }
    getCurrentGroup() {
        return this.currentGroup;
    }
    getBaseUnit() {
        return this.curConfig.baseUnit;
    }
    getHeight() {
        return this.svgContent.getAttribute("height") / this.zoom;
    }
    getWidth() {
        return this.svgContent.getAttribute("width") / this.zoom;
    }
    getRoundDigits() {
        return this.saveOptions.round_digits;
    }
    getSnappingStep() {
        return this.curConfig.snappingStep;
    }
    getGridSnapping() {
        return this.curConfig.gridSnapping;
    }
    getStartTransform() {
        return this.startTransform;
    }
    setStartTransform(transform) {
        this.startTransform = transform;
    }
    getZoom() {
        return this.zoom;
    }
    round(val) {
        return Math.round((val * this.zoom) / this.zoom);
    }
    createSVGElement(jsonMap) {
        return this.addSVGElementsFromJson(jsonMap);
    }
    getContainer() {
        return this.container;
    }
    setStarted(s) {
        this.started = s;
    }
    getRubberBox() {
        return this.rubberBox;
    }
    setRubberBox(rb) {
        this.rubberBox = rb;
        return this.rubberBox;
    }
    addPtsToSelection({ closedSubpath, grips }) {
        // TODO: Correct this:
        this.pathActions.canDeleteNodes = true;
        this.pathActions.closed_subpath = closedSubpath;
        this.call("pointsAdded", {
            closedSubpath,
            grips,
        });
        this.call("selected", grips);
    }

    /**
     * @param {PlainObject} changes
     * @param {ChangeElementCommand} changes.cmd
     * @param {SVGPathElement} changes.elem
     * @fires module:svgcanvas.SvgCanvas#event:changed
     * @returns {void}
     */
    endChanges({ cmd, elem }) {
        this.addCommandToHistory(cmd);
        this.call("changed", [elem]);
    }
    getCurrentMode() {
        return this.currentMode;
    }
    setCurrentMode(cm) {
        this.currentMode = cm;
        return this.currentMode;
    }
    getDrawnPath() {
        return this.drawnPath;
    }
    setDrawnPath(dp) {
        this.drawnPath = dp;
        return this.drawnPath;
    }
    setCurrentGroup(cg) {
        this.currentGroup = cg;
    }
    changeSvgContent() {
        this.call("changed", [this.svgContent]);
    }
    getStarted() {
        return this.started;
    }
    getCanvas() {
        return this;
    }
    getrootSctm() {
        return this.rootSctm;
    }
    getStartX() {
        return this.startX;
    }
    setStartX(value) {
        this.startX = value;
    }
    getStartY() {
        return this.startY;
    }
    setStartY(value) {
        this.startY = value;
    }
    getRStartX() {
        return this.rStartX;
    }
    getRStartY() {
        return this.rStartY;
    }
    getInitBbox() {
        return this.initBbox;
    }
    getCurrentResizeMode() {
        return this.currentResizeMode;
    }
    getJustSelected() {
        return this.justSelected;
    }
    getOpacAni() {
        return this.opacAni;
    }
    getParameter() {
        return this.parameter;
    }
    getNextParameter() {
        return this.nextParameter;
    }
    getStepCount() {
        return STEP_COUNT;
    }
    getThreSholdDist() {
        return THRESHOLD_DIST;
    }
    getSumDistance() {
        return this.sumDistance;
    }
    getStart(key) {
        return this.start[key];
    }
    getEnd(key) {
        return this.end[key];
    }
    getbSpline(key) {
        return this.bSpline[key];
    }
    getNextPos(key) {
        return this.nextPos[key];
    }
    getControllPoint1(key) {
        return this.controllPoint1[key];
    }
    getControllPoint2(key) {
        return this.controllPoint2[key];
    }
    getFreehand(key) {
        return this.freehand[key];
    }
    getDrawing() {
        return this.getCurrentDrawing();
    }
    getDAttr() {
        return this.dAttr;
    }
    getLastGoodImgUrl() {
        return this.lastGoodImgUrl;
    }
    getCurText(key) {
        return this.curText[key];
    }
    setDAttr(value) {
        this.dAttr = value;
    }
    setEnd(key, value) {
        this.end[key] = value;
    }
    setControllPoint1(key, value) {
        this.controllPoint1[key] = value;
    }
    setControllPoint2(key, value) {
        this.controllPoint2[key] = value;
    }
    setJustSelected(value) {
        this.justSelected = value;
    }
    setParameter(value) {
        this.parameter = value;
    }
    setStart(value) {
        this.start = value;
    }
    setRStartX(value) {
        this.rStartX = value;
    }
    setRStartY(value) {
        this.rStartY = value;
    }
    setSumDistance(value) {
        this.sumDistance = value;
    }
    setbSpline(value) {
        this.bSpline = value;
    }
    setNextPos(value) {
        this.nextPos = value;
    }
    setNextParameter(value) {
        this.nextParameter = value;
    }
    setCurText(key, value) {
        this.curText[key] = value;
    }
    setFreehand(key, value) {
        this.freehand[key] = value;
    }
    setCurBBoxes(value) {
        this.curBBoxes = value;
    }
    getCurBBoxes() {
        return this.curBBoxes;
    }
    setInitBbox(value) {
        this.initBbox = value;
    }
    setRootSctm(value) {
        this.rootSctm = value;
    }
    setCurrentResizeMode(value) {
        this.currentResizeMode = value;
    }
    getLastClickPoint(key) {
        return this.lastClickPoint[key];
    }
    setLastClickPoint(value) {
        this.lastClickPoint = value;
    }
    getId() {
        return this.getCurrentDrawing().getId();
    }
    getUIStrings() {
        return this.uiStrings;
    }
    getNsMap() {
        return this.nsMap;
    }
    getSvgOptionApply() {
        return this.saveOptions.apply;
    }
    getSvgOptionImages() {
        return this.saveOptions.images;
    }
    getEncodableImages(key) {
        return this.encodableImages[key];
    }
    setEncodableImages(key, value) {
        this.encodableImages[key] = value;
    }
    getVisElems() {
        return visElems;
    }
    getIdPrefix() {
        return this.idprefix;
    }
    getDataStorage() {
        return dataStorage;
    }
    setZoom(value) {
        this.zoom = value;
    }
    getImportIds(key) {
        return this.importIds[key];
    }
    setImportIds(key, value) {
        this.importIds[key] = value;
    }
    setRemovedElements(key, value) {
        this.removedElements[key] = value;
    }
    setSvgContent(value) {
        this.svgContent = value;
    }
    getrefAttrs() {
        return refAttrs;
    }
    setCanvas(key, value) {
        this[key] = value;
    }
    setCurProperties(key, value) {
        this.curProperties[key] = value;
    }
    getCurProperties(key) {
        return this.curProperties[key];
    }
    setCurShape(key, value) {
        this.curShape[key] = value;
    }
    gettingSelectorManager() {
        return this.selectorManager;
    }
    getContentW() {
        return this.contentW;
    }
    getContentH() {
        return this.contentH;
    }
    getClipboardID() {
        return CLIPBOARD_ID;
    }
    getSvgContent() {
        return this.svgContent;
    }
    getExtensions() {
        return this.extensions;
    }
    getSelector() {
        return Selector;
    }
    getMode() {
        return this.currentMode;
    } // The current editor mode string

    getNextId() {
        return this.getCurrentDrawing().getNextId();
    }
    getCurCommand() {
        return this.curCommand;
    }
    setCurCommand(value) {
        this.curCommand = value;
    }
    getFilter() {
        return this.filter;
    }
    setFilter(value) {
        this.filter = value;
    }
    getFilterHidden() {
        return this.filterHidden;
    }
    setFilterHidden(value) {
        this.filterHidden = value;
    }

    /**
     * Sets the editor's mode to the given string.
     * @function module:svgcanvas.SvgCanvas#setMode
     * @param {string} name - String with the new mode to change to
     * @returns {void}
     */
    setMode(name) {
        this.pathActions.clear(true);
        this.textActions.clear();
        this.curProperties =
            this.selectedElements[0]?.nodeName === "text"
                ? this.curText
                : this.curShape;
        this.currentMode = name;
    }

    /**
     * Clears the current document. This is not an undoable action.
     * @function module:svgcanvas.SvgCanvas#clear
     * @fires module:svgcanvas.SvgCanvas#event:beforeClear|afterClear
     * @returns {void}
     */
    clear() {
        this.call("beforeClear");
        this.pathActions.clear();
        this.clearSelection();
        // clear the svgcontent node
        this.clearSvgContentElement();
        // create new document
        this.current_drawing_ = new Drawing(this.svgContent);
        // create empty first layer
        this.createLayer("Layer 1");
        // clear the undo stack
        this.undoMgr.resetUndoStack();
        // reset the selector manager
        this.selectorManager.initGroup();
        // reset the rubber band box
        this.rubberBox = this.selectorManager.getRubberBandBox();
        this.call("afterClear");
    }
    async addExtension(name, extInitFunc, { importLocale }) {
        if (typeof extInitFunc !== "function") {
            throw new TypeError(
                "Function argument expected for `svgcanvas.addExtension`",
            );
        }
        if (name in this.extensions) {
            throw new Error(
                'Cannot add extension "' +
                    name +
                    '", an extension by that name already exists.',
            );
        }
        const argObj = {
            importLocale,
            svgroot: this.svgroot,
            svgContent: this.svgContent,
            nonce: this.getCurrentDrawing().getNonce(),
            selectorManager: this.selectorManager,
        };
        const extObj = await extInitFunc(argObj);
        if (extObj) {
            extObj.name = name;
        }
        this.extensions[name] = extObj;
        return this.call("extension_added", extObj);
    }
    addCommandToHistory(cmd) {
        this.undoMgr.addCommandToHistory(cmd);
    }
    restoreRefElements(elem) {
        // Look for missing reference elements, restore any found
        const attrs = {};
        refAttrs.forEach((item, _) => {
            attrs[item] = elem.getAttribute(item);
        });
        Object.values(attrs).forEach((val) => {
            if (val?.startsWith("url(")) {
                const id = getUrlFromAttr(val).substr(1);
                const ref = getElement(id);
                if (!ref) {
                    findDefs().append(this.removedElements[id]);
                    delete this.removedElements[id];
                }
            }
        });
        const childs = elem.getElementsByTagName("*");
        if (childs.length) {
            for (let i = 0, l = childs.length; i < l; i++) {
                this.restoreRefElements(childs[i]);
            }
        }
    }
    call(ev, arg) {
        if (this.events[ev]) {
            return this.events[ev](window, arg);
        }
        return undefined;
    }

    /**
     * Attaches a callback function to an event.
     * @function module:svgcanvas.SvgCanvas#bind
     * @param  {string} ev - String indicating the name of the event
     * @param {module:svgcanvas.EventHandler} f - The callback function to bind to the event
     * @returns {module:svgcanvas.EventHandler} The previous event
     */
    bind(ev, f) {
        const old = this.events[ev];
        this.events[ev] = f;
        return old;
    }

    /**
     * Flash the clipboard data momentarily on localStorage so all tabs can see.
     * @returns {void}
     */
    flashStorage() {
        const data = sessionStorage.getItem(CLIPBOARD_ID);
        localStorage.setItem(CLIPBOARD_ID, data);
        setTimeout(() => {
            localStorage.removeItem(CLIPBOARD_ID);
        }, 1);
    }

    /**
     * Selects only the given elements, shortcut for `clearSelection(); addToSelection()`.
     * @function module:svgcanvas.SvgCanvas#selectOnly
     * @param {Element[]} elems - an array of DOM elements to be selected
     * @param {boolean} showGrips - Indicates whether the resize grips should be shown
     * @returns {void}
     */
    selectOnly(elems, showGrips) {
        this.clearSelection(true);
        this.addToSelection(elems, showGrips);
    }

    /**
     * Removes elements from the selection.
     * @function module:svgcanvas.SvgCanvas#removeFromSelection
     * @param {Element[]} elemsToRemove - An array of elements to remove from selection
     * @returns {void}
     */
    removeFromSelection(elemsToRemove) {
        if (!elemsToRemove.length || !this.selectedElements[0]) {
            return;
        }

        // find every element and remove it from our array copy
        const newSelectedItems = [];
        const len = this.selectedElements.length;
        for (let i = 0; i < len; ++i) {
            const elem = this.selectedElements[i];
            if (elem) {
                // keep the item
                if (!elemsToRemove.includes(elem)) {
                    newSelectedItems.push(elem);
                } else {
                    // remove the item and its selector
                    this.selectorManager.releaseSelector(elem);
                }
            }
        }
        // the copy becomes the master now
        this.selectedElements = newSelectedItems;
    }

    /**
     * Clears the selection, then adds all elements in the current layer to the selection.
     * @function module:svgcanvas.SvgCanvas#selectAllInCurrentLayer
     * @returns {void}
     */
    selectAllInCurrentLayer() {
        const currentLayer = this.getCurrentDrawing().getCurrentLayer();
        if (currentLayer) {
            this.currentMode = "select";
            if (this.currentGroup) {
                this.selectOnly(this.currentGroup.children);
            } else {
                this.selectOnly(currentLayer.children);
            }
        }
    }
    getOpacity() {
        return this.curShape.opacity;
    }

    /**
     * @function module:svgcanvas.SvgCanvas#getSnapToGrid
     * @returns {boolean} The current snap to grid setting
     */
    getSnapToGrid() {
        return this.curConfig.gridSnapping;
    }

    /**
     * @function module:svgcanvas.SvgCanvas#getVersion
     * @returns {string} A string which describes the revision number of SvgCanvas.
     */
    getVersion() {
        return "svgcanvas.js ($Rev$)";
    }

    /**
     * Update interface strings with given values.
     * @function module:svgcanvas.SvgCanvas#setUiStrings
     * @param {module:path.uiStrings} strs - Object with strings (see the [locales API]{@link module:locale.LocaleStrings} and the [tutorial]{@tutorial LocaleDocs})
     * @returns {void}
     */
    setUiStrings(strs) {
        Object.assign(this.uiStrings, strs.notification);
        setUiStrings(strs);
    }

    /**
     * Update configuration options with given values.
     * @function module:svgcanvas.SvgCanvas#setConfig
     * @param {module:SVGEditor.Config} opts - Object with options
     * @returns {void}
     */
    setConfig(opts) {
        Object.assign(this.curConfig, opts);
    }

    /**
     * @function module:svgcanvas.SvgCanvas#getDocumentTitle
     * @returns {string|void} The current document title or an empty string if not found
     */
    getDocumentTitle() {
        return this.getTitle(this.svgContent);
    }
    getOffset() {
        return {
            x: Number(this.svgContent.getAttribute("x")),
            y: Number(this.svgContent.getAttribute("y")),
        };
    }
    getColor(type) {
        return this.curProperties[type];
    }
    setStrokePaint(paint) {
        this.setPaint("stroke", paint);
    }

    /**
     * @function module:svgcanvas.SvgCanvas#setFillPaint
     * @param {module:jGraduate~Paint} paint
     * @returns {void}
     */
    setFillPaint(paint) {
        this.setPaint("fill", paint);
    }

    /**
     * @function module:svgcanvas.SvgCanvas#getStrokeWidth
     * @returns {Float|string} The current stroke-width value
     */
    getStrokeWidth() {
        return this.curProperties.stroke_width;
    }

    /**
     * @function module:svgcanvas.SvgCanvas#getStyle
     * @returns {module:svgcanvas.StyleOptions} current style options
     */
    getStyle() {
        return this.curShape;
    }

    /**
     * Sets the given opacity on the current selected elements.
     * @function module:svgcanvas.SvgCanvas#setOpacity
     * @param {string} val
     * @returns {void}
     */
    setOpacity(val) {
        this.curShape.opacity = val;
        this.changeSelectedAttribute("opacity", val);
    }

    /**
     * @function module:svgcanvas.SvgCanvas#getFillOpacity
     * @returns {Float} the current fill opacity
     */
    getFillOpacity() {
        return this.curShape.fill_opacity;
    }

    /**
     * @function module:svgcanvas.SvgCanvas#getStrokeOpacity
     * @returns {string} the current stroke opacity
     */
    getStrokeOpacity() {
        return this.curShape.stroke_opacity;
    }

    /**
     * Sets the current fill/stroke opacity.
     * @function module:svgcanvas.SvgCanvas#setPaintOpacity
     * @param {string} type - String with "fill" or "stroke"
     * @param {Float} val - Float with the new opacity value
     * @param {boolean} preventUndo - Indicates whether or not this should be an undoable action
     * @returns {void}
     */
    setPaintOpacity(type, val, preventUndo) {
        this.curShape[type + "_opacity"] = val;
        if (!preventUndo) {
            this.changeSelectedAttribute(type + "-opacity", val);
        } else {
            this.changeSelectedAttributeNoUndo(type + "-opacity", val);
        }
    }

    /**
     * Gets the current fill/stroke opacity.
     * @function module:svgcanvas.SvgCanvas#getPaintOpacity
     * @param {"fill"|"stroke"} type - String with "fill" or "stroke"
     * @returns {Float} Fill/stroke opacity
     */
    getPaintOpacity(type) {
        return type === "fill"
            ? this.getFillOpacity()
            : this.getStrokeOpacity();
    }

    /**
     * Gets the `stdDeviation` blur value of the given element.
     * @function module:svgcanvas.SvgCanvas#getBlur
     * @param {Element} elem - The element to check the blur value for
     * @returns {string} stdDeviation blur attribute value
     */
    getBlur(elem) {
        let val = 0;
        if (elem) {
            const filterUrl = elem.getAttribute("filter");
            if (filterUrl) {
                const blur = getElement(elem.id + "_blur");
                if (blur) {
                    val = blur.firstChild.getAttribute("stdDeviation");
                } else {
                    const filterElem = getRefElem(filterUrl);
                    const blurElem = getFeGaussianBlur(filterElem);
                    if (blurElem !== null) {
                        val = blurElem.getAttribute("stdDeviation");
                    }
                }
            }
        }
        return val;
    }

    /**
     * Sets a given URL to be a "last good image" URL.
     * @function module:svgcanvas.SvgCanvas#setGoodImage
     * @param {string} val
     * @returns {void}
     */
    setGoodImage(val) {
        this.lastGoodImgUrl = val;
    }

    /**
     * Returns the current drawing as raw SVG XML text.
     * @function module:svgcanvas.SvgCanvas#getSvgString
     * @returns {string} The current drawing as raw SVG XML text.
     */
    getSvgString() {
        this.saveOptions.apply = false;
        return this.svgCanvasToString();
    }

    /**
     * This function determines whether to use a nonce in the prefix, when
     * generating IDs for future documents in SVG-Edit.
     * If you're controlling SVG-Edit externally, and want randomized IDs, call
     * this BEFORE calling `svgCanvas.setSvgString`.
     * @function module:svgcanvas.SvgCanvas#randomizeIds
     * @param {boolean} [enableRandomization] If true, adds a nonce to the prefix. Thus
     * `svgCanvas.randomizeIds() <==> svgCanvas.randomizeIds(true)`
     * @returns {void}
     */
    randomizeIds(enableRandomization) {
        if (arguments.length > 0 && enableRandomization === false) {
            randomizeIds(false, this.getCurrentDrawing());
        } else {
            randomizeIds(true, this.getCurrentDrawing());
        }
    }

    /**
     * Convert selected element to a path, or get the BBox of an element-as-path.
     * @function module:svgcanvas.SvgCanvas#convertToPath
     * @todo (codedread): Remove the getBBox argument and split this function into two.
     * @param {Element} elem - The DOM element to be converted
     * @param {boolean} getBBox - Boolean on whether or not to only return the path's BBox
     * @returns {void|DOMRect|false|SVGPathElement|null} If the getBBox flag is true, the resulting path's bounding box object.
     * Otherwise the resulting path element is returned.
     */
    convertToPath(elem, getBBox) {
        // if elems not given, recursively call convertPath for all selected elements.
        if (!elem) {
            const elems = this.selectedElements;
            elems.forEach((el) => {
                if (el) {
                    this.convertToPath(el);
                }
            });
            return undefined;
        }
        if (getBBox) {
            return getBBoxOfElementAsPath(
                elem,
                this.addSVGElementsFromJson,
                this.pathActions,
            );
        }
        // TODO: Why is this applying attributes from this.curShape, then inside utilities.convertToPath it's pulling addition attributes from elem?
        // TODO: If convertToPath is called with one elem, this.curShape and elem are probably the same; but calling with multiple is a bug or cool feature.
        const attrs = {
            fill: this.curShape.fill,
            "fill-opacity": this.curShape.fill_opacity,
            stroke: this.curShape.stroke,
            "stroke-width": this.curShape.stroke_width,
            "stroke-dasharray": this.curShape.stroke_dasharray,
            "stroke-linejoin": this.curShape.stroke_linejoin,
            "stroke-linecap": this.curShape.stroke_linecap,
            "stroke-opacity": this.curShape.stroke_opacity,
            opacity: this.curShape.opacity,
            visibility: "hidden",
        };
        return convertToPath(elem, attrs, this); // call convertToPath from utilities.js
    }

    /**
     * Removes all selected elements from the DOM and adds the change to the
     * history stack. Remembers removed elements on the clipboard.
     * @function module:svgcanvas.SvgCanvas#cutSelectedElements
     * @returns {void}
     */
    cutSelectedElements() {
        this.copySelectedElements();
        this.deleteSelectedElements();
    }
    initializeSvgCanvasMethods() {
        this.getJsonFromSvgElements = getJsonFromSvgElements;
        this.addSVGElementsFromJson = addSVGElementsFromJson;
        this.clearSvgContentElement = clearSvgContentElementInit;
        this.textActions = textActionsMethod;
        this.getStrokedBBox = getStrokedBBoxDefaultVisible;
        this.getVisibleElements = getVisibleElements;
        this.stringToHTML = stringToHTML;
        this.insertChildAtIndex = insertChildAtIndex;
        this.getClosest = getClosest;
        this.getParents = getParents;
        this.isLayer = Layer.isLayer;
        this.matrixMultiply = matrixMultiply;
        this.hasMatrixTransform = hasMatrixTransform;
        this.transformListToTransform = transformListToTransform;
        this.convertToNum = convertToNum;
        this.findDefs = findDefs;
        this.getUrlFromAttr = getUrlFromAttr;
        this.getHref = getHref;
        this.setHref = setHref;
        this.getBBox = getBBox;
        this.getRotationAngle = getRotationAngle;
        this.getElement = getElement;
        this.getRefElem = getRefElem;
        this.assignAttributes = assignAttributes;
        this.cleanupElement = cleanupElement;
        this.remapElement = remapElement;
        this.recalculateDimensions = recalculateDimensions;
        this.sanitizeSvg = sanitizeSvg;
        this.pasteElements = pasteElementsMethod; // Remembers the current selected elements on the clipboard.
        this.identifyLayers = identifyLayers;
        this.createLayer = createLayer;
        this.cloneLayer = cloneLayer;
        this.deleteCurrentLayer = deleteCurrentLayer;
        this.setCurrentLayer = setCurrentLayer;
        this.renameCurrentLayer = renameCurrentLayer;
        this.setCurrentLayerPosition = setCurrentLayerPosition;
        this.indexCurrentLayer = indexCurrentLayer;
        this.setLayerVisibility = setLayerVisibility;
        this.moveSelectedToLayer = moveSelectedToLayer;
        this.mergeLayer = mergeLayer;
        this.mergeAllLayers = mergeAllLayers;
        this.leaveContext = leaveContext;
        this.setContext = setContext;
        this.changeSelectedAttributeNoUndo =
            changeSelectedAttributeNoUndoMethod; // This function makes the changes to the elements. It does not add the change to the history stack.
        this.changeSelectedAttribute = changeSelectedAttributeMethod; // Change the given/selected element and add the original value to the history stack.
        this.setBlurNoUndo = setBlurNoUndo; // Sets the `stdDeviation` blur value on the selected element without being undoable.
        this.setBlurOffsets = setBlurOffsets; // Sets the `x`, `y`, `width`, `height` values of the filter element in order to make the blur not be clipped. Removes them if not neeeded.
        this.setBlur = setBlur; // Adds/updates the blur filter to the selected element.
        this.smoothControlPoints = smoothControlPoints;
        this.getTypeMap = getTypeMap;
        this.history = history; // object with all histor methods
        this.NS = NS;
        this.$id = $id;
        this.$qq = $qq;
        this.$qa = $qa;
        this.$click = $click;
        this.encode64 = encode64;
        this.decode64 = decode64;
        this.mergeDeep = mergeDeep;
        this.updateTransformList = updateTransformList;
    }
} // End class

// attach utilities function to the class that are used by SvgEdit so
// we can avoid using the whole utilities.js file in svgEdit.js
SvgCanvas.$id = $id;
SvgCanvas.$qq = $qq;
SvgCanvas.$qa = $qa;
SvgCanvas.$click = $click;
SvgCanvas.encode64 = encode64;
SvgCanvas.decode64 = decode64;
SvgCanvas.mergeDeep = mergeDeep;
SvgCanvas.getClosest = getClosest;
SvgCanvas.getParents = getParents;
SvgCanvas.blankPageObjectURL = blankPageObjectURL;
SvgCanvas.Paint = Paint;
SvgCanvas.getTypeMap = getTypeMap;
SvgCanvas.convertToNum = convertToNum;
SvgCanvas.isValidUnit = isValidUnit;
SvgCanvas.convertUnit = convertUnit;

export { SvgCanvas as S, _typeof as _, commonjsGlobal as c };
//# sourceMappingURL=svgcanvas-3a42e433.js.map
